import _defineProperty2 from "/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { Component, useState, useMemo, useEffect, useContext, useReducer, useRef, useLayoutEffect, forwardRef, createElement, useCallback, Fragment as Fragment$1, cloneElement } from 'react';
import PropTypes__default, { bool, func, oneOfType, object as object$1, array, string, number, any, shape, node, oneOf, element, arrayOf } from 'prop-types';
import MuiButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid/Grid';
import Box from '@material-ui/core/Box';
import { createMuiTheme, withStyles, useTheme, makeStyles, darken, lighten, fade } from '@material-ui/core/styles';
import { red, green, amber, grey, orange, lightBlue, indigo } from '@material-ui/core/colors';
import { responsiveFontSizes, Typography as Typography$1, FormControlLabel as FormControlLabel$1, Checkbox, makeStyles as makeStyles$1, Box as Box$1, Grid as Grid$2, Hidden, DialogTitle as DialogTitle$1, MenuItem as MenuItem$1, Drawer as Drawer$1, Link as Link$1, useMediaQuery as useMediaQuery$1, useTheme as useTheme$1, Card as Card$1, CardContent as CardContent$1, Divider as Divider$1, Container, LinearProgress, Paper as Paper$1, TextField as TextField$1, FormControl as FormControl$1, InputLabel as InputLabel$1, Select as Select$3, FormHelperText as FormHelperText$1, Dialog as Dialog$1, DialogContent as DialogContent$1, DialogContentText as DialogContentText$1, DialogActions as DialogActions$1, Snackbar, CardActionArea as CardActionArea$1, CardMedia as CardMedia$1, ExpansionPanel, ExpansionPanelDetails, CircularProgress as CircularProgress$1, IconButton as IconButton$1, Zoom, Tooltip } from '@material-ui/core';
import Grid$1 from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select$2 from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Warning from '@material-ui/icons/Warning';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import PauseIcon from '@material-ui/icons/Pause';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import Videocam from '@material-ui/icons/Videocam';
import VideocamOff from '@material-ui/icons/VideocamOff';
import { unstable_batchedUpdates } from 'react-dom';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import Card from '@material-ui/core/Card';
import Warning$1 from '@material-ui/icons/WarningRounded';
import grey$1 from '@material-ui/core/colors/grey';
import Avatar from '@material-ui/core/Avatar';
import Schedule from '@material-ui/icons/Schedule';
import Icon from '@material-ui/core/Icon';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import Input$1 from '@material-ui/core/Input';
import Create from '@material-ui/icons/Create';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Input$2 from '@material-ui/core/Input/Input';
import InputAdornment from '@material-ui/core/InputAdornment/InputAdornment';
import TextField from '@material-ui/core/TextField';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Checkbox$1 from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import Link from '@material-ui/core/Link';
import { CheckCircle, Warning as Warning$2, Error as Error$1, Info, KeyboardArrowLeft, KeyboardArrowRight, KeyboardArrowUp, KeyboardArrowDown, Person, ChevronRight, ExpandMore, ArrowBack, Close, Menu, Delete } from '@material-ui/icons';
import Divider from '@material-ui/core/Divider';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CloseIcon$1 from '@material-ui/icons/Close';
import { ThemeProvider as ThemeProvider$1, StylesProvider, createGenerateClassName, makeStyles as makeStyles$2 } from '@material-ui/styles';
import Hidden$1 from '@material-ui/core/Hidden';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import SvgIcon from '@material-ui/core/SvgIcon';
import { capitalize, useControlled } from '@material-ui/core/utils';
import '@material-ui/core/ListSubheader';
import '@material-ui/core/Chip';
import ButtonBase from '@material-ui/core/ButtonBase';
import '@material-ui/core/Zoom';
import '@material-ui/core/Fab';
import '@material-ui/core/Tooltip';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import GavelIcon from '@material-ui/icons/Gavel';
import UhOhIcon from '@material-ui/icons/MoodBadOutlined';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment$1 from '@material-ui/core/InputAdornment';
import metadata$1 from 'libphonenumber-js/metadata.min.json';
import { getCountryCallingCode, AsYouType, parsePhoneNumberCharacter, parseIncompletePhoneNumber, formatIncompletePhoneNumber, isSupportedCountry, parsePhoneNumberFromString, Metadata, getCountries } from 'libphonenumber-js/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { parseISO, isValid, getYear, getMonth, getDate, isFuture, getDaysInMonth, endOfMonth, format as format$1, startOfMonth, parse as parse$4, isBefore } from 'date-fns';
import Menu$1 from '@material-ui/core/Menu';
import NativeSelect from '@material-ui/core/NativeSelect';
import withStyles$1 from '@material-ui/core/styles/withStyles';
import RootRef from '@material-ui/core/RootRef';
import ErrorIcon from '@material-ui/icons/Error';
import TextField$1$1 from '@material-ui/core/TextField/TextField';
import ReportProblemOutlinedIcon$1 from '@material-ui/icons/ReportProblemOutlined';
import makeStyles$3 from '@material-ui/core/styles/makeStyles';
import Switch from '@material-ui/core/Switch';
import Dialog$1$1 from '@material-ui/core/Dialog';
import DialogContent$1$1 from '@material-ui/core/DialogContent';
import DialogTitle$1$1 from '@material-ui/core/DialogTitle';
import 'typeface-roboto';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);

  for (var e = 0, n = Array(a); e < a; e++) {
    n[e] = r[e];
  }

  return n;
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
        u = i.value;
  } catch (n) {
    return void e(n);
  }

  i.done ? t(u) : Promise.resolve(u).then(r, o);
}

function _asyncToGenerator(n) {
  return function () {
    var t = this,
        e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);

      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }

      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }

      _next(void 0);
    });
  };
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}

function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  }, _extends.apply(null, arguments);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};

  var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);

  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);

    for (r = 0; r < s.length; r++) {
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
  }

  return i;
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};

  for (var n in r) {
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n)) continue;
      t[n] = r[n];
    }
  }

  return t;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _regeneratorRuntime() {
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };

  var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
    t[e] = r.value;
  },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";

  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }

  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }

  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }

  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }

  e.wrap = wrap;
  var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);

  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }

  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);

      if ("throw" !== c.type) {
        var u = c.arg,
            h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }

      a(c.arg);
    }

    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }

        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }

  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");

      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }

      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;

        if (c) {
          var u = maybeInvokeDelegate(c, n);

          if (u) {
            if (u === y) continue;
            return u;
          }
        }

        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);

        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }

        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }

  function maybeInvokeDelegate(e, r) {
    var n = r.method,
        o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }

  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }

  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }

  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;

      if (!isNaN(e.length)) {
        var o = -1,
            i = function next() {
          for (; ++o < e.length;) {
            if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
          }

          return next.value = t, next.done = !0, next;
        };

        return i.next = i;
      }
    }

    throw new TypeError(typeof e + " is not iterable");
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
        r = [];

    for (var n in e) {
      r.push(n);
    }

    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) {
        "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      }
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;

      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }

      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
            a = i.completion;
        if ("root" === i.tryLoc) return handle("end");

        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");

          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];

        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }

      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];

        if (r.tryLoc === t) {
          var n = r.completion;

          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }

          return o;
        }
      }

      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == typeof i ? i : i + "";
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _excluded = ["loading", "disabled", "children"];

function Button(props) {
  var loading = props.loading,
      disabled = props.disabled,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(MuiButton, _extends({}, rest, {
    disabled: loading || disabled
  }), loading && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 20,
    color: 'inherit',
    style: {
      position: 'absolute',
      margin: 'auto',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      visibility: loading ? 'hidden' : 'visible'
    }
  }, children));
}

Button.propTypes = {
  children: PropTypes__default.node,
  loading: PropTypes__default.bool,
  disabled: PropTypes__default.bool
};
Button.defaultProps = {
  loading: false,
  disabled: false
};
var brandColors = {
  capuaBlue: '#1a237e'
};
var theme = responsiveFontSizes(createMuiTheme({
  palette: {
    primary: {
      main: brandColors.capuaBlue
    },
    secondary: {
      main: '#FF971B'
    },
    error: red
  },
  success: {
    color: green[600]
  },
  warning: {
    color: amber[700]
  },
  info: {
    color: '#2A68E4'
  },
  "default": {
    color: '#e0e0e0'
  },
  spacing: 7,
  textColor: grey,
  brandColors: brandColors,
  header: {
    errorColor: orange[300],
    fontSize: '0.875rem',
    fontSizeSmall: '0.85rem',
    logoSource: null,
    icon: {
      fontSize: 'large'
    },
    upperSection: {
      textColor: '#fff',
      buttonColor: lightBlue[700],
      buttonHover: lightBlue[500],
      iconColor: grey[50]
    },
    lowerSection: {
      background: grey[50],
      categoryTextColor: grey[50],
      activeLinkBackground: indigo[600],
      activeLinkHighlight: lightBlue[700],
      textColor: grey[900]
    }
  },
  searchField: {
    fontSize: '0.875rem',
    fontSizeSmall: '0.85rem',
    icon: {
      fontSize: '2rem',
      color: lightBlue[700]
    },
    textColor: grey[900]
  },
  login: {
    colorPalette: 'primary'
  }
}));
theme.typographyClasses = {
  sectionHeader: _objectSpread2(_objectSpread2({}, theme.typography.h5), {}, {
    fontSize: '1.5rem',
    fontWeight: 'normal',
    marginBottom: theme.spacing(2)
  })
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var uaParser_min = createCommonjsModule(function (module, exports) {
  /* UAParser.js v0.7.38
     Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
     MIT License */
  (function (window, undefined$1) {
    var LIBVERSION = "0.7.38",
        EMPTY = "",
        UNKNOWN = "?",
        FUNC_TYPE = "function",
        UNDEF_TYPE = "undefined",
        OBJ_TYPE = "object",
        STR_TYPE = "string",
        MAJOR = "major",
        MODEL = "model",
        NAME = "name",
        TYPE = "type",
        VENDOR = "vendor",
        VERSION = "version",
        ARCHITECTURE = "architecture",
        CONSOLE = "console",
        MOBILE = "mobile",
        TABLET = "tablet",
        SMARTTV = "smarttv",
        WEARABLE = "wearable",
        EMBEDDED = "embedded",
        UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon",
        APPLE = "Apple",
        ASUS = "ASUS",
        BLACKBERRY = "BlackBerry",
        BROWSER = "Browser",
        CHROME = "Chrome",
        EDGE = "Edge",
        FIREFOX = "Firefox",
        GOOGLE = "Google",
        HUAWEI = "Huawei",
        LG = "LG",
        MICROSOFT = "Microsoft",
        MOTOROLA = "Motorola",
        OPERA = "Opera",
        SAMSUNG = "Samsung",
        SHARP = "Sharp",
        SONY = "Sony",
        XIAOMI = "Xiaomi",
        ZEBRA = "Zebra",
        FACEBOOK = "Facebook",
        CHROMIUM_OS = "Chromium OS",
        MAC_OS = "Mac OS";

    var extend = function extend(regexes, extensions) {
      var mergedRegexes = {};

      for (var i in regexes) {
        if (extensions[i] && extensions[i].length % 2 === 0) {
          mergedRegexes[i] = extensions[i].concat(regexes[i]);
        } else {
          mergedRegexes[i] = regexes[i];
        }
      }

      return mergedRegexes;
    },
        enumerize = function enumerize(arr) {
      var enums = {};

      for (var i = 0; i < arr.length; i++) {
        enums[arr[i].toUpperCase()] = arr[i];
      }

      return enums;
    },
        has = function has(str1, str2) {
      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    },
        lowerize = function lowerize(str) {
      return str.toLowerCase();
    },
        majorize = function majorize(version) {
      return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
    },
        trim = function trim(str, len) {
      if (typeof str === STR_TYPE) {
        str = str.replace(/^\s\s*/, EMPTY);
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    };

    var rgxMapper = function rgxMapper(ua, arrays) {
      var i = 0,
          j,
          k,
          p,
          q,
          matches,
          match;

      while (i < arrays.length && !matches) {
        var regex = arrays[i],
            props = arrays[i + 1];
        j = k = 0;

        while (j < regex.length && !matches) {
          if (!regex[j]) {
            break;
          }

          matches = regex[j++].exec(ua);

          if (!!matches) {
            for (p = 0; p < props.length; p++) {
              match = matches[++k];
              q = props[p];

              if (typeof q === OBJ_TYPE && q.length > 0) {
                if (q.length === 2) {
                  if (typeof q[1] == FUNC_TYPE) {
                    this[q[0]] = q[1].call(this, match);
                  } else {
                    this[q[0]] = q[1];
                  }
                } else if (q.length === 3) {
                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                  } else {
                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                  }
                } else if (q.length === 4) {
                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                }
              } else {
                this[q] = match ? match : undefined$1;
              }
            }
          }
        }

        i += 2;
      }
    },
        strMapper = function strMapper(str, map) {
      for (var i in map) {
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j = 0; j < map[i].length; j++) {
            if (has(map[i][j], str)) {
              return i === UNKNOWN ? undefined$1 : i;
            }
          }
        } else if (has(map[i], str)) {
          return i === UNKNOWN ? undefined$1 : i;
        }
      }

      return str;
    };

    var oldSafariMap = {
      "1.0": "/8",
      1.2: "/1",
      1.3: "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    },
        windowsVersionMap = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      8.1: "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    };
    var regexes = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [VERSION, [NAME, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [VERSION, [NAME, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [NAME, VERSION], [/opios[\/ ]+([\w\.]+)/i], [VERSION, [NAME, OPERA + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [VERSION, [NAME, OPERA + " GX"]], [/\bopr\/([\w\.]+)/i], [VERSION, [NAME, OPERA]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [VERSION, [NAME, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [NAME, VERSION], [/\bddg\/([\w\.]+)/i], [VERSION, [NAME, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [VERSION, [NAME, "UC" + BROWSER]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [VERSION, [NAME, "WeChat"]], [/konqueror\/([\w\.]+)/i], [VERSION, [NAME, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [VERSION, [NAME, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [VERSION, [NAME, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [VERSION, [NAME, "Smart Lenovo " + BROWSER]], [/(avast|avg)\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION], [/\bfocus\/([\w\.]+)/i], [VERSION, [NAME, FIREFOX + " Focus"]], [/\bopt\/([\w\.]+)/i], [VERSION, [NAME, OPERA + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [VERSION, [NAME, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [VERSION, [NAME, "Dolphin"]], [/coast\/([\w\.]+)/i], [VERSION, [NAME, OPERA + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [VERSION, [NAME, "MIUI " + BROWSER]], [/fxios\/([-\w\.]+)/i], [VERSION, [NAME, FIREFOX]], [/\bqihu|(qi?ho?o?|360)browser/i], [[NAME, "360 " + BROWSER]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 " + BROWSER], VERSION], [/samsungbrowser\/([\w\.]+)/i], [VERSION, [NAME, SAMSUNG + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[NAME, /_/g, " "], VERSION], [/metasr[\/ ]?([\d\.]+)/i], [VERSION, [NAME, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[NAME, "Sogou Mobile"], VERSION], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [NAME, VERSION], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [NAME], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[NAME, FACEBOOK], VERSION], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [NAME, VERSION], [/\bgsa\/([\w\.]+) .*safari\//i], [VERSION, [NAME, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [VERSION, [NAME, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [VERSION, [NAME, CHROME + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[NAME, CHROME + " WebView"], VERSION], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [VERSION, [NAME, "Android " + BROWSER]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [NAME, VERSION], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [VERSION, NAME], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [NAME, [VERSION, strMapper, oldSafariMap]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[NAME, "Netscape"], VERSION], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [VERSION, [NAME, FIREFOX + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [NAME, VERSION], [/(cobalt)\/([\w\.]+)/i], [NAME, [VERSION, /master.|lts./, ""]]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i], [[ARCHITECTURE, lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[ARCHITECTURE, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[ARCHITECTURE, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[ARCHITECTURE, "armhf"]], [/windows (ce|mobile); ppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [/(sun4\w)[;\)]/i], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[ARCHITECTURE, lowerize]]],
      device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [/(macintosh);/i], [MODEL, [VENDOR, APPLE]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]], [/\b(opd2\d{3}a?) bui/i], [MODEL, [VENDOR, "OPPO"], [TYPE, TABLET]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[MODEL, /_/g, " "], [VENDOR, "Nokia"], [TYPE, MOBILE]], [/(pixel c)\b/i], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]], [/(playbook);[-\w\),; ]+(rim)/i], [MODEL, VENDOR, [TYPE, TABLET]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [/(nexus 9)/i], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [MODEL, [VENDOR, "Ulefone"], [TYPE, MOBILE]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(surface duo)/i], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]], [/(u304aa)/i], [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]], [/\bsie-(\w*)/i], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/\b(rct\w+) b/i], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/\b(venue[\d ]{2,7}) b/i], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/\b(q(?:mv|ta)\w+) b/i], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]], [/\b(tm\d{3}\w+) b/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/\b(k88) b/i], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/\b(nx\d{3}j) b/i], [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]], [/\b(gen\d{3}) b.+49h/i], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/\b(zur\d{3}) b/i], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/\b((zeki)?tb.*\b) b/i], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/\b(ns-?\w{0,9}) b/i], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/\b((nxa|next)-?\w{0,9}) b/i], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/\b(lvtel\-)?(v1[12]) b/i], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/\b(ph-1) /i], [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/\b(trio[-\w\. ]+) b/i], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/\btu_(1491) b/i], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/(shield[\w ]+) b/i], [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]], [/(sprint) (\w+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/(kin\.[onetw]{3})/i], [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [/smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[VENDOR, LG], [TYPE, SMARTTV]], [/(apple) ?tv/i], [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]], [/crkey/i], [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [/droid.+aft(\w+)( bui|\))/i], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]], [/(bravia[\w ]+)( bui|\))/i], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [/(mitv-\w{5}) bui/i], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [/Hbbtv.*(technisat) (.*);/i], [VENDOR, MODEL, [TYPE, SMARTTV]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[TYPE, SMARTTV]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [VENDOR, MODEL, [TYPE, CONSOLE]], [/droid.+; (shield) bui/i], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation [345portablevi]+)/i], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [/((pebble))app/i], [VENDOR, MODEL, [TYPE, WEARABLE]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]], [/droid.+; (glass) \d/i], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [/droid.+; (wt63?0{2,3})\)/i], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [/(quest( \d| pro)?)/i], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [VENDOR, [TYPE, EMBEDDED]], [/(aeobc)\b/i], [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [MODEL, [TYPE, MOBILE]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [MODEL, [TYPE, TABLET]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[TYPE, TABLET]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[TYPE, MOBILE]], [/(android[-\w\. ]{0,9});.+buil/i], [MODEL, [VENDOR, "Generic"]]],
      engine: [[/windows.+ edge\/([\w\.]+)/i], [VERSION, [NAME, EDGE + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [VERSION, [NAME, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [NAME, VERSION], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [VERSION, NAME]],
      os: [[/microsoft (windows) (vista|xp)/i], [NAME, VERSION], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [NAME, [VERSION, strMapper, windowsVersionMap]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[VERSION, strMapper, windowsVersionMap], [NAME, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[NAME, MAC_OS], [VERSION, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [VERSION, NAME], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [NAME, VERSION], [/\(bb(10);/i], [VERSION, [NAME, BLACKBERRY]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [VERSION, [NAME, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [VERSION, [NAME, FIREFOX + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [VERSION, [NAME, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [VERSION, [NAME, "watchOS"]], [/crkey\/([\d\.]+)/i], [VERSION, [NAME, CHROME + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[NAME, CHROMIUM_OS], VERSION], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [NAME, VERSION], [/(sunos) ?([\w\.\d]*)/i], [[NAME, "Solaris"], VERSION], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [NAME, VERSION]]
    };

    var UAParser = function UAParser(ua, extensions) {
      if (typeof ua === OBJ_TYPE) {
        extensions = ua;
        ua = undefined$1;
      }

      if (!(this instanceof UAParser)) {
        return new UAParser(ua, extensions).getResult();
      }

      var _navigator = typeof window !== UNDEF_TYPE && window.navigator ? window.navigator : undefined$1;

      var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);

      var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;

      var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

      var _isSelfNav = _navigator && _navigator.userAgent == _ua;

      this.getBrowser = function () {
        var _browser = {};
        _browser[NAME] = undefined$1;
        _browser[VERSION] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser[MAJOR] = majorize(_browser[VERSION]);

        if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
          _browser[NAME] = "Brave";
        }

        return _browser;
      };

      this.getCPU = function () {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };

      this.getDevice = function () {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);

        if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
          _device[TYPE] = MOBILE;
        }

        if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
          _device[MODEL] = "iPad";
          _device[TYPE] = TABLET;
        }

        return _device;
      };

      this.getEngine = function () {
        var _engine = {};
        _engine[NAME] = undefined$1;
        _engine[VERSION] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };

      this.getOS = function () {
        var _os = {};
        _os[NAME] = undefined$1;
        _os[VERSION] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);

        if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") {
          _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
        }

        return _os;
      };

      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };

      this.getUA = function () {
        return _ua;
      };

      this.setUA = function (ua) {
        _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
        return this;
      };

      this.setUA(_ua);
      return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
    {
      if (module.exports) {
        exports = module.exports = UAParser;
      }

      exports.UAParser = UAParser;
    }
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);

    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();

      $.ua.get = function () {
        return parser.getUA();
      };

      $.ua.set = function (ua) {
        parser.setUA(ua);
        var result = parser.getResult();

        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
});
var uaParser_min_1 = uaParser_min.UAParser;
var main = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
  }

  var React__default = _interopDefault(React);

  var UA = new uaParser_min();
  var browser = UA.getBrowser();
  var cpu = UA.getCPU();
  var device = UA.getDevice();
  var engine = UA.getEngine();
  var os = UA.getOS();
  var ua = UA.getUA();

  var setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
  };

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  var DEVICE_TYPES = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    SMART_TV: 'smarttv',
    CONSOLE: 'console',
    WEARABLE: 'wearable',
    BROWSER: undefined
  };
  var BROWSER_TYPES = {
    CHROME: 'Chrome',
    FIREFOX: "Firefox",
    OPERA: "Opera",
    YANDEX: "Yandex",
    SAFARI: "Safari",
    INTERNET_EXPLORER: "Internet Explorer",
    EDGE: "Edge",
    CHROMIUM: "Chromium",
    IE: 'IE',
    MOBILE_SAFARI: "Mobile Safari"
  };
  var OS_TYPES = {
    IOS: 'iOS',
    ANDROID: "Android",
    WINDOWS_PHONE: "Windows Phone"
  };
  var initialData = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
  };

  var checkType = function checkType(type) {
    switch (type) {
      case DEVICE_TYPES.MOBILE:
        return {
          isMobile: true
        };

      case DEVICE_TYPES.TABLET:
        return {
          isTablet: true
        };

      case DEVICE_TYPES.SMART_TV:
        return {
          isSmartTV: true
        };

      case DEVICE_TYPES.CONSOLE:
        return {
          isConsole: true
        };

      case DEVICE_TYPES.WEARABLE:
        return {
          isWearable: true
        };

      case DEVICE_TYPES.BROWSER:
        return {
          isBrowser: true
        };

      default:
        return initialData;
    }
  };

  var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
    return {
      isBrowser: isBrowser,
      browserMajorVersion: setDefaults(browser.major),
      browserFullVersion: setDefaults(browser.version),
      browserName: setDefaults(browser.name),
      engineName: setDefaults(engine.name),
      engineVersion: setDefaults(engine.version),
      osName: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      userAgent: setDefaults(ua)
    };
  };

  var mobilePayload = function mobilePayload(type, device, os, ua) {
    return _objectSpread2({}, type, {
      vendor: setDefaults(device.vendor),
      model: setDefaults(device.model),
      os: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      ua: setDefaults(ua)
    });
  };

  var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
    return {
      isSmartTV: isSmartTV,
      engineName: setDefaults(engine.name),
      engineVersion: setDefaults(engine.version),
      osName: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      userAgent: setDefaults(ua)
    };
  };

  var consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
      isConsole: isConsole,
      engineName: setDefaults(engine.name),
      engineVersion: setDefaults(engine.version),
      osName: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      userAgent: setDefaults(ua)
    };
  };

  var wearPayload = function wearPayload(isWearable, engine, os, ua) {
    return {
      isWearable: isWearable,
      engineName: setDefaults(engine.name),
      engineVersion: setDefaults(engine.version),
      osName: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      userAgent: setDefaults(ua)
    };
  };

  var type = checkType(device.type);

  function deviceDetect() {
    var isBrowser = type.isBrowser,
        isMobile = type.isMobile,
        isTablet = type.isTablet,
        isSmartTV = type.isSmartTV,
        isConsole = type.isConsole,
        isWearable = type.isWearable;

    if (isBrowser) {
      return broPayload(isBrowser, browser, engine, os, ua);
    }

    if (isSmartTV) {
      return stvPayload(isSmartTV, engine, os, ua);
    }

    if (isConsole) {
      return consolePayload(isConsole, engine, os, ua);
    }

    if (isMobile) {
      return mobilePayload(type, device, os, ua);
    }

    if (isTablet) {
      return mobilePayload(type, device, os, ua);
    }

    if (isWearable) {
      return wearPayload(isWearable, engine, os, ua);
    }
  }

  var isMobileType = function isMobileType() {
    return device.type === DEVICE_TYPES.MOBILE;
  };

  var isTabletType = function isTabletType() {
    return device.type === DEVICE_TYPES.TABLET;
  };

  var isMobileAndTabletType = function isMobileAndTabletType() {
    switch (device.type) {
      case DEVICE_TYPES.MOBILE:
      case DEVICE_TYPES.TABLET:
        return true;

      default:
        return false;
    }
  };

  var isSmartTVType = function isSmartTVType() {
    return device.type === DEVICE_TYPES.SMART_TV;
  };

  var isBrowserType = function isBrowserType() {
    return device.type === DEVICE_TYPES.BROWSER;
  };

  var isWearableType = function isWearableType() {
    return device.type === DEVICE_TYPES.WEARABLE;
  };

  var isConsoleType = function isConsoleType() {
    return device.type === DEVICE_TYPES.CONSOLE;
  };

  var isAndroidType = function isAndroidType() {
    return os.name === OS_TYPES.ANDROID;
  };

  var isWinPhoneType = function isWinPhoneType() {
    return os.name === OS_TYPES.WINDOWS_PHONE;
  };

  var isIOSType = function isIOSType() {
    return os.name === OS_TYPES.IOS;
  };

  var isChromeType = function isChromeType() {
    return browser.name === BROWSER_TYPES.CHROME;
  };

  var isFirefoxType = function isFirefoxType() {
    return browser.name === BROWSER_TYPES.FIREFOX;
  };

  var isChromiumType = function isChromiumType() {
    return browser.name === BROWSER_TYPES.CHROMIUM;
  };

  var isEdgeType = function isEdgeType() {
    return browser.name === BROWSER_TYPES.EDGE;
  };

  var isYandexType = function isYandexType() {
    return browser.name === BROWSER_TYPES.YANDEX;
  };

  var isSafariType = function isSafariType() {
    return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
  };

  var isMobileSafariType = function isMobileSafariType() {
    return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
  };

  var isOperaType = function isOperaType() {
    return browser.name === BROWSER_TYPES.OPERA;
  };

  var isIEType = function isIEType() {
    return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
  };

  var getBrowserFullVersion = function getBrowserFullVersion() {
    return setDefaults(browser.version);
  };

  var getBrowserVersion = function getBrowserVersion() {
    return setDefaults(browser.major);
  };

  var getOsVersion = function getOsVersion() {
    return setDefaults(os.version);
  };

  var getOsName = function getOsName() {
    return setDefaults(os.name);
  };

  var getBrowserName = function getBrowserName() {
    return setDefaults(browser.name);
  };

  var getMobileVendor = function getMobileVendor() {
    return setDefaults(device.vendor);
  };

  var getMobileModel = function getMobileModel() {
    return setDefaults(device.model);
  };

  var getEngineName = function getEngineName() {
    return setDefaults(engine.name);
  };

  var getEngineVersion = function getEngineVersion() {
    return setDefaults(engine.version);
  };

  var getUseragent = function getUseragent() {
    return setDefaults(ua);
  };

  var getDeviceType = function getDeviceType() {
    return setDefaults(device.type, '');
  };

  var isSmartTV = isSmartTVType();
  var isConsole = isConsoleType();
  var isWearable = isWearableType();
  var isMobileSafari = isMobileSafariType();
  var isChromium = isChromiumType();
  var isMobile = isMobileAndTabletType();
  var isMobileOnly = isMobileType();
  var isTablet = isTabletType();
  var isBrowser = isBrowserType();
  var isAndroid = isAndroidType();
  var isWinPhone = isWinPhoneType();
  var isIOS = isIOSType();
  var isChrome = isChromeType();
  var isFirefox = isFirefoxType();
  var isSafari = isSafariType();
  var isOpera = isOperaType();
  var isIE = isIEType();
  var osVersion = getOsVersion();
  var osName = getOsName();
  var fullBrowserVersion = getBrowserFullVersion();
  var browserVersion = getBrowserVersion();
  var browserName = getBrowserName();
  var mobileVendor = getMobileVendor();
  var mobileModel = getMobileModel();
  var engineName = getEngineName();
  var engineVersion = getEngineVersion();
  var getUA = getUseragent();
  var isEdge = isEdgeType();
  var isYandex = isYandexType();
  var deviceType = getDeviceType();

  var AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment,
        children = _ref.children,
        viewClassName = _ref.viewClassName,
        style = _ref.style;
    return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment,
        children = _ref2.children,
        viewClassName = _ref2.viewClassName,
        style = _ref2.style;
    return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment,
        children = _ref3.children,
        viewClassName = _ref3.viewClassName,
        style = _ref3.style;
    return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment,
        children = _ref4.children,
        viewClassName = _ref4.viewClassName,
        style = _ref4.style;
    return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment,
        children = _ref5.children,
        viewClassName = _ref5.viewClassName,
        style = _ref5.style;
    return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment,
        children = _ref6.children,
        viewClassName = _ref6.viewClassName,
        style = _ref6.style;
    return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment,
        children = _ref7.children,
        viewClassName = _ref7.viewClassName,
        style = _ref7.style;
    return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment,
        children = _ref8.children,
        viewClassName = _ref8.viewClassName,
        style = _ref8.style;
    return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment,
        children = _ref9.children,
        viewClassName = _ref9.viewClassName,
        style = _ref9.style;
    return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment,
        children = _ref10.children,
        viewClassName = _ref10.viewClassName,
        style = _ref10.style;
    return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment,
        children = _ref11.children,
        viewClassName = _ref11.viewClassName,
        style = _ref11.style;
    return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment,
        children = _ref12.children,
        viewClassName = _ref12.viewClassName,
        style = _ref12.style,
        condition = _ref12.condition;
    return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  function withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          });
        }
      }]);

      return _class;
    }(React__default.Component);
  }

  exports.AndroidView = AndroidView;
  exports.BrowserView = BrowserView;
  exports.ConsoleView = ConsoleView;
  exports.CustomView = CustomView;
  exports.IEView = IEView;
  exports.IOSView = IOSView;
  exports.MobileOnlyView = MobileOnlyView;
  exports.MobileView = MobileView;
  exports.SmartTVView = SmartTVView;
  exports.TabletView = TabletView;
  exports.WearableView = WearableView;
  exports.WinPhoneView = WinPhoneView;
  exports.browserName = browserName;
  exports.browserVersion = browserVersion;
  exports.deviceDetect = deviceDetect;
  exports.deviceType = deviceType;
  exports.engineName = engineName;
  exports.engineVersion = engineVersion;
  exports.fullBrowserVersion = fullBrowserVersion;
  exports.getUA = getUA;
  exports.isAndroid = isAndroid;
  exports.isBrowser = isBrowser;
  exports.isChrome = isChrome;
  exports.isChromium = isChromium;
  exports.isConsole = isConsole;
  exports.isEdge = isEdge;
  exports.isFirefox = isFirefox;
  exports.isIE = isIE;
  exports.isIOS = isIOS;
  exports.isMobile = isMobile;
  exports.isMobileOnly = isMobileOnly;
  exports.isMobileSafari = isMobileSafari;
  exports.isOpera = isOpera;
  exports.isSafari = isSafari;
  exports.isSmartTV = isSmartTV;
  exports.isTablet = isTablet;
  exports.isWearable = isWearable;
  exports.isWinPhone = isWinPhone;
  exports.isYandex = isYandex;
  exports.mobileModel = mobileModel;
  exports.mobileVendor = mobileVendor;
  exports.osName = osName;
  exports.osVersion = osVersion;
  exports.withOrientationChange = withOrientationChange;
});
unwrapExports(main);
var main_1 = main.AndroidView;
var main_2 = main.BrowserView;
var main_3 = main.ConsoleView;
var main_4 = main.CustomView;
var main_5 = main.IEView;
var main_6 = main.IOSView;
var main_7 = main.MobileOnlyView;
var main_8 = main.MobileView;
var main_9 = main.SmartTVView;
var main_10 = main.TabletView;
var main_11 = main.WearableView;
var main_12 = main.WinPhoneView;
var main_13 = main.browserName;
var main_14 = main.browserVersion;
var main_15 = main.deviceDetect;
var main_16 = main.deviceType;
var main_17 = main.engineName;
var main_18 = main.engineVersion;
var main_19 = main.fullBrowserVersion;
var main_20 = main.getUA;
var main_21 = main.isAndroid;
var main_22 = main.isBrowser;
var main_23 = main.isChrome;
var main_24 = main.isChromium;
var main_25 = main.isConsole;
var main_26 = main.isEdge;
var main_27 = main.isFirefox;
var main_28 = main.isIE;
var main_29 = main.isIOS;
var main_30 = main.isMobile;
var main_31 = main.isMobileOnly;
var main_32 = main.isMobileSafari;
var main_33 = main.isOpera;
var main_34 = main.isSafari;
var main_35 = main.isSmartTV;
var main_36 = main.isTablet;
var main_37 = main.isWearable;
var main_38 = main.isWinPhone;
var main_39 = main.isYandex;
var main_40 = main.mobileModel;
var main_41 = main.mobileVendor;
var main_42 = main.osName;
var main_43 = main.osVersion;
var main_44 = main.withOrientationChange;
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

var logDisabled_ = true;
var deprecationWarnings_ = true;
/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */

function extractVersion(uastring, expr, pos) {
  var match = uastring.match(expr);
  return match && match.length >= pos && parseInt(match[pos], 10);
} // Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).


function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
  if (!window.RTCPeerConnection) {
    return;
  }

  var proto = window.RTCPeerConnection.prototype;
  var nativeAddEventListener = proto.addEventListener;

  proto.addEventListener = function (nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }

    var wrappedCallback = function wrappedCallback(e) {
      var modifiedEvent = wrapper(e);

      if (modifiedEvent) {
        cb(modifiedEvent);
      }
    };

    this._eventMap = this._eventMap || {};
    this._eventMap[cb] = wrappedCallback;
    return nativeAddEventListener.apply(this, [nativeEventName, wrappedCallback]);
  };

  var nativeRemoveEventListener = proto.removeEventListener;

  proto.removeEventListener = function (nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[cb]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }

    var unwrappedCb = this._eventMap[cb];
    delete this._eventMap[cb];
    return nativeRemoveEventListener.apply(this, [nativeEventName, unwrappedCb]);
  };

  Object.defineProperty(proto, 'on' + eventNameToWrap, {
    get: function get() {
      return this['_on' + eventNameToWrap];
    },
    set: function set(cb) {
      if (this['_on' + eventNameToWrap]) {
        this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
        delete this['_on' + eventNameToWrap];
      }

      if (cb) {
        this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
      }
    },
    enumerable: true,
    configurable: true
  });
}

function disableLog(bool) {
  if (typeof bool !== 'boolean') {
    return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
  }

  logDisabled_ = bool;
  return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
}
/**
 * Disable or enable deprecation warnings
 * @param {!boolean} bool set to true to disable warnings.
 */


function disableWarnings(bool) {
  if (typeof bool !== 'boolean') {
    return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
  }

  deprecationWarnings_ = !bool;
  return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}

function log() {
  if (typeof window === 'object') {
    if (logDisabled_) {
      return;
    }

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
      console.log.apply(console, arguments);
    }
  }
}
/**
 * Shows a deprecation warning suggesting the modern and spec-compatible API.
 */


function deprecated(oldMethod, newMethod) {
  if (!deprecationWarnings_) {
    return;
  }

  console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
}
/**
 * Browser detector.
 *
 * @return {object} result containing browser and version
 *     properties.
 */


function detectBrowser(window) {
  var navigator = window.navigator; // Returned result object.

  var result = {
    browser: null,
    version: null
  }; // Fail early if it's not a browser

  if (typeof window === 'undefined' || !window.navigator) {
    result.browser = 'Not a browser.';
    return result;
  }

  if (navigator.mozGetUserMedia) {
    // Firefox.
    result.browser = 'firefox';
    result.version = extractVersion(navigator.userAgent, /Firefox\/(\d+)\./, 1);
  } else if (navigator.webkitGetUserMedia || window.isSecureContext === false && window.webkitRTCPeerConnection && !window.RTCIceGatherer) {
    // Chrome, Chromium, Webview, Opera.
    // Version matches Chrome/WebRTC version.
    // Chrome 74 removed webkitGetUserMedia on http as well so we need the
    // more complicated fallback to webkitRTCPeerConnection.
    result.browser = 'chrome';
    result.version = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
  } else if (navigator.mediaDevices && navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
    // Edge.
    result.browser = 'edge';
    result.version = extractVersion(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
  } else if (window.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
    // Safari.
    result.browser = 'safari';
    result.version = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
    result.supportsUnifiedPlan = window.RTCRtpTransceiver && 'currentDirection' in window.RTCRtpTransceiver.prototype;
  } else {
    // Default fallthrough: not supported.
    result.browser = 'Not a supported browser.';
    return result;
  }

  return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */


function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]';
}
/**
 * Remove all empty objects and undefined values
 * from a nested object -- an enhanced and vanilla version
 * of Lodash's `compact`.
 */


function compactObject(data) {
  if (!isObject(data)) {
    return data;
  }

  return Object.keys(data).reduce(function (accumulator, key) {
    var isObj = isObject(data[key]);
    var value = isObj ? compactObject(data[key]) : data[key];
    var isEmptyObject = isObj && !Object.keys(value).length;

    if (value === undefined || isEmptyObject) {
      return accumulator;
    }

    return Object.assign(accumulator, _defineProperty2({}, key, value));
  }, {});
}
/* iterates the stats graph recursively. */


function walkStats(stats, base, resultSet) {
  if (!base || resultSet.has(base.id)) {
    return;
  }

  resultSet.set(base.id, base);
  Object.keys(base).forEach(function (name) {
    if (name.endsWith('Id')) {
      walkStats(stats, stats.get(base[name]), resultSet);
    } else if (name.endsWith('Ids')) {
      base[name].forEach(function (id) {
        walkStats(stats, stats.get(id), resultSet);
      });
    }
  });
}
/* filter getStats for a sender/receiver track. */


function filterStats(result, track, outbound) {
  var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
  var filteredResult = new Map();

  if (track === null) {
    return filteredResult;
  }

  var trackStats = [];
  result.forEach(function (value) {
    if (value.type === 'track' && value.trackIdentifier === track.id) {
      trackStats.push(value);
    }
  });
  trackStats.forEach(function (trackStat) {
    result.forEach(function (stats) {
      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
        walkStats(result, stats, filteredResult);
      }
    });
  });
  return filteredResult;
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


var logging = log;

function shimGetUserMedia(window) {
  var navigator = window && window.navigator;

  if (!navigator.mediaDevices) {
    return;
  }

  var browserDetails = detectBrowser(window);

  var constraintsToChrome_ = function constraintsToChrome_(c) {
    if (typeof c !== 'object' || c.mandatory || c.optional) {
      return c;
    }

    var cc = {};
    Object.keys(c).forEach(function (key) {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }

      var r = typeof c[key] === 'object' ? c[key] : {
        ideal: c[key]
      };

      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }

      var oldname_ = function oldname_(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }

        return name === 'deviceId' ? 'sourceId' : name;
      };

      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        var oc = {};

        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }

      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(function (mix) {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });

    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }

    return cc;
  };

  var shimConstraints_ = function shimConstraints_(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }

    constraints = JSON.parse(JSON.stringify(constraints));

    if (constraints && typeof constraints.audio === 'object') {
      var remap = function remap(obj, a, b) {
        if (a in obj && !(b in obj)) {
          obj[b] = obj[a];
          delete obj[a];
        }
      };

      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
      constraints.audio = constraintsToChrome_(constraints.audio);
    }

    if (constraints && typeof constraints.video === 'object') {
      // Shim facingMode for mobile & surface pro.
      var face = constraints.video.facingMode;
      face = face && (typeof face === 'object' ? face : {
        ideal: face
      });
      var getSupportedFacingModeLies = browserDetails.version < 66;

      if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;

        var _matches;

        if (face.exact === 'environment' || face.ideal === 'environment') {
          _matches = ['back', 'rear'];
        } else if (face.exact === 'user' || face.ideal === 'user') {
          _matches = ['front'];
        }

        if (_matches) {
          // Look for matches in label, or use last cam for back (typical).
          return navigator.mediaDevices.enumerateDevices().then(function (devices) {
            devices = devices.filter(function (d) {
              return d.kind === 'videoinput';
            });
            var dev = devices.find(function (d) {
              return _matches.some(function (match) {
                return d.label.toLowerCase().includes(match);
              });
            });

            if (!dev && devices.length && _matches.includes('back')) {
              dev = devices[devices.length - 1]; // more likely the back cam
            }

            if (dev) {
              constraints.video.deviceId = face.exact ? {
                exact: dev.deviceId
              } : {
                ideal: dev.deviceId
              };
            }

            constraints.video = constraintsToChrome_(constraints.video);
            logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }

      constraints.video = constraintsToChrome_(constraints.video);
    }

    logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };

  var shimError_ = function shimError_(e) {
    if (browserDetails.version >= 64) {
      return e;
    }

    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        PermissionDismissedError: 'NotAllowedError',
        InvalidStateError: 'NotAllowedError',
        DevicesNotFoundError: 'NotFoundError',
        ConstraintNotSatisfiedError: 'OverconstrainedError',
        TrackStartError: 'NotReadableError',
        MediaDeviceFailedDueToShutdown: 'NotAllowedError',
        MediaDeviceKillSwitchOn: 'NotAllowedError',
        TabCaptureError: 'AbortError',
        ScreenCaptureError: 'AbortError',
        DeviceCaptureError: 'AbortError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint || e.constraintName,
      toString: function toString() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  var getUserMedia_ = function getUserMedia_(constraints, onSuccess, onError) {
    shimConstraints_(constraints, function (c) {
      navigator.webkitGetUserMedia(c, onSuccess, function (e) {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };

  navigator.getUserMedia = getUserMedia_.bind(navigator); // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
  // function which returns a Promise, it does not accept spec-style
  // constraints.

  if (navigator.mediaDevices.getUserMedia) {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

    navigator.mediaDevices.getUserMedia = function (cs) {
      return shimConstraints_(cs, function (c) {
        return origGetUserMedia(c).then(function (stream) {
          if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
            throw new DOMException('', 'NotFoundError');
          }

          return stream;
        }, function (e) {
          return Promise.reject(shimError_(e));
        });
      });
    };
  }
}
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


function shimGetDisplayMedia(window, getSourceId) {
  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }

  if (!window.navigator.mediaDevices) {
    return;
  } // getSourceId is a function that returns a promise resolving with
  // the sourceId of the screen/window/tab to be shared.


  if (typeof getSourceId !== 'function') {
    console.error('shimGetDisplayMedia: getSourceId argument is not ' + 'a function');
    return;
  }

  window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
    return getSourceId(constraints).then(function (sourceId) {
      var widthSpecified = constraints.video && constraints.video.width;
      var heightSpecified = constraints.video && constraints.video.height;
      var frameRateSpecified = constraints.video && constraints.video.frameRate;
      constraints.video = {
        mandatory: {
          chromeMediaSource: 'desktop',
          chromeMediaSourceId: sourceId,
          maxFrameRate: frameRateSpecified || 3
        }
      };

      if (widthSpecified) {
        constraints.video.mandatory.maxWidth = widthSpecified;
      }

      if (heightSpecified) {
        constraints.video.mandatory.maxHeight = heightSpecified;
      }

      return window.navigator.mediaDevices.getUserMedia(constraints);
    });
  };
}

function shimMediaStream(window) {
  window.MediaStream = window.MediaStream || window.webkitMediaStream;
}

function shimOnTrack(window) {
  if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
      get: function get() {
        return this._ontrack;
      },
      set: function set(f) {
        if (this._ontrack) {
          this.removeEventListener('track', this._ontrack);
        }

        this.addEventListener('track', this._ontrack = f);
      },
      enumerable: true,
      configurable: true
    });
    var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;

    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
      var _this6 = this;

      if (!this._ontrackpoly) {
        this._ontrackpoly = function (e) {
          // onaddstream does not fire when a track is added to an existing
          // stream. But stream.onaddtrack is implemented so we use that.
          e.stream.addEventListener('addtrack', function (te) {
            var receiver;

            if (window.RTCPeerConnection.prototype.getReceivers) {
              receiver = _this6.getReceivers().find(function (r) {
                return r.track && r.track.id === te.track.id;
              });
            } else {
              receiver = {
                track: te.track
              };
            }

            var event = new Event('track');
            event.track = te.track;
            event.receiver = receiver;
            event.transceiver = {
              receiver: receiver
            };
            event.streams = [e.stream];

            _this6.dispatchEvent(event);
          });
          e.stream.getTracks().forEach(function (track) {
            var receiver;

            if (window.RTCPeerConnection.prototype.getReceivers) {
              receiver = _this6.getReceivers().find(function (r) {
                return r.track && r.track.id === track.id;
              });
            } else {
              receiver = {
                track: track
              };
            }

            var event = new Event('track');
            event.track = track;
            event.receiver = receiver;
            event.transceiver = {
              receiver: receiver
            };
            event.streams = [e.stream];

            _this6.dispatchEvent(event);
          });
        };

        this.addEventListener('addstream', this._ontrackpoly);
      }

      return origSetRemoteDescription.apply(this, arguments);
    };
  } else {
    // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    wrapPeerConnectionEvent(window, 'track', function (e) {
      if (!e.transceiver) {
        Object.defineProperty(e, 'transceiver', {
          value: {
            receiver: e.receiver
          }
        });
      }

      return e;
    });
  }
}

function shimGetSendersWithDtmf(window) {
  // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
  if (typeof window === 'object' && window.RTCPeerConnection && !('getSenders' in window.RTCPeerConnection.prototype) && 'createDTMFSender' in window.RTCPeerConnection.prototype) {
    var shimSenderWithDtmf = function shimSenderWithDtmf(pc, track) {
      return {
        track: track,

        get dtmf() {
          if (this._dtmf === undefined) {
            if (track.kind === 'audio') {
              this._dtmf = pc.createDTMFSender(track);
            } else {
              this._dtmf = null;
            }
          }

          return this._dtmf;
        },

        _pc: pc
      };
    }; // augment addTrack when getSenders is not available.


    if (!window.RTCPeerConnection.prototype.getSenders) {
      window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        this._senders = this._senders || [];
        return this._senders.slice(); // return a copy of the internal state.
      };

      var origAddTrack = window.RTCPeerConnection.prototype.addTrack;

      window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        var sender = origAddTrack.apply(this, arguments);

        if (!sender) {
          sender = shimSenderWithDtmf(this, track);

          this._senders.push(sender);
        }

        return sender;
      };

      var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;

      window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        origRemoveTrack.apply(this, arguments);

        var idx = this._senders.indexOf(sender);

        if (idx !== -1) {
          this._senders.splice(idx, 1);
        }
      };
    }

    var origAddStream = window.RTCPeerConnection.prototype.addStream;

    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
      var _this7 = this;

      this._senders = this._senders || [];
      origAddStream.apply(this, [stream]);
      stream.getTracks().forEach(function (track) {
        _this7._senders.push(shimSenderWithDtmf(_this7, track));
      });
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;

    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
      var _this8 = this;

      this._senders = this._senders || [];
      origRemoveStream.apply(this, [stream]);
      stream.getTracks().forEach(function (track) {
        var sender = _this8._senders.find(function (s) {
          return s.track === track;
        });

        if (sender) {
          // remove sender
          _this8._senders.splice(_this8._senders.indexOf(sender), 1);
        }
      });
    };
  } else if (typeof window === 'object' && window.RTCPeerConnection && 'getSenders' in window.RTCPeerConnection.prototype && 'createDTMFSender' in window.RTCPeerConnection.prototype && window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;

    window.RTCPeerConnection.prototype.getSenders = function getSenders() {
      var _this9 = this;

      var senders = origGetSenders.apply(this, []);
      senders.forEach(function (sender) {
        return sender._pc = _this9;
      });
      return senders;
    };

    Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
      get: function get() {
        if (this._dtmf === undefined) {
          if (this.track.kind === 'audio') {
            this._dtmf = this._pc.createDTMFSender(this.track);
          } else {
            this._dtmf = null;
          }
        }

        return this._dtmf;
      }
    });
  }
}

function shimGetStats(window) {
  if (!window.RTCPeerConnection) {
    return;
  }

  var origGetStats = window.RTCPeerConnection.prototype.getStats;

  window.RTCPeerConnection.prototype.getStats = function getStats() {
    var _this10 = this;

    var _arguments2 = Array.prototype.slice.call(arguments),
        selector = _arguments2[0],
        onSucc = _arguments2[1],
        onErr = _arguments2[2]; // If selector is a function then we are in the old style stats so just
    // pass back the original getStats format to avoid breaking old users.


    if (arguments.length > 0 && typeof selector === 'function') {
      return origGetStats.apply(this, arguments);
    } // When spec-style getStats is supported, return those when called with
    // either no arguments or the selector argument is null.


    if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== 'function')) {
      return origGetStats.apply(this, []);
    }

    var fixChromeStats_ = function fixChromeStats_(response) {
      var standardReport = {};
      var reports = response.result();
      reports.forEach(function (report) {
        var standardStats = {
          id: report.id,
          timestamp: report.timestamp,
          type: {
            localcandidate: 'local-candidate',
            remotecandidate: 'remote-candidate'
          }[report.type] || report.type
        };
        report.names().forEach(function (name) {
          standardStats[name] = report.stat(name);
        });
        standardReport[standardStats.id] = standardStats;
      });
      return standardReport;
    }; // shim getStats with maplike support


    var makeMapStats = function makeMapStats(stats) {
      return new Map(Object.keys(stats).map(function (key) {
        return [key, stats[key]];
      }));
    };

    if (arguments.length >= 2) {
      var successCallbackWrapper_ = function successCallbackWrapper_(response) {
        onSucc(makeMapStats(fixChromeStats_(response)));
      };

      return origGetStats.apply(this, [successCallbackWrapper_, selector]);
    } // promise-support


    return new Promise(function (resolve, reject) {
      origGetStats.apply(_this10, [function (response) {
        resolve(makeMapStats(fixChromeStats_(response)));
      }, reject]);
    }).then(onSucc, onErr);
  };
}

function shimSenderReceiverGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) {
    return;
  } // shim sender stats.


  if (!('getStats' in window.RTCRtpSender.prototype)) {
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;

    if (origGetSenders) {
      window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        var _this11 = this;

        var senders = origGetSenders.apply(this, []);
        senders.forEach(function (sender) {
          return sender._pc = _this11;
        });
        return senders;
      };
    }

    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;

    if (origAddTrack) {
      window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        var sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
      };
    }

    window.RTCRtpSender.prototype.getStats = function getStats() {
      var sender = this;
      return this._pc.getStats().then(function (result) {
        return (
          /* Note: this will include stats of all senders that
           *   send a track with the same id as sender.track as
           *   it is not possible to identify the RTCRtpSender.
           */
          filterStats(result, sender.track, true)
        );
      });
    };
  } // shim receiver stats.


  if (!('getStats' in window.RTCRtpReceiver.prototype)) {
    var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;

    if (origGetReceivers) {
      window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        var _this12 = this;

        var receivers = origGetReceivers.apply(this, []);
        receivers.forEach(function (receiver) {
          return receiver._pc = _this12;
        });
        return receivers;
      };
    }

    wrapPeerConnectionEvent(window, 'track', function (e) {
      e.receiver._pc = e.srcElement;
      return e;
    });

    window.RTCRtpReceiver.prototype.getStats = function getStats() {
      var receiver = this;
      return this._pc.getStats().then(function (result) {
        return filterStats(result, receiver.track, false);
      });
    };
  }

  if (!('getStats' in window.RTCRtpSender.prototype && 'getStats' in window.RTCRtpReceiver.prototype)) {
    return;
  } // shim RTCPeerConnection.getStats(track).


  var origGetStats = window.RTCPeerConnection.prototype.getStats;

  window.RTCPeerConnection.prototype.getStats = function getStats() {
    if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
      var track = arguments[0];
      var sender;
      var receiver;
      var err;
      this.getSenders().forEach(function (s) {
        if (s.track === track) {
          if (sender) {
            err = true;
          } else {
            sender = s;
          }
        }
      });
      this.getReceivers().forEach(function (r) {
        if (r.track === track) {
          if (receiver) {
            err = true;
          } else {
            receiver = r;
          }
        }

        return r.track === track;
      });

      if (err || sender && receiver) {
        return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
      } else if (sender) {
        return sender.getStats();
      } else if (receiver) {
        return receiver.getStats();
      }

      return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
    }

    return origGetStats.apply(this, arguments);
  };
}

function shimAddTrackRemoveTrackWithNative(window) {
  // shim addTrack/removeTrack with native variants in order to make
  // the interactions with legacy getLocalStreams behave as in other browsers.
  // Keeps a mapping stream.id => [stream, rtpsenders...]
  window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
    var _this13 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    return Object.keys(this._shimmedLocalStreams).map(function (streamId) {
      return _this13._shimmedLocalStreams[streamId][0];
    });
  };

  var origAddTrack = window.RTCPeerConnection.prototype.addTrack;

  window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
    if (!stream) {
      return origAddTrack.apply(this, arguments);
    }

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    var sender = origAddTrack.apply(this, arguments);

    if (!this._shimmedLocalStreams[stream.id]) {
      this._shimmedLocalStreams[stream.id] = [stream, sender];
    } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
      this._shimmedLocalStreams[stream.id].push(sender);
    }

    return sender;
  };

  var origAddStream = window.RTCPeerConnection.prototype.addStream;

  window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
    var _this14 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    stream.getTracks().forEach(function (track) {
      var alreadyExists = _this14.getSenders().find(function (s) {
        return s.track === track;
      });

      if (alreadyExists) {
        throw new DOMException('Track already exists.', 'InvalidAccessError');
      }
    });
    var existingSenders = this.getSenders();
    origAddStream.apply(this, arguments);
    var newSenders = this.getSenders().filter(function (newSender) {
      return existingSenders.indexOf(newSender) === -1;
    });
    this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
  };

  var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;

  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    this._shimmedLocalStreams = this._shimmedLocalStreams || {};
    delete this._shimmedLocalStreams[stream.id];
    return origRemoveStream.apply(this, arguments);
  };

  var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;

  window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
    var _this15 = this;

    this._shimmedLocalStreams = this._shimmedLocalStreams || {};

    if (sender) {
      Object.keys(this._shimmedLocalStreams).forEach(function (streamId) {
        var idx = _this15._shimmedLocalStreams[streamId].indexOf(sender);

        if (idx !== -1) {
          _this15._shimmedLocalStreams[streamId].splice(idx, 1);
        }

        if (_this15._shimmedLocalStreams[streamId].length === 1) {
          delete _this15._shimmedLocalStreams[streamId];
        }
      });
    }

    return origRemoveTrack.apply(this, arguments);
  };
}

function shimAddTrackRemoveTrack(window) {
  if (!window.RTCPeerConnection) {
    return;
  }

  var browserDetails = detectBrowser(window); // shim addTrack and removeTrack.

  if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) {
    return shimAddTrackRemoveTrackWithNative(window);
  } // also shim pc.getLocalStreams when addTrack is shimmed
  // to return the original streams.


  var origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;

  window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
    var _this16 = this;

    var nativeStreams = origGetLocalStreams.apply(this);
    this._reverseStreams = this._reverseStreams || {};
    return nativeStreams.map(function (stream) {
      return _this16._reverseStreams[stream.id];
    });
  };

  var origAddStream = window.RTCPeerConnection.prototype.addStream;

  window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
    var _this17 = this;

    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};
    stream.getTracks().forEach(function (track) {
      var alreadyExists = _this17.getSenders().find(function (s) {
        return s.track === track;
      });

      if (alreadyExists) {
        throw new DOMException('Track already exists.', 'InvalidAccessError');
      }
    }); // Add identity mapping for consistency with addTrack.
    // Unless this is being used with a stream from addTrack.

    if (!this._reverseStreams[stream.id]) {
      var newStream = new window.MediaStream(stream.getTracks());
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      stream = newStream;
    }

    origAddStream.apply(this, [stream]);
  };

  var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;

  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};
    origRemoveStream.apply(this, [this._streams[stream.id] || stream]);
    delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
    delete this._streams[stream.id];
  };

  window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
    var _this18 = this;

    if (this.signalingState === 'closed') {
      throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
    }

    var streams = [].slice.call(arguments, 1);

    if (streams.length !== 1 || !streams[0].getTracks().find(function (t) {
      return t === track;
    })) {
      // this is not fully correct but all we can manage without
      // [[associated MediaStreams]] internal slot.
      throw new DOMException('The adapter.js addTrack polyfill only supports a single ' + ' stream which is associated with the specified track.', 'NotSupportedError');
    }

    var alreadyExists = this.getSenders().find(function (s) {
      return s.track === track;
    });

    if (alreadyExists) {
      throw new DOMException('Track already exists.', 'InvalidAccessError');
    }

    this._streams = this._streams || {};
    this._reverseStreams = this._reverseStreams || {};
    var oldStream = this._streams[stream.id];

    if (oldStream) {
      // this is using odd Chrome behaviour, use with caution:
      // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
      // Note: we rely on the high-level addTrack/dtmf shim to
      // create the sender with a dtmf sender.
      oldStream.addTrack(track); // Trigger ONN async.

      Promise.resolve().then(function () {
        _this18.dispatchEvent(new Event('negotiationneeded'));
      });
    } else {
      var newStream = new window.MediaStream([track]);
      this._streams[stream.id] = newStream;
      this._reverseStreams[newStream.id] = stream;
      this.addStream(newStream);
    }

    return this.getSenders().find(function (s) {
      return s.track === track;
    });
  }; // replace the internal stream id with the external one and
  // vice versa.


  function replaceInternalStreamId(pc, description) {
    var sdp = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
      var externalStream = pc._reverseStreams[internalId];
      var internalStream = pc._streams[externalStream.id];
      sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp: sdp
    });
  }

  function replaceExternalStreamId(pc, description) {
    var sdp = description.sdp;
    Object.keys(pc._reverseStreams || []).forEach(function (internalId) {
      var externalStream = pc._reverseStreams[internalId];
      var internalStream = pc._streams[externalStream.id];
      sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
    });
    return new RTCSessionDescription({
      type: description.type,
      sdp: sdp
    });
  }

  ['createOffer', 'createAnswer'].forEach(function (method) {
    var nativeMethod = window.RTCPeerConnection.prototype[method];

    var methodObj = _defineProperty2({}, method, function () {
      var _this19 = this;

      var args = arguments;
      var isLegacyCall = arguments.length && typeof arguments[0] === 'function';

      if (isLegacyCall) {
        return nativeMethod.apply(this, [function (description) {
          var desc = replaceInternalStreamId(_this19, description);
          args[0].apply(null, [desc]);
        }, function (err) {
          if (args[1]) {
            args[1].apply(null, err);
          }
        }, arguments[2]]);
      }

      return nativeMethod.apply(this, arguments).then(function (description) {
        return replaceInternalStreamId(_this19, description);
      });
    });

    window.RTCPeerConnection.prototype[method] = methodObj[method];
  });
  var origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;

  window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
    if (!arguments.length || !arguments[0].type) {
      return origSetLocalDescription.apply(this, arguments);
    }

    arguments[0] = replaceExternalStreamId(this, arguments[0]);
    return origSetLocalDescription.apply(this, arguments);
  }; // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier


  var origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, 'localDescription');
  Object.defineProperty(window.RTCPeerConnection.prototype, 'localDescription', {
    get: function get() {
      var description = origLocalDescription.get.apply(this);

      if (description.type === '') {
        return description;
      }

      return replaceInternalStreamId(this, description);
    }
  });

  window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
    var _this20 = this;

    if (this.signalingState === 'closed') {
      throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
    } // We can not yet check for sender instanceof RTCRtpSender
    // since we shim RTPSender. So we check if sender._pc is set.


    if (!sender._pc) {
      throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' + 'does not implement interface RTCRtpSender.', 'TypeError');
    }

    var isLocal = sender._pc === this;

    if (!isLocal) {
      throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
    } // Search for the native stream the senders track belongs to.


    this._streams = this._streams || {};
    var stream;
    Object.keys(this._streams).forEach(function (streamid) {
      var hasTrack = _this20._streams[streamid].getTracks().find(function (track) {
        return sender.track === track;
      });

      if (hasTrack) {
        stream = _this20._streams[streamid];
      }
    });

    if (stream) {
      if (stream.getTracks().length === 1) {
        // if this is the last track of the stream, remove the stream. This
        // takes care of any shimmed _senders.
        this.removeStream(this._reverseStreams[stream.id]);
      } else {
        // relying on the same odd chrome behaviour as above.
        stream.removeTrack(sender.track);
      }

      this.dispatchEvent(new Event('negotiationneeded'));
    }
  };
}

function shimPeerConnection(window) {
  var browserDetails = detectBrowser(window);

  if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
    // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
  }

  if (!window.RTCPeerConnection) {
    return;
  } // shim implicit creation of RTCSessionDescription/RTCIceCandidate


  if (browserDetails.version < 53) {
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
      var nativeMethod = window.RTCPeerConnection.prototype[method];

      var methodObj = _defineProperty2({}, method, function () {
        arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
        return nativeMethod.apply(this, arguments);
      });

      window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
  } // support for addIceCandidate(null or undefined)


  var nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;

  window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
    if (!arguments[0]) {
      if (arguments[1]) {
        arguments[1].apply(null);
      }

      return Promise.resolve();
    } // Firefox 68+ emits and processes {candidate: "", ...}, ignore
    // in older versions. Native support planned for Chrome M77.


    if (browserDetails.version < 78 && arguments[0] && arguments[0].candidate === '') {
      return Promise.resolve();
    }

    return nativeAddIceCandidate.apply(this, arguments);
  };
}

function fixNegotiationNeeded(window) {
  wrapPeerConnectionEvent(window, 'negotiationneeded', function (e) {
    var pc = e.target;

    if (pc.signalingState !== 'stable') {
      return;
    }

    return e;
  });
}

var chromeShim = /*#__PURE__*/Object.freeze({
  __proto__: null,
  shimMediaStream: shimMediaStream,
  shimOnTrack: shimOnTrack,
  shimGetSendersWithDtmf: shimGetSendersWithDtmf,
  shimGetStats: shimGetStats,
  shimSenderReceiverGetStats: shimSenderReceiverGetStats,
  shimAddTrackRemoveTrackWithNative: shimAddTrackRemoveTrackWithNative,
  shimAddTrackRemoveTrack: shimAddTrackRemoveTrack,
  shimPeerConnection: shimPeerConnection,
  fixNegotiationNeeded: fixNegotiationNeeded,
  shimGetUserMedia: shimGetUserMedia,
  shimGetDisplayMedia: shimGetDisplayMedia
});
/*
 *  Copyright (c) 2018 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times

function filterIceServers(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function (server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;

      if (server.url && !server.urls) {
        deprecated('RTCIceServer.url', 'RTCIceServer.urls');
      }

      var _isString = typeof urls === 'string';

      if (_isString) {
        urls = [urls];
      }

      urls = urls.filter(function (url) {
        // filter STUN unconditionally.
        if (url.indexOf('stun:') === 0) {
          return false;
        }

        var validTurn = url.startsWith('turn') && !url.startsWith('turn:[') && url.includes('transport=udp');

        if (validTurn && !hasTurn) {
          hasTurn = true;
          return true;
        }

        return validTurn && !hasTurn;
      });
      delete server.url;
      server.urls = _isString ? urls[0] : urls;
      return !!urls.length;
    }
  });
}

var sdp = createCommonjsModule(function (module) {
  // SDP helpers.
  var SDPUtils = {}; // Generate an alphanumeric identifier for cname or mids.
  // TODO: use UUIDs instead? https://gist.github.com/jed/982883

  SDPUtils.generateIdentifier = function () {
    return Math.random().toString(36).substr(2, 10);
  }; // The RTCP CNAME used by all peerconnections from the same JS.


  SDPUtils.localCName = SDPUtils.generateIdentifier(); // Splits SDP into lines, dealing with both CRLF and LF.

  SDPUtils.splitLines = function (blob) {
    return blob.trim().split('\n').map(function (line) {
      return line.trim();
    });
  }; // Splits SDP into sessionpart and mediasections. Ensures CRLF.


  SDPUtils.splitSections = function (blob) {
    var parts = blob.split('\nm=');
    return parts.map(function (part, index) {
      return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
    });
  }; // returns the session description.


  SDPUtils.getDescription = function (blob) {
    var sections = SDPUtils.splitSections(blob);
    return sections && sections[0];
  }; // returns the individual media sections.


  SDPUtils.getMediaSections = function (blob) {
    var sections = SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
  }; // Returns lines that start with a certain prefix.


  SDPUtils.matchPrefix = function (blob, prefix) {
    return SDPUtils.splitLines(blob).filter(function (line) {
      return line.indexOf(prefix) === 0;
    });
  }; // Parses an ICE candidate line. Sample input:
  // candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
  // rport 55996"


  SDPUtils.parseCandidate = function (line) {
    var parts; // Parse both variants.

    if (line.indexOf('a=candidate:') === 0) {
      parts = line.substring(12).split(' ');
    } else {
      parts = line.substring(10).split(' ');
    }

    var candidate = {
      foundation: parts[0],
      component: parseInt(parts[1], 10),
      protocol: parts[2].toLowerCase(),
      priority: parseInt(parts[3], 10),
      ip: parts[4],
      address: parts[4],
      // address is an alias for ip.
      port: parseInt(parts[5], 10),
      // skip parts[6] == 'typ'
      type: parts[7]
    };

    for (var i = 8; i < parts.length; i += 2) {
      switch (parts[i]) {
        case 'raddr':
          candidate.relatedAddress = parts[i + 1];
          break;

        case 'rport':
          candidate.relatedPort = parseInt(parts[i + 1], 10);
          break;

        case 'tcptype':
          candidate.tcpType = parts[i + 1];
          break;

        case 'ufrag':
          candidate.ufrag = parts[i + 1]; // for backward compability.

          candidate.usernameFragment = parts[i + 1];
          break;

        default:
          // extension handling, in particular ufrag
          candidate[parts[i]] = parts[i + 1];
          break;
      }
    }

    return candidate;
  }; // Translates a candidate object into SDP candidate attribute.


  SDPUtils.writeCandidate = function (candidate) {
    var sdp = [];
    sdp.push(candidate.foundation);
    sdp.push(candidate.component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    var type = candidate.type;
    sdp.push('typ');
    sdp.push(type);

    if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort) {
      sdp.push('raddr');
      sdp.push(candidate.relatedAddress);
      sdp.push('rport');
      sdp.push(candidate.relatedPort);
    }

    if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
      sdp.push('tcptype');
      sdp.push(candidate.tcpType);
    }

    if (candidate.usernameFragment || candidate.ufrag) {
      sdp.push('ufrag');
      sdp.push(candidate.usernameFragment || candidate.ufrag);
    }

    return 'candidate:' + sdp.join(' ');
  }; // Parses an ice-options line, returns an array of option tags.
  // a=ice-options:foo bar


  SDPUtils.parseIceOptions = function (line) {
    return line.substr(14).split(' ');
  }; // Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
  // a=rtpmap:111 opus/48000/2


  SDPUtils.parseRtpMap = function (line) {
    var parts = line.substr(9).split(' ');
    var parsed = {
      payloadType: parseInt(parts.shift(), 10) // was: id

    };
    parts = parts[0].split('/');
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate

    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1; // legacy alias, got renamed back to channels in ORTC.

    parsed.numChannels = parsed.channels;
    return parsed;
  }; // Generate an a=rtpmap line from RTCRtpCodecCapability or
  // RTCRtpCodecParameters.


  SDPUtils.writeRtpMap = function (codec) {
    var pt = codec.payloadType;

    if (codec.preferredPayloadType !== undefined) {
      pt = codec.preferredPayloadType;
    }

    var channels = codec.channels || codec.numChannels || 1;
    return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
  }; // Parses an a=extmap line (headerextension from RFC 5285). Sample input:
  // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
  // a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset


  SDPUtils.parseExtmap = function (line) {
    var parts = line.substr(9).split(' ');
    return {
      id: parseInt(parts[0], 10),
      direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
      uri: parts[1]
    };
  }; // Generates a=extmap line from RTCRtpHeaderExtensionParameters or
  // RTCRtpHeaderExtension.


  SDPUtils.writeExtmap = function (headerExtension) {
    return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + '\r\n';
  }; // Parses an ftmp line, returns dictionary. Sample input:
  // a=fmtp:96 vbr=on;cng=on
  // Also deals with vbr=on; cng=on


  SDPUtils.parseFmtp = function (line) {
    var parsed = {};
    var kv;
    var parts = line.substr(line.indexOf(' ') + 1).split(';');

    for (var j = 0; j < parts.length; j++) {
      kv = parts[j].trim().split('=');
      parsed[kv[0].trim()] = kv[1];
    }

    return parsed;
  }; // Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.


  SDPUtils.writeFmtp = function (codec) {
    var line = '';
    var pt = codec.payloadType;

    if (codec.preferredPayloadType !== undefined) {
      pt = codec.preferredPayloadType;
    }

    if (codec.parameters && Object.keys(codec.parameters).length) {
      var params = [];
      Object.keys(codec.parameters).forEach(function (param) {
        if (codec.parameters[param]) {
          params.push(param + '=' + codec.parameters[param]);
        } else {
          params.push(param);
        }
      });
      line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
    }

    return line;
  }; // Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
  // a=rtcp-fb:98 nack rpsi


  SDPUtils.parseRtcpFb = function (line) {
    var parts = line.substr(line.indexOf(' ') + 1).split(' ');
    return {
      type: parts.shift(),
      parameter: parts.join(' ')
    };
  }; // Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.


  SDPUtils.writeRtcpFb = function (codec) {
    var lines = '';
    var pt = codec.payloadType;

    if (codec.preferredPayloadType !== undefined) {
      pt = codec.preferredPayloadType;
    }

    if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
      // FIXME: special handling for trr-int?
      codec.rtcpFeedback.forEach(function (fb) {
        lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
      });
    }

    return lines;
  }; // Parses an RFC 5576 ssrc media attribute. Sample input:
  // a=ssrc:3735928559 cname:something


  SDPUtils.parseSsrcMedia = function (line) {
    var sp = line.indexOf(' ');
    var parts = {
      ssrc: parseInt(line.substr(7, sp - 7), 10)
    };
    var colon = line.indexOf(':', sp);

    if (colon > -1) {
      parts.attribute = line.substr(sp + 1, colon - sp - 1);
      parts.value = line.substr(colon + 1);
    } else {
      parts.attribute = line.substr(sp + 1);
    }

    return parts;
  };

  SDPUtils.parseSsrcGroup = function (line) {
    var parts = line.substr(13).split(' ');
    return {
      semantics: parts.shift(),
      ssrcs: parts.map(function (ssrc) {
        return parseInt(ssrc, 10);
      })
    };
  }; // Extracts the MID (RFC 5888) from a media section.
  // returns the MID or undefined if no mid line was found.


  SDPUtils.getMid = function (mediaSection) {
    var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];

    if (mid) {
      return mid.substr(6);
    }
  };

  SDPUtils.parseFingerprint = function (line) {
    var parts = line.substr(14).split(' ');
    return {
      algorithm: parts[0].toLowerCase(),
      // algorithm is case-sensitive in Edge.
      value: parts[1]
    };
  }; // Extracts DTLS parameters from SDP media section or sessionpart.
  // FIXME: for consistency with other functions this should only
  //   get the fingerprint line as input. See also getIceParameters.


  SDPUtils.getDtlsParameters = function (mediaSection, sessionpart) {
    var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:'); // Note: a=setup line is ignored since we use the 'auto' role.
    // Note2: 'algorithm' is not case sensitive except in Edge.

    return {
      role: 'auto',
      fingerprints: lines.map(SDPUtils.parseFingerprint)
    };
  }; // Serializes DTLS parameters to SDP.


  SDPUtils.writeDtlsParameters = function (params, setupType) {
    var sdp = 'a=setup:' + setupType + '\r\n';
    params.fingerprints.forEach(function (fp) {
      sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
    });
    return sdp;
  }; // Parses a=crypto lines into
  //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members


  SDPUtils.parseCryptoLine = function (line) {
    var parts = line.substr(9).split(' ');
    return {
      tag: parseInt(parts[0], 10),
      cryptoSuite: parts[1],
      keyParams: parts[2],
      sessionParams: parts.slice(3)
    };
  };

  SDPUtils.writeCryptoLine = function (parameters) {
    return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
  }; // Parses the crypto key parameters into
  //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*


  SDPUtils.parseCryptoKeyParams = function (keyParams) {
    if (keyParams.indexOf('inline:') !== 0) {
      return null;
    }

    var parts = keyParams.substr(7).split('|');
    return {
      keyMethod: 'inline',
      keySalt: parts[0],
      lifeTime: parts[1],
      mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
      mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
    };
  };

  SDPUtils.writeCryptoKeyParams = function (keyParams) {
    return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
  }; // Extracts all SDES paramters.


  SDPUtils.getCryptoParameters = function (mediaSection, sessionpart) {
    var lines = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
    return lines.map(SDPUtils.parseCryptoLine);
  }; // Parses ICE information from SDP media section or sessionpart.
  // FIXME: for consistency with other functions this should only
  //   get the ice-ufrag and ice-pwd lines as input.


  SDPUtils.getIceParameters = function (mediaSection, sessionpart) {
    var ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
    var pwd = SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];

    if (!(ufrag && pwd)) {
      return null;
    }

    return {
      usernameFragment: ufrag.substr(12),
      password: pwd.substr(10)
    };
  }; // Serializes ICE parameters to SDP.


  SDPUtils.writeIceParameters = function (params) {
    return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
  }; // Parses the SDP media section and returns RTCRtpParameters.


  SDPUtils.parseRtpParameters = function (mediaSection) {
    var description = {
      codecs: [],
      headerExtensions: [],
      fecMechanisms: [],
      rtcp: []
    };
    var lines = SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(' ');

    for (var i = 3; i < mline.length; i++) {
      // find all codecs from mline[3..]
      var pt = mline[i];
      var rtpmapline = SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];

      if (rtpmapline) {
        var codec = SDPUtils.parseRtpMap(rtpmapline);
        var fmtps = SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' '); // Only the first a=fmtp:<pt> is considered.

        codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
        codec.rtcpFeedback = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map(SDPUtils.parseRtcpFb);
        description.codecs.push(codec); // parse FEC mechanisms from rtpmap lines.

        switch (codec.name.toUpperCase()) {
          case 'RED':
          case 'ULPFEC':
            description.fecMechanisms.push(codec.name.toUpperCase());
            break;
        }
      }
    }

    SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function (line) {
      description.headerExtensions.push(SDPUtils.parseExtmap(line));
    }); // FIXME: parse rtcp.

    return description;
  }; // Generates parts of the SDP media section describing the capabilities /
  // parameters.


  SDPUtils.writeRtpDescription = function (kind, caps) {
    var sdp = ''; // Build the mline.

    sdp += 'm=' + kind + ' ';
    sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.

    sdp += ' UDP/TLS/RTP/SAVPF ';
    sdp += caps.codecs.map(function (codec) {
      if (codec.preferredPayloadType !== undefined) {
        return codec.preferredPayloadType;
      }

      return codec.payloadType;
    }).join(' ') + '\r\n';
    sdp += 'c=IN IP4 0.0.0.0\r\n';
    sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n'; // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.

    caps.codecs.forEach(function (codec) {
      sdp += SDPUtils.writeRtpMap(codec);
      sdp += SDPUtils.writeFmtp(codec);
      sdp += SDPUtils.writeRtcpFb(codec);
    });
    var maxptime = 0;
    caps.codecs.forEach(function (codec) {
      if (codec.maxptime > maxptime) {
        maxptime = codec.maxptime;
      }
    });

    if (maxptime > 0) {
      sdp += 'a=maxptime:' + maxptime + '\r\n';
    }

    sdp += 'a=rtcp-mux\r\n';

    if (caps.headerExtensions) {
      caps.headerExtensions.forEach(function (extension) {
        sdp += SDPUtils.writeExtmap(extension);
      });
    } // FIXME: write fecMechanisms.


    return sdp;
  }; // Parses the SDP media section and returns an array of
  // RTCRtpEncodingParameters.


  SDPUtils.parseRtpEncodingParameters = function (mediaSection) {
    var encodingParameters = [];
    var description = SDPUtils.parseRtpParameters(mediaSection);
    var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
    var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1; // filter a=ssrc:... cname:, ignore PlanB-msid

    var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
      return SDPUtils.parseSsrcMedia(line);
    }).filter(function (parts) {
      return parts.attribute === 'cname';
    });
    var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    var secondarySsrc;
    var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map(function (line) {
      var parts = line.substr(17).split(' ');
      return parts.map(function (part) {
        return parseInt(part, 10);
      });
    });

    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
      secondarySsrc = flows[0][1];
    }

    description.codecs.forEach(function (codec) {
      if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
        var encParam = {
          ssrc: primarySsrc,
          codecPayloadType: parseInt(codec.parameters.apt, 10)
        };

        if (primarySsrc && secondarySsrc) {
          encParam.rtx = {
            ssrc: secondarySsrc
          };
        }

        encodingParameters.push(encParam);

        if (hasRed) {
          encParam = JSON.parse(JSON.stringify(encParam));
          encParam.fec = {
            ssrc: primarySsrc,
            mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
          };
          encodingParameters.push(encParam);
        }
      }
    });

    if (encodingParameters.length === 0 && primarySsrc) {
      encodingParameters.push({
        ssrc: primarySsrc
      });
    } // we support both b=AS and b=TIAS but interpret AS as TIAS.


    var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');

    if (bandwidth.length) {
      if (bandwidth[0].indexOf('b=TIAS:') === 0) {
        bandwidth = parseInt(bandwidth[0].substr(7), 10);
      } else if (bandwidth[0].indexOf('b=AS:') === 0) {
        // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95 - 50 * 40 * 8;
      } else {
        bandwidth = undefined;
      }

      encodingParameters.forEach(function (params) {
        params.maxBitrate = bandwidth;
      });
    }

    return encodingParameters;
  }; // parses http://draft.ortc.org/#rtcrtcpparameters*


  SDPUtils.parseRtcpParameters = function (mediaSection) {
    var rtcpParameters = {}; // Gets the first SSRC. Note tha with RTX there might be multiple
    // SSRCs.

    var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
      return SDPUtils.parseSsrcMedia(line);
    }).filter(function (obj) {
      return obj.attribute === 'cname';
    })[0];

    if (remoteSsrc) {
      rtcpParameters.cname = remoteSsrc.value;
      rtcpParameters.ssrc = remoteSsrc.ssrc;
    } // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize


    var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0; // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.

    var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
  }; // parses either a=msid: or a=ssrc:... msid lines and returns
  // the id of the MediaStream and MediaStreamTrack.


  SDPUtils.parseMsid = function (mediaSection) {
    var parts;
    var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');

    if (spec.length === 1) {
      parts = spec[0].substr(7).split(' ');
      return {
        stream: parts[0],
        track: parts[1]
      };
    }

    var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map(function (line) {
      return SDPUtils.parseSsrcMedia(line);
    }).filter(function (msidParts) {
      return msidParts.attribute === 'msid';
    });

    if (planB.length > 0) {
      parts = planB[0].value.split(' ');
      return {
        stream: parts[0],
        track: parts[1]
      };
    }
  }; // SCTP
  // parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
  // to draft-ietf-mmusic-sctp-sdp-05


  SDPUtils.parseSctpDescription = function (mediaSection) {
    var mline = SDPUtils.parseMLine(mediaSection);
    var maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
    var maxMessageSize;

    if (maxSizeLine.length > 0) {
      maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
    }

    if (isNaN(maxMessageSize)) {
      maxMessageSize = 65536;
    }

    var sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');

    if (sctpPort.length > 0) {
      return {
        port: parseInt(sctpPort[0].substr(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
      };
    }

    var sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');

    if (sctpMapLines.length > 0) {
      var parts = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:')[0].substr(10).split(' ');
      return {
        port: parseInt(parts[0], 10),
        protocol: parts[1],
        maxMessageSize: maxMessageSize
      };
    }
  }; // SCTP
  // outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
  // support by now receiving in this format, unless we originally parsed
  // as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
  // protocol of DTLS/SCTP -- without UDP/ or TCP/)


  SDPUtils.writeSctpDescription = function (media, sctp) {
    var output = [];

    if (media.protocol !== 'DTLS/SCTP') {
      output = ['m=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n', 'c=IN IP4 0.0.0.0\r\n', 'a=sctp-port:' + sctp.port + '\r\n'];
    } else {
      output = ['m=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n', 'c=IN IP4 0.0.0.0\r\n', 'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'];
    }

    if (sctp.maxMessageSize !== undefined) {
      output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
    }

    return output.join('');
  }; // Generate a session ID for SDP.
  // https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
  // recommends using a cryptographically random +ve 64-bit value
  // but right now this should be acceptable and within the right range


  SDPUtils.generateSessionId = function () {
    return Math.random().toString().substr(2, 21);
  }; // Write boilder plate for start of SDP
  // sessId argument is optional - if not supplied it will
  // be generated randomly
  // sessVersion is optional and defaults to 2
  // sessUser is optional and defaults to 'thisisadapterortc'


  SDPUtils.writeSessionBoilerplate = function (sessId, sessVer, sessUser) {
    var sessionId;
    var version = sessVer !== undefined ? sessVer : 2;

    if (sessId) {
      sessionId = sessId;
    } else {
      sessionId = SDPUtils.generateSessionId();
    }

    var user = sessUser || 'thisisadapterortc'; // FIXME: sess-id should be an NTP timestamp.

    return 'v=0\r\n' + 'o=' + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
  };

  SDPUtils.writeMediaSection = function (transceiver, caps, type, stream) {
    var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps); // Map ICE parameters (ufrag, pwd) to SDP.

    sdp += SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters()); // Map DTLS parameters to SDP.

    sdp += SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === 'offer' ? 'actpass' : 'active');
    sdp += 'a=mid:' + transceiver.mid + '\r\n';

    if (transceiver.direction) {
      sdp += 'a=' + transceiver.direction + '\r\n';
    } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
      sdp += 'a=sendrecv\r\n';
    } else if (transceiver.rtpSender) {
      sdp += 'a=sendonly\r\n';
    } else if (transceiver.rtpReceiver) {
      sdp += 'a=recvonly\r\n';
    } else {
      sdp += 'a=inactive\r\n';
    }

    if (transceiver.rtpSender) {
      // spec.
      var msid = 'msid:' + stream.id + ' ' + transceiver.rtpSender.track.id + '\r\n';
      sdp += 'a=' + msid; // for Chrome.

      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' ' + msid;

      if (transceiver.sendEncodingParameters[0].rtx) {
        sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' ' + msid;
        sdp += 'a=ssrc-group:FID ' + transceiver.sendEncodingParameters[0].ssrc + ' ' + transceiver.sendEncodingParameters[0].rtx.ssrc + '\r\n';
      }
    } // FIXME: this should be written by writeRtpDescription.


    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' cname:' + SDPUtils.localCName + '\r\n';

    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' cname:' + SDPUtils.localCName + '\r\n';
    }

    return sdp;
  }; // Gets the direction from the mediaSection or the sessionpart.


  SDPUtils.getDirection = function (mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    var lines = SDPUtils.splitLines(mediaSection);

    for (var i = 0; i < lines.length; i++) {
      switch (lines[i]) {
        case 'a=sendrecv':
        case 'a=sendonly':
        case 'a=recvonly':
        case 'a=inactive':
          return lines[i].substr(2);
        // FIXME: What should happen here?
      }
    }

    if (sessionpart) {
      return SDPUtils.getDirection(sessionpart);
    }

    return 'sendrecv';
  };

  SDPUtils.getKind = function (mediaSection) {
    var lines = SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(' ');
    return mline[0].substr(2);
  };

  SDPUtils.isRejected = function (mediaSection) {
    return mediaSection.split(' ', 2)[1] === '0';
  };

  SDPUtils.parseMLine = function (mediaSection) {
    var lines = SDPUtils.splitLines(mediaSection);
    var parts = lines[0].substr(2).split(' ');
    return {
      kind: parts[0],
      port: parseInt(parts[1], 10),
      protocol: parts[2],
      fmt: parts.slice(3).join(' ')
    };
  };

  SDPUtils.parseOLine = function (mediaSection) {
    var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
    var parts = line.substr(2).split(' ');
    return {
      username: parts[0],
      sessionId: parts[1],
      sessionVersion: parseInt(parts[2], 10),
      netType: parts[3],
      addressType: parts[4],
      address: parts[5]
    };
  }; // a very naive interpretation of a valid SDP.


  SDPUtils.isValidSDP = function (blob) {
    if (typeof blob !== 'string' || blob.length === 0) {
      return false;
    }

    var lines = SDPUtils.splitLines(blob);

    for (var i = 0; i < lines.length; i++) {
      if (lines[i].length < 2 || lines[i].charAt(1) !== '=') {
        return false;
      } // TODO: check the modifier a bit more.

    }

    return true;
  }; // Expose public methods.


  {
    module.exports = SDPUtils;
  }
});

function fixStatsType(stat) {
  return {
    inboundrtp: 'inbound-rtp',
    outboundrtp: 'outbound-rtp',
    candidatepair: 'candidate-pair',
    localcandidate: 'local-candidate',
    remotecandidate: 'remote-candidate'
  }[stat.type] || stat.type;
}

function writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
  var sdp$1 = sdp.writeRtpDescription(transceiver.kind, caps); // Map ICE parameters (ufrag, pwd) to SDP.

  sdp$1 += sdp.writeIceParameters(transceiver.iceGatherer.getLocalParameters()); // Map DTLS parameters to SDP.

  sdp$1 += sdp.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === 'offer' ? 'actpass' : dtlsRole || 'active');
  sdp$1 += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp$1 += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp$1 += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp$1 += 'a=recvonly\r\n';
  } else {
    sdp$1 += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    var trackId = transceiver.rtpSender._initialTrackId || transceiver.rtpSender.track.id;
    transceiver.rtpSender._initialTrackId = trackId; // spec.

    var msid = 'msid:' + (stream ? stream.id : '-') + ' ' + trackId + '\r\n';
    sdp$1 += 'a=' + msid; // for Chrome. Legacy should no longer be required.

    sdp$1 += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' ' + msid; // RTX

    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp$1 += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' ' + msid;
      sdp$1 += 'a=ssrc-group:FID ' + transceiver.sendEncodingParameters[0].ssrc + ' ' + transceiver.sendEncodingParameters[0].rtx.ssrc + '\r\n';
    }
  } // FIXME: this should be written by writeRtpDescription.


  sdp$1 += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc + ' cname:' + sdp.localCName + '\r\n';

  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp$1 += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc + ' cname:' + sdp.localCName + '\r\n';
  }

  return sdp$1;
} // Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times


function filterIceServers$1(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function (server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;

      if (server.url && !server.urls) {
        console.warn('RTCIceServer.url is deprecated! Use urls instead.');
      }

      var isString = typeof urls === 'string';

      if (isString) {
        urls = [urls];
      }

      urls = urls.filter(function (url) {
        var validTurn = url.indexOf('turn:') === 0 && url.indexOf('transport=udp') !== -1 && url.indexOf('turn:[') === -1 && !hasTurn;

        if (validTurn) {
          hasTurn = true;
          return true;
        }

        return url.indexOf('stun:') === 0 && edgeVersion >= 14393 && url.indexOf('?transport=udp') === -1;
      });
      delete server.url;
      server.urls = isString ? urls[0] : urls;
      return !!urls.length;
    }
  });
} // Determines the intersection of local and remote capabilities.


function getCommonCapabilities(localCapabilities, remoteCapabilities) {
  var commonCapabilities = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: []
  };

  var findCodecByPayloadType = function findCodecByPayloadType(pt, codecs) {
    pt = parseInt(pt, 10);

    for (var i = 0; i < codecs.length; i++) {
      if (codecs[i].payloadType === pt || codecs[i].preferredPayloadType === pt) {
        return codecs[i];
      }
    }
  };

  var rtxCapabilityMatches = function rtxCapabilityMatches(lRtx, rRtx, lCodecs, rCodecs) {
    var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
    var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
    return lCodec && rCodec && lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
  };

  localCapabilities.codecs.forEach(function (lCodec) {
    for (var i = 0; i < remoteCapabilities.codecs.length; i++) {
      var rCodec = remoteCapabilities.codecs[i];

      if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() && lCodec.clockRate === rCodec.clockRate) {
        if (lCodec.name.toLowerCase() === 'rtx' && lCodec.parameters && rCodec.parameters.apt) {
          // for RTX we need to find the local rtx that has a apt
          // which points to the same local codec as the remote one.
          if (!rtxCapabilityMatches(lCodec, rCodec, localCapabilities.codecs, remoteCapabilities.codecs)) {
            continue;
          }
        }

        rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
        // number of channels is the highest common number of channels

        rCodec.numChannels = Math.min(lCodec.numChannels, rCodec.numChannels); // push rCodec so we reply with offerer payload type

        commonCapabilities.codecs.push(rCodec); // determine common feedback mechanisms

        rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function (fb) {
          for (var j = 0; j < lCodec.rtcpFeedback.length; j++) {
            if (lCodec.rtcpFeedback[j].type === fb.type && lCodec.rtcpFeedback[j].parameter === fb.parameter) {
              return true;
            }
          }

          return false;
        }); // FIXME: also need to determine .parameters
        //  see https://github.com/openpeer/ortc/issues/569

        break;
      }
    }
  });
  localCapabilities.headerExtensions.forEach(function (lHeaderExtension) {
    for (var i = 0; i < remoteCapabilities.headerExtensions.length; i++) {
      var rHeaderExtension = remoteCapabilities.headerExtensions[i];

      if (lHeaderExtension.uri === rHeaderExtension.uri) {
        commonCapabilities.headerExtensions.push(rHeaderExtension);
        break;
      }
    }
  }); // FIXME: fecMechanisms

  return commonCapabilities;
} // is action=setLocalDescription with type allowed in signalingState


function isActionAllowedInSignalingState(action, type, signalingState) {
  return {
    offer: {
      setLocalDescription: ['stable', 'have-local-offer'],
      setRemoteDescription: ['stable', 'have-remote-offer']
    },
    answer: {
      setLocalDescription: ['have-remote-offer', 'have-local-pranswer'],
      setRemoteDescription: ['have-local-offer', 'have-remote-pranswer']
    }
  }[type][action].indexOf(signalingState) !== -1;
}

function maybeAddCandidate(iceTransport, candidate) {
  // Edge's internal representation adds some fields therefore
  // not all fieldѕ are taken into account.
  var alreadyAdded = iceTransport.getRemoteCandidates().find(function (remoteCandidate) {
    return candidate.foundation === remoteCandidate.foundation && candidate.ip === remoteCandidate.ip && candidate.port === remoteCandidate.port && candidate.priority === remoteCandidate.priority && candidate.protocol === remoteCandidate.protocol && candidate.type === remoteCandidate.type;
  });

  if (!alreadyAdded) {
    iceTransport.addRemoteCandidate(candidate);
  }

  return !alreadyAdded;
}

function makeError(name, description) {
  var e = new Error(description);
  e.name = name; // legacy error codes from https://heycam.github.io/webidl/#idl-DOMException-error-names

  e.code = {
    NotSupportedError: 9,
    InvalidStateError: 11,
    InvalidAccessError: 15,
    TypeError: undefined,
    OperationError: undefined
  }[name];
  return e;
}

var rtcpeerconnection = function rtcpeerconnection(window, edgeVersion) {
  // https://w3c.github.io/mediacapture-main/#mediastream
  // Helper function to add the track to the stream and
  // dispatch the event ourselves.
  function addTrackToStreamAndFireEvent(track, stream) {
    stream.addTrack(track);
    stream.dispatchEvent(new window.MediaStreamTrackEvent('addtrack', {
      track: track
    }));
  }

  function removeTrackFromStreamAndFireEvent(track, stream) {
    stream.removeTrack(track);
    stream.dispatchEvent(new window.MediaStreamTrackEvent('removetrack', {
      track: track
    }));
  }

  function fireAddTrack(pc, track, receiver, streams) {
    var trackEvent = new Event('track');
    trackEvent.track = track;
    trackEvent.receiver = receiver;
    trackEvent.transceiver = {
      receiver: receiver
    };
    trackEvent.streams = streams;
    window.setTimeout(function () {
      pc._dispatchEvent('track', trackEvent);
    });
  }

  var RTCPeerConnection = function RTCPeerConnection(config) {
    var pc = this;

    var _eventTarget = document.createDocumentFragment();

    ['addEventListener', 'removeEventListener', 'dispatchEvent'].forEach(function (method) {
      pc[method] = _eventTarget[method].bind(_eventTarget);
    });
    this.canTrickleIceCandidates = null;
    this.needNegotiation = false;
    this.localStreams = [];
    this.remoteStreams = [];
    this._localDescription = null;
    this._remoteDescription = null;
    this.signalingState = 'stable';
    this.iceConnectionState = 'new';
    this.connectionState = 'new';
    this.iceGatheringState = 'new';
    config = JSON.parse(JSON.stringify(config || {}));
    this.usingBundle = config.bundlePolicy === 'max-bundle';

    if (config.rtcpMuxPolicy === 'negotiate') {
      throw makeError('NotSupportedError', 'rtcpMuxPolicy \'negotiate\' is not supported');
    } else if (!config.rtcpMuxPolicy) {
      config.rtcpMuxPolicy = 'require';
    }

    switch (config.iceTransportPolicy) {
      case 'all':
      case 'relay':
        break;

      default:
        config.iceTransportPolicy = 'all';
        break;
    }

    switch (config.bundlePolicy) {
      case 'balanced':
      case 'max-compat':
      case 'max-bundle':
        break;

      default:
        config.bundlePolicy = 'balanced';
        break;
    }

    config.iceServers = filterIceServers$1(config.iceServers || [], edgeVersion);
    this._iceGatherers = [];

    if (config.iceCandidatePoolSize) {
      for (var i = config.iceCandidatePoolSize; i > 0; i--) {
        this._iceGatherers.push(new window.RTCIceGatherer({
          iceServers: config.iceServers,
          gatherPolicy: config.iceTransportPolicy
        }));
      }
    } else {
      config.iceCandidatePoolSize = 0;
    }

    this._config = config; // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
    // everything that is needed to describe a SDP m-line.

    this.transceivers = [];
    this._sdpSessionId = sdp.generateSessionId();
    this._sdpSessionVersion = 0;
    this._dtlsRole = undefined; // role for a=setup to use in answers.

    this._isClosed = false;
  };

  Object.defineProperty(RTCPeerConnection.prototype, 'localDescription', {
    configurable: true,
    get: function get() {
      return this._localDescription;
    }
  });
  Object.defineProperty(RTCPeerConnection.prototype, 'remoteDescription', {
    configurable: true,
    get: function get() {
      return this._remoteDescription;
    }
  }); // set up event handlers on prototype

  RTCPeerConnection.prototype.onicecandidate = null;
  RTCPeerConnection.prototype.onaddstream = null;
  RTCPeerConnection.prototype.ontrack = null;
  RTCPeerConnection.prototype.onremovestream = null;
  RTCPeerConnection.prototype.onsignalingstatechange = null;
  RTCPeerConnection.prototype.oniceconnectionstatechange = null;
  RTCPeerConnection.prototype.onconnectionstatechange = null;
  RTCPeerConnection.prototype.onicegatheringstatechange = null;
  RTCPeerConnection.prototype.onnegotiationneeded = null;
  RTCPeerConnection.prototype.ondatachannel = null;

  RTCPeerConnection.prototype._dispatchEvent = function (name, event) {
    if (this._isClosed) {
      return;
    }

    this.dispatchEvent(event);

    if (typeof this['on' + name] === 'function') {
      this['on' + name](event);
    }
  };

  RTCPeerConnection.prototype._emitGatheringStateChange = function () {
    var event = new Event('icegatheringstatechange');

    this._dispatchEvent('icegatheringstatechange', event);
  };

  RTCPeerConnection.prototype.getConfiguration = function () {
    return this._config;
  };

  RTCPeerConnection.prototype.getLocalStreams = function () {
    return this.localStreams;
  };

  RTCPeerConnection.prototype.getRemoteStreams = function () {
    return this.remoteStreams;
  }; // internal helper to create a transceiver object.
  // (which is not yet the same as the WebRTC 1.0 transceiver)


  RTCPeerConnection.prototype._createTransceiver = function (kind, doNotAdd) {
    var hasBundleTransport = this.transceivers.length > 0;
    var transceiver = {
      track: null,
      iceGatherer: null,
      iceTransport: null,
      dtlsTransport: null,
      localCapabilities: null,
      remoteCapabilities: null,
      rtpSender: null,
      rtpReceiver: null,
      kind: kind,
      mid: null,
      sendEncodingParameters: null,
      recvEncodingParameters: null,
      stream: null,
      associatedRemoteMediaStreams: [],
      wantReceive: true
    };

    if (this.usingBundle && hasBundleTransport) {
      transceiver.iceTransport = this.transceivers[0].iceTransport;
      transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
    } else {
      var transports = this._createIceAndDtlsTransports();

      transceiver.iceTransport = transports.iceTransport;
      transceiver.dtlsTransport = transports.dtlsTransport;
    }

    if (!doNotAdd) {
      this.transceivers.push(transceiver);
    }

    return transceiver;
  };

  RTCPeerConnection.prototype.addTrack = function (track, stream) {
    if (this._isClosed) {
      throw makeError('InvalidStateError', 'Attempted to call addTrack on a closed peerconnection.');
    }

    var alreadyExists = this.transceivers.find(function (s) {
      return s.track === track;
    });

    if (alreadyExists) {
      throw makeError('InvalidAccessError', 'Track already exists.');
    }

    var transceiver;

    for (var i = 0; i < this.transceivers.length; i++) {
      if (!this.transceivers[i].track && this.transceivers[i].kind === track.kind) {
        transceiver = this.transceivers[i];
      }
    }

    if (!transceiver) {
      transceiver = this._createTransceiver(track.kind);
    }

    this._maybeFireNegotiationNeeded();

    if (this.localStreams.indexOf(stream) === -1) {
      this.localStreams.push(stream);
    }

    transceiver.track = track;
    transceiver.stream = stream;
    transceiver.rtpSender = new window.RTCRtpSender(track, transceiver.dtlsTransport);
    return transceiver.rtpSender;
  };

  RTCPeerConnection.prototype.addStream = function (stream) {
    var pc = this;

    if (edgeVersion >= 15025) {
      stream.getTracks().forEach(function (track) {
        pc.addTrack(track, stream);
      });
    } else {
      // Clone is necessary for local demos mostly, attaching directly
      // to two different senders does not work (build 10547).
      // Fixed in 15025 (or earlier)
      var clonedStream = stream.clone();
      stream.getTracks().forEach(function (track, idx) {
        var clonedTrack = clonedStream.getTracks()[idx];
        track.addEventListener('enabled', function (event) {
          clonedTrack.enabled = event.enabled;
        });
      });
      clonedStream.getTracks().forEach(function (track) {
        pc.addTrack(track, clonedStream);
      });
    }
  };

  RTCPeerConnection.prototype.removeTrack = function (sender) {
    if (this._isClosed) {
      throw makeError('InvalidStateError', 'Attempted to call removeTrack on a closed peerconnection.');
    }

    if (!(sender instanceof window.RTCRtpSender)) {
      throw new TypeError('Argument 1 of RTCPeerConnection.removeTrack ' + 'does not implement interface RTCRtpSender.');
    }

    var transceiver = this.transceivers.find(function (t) {
      return t.rtpSender === sender;
    });

    if (!transceiver) {
      throw makeError('InvalidAccessError', 'Sender was not created by this connection.');
    }

    var stream = transceiver.stream;
    transceiver.rtpSender.stop();
    transceiver.rtpSender = null;
    transceiver.track = null;
    transceiver.stream = null; // remove the stream from the set of local streams

    var localStreams = this.transceivers.map(function (t) {
      return t.stream;
    });

    if (localStreams.indexOf(stream) === -1 && this.localStreams.indexOf(stream) > -1) {
      this.localStreams.splice(this.localStreams.indexOf(stream), 1);
    }

    this._maybeFireNegotiationNeeded();
  };

  RTCPeerConnection.prototype.removeStream = function (stream) {
    var pc = this;
    stream.getTracks().forEach(function (track) {
      var sender = pc.getSenders().find(function (s) {
        return s.track === track;
      });

      if (sender) {
        pc.removeTrack(sender);
      }
    });
  };

  RTCPeerConnection.prototype.getSenders = function () {
    return this.transceivers.filter(function (transceiver) {
      return !!transceiver.rtpSender;
    }).map(function (transceiver) {
      return transceiver.rtpSender;
    });
  };

  RTCPeerConnection.prototype.getReceivers = function () {
    return this.transceivers.filter(function (transceiver) {
      return !!transceiver.rtpReceiver;
    }).map(function (transceiver) {
      return transceiver.rtpReceiver;
    });
  };

  RTCPeerConnection.prototype._createIceGatherer = function (sdpMLineIndex, usingBundle) {
    var pc = this;

    if (usingBundle && sdpMLineIndex > 0) {
      return this.transceivers[0].iceGatherer;
    } else if (this._iceGatherers.length) {
      return this._iceGatherers.shift();
    }

    var iceGatherer = new window.RTCIceGatherer({
      iceServers: this._config.iceServers,
      gatherPolicy: this._config.iceTransportPolicy
    });
    Object.defineProperty(iceGatherer, 'state', {
      value: 'new',
      writable: true
    });
    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];

    this.transceivers[sdpMLineIndex].bufferCandidates = function (event) {
      var end = !event.candidate || Object.keys(event.candidate).length === 0; // polyfill since RTCIceGatherer.state is not implemented in
      // Edge 10547 yet.

      iceGatherer.state = end ? 'completed' : 'gathering';

      if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) {
        pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
      }
    };

    iceGatherer.addEventListener('localcandidate', this.transceivers[sdpMLineIndex].bufferCandidates);
    return iceGatherer;
  }; // start gathering from an RTCIceGatherer.


  RTCPeerConnection.prototype._gather = function (mid, sdpMLineIndex) {
    var pc = this;
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;

    if (iceGatherer.onlocalcandidate) {
      return;
    }

    var bufferedCandidateEvents = this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
    iceGatherer.removeEventListener('localcandidate', this.transceivers[sdpMLineIndex].bufferCandidates);

    iceGatherer.onlocalcandidate = function (evt) {
      if (pc.usingBundle && sdpMLineIndex > 0) {
        // if we know that we use bundle we can drop candidates with
        // ѕdpMLineIndex > 0. If we don't do this then our state gets
        // confused since we dispose the extra ice gatherer.
        return;
      }

      var event = new Event('icecandidate');
      event.candidate = {
        sdpMid: mid,
        sdpMLineIndex: sdpMLineIndex
      };
      var cand = evt.candidate; // Edge emits an empty object for RTCIceCandidateComplete‥

      var end = !cand || Object.keys(cand).length === 0;

      if (end) {
        // polyfill since RTCIceGatherer.state is not implemented in
        // Edge 10547 yet.
        if (iceGatherer.state === 'new' || iceGatherer.state === 'gathering') {
          iceGatherer.state = 'completed';
        }
      } else {
        if (iceGatherer.state === 'new') {
          iceGatherer.state = 'gathering';
        } // RTCIceCandidate doesn't have a component, needs to be added


        cand.component = 1; // also the usernameFragment. TODO: update SDP to take both variants.

        cand.ufrag = iceGatherer.getLocalParameters().usernameFragment;
        var serializedCandidate = sdp.writeCandidate(cand);
        event.candidate = Object.assign(event.candidate, sdp.parseCandidate(serializedCandidate));
        event.candidate.candidate = serializedCandidate;

        event.candidate.toJSON = function () {
          return {
            candidate: event.candidate.candidate,
            sdpMid: event.candidate.sdpMid,
            sdpMLineIndex: event.candidate.sdpMLineIndex,
            usernameFragment: event.candidate.usernameFragment
          };
        };
      } // update local description.


      var sections = sdp.getMediaSections(pc._localDescription.sdp);

      if (!end) {
        sections[event.candidate.sdpMLineIndex] += 'a=' + event.candidate.candidate + '\r\n';
      } else {
        sections[event.candidate.sdpMLineIndex] += 'a=end-of-candidates\r\n';
      }

      pc._localDescription.sdp = sdp.getDescription(pc._localDescription.sdp) + sections.join('');
      var complete = pc.transceivers.every(function (transceiver) {
        return transceiver.iceGatherer && transceiver.iceGatherer.state === 'completed';
      });

      if (pc.iceGatheringState !== 'gathering') {
        pc.iceGatheringState = 'gathering';

        pc._emitGatheringStateChange();
      } // Emit candidate. Also emit null candidate when all gatherers are
      // complete.


      if (!end) {
        pc._dispatchEvent('icecandidate', event);
      }

      if (complete) {
        pc._dispatchEvent('icecandidate', new Event('icecandidate'));

        pc.iceGatheringState = 'complete';

        pc._emitGatheringStateChange();
      }
    }; // emit already gathered candidates.


    window.setTimeout(function () {
      bufferedCandidateEvents.forEach(function (e) {
        iceGatherer.onlocalcandidate(e);
      });
    }, 0);
  }; // Create ICE transport and DTLS transport.


  RTCPeerConnection.prototype._createIceAndDtlsTransports = function () {
    var pc = this;
    var iceTransport = new window.RTCIceTransport(null);

    iceTransport.onicestatechange = function () {
      pc._updateIceConnectionState();

      pc._updateConnectionState();
    };

    var dtlsTransport = new window.RTCDtlsTransport(iceTransport);

    dtlsTransport.ondtlsstatechange = function () {
      pc._updateConnectionState();
    };

    dtlsTransport.onerror = function () {
      // onerror does not set state to failed by itself.
      Object.defineProperty(dtlsTransport, 'state', {
        value: 'failed',
        writable: true
      });

      pc._updateConnectionState();
    };

    return {
      iceTransport: iceTransport,
      dtlsTransport: dtlsTransport
    };
  }; // Destroy ICE gatherer, ICE transport and DTLS transport.
  // Without triggering the callbacks.


  RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function (sdpMLineIndex) {
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;

    if (iceGatherer) {
      delete iceGatherer.onlocalcandidate;
      delete this.transceivers[sdpMLineIndex].iceGatherer;
    }

    var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;

    if (iceTransport) {
      delete iceTransport.onicestatechange;
      delete this.transceivers[sdpMLineIndex].iceTransport;
    }

    var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;

    if (dtlsTransport) {
      delete dtlsTransport.ondtlsstatechange;
      delete dtlsTransport.onerror;
      delete this.transceivers[sdpMLineIndex].dtlsTransport;
    }
  }; // Start the RTP Sender and Receiver for a transceiver.


  RTCPeerConnection.prototype._transceive = function (transceiver, send, recv) {
    var params = getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);

    if (send && transceiver.rtpSender) {
      params.encodings = transceiver.sendEncodingParameters;
      params.rtcp = {
        cname: sdp.localCName,
        compound: transceiver.rtcpParameters.compound
      };

      if (transceiver.recvEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
      }

      transceiver.rtpSender.send(params);
    }

    if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
      // remove RTX field in Edge 14942
      if (transceiver.kind === 'video' && transceiver.recvEncodingParameters && edgeVersion < 15019) {
        transceiver.recvEncodingParameters.forEach(function (p) {
          delete p.rtx;
        });
      }

      if (transceiver.recvEncodingParameters.length) {
        params.encodings = transceiver.recvEncodingParameters;
      } else {
        params.encodings = [{}];
      }

      params.rtcp = {
        compound: transceiver.rtcpParameters.compound
      };

      if (transceiver.rtcpParameters.cname) {
        params.rtcp.cname = transceiver.rtcpParameters.cname;
      }

      if (transceiver.sendEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
      }

      transceiver.rtpReceiver.receive(params);
    }
  };

  RTCPeerConnection.prototype.setLocalDescription = function (description) {
    var pc = this; // Note: pranswer is not supported.

    if (['offer', 'answer'].indexOf(description.type) === -1) {
      return Promise.reject(makeError('TypeError', 'Unsupported type "' + description.type + '"'));
    }

    if (!isActionAllowedInSignalingState('setLocalDescription', description.type, pc.signalingState) || pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError', 'Can not set local ' + description.type + ' in state ' + pc.signalingState));
    }

    var sections;
    var sessionpart;

    if (description.type === 'offer') {
      // VERY limited support for SDP munging. Limited to:
      // * changing the order of codecs
      sections = sdp.splitSections(description.sdp);
      sessionpart = sections.shift();
      sections.forEach(function (mediaSection, sdpMLineIndex) {
        var caps = sdp.parseRtpParameters(mediaSection);
        pc.transceivers[sdpMLineIndex].localCapabilities = caps;
      });
      pc.transceivers.forEach(function (transceiver, sdpMLineIndex) {
        pc._gather(transceiver.mid, sdpMLineIndex);
      });
    } else if (description.type === 'answer') {
      sections = sdp.splitSections(pc._remoteDescription.sdp);
      sessionpart = sections.shift();
      var isIceLite = sdp.matchPrefix(sessionpart, 'a=ice-lite').length > 0;
      sections.forEach(function (mediaSection, sdpMLineIndex) {
        var transceiver = pc.transceivers[sdpMLineIndex];
        var iceGatherer = transceiver.iceGatherer;
        var iceTransport = transceiver.iceTransport;
        var dtlsTransport = transceiver.dtlsTransport;
        var localCapabilities = transceiver.localCapabilities;
        var remoteCapabilities = transceiver.remoteCapabilities; // treat bundle-only as not-rejected.

        var rejected = sdp.isRejected(mediaSection) && sdp.matchPrefix(mediaSection, 'a=bundle-only').length === 0;

        if (!rejected && !transceiver.rejected) {
          var remoteIceParameters = sdp.getIceParameters(mediaSection, sessionpart);
          var remoteDtlsParameters = sdp.getDtlsParameters(mediaSection, sessionpart);

          if (isIceLite) {
            remoteDtlsParameters.role = 'server';
          }

          if (!pc.usingBundle || sdpMLineIndex === 0) {
            pc._gather(transceiver.mid, sdpMLineIndex);

            if (iceTransport.state === 'new') {
              iceTransport.start(iceGatherer, remoteIceParameters, isIceLite ? 'controlling' : 'controlled');
            }

            if (dtlsTransport.state === 'new') {
              dtlsTransport.start(remoteDtlsParameters);
            }
          } // Calculate intersection of capabilities.


          var params = getCommonCapabilities(localCapabilities, remoteCapabilities); // Start the RTCRtpSender. The RTCRtpReceiver for this
          // transceiver has already been started in setRemoteDescription.

          pc._transceive(transceiver, params.codecs.length > 0, false);
        }
      });
    }

    pc._localDescription = {
      type: description.type,
      sdp: description.sdp
    };

    if (description.type === 'offer') {
      pc._updateSignalingState('have-local-offer');
    } else {
      pc._updateSignalingState('stable');
    }

    return Promise.resolve();
  };

  RTCPeerConnection.prototype.setRemoteDescription = function (description) {
    var pc = this; // Note: pranswer is not supported.

    if (['offer', 'answer'].indexOf(description.type) === -1) {
      return Promise.reject(makeError('TypeError', 'Unsupported type "' + description.type + '"'));
    }

    if (!isActionAllowedInSignalingState('setRemoteDescription', description.type, pc.signalingState) || pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError', 'Can not set remote ' + description.type + ' in state ' + pc.signalingState));
    }

    var streams = {};
    pc.remoteStreams.forEach(function (stream) {
      streams[stream.id] = stream;
    });
    var receiverList = [];
    var sections = sdp.splitSections(description.sdp);
    var sessionpart = sections.shift();
    var isIceLite = sdp.matchPrefix(sessionpart, 'a=ice-lite').length > 0;
    var usingBundle = sdp.matchPrefix(sessionpart, 'a=group:BUNDLE ').length > 0;
    pc.usingBundle = usingBundle;
    var iceOptions = sdp.matchPrefix(sessionpart, 'a=ice-options:')[0];

    if (iceOptions) {
      pc.canTrickleIceCandidates = iceOptions.substr(14).split(' ').indexOf('trickle') >= 0;
    } else {
      pc.canTrickleIceCandidates = false;
    }

    sections.forEach(function (mediaSection, sdpMLineIndex) {
      var lines = sdp.splitLines(mediaSection);
      var kind = sdp.getKind(mediaSection); // treat bundle-only as not-rejected.

      var rejected = sdp.isRejected(mediaSection) && sdp.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
      var protocol = lines[0].substr(2).split(' ')[2];
      var direction = sdp.getDirection(mediaSection, sessionpart);
      var remoteMsid = sdp.parseMsid(mediaSection);
      var mid = sdp.getMid(mediaSection) || sdp.generateIdentifier(); // Reject datachannels which are not implemented yet.

      if (rejected || kind === 'application' && (protocol === 'DTLS/SCTP' || protocol === 'UDP/DTLS/SCTP')) {
        // TODO: this is dangerous in the case where a non-rejected m-line
        //     becomes rejected.
        pc.transceivers[sdpMLineIndex] = {
          mid: mid,
          kind: kind,
          protocol: protocol,
          rejected: true
        };
        return;
      }

      if (!rejected && pc.transceivers[sdpMLineIndex] && pc.transceivers[sdpMLineIndex].rejected) {
        // recycle a rejected transceiver.
        pc.transceivers[sdpMLineIndex] = pc._createTransceiver(kind, true);
      }

      var transceiver;
      var iceGatherer;
      var iceTransport;
      var dtlsTransport;
      var rtpReceiver;
      var sendEncodingParameters;
      var recvEncodingParameters;
      var localCapabilities;
      var track; // FIXME: ensure the mediaSection has rtcp-mux set.

      var remoteCapabilities = sdp.parseRtpParameters(mediaSection);
      var remoteIceParameters;
      var remoteDtlsParameters;

      if (!rejected) {
        remoteIceParameters = sdp.getIceParameters(mediaSection, sessionpart);
        remoteDtlsParameters = sdp.getDtlsParameters(mediaSection, sessionpart);
        remoteDtlsParameters.role = 'client';
      }

      recvEncodingParameters = sdp.parseRtpEncodingParameters(mediaSection);
      var rtcpParameters = sdp.parseRtcpParameters(mediaSection);
      var isComplete = sdp.matchPrefix(mediaSection, 'a=end-of-candidates', sessionpart).length > 0;
      var cands = sdp.matchPrefix(mediaSection, 'a=candidate:').map(function (cand) {
        return sdp.parseCandidate(cand);
      }).filter(function (cand) {
        return cand.component === 1;
      }); // Check if we can use BUNDLE and dispose transports.

      if ((description.type === 'offer' || description.type === 'answer') && !rejected && usingBundle && sdpMLineIndex > 0 && pc.transceivers[sdpMLineIndex]) {
        pc._disposeIceAndDtlsTransports(sdpMLineIndex);

        pc.transceivers[sdpMLineIndex].iceGatherer = pc.transceivers[0].iceGatherer;
        pc.transceivers[sdpMLineIndex].iceTransport = pc.transceivers[0].iceTransport;
        pc.transceivers[sdpMLineIndex].dtlsTransport = pc.transceivers[0].dtlsTransport;

        if (pc.transceivers[sdpMLineIndex].rtpSender) {
          pc.transceivers[sdpMLineIndex].rtpSender.setTransport(pc.transceivers[0].dtlsTransport);
        }

        if (pc.transceivers[sdpMLineIndex].rtpReceiver) {
          pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(pc.transceivers[0].dtlsTransport);
        }
      }

      if (description.type === 'offer' && !rejected) {
        transceiver = pc.transceivers[sdpMLineIndex] || pc._createTransceiver(kind);
        transceiver.mid = mid;

        if (!transceiver.iceGatherer) {
          transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, usingBundle);
        }

        if (cands.length && transceiver.iceTransport.state === 'new') {
          if (isComplete && (!usingBundle || sdpMLineIndex === 0)) {
            transceiver.iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function (candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        localCapabilities = window.RTCRtpReceiver.getCapabilities(kind); // filter RTX until additional stuff needed for RTX is implemented
        // in adapter.js

        if (edgeVersion < 15019) {
          localCapabilities.codecs = localCapabilities.codecs.filter(function (codec) {
            return codec.name !== 'rtx';
          });
        }

        sendEncodingParameters = transceiver.sendEncodingParameters || [{
          ssrc: (2 * sdpMLineIndex + 2) * 1001
        }]; // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams

        var isNewTrack = false;

        if (direction === 'sendrecv' || direction === 'sendonly') {
          isNewTrack = !transceiver.rtpReceiver;
          rtpReceiver = transceiver.rtpReceiver || new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);

          if (isNewTrack) {
            var stream;
            track = rtpReceiver.track; // FIXME: does not work with Plan B.

            if (remoteMsid && remoteMsid.stream === '-') ;else if (remoteMsid) {
              if (!streams[remoteMsid.stream]) {
                streams[remoteMsid.stream] = new window.MediaStream();
                Object.defineProperty(streams[remoteMsid.stream], 'id', {
                  get: function get() {
                    return remoteMsid.stream;
                  }
                });
              }

              Object.defineProperty(track, 'id', {
                get: function get() {
                  return remoteMsid.track;
                }
              });
              stream = streams[remoteMsid.stream];
            } else {
              if (!streams.default) {
                streams.default = new window.MediaStream();
              }

              stream = streams.default;
            }

            if (stream) {
              addTrackToStreamAndFireEvent(track, stream);
              transceiver.associatedRemoteMediaStreams.push(stream);
            }

            receiverList.push([track, rtpReceiver, stream]);
          }
        } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
          transceiver.associatedRemoteMediaStreams.forEach(function (s) {
            var nativeTrack = s.getTracks().find(function (t) {
              return t.id === transceiver.rtpReceiver.track.id;
            });

            if (nativeTrack) {
              removeTrackFromStreamAndFireEvent(nativeTrack, s);
            }
          });
          transceiver.associatedRemoteMediaStreams = [];
        }

        transceiver.localCapabilities = localCapabilities;
        transceiver.remoteCapabilities = remoteCapabilities;
        transceiver.rtpReceiver = rtpReceiver;
        transceiver.rtcpParameters = rtcpParameters;
        transceiver.sendEncodingParameters = sendEncodingParameters;
        transceiver.recvEncodingParameters = recvEncodingParameters; // Start the RTCRtpReceiver now. The RTPSender is started in
        // setLocalDescription.

        pc._transceive(pc.transceivers[sdpMLineIndex], false, isNewTrack);
      } else if (description.type === 'answer' && !rejected) {
        transceiver = pc.transceivers[sdpMLineIndex];
        iceGatherer = transceiver.iceGatherer;
        iceTransport = transceiver.iceTransport;
        dtlsTransport = transceiver.dtlsTransport;
        rtpReceiver = transceiver.rtpReceiver;
        sendEncodingParameters = transceiver.sendEncodingParameters;
        localCapabilities = transceiver.localCapabilities;
        pc.transceivers[sdpMLineIndex].recvEncodingParameters = recvEncodingParameters;
        pc.transceivers[sdpMLineIndex].remoteCapabilities = remoteCapabilities;
        pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;

        if (cands.length && iceTransport.state === 'new') {
          if ((isIceLite || isComplete) && (!usingBundle || sdpMLineIndex === 0)) {
            iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function (candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        if (!usingBundle || sdpMLineIndex === 0) {
          if (iceTransport.state === 'new') {
            iceTransport.start(iceGatherer, remoteIceParameters, 'controlling');
          }

          if (dtlsTransport.state === 'new') {
            dtlsTransport.start(remoteDtlsParameters);
          }
        } // If the offer contained RTX but the answer did not,
        // remove RTX from sendEncodingParameters.


        var commonCapabilities = getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
        var hasRtx = commonCapabilities.codecs.filter(function (c) {
          return c.name.toLowerCase() === 'rtx';
        }).length;

        if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
          delete transceiver.sendEncodingParameters[0].rtx;
        }

        pc._transceive(transceiver, direction === 'sendrecv' || direction === 'recvonly', direction === 'sendrecv' || direction === 'sendonly'); // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams


        if (rtpReceiver && (direction === 'sendrecv' || direction === 'sendonly')) {
          track = rtpReceiver.track;

          if (remoteMsid) {
            if (!streams[remoteMsid.stream]) {
              streams[remoteMsid.stream] = new window.MediaStream();
            }

            addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
            receiverList.push([track, rtpReceiver, streams[remoteMsid.stream]]);
          } else {
            if (!streams.default) {
              streams.default = new window.MediaStream();
            }

            addTrackToStreamAndFireEvent(track, streams.default);
            receiverList.push([track, rtpReceiver, streams.default]);
          }
        } else {
          // FIXME: actually the receiver should be created later.
          delete transceiver.rtpReceiver;
        }
      }
    });

    if (pc._dtlsRole === undefined) {
      pc._dtlsRole = description.type === 'offer' ? 'active' : 'passive';
    }

    pc._remoteDescription = {
      type: description.type,
      sdp: description.sdp
    };

    if (description.type === 'offer') {
      pc._updateSignalingState('have-remote-offer');
    } else {
      pc._updateSignalingState('stable');
    }

    Object.keys(streams).forEach(function (sid) {
      var stream = streams[sid];

      if (stream.getTracks().length) {
        if (pc.remoteStreams.indexOf(stream) === -1) {
          pc.remoteStreams.push(stream);
          var event = new Event('addstream');
          event.stream = stream;
          window.setTimeout(function () {
            pc._dispatchEvent('addstream', event);
          });
        }

        receiverList.forEach(function (item) {
          var track = item[0];
          var receiver = item[1];

          if (stream.id !== item[2].id) {
            return;
          }

          fireAddTrack(pc, track, receiver, [stream]);
        });
      }
    });
    receiverList.forEach(function (item) {
      if (item[2]) {
        return;
      }

      fireAddTrack(pc, item[0], item[1], []);
    }); // check whether addIceCandidate({}) was called within four seconds after
    // setRemoteDescription.

    window.setTimeout(function () {
      if (!(pc && pc.transceivers)) {
        return;
      }

      pc.transceivers.forEach(function (transceiver) {
        if (transceiver.iceTransport && transceiver.iceTransport.state === 'new' && transceiver.iceTransport.getRemoteCandidates().length > 0) {
          console.warn('Timeout for addRemoteCandidate. Consider sending ' + 'an end-of-candidates notification');
          transceiver.iceTransport.addRemoteCandidate({});
        }
      });
    }, 4000);
    return Promise.resolve();
  };

  RTCPeerConnection.prototype.close = function () {
    this.transceivers.forEach(function (transceiver) {
      /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */
      if (transceiver.iceTransport) {
        transceiver.iceTransport.stop();
      }

      if (transceiver.dtlsTransport) {
        transceiver.dtlsTransport.stop();
      }

      if (transceiver.rtpSender) {
        transceiver.rtpSender.stop();
      }

      if (transceiver.rtpReceiver) {
        transceiver.rtpReceiver.stop();
      }
    }); // FIXME: clean up tracks, local streams, remote streams, etc

    this._isClosed = true;

    this._updateSignalingState('closed');
  }; // Update the signaling state.


  RTCPeerConnection.prototype._updateSignalingState = function (newState) {
    this.signalingState = newState;
    var event = new Event('signalingstatechange');

    this._dispatchEvent('signalingstatechange', event);
  }; // Determine whether to fire the negotiationneeded event.


  RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function () {
    var pc = this;

    if (this.signalingState !== 'stable' || this.needNegotiation === true) {
      return;
    }

    this.needNegotiation = true;
    window.setTimeout(function () {
      if (pc.needNegotiation) {
        pc.needNegotiation = false;
        var event = new Event('negotiationneeded');

        pc._dispatchEvent('negotiationneeded', event);
      }
    }, 0);
  }; // Update the ice connection state.


  RTCPeerConnection.prototype._updateIceConnectionState = function () {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      checking: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function (transceiver) {
      if (transceiver.iceTransport && !transceiver.rejected) {
        states[transceiver.iceTransport.state]++;
      }
    });
    newState = 'new';

    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.checking > 0) {
      newState = 'checking';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0) {
      newState = 'connected';
    } else if (states.completed > 0) {
      newState = 'completed';
    }

    if (newState !== this.iceConnectionState) {
      this.iceConnectionState = newState;
      var event = new Event('iceconnectionstatechange');

      this._dispatchEvent('iceconnectionstatechange', event);
    }
  }; // Update the connection state.


  RTCPeerConnection.prototype._updateConnectionState = function () {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      connecting: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function (transceiver) {
      if (transceiver.iceTransport && transceiver.dtlsTransport && !transceiver.rejected) {
        states[transceiver.iceTransport.state]++;
        states[transceiver.dtlsTransport.state]++;
      }
    }); // ICETransport.completed and connected are the same for this purpose.

    states.connected += states.completed;
    newState = 'new';

    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.connecting > 0) {
      newState = 'connecting';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0) {
      newState = 'connected';
    }

    if (newState !== this.connectionState) {
      this.connectionState = newState;
      var event = new Event('connectionstatechange');

      this._dispatchEvent('connectionstatechange', event);
    }
  };

  RTCPeerConnection.prototype.createOffer = function () {
    var pc = this;

    if (pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError', 'Can not call createOffer after close'));
    }

    var numAudioTracks = pc.transceivers.filter(function (t) {
      return t.kind === 'audio';
    }).length;
    var numVideoTracks = pc.transceivers.filter(function (t) {
      return t.kind === 'video';
    }).length; // Determine number of audio and video tracks we need to send/recv.

    var offerOptions = arguments[0];

    if (offerOptions) {
      // Reject Chrome legacy constraints.
      if (offerOptions.mandatory || offerOptions.optional) {
        throw new TypeError('Legacy mandatory/optional constraints not supported.');
      }

      if (offerOptions.offerToReceiveAudio !== undefined) {
        if (offerOptions.offerToReceiveAudio === true) {
          numAudioTracks = 1;
        } else if (offerOptions.offerToReceiveAudio === false) {
          numAudioTracks = 0;
        } else {
          numAudioTracks = offerOptions.offerToReceiveAudio;
        }
      }

      if (offerOptions.offerToReceiveVideo !== undefined) {
        if (offerOptions.offerToReceiveVideo === true) {
          numVideoTracks = 1;
        } else if (offerOptions.offerToReceiveVideo === false) {
          numVideoTracks = 0;
        } else {
          numVideoTracks = offerOptions.offerToReceiveVideo;
        }
      }
    }

    pc.transceivers.forEach(function (transceiver) {
      if (transceiver.kind === 'audio') {
        numAudioTracks--;

        if (numAudioTracks < 0) {
          transceiver.wantReceive = false;
        }
      } else if (transceiver.kind === 'video') {
        numVideoTracks--;

        if (numVideoTracks < 0) {
          transceiver.wantReceive = false;
        }
      }
    }); // Create M-lines for recvonly streams.

    while (numAudioTracks > 0 || numVideoTracks > 0) {
      if (numAudioTracks > 0) {
        pc._createTransceiver('audio');

        numAudioTracks--;
      }

      if (numVideoTracks > 0) {
        pc._createTransceiver('video');

        numVideoTracks--;
      }
    }

    var sdp$1 = sdp.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
    pc.transceivers.forEach(function (transceiver, sdpMLineIndex) {
      // For each track, create an ice gatherer, ice transport,
      // dtls transport, potentially rtpsender and rtpreceiver.
      var track = transceiver.track;
      var kind = transceiver.kind;
      var mid = transceiver.mid || sdp.generateIdentifier();
      transceiver.mid = mid;

      if (!transceiver.iceGatherer) {
        transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, pc.usingBundle);
      }

      var localCapabilities = window.RTCRtpSender.getCapabilities(kind); // filter RTX until additional stuff needed for RTX is implemented
      // in adapter.js

      if (edgeVersion < 15019) {
        localCapabilities.codecs = localCapabilities.codecs.filter(function (codec) {
          return codec.name !== 'rtx';
        });
      }

      localCapabilities.codecs.forEach(function (codec) {
        // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
        // by adding level-asymmetry-allowed=1
        if (codec.name === 'H264' && codec.parameters['level-asymmetry-allowed'] === undefined) {
          codec.parameters['level-asymmetry-allowed'] = '1';
        } // for subsequent offers, we might have to re-use the payload
        // type of the last offer.


        if (transceiver.remoteCapabilities && transceiver.remoteCapabilities.codecs) {
          transceiver.remoteCapabilities.codecs.forEach(function (remoteCodec) {
            if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() && codec.clockRate === remoteCodec.clockRate) {
              codec.preferredPayloadType = remoteCodec.payloadType;
            }
          });
        }
      });
      localCapabilities.headerExtensions.forEach(function (hdrExt) {
        var remoteExtensions = transceiver.remoteCapabilities && transceiver.remoteCapabilities.headerExtensions || [];
        remoteExtensions.forEach(function (rHdrExt) {
          if (hdrExt.uri === rHdrExt.uri) {
            hdrExt.id = rHdrExt.id;
          }
        });
      }); // generate an ssrc now, to be used later in rtpSender.send

      var sendEncodingParameters = transceiver.sendEncodingParameters || [{
        ssrc: (2 * sdpMLineIndex + 1) * 1001
      }];

      if (track) {
        // add RTX
        if (edgeVersion >= 15019 && kind === 'video' && !sendEncodingParameters[0].rtx) {
          sendEncodingParameters[0].rtx = {
            ssrc: sendEncodingParameters[0].ssrc + 1
          };
        }
      }

      if (transceiver.wantReceive) {
        transceiver.rtpReceiver = new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
      }

      transceiver.localCapabilities = localCapabilities;
      transceiver.sendEncodingParameters = sendEncodingParameters;
    }); // always offer BUNDLE and dispose on return if not supported.

    if (pc._config.bundlePolicy !== 'max-compat') {
      sdp$1 += 'a=group:BUNDLE ' + pc.transceivers.map(function (t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }

    sdp$1 += 'a=ice-options:trickle\r\n';
    pc.transceivers.forEach(function (transceiver, sdpMLineIndex) {
      sdp$1 += writeMediaSection(transceiver, transceiver.localCapabilities, 'offer', transceiver.stream, pc._dtlsRole);
      sdp$1 += 'a=rtcp-rsize\r\n';

      if (transceiver.iceGatherer && pc.iceGatheringState !== 'new' && (sdpMLineIndex === 0 || !pc.usingBundle)) {
        transceiver.iceGatherer.getLocalCandidates().forEach(function (cand) {
          cand.component = 1;
          sdp$1 += 'a=' + sdp.writeCandidate(cand) + '\r\n';
        });

        if (transceiver.iceGatherer.state === 'completed') {
          sdp$1 += 'a=end-of-candidates\r\n';
        }
      }
    });
    var desc = new window.RTCSessionDescription({
      type: 'offer',
      sdp: sdp$1
    });
    return Promise.resolve(desc);
  };

  RTCPeerConnection.prototype.createAnswer = function () {
    var pc = this;

    if (pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError', 'Can not call createAnswer after close'));
    }

    if (!(pc.signalingState === 'have-remote-offer' || pc.signalingState === 'have-local-pranswer')) {
      return Promise.reject(makeError('InvalidStateError', 'Can not call createAnswer in signalingState ' + pc.signalingState));
    }

    var sdp$1 = sdp.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);

    if (pc.usingBundle) {
      sdp$1 += 'a=group:BUNDLE ' + pc.transceivers.map(function (t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }

    sdp$1 += 'a=ice-options:trickle\r\n';
    var mediaSectionsInOffer = sdp.getMediaSections(pc._remoteDescription.sdp).length;
    pc.transceivers.forEach(function (transceiver, sdpMLineIndex) {
      if (sdpMLineIndex + 1 > mediaSectionsInOffer) {
        return;
      }

      if (transceiver.rejected) {
        if (transceiver.kind === 'application') {
          if (transceiver.protocol === 'DTLS/SCTP') {
            // legacy fmt
            sdp$1 += 'm=application 0 DTLS/SCTP 5000\r\n';
          } else {
            sdp$1 += 'm=application 0 ' + transceiver.protocol + ' webrtc-datachannel\r\n';
          }
        } else if (transceiver.kind === 'audio') {
          sdp$1 += 'm=audio 0 UDP/TLS/RTP/SAVPF 0\r\n' + 'a=rtpmap:0 PCMU/8000\r\n';
        } else if (transceiver.kind === 'video') {
          sdp$1 += 'm=video 0 UDP/TLS/RTP/SAVPF 120\r\n' + 'a=rtpmap:120 VP8/90000\r\n';
        }

        sdp$1 += 'c=IN IP4 0.0.0.0\r\n' + 'a=inactive\r\n' + 'a=mid:' + transceiver.mid + '\r\n';
        return;
      } // FIXME: look at direction.


      if (transceiver.stream) {
        var localTrack;

        if (transceiver.kind === 'audio') {
          localTrack = transceiver.stream.getAudioTracks()[0];
        } else if (transceiver.kind === 'video') {
          localTrack = transceiver.stream.getVideoTracks()[0];
        }

        if (localTrack) {
          // add RTX
          if (edgeVersion >= 15019 && transceiver.kind === 'video' && !transceiver.sendEncodingParameters[0].rtx) {
            transceiver.sendEncodingParameters[0].rtx = {
              ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
            };
          }
        }
      } // Calculate intersection of capabilities.


      var commonCapabilities = getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
      var hasRtx = commonCapabilities.codecs.filter(function (c) {
        return c.name.toLowerCase() === 'rtx';
      }).length;

      if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
        delete transceiver.sendEncodingParameters[0].rtx;
      }

      sdp$1 += writeMediaSection(transceiver, commonCapabilities, 'answer', transceiver.stream, pc._dtlsRole);

      if (transceiver.rtcpParameters && transceiver.rtcpParameters.reducedSize) {
        sdp$1 += 'a=rtcp-rsize\r\n';
      }
    });
    var desc = new window.RTCSessionDescription({
      type: 'answer',
      sdp: sdp$1
    });
    return Promise.resolve(desc);
  };

  RTCPeerConnection.prototype.addIceCandidate = function (candidate) {
    var pc = this;
    var sections;

    if (candidate && !(candidate.sdpMLineIndex !== undefined || candidate.sdpMid)) {
      return Promise.reject(new TypeError('sdpMLineIndex or sdpMid required'));
    } // TODO: needs to go into ops queue.


    return new Promise(function (resolve, reject) {
      if (!pc._remoteDescription) {
        return reject(makeError('InvalidStateError', 'Can not add ICE candidate without a remote description'));
      } else if (!candidate || candidate.candidate === '') {
        for (var j = 0; j < pc.transceivers.length; j++) {
          if (pc.transceivers[j].rejected) {
            continue;
          }

          pc.transceivers[j].iceTransport.addRemoteCandidate({});
          sections = sdp.getMediaSections(pc._remoteDescription.sdp);
          sections[j] += 'a=end-of-candidates\r\n';
          pc._remoteDescription.sdp = sdp.getDescription(pc._remoteDescription.sdp) + sections.join('');

          if (pc.usingBundle) {
            break;
          }
        }
      } else {
        var sdpMLineIndex = candidate.sdpMLineIndex;

        if (candidate.sdpMid) {
          for (var i = 0; i < pc.transceivers.length; i++) {
            if (pc.transceivers[i].mid === candidate.sdpMid) {
              sdpMLineIndex = i;
              break;
            }
          }
        }

        var transceiver = pc.transceivers[sdpMLineIndex];

        if (transceiver) {
          if (transceiver.rejected) {
            return resolve();
          }

          var cand = Object.keys(candidate.candidate).length > 0 ? sdp.parseCandidate(candidate.candidate) : {}; // Ignore Chrome's invalid candidates since Edge does not like them.

          if (cand.protocol === 'tcp' && (cand.port === 0 || cand.port === 9)) {
            return resolve();
          } // Ignore RTCP candidates, we assume RTCP-MUX.


          if (cand.component && cand.component !== 1) {
            return resolve();
          } // when using bundle, avoid adding candidates to the wrong
          // ice transport. And avoid adding candidates added in the SDP.


          if (sdpMLineIndex === 0 || sdpMLineIndex > 0 && transceiver.iceTransport !== pc.transceivers[0].iceTransport) {
            if (!maybeAddCandidate(transceiver.iceTransport, cand)) {
              return reject(makeError('OperationError', 'Can not add ICE candidate'));
            }
          } // update the remoteDescription.


          var candidateString = candidate.candidate.trim();

          if (candidateString.indexOf('a=') === 0) {
            candidateString = candidateString.substr(2);
          }

          sections = sdp.getMediaSections(pc._remoteDescription.sdp);
          sections[sdpMLineIndex] += 'a=' + (cand.type ? candidateString : 'end-of-candidates') + '\r\n';
          pc._remoteDescription.sdp = sdp.getDescription(pc._remoteDescription.sdp) + sections.join('');
        } else {
          return reject(makeError('OperationError', 'Can not add ICE candidate'));
        }
      }

      resolve();
    });
  };

  RTCPeerConnection.prototype.getStats = function (selector) {
    if (selector && selector instanceof window.MediaStreamTrack) {
      var senderOrReceiver = null;
      this.transceivers.forEach(function (transceiver) {
        if (transceiver.rtpSender && transceiver.rtpSender.track === selector) {
          senderOrReceiver = transceiver.rtpSender;
        } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track === selector) {
          senderOrReceiver = transceiver.rtpReceiver;
        }
      });

      if (!senderOrReceiver) {
        throw makeError('InvalidAccessError', 'Invalid selector.');
      }

      return senderOrReceiver.getStats();
    }

    var promises = [];
    this.transceivers.forEach(function (transceiver) {
      ['rtpSender', 'rtpReceiver', 'iceGatherer', 'iceTransport', 'dtlsTransport'].forEach(function (method) {
        if (transceiver[method]) {
          promises.push(transceiver[method].getStats());
        }
      });
    });
    return Promise.all(promises).then(function (allStats) {
      var results = new Map();
      allStats.forEach(function (stats) {
        stats.forEach(function (stat) {
          results.set(stat.id, stat);
        });
      });
      return results;
    });
  }; // fix low-level stat names and return Map instead of object.


  var ortcObjects = ['RTCRtpSender', 'RTCRtpReceiver', 'RTCIceGatherer', 'RTCIceTransport', 'RTCDtlsTransport'];
  ortcObjects.forEach(function (ortcObjectName) {
    var obj = window[ortcObjectName];

    if (obj && obj.prototype && obj.prototype.getStats) {
      var nativeGetstats = obj.prototype.getStats;

      obj.prototype.getStats = function () {
        return nativeGetstats.apply(this).then(function (nativeStats) {
          var mapStats = new Map();
          Object.keys(nativeStats).forEach(function (id) {
            nativeStats[id].type = fixStatsType(nativeStats[id]);
            mapStats.set(id, nativeStats[id]);
          });
          return mapStats;
        });
      };
    }
  }); // legacy callback shims. Should be moved to adapter.js some days.

  var methods = ['createOffer', 'createAnswer'];
  methods.forEach(function (method) {
    var nativeMethod = RTCPeerConnection.prototype[method];

    RTCPeerConnection.prototype[method] = function () {
      var args = arguments;

      if (typeof args[0] === 'function' || typeof args[1] === 'function') {
        // legacy
        return nativeMethod.apply(this, [arguments[2]]).then(function (description) {
          if (typeof args[0] === 'function') {
            args[0].apply(null, [description]);
          }
        }, function (error) {
          if (typeof args[1] === 'function') {
            args[1].apply(null, [error]);
          }
        });
      }

      return nativeMethod.apply(this, arguments);
    };
  });
  methods = ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'];
  methods.forEach(function (method) {
    var nativeMethod = RTCPeerConnection.prototype[method];

    RTCPeerConnection.prototype[method] = function () {
      var args = arguments;

      if (typeof args[1] === 'function' || typeof args[2] === 'function') {
        // legacy
        return nativeMethod.apply(this, arguments).then(function () {
          if (typeof args[1] === 'function') {
            args[1].apply(null);
          }
        }, function (error) {
          if (typeof args[2] === 'function') {
            args[2].apply(null, [error]);
          }
        });
      }

      return nativeMethod.apply(this, arguments);
    };
  }); // getStats is special. It doesn't have a spec legacy method yet we support
  // getStats(something, cb) without error callbacks.

  ['getStats'].forEach(function (method) {
    var nativeMethod = RTCPeerConnection.prototype[method];

    RTCPeerConnection.prototype[method] = function () {
      var args = arguments;

      if (typeof args[1] === 'function') {
        return nativeMethod.apply(this, arguments).then(function () {
          if (typeof args[1] === 'function') {
            args[1].apply(null);
          }
        });
      }

      return nativeMethod.apply(this, arguments);
    };
  });
  return RTCPeerConnection;
};
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


function shimGetUserMedia$1(window) {
  var navigator = window && window.navigator;

  var shimError_ = function shimError_(e) {
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint,
      toString: function toString() {
        return this.name;
      }
    };
  }; // getUserMedia error shim.


  var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

  navigator.mediaDevices.getUserMedia = function (c) {
    return origGetUserMedia(c).catch(function (e) {
      return Promise.reject(shimError_(e));
    });
  };
}
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


function shimGetDisplayMedia$1(window) {
  if (!('getDisplayMedia' in window.navigator)) {
    return;
  }

  if (!window.navigator.mediaDevices) {
    return;
  }

  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }

  window.navigator.mediaDevices.getDisplayMedia = window.navigator.getDisplayMedia.bind(window.navigator);
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


function shimPeerConnection$1(window) {
  var browserDetails = detectBrowser(window);

  if (window.RTCIceGatherer) {
    if (!window.RTCIceCandidate) {
      window.RTCIceCandidate = function RTCIceCandidate(args) {
        return args;
      };
    }

    if (!window.RTCSessionDescription) {
      window.RTCSessionDescription = function RTCSessionDescription(args) {
        return args;
      };
    } // this adds an additional event listener to MediaStrackTrack that signals
    // when a tracks enabled property was changed. Workaround for a bug in
    // addStream, see below. No longer required in 15025+


    if (browserDetails.version < 15025) {
      var origMSTEnabled = Object.getOwnPropertyDescriptor(window.MediaStreamTrack.prototype, 'enabled');
      Object.defineProperty(window.MediaStreamTrack.prototype, 'enabled', {
        set: function set(value) {
          origMSTEnabled.set.call(this, value);
          var ev = new Event('enabled');
          ev.enabled = value;
          this.dispatchEvent(ev);
        }
      });
    }
  } // ORTC defines the DTMF sender a bit different.
  // https://github.com/w3c/ortc/issues/714


  if (window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
    Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
      get: function get() {
        if (this._dtmf === undefined) {
          if (this.track.kind === 'audio') {
            this._dtmf = new window.RTCDtmfSender(this);
          } else if (this.track.kind === 'video') {
            this._dtmf = null;
          }
        }

        return this._dtmf;
      }
    });
  } // Edge currently only implements the RTCDtmfSender, not the
  // RTCDTMFSender alias. See http://draft.ortc.org/#rtcdtmfsender2*


  if (window.RTCDtmfSender && !window.RTCDTMFSender) {
    window.RTCDTMFSender = window.RTCDtmfSender;
  }

  var RTCPeerConnectionShim = rtcpeerconnection(window, browserDetails.version);

  window.RTCPeerConnection = function RTCPeerConnection(config) {
    if (config && config.iceServers) {
      config.iceServers = filterIceServers(config.iceServers, browserDetails.version);
      log('ICE servers after filtering:', config.iceServers);
    }

    return new RTCPeerConnectionShim(config);
  };

  window.RTCPeerConnection.prototype = RTCPeerConnectionShim.prototype;
}

function shimReplaceTrack(window) {
  // ORTC has replaceTrack -- https://github.com/w3c/ortc/issues/614
  if (window.RTCRtpSender && !('replaceTrack' in window.RTCRtpSender.prototype)) {
    window.RTCRtpSender.prototype.replaceTrack = window.RTCRtpSender.prototype.setTrack;
  }
}

var edgeShim = /*#__PURE__*/Object.freeze({
  __proto__: null,
  shimPeerConnection: shimPeerConnection$1,
  shimReplaceTrack: shimReplaceTrack,
  shimGetUserMedia: shimGetUserMedia$1,
  shimGetDisplayMedia: shimGetDisplayMedia$1
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimGetUserMedia$2(window) {
  var browserDetails = detectBrowser(window);
  var navigator = window && window.navigator;
  var MediaStreamTrack = window && window.MediaStreamTrack;

  navigator.getUserMedia = function (constraints, onSuccess, onError) {
    // Replace Firefox 44+'s deprecation warning with unprefixed version.
    deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };

  if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
    var remap = function remap(obj, a, b) {
      if (a in obj && !(b in obj)) {
        obj[b] = obj[a];
        delete obj[a];
      }
    };

    var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

    navigator.mediaDevices.getUserMedia = function (c) {
      if (typeof c === 'object' && typeof c.audio === 'object') {
        c = JSON.parse(JSON.stringify(c));
        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
      }

      return nativeGetUserMedia(c);
    };

    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      var nativeGetSettings = MediaStreamTrack.prototype.getSettings;

      MediaStreamTrack.prototype.getSettings = function () {
        var obj = nativeGetSettings.apply(this, arguments);
        remap(obj, 'mozAutoGainControl', 'autoGainControl');
        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
        return obj;
      };
    }

    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;

      MediaStreamTrack.prototype.applyConstraints = function (c) {
        if (this.kind === 'audio' && typeof c === 'object') {
          c = JSON.parse(JSON.stringify(c));
          remap(c, 'autoGainControl', 'mozAutoGainControl');
          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
        }

        return nativeApplyConstraints.apply(this, [c]);
      };
    }
  }
}
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


function shimGetDisplayMedia$2(window, preferredMediaSource) {
  if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) {
    return;
  }

  if (!window.navigator.mediaDevices) {
    return;
  }

  window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
    if (!(constraints && constraints.video)) {
      var err = new DOMException('getDisplayMedia without video ' + 'constraints is undefined');
      err.name = 'NotFoundError'; // from https://heycam.github.io/webidl/#idl-DOMException-error-names

      err.code = 8;
      return Promise.reject(err);
    }

    if (constraints.video === true) {
      constraints.video = {
        mediaSource: preferredMediaSource
      };
    } else {
      constraints.video.mediaSource = preferredMediaSource;
    }

    return window.navigator.mediaDevices.getUserMedia(constraints);
  };
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


function shimOnTrack$1(window) {
  if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
      get: function get() {
        return {
          receiver: this.receiver
        };
      }
    });
  }
}

function shimPeerConnection$2(window) {
  var browserDetails = detectBrowser(window);

  if (typeof window !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) {
    return; // probably media.peerconnection.enabled=false in about:config
  }

  if (!window.RTCPeerConnection && window.mozRTCPeerConnection) {
    // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
  }

  if (browserDetails.version < 53) {
    // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'].forEach(function (method) {
      var nativeMethod = window.RTCPeerConnection.prototype[method];

      var methodObj = _defineProperty2({}, method, function () {
        arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
        return nativeMethod.apply(this, arguments);
      });

      window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
  } // support for addIceCandidate(null or undefined)


  var nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;

  window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
    if (!arguments[0]) {
      if (arguments[1]) {
        arguments[1].apply(null);
      }

      return Promise.resolve();
    } // Firefox 68+ emits and processes {candidate: "", ...}, ignore
    // in older versions.


    if (browserDetails.version < 68 && arguments[0] && arguments[0].candidate === '') {
      return Promise.resolve();
    }

    return nativeAddIceCandidate.apply(this, arguments);
  };

  var modernStatsTypes = {
    inboundrtp: 'inbound-rtp',
    outboundrtp: 'outbound-rtp',
    candidatepair: 'candidate-pair',
    localcandidate: 'local-candidate',
    remotecandidate: 'remote-candidate'
  };
  var nativeGetStats = window.RTCPeerConnection.prototype.getStats;

  window.RTCPeerConnection.prototype.getStats = function getStats() {
    var _arguments3 = Array.prototype.slice.call(arguments),
        selector = _arguments3[0],
        onSucc = _arguments3[1],
        onErr = _arguments3[2];

    return nativeGetStats.apply(this, [selector || null]).then(function (stats) {
      if (browserDetails.version < 53 && !onSucc) {
        // Shim only promise getStats with spec-hyphens in type names
        // Leave callback version alone; misc old uses of forEach before Map
        try {
          stats.forEach(function (stat) {
            stat.type = modernStatsTypes[stat.type] || stat.type;
          });
        } catch (e) {
          if (e.name !== 'TypeError') {
            throw e;
          } // Avoid TypeError: "type" is read-only, in old versions. 34-43ish


          stats.forEach(function (stat, i) {
            stats.set(i, Object.assign({}, stat, {
              type: modernStatsTypes[stat.type] || stat.type
            }));
          });
        }
      }

      return stats;
    }).then(onSucc, onErr);
  };
}

function shimSenderGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
    return;
  }

  if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
    return;
  }

  var origGetSenders = window.RTCPeerConnection.prototype.getSenders;

  if (origGetSenders) {
    window.RTCPeerConnection.prototype.getSenders = function getSenders() {
      var _this21 = this;

      var senders = origGetSenders.apply(this, []);
      senders.forEach(function (sender) {
        return sender._pc = _this21;
      });
      return senders;
    };
  }

  var origAddTrack = window.RTCPeerConnection.prototype.addTrack;

  if (origAddTrack) {
    window.RTCPeerConnection.prototype.addTrack = function addTrack() {
      var sender = origAddTrack.apply(this, arguments);
      sender._pc = this;
      return sender;
    };
  }

  window.RTCRtpSender.prototype.getStats = function getStats() {
    return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
  };
}

function shimReceiverGetStats(window) {
  if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) {
    return;
  }

  if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
    return;
  }

  var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;

  if (origGetReceivers) {
    window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
      var _this22 = this;

      var receivers = origGetReceivers.apply(this, []);
      receivers.forEach(function (receiver) {
        return receiver._pc = _this22;
      });
      return receivers;
    };
  }

  wrapPeerConnectionEvent(window, 'track', function (e) {
    e.receiver._pc = e.srcElement;
    return e;
  });

  window.RTCRtpReceiver.prototype.getStats = function getStats() {
    return this._pc.getStats(this.track);
  };
}

function shimRemoveStream(window) {
  if (!window.RTCPeerConnection || 'removeStream' in window.RTCPeerConnection.prototype) {
    return;
  }

  window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
    var _this23 = this;

    deprecated('removeStream', 'removeTrack');
    this.getSenders().forEach(function (sender) {
      if (sender.track && stream.getTracks().includes(sender.track)) {
        _this23.removeTrack(sender);
      }
    });
  };
}

function shimRTCDataChannel(window) {
  // rename DataChannel to RTCDataChannel (native fix in FF60):
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
  if (window.DataChannel && !window.RTCDataChannel) {
    window.RTCDataChannel = window.DataChannel;
  }
}

var firefoxShim = /*#__PURE__*/Object.freeze({
  __proto__: null,
  shimOnTrack: shimOnTrack$1,
  shimPeerConnection: shimPeerConnection$2,
  shimSenderGetStats: shimSenderGetStats,
  shimReceiverGetStats: shimReceiverGetStats,
  shimRemoveStream: shimRemoveStream,
  shimRTCDataChannel: shimRTCDataChannel,
  shimGetUserMedia: shimGetUserMedia$2,
  shimGetDisplayMedia: shimGetDisplayMedia$2
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimLocalStreamsAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }

  if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
      if (!this._localStreams) {
        this._localStreams = [];
      }

      return this._localStreams;
    };
  }

  if (!('addStream' in window.RTCPeerConnection.prototype)) {
    var _addTrack = window.RTCPeerConnection.prototype.addTrack;

    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
      var _this24 = this;

      if (!this._localStreams) {
        this._localStreams = [];
      }

      if (!this._localStreams.includes(stream)) {
        this._localStreams.push(stream);
      } // Try to emulate Chrome's behaviour of adding in audio-video order.
      // Safari orders by track id.


      stream.getAudioTracks().forEach(function (track) {
        return _addTrack.call(_this24, track, stream);
      });
      stream.getVideoTracks().forEach(function (track) {
        return _addTrack.call(_this24, track, stream);
      });
    };

    window.RTCPeerConnection.prototype.addTrack = function addTrack(track) {
      var stream = arguments[1];

      if (stream) {
        if (!this._localStreams) {
          this._localStreams = [stream];
        } else if (!this._localStreams.includes(stream)) {
          this._localStreams.push(stream);
        }
      }

      return _addTrack.apply(this, arguments);
    };
  }

  if (!('removeStream' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
      var _this25 = this;

      if (!this._localStreams) {
        this._localStreams = [];
      }

      var index = this._localStreams.indexOf(stream);

      if (index === -1) {
        return;
      }

      this._localStreams.splice(index, 1);

      var tracks = stream.getTracks();
      this.getSenders().forEach(function (sender) {
        if (tracks.includes(sender.track)) {
          _this25.removeTrack(sender);
        }
      });
    };
  }
}

function shimRemoteStreamsAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }

  if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
    window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
      return this._remoteStreams ? this._remoteStreams : [];
    };
  }

  if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
      get: function get() {
        return this._onaddstream;
      },
      set: function set(f) {
        var _this26 = this;

        if (this._onaddstream) {
          this.removeEventListener('addstream', this._onaddstream);
          this.removeEventListener('track', this._onaddstreampoly);
        }

        this.addEventListener('addstream', this._onaddstream = f);
        this.addEventListener('track', this._onaddstreampoly = function (e) {
          e.streams.forEach(function (stream) {
            if (!_this26._remoteStreams) {
              _this26._remoteStreams = [];
            }

            if (_this26._remoteStreams.includes(stream)) {
              return;
            }

            _this26._remoteStreams.push(stream);

            var event = new Event('addstream');
            event.stream = stream;

            _this26.dispatchEvent(event);
          });
        });
      }
    });
    var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;

    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
      var pc = this;

      if (!this._onaddstreampoly) {
        this.addEventListener('track', this._onaddstreampoly = function (e) {
          e.streams.forEach(function (stream) {
            if (!pc._remoteStreams) {
              pc._remoteStreams = [];
            }

            if (pc._remoteStreams.indexOf(stream) >= 0) {
              return;
            }

            pc._remoteStreams.push(stream);

            var event = new Event('addstream');
            event.stream = stream;
            pc.dispatchEvent(event);
          });
        });
      }

      return origSetRemoteDescription.apply(pc, arguments);
    };
  }
}

function shimCallbacksAPI(window) {
  if (typeof window !== 'object' || !window.RTCPeerConnection) {
    return;
  }

  var prototype = window.RTCPeerConnection.prototype;
  var origCreateOffer = prototype.createOffer;
  var origCreateAnswer = prototype.createAnswer;
  var setLocalDescription = prototype.setLocalDescription;
  var setRemoteDescription = prototype.setRemoteDescription;
  var addIceCandidate = prototype.addIceCandidate;

  prototype.createOffer = function createOffer(successCallback, failureCallback) {
    var options = arguments.length >= 2 ? arguments[2] : arguments[0];
    var promise = origCreateOffer.apply(this, [options]);

    if (!failureCallback) {
      return promise;
    }

    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
    var options = arguments.length >= 2 ? arguments[2] : arguments[0];
    var promise = origCreateAnswer.apply(this, [options]);

    if (!failureCallback) {
      return promise;
    }

    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  var withCallback = function withCallback(description, successCallback, failureCallback) {
    var promise = setLocalDescription.apply(this, [description]);

    if (!failureCallback) {
      return promise;
    }

    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  prototype.setLocalDescription = withCallback;

  withCallback = function withCallback(description, successCallback, failureCallback) {
    var promise = setRemoteDescription.apply(this, [description]);

    if (!failureCallback) {
      return promise;
    }

    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  prototype.setRemoteDescription = withCallback;

  withCallback = function withCallback(candidate, successCallback, failureCallback) {
    var promise = addIceCandidate.apply(this, [candidate]);

    if (!failureCallback) {
      return promise;
    }

    promise.then(successCallback, failureCallback);
    return Promise.resolve();
  };

  prototype.addIceCandidate = withCallback;
}

function shimGetUserMedia$3(window) {
  var navigator = window && window.navigator;

  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    // shim not needed in Safari 12.1
    var mediaDevices = navigator.mediaDevices;

    var _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);

    navigator.mediaDevices.getUserMedia = function (constraints) {
      return _getUserMedia(shimConstraints(constraints));
    };
  }

  if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    navigator.getUserMedia = function getUserMedia(constraints, cb, errcb) {
      navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }.bind(navigator);
  }
}

function shimConstraints(constraints) {
  if (constraints && constraints.video !== undefined) {
    return Object.assign({}, constraints, {
      video: compactObject(constraints.video)
    });
  }

  return constraints;
}

function shimRTCIceServerUrls(window) {
  // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
  var OrigPeerConnection = window.RTCPeerConnection;

  window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
    if (pcConfig && pcConfig.iceServers) {
      var newIceServers = [];

      for (var i = 0; i < pcConfig.iceServers.length; i++) {
        var server = pcConfig.iceServers[i];

        if (!server.hasOwnProperty('urls') && server.hasOwnProperty('url')) {
          deprecated('RTCIceServer.url', 'RTCIceServer.urls');
          server = JSON.parse(JSON.stringify(server));
          server.urls = server.url;
          delete server.url;
          newIceServers.push(server);
        } else {
          newIceServers.push(pcConfig.iceServers[i]);
        }
      }

      pcConfig.iceServers = newIceServers;
    }

    return new OrigPeerConnection(pcConfig, pcConstraints);
  };

  window.RTCPeerConnection.prototype = OrigPeerConnection.prototype; // wrap static methods. Currently just generateCertificate.

  if ('generateCertificate' in window.RTCPeerConnection) {
    Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
      get: function get() {
        return OrigPeerConnection.generateCertificate;
      }
    });
  }
}

function shimTrackEventTransceiver(window) {
  // Add event.transceiver member over deprecated event.receiver
  if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
    Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
      get: function get() {
        return {
          receiver: this.receiver
        };
      }
    });
  }
}

function shimCreateOfferLegacy(window) {
  var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;

  window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
    if (offerOptions) {
      if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
        // support bit values
        offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
      }

      var audioTransceiver = this.getTransceivers().find(function (transceiver) {
        return transceiver.receiver.track.kind === 'audio';
      });

      if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
        if (audioTransceiver.direction === 'sendrecv') {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection('sendonly');
          } else {
            audioTransceiver.direction = 'sendonly';
          }
        } else if (audioTransceiver.direction === 'recvonly') {
          if (audioTransceiver.setDirection) {
            audioTransceiver.setDirection('inactive');
          } else {
            audioTransceiver.direction = 'inactive';
          }
        }
      } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) {
        this.addTransceiver('audio');
      }

      if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
        // support bit values
        offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
      }

      var videoTransceiver = this.getTransceivers().find(function (transceiver) {
        return transceiver.receiver.track.kind === 'video';
      });

      if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
        if (videoTransceiver.direction === 'sendrecv') {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection('sendonly');
          } else {
            videoTransceiver.direction = 'sendonly';
          }
        } else if (videoTransceiver.direction === 'recvonly') {
          if (videoTransceiver.setDirection) {
            videoTransceiver.setDirection('inactive');
          } else {
            videoTransceiver.direction = 'inactive';
          }
        }
      } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) {
        this.addTransceiver('video');
      }
    }

    return origCreateOffer.apply(this, arguments);
  };
}

var safariShim = /*#__PURE__*/Object.freeze({
  __proto__: null,
  shimLocalStreamsAPI: shimLocalStreamsAPI,
  shimRemoteStreamsAPI: shimRemoteStreamsAPI,
  shimCallbacksAPI: shimCallbacksAPI,
  shimGetUserMedia: shimGetUserMedia$3,
  shimConstraints: shimConstraints,
  shimRTCIceServerUrls: shimRTCIceServerUrls,
  shimTrackEventTransceiver: shimTrackEventTransceiver,
  shimCreateOfferLegacy: shimCreateOfferLegacy
});
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

function shimRTCIceCandidate(window) {
  // foundation is arbitrarily chosen as an indicator for full support for
  // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
  if (!window.RTCIceCandidate || window.RTCIceCandidate && 'foundation' in window.RTCIceCandidate.prototype) {
    return;
  }

  var NativeRTCIceCandidate = window.RTCIceCandidate;

  window.RTCIceCandidate = function RTCIceCandidate(args) {
    // Remove the a= which shouldn't be part of the candidate string.
    if (typeof args === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
      args = JSON.parse(JSON.stringify(args));
      args.candidate = args.candidate.substr(2);
    }

    if (args.candidate && args.candidate.length) {
      // Augment the native candidate with the parsed fields.
      var nativeCandidate = new NativeRTCIceCandidate(args);
      var parsedCandidate = sdp.parseCandidate(args.candidate);
      var augmentedCandidate = Object.assign(nativeCandidate, parsedCandidate); // Add a serializer that does not serialize the extra attributes.

      augmentedCandidate.toJSON = function toJSON() {
        return {
          candidate: augmentedCandidate.candidate,
          sdpMid: augmentedCandidate.sdpMid,
          sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
          usernameFragment: augmentedCandidate.usernameFragment
        };
      };

      return augmentedCandidate;
    }

    return new NativeRTCIceCandidate(args);
  };

  window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype; // Hook up the augmented candidate in onicecandidate and
  // addEventListener('icecandidate', ...)

  wrapPeerConnectionEvent(window, 'icecandidate', function (e) {
    if (e.candidate) {
      Object.defineProperty(e, 'candidate', {
        value: new window.RTCIceCandidate(e.candidate),
        writable: 'false'
      });
    }

    return e;
  });
}

function shimMaxMessageSize(window) {
  if (!window.RTCPeerConnection) {
    return;
  }

  var browserDetails = detectBrowser(window);

  if (!('sctp' in window.RTCPeerConnection.prototype)) {
    Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
      get: function get() {
        return typeof this._sctp === 'undefined' ? null : this._sctp;
      }
    });
  }

  var sctpInDescription = function sctpInDescription(description) {
    if (!description || !description.sdp) {
      return false;
    }

    var sections = sdp.splitSections(description.sdp);
    sections.shift();
    return sections.some(function (mediaSection) {
      var mLine = sdp.parseMLine(mediaSection);
      return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
    });
  };

  var getRemoteFirefoxVersion = function getRemoteFirefoxVersion(description) {
    // TODO: Is there a better solution for detecting Firefox?
    var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);

    if (match === null || match.length < 2) {
      return -1;
    }

    var version = parseInt(match[1], 10); // Test for NaN (yes, this is ugly)

    return version !== version ? -1 : version;
  };

  var getCanSendMaxMessageSize = function getCanSendMaxMessageSize(remoteIsFirefox) {
    // Every implementation we know can send at least 64 KiB.
    // Note: Although Chrome is technically able to send up to 256 KiB, the
    //       data does not reach the other peer reliably.
    //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
    var canSendMaxMessageSize = 65536;

    if (browserDetails.browser === 'firefox') {
      if (browserDetails.version < 57) {
        if (remoteIsFirefox === -1) {
          // FF < 57 will send in 16 KiB chunks using the deprecated PPID
          // fragmentation.
          canSendMaxMessageSize = 16384;
        } else {
          // However, other FF (and RAWRTC) can reassemble PPID-fragmented
          // messages. Thus, supporting ~2 GiB when sending.
          canSendMaxMessageSize = 2147483637;
        }
      } else if (browserDetails.version < 60) {
        // Currently, all FF >= 57 will reset the remote maximum message size
        // to the default value when a data channel is created at a later
        // stage. :(
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
        canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
      } else {
        // FF >= 60 supports sending ~2 GiB
        canSendMaxMessageSize = 2147483637;
      }
    }

    return canSendMaxMessageSize;
  };

  var getMaxMessageSize = function getMaxMessageSize(description, remoteIsFirefox) {
    // Note: 65536 bytes is the default value from the SDP spec. Also,
    //       every implementation we know supports receiving 65536 bytes.
    var maxMessageSize = 65536; // FF 57 has a slightly incorrect default remote max message size, so
    // we need to adjust it here to avoid a failure when sending.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697

    if (browserDetails.browser === 'firefox' && browserDetails.version === 57) {
      maxMessageSize = 65535;
    }

    var match = sdp.matchPrefix(description.sdp, 'a=max-message-size:');

    if (match.length > 0) {
      maxMessageSize = parseInt(match[0].substr(19), 10);
    } else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) {
      // If the maximum message size is not present in the remote SDP and
      // both local and remote are Firefox, the remote peer can receive
      // ~2 GiB.
      maxMessageSize = 2147483637;
    }

    return maxMessageSize;
  };

  var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;

  window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
    this._sctp = null; // Chrome decided to not expose .sctp in plan-b mode.
    // As usual, adapter.js has to do an 'ugly worakaround'
    // to cover up the mess.

    if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
      var _this$getConfiguratio = this.getConfiguration(),
          sdpSemantics = _this$getConfiguratio.sdpSemantics;

      if (sdpSemantics === 'plan-b') {
        Object.defineProperty(this, 'sctp', {
          get: function get() {
            return typeof this._sctp === 'undefined' ? null : this._sctp;
          },
          enumerable: true,
          configurable: true
        });
      }
    }

    if (sctpInDescription(arguments[0])) {
      // Check if the remote is FF.
      var isFirefox = getRemoteFirefoxVersion(arguments[0]); // Get the maximum message size the local peer is capable of sending

      var canSendMMS = getCanSendMaxMessageSize(isFirefox); // Get the maximum message size of the remote peer.

      var remoteMMS = getMaxMessageSize(arguments[0], isFirefox); // Determine final maximum message size

      var maxMessageSize;

      if (canSendMMS === 0 && remoteMMS === 0) {
        maxMessageSize = Number.POSITIVE_INFINITY;
      } else if (canSendMMS === 0 || remoteMMS === 0) {
        maxMessageSize = Math.max(canSendMMS, remoteMMS);
      } else {
        maxMessageSize = Math.min(canSendMMS, remoteMMS);
      } // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
      // attribute.


      var sctp = {};
      Object.defineProperty(sctp, 'maxMessageSize', {
        get: function get() {
          return maxMessageSize;
        }
      });
      this._sctp = sctp;
    }

    return origSetRemoteDescription.apply(this, arguments);
  };
}

function shimSendThrowTypeError(window) {
  if (!(window.RTCPeerConnection && 'createDataChannel' in window.RTCPeerConnection.prototype)) {
    return;
  } // Note: Although Firefox >= 57 has a native implementation, the maximum
  //       message size can be reset for all data channels at a later stage.
  //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831


  function wrapDcSend(dc, pc) {
    var origDataChannelSend = dc.send;

    dc.send = function send() {
      var data = arguments[0];
      var length = data.length || data.size || data.byteLength;

      if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) {
        throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
      }

      return origDataChannelSend.apply(dc, arguments);
    };
  }

  var origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;

  window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
    var dataChannel = origCreateDataChannel.apply(this, arguments);
    wrapDcSend(dataChannel, this);
    return dataChannel;
  };

  wrapPeerConnectionEvent(window, 'datachannel', function (e) {
    wrapDcSend(e.channel, e.target);
    return e;
  });
}
/* shims RTCConnectionState by pretending it is the same as iceConnectionState.
 * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
 * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
 * since DTLS failures would be hidden. See
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
 * for the Firefox tracking bug.
 */


function shimConnectionState(window) {
  if (!window.RTCPeerConnection || 'connectionState' in window.RTCPeerConnection.prototype) {
    return;
  }

  var proto = window.RTCPeerConnection.prototype;
  Object.defineProperty(proto, 'connectionState', {
    get: function get() {
      return {
        completed: 'connected',
        checking: 'connecting'
      }[this.iceConnectionState] || this.iceConnectionState;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(proto, 'onconnectionstatechange', {
    get: function get() {
      return this._onconnectionstatechange || null;
    },
    set: function set(cb) {
      if (this._onconnectionstatechange) {
        this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
        delete this._onconnectionstatechange;
      }

      if (cb) {
        this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
      }
    },
    enumerable: true,
    configurable: true
  });
  ['setLocalDescription', 'setRemoteDescription'].forEach(function (method) {
    var origMethod = proto[method];

    proto[method] = function () {
      if (!this._connectionstatechangepoly) {
        this._connectionstatechangepoly = function (e) {
          var pc = e.target;

          if (pc._lastConnectionState !== pc.connectionState) {
            pc._lastConnectionState = pc.connectionState;
            var newEvent = new Event('connectionstatechange', e);
            pc.dispatchEvent(newEvent);
          }

          return e;
        };

        this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
      }

      return origMethod.apply(this, arguments);
    };
  });
}

function removeAllowExtmapMixed(window) {
  /* remove a=extmap-allow-mixed for Chrome < M71 */
  if (!window.RTCPeerConnection) {
    return;
  }

  var browserDetails = detectBrowser(window);

  if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) {
    return;
  }

  var nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;

  window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
    if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
      desc.sdp = desc.sdp.split('\n').filter(function (line) {
        return line.trim() !== 'a=extmap-allow-mixed';
      }).join('\n');
    }

    return nativeSRD.apply(this, arguments);
  };
}

var commonShim = /*#__PURE__*/Object.freeze({
  __proto__: null,
  shimRTCIceCandidate: shimRTCIceCandidate,
  shimMaxMessageSize: shimMaxMessageSize,
  shimSendThrowTypeError: shimSendThrowTypeError,
  shimConnectionState: shimConnectionState,
  removeAllowExtmapMixed: removeAllowExtmapMixed
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
// Shimming starts here.

function adapterFactory() {
  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      window = _ref13.window;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    shimChrome: true,
    shimFirefox: true,
    shimEdge: true,
    shimSafari: true
  };
  // Utils.
  var logging = log;
  var browserDetails = detectBrowser(window);
  var adapter = {
    browserDetails: browserDetails,
    commonShim: commonShim,
    extractVersion: extractVersion,
    disableLog: disableLog,
    disableWarnings: disableWarnings
  }; // Shim browser if found.

  switch (browserDetails.browser) {
    case 'chrome':
      if (!chromeShim || !shimPeerConnection || !options.shimChrome) {
        logging('Chrome shim is not included in this adapter release.');
        return adapter;
      }

      logging('adapter.js shimming chrome.'); // Export to the adapter global object visible in the browser.

      adapter.browserShim = chromeShim;
      shimGetUserMedia(window);
      shimMediaStream(window);
      shimPeerConnection(window);
      shimOnTrack(window);
      shimAddTrackRemoveTrack(window);
      shimGetSendersWithDtmf(window);
      shimGetStats(window);
      shimSenderReceiverGetStats(window);
      fixNegotiationNeeded(window);
      shimRTCIceCandidate(window);
      shimConnectionState(window);
      shimMaxMessageSize(window);
      shimSendThrowTypeError(window);
      removeAllowExtmapMixed(window);
      break;

    case 'firefox':
      if (!firefoxShim || !shimPeerConnection$2 || !options.shimFirefox) {
        logging('Firefox shim is not included in this adapter release.');
        return adapter;
      }

      logging('adapter.js shimming firefox.'); // Export to the adapter global object visible in the browser.

      adapter.browserShim = firefoxShim;
      shimGetUserMedia$2(window);
      shimPeerConnection$2(window);
      shimOnTrack$1(window);
      shimRemoveStream(window);
      shimSenderGetStats(window);
      shimReceiverGetStats(window);
      shimRTCDataChannel(window);
      shimRTCIceCandidate(window);
      shimConnectionState(window);
      shimMaxMessageSize(window);
      shimSendThrowTypeError(window);
      break;

    case 'edge':
      if (!edgeShim || !shimPeerConnection$1 || !options.shimEdge) {
        logging('MS edge shim is not included in this adapter release.');
        return adapter;
      }

      logging('adapter.js shimming edge.'); // Export to the adapter global object visible in the browser.

      adapter.browserShim = edgeShim;
      shimGetUserMedia$1(window);
      shimGetDisplayMedia$1(window);
      shimPeerConnection$1(window);
      shimReplaceTrack(window); // the edge shim implements the full RTCIceCandidate object.

      shimMaxMessageSize(window);
      shimSendThrowTypeError(window);
      break;

    case 'safari':
      if (!safariShim || !options.shimSafari) {
        logging('Safari shim is not included in this adapter release.');
        return adapter;
      }

      logging('adapter.js shimming safari.'); // Export to the adapter global object visible in the browser.

      adapter.browserShim = safariShim;
      shimRTCIceServerUrls(window);
      shimCreateOfferLegacy(window);
      shimCallbacksAPI(window);
      shimLocalStreamsAPI(window);
      shimRemoteStreamsAPI(window);
      shimTrackEventTransceiver(window);
      shimGetUserMedia$3(window);
      shimRTCIceCandidate(window);
      shimMaxMessageSize(window);
      shimSendThrowTypeError(window);
      removeAllowExtmapMixed(window);
      break;

    default:
      logging('Unsupported browser!');
      break;
  }

  return adapter;
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


var adapter = adapterFactory({
  window: window
});
var red5proSdk_min = createCommonjsModule(function (module, exports) {
  /*!
   * 
   *   red5pro-sdk - Red5 Pro HTML Publisher and Subscriber SDK.
   *   Author: Infrared5 Inc.
   *   Version: 10.9.0-release.b67
   *   Url: https://github.com/red5pro/red5pro-html-sdk#readme
   * 
   *   Copyright © 2015 Infrared5, Inc. All rights reserved.
   * 
   *   The accompanying code comprising examples for use solely in conjunction with Red5 Pro (the "Example Code") 
   *   is  licensed  to  you  by  Infrared5  Inc.  in  consideration  of  your  agreement  to  the  following  
   *   license terms  and  conditions.  Access,  use,  modification,  or  redistribution  of  the  accompanying  
   *   code  constitutes your acceptance of the following license terms and conditions.
   * 
   *   Permission is hereby granted, free of charge, to you to use the Example Code and associated documentation 
   *   files (collectively, the "Software") without restriction, including without limitation the rights to use, 
   *   copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit 
   *   persons to whom the Software is furnished to do so, subject to the following conditions:
   * 
   *   The Software shall be used solely in conjunction with Red5 Pro. Red5 Pro is licensed under a separate end 
   *   user  license  agreement  (the  "EULA"),  which  must  be  executed  with  Infrared5,  Inc.   
   *   An  example  of  the EULA can be found on our website at: https://account.red5pro.com/assets/LICENSE.txt.
   * 
   *   The above copyright notice and this license shall be included in all copies or portions of the Software.
   * 
   *   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,  INCLUDING  BUT  
   *   NOT  LIMITED  TO  THE  WARRANTIES  OF  MERCHANTABILITY, FITNESS  FOR  A  PARTICULAR  PURPOSE  AND  
   *   NONINFRINGEMENT.   IN  NO  EVENT  SHALL INFRARED5, INC. BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, 
   *   WHETHER IN  AN  ACTION  OF  CONTRACT,  TORT  OR  OTHERWISE,  ARISING  FROM,  OUT  OF  OR  IN CONNECTION 
   *   WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   * 
   */
  !function (e, t) {
    module.exports = t();
  }(commonjsGlobal, function () {
    return function (e) {
      function t(r) {
        if (n[r]) return n[r].exports;
        var i = n[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
      }

      var n = {};
      return t.m = e, t.c = n, t.i = function (e) {
        return e;
      }, t.d = function (e, n, r) {
        t.o(e, n) || Object.defineProperty(e, n, {
          configurable: !1,
          enumerable: !0,
          get: r
        });
      }, t.n = function (e) {
        var n = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return t.d(n, "a", n), n;
      }, t.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, t.p = "", t(t.s = 216);
    }([function (e, t, n) {
      t.__esModule = !0, t.default = function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      };
    }, function (e, t, n) {
      t.__esModule = !0;

      var r = n(98),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.default = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), (0, i.default)(e, r.key, r);
          }
        }

        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }();
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.fatal = t.error = t.warn = t.debug = t.info = t.trace = t.getRecordedLogs = t.getLogger = t.establishLogger = t.LEVELS = void 0;

      var r = n(102),
          i = n(126),
          o = void 0,
          a = void 0,
          s = function s(e) {
        return function (t) {
          return "(" + e + ") " + t;
        };
      },
          u = function u(e) {
        return function (t, n) {
          o[e](s(t)(n));
        };
      },
          c = t.LEVELS = {
        TRACE: "trace",
        INFO: "info",
        DEBUG: "debug",
        WARN: "warn",
        ERROR: "error",
        FATAL: "fatal"
      };

      t.establishLogger = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0,
            s = [];

        if (s.push({
          level: e,
          stream: new i.RawStream(),
          type: "raw"
        }), n) {
          var u = n.map(function (t) {
            t.level = e;
          });
          s = s.concat(u);
        }

        t && (a = [], s.push({
          level: e,
          stream: {
            write: function write(e) {
              var t = "[" + e.time.toISOString() + "] " + r.nameFromLevel[e.level] + ": " + e.msg;
              a.push(t);
            }
          }
        })), o = (0, r.createLogger)({
          level: e,
          name: "red5pro-sdk",
          streams: s
        });
      }, t.getLogger = function () {
        return o;
      }, t.getRecordedLogs = function () {
        return a;
      }, t.trace = u(c.TRACE), t.info = u(c.INFO), t.debug = u(c.DEBUG), t.warn = u(c.WARN), t.error = u(c.ERROR), t.fatal = u(c.FATAL);
    }, function (e, t, n) {
      e.exports = {
        default: n(165),
        __esModule: !0
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      t.__esModule = !0;
      var i = n(148),
          o = r(i),
          a = n(146),
          s = r(a),
          u = n(63),
          c = r(u);

      t.default = function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === t ? "undefined" : (0, c.default)(t)));
        e.prototype = (0, s.default)(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (o.default ? (0, o.default)(e, t) : e.__proto__ = t);
      };
    }, function (e, t, n) {
      t.__esModule = !0;

      var r = n(63),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.default = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" !== (void 0 === t ? "undefined" : (0, i.default)(t)) && "function" != typeof t ? e : t;
      };
    }, function (e, t) {
      var n = e.exports = {
        version: "2.4.0"
      };
      "number" == typeof __e && (__e = n);
    }, function (e, t, n) {
      function r() {
        !p && window.screenfull && window.screenfull.enabled && (p = !0, window.screenfull.onchange(function () {
          var e = void 0,
              t = f.length;

          for (e = 0; e < t; e++) {
            f[e](window.screenfull.isFullscreen);
          }
        }));
      }

      function i(e) {
        var t = screen.orientation ? screen.orientation.angle : void 0,
            n = void 0 === t ? window.matchMedia("(orientation: portrait)").matches ? 0 : 90 : t,
            r = void 0,
            i = v.length;

        for ((0, d.debug)("[window:onorientationchange]", "orientation(" + n + ")."), r = 0; r < i; r++) {
          v[r]((n + 90) % 360);
        }
      }

      function o(e) {
        var t = void 0,
            n = b.length;

        for (t = 0; t < n; t++) {
          b[t]();
        }

        _ = !0;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var a = n(63),
          s = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(a),
          u = n(8),
          c = n(121),
          l = n(120),
          d = n(2),
          h = [],
          f = [],
          p = !1,
          v = [],
          b = [],
          _ = !1,
          m = function m() {
        var e = "0,0,0";

        try {
          e = new window.ActiveXObject("ShockwaveFlash.ShockwaveFlash").GetVariable("$version").replace(/\D+/g, ",").match(/^,?(.+),?$/)[1];
        } catch (t) {
          try {
            navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin && (e = (navigator.plugins["Shockwave Flash 2.0"] || navigator.plugins["Shockwave Flash"]).description.replace(/\D+/g, ",").match(/^,?(.+),?$/)[1]);
          } catch (e) {}
        }

        return e.split(",");
      },
          g = function (e) {
        return window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (e) {
          return window.setTimeout(e, 1e3);
        };
      }(),
          y = window.adapter,
          S = !!navigator.mozGetUserMedia,
          E = !!document.documentMode,
          C = y ? "edge" === window.adapter.browserDetails.browser.toLowerCase() : !E && !!window.StyleMedia,
          T = "ontouchstart" in window || window.DocumentTouch && window.document instanceof window.DocumentTouch;

      y || (navigator.getUserMedia = navigator.mediaDevices && navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia || navigator.msGetUserMedia), t.default = {
        requestFrame: g,
        getIsMoz: function getIsMoz() {
          return S;
        },
        getIsEdge: function getIsEdge() {
          return C;
        },
        isTouchEnabled: function isTouchEnabled() {
          return T;
        },
        supportsWebSocket: function supportsWebSocket() {
          return !!window.WebSocket;
        },
        supportsHLS: function supportsHLS() {
          var e = document.createElement("video");
          return e.canPlayType("application/vnd.apple.mpegURL").length > 0 || e.canPlayType("application/x-mpegURL").length > 0 || e.canPlayType("audio/mpegurl").length > 0 || e.canPlayType("audio/x-mpegurl").length > 0;
        },
        supportsFlashVersion: function supportsFlashVersion(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".";
          return m()[0] >= e.split(t)[0];
        },
        resolveElement: function resolveElement(e) {
          try {
            var t = document.getElementById(e);
            if (!t) throw new c.NoElementFoundError("Element with id(" + e + ") could not be found.");
            return t;
          } catch (t) {
            throw new c.NoElementFoundError("Error in accessing element with id(" + e + "). " + t.message);
          }
        },
        createWebSocket: function createWebSocket(e) {
          return new WebSocket(e);
        },
        setVideoSource: function setVideoSource(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];

          try {
            e.srcObject = t;
          } catch (n) {
            (0, d.warn)("[setVideoSource:obj]", "Could not set srcObject: " + n.message), S ? e.mozSrcObject = t : e.src = window.URL.createObjectURL(t);
          }

          if (n) try {
            var r = e.play();
            r && r.then(function () {
              return (0, d.debug)("[setVideoSource:action]", "play (START)");
            }).catch(function (e) {
              return (0, d.warn)("[setVideoSource:action]", "play (FAULT) " + (e.message ? e.message : e));
            });
          } catch (t) {
            (0, d.warn)("[setVideoSource:action]", "play (CATCH::FAULT) " + t.message);

            try {
              e.setAttribute("autoplay", !1), e.pause();
            } catch (e) {
              (0, d.warn)("[setVideoSource:action]", "pause (CATCH::FAULT) " + e.message);
            }
          } else try {
            e.setAttribute("autoplay", !1), e.pause();
          } catch (e) {}
        },
        injectScript: function injectScript(e) {
          var t = new u.DeferredPromise(),
              n = document.createElement("script");
          return n.type = "text/javascript", n.onload = function () {
            t.resolve();
          }, n.onreadystatechange = function () {
            "loaded" !== n.readyState && "complete" !== n.readyState || (n.onreadystatechange = null, t.resolve());
          }, n.src = e, document.getElementsByTagName("head")[0].appendChild(n), t.promise;
        },
        gUM: function gUM(e) {
          return (navigator.mediaDevices || navigator).getUserMedia(e);
        },
        setGlobal: function setGlobal(e, t) {
          window[e] = t;
        },
        getSwfObject: function getSwfObject() {
          return window.swfobject;
        },
        getEmbedObject: function getEmbedObject(e) {
          return document.getElementById(e);
        },
        getElementId: function getElementId(e) {
          return e.getAttribute("id");
        },
        addOrientationChangeHandler: function addOrientationChangeHandler(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          "onorientationchange" in window && ((0, d.debug)("[window:orientation]", "[addOrientationChangeHandler]", "adding responder."), v.push(e), t && i()), 1 === v.length && ((0, d.debug)("[window:orientation]", "[addOrientationChangeHandler]", "onorientationchange added."), window.addEventListener("orientationchange", i));
        },
        removeOrientationChangeHandler: function removeOrientationChangeHandler(e) {
          0 === v.length && ((0, d.debug)("[window:orientation]", "[removeOrientationChangeHandler]:: onorientationchange removed."), window.removeEventListener("onorientationchange", i));
        },
        addCloseHandler: function addCloseHandler(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
          b.splice(-1 === t ? b.length : t, 0, e), _ || window.addEventListener("unload", o);
        },
        removeCloseHandler: function removeCloseHandler(e) {},
        invoke: function invoke(e, t) {
          window.hasOwnProperty(e) && window[e].call(window, t);
        },
        toggleFullScreen: function toggleFullScreen(e) {
          window.screenfull && window.screenfull.enabled && window.screenfull.toggle(e);
        },
        onFullScreenStateChange: function onFullScreenStateChange(e) {
          f.push(e), r();
        },
        onOrientationMetadata: l.onOrientationMetadata,
        onStreamingModeMetadata: l.onStreamingModeMetadata,
        hasAttributeDefined: function hasAttributeDefined(e, t) {
          var n = e.getAttribute(t);
          return null !== n && void 0 !== (void 0 === n ? "undefined" : (0, s.default)(n)) && "string" == typeof n && ("" === n || "true" === n || n === t);
        },
        hasClassDefined: function hasClassDefined(e, t) {
          return e.classList.contains(t);
        },
        createElement: function createElement(e, t) {
          return "text" === e ? document.createTextNode(t.toString()) : document.createElement(e, t);
        },
        addSubscriptionAssignmentHandler: function addSubscriptionAssignmentHandler(e) {
          h.push(e), void 0 === window.setSubscriberId && (window.setSubscriberId = function (e) {
            h.shift()(e);
          });
        },
        getMouseXFromEvent: function getMouseXFromEvent(e) {
          return e || (e = window.event), e.pageX ? e.pageX : e.clientX ? e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft : 0;
        },
        getScrollX: function getScrollX() {
          return void 0 !== window.pageXOffset ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
        },
        createEvent: function createEvent(e) {
          return document.createEvent(e);
        },
        getGlobal: function getGlobal() {
          return window;
        }
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Future = t.DeferredPromise = void 0;

      var i = n(62),
          o = r(i),
          a = n(0),
          s = r(a),
          u = function e() {
        var t = this;
        (0, s.default)(this, e), this.resolve = void 0, this.reject = void 0, this.promise = new o.default(function (e, n) {
          t.resolve = e, t.reject = n;
        });
      },
          c = {
        createIfNotExist: function createIfNotExist(e) {
          var t = e;
          return t || (t = new u()), t;
        }
      };

      t.DeferredPromise = u, t.Future = c;
    }, function (e, t, n) {
      e.exports = {
        default: n(156),
        __esModule: !0
      };
    }, function (e, t, n) {
      var r = n(75)("wks"),
          i = n(57),
          o = n(13).Symbol,
          a = "function" == typeof o;
      (e.exports = function (e) {
        return r[e] || (r[e] = a && o[e] || (a ? o : i)("Symbol." + e));
      }).store = r;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RTCConferenceParticipantEventTypes = t.MessageTransportStateEventTypes = t.SharedObjectEventTypes = t.FailoverSubscriberEventTypes = t.RTMPSubscriberEventTypes = t.RTCSubscriberEventTypes = t.SubscriberEventTypes = t.FailoverPublisherEventTypes = t.RTMPPublisherEventTypes = t.RTCPublisherEventTypes = t.PublisherEventTypes = t.RTCConferenceParticipantEvent = t.MessageTransportStateEvent = t.SharedObjectEvent = t.SubscriberEvent = t.PublisherEvent = t.Event = void 0;
      var i = n(3),
          o = r(i),
          a = n(5),
          s = r(a),
          u = n(4),
          c = r(u),
          l = n(0),
          d = r(l),
          h = n(1),
          f = r(h),
          p = n(85);
      Object.defineProperty(t, "PublisherEventTypes", {
        enumerable: !0,
        get: function get() {
          return p.PublisherEventTypes;
        }
      }), Object.defineProperty(t, "RTCPublisherEventTypes", {
        enumerable: !0,
        get: function get() {
          return p.RTCPublisherEventTypes;
        }
      }), Object.defineProperty(t, "RTMPPublisherEventTypes", {
        enumerable: !0,
        get: function get() {
          return p.RTMPPublisherEventTypes;
        }
      }), Object.defineProperty(t, "FailoverPublisherEventTypes", {
        enumerable: !0,
        get: function get() {
          return p.FailoverPublisherEventTypes;
        }
      });
      var v = n(87);
      Object.defineProperty(t, "SubscriberEventTypes", {
        enumerable: !0,
        get: function get() {
          return v.SubscriberEventTypes;
        }
      }), Object.defineProperty(t, "RTCSubscriberEventTypes", {
        enumerable: !0,
        get: function get() {
          return v.RTCSubscriberEventTypes;
        }
      }), Object.defineProperty(t, "RTMPSubscriberEventTypes", {
        enumerable: !0,
        get: function get() {
          return v.RTMPSubscriberEventTypes;
        }
      }), Object.defineProperty(t, "FailoverSubscriberEventTypes", {
        enumerable: !0,
        get: function get() {
          return v.FailoverSubscriberEventTypes;
        }
      });
      var b = n(86);
      Object.defineProperty(t, "SharedObjectEventTypes", {
        enumerable: !0,
        get: function get() {
          return b.SharedObjectEventTypes;
        }
      });

      var _ = n(83);

      Object.defineProperty(t, "MessageTransportStateEventTypes", {
        enumerable: !0,
        get: function get() {
          return _.MessageTransportStateEventTypes;
        }
      });
      var m = n(84);
      Object.defineProperty(t, "RTCConferenceParticipantEventTypes", {
        enumerable: !0,
        get: function get() {
          return m.RTCConferenceParticipantEventTypes;
        }
      });

      var g = function () {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
          (0, d.default)(this, e), this._type = t, this._data = n;
        }

        return (0, f.default)(e, [{
          key: "type",
          get: function get() {
            return this._type;
          }
        }, {
          key: "data",
          get: function get() {
            return this._data;
          }
        }]), e;
      }(),
          y = function (e) {
        function t(e, n, r) {
          (0, d.default)(this, t);
          var i = (0, s.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, r));
          return i._publisher = n, i;
        }

        return (0, c.default)(t, e), (0, f.default)(t, [{
          key: "publisher",
          get: function get() {
            return this._publisher;
          }
        }]), t;
      }(g),
          S = function (e) {
        function t(e, n, r) {
          (0, d.default)(this, t);
          var i = (0, s.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, r));
          return i._subscriber = n, i;
        }

        return (0, c.default)(t, e), (0, f.default)(t, [{
          key: "subscriber",
          get: function get() {
            return this._subscriber;
          }
        }]), t;
      }(g),
          E = function (e) {
        function t(e, n, r) {
          (0, d.default)(this, t);
          var i = (0, s.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, r));
          return i._name = n, i;
        }

        return (0, c.default)(t, e), (0, f.default)(t, [{
          key: "name",
          get: function get() {
            return this._name;
          }
        }]), t;
      }(g),
          C = function (e) {
        function t(e, n, r) {
          (0, d.default)(this, t);
          var i = (0, s.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, r));
          return i._name = n, i;
        }

        return (0, c.default)(t, e), (0, f.default)(t, [{
          key: "name",
          get: function get() {
            return this._name;
          }
        }]), t;
      }(g),
          T = function (e) {
        function t(e, n, r) {
          (0, d.default)(this, t);
          var i = (0, s.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, r));
          return i._participant = n, i;
        }

        return (0, c.default)(t, e), (0, f.default)(t, [{
          key: "participant",
          get: function get() {
            return this._participant;
          }
        }]), t;
      }(g);

      t.Event = g, t.PublisherEvent = y, t.SubscriberEvent = S, t.SharedObjectEvent = E, t.MessageTransportStateEvent = C, t.RTCConferenceParticipantEvent = T;
    }, function (e, t, n) {
      var r = n(13),
          i = n(6),
          o = n(20),
          a = n(22),
          s = function s(e, t, n) {
        var u,
            c,
            l,
            d = e & s.F,
            h = e & s.G,
            f = e & s.S,
            p = e & s.P,
            v = e & s.B,
            b = e & s.W,
            _ = h ? i : i[t] || (i[t] = {}),
            m = _.prototype,
            g = h ? r : f ? r[t] : (r[t] || {}).prototype;

        h && (n = t);

        for (u in n) {
          (c = !d && g && void 0 !== g[u]) && u in _ || (l = c ? g[u] : n[u], _[u] = h && "function" != typeof g[u] ? n[u] : v && c ? o(l, r) : b && g[u] == l ? function (e) {
            var t = function t(_t, n, r) {
              if (this instanceof e) {
                switch (arguments.length) {
                  case 0:
                    return new e();

                  case 1:
                    return new e(_t);

                  case 2:
                    return new e(_t, n);
                }

                return new e(_t, n, r);
              }

              return e.apply(this, arguments);
            };

            return t.prototype = e.prototype, t;
          }(l) : p && "function" == typeof l ? o(Function.call, l) : l, p && ((_.virtual || (_.virtual = {}))[u] = l, e & s.R && m && !m[u] && a(m, u, l)));
        }
      };

      s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, e.exports = s;
    }, function (e, t) {
      var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = n);
    }, function (e, t) {
      e.exports = function (e) {
        return "object" == typeof e ? null !== e : "function" == typeof e;
      };
    }, function (e, t, n) {
      var r = n(17),
          i = n(106),
          o = n(77),
          a = Object.defineProperty;
      t.f = n(18) ? Object.defineProperty : function (e, t, n) {
        if (r(e), t = o(t, !0), r(n), i) try {
          return a(e, t, n);
        } catch (e) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (e[t] = n.value), e;
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(163),
        __esModule: !0
      };
    }, function (e, t, n) {
      var r = n(14);

      e.exports = function (e) {
        if (!r(e)) throw TypeError(e + " is not an object!");
        return e;
      };
    }, function (e, t, n) {
      e.exports = !n(28)(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          o = r(i),
          a = n(1),
          s = r(a),
          u = "RED5PRO",
          c = function () {
        function e() {
          (0, o.default)(this, e), this._callbacks = {}, this._callbacks[u] = [];
        }

        return (0, s.default)(e, [{
          key: "_notify",
          value: function value(e, t) {
            var n = void 0,
                r = e.length;

            for (n = 0; n < r; n++) {
              e[n](t);
            }
          }
        }, {
          key: "on",
          value: function value(e, t) {
            if ("function" == typeof t) {
              if ("*" === e) return void this._callbacks[u].push(t);
              void 0 === this._callbacks[e] && (this._callbacks[e] = []), -1 === this._callbacks[e].indexOf(t) && this._callbacks[e].push(t);
            }
          }
        }, {
          key: "off",
          value: function value(e, t) {
            var n = this._callbacks[e];

            if ("*" === e && (n = this._callbacks[u]), n) {
              var r = n.indexOf(t);
              -1 !== r && n.splice(r, 1);
            }
          }
        }, {
          key: "trigger",
          value: function value(e) {
            var t = e.type;
            this._callbacks[t] && this._notify(this._callbacks[t], e), this._notify(this._callbacks[u], e);
          }
        }]), e;
      }();

      t.default = c;
    }, function (e, t, n) {
      var r = n(64);

      e.exports = function (e, t, n) {
        if (r(e), void 0 === t) return e;

        switch (n) {
          case 1:
            return function (n) {
              return e.call(t, n);
            };

          case 2:
            return function (n, r) {
              return e.call(t, n, r);
            };

          case 3:
            return function (n, r, i) {
              return e.call(t, n, r, i);
            };
        }

        return function () {
          return e.apply(t, arguments);
        };
      };
    }, function (e, t) {
      var n = {}.hasOwnProperty;

      e.exports = function (e, t) {
        return n.call(e, t);
      };
    }, function (e, t, n) {
      var r = n(15),
          i = n(41);
      e.exports = n(18) ? function (e, t, n) {
        return r.f(e, t, i(1, n));
      } : function (e, t, n) {
        return e[t] = n, e;
      };
    }, function (e, t, n) {
      var r = n(69),
          i = n(50);

      e.exports = function (e) {
        return r(i(e));
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.PlaybackControlsImpl = t.PlaybackControls = t.PlaybackController = void 0;

      var i = n(3),
          o = r(i),
          a = n(0),
          s = r(a),
          u = n(1),
          c = r(u),
          l = n(5),
          d = r(l),
          h = n(4),
          f = r(h),
          p = n(19),
          v = r(p),
          b = n(7),
          _ = r(b),
          m = n(133),
          g = r(m),
          y = n(93),
          S = n(37),
          E = n(2),
          C = "PlaybackControls",
          T = function (e) {
        function t() {
          return (0, s.default)(this, t), (0, d.default)(this, (t.__proto__ || (0, o.default)(t)).call(this));
        }

        return (0, f.default)(t, e), (0, c.default)(t, [{
          key: "play",
          value: function value() {}
        }, {
          key: "pause",
          value: function value() {}
        }, {
          key: "resume",
          value: function value() {}
        }, {
          key: "stop",
          value: function value() {}
        }, {
          key: "mute",
          value: function value() {}
        }, {
          key: "unmute",
          value: function value() {}
        }, {
          key: "setVolume",
          value: function value(e) {}
        }, {
          key: "seekTo",
          value: function value(e) {}
        }, {
          key: "toggleFullScreen",
          value: function value() {}
        }]), t;
      }(v.default),
          w = function () {
        function e() {
          (0, s.default)(this, e);
        }

        return (0, c.default)(e, [{
          key: "getVolume",
          value: function value() {}
        }, {
          key: "setVolume",
          value: function value(e) {}
        }, {
          key: "setSeekTime",
          value: function value(e) {}
        }, {
          key: "setPlaybackDuration",
          value: function value(e) {}
        }, {
          key: "getState",
          value: function value() {}
        }, {
          key: "setState",
          value: function value(e) {}
        }, {
          key: "setAsVOD",
          value: function value(e) {}
        }, {
          key: "enable",
          value: function value(e) {}
        }]), e;
      }(),
          k = function (e) {
        function t(e, n) {
          (0, s.default)(this, t);
          var r = (0, d.default)(this, (t.__proto__ || (0, o.default)(t)).call(this));
          return r.player = e, r.container = n, r._controlbar = void 0, r._playPauseButton = void 0, r._muteButton = void 0, r._volumeField = void 0, r._seekTimeField = void 0, r._timeField = void 0, r._fullScreenButton = void 0, r._state = S.PlaybackState.IDLE, r._mutedState = !1, r._resumeAfterSeek = !1, r._playbackDuration = 0, r._volumeValue = 1, r._onPlayPauseClickBound = r._onPlayPauseClick.bind(r), r.decorate(r.container), r;
        }

        return (0, f.default)(t, e), (0, c.default)(t, [{
          key: "decorate",
          value: function value(e) {
            (0, E.debug)(C, "[decorate]");

            var t = _.default.createElement("div");

            t.classList.add("red5pro-media-control-bar"), this._playPauseButton = this._createPlayPauseButton(), this._muteButton = this._createMuteButton(), this._volumeField = this._createVolumeControl(), this._seekTimeField = this._createSeekControl(), this._timeField = this._createPlaybackTime(), this._fullScreenButton = this._createFullScreenToggle(), t.appendChild(this._playPauseButton), t.appendChild(this._timeField), t.appendChild(this._seekTimeField.view), t.appendChild(this._muteButton), t.appendChild(this._volumeField.view), t.appendChild(this._fullScreenButton), e.appendChild(t), this._controlbar = t;

            var n = void 0,
                r = function r() {
              clearTimeout(n), n = setTimeout(function () {
                t.classList.remove("red5pro-media-control-bar-show");
              }, 6e3);
            };

            _.default.isTouchEnabled() ? (t.classList.add("red5pro-media-control-bar-show"), this.container.addEventListener("touchend", function () {
              t.classList.toggle("red5pro-media-control-bar-show"), r();
            }), r()) : (this.container.addEventListener("mouseover", function () {
              t.classList.add("red5pro-media-control-bar-show");
            }), this.container.addEventListener("mouseout", function () {
              t.classList.remove("red5pro-media-control-bar-show");
            })), this.setState(S.PlaybackState.IDLE).onFullScreenChange(!1).setSeekTime(0).enable(!1);
          }
        }, {
          key: "_onPlayPauseClick",
          value: function value() {
            this.getState() === S.PlaybackState.PLAYING ? this.player.pause() : this.getState() === S.PlaybackState.PAUSED ? this.player.resume() : this.player.play();
          }
        }, {
          key: "_createPlayPauseButton",
          value: function value() {
            var e = _.default.createElement("button");

            return e.setAttribute("aria-label", "Toggle Playback"), e.classList.add("red5pro-media-control-element"), e.classList.add("red5pro-media-element-button"), e.classList.add("red5pro-media-playpause-button"), e;
          }
        }, {
          key: "_createMuteButton",
          value: function value() {
            var e = this,
                t = _.default.createElement("button");

            return t.setAttribute("aria-label", "Toggle Mute Audio"), t.classList.add("red5pro-media-control-element"), t.classList.add("red5pro-media-element-button"), t.classList.add("red5pro-media-muteunmute-button"), t.addEventListener("click", function () {
              e.getMutedState() ? (e.player.unmute(), e.setMutedState(!1)) : (e.player.mute(), e.setMutedState(!0));
            }), t;
          }
        }, {
          key: "_createVolumeControl",
          value: function value() {
            var e = this,
                t = new g.default("volume");
            return t.view.classList.add("red5pro-media-control-element"), t.view.classList.add("red5pro-media-volume-slider"), t.view.classList.add("red5pro-media-slider"), t.on(y.SliderEventTypes.CHANGE, function (t) {
              var n = Number(t.data);
              e.player.setVolume(n);
            }), t;
          }
        }, {
          key: "_createSeekControl",
          value: function value() {
            var e = this,
                t = new g.default("seek");
            return t.view.classList.add("red5pro-media-control-element"), t.view.classList.add("red5pro-media-seektime-slider"), t.view.classList.add("red5pro-media-slider"), t.on(y.SliderEventTypes.CHANGE_START, function () {
              e.getState() === S.PlaybackState.PLAYING && (e._resumeAfterSeek = !0, e.player.pause());
            }), t.on(y.SliderEventTypes.CHANGE, function (t) {
              var n = Number(t.data);
              e.player.seekTo(n, 0 === e._playbackDuration ? void 0 : e._playbackDuration), e.setSeekTime(n * e._playbackDuration, e._playbackDuration);
            }), t.on(y.SliderEventTypes.CHANGE_COMPLETE, function () {
              e._resumeAfterSeek && e.getState() === S.PlaybackState.PAUSED && (e._resumeAfterSeek = !1, e.player.resume());
            }), t;
          }
        }, {
          key: "_createPlaybackTime",
          value: function value() {
            var e = _.default.createElement("span"),
                t = _.default.createElement("text", "hello!");

            return e.classList.add("red5pro-media-control-element"), e.classList.add("red5pro-media-time-field"), e.appendChild(t), e;
          }
        }, {
          key: "_createFullScreenToggle",
          value: function value() {
            var e = this,
                t = _.default.createElement("button");

            return t.setAttribute("aria-label", "Toggle Fullscreen"), t.classList.add("red5pro-media-control-element"), t.classList.add("red5pro-media-element-button"), t.classList.add("red5pro-media-fullscreen-button"), t.addEventListener("click", function () {
              e.player.toggleFullScreen();
            }), t;
          }
        }, {
          key: "enable",
          value: function value(e) {
            e ? (this._playPauseButton.classList.remove("red5pro-media-element-button-disabled"), this._playPauseButton.addEventListener("click", this._onPlayPauseClickBound)) : (this._playPauseButton.classList.add("red5pro-media-element-button-disabled"), this._playPauseButton.removeEventListener("click", this._onPlayPauseClickBound));
          }
        }, {
          key: "formatTime",
          value: function value(e) {
            var t = 0,
                n = 0 === e ? 0 : parseInt(e / 60),
                r = 0;
            n >= 60 && (t = parseInt(n / 60), n %= 60), r = 0 === e ? 0 : parseInt(e % 60);
            var i = t < 10 ? ["0" + t] : [t];
            return i.push(n < 10 ? ["0" + n] : [n]), i.push(r < 10 ? ["0" + r] : [r]), i.join(":");
          }
        }, {
          key: "getVolume",
          value: function value() {
            return this._volumeValue;
          }
        }, {
          key: "setVolume",
          value: function value(e) {
            return this._volumeField.value = e, this._volumeValue = e, 0 === e ? this.setMutedState(!0) : this.getMutedState() && this.setMutedState(!1), this;
          }
        }, {
          key: "setSeekTime",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            return this._seekTimeField.value = 0 === t ? 0 : e / t, 0 !== this._playbackDuration && parseInt(this._playbackDuration) <= parseInt(e) && (this._seekTimeField.value = 1), this._timeField.innerText = this.formatTime(Math.floor(e)), this;
          }
        }, {
          key: "setPlaybackDuration",
          value: function value(e) {
            (0, E.debug)(C, "[setplaybackduration]: " + e), this._playbackDuration = e;
          }
        }, {
          key: "getState",
          value: function value() {
            return this._state;
          }
        }, {
          key: "setState",
          value: function value(e) {
            return (0, E.debug)(C, "[setState]: " + S.PlaybackStateReadable[e]), this._state = e, this.onStateChange(this._state), this;
          }
        }, {
          key: "getMutedState",
          value: function value() {
            return "muted" in this.player ? this.player.muted : this._mutedState;
          }
        }, {
          key: "setMutedState",
          value: function value(e) {
            return this._mutedState = e, this.onMutedStateChange(this._mutedState), this;
          }
        }, {
          key: "onStateChange",
          value: function value(e) {
            return e === S.PlaybackState.PLAYING ? (this._playPauseButton.classList.remove("red5pro-media-play-button"), this._playPauseButton.classList.add("red5pro-media-pause-button")) : (this._playPauseButton.classList.add("red5pro-media-play-button"), this._playPauseButton.classList.remove("red5pro-media-pause-button")), this;
          }
        }, {
          key: "onMutedStateChange",
          value: function value(e) {
            e ? (this._muteButton.classList.add("red5pro-media-mute-button"), this._muteButton.classList.remove("red5pro-media-unmute-button"), this._volumeField.value = 0) : (this._muteButton.classList.remove("red5pro-media-mute-button"), this._muteButton.classList.add("red5pro-media-unmute-button"), this._volumeField.value = this._volumeValue);
          }
        }, {
          key: "onFullScreenChange",
          value: function value(e) {
            return e ? (this._fullScreenButton.classList.add("red5pro-media-exit-fullscreen-button"), this._fullScreenButton.classList.remove("red5pro-media-fullscreen-button")) : (this._fullScreenButton.classList.remove("red5pro-media-exit-fullscreen-button"), this._fullScreenButton.classList.add("red5pro-media-fullscreen-button")), this;
          }
        }, {
          key: "setAsVOD",
          value: function value(e) {
            (0, E.debug)(C, "[setAsVOD]: " + e), e ? this._seekTimeField.disabled = !1 : (this._seekTimeField.value = 0, this._seekTimeField.disabled = !0);
          }
        }, {
          key: "detach",
          value: function value() {
            this.enable(!1), this._controlbar && this._controlbar.parentNode === this.container && this.container.removeChild(this._controlbar);
          }
        }]), t;
      }(w);

      t.PlaybackController = T, t.PlaybackControls = w, t.PlaybackControlsImpl = k;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isObjectEmpty = t.metadataResolutionToObject = t.deepCopy = t.deepDefine = void 0;
      var i = n(38),
          o = r(i),
          a = n(9),
          s = r(a);
      t.deepDefine = function (e, t, n) {
        var r = 0,
            i = e,
            o = t.pop(),
            a = t.length;

        for (r; r < a; r++) {
          var s = t[r];
          i[s] = i[s] || {}, i = i[s];
        }

        i[o] = n;
      }, t.deepCopy = function (e) {
        var t = (0, s.default)(e);
        return JSON.parse(t);
      }, t.metadataResolutionToObject = function (e) {
        if ("string" == typeof e) {
          var t = e.split(",");
          return {
            width: parseInt(t[0]),
            height: parseInt(t[1])
          };
        }

        return e;
      }, t.isObjectEmpty = function (e) {
        return 0 === (0, o.default)(e).length && e.constructor === Object;
      };
    }, function (e, t, n) {
      t.__esModule = !0;

      var r = n(145),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.default = i.default || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      t.__esModule = !0;
      var i = n(3),
          o = r(i),
          a = n(147),
          s = r(a);

      t.default = function e(t, n, r) {
        null === t && (t = Function.prototype);
        var i = (0, s.default)(t, n);

        if (void 0 === i) {
          var a = (0, o.default)(t);
          return null === a ? void 0 : e(a, n, r);
        }

        if ("value" in i) return i.value;
        var u = i.get;
        if (void 0 !== u) return u.call(r);
      };
    }, function (e, t) {
      e.exports = function (e) {
        try {
          return !!e();
        } catch (e) {
          return !0;
        }
      };
    }, function (e, t, n) {
      var r = n(189)(!0);
      n(70)(String, "String", function (e) {
        this._t = String(e), this._i = 0;
      }, function () {
        var e,
            t = this._t,
            n = this._i;
        return n >= t.length ? {
          value: void 0,
          done: !0
        } : (e = r(t, n), this._i += e.length, {
          value: e,
          done: !1
        });
      });
    }, function (e, t, n) {
      n(194);

      for (var r = n(13), i = n(22), o = n(32), a = n(10)("toStringTag"), s = ["NodeList", "DOMTokenList", "MediaList", "StyleSheetList", "CSSRuleList"], u = 0; u < 5; u++) {
        var c = s[u],
            l = r[c],
            d = l && l.prototype;
        d && !d[a] && i(d, a, c), o[c] = o.Array;
      }
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RTCSessionDescription = t.RTCIceCandidate = t.RTCPeerConnection = t.forceStereoOnLocalAnswer = t.updateBandwidth = t.flipRecvOnlyOnExtraVideo = t.flipRecvOnlyOnExtraAudio = t.stripNonH264FromVideo = t.stripNonH264 = t.stripRTPMaps = t.forceUserMedia = t.getUserMedia = t.supportsDataChannel = t.isSupported = t.determineSupportedResolution = t.quickResolutionSupport = void 0;

      var i = n(9),
          o = r(i),
          a = n(7),
          s = r(a),
          u = n(8),
          c = n(95),
          l = n(25),
          d = n(2),
          h = [{
        label: "4K(UHD)",
        width: 3840,
        height: 2160
      }, {
        label: "1080p(FHD)",
        width: 1920,
        height: 1080
      }, {
        label: "UXGA",
        width: 1600,
        height: 1200
      }, {
        label: "720p(HD)",
        width: 1280,
        height: 720
      }, {
        label: "SVGA",
        width: 800,
        height: 600
      }, {
        label: "VGA",
        width: 640,
        height: 480
      }, {
        label: "360p(nHD)",
        width: 640,
        height: 360
      }, {
        label: "CIF",
        width: 352,
        height: 288
      }, {
        label: "QVGA",
        width: 320,
        height: 240
      }, {
        label: "QCIF",
        width: 176,
        height: 144
      }, {
        label: "QQVGA",
        width: 160,
        height: 120
      }],
          f = function f(e) {
        return e.hasOwnProperty("video") && (e.video.hasOwnProperty("width") || e.video.hasOwnProperty("height"));
      },
          p = function p(e) {
        return e.exact || e.ideal || e.max || e.min || e;
      },
          v = (0, c.curry)(function (e, t) {
        if ("boolean" == typeof e.video) return !0;
        var n = e.video.hasOwnProperty("width") ? p(e.video.width) : 0,
            r = e.video.hasOwnProperty("height") ? p(e.video.height) : 0,
            i = n === t.width && r === t.height;
        return i && (0, d.debug)("[gum:isExact]", "Found matching resolution for " + t.width + ", " + t.height + "."), i;
      }),
          b = (0, c.curry)(function (e, t) {
        var n = e.video.hasOwnProperty("width") ? p(e.video.width) : 0,
            r = e.video.hasOwnProperty("height") ? p(e.video.height) : 0,
            i = n * r;
        return t.width * t.height < i;
      }),
          _ = (0, c.curry)(function (e, t) {
        var n = (0, c.filter)(v(t))(e);
        return (0, d.debug)("[gum:hasMatchingFormat]", "Filtered list: " + (0, o.default)(n, null, 2)), n.length > 0;
      }),
          m = (0, c.curry)(function (e, t) {
        var n = b(t);
        return (0, c.filter)(n)(e);
      }),
          g = function g(e, t) {
        e.video = !0, s.default.gUM(e).then(function (n) {
          t.resolve({
            media: n,
            constraints: e
          });
        }).catch(function (n) {
          var r = "string" == typeof n ? n : [n.name, n.message].join(": ");
          (0, d.debug)("[gum:getUserMedia]", "Failure in getUserMedia: " + r + ". Attempting other resolution tests..."), (0, d.debug)("[gUM:findformat]", "Constraints declined by browser: " + (0, o.default)(e, null, 2)), t.reject("Could not find proper camera for provided constraints.");
        });
      },
          y = function e(t, n, r) {
        if (0 == n.length) return void g(t, r);
        var i = n.shift();
        t.video.width = {
          exact: i.width
        }, t.video.height = {
          exact: i.height
        }, s.default.gUM(t).then(function (e) {
          r.resolve({
            media: e,
            constraints: t
          });
        }).catch(function (i) {
          var a = "string" == typeof i ? i : [i.name, i.message].join(": ");
          (0, d.debug)("[gum:getUserMedia]", "Failure in getUserMedia: " + a + ". Attempting other resolution tests..."), (0, d.debug)("[gUM:findformat]", "Constraints declined by browser: " + (0, o.default)(t, null, 2)), e(t, n, r);
        });
      },
          S = t.quickResolutionSupport = function (e) {
        var t = (0, l.deepCopy)(e);
        return "boolean" == typeof e.video ? t : (e.video.width && (t.video.width = {
          exact: p(e.video.width)
        }), e.video.height && (t.video.height = {
          exact: p(e.video.height)
        }), t);
      },
          E = t.determineSupportedResolution = function (e) {
        (0, d.debug)("[gum:determineSupportedResolution]", "Determine next neighbor based on constraints: " + (0, o.default)(e, null, 2));
        var t = new u.DeferredPromise(),
            n = m(h)(e),
            r = (0, l.deepCopy)(e);
        return y(r, n, t), t.promise;
      },
          C = t.isSupported = function () {
        return O && R && A;
      },
          T = (t.supportsDataChannel = function () {
        try {
          var e = new O(null);
          return e.createDataChannel({
            name: "test"
          }).close(), e.close(), !!C();
        } catch (e) {
          return (0, d.debug)("Could not detect RTCDataChannel support: " + e.message), !1;
        }
      }, t.getUserMedia = function (e, t) {
        var n = new u.DeferredPromise(),
            r = _(h);

        (0, d.debug)("[gum:getUserMedia]", "Is Available in format listing: " + r(e));

        var i = function i(r) {
          if (r) {
            var i = "string" == typeof r ? r : [r.name, r.message].join(": ");
            (0, d.debug)("[gum:getUserMedia]", "Failure in getUserMedia: " + i + ". Attempting other resolution tests...");
          }

          E(e).then(function (e) {
            n.resolve({
              media: e.media,
              constraints: e.constraints
            });
          }).catch(function (r) {
            t && t(e), n.reject({
              error: r,
              constraints: e
            });
          });
        };

        if (f(e)) {
          if (r(e)) {
            (0, d.debug)("[gum:getUserMedia]", "Found constraints in list. Checking quick support for faster setup with: " + (0, o.default)(e, null, 2));
            var a = S(e);
            s.default.gUM(a).then(function (e) {
              n.resolve({
                media: e,
                constraints: a
              });
            }).catch(i);
          } else (0, d.debug)("[gum:getUserMedia]", "Could not find contraints in list. Attempting failover..."), t && t(e), i();
        } else (0, d.debug)("[gum:getUserMedia]", "Constraints were not defined properly. Attempting failover..."), s.default.gUM(e).then(function (t) {
          n.resolve({
            media: t,
            constraints: e
          });
        }).catch(i);
        return n.promise;
      }, t.forceUserMedia = function (e) {
        return s.default.gUM(e);
      }, function (e) {
        var t = [];
        return e.forEach(function (e) {
          return t.push(new RegExp("a=(" + e + ")", "g"));
        }), t;
      }(["rtpmap:(\\d{1,}) ISAC", "rtpmap:(\\d{1,}) G722", "rtpmap:(\\d{1,}) CN", "rtpmap:(\\d{1,}) PCMU", "rtpmap:(\\d{1,}) PCMA", "rtpmap:(\\d{1,}) telephone-event"])),
          w = (t.stripRTPMaps = function (e) {
        for (var t = e.split("\r\n"), n = t.length, r = void 0, i = void 0, o = void 0, a = [], s = void 0; --n > -1;) {
          for (r = 0; r < T.length; r++) {
            if (i = T[r], i.lastIndex = 0, o = i.exec(t[n])) {
              s = function (e) {
                return "^a=(rtcp-fb|fmtp):" + e + " .*";
              }(o[o.length - 1]), -1 === a.indexOf(s) && a.push(s), t.splice(n, 1);
              break;
            }
          }
        }

        for (i && (i.lastIndex = 0), n = t.length; --n > -1;) {
          for (r = 0; r < a.length; r++) {
            if (i = new RegExp(a[r], "g"), i.lastIndex = 0, i.exec(t[n])) {
              t.splice(n, 1);
              break;
            }
          }
        }

        return t.join("\r\n");
      }, t.stripNonH264 = function (e) {
        for (var t = /^a=((rtpmap|rtcp-fb|fmtp):(\d{1,}).*)/gi, n = /^a=fmtp:(\d{1,}).*profile-level-id=\b42/gi, r = [], i = e.split("\r\n"), o = i.length, a = 0, s = void 0; --o > -1;) {
          n.lastIndex = 0, (s = n.exec(i[o])) && -1 === r.indexOf(s[s.length - 1]) && r.push(s[s.length - 1]);
        }

        for (o = i.length; --o > -1;) {
          for (a = 0; a < r.length; a++) {
            if (t.lastIndex = 0, (s = t.exec(i[o])) && -1 === r.indexOf(s[s.length - 1])) {
              i.splice(o, 1);
              break;
            }
          }
        }

        return i.join("\r\n");
      }),
          k = (t.stripNonH264FromVideo = function (e) {
        var t = /^video/g;
        return e.split("m=").map(function (e) {
          return e.match(t) && -1 !== e.indexOf("a=sendrecv") ? w(e) : e;
        }).join("m=");
      }, /a=ssrc/gi),
          P = function P(e, t, n) {
        var r = 0;
        return e.split(t).map(function (e) {
          if (e.match(n) && ++r > 1) {
            for (var t = e.replace("a=sendrecv", "a=recvonly"), i = t.split("\r\n"), o = i.length; --o > -1;) {
              k.lastIndex = 0, k.exec(i[o]) && i.splice(o, 1);
            }

            return i.join("\r\n");
          }

          return e;
        }).join(t);
      },
          O = (t.flipRecvOnlyOnExtraAudio = function (e) {
        return P(e, "m=", /^audio/g);
      }, t.flipRecvOnlyOnExtraVideo = function (e) {
        return P(e, "m=", /^video/g);
      }, t.updateBandwidth = function (e, t) {
        var n = t.indexOf("m=audio"),
            r = t.indexOf("m=video"),
            i = void 0,
            o = void 0,
            a = void 0;
        return n > -1 && (e.audio && (i = t.indexOf("\r\n", n), o = t.slice(0, i), a = t.slice(i + "\r\n".length, t.length), t = [o, "b=AS:" + e.audio, a].join("\r\n")), r = t.indexOf("m=video")), r > -1 && e.video && (i = t.indexOf("\r\n", r), o = t.slice(0, i), a = t.slice(i + "\r\n".length, t.length), t = [o, "b=AS:" + e.video, a].join("\r\n")), -1 === n && -1 === r && (t = t.replace(/b=AS([^\r\n]+\r\n)/g, ""), e.audio && (t = t.replace(/a=mid:audio\r\n/g, "a=mid:audio\r\nb=AS:" + e.audio + "\r\n")), e.video && (t = t.replace(/a=mid:video\r\n/g, "a=mid:video\r\nb=AS:" + e.video + "\r\n"))), t;
      }, t.forceStereoOnLocalAnswer = function (e) {
        return e.includes("stereo=1") ? e : e.replace("useinbandfec=1", "useinbandfec=1;stereo=1;sprop-stereo=1");
      }, window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection),
          R = window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate,
          A = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;

      t.RTCPeerConnection = O, t.RTCIceCandidate = R, t.RTCSessionDescription = A;
    }, function (e, t) {
      e.exports = {};
    }, function (e, t, n) {
      var r = n(57)("meta"),
          i = n(14),
          o = n(21),
          a = n(15).f,
          s = 0,
          u = Object.isExtensible || function () {
        return !0;
      },
          c = !n(28)(function () {
        return u(Object.preventExtensions({}));
      }),
          l = function l(e) {
        a(e, r, {
          value: {
            i: "O" + ++s,
            w: {}
          }
        });
      },
          d = function d(e, t) {
        if (!i(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;

        if (!o(e, r)) {
          if (!u(e)) return "F";
          if (!t) return "E";
          l(e);
        }

        return e[r].i;
      },
          h = function h(e, t) {
        if (!o(e, r)) {
          if (!u(e)) return !0;
          if (!t) return !1;
          l(e);
        }

        return e[r].w;
      },
          f = function f(e) {
        return c && p.NEED && u(e) && !o(e, r) && l(e), e;
      },
          p = e.exports = {
        KEY: r,
        NEED: !1,
        fastKey: d,
        getWeak: h,
        onFreeze: f
      };
    }, function (e, t, n) {
      var r = n(115),
          i = n(68);

      e.exports = Object.keys || function (e) {
        return r(e, i);
      };
    }, function (e, t, n) {
      var r = n(50);

      e.exports = function (e) {
        return Object(r(e));
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.PlaybackVideoEncoder = t.PlaybackAudioEncoder = t.PlaybackTypes = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.PlaybackTypes = (0, i.default)({
        RTC: "rtc",
        RTMP: "rtmp",
        HLS: "hls"
      }), t.PlaybackAudioEncoder = (0, i.default)({
        OPUS: "Opus",
        PCMU: "PCMU",
        PCMA: "PCMA",
        SPEEX: "Speex",
        NONE: "NONE"
      }), t.PlaybackVideoEncoder = (0, i.default)({
        VP8: "VP8",
        H264: "H264",
        NONE: "NONE"
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.PlaybackStateReadable = t.PlaybackState = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.PlaybackState = (0, i.default)({
        UNAVAILABLE: 1e3,
        AVAILABLE: 0,
        IDLE: 1,
        PLAYING: 2,
        PAUSED: 3
      }), t.PlaybackStateReadable = (0, i.default)({
        1e3: "Playback.UNAVAILABLE",
        0: "Playback.AVAILABLE",
        1: "Playback.IDLE",
        2: "Playback.PLAYING",
        3: "Playback.PAUSED"
      });
    }, function (e, t, n) {
      e.exports = {
        default: n(166),
        __esModule: !0
      };
    }, function (e, t) {
      var n = {}.toString;

      e.exports = function (e) {
        return n.call(e).slice(8, -1);
      };
    }, function (e, t, n) {
      var r = n(20),
          i = n(109),
          o = n(107),
          a = n(17),
          s = n(56),
          u = n(80),
          c = {},
          l = {},
          t = e.exports = function (e, t, n, d, h) {
        var f,
            p,
            v,
            b,
            _ = h ? function () {
          return e;
        } : u(e),
            m = r(n, d, t ? 2 : 1),
            g = 0;

        if ("function" != typeof _) throw TypeError(e + " is not iterable!");

        if (o(_)) {
          for (f = s(e.length); f > g; g++) {
            if ((b = t ? m(a(p = e[g])[0], p[1]) : m(e[g])) === c || b === l) return b;
          }
        } else for (v = _.call(e); !(p = v.next()).done;) {
          if ((b = i(v, m, p.value, t)) === c || b === l) return b;
        }
      };

      t.BREAK = c, t.RETURN = l;
    }, function (e, t) {
      e.exports = function (e, t) {
        return {
          enumerable: !(1 & e),
          configurable: !(2 & e),
          writable: !(4 & e),
          value: t
        };
      };
    }, function (e, t, n) {
      var r = n(15).f,
          i = n(21),
          o = n(10)("toStringTag");

      e.exports = function (e, t, n) {
        e && !i(e = n ? e : e.prototype, o) && r(e, o, {
          configurable: !0,
          value: t
        });
      };
    }, function (e, t) {}, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.create = t.isSupported = void 0;

      var r = n(7),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.isSupported = function () {
        return i.default.supportsWebSocket();
      }, t.create = function (e) {
        return i.default.createWebSocket(e);
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(3),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(5),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(44),
          _ = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }(b),
          m = n(7),
          g = r(m),
          y = n(88),
          S = r(y),
          E = n(11),
          C = n(2),
          T = "R5ProSocketProxy",
          w = function (e) {
        function t(e, n) {
          (0, c.default)(this, t);
          var r = (0, f.default)(this, (t.__proto__ || (0, s.default)(t)).call(this, n || T));
          return r._responder = e, r._pendingPostRequests = [], r._websocket = void 0, r._connectionPromise = void 0, r._responseHandlers = [], r._isTerminated = !1, r._retryCount = 0, r._retryLimit = 1, r._readyCheckCount = 0, r._readyCheckLimit = 10, r._openState = 0, r._onclose = r.tearDown.bind(r), r._onopenTimeout = 0, r;
        }

        return (0, v.default)(t, e), (0, d.default)(t, [{
          key: "_resetOnopenTimeout",
          value: function value(e, t) {
            var n = this,
                r = setTimeout(function () {
              if (clearTimeout(r), 1 === e.readyState) {
                for ((0, C.info)(n._name, "[websocketopen]"), n._openState = 1; n._pendingPostRequests.length > 0;) {
                  n.post(n._pendingPostRequests.shift());
                }

                n._responder && n._responder.onSocketOpen && n._responder.onSocketOpen(), n.trigger(new E.MessageTransportStateEvent(E.MessageTransportStateEventTypes.OPEN, n._name, {
                  socket: n
                }));
              } else 0 === e.readyState ? ++n._readyCheckCount > n._readyCheckLimit ? ((0, C.warn)(n._name, "WebSocket connection issue. We have waited for " + (n._readyCheckCount - 1) + " samples, without any connection."), n.clearRetry(), t.reject({
                type: "Timeout"
              }), n.tearDown()) : ((0, C.info)(n._name, "WebSocket connection is still opening, will let it continue (" + n._readyCheckCount + ")..."), n._onopenTimeout = n._resetOnopenTimeout(e, t)) : (0, C.info)(n._name, "WebSocket connection attempts have ended with state (" + e.readyState + ").");
            }, 500);
            return r;
          }
        }, {
          key: "_removeSocketHandlers",
          value: function value(e) {
            e && (e.onopen = void 0, e.onmessage = void 0, e.onerror = void 0, e.onclose = void 0);
          }
        }, {
          key: "_addSocketHandlers",
          value: function value(e, t) {
            var n = this;
            this._openState = 0, this._readyCheckCount = 0, clearTimeout(this._onopenTimeout), this._onopenTimeout = this._resetOnopenTimeout(e, t), e.onerror = function (e) {
              (0, C.warn)(n._name, "[websocketerror]: Error from WebSocket. " + e.type + "."), n.clearRetry(), t.reject(e), n.trigger(new E.MessageTransportStateEvent(E.MessageTransportStateEventTypes.ERROR, n._name, {
                socket: n,
                error: e
              }));
            }, e.onmessage = function (e) {
              n.respond(e);
            }, e.onclose = function (t) {
              t.code > 1e3 ? (0, C.warn)(n._name, "[websocketclose]: " + t.code) : (0, C.debug)(n._name, "[websocketclose]: " + t.code), n._responder && n._responder.onSocketClose && n._responder.onSocketClose(t), n.clearRetry(), n._removeSocketHandlers(e || n._websocket), n._openState = 0, n.trigger(new E.MessageTransportStateEvent(E.MessageTransportStateEventTypes.CLOSE, n._name, {
                socket: n,
                event: t
              }));
            };
          }
        }, {
          key: "_onUnexpectedSocketError",
          value: function value(e) {
            this._responder && this._responder.onSocketClose && this._responder.onSocketClose(e), this.trigger(new E.MessageTransportStateEvent(E.MessageTransportStateEventTypes.CLOSE, this._name, {
              socket: this
            })), (0, C.warn)(this._name, "[websocketerror]: Possible Unexpected Error from WebSocket. " + e.type + ", " + e.detail), this.clearRetry(), this._removeSocketHandlers(this._websocket);
          }
        }, {
          key: "clearRetry",
          value: function value() {
            this._retryCount = 0, this._readyCheckCount = 0, clearTimeout(this._onopenTimeout);
          }
        }, {
          key: "setUp",
          value: function value(e, t) {
            var n = this,
                r = g.default.getIsMoz() || g.default.getIsEdge();

            if ((0, C.debug)(this._name, "[websocket:setup] " + e + "."), this.tearDown(), this._isTerminated = !1, this._connectionPromise = t, g.default.addCloseHandler(this._onclose), this._websocket = _.create(e), this._addSocketHandlers(this._websocket, this._connectionPromise), r && this._retryCount++ < this._retryLimit) {
              (0, C.debug)(this._name, "We have determined it is Firefox and are setting up a retry limit.");
              var i = setTimeout(function () {
                n._websocket && 0 === n._websocket.readyState && ((0, C.debug)(n._name, "[websocket:FF-timeout]"), (0, C.debug)(n._name, "Our connection on Firefox to the wss endpoint has timed out. Let's try that again."), n._removeSocketHandlers(n._websocket), n.setUp(e, t)), clearTimeout(i);
              }, 2e3);
            }
          }
        }, {
          key: "setUpWithSocket",
          value: function value(e, t) {
            (0, C.debug)(this._name, "[websocket:setupWithSocket] " + e.url + "."), this.tearDown(), this._isTerminated = !1, this._connectionPromise = t, g.default.addCloseHandler(this._onclose), this._websocket = e, this._addSocketHandlers(this._websocket, this._connectionPromise);
          }
        }, {
          key: "sever",
          value: function value(e) {
            (0, C.debug)(this._name, "[websocket:sever]"), this._websocket && (e && this.post(e), this._removeSocketHandlers(this._websocket), this.tearDown());
          }
        }, {
          key: "tearDown",
          value: function value() {
            if (this._pendingPostRequests.length = 0, void 0 !== this._websocket && !this._isTerminated) {
              (0, C.debug)(this._name, "[teardown] >>"), (0, C.debug)(this._name, "[WebSocket(" + this._websocket.url + ")] close() >>");

              try {
                this._websocket.close();
              } catch (e) {
                (0, C.warn)(this._name, "Attempt to close WebSocket failed: " + e.message + "."), this._removeSocketHandlers(this._websocket);
              } finally {
                this._websocket && (0, C.debug)(this._name, "<< [WebSocket(" + this._websocket.url + ")] close()");
              }

              (0, C.debug)(this._name, "<< [teardown]");
            }

            for (this._websocket = void 0, this._isTerminated = !0, this._openState = 0; this._responseHandlers.length > 0;) {
              this._responseHandlers.shift();
            }

            g.default.removeCloseHandler(this._onclose);
          }
        }, {
          key: "postEndOfCandidates",
          value: function value(e) {
            this.post({
              handleCandidate: e,
              data: {
                candidate: {
                  type: "candidate",
                  candidate: ""
                }
              }
            });
          }
        }, {
          key: "post",
          value: function value(e) {
            if (void 0 === this._websocket || 1 !== this._openState) return (void 0 === this._websocket || 2 !== this._websocket.readyState && 3 !== this._websocket.readyState) && !this._isTerminated && (this._pendingPostRequests.push(e), !0);

            try {
              return (0, C.debug)(this._name, "[websocket-post]: " + (0, o.default)(e, null, 2)), this._websocket.send((0, o.default)(e)), !0;
            } catch (t) {
              return (0, C.debug)(this._name, "Could not send request: " + e + ". " + t), !1;
            }
          }
        }, {
          key: "respond",
          value: function value(e) {
            var t = this.handleMessageResponse(e);

            if (!t && e.data) {
              var n = this.getJsonFromSocketMessage(e);
              if (null === n) return (0, C.warn)(this._name, "Determined websocket response not in correct format. Aborting message handle."), !0;
              if ((0, C.debug)(this._name, "[websocket-response]: " + (0, o.default)(n, null, 2)), void 0 !== n.isAvailable) return "boolean" == typeof n.isAvailable && n.isAvailable ? (this._responder && this._responder.onStreamAvailable(n), !0) : (this._responder && this._responder.onStreamUnavailable(n), !0);

              if (n.async && n.id) {
                var r = this._asyncTickets.find(function (e) {
                  return e.id === n.id;
                }),
                    i = r.promise;

                i && n.data ? i.resolve(n.data) : i && n.error && i.reject(n.error);
              } else if (void 0 !== n.data) {
                var a = n.data;

                if (void 0 !== a.message) {
                  if ("error" === a.type && this._responder) return this._responder.onSocketMessageError(a.message, a.detail), !0;
                } else if ("status" === a.type) {
                  if ("NetConnection.Connect.Success" === a.code) return this._websocket.onerror = this._onUnexpectedSocketError.bind(this), this._connectionPromise.resolve(this), !0;
                  if ("NetConnection.DataChannel.Available" === a.code) return this._responder.onDataChannelAvailable(a.description), !0;
                  if ("NetConnection.Connect.Rejected" === a.code) return this._connectionPromise.reject("NetConnection.Connect.Rejected"), !0;
                } else if ("error" === a.type) {
                  if ("NetConnection.Connect.Rejected" === a.code) return this._connectionPromise.reject("NetConnection.Connect.Rejected"), !0;
                  if ("NetConnection.Connect.Failed" === a.code) return this._connectionPromise.reject("NetConnection.Connect.Failed"), !0;
                }
              }
            }

            return t;
          }
        }, {
          key: "isTerminated",
          get: function get() {
            return this._isTerminated;
          }
        }]), t;
      }(S.default);

      t.default = w;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.hlsSocketEndpointFromOptions = t.rtcSocketEndpointFromOptions = t.encodeKeyValues = void 0;

      var i = n(26),
          o = r(i),
          a = n(38),
          s = r(a),
          u = function u(e) {
        switch (e) {
          case 8083:
          case "8083":
            return console.warn("The default WebSocket port on the server has changed from 8083 to 443 for secure connections."), 443;

          case 8081:
          case "8081":
            return console.warn("The default WebSocket port on the server has changed from 8081 to 5080 or 80 for secure connections."), 5080;
        }

        return e;
      },
          c = t.encodeKeyValues = function (e) {
        var t = {};
        return (0, s.default)(e).forEach(function (n, r) {
          t[n] = encodeURIComponent(e[n]);
        }), t;
      };

      t.rtcSocketEndpointFromOptions = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
            n = e.wsprotocol || e.protocol,
            r = u(e.wsport || e.port),
            i = e.context ? [e.app, e.context].join("/") : e.app,
            a = n + "://" + e.host + ":" + r + "/" + i + "/";

        if (void 0 !== e.connectionParams) {
          var l = c(e.connectionParams);
          t = (0, o.default)(t, l);
        }

        if (void 0 !== t) {
          var d = [];
          (0, s.default)(t).forEach(function (e, n) {
            d.push([e, t[e]].join("="));
          }), d.length > 0 && (a += "?" + d.join("&"));
        }

        return a;
      }, t.hlsSocketEndpointFromOptions = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
            n = e.socketParams,
            r = e.connectionParams,
            i = n.protocol,
            a = u(n.port || ("wss" === i ? 443 : 5080)),
            l = i + "://" + n.host + ":" + a + "/" + n.app + "/";

        if (r) {
          var d = c(e.connectionParams);
          t = (0, o.default)(t, d);
        }

        if (t) {
          var h = [];
          (0, s.default)(t).forEach(function (e, n) {
            h.push([e, t[e]].join("="));
          }), h.length > 0 && (l += "?" + h.join("&"));
        }

        return l;
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.PlaybackView = void 0;

      var i = n(0),
          o = r(i),
          a = n(1),
          s = r(a),
          u = n(7),
          c = r(u),
          l = n(2),
          d = "R5ProPlaybackView",
          h = "red5pro-subscriber",
          f = t.PlaybackView = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : h;
          (0, o.default)(this, e);

          try {
            this._targetElement = c.default.resolveElement(t);
          } catch (e) {
            throw (0, l.error)(d, "Could not instantiate a new instance of Red5ProSubscriber. Reason: " + e.message), e;
          }
        }

        return (0, s.default)(e, [{
          key: "attachSubscriber",
          value: function value(e) {
            (0, l.debug)(d, "[attachsubscriber]"), e.setView(this, c.default.getElementId(this._targetElement));
          }
        }, {
          key: "attachStream",
          value: function value(e) {
            var t = this.isAutoplay;
            (0, l.debug)(d, "[attachstream]"), c.default.setVideoSource(this._targetElement, e, t);
          }
        }, {
          key: "detachStream",
          value: function value() {
            (0, l.debug)(d, "[detachstream]"), c.default.setVideoSource(this._targetElement, null, this.isAutoplay);
          }
        }, {
          key: "isAutoplay",
          get: function get() {
            return c.default.hasAttributeDefined(this._targetElement, "autoplay");
          }
        }, {
          key: "view",
          get: function get() {
            return this._targetElement;
          }
        }]), e;
      }();

      t.default = f;
    }, function (e, t) {
      e.exports = function (e, t, n, r) {
        if (!(e instanceof t) || void 0 !== r && r in e) throw TypeError(n + ": incorrect invocation!");
        return e;
      };
    }, function (e, t, n) {
      var r = n(39),
          i = n(10)("toStringTag"),
          o = "Arguments" == r(function () {
        return arguments;
      }()),
          a = function a(e, t) {
        try {
          return e[t];
        } catch (e) {}
      };

      e.exports = function (e) {
        var t, n, s;
        return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = a(t = Object(e), i)) ? n : o ? r(t) : "Object" == (s = r(t)) && "function" == typeof t.callee ? "Arguments" : s;
      };
    }, function (e, t) {
      e.exports = function (e) {
        if (void 0 == e) throw TypeError("Can't call method on  " + e);
        return e;
      };
    }, function (e, t) {
      e.exports = !0;
    }, function (e, t, n) {
      var r = n(17),
          i = n(185),
          o = n(68),
          a = n(74)("IE_PROTO"),
          s = function s() {},
          _u = function u() {
        var e,
            t = n(67)("iframe"),
            r = o.length;

        for (t.style.display = "none", n(105).appendChild(t), t.src = "javascript:", e = t.contentWindow.document, e.open(), e.write("<script>document.F=Object<\/script>"), e.close(), _u = e.F; r--;) {
          delete _u.prototype[o[r]];
        }

        return _u();
      };

      e.exports = Object.create || function (e, t) {
        var n;
        return null !== e ? (s.prototype = r(e), n = new s(), s.prototype = null, n[a] = e) : n = _u(), void 0 === t ? n : i(n, t);
      };
    }, function (e, t) {
      t.f = {}.propertyIsEnumerable;
    }, function (e, t, n) {
      var r = n(12),
          i = n(6),
          o = n(28);

      e.exports = function (e, t) {
        var n = (i.Object || {})[e] || Object[e],
            a = {};
        a[e] = t(n), r(r.S + r.F * o(function () {
          n(1);
        }), "Object", a);
      };
    }, function (e, t, n) {
      var r = n(22);

      e.exports = function (e, t, n) {
        for (var i in t) {
          n && e[i] ? e[i] = t[i] : r(e, i, t[i]);
        }

        return e;
      };
    }, function (e, t, n) {
      var r = n(76),
          i = Math.min;

      e.exports = function (e) {
        return e > 0 ? i(r(e), 9007199254740991) : 0;
      };
    }, function (e, t) {
      var n = 0,
          r = Math.random();

      e.exports = function (e) {
        return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + r).toString(36));
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.PublishModeTypes = t.PublishTypes = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.PublishTypes = (0, i.default)({
        RTMP: "rtmp",
        RTC: "rtc"
      }), t.PublishModeTypes = (0, i.default)({
        LIVE: "live",
        RECORD: "record",
        APPEND: "append"
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.IceTransportTypes = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.IceTransportTypes = (0, i.default)({
        UDP: "udp",
        TCP: "tcp"
      });
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(3),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(5),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(31),
          _ = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }(b),
          m = n(88),
          g = r(m),
          y = n(11),
          S = n(8),
          E = n(2),
          C = "R5ProWebRTCPeer",
          T = function (e) {
        function t(e, n) {
          (0, c.default)(this, t);
          var r = (0, f.default)(this, (t.__proto__ || (0, s.default)(t)).call(this, n || C));
          return r._responder = e, r._dataChannel = void 0, r._peerConnection = void 0, r._onDataChannelMessage = r._onDataChannelMessage.bind(r), r;
        }

        return (0, v.default)(t, e), (0, d.default)(t, [{
          key: "_removeDataChannelHandlers",
          value: function value(e) {
            e.onopen = void 0, e.onerror = void 0, e.onclose = void 0, e.onmessage = void 0;
          }
        }, {
          key: "_addDataChannelHandlers",
          value: function value(e) {
            var t = this;
            e.onerror = function (n) {
              t._responder.onDataChannelError(e, n.error.message);
            }, e.onmessage = this._onDataChannelMessage, e.onopen = function () {
              t._responder.onDataChannelOpen(e);
            }, e.onclose = function (n) {
              t._responder.onDataChannelClose(e), t.trigger(new y.MessageTransportStateEvent(y.MessageTransportStateEventTypes.CLOSE, t._name, {
                socket: t,
                event: n
              }));
            };
          }
        }, {
          key: "_removeConnectionHandlers",
          value: function value(e) {
            (0, E.warn)(this._name, "_removeConnectionHandlers is abstract.");
          }
        }, {
          key: "_addConnectionHandlers",
          value: function value(e, t) {
            (0, E.warn)(this._name, "_addConnectionHandlers is abstract.");
          }
        }, {
          key: "_onDataChannelMessage",
          value: function value(e) {
            var t = e;
            if (this.handleMessageResponse(t)) return !0;
            var n = this.getJsonFromSocketMessage(t);
            if (null === n) return (0, E.warn)(this._name, "Determined websocket response not in correct format. Aborting message handle."), !0;
            (0, E.debug)(this._name, "[datachannel-response]: " + (0, o.default)(n, null, 2));
            var r = n.data,
                i = n.method,
                a = n.type,
                s = n.id;
            if (r && r.message && "error" === r.type) return this._responder.onDataChannelError(this._dataChannel, r.message), !0;
            if (r && r.code && "error" === r.type) return this._responder.onDataChannelError(this._dataChannel, r.code), !0;
            if (i) return this._responder.onSendReceived(i, r), !0;
            if ("metadata" === a) return this._responder.onMetaData(r), !0;

            if (r && "status" === r.type) {
              if ("NetConnection.Connect.Closed" === r.code) return this._responder.onConnectionClosed(), !0;
              (0, E.debug)(C, "[datachannel.message] status :: " + r.code);
            } else if (n.async && s) {
              var u = this._asyncTickets.find(function (e) {
                return e.id === s;
              }),
                  c = u.promise;

              if (c && n.data) return c.resolve(n.data), !0;
              if (c && n.error) return c.reject(n.error), !0;
            }

            return !1;
          }
        }, {
          key: "setUp",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
            this.tearDown();
            var r = t || new S.DeferredPromise();

            try {
              var i = {
                iceServers: e,
                iceCandidatePoolSize: 2,
                bundlePolicy: "max-bundle"
              };
              void 0 !== n && (i.rtcpMuxPolicy = n), (0, E.debug)(C, "[peerconnection:setup]: " + (0, o.default)(i, null, 2));
              var a = new _.RTCPeerConnection(i, {
                optional: [{
                  RtpDataChannels: !1
                }, {
                  googCpuOveruseDetection: !0
                }]
              });
              this._addConnectionHandlers(a), this._peerConnection = a, r.resolve(a);
            } catch (e) {
              (0, E.warn)(C, "Could not establish a PeerConnection. " + e.message), r.reject(e.message);
            }

            return r.hasOwnProperty("promise") ? r.promise : r;
          }
        }, {
          key: "setUpWithPeerConfiguration",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
            this.tearDown();
            var r = n || new S.DeferredPromise();

            try {
              (0, E.debug)(C, "[peerconnection:setUpWithPeerConfiguration]: " + (0, o.default)(e, null, 2));
              var i = new _.RTCPeerConnection(e);
              t && (this._dataChannel = i.createDataChannel(t.name, {
                ordered: !0
              }), this._addDataChannelHandlers(this._dataChannel)), this._addConnectionHandlers(i), this._peerConnection = i, r.resolve(i);
            } catch (e) {
              (0, E.warn)(C, "Could not establish a PeerConnection. " + e.message), r.reject(e.message);
            }

            return r.hasOwnProperty("promise") ? r.promise : r;
          }
        }, {
          key: "tearDown",
          value: function value() {
            if (this._dataChannel) {
              this._removeDataChannelHandlers(this._dataChannel);

              try {
                this._dataChannel.close();
              } catch (e) {
                (0, E.warn)(C, "[datachannel.close] error: " + e.message);
              } finally {
                this._dataChannel = void 0;
              }
            }

            if (this._peerConnection) {
              (0, E.debug)(C, "[teardown]"), this._removeConnectionHandlers(this._peerConnection);

              try {
                this._peerConnection.close();
              } catch (e) {
                (0, E.warn)(C, "[peerconnection.close] error: " + e.message);
              } finally {
                this._peerConnection = void 0;
              }
            }
          }
        }, {
          key: "setLocalDescription",
          value: function value(e) {
            return (0, E.debug)(C, "[setlocaldescription]"), this._peerConnection.setLocalDescription(e);
          }
        }, {
          key: "setRemoteDescription",
          value: function value(e) {
            return (0, E.debug)(C, "[setremotedescription]"), this._peerConnection.setRemoteDescription(new _.RTCSessionDescription(e));
          }
        }, {
          key: "addIceCandidate",
          value: function value(e) {
            return (0, E.debug)(C, "[addcandidate]"), this._peerConnection.addIceCandidate(e);
          }
        }, {
          key: "post",
          value: function value(e) {
            if (this._dataChannel) {
              var t = "string" == typeof e ? e : (0, o.default)(e, null, 2);
              (0, E.debug)(C, "[datachannel.send] message: " + t);

              try {
                return this._dataChannel.send(t), !0;
              } catch (e) {
                (0, E.error)(C, e.hasOwnProperty("message") ? e.message : e);
              }
            }

            return !1;
          }
        }, {
          key: "connection",
          get: function get() {
            return this._peerConnection;
          }
        }, {
          key: "dataChannel",
          get: function get() {
            return this._dataChannel;
          }
        }]), t;
      }(g.default);

      t.default = T;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          o = r(i),
          a = n(1),
          s = r(a),
          u = n(7),
          c = r(u),
          l = n(2),
          d = "R5ProPublishView",
          h = "red5pro-publisher",
          f = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : h;
          (0, o.default)(this, e);

          try {
            this._targetElement = c.default.resolveElement(t);
          } catch (e) {
            throw (0, l.error)(d, "Could not instantiate a new instance of Red5ProPublisher. Reason: " + e.message), e;
          }
        }

        return (0, s.default)(e, [{
          key: "attachPublisher",
          value: function value(e) {
            (0, l.debug)(d, "[attachpublisher]"), e.setView(this, c.default.getElementId(this._targetElement));
          }
        }, {
          key: "preview",
          value: function value(e) {
            var t = this.isAutoplay;
            (0, l.debug)(d, "[preview]: autoplay(" + t + ")"), c.default.setVideoSource(this._targetElement, e, t);
          }
        }, {
          key: "unpreview",
          value: function value() {
            c.default.setVideoSource(this._targetElement, null, this.isAutoplay);
          }
        }, {
          key: "isAutoplay",
          get: function get() {
            return c.default.hasAttributeDefined(this._targetElement, "autoplay");
          }
        }, {
          key: "view",
          get: function get() {
            return this._targetElement;
          }
        }]), e;
      }();

      t.default = f;
    }, function (e, t, n) {
      e.exports = {
        default: n(168),
        __esModule: !0
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      t.__esModule = !0;
      var i = n(150),
          o = r(i),
          a = n(149),
          s = r(a),
          u = "function" == typeof s.default && "symbol" == typeof o.default ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof s.default && e.constructor === s.default && e !== s.default.prototype ? "symbol" : typeof e;
      };
      t.default = "function" == typeof s.default && "symbol" === u(o.default) ? function (e) {
        return void 0 === e ? "undefined" : u(e);
      } : function (e) {
        return e && "function" == typeof s.default && e.constructor === s.default && e !== s.default.prototype ? "symbol" : void 0 === e ? "undefined" : u(e);
      };
    }, function (e, t) {
      e.exports = function (e) {
        if ("function" != typeof e) throw TypeError(e + " is not a function!");
        return e;
      };
    }, function (e, t, n) {
      var r = n(20),
          i = n(69),
          o = n(35),
          a = n(56),
          s = n(177);

      e.exports = function (e, t) {
        var n = 1 == e,
            u = 2 == e,
            c = 3 == e,
            l = 4 == e,
            d = 6 == e,
            h = 5 == e || d,
            f = t || s;
        return function (t, s, p) {
          for (var v, b, _ = o(t), m = i(_), g = r(s, p, 3), y = a(m.length), S = 0, E = n ? f(t, y) : u ? f(t, 0) : void 0; y > S; S++) {
            if ((h || S in m) && (v = m[S], b = g(v, S, _), e)) if (n) E[S] = b;else if (b) switch (e) {
              case 3:
                return !0;

              case 5:
                return v;

              case 6:
                return S;

              case 2:
                E.push(v);
            } else if (l) return !1;
          }

          return d ? -1 : c || l ? l : E;
        };
      };
    }, function (e, t, n) {
      var r = n(13),
          i = n(12),
          o = n(33),
          a = n(28),
          s = n(22),
          u = n(55),
          c = n(40),
          l = n(48),
          d = n(14),
          h = n(42),
          f = n(15).f,
          p = n(65)(0),
          v = n(18);

      e.exports = function (e, t, n, b, _, m) {
        var g = r[e],
            y = g,
            S = _ ? "set" : "add",
            E = y && y.prototype,
            C = {};
        return v && "function" == typeof y && (m || E.forEach && !a(function () {
          new y().entries().next();
        })) ? (y = t(function (t, n) {
          l(t, y, e, "_c"), t._c = new g(), void 0 != n && c(n, _, t[S], t);
        }), p("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","), function (e) {
          var t = "add" == e || "set" == e;
          e in E && (!m || "clear" != e) && s(y.prototype, e, function (n, r) {
            if (l(this, y, e), !t && m && !d(n)) return "get" == e && void 0;

            var i = this._c[e](0 === n ? 0 : n, r);

            return t ? this : i;
          });
        }), "size" in E && f(y.prototype, "size", {
          get: function get() {
            return this._c.size;
          }
        })) : (y = b.getConstructor(t, e, _, S), u(y.prototype, n), o.NEED = !0), h(y, e), C[e] = y, i(i.G + i.W + i.F, C), m || b.setStrong(y, e, _), y;
      };
    }, function (e, t, n) {
      var r = n(14),
          i = n(13).document,
          o = r(i) && r(i.createElement);

      e.exports = function (e) {
        return o ? i.createElement(e) : {};
      };
    }, function (e, t) {
      e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    }, function (e, t, n) {
      var r = n(39);
      e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
        return "String" == r(e) ? e.split("") : Object(e);
      };
    }, function (e, t, n) {
      var r = n(51),
          i = n(12),
          o = n(73),
          a = n(22),
          s = n(21),
          u = n(32),
          c = n(182),
          l = n(42),
          d = n(114),
          h = n(10)("iterator"),
          f = !([].keys && "next" in [].keys()),
          p = function p() {
        return this;
      };

      e.exports = function (e, t, n, v, b, _, m) {
        c(n, t, v);

        var g,
            y,
            S,
            E = function E(e) {
          if (!f && e in k) return k[e];

          switch (e) {
            case "keys":
            case "values":
              return function () {
                return new n(this, e);
              };
          }

          return function () {
            return new n(this, e);
          };
        },
            C = t + " Iterator",
            T = "values" == b,
            w = !1,
            k = e.prototype,
            P = k[h] || k["@@iterator"] || b && k[b],
            O = P || E(b),
            R = b ? T ? E("entries") : O : void 0,
            A = "Array" == t ? k.entries || P : P;

        if (A && (S = d(A.call(new e()))) !== Object.prototype && (l(S, C, !0), r || s(S, h) || a(S, h, p)), T && P && "values" !== P.name && (w = !0, O = function O() {
          return P.call(this);
        }), r && !m || !f && !w && k[h] || a(k, h, O), u[t] = O, u[C] = p, b) if (g = {
          values: T ? O : E("values"),
          keys: _ ? O : E("keys"),
          entries: R
        }, m) for (y in g) {
          y in k || o(k, y, g[y]);
        } else i(i.P + i.F * (f || w), t, g);
        return g;
      };
    }, function (e, t, n) {
      var r = n(53),
          i = n(41),
          o = n(23),
          a = n(77),
          s = n(21),
          u = n(106),
          c = Object.getOwnPropertyDescriptor;
      t.f = n(18) ? c : function (e, t) {
        if (e = o(e), t = a(t, !0), u) try {
          return c(e, t);
        } catch (e) {}
        if (s(e, t)) return i(!r.f.call(e, t), e[t]);
      };
    }, function (e, t) {
      t.f = Object.getOwnPropertySymbols;
    }, function (e, t, n) {
      e.exports = n(22);
    }, function (e, t, n) {
      var r = n(75)("keys"),
          i = n(57);

      e.exports = function (e) {
        return r[e] || (r[e] = i(e));
      };
    }, function (e, t, n) {
      var r = n(13),
          i = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});

      e.exports = function (e) {
        return i[e] || (i[e] = {});
      };
    }, function (e, t) {
      var n = Math.ceil,
          r = Math.floor;

      e.exports = function (e) {
        return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e);
      };
    }, function (e, t, n) {
      var r = n(14);

      e.exports = function (e, t) {
        if (!r(e)) return e;
        var n, i;
        if (t && "function" == typeof (n = e.toString) && !r(i = n.call(e))) return i;
        if ("function" == typeof (n = e.valueOf) && !r(i = n.call(e))) return i;
        if (!t && "function" == typeof (n = e.toString) && !r(i = n.call(e))) return i;
        throw TypeError("Can't convert object to primitive value");
      };
    }, function (e, t, n) {
      var r = n(13),
          i = n(6),
          o = n(51),
          a = n(79),
          s = n(15).f;

      e.exports = function (e) {
        var t = i.Symbol || (i.Symbol = o ? {} : r.Symbol || {});
        "_" == e.charAt(0) || e in t || s(t, e, {
          value: a.f(e)
        });
      };
    }, function (e, t, n) {
      t.f = n(10);
    }, function (e, t, n) {
      var r = n(49),
          i = n(10)("iterator"),
          o = n(32);

      e.exports = n(6).getIteratorMethod = function (e) {
        if (void 0 != e) return e[i] || e["@@iterator"] || o[r(e)];
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.embedSwfObject = t.defineEmbedElement = void 0;

      var r = n(7),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r),
          o = n(8);

      t.defineEmbedElement = function (e, t) {
        var n = new o.DeferredPromise(),
            r = e.id;

        if ("video" === e.nodeName.toLowerCase()) {
          var a = i.default.createElement("div");
          a.id = r + "_rtmp", t.appendChild(a), e.parentElement && e.parentElement.removeChild(e), n.resolve(a.id);
        } else n.resolve(r);

        return n.promise;
      }, t.embedSwfObject = function (e, t, n, r, i) {
        var a = new o.DeferredPromise(),
            s = {
          quality: "high",
          wmode: "opaque",
          bgcolor: t.backgroundColor || "#000",
          allowscriptaccess: "always",
          allowfullscreen: "true",
          allownetworking: "all"
        },
            u = {
          id: e,
          name: e,
          align: "middle"
        };
        return r.hasFlashPlayerVersion(t.minFlashVersion) ? r.embedSWF(t.swf, i, t.embedWidth || 640, t.embedHeight || 480, t.minFlashVersion, t.productInstallURL, n, s, u, function (e) {
          e.success ? a.resolve() : a.reject("Flash Object embed failed.");
        }) : a.reject("Flash Player Version is not supported."), a.promise;
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.applyOrientation = void 0;

      var r = n(7),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r),
          o = i.default.requestFrame,
          a = ["webkitTransformOrigin", "mozTransformOrigin", "msTransformOrigin", "oTransformOrigin", "transformOrigin"],
          s = ["webkitTransform", "mozTransform", "msTransform", "oTransform", "transform"],
          u = ["webkitTransition", "mozTransition", "msTransition", "oTransition", "transition"],
          c = {
        0: {
          origin: "center center",
          transform: "rotate(0deg)"
        },
        90: {
          origin: "left top",
          transform: "rotate(90deg) translateY(-100%)"
        },
        180: {
          origin: "center center",
          transform: "rotate(180deg)"
        },
        270: {
          origin: "top left",
          transform: "rotate(270deg) translateX(-100%) translateY(0%)"
        },
        "-90": {
          origin: "left top",
          transform: "rotate(-90deg) translateX(-100%)"
        },
        "-180": {
          origin: "center center",
          transform: "rotate(-180deg)"
        },
        "-270": {
          origin: "top left",
          transform: "rotate(-270deg) translateY(-100%)"
        }
      },
          l = function e(t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return function () {
          var i = t.parentNode;

          if (i) {
            var o = i.clientWidth,
                a = i.clientHeight;
            t.style.width = r ? a + "px" : o + "px";
            var s = t.clientWidth,
                u = t.clientHeight,
                c = .5 * (r ? o - u : o - s);
            t.style.position = "relative", t.style.left = c + "px";
          }

          n && n(e(t, n, r));
        };
      };

      t.applyOrientation = function (e, t, n) {
        var r = void 0,
            i = s.length;
        t %= 360;
        var d = t % 180 != 0,
            h = e.parentNode,
            f = e.width ? e.width : h.clientWidth,
            p = e.height ? e.height : h.clientHeight,
            v = c[t.toString()];

        for (r = 0; r < i; r++) {
          e.style[a[r]] = v.origin, e.style[s[r]] = v.transform, e.style[u[r]] = "transform 0.0s linear";
        }

        d ? (e.style.width = p + "px", h.style.height = p + "px") : (e.style.width = f + "px", e.style.height = p + "px", h.style.height = "unset"), document.attachEvent ? h.attachEvent("resize", l(e, o, d)) : l(e, o, d)();
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.MessageTransportStateEventTypes = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.MessageTransportStateEventTypes = (0, i.default)({
        OPEN: "MessageTransport.Open",
        CLOSE: "MessageTransport.Close",
        CHANGE: "MessageTransport.Change",
        ERROR: "MessageTransport.Error"
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RTCConferenceParticipantEventTypes = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.RTCConferenceParticipantEventTypes = (0, i.default)({
        AUDIO_STREAM: "Conference.AudioStream",
        VIDEO_STREAM: "Conference.VideoStream",
        MEDIA_STREAM: "Conference.MediaStream"
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RTMPPublisherEventTypes = t.RTCPublisherEventTypes = t.FailoverPublisherEventTypes = t.PublisherEventTypes = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.PublisherEventTypes = (0, i.default)({
        CONNECT_SUCCESS: "Connect.Success",
        CONNECT_FAILURE: "Connect.Failure",
        PUBLISH_START: "Publish.Start",
        PUBLISH_FAIL: "Publish.Fail",
        PUBLISH_INVALID_NAME: "Publish.InvalidName",
        UNPUBLISH_SUCCESS: "Unpublish.Success",
        PUBLISH_METADATA: "Publish.Metadata",
        PUBLISH_STATUS: "Publish.Status",
        PUBLISH_AVAILABLE: "Publish.Available",
        PUBLISH_INSUFFICIENT_BANDWIDTH: "Publish.InsufficientBW",
        PUBLISH_SUFFICIENT_BANDWIDTH: "Publish.SufficientBW",
        PUBLISH_RECOVERING_BANDWIDTH: "Publish.RecoveringBW",
        PUBLISH_SEND_INVOKE: "Publish.Send.Invoke",
        CONNECTION_CLOSED: "Publisher.Connection.Closed",
        DIMENSION_CHANGE: "Publisher.Video.DimensionChange"
      }), t.FailoverPublisherEventTypes = (0, i.default)({
        PUBLISHER_REJECT: "Publisher.Reject",
        PUBLISHER_ACCEPT: "Publisher.Accept"
      }), t.RTCPublisherEventTypes = (0, i.default)({
        CONSTRAINTS_ACCEPTED: "WebRTC.MediaConstraints.Accepted",
        CONSTRAINTS_REJECTED: "WebRTC.MediaConstraints.Rejected",
        MEDIA_STREAM_AVAILABLE: "WebRTC.MediaStream.Available",
        PEER_CONNECTION_AVAILABLE: "WebRTC.PeerConnection.Available",
        OFFER_START: "WebRTC.Offer.Start",
        OFFER_END: "WebRTC.Offer.End",
        PEER_CANDIDATE_END: "WebRTC.PeerConnection.CandidateEnd",
        ICE_TRICKLE_COMPLETE: "WebRTC.IceTrickle.Complete",
        SOCKET_MESSAGE: "WebRTC.Socket.Message",
        DATA_CHANNEL_OPEN: "WebRTC.DataChannel.Open",
        DATA_CHANNEL_AVAILABLE: "WebRTC.DataChannel.Available",
        DATA_CHANNEL_CLOSE: "WebRTC.DataChannel.Close",
        DATA_CHANNEL_MESSAGE: "WebRTC.DataChannel.Message",
        DATA_CHANNEL_ERROR: "WebRTC.DataChannel.Error",
        PEER_CONNECTION_OPEN: "WebRTC.PeerConnection.Open",
        TRACK_ADDED: "WebRTC.PeerConnection.OnTrack"
      }), t.RTMPPublisherEventTypes = (0, i.default)({
        EMBED_SUCCESS: "FlashPlayer.Embed.Success",
        EMBED_FAILURE: "FlashPlayer.Embed.Failure"
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.SharedObjectEventTypes = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.SharedObjectEventTypes = (0, i.default)({
        CONNECT_SUCCESS: "Connect.Success",
        CONNECT_FAILURE: "Connect.Failure",
        PROPERTY_UPDATE: "SharedObject.PropertyUpdate",
        PROPERTY_REMOVE: "SharedObject.PropertyRemove",
        METHOD_UPDATE: "SharedObject.MethodUpdate",
        CONNECTION_CLOSED: "SharedObject.Connection.Closed"
      });
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RTMPSubscriberEventTypes = t.RTCSubscriberEventTypes = t.FailoverSubscriberEventTypes = t.SubscriberEventTypes = void 0;

      var r = n(16),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.SubscriberEventTypes = (0, i.default)({
        CONNECT_SUCCESS: "Connect.Success",
        CONNECT_FAILURE: "Connect.Failure",
        SUBSCRIBE_START: "Subscribe.Start",
        SUBSCRIBE_STOP: "Subscribe.Stop",
        SUBSCRIBE_FAIL: "Subscribe.Fail",
        SUBSCRIBE_INVALID_NAME: "Subscribe.InvalidName",
        SUBSCRIBE_METADATA: "Subscribe.Metadata",
        SUBSCRIBE_STATUS: "Subscribe.Status",
        SUBSCRIBE_SEND_INVOKE: "Subscribe.Send.Invoke",
        SUBSCRIBE_PUBLISHER_CONGESTION: "Subscribe.Publisher.NetworkCongestion",
        SUBSCRIBE_PUBLISHER_RECOVERY: "Subscribe.Publisher.NetworkRecovery",
        PLAY_UNPUBLISH: "Subscribe.Play.Unpublish",
        CONNECTION_CLOSED: "Subscribe.Connection.Closed",
        ORIENTATION_CHANGE: "Subscribe.Orientation.Change",
        STREAMING_MODE_CHANGE: "Subscribe.StreamingMode.Change",
        VIDEO_DIMENSIONS_CHANGE: "Subscribe.VideoDimensions.Change",
        VOLUME_CHANGE: "Subscribe.Volume.Change",
        PLAYBACK_TIME_UPDATE: "Subscribe.Time.Update",
        PLAYBACK_STATE_CHANGE: "Subscribe.Playback.Change",
        FULL_SCREEN_STATE_CHANGE: "Subscribe.FullScreen.Change",
        AUTO_PLAYBACK_FAILURE: "Subscribe.Autoplay.Failure",
        AUTO_PLAYBACK_MUTED: "Subscribe.Autoplay.Muted"
      }), t.FailoverSubscriberEventTypes = (0, i.default)({
        SUBSCRIBER_REJECT: "Subscriber.Reject",
        SUBSCRIBER_ACCEPT: "Subscriber.Accept"
      }), t.RTCSubscriberEventTypes = (0, i.default)({
        PEER_CONNECTION_AVAILABLE: "WebRTC.PeerConnection.Available",
        OFFER_START: "WebRTC.Offer.Start",
        OFFER_END: "WebRTC.Offer.End",
        ANSWER_START: "WebRTC.Answer.Start",
        ANSWER_END: "WebRTC.Answer.End",
        CANDIDATE_START: "WebRTC.Candidate.Start",
        CANDIDATE_END: "WebRTC.Candidate.End",
        PEER_CANDIDATE_END: "WebRTC.PeerConnection.CandidateEnd",
        ICE_TRICKLE_COMPLETE: "WebRTC.IceTrickle.Complete",
        SOCKET_MESSAGE: "WebRTC.Socket.Message",
        DATA_CHANNEL_MESSAGE: "WebRTC.DataChannel.Message",
        DATA_CHANNEL_OPEN: "WebRTC.DataChannel.Open",
        DATA_CHANNEL_AVAILABLE: "WebRTC.DataChannel.Available",
        DATA_CHANNEL_CLOSE: "WebRTC.DataChannel.Close",
        DATA_CHANNEL_ERROR: "WebRTC.DataChannel.Error",
        PEER_CONNECTION_OPEN: "WebRTC.PeerConnection.Open",
        ON_ADD_STREAM: "WebRTC.Add.Stream"
      }), t.RTMPSubscriberEventTypes = (0, i.default)({
        EMBED_SUCCESS: "FlashPlayer.Embed.Success",
        EMBED_FAILURE: "FlashPlayer.Embed.Failure",
        ABR_LEVEL_CHANGE: "RTMP.AdaptiveBitrate.Level"
      });
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(3),
          o = r(i),
          a = n(0),
          s = r(a),
          u = n(1),
          c = r(u),
          l = n(5),
          d = r(l),
          h = n(4),
          f = r(h),
          p = n(19),
          v = r(p),
          b = n(8),
          _ = n(2),
          m = "MessageTransport",
          g = function (e) {
        function t(e) {
          (0, s.default)(this, t);
          var n = (0, d.default)(this, (t.__proto__ || (0, o.default)(t)).call(this));
          return n._name = e || m, n._responseHandlers = [], n._asyncTickets = [], n;
        }

        return (0, f.default)(t, e), (0, c.default)(t, [{
          key: "getJsonFromSocketMessage",
          value: function value(e) {
            try {
              return "string" == typeof e.data ? JSON.parse(e.data) : e.data;
            } catch (t) {
              (0, _.warn)(this._name, "Could not parse message as JSON. Message= " + e.data + ". Error= " + t.message);
            }

            return null;
          }
        }, {
          key: "addResponseHandler",
          value: function value(e) {
            this._responseHandlers.push(e);
          }
        }, {
          key: "respond",
          value: function value(e) {
            (0, _.warn)(this._name, "respond() should be overriden.");
          }
        }, {
          key: "post",
          value: function value(e) {
            (0, _.warn)(this._name, "post() should be overriden.");
          }
        }, {
          key: "postAsync",
          value: function value(e) {
            var t = new b.DeferredPromise(),
                n = Math.floor(65536 * Math.random()).toString(16);
            return e.id = n, e.async = !0, this._asyncTickets.push({
              id: n,
              promise: t
            }), this.post(e), t.promise;
          }
        }, {
          key: "addSharedObjectResponseHandler",
          value: function value(e) {
            this._responseHandlers.push(e);
          }
        }, {
          key: "removeSharedObjectResponseHandler",
          value: function value(e) {
            for (var t = this._responseHandlers.length; --t > -1;) {
              if (this._responseHandlers[t] === e) return void this._responseHandlers.splice(t, 1);
            }
          }
        }, {
          key: "handleMessageResponse",
          value: function value(e) {
            var t = void 0,
                n = void 0,
                r = this._responseHandlers.length;

            for (t = 0; t < r; t++) {
              if (n = this._responseHandlers[t], n.respond(e)) return !0;
            }

            return !1;
          }
        }, {
          key: "getRemoteSharedObject",
          value: function value(e) {
            this.post({
              sharedObjectGetRemote: {
                name: e
              }
            });
          }
        }, {
          key: "connectToSharedObject",
          value: function value(e) {
            this.post({
              sharedObjectConnect: {
                name: e
              }
            });
          }
        }, {
          key: "sendToSharedObject",
          value: function value(e, t, n) {
            this.post({
              sharedObjectSend: {
                name: e,
                method: t,
                message: n
              }
            });
          }
        }, {
          key: "sendPropertyToSharedObject",
          value: function value(e, t, n) {
            this.post({
              sharedObjectSetProperty: {
                name: e,
                key: t,
                value: n
              }
            });
          }
        }, {
          key: "closeSharedObject",
          value: function value(e) {
            this.post({
              sharedObjectClose: {
                name: e
              }
            });
          }
        }]), t;
      }(v.default);

      t.default = g;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(0),
          s = r(a),
          u = n(1),
          c = r(u),
          l = n(7),
          d = r(l),
          h = n(2),
          f = "R5ProRTMPSharedObjectHandler",
          p = function () {
        function e() {
          (0, s.default)(this, e), this._element = void 0, this._responseHandlers = [];
        }

        return (0, c.default)(e, [{
          key: "addResponseHandler",
          value: function value(e) {
            this._responseHandlers.push(e);
          }
        }, {
          key: "removeResponseHandler",
          value: function value(e) {
            for (var t = this._responseHandlers.length; --t > -1;) {
              if (this._responseHandlers[t] === e) return void this._responseHandlers.splice(t, 1);
            }
          }
        }, {
          key: "handleSharedObjectEvent",
          value: function value(e) {
            (0, h.debug)(f, "[sharedobject:event]");
            var t = void 0,
                n = this._responseHandlers.length,
                r = void 0;

            for (t = 0; t < n && (r = this._responseHandlers[t], !r.respond(JSON.parse(e))); t++) {
              ;
            }
          }
        }, {
          key: "assignSharedObjectResponder",
          value: function value(e, t) {
            var n = this.handleSharedObjectEvent.bind(this),
                r = t.id.split("-").join("_"),
                i = ["handleSharedObjectEvent", r].join("_");
            (0, h.debug)(f, "[assign:sharedobject:responder] :: " + r), (0, h.debug)(f, "[sharedoject:responder] :: " + i), t.setSharedObjectResponder(e, i), d.default.setGlobal(i, n);
          }
        }, {
          key: "connect",
          value: function value(e) {
            this._element = d.default.getEmbedObject(e), this._element || (0, h.warn)("Could not locate embedded Flash object for id: " + e);
          }
        }, {
          key: "disconnect",
          value: function value() {
            for (; this._responseHandlers.length > 0;) {
              this._responseHandlers.shift();
            }
          }
        }, {
          key: "sendToSharedObject",
          value: function value(e, t, n) {
            (0, h.debug)(f, "[sendToSharedObject]");

            try {
              this._element.sharedObjectSend(e, t, "string" == typeof n ? n : (0, o.default)(n));
            } catch (t) {
              (0, h.warn)("Could not send to shared object (" + e + "). Error: " + t.message);
            }
          }
        }, {
          key: "sendPropertyToSharedObject",
          value: function value(e, t, n) {
            (0, h.debug)(f, "[sendPropertyToSharedObject]");

            try {
              this._element.sharedObjectSendProperty(e, t, n);
            } catch (t) {
              (0, h.warn)("Could not send to shared object (" + e + "). Error: " + t.message);
            }
          }
        }, {
          key: "getRemoteSharedObject",
          value: function value(e) {
            (0, h.debug)(f, "[getRemoteSharedObject]");

            try {
              this.assignSharedObjectResponder(e, this._element), this._element.getRemoteSharedObject(e);
            } catch (e) {
              (0, h.warn)("Could not get remote shared object (" + name + "). Error: " + e.message);
            }
          }
        }, {
          key: "connectToSharedObject",
          value: function value(e) {
            (0, h.debug)(f, "[connectToSharedObject]");

            try {
              this._element.connectToSharedObject(e);
            } catch (e) {
              (0, h.warn)("Could not connect to shared object (" + name + "). Error: " + e.message);
            }
          }
        }, {
          key: "closeSharedObject",
          value: function value(e) {
            (0, h.debug)(f, "[disconnectToSharedObject]");

            try {
              this._element.disconnectFromSharedObject(e);
            } catch (e) {
              (0, h.warn)("Could not disconnect to shared object (" + name + "). Error: " + e.message);
            }
          }
        }]), e;
      }();

      t.default = p;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RTMPMediaConstraint = t.RTCMediaConstraint = void 0;

      var i = n(0),
          o = r(i),
          a = n(98),
          s = r(a),
          u = function u(e, t, n) {
        (0, s.default)(e, t, {
          value: n,
          writable: !0,
          enumerable: !0
        });
      },
          c = function e() {
        (0, o.default)(this, e), u(this, "width", {
          exact: 640
        }), u(this, "height", {
          exact: 480
        });
      },
          l = function e() {
        (0, o.default)(this, e), u(this, "width", 640), u(this, "height", 480), u(this, "force", !1), u(this, "framerate", 15), u(this, "bandwidth", 5e4), u(this, "quality", 80), u(this, "profile", "baseline"), u(this, "level", 3.1);
      },
          d = function e() {
        var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        (0, o.default)(this, e), u(this, "audio", t), u(this, "video", n || new c());
      },
          h = function e() {
        var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        (0, o.default)(this, e), u(this, "audio", t), u(this, "video", n || new l());
      };

      t.RTCMediaConstraint = d, t.RTMPMediaConstraint = h;
    }, function (e, t, n) {
      function r(e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }

      function i(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(38),
          a = i(o),
          s = n(62),
          u = i(s),
          c = n(26),
          l = i(c),
          d = n(9),
          h = i(d),
          f = n(3),
          p = i(f),
          v = n(0),
          b = i(v),
          _ = n(1),
          m = i(_),
          g = n(5),
          y = i(g),
          S = n(4),
          E = i(S),
          C = n(19),
          T = i(C),
          w = n(31),
          k = r(w),
          P = n(44),
          O = r(P),
          R = n(7),
          A = i(R),
          M = n(122),
          N = i(M),
          I = n(124),
          L = i(I),
          j = n(61),
          D = i(j),
          H = n(11),
          F = n(58),
          U = n(59),
          x = n(8),
          B = n(90),
          V = n(46),
          G = n(2),
          W = /(.*) starting/i,
          z = /(.*) stopping/i,
          q = "RTCPublisher",
          Y = function Y(e) {
        (0, G.debug)(q, e);
      },
          K = function K(e) {
        (0, G.warn)(q, e);
      },
          J = function J(e) {
        (0, G.error)(q, e);
      },
          X = {
        protocol: "wss",
        port: 443,
        app: "live",
        streamMode: F.PublishModeTypes.LIVE,
        keyFramerate: 3e3,
        mediaElementId: "red5pro-publisher",
        rtcConfiguration: {
          iceServers: [{
            urls: "stun:stun2.l.google.com:19302"
          }],
          iceCandidatePoolSize: 2,
          bundlePolicy: "max-bundle"
        },
        iceServers: void 0,
        iceTransport: U.IceTransportTypes.UDP,
        bandwidth: {
          audio: 56,
          video: 512
        },
        clearMediaOnUnpublish: !1,
        mediaConstraints: new B.RTCMediaConstraint(),
        onGetUserMedia: void 0,
        signalingSocketOnly: !0,
        dataChannelConfiguration: void 0,
        forceVP8: !1,
        socketSwitchDelay: 1e3,
        bypassAvailable: !1
      },
          Q = function Q(e) {
        var t = {
          audio: !1,
          video: !1
        },
            n = {
          audio: !1,
          video: !1
        };
        return e.getTracks().forEach(function (e) {
          "video" === e.kind ? (n.video = e.getSettings(), t.video = e.getConstraints()) : "audio" === e.kind && (n.audio = e.getSettings(), t.audio = e.getConstraints());
        }), {
          requested: t,
          accepted: n
        };
      },
          $ = function (e) {
        function t() {
          (0, b.default)(this, t);
          var e = (0, y.default)(this, (t.__proto__ || (0, p.default)(t)).call(this));
          return e._options = void 0, e._view = void 0, e._peerHelper = void 0, e._socketHelper = void 0, e._messageTransport = void 0, e._mediaStream = void 0, e._switchChannelRequest = void 0, e._streamFuture = void 0, e._availableFuture = void 0, e._peerFuture = void 0, e._offerFuture = void 0, e._sendOfferFuture = void 0, e._trickleEndFuture = void 0, e._publishFuture = void 0, e._unpublishFuture = void 0, e._onOrientationChange = e._onOrientationChange.bind(e), e._gUMRejectionHandler = e._onGUMRejection.bind(e), e;
        }

        return (0, E.default)(t, e), (0, m.default)(t, [{
          key: "_getMediaStream",
          value: function value() {
            return this._streamFuture = x.Future.createIfNotExist(this._streamFuture), this._streamFuture.promise;
          }
        }, {
          key: "_getTrickleEnd",
          value: function value() {
            return x.Future.createIfNotExist(this._trickleEndFuture);
          }
        }, {
          key: "_gum",
          value: function value(e) {
            var t = this,
                n = function n(e) {
              if (!e) return !1;
              var t = e.getTracks();
              return !!(t && t.length > 1) && "video" === t[0].kind;
            };

            void 0 !== e.onGetUserMedia ? (Y("Requesting gUM from user-defined configuration:onGetUserMedia."), e.onGetUserMedia().then(function (r) {
              if (n(r)) return Y("We received a MediaStream with mismatching track listing. Trying again..."), void t._gum(e);
              t.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.CONSTRAINTS_ACCEPTED, t, Q(r))), t._streamFuture.resolve(r);
            }).catch(function (n) {
              J("Could not resolve MediaStream from provided gUM. Error - " + n), t.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.CONSTRAINTS_REJECTED, t, {
                constraints: e.mediaConstraints
              })), t._streamFuture.reject(n);
            })) : (Y("Requesting gUM using mediaConstraints: " + (0, h.default)(e.mediaConstraints, null, 2)), this._peerHelper.getUserMedia(e.mediaConstraints, this._gUMRejectionHandler).then(function (r) {
              if (n(r.media)) return Y("We received a MediaStream with mismatching track listing. Trying again..."), void t._gum(e);
              Y("Found valid constraints: " + (0, h.default)(r.constraints, null, 2)), t.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.CONSTRAINTS_ACCEPTED, t, Q(r.media))), t.trigger(new H.PublisherEvent(H.PublisherEventTypes.DIMENSION_CHANGE, t, r.constraints)), t._streamFuture.resolve(r.media);
            }).catch(function (n) {
              Y("Could not find valid constraint resolutions from: " + (0, h.default)(n.constraints, null, 2)), J("Could not resolve MediaStream from provided mediaConstraints. Error - " + n.error), Y("Attempting to find resolutions from original provided constraints: " + (0, h.default)(n.constraints, null, 2)), t.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.CONSTRAINTS_REJECTED, t, {
                constraints: n.constraints
              })), e.onGetUserMedia = function () {
                return t._peerHelper.forceUserMedia(n.constraints);
              }, t._gum(e);
            }));
          }
        }, {
          key: "_onGUMRejection",
          value: function value(e) {
            this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.CONSTRAINTS_REJECTED, this, {
              constraints: e
            }));
          }
        }, {
          key: "_onOrientationChange",
          value: function value(e) {
            this.getMessageTransport() && this.getMessageTransport().post({
              send: {
                method: "onMetaData",
                data: {
                  deviceOrientation: e
                }
              }
            });
          }
        }, {
          key: "_onMediaStreamReceived",
          value: function value(e) {
            this._mediaStream = e, this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.MEDIA_STREAM_AVAILABLE, this, e)), this._view && this._view.preview(this._mediaStream);
          }
        }, {
          key: "_setViewIfNotExist",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;

            if (void 0 === e && void 0 !== t) {
              new D.default(t).attachPublisher(this);
            }
          }
        }, {
          key: "_requestAvailability",
          value: function value(e) {
            return Y("[requestavailability]"), this._availableFuture = x.Future.createIfNotExist(this._availableFuture), this._options.bypassAvailable ? this._availableFuture.resolve(!0) : this._socketHelper.post({
              isAvailable: e,
              bundle: !0
            }), this._availableFuture.promise;
          }
        }, {
          key: "_createPeerConnection",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
            Y("[createpeeer]"), this._peerFuture = void 0, this._peerFuture = x.Future.createIfNotExist(this._peerFuture), n && e && (K("The iceServers configuration property is considered deprecated. Please use the rtcConfiguration configuration property upon which you can assign iceServers. Reference: https://www.red5pro.com/docs/streaming/migrationguide.html"), e.iceServers = n);
            return void 0 !== e ? this._peerHelper.setUpWithPeerConfiguration(e, t, this._peerFuture) : this._peerHelper.setUp(n, this._peerFuture, this._options.rtcpMuxPolicy);
          }
        }, {
          key: "_createOffer",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return Y("[createoffer]"), this._offerFuture = void 0, this._offerFuture = x.Future.createIfNotExist(this._offerFuture), this._peerHelper.createOffer(e, t, !1, this._offerFuture), this._offerFuture.promise;
          }
        }, {
          key: "_setRemoteDescription",
          value: function value(e) {
            return Y("[setremotedescription]"), this._peerHelper.setRemoteDescription(e);
          }
        }, {
          key: "_sendOffer",
          value: function value(e, t, n) {
            return Y("[sendoffer]"), this._sendOfferFuture = void 0, this._sendOfferFuture = x.Future.createIfNotExist(this._sendOffFuture), this._socketHelper.post({
              handleOffer: t,
              transport: n,
              data: {
                sdp: e
              }
            }), this._sendOfferFuture.promise;
          }
        }, {
          key: "_sendCandidate",
          value: function value(e, t) {
            Y("[sendcandidate]"), this._socketHelper.post({
              handleCandidate: t,
              data: {
                candidate: e
              }
            });
          }
        }, {
          key: "_requestPublish",
          value: function value(e, t, n) {
            return Y("[requestpublish]"), this._publishFuture = void 0, this._publishFuture = x.Future.createIfNotExist(this._publishFuture), this._socketHelper.post({
              publish: e,
              mode: t,
              keyFramerate: n
            }), this._publishFuture.promise;
          }
        }, {
          key: "_requestUnpublish",
          value: function value(e) {
            return this._unpublishFuture = void 0, this._unpublishFuture = x.Future.createIfNotExist(this._unpublishFuture), this.getMessageTransport().postUnpublish(e) || this._unpublishFuture.resolve(), this._unpublishFuture.promise;
          }
        }, {
          key: "init",
          value: function value(e) {
            this._streamFuture = void 0;
            var t = new x.DeferredPromise();
            return k.isSupported() && O.isSupported() ? (this._options = (0, l.default)({}, X, e), this._peerHelper = new L.default(this), this._socketHelper = new N.default(this), this._messageTransport = this._socketHelper, this._getMediaStream().then(this._onMediaStreamReceived.bind(this)).catch(function (e) {
              K("[gum]: " + e);
            }), this._gum(this._options), this._setViewIfNotExist(this._view, this._options.mediaElementId), t.resolve(this)) : t.reject("Cannot create WebRTC playback instance. Your environment does not support WebRTC and/or WebSockets."), t.promise;
          }
        }, {
          key: "initWithStream",
          value: function value(e, t) {
            Y("[initWithStream]"), this._streamFuture = void 0;
            var n = new x.DeferredPromise();

            if (k.isSupported() && O.isSupported()) {
              this._options = (0, l.default)({}, X, e), this._peerHelper = new L.default(this), this._socketHelper = new N.default(this), this._messageTransport = this._socketHelper, this._setViewIfNotExist(this._view, this._options.mediaElementId);
              this._getMediaStream().then(this._onMediaStreamReceived.bind(this)).catch(function (e) {
                K("[gum]: " + e);
              }), this._streamFuture.resolve(t), n.resolve(this);
            } else n.reject("Cannot create WebRTC playback instance. Your environment does not support WebRTC and/or WebSockets.");

            return n.promise;
          }
        }, {
          key: "setView",
          value: function value(e) {
            return this._view = e, this._mediaStream && this._view && this._view.preview(this._mediaStream), this;
          }
        }, {
          key: "preview",
          value: function value() {
            var e = this;
            Y("[preview]");
            var t = new u.default(function (t) {
              t(e);
            });
            return this._setViewIfNotExist(this._view, this._options.mediaElementId), t;
          }
        }, {
          key: "unpreview",
          value: function value() {
            Y("[unpreview]"), this._mediaStream && this._mediaStream.getTracks().forEach(function (e) {
              e.stop();
            }), this._view && this._view.unpreview();
          }
        }, {
          key: "publish",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            Y("[publish]"), this._options.streamName = t || this._options.streamName;
            var r = n || new x.DeferredPromise(),
                i = new x.DeferredPromise(),
                o = (0, V.rtcSocketEndpointFromOptions)(this._options, {
              id: this._options.streamName
            });
            this._trickleEndFuture = this._getTrickleEnd(), this._peerHelper || (this._peerHelper = new L.default(this)), this._socketHelper ? this._socketHelper.clearRetry() : (this._socketHelper = new N.default(this), this._messageTransport = this._socketHelper), this._socketHelper.setUp(o, i);
            var a = this._options,
                s = a.rtcConfiguration,
                u = a.signalingSocketOnly,
                c = a.dataChannelConfiguration,
                l = u && k.supportsDataChannel();
            return l && !c && (c = {
              name: "red5pro"
            }), this._options.signalingSocketOnly = l, this._publishFuture = x.Future.createIfNotExist(this._publishFuture), this._publishFuture.promise.catch(function (t) {
              A.default.removeOrientationChangeHandler(e._onOrientationChange), r.reject(t), e.trigger(new H.PublisherEvent(H.PublisherEventTypes.CONNECT_FAILURE, e, t));
            }), i.promise.then(function () {
              return e.trigger(new H.PublisherEvent(H.PublisherEventTypes.CONNECT_SUCCESS, e)), e._getMediaStream();
            }).then(function () {
              return e._requestAvailability(e._options.streamName, e._options.streamType);
            }).then(function () {
              return e._createPeerConnection(s, c, e._options.iceServers);
            }).then(function (t) {
              return e.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.PEER_CONNECTION_AVAILABLE, e, t)), e._mediaStream.getTracks().forEach(function (n) {
                t.addTrack(n, e._mediaStream);
              }), e._createOffer(e._options.bandwidth, e._options.forceVP8);
            }).then(function (t) {
              return e.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.OFFER_START, e, t)), e._sendOffer(t, e._options.streamName, e._options.iceTransport);
            }).then(function (t) {
              return e._setRemoteDescription(t.sdp);
            }).then(function (t) {
              return e.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.OFFER_END, e, t)), e._getTrickleEnd().promise;
            }).then(function () {
              return e.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.ICE_TRICKLE_COMPLETE, e)), e._requestPublish(e._options.streamName, e._options.streamMode, e._options.keyFramerate);
            }).then(function () {
              A.default.addOrientationChangeHandler(e._onOrientationChange), r.resolve(e), e.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_START, e));
            }).catch(function (t) {
              A.default.removeOrientationChangeHandler(e._onOrientationChange), r.reject(t), e.trigger(new H.PublisherEvent(H.PublisherEventTypes.CONNECT_FAILURE, e, t));
            }), r.hasOwnProperty("promise") ? r.promise : r;
          }
        }, {
          key: "publishWithSocket",
          value: function value(e) {
            var t = this,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            Y("[publishWithSocket]"), this._options.streamName = n || this._options.streamName;
            var i = r || new x.DeferredPromise(),
                o = new x.DeferredPromise();
            return this._socketHelper = new N.default(this), this._socketHelper.setUpWithSocket(e, o), o.promise.then(function () {
              return t._requestPublish(t._options.streamName, t._options.streamMode, t._options.keyFramerate);
            }).then(function () {
              A.default.addOrientationChangeHandler(t._onOrientationChange), i.resolve(t), t.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_START, t));
            }).catch(function (e) {
              A.default.removeOrientationChangeHandler(t._onOrientationChange), i.reject(e), t.trigger(new H.PublisherEvent(H.PublisherEventTypes.CONNECT_FAILURE, t, e));
            }), i.hasOwnProperty("promise") ? i.promise : i;
          }
        }, {
          key: "unpublish",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            Y("[unpublish]");

            var n = function n() {
              e._socketHelper && (Y("[unpublish:teardown]"), e._socketHelper.tearDown()), e._peerHelper && e._peerHelper.tearDown(), e._socketHelper = void 0, e._peerHelper = void 0, e._messageTransport = void 0;
            };

            (this._options.clearMediaOnUnpublish || t) && this.unpreview(), this._availableFuture = void 0, this._peerFuture = void 0, this._offerFuture = void 0, this._sendOfferFuture = void 0, this._trickleEndFuture = void 0, this._publishFuture = void 0;

            var r = this._requestUnpublish(this._options.streamName, this._options.groupName);

            return r.then(function () {
              e._unpublishFuture = void 0, n(), e.trigger(new H.PublisherEvent(H.PublisherEventTypes.UNPUBLISH_SUCCESS, e));
            }), A.default.removeOrientationChangeHandler(this._onOrientationChange), r;
          }
        }, {
          key: "mute",
          value: function value() {
            this.muteAudio();
          }
        }, {
          key: "unmute",
          value: function value() {
            this.unmuteAudio();
          }
        }, {
          key: "muteAudio",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteAudio: !0
              }
            });
          }
        }, {
          key: "unmuteAudio",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteAudio: !1
              }
            });
          }
        }, {
          key: "muteVideo",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteVideo: !0
              }
            });
          }
        }, {
          key: "unmuteVideo",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteVideo: !1
              }
            });
          }
        }, {
          key: "send",
          value: function value(e, t) {
            this.getMessageTransport().post({
              send: {
                method: e,
                data: "string" == typeof t ? JSON.parse(t) : t
              }
            });
          }
        }, {
          key: "callServer",
          value: function value(e, t) {
            return this.getMessageTransport().postAsync({
              callAdapter: {
                method: e,
                arguments: t
              }
            });
          }
        }, {
          key: "sendLog",
          value: function value(e, t) {
            try {
              var n = (0, a.default)(G.LEVELS).find(function (t) {
                return t.toLowerCase() === e.toLowerCase();
              }) ? e : G.LEVELS.DEBUG,
                  r = "string" == typeof t ? t : (0, h.default)(t);
              this.getMessageTransport().post({
                log: n.toUpperCase(),
                message: r
              });
            } catch (e) {
              e.message;
              J(q), J(q);
            }
          }
        }, {
          key: "onStreamAvailable",
          value: function value(e) {
            Y("[onstreamavailable]: " + (0, h.default)(e, null, 2)), this._availableFuture = x.Future.createIfNotExist(this._availableFuture), this._availableFuture.reject("Stream with name " + this._options.streamName + " already has a broadcast session."), this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_INVALID_NAME, this));
          }
        }, {
          key: "onStreamUnavailable",
          value: function value(e) {
            Y("Stream " + this._options.streamName + " does not exist."), Y("[onstreamunavailable]: " + (0, h.default)(e, null, 2)), this._availableFuture = x.Future.createIfNotExist(this._availableFuture), this._availableFuture.resolve(!0);
          }
        }, {
          key: "onSocketMessage",
          value: function value(e, t) {
            this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.SOCKET_MESSAGE, this, {
              socket: e,
              message: t
            }));
          }
        }, {
          key: "onSocketMessageError",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            J("Error in stream publish: " + e + ".\n[Optional detail]: " + t), this._publishFuture && (this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_FAIL, this)), this._publishFuture.reject(e), this.unpublish());
          }
        }, {
          key: "onSocketClose",
          value: function value(e) {
            Y("[onsocketclose]"), this._peerHelper && this._peerHelper.tearDown(), this.trigger(new H.PublisherEvent(H.PublisherEventTypes.CONNECTION_CLOSED, this, e));
          }
        }, {
          key: "onPeerConnectionFail",
          value: function value() {
            Y("[onpeerconnectionfail]"), this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_FAIL, this)), this._publishFuture.reject("Peer Connection Failed.");
          }
        }, {
          key: "onPeerConnectionClose",
          value: function value(e) {
            Y("[onpeerconnectionclose]"), this._socketHelper && (Y("[onpeerconnectionclose:teardown]"), this._socketHelper.tearDown()), this.onSocketClose(e);
          }
        }, {
          key: "onPeerConnectionOpen",
          value: function value() {
            Y("[onpeerconnection::open]"), this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.PEER_CONNECTION_OPEN));
          }
        }, {
          key: "onPeerConnectionTrackAdd",
          value: function value(e) {
            Y("[onpeerconnection::track]"), this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.TRACK_ADDED, this, {
              track: e
            }));
          }
        }, {
          key: "onSDPSuccess",
          value: function value(e) {
            var t = e ? ": " + (0, h.default)(e, null, 2) : "";
            Y("[onsdpsuccess]" + t);
          }
        }, {
          key: "onSDPError",
          value: function value(e) {
            this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_FAIL, this));
            var t = e ? ": " + (0, h.default)(e, null, 2) : "";
            J("[onsdperror]" + t);
          }
        }, {
          key: "onSDPAnswer",
          value: function value(e) {
            Y("[sdpanswer]:: " + (0, h.default)(e, null, 2)), this._sendOfferFuture = x.Future.createIfNotExist(this._sendOfferFuture), this._sendOfferFuture.resolve(e);
          }
        }, {
          key: "onAddIceCandidate",
          value: function value(e) {
            Y("[addicecandidate]"), this._peerHelper.addIceCandidate(e).then(function () {
              Y("[addicecandidate:success]");
            }).catch(function (e) {
              K("[addicecandidate:error] - " + e);
            });
          }
        }, {
          key: "onIceCandidate",
          value: function value(e) {
            Y("[icecandidatetrickle]"), this._sendCandidate(e, this._options.streamName);
          }
        }, {
          key: "onIceCandidateTrickleEnd",
          value: function value() {
            Y("[icecandidatetrickle:end]");
          }
        }, {
          key: "onEmptyCandidate",
          value: function value() {
            Y("[icecandidatetrickle:empty]"), this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.PEER_CANDIDATE_END));
          }
        }, {
          key: "onPeerGatheringComplete",
          value: function value() {
            Y("[icecandidategathering:end]"), this._socketHelper && this._socketHelper.postEndOfCandidates(this._options.streamName);
          }
        }, {
          key: "onSocketIceCandidateEnd",
          value: function value() {
            Y("[socketicecandidate:end]"), this._getTrickleEnd().resolve();
          }
        }, {
          key: "onPublisherStatus",
          value: function value(e) {
            Y("[publisherstatus] - " + (0, h.default)(e, null, 2));
            var t = z.exec(e.message),
                n = W.exec(e.message);
            t && t[1] === this._options.streamName ? this._unpublishFuture.resolve() : n && n[1] === this._options.streamName ? this._publishFuture.resolve() : e.code && "NetStream.Publish.IsAvailable" === e.code ? this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_AVAILABLE, this.status)) : this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_STATUS, this, e));
          }
        }, {
          key: "onInsufficientBandwidth",
          value: function value(e) {
            this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_INSUFFICIENT_BANDWIDTH, this, e));
          }
        }, {
          key: "onSufficientBandwidth",
          value: function value(e) {
            this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_SUFFICIENT_BANDWIDTH, this, e));
          }
        }, {
          key: "onRecoveringBandwidth",
          value: function value(e) {
            this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_RECOVERING_BANDWIDTH, this, e));
          }
        }, {
          key: "onSendReceived",
          value: function value(e, t) {
            "onMetaData" === e ? this.onMetaData(t) : this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_SEND_INVOKE, this, {
              methodName: e,
              data: t
            }));
          }
        }, {
          key: "onDataChannelAvailable",
          value: function value(e) {
            var t = this;
            if (Y("[ondatachannel::available]"), this._switchChannelRequest = {
              switchChannel: e || "red5pro"
            }, this._options.signalingSocketOnly) var n = setTimeout(function () {
              clearTimeout(n), t._socketHelper.sever(t._switchChannelRequest), t._messageTransport = t._peerHelper, t.trigger(new H.MessageTransportStateEvent(H.MessageTransportStateEventTypes.CHANGE, t, {
                controller: t,
                transport: t._messageTransport
              }));
            }, this._options.socketSwitchDelay);
            this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.DATA_CHANNEL_AVAILABLE, this, {
              name: e,
              dataChannel: this.getDataChannel()
            }));
          }
        }, {
          key: "onDataChannelError",
          value: function value(e, t) {
            this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.DATA_CHANNEL_ERROR, this, {
              dataChannel: e,
              error: t
            }));
          }
        }, {
          key: "onDataChannelMessage",
          value: function value(e, t) {
            this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.DATA_CHANNEL_MESSAGE, this, {
              dataChannel: e,
              message: t
            }));
          }
        }, {
          key: "onDataChannelOpen",
          value: function value(e) {
            this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.DATA_CHANNEL_OPEN, this, {
              dataChannel: e
            }));
          }
        }, {
          key: "onDataChannelClose",
          value: function value(e) {
            this.trigger(new H.PublisherEvent(H.RTCPublisherEventTypes.DATA_CHANNEL_CLOSE, this, {
              dataChannel: e
            }));
          }
        }, {
          key: "onMetaData",
          value: function value(e) {
            this.trigger(new H.PublisherEvent(H.PublisherEventTypes.PUBLISH_METADATA, this, e));
          }
        }, {
          key: "overlayOptions",
          value: function value(e) {
            this._options = (0, l.default)(this._options, e);
          }
        }, {
          key: "getMessageTransport",
          value: function value() {
            return this._messageTransport;
          }
        }, {
          key: "getConnection",
          value: function value() {
            return this._socketHelper;
          }
        }, {
          key: "getPeerConnection",
          value: function value() {
            return this._peerHelper ? this._peerHelper.connection : void 0;
          }
        }, {
          key: "getDataChannel",
          value: function value() {
            return this._peerHelper ? this._peerHelper.dataChannel : void 0;
          }
        }, {
          key: "getMediaStream",
          value: function value() {
            return this._mediaStream;
          }
        }, {
          key: "getOptions",
          value: function value() {
            return this._options;
          }
        }, {
          key: "getType",
          value: function value() {
            return F.PublishTypes.RTC.toUpperCase();
          }
        }]), t;
      }(T.default);

      t.default = $;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(3),
          o = r(i),
          a = n(0),
          s = r(a),
          u = n(1),
          c = r(u),
          l = n(5),
          d = r(l),
          h = n(27),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(45),
          _ = r(b),
          m = n(8),
          g = n(46),
          y = function (e) {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
          (0, s.default)(this, t);
          var n = Math.floor(65536 * Math.random()).toString(16),
              r = "sharedobject-" + n,
              i = (0, d.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, r));
          return i.id = r, i._sharedObjectName = void 0, i;
        }

        return (0, v.default)(t, e), (0, c.default)(t, [{
          key: "getRemoteSharedObject",
          value: function value(e) {
            (0, f.default)(t.prototype.__proto__ || (0, o.default)(t.prototype), "getRemoteSharedObject", this).call(this, e), this._sharedObjectName = e;
          }
        }, {
          key: "init",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2,
                r = new m.DeferredPromise();
            this.id = t || this.id, this._name = this.id;
            var i = (0, g.rtcSocketEndpointFromOptions)(e, {
              id: this.id,
              capabilities: n
            });
            return this.setUp(i, r), r.promise;
          }
        }, {
          key: "respond",
          value: function value(e) {
            if (!(0, f.default)(t.prototype.__proto__ || (0, o.default)(t.prototype), "respond", this).call(this, e) && e.data) {
              var n = this.getJsonFromSocketMessage(e);

              if (n && n.data) {
                var r = n.data;
                if ("status" === r.type) "NetConnection.Connect.Closed" === r.code ? (this.respond({
                  data: {
                    data: {
                      status: "SharedObject.Status.Disconnect",
                      message: r.code,
                      name: this._sharedObjectName
                    }
                  }
                }), this._sharedObjectName = void 0) : "NetConnection.ICE.TrickleCompleted" === r.code && this._responder ? this._responder.onIceTrickleComplete() : "NetConnection.DataChannel.Available" === r.code && this._responder ? this._responder.onDataChannelAvailable(r.description) : this._responder && this._responder.onSocketStatus(r);else if (r.sdp) {
                  var i = r.sdp;
                  "answer" === i.type && this._responder && this._responder.onSDPAnswer(i);
                } else if (r.candidate && this._responder) {
                  var a = r.candidate;

                  this._responder.onAddIceCandidate(a);
                }
              }
            }
          }
        }, {
          key: "close",
          value: function value() {
            this._sharedObjectName = void 0, this.tearDown();
          }
        }, {
          key: "getMessageTransport",
          value: function value() {
            return this;
          }
        }, {
          key: "getConnection",
          value: function value() {
            return this;
          }
        }]), t;
      }(_.default);

      t.default = y;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.SliderEventTypes = t.SliderEvent = void 0;

      var i = n(16),
          o = r(i),
          a = n(3),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(5),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(11),
          _ = function (e) {
        function t(e, n, r) {
          (0, c.default)(this, t);
          var i = (0, f.default)(this, (t.__proto__ || (0, s.default)(t)).call(this, e, r));
          return i._control = n, i;
        }

        return (0, v.default)(t, e), (0, d.default)(t, [{
          key: "control",
          get: function get() {
            return this._control;
          }
        }]), t;
      }(b.Event),
          m = (0, o.default)({
        CHANGE_START: "changestart",
        CHANGE: "change",
        CHANGE_COMPLETE: "changecomplete"
      });

      t.SliderEvent = _, t.SliderEventTypes = m;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.ImplFactoryOrder = void 0;

      var i = n(151),
          o = r(i),
          a = n(152),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(100),
          f = r(h),
          p = n(8),
          v = new f.default(),
          b = function b(e) {
        return v.has(e) || v.set(e, {}), v.get(e);
      },
          _ = t.ImplFactoryOrder = function () {
        function e() {
          var t = this;
          (0, c.default)(this, e), this.listorder = function () {
            return s.default.mark(function e(t) {
              return s.default.wrap(function (e) {
                for (;;) {
                  switch (e.prev = e.next) {
                    case 0:
                      if (!(t.length > 0)) {
                        e.next = 5;
                        break;
                      }

                      return e.next = 3, t.shift();

                    case 3:
                      e.next = 0;
                      break;

                    case 5:
                    case "end":
                      return e.stop();
                  }
                }
              }, e, this);
            });
          }(), b(this).find = function (e, n, r, i) {
            var a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null,
                s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
                u = b(t).next(e, n),
                c = (0, o.default)(u, 2),
                l = c[0],
                d = c[1];

            if (d) {
              var h = void 0,
                  f = r[l];
              f = f || r, h = a ? new d()[a](f) : new d(f), h.then(function (e) {
                i.resolve(e);
              }).catch(function (o) {
                s = o, b(t).find(e, n, r, i, a, s);
              });
            } else i.reject(s);
          }, b(this).next = function (e, t) {
            var n = void 0,
                r = void 0,
                i = e.next();
            return i.done || (r = i.value, n = t.get(r)), [r, n];
          };
        }

        return (0, d.default)(e, [{
          key: "create",
          value: function value(e, t, n) {
            var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                i = new p.DeferredPromise();
            return b(this).find(this.listorder(e.slice()), t, n, i, r), i.promise;
          }
        }]), e;
      }();

      t.default = _;
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var r = t.curry = function (e) {
        var t = e.length;
        return function n() {
          var r = Array.prototype.slice.call(arguments, 0);
          return r.length >= t ? e.apply(null, r) : function () {
            var e = Array.prototype.slice.call(arguments, 0);
            return n.apply(null, r.concat(e));
          };
        };
      },
          i = (t.filter = r(function (e, t) {
        for (var n = 0, r = t.length, i = []; n < r;) {
          e(t[n]) && (i[i.length] = t[n]), n += 1;
        }

        return i;
      }), t.toInt = function (e) {
        return "string" == typeof e ? parseInt(e, 10) : Math.round(e);
      });

      t.getOrElse = function (e, t) {
        return e || t;
      }, t.getIntOrElse = function (e, t) {
        return isNaN(i(e)) ? t : i(e);
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(157),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(158),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(162),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(169),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(172),
        __esModule: !0
      };
    }, function (e, t, n) {
      t.__esModule = !0;

      var r = n(141),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.default = function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }

        return (0, i.default)(e);
      };
    }, function (e, t, n) {
      function r(e) {
        if (void 0 === e || null === e) return e;
        if (Array.isArray(e)) return e.slice();

        if ("object" == typeof e) {
          var t = {};
          return Object.keys(e).forEach(function (n) {
            t[n] = e[n];
          }), t;
        }

        return e;
      }

      function i() {
        var e = {},
            t = Error.stackTraceLimit,
            n = Error.prepareStackTrace;
        return Error.stackTraceLimit = 3, Error.prepareStackTrace = function (t, n) {
          var r = n[2];
          e.file = r.getFileName(), e.line = r.getLineNumber();
          var i = r.getFunctionName();
          i && (e.func = i);
        }, Error.stackTraceLimit = t, Error.prepareStackTrace = n, e;
      }

      function o(e, t) {
        return t || (t = "    "), t + e.split(/\r?\n/g).join("\n" + t);
      }

      function a(e, t) {
        if (t) {
          if (_[t]) return;
          _[t] = !0;
        }

        console.error(e + "\n");
      }

      function s(e) {
        return _[e];
      }

      function u() {}

      function c() {}

      function l(e) {
        return "string" == typeof e ? C[e.toLowerCase()] : e;
      }

      function d(e, t, n) {
        if (!(this instanceof d)) return new d(e, t);
        var i;
        if (void 0 !== t && (i = e, e = t, !(i instanceof d))) throw new TypeError("invalid Logger creation: do not pass a second arg");
        if (!e) throw new TypeError("options (object) is required");

        if (i) {
          if (e.name) throw new TypeError("invalid options.name: child cannot set logger name");
        } else if (!e.name) throw new TypeError("options.name (string) is required");

        if (e.stream && e.streams) throw new TypeError('cannot mix "streams" and "stream" options');
        if (e.streams && !Array.isArray(e.streams)) throw new TypeError("invalid options.streams: must be an array");
        if (e.serializers && ("object" != typeof e.serializers || Array.isArray(e.serializers))) throw new TypeError("invalid options.serializers: must be an object");
        var o, a, s;

        if (i && n) {
          this._isSimpleChild = !0, this._level = i._level, this.streams = i.streams, this.serializers = i.serializers, this.src = i.src, o = this.fields = {};
          var c = Object.keys(i.fields);

          for (s = 0; s < c.length; s++) {
            a = c[s], o[a] = i.fields[a];
          }

          var l = Object.keys(e);

          for (s = 0; s < l.length; s++) {
            a = l[s], o[a] = e[a];
          }
        } else {
          var h = this;

          if (i) {
            for (this._level = i._level, this.streams = [], s = 0; s < i.streams.length; s++) {
              var f = r(i.streams[s]);
              f.closeOnExit = !1, this.streams.push(f);
            }

            this.serializers = r(i.serializers), this.src = i.src, this.fields = r(i.fields), e.level && this.level(e.level);
          } else this._level = Number.POSITIVE_INFINITY, this.streams = [], this.serializers = null, this.src = !1, this.fields = {};

          e.stream ? h.addStream({
            type: "stream",
            stream: e.stream,
            closeOnExit: !1,
            level: e.level
          }) : e.streams ? e.streams.forEach(function (t) {
            h.addStream(t, e.level);
          }) : i && e.level ? this.level(e.level) : i || h.addStream({
            type: "raw",
            stream: new u(),
            closeOnExit: !1,
            level: e.level
          }), e.serializers && h.addSerializers(e.serializers), e.src && (this.src = !0), o = r(e), delete o.stream, delete o.level, delete o.streams, delete o.serializers, delete o.src, this.serializers && this._applySerializers(o), Object.keys(o).forEach(function (e) {
            h.fields[e] = o[e];
          });
        }
      }

      function h(e) {
        return function () {
          var t = this,
              n = null,
              o = arguments,
              u = null;

          if (this._emit) {
            if (0 === arguments.length) return this._level <= e;
            this._level > e || (u = function (a) {
              var s;
              a[0] instanceof Error ? (n = {
                err: t.serializers && t.serializers.err ? t.serializers.err(a[0]) : d.stdSerializers.err(a[0])
              }, s = {
                err: !0
              }, o = 1 === a.length ? [n.err.message] : Array.prototype.slice.call(a, 1)) : "object" != typeof a[0] && null !== a[0] || Array.isArray(a[0]) ? (n = null, o = Array.prototype.slice.call(a)) : (n = a[0], o = Array.prototype.slice.call(a, 1));
              var u = r(t.fields);
              u.level = e;
              var c = n ? r(n) : null;
              return c && (t.serializers && t._applySerializers(c, s), Object.keys(c).forEach(function (e) {
                u[e] = c[e];
              })), u.levelName = T[e], u.msg = b.apply(t, o), u.time || (u.time = new Date()), t.src && !u.src && (u.src = i()), u.v = v, u;
            }(o), this._emit(u));
          } else {
            if (!s.unbound) {
              var c = i();
              a(b("bunyan usage error: %s:%s: attempt to log with an unbound log method: `this` is: %s", c.file, c.line, this.toString()), "unbound");
            }
          }
        };
      }

      function f(e) {
        var t = e.stack || e.toString();

        if (e.cause && "function" == typeof e.cause) {
          var n = e.cause();
          n && (t += "\nCaused by: " + f(n));
        }

        return t;
      }

      function p() {
        var e = [];
        return function (t, n) {
          return n && "object" == typeof n ? -1 !== e.indexOf(n) ? "[Circular]" : (e.push(n), n) : n;
        };
      }

      var v = 0,
          b = function b(e) {
        if (null === e) return "null";
        if ("string" != typeof e) return e.toString();

        for (var t = /%[sdj%]/g, n = 1, r = arguments, i = r.length, o = String(e).replace(t, function (e) {
          if ("%%" === e) return "%";
          if (n >= i) return e;

          switch (e) {
            case "%s":
              return String(r[n++]);

            case "%d":
              return Number(r[n++]);

            case "%j":
              try {
                return JSON.stringify(r[n++]);
              } catch (e) {
                return "[Circular]";
              }

              break;

            default:
              return e;
          }
        }), a = r[n]; n < i; a = r[++n]) {
          o += " " + a;
        }

        return o;
      },
          _ = {};

      u.prototype.write = function (e) {
        e.level < g ? console.log(e) : e.level < y ? console.info(e) : e.level < S ? console.warn(e) : console.error(e), e.err && e.err.stack && console.error(e.err.stack);
      }, c.prototype.write = function (e) {
        function t(e, t) {
          return Array(t + 1 - (e + "").length).join("0") + e;
        }

        var n;
        n = e.level < m ? "color: DeepPink" : e.level < g ? "color: GoldenRod" : e.level < y ? "color: DarkTurquoise" : e.level < S ? "color: Purple" : e.level < E ? "color: Crimson" : "color: Black";
        var r = e.childName ? e.name + "/" + e.childName : e.name,
            i = T[e.level].toUpperCase();
        i = Array(6 - i.length).join(" ") + i, console.log("[%s:%s:%s:%s] %c%s%c: %s: %c%s", t(e.time.getHours(), 2), t(e.time.getMinutes(), 2), t(e.time.getSeconds(), 2), t(e.time.getMilliseconds(), 4), n, i, "color: DimGray", r, "color: SteelBlue", e.msg), e.err && e.err.stack && console.log("%c%s,", n, e.err.stack);
      };
      var m = 20,
          g = 30,
          y = 40,
          S = 50,
          E = 60,
          C = {
        trace: 10,
        debug: m,
        info: g,
        warn: y,
        error: S,
        fatal: E
      },
          T = {};
      Object.keys(C).forEach(function (e) {
        T[C[e]] = e;
      }), d.prototype.addStream = function (e, t) {
        var n = this;

        switch (null !== t && void 0 !== t || (t = g), e = r(e), !e.type && e.stream && (e.type = "raw"), e.raw = "raw" === e.type, e.level ? e.level = l(e.level) : e.level = l(t), e.level < n._level && (n._level = e.level), e.type) {
          case "stream":
          case "raw":
            e.closeOnExit || (e.closeOnExit = !1);
            break;

          default:
            throw new TypeError('unknown stream type "' + e.type + '"');
        }

        n.streams.push(e), delete n.haveNonRawStreams;
      }, d.prototype.addSerializers = function (e) {
        var t = this;
        t.serializers || (t.serializers = {}), Object.keys(e).forEach(function (n) {
          var r = e[n];
          if ("function" != typeof r) throw new TypeError(b('invalid serializer for "%s" field: must be a function', n));
          t.serializers[n] = r;
        });
      }, d.prototype.child = function (e, t) {
        return new this.constructor(this, e || {}, t);
      }, d.prototype.level = function (e) {
        if (void 0 === e) return this._level;

        for (var t = l(e), n = this.streams.length, r = 0; r < n; r++) {
          this.streams[r].level = t;
        }

        this._level = t;
      }, d.prototype.levels = function (e, t) {
        if (void 0 === e) return this.streams.map(function (e) {
          return e.level;
        });
        var n;

        if ("number" == typeof e) {
          if (void 0 === (n = this.streams[e])) throw new Error("invalid stream index: " + e);
        } else {
          for (var r = this.streams.length, i = 0; i < r; i++) {
            var o = this.streams[i];

            if (o.name === e) {
              n = o;
              break;
            }
          }

          if (!n) throw new Error(b('no stream with name "%s"', e));
        }

        if (void 0 === t) return n.level;
        var a = l(t);
        n.level = a, a < this._level && (this._level = a);
      }, d.prototype._applySerializers = function (e, t) {
        var n = this;
        Object.keys(this.serializers).forEach(function (r) {
          if (!(void 0 === e[r] || t && t[r])) try {
            e[r] = n.serializers[r](e[r]);
          } catch (t) {
            a(b('bunyan: ERROR: Exception thrown from the "%s" Bunyan serializer. This should never happen. This is a bugin that serializer function.\n%s', r, t.stack || t)), e[r] = b('(Error in Bunyan log "%s" serializer broke field. See stderr for details.)', r);
          }
        });
      }, d.prototype._emit = function (e, t) {
        var n;
        if (void 0 === this.haveNonRawStreams) for (this.haveNonRawStreams = !1, n = 0; n < this.streams.length; n++) {
          if (!this.streams[n].raw) {
            this.haveNonRawStreams = !0;
            break;
          }
        }
        var r;
        if (t || this.haveNonRawStreams) try {
          r = JSON.stringify(e, p()) + "\n";
        } catch (t) {
          var i = t.stack.split(/\n/g, 2).join("\n");
          a('bunyan: ERROR: Exception in `JSON.stringify(rec)`. You can install the "safe-json-stringify" module to have Bunyan fallback to safer stringification. Record:\n' + o(b("%s\n%s", e, t.stack)), i), r = b("(Exception in JSON.stringify(rec): %j. See stderr for details.)\n", t.message);
        }
        if (t) return r;
        var s = e.level;

        for (n = 0; n < this.streams.length; n++) {
          var u = this.streams[n];
          u.level <= s && u.stream.write(u.raw ? e : r);
        }

        return r;
      }, d.prototype.trace = h(10), d.prototype.debug = h(m), d.prototype.info = h(g), d.prototype.warn = h(y), d.prototype.error = h(S), d.prototype.fatal = h(E), d.stdSerializers = {}, d.stdSerializers.err = function (e) {
        return e && e.stack ? {
          message: e.message,
          name: e.name,
          stack: f(e),
          code: e.code,
          signal: e.signal
        } : e;
      }, e.exports = d, e.exports.TRACE = 10, e.exports.DEBUG = m, e.exports.INFO = g, e.exports.WARN = y, e.exports.ERROR = S, e.exports.FATAL = E, e.exports.resolveLevel = l, e.exports.levelFromName = C, e.exports.nameFromLevel = T, e.exports.VERSION = "0.2.3", e.exports.LOG_VERSION = v, e.exports.createLogger = function (e) {
        return new d(e);
      }, e.exports.safeCycles = p, e.exports.ConsoleFormattedStream = c, e.exports.ConsoleRawStream = u;
    }, function (e, t, n) {
      var r = n(15).f,
          i = n(52),
          o = n(55),
          a = n(20),
          s = n(48),
          u = n(50),
          c = n(40),
          l = n(70),
          d = n(111),
          h = n(116),
          f = n(18),
          p = n(33).fastKey,
          v = f ? "_s" : "size",
          b = function b(e, t) {
        var n,
            r = p(t);
        if ("F" !== r) return e._i[r];

        for (n = e._f; n; n = n.n) {
          if (n.k == t) return n;
        }
      };

      e.exports = {
        getConstructor: function getConstructor(e, t, n, l) {
          var d = e(function (e, r) {
            s(e, d, t, "_i"), e._i = i(null), e._f = void 0, e._l = void 0, e[v] = 0, void 0 != r && c(r, n, e[l], e);
          });
          return o(d.prototype, {
            clear: function clear() {
              for (var e = this, t = e._i, n = e._f; n; n = n.n) {
                n.r = !0, n.p && (n.p = n.p.n = void 0), delete t[n.i];
              }

              e._f = e._l = void 0, e[v] = 0;
            },
            delete: function _delete(e) {
              var t = this,
                  n = b(t, e);

              if (n) {
                var r = n.n,
                    i = n.p;
                delete t._i[n.i], n.r = !0, i && (i.n = r), r && (r.p = i), t._f == n && (t._f = r), t._l == n && (t._l = i), t[v]--;
              }

              return !!n;
            },
            forEach: function forEach(e) {
              s(this, d, "forEach");

              for (var t, n = a(e, arguments.length > 1 ? arguments[1] : void 0, 3); t = t ? t.n : this._f;) {
                for (n(t.v, t.k, this); t && t.r;) {
                  t = t.p;
                }
              }
            },
            has: function has(e) {
              return !!b(this, e);
            }
          }), f && r(d.prototype, "size", {
            get: function get() {
              return u(this[v]);
            }
          }), d;
        },
        def: function def(e, t, n) {
          var r,
              i,
              o = b(e, t);
          return o ? o.v = n : (e._l = o = {
            i: i = p(t, !0),
            k: t,
            v: n,
            p: r = e._l,
            n: void 0,
            r: !1
          }, e._f || (e._f = o), r && (r.n = o), e[v]++, "F" !== i && (e._i[i] = o)), e;
        },
        getEntry: b,
        setStrong: function setStrong(e, t, n) {
          l(e, t, function (e, t) {
            this._t = e, this._k = t, this._l = void 0;
          }, function () {
            for (var e = this, t = e._k, n = e._l; n && n.r;) {
              n = n.p;
            }

            return e._t && (e._l = n = n ? n.n : e._t._f) ? "keys" == t ? d(0, n.k) : "values" == t ? d(0, n.v) : d(0, [n.k, n.v]) : (e._t = void 0, d(1));
          }, n ? "entries" : "values", !n, !0), h(t);
        }
      };
    }, function (e, t, n) {
      var r = n(49),
          i = n(174);

      e.exports = function (e) {
        return function () {
          if (r(this) != e) throw TypeError(e + "#toJSON isn't generic");
          return i(this);
        };
      };
    }, function (e, t, n) {
      e.exports = n(13).document && document.documentElement;
    }, function (e, t, n) {
      e.exports = !n(18) && !n(28)(function () {
        return 7 != Object.defineProperty(n(67)("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    }, function (e, t, n) {
      var r = n(32),
          i = n(10)("iterator"),
          o = Array.prototype;

      e.exports = function (e) {
        return void 0 !== e && (r.Array === e || o[i] === e);
      };
    }, function (e, t, n) {
      var r = n(39);

      e.exports = Array.isArray || function (e) {
        return "Array" == r(e);
      };
    }, function (e, t, n) {
      var r = n(17);

      e.exports = function (e, t, n, i) {
        try {
          return i ? t(r(n)[0], n[1]) : t(n);
        } catch (t) {
          var o = e.return;
          throw void 0 !== o && r(o.call(e)), t;
        }
      };
    }, function (e, t, n) {
      var r = n(10)("iterator"),
          i = !1;

      try {
        var o = [7][r]();
        o.return = function () {
          i = !0;
        }, Array.from(o, function () {
          throw 2;
        });
      } catch (e) {}

      e.exports = function (e, t) {
        if (!t && !i) return !1;
        var n = !1;

        try {
          var o = [7],
              a = o[r]();
          a.next = function () {
            return {
              done: n = !0
            };
          }, o[r] = function () {
            return a;
          }, e(o);
        } catch (e) {}

        return n;
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        return {
          value: t,
          done: !!e
        };
      };
    }, function (e, t, n) {
      var r = n(34),
          i = n(72),
          o = n(53),
          a = n(35),
          s = n(69),
          u = Object.assign;
      e.exports = !u || n(28)(function () {
        var e = {},
            t = {},
            n = Symbol(),
            r = "abcdefghijklmnopqrst";
        return e[n] = 7, r.split("").forEach(function (e) {
          t[e] = e;
        }), 7 != u({}, e)[n] || Object.keys(u({}, t)).join("") != r;
      }) ? function (e, t) {
        for (var n = a(e), u = arguments.length, c = 1, l = i.f, d = o.f; u > c;) {
          for (var h, f = s(arguments[c++]), p = l ? r(f).concat(l(f)) : r(f), v = p.length, b = 0; v > b;) {
            d.call(f, h = p[b++]) && (n[h] = f[h]);
          }
        }

        return n;
      } : u;
    }, function (e, t, n) {
      var r = n(115),
          i = n(68).concat("length", "prototype");

      t.f = Object.getOwnPropertyNames || function (e) {
        return r(e, i);
      };
    }, function (e, t, n) {
      var r = n(21),
          i = n(35),
          o = n(74)("IE_PROTO"),
          a = Object.prototype;

      e.exports = Object.getPrototypeOf || function (e) {
        return e = i(e), r(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? a : null;
      };
    }, function (e, t, n) {
      var r = n(21),
          i = n(23),
          o = n(175)(!1),
          a = n(74)("IE_PROTO");

      e.exports = function (e, t) {
        var n,
            s = i(e),
            u = 0,
            c = [];

        for (n in s) {
          n != a && r(s, n) && c.push(n);
        }

        for (; t.length > u;) {
          r(s, n = t[u++]) && (~o(c, n) || c.push(n));
        }

        return c;
      };
    }, function (e, t, n) {
      var r = n(13),
          i = n(6),
          o = n(15),
          a = n(18),
          s = n(10)("species");

      e.exports = function (e) {
        var t = "function" == typeof i[e] ? i[e] : r[e];
        a && t && !t[s] && o.f(t, s, {
          configurable: !0,
          get: function get() {
            return this;
          }
        });
      };
    }, function (e, t, n) {
      var r,
          i,
          o,
          a = n(20),
          s = n(181),
          u = n(105),
          c = n(67),
          l = n(13),
          d = l.process,
          h = l.setImmediate,
          f = l.clearImmediate,
          p = l.MessageChannel,
          v = 0,
          b = {},
          _ = function _() {
        var e = +this;

        if (b.hasOwnProperty(e)) {
          var t = b[e];
          delete b[e], t();
        }
      },
          m = function m(e) {
        _.call(e.data);
      };

      h && f || (h = function h(e) {
        for (var t = [], n = 1; arguments.length > n;) {
          t.push(arguments[n++]);
        }

        return b[++v] = function () {
          s("function" == typeof e ? e : Function(e), t);
        }, r(v), v;
      }, f = function f(e) {
        delete b[e];
      }, "process" == n(39)(d) ? r = function r(e) {
        d.nextTick(a(_, e, 1));
      } : p ? (i = new p(), o = i.port2, i.port1.onmessage = m, r = a(o.postMessage, o, 1)) : l.addEventListener && "function" == typeof postMessage && !l.importScripts ? (r = function r(e) {
        l.postMessage(e + "", "*");
      }, l.addEventListener("message", m, !1)) : r = "onreadystatechange" in c("script") ? function (e) {
        u.appendChild(c("script")).onreadystatechange = function () {
          u.removeChild(this), _.call(e);
        };
      } : function (e) {
        setTimeout(a(_, e, 1), 0);
      }), e.exports = {
        set: h,
        clear: f
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function i(e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.getLogger = t.LOG_LEVELS = t.getRecordedLogs = t.setLogLevel = t.IceTransportTypes = t.PlaybackVideoEncoder = t.PlaybackAudioEncoder = t.RTCConferenceParticipantEventType = t.MessageTransportStateEventTypes = t.SharedObjectEventTypes = t.FailoverSubscriberEventTypes = t.RTMPSubscriberEventTypes = t.RTCSubscriberEventTypes = t.SubscriberEventTypes = t.FailoverPublisherEventTypes = t.RTCPublisherEventTypes = t.PublisherEventTypes = t.Red5ProSharedObjectPeerConnection = t.Red5ProSharedObjectSocket = t.Red5ProSharedObject = t.PlaybackControls = t.PublisherView = t.RTMPPublisher = t.RTCPublisher = t.Red5ProPublisher = t.PlaybackView = t.HLSSubscriber = t.RTMPSubscriber = t.RTCSubscriber = t.Red5ProSubscriber = t.RTCConferenceParticipant = void 0;
      var o = n(24);
      Object.defineProperty(t, "PlaybackControls", {
        enumerable: !0,
        get: function get() {
          return o.PlaybackControls;
        }
      });

      var a = n(2),
          s = n(134),
          u = i(s),
          c = n(127),
          l = i(c),
          d = n(130),
          h = i(d),
          f = n(36),
          p = i(f),
          v = n(59),
          b = i(v),
          _ = n(85),
          m = i(_),
          g = n(87),
          y = i(g),
          S = n(86),
          E = i(S),
          C = n(83),
          T = i(C),
          w = n(84),
          k = i(w),
          P = n(47),
          O = r(P),
          R = n(61),
          A = r(R),
          M = n(119),
          N = r(M);

      t.RTCConferenceParticipant = N.default;
      t.Red5ProSubscriber = u.Red5ProSubscriber, t.RTCSubscriber = u.RTCSubscriber, t.RTMPSubscriber = u.RTMPSubscriber, t.HLSSubscriber = u.HLSSubscriber;
      t.PlaybackView = O.default;
      t.Red5ProPublisher = l.Red5ProPublisher, t.RTCPublisher = l.RTCPublisher, t.RTMPPublisher = l.RTMPPublisher;
      t.PublisherView = A.default;
      t.Red5ProSharedObject = h.Red5ProSharedObject, t.Red5ProSharedObjectSocket = h.Red5ProSharedObjectSocket, t.Red5ProSharedObjectPeerConnection = h.Red5ProSharedObjectPeerConnection, t.PublisherEventTypes = m.PublisherEventTypes, t.RTCPublisherEventTypes = m.RTCPublisherEventTypes, t.FailoverPublisherEventTypes = m.FailoverPublisherEventTypes, t.SubscriberEventTypes = y.SubscriberEventTypes, t.RTCSubscriberEventTypes = y.RTCSubscriberEventTypes, t.RTMPSubscriberEventTypes = y.RTMPSubscriberEventTypes, t.FailoverSubscriberEventTypes = y.FailoverSubscriberEventTypes, t.SharedObjectEventTypes = E.SharedObjectEventTypes, t.MessageTransportStateEventTypes = T.MessageTransportStateEventTypes, t.RTCConferenceParticipantEventType = k.RTCConferenceParticipantEventTypes, t.PlaybackAudioEncoder = p.PlaybackAudioEncoder, t.PlaybackVideoEncoder = p.PlaybackVideoEncoder, t.IceTransportTypes = b.IceTransportTypes;
      (0, a.establishLogger)("error");

      t.setLogLevel = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        a.LEVELS.hasOwnProperty(e.toUpperCase()) && ((0, a.establishLogger)(e, t), console && console.log("Red5 Pro SDK Version 10.9.0-release.b67"));
      };

      t.getRecordedLogs = a.getRecordedLogs;
      t.LOG_LEVELS = a.LEVELS, t.getLogger = a.getLogger;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(26),
          s = r(a),
          u = n(3),
          c = r(u),
          l = n(0),
          d = r(l),
          h = n(1),
          f = r(h),
          p = n(5),
          v = r(p),
          b = n(27),
          _ = r(b),
          m = n(4),
          g = r(m),
          y = n(91),
          S = r(y),
          E = n(11),
          C = n(8),
          T = n(2),
          w = /participant (.*) starting (.*)/i,
          k = /Leaving group (.*)/i,
          P = "RTCConferenceParticipant",
          O = {
        groupName: "group01",
        autoGenerateMediaStream: !0,
        mixAudioDown: !1
      },
          R = function (e) {
        function t() {
          (0, d.default)(this, t);
          var e = (0, v.default)(this, (t.__proto__ || (0, c.default)(t)).call(this));
          return e._name = P, e._audioTracks = [], e._videoTracks = [], e._conferenceStream = void 0, e;
        }

        return (0, g.default)(t, e), (0, f.default)(t, [{
          key: "_createAudioElement",
          value: function value() {
            var e = document.createElement("audio");
            return e.id = "red5pro-audio", e.controls = "controls", e.autoplay = "autoplay", e.playsinline = "playsinline", e;
          }
        }, {
          key: "_packStreamWithAudio",
          value: function value(e, t) {
            var n = e.getVideoTracks()[0].clone();

            for (e.addTrack(n); --t > -1;) {
              var r = new AudioContext(),
                  i = r.createMediaStreamDestination();
              r.createMediaStreamSource(e).connect(i), e.addTrack(i.stream.getAudioTracks()[0]);
            }
          }
        }, {
          key: "_createOffer",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return (0, T.debug)("[createoffer]"), this._offerFuture = void 0, this._offerFuture = C.Future.createIfNotExist(this._offerFuture), this._peerHelper.createOffer(e, t, !0, this._offerFuture), this._offerFuture.promise;
          }
        }, {
          key: "_sendOffer",
          value: function value(e, t, n) {
            var r = this._options.groupName;
            return this._sendOfferFuture = void 0, this._sendOfferFuture = C.Future.createIfNotExist(this._sendOffFuture), this._socketHelper.post({
              joinGroup: r,
              streamName: t,
              transport: n,
              data: {
                sdp: e
              }
            }), this._sendOfferFuture.promise;
          }
        }, {
          key: "_requestPublish",
          value: function value(e, t, n) {
            var r = this._options.autoGenerateMediaStream;
            return this._publishFuture = void 0, this._publishFuture = C.Future.createIfNotExist(this._publishFuture), this._publishFuture.resolve(), r && (this._conferenceStream = this._startReceivers(), this.trigger(new E.RTCConferenceParticipantEvent(E.RTCConferenceParticipantEventTypes.MEDIA_STREAM, this, {
              stream: this._conferenceStream
            }))), this._publishFuture.promise;
          }
        }, {
          key: "unpublish",
          value: function value() {
            return this._conferenceStream && this._conferenceStream.getTracks().forEach(function (e) {
              return e.stop();
            }), (0, _.default)(t.prototype.__proto__ || (0, c.default)(t.prototype), "unpublish", this).call(this);
          }
        }, {
          key: "_requestUnpublish",
          value: function value(e) {
            var t = this._options.groupName;
            return this._unpublishFuture = void 0, this._unpublishFuture = C.Future.createIfNotExist(this._unpublishFuture), this.getMessageTransport().postUnjoin(t, e) || this._unpublishFuture.resolve(), this._unpublishFuture.promise;
          }
        }, {
          key: "_startReceivers",
          value: function value() {
            var e = this.getPeerConnection().getTransceivers().map(function (e) {
              if ("recvonly" === e.currentDirection) return e.receiver.track;
            }).filter(function (e) {
              return e;
            }),
                t = this._options.mixAudioDown,
                n = void 0,
                r = this._conferenceStream || new MediaStream();

            if (t) {
              var i = new AudioContext(),
                  o = e.map(function (e) {
                if ("audio" === e.kind) return i.createMediaStreamSource(new MediaStream([e]));
              }).filter(function (e) {
                return e;
              }),
                  a = i.createMediaStreamDestination();
              o.forEach(function (e) {
                return e.connect(a);
              }), n = a.stream, n.getTracks().forEach(function (e) {
                return r.addTrack(e);
              });
            } else e.forEach(function (e) {
              return r.addTrack(e);
            });

            return e.forEach(function (e) {
              "video" === e.kind && r.addTrack(e);
            }), r;
          }
        }, {
          key: "init",
          value: function value(e) {
            return (0, _.default)(t.prototype.__proto__ || (0, c.default)(t.prototype), "init", this).call(this, (0, s.default)(O, e));
          }
        }, {
          key: "initWithStream",
          value: function value(e, n) {
            return (0, _.default)(t.prototype.__proto__ || (0, c.default)(t.prototype), "initWithStream", this).call(this, (0, s.default)(O, e), n);
          }
        }, {
          key: "onPeerConnectionTrackAdd",
          value: function value(e) {
            var n = this._options.autoGenerateMediaStream;
            n && "audio" === e.kind ? this._audioTracks.push(e) : n && "video" === e.kind && this._videoTracks.push(e), (0, _.default)(t.prototype.__proto__ || (0, c.default)(t.prototype), "onPeerConnectionTrackAdd", this).call(this, e);
          }
        }, {
          key: "_onMediaStreamReceived",
          value: function value(e) {
            this._packStreamWithAudio(e, 3), (0, _.default)(t.prototype.__proto__ || (0, c.default)(t.prototype), "_onMediaStreamReceived", this).call(this, e);
          }
        }, {
          key: "onSDPAnswer",
          value: function value(e) {
            var t = this._options.streamName;
            this.overlayOptions({
              streamName: e.participantId,
              participantId: e.participantId,
              publisherName: t
            }), this._sendOfferFuture = C.Future.createIfNotExist(this._sendOfferFuture), this._sendOfferFuture.resolve(e);
          }
        }, {
          key: "onPublisherStatus",
          value: function value(e) {
            (0, T.debug)(this._name, "[publisherstatus] - " + (0, o.default)(e, null, 2));
            var t = k.exec(e.message),
                n = w.exec(e.message);
            t && t[1] === this._options.groupName ? this._unpublishFuture.resolve() : n && n[1] === this._options.streamName ? this._publishFuture.resolve() : (0, T.warn)(this._name, "Publisher status received, but could not handle.");
          }
        }]), t;
      }(S.default);

      t.default = R;
    }, function (e, t, n) {
      function r(e, t, n) {
        var r = "",
            i = t,
            o = t + n;

        do {
          r += String.fromCharCode(e[i++]);
        } while (i < o);

        return r;
      }

      function i(e, t) {
        try {
          return JSON.parse(e)[t];
        } catch (i) {
          var n = c.exec(e),
              r = void 0;
          if (n && n.length > 1 && (r = l.exec(e), n[1] === t && r && r.length > 1)) return r[1];
          return;
        }
      }

      function o(e) {
        var t = i(e, "orientation");
        if (t) return {
          orientation: parseInt(t)
        };
      }

      function a(e) {
        var t = i(e, "streamingMode");
        if (t) return {
          streamingMode: t
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.removePlayerDelegates = t.onStreamingModeMetadata = t.onOrientationMetadata = void 0;

      var s = n(100),
          u = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(s),
          c = /['"](.*?)['"]:/gi,
          l = /:['"](.*?)['"]/gi,
          d = new u.default(),
          h = function h(e) {
        return d.get(e);
      },
          f = function f(e) {
        var t = "function" == typeof e.textTracks ? e.textTracks() : e.textTracks;
        t && (e.addTextTrack("metadata"), t.addEventListener("addtrack", function (t) {
          var n = t.track;
          n.mode = "hidden", n.addEventListener("cuechange", function (t) {
            var i = void 0,
                s = void 0;

            for (t && t.currentTarget ? i = t.currentTarget.cues : (i = n.cues, i = i && i.length > 0 ? i : n.activeCues), i = i || [], s = 0; s < i.length; s++) {
              var u = i[s];
              u.value && function () {
                var t = "string" == typeof u.value.data ? u.value.data : r(u.value.data, 0, u.size),
                    n = o(t),
                    i = a(t),
                    s = h(e);
                n && s && s.orientation && s.orientation.forEach(function (e) {
                  e(n);
                }), i && s && s.streamingMode && s.streamingMode.forEach(function (e) {
                  e(i);
                });
              }();
            }
          });
        }));
      };

      t.onOrientationMetadata = function (e, t) {
        var n = d.get(e);
        d.has(e) ? n.hasOwnProperty("orientation") || (d.get(e).orientation = []) : (f(e), d.set(e, {
          orientation: []
        })), d.get(e).orientation.push(t);
      }, t.onStreamingModeMetadata = function (e, t) {
        var n = d.get(e);
        d.has(e) ? n.hasOwnProperty("streamingMode") || (d.get(e).streamingMode = []) : (f(e), d.set(e, {
          streamingMode: []
        })), d.get(e).streamingMode.push(t);
      }, t.removePlayerDelegates = function (e) {
        d.has(e) && d.delete(e);
      };
    }, function (e, t, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.NoSupportedCameraResolutionsError = t.NoElementFoundError = void 0;

      var r = n(0),
          i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(r);

      t.NoElementFoundError = function e(t) {
        (0, i.default)(this, e), this.name = "NoElementFound", this.message = t;
      }, t.NoSupportedCameraResolutionsError = function e(t) {
        (0, i.default)(this, e), this.name = "NoSupportedCameraResolutionsError", this.message = t;
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(3),
          o = r(i),
          a = n(0),
          s = r(a),
          u = n(1),
          c = r(u),
          l = n(5),
          d = r(l),
          h = n(27),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(45),
          _ = r(b),
          m = n(25),
          g = n(2),
          y = "R5ProPublisherSocket",
          S = function (e) {
        function t(e) {
          return (0, s.default)(this, t), (0, d.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, y));
        }

        return (0, v.default)(t, e), (0, c.default)(t, [{
          key: "respond",
          value: function value(e) {
            if (e.data) {
              var n = this.getJsonFromSocketMessage(e);

              if (!(0, f.default)(t.prototype.__proto__ || (0, o.default)(t.prototype), "respond", this).call(this, e)) {
                if (void 0 !== n.data) {
                  if (void 0 !== n.data.sdp && "answer" === n.data.sdp.type) return this._responder.onSDPAnswer(n.data), !0;
                  if (void 0 !== n.data.candidate) return (0, m.isObjectEmpty)(n.data.candidate) ? (this._responder.onEmptyCandidate(), !0) : (this._responder.onAddIceCandidate(n.data.candidate), !0);
                  if ("status" === n.data.type) if ("NetConnection.ICE.TricleCompleted" === n.data.code || "NetConnection.ICE.TrickleCompleted" === n.data.code) this._responder.onSocketIceCandidateEnd();else if ("NetConnection.Publish.InsufficientBW" === n.data.code) this._responder.onInsufficientBandwidth(n.data);else if ("NetConnection.Publish.SufficientBW" === n.data.code) this._responder.onSufficientBandwidth(n.data);else {
                    if ("NetConnection.Publish.RecoveringBW" !== n.data.code) return this._responder.onPublisherStatus(n.data), !0;

                    this._responder.onRecoveringBandwidth(n.data);
                  }
                  if (void 0 !== n.type && "metadata" === n.type.toLowerCase()) return void 0 !== n.method ? (this._responder.onSendReceived(n.method, n.data), !0) : (this._responder.onMetaData(n.data), !0);
                }

                this._responder.onSocketMessage(this, e);
              }
            } else (0, g.warn)(y, "[ws.onmessage] - No Message Data.");
          }
        }, {
          key: "postUnpublish",
          value: function value(e) {
            return void 0 !== this._websocket && 1 === this._openState && (this.post({
              unpublish: e
            }), !0);
          }
        }, {
          key: "postUnjoin",
          value: function value(e, t) {
            return void 0 !== this._websocket && 1 === this._openState && ((0, g.debug)(y, "[peerconnection:leavegroup]"), this.post({
              leaveGroup: e,
              streamName: t
            }));
          }
        }]), t;
      }(_.default);

      t.default = S;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(3),
          o = r(i),
          a = n(0),
          s = r(a),
          u = n(1),
          c = r(u),
          l = n(5),
          d = r(l),
          h = n(27),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(45),
          _ = r(b),
          m = n(25),
          g = n(2),
          y = "R5ProSubscriptionSocket",
          S = function (e) {
        function t(e) {
          return (0, s.default)(this, t), (0, d.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, y));
        }

        return (0, v.default)(t, e), (0, c.default)(t, [{
          key: "respond",
          value: function value(e) {
            if (e.data) {
              var n = this.getJsonFromSocketMessage(e);

              if (!(0, f.default)(t.prototype.__proto__ || (0, o.default)(t.prototype), "respond", this).call(this, e)) {
                if (void 0 !== n.data) {
                  if (void 0 !== n.data.sdp && "offer" === n.data.sdp.type) return this._responder.onSDPOffer(n.data), !0;
                  if (void 0 !== n.data.candidate) return (0, m.isObjectEmpty)(n.data.candidate) ? (this._responder.onEmptyCandidate(), !0) : (this._responder.onAddIceCandidate(n.data.candidate), !0);
                  if ("status" === n.data.type) return "NetConnection.ICE.TricleCompleted" === n.data.code || "NetConnection.ICE.TrickleCompleted" === n.data.code ? (this._responder.onSocketIceCandidateEnd(), !0) : "NetStream.Play.UnpublishNotify" === n.data.code ? (this._responder.onUnpublish(), !0) : "NetConnection.Connect.Closed" === n.data.code ? (this._responder.onConnectionClosed(), !0) : (this._responder.onSubscriberStatus(n.data), !0);
                  if (n.data.hasOwnProperty("status") && "NetStream.Play.UnpublishNotify" === n.data.status) return this._responder.onUnpublish(), !0;
                  if (void 0 !== n.type && "metadata" === n.type) return void 0 !== n.method ? (this._responder.onSendReceived(n.method, n.data), !0) : (this._responder.onMetaData(n.data), !0);
                } else if (void 0 !== n.type && "metadata" === n.type) return this._responder.onMetaData(n.metadata), !0;

                this._responder.onSocketMessage(this, e);
              }
            } else (0, g.warn)(y, "[ws.onmessage] - No Message Data.");
          }
        }]), t;
      }(_.default);

      t.default = S;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(3),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(5),
          f = r(h),
          p = n(27),
          v = r(p),
          b = n(4),
          _ = r(b),
          m = n(31),
          g = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }(m),
          y = n(7),
          S = r(y),
          E = n(60),
          C = r(E),
          T = n(8),
          w = n(2),
          k = "R5ProPublishPeer",
          P = function (e) {
        function t(e) {
          return (0, c.default)(this, t), (0, f.default)(this, (t.__proto__ || (0, s.default)(t)).call(this, e, k));
        }

        return (0, _.default)(t, e), (0, d.default)(t, [{
          key: "_removeConnectionHandlers",
          value: function value(e) {
            e.onconnectionstatechange = void 0, e.oniceconnectionstatechange = void 0, e.onicecandidate = void 0, e.ontrack = void 0;
          }
        }, {
          key: "_addConnectionHandlers",
          value: function value(e, t) {
            var n = this,
                r = void 0;
            e.ontrack = function (e) {
              (0, w.debug)(k, "[peer:ontrack]"), console.log(e), n._responder.onPeerConnectionTrackAdd(e.track);
            }, e.onconnectionstatechange = function () {
              (0, w.debug)(k, "[peer.onconnectionstatechange] - State: " + e.connectionState), "connected" === e.connectionState ? ((0, w.debug)(k, "[peerconnection:open]"), t ? t.resolve(n) : n._responder.onPeerConnectionOpen()) : "failed" !== e.connectionState && "disconnected" !== e.connectionState || ((0, w.warn)(k, "[peerconnection:error]"), t && t.reject(), "failed" === e.connectionState && n._responder.onPeerConnectionFail());
            }, e.onicecandidate = function (e) {
              (0, w.debug)(k, "[peer.onicecandidate] - Peer Candidate: " + e.candidate), e.candidate ? n._responder.onIceCandidate(e.candidate) : e.candidate;
            }, e.oniceconnectionstatechange = function (t) {
              var i = e.iceConnectionState;
              (0, w.debug)(k, "[peer.oniceconnectionstatechange] - State: " + i), "connected" === i && S.default.getIsEdge() ? ((0, w.debug)(k, "[edge/ortc:notify complete]"), n._responder.onPeerGatheringComplete()) : "failed" === i ? (r && clearTimeout(r), n._responder.onPeerConnectionClose(t)) : "disconnected" === i ? r = setTimeout(function () {
                (0, w.debug)(k, "[peer.oniceconnectionstatechange] - Reconnect timeout reached. Closing PeerConnection."), clearTimeout(r), n._responder.onPeerConnectionClose(t);
              }, 5e3) : r && ((0, w.debug)(k, "[peer.oniceconnectionstatechange] - Clearing timeout for reconnect."), clearTimeout(r));
            }, e.onsignalingstatechange = function (t) {
              var n = e.signalingState;
              (0, w.debug)(k, "[peer.onsignalingstatechange] - State: " + n);
            }, e.onicegatheringstatechange = function () {
              var t = e.iceGatheringState;
              (0, w.debug)(k, "[peer.onicegatheringstatechange] - State: " + t), "complete" === t && n._responder.onPeerGatheringComplete();
            }, e.onremovestream = function () {
              (0, w.debug)(k, "[peer.onremovestream]");
            };
          }
        }, {
          key: "_onDataChannelMessage",
          value: function value(e) {
            var n = e;
            if ((0, v.default)(t.prototype.__proto__ || (0, s.default)(t.prototype), "_onDataChannelMessage", this).call(this, e)) return !0;
            var r = this.getJsonFromSocketMessage(n);
            if (null === r) return (0, w.warn)(this._name, "Determined websocket response not in correct format. Aborting message handle."), !0;
            (0, w.debug)(this._name, "[datachannel-response]: " + (0, o.default)(r, null, 2));
            var i = r.data;
            return i && "status" === i.type ? "NetStream.Play.UnpublishNotify" === i.code ? (this._responder.onUnpublish(), !0) : ((0, w.debug)(k, "[datachannel.message] status :: " + i.code), this._responder.onPublisherStatus(i), !0) : (this._responder.onDataChannelMessage(this._dataChannel, n), !1);
          }
        }, {
          key: "getUserMedia",
          value: function value(e, t) {
            return g.getUserMedia(e, t);
          }
        }, {
          key: "forceUserMedia",
          value: function value(e) {
            return g.forceUserMedia(e);
          }
        }, {
          key: "createOffer",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = this,
                r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
            (0, w.debug)(k, "[createoffer]");
            var o = i || new T.DeferredPromise();
            return this._peerConnection.createOffer().then(function (i) {
              n.setLocalDescription(i, e).then(function () {
                var a = i.sdp;
                e && (a = g.updateBandwidth(e, a)), r && (a = g.stripRTPMaps(a), a = g.stripNonH264FromVideo(a), a = g.flipRecvOnlyOnExtraAudio(a), a = g.flipRecvOnlyOnExtraVideo(a)), t && (a = a.replaceAll("H264", "H265"), (0, w.debug)(k, "[createoffer] FORCING VP8")), i.sdp = a, n._responder.onSDPSuccess(), o.resolve(i);
              }).catch(function (e) {
                n._responder.onSDPError(e), o.reject(e);
              });
            }).catch(function (e) {
              (0, w.debug)(k, "[createoffer:error]"), o.reject(e);
            }), o.hasOwnProperty("promise") ? o.promise : o;
          }
        }, {
          key: "postUnpublish",
          value: function value(e) {
            var t = this.post({
              unpublish: e
            });
            return (0, w.debug)(k, "[peerconnection:unpublish] complete: " + t), t;
          }
        }, {
          key: "postUnjoin",
          value: function value(e, t) {
            return (0, w.debug)(k, "[peerconnection:leavegroup]"), this.post({
              leaveGroup: e,
              streamName: t
            });
          }
        }]), t;
      }(C.default);

      t.default = P;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(3),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(5),
          f = r(h),
          p = n(27),
          v = r(p),
          b = n(4),
          _ = r(b),
          m = n(31),
          g = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }(m),
          y = n(7),
          S = r(y),
          E = n(60),
          C = r(E),
          T = n(8),
          w = n(2),
          k = "R5ProSubscriptionPeer",
          P = function P(e) {
        return void 0 === e || "string" == typeof e && 0 === e.length;
      },
          O = function (e) {
        function t(e) {
          return (0, c.default)(this, t), (0, f.default)(this, (t.__proto__ || (0, s.default)(t)).call(this, e, k));
        }

        return (0, _.default)(t, e), (0, d.default)(t, [{
          key: "_removeConnectionHandlers",
          value: function value(e) {
            e.onconnectionstatechange = void 0, e.oniceconnectionstatechange = void 0, e.onicecandidate = void 0, e.ontrack = void 0, e.ondatachannel = void 0;
          }
        }, {
          key: "_addConnectionHandlers",
          value: function value(e, t) {
            var n = this,
                r = void 0;
            e.onconnectionstatechange = function () {
              (0, w.debug)(k, "[peer.onconnectionstatechange] - State: " + e.connectionState), "connected" === e.connectionState ? ((0, w.debug)(k, "[peerconnection:open]"), t ? t.resolve(n) : n._responder.onPeerConnectionOpen()) : "failed" !== e.connectionState && "disconnected" !== e.connectionState || ((0, w.warn)(k, "[peerconnection:error]"), t && t.reject());
            }, e.onicecandidate = function (e) {
              (0, w.debug)(k, "[peer.onicecandidate] - Peer Candidate: " + e.candidate), e.candidate ? n._responder.onIceCandidate(e.candidate) : null === e.candidate && n._pendingMediaStream && (n._responder.onIceCandidateTrickleEnd(n._pendingMediaStream), n._pendingMediaStream = void 0);
            }, e.ontrack = function (e) {
              (0, w.debug)(k, "(ontrack) Peer Add Stream: " + e.streams), e.streams && e.streams.length > 0 && void 0 === n._pendingMediaStream && (n._pendingMediaStream = e.streams[0], n._responder.onAnswerMediaStream(e.streams[0]));
            }, e.oniceconnectionstatechange = function (t) {
              var i = e.iceConnectionState;
              (0, w.debug)(k, "[peer.oniceconnectionstatechange] - State: " + i), "connected" === i && S.default.getIsEdge() ? ((0, w.debug)(k, "[edge/ortc:notify complete]"), n._responder.onPeerGatheringComplete(), e.onicecandidate({
                candidate: null
              })) : "failed" === i ? (r && clearTimeout(r), n._responder.onPeerConnectionFail(), n._responder.onPeerConnectionClose(t)) : "disconnected" === i ? r = setTimeout(function () {
                (0, w.debug)(k, "[peer.oniceconnectionstatechange] - Reconnect timeout reached. Closing PeerConnection."), clearTimeout(r), n._responder.onPeerConnectionClose(t);
              }, 5e3) : r && ((0, w.debug)(k, "[peer.oniceconnectionstatechange] - Clearing timeout for reconnect."), clearTimeout(r));
            }, e.onicegatheringstatechange = function () {
              var t = e.iceGatheringState;
              (0, w.debug)(k, "[peer.onicegatheringstatechange] - State: " + t), "complete" === t && n._responder.onPeerGatheringComplete();
            }, e.onremovestream = function () {
              (0, w.debug)(k, "[peer.onremovestream]");
            };
          }
        }, {
          key: "_onDataChannelMessage",
          value: function value(e) {
            var n = e;
            if ((0, v.default)(t.prototype.__proto__ || (0, s.default)(t.prototype), "_onDataChannelMessage", this).call(this, e)) return !0;
            var r = this.getJsonFromSocketMessage(n);
            if (null === r) return (0, w.warn)(this._name, "Determined websocket response not in correct format. Aborting message handle."), !0;
            (0, w.debug)(this._name, "[datachannel-response]: " + (0, o.default)(r, null, 2));
            var i = r.data;
            return i && "status" === i.type ? "NetStream.Play.UnpublishNotify" === i.code ? (this._responder.onUnpublish(), this._responder.onConnectionClosed(), !0) : ((0, w.debug)(k, "[datachannel.message] status :: " + i.code), this._responder.onSubscriberStatus(i), !0) : i && i.status && "NetStream.Play.UnpublishNotify" === i.status ? (this._responder.onUnpublish(), this._responder.onConnectionClosed(), !0) : (this._responder.onDataChannelMessage(this._dataChannel, n), !1);
          }
        }, {
          key: "createAnswer",
          value: function value(e) {
            var t = this;
            (0, w.debug)(k, "[createanswer]");
            var n = new T.DeferredPromise();
            return this._peerConnection.setRemoteDescription(e).then(this._responder.onSDPSuccess).catch(function (e) {
              t._responder.onSDPError(e);
            }), this._peerConnection.createAnswer().then(function (e) {
              e.sdp = g.forceStereoOnLocalAnswer(e.sdp), t._peerConnection.setLocalDescription(e).then(t._responder.onSDPSuccess).catch(function (e) {
                t._responder.onSDPError(e);
              }), n.resolve(e);
            }).catch(n.reject), n.promise;
          }
        }, {
          key: "addIceCandidate",
          value: function value(e) {
            if ((0, w.debug)(k, "checking if empty..."), P(e)) (0, w.debug)(k, "[addicecandidate]:: empty");else if (null !== e) {
              (0, w.debug)(k, "[addicecandidate] :: non-empty");
              var t = new g.RTCIceCandidate({
                sdpMLineIndex: e.sdpMLineIndex,
                candidate: e.candidate
              });

              this._peerConnection.addIceCandidate(t).then(function () {}).catch(function (e) {
                (0, w.error)(k, "Error in add of ICE Candidiate + " + e);
              });
            } else (0, w.debug)(k, "[addicecandidate] :: null"), this._peerConnection.addIceCandidate(e).then(function () {}).catch(function (e) {
              (0, w.error)(k, "Error in add of ICE Candidiate + " + e);
            });
          }
        }]), t;
      }(C.default);

      t.default = O;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RawStream = void 0;
      var i = n(0),
          o = r(i),
          a = n(1),
          s = r(a),
          u = n(102);

      t.RawStream = function () {
        function e() {
          (0, o.default)(this, e);
        }

        return (0, s.default)(e, [{
          key: "write",
          value: function value(e) {
            console.log("%s - [%s] %s: %s", e.time.toISOString(), e.name, u.nameFromLevel[e.level], e.msg);
          }
        }]), e;
      }();
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RTCPublisher = t.RTMPPublisher = t.Red5ProPublisher = void 0;

      var i = n(99),
          o = r(i),
          a = n(101),
          s = r(a),
          u = n(3),
          c = r(u),
          l = n(0),
          d = r(l),
          h = n(1),
          f = r(h),
          p = n(5),
          v = r(p),
          b = n(4),
          _ = r(b),
          m = n(96),
          g = r(m),
          y = n(94),
          S = r(y),
          E = n(19),
          C = r(E),
          T = n(129),
          w = r(T),
          k = n(91),
          P = r(k),
          O = n(8),
          R = n(58),
          A = n(2),
          M = "Red5ProPublisher",
          N = new S.default(),
          I = function () {
        var e = new g.default();
        return e.set(R.PublishTypes.RTC, P.default), e.set(R.PublishTypes.RTMP, w.default), e;
      }(),
          L = function (e) {
        function t() {
          (0, d.default)(this, t);
          var e = (0, v.default)(this, (t.__proto__ || (0, c.default)(t)).call(this));
          return e._options = void 0, e._order = [R.PublishTypes.RTC, R.PublishTypes.RTMP], e;
        }

        return (0, _.default)(t, e), (0, f.default)(t, [{
          key: "_getPublisherFromOrder",
          value: function value(e, t) {
            return N.create(e, I, t, "init");
          }
        }, {
          key: "getPublishOrder",
          value: function value() {
            return this._order;
          }
        }, {
          key: "setPublishOrder",
          value: function value(e) {
            e = "string" == typeof e ? [e] : e;
            var t = e.filter(function (e) {
              var t = void 0;

              for (t in R.PublishTypes) {
                if (R.PublishTypes[t].toLowerCase() === e.toLowerCase()) return !0;
              }

              return !1;
            }).map(function (e) {
              return e.toLowerCase();
            });
            return this._order = [].concat((0, s.default)(new o.default(t))), (0, A.debug)(M, "[orderupdate]: " + this._order), this;
          }
        }, {
          key: "init",
          value: function value(e) {
            var t = new O.DeferredPromise();
            return (0, A.debug)(M, "[publish]"), this._options = e, this._getPublisherFromOrder(this._order, this._options).then(function (e) {
              t.resolve(e);
            }).catch(function (e) {
              (0, A.warn)(M, "[publisherror]: Could not implement a publisher: " + e), t.reject(e);
            }), t.promise;
          }
        }, {
          key: "publishTypes",
          get: function get() {
            return R.PublishTypes;
          }
        }]), t;
      }(C.default);

      t.Red5ProPublisher = L, t.RTMPPublisher = w.default, t.RTCPublisher = P.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(144),
          o = r(i),
          a = n(9),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(81),
          f = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }(h),
          p = n(7),
          v = r(p),
          b = n(89),
          _ = r(b),
          m = n(95),
          g = n(25),
          y = n(8),
          S = n(2),
          E = "R5ProPublisherSourceHandler",
          C = function C(e) {
        return e.exact || e.ideal || e.max || e.min || e;
      },
          T = function T(e, t) {
        var n = (0, g.deepCopy)(t);
        if ("boolean" == typeof e.video) n.video = e.video;else {
          var r = void 0;

          for (r in e.video) {
            n[r] = C(e.video[r]);
          }

          n.video = !0;
        }
        return n.audio = "boolean" != typeof e.audio || e.audio, n;
      },
          w = function () {
        function e(t, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
          (0, c.default)(this, e), this.video = t, this.clone = this.video.cloneNode(!0), this.holder = this.video.parentNode, this._publisherType = n, this._swfId = null, this._embedFuture = void 0, this._soResponder = r || new _.default();
        }

        return (0, d.default)(e, [{
          key: "getEmbedOperation",
          value: function value() {
            return this._embedFuture = y.Future.createIfNotExist(this._embedFuture), this._embedFuture.promise;
          }
        }, {
          key: "cleanUp",
          value: function value() {
            this.video.remove(), this.video = this.clone.cloneNode(!0), this.holder.appendChild(this.video), this._embedFuture = void 0;
          }
        }, {
          key: "addSource",
          value: function value(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
            (0, S.debug)(E, "[addsource]");
            var i = this;
            this._swfId = e, this._embedFuture = y.Future.createIfNotExist(this._embedFuture);
            var o = this._embedFuture;
            return t.swf = n || t.swf, t.minFlashVersion = r || t.minFlashVersion, f.defineEmbedElement(this.video, this.holder).then(function (n) {
              (0, S.debug)(E, "[element:complete]");
              var r = {
                buffer: null != t.buffer ? t.buffer : 1,
                streamMode: t.streamMode,
                streamName: t.streamName,
                appName: t.app,
                host: t.host
              };
              return t.backgroundColor && (r.backgroundColor = t.backgroundColor), t.context && (r.roomName = t.context), "100%" !== t.embedWidth && "100%" !== t.embedHeight || (r.autosize = !0), void 0 !== t.connectionParams && (r.connectionParams = encodeURIComponent((0, s.default)(t.connectionParams))), r = T(t.mediaConstraints, r), f.embedSwfObject(e, t, r, v.default.getSwfObject(), n);
            }).then(function () {
              (0, S.debug)(E, "[embed:complete]"), o.resolve(i);
            }).catch(function (e) {
              return o.reject(e);
            }), o.promise;
          }
        }, {
          key: "connect",
          value: function value(e) {
            (0, S.debug)(E, "[connect]");
            var t = v.default.getEmbedObject(this._swfId);
            t ? (t.connect(e), this._soResponder.connect(this._swfId)) : (0, S.warn)(E, "Could not determine embedded element with swf id: " + this._swfId + ".");
          }
        }, {
          key: "disconnect",
          value: function value() {
            (0, S.debug)(E, "[disconnect]");

            try {
              var e = v.default.getEmbedObject(this._swfId);
              e && e.disconnect();
            } catch (e) {}

            this.cleanUp(), this._soResponder.disconnect();
          }
        }, {
          key: "send",
          value: function value(e, t) {
            var n = v.default.getEmbedObject(this._swfId);
            n && n.send(e, t);
          }
        }, {
          key: "addSharedObjectResponseHandler",
          value: function value(e) {
            this._soResponder.addResponseHandler(e);
          }
        }, {
          key: "removeSharedObjectResponseHandler",
          value: function value(e) {
            this._soResponder.removeResponseHandler(e);
          }
        }, {
          key: "sendToSharedObject",
          value: function value(e, t, n) {
            this._soResponder.sendToSharedObject(e, t, n);
          }
        }, {
          key: "sendPropertyToSharedObject",
          value: function value(e, t, n) {
            this._soResponder.sendPropertyToSharedObject(e, t, n);
          }
        }, {
          key: "getRemoteSharedObject",
          value: function value(e) {
            this._soResponder.getRemoteSharedObject(e);
          }
        }, {
          key: "connectToSharedObject",
          value: function value(e) {
            this._soResponder.connectToSharedObject(e);
          }
        }, {
          key: "closeSharedObject",
          value: function value(e) {
            this._soResponder.closeSharedObject(e);
          }
        }, {
          key: "setMediaQuality",
          value: function value(e) {
            var t = v.default.getEmbedObject(this._swfId);

            if (t && e.video && "boolean" != typeof e.video) {
              var n = isNaN(e.video.width) ? o.default : (0, m.toInt)(e.video.width),
                  r = isNaN(e.video.height) ? o.default : (0, m.toInt)(e.video.height);
              t.updateResolution(n, r);
            }
          }
        }, {
          key: "getType",
          value: function value() {
            return this._publisherType;
          }
        }]), e;
      }();

      t.default = w;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(26),
          s = r(a),
          u = n(3),
          c = r(u),
          l = n(0),
          d = r(l),
          h = n(1),
          f = r(h),
          p = n(5),
          v = r(p),
          b = n(4),
          _ = r(b),
          m = n(19),
          g = r(m),
          y = n(7),
          S = r(y),
          E = n(128),
          C = r(E),
          T = n(61),
          w = r(T),
          k = n(11),
          P = n(8),
          O = n(58),
          R = n(90),
          A = n(2),
          M = "RTMPPublisher",
          N = {
        protocol: "rtmp",
        port: 1935,
        streamMode: "live",
        mediaElementId: "red5pro-publisher",
        embedWidth: "100%",
        embedHeight: "100%",
        minFlashVersion: "10.0.0",
        swf: "lib/red5pro/red5pro-publisher.swf",
        swfobjectURL: "lib/swfobject/swfobject.js",
        productInstallURL: "lib/swfobject/playerProductInstall.swf",
        mediaConstraints: new R.RTMPMediaConstraint()
      },
          I = function (e) {
        function t() {
          (0, d.default)(this, t);
          var e = (0, v.default)(this, (t.__proto__ || (0, c.default)(t)).call(this));
          return e._options = void 0, e._view = void 0, e._sourceHandler = void 0, e._elementId = void 0, e._connectFuture = void 0, e;
        }

        return (0, _.default)(t, e), (0, f.default)(t, [{
          key: "_setViewIfNotExist",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;

            if (void 0 === e && void 0 !== t) {
              new w.default(t).attachPublisher(this);
            }
          }
        }, {
          key: "setView",
          value: function value(e, t) {
            var n = this;
            return this._view = e, this._elementId = t, void 0 !== this._sourceHandler && (this._sourceHandler.disconnect(), this._sourceHandler = void 0), this._view && (this._sourceHandler = new C.default(this._view.view, this.getType())), this._options && this._sourceHandler && this._sourceHandler.addSource(this._elementId, this._options).catch(function (e) {
              (0, A.error)(M, "Could not establish proper RTMP publisher: " + e), n.trigger(new k.PublisherEvent(k.RTMPPublisherEventTypes.EMBED_FAILURE, n));
            }), this;
          }
        }, {
          key: "_setUpConnectCallback",
          value: function value(e) {
            var t = this;

            window.setActiveId = function (n) {
              (0, A.debug)(M, "Embed and connect() complete for publisher swf. successId(" + n + ")."), e.resolve(t), t.trigger(new k.PublisherEvent(k.RTMPPublisherEventTypes.EMBED_SUCCESS, t)), t._tearDownConnectCallback();
            };
          }
        }, {
          key: "_tearDownConnectCallback",
          value: function value() {
            window.setActiveId = void 0;
          }
        }, {
          key: "_establishExtIntHandlers",
          value: function value() {
            var e = this,
                t = this._options.streamName,
                n = function n(e) {
              return ["publisher", e, t.split("-").join("_")].join("_");
            };

            window[n("r5proConnectClosed")] = function () {
              e.trigger(new k.PublisherEvent(k.PublisherEventTypes.CONNECTION_CLOSED, e));
            }, window[n("r5proConnectSuccess")] = function () {
              return e.trigger(new k.PublisherEvent(k.PublisherEventTypes.CONNECT_SUCCESS, e));
            }, window[n("r5proUnpublishSuccess")] = function () {
              return e.trigger(new k.PublisherEvent(k.PublisherEventTypes.UNPUBLISH_SUCCESS, e));
            }, window[n("r5proPublishStart")] = function () {
              e._connectFuture.resolve(e), e.trigger(new k.PublisherEvent(k.PublisherEventTypes.PUBLISH_START, e));
            }, window[n("r5proPublishMetadata")] = function (t) {
              return e.trigger(new k.PublisherEvent(k.PublisherEventTypes.PUBLISH_METADATA, e, t));
            }, window[n("r5proPublishInsufficientBW")] = function (t) {
              return e.trigger(new k.PublisherEvent(k.PublisherEventTypes.PUBLISH_INSUFFICIENT_BANDWIDTH, e, t));
            }, window[n("r5proPublishSufficientBW")] = function (t) {
              return e.trigger(new k.PublisherEvent(k.PublisherEventTypes.PUBLISH_SUFFICIENT_BANDWIDTH, e, t));
            }, window[n("r5proPublishRecoveringBW")] = function (t) {
              return e.trigger(new k.PublisherEvent(k.PublisherEventTypes.PUBLISH_RECOVERING_BANDWIDTH, e, t));
            }, window[n("r5proConnectFailure")] = function () {
              e._connectFuture.reject(k.PublisherEventTypes.CONNECT_FAILURE), e.trigger(new k.PublisherEvent(k.PublisherEventTypes.CONNECT_FAILURE, e));
            }, window[n("r5proPublishFail")] = function () {
              e._connectFuture.reject(k.PublisherEventTypes.PUBLISH_FAIL), e.trigger(new k.PublisherEvent(k.PublisherEventTypes.PUBLISH_FAIL, e));
            }, window[n("r5proPublishInvalidName")] = function () {
              e._connectFuture.reject(k.PublisherEventTypes.PUBLISH_INVALID_NAME), e.trigger(new k.PublisherEvent(k.PublisherEventTypes.PUBLISH_INVALID_NAME, e));
            };
          }
        }, {
          key: "init",
          value: function value(e) {
            var t = this,
                n = new P.DeferredPromise(),
                r = e.minFlashVersion || N.minFlashVersion;

            if (S.default.supportsFlashVersion(r)) {
              this._options = (0, s.default)({}, N, e);

              try {
                S.default.injectScript(this._options.swfobjectURL).then(function () {
                  return (0, A.debug)(M, "SWFObject embedded."), t._sourceHandler ? ((0, A.debug)(M, "Publish handler established."), t._sourceHandler.addSource(t._elementId, t._options)) : ((0, A.debug)(M, "Publish handler not established."), !0);
                }).then(function () {
                  t._setViewIfNotExist(t._view, t._options.mediaElementId), n.resolve(t);
                }).catch(function (e) {
                  (0, A.error)(M, "Could not embed Flash-based RTMP Publisher. Reason: " + e), t._sourceHandler && t._sourceHandler.disconnect(), n.reject(e), t.trigger(new k.PublisherEvent(k.RTMPPublisherEventTypes.EMBED_FAILURE, t));
                });
              } catch (e) {
                n.reject("Could not inject Flash-based Publisher into the page. Reason: " + e.message), t.trigger(new k.PublisherEvent(k.RTMPPublisherEventTypes.EMBED_FAILURE, t));
              }
            } else n.reject("Could not resolve RTMPPublisher instance. Requires minimum Flash Player install of " + r);

            return n.promise;
          }
        }, {
          key: "publish",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
                r = n || new P.DeferredPromise();
            this._setUpConnectCallback(r), this._options.streamName = t || this._options.streamName;
            var i = this._options;

            try {
              var a = this._sourceHandler;

              this._sourceHandler.getEmbedOperation().then(function () {
                (0, A.debug)(M, "[handler:embed:complete]"), S.default.getEmbedObject(e._elementId) && e._establishExtIntHandlers();
                var t = 0;
                !function e() {
                  var n = void 0;
                  n = setTimeout(function () {
                    try {
                      clearTimeout(n), a.connect((0, o.default)(i));
                    } catch (n) {
                      if (t++ > 100) throw n;
                      e();
                    }
                  }, 300);
                }();
              }).catch(function (t) {
                r.reject(t), e.trigger(new k.PublisherEvent(k.PublisherEventTypes.CONNECT_FAILURE, e));
              });
            } catch (e) {
              (0, A.error)(M, "[handler:embed:error]"), r.reject("Could not initiate connection sequence. Reason: " + e.message), this.trigger(new k.PublisherEvent(k.PublisherEventTypes.CONNECT_FAILURE, this)), this._tearDownConnectCallback();
            }

            return this._connectFuture = r, r.promise;
          }
        }, {
          key: "unpublish",
          value: function value() {
            var e = new P.DeferredPromise();

            try {
              S.default.getEmbedObject(this._elementId).unpublish(), e.resolve();
            } catch (t) {
              (0, A.error)(M, "Could not initiate publish sequence. Reason: " + t.message), e.reject(t.message);
            }

            return this._connectFuture = void 0, e.promise;
          }
        }, {
          key: "send",
          value: function value(e, t) {
            this._sourceHandler.send(e, "string" == typeof t ? t : (0, o.default)(t));
          }
        }, {
          key: "setMediaQuality",
          value: function value(e) {
            this._sourceHandler && this._sourceHandler.setMediaQuality(e);
          }
        }, {
          key: "overlayOptions",
          value: function value(e) {
            this._options = (0, s.default)(this._options, e);
          }
        }, {
          key: "getConnection",
          value: function value() {
            return this._sourceHandler;
          }
        }, {
          key: "getOptions",
          value: function value() {
            return this._options;
          }
        }, {
          key: "getType",
          value: function value() {
            return O.PublishTypes.RTMP.toUpperCase();
          }
        }]), t;
      }(g.default);

      t.default = I;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Red5ProSharedObjectPeerConnection = t.Red5ProSharedObjectSocket = t.Red5ProSharedObject = void 0;
      var i = n(132),
          o = r(i),
          a = n(92),
          s = r(a),
          u = n(131),
          c = r(u);
      t.Red5ProSharedObject = o.default, t.Red5ProSharedObjectSocket = s.default, t.Red5ProSharedObjectPeerConnection = c.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(3),
          o = r(i),
          a = n(0),
          s = r(a),
          u = n(1),
          c = r(u),
          l = n(5),
          d = r(l),
          h = n(27),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(31),
          _ = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }(b),
          m = n(60),
          g = r(m),
          y = n(7),
          S = r(y),
          E = n(92),
          C = r(E),
          T = n(25),
          w = n(11),
          k = n(8),
          P = n(2),
          O = /(.*) starting/i,
          R = function (e) {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
          (0, s.default)(this, t);
          var n = Math.floor(65536 * Math.random()).toString(16),
              r = "sharedobject-" + n,
              i = (0, d.default)(this, (t.__proto__ || (0, o.default)(t)).call(this, e, r));
          return i.id = r, i._options = void 0, i._socket = void 0, i._sharedObjectName = void 0, i._connectionPromise = void 0, i;
        }

        return (0, v.default)(t, e), (0, c.default)(t, [{
          key: "_removeConnectionHandlers",
          value: function value(e) {
            e.onconnectionstatechange = void 0, e.oniceconnectionstatechange = void 0, e.onicecandidate = void 0, e.ontrack = void 0, e.ondatachannel = void 0;
          }
        }, {
          key: "_addConnectionHandlers",
          value: function value(e, t) {
            var n = this,
                r = void 0;
            t = t || this._connectionPromise, e.onconnectionstatechange = function () {
              (0, P.debug)(n._name, "[peer.onconnectionstatechange] - State: " + e.connectionState), "connected" === e.connectionState ? ((0, P.debug)(n._name, "[peerconnection:open]"), n.trigger(new w.MessageTransportStateEvent(w.MessageTransportStateEventTypes.OPEN, n._name, {
                peerConnection: n
              }))) : "failed" !== e.connectionState && "disconnected" !== e.connectionState || ((0, P.warn)(n._name, "[peerconnection:error]"), "failed" === e.connectionState && n.trigger(new w.MessageTransportStateEvent(w.MessageTransportStateEventTypes.ERROR, n._name, {
                peerConnection: n,
                error: "Connection Failed."
              })), t && t.reject("Connection Failed."));
            }, e.onicecandidate = function (e) {
              (0, P.debug)(n._name, "[peer.onicecandidate] - Peer Candidate: " + e.candidate), e.candidate ? n._socket.post({
                handleCandidate: n._name,
                data: {
                  candidate: e.candidate
                }
              }) : null === e.candidate && (0, P.debug)(n._name, "[icecandidatetrickle:end]");
            }, e.oniceconnectionstatechange = function (i) {
              var o = e.iceConnectionState;
              (0, P.debug)(n._name, "[peer.oniceconnectionstatechange] - State: " + o), "connected" === o && S.default.getIsEdge() ? ((0, P.debug)(n._name, "[edge/ortc:notify complete]"), (0, P.debug)(n._name, "[icecandidategathering:end]"), n._socket.postEndOfCandidates(n._name)) : "failed" === o ? (r && clearTimeout(r), n.trigger(new w.MessageTransportStateEvent(w.MessageTransportStateEventTypes.ERROR, n._name, {
                peerConnection: n,
                error: "Connection Failed."
              })), n.trigger(new w.MessageTransportStateEvent(w.MessageTransportStateEventTypes.CLOSE, n._name, {
                peerConnection: n,
                event: i
              })), t && t.reject("Connection Failed.")) : "disconnected" === o ? r = setTimeout(function () {
                (0, P.debug)(n._name, "[peer.oniceconnectionstatechange] - Reconnect timeout reached. Closing PeerConnection."), clearTimeout(r), n.trigger(new w.MessageTransportStateEvent(w.MessageTransportStateEventTypes.CLOSE, n._name, {
                  peerConnection: n,
                  event: i
                }));
              }, 5e3) : r && ((0, P.debug)(n._name, "[peer.oniceconnectionstatechange] - Clearing timeout for reconnect."), clearTimeout(r));
            }, e.onicegatheringstatechange = function () {
              var t = e.iceGatheringState;
              (0, P.debug)(n._name, "[peer.onicegatheringstatechange] - State: " + t), "complete" === t && ((0, P.debug)(n._name, "[icecandidategathering:end]"), n._socket.postEndOfCandidates(n._name));
            };
          }
        }, {
          key: "_createOffer",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
            (0, P.debug)(this._name, "[peer.createoffer]"), this._peerConnection.createOffer().then(function (n) {
              (0, P.debug)(e._name, "[peer:offer] " + n.sdp), e._peerConnection.setLocalDescription(n).then(function () {
                e._socket.post({
                  handleOffer: e._name,
                  transport: "udp",
                  data: {
                    sdp: n
                  }
                });
              }).catch(function (e) {
                t && t.reject(e);
              });
            });
          }
        }, {
          key: "getRemoteSharedObject",
          value: function value(e) {
            (0, f.default)(t.prototype.__proto__ || (0, o.default)(t.prototype), "getRemoteSharedObject", this).call(this, e), this._sharedObjectName = e;
          }
        }, {
          key: "init",
          value: function value(e) {
            var t = this,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
                r = new k.DeferredPromise();
            return this.id = n || this.id, this._name = this.id, this._options = e, this._socket = new C.default(this), this._socket.on("MessageTransport.Open", function (n) {
              (0, P.debug)(t._name, "[socket:event] - " + n.type), t._connectionPromise = r, t.setUpWithPeerConfiguration(e.rtcConfiguration, t.getDataChannelConfiguration(e)).then(function () {
                t._createOffer(r);
              }).catch(function (e) {
                t.trigger(new w.MessageTransportStateEvent(w.MessageTransportStateEventTypes.ERROR, t._name, {
                  peerConnection: t,
                  error: e
                })), r.reject(e);
              });
            }), this._socket.init(e, this.id, 4).catch(function (e) {
              t.trigger(new w.MessageTransportStateEvent(w.MessageTransportStateEventTypes.ERROR, t._name, {
                peerConnection: t,
                error: e
              })), r.reject(e);
            }), r.promise;
          }
        }, {
          key: "getMessageTransport",
          value: function value() {
            return this._socket || this;
          }
        }, {
          key: "getDataChannelConfiguration",
          value: function value(e) {
            return e.dataChannelConfiguration || {
              name: "red5pro"
            };
          }
        }, {
          key: "getDataChannelName",
          value: function value(e) {
            var t = e.dataChannelConfiguration;
            return t && t.name ? t.name : "red5pro";
          }
        }, {
          key: "onIceTrickleComplete",
          value: function value() {
            (0, P.debug)(this._name, "[peer:icetricklecomplete]"), this._socket.post({
              startChannel: this.getDataChannelName(this._options)
            });
          }
        }, {
          key: "onAddIceCandidate",
          value: function value(e) {
            (0, P.debug)(this._name, "[peer:addicecandidate]"), (0, T.isObjectEmpty)(e.candidate) ? (0, P.debug)(this._name, "[peer:onemptycandidate]") : this._peerConnection.addIceCandidate(e);
          }
        }, {
          key: "onSDPAnswer",
          value: function value(e) {
            var t = this;
            (0, P.debug)(this._name, "[peer:handleanswer]"), this._peerConnection.setRemoteDescription(new _.RTCSessionDescription(e)).then(function () {}).catch(function (e) {
              t.trigger(new w.MessageTransportStateEvent(w.MessageTransportStateEventTypes.ERROR, t._name, {
                peerConnection: t,
                error: e
              })), t._connectionPromise.reject(e);
            });
          }
        }, {
          key: "onDataChannelAvailable",
          value: function value(e) {
            this._socket.sever({
              switchChannel: e || "red5pro"
            }), this._socket = void 0, this._connectionPromise.resolve(this);
          }
        }, {
          key: "onSocketStatus",
          value: function value(e) {
            if (e.message) {
              var t = O.exec(e.message);
              (0, P.debug)(this._name, "[peer:status] " + e.message), t && t.length;
            }
          }
        }]), t;
      }(g.default);

      t.default = R;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(38),
          s = r(a),
          u = n(3),
          c = r(u),
          l = n(5),
          d = r(l),
          h = n(4),
          f = r(h),
          p = n(0),
          v = r(p),
          b = n(1),
          _ = r(b),
          m = n(19),
          g = r(m),
          y = n(7),
          S = r(y),
          E = n(11),
          C = n(2),
          T = "Red5ProSharedObject",
          w = function w(e, t) {
        (0, C.debug)([T, e].join(":"), t);
      },
          k = function k(e, t) {
        (0, C.warn)([T, e].join(":"), t);
      },
          P = function P(e, t) {
        (0, C.error)([T, e].join(":"), t);
      },
          O = function O(e) {
        return "string" == typeof e ? JSON.parse(e) : e;
      },
          R = function () {
        function e(t, n) {
          (0, v.default)(this, e), this.key = t, this.value = n;
        }

        return (0, _.default)(e, [{
          key: "toObject",
          value: function value() {
            var e = {};
            return e[this.key] = this.value, e;
          }
        }]), e;
      }(),
          A = function () {
        function e(t, n) {
          (0, v.default)(this, e), this.methodName = t;
          var r = void 0;

          if ("[object Array]" === Object.prototype.toString.call(n)) {
            var i = void 0,
                o = void 0,
                a = n.length;

            for (r = [], i = 0; i < a; i++) {
              o = O(n[i]), "[object Array]" === Object.prototype.toString.call(n) ? r = r.concat(o) : r.push(o);
            }
          } else r = [O(n)];

          this.message = 1 === r.length ? r[0] : r;
        }

        return (0, _.default)(e, [{
          key: "toObject",
          value: function value() {
            return {
              methodName: this.methodName,
              message: this.message
            };
          }
        }]), e;
      }(),
          M = function (e) {
        function t(e, n) {
          (0, v.default)(this, t);
          var r = (0, d.default)(this, (t.__proto__ || (0, c.default)(t)).call(this));
          return r._name = e, r._transport = void 0, r._transportController = void 0, r._onclose = r.close.bind(r), r._handleTransportStateEvents = r._handleTransportStateEvents.bind(r), r._handleMessageTransportChange = r._handleMessageTransportChange.bind(r), r.setMessageTransportController(n), r;
        }

        return (0, f.default)(t, e), (0, _.default)(t, [{
          key: "_establishTransport",
          value: function value(e) {
            e.addSharedObjectResponseHandler(this);

            try {
              w(this._name, "[sharedobject:connect:attempt]"), e.on("*", this._handleSocketStateEvents), e.getRemoteSharedObject(this._name), S.default.addCloseHandler(this._onclose, 0);
            } catch (e) {
              P(this._name, "[sharedobject:connect:error]: " + e.message), this._transport = void 0, this._transportController = void 0;
            }
          }
        }, {
          key: "_handleMessageTransportChange",
          value: function value(e) {
            var t = this,
                n = e.data.controller,
                r = setTimeout(function () {
              clearTimeout(r), t.setMessageTransportController(n);
            }, 1e3);
          }
        }, {
          key: "_handleTransportStateEvents",
          value: function value(e) {
            w(this._name, e.name + ": " + e.type), e.type === E.MessageTransportStateEventTypes.CLOSE && (this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.CONNECTION_CLOSED, this._name)), this.close());
          }
        }, {
          key: "_getJsonFromSocketMessage",
          value: function value(e) {
            try {
              return "string" == typeof e.data ? JSON.parse(e.data) : e.data;
            } catch (t) {
              k(this._name, "Could not parse message as JSON. Message= " + e.data + ". Error= " + t.message);
            }

            return null;
          }
        }, {
          key: "_notifyOfPropertyValues",
          value: function value(e) {
            if (0 === (0, s.default)(e).length) this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.PROPERTY_UPDATE, this._name, {}));else {
              var t = void 0;

              for (t in e) {
                this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.PROPERTY_UPDATE, this._name, new R(t, e[t]).toObject()));
              }
            }
          }
        }, {
          key: "_notifyOfEvents",
          value: function value(e) {
            var t = void 0,
                n = void 0,
                r = !1,
                i = e.length;

            for (t = 0; t < i; t++) {
              switch (n = e[t], n.subtype) {
                case 9:
                  this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.PROPERTY_REMOVE, this._name, {
                    attribute: n.attribute
                  })), r = !0;
                  break;

                case 4:
                  n.attributes ? this._notifyOfPropertyValues(n.attributes) : this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.PROPERTY_UPDATE, this._name, new R(n.attribute, n.value).toObject())), r = !0;
                  break;

                case 6:
                  this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.METHOD_UPDATE, this._name, new A(n.method, n.value).toObject())), r = !0;
              }
            }

            return r;
          }
        }, {
          key: "respond",
          value: function value(e) {
            if (e.data) {
              var t = this._getJsonFromSocketMessage(e);

              if (null === t) return k(this._name, "Determined message response not in correct format. Aborting message handle."), !0;
              if (void 0 !== t.data) if (t.data.name === this._name) {
                if (w(this._name, "[sharedobject-response]: " + (0, o.default)(t, null, 2)), "SharedObject.Status.GetRemote" === t.data.status && "Success" === t.data.message) return this._transport.connectToSharedObject(this._name), !0;
                if ("SharedObject.Status.GetRemote" === t.data.status && "Fail" === t.data.message) return this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.CONNECT_FAILURE, this._name)), !0;
                if ("SharedObject.Status.Connect" === t.data.status && "Success" === t.data.message) return this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.CONNECT_SUCCESS, this._name)), !0;
                if ("SharedObject.Status.Connect" === t.data.status && "Fail" === t.data.message) return this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.CONNECT_FAILURE, this._name)), !0;
                if ("SharedObject.Status.Disconnect" === t.data.status) return this.trigger(new E.SharedObjectEvent(E.SharedObjectEventTypes.CONNECTION_CLOSED, this._name)), !0;

                if ("sharedobject" === t.data.type) {
                  if (t.data.hasOwnProperty("events")) return this._notifyOfEvents(t.data.events);
                  if (t.data.hasOwnProperty("value")) return this._notifyOfPropertyValues(t.data.value);
                }
              } else w(this._name, "Unhandled Message exchange: " + (0, o.default)(t, null, 2));
            }

            return !1;
          }
        }, {
          key: "send",
          value: function value(e, t) {
            var n = this._transport;
            n ? n.sendToSharedObject(this._name, e, t) : k(this._name, "No WebSocket connection available!");
          }
        }, {
          key: "setProperty",
          value: function value(e, t) {
            this._transport.sendPropertyToSharedObject(this._name, e, t);
          }
        }, {
          key: "close",
          value: function value() {
            var e = this._transport;

            if (e) {
              try {
                e.closeSharedObject(this._name);
              } catch (e) {}

              e.removeSharedObjectResponseHandler(this), e.off("*", this._handleTransportStateEvents);
            }

            this._transport = void 0, this._transportController = void 0, S.default.removeCloseHandler(this._onclose);
          }
        }, {
          key: "getMessageTransportController",
          value: function value() {
            return this._transportController;
          }
        }, {
          key: "setMessageTransportController",
          value: function value(e) {
            this._transport && (this._transport.removeSharedObjectResponseHandler(this), this._transport.off("*", this._handleTransportStateEvents), S.default.removeCloseHandler(this._onclose), this._transport = void 0, this._transportController = void 0), this._transportController = e, this._transport = this._transportController.getMessageTransport(), this._transportController && this._transport && (this._transportController.on(E.MessageTransportStateEventTypes.CHANGE, this._handleMessageTransportChange), this._establishTransport(this._transport));
          }
        }, {
          key: "getName",
          value: function value() {
            return this._name;
          }
        }]), t;
      }(g.default);

      t.default = M;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(3),
          o = r(i),
          a = n(0),
          s = r(a),
          u = n(1),
          c = r(u),
          l = n(5),
          d = r(l),
          h = n(4),
          f = r(h),
          p = n(19),
          v = r(p),
          b = n(7),
          _ = r(b),
          m = n(93),
          g = n(2),
          y = "ControlSlider",
          S = function (e) {
        function t(e) {
          (0, s.default)(this, t);
          var n = (0, d.default)(this, (t.__proto__ || (0, o.default)(t)).call(this));
          return n.name = [y, e].join("::"), (0, g.debug)(n.name, "[init]"), n._container = _.default.createElement("div"), n._button = n.createButton(), n._track = n.createTrack(), n._progressBar = n.createProgressBar(), n._container.appendChild(n._track), n._container.appendChild(n._progressBar), n._container.appendChild(n._button), n._value = 0, n._disabled = !1, n._eventStartPosition = 0, n._layout(), n._mouseupHandler = n._mouseup.bind(n), n._mousedownHandler = n._mousedown.bind(n), n._mousemoveHandler = n._mousemove.bind(n), n._touchupHandler = n._touchproxy.bind(n), n._touchdownHandler = n._touchproxy.bind(n), n._touchmoveHandler = n._touchproxy.bind(n), n._updateHandlers(n._disabled), n;
        }

        return (0, f.default)(t, e), (0, c.default)(t, [{
          key: "_touchproxy",
          value: function value(e) {
            if (e.preventDefault(), !(e.touches.length > 1 || "touchend" == e.type && e.touches.length > 0)) {
              var t = _.default.createEvent("MouseEvent"),
                  n = void 0,
                  r = void 0,
                  i = e.originalTarget || e.target;

              switch (e.type) {
                case "touchstart":
                  n = "mousedown", r = e.changedTouches[0];
                  break;

                case "touchmove":
                  n = "mousemove", r = e.changedTouches[0];
                  break;

                case "touchend":
                  n = "mouseup", r = e.changedTouches[0];
              }

              t.initMouseEvent(n, !0, !0, i.ownerDocument.defaultView, 0, r.screenX, r.screenY, r.clientX, r.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, 0, null), i.dispatchEvent(t);
            }
          }
        }, {
          key: "_mouseup",
          value: function value() {
            this._eventStartPosition = 0, document.removeEventListener("mousemove", this._mousemoveHandler), document.removeEventListener("mouseup", this._mouseupHandler), document.removeEventListener("touchmove", this._touchmoveHandler), document.removeEventListener("touchup", this._touchupHandler), this.trigger(new m.SliderEvent(m.SliderEventTypes.CHANGE_COMPLETE, this));
          }
        }, {
          key: "_mousemove",
          value: function value(e) {
            var t = _.default.getMouseXFromEvent(e) - this._eventStartPosition,
                n = this._button.parentNode.getBoundingClientRect(),
                r = this._eventStartPosition + t - n.left;

            r = Math.max(0, r), r = Math.min(r, n.width);
            var i = r / n.width;
            this.trigger(new m.SliderEvent(m.SliderEventTypes.CHANGE, this, i));
          }
        }, {
          key: "_mousedown",
          value: function value(e) {
            this._eventStartPosition = _.default.getMouseXFromEvent(e), this.trigger(new m.SliderEvent(m.SliderEventTypes.CHANGE_START, this)), document.addEventListener("mousemove", this._mousemoveHandler), document.addEventListener("mouseup", this._mouseupHandler), document.addEventListener("touchmove", this._touchmoveHandler), document.addEventListener("touchup", this._touchupHandler);
          }
        }, {
          key: "_updateHandlers",
          value: function value(e) {
            this._eventStartPosition = 0, e ? (this._track.removeEventListener("click", this._mousemoveHandler), this._progressBar.removeEventListener("click", this._mousemoveHandler), this._button.removeEventListener("mousedown", this._mousedownHandler), document.removeEventListener("mousemove", this._mousemoveHandler), document.removeEventListener("mouseup", this._mouseupHandler), document.removeEventListener("touchmove", this._touchmoveHandler), document.removeEventListener("touchup", this._touchupHandler), this._track.classList.add("red5pro-media-slider-disabled"), this._progressBar.classList.add("red5pro-media-slider-disabled"), this._button.classList.add("red5pro-media-slider-disabled")) : (this._track.addEventListener("click", this._mousemoveHandler), this._progressBar.addEventListener("click", this._mousemoveHandler), this._button.addEventListener("mousedown", this._mousedownHandler), this._button.addEventListener("touchstart", this._touchdownHandler), this._track.classList.remove("red5pro-media-slider-disabled"), this._progressBar.classList.remove("red5pro-media-slider-disabled"), this._button.classList.remove("red5pro-media-slider-disabled"));
          }
        }, {
          key: "_layout",
          value: function value() {
            var e = this._progressBar.parentNode.clientWidth * this._value;
            this._progressBar.style.width = e + "px", this._button.style.left = e - .5 * this._button.clientWidth + "px";
          }
        }, {
          key: "createButton",
          value: function value() {
            var e = _.default.createElement("span");

            return e.classList.add("red5pro-media-slider-button"), e;
          }
        }, {
          key: "createProgressBar",
          value: function value() {
            var e = _.default.createElement("span");

            return e.classList.add("red5pro-media-slider-progress"), e;
          }
        }, {
          key: "createTrack",
          value: function value() {
            var e = _.default.createElement("span");

            return e.classList.add("red5pro-media-slider-track"), e;
          }
        }, {
          key: "value",
          get: function get() {
            return this._value;
          },
          set: function set(e) {
            this._value = e, this._layout();
          }
        }, {
          key: "disabled",
          get: function get() {
            return this._disabled;
          },
          set: function set(e) {
            this._disabled = e, this._updateHandlers(e);
          }
        }, {
          key: "view",
          get: function get() {
            return this._container;
          }
        }]), t;
      }(v.default);

      t.default = S;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.RTMPSubscriber = t.HLSSubscriber = t.RTCSubscriber = t.Red5ProSubscriber = void 0;

      var i = n(99),
          o = r(i),
          a = n(101),
          s = r(a),
          u = n(3),
          c = r(u),
          l = n(0),
          d = r(l),
          h = n(1),
          f = r(h),
          p = n(5),
          v = r(p),
          b = n(4),
          _ = r(b),
          m = n(96),
          g = r(m),
          y = n(94),
          S = r(y),
          E = n(19),
          C = r(E),
          T = n(136),
          w = r(T),
          k = n(137),
          P = r(k),
          O = n(135),
          R = r(O),
          A = n(8),
          M = n(36),
          N = n(2),
          I = "Red5ProSubscriber",
          L = new S.default(),
          j = function () {
        var e = new g.default();
        return e.set(M.PlaybackTypes.RTC, w.default), e.set(M.PlaybackTypes.RTMP, P.default), e.set(M.PlaybackTypes.HLS, R.default), e;
      }(),
          D = function (e) {
        function t() {
          (0, d.default)(this, t);
          var e = (0, v.default)(this, (t.__proto__ || (0, c.default)(t)).call(this));
          return e._options = void 0, e._order = [M.PlaybackTypes.RTC, M.PlaybackTypes.RTMP, M.PlaybackTypes.HLS], e;
        }

        return (0, _.default)(t, e), (0, f.default)(t, [{
          key: "_getPlaybackFromOrder",
          value: function value(e, t) {
            return L.create(e, j, t, "init");
          }
        }, {
          key: "getPlaybackOrder",
          value: function value() {
            return this._order;
          }
        }, {
          key: "setPlaybackOrder",
          value: function value(e) {
            e = "string" == typeof e ? [e] : e;
            var t = e.filter(function (e) {
              var t = void 0;

              for (t in M.PlaybackTypes) {
                if (M.PlaybackTypes[t].toLowerCase() === e.toLowerCase()) return !0;
              }

              return !1;
            }).map(function (e) {
              return e.toLowerCase();
            });
            return this._order = [].concat((0, s.default)(new o.default(t))), (0, N.debug)(I, "[orderupdate]: " + this._order), this;
          }
        }, {
          key: "init",
          value: function value(e) {
            this._options = e;
            var t = new A.DeferredPromise();
            return (0, N.debug)(I, "[init]"), this._getPlaybackFromOrder(this._order, this._options).then(function (e) {
              (0, N.debug)(I, "[init:success]: subscriber found " + e.getType()), t.resolve(e);
            }).catch(function (e) {
              (0, N.warn)(I, "[playerror]: Could not implement a subscriber: " + e), t.reject(e);
            }), t.promise;
          }
        }, {
          key: "playbackTypes",
          get: function get() {
            return M.PlaybackTypes;
          }
        }]), t;
      }(C.default);

      t.Red5ProSubscriber = D, t.RTCSubscriber = w.default, t.HLSSubscriber = R.default, t.RTMPSubscriber = P.default;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(26),
          o = r(i),
          a = n(3),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(5),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(7),
          _ = r(b),
          m = n(44),
          g = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }(m),
          y = n(45),
          S = r(y),
          E = n(138),
          C = r(E),
          T = n(47),
          w = r(T),
          k = n(24),
          P = n(11),
          O = n(36),
          R = n(8),
          A = n(2),
          M = n(46),
          N = "HLSSubscriber",
          I = {
        protocol: "https",
        port: 443,
        app: "live",
        mimeType: "application/x-mpegURL",
        mediaElementId: "red5pro-subscriber",
        autoLayoutOrientation: !0,
        muteOnAutoplayRestriction: !0,
        subscriptionId: function () {
          return "subscriber-" + Math.floor(65536 * Math.random()).toString(16);
        }()
      },
          L = /^http(|s).*\.m3u8/g,
          j = function j(e) {
        var t = e.hlsprotocol ? e.hlsprotocol : e.protocol,
            n = e.hlsport ? e.hlsport : e.port,
            r = e.context ? [e.app, e.context].join("/") : e.app;
        return t + "://" + e.host + ":" + n + "/" + r + "/" + e.streamName + ".m3u8";
      },
          D = function (e) {
        function t() {
          (0, c.default)(this, t);
          var e = (0, f.default)(this, (t.__proto__ || (0, s.default)(t)).call(this));
          return e._options = void 0, e._view = void 0, e._sourceHandler = void 0, e._socketHelper = void 0, e._viewResolver = new R.DeferredPromise(), e._subscriptionResolver = new R.DeferredPromise(), e._boundBubbleSubscriberEvents = e.bubbleSubscriberEvents.bind(e), e;
        }

        return (0, v.default)(t, e), (0, d.default)(t, [{
          key: "_getViewResolverPromise",
          value: function value() {
            return this._viewResolver.promise;
          }
        }, {
          key: "_getSubscriptionResolverPromise",
          value: function value() {
            return this._subscriptionResolver.promise;
          }
        }, {
          key: "bubbleSubscriberEvents",
          value: function value(e) {
            e.type === P.SubscriberEventTypes.SUBSCRIBE_START && this._subscriptionResolver.resolve(this), this.trigger(new P.SubscriberEvent(e.type, this, e.data));
          }
        }, {
          key: "_glomSourceHandlerAPI",
          value: function value(e) {
            var t = this;
            this.play = e.play.bind(e), this.pause = e.pause.bind(e), this.resume = e.resume.bind(e), this.stop = e.stop.bind(e), this.mute = e.mute.bind(e), this.unmute = e.unmute.bind(e), this.setVolume = e.setVolume.bind(e), this.seekTo = e.seekTo.bind(e), this.toggleFullScreen = e.toggleFullScreen.bind(e), e.on("*", function (e) {
              t.trigger(new P.SubscriberEvent(e.type, t, e.data));
            });
          }
        }, {
          key: "_setViewIfNotExist",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;

            if (void 0 === e && void 0 !== t) {
              new w.default(t).attachSubscriber(this);
            }
          }
        }, {
          key: "_initHandler",
          value: function value(e) {
            var t = this,
                n = this._options,
                r = n.streamName,
                i = n.mimeType,
                o = r.match(L) ? r : j(this._options);
            this._sourceHandler.on("*", this._boundBubbleSubscriberEvents), this._sourceHandler.addSource(o, i, e).then(function () {
              t.trigger(new P.SubscriberEvent(P.SubscriberEventTypes.CONNECT_SUCCESS)), t._trackStreamingModeState(t._sourceHandler);
            }).catch(function (e) {
              (0, A.error)(N, "Could not establish an HLS Subscriber: " + e), t.trigger(new P.SubscriberEvent(P.SubscriberEventTypes.CONNECT_FAILURE));
            });
          }
        }, {
          key: "_trackStreamingModeState",
          value: function value(e) {
            var t = this;
            e.on(P.SubscriberEventTypes.STREAMING_MODE_CHANGE, function (e) {
              var n = e.data,
                  r = n.streamingMode,
                  i = n.previousStreamingMode;

              if ("Empty" !== r && "Empty" === i) {
                t._sourceHandler.disconnect();

                var o = t._options,
                    a = o.streamName,
                    s = o.mimeType,
                    u = a.match(L) ? a : j(t._options);

                t._sourceHandler.addSource(u, s, t._options).then(function () {
                  return t.subscribe();
                }).catch(function (e) {
                  return e(N, e);
                });
              }
            });
          }
        }, {
          key: "init",
          value: function value(e) {
            var t = this,
                n = new R.DeferredPromise();
            if (_.default.supportsHLS()) {
              if (e.connectionParams && !g.isSupported()) (0, A.warn)(N, "Could not resolve HLSSubscriber instance with connection params. WebSocket support is required."), n.reject(N, "Could not resolve HLSSubscriber instance with connection params. WebSocket support is required.");else {
                this._options = (0, o.default)({}, I, e);
                var r = new R.DeferredPromise();
                if (this._options.connectionParams) try {
                  this._socketHelper = new S.default(this, "HLSSubscriptionSocket");
                  var i = (0, M.hlsSocketEndpointFromOptions)(this._options, {
                    id: this._options.subscriptionId
                  });

                  this._socketHelper.setUp(i, r);
                } catch (e) {
                  (0, A.error)(N, e.message), n.reject(N, "Could not set up WebSocket for authentication with connectionParams: " + e.message);
                } else r.resolve();
                r.promise.then(function () {
                  t._socketHelper && (t._socketHelper.tearDown(), t._socketHelper = void 0), t._setViewIfNotExist(t._view, t._options.mediaElementId), t._getViewResolverPromise().then(function (e) {
                    t._sourceHandler = new C.default(e.view, t.getType()), t._glomSourceHandlerAPI(t._sourceHandler), t._options && t._initHandler(t._options);
                  }), n.resolve(t);
                }).catch(function (e) {
                  n.reject(e), t.trigger(new P.SubscriberEvent(P.SubscriberEventTypes.CONNECT_FAILURE, t, e));
                });
              }
            } else (0, A.warn)(N, "Could not resolve HLSSubscriber instance."), n.reject("Could not resolve HLSSubscriber instance.");
            return n.promise;
          }
        }, {
          key: "setView",
          value: function value(e) {
            return this._view = e, this._viewResolver.resolve(e), this;
          }
        }, {
          key: "subscribe",
          value: function value() {
            return this._getSubscriptionResolverPromise();
          }
        }, {
          key: "unsubscribe",
          value: function value() {
            (0, A.debug)(N, "[unscubscribe]");
            var e = new R.DeferredPromise();
            this._socketHelper && this._socketHelper.tearDown();

            try {
              this._sourceHandler.stop(), this._sourceHandler.disconnect(), e.resolve();
            } catch (t) {
              e.reject(t.message);
            }

            return e.promise;
          }
        }, {
          key: "getConnection",
          value: function value() {
            return this._sourceHandler;
          }
        }, {
          key: "getControls",
          value: function value() {
            return this._sourceHandler ? this._sourceHandler.getControls() : void 0;
          }
        }, {
          key: "getOptions",
          value: function value() {
            return this._options;
          }
        }, {
          key: "getPlayer",
          value: function value() {
            return this._view.view;
          }
        }, {
          key: "getType",
          value: function value() {
            return O.PlaybackTypes.HLS.toUpperCase();
          }
        }]), t;
      }(k.PlaybackController);

      t.default = D;
    }, function (e, t, n) {
      function r(e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }

      function i(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(38),
          a = i(o),
          s = n(9),
          u = i(s),
          c = n(26),
          l = i(c),
          d = n(3),
          h = i(d),
          f = n(0),
          p = i(f),
          v = n(1),
          b = i(v),
          _ = n(5),
          m = i(_),
          g = n(4),
          y = i(g),
          S = n(7),
          E = i(S),
          C = n(82),
          T = n(31),
          w = r(T),
          k = n(44),
          P = r(k),
          O = n(139),
          R = i(O),
          A = n(123),
          M = i(A),
          N = n(125),
          I = i(N),
          L = n(47),
          j = i(L),
          D = n(24),
          H = n(25),
          F = n(46),
          U = n(11),
          x = n(36),
          B = n(59),
          V = n(8),
          G = n(2),
          W = /(.*) starting/i,
          z = "RTCSubscriber",
          q = function q() {
        return "subscriber-" + Math.floor(65536 * Math.random()).toString(16);
      },
          Y = {
        protocol: "wss",
        port: 443,
        app: "live",
        autoLayoutOrientation: !0,
        mediaElementId: "red5pro-subscriber",
        rtcConfiguration: {
          iceServers: [{
            urls: "stun:stun2.l.google.com:19302"
          }],
          iceCandidatePoolSize: 2,
          bundlePolicy: "max-bundle"
        },
        iceServers: void 0,
        iceTransport: B.IceTransportTypes.UDP,
        muteOnAutoplayRestriction: !0,
        maintainConnectionOnSubscribeErrors: !1,
        signalingSocketOnly: !0,
        dataChannelConfiguration: void 0,
        socketSwitchDelay: 1e3,
        bypassAvailable: !1,
        maintainStreamVariant: !1
      },
          K = function (e) {
        function t() {
          (0, p.default)(this, t);
          var e = (0, m.default)(this, (t.__proto__ || (0, h.default)(t)).call(this));
          return e._view = void 0, e._options = void 0, e._peerHelper = void 0, e._socketHelper = void 0, e._messageTransport = void 0, e._connectionClosed = !0, e._sourceHandler = void 0, e._mediaStream = void 0, e._viewResolver = new V.DeferredPromise(), e._availabilityResolver = new V.DeferredPromise(), e._subscriptionResolver = new V.DeferredPromise(), e._orientation = 0, e._streamingMode = "Video/Audio", e._switchChannelRequest = void 0, e;
        }

        return (0, y.default)(t, e), (0, b.default)(t, [{
          key: "_getViewResolverPromise",
          value: function value() {
            return this._viewResolver.promise;
          }
        }, {
          key: "_getAvailabilityResolverPromise",
          value: function value() {
            return this._availabilityResolver.promise;
          }
        }, {
          key: "_getSubscriptionResolverPromise",
          value: function value() {
            return this._subscriptionResolver.promise;
          }
        }, {
          key: "_glomSourceHandlerAPI",
          value: function value(e) {
            var t = this;
            this.play = e.play.bind(e), this.pause = e.pause.bind(e), this.resume = e.resume.bind(e), this.stop = e.stop.bind(e), this.mute = e.mute.bind(e), this.unmute = e.unmute.bind(e), this.setVolume = e.setVolume.bind(e), this.seekTo = e.seekTo.bind(e), this.toggleFullScreen = e.toggleFullScreen.bind(e), e.on("*", function (e) {
              t.trigger(new U.SubscriberEvent(e.type, t, e.data));
            });
          }
        }, {
          key: "_setViewIfNotExist",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;

            if (void 0 === e && void 0 !== t) {
              new j.default(t).attachSubscriber(this);
            }
          }
        }, {
          key: "_initHandler",
          value: function value(e, t) {
            e && t && (t.on("*", this._boundBubbleSubscriberEvents), t.addSource(e));
          }
        }, {
          key: "_requestAvailability",
          value: function value(e) {
            (0, G.debug)(z, "[requestavailability]"), this._socketHelper.post({
              isAvailable: e
            });
          }
        }, {
          key: "_requestOffer",
          value: function value(e, t, n, r, i) {
            var o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : void 0,
                a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : void 0;
            (0, G.debug)(z, "[requestoffer]");
            var s = {
              requestOffer: e,
              requestId: t,
              transport: n,
              datachannel: r,
              doNotSwitch: i
            };
            void 0 !== o && o !== x.PlaybackVideoEncoder.NONE ? s.videoEncoding = o : E.default.getIsEdge(), void 0 !== a && a !== x.PlaybackAudioEncoder.NONE && (s.audioEncoding = a), this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.OFFER_START, this)), this._socketHelper.post(s);
          }
        }, {
          key: "_requestAnswer",
          value: function value(e) {
            var t = this;
            (0, G.debug)(z, "[requestanswer]"), this._peerHelper.createAnswer(e).then(function (e) {
              (0, G.debug)(z, "[onanswercreated]"), (0, G.debug)(z, "[> sendanswer]"), t._sendAnswer(t._options.streamName, t._options.subscriptionId, e);
            }).catch(function (e) {
              t.onSDPError(e);
            });
          }
        }, {
          key: "_sendAnswer",
          value: function value(e, t, n) {
            (0, G.debug)(z, "[sendanswer]: streamname(" + e + "), subscriptionid(" + t + ")"), this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.ANSWER_START, this, n)), this._socketHelper.post({
              handleAnswer: e,
              requestId: t,
              data: {
                sdp: n
              }
            });
          }
        }, {
          key: "_sendCandidate",
          value: function value(e) {
            (0, G.debug)(z, "[sendcandidate]"), this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.CANDIDATE_START, this, e)), this._socketHelper.post({
              handleCandidate: this._options.streamName,
              requestId: this._options.subscriptionId,
              data: {
                candidate: e
              }
            });
          }
        }, {
          key: "_connect",
          value: function value(e) {
            var t = this,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
            (0, G.debug)(z, "[connect]"), r && e && ((0, G.warn)("The iceServers configuration property is considered deprecated. Please use the rtcConfiguration configuration property upon which you can assign iceServers. Reference: https://www.red5pro.com/docs/streaming/migrationguide.html"), e.iceServers = r), this._options.iceServers = e ? e.iceServers : r;
            var i = void 0;
            return i = void 0 !== e ? this._peerHelper.setUpWithPeerConfiguration(e, n, void 0) : this._peerHelper.setUp(this._options.iceServers, void 0, this._options.rtcpMuxPolicy), i.then(function (e) {
              t.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.PEER_CONNECTION_AVAILABLE, t, e)), t._requestOffer(t._options.streamName, t._options.subscriptionId, t._options.iceTransport, t._options.signalingSocketOnly, t._options.maintainStreamVariant, t._options.videoEncoding, t._options.audioEncoding);
            }).catch(function () {
              (0, G.warn)(z, "Could not establish RTCPeerConnection."), t.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.CONNECT_FAILURE, t));
            }), this;
          }
        }, {
          key: "_disconnect",
          value: function value() {
            this._socketHelper && ((0, G.debug)(z, "[disconnect:socket]"), this._socketHelper.tearDown()), this._peerHelper && ((0, G.debug)(z, "[disconnect:peer]"), this._peerHelper.tearDown()), this._view && this._view.detachStream(), this._socketHelper = void 0, this._peerHelper = void 0, this._messageTransport = void 0, this._sourceHandler && ((0, G.debug)(z, "[disconnect:source]"), this._sourceHandler.disconnect(), this._sourceHandler = void 0), this._connectionClosed = !0;
          }
        }, {
          key: "_playIfAutoplaySet",
          value: function value(e, t) {
            e && t && (e.autoplay = E.default.hasAttributeDefined(t.view, "autoplay"), e.autoplay && this._sourceHandler.attemptAutoplay(e.muteOnAutoplayRestriction));
          }
        }, {
          key: "_sendSubscribe",
          value: function value() {
            (0, G.debug)(z, "[sendsubscribe]"), this._socketHelper.post({
              subscribe: this._options.streamName,
              requestId: this._options.subscriptionId
            });
          }
        }, {
          key: "init",
          value: function value(e) {
            var t = this,
                n = new V.DeferredPromise();

            if (w.isSupported() && P.isSupported()) {
              this._disconnect(), this._options = (0, l.default)({}, Y, e), this._options.subscriptionId = this._options.subscriptionId || q(), this._peerHelper = new I.default(this), this._socketHelper = new M.default(this), this._messageTransport = this._socketHelper;
              var r = new V.DeferredPromise(),
                  i = (0, F.rtcSocketEndpointFromOptions)(this._options, {
                id: this._options.subscriptionId
              });
              r.promise.then(function () {
                n.resolve(t), t._connectionClosed = !1, t.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.CONNECT_SUCCESS, t));
              }).catch(function (e) {
                n.reject(e), t.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.CONNECT_FAILURE, t, e));
              }), this._socketHelper.setUp(i, r);
            } else n.reject("Cannot create WebRTC playback instance. Your environment does not support WebRTC and/or WebSockets.");

            return n.promise;
          }
        }, {
          key: "setView",
          value: function value(e) {
            return this._view = e, this._viewResolver.resolve(this._view), this;
          }
        }, {
          key: "subscribe",
          value: function value() {
            var e = this,
                t = this._options,
                n = t.streamName,
                r = t.mediaElementId,
                i = t.rtcConfiguration,
                o = this._options,
                a = o.signalingSocketOnly,
                s = o.dataChannelConfiguration,
                u = a && w.supportsDataChannel();
            return u && !s && (s = {
              name: "red5pro"
            }), this._options.signalingSocketOnly = u, this._getViewResolverPromise().then(function (t) {
              e._sourceHandler = new R.default(t.view, e.getType()), e._glomSourceHandlerAPI(e._sourceHandler), e._initHandler(e._options, e._sourceHandler);
            }).catch(function () {}), this._getAvailabilityResolverPromise().then(function () {
              e._connect(i, s, e._options.iceServers);
            }).catch(function () {}), this._setViewIfNotExist(this._view, r), this._options.bypassAvailable ? this._availabilityResolver.resolve(this) : this._requestAvailability(n), this._getSubscriptionResolverPromise();
          }
        }, {
          key: "unsubscribe",
          value: function value() {
            (0, G.debug)(z, "[unsubscribe]");
            var e = new V.DeferredPromise();
            return this.stop(), this._disconnect(), this._mediaStream = void 0, e.resolve(this), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_STOP, this)), e.promise;
          }
        }, {
          key: "onStreamAvailable",
          value: function value(e) {
            (0, G.debug)(z, "[onstreamavailable]: " + (0, u.default)(e, null, 2)), this._availabilityResolver.resolve(this);
          }
        }, {
          key: "onStreamUnavailable",
          value: function value(e) {
            (0, G.debug)(z, "Stream " + this._options.streamName + " does not exist."), (0, G.debug)(z, "[onstreamunavailable]: " + (0, u.default)(e, null, 2)), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_INVALID_NAME, this)), this._availabilityResolver.reject("Stream " + this._options.streamName + " does not exist."), this._subscriptionResolver.reject("Stream " + this._options.streamName + " does not exist."), this._options.maintainConnectionOnSubscribeErrors ? (this._availabilityResolver = new V.DeferredPromise(), this._subscriptionResolver = new V.DeferredPromise()) : this._disconnect();
          }
        }, {
          key: "onSDPSuccess",
          value: function value(e) {
            (0, G.debug)(z, "[onsdpsuccess]: " + (0, u.default)(e, null, 2));
          }
        }, {
          key: "onSDPOffer",
          value: function value(e) {
            (0, G.debug)(z, "[onsdpoffer]: " + (0, u.default)(e, null, 2));
            var t = new w.RTCSessionDescription(e.sdp);
            this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.OFFER_END, this)), this._requestAnswer(t);
          }
        }, {
          key: "onSDPError",
          value: function value(e) {
            this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_FAIL, this, e)), this._subscriptionResolver.reject("Invalid SDP."), (0, G.error)(z, "[onsdperror]"), (0, G.error)(z, e);
          }
        }, {
          key: "onAnswerMediaStream",
          value: function value() {
            this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.ANSWER_END, this));
          }
        }, {
          key: "onIceCandidate",
          value: function value(e) {
            (0, G.debug)(z, "[onicecandidate]"), this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.CANDIDATE_END, this)), this._sendCandidate(e);
          }
        }, {
          key: "onIceCandidateTrickleEnd",
          value: function value(e) {
            var t = this;
            (0, G.debug)(z, "[onicetrickleend]"), this._getViewResolverPromise().then(function (n) {
              n.attachStream(e), t._mediaStream = e, t.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.ON_ADD_STREAM, t, t._mediaStream));
            });
          }
        }, {
          key: "onAddIceCandidate",
          value: function value(e) {
            (0, G.debug)(z, "[onaddicecandidate]"), this._peerHelper.addIceCandidate(e);
          }
        }, {
          key: "onEmptyCandidate",
          value: function value() {
            (0, G.debug)(z, "[icecandidatetrickle:empty]"), this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.PEER_CANDIDATE_END));
          }
        }, {
          key: "onPeerGatheringComplete",
          value: function value() {
            (0, G.debug)(z, "[icecandidategathering:end]"), this._socketHelper && this._socketHelper.postEndOfCandidates(this._options.streamName);
          }
        }, {
          key: "onSocketIceCandidateEnd",
          value: function value() {
            (0, G.debug)(z, "[onsocketicecandidateend]"), this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.ICE_TRICKLE_COMPLETE, this)), this._sendSubscribe();
          }
        }, {
          key: "onSocketMessage",
          value: function value(e, t) {
            this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.SOCKET_MESSAGE, this, {
              socket: e,
              message: t
            }));
          }
        }, {
          key: "onSocketMessageError",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
            (0, G.error)(z, "Error in stream subscription: " + e + ".\n[Optional detail]: " + t), this._subscriptionResolver.reject("Error in stream subscription: " + e + "."), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_FAIL, this, e));
          }
        }, {
          key: "onSocketClose",
          value: function value(e) {
            (0, G.debug)(z, "[onsocketclose]"), this._peerHelper && this._peerHelper.tearDown(), this.onConnectionClosed(e);
          }
        }, {
          key: "onPeerConnectionFail",
          value: function value() {
            (0, G.debug)(z, "[onpeerconnectionfail]"), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_FAIL, this, "fail")), this._subscriptionResolver.reject("Peer Connection Failed.");
          }
        }, {
          key: "onPeerConnectionClose",
          value: function value(e) {
            (0, G.debug)(z, "[onpeerconnectionclose]"), this._socketHelper && this._socketHelper.tearDown(), this.onSocketClose(e);
          }
        }, {
          key: "onPeerConnectionOpen",
          value: function value() {
            (0, G.debug)(z, "[onpeerconnectionopen]"), this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.PEER_CONNECTION_OPEN));
          }
        }, {
          key: "onUnpublish",
          value: function value() {
            (0, G.debug)(z, "[onunpublish]"), this._sourceHandler && this._sourceHandler.unpublish(), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.PLAY_UNPUBLISH, this)), this.unsubscribe();
          }
        }, {
          key: "onConnectionClosed",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
            this._connectionClosed || ((0, G.debug)(z, "[onconnectionclosed]"), this._disconnect(), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.CONNECTION_CLOSED, this, e)));
          }
        }, {
          key: "onSendReceived",
          value: function value(e, t) {
            "onMetaData" === e ? this.onMetaData(t) : "onPublisherNetworkCongestion" === e ? this.onPublisherNetworkCongestion(t) : "onPublisherNetworkRecovery" === e ? this.onPublisherNetworkRecovery(t) : this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_SEND_INVOKE, this, {
              methodName: e,
              data: t
            }));
          }
        }, {
          key: "onSubscriberStatus",
          value: function value(e) {
            (0, G.debug)(z, "[subscriberstatus] - " + (0, u.default)(e, null, 2));
            var t = W.exec(e.message);
            t && t[1] === this._options.streamName ? (this._subscriptionResolver.resolve(this), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_START, this)), this._playIfAutoplaySet(this._options, this._view)) : this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_STATUS, this, e));
          }
        }, {
          key: "onDataChannelAvailable",
          value: function value(e) {
            var t = this;
            if ((0, G.debug)("[ondatachannel::available]"), this._switchChannelRequest = {
              switchChannel: e || "red5pro"
            }, this._options.signalingSocketOnly) var n = setTimeout(function () {
              clearTimeout(n), t._socketHelper.sever(t._switchChannelRequest), t._messageTransport = t._peerHelper, t.trigger(new U.MessageTransportStateEvent(U.MessageTransportStateEventTypes.CHANGE, t, {
                controller: t,
                transport: t._messageTransport
              }));
            }, this._options.socketSwitchDelay);
            this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.DATA_CHANNEL_AVAILABLE, this, {
              name: e,
              dataChannel: this.getDataChannel()
            }));
          }
        }, {
          key: "onDataChannelError",
          value: function value(e, t) {
            this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.DATA_CHANNEL_ERROR, this, {
              dataChannel: e,
              error: t
            }));
          }
        }, {
          key: "onDataChannelMessage",
          value: function value(e, t) {
            this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.DATA_CHANNEL_MESSAGE, this, {
              dataChannel: e,
              message: t
            }));
          }
        }, {
          key: "onDataChannelOpen",
          value: function value(e) {
            this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.DATA_CHANNEL_OPEN, this, {
              dataChannel: e
            }));
          }
        }, {
          key: "onDataChannelClose",
          value: function value(e) {
            this.trigger(new U.SubscriberEvent(U.RTCSubscriberEventTypes.DATA_CHANNEL_CLOSE, this, {
              dataChannel: e
            }));
          }
        }, {
          key: "onMetaData",
          value: function value(e) {
            var t = e.orientation,
                n = e.streamingMode,
                r = this._streamingMode;
            void 0 !== t && t !== this._orientation && (this._orientation = t, this._options.autoLayoutOrientation && ((0, C.applyOrientation)(this._view.view, parseInt(t, 10), (0, H.metadataResolutionToObject)(e.resolution)), this._sourceHandler && this._sourceHandler.handleOrientationChange(parseInt(t, 10))), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.ORIENTATION_CHANGE, this, {
              orientation: parseInt(t, 10),
              viewElement: this._view.view
            }))), void 0 !== n && n !== r && (this._streamingMode = n, this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.STREAMING_MODE_CHANGE, this, {
              streamingMode: n,
              previousStreamingMode: r,
              viewElement: this._view.view
            }))), this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_METADATA, this, e));
          }
        }, {
          key: "onPublisherNetworkCongestion",
          value: function value(e) {
            this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_PUBLISHER_CONGESTION, this, e));
          }
        }, {
          key: "onPublisherNetworkRecovery",
          value: function value(e) {
            this.trigger(new U.SubscriberEvent(U.SubscriberEventTypes.SUBSCRIBE_PUBLISHER_RECOVERY, this, e));
          }
        }, {
          key: "callServer",
          value: function value(e, t) {
            return this.getMessageTransport().postAsync({
              callAdapter: {
                method: e,
                arguments: t
              }
            });
          }
        }, {
          key: "sendLog",
          value: function value(e, t) {
            try {
              var n = (0, a.default)(G.LEVELS).find(function (t) {
                return t.toLowerCase() === e.toLowerCase();
              }) ? e : G.LEVELS.DEBUG,
                  r = "string" == typeof t ? t : (0, u.default)(t);
              this.getMessageTransport().post({
                log: n.toUpperCase(),
                message: r
              });
            } catch (e) {
              var i = e.message || e;
              (0, G.error)(z, "Could not send log to server. Message parameter expected to be String or JSON-serializable object."), (0, G.error)(z, i);
            }
          }
        }, {
          key: "enableStandby",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteAudio: !0,
                muteVideo: !0
              }
            });
          }
        }, {
          key: "disableStandby",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteAudio: !1,
                muteVideo: !1
              }
            });
          }
        }, {
          key: "muteAudio",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteAudio: !0
              }
            });
          }
        }, {
          key: "unmuteAudio",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteAudio: !1
              }
            });
          }
        }, {
          key: "muteVideo",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteVideo: !0
              }
            });
          }
        }, {
          key: "unmuteVideo",
          value: function value() {
            this.getMessageTransport().post({
              mute: {
                muteVideo: !1
              }
            });
          }
        }, {
          key: "getMessageTransport",
          value: function value() {
            return this._messageTransport;
          }
        }, {
          key: "getConnection",
          value: function value() {
            return this._socketHelper;
          }
        }, {
          key: "getPeerConnection",
          value: function value() {
            return this._peerHelper ? this._peerHelper.connection : void 0;
          }
        }, {
          key: "getDataChannel",
          value: function value() {
            return this._peerHelper ? this._peerHelper.dataChannel : void 0;
          }
        }, {
          key: "getMediaStream",
          value: function value() {
            return this._mediaStream;
          }
        }, {
          key: "getControls",
          value: function value() {
            return this._sourceHandler ? this._sourceHandler.getControls() : void 0;
          }
        }, {
          key: "getPlayer",
          value: function value() {
            return this._view.view;
          }
        }, {
          key: "getOptions",
          value: function value() {
            return this._options;
          }
        }, {
          key: "getType",
          value: function value() {
            return x.PlaybackTypes.RTC.toUpperCase();
          }
        }]), t;
      }(D.PlaybackController);

      t.default = K;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(62),
          o = r(i),
          a = n(26),
          s = r(a),
          u = n(3),
          c = r(u),
          l = n(0),
          d = r(l),
          h = n(1),
          f = r(h),
          p = n(5),
          v = r(p),
          b = n(4),
          _ = r(b),
          m = n(7),
          g = r(m),
          y = n(140),
          S = r(y),
          E = n(47),
          C = r(E),
          T = n(24),
          w = n(11),
          k = n(36),
          P = n(37),
          O = n(8),
          R = n(2),
          A = "RTMPSubcriber",
          M = {
        protocol: "rtmp",
        port: 1935,
        width: 320,
        height: 240,
        embedWidth: "100%",
        embedHeight: "100%",
        minFlashVersion: "10.0.0",
        swf: "lib/red5pro/red5pro-subscriber.swf",
        swfobjectURL: "lib/swfobject/swfobject.js",
        productInstallURL: "lib/swfobject/playerProductInstall.swf",
        mediaElementId: "red5pro-subscriber",
        useAdaptiveBitrateController: !1,
        abrVariants: void 0,
        abrVariantUpgradeSettings: {
          minimumDowngradePlaybackSpan: 1e4,
          upgrade: [{
            level: 1,
            retryTimeout: 0
          }, {
            level: 2,
            retryTimeout: 1e4
          }, {
            level: 3,
            retryTimeout: 2e4
          }]
        }
      },
          N = function (e) {
        function t() {
          (0, d.default)(this, t);
          var e = (0, v.default)(this, (t.__proto__ || (0, c.default)(t)).call(this));
          return e._options = void 0, e._view = void 0, e._sourceHandler = void 0, e._elementId = void 0, e._embedPromise = void 0, e._getEmbedPromise().then(function () {
            e.onEmbedComplete();
          }).catch(function (t) {
            return e.onEmbedFailure(t);
          }), e._viewResolver = new O.DeferredPromise(), e._subscriptionResolver = new O.DeferredPromise(), e._orientation = 0, e._streamingMode = "Video/Audio", e;
        }

        return (0, _.default)(t, e), (0, f.default)(t, [{
          key: "_getViewResolverPromise",
          value: function value() {
            return this._viewResolver.promise;
          }
        }, {
          key: "_getSubscriptionResolverPromise",
          value: function value() {
            return this._subscriptionResolver.promise;
          }
        }, {
          key: "_getEmbedPromise",
          value: function value() {
            return this._embedPromise = O.Future.createIfNotExist(this._embedPromise), this._embedPromise.promise;
          }
        }, {
          key: "_glomSourceHandlerAPI",
          value: function value(e) {
            var t = this;
            this.pause = e.pause.bind(e), this.resume = e.resume.bind(e), this.stop = e.stop.bind(e), this.mute = e.mute.bind(e), this.unmute = e.unmute.bind(e), this.setVolume = e.setVolume.bind(e), this.seekTo = e.seekTo.bind(e), this.toggleFullScreen = e.toggleFullScreen.bind(e), this.setABRLevel = e.setABRLevel.bind(e), this.setABRVariants = e.setABRVariants.bind(e), this.stopABRController = e.stopABRController.bind(e), this.startABRController = e.startABRController.bind(e), this.setABRVariantUpgradeSettings = e.setABRVariantUpgradeSettings.bind(e), e.on("*", function (e) {
              t.trigger(new w.SubscriberEvent(e.type, t, e.data));
            });
          }
        }, {
          key: "_setViewIfNotExist",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;

            if (void 0 === e && void 0 !== t) {
              new C.default(t).attachSubscriber(this);
            }
          }
        }, {
          key: "_establishExtIntHandlers",
          value: function value(e) {
            var t = this;
            (0, R.debug)(A, "Subscriber ID provided to client: (" + e + ").");

            var n = function n(t) {
              return ["subscriber", t, e.split("-").join("_")].join("_");
            };

            window[n("r5proConnectClosed")] = function () {
              return t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.CONNECTION_CLOSED, t));
            }, window[n("r5proConnectSuccess")] = function () {
              return t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.CONNECT_SUCCESS, t));
            }, window[n("r5proConnectFailure")] = function () {
              t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.CONNECT_FAILURE, t));
            }, window[n("r5proSubscribeStop")] = function () {
              return t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.SUBSCRIBE_STOP, t));
            }, window[n("r5proSubscribeMetadata")] = function (e) {
              var n = JSON.parse(e),
                  r = n.orientation,
                  i = n.streamingMode,
                  o = parseInt(r, 10),
                  a = t._streamingMode;
              t._orientation !== o && (t._orientation = o, t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.ORIENTATION_CHANGE, t, {
                orientation: o
              }))), a !== i && (t._streamingMode = i, t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.STREAMING_MODE_CHANGE, t, {
                streamingMode: i,
                previousStreamingMode: a
              }))), t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.SUBSCRIBE_METADATA, t, JSON.parse(e)));
            }, window[n("r5proSubscribeUnpublish")] = function () {
              t.onUnpublish();
            }, window[n("r5proSubscribePublisherCongestion")] = function (e) {
              return t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.SUBSCRIBE_PUBLISHER_CONGESTION, t, JSON.parse(e)));
            }, window[n("r5proSubscribePublisherRecovery")] = function (e) {
              return t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.SUBSCRIBE_PUBLISHER_RECOVERY, t, JSON.parse(e)));
            }, window[n("r5proSubscribeSendInvoke")] = function (e) {
              t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.SUBSCRIBE_SEND_INVOKE, t, "string" == typeof e ? JSON.parse(e) : e));
            }, window[n("r5proSubscribePlayRequest")] = function () {
              t.play();
            }, window[n("r5proSubscribeStart")] = function () {
              t._subscriptionResolver.resolve(t), t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.SUBSCRIBE_START, t));
            }, window[n("r5proSubscribeInvalidName")] = function () {
              t._subscriptionResolver.reject("NetStream.Play.StreamNotFound", t), t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.SUBSCRIBE_INVALID_NAME, t));
            }, window[n("r5proSubscribeFail")] = function () {
              t._subscriptionResolver.reject("NetStream.Failed", t), t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.SUBSCRIBE_FAIL, t));
            }, window[n("r5proSubscribeVolumeChange")] = function (e) {
              t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.VOLUME_CHANGE, t, {
                volume: JSON.parse(e).volume
              }));
            }, window[n("r5proSubscribePlaybackStalled")] = function () {
              (0, R.debug)(A, "playback has stalled...");
            }, window[n("r5proSubscribePlaybackTimeChange")] = function (e) {
              var n = JSON.parse(e);
              t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.PLAYBACK_TIME_UPDATE, t, {
                time: n.value,
                duration: n.duration
              }));
            }, window[n("r5proSubscribePlaybackStateChange")] = function (e) {
              var n = JSON.parse(e).code;
              t.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, t, {
                code: n,
                state: P.PlaybackStateReadable[n]
              }));
            }, window[n("r5proSubscribeABRLevelChange")] = function (e) {
              var n = JSON.parse(e),
                  r = n.level,
                  i = n.stream,
                  o = JSON.parse(decodeURIComponent(i));
              t.trigger(new w.SubscriberEvent(w.RTMPSubscriberEventTypes.ABR_LEVEL_CHANGE, t, {
                level: r,
                stream: o
              }));
            };
          }
        }, {
          key: "init",
          value: function value(e) {
            var t = this,
                n = new O.DeferredPromise(),
                r = e.minFlashVersion || M.minFlashVersion;

            if (g.default.supportsFlashVersion(r)) {
              this._options = (0, s.default)({}, M, e);

              var i = function i() {
                t._getViewResolverPromise().then(function (e) {
                  if (t._sourceHandler = new S.default(t, e.view, t.getType()), t._glomSourceHandlerAPI(t._sourceHandler), t._options) {
                    var n = t._embedPromise;

                    t._sourceHandler.addSource(t._elementId, t._options).then(function (e) {
                      t._establishExtIntHandlers(e), n.resolve(t);
                    }).catch(function (e) {
                      return n.reject(e);
                    });
                  }
                });
              };

              try {
                g.default.injectScript(this._options.swfobjectURL).then(function () {
                  var e = t._embedPromise;
                  return (0, R.debug)(A, "SWFObject embedded."), t._sourceHandler ? (t._sourceHandler.addSource(t._elementId, t._options).then(function (n) {
                    t._establishExtIntHandlers(n), e.resolve(t);
                  }).catch(function (t) {
                    e.reject(t);
                  }), t._getEmbedPromise()) : (i(), !0);
                }).then(function () {
                  t._setViewIfNotExist(t._view, t._options.mediaElementId), n.resolve(t);
                }).catch(function (e) {
                  (0, R.error)(A, "Could not embed Flash-based RTMP Player. Reason: " + e), t._sourceHandler && t._sourceHandler.disconnect(), n.reject(e), t.trigger(new w.SubscriberEvent(w.RTMPSubscriberEventTypes.EMBED_FAILURE, t));
                });
              } catch (e) {
                n.reject("Could not inject Flash-based Player into the page. Reason: " + e.message), this.trigger(new w.SubscriberEvent(w.RTMPSubscriberEventTypes.EMBED_FAILURE, this));
              }
            } else (0, R.warn)(A, "Could not resolve RTMPSubscriber instance. Requires minimum Flash Player install of " + r + "."), n.reject("Could not resolve RTMPSubscriber instance. Requires minimum Flash Player install of " + r + ".");

            return n.promise;
          }
        }, {
          key: "setView",
          value: function value(e, t) {
            return this._view = e, this._elementId = t, this._viewResolver.resolve(this._view), this;
          }
        }, {
          key: "subscribe",
          value: function value() {
            return this._getSubscriptionResolverPromise();
          }
        }, {
          key: "unsubscribe",
          value: function value() {
            var e = this;
            (0, R.debug)(A, "[unsubscribe]");

            var t = function t(_t2, n) {
              try {
                e._sourceHandler.disconnect(), _t2();
              } catch (e) {
                n(e.message);
              }
            };

            return new o.default(t);
          }
        }, {
          key: "play",
          value: function value() {
            var e = this;
            (0, R.debug)(A, "[play]"), this._getEmbedPromise().then(function () {
              e._sourceHandler.play();
            });
          }
        }, {
          key: "onEmbedComplete",
          value: function value() {
            (0, R.debug)(A, "[embed:complete]"), this.trigger(new w.SubscriberEvent(w.RTMPSubscriberEventTypes.EMBED_SUCCESS, this));
          }
        }, {
          key: "onEmbedFailure",
          value: function value(e) {
            (0, R.debug)(A, "[embed:failure] - " + e), this.trigger(new w.SubscriberEvent(w.RTMPSubscriberEventTypes.EMBED_FAILURE, this));
          }
        }, {
          key: "onUnpublish",
          value: function value() {
            (0, R.debug)(A, "[onunpublish]"), this._sourceHandler && this._sourceHandler.unpublish(), this.trigger(new w.SubscriberEvent(w.SubscriberEventTypes.PLAY_UNPUBLISH, this)), this._sourceHandler && this._sourceHandler.disconnect();
          }
        }, {
          key: "getConnection",
          value: function value() {
            return this._sourceHandler;
          }
        }, {
          key: "getControls",
          value: function value() {
            return this._sourceHandler ? this._sourceHandler.getControls() : void 0;
          }
        }, {
          key: "getOptions",
          value: function value() {
            return this._options;
          }
        }, {
          key: "getPlayer",
          value: function value() {
            return this._sourceHandler ? this._sourceHandler.getEmbeddedView() : void 0;
          }
        }, {
          key: "getType",
          value: function value() {
            return k.PlaybackTypes.RTMP.toUpperCase();
          }
        }]), t;
      }(T.PlaybackController);

      t.default = N;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(97),
          s = r(a),
          u = n(3),
          c = r(u),
          l = n(0),
          d = r(l),
          h = n(1),
          f = r(h),
          p = n(5),
          v = r(p),
          b = n(4),
          _ = r(b),
          m = n(7),
          g = r(m),
          y = n(82),
          S = n(25),
          E = n(24),
          C = n(37),
          T = n(11),
          w = n(8),
          k = n(2),
          P = "HLSSourceHandler",
          O = function (e) {
        function t(e, n) {
          (0, d.default)(this, t);
          var r = (0, v.default)(this, (t.__proto__ || (0, c.default)(t)).call(this));
          return r.media = e, r.clone = r.media.cloneNode(!0), r.parent = r.media.parentNode, r.holder = r._determineHolder(e), r.playerType = n, r._mediaSource = void 0, r._isVOD = !1, r._controls = void 0, r._orientation = 0, r._streamingMode = "Video/Audio", r._autoLayoutOrientation = !0, r._playbackNotificationCenter = r.media, r._handleOrientationChange = r._handleOrientationChange.bind(r), r._onOrientationMetadata = r._onOrientationMetadata.bind(r), r._onStreamingModeMetadata = r._onStreamingModeMetadata.bind(r), g.default.onFullScreenStateChange(r._handleFullScreenChange.bind(r)), r;
        }

        return (0, _.default)(t, e), (0, f.default)(t, [{
          key: "_determineHolder",
          value: function value(e) {
            if (e.parentNode.classList.contains("red5pro-media-container")) return e.parentNode;
            var t = e.parentNode,
                n = g.default.createElement("div");
            return n.classList.add("red5pro-media-container"), t.insertBefore(n, e), t.removeChild(e), n.appendChild(e), n;
          }
        }, {
          key: "_cleanUp",
          value: function value() {
            var e = this.media,
                t = this._mediaSource,
                n = e.parentNode,
                r = this.holder;
            if (t && e.removeChild(t), n) n.removeChild(e), n !== this.parent && (n.parentNode.removeChild(n), r = this.parent);else try {
              e.remove();
            } catch (e) {
              (0, k.warn)(P, "Issue in DOM cleanup of HLS video object: " + e.message);
            }
            this.media = this.clone.cloneNode(!0), r.appendChild(this.media), this._controls && this._controls.detach(), this.media.setAttribute("autoplay", !0), this.clone = this.media.cloneNode(!0), this.parent = this.media.parentNode, this.holder = this._determineHolder(this.media), this._orientation = 0, this.isVOD = !1;
          }
        }, {
          key: "_addPlaybackHandlers",
          value: function value(e) {
            var t = this,
                n = this.getControls(),
                r = void 0 !== n;
            e.oncanplay = function () {
              n && n.enable(!0), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: C.PlaybackState.AVAILABLE,
                state: C.PlaybackStateReadable[C.PlaybackState.AVAILABLE]
              })), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.VOLUME_CHANGE, void 0, {
                volume: e.volume
              }));
            }, e.ondurationchange = function (i) {
              !isNaN(e.duration) && (0, s.default)(e.duration) && (t.isVOD = !0), r && n.setPlaybackDuration(e.duration);
            }, e.onended = function () {
              (0, k.debug)(P, "[videoelement:onended]"), r && n.setState(C.PlaybackState.IDLE), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: C.PlaybackState.IDLE,
                state: C.PlaybackStateReadable[C.PlaybackState.IDLE]
              }));
            }, e.ontimeupdate = function (i) {
              r && n.setSeekTime(e.currentTime, self.isVOD ? e.duration : void 0), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.PLAYBACK_TIME_UPDATE, void 0, {
                time: e.currentTime,
                duration: e.duration
              }));
            }, e.onseeked = function (e) {}, e.onseeking = function (e) {}, e.onplay = function () {
              r && n.setState(C.PlaybackState.PLAYING), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: C.PlaybackState.PLAYING,
                state: C.PlaybackStateReadable[C.PlaybackState.PLAYING]
              }));
            }, e.onpause = function () {
              r && n.setState(C.PlaybackState.PAUSED), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: C.PlaybackState.PAUSED,
                state: C.PlaybackStateReadable[C.PlaybackState.PAUSED]
              }));
            }, e.onvolumechange = function (i) {
              r && n.getVolume() !== t.media.volume && n.setVolume(t.media.volume), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.VOLUME_CHANGE, void 0, {
                volume: e.muted ? 0 : e.volume
              }));
            }, e.onencrypted = function () {
              (0, k.debug)(P, "[videoelement:event] encrypted");
            }, e.onemptied = function () {
              (0, k.debug)(P, "[videoelement:event] emptied");
            }, e.onloadeddata = function () {
              (0, k.debug)(P, "[videoelement:event] loadeddata");
            }, e.onresize = function () {
              (0, k.debug)(P, "[videoelement:event] resize"), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.VIDEO_DIMENSIONS_CHANGE, void 0, {
                width: t.media.videoWidth,
                height: t.media.videoHeight
              }));
            }, e.onloadedmetadata = function () {
              (0, k.debug)(P, "[videoelement:event] loadedmetadata"), t.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.SUBSCRIBE_START, void 0, {}));
            }, e.onloadstart = function () {
              (0, k.debug)(P, "[videoelement:event] loadedstart");
            }, e.onstalled = function () {
              (0, k.debug)(P, "[videoelement:event] stalled");
            }, e.onsuspend = function () {
              (0, k.debug)(P, "[videoelement:event] suspend");
            }, e.onwaiting = function () {
              (0, k.debug)(P, "[videoelement:event] waiting");
            };
          }
        }, {
          key: "_handleFullScreenChange",
          value: function value(e) {
            e ? (this.holder.classList.add("red5pro-media-container-full-screen"), this.media.classList.add("red5pro-media-container-full-screen")) : (this.holder.classList.remove("red5pro-media-container-full-screen"), this.media.classList.remove("red5pro-media-container-full-screen")), this.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.FULL_SCREEN_STATE_CHANGE, void 0, e));
          }
        }, {
          key: "_embedMediaSource",
          value: function value(e, t, n) {
            var r = new w.DeferredPromise();

            try {
              var i = g.default.createElement("source");
              i.type = t, i.src = e, this.media.type = t, this.media.firstChild ? this.media.insertBefore(i, this.media.firstChild) : this.media.appendChild(i), this._mediaSource = i, this._autoLayoutOrientation = n.autoLayoutOrientation, g.default.onOrientationMetadata(this.media, this._onOrientationMetadata), g.default.onStreamingModeMetadata(this.media, this._onStreamingModeMetadata), r.resolve();
            } catch (e) {
              r.reject(e.message);
            }

            return r.promise;
          }
        }, {
          key: "_onOrientationMetadata",
          value: function value(e) {
            var t = e.orientation,
                n = e.resolution,
                r = parseInt(t, 10);
            t && this._orientation !== r && ((0, k.debug)(P, "Metadata received: " + (0, o.default)(e, null, 2)), this._orientation = r, this._autoLayoutOrientation && ((0, y.applyOrientation)(this.media, this._orientation, (0, S.metadataResolutionToObject)(n)), this._handleOrientationChange(this._orientation)), this.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.ORIENTATION_CHANGE, void 0, {
              orientation: this._orientation,
              viewElement: this.media
            })), this.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.SUBSCRIBE_METADATA, void 0, e)));
          }
        }, {
          key: "_onStreamingModeMetadata",
          value: function value(e) {
            var t = e.streamingMode,
                n = this._streamingMode;
            t && n !== t && ((0, k.debug)(P, "Metadata received: " + (0, o.default)(e, null, 2)), this._streamingMode = t, this.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.STREAMING_MODE_CHANGE, void 0, {
              streamingMode: this._streamingMode,
              previousStreamingMode: n,
              viewElement: this.media
            })), this.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.SUBSCRIBE_METADATA, void 0, e)));
          }
        }, {
          key: "addSource",
          value: function value(e, t, n) {
            var r = this;
            (0, k.debug)(P, "[addsource]"), this.holder = this._determineHolder(this.media);
            var i = new w.DeferredPromise(),
                o = n.controls,
                a = g.default.hasAttributeDefined(this.media, "muted"),
                s = g.default.hasAttributeDefined(this.media, "autoplay");
            a || this.media.setAttribute("autoplay", !1);
            var u = g.default.hasAttributeDefined(this.media, "controls") && g.default.hasClassDefined(this.media, "red5pro-media");
            return this._embedMediaSource(e, t, n).then(function () {
              (o || u) && (r._controls = o ? n.controls : new E.PlaybackControlsImpl(r, r.holder), r.media.controls = !1, r._controls.setAsVOD(r.isVOD), r._controls.setMutedState(a)), r._addPlaybackHandlers(r._playbackNotificationCenter), s && r.attemptAutoplay(n.muteOnAutoplayRestriction), i.resolve();
            }).catch(function (e) {
              return i.reject(e);
            }), i.promise;
          }
        }, {
          key: "connect",
          value: function value() {
            (0, k.debug)(P, "[connect]");
          }
        }, {
          key: "attemptAutoplay",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            this.play().catch(function (n) {
              t ? (e.mute(), e.play().then(function () {
                e.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.AUTO_PLAYBACK_MUTED, void 0, {
                  element: e.media
                }));
              }).catch(function (t) {
                e.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.AUTO_PLAYBACK_FAILURE, void 0, {
                  error: t.message ? t.message : t,
                  element: e.media
                }));
              })) : e.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.AUTO_PLAYBACK_FAILURE, void 0, {
                error: n.message ? n.message : n,
                element: e.media
              }));
            });
          }
        }, {
          key: "play",
          value: function value() {
            (0, k.debug)(P, "[videoelement:action] play");
            var e = new w.DeferredPromise();

            try {
              var t = this.media.play();
              t ? t.then(function () {
                (0, k.debug)(P, "[videoelement:action] play (START)"), e.resolve();
              }).catch(e.reject) : ((0, k.debug)(P, "[videoelement:action] play (START)"), e.resolve());
            } catch (t) {
              (0, k.error)(P, "[videoelement:action] play (FAULT) - " + t.message), e.reject(t);
            }

            return e.promise;
          }
        }, {
          key: "pause",
          value: function value() {
            (0, k.debug)(P, "[videoelement:action] pause");

            try {
              this.media.pause();
            } catch (e) {
              (0, k.debug)(P, "[videoelement:action] pause (FAULT) - " + e.message);
            }
          }
        }, {
          key: "resume",
          value: function value() {
            (0, k.debug)(P, "[videoelement:action] resume");

            try {
              var e = this.media.play();
              e && e.then(function () {
                return (0, k.debug)(P, "[videoelement:action] play (START)");
              }).catch(function (e) {
                return (0, k.error)(P, "[videoelement:action] play (FAULT) " + (e.message ? e.message : e));
              });
            } catch (e) {
              (0, k.error)(P, "[videoelement:action] resume (FAULT) - " + e.message);
            }
          }
        }, {
          key: "stop",
          value: function value() {
            try {
              this.media.stop();
            } catch (e) {}
          }
        }, {
          key: "mute",
          value: function value() {
            this.media.muted = !0;
            var e = this.getControls();
            e && e.setMutedState(!0);
          }
        }, {
          key: "unmute",
          value: function value() {
            this.media.muted = !1;
            var e = this.getControls();
            e && e.setMutedState(!1);
          }
        }, {
          key: "setVolume",
          value: function value(e) {
            this.unmute(), this.media.volume = e;
          }
        }, {
          key: "seekTo",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
            this.media.currentTime = t ? e * t : e;
          }
        }, {
          key: "toggleFullScreen",
          value: function value() {
            try {
              g.default.toggleFullScreen(this.holder);
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "unpublish",
          value: function value() {
            try {
              this.stop(), this.media.onended.call(this.media);
            } catch (e) {}
          }
        }, {
          key: "disconnect",
          value: function value() {
            this._cleanUp();
          }
        }, {
          key: "_handleOrientationChange",
          value: function value(e) {
            this._controls && e % 180 != 0 && (this.holder.classList.add("red5pro-media-background"), this.media.classList.remove("red5pro-media-background"));
          }
        }, {
          key: "addSharedObjectResponseHandler",
          value: function value(e) {}
        }, {
          key: "removeSharedObjectResponseHandler",
          value: function value(e) {}
        }, {
          key: "sendToSharedObject",
          value: function value(e, t, n) {}
        }, {
          key: "sendPropertyToSharedObject",
          value: function value(e, t, n) {}
        }, {
          key: "getRemoteSharedObject",
          value: function value(e) {}
        }, {
          key: "connectToSharedObject",
          value: function value(e) {}
        }, {
          key: "closeSharedObject",
          value: function value(e) {}
        }, {
          key: "getControls",
          value: function value() {
            return this._controls;
          }
        }, {
          key: "getType",
          value: function value() {
            return this.playerType;
          }
        }, {
          key: "isVOD",
          get: function get() {
            return this._isVOD;
          },
          set: function set(e) {
            this._isVOD = e, this._controls && this._controls.setAsVOD(e);
          }
        }]), t;
      }(E.PlaybackController);

      t.default = O;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(97),
          o = r(i),
          a = n(3),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(5),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(7),
          _ = r(b),
          m = n(24),
          g = n(37),
          y = n(11),
          S = n(8),
          E = n(2),
          C = "RTCSourceHandler",
          T = function (e) {
        function t(e, n) {
          (0, c.default)(this, t);
          var r = (0, f.default)(this, (t.__proto__ || (0, s.default)(t)).call(this));
          return r.media = e, _.default.hasAttributeDefined(r.media, "controls") && _.default.hasClassDefined(r.media, "red5pro-media") && (r.clone = r.media.cloneNode(!0), r.parent = r.media.parentNode, r.holder = r._determineHolder(r.media)), r.playerType = n, r._isVOD = !1, r._controls = void 0, r._playbackNotificationCenter = r.media, _.default.onFullScreenStateChange(r._handleFullScreenChange.bind(r)), r;
        }

        return (0, v.default)(t, e), (0, d.default)(t, [{
          key: "_determineHolder",
          value: function value(e) {
            if (e.parentNode.classList.contains("red5pro-media-container")) return e.parentNode;

            var t = e.parentNode,
                n = _.default.createElement("div");

            return n.classList.add("red5pro-media-container"), t.insertBefore(n, e), t.removeChild(e), n.appendChild(e), n;
          }
        }, {
          key: "_cleanUp",
          value: function value() {
            if (this.clone) {
              var e = this.media,
                  t = e.parentNode,
                  n = this.holder;
              if (t) t.removeChild(e), t !== this.parent && (t.parentNode.removeChild(t), n = this.parent);else try {
                e.remove();
              } catch (e) {
                (0, E.warn)(C, "Issue in DOM cleanup of WebRTC video object: " + e.message);
              }
              this.media = this.clone.cloneNode(!0), n.appendChild(this.media), this._controls && this._controls.detach();
            }
          }
        }, {
          key: "_addPlaybackHandlers",
          value: function value(e) {
            var t = this,
                n = this.getControls(),
                r = void 0 !== n;
            e.oncanplay = function () {
              (0, E.debug)(C, "[videoelement:event] canplay"), n && n.enable(!0), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: g.PlaybackState.AVAILABLE,
                state: g.PlaybackStateReadable[g.PlaybackState.AVAILABLE]
              })), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.VOLUME_CHANGE, void 0, {
                volume: e.volume
              }));
            }, e.ondurationchange = function (i) {
              (0, E.debug)(C, "[videoelement:event] durationchange"), !isNaN(e.duration) && (0, o.default)(e.duration) && (t.isVOD = !0), r && n.setPlaybackDuration(e.duration);
            }, e.onended = function () {
              (0, E.debug)(C, "[videoelement:event] ended"), r && n.setState(g.PlaybackState.IDLE), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: g.PlaybackState.IDLE,
                state: g.PlaybackStateReadable[g.PlaybackState.IDLE]
              }));
            }, e.ontimeupdate = function (i) {
              r && n.setSeekTime(e.currentTime, self.isVOD ? e.duration : void 0), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.PLAYBACK_TIME_UPDATE, void 0, {
                time: e.currentTime,
                duration: e.duration
              }));
            }, e.onseeked = function (e) {}, e.onseeking = function (e) {}, e.onplay = function () {
              (0, E.debug)(C, "[videoelement:event] play"), r && n.setState(g.PlaybackState.PLAYING), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: g.PlaybackState.PLAYING,
                state: g.PlaybackStateReadable[g.PlaybackState.PLAYING]
              }));
            }, e.onpause = function () {
              (0, E.debug)(C, "[videoelement:event] pause"), r && n.setState(g.PlaybackState.PAUSED), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: g.PlaybackState.PAUSED,
                state: g.PlaybackStateReadable[g.PlaybackState.PAUSED]
              }));
            }, e.onvolumechange = function (i) {
              r && n.getVolume() !== t.media.volume && n.setVolume(t.media.volume), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.VOLUME_CHANGE, void 0, {
                volume: e.muted ? 0 : e.volume
              }));
            }, e.onencrypted = function () {
              (0, E.debug)(C, "[videoelement:event] encrypted");
            }, e.onemptied = function () {
              (0, E.debug)(C, "[videoelement:event] emptied");
            }, e.onloadeddata = function () {
              (0, E.debug)(C, "[videoelement:event] loadeddata"), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.VIDEO_DIMENSIONS_CHANGE, void 0, {
                width: t.media.videoWidth,
                height: t.media.videoHeight
              }));
            }, e.onresize = function () {
              (0, E.debug)(C, "[videoelement:event] resize"), t.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.VIDEO_DIMENSIONS_CHANGE, void 0, {
                width: t.media.videoWidth,
                height: t.media.videoHeight
              }));
            }, e.onloadedmetadata = function () {
              (0, E.debug)(C, "[videoelement:event] loadedmetadata");
            }, e.onloadstart = function () {
              (0, E.debug)(C, "[videoelement:event] loadedstart");
            }, e.onstalled = function () {
              (0, E.debug)(C, "[videoelement:event] stalled");
            }, e.onsuspend = function () {
              (0, E.debug)(C, "[videoelement:event] suspend");
            }, e.onwaiting = function () {
              (0, E.debug)(C, "[videoelement:event] waiting");
            };
          }
        }, {
          key: "_handleFullScreenChange",
          value: function value(e) {
            e ? (this.holder && this.holder.classList.add("red5pro-media-container-full-screen"), this.media.classList.add("red5pro-media-container-full-screen")) : (this.holder && this.holder.classList.remove("red5pro-media-container-full-screen"), this.media.classList.remove("red5pro-media-container-full-screen")), this.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.FULL_SCREEN_STATE_CHANGE, void 0, e));
          }
        }, {
          key: "addSource",
          value: function value(e) {
            (0, E.debug)(C, "[addsource]");

            var t = _.default.hasAttributeDefined(this.media, "controls") && _.default.hasClassDefined(this.media, "red5pro-media");

            t && (this.holder = this._determineHolder(this.media));

            var n = new S.DeferredPromise(),
                r = e.controls,
                i = _.default.hasAttributeDefined(this.media, "muted");

            return (r || t) && (this._controls = r ? e.controls : new m.PlaybackControlsImpl(this, this.holder), this.media.controls = !1, this._controls.setAsVOD(this.isVOD), this._controls.setMutedState(i)), this._addPlaybackHandlers(this._playbackNotificationCenter), n.resolve(), n.promise;
          }
        }, {
          key: "connect",
          value: function value() {
            (0, E.debug)(C, "[connect]");
          }
        }, {
          key: "attemptAutoplay",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            this.play().catch(function (n) {
              t ? (e.mute(), e.play().then(function () {
                e.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.AUTO_PLAYBACK_MUTED, void 0, {
                  element: e.media
                }));
              }).catch(function (t) {
                e.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.AUTO_PLAYBACK_FAILURE, void 0, {
                  error: t.message ? t.message : t,
                  element: e.media
                }));
              })) : e.trigger(new y.SubscriberEvent(y.SubscriberEventTypes.AUTO_PLAYBACK_FAILURE, void 0, {
                error: n.message ? n.message : n,
                element: e.media
              }));
            });
          }
        }, {
          key: "play",
          value: function value() {
            (0, E.debug)(C, "[videoelement:action] play");
            var e = new S.DeferredPromise();

            try {
              var t = this.media.play();
              t ? t.then(function () {
                (0, E.debug)(C, "[videoelement:action] play (START)"), e.resolve();
              }).catch(e.reject) : ((0, E.debug)(C, "[videoelement:action] play (START)"), e.resolve());
            } catch (t) {
              (0, E.error)(C, "[videoelement:action] play (FAULT) - " + t.message), e.reject(t);
            }

            return e.promise;
          }
        }, {
          key: "pause",
          value: function value() {
            (0, E.debug)(C, "[videoelement:action] pause");

            try {
              this.media.pause();
            } catch (e) {
              (0, E.warn)(C, "[videoelement:action] pause (CATCH::FAULT) - " + e.message);
            }
          }
        }, {
          key: "resume",
          value: function value() {
            (0, E.debug)(C, "[videoelement:action] resume");

            try {
              var e = this.media.play();
              e && e.then(function () {
                return (0, E.debug)(C, "[videoelement:action] play (START)");
              }).catch(function (e) {
                return (0, E.warn)(C, "[videoelement:action] play (CATCH::FAULT) " + (e.message ? e.message : e));
              });
            } catch (e) {
              (0, E.warn)(C, "[videoelement:action] resume (CATCH::FAULT) - " + e.message);
            }
          }
        }, {
          key: "stop",
          value: function value() {
            (0, E.debug)(C, "[videoelement:action] stop");

            try {
              this.media.stop();
            } catch (e) {}
          }
        }, {
          key: "mute",
          value: function value() {
            this.media.muted = !0;
            var e = this.getControls();
            e && e.setMutedState(!0);
          }
        }, {
          key: "unmute",
          value: function value() {
            this.media.muted = !1;
            var e = this.getControls();
            e && e.setMutedState(!1);
          }
        }, {
          key: "setVolume",
          value: function value(e) {
            this.unmute(), this.media.volume = e;
          }
        }, {
          key: "seekTo",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
            this.media.currentTime = t ? e * t : e;
          }
        }, {
          key: "toggleFullScreen",
          value: function value() {
            try {
              this.holder && _.default.toggleFullScreen(this.holder);
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "unpublish",
          value: function value() {
            try {
              this.stop(), this.media.onended.call(this.media);
            } catch (e) {}
          }
        }, {
          key: "disconnect",
          value: function value() {
            this._cleanUp();
          }
        }, {
          key: "handleOrientationChange",
          value: function value(e) {
            this._controls && e % 180 != 0 && (this.holder && this.holder.classList.add("red5pro-media-background"), this.media.classList.remove("red5pro-media-background"));
          }
        }, {
          key: "addSharedObjectResponseHandler",
          value: function value(e) {}
        }, {
          key: "removeSharedObjectResponseHandler",
          value: function value(e) {}
        }, {
          key: "sendToSharedObject",
          value: function value(e, t, n) {}
        }, {
          key: "sendPropertyToSharedObject",
          value: function value(e, t, n) {}
        }, {
          key: "getRemoteSharedObject",
          value: function value(e) {}
        }, {
          key: "connectToSharedObject",
          value: function value(e) {}
        }, {
          key: "closeSharedObject",
          value: function value(e) {}
        }, {
          key: "getControls",
          value: function value() {
            return this._controls;
          }
        }, {
          key: "getType",
          value: function value() {
            return this.playerType;
          }
        }, {
          key: "isVOD",
          get: function get() {
            return this._isVOD;
          },
          set: function set(e) {
            this._isVOD = e, this._controls && this._controls.setAsVOD(e);
          }
        }]), t;
      }(m.PlaybackController);

      t.default = T;
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(9),
          o = r(i),
          a = n(3),
          s = r(a),
          u = n(0),
          c = r(u),
          l = n(1),
          d = r(l),
          h = n(5),
          f = r(h),
          p = n(4),
          v = r(p),
          b = n(81),
          _ = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t.default = e, t;
      }(b),
          m = n(7),
          g = r(m),
          y = n(89),
          S = r(y),
          E = n(24),
          C = n(37),
          T = n(11),
          w = n(8),
          k = n(2),
          P = "RTMPSourceHandler",
          O = function O(e) {
        return "string" == typeof e ? parseInt(e, 10) : Math.round(e);
      },
          R = function R(e) {
        return /^.*\.(flv|mp4|mp3)/.test(e);
      },
          A = function (e) {
        function t(e, n, r) {
          var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : void 0;
          (0, c.default)(this, t);
          var o = (0, f.default)(this, (t.__proto__ || (0, s.default)(t)).call(this));
          return o.media = n, o.clone = o.media.cloneNode(!0), o.parent = o.media.parentNode, o.holder = o._determineHolder(o.media), o.playerType = r, o._swfId = void 0, o._controls = void 0, o._soResponder = i || new S.default(), o._playbackNotificationCenter = e, g.default.onFullScreenStateChange(o._handleFullScreenChange.bind(o)), o;
        }

        return (0, v.default)(t, e), (0, d.default)(t, [{
          key: "_determineHolder",
          value: function value(e) {
            if (e.parentNode.classList.contains("red5pro-media-container")) return e.parentNode;
            var t = e.parentNode,
                n = g.default.createElement("div");
            return n.classList.add("red5pro-media-container"), t.insertBefore(n, e), t.removeChild(e), n.appendChild(e), n;
          }
        }, {
          key: "_cleanUp",
          value: function value() {
            var e = this.getEmbeddedView(),
                t = e.parentNode,
                n = this.holder;
            if (t) t.removeChild(e), t !== this.parent && (t.parentNode.removeChild(t), n = this.parent);else try {
              e.remove();
            } catch (e) {
              (0, k.warn)(P, "Issue in DOM cleanup of flash object embed: " + e.message);
            }
            this.media = this.clone.cloneNode(!0), n.appendChild(this.media), this._controls && this._controls.detach();
          }
        }, {
          key: "_addPlaybackHandlers",
          value: function value(e) {
            var t = this.getControls();
            void 0 !== t && (e.on(T.SubscriberEventTypes.SUBSCRIBE_START, function () {
              t.setState(C.PlaybackState.PLAYING);
            }), e.on(T.SubscriberEventTypes.SUBSCRIBE_STOP, function () {
              t.setState(C.PlaybackState.IDLE);
            }), e.on(T.SubscriberEventTypes.PLAY_UNPUBLISH, function () {
              t.setState(C.PlaybackState.IDLE);
            }), e.on(T.SubscriberEventTypes.SUBSCRIBE_METADATA, function (e) {
              e.data.duration && t.setPlaybackDuration(e.data.duration);
            }), e.on(T.SubscriberEventTypes.VOLUME_CHANGE, function (e) {
              t.setVolume(e.data.volume);
            }), e.on(T.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, function (e) {
              e.data.code === C.PlaybackState.AVAILABLE && t.enable(!0), t.setState(e.data.code);
            }), e.on(T.SubscriberEventTypes.PLAYBACK_TIME_UPDATE, function (e) {
              t.setSeekTime(e.data.time, e.data.duration);
            }), e.on(T.SubscriberEventTypes.FULL_SCREEN_STATE_CHANGE, function (e) {
              t.onFullScreenChange(e.data);
            }));
          }
        }, {
          key: "_handleFullScreenChange",
          value: function value(e) {
            var t = this.getEmbeddedView();
            e ? (this.holder.classList.add("red5pro-media-container-full-screen"), t.classList.add("red5pro-media-container-full-screen")) : (this.holder.classList.remove("red5pro-media-container-full-screen"), t.classList.remove("red5pro-media-container-full-screen")), this.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.FULL_SCREEN_STATE_CHANGE, void 0, e));
          }
        }, {
          key: "_setUpInitCallback",
          value: function value(e) {
            var t = this;
            g.default.addSubscriptionAssignmentHandler(function (n) {
              (0, k.debug)(P, "Embed and init() complete for subscriber swf. successId(" + n + ")."), e.resolve(n), t._tearDownInitCallback();
            });
          }
        }, {
          key: "_tearDownInitCallback",
          value: function value() {}
        }, {
          key: "addSource",
          value: function value(e, t) {
            var n = this,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
            (0, k.debug)(P, "[addsource]"), this._swfId = e, this.holder = this._determineHolder(this.media);
            var a = this._soResponder,
                s = new w.DeferredPromise(),
                u = t.controls,
                c = g.default.hasAttributeDefined(this.media, "muted"),
                l = g.default.hasAttributeDefined(this.media, "controls") && g.default.hasClassDefined(this.media, "red5pro-media");
            t.swf = r || t.swf, t.minFlashVersion = i || t.minFlashVersion, this._setUpInitCallback(s);
            var d = this.media.classList;
            return _.defineEmbedElement(this.media, this.holder).then(function (r) {
              var i = {
                stream: t.streamName,
                app: t.context ? t.app + "/" + t.context : t.app,
                host: t.host,
                muted: g.default.hasAttributeDefined(n.media, "muted"),
                autoplay: g.default.hasAttributeDefined(n.media, "autoplay"),
                useAdaptiveBitrateController: t.useAdaptiveBitrateController
              };
              return t.backgroundColor && (i.backgroundColor = t.backgroundColor), t.buffer && !isNaN(Number(t.buffer)) && (i.buffer = t.buffer), t.width && !isNaN(t.width) && (i.width = O(t.width)), t.height && !isNaN(t.height) && (i.height = O(t.height)), "100%" !== t.embedWidth && "100%" !== t.embedHeight || (i.autosize = !0), n._swfId = e, void 0 !== t.connectionParams && (i.connectionParams = encodeURIComponent((0, o.default)(t.connectionParams))), void 0 !== t.abrVariants && (i.abrVariants = encodeURIComponent((0, o.default)(t.abrVariants))), void 0 !== t.abrVariantUpgradeSettings && (i.abrVariantUpgradeSettings = encodeURIComponent((0, o.default)(t.abrVariantUpgradeSettings))), _.embedSwfObject(e, t, i, g.default.getSwfObject(), r);
            }).then(function () {
              if (u || l) {
                n._controls = u ? t.controls : new E.PlaybackControlsImpl(n, n.holder), n.media.controls = !1, n._controls.setAsVOD(R(t.streamName)), n._controls.setMutedState(c);

                for (var e = n.getEmbeddedView(), r = d.length, i = void 0; --r > -1;) {
                  i = d.item(r), e.classList.add(i);
                }
              }

              return n._addPlaybackHandlers(n._playbackNotificationCenter), n.trigger(new T.SubscriberEvent(T.SubscriberEventTypes.PLAYBACK_STATE_CHANGE, void 0, {
                code: C.PlaybackState.AVAILABLE,
                state: C.PlaybackStateReadable[C.PlaybackState.AVAILABLE]
              })), !0;
            }).then(function () {
              return a.connect(e), !0;
            }).catch(function (e) {
              return s.reject(e);
            }), s.promise;
          }
        }, {
          key: "connect",
          value: function value() {
            (0, k.debug)(P, "[connect]");

            try {
              this.getEmbeddedView().connect();
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "play",
          value: function value() {
            try {
              this.getEmbeddedView().play();
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "pause",
          value: function value() {
            try {
              this.getEmbeddedView().pause();
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "resume",
          value: function value() {
            try {
              this.getEmbeddedView().resume();
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "stop",
          value: function value() {
            try {
              this.getEmbeddedView().stop();
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "mute",
          value: function value() {
            try {
              this.getEmbeddedView().mute();
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "unmute",
          value: function value() {
            try {
              this.getEmbeddedView().unmute();
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "setVolume",
          value: function value(e) {
            try {
              this.getEmbeddedView().setVolume(e);
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "seekTo",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;

            try {
              this.getEmbeddedView().seekTo(e, t);
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "toggleFullScreen",
          value: function value() {
            try {
              g.default.toggleFullScreen(this.holder);
            } catch (e) {
              throw e;
            }
          }
        }, {
          key: "unpublish",
          value: function value() {
            this.stop();
          }
        }, {
          key: "disconnect",
          value: function value() {
            try {
              this.getEmbeddedView().disconnect(), (0, k.debug)(P, "[disconnect]");
            } catch (e) {}

            this._cleanUp(), this._soResponder.disconnect();
          }
        }, {
          key: "addSharedObjectResponseHandler",
          value: function value(e) {
            this._soResponder.addResponseHandler(e);
          }
        }, {
          key: "removeSharedObjectResponseHandler",
          value: function value(e) {
            this._soResponder.removeResponseHandler(e);
          }
        }, {
          key: "sendToSharedObject",
          value: function value(e, t, n) {
            this._soResponder.sendToSharedObject(e, t, n);
          }
        }, {
          key: "sendPropertyToSharedObject",
          value: function value(e, t, n) {
            this._soResponder.sendPropertyToSharedObject(e, t, n);
          }
        }, {
          key: "getRemoteSharedObject",
          value: function value(e) {
            this._soResponder.getRemoteSharedObject(e);
          }
        }, {
          key: "connectToSharedObject",
          value: function value(e) {
            this._soResponder.connectToSharedObject(e);
          }
        }, {
          key: "closeSharedObject",
          value: function value(e) {
            this._soResponder.closeSharedObject(e);
          }
        }, {
          key: "startABRController",
          value: function value() {
            try {
              this.getEmbeddedView().startABRController();
            } catch (e) {
              (0, k.debug)(P, "Could not start the Adaptive Bitrate Controller: " + e.message);
            }
          }
        }, {
          key: "stopABRController",
          value: function value() {
            try {
              this.getEmbeddedView().stopABRController();
            } catch (e) {
              (0, k.debug)(P, "Could not stop the Adaptive Bitrate Controller: " + e.message);
            }
          }
        }, {
          key: "setABRVariants",
          value: function value(e, t) {
            try {
              var n = "string" == typeof e ? encodeURIComponent(e) : encodeURIComponent((0, o.default)(e));
              this.getEmbeddedView().setABRVariants(n, t || 1);
            } catch (e) {
              (0, k.debug)(P, "Could not set ABR Variants: " + e.message);
            }
          }
        }, {
          key: "setABRLevel",
          value: function value(e, t) {
            try {
              this.getEmbeddedView().setABRLevel(e, !!t);
            } catch (e) {
              (0, k.debug)(P, "Could not set ABR level: " + e.message);
            }
          }
        }, {
          key: "setABRVariantUpgradeSettings",
          value: function value(e) {
            try {
              var t = "string" == typeof abrVariants ? encodeURIComponent(e) : encodeURIComponent((0, o.default)(e));
              this.getEmbeddedView().setABRVariantUpgradeSettings(t);
            } catch (e) {
              (0, k.debug)(P, "Could not set ABR Variants: " + e.message);
            }
          }
        }, {
          key: "getEmbeddedView",
          value: function value() {
            return g.default.getEmbedObject(this._swfId);
          }
        }, {
          key: "getControls",
          value: function value() {
            return this._controls;
          }
        }, {
          key: "getType",
          value: function value() {
            return this.playerType;
          }
        }]), t;
      }(E.PlaybackController);

      t.default = A;
    }, function (e, t, n) {
      e.exports = {
        default: n(153),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(154),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(155),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(159),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(160),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(161),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(164),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(167),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(170),
        __esModule: !0
      };
    }, function (e, t, n) {
      e.exports = {
        default: n(171),
        __esModule: !0
      };
    }, function (e, t, n) {
      function r(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      t.__esModule = !0;
      var i = n(143),
          o = r(i),
          a = n(142),
          s = r(a);

      t.default = function () {
        function e(e, t) {
          var n = [],
              r = !0,
              i = !1,
              o = void 0;

          try {
            for (var a, u = (0, s.default)(e); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            i = !0, o = e;
          } finally {
            try {
              !r && u.return && u.return();
            } finally {
              if (i) throw o;
            }
          }

          return n;
        }

        return function (t, n) {
          if (Array.isArray(t)) return t;
          if ((0, o.default)(Object(t))) return e(t, n);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }();
    }, function (e, t, n) {
      e.exports = n(214);
    }, function (e, t, n) {
      n(29), n(193), e.exports = n(6).Array.from;
    }, function (e, t, n) {
      n(30), n(29), e.exports = n(191);
    }, function (e, t, n) {
      n(30), n(29), e.exports = n(192);
    }, function (e, t, n) {
      var r = n(6),
          i = r.JSON || (r.JSON = {
        stringify: JSON.stringify
      });

      e.exports = function (e) {
        return i.stringify.apply(i, arguments);
      };
    }, function (e, t, n) {
      n(43), n(29), n(30), n(195), n(210), e.exports = n(6).Map;
    }, function (e, t, n) {
      n(196), e.exports = n(6).Number.isFinite;
    }, function (e, t, n) {
      n(197), e.exports = n(6).Number.isNaN;
    }, function (e, t, n) {
      n(198), e.exports = n(6).Object.assign;
    }, function (e, t, n) {
      n(199);
      var r = n(6).Object;

      e.exports = function (e, t) {
        return r.create(e, t);
      };
    }, function (e, t, n) {
      n(200);
      var r = n(6).Object;

      e.exports = function (e, t, n) {
        return r.defineProperty(e, t, n);
      };
    }, function (e, t, n) {
      n(201), e.exports = n(6).Object.freeze;
    }, function (e, t, n) {
      n(202);
      var r = n(6).Object;

      e.exports = function (e, t) {
        return r.getOwnPropertyDescriptor(e, t);
      };
    }, function (e, t, n) {
      n(203), e.exports = n(6).Object.getPrototypeOf;
    }, function (e, t, n) {
      n(204), e.exports = n(6).Object.keys;
    }, function (e, t, n) {
      n(205), e.exports = n(6).Object.setPrototypeOf;
    }, function (e, t, n) {
      n(43), n(29), n(30), n(206), e.exports = n(6).Promise;
    }, function (e, t, n) {
      n(43), n(29), n(30), n(207), n(211), e.exports = n(6).Set;
    }, function (e, t, n) {
      n(208), n(43), n(212), n(213), e.exports = n(6).Symbol;
    }, function (e, t, n) {
      n(29), n(30), e.exports = n(79).f("iterator");
    }, function (e, t, n) {
      n(43), n(30), n(209), e.exports = n(6).WeakMap;
    }, function (e, t) {
      e.exports = function () {};
    }, function (e, t, n) {
      var r = n(40);

      e.exports = function (e, t) {
        var n = [];
        return r(e, !1, n.push, n, t), n;
      };
    }, function (e, t, n) {
      var r = n(23),
          i = n(56),
          o = n(190);

      e.exports = function (e) {
        return function (t, n, a) {
          var s,
              u = r(t),
              c = i(u.length),
              l = o(a, c);

          if (e && n != n) {
            for (; c > l;) {
              if ((s = u[l++]) != s) return !0;
            }
          } else for (; c > l; l++) {
            if ((e || l in u) && u[l] === n) return e || l || 0;
          }

          return !e && -1;
        };
      };
    }, function (e, t, n) {
      var r = n(14),
          i = n(108),
          o = n(10)("species");

      e.exports = function (e) {
        var t;
        return i(e) && (t = e.constructor, "function" != typeof t || t !== Array && !i(t.prototype) || (t = void 0), r(t) && null === (t = t[o]) && (t = void 0)), void 0 === t ? Array : t;
      };
    }, function (e, t, n) {
      var r = n(176);

      e.exports = function (e, t) {
        return new (r(e))(t);
      };
    }, function (e, t, n) {
      var r = n(55),
          i = n(33).getWeak,
          o = n(17),
          a = n(14),
          s = n(48),
          u = n(40),
          c = n(65),
          l = n(21),
          d = c(5),
          h = c(6),
          f = 0,
          p = function p(e) {
        return e._l || (e._l = new v());
      },
          v = function v() {
        this.a = [];
      },
          b = function b(e, t) {
        return d(e.a, function (e) {
          return e[0] === t;
        });
      };

      v.prototype = {
        get: function get(e) {
          var t = b(this, e);
          if (t) return t[1];
        },
        has: function has(e) {
          return !!b(this, e);
        },
        set: function set(e, t) {
          var n = b(this, e);
          n ? n[1] = t : this.a.push([e, t]);
        },
        delete: function _delete(e) {
          var t = h(this.a, function (t) {
            return t[0] === e;
          });
          return ~t && this.a.splice(t, 1), !!~t;
        }
      }, e.exports = {
        getConstructor: function getConstructor(e, t, n, o) {
          var c = e(function (e, r) {
            s(e, c, t, "_i"), e._i = f++, e._l = void 0, void 0 != r && u(r, n, e[o], e);
          });
          return r(c.prototype, {
            delete: function _delete(e) {
              if (!a(e)) return !1;
              var t = i(e);
              return !0 === t ? p(this).delete(e) : t && l(t, this._i) && delete t[this._i];
            },
            has: function has(e) {
              if (!a(e)) return !1;
              var t = i(e);
              return !0 === t ? p(this).has(e) : t && l(t, this._i);
            }
          }), c;
        },
        def: function def(e, t, n) {
          var r = i(o(t), !0);
          return !0 === r ? p(e).set(t, n) : r[e._i] = n, e;
        },
        ufstore: p
      };
    }, function (e, t, n) {
      var r = n(15),
          i = n(41);

      e.exports = function (e, t, n) {
        t in e ? r.f(e, t, i(0, n)) : e[t] = n;
      };
    }, function (e, t, n) {
      var r = n(34),
          i = n(72),
          o = n(53);

      e.exports = function (e) {
        var t = r(e),
            n = i.f;
        if (n) for (var a, s = n(e), u = o.f, c = 0; s.length > c;) {
          u.call(e, a = s[c++]) && t.push(a);
        }
        return t;
      };
    }, function (e, t) {
      e.exports = function (e, t, n) {
        var r = void 0 === n;

        switch (t.length) {
          case 0:
            return r ? e() : e.call(n);

          case 1:
            return r ? e(t[0]) : e.call(n, t[0]);

          case 2:
            return r ? e(t[0], t[1]) : e.call(n, t[0], t[1]);

          case 3:
            return r ? e(t[0], t[1], t[2]) : e.call(n, t[0], t[1], t[2]);

          case 4:
            return r ? e(t[0], t[1], t[2], t[3]) : e.call(n, t[0], t[1], t[2], t[3]);
        }

        return e.apply(n, t);
      };
    }, function (e, t, n) {
      var r = n(52),
          i = n(41),
          o = n(42),
          a = {};
      n(22)(a, n(10)("iterator"), function () {
        return this;
      }), e.exports = function (e, t, n) {
        e.prototype = r(a, {
          next: i(1, n)
        }), o(e, t + " Iterator");
      };
    }, function (e, t, n) {
      var r = n(34),
          i = n(23);

      e.exports = function (e, t) {
        for (var n, o = i(e), a = r(o), s = a.length, u = 0; s > u;) {
          if (o[n = a[u++]] === t) return n;
        }
      };
    }, function (e, t, n) {
      var r = n(13),
          i = n(117).set,
          o = r.MutationObserver || r.WebKitMutationObserver,
          a = r.process,
          s = r.Promise,
          u = "process" == n(39)(a);

      e.exports = function () {
        var e,
            t,
            n,
            c = function c() {
          var r, i;

          for (u && (r = a.domain) && r.exit(); e;) {
            i = e.fn, e = e.next;

            try {
              i();
            } catch (r) {
              throw e ? n() : t = void 0, r;
            }
          }

          t = void 0, r && r.enter();
        };

        if (u) n = function n() {
          a.nextTick(c);
        };else if (o) {
          var l = !0,
              d = document.createTextNode("");
          new o(c).observe(d, {
            characterData: !0
          }), n = function n() {
            d.data = l = !l;
          };
        } else if (s && s.resolve) {
          var h = s.resolve();

          n = function n() {
            h.then(c);
          };
        } else n = function n() {
          i.call(r, c);
        };
        return function (r) {
          var i = {
            fn: r,
            next: void 0
          };
          t && (t.next = i), e || (e = i, n()), t = i;
        };
      };
    }, function (e, t, n) {
      var r = n(15),
          i = n(17),
          o = n(34);
      e.exports = n(18) ? Object.defineProperties : function (e, t) {
        i(e);

        for (var n, a = o(t), s = a.length, u = 0; s > u;) {
          r.f(e, n = a[u++], t[n]);
        }

        return e;
      };
    }, function (e, t, n) {
      var r = n(23),
          i = n(113).f,
          o = {}.toString,
          a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
          s = function s(e) {
        try {
          return i(e);
        } catch (e) {
          return a.slice();
        }
      };

      e.exports.f = function (e) {
        return a && "[object Window]" == o.call(e) ? s(e) : i(r(e));
      };
    }, function (e, t, n) {
      var r = n(14),
          i = n(17),
          o = function o(e, t) {
        if (i(e), !r(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
      };

      e.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, t, r) {
          try {
            r = n(20)(Function.call, n(71).f(Object.prototype, "__proto__").set, 2), r(e, []), t = !(e instanceof Array);
          } catch (e) {
            t = !0;
          }

          return function (e, n) {
            return o(e, n), t ? e.__proto__ = n : r(e, n), e;
          };
        }({}, !1) : void 0),
        check: o
      };
    }, function (e, t, n) {
      var r = n(17),
          i = n(64),
          o = n(10)("species");

      e.exports = function (e, t) {
        var n,
            a = r(e).constructor;
        return void 0 === a || void 0 == (n = r(a)[o]) ? t : i(n);
      };
    }, function (e, t, n) {
      var r = n(76),
          i = n(50);

      e.exports = function (e) {
        return function (t, n) {
          var o,
              a,
              s = String(i(t)),
              u = r(n),
              c = s.length;
          return u < 0 || u >= c ? e ? "" : void 0 : (o = s.charCodeAt(u), o < 55296 || o > 56319 || u + 1 === c || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? e ? s.charAt(u) : o : e ? s.slice(u, u + 2) : a - 56320 + (o - 55296 << 10) + 65536);
        };
      };
    }, function (e, t, n) {
      var r = n(76),
          i = Math.max,
          o = Math.min;

      e.exports = function (e, t) {
        return e = r(e), e < 0 ? i(e + t, 0) : o(e, t);
      };
    }, function (e, t, n) {
      var r = n(17),
          i = n(80);

      e.exports = n(6).getIterator = function (e) {
        var t = i(e);
        if ("function" != typeof t) throw TypeError(e + " is not iterable!");
        return r(t.call(e));
      };
    }, function (e, t, n) {
      var r = n(49),
          i = n(10)("iterator"),
          o = n(32);

      e.exports = n(6).isIterable = function (e) {
        var t = Object(e);
        return void 0 !== t[i] || "@@iterator" in t || o.hasOwnProperty(r(t));
      };
    }, function (e, t, n) {
      var r = n(20),
          i = n(12),
          o = n(35),
          a = n(109),
          s = n(107),
          u = n(56),
          c = n(179),
          l = n(80);
      i(i.S + i.F * !n(110)(function (e) {}), "Array", {
        from: function from(e) {
          var t,
              n,
              i,
              d,
              h = o(e),
              f = "function" == typeof this ? this : Array,
              p = arguments.length,
              v = p > 1 ? arguments[1] : void 0,
              b = void 0 !== v,
              _ = 0,
              m = l(h);
          if (b && (v = r(v, p > 2 ? arguments[2] : void 0, 2)), void 0 == m || f == Array && s(m)) for (t = u(h.length), n = new f(t); t > _; _++) {
            c(n, _, b ? v(h[_], _) : h[_]);
          } else for (d = m.call(h), n = new f(); !(i = d.next()).done; _++) {
            c(n, _, b ? a(d, v, [i.value, _], !0) : i.value);
          }
          return n.length = _, n;
        }
      });
    }, function (e, t, n) {
      var r = n(173),
          i = n(111),
          o = n(32),
          a = n(23);
      e.exports = n(70)(Array, "Array", function (e, t) {
        this._t = a(e), this._i = 0, this._k = t;
      }, function () {
        var e = this._t,
            t = this._k,
            n = this._i++;
        return !e || n >= e.length ? (this._t = void 0, i(1)) : "keys" == t ? i(0, n) : "values" == t ? i(0, e[n]) : i(0, [n, e[n]]);
      }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
    }, function (e, t, n) {
      var r = n(103);
      e.exports = n(66)("Map", function (e) {
        return function () {
          return e(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      }, {
        get: function get(e) {
          var t = r.getEntry(this, e);
          return t && t.v;
        },
        set: function set(e, t) {
          return r.def(this, 0 === e ? 0 : e, t);
        }
      }, r, !0);
    }, function (e, t, n) {
      var r = n(12),
          i = n(13).isFinite;
      r(r.S, "Number", {
        isFinite: function isFinite(e) {
          return "number" == typeof e && i(e);
        }
      });
    }, function (e, t, n) {
      var r = n(12);
      r(r.S, "Number", {
        isNaN: function isNaN(e) {
          return e != e;
        }
      });
    }, function (e, t, n) {
      var r = n(12);
      r(r.S + r.F, "Object", {
        assign: n(112)
      });
    }, function (e, t, n) {
      var r = n(12);
      r(r.S, "Object", {
        create: n(52)
      });
    }, function (e, t, n) {
      var r = n(12);
      r(r.S + r.F * !n(18), "Object", {
        defineProperty: n(15).f
      });
    }, function (e, t, n) {
      var r = n(14),
          i = n(33).onFreeze;
      n(54)("freeze", function (e) {
        return function (t) {
          return e && r(t) ? e(i(t)) : t;
        };
      });
    }, function (e, t, n) {
      var r = n(23),
          i = n(71).f;
      n(54)("getOwnPropertyDescriptor", function () {
        return function (e, t) {
          return i(r(e), t);
        };
      });
    }, function (e, t, n) {
      var r = n(35),
          i = n(114);
      n(54)("getPrototypeOf", function () {
        return function (e) {
          return i(r(e));
        };
      });
    }, function (e, t, n) {
      var r = n(35),
          i = n(34);
      n(54)("keys", function () {
        return function (e) {
          return i(r(e));
        };
      });
    }, function (e, t, n) {
      var r = n(12);
      r(r.S, "Object", {
        setPrototypeOf: n(187).set
      });
    }, function (e, t, n) {
      var r,
          i,
          o,
          a = n(51),
          s = n(13),
          u = n(20),
          c = n(49),
          l = n(12),
          d = n(14),
          h = n(64),
          f = n(48),
          p = n(40),
          v = n(188),
          b = n(117).set,
          _ = n(184)(),
          m = s.TypeError,
          g = s.process,
          _y = s.Promise,
          g = s.process,
          S = "process" == c(g),
          E = function E() {},
          C = !!function () {
        try {
          var e = _y.resolve(1),
              t = (e.constructor = {})[n(10)("species")] = function (e) {
            e(E, E);
          };

          return (S || "function" == typeof PromiseRejectionEvent) && e.then(E) instanceof t;
        } catch (e) {}
      }(),
          T = function T(e, t) {
        return e === t || e === _y && t === o;
      },
          w = function w(e) {
        var t;
        return !(!d(e) || "function" != typeof (t = e.then)) && t;
      },
          k = function k(e) {
        return T(_y, e) ? new P(e) : new i(e);
      },
          P = i = function i(e) {
        var t, n;
        this.promise = new e(function (e, r) {
          if (void 0 !== t || void 0 !== n) throw m("Bad Promise constructor");
          t = e, n = r;
        }), this.resolve = h(t), this.reject = h(n);
      },
          O = function O(e) {
        try {
          e();
        } catch (e) {
          return {
            error: e
          };
        }
      },
          R = function R(e, t) {
        if (!e._n) {
          e._n = !0;
          var n = e._c;

          _(function () {
            for (var r = e._v, i = 1 == e._s, o = 0; n.length > o;) {
              !function (t) {
                var n,
                    o,
                    a = i ? t.ok : t.fail,
                    s = t.resolve,
                    u = t.reject,
                    c = t.domain;

                try {
                  a ? (i || (2 == e._h && N(e), e._h = 1), !0 === a ? n = r : (c && c.enter(), n = a(r), c && c.exit()), n === t.promise ? u(m("Promise-chain cycle")) : (o = w(n)) ? o.call(n, s, u) : s(n)) : u(r);
                } catch (e) {
                  u(e);
                }
              }(n[o++]);
            }

            e._c = [], e._n = !1, t && !e._h && A(e);
          });
        }
      },
          A = function A(e) {
        b.call(s, function () {
          var t,
              n,
              r,
              i = e._v;
          if (M(e) && (t = O(function () {
            S ? g.emit("unhandledRejection", i, e) : (n = s.onunhandledrejection) ? n({
              promise: e,
              reason: i
            }) : (r = s.console) && r.error && r.error("Unhandled promise rejection", i);
          }), e._h = S || M(e) ? 2 : 1), e._a = void 0, t) throw t.error;
        });
      },
          M = function M(e) {
        if (1 == e._h) return !1;

        for (var t, n = e._a || e._c, r = 0; n.length > r;) {
          if (t = n[r++], t.fail || !M(t.promise)) return !1;
        }

        return !0;
      },
          N = function N(e) {
        b.call(s, function () {
          var t;
          S ? g.emit("rejectionHandled", e) : (t = s.onrejectionhandled) && t({
            promise: e,
            reason: e._v
          });
        });
      },
          I = function I(e) {
        var t = this;
        t._d || (t._d = !0, t = t._w || t, t._v = e, t._s = 2, t._a || (t._a = t._c.slice()), R(t, !0));
      },
          L = function L(e) {
        var t,
            n = this;

        if (!n._d) {
          n._d = !0, n = n._w || n;

          try {
            if (n === e) throw m("Promise can't be resolved itself");
            (t = w(e)) ? _(function () {
              var r = {
                _w: n,
                _d: !1
              };

              try {
                t.call(e, u(L, r, 1), u(I, r, 1));
              } catch (e) {
                I.call(r, e);
              }
            }) : (n._v = e, n._s = 1, R(n, !1));
          } catch (e) {
            I.call({
              _w: n,
              _d: !1
            }, e);
          }
        }
      };

      C || (_y = function y(e) {
        f(this, _y, "Promise", "_h"), h(e), r.call(this);

        try {
          e(u(L, this, 1), u(I, this, 1));
        } catch (e) {
          I.call(this, e);
        }
      }, r = function r(e) {
        this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
      }, r.prototype = n(55)(_y.prototype, {
        then: function then(e, t) {
          var n = k(v(this, _y));
          return n.ok = "function" != typeof e || e, n.fail = "function" == typeof t && t, n.domain = S ? g.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && R(this, !1), n.promise;
        },
        catch: function _catch(e) {
          return this.then(void 0, e);
        }
      }), P = function P() {
        var e = new r();
        this.promise = e, this.resolve = u(L, e, 1), this.reject = u(I, e, 1);
      }), l(l.G + l.W + l.F * !C, {
        Promise: _y
      }), n(42)(_y, "Promise"), n(116)("Promise"), o = n(6).Promise, l(l.S + l.F * !C, "Promise", {
        reject: function reject(e) {
          var t = k(this);
          return (0, t.reject)(e), t.promise;
        }
      }), l(l.S + l.F * (a || !C), "Promise", {
        resolve: function resolve(e) {
          if (e instanceof _y && T(e.constructor, this)) return e;
          var t = k(this);
          return (0, t.resolve)(e), t.promise;
        }
      }), l(l.S + l.F * !(C && n(110)(function (e) {
        _y.all(e).catch(E);
      })), "Promise", {
        all: function all(e) {
          var t = this,
              n = k(t),
              r = n.resolve,
              i = n.reject,
              o = O(function () {
            var n = [],
                o = 0,
                a = 1;
            p(e, !1, function (e) {
              var s = o++,
                  u = !1;
              n.push(void 0), a++, t.resolve(e).then(function (e) {
                u || (u = !0, n[s] = e, --a || r(n));
              }, i);
            }), --a || r(n);
          });
          return o && i(o.error), n.promise;
        },
        race: function race(e) {
          var t = this,
              n = k(t),
              r = n.reject,
              i = O(function () {
            p(e, !1, function (e) {
              t.resolve(e).then(n.resolve, r);
            });
          });
          return i && r(i.error), n.promise;
        }
      });
    }, function (e, t, n) {
      var r = n(103);
      e.exports = n(66)("Set", function (e) {
        return function () {
          return e(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      }, {
        add: function add(e) {
          return r.def(this, e = 0 === e ? 0 : e, e);
        }
      }, r);
    }, function (e, t, n) {
      var r = n(13),
          i = n(21),
          o = n(18),
          a = n(12),
          s = n(73),
          u = n(33).KEY,
          c = n(28),
          l = n(75),
          d = n(42),
          h = n(57),
          f = n(10),
          p = n(79),
          v = n(78),
          b = n(183),
          _ = n(180),
          m = n(108),
          g = n(17),
          y = n(23),
          S = n(77),
          E = n(41),
          C = n(52),
          T = n(186),
          w = n(71),
          k = n(15),
          P = n(34),
          O = w.f,
          R = k.f,
          A = T.f,
          _M = r.Symbol,
          N = r.JSON,
          I = N && N.stringify,
          L = f("_hidden"),
          j = f("toPrimitive"),
          D = {}.propertyIsEnumerable,
          H = l("symbol-registry"),
          F = l("symbols"),
          U = l("op-symbols"),
          x = Object.prototype,
          B = "function" == typeof _M,
          V = r.QObject,
          G = !V || !V.prototype || !V.prototype.findChild,
          W = o && c(function () {
        return 7 != C(R({}, "a", {
          get: function get() {
            return R(this, "a", {
              value: 7
            }).a;
          }
        })).a;
      }) ? function (e, t, n) {
        var r = O(x, t);
        r && delete x[t], R(e, t, n), r && e !== x && R(x, t, r);
      } : R,
          z = function z(e) {
        var t = F[e] = C(_M.prototype);
        return t._k = e, t;
      },
          q = B && "symbol" == typeof _M.iterator ? function (e) {
        return "symbol" == typeof e;
      } : function (e) {
        return e instanceof _M;
      },
          Y = function Y(e, t, n) {
        return e === x && Y(U, t, n), g(e), t = S(t, !0), g(n), i(F, t) ? (n.enumerable ? (i(e, L) && e[L][t] && (e[L][t] = !1), n = C(n, {
          enumerable: E(0, !1)
        })) : (i(e, L) || R(e, L, E(1, {})), e[L][t] = !0), W(e, t, n)) : R(e, t, n);
      },
          K = function K(e, t) {
        g(e);

        for (var n, r = _(t = y(t)), i = 0, o = r.length; o > i;) {
          Y(e, n = r[i++], t[n]);
        }

        return e;
      },
          J = function J(e, t) {
        return void 0 === t ? C(e) : K(C(e), t);
      },
          X = function X(e) {
        var t = D.call(this, e = S(e, !0));
        return !(this === x && i(F, e) && !i(U, e)) && (!(t || !i(this, e) || !i(F, e) || i(this, L) && this[L][e]) || t);
      },
          Q = function Q(e, t) {
        if (e = y(e), t = S(t, !0), e !== x || !i(F, t) || i(U, t)) {
          var n = O(e, t);
          return !n || !i(F, t) || i(e, L) && e[L][t] || (n.enumerable = !0), n;
        }
      },
          $ = function $(e) {
        for (var t, n = A(y(e)), r = [], o = 0; n.length > o;) {
          i(F, t = n[o++]) || t == L || t == u || r.push(t);
        }

        return r;
      },
          Z = function Z(e) {
        for (var t, n = e === x, r = A(n ? U : y(e)), o = [], a = 0; r.length > a;) {
          !i(F, t = r[a++]) || n && !i(x, t) || o.push(F[t]);
        }

        return o;
      };

      B || (_M = function M() {
        if (this instanceof _M) throw TypeError("Symbol is not a constructor!");

        var e = h(arguments.length > 0 ? arguments[0] : void 0),
            t = function t(n) {
          this === x && t.call(U, n), i(this, L) && i(this[L], e) && (this[L][e] = !1), W(this, e, E(1, n));
        };

        return o && G && W(x, e, {
          configurable: !0,
          set: t
        }), z(e);
      }, s(_M.prototype, "toString", function () {
        return this._k;
      }), w.f = Q, k.f = Y, n(113).f = T.f = $, n(53).f = X, n(72).f = Z, o && !n(51) && s(x, "propertyIsEnumerable", X, !0), p.f = function (e) {
        return z(f(e));
      }), a(a.G + a.W + a.F * !B, {
        Symbol: _M
      });

      for (var ee = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), te = 0; ee.length > te;) {
        f(ee[te++]);
      }

      for (var ee = P(f.store), te = 0; ee.length > te;) {
        v(ee[te++]);
      }

      a(a.S + a.F * !B, "Symbol", {
        for: function _for(e) {
          return i(H, e += "") ? H[e] : H[e] = _M(e);
        },
        keyFor: function keyFor(e) {
          if (q(e)) return b(H, e);
          throw TypeError(e + " is not a symbol!");
        },
        useSetter: function useSetter() {
          G = !0;
        },
        useSimple: function useSimple() {
          G = !1;
        }
      }), a(a.S + a.F * !B, "Object", {
        create: J,
        defineProperty: Y,
        defineProperties: K,
        getOwnPropertyDescriptor: Q,
        getOwnPropertyNames: $,
        getOwnPropertySymbols: Z
      }), N && a(a.S + a.F * (!B || c(function () {
        var e = _M();

        return "[null]" != I([e]) || "{}" != I({
          a: e
        }) || "{}" != I(Object(e));
      })), "JSON", {
        stringify: function stringify(e) {
          if (void 0 !== e && !q(e)) {
            for (var t, n, r = [e], i = 1; arguments.length > i;) {
              r.push(arguments[i++]);
            }

            return t = r[1], "function" == typeof t && (n = t), !n && m(t) || (t = function t(e, _t3) {
              if (n && (_t3 = n.call(this, e, _t3)), !q(_t3)) return _t3;
            }), r[1] = t, I.apply(N, r);
          }
        }
      }), _M.prototype[j] || n(22)(_M.prototype, j, _M.prototype.valueOf), d(_M, "Symbol"), d(Math, "Math", !0), d(r.JSON, "JSON", !0);
    }, function (e, t, n) {
      var r,
          i = n(65)(0),
          o = n(73),
          a = n(33),
          s = n(112),
          u = n(178),
          c = n(14),
          l = a.getWeak,
          d = Object.isExtensible,
          h = u.ufstore,
          f = {},
          p = function p(e) {
        return function () {
          return e(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      },
          v = {
        get: function get(e) {
          if (c(e)) {
            var t = l(e);
            return !0 === t ? h(this).get(e) : t ? t[this._i] : void 0;
          }
        },
        set: function set(e, t) {
          return u.def(this, e, t);
        }
      },
          b = e.exports = n(66)("WeakMap", p, v, u, !0, !0);

      7 != new b().set((Object.freeze || Object)(f), 7).get(f) && (r = u.getConstructor(p), s(r.prototype, v), a.NEED = !0, i(["delete", "has", "get", "set"], function (e) {
        var t = b.prototype,
            n = t[e];
        o(t, e, function (t, i) {
          if (c(t) && !d(t)) {
            this._f || (this._f = new r());

            var o = this._f[e](t, i);

            return "set" == e ? this : o;
          }

          return n.call(this, t, i);
        });
      }));
    }, function (e, t, n) {
      var r = n(12);
      r(r.P + r.R, "Map", {
        toJSON: n(104)("Map")
      });
    }, function (e, t, n) {
      var r = n(12);
      r(r.P + r.R, "Set", {
        toJSON: n(104)("Set")
      });
    }, function (e, t, n) {
      n(78)("asyncIterator");
    }, function (e, t, n) {
      n(78)("observable");
    }, function (e, t, n) {
      var r = function () {
        return this;
      }() || Function("return this")(),
          i = r.regeneratorRuntime && Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime") >= 0,
          o = i && r.regeneratorRuntime;

      if (r.regeneratorRuntime = void 0, e.exports = n(215), i) r.regeneratorRuntime = o;else try {
        delete r.regeneratorRuntime;
      } catch (e) {
        r.regeneratorRuntime = void 0;
      }
    }, function (e, t) {
      !function (t) {
        function n(e, t, n, r) {
          var o = t && t.prototype instanceof i ? t : i,
              a = Object.create(o.prototype),
              s = new f(r || []);
          return a._invoke = c(e, n, s), a;
        }

        function r(e, t, n) {
          try {
            return {
              type: "normal",
              arg: e.call(t, n)
            };
          } catch (e) {
            return {
              type: "throw",
              arg: e
            };
          }
        }

        function i() {}

        function o() {}

        function a() {}

        function s(e) {
          ["next", "throw", "return"].forEach(function (t) {
            e[t] = function (e) {
              return this._invoke(t, e);
            };
          });
        }

        function u(e) {
          function t(n, i, o, a) {
            var s = r(e[n], e, i);

            if ("throw" !== s.type) {
              var u = s.arg,
                  c = u.value;
              return c && "object" == typeof c && m.call(c, "__await") ? Promise.resolve(c.__await).then(function (e) {
                t("next", e, o, a);
              }, function (e) {
                t("throw", e, o, a);
              }) : Promise.resolve(c).then(function (e) {
                u.value = e, o(u);
              }, a);
            }

            a(s.arg);
          }

          function n(e, n) {
            function r() {
              return new Promise(function (r, i) {
                t(e, n, r, i);
              });
            }

            return i = i ? i.then(r, r) : r();
          }

          var i;
          this._invoke = n;
        }

        function c(e, t, n) {
          var i = w;
          return function (o, a) {
            if (i === P) throw new Error("Generator is already running");

            if (i === O) {
              if ("throw" === o) throw a;
              return v();
            }

            for (n.method = o, n.arg = a;;) {
              var s = n.delegate;

              if (s) {
                var u = l(s, n);

                if (u) {
                  if (u === R) continue;
                  return u;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (i === w) throw i = O, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              i = P;
              var c = r(e, t, n);

              if ("normal" === c.type) {
                if (i = n.done ? O : k, c.arg === R) continue;
                return {
                  value: c.arg,
                  done: n.done
                };
              }

              "throw" === c.type && (i = O, n.method = "throw", n.arg = c.arg);
            }
          };
        }

        function l(e, t) {
          var n = e.iterator[t.method];

          if (n === b) {
            if (t.delegate = null, "throw" === t.method) {
              if (e.iterator.return && (t.method = "return", t.arg = b, l(e, t), "throw" === t.method)) return R;
              t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return R;
          }

          var i = r(n, e.iterator, t.arg);
          if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, R;
          var o = i.arg;
          return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = b), t.delegate = null, R) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, R);
        }

        function d(e) {
          var t = {
            tryLoc: e[0]
          };
          1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
        }

        function h(e) {
          var t = e.completion || {};
          t.type = "normal", delete t.arg, e.completion = t;
        }

        function f(e) {
          this.tryEntries = [{
            tryLoc: "root"
          }], e.forEach(d, this), this.reset(!0);
        }

        function p(e) {
          if (e) {
            var t = e[y];
            if (t) return t.call(e);
            if ("function" == typeof e.next) return e;

            if (!isNaN(e.length)) {
              var n = -1,
                  r = function t() {
                for (; ++n < e.length;) {
                  if (m.call(e, n)) return t.value = e[n], t.done = !1, t;
                }

                return t.value = b, t.done = !0, t;
              };

              return r.next = r;
            }
          }

          return {
            next: v
          };
        }

        function v() {
          return {
            value: b,
            done: !0
          };
        }

        var b,
            _ = Object.prototype,
            m = _.hasOwnProperty,
            g = "function" == typeof Symbol ? Symbol : {},
            y = g.iterator || "@@iterator",
            S = g.asyncIterator || "@@asyncIterator",
            E = g.toStringTag || "@@toStringTag",
            C = "object" == typeof e,
            T = t.regeneratorRuntime;
        if (T) return void (C && (e.exports = T));
        T = t.regeneratorRuntime = C ? e.exports : {}, T.wrap = n;
        var w = "suspendedStart",
            k = "suspendedYield",
            P = "executing",
            O = "completed",
            R = {},
            A = {};

        A[y] = function () {
          return this;
        };

        var M = Object.getPrototypeOf,
            N = M && M(M(p([])));
        N && N !== _ && m.call(N, y) && (A = N);
        var I = a.prototype = i.prototype = Object.create(A);
        o.prototype = I.constructor = a, a.constructor = o, a[E] = o.displayName = "GeneratorFunction", T.isGeneratorFunction = function (e) {
          var t = "function" == typeof e && e.constructor;
          return !!t && (t === o || "GeneratorFunction" === (t.displayName || t.name));
        }, T.mark = function (e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, a) : (e.__proto__ = a, E in e || (e[E] = "GeneratorFunction")), e.prototype = Object.create(I), e;
        }, T.awrap = function (e) {
          return {
            __await: e
          };
        }, s(u.prototype), u.prototype[S] = function () {
          return this;
        }, T.AsyncIterator = u, T.async = function (e, t, r, i) {
          var o = new u(n(e, t, r, i));
          return T.isGeneratorFunction(t) ? o : o.next().then(function (e) {
            return e.done ? e.value : o.next();
          });
        }, s(I), I[E] = "Generator", I[y] = function () {
          return this;
        }, I.toString = function () {
          return "[object Generator]";
        }, T.keys = function (e) {
          var t = [];

          for (var n in e) {
            t.push(n);
          }

          return t.reverse(), function n() {
            for (; t.length;) {
              var r = t.pop();
              if (r in e) return n.value = r, n.done = !1, n;
            }

            return n.done = !0, n;
          };
        }, T.values = p, f.prototype = {
          constructor: f,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = b, this.done = !1, this.delegate = null, this.method = "next", this.arg = b, this.tryEntries.forEach(h), !e) for (var t in this) {
              "t" === t.charAt(0) && m.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = b);
            }
          },
          stop: function stop() {
            this.done = !0;
            var e = this.tryEntries[0],
                t = e.completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            function t(t, r) {
              return o.type = "throw", o.arg = e, n.next = t, r && (n.method = "next", n.arg = b), !!r;
            }

            if (this.done) throw e;

            for (var n = this, r = this.tryEntries.length - 1; r >= 0; --r) {
              var i = this.tryEntries[r],
                  o = i.completion;
              if ("root" === i.tryLoc) return t("end");

              if (i.tryLoc <= this.prev) {
                var a = m.call(i, "catchLoc"),
                    s = m.call(i, "finallyLoc");

                if (a && s) {
                  if (this.prev < i.catchLoc) return t(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return t(i.finallyLoc);
                } else if (a) {
                  if (this.prev < i.catchLoc) return t(i.catchLoc, !0);
                } else {
                  if (!s) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return t(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(e, t) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var r = this.tryEntries[n];

              if (r.tryLoc <= this.prev && m.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                var i = r;
                break;
              }
            }

            i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
            var o = i ? i.completion : {};
            return o.type = e, o.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, R) : this.complete(o);
          },
          complete: function complete(e, t) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), R;
          },
          finish: function finish(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var n = this.tryEntries[t];
              if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), h(n), R;
            }
          },
          catch: function _catch(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var n = this.tryEntries[t];

              if (n.tryLoc === e) {
                var r = n.completion;

                if ("throw" === r.type) {
                  var i = r.arg;
                  h(n);
                }

                return i;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, t, n) {
            return this.delegate = {
              iterator: p(e),
              resultName: t,
              nextLoc: n
            }, "next" === this.method && (this.arg = b), R;
          }
        };
      }(function () {
        return this;
      }() || Function("return this")());
    }, function (e, t, n) {
      e.exports = n(118);
    }]);
  });
});
unwrapExports(red5proSdk_min);
var red5proSdk_min_1 = red5proSdk_min.RTCPublisher;
var red5proSdk_min_2 = red5proSdk_min.PublisherEventTypes;
var red5proSdk_min_3 = red5proSdk_min.RTCPublisherEventTypes;
var red5proSdk_min_4 = red5proSdk_min.RTCSubscriber;
var red5proSdk_min_5 = red5proSdk_min.RTCSubscriberEventTypes;
var red5proSdk_min_6 = red5proSdk_min.SubscriberEventTypes;
var red5proSdk_min_7 = red5proSdk_min.red5prosdk;

function red5ProUtils() {
  console.debug('loaded red5pro utils');
  var INTERVAL_MILLISECONDS = 1000;

  var calculateBitRateSent = function calculateBitRateSent(bytes, lastResult, report, now) {
    return 8 * (bytes - lastResult.get(report.id).bytesSent) / (now - lastResult.get(report.id).timestamp);
  };

  var calculateBitRateReceived = function calculateBitRateReceived(bytes, lastResult, report, now) {
    return 8 * (bytes - lastResult.get(report.id).bytesReceived) / (now - lastResult.get(report.id).timestamp);
  };

  var isPublishing = function isPublishing(isSubscriber, report) {
    return !isSubscriber && (report.type === 'outboundrtp' || report.type === 'outbound-rtp' || report.type === 'ssrc' && report.bytesSent);
  };

  var isSubscribing = function isSubscribing(isSubscriber, report) {
    isSubscriber && (report.type === 'inboundrtp' || report.type === 'inbound-rtp' || report.type === 'ssrc' && report.bytesReceived);
  };

  var globalBitrateTicket = undefined;
  var bitrateTickets = [];

  var BitrateTicket = function BitrateTicket(connection, cb, resolutionCb, isSubscriber) {
    this.connection = connection;
    this.cb = cb;
    this.resolutionCb = resolutionCb;
    this.isSubscriber = isSubscriber;
    this.bitrateInterval = 0;
  };

  BitrateTicket.prototype.start = function () {
    var lastResult;
    var connection = this.connection;
    var cb = this.cb;
    var resolutionCb = this.resolutionCb;
    var isSubscriber = this.isSubscriber; // Based on https://github.com/webrtc/samples/blob/gh-pages/src/content/peerconnection/bandwidth/js/main.js

    this.bitrateInterval = setInterval(function () {
      connection.getStats(null).then(function (res) {
        res.forEach(function (report) {
          var bytes;
          var packets;
          var now = report.timestamp;
          var bitrate;

          if (isPublishing(isSubscriber, report)) {
            bytes = report.bytesSent;
            packets = report.packetsSent;

            if (report.mediaType === 'video' && lastResult && lastResult.get(report.id)) {
              bitrate = calculateBitRateSent(bytes, lastResult, report, now);
              cb(bitrate, packets);
            }
          } else if (isSubscribing(isSubscriber, report)) {
            bytes = report.bytesReceived;
            packets = report.packetsReceived;

            if (report.mediaType === 'video' && lastResult && lastResult.get(report.id)) {
              bitrate = calculateBitRateReceived(bytes, lastResult, report, now);
              cb(bitrate, packets);
            }
          } else if (resolutionCb && report.type === 'track' && report.kind === 'video') {
            resolutionCb(report.frameWidth, report.frameHeight);
          }
        });
        lastResult = res;
      });
    }, INTERVAL_MILLISECONDS);
  };

  BitrateTicket.prototype.stop = function () {
    console.log('bitrate ticket stop');
    clearInterval(this.bitrateInterval);
  };

  window.trackBitrate = function (connection, cb, resolutionCb, isSubscriber, withTicket) {
    var t = new BitrateTicket(connection, cb, resolutionCb, isSubscriber);

    if (withTicket) {
      var ticket = ['bitrateTicket', Math.floor(Math.random() * 0x10000).toString(16)].join('-');
      bitrateTickets[ticket] = t;
      t.start();
      return ticket;
    } else if (globalBitrateTicket) {
      globalBitrateTicket.stop();
    }

    globalBitrateTicket = t;
    t.start();
  };

  window.untrackBitrate = function (ticket) {
    if (!ticket && globalBitrateTicket) {
      globalBitrateTicket.stop();
    } else if (bitrateTickets[ticket]) {
      bitrateTickets[ticket].stop();
      delete bitrateTickets[ticket];
    }
  };
}

var Red5Service = /*#__PURE__*/function () {
  function Red5Service() {
    var _this = this;

    _classCallCheck(this, Red5Service);

    this.trackBitrate = function (onBitrateUpdate) {
      if (onBitrateUpdate && _this.red5ProPublisher.getPeerConnection) {
        try {
          window.trackBitrate(_this.red5ProPublisher.getPeerConnection(), onBitrateUpdate);
        } catch (e) {
          console.log(e);
        }
      }
    };

    this.untrackBitrate = function () {
      window.untrackBitrate && window.untrackBitrate();
    };

    red5ProUtils();
  }

  return _createClass(Red5Service, [{
    key: "initializePublisher",
    value: function () {
      var _initializePublisher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config, eventHandler) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.debug('Configuring Publisher');
                console.debug(config);
                _context.prev = 2;
                this.red5ProPublisher = new red5proSdk_min_1();
                _context.next = 6;
                return this.red5ProPublisher.init(config.rtc);

              case 6:
                this.red5ProPublisher.on('*', eventHandler);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                console.log("Could not initialize: ".concat(_context.t0));
                console.error(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function initializePublisher(_x, _x2) {
        return _initializePublisher.apply(this, arguments);
      }

      return initializePublisher;
    }()
  }, {
    key: "publishStream",
    value: function () {
      var _publishStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.debug('red5service publish');
                _context2.next = 3;
                return this.red5ProPublisher.publish();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function publishStream() {
        return _publishStream.apply(this, arguments);
      }

      return publishStream;
    }()
  }, {
    key: "stopStream",
    value: function () {
      var _stopStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                console.debug('Stopping!');
                _context3.next = 4;
                return this.red5ProPublisher.unpublish();

              case 4:
                _context3.next = 10;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                console.warn('Could not stop stream');
                console.warn(_context3.t0);

              case 10:
                this.untrackBitrate();

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 6]]);
      }));

      function stopStream() {
        return _stopStream.apply(this, arguments);
      }

      return stopStream;
    }()
  }, {
    key: "cleanUpPublisher",
    value: function () {
      var _cleanUpPublisher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.red5ProPublisher) {
                  _context4.next = 8;
                  break;
                }

                navigator.mediaDevices.ondevicechange = null;
                this.red5ProPublisher.off('*', event);
                _context4.next = 5;
                return this.stopStream();

              case 5:
                this.red5ProPublisher = null;
                _context4.next = 9;
                break;

              case 8:
                console.debug('No existing publisher for this instance of Red5Service');

              case 9:
                this.untrackBitrate();

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function cleanUpPublisher(_x3) {
        return _cleanUpPublisher.apply(this, arguments);
      }

      return cleanUpPublisher;
    }()
  }]);
}();

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    formControl: {
      minWidth: 120
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  };
};

var Select = /*#__PURE__*/function (_React$Component) {
  function Select() {
    _classCallCheck(this, Select);

    return _callSuper(this, Select, arguments);
  }

  _inherits(Select, _React$Component);

  return _createClass(Select, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          _onChange = _this$props.onChange,
          value = _this$props.value,
          options = _this$props.options,
          disabled = _this$props.disabled,
          label = _this$props.label,
          optionKeyProperty = _this$props.optionKeyProperty,
          optionTitleProperty = _this$props.optionTitleProperty,
          showNoneOption = _this$props.showNoneOption;
      return /*#__PURE__*/React.createElement(FormControl, {
        className: classes.formControl,
        disabled: !options || !options.length
      }, /*#__PURE__*/React.createElement(InputLabel, {
        htmlFor: "item-select"
      }, label), /*#__PURE__*/React.createElement(Select$2, {
        value: value,
        className: classes.select,
        onChange: function onChange(event) {
          return _onChange(event.target.value);
        },
        disabled: disabled
      }, showNoneOption && /*#__PURE__*/React.createElement(MenuItem, {
        value: ''
      }, "None"), options && options.length ? options.map(function (option) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: option[optionKeyProperty],
          value: option
        }, option[optionTitleProperty]);
      }) : []), !options || !options.length ? /*#__PURE__*/React.createElement(FormHelperText, null, "No Items") : '');
    }
  }]);
}(React.Component);

Select.propTypes = {
  classes: PropTypes__default.object.isRequired,
  options: PropTypes__default.array.isRequired,
  label: PropTypes__default.string.isRequired,
  optionKeyProperty: PropTypes__default.string.isRequired,
  optionTitleProperty: PropTypes__default.string.isRequired,
  value: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string, PropTypes__default.object]),
  disabled: PropTypes__default.bool,
  showNoneOption: PropTypes__default.bool,
  onChange: PropTypes__default.func.isRequired
};
var Select$1 = withStyles(styles)(Select);

var MediaInputSelectors = function MediaInputSelectors(_ref) {
  var onAudioInputChange = _ref.onAudioInputChange,
      onVideoInputChange = _ref.onVideoInputChange,
      disabled = _ref.disabled,
      videoInputs = _ref.videoInputs,
      selectedVideoInput = _ref.selectedVideoInput,
      audioInputs = _ref.audioInputs,
      selectedAudioInput = _ref.selectedAudioInput;

  function handleVideoInput(e) {
    var _selectedVideoInput$d, _selectedVideoInput$g;

    var inputPreviouslySelected = ((_selectedVideoInput$d = selectedVideoInput.deviceId) === null || _selectedVideoInput$d === void 0 ? void 0 : _selectedVideoInput$d.length) > 0 || ((_selectedVideoInput$g = selectedVideoInput.groupId) === null || _selectedVideoInput$g === void 0 ? void 0 : _selectedVideoInput$g.length) > 0;
    var inputCurrentlySelected = e !== '';

    if (inputPreviouslySelected || inputCurrentlySelected) {
      onVideoInputChange(e);
    }
  }

  function handleAudioInput(e) {
    var _selectedAudioInput$d, _selectedAudioInput$g;

    var inputPreviouslySelected = ((_selectedAudioInput$d = selectedAudioInput.deviceId) === null || _selectedAudioInput$d === void 0 ? void 0 : _selectedAudioInput$d.length) > 0 || ((_selectedAudioInput$g = selectedAudioInput.groupId) === null || _selectedAudioInput$g === void 0 ? void 0 : _selectedAudioInput$g.length) > 0;
    var inputCurrentlySelected = e !== '';

    if (inputPreviouslySelected || inputCurrentlySelected) {
      onAudioInputChange(e);
    }
  }

  return /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    spacing: 2,
    justify: 'flex-start'
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true
  }, /*#__PURE__*/React.createElement(Select$1, {
    disabled: disabled,
    label: "Camera",
    onChange: handleVideoInput,
    options: videoInputs,
    optionKeyProperty: "groupId",
    optionTitleProperty: "label",
    showNoneOption: true,
    value: selectedVideoInput
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true
  }, /*#__PURE__*/React.createElement(Select$1, {
    disabled: disabled,
    label: "Microphone",
    onChange: handleAudioInput,
    options: audioInputs,
    optionKeyProperty: "groupId",
    optionTitleProperty: "label",
    showNoneOption: true,
    value: selectedAudioInput
  })));
};

MediaInputSelectors.propTypes = {
  disabled: bool,
  onAudioInputChange: func.isRequired,
  selectedAudioInput: oneOfType([object$1, bool]),
  audioInputs: array.isRequired,
  onVideoInputChange: func.isRequired,
  selectedVideoInput: object$1,
  videoInputs: oneOfType([object$1, bool])
};

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    return fn.apply(thisArg, args);
  };
};
/*global toString:true*/
// utils is a library of generic helper functions non-specific to axios


var toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */

function isArray(val) {
  return toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */


function isUndefined(val) {
  return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */


function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */


function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */


function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */


function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }

  return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */


function isString(val) {
  return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */


function isNumber(val) {
  return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */


function isObject$1(val) {
  return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */


function isDate(val) {
  return toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */


function isFile(val) {
  return toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */


function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */


function isFunction(val) {
  return toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */


function isStream(val) {
  return isObject$1(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */


function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */


function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */


function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */


function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  } // Force an array if not already something iterable


  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */


function
  /* obj1, obj2, obj3, ... */
merge() {
  var result = {};

  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */


function
  /* obj1, obj2, obj3, ... */
deepMerge() {
  var result = {};

  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */


function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject$1,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */


var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }

        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */


InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */


InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */


InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */

var transformData = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });
  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */


var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;

  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function () {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };

  return error;
};
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */


var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */


var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;

  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */


var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */


var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */


var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }

  return requestedURL;
}; // Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers


var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */

var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }

      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isValidXss = function isValidXss(requestURL) {
  var xssRegex = /(\b)(on\w+)=|javascript|(<\s*)(\/*)script/gi;
  return xssRegex.test(requestURL);
};

var isURLSameOrigin = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */

  function resolveURL(url) {
    var href = url;

    if (isValidXss(url)) {
      throw new Error('URL contains XSS injection attempt');
    }

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */

  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();
var cookies = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest(); // HTTP basic authentication

    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

    request.timeout = config.timeout; // Listen for ready state

    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      } // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request


      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      } // Prepare the response


      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(resolve, reject, response); // Clean up request

      request = null;
    }; // Handle browser request cancellation (as opposed to a manual cancellation)


    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Handle low level network errors


    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request)); // Clean up request

      request = null;
    }; // Handle timeout


    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.


    if (utils.isStandardBrowserEnv()) {
      var cookies$1 = cookies; // Add xsrf header

      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies$1.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    } // Add headers to the request


    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    } // Add withCredentials to request if needed


    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    } // Add responseType to request if needed


    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    } // Handle progress if needed


    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    } // Not all browsers support upload events


    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel); // Clean up request

        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    } // Send the request


    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;

  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }

  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }

    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }

    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }

    return data;
  }],
  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        /* Ignore */
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults;
/**
 * Throws a `Cancel` if cancellation has been requested.
 */

function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */


var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config); // Ensure headers exist

  config.headers = config.headers || {}; // Transform request data

  config.data = transformData(config.data, config.headers, config.transformRequest); // Flatten headers

  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config); // Transform response data

    response.data = transformData(response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config); // Transform response data

      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */


var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};
  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = ['baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath'];
  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });
  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });
  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });
  var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
  var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
    return axiosKeys.indexOf(key) === -1;
  });
  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });
  return config;
};
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */


function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */


Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config); // Set config.method

  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  } // Hook up interceptors middleware


  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
}; // Provide aliases for supported request methods


utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios;
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel;
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */

function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */


CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */


CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */


function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context); // Copy axios.prototype to instance

  utils.extend(instance, Axios_1.prototype, context); // Copy context to instance

  utils.extend(instance, context);
  return instance;
} // Create the default instance to be exported


var axios = createInstance(defaults_1); // Expose Axios class to allow class inheritance

axios.Axios = Axios_1; // Factory for creating new instances

axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
}; // Expose Cancel & CancelToken


axios.Cancel = Cancel_1;
axios.CancelToken = CancelToken_1;
axios.isCancel = isCancel; // Expose all/spread

axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;
var axios_1 = axios; // Allow use of default import syntax in TypeScript

var default_1 = axios;
axios_1.default = default_1;
var axios$1 = axios_1;
var EVENT_HTTP_401 = '@http-event/EVENT_HTTP_401';
var eventHttp = {
  EVENT_HTTP_401: EVENT_HTTP_401
};

var EventService = /*#__PURE__*/function () {
  function EventService() {
    _classCallCheck(this, EventService);
  }

  return _createClass(EventService, null, [{
    key: "dispatchEvent",
    value: function dispatchEvent(eventName, payload) {
      var event;

      if (payload) {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, payload);
      } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
      }

      this.html.dispatchEvent(event);
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(eventName, eventFunction) {
      this.html.addEventListener(eventName, eventFunction);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventName, eventFunction) {
      this.html.removeEventListener(eventName, eventFunction);
    }
  }]);
}();

EventService.html = document.getElementsByTagName('html')[0];
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */

var parse_1 = parse;
var serialize_1 = serialize;
/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode$1 = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(';');
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('='); // skip things that don't look like key=value

    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim(); // only assign once

    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim(); // quoted values

      if (val[0] === '"') {
        val = val.slice(1, -1);
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */


function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode$1;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid');
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;

      case 'lax':
        str += '; SameSite=Lax';
        break;

      case 'strict':
        str += '; SameSite=Strict';
        break;

      case 'none':
        str += '; SameSite=None';
        break;

      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */


function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

function hasDocumentCookie() {
  // JSDOM does not support changing cookies, disable it for tests
  if (isJsDom()) {
    return false;
  } // Can we get/set cookies on document.cookie?


  return typeof document === 'object' && typeof document.cookie === 'string';
}

function isJsDom() {
  if (typeof navigator !== 'object' || typeof navigator.userAgent !== 'string') {
    return false;
  }

  return navigator.userAgent.indexOf('Node.js') >= 0 || navigator.userAgent.indexOf('jsdom') >= 0;
}

function parseCookies(cookies) {
  if (typeof cookies === 'string') {
    return parse_1(cookies);
  } else if (typeof cookies === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }

  var cleanValue = cleanupCookieValue(value);

  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {// At least we tried
    }
  } // Ignore clean value if we failed the deserialization
  // It is not relevant anymore to trim those values


  return value;
}

function cleanupCookieValue(value) {
  // express prepend j: before serializing a cookie
  if (value && value[0] === 'j' && value[1] === ':') {
    return value.substr(2);
  }

  return value;
} // We can't please Rollup and TypeScript at the same time
// Only way to make both of them work


var objectAssign = require('object-assign');

var Cookies =
/** @class */
function () {
  function Cookies(cookies) {
    var _this = this;

    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.cookies = parseCookies(cookies);
    new Promise(function () {
      _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    }).catch(function () {});
  }

  Cookies.prototype._updateBrowserValues = function () {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }

    this.cookies = parse_1(document.cookie);
  };

  Cookies.prototype._emitChange = function (params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };

  Cookies.prototype.get = function (name, options) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues();

    return readCookie(this.cookies[name], options);
  };

  Cookies.prototype.getAll = function (options) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues();

    var result = {};

    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }

    return result;
  };

  Cookies.prototype.set = function (name, value, options) {
    var _a;

    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }

    this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, value, options);
    }

    this._emitChange({
      name: name,
      value: value,
      options: options
    });
  };

  Cookies.prototype.remove = function (name, options) {
    var finalOptions = options = objectAssign({}, options, {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });
    this.cookies = objectAssign({}, this.cookies);
    delete this.cookies[name];

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, '', finalOptions);
    }

    this._emitChange({
      name: name,
      value: undefined,
      options: options
    });
  };

  Cookies.prototype.addChangeListener = function (callback) {
    this.changeListeners.push(callback);
  };

  Cookies.prototype.removeChangeListener = function (callback) {
    var idx = this.changeListeners.indexOf(callback);

    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };

  return Cookies;
}();

var cookies$1 = new Cookies();

var setCookie = function setCookie(name, value, daysTillExpire) {
  var data = {
    path: '/'
  };

  if (window.location.host.includes('.proxibid.com')) {
    data.domain = '.proxibid.com';
  }

  if (daysTillExpire > 0) {
    var date = new Date();
    date.setTime(date.getTime() + daysTillExpire * 24 * 60 * 60 * 1000);
    data['expires'] = date;
  }

  cookies$1.set(name, value, data);
};

var getCookieValue = function getCookieValue(name) {
  return cookies$1.get(name);
};

var deleteCookiesStartingWith = function deleteCookiesStartingWith(name) {
  Object.keys(cookies$1.getAll()).forEach(function (key) {
    if (key.startsWith(name)) {
      deleteCookie(key);
    }
  });
};

var deleteCookie = function deleteCookie(name) {
  var dataWithoutDomain = {
    path: '/'
  };
  var dataWithDomain = {
    path: '/',
    domain: '.proxibid.com'
  };
  cookies$1.remove(name, dataWithoutDomain);
  cookies$1.remove(name, dataWithDomain);
};

var deleteAllCookies = function deleteAllCookies() {
  Object.keys(cookies$1.getAll()).forEach(function (key) {
    cookies$1.remove(key);
  });
};

var cookie = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setCookie: setCookie,
  getCookieValue: getCookieValue,
  deleteCookiesStartingWith: deleteCookiesStartingWith,
  deleteCookie: deleteCookie,
  deleteAllCookies: deleteAllCookies
});
var axiosInstance = axios$1.create();
axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';
axiosInstance.interceptors.request.use(function (config) {
  config.withCredentials = true;

  if (config.headers['user-id'] || getCookieValue('userid')) {
    config.headers['user-id'] = config.headers['user-id'] || getCookieValue('userid');
  }

  if (config.headers['guid'] || getCookieValue('guid')) {
    config.headers['guid'] = config.headers['guid'] || getCookieValue('guid');
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});
axiosInstance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var _error$response, _error$config, _error$config$params;

  if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401 && !(error !== null && error !== void 0 && (_error$config = error.config) !== null && _error$config !== void 0 && (_error$config$params = _error$config.params) !== null && _error$config$params !== void 0 && _error$config$params.skip401Event)) {
    EventService.dispatchEvent(EVENT_HTTP_401);
  }

  return Promise.reject(error);
});

var getPublishConfigRequestBody = function getPublishConfigRequestBody(streamTest, bandwidth) {
  return {
    backgroundColor: '#000000',
    embedHeight: '360',
    embedWidth: '640',
    streamTest: streamTest,
    bandwidth: bandwidth
  };
};

var getSubscribeConfigRequestBody = function getSubscribeConfigRequestBody(streamTest) {
  return {
    backgroundColor: '#000000',
    height: '360',
    mediaElementId: 'red5pro-subscriber',
    width: '640',
    streamTest: streamTest
  };
};

var fetchPublishConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(clientProxyUrl, auctionId, streamTest, bandwidth) {
    var url, data, httpConfig;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(clientProxyUrl, "/audioVideo/v1/auctions/").concat(auctionId, "/publish/config");
            data = JSON.stringify(getPublishConfigRequestBody(streamTest, bandwidth));
            httpConfig = {
              headers: {
                'Content-Type': 'application/json'
              }
            };
            return _context.abrupt("return", axiosInstance.post(url, data, httpConfig));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchPublishConfig(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var fetchSubscribeConfig = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(clientProxyUrl, auctionId, streamTest) {
    var url, data;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = "".concat(clientProxyUrl, "/audioVideo/v1/auctions/").concat(auctionId, "/subscribe/config");
            data = JSON.stringify(getSubscribeConfigRequestBody(streamTest));
            return _context2.abrupt("return", axiosInstance.post(url, data));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchSubscribeConfig(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

var saveAuction = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(clientProxyUrl, auctionId, audioOnly, active, vas) {
    var url, data, httpConfig;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = "".concat(clientProxyUrl, "/audioVideo/v1/auctions/").concat(auctionId);
            data = {
              active: !!active,
              audioOnly: !!audioOnly,
              vas: !!vas
            };
            httpConfig = {
              headers: {
                'Content-Type': 'application/json'
              }
            };
            return _context3.abrupt("return", axiosInstance.post(url, data, httpConfig));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function saveAuction(_x8, _x9, _x10, _x11, _x12) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchCurrentStreams = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(clientProxyUrl) {
    var url;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = "".concat(clientProxyUrl, "/audioVideo/v1/auctions/");
            return _context4.abrupt("return", axiosInstance.get(url));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchCurrentStreams(_x13) {
    return _ref4.apply(this, arguments);
  };
}();

var DiagnosticsDisplay = /*#__PURE__*/function (_Component) {
  function DiagnosticsDisplay(props) {
    var _this;

    _classCallCheck(this, DiagnosticsDisplay);

    _this = _callSuper(this, DiagnosticsDisplay, [props]);

    _this.onBitrateUpdate = function (bitrate, packetsSent) {
      _this.setState({
        bitrate: Math.floor(bitrate),
        packetsSent: packetsSent
      });
    };

    _this.state = {
      bitrate: 0,
      packetsSent: 0
    };
    return _this;
  }

  _inherits(DiagnosticsDisplay, _Component);

  return _createClass(DiagnosticsDisplay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.red5ProService.trackBitrate(this.onBitrateUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.red5ProService.untrackBitrate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          bitrate = _this$state.bitrate,
          packetsSent = _this$state.packetsSent;
      return /*#__PURE__*/React.createElement(Box, {
        display: 'flex',
        flexDirection: 'column'
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: 'caption'
      }, "Bitrate: ", bitrate), /*#__PURE__*/React.createElement(Typography, {
        variant: 'caption'
      }, "Packets Sent: ", packetsSent));
    }
  }]);
}(Component);

DiagnosticsDisplay.propTypes = {
  red5ProService: object$1.isRequired
};

var Notification = /*#__PURE__*/function (_React$Component) {
  function Notification() {
    _classCallCheck(this, Notification);

    return _callSuper(this, Notification, arguments);
  }

  _inherits(Notification, _React$Component);

  return _createClass(Notification, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Dialog, {
        open: this.props.messageOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
      }, /*#__PURE__*/React.createElement(DialogTitle, {
        id: "alert-dialog-title"
      }, this.props.headerText), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, {
        id: "alert-dialog-description"
      }, this.props.bodyText)), /*#__PURE__*/React.createElement(DialogActions, null, this.props.children));
    }
  }]);
}(React.Component);

Notification.propTypes = {
  messageOpen: PropTypes__default.bool.isRequired,
  headerText: PropTypes__default.string.isRequired,
  bodyText: PropTypes__default.string.isRequired,
  children: PropTypes__default.node
};

var StreamInProgress = /*#__PURE__*/function (_Component) {
  function StreamInProgress() {
    _classCallCheck(this, StreamInProgress);

    return _callSuper(this, StreamInProgress, arguments);
  }

  _inherits(StreamInProgress, _Component);

  return _createClass(StreamInProgress, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.props.show !== nextProps.show;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Notification, {
        messageOpen: this.props.show,
        headerText: 'Publishing Error:',
        bodyText: 'A broadcast was already detected to be in progress. This may be in another browser tab or window. Please close all other streams and try again.'
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.onOkay
      }, "Okay"));
    }
  }]);
}(Component);

StreamInProgress.propTypes = {
  show: bool.isRequired,
  onOkay: func.isRequired
};

var PublishHasStopped = /*#__PURE__*/function (_Component2) {
  function PublishHasStopped() {
    _classCallCheck(this, PublishHasStopped);

    return _callSuper(this, PublishHasStopped, arguments);
  }

  _inherits(PublishHasStopped, _Component2);

  return _createClass(PublishHasStopped, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.props.show !== nextProps.show;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Notification, {
        messageOpen: this.props.show,
        headerText: 'Stream has ended',
        bodyText: 'To continue broadcasting, please re-publish the stream.'
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.onOkay,
        color: "primary",
        variant: "contained"
      }, "Okay"));
    }
  }]);
}(Component);

PublishHasStopped.propTypes = {
  show: bool.isRequired,
  onOkay: func.isRequired
};

var HighBandwidth = /*#__PURE__*/function (_Component3) {
  function HighBandwidth() {
    _classCallCheck(this, HighBandwidth);

    return _callSuper(this, HighBandwidth, arguments);
  }

  _inherits(HighBandwidth, _Component3);

  return _createClass(HighBandwidth, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.props.show !== nextProps.show;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Notification, {
        messageOpen: this.props.show,
        headerText: 'Publishing Notification:',
        bodyText: 'Publishing a stream with high bandwidth requires large amounts of data. ' + 'If this is undesirable, please use a lower bandwidth for publishing.'
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.onOkay,
        color: "primary",
        variant: "contained"
      }, "Okay"));
    }
  }]);
}(Component);

HighBandwidth.propTypes = {
  show: bool.isRequired,
  onOkay: func.isRequired
};

var Reconnecting = /*#__PURE__*/function (_Component4) {
  function Reconnecting() {
    _classCallCheck(this, Reconnecting);

    return _callSuper(this, Reconnecting, arguments);
  }

  _inherits(Reconnecting, _Component4);

  return _createClass(Reconnecting, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.props.show !== nextProps.show;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Notification, {
        messageOpen: this.props.show,
        headerText: 'Reconnecting',
        bodyText: 'Your internet connection is unstable. Attempting to reconnect.'
      });
    }
  }]);
}(Component);

Reconnecting.propTypes = {
  show: bool.isRequired
};

var NoInternet = /*#__PURE__*/function (_Component5) {
  function NoInternet() {
    _classCallCheck(this, NoInternet);

    return _callSuper(this, NoInternet, arguments);
  }

  _inherits(NoInternet, _Component5);

  return _createClass(NoInternet, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.props.show !== nextProps.show;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Notification, {
        messageOpen: this.props.show,
        headerText: 'No Internet Connection',
        bodyText: 'Please republish when you are connected to internet.'
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.onOkay,
        color: "primary",
        variant: "contained"
      }, "Okay"));
    }
  }]);
}(Component);

NoInternet.propTypes = {
  show: bool.isRequired,
  onOkay: func.isRequired
};

var FailedToPublish = /*#__PURE__*/function (_Component6) {
  function FailedToPublish() {
    _classCallCheck(this, FailedToPublish);

    return _callSuper(this, FailedToPublish, arguments);
  }

  _inherits(FailedToPublish, _Component6);

  return _createClass(FailedToPublish, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.props.show !== nextProps.show;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Notification, {
        messageOpen: this.props.show,
        headerText: 'Failed to Publish',
        bodyText: 'Please check internet connection and/or refresh your page.'
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.props.onOkay,
        color: "primary",
        variant: "contained"
      }, "Okay"));
    }
  }]);
}(Component);

FailedToPublish.propTypes = {
  show: bool.isRequired,
  onOkay: func.isRequired
};
BandwidthRadioGroup.propTypes = {
  onSelect: func.isRequired,
  bandwidth: string.isRequired,
  disabled: bool
};

function BandwidthRadioGroup(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showBandwidthNotification = _useState2[0],
      setShowBandwidthNotification = _useState2[1];

  function handleChange(event) {
    props.onSelect(event.target.value);

    if (event.target.value === 'HIGH') {
      setShowBandwidthNotification(true);
    }
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormLabel, {
    component: "legend"
  }, "Bandwidth"), /*#__PURE__*/React.createElement(RadioGroup, {
    defaultValue: props.bandwidth,
    "aria-label": "bandwidth",
    name: "customized-radios",
    row: true,
    onChange: handleChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "LOW",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: "Low",
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "MEDIUM",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: "Medium",
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "HIGH",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: "High",
    disabled: props.disabled
  })), /*#__PURE__*/React.createElement(HighBandwidth, {
    show: showBandwidthNotification,
    onOkay: function onOkay() {
      return setShowBandwidthNotification(false);
    }
  }));
}

var notificationStyles = {
  width: '100%',
  position: 'absolute',
  top: '50%',
  textAlign: 'center',
  userSelect: 'none'
};
Overlay.propTypes = {
  overlayText: string.isRequired
};

function Overlay(props) {
  return /*#__PURE__*/React.createElement("div", {
    style: notificationStyles
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, props.overlayText));
}

function retrieveAvailableDevices() {
  return _retrieveAvailableDevices.apply(this, arguments);
}

function _retrieveAvailableDevices() {
  _retrieveAvailableDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var hasAudioDevices, hasVideoDevices, enumeratedDevices, videoInputs, audioInputs;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return checkAudioDevices();

          case 2:
            hasAudioDevices = _context.sent;
            _context.next = 5;
            return checkVideoDevices();

          case 5:
            hasVideoDevices = _context.sent;
            _context.next = 8;
            return navigator.mediaDevices.enumerateDevices();

          case 8:
            enumeratedDevices = _context.sent;
            videoInputs = hasVideoDevices ? dedupeListByKey(enumeratedDevices.filter(function (device) {
              return device.kind === 'videoinput';
            }), 'groupId') : [];
            audioInputs = hasAudioDevices ? dedupeListByKey(enumeratedDevices.filter(function (device) {
              return device.kind === 'audioinput';
            }), 'groupId') : [];
            return _context.abrupt("return", {
              videoInputs: videoInputs,
              audioInputs: audioInputs
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _retrieveAvailableDevices.apply(this, arguments);
}

function checkVideoDevices() {
  return _checkVideoDevices.apply(this, arguments);
}

function _checkVideoDevices() {
  _checkVideoDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", checkDevices('video'));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _checkVideoDevices.apply(this, arguments);
}

function checkAudioDevices() {
  return _checkAudioDevices.apply(this, arguments);
}

function _checkAudioDevices() {
  _checkAudioDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", checkDevices('audio'));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _checkAudioDevices.apply(this, arguments);
}

function checkDevices(_x) {
  return _checkDevices.apply(this, arguments);
}

function _checkDevices() {
  _checkDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(type) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return navigator.mediaDevices.getUserMedia(_defineProperty({}, type, true));

          case 3:
            return _context4.abrupt("return", true);

          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", false);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 6]]);
  }));
  return _checkDevices.apply(this, arguments);
}

function dedupeListByKey(list, key) {
  if (main_34) {
    return list;
  }

  var map = new Map(list.map(function (item) {
    return [item[key], item];
  }));
  return _toConsumableArray(map.values());
}

var Publisher = /*#__PURE__*/function (_Component) {
  function Publisher(props) {
    var _this;

    _classCallCheck(this, Publisher);

    _this = _callSuper(this, Publisher, [props]);
    _this.fetchConfig = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, clientProxyUrl, auctionId, streamTest, vas, response, _this$state$config, _this$state$config$rt, _this$state$config$rt2, _this$state$config$rt3, _this$state$config2, _this$state$config2$r, _this$state$config2$r2, _this$state$config2$r3, videoDeviceId, audioDeviceId, _this$state$config3, _this$state$config3$r, _this$state$config3$r2, _this$state$config4, _this$state$config4$r, _this$state$config4$r2;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, clientProxyUrl = _this$props.clientProxyUrl, auctionId = _this$props.auctionId, streamTest = _this$props.streamTest, vas = _this$props.vas;

              _this.setState({
                startingStoppingStream: true
              });

              _context.prev = 2;
              console.debug('publisher.js#fetchConfig');
              _context.next = 6;
              return fetchPublishConfig(clientProxyUrl, auctionId, streamTest, _this.state.bandwidth);

            case 6:
              response = _context.sent;

              if (!(_this.state.config !== response.data)) {
                _context.next = 15;
                break;
              }

              console.debug('publisher.js#fetchConfig : updating devices');
              videoDeviceId = (_this$state$config = _this.state.config) === null || _this$state$config === void 0 ? void 0 : (_this$state$config$rt = _this$state$config.rtc) === null || _this$state$config$rt === void 0 ? void 0 : (_this$state$config$rt2 = _this$state$config$rt.mediaConstraints) === null || _this$state$config$rt2 === void 0 ? void 0 : (_this$state$config$rt3 = _this$state$config$rt2.video) === null || _this$state$config$rt3 === void 0 ? void 0 : _this$state$config$rt3.deviceId;
              audioDeviceId = (_this$state$config2 = _this.state.config) === null || _this$state$config2 === void 0 ? void 0 : (_this$state$config2$r = _this$state$config2.rtc) === null || _this$state$config2$r === void 0 ? void 0 : (_this$state$config2$r2 = _this$state$config2$r.mediaConstraints) === null || _this$state$config2$r2 === void 0 ? void 0 : (_this$state$config2$r3 = _this$state$config2$r2.audio) === null || _this$state$config2$r3 === void 0 ? void 0 : _this$state$config2$r3.deviceId;

              if (audioDeviceId) {
                response.data.rtc.mediaConstraints.audio.deviceId = audioDeviceId;
              } else {
                response.data.rtc.mediaConstraints.audio = (_this$state$config3 = _this.state.config) === null || _this$state$config3 === void 0 ? void 0 : (_this$state$config3$r = _this$state$config3.rtc) === null || _this$state$config3$r === void 0 ? void 0 : (_this$state$config3$r2 = _this$state$config3$r.mediaConstraints) === null || _this$state$config3$r2 === void 0 ? void 0 : _this$state$config3$r2.audio;
              }

              if (videoDeviceId) {
                response.data.rtc.mediaConstraints.video.deviceId = videoDeviceId;
              } else {
                response.data.rtc.mediaConstraints.video = (_this$state$config4 = _this.state.config) === null || _this$state$config4 === void 0 ? void 0 : (_this$state$config4$r = _this$state$config4.rtc) === null || _this$state$config4$r === void 0 ? void 0 : (_this$state$config4$r2 = _this$state$config4$r.mediaConstraints) === null || _this$state$config4$r2 === void 0 ? void 0 : _this$state$config4$r2.video;
              }

              _this.setState({
                config: response.data
              });

              return _context.abrupt("return", response.data);

            case 15:
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);

              _this.setState({
                startingStoppingStream: false
              });

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 17]]);
    }));

    _this.renderNotChromeWarning = function () {
      return /*#__PURE__*/React.createElement(Grid, {
        style: {
          paddingBottom: 10
        },
        container: true,
        direction: "row",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Warning, {
        color: 'error'
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, null, "We currently only support Chrome for streaming. We do not recommend using any other browser at this time. Download Chrome ", /*#__PURE__*/React.createElement("a", {
        href: 'https://google.com/chrome',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, "here."))));
    };

    _this.renderLoading = function () {
      return /*#__PURE__*/React.createElement(CircularProgress, {
        size: 100
      });
    };

    _this.renderMediaInputSelectors = function () {
      if (_this.state && _this.state.audioInputs && _this.state.videoInputs) {
        return /*#__PURE__*/React.createElement(MediaInputSelectors, {
          videoInputs: _this.state.videoInputs,
          selectedVideoInput: _this.state.selectedVideoInput,
          onVideoInputChange: _this.switchCamera,
          onAudioInputChange: _this.switchMicrophone,
          selectedAudioInput: _this.state.selectedAudioInput,
          audioInputs: _this.state.audioInputs,
          disabled: _this.props.disabled || _this.state.isStreaming || _this.state.startingStoppingStream || _this.state.networkDisconnect
        });
      } else {
        // TODO what more should we do?
        return /*#__PURE__*/React.createElement("div", null, "Loading media inputs");
      }
    };

    _this.renderBandwidthSelectors = function () {
      return /*#__PURE__*/React.createElement(BandwidthRadioGroup, {
        bandwidth: _this.state.bandwidth,
        disabled: _this.props.disabled || _this.state.isStreaming || _this.state.startingStoppingStream || _this.state.networkDisconnect,
        onSelect: function onSelect(bandwidth) {
          return _this.setState({
            bandwidth: bandwidth
          }, _this.configureDevices);
        }
      });
    };

    _this.inputsSelected = function () {
      var _this$state = _this.state,
          selectedVideoInput = _this$state.selectedVideoInput,
          selectedAudioInput = _this$state.selectedAudioInput;
      var videoSelected = !!(selectedVideoInput !== null && selectedVideoInput !== void 0 && selectedVideoInput.deviceId);
      var audioSelected = !!(selectedAudioInput !== null && selectedAudioInput !== void 0 && selectedAudioInput.deviceId);
      return videoSelected || audioSelected;
    };

    _this.renderBroadcastOptions = function () {
      var disabled = _this.props.disabled;
      var _this$state2 = _this.state,
          hasMediaDevicesAvailable = _this$state2.hasMediaDevicesAvailable,
          startingStoppingStream = _this$state2.startingStoppingStream;
      var hidden = !_this.inputsSelected() || !hasMediaDevicesAvailable;
      var disablePublishButton = disabled || startingStoppingStream || !_this.inputsSelected() && !main_26 || _this.state.networkDisconnect || _this.state.reconnecting;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !main_26 && _this.renderBandwidthSelectors(), !main_26 && hasMediaDevicesAvailable && _this.renderMediaInputSelectors(), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2,
        justify: 'flex-start'
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Box, {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }, /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        disabled: disablePublishButton,
        loading: startingStoppingStream,
        onClick: _this.state.isStreaming ? function () {
          return _this.stopStream();
        } : function () {
          return _this.publishStream();
        },
        size: 'medium',
        variant: "contained"
      }, _this.state.isStreaming ? 'Stop Stream' : 'Publish Stream'), _this.state.isStreaming && /*#__PURE__*/React.createElement(DiagnosticsDisplay, {
        red5ProService: _this.red5ProService
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: 362,
          width: 642,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("video", {
        id: "red5pro-publisher",
        width: "640",
        height: "360",
        style: {
          visibility: hidden ? 'hidden' : 'visible',
          borderWidth: 1,
          borderColor: theme.palette.grey['400'],
          borderStyle: 'solid'
        },
        muted: true,
        autoPlay: true
      }), !hidden && _this.state.showAudioOnly && /*#__PURE__*/React.createElement(Overlay, {
        overlayText: 'Audio only stream'
      })))), /*#__PURE__*/React.createElement(StreamInProgress, {
        show: _this.state.showStreamInProgress,
        onOkay: _this.closeBroadcastInProgressNotification
      }), /*#__PURE__*/React.createElement(PublishHasStopped, {
        show: _this.state.showStopNotification,
        onOkay: _this.hidePublishHasStoppedNotification
      }), /*#__PURE__*/React.createElement(Reconnecting, {
        show: _this.state.reconnecting
      }), /*#__PURE__*/React.createElement(NoInternet, {
        show: _this.state.showNoInternet,
        onOkay: _this.hideNoInternetNotification
      }), /*#__PURE__*/React.createElement(FailedToPublish, {
        show: _this.state.showPublishFailed,
        onOkay: _this.hidePublishFailedNotification
      }));
    };

    _this.hidePublishHasStoppedNotification = function () {
      _this.setState({
        showStopNotification: false
      });
    };

    _this.hidePublishFailedNotification = function () {
      _this.setState({
        showPublishFailed: false
      });
    };

    _this.hideNoInternetNotification = function () {
      _this.setState({
        showNoInternet: false
      });
    };

    _this.attemptReconnect = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                reconnecting: true
              });

              _context2.next = 3;
              return _this.stopStream(true);

            case 3:
              setTimeout(function () {
                _this.publishStream();

                _this.setState({
                  reconnecting: false
                });
              }, 2500);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this.handlePublisherEvent = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
        var type, publisher, data, closeEvent;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = event.type;
                publisher = event.publisher;
                data = event.data;
                console.debug("publisher.js#handlePublisherEvent : Event type: ".concat(type, ", event publisher: ").concat(publisher, ", event data: ").concat(data));
                _context3.t0 = type;
                _context3.next = _context3.t0 === red5proSdk_min_2.PUBLISH_START ? 7 : _context3.t0 === red5proSdk_min_2.CONNECT_FAILURE ? 10 : _context3.t0 === red5proSdk_min_2.UNPUBLISH_SUCCESS ? 13 : _context3.t0 === red5proSdk_min_2.CONNECTION_CLOSED ? 16 : _context3.t0 === red5proSdk_min_3.MEDIA_STREAM_AVAILABLE ? 35 : 37;
                break;

              case 7:
                _this.setState({
                  startingStoppingStream: false,
                  stopAttempted: false
                });

                _this.changeStreamingState(true);

                return _context3.abrupt("break", 37);

              case 10:
                _this.setState({
                  startingStoppingStream: false
                });

                _this.changeStreamingState(false);

                return _context3.abrupt("break", 37);

              case 13:
                _this.setState({
                  startingStoppingStream: false,
                  stopAttempted: false
                });

                _this.changeStreamingState(false);

                return _context3.abrupt("break", 37);

              case 16:
                if (!_this.state.stopAttempted) {
                  _context3.next = 21;
                  break;
                }

                _this.setState({
                  startingStoppingStream: false,
                  networkDisconnect: false
                });

                _this.changeStreamingState(false);

                _context3.next = 34;
                break;

              case 21:
                closeEvent = (data === null || data === void 0 ? void 0 : data.type) === 'close';

                if (!closeEvent) {
                  _context3.next = 33;
                  break;
                }

                if (!event.data.wasClean) {
                  _context3.next = 27;
                  break;
                }

                if (_this.state.networkDisconnect) {
                  _this.setState({
                    startingStoppingStream: false,
                    networkDisconnect: false
                  });

                  _this.attemptReconnect();
                }

                _context3.next = 31;
                break;

              case 27:
                if (_this.state.networkDisconnect) {
                  _this.setState({
                    showNoInternet: true
                  });
                }

                _context3.next = 30;
                return _this.stopStream(true);

              case 30:
                _this.setState({
                  startingStoppingStream: false,
                  networkDisconnect: false
                });

              case 31:
                _context3.next = 34;
                break;

              case 33:
                _this.setState({
                  networkDisconnect: true
                });

              case 34:
                return _context3.abrupt("break", 37);

              case 35:
                if (_this.state.startingStoppingStream) {
                  _this.setState({
                    startingStoppingStream: false
                  });
                }

                return _context3.abrupt("break", 37);

              case 37:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.publishStream = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _this$props2, clientProxyUrl, auctionId, streamTest, vas, _this$state$selectedV;

      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props2 = _this.props, clientProxyUrl = _this$props2.clientProxyUrl, auctionId = _this$props2.auctionId, streamTest = _this$props2.streamTest, vas = _this$props2.vas;

              _this.setState({
                startingStoppingStream: true,
                stopAttempted: false
              });

              _this.setUpAutoStop();

              _context4.prev = 3;
              _context4.next = 6;
              return saveAuction(_this.props.clientProxyUrl, _this.props.auctionId, !((_this$state$selectedV = _this.state.selectedVideoInput) !== null && _this$state$selectedV !== void 0 && _this$state$selectedV.deviceId), true, vas);

            case 6:
              _context4.next = 8;
              return fetchPublishConfig(clientProxyUrl, auctionId, streamTest, _this.state.bandwidth);

            case 8:
              _context4.next = 10;
              return _this.red5ProService.publishStream();

            case 10:
              _context4.next = 16;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](3);
              console.error(_context4.t0);

              if (_context4.t0 && _context4.t0.indexOf && _context4.t0.indexOf('already has a broadcast session') >= 0) {
                _this.setState({
                  showStreamInProgress: true
                });
              } else {
                _this.setState({
                  showPublishFailed: true
                });
              }

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 12]]);
    }));

    _this.stopStream = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(ignoreNotification) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this.setState({
                  stopAttempted: true
                });

                if (!_this.state.isStreaming) {
                  _context5.next = 20;
                  break;
                }

                _this.setState({
                  startingStoppingStream: true
                });

                _context5.prev = 3;
                console.debug('publisher.js#stopStream : Stopping!');
                _context5.next = 7;
                return saveAuction(_this.props.clientProxyUrl, _this.props.auctionId, false, false, _this.props.vas);

              case 7:
                _context5.next = 9;
                return _this.red5ProService.stopStream();

              case 9:
                _this.changeStreamingState(false);

                _this.setState({
                  showStopNotification: !ignoreNotification
                });

                _context5.next = 13;
                return _this.initializePublisher();

              case 13:
                _context5.next = 20;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](3);
                console.debug("publisher.js#stopStream : Could not stop: ".concat(_context5.t0));
                console.error(_context5.t0);

                _this.setState({
                  startingStoppingStream: false
                });

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[3, 15]]);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.loadInputDevices = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var availableDevices;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this.setState({
                loadingAudioVideoInputs: true
              });

              _context6.prev = 1;
              _context6.next = 4;
              return retrieveAvailableDevices();

            case 4:
              availableDevices = _context6.sent;

              _this.setState({
                videoInputs: availableDevices.videoInputs,
                audioInputs: availableDevices.audioInputs,
                loadingAudioVideoInputs: false,
                selectedVideoInput: availableDevices.videoInputs.length > 0 ? availableDevices.videoInputs[0] : '',
                selectedAudioInput: availableDevices.audioInputs.length > 0 ? availableDevices.audioInputs[0] : ''
              }, _this.configureDevices);

              _context6.next = 12;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              console.error(_context6.t0);

              _this.setState({
                loadingAudioVideoInputs: false
              });

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 8]]);
    }));
    _this.configureDevices = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              console.debug('publisher.js#configureDevices');
              _context7.next = 4;
              return _this.fetchConfig();

            case 4:
              _this.switchCamera(_this.state.selectedVideoInput);

              _this.switchMicrophone(_this.state.selectedAudioInput);

              _context7.next = 11;
              break;

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              console.error(_context7.t0);

            case 11:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 8]]);
    }));

    _this.switchCamera = function (videoInputDevice) {
      console.debug('publisher.js#switchCamera : Switching Video Input');
      console.debug(videoInputDevice);

      if (videoInputDevice === '') {
        videoInputDevice = false;
        saveAuction(_this.props.clientProxyUrl, _this.props.auctionId, true, false, _this.props.vas);
      } else {
        saveAuction(_this.props.clientProxyUrl, _this.props.auctionId, false, false, _this.props.vas);
      }

      var newMediaConstraints = videoInputDevice ? _objectSpread2(_objectSpread2({}, _this.state.config.rtc.mediaConstraints), {}, {
        video: _objectSpread2(_objectSpread2({}, _this.state.config.rtc.mediaConstraints.video), {}, {
          deviceId: {
            exact: videoInputDevice.deviceId
          }
        })
      }) : _objectSpread2(_objectSpread2({}, _this.state.config.rtc.mediaConstraints), {}, {
        video: false
      });

      var newRtcConfig = _objectSpread2(_objectSpread2({}, _this.state.config.rtc), {}, {
        mediaConstraints: newMediaConstraints
      });

      var newConfig = _objectSpread2(_objectSpread2({}, _this.state.config), {}, {
        rtc: newRtcConfig
      });

      _this.setState({
        config: newConfig,
        selectedVideoInput: videoInputDevice ? videoInputDevice : false,
        showAudioOnly: !videoInputDevice
      });
    };

    _this.switchMicrophone = function (audioInputDevice) {
      console.debug('publisher.js#switchMicrophone : Switching Audio Input');
      console.debug(audioInputDevice);

      if (audioInputDevice === '') {
        audioInputDevice = false;
      }

      var newMediaConstraints = audioInputDevice ? _objectSpread2(_objectSpread2({}, _this.state.config.rtc.mediaConstraints), {}, {
        audio: {
          groupId: audioInputDevice.groupId
        }
      }) : _objectSpread2(_objectSpread2({}, _this.state.config.rtc.mediaConstraints), {}, {
        audio: false
      });

      var newRtcConfig = _objectSpread2(_objectSpread2({}, _this.state.config.rtc), {}, {
        mediaConstraints: newMediaConstraints
      });

      var newConfig = _objectSpread2(_objectSpread2({}, _this.state.config), {}, {
        rtc: newRtcConfig
      });

      _this.setState({
        config: newConfig,
        selectedAudioInput: audioInputDevice ? audioInputDevice : false
      });
    };

    _this.initializePublisher = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (_this.state.isStreaming) {
                _context8.next = 4;
                break;
              }

              _context8.next = 3;
              return _this.red5ProService.initializePublisher(_this.state.config, _this.handlePublisherEvent);

            case 3:
              console.debug('publisher.js#initializePublisher : Finished initializing publisher');

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    _this.handleDeviceChange = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (_this.state.isStreaming) {
                _context9.next = 5;
                break;
              }

              _context9.next = 3;
              return _this.loadInputDevices();

            case 3:
              _context9.next = 5;
              return _this.initializePublisher();

            case 5:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    _this.closeBroadcastInProgressNotification = function () {
      _this.setupPublisher();

      _this.setState({
        showStreamInProgress: false
      });
    };

    _this.state = {
      showStreamInProgress: false,
      showStopNotification: false,
      showNoInternet: false,
      showPublishFailed: false,
      startingStoppingStream: false,
      videoInputs: [],
      selectedVideoInput: undefined,
      audioInputs: [],
      selectedAudioInput: undefined,
      loadingAudioVideoInputs: false,
      selectedPublisher: null,
      hasMediaDevicesAvailable: !!navigator.mediaDevices,
      streamName: _this.props.auctionId.toString(),
      isStreaming: false,
      config: {},
      stopAttempted: false,
      reconnecting: false,
      publishFailed: false,
      noInternet: false,
      networkDisconnect: false,
      bandwidth: _this.props.bandwidth,
      showAudioOnly: false
    };
    _this.red5ProService = new Red5Service();
    return _this;
  }

  _inherits(Publisher, _Component);

  return _createClass(Publisher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      adapter.disableLog(true);
      var auctionId = this.props.auctionId;

      if (auctionId && !isNaN(parseInt(auctionId))) {
        this.setupPublisher();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 642
        }
      }, !main_23 && this.renderNotChromeWarning(), this.state.loadingAudioVideoInputs ? this.renderLoading() : this.renderBroadcastOptions());
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this$state3, _this$state3$config, _this$state3$config$r, _this$state3$config$r2, _this$state4, _this$state4$config, _this$state4$config$r, _this$state4$config$r2;

      var videoDeviceSpecified = !!((_this$state3 = this.state) !== null && _this$state3 !== void 0 && (_this$state3$config = _this$state3.config) !== null && _this$state3$config !== void 0 && (_this$state3$config$r = _this$state3$config.rtc) !== null && _this$state3$config$r !== void 0 && (_this$state3$config$r2 = _this$state3$config$r.mediaConstraints) !== null && _this$state3$config$r2 !== void 0 && _this$state3$config$r2.video);
      var audioDeviceSpecified = !!((_this$state4 = this.state) !== null && _this$state4 !== void 0 && (_this$state4$config = _this$state4.config) !== null && _this$state4$config !== void 0 && (_this$state4$config$r = _this$state4$config.rtc) !== null && _this$state4$config$r !== void 0 && (_this$state4$config$r2 = _this$state4$config$r.mediaConstraints) !== null && _this$state4$config$r2 !== void 0 && _this$state4$config$r2.audio);

      if (prevState.config !== this.state.config) {
        var _this$state5, _this$state5$config, _this$state5$config$r, _this$state5$config$r2, _this$state5$config$r3;

        var newVideoInput = this.state.selectedVideoInput !== prevState.selectedVideoInput;
        var newAudioInput = this.state.selectedAudioInput !== prevState.selectedAudioInput;
        var noHeightSpecified = !((_this$state5 = this.state) !== null && _this$state5 !== void 0 && (_this$state5$config = _this$state5.config) !== null && _this$state5$config !== void 0 && (_this$state5$config$r = _this$state5$config.rtc) !== null && _this$state5$config$r !== void 0 && (_this$state5$config$r2 = _this$state5$config$r.mediaConstraints) !== null && _this$state5$config$r2 !== void 0 && (_this$state5$config$r3 = _this$state5$config$r2.video) !== null && _this$state5$config$r3 !== void 0 && _this$state5$config$r3.height);

        if (newVideoInput || newAudioInput || noHeightSpecified && videoDeviceSpecified) {
          console.debug('publisher.js#componentDidUpdate : fetchConfig');
          this.fetchConfig();
        } else if (videoDeviceSpecified || audioDeviceSpecified) {
          console.debug('publisher.js#componentDidUpdate : initializePublisher');
          this.initializePublisher();
        } else {
          this.setState({
            startingStoppingStream: false
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cleanupPublisher();
    }
  }, {
    key: "changeStreamingState",
    value: function changeStreamingState(isStreaming) {
      this.setState({
        isStreaming: isStreaming
      });
    }
  }, {
    key: "setUpAutoStop",
    value: function setUpAutoStop() {
      if (this.props.streamTest) {
        var msToLive = 15 * 60 * 1000;
        setTimeout(this.stopStream, msToLive);
      }
    }
  }, {
    key: "cleanupPublisher",
    value: function () {
      var _cleanupPublisher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.red5ProService.cleanUpPublisher(this.handlePublisherEvent);

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function cleanupPublisher() {
        return _cleanupPublisher.apply(this, arguments);
      }

      return cleanupPublisher;
    }()
  }, {
    key: "setupPublisher",
    value: function () {
      var _setupPublisher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(this.state.hasMediaDevicesAvailable && !main_26)) {
                  _context11.next = 14;
                  break;
                }

                navigator.mediaDevices.ondevicechange = this.handleDeviceChange;
                _context11.prev = 2;
                _context11.next = 5;
                return this.loadInputDevices();

              case 5:
                console.debug('publisher.js#setupPublisher : Finished loading input devices');
                _context11.next = 12;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](2);
                console.error('publisher.js#setupPublisher : Could not setup publisher');
                console.debug(_context11.t0);

              case 12:
                _context11.next = 15;
                break;

              case 14:
                console.error('publisher.js#setupPublisher : Could not setup publisher');

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 8]]);
      }));

      function setupPublisher() {
        return _setupPublisher.apply(this, arguments);
      }

      return setupPublisher;
    }()
  }]);
}(Component);

Publisher.propTypes = {
  disabled: bool,
  clientProxyUrl: string.isRequired,
  auctionId: number.isRequired,
  streamTest: bool,
  bandwidth: string,
  vas: bool
};
Publisher.defaultProps = {
  streamTest: false,
  bandwidth: 'MEDIUM',
  vas: false
};

var LiveStreamTest = /*#__PURE__*/function (_React$Component) {
  function LiveStreamTest(props) {
    _classCallCheck(this, LiveStreamTest);

    return _callSuper(this, LiveStreamTest, [props]);
  }

  _inherits(LiveStreamTest, _React$Component);

  return _createClass(LiveStreamTest, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
        display: 'flex',
        flexDirection: 'column'
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          color: theme.palette.error.main,
          fontWeight: 'bold',
          height: '50px'
        }
      }, "DO NOT use the test Proxibid encoder to broadcast your live auction."), /*#__PURE__*/React.createElement(Box, {
        pb: 2
      }, /*#__PURE__*/React.createElement(Publisher, {
        clientProxyUrl: this.props.clientProxyUrl,
        auctionId: this.props.auctionHouseId //use auctionHouseId for auctionId on LiveStreamTest ONLY
        ,
        disabled: false,
        streamTest: true
      }))));
    }
  }]);
}(React.Component);

LiveStreamTest.propTypes = {
  clientProxyUrl: string.isRequired,
  auctionHouseName: string.isRequired,
  auctionHouseId: number.isRequired
};
var screenfull = createCommonjsModule(function (module) {
  /*!
  * screenfull
  * v4.2.0 - 2019-04-01
  * (c) Sindre Sorhus; MIT License
  */
  (function () {
    var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
    var isCommonjs = module.exports;
    var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

    var fn = function () {
      var val;
      var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'], // New WebKit
      ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'], // Old WebKit (Safari 5.1)
      ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
      var i = 0;
      var l = fnMap.length;
      var ret = {};

      for (; i < l; i++) {
        val = fnMap[i];

        if (val && val[1] in document) {
          for (i = 0; i < val.length; i++) {
            ret[fnMap[0][i]] = val[i];
          }

          return ret;
        }
      }

      return false;
    }();

    var eventNameMap = {
      change: fn.fullscreenchange,
      error: fn.fullscreenerror
    };
    var screenfull = {
      request: function request(elem) {
        return new Promise(function (resolve) {
          var request = fn.requestFullscreen;

          var onFullScreenEntered = function () {
            this.off('change', onFullScreenEntered);
            resolve();
          }.bind(this);

          elem = elem || document.documentElement; // Work around Safari 5.1 bug: reports support for
          // keyboard in fullscreen even though it doesn't.
          // Browser sniffing, since the alternative with
          // setTimeout is even worse.

          if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
            elem[request]();
          } else {
            elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
          }

          this.on('change', onFullScreenEntered);
        }.bind(this));
      },
      exit: function exit() {
        return new Promise(function (resolve) {
          if (!this.isFullscreen) {
            resolve();
            return;
          }

          var onFullScreenExit = function () {
            this.off('change', onFullScreenExit);
            resolve();
          }.bind(this);

          document[fn.exitFullscreen]();
          this.on('change', onFullScreenExit);
        }.bind(this));
      },
      toggle: function toggle(elem) {
        return this.isFullscreen ? this.exit() : this.request(elem);
      },
      onchange: function onchange(callback) {
        this.on('change', callback);
      },
      onerror: function onerror(callback) {
        this.on('error', callback);
      },
      on: function on(event, callback) {
        var eventName = eventNameMap[event];

        if (eventName) {
          document.addEventListener(eventName, callback, false);
        }
      },
      off: function off(event, callback) {
        var eventName = eventNameMap[event];

        if (eventName) {
          document.removeEventListener(eventName, callback, false);
        }
      },
      raw: fn
    };

    if (!fn) {
      if (isCommonjs) {
        module.exports = false;
      } else {
        window.screenfull = false;
      }

      return;
    }

    Object.defineProperties(screenfull, {
      isFullscreen: {
        get: function get() {
          return Boolean(document[fn.fullscreenElement]);
        }
      },
      element: {
        enumerable: true,
        get: function get() {
          return document[fn.fullscreenElement];
        }
      },
      enabled: {
        enumerable: true,
        get: function get() {
          // Coerce to boolean in case of old WebKit
          return Boolean(document[fn.fullscreenEnabled]);
        }
      }
    });

    if (isCommonjs) {
      module.exports = screenfull; // TODO: remove this in the next major version

      module.exports.default = screenfull;
    } else {
      window.screenfull = screenfull;
    }
  })();
});

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".audioVideo-media-container {\n  display: block;\n  box-sizing: border-box;\n  position: relative;\n  height: 100%;\n  line-height: 0;\n}\n\n.audioVideo-media {\n  width: 100%;\n}\n\n.audioVideo-media-container-full-screen {\n  width: 100% !important;\n  height: 100% !important;\n  overflow: hidden !important;\n}\n\n.audioVideo-media-control-bar {\n  font-family: sans-serif;\n  opacity: 0;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  flex-align: center;\n  display: -ms-flexbox;\n  -ms-flex-direction: row;\n  -ms-flex-align: center;\n  -ms-flex-pack: justify;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 1.5em;\n  padding: 0.5em;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-transition: opacity 0.5s ease-in-out;\n  -moz-transition: opacity 0.5s ease-in-out;\n  -ms-transition: opacity 0.5s ease-in-out;\n  -o-transition: opacity 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n  z-index: 9999;\n}\n\ninput[type=range][orient=vertical] {\n  writing-mode: bt-lr; /* IE */\n  -webkit-appearance: slider-vertical; /* WebKit */\n  width: 8px;\n  height: 175px;\n  padding: 0 5px;\n}\n\n.audioVideo-media-control-element {\n  margin: 0 0.5em;\n  cursor: pointer;\n}\n.audioVideo-media-time-field {\n  font-size: 0.8em;\n  line-height: 1em;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n.audioVideo-media-slider {\n  -webkit-appearance: none !important; /*Needed to reset default slider styles */\n  transition: all 0.3s ease;\n  margin-top: 0.8em;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\n.audioVideo-media-slider-track {\n  background-color: #595959;\n  height: 0.2em;\n  position: relative;\n  display: block;\n  top: 0.1em\n}\n\n.audioVideo-media-slider-progress {\n  background-color: #4286F4;\n  height: 0.2em;\n  position: relative;\n  display: block;\n  top: -0.1em;\n}\n\n.audioVideo-media-slider-button {\n  width: 1em;\n  height: 1em;\n  max-width: 24px;\n  max-height: 24px;\n  top: -0.7em;\n  position: relative;\n  display: block;\n  border-radius: 20px;\n  background-color: #4286F4;\n}\n\n.audioVideo-media-slider-disabled {\n  background-color: #bbb;\n  cursor: pointer;\n}\n\n.audioVideo-media-volume-slider {\n  width: 110px;\n}\n\n.audioVideo-media-seektime-slider {\n  flex-grow: 1;\n  -ms-flex-grow: 1;\n  -ms-flex-positive: 1;\n}\n\n.audioVideo-media-element-button {\n  width: 24px;\n  height: 24px;\n  display: inline-block;\n  background-size: 100% 100%;\n  background-position: 50% 50%;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  border: none;\n  cursor: pointer;\n}\n\n.audioVideo-media-element-button-disabled {\n  cursor: pointer;\n  opacity: 0.5;\n}\n\n.subscriber-details {\n  opacity: 0;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  text-align: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  -webkit-transition: opacity 0.5s ease-in-out;\n  -moz-transition: opacity 0.5s ease-in-out;\n  -ms-transition: opacity 0.5s ease-in-out;\n  -o-transition: opacity 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n}\n\n/*Needs to be last, cuz css*/\n.show {\n  opacity: 1;\n}\n";
styleInject(css);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */

var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */

var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/** Used for built-in method references. */

var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max,
    nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now = function now() {
  return root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */


function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  wait = toNumber(wait) || 0;

  if (isObject$2(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;
    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */


function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol(value)) {
    return NAN;
  }

  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var lodash_debounce = debounce;
var avControlButtonClasses = 'audioVideo-media-control-element audioVideo-media-element-button';
PlayPauseToggle.propTypes = {
  isPlaying: bool.isRequired,
  playPause: func.isRequired
};

function PlayPauseToggle(_ref) {
  var isPlaying = _ref.isPlaying,
      playPause = _ref.playPause;
  var theme = useTheme();
  return isPlaying ? /*#__PURE__*/React.createElement(PauseIcon, {
    style: {
      color: theme.palette.common.white
    },
    onClick: playPause,
    className: avControlButtonClasses
  }) : /*#__PURE__*/React.createElement(PlayArrowIcon, {
    style: {
      color: theme.palette.common.white
    },
    onClick: playPause,
    className: avControlButtonClasses
  });
}

VolumeToggle.propTypes = {
  isMuted: bool.isRequired,
  muteUnmute: func.isRequired
};

function VolumeToggle(_ref2) {
  var isMuted = _ref2.isMuted,
      muteUnmute = _ref2.muteUnmute;
  var theme = useTheme();
  return isMuted ? /*#__PURE__*/React.createElement(VolumeOffIcon, {
    style: {
      color: theme.palette.error.main
    },
    onClick: muteUnmute,
    className: avControlButtonClasses
  }) : /*#__PURE__*/React.createElement(VolumeUpIcon, {
    style: {
      color: theme.palette.common.white
    },
    onClick: muteUnmute,
    className: avControlButtonClasses
  });
}

FullScreenToggle.propTypes = {
  toggleFullScreen: func.isRequired,
  audioOnly: bool.isRequired,
  showVideo: bool.isRequired,
  isIframe: bool.isRequired,
  isFullscreen: bool.isRequired
};

function FullScreenToggle(_ref3) {
  var audioOnly = _ref3.audioOnly,
      isIframe = _ref3.isIframe,
      showVideo = _ref3.showVideo,
      isFullscreen = _ref3.isFullscreen,
      toggleFullScreen = _ref3.toggleFullScreen;
  var theme = useTheme();

  if (!audioOnly && !isIframe && showVideo) {
    return isFullscreen ? /*#__PURE__*/React.createElement(FullscreenExitIcon, {
      style: {
        color: theme.palette.common.white
      },
      onClick: toggleFullScreen,
      className: avControlButtonClasses
    }) : /*#__PURE__*/React.createElement(FullscreenIcon, {
      style: {
        color: theme.palette.common.white
      },
      onClick: toggleFullScreen,
      className: avControlButtonClasses
    });
  }

  return null;
}

VideoToggle.propTypes = {
  toggleVideo: func.isRequired,
  audioOnly: bool.isRequired,
  showVideo: bool.isRequired
};

function VideoToggle(_ref4) {
  var audioOnly = _ref4.audioOnly,
      showVideo = _ref4.showVideo,
      toggleVideo = _ref4.toggleVideo;
  var theme = useTheme();

  if (!audioOnly) {
    return showVideo ? /*#__PURE__*/React.createElement(VideocamOff, {
      style: {
        color: theme.palette.common.white
      },
      onClick: toggleVideo,
      className: avControlButtonClasses
    }) : /*#__PURE__*/React.createElement(Videocam, {
      style: {
        color: theme.palette.common.white
      },
      onClick: toggleVideo,
      className: avControlButtonClasses
    });
  }

  return null;
}

AudioVideoControls.propTypes = {
  playPause: func.isRequired,
  muteUnmute: func.isRequired,
  toggleVideo: func.isRequired,
  toggleFullScreen: func.isRequired,
  shouldShowDetails: func.isRequired,
  audioOnly: bool.isRequired,
  subscribeStartReceived: bool.isRequired,
  isPlaying: bool.isRequired,
  isMuted: bool.isRequired,
  showVideo: bool.isRequired,
  isIframe: bool.isRequired,
  isFullscreen: bool.isRequired,
  iframeControlHeight: string
};

function AudioVideoControls(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "audioVideo-media-control-bar ".concat(props.shouldShowDetails() ? 'show' : ''),
    style: {
      bottom: props.iframeControlHeight
    }
  }, /*#__PURE__*/React.createElement(PlayPauseToggle, {
    isPlaying: props.isPlaying,
    playPause: props.playPause
  }), /*#__PURE__*/React.createElement(VolumeToggle, {
    isMuted: props.isMuted,
    muteUnmute: props.muteUnmute
  }), props.subscribeStartReceived && /*#__PURE__*/React.createElement(FullScreenToggle, {
    audioOnly: props.audioOnly,
    showVideo: props.showVideo,
    isIframe: props.isIframe,
    isFullscreen: props.isFullscreen,
    toggleFullScreen: props.toggleFullScreen
  }), props.subscribeStartReceived && /*#__PURE__*/React.createElement(VideoToggle, {
    audioOnly: props.audioOnly,
    showVideo: props.showVideo,
    toggleVideo: props.toggleVideo
  }));
}

AudioOnlyControls.propTypes = {
  playPause: func.isRequired,
  muteUnmute: func.isRequired,
  isPlaying: bool.isRequired,
  isMuted: bool.isRequired
};

function AudioOnlyControls(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'audioVideo-media-control-bar show'
  }, /*#__PURE__*/React.createElement(PlayPauseToggle, {
    isPlaying: props.isPlaying,
    playPause: props.playPause
  }), /*#__PURE__*/React.createElement(VolumeToggle, {
    isMuted: props.isMuted,
    muteUnmute: props.muteUnmute
  }));
}

var loadingStyles = {
  width: '100%',
  position: 'absolute',
  top: '33%',
  textAlign: 'center',
  userSelect: 'none'
};
var bigPlayStyles = {
  width: '100%',
  position: 'absolute',
  top: '20%',
  textAlign: 'center',
  userSelect: 'none',
  fontSize: '200px'
};
var EXTENDED_RECONNECT_MILLIS = 60000;

var Subscriber = /*#__PURE__*/function (_React$Component) {
  function Subscriber(props) {
    var _this;

    _classCallCheck(this, Subscriber);

    _this = _callSuper(this, Subscriber, [props]);
    _this.fetchConfigAndSubscribe = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this$props, clientProxyUrl, auctionId, streamTest, audioOnly;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, clientProxyUrl = _this$props.clientProxyUrl, auctionId = _this$props.auctionId, streamTest = _this$props.streamTest, audioOnly = _this$props.audioOnly;
              return _context.abrupt("return", fetchSubscribeConfig(clientProxyUrl, auctionId, streamTest, audioOnly).then(function (response) {
                _this.setState({
                  config: response.data
                });

                return _this.subscribe();
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.handleCellClose = function () {
      _this.setState({
        cellMessageOpen: false
      });

      if (_this.state.masterCookieAccepted) {
        setCookie('acceptedCell' + _this.props.auctionId, 'true', 7);
      }
    };

    _this.ignoreChrome = function () {
      _this.setState({
        edgeOrIeMessageOpen: false
      });

      if (_this.state.masterCookieAccepted) {
        setCookie('ignoreChromeDownload', 'true', 7);
      }
    };

    _this.getChrome = function () {
      window.open('https://www.google.com/chrome/');

      _this.setState({
        edgeOrIeMessageOpen: false
      });
    };

    _this.renderControls = function () {
      return /*#__PURE__*/React.createElement(AudioVideoControls, {
        playPause: _this.playPause,
        muteUnmute: _this.muteUnmute,
        toggleVideo: _this.toggleVideo,
        toggleFullScreen: _this.toggleFullScreen,
        shouldShowDetails: _this.shouldShowDetails,
        audioOnly: _this.props.audioOnly,
        subscribeStartReceived: _this.state.subscribeStartReceived,
        isPlaying: _this.state.isPlaying,
        isMuted: _this.state.isMuted,
        showVideo: _this.state.showVideo,
        isIframe: _this.state.isIframe,
        isFullscreen: _this.state.isFullscreen,
        iframeControlHeight: _this.state.iframeControlHeight
      });
    };

    _this.renderDetails = function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "subscriber-details ".concat(_this.shouldShowDetails() ? 'show' : '')
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        style: {
          color: theme.palette.common.white
        }
      }, _this.props.title), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        style: {
          color: theme.palette.common.white
        }
      }, _this.props.description, " ", _this.props.dateLocation));
    };

    _this.renderBigPlayButton = function () {
      return _this.state.showBigPlayButton && /*#__PURE__*/React.createElement(PlayArrowIcon, {
        style: bigPlayStyles,
        onClick: _this.playPause
      });
    };

    _this.renderAudio = function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: 180,
          zIndex: 5
        },
        className: "media-container"
      }, /*#__PURE__*/React.createElement("audio", {
        id: "red5pro-subscriber",
        autoPlay: true,
        muted: _this.state.isMuted,
        className: "audioVideo-media"
      }), _this.renderControls());
    };

    _this.renderVideo = function () {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: 360,
          zIndex: 5
        },
        className: "media-container"
      }, /*#__PURE__*/React.createElement("video", {
        id: "red5pro-subscriber",
        height: _this.state.videoHeight,
        muted: _this.state.isMuted,
        className: "audioVideo-media",
        playsInline: "true",
        autoPlay: !_this.state.showBigPlayButton
      }), _this.renderControls());
    };

    _this.determineLoadingText = function () {
      if (_this.state.subscribeStartReceived) {
        return 'Attempting to reconnect';
      } else {
        return 'Loading stream';
      }
    };

    _this.renderLoading = function () {
      return /*#__PURE__*/React.createElement("div", {
        style: loadingStyles,
        className: "loadingContainer"
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        size: _this.state.showVideo ? 100 : 50
      }), /*#__PURE__*/React.createElement(Typography, {
        variant: _this.state.showVideo ? 'h5' : 'h6'
      }, _this.determineLoadingText()));
    };

    _this.unsubscribe = function () {
      var subscriber = _this.selectedSubscriber;

      if (subscriber) {
        return subscriber.unsubscribe().then(function () {
          _this.selectedSubscriber.off('*', _this.onSubscriberEvent);

          _this.selectedSubscriber = undefined;
          console.info('Unsubscribe Complete!');
        })["catch"](function (error) {
          console.error(error);
        });
      }
    };

    _this.subscribe = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _this.unsubscribe();

              _this.selectedSubscriber = new red5proSdk_min_4();
              _context2.next = 5;
              return _this.selectedSubscriber.init(_this.state.config.rtc);

            case 5:
              _this.selectedSubscriber.on('*', _this.onSubscriberEvent);

              _context2.next = 8;
              return _this.selectedSubscriber.subscribe();

            case 8:
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    }));

    _this.onSubscriberEvent = function (event) {
      var type = event.type;

      switch (type) {
        case red5proSdk_min_6.SUBSCRIBE_INVALID_NAME:
          {
            _this.setState({
              showNoStreamNotification: true
            });

            break;
          }

        case red5proSdk_min_6.PLAYBACK_STATE_CHANGE:
          {
            _this.setState({
              isLoading: false
            });

            switch (event.data.state) {
              case 'Playback.PLAYING':
                {
                  _this.setState({
                    isPlaying: true,
                    isLoading: false,
                    showNoStreamNotification: false,
                    startReconnectTime: 0
                  });

                  break;
                }

              case 'Playback.PAUSED':
                {
                  _this.setState({
                    isPlaying: false
                  });

                  break;
                }

              case 'Playback.AVAILABLE':
                {
                  if (_this.outerRef.current) {
                    var width = _this.outerRef.current.getBoundingClientRect().width;

                    var height = _this.outerRef.current.getBoundingClientRect().height;

                    var extraWindowWidth = window.outerWidth - window.innerWidth;
                    var extraWindowHeight = window.outerHeight - window.innerHeight;
                    window.resizeTo(width + extraWindowWidth, height + extraWindowHeight);
                  }

                  break;
                }

              case 'Playback.IDLE':
                {
                  _this.setState({
                    isPlaying: false,
                    showNoStreamNotification: true
                  });

                  break;
                }
            }

            break;
          }

        case red5proSdk_min_6.EMBED_SUCCESS:
          {
            _this.setState({
              showNoStreamNotification: true,
              isPlaying: false,
              isLoading: false
            });

            if (_this.state.isFullscreen) {
              screenfull.exit();
            }

            _this.selectedSubscriber.setABRVariants(_this.state.config.provisionData, 1);

            break;
          }

        case red5proSdk_min_6.PLAY_UNPUBLISH:
        case red5proSdk_min_6.EMBED_FAILURE:
          {
            _this.setState({
              showNoStreamNotification: true,
              isPlaying: false
            });

            if (_this.state.isFullscreen) {
              screenfull.exit();
            }

            if (main_27) {
              _this.setState({
                firefoxSubscribed: false
              });
            }

            break;
          }

        case red5proSdk_min_6.SUBSCRIBE_METADATA:
          {
            _this.setState({
              showNoStreamNotification: false
            });

            break;
          }

        case red5proSdk_min_6.SUBSCRIBE_START:
          {
            _this.setState({
              isLoading: false
            });

            if (main_26) {
              _this.setState({
                showNoStreamNotification: false
              });
            }

            if (main_27) {
              _this.setState({
                firefoxSubscribed: true
              });
            }

            if (!_this.state.subscribeStartReceived) {
              _this.setState({
                subscribeStartReceived: true
              });
            }

            break;
          }

        case red5proSdk_min_6.SUBSCRIBE_STOP:
          {
            if (_this.state.switchingVideo) {
              _this.setState({
                switchingVideo: false,
                showVideo: !_this.state.showVideo,
                isFullscreen: false
              });
            }

            break;
          }

        case red5proSdk_min_5.PEER_CONNECTION_AVAILABLE:
          {
            _this.setState({
              isLoading: true
            });

            break;
          }

        case red5proSdk_min_6.SUBSCRIBE_FAIL:
        case red5proSdk_min_6.CONNECTION_CLOSED:
        case red5proSdk_min_6.CONNECT_FAILURE:
          {
            if (!_this.state.firefoxSubscribed || !_this.state.firefoxResubscribing || !main_27) {
              _this.unsubscribe().then(function () {
                _this.setState({
                  switchingVideo: true,
                  isPlaying: false
                }, function () {
                  _this.setState({
                    switchingVideo: false
                  }, function () {
                    if (!_this.state.isLoading) {
                      _this.debounceAutoRefresh();
                    }
                  });
                });
              });
            }

            if (_this.state.firefoxResubscribing) {
              _this.autoRefreshSubscriber();
            }

            break;
          }
      }
    };

    _this.inExtendedReconnect = function () {
      return new Date() - _this.props.minutesBeforeExtendedReconnect * 60 * 1000 > _this.state.startReconnectTime;
    };

    _this.timeHasExpired = function () {
      if (!_this.state.startReconnectTime) {
        _this.setState({
          startReconnectTime: new Date()
        });

        return false;
      }

      return new Date() - _this.props.maxRetryMinutes * 60 * 1000 > _this.state.startReconnectTime;
    };

    _this.autoRefreshSubscriber = function () {
      if (main_27) {
        _this.setState({
          firefoxResubscribing: true
        });
      }

      if (!_this.state.isPlaying) {
        if (_this.timeHasExpired()) {
          console.log('Failed to re-connect to stream. User can press play or refresh');

          _this.setState({
            isLoading: false,
            firefoxResubscribing: false,
            startReconnectTime: 0
          });
        } else {
          _this.setState({
            isLoading: true
          }, function () {
            _this.autoRefreshTimer = setTimeout(function () {
              if (!_this.state.isPlaying) {
                _this.fetchConfigAndSubscribe()["catch"](function () {
                  console.debug("Failed to load subscriber config @ ".concat(new Date()));
                })["finally"](function () {
                  var player = document.getElementById('red5pro-subscriber');
                  player.muted = _this.state.isMuted;

                  _this.autoRefreshSubscriber();
                });
              } else {
                _this.setState({
                  isLoading: false,
                  firefoxResubscribing: false,
                  startReconnectTime: 0
                });
              }
            }, _this.inExtendedReconnect() ? EXTENDED_RECONNECT_MILLIS : _this.props.retryWaitTime);
          });
        }
      }
    };

    _this.debounceAutoRefresh = lodash_debounce(_this.autoRefreshSubscriber.bind(_this), 4500, {
      'leading': true,
      'trailing': false
    });

    _this.onMove = function () {
      if (_this.timeoutRef) {
        clearTimeout(_this.timeoutRef);
      }

      _this.setState({
        mouseMoving: true
      });

      _this.timeoutRef = setTimeout(function () {
        _this.setState({
          mouseMoving: false
        });
      }, 3000);
    };

    _this.onLeave = function () {
      _this.setState({
        mouseMoving: false
      });
    };

    _this.toggleFullScreen = function () {
      if (!_this.state.showNoStreamNotification) {
        var media = document.getElementById('red5pro-subscriber');
        var controls = document.getElementsByClassName('audioVideo-media-control-bar')[0];
        var details = document.getElementsByClassName('subscriber-details')[0];

        if (main_34 && !main_32 && media.webkitRequestFullscreen) {
          if (_this.state.isFullscreen) {
            media.webkitExitFullscreen();
            screenfull.exit();
          } else {
            media.webkitRequestFullscreen();
            screenfull.request(controls);
            screenfull.request(details);
            controls.style.zIndex = 2147483647;
            details.style.zIndex = 2147483647;
          }
        } else if (main_32 && media.webkitSetPresentationMode) {
          if (_this.state.isFullScreen) {
            media.webkitSetPresentationMode('inline');
          } else {
            media.webkitSetPresentationMode('fullscreen');
          }
        } else {
          if (_this.state.isFullscreen) {
            screenfull.exit();
          } else {
            screenfull.request(_this.outerRef.current);
          }
        }

        var videoHeight = _this.state.isFullScreen ? '360px' : '';

        _this.setState({
          videoHeight: videoHeight,
          isFullscreen: !_this.state.isFullscreen,
          isLastActionToggleFullscreen: true
        });
      }
    };

    _this.toggleVideo = function () {
      if (!_this.state.showNoStreamNotification) {
        if (_this.state.isFullscreen) {
          screenfull.exit();
        }

        _this.setState({
          switchingVideo: true
        }, function () {
          return _this.unsubscribe().then(_this.subscribe);
        });
      }
    };

    _this.playPause = function () {
      _this.setState({
        showBigPlayButton: false
      });

      if (!_this.state.showNoStreamNotification) {
        _this.state.isPlaying ? _this.selectedSubscriber.pause() : _this.selectedSubscriber.play();

        _this.setState({
          isPlaying: !_this.state.isPlaying
        });
      } else if (!_this.state.isPlaying) {
        if (!_this.state.isLoading) {
          _this.debounceAutoRefresh();
        }
      }
    };

    _this.muteUnmute = function () {
      if (!_this.state.showNoStreamNotification) {
        _this.state.isMuted ? _this.selectedSubscriber.unmute() : _this.selectedSubscriber.mute();

        _this.setState({
          isMuted: !_this.state.isMuted
        });
      }
    };

    _this.checkCookies = function () {
      var masterCookie = getCookieValue('acceptedCookies');
      var chromeIgnore = getCookieValue('ignoreChromeDownload');
      var acceptedCellAlert = getCookieValue('acceptedCell' + _this.props.auctionId);

      _this.setState({
        masterCookieAccepted: masterCookie === 'true',
        cellMessageOpen: acceptedCellAlert !== 'true',
        edgeOrIeMessageOpen: chromeIgnore !== 'true'
      });
    };

    _this.exitFullscreenHandler = function () {
      if (!_this.state.isLastActionToggleFullscreen || main_32) {
        _this.setState({
          videoHeight: '360px',
          isFullscreen: false
        });
      }

      _this.setState({
        isLastActionToggleFullscreen: false
      });
    };

    _this.checkInIframe = function () {
      if (window.frameElement !== null || window.self === window.top) {
        _this.setState({
          iframeControlHeight: ''
        });
      } else {
        _this.setState({
          iframeControlHeight: '40px',
          isIframe: true
        });
      }
    };

    _this.shouldShowDetails = function () {
      return _this.state.showNoStreamNotification || main_32 || _this.state.mouseMoving || !_this.state.isPlaying || _this.state.isMuted || !_this.state.showVideo;
    };

    _this.outerRef = React.createRef();
    _this.timeoutRef = null;
    _this.state = {
      cellMessageOpen: false,
      edgeOrIeMessageOpen: false,
      masterCookieAccepted: false,
      isFullscreen: false,
      isPlaying: false,
      isLoading: false,
      isMuted: props.audioOnly && main_31,
      showVideo: !props.audioOnly,
      mouseMoving: false,
      isLastActionToggleFullscreen: false,
      showNoStreamNotification: false,
      subscribeStartReceived: false,
      firefoxSubscribed: false,
      firefoxResubscribing: false,
      switchingVideo: false,
      config: {},
      videoHeight: '360px',
      isIframe: false,
      iframeControlHeight: '',
      showBigPlayButton: true,
      startReconnectTime: 0
    };
    return _this;
  }

  _inherits(Subscriber, _React$Component);

  return _createClass(Subscriber, [{
    key: "render",
    value: function render() {
      return this.props.audioOnly ? this.renderAudioOnly() : this.renderAudioVideo();
    }
  }, {
    key: "renderAudioOnly",
    value: function renderAudioOnly() {
      return /*#__PURE__*/React.createElement("div", null, this.state.switchingVideo ? /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...") : /*#__PURE__*/React.createElement("div", {
        style: {
          height: 40,
          width: this.props.displayWidth || 640,
          position: 'absolute'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "media-container"
      }, /*#__PURE__*/React.createElement("audio", {
        id: "red5pro-subscriber",
        autoPlay: true,
        muted: this.state.isMuted,
        className: "audioVideo-media"
      }), /*#__PURE__*/React.createElement(AudioOnlyControls, {
        isPlaying: this.state.isPlaying,
        isMuted: this.state.isMuted,
        playPause: this.playPause,
        muteUnmute: this.muteUnmute
      }))));
    }
  }, {
    key: "renderAudioVideo",
    value: function renderAudioVideo() {
      return /*#__PURE__*/React.createElement("div", {
        ref: this.outerRef,
        style: {
          width: this.props.displayWidth || 640,
          position: 'absolute',
          borderWidth: 1,
          borderColor: theme.palette.grey['400'],
          borderStyle: 'solid'
        },
        onMouseMove: this.onMove,
        onMouseLeave: this.onLeave
      }, main_31 && /*#__PURE__*/React.createElement(Notification, {
        messageOpen: this.state.cellMessageOpen,
        headerText: 'Viewer Notification:',
        bodyText: 'Viewing a stream while on cellular data ' + 'may incur charges with your network provider. Please use wifi if available.'
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.handleCellClose,
        variant: "contained",
        color: "primary"
      }, "Okay")), (main_26 || main_28) && /*#__PURE__*/React.createElement(Notification, {
        messageOpen: this.state.edgeOrIeMessageOpen,
        headerText: 'Viewer Notification:',
        bodyText: 'Your browser is outdated and your viewing ' + 'experience will not be of optimal quality. Please consider downloading and using Google Chrome.'
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.ignoreChrome
      }, "Ignore"), /*#__PURE__*/React.createElement(Button, {
        onClick: this.getChrome,
        variant: "contained",
        color: "primary"
      }, "Get Chrome")), this.state.isLoading && !this.state.isPlaying && this.renderLoading(), this.state.switchingVideo ? /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...") : this.state.showVideo ? this.renderVideo() : this.renderAudio(), this.state.subscribeStartReceived && this.renderBigPlayButton(), this.renderDetails(), !this.state.isLoading && this.state.showNoStreamNotification && /*#__PURE__*/React.createElement(Overlay, {
        overlayText: 'Stream not available'
      }), !this.state.isLoading && this.state.config.audioOnly && !this.state.showBigPlayButton && /*#__PURE__*/React.createElement(Overlay, {
        overlayText: 'Audio only stream'
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      adapter.disableLog(true);
      this.checkCookies();
      this.fetchConfigAndSubscribe()["catch"](function () {
        _this2.setState({
          isLoading: false,
          showNoStreamNotification: true
        });
      });
      this.checkInIframe();
      document.addEventListener('fullscreenchange', this.exitFullscreenHandler);
      document.addEventListener('webkitfullscreenchange', this.exitFullscreenHandler);
      document.addEventListener('mozfullscreenchange', this.exitFullscreenHandler);
      document.addEventListener('MSFullscreenChange', this.exitFullscreenHandler);
      document.getElementById('red5pro-subscriber').addEventListener('webkitendfullscreen', this.exitFullscreenHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var streamIdChanged = this.props.auctionId !== prevProps.auctionId;

      if (streamIdChanged) {
        this.unsubscribe();
        this.fetchConfigAndSubscribe()["catch"](function () {
          _this3.setState({
            isLoading: false,
            showNoStreamNotification: true
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('fullscreenchange', this.exitFullscreenHandler);
      document.removeEventListener('webkitfullscreenchange', this.exitFullscreenHandler);
      document.removeEventListener('mozfullscreenchange', this.exitFullscreenHandler);
      document.removeEventListener('MSFullscreenChange', this.exitFullscreenHandler);

      if (document.getElementById('red5pro-subscriber')) {
        document.getElementById('red5pro-subscriber').removeEventListener('webkitendfullscreen', this.exitFullscreenHandler);
      }

      if (this.autoRefreshTimer) {
        clearTimeout(this.autoRefreshTimer);
      }
    }
  }]);
}(React.Component);

Subscriber.propTypes = {
  title: PropTypes__default.string.isRequired,
  description: PropTypes__default.string.isRequired,
  dateLocation: PropTypes__default.string.isRequired,
  auctionId: PropTypes__default.number.isRequired,
  displayHeight: PropTypes__default.number,
  displayWidth: PropTypes__default.number,
  clientProxyUrl: PropTypes__default.string.isRequired,
  streamTest: PropTypes__default.bool,
  retryWaitTime: PropTypes__default.number,
  maxRetryMinutes: PropTypes__default.number,
  minutesBeforeExtendedReconnect: PropTypes__default.number,
  audioOnly: PropTypes__default.bool
};
Subscriber.defaultProps = {
  streamTest: false,
  retryWaitTime: 15000,
  maxRetryMinutes: 120,
  minutesBeforeExtendedReconnect: 3
};

(function (l) {
  function m(b) {
    b = void 0 === b ? "utf-8" : b;
    if ("utf-8" !== b) throw new RangeError("Failed to construct 'TextEncoder': The encoding label provided ('" + b + "') is invalid.");
  }

  function k(b, a) {
    b = void 0 === b ? "utf-8" : b;
    a = void 0 === a ? {
      fatal: !1
    } : a;
    if ("utf-8" !== b) throw new RangeError("Failed to construct 'TextDecoder': The encoding label provided ('" + b + "') is invalid.");
    if (a.fatal) throw Error("Failed to construct 'TextDecoder': the 'fatal' option is unsupported.");
  }

  if (l.TextEncoder && l.TextDecoder) return !1;
  Object.defineProperty(m.prototype, "encoding", {
    value: "utf-8"
  });

  m.prototype.encode = function (b, a) {
    a = void 0 === a ? {
      stream: !1
    } : a;
    if (a.stream) throw Error("Failed to encode: the 'stream' option is unsupported.");
    a = 0;

    for (var h = b.length, f = 0, c = Math.max(32, h + (h >> 1) + 7), e = new Uint8Array(c >> 3 << 3); a < h;) {
      var d = b.charCodeAt(a++);

      if (55296 <= d && 56319 >= d) {
        if (a < h) {
          var g = b.charCodeAt(a);
          56320 === (g & 64512) && (++a, d = ((d & 1023) << 10) + (g & 1023) + 65536);
        }

        if (55296 <= d && 56319 >= d) continue;
      }

      f + 4 > e.length && (c += 8, c *= 1 + a / b.length * 2, c = c >> 3 << 3, g = new Uint8Array(c), g.set(e), e = g);
      if (0 === (d & 4294967168)) e[f++] = d;else {
        if (0 === (d & 4294965248)) e[f++] = d >> 6 & 31 | 192;else if (0 === (d & 4294901760)) e[f++] = d >> 12 & 15 | 224, e[f++] = d >> 6 & 63 | 128;else if (0 === (d & 4292870144)) e[f++] = d >> 18 & 7 | 240, e[f++] = d >> 12 & 63 | 128, e[f++] = d >> 6 & 63 | 128;else continue;
        e[f++] = d & 63 | 128;
      }
    }

    return e.slice(0, f);
  };

  Object.defineProperty(k.prototype, "encoding", {
    value: "utf-8"
  });
  Object.defineProperty(k.prototype, "fatal", {
    value: !1
  });
  Object.defineProperty(k.prototype, "ignoreBOM", {
    value: !1
  });

  k.prototype.decode = function (b, a) {
    a = void 0 === a ? {
      stream: !1
    } : a;
    if (a.stream) throw Error("Failed to decode: the 'stream' option is unsupported.");
    b = new Uint8Array(b);
    a = 0;

    for (var h = b.length, f = []; a < h;) {
      var c = b[a++];
      if (0 === c) break;
      if (0 === (c & 128)) f.push(c);else if (192 === (c & 224)) {
        var e = b[a++] & 63;
        f.push((c & 31) << 6 | e);
      } else if (224 === (c & 240)) {
        e = b[a++] & 63;
        var d = b[a++] & 63;
        f.push((c & 31) << 12 | e << 6 | d);
      } else if (240 === (c & 248)) {
        e = b[a++] & 63;
        d = b[a++] & 63;
        var g = b[a++] & 63;
        c = (c & 7) << 18 | e << 12 | d << 6 | g;
        65535 < c && (c -= 65536, f.push(c >>> 10 & 1023 | 55296), c = 56320 | c & 1023);
        f.push(c);
      }
    }

    return String.fromCharCode.apply(null, f);
  };

  l.TextEncoder = m;
  l.TextDecoder = k;
})("undefined" !== typeof window ? window : "undefined" !== typeof commonjsGlobal ? commonjsGlobal : commonjsGlobal);

function symbolObservablePonyfill(root) {
  var result;
  var Symbol = root.Symbol;

  if (typeof Symbol === 'function') {
    if (Symbol.observable) {
      result = Symbol.observable;
    } else {
      result = Symbol('observable');
      Symbol.observable = result;
    }
  } else {
    result = '@@observable';
  }

  return result;
}
/* global window */


var root$1;

if (typeof self !== 'undefined') {
  root$1 = self;
} else if (typeof window !== 'undefined') {
  root$1 = window;
} else if (typeof global !== 'undefined') {
  root$1 = global;
} else if (typeof module !== 'undefined') {
  root$1 = module;
} else {
  root$1 = Function('return this')();
}

var result = symbolObservablePonyfill(root$1);
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */

var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */


function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[result] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[result] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */


function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (process.env.NODE_ENV !== 'production') {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (process.env.NODE_ENV !== 'production') {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (process.env.NODE_ENV !== 'production') {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(source, true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */


function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */


function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2$1({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */


function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

var redux = /*#__PURE__*/Object.freeze({
  __proto__: null,
  __DO_NOT_USE__ActionTypes: ActionTypes,
  applyMiddleware: applyMiddleware,
  bindActionCreators: bindActionCreators,
  combineReducers: combineReducers,
  compose: compose,
  createStore: createStore
});
var ReactReduxContext = React.createContext(null); // Default to a dummy "batch" implementation that just runs the callback

function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings


var getBatch = function getBatch() {
  return batch;
}; // well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants


var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = getBatch(); // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?

  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      batch(function () {
        for (var i = 0; i < listeners.length; i++) {
          listeners[i]();
        }
      });
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = useMemo(function () {
    var subscription = new Subscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = useMemo(function () {
    return store.getState();
  }, [store]);
  useEffect(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return React.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

Provider.propTypes = {
  store: PropTypes__default.shape({
    subscribe: PropTypes__default.func.isRequired,
    dispatch: PropTypes__default.func.isRequired,
    getState: PropTypes__default.func.isRequired
  }),
  context: PropTypes__default.object,
  children: PropTypes__default.any
};

function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  }, _extends$1.apply(null, arguments);
}

function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};

  for (var n in r) {
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n)) continue;
      t[n] = r[n];
    }
  }

  return t;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element$1 = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element$1,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
var reactIs_1 = reactIs.isFragment;
var reactIs_2 = reactIs.ForwardRef;
var reactIs_3 = reactIs.Memo;
var reactIs_4 = reactIs.isValidElementType;
var reactIs_5 = reactIs.forwardRef;
var reactIs_6 = reactIs.isContextConsumer;
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
};

var browser = invariant;
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
}; // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect because we want
// `connect` to perform sync updates to a ref to save the latest props after
// a render is actually committed to the DOM.


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose$1(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  browser(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
  browser(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  browser(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production') {
      browser(reactIs_4(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends$1({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = useMemo(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose$1(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = useMemo(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && reactIs_6(React.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = useContext(ContextToUse); // The store _must_ exist as either a prop or in context

      var didStoreComeFromProps = Boolean(props.store);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
      browser(didStoreComeFromProps || didStoreComeFromContext, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      var store = props.store || contextValue.store;
      var childPropsSelector = useMemo(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = useMemo(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new Subscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = useMemo(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends$1({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = useRef();
      var lastWrapperProps = useRef(wrapperProps);
      var childPropsFromStoreUpdate = useRef();
      var renderIsScheduled = useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffect(function () {
        // We want to capture the wrapper props and child props we used for later comparisons
        lastWrapperProps.current = wrapperProps;
        lastChildProps.current = actualChildProps;
        renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

        if (childPropsFromStoreUpdate.current) {
          childPropsFromStoreUpdate.current = null;
          notifyNestedSubs();
        }
      }); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffect(function () {
        // If we're not subscribed to the store, nothing to do here
        if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

        var didUnsubscribe = false;
        var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

        var checkForUpdates = function checkForUpdates() {
          if (didUnsubscribe) {
            // Don't run stale listeners.
            // Redux doesn't guarantee unsubscriptions happen until next dispatch.
            return;
          }

          var latestStoreState = store.getState();
          var newChildProps, error;

          try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
          } catch (e) {
            error = e;
            lastThrownError = e;
          }

          if (!error) {
            lastThrownError = null;
          } // If the child props haven't changed, nothing to do here - cascade the subscription update


          if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) {
              notifyNestedSubs();
            }
          } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

            forceComponentUpdateDispatch({
              type: 'STORE_UPDATED',
              payload: {
                latestStoreState: latestStoreState,
                error: error
              }
            });
          }
        }; // Actually subscribe to the nearest connected ancestor (or store)


        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe(); // Pull data from the store after first render in case the store has
        // changed since we began.

        checkForUpdates();

        var unsubscribeWrapper = function unsubscribeWrapper() {
          didUnsubscribe = true;
          subscription.tryUnsubscribe();
          subscription.onStateChange = null;

          if (lastThrownError) {
            // It's possible that we caught an error due to a bad mapState function, but the
            // parent re-rendered without this component and we're about to unmount.
            // This shouldn't happen as long as we do top-down subscriptions correctly, but
            // if we ever do those wrong, this throw will surface the error in our tests.
            // In that case, throw the error from here so it doesn't get lost.
            throw lastThrownError;
          }
        };

        return unsubscribeWrapper;
      }, [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = useMemo(function () {
        return React.createElement(WrappedComponent, _extends$1({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = useMemo(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return React.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = React.forwardRef(function forwardConnectRef(props, ref) {
        return React.createElement(Connect, _extends$1({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistNonReactStatics_cjs(forwarded, WrappedComponent);
    }

    return hoistNonReactStatics_cjs(Connect, WrappedComponent);
  };
}

var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */


function isPlainObject$1(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */


function warning$1(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject$1(value)) {
    warning$1(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..


function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//


function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}

var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}

var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends$1({}, ownProps, {}, stateProps, {}, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      warning$1("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.


function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose$1(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */


function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose$1(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends$1({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}

var connect = createConnect();
setBatch(unstable_batchedUpdates);

function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

var objectKeys = Object.keys || function (obj) {
  var keys = [];

  for (var key in obj) {
    if ({}.hasOwnProperty.call(obj, key)) keys.push(key);
  }

  return keys;
};

function assign(obj, newKey, newValue) {
  var keys = objectKeys(obj);
  var copy = {};

  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    copy[key] = obj[key];
  }

  copy[newKey] = newValue;
  return copy;
}

var assign_1 = assign;
var logOnly = createCommonjsModule(function (module, exports) {
  var compose = redux.compose;

  function enhancer() {
    var config = arguments[0] || {};
    config.features = {
      pause: true,
      export: true,
      test: true
    };
    config.type = 'redux';
    if (config.autoPause === undefined) config.autoPause = true;
    if (config.latency === undefined) config.latency = 500;
    return function (createStore) {
      return function (reducer, preloadedState, enhancer) {
        var store = createStore(reducer, preloadedState, enhancer);
        var origDispatch = store.dispatch;

        var devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(config);

        devTools.init(store.getState());

        var dispatch = function dispatch(action) {
          var r = origDispatch(action);
          devTools.send(action, store.getState());
          return r;
        };

        if (Object.assign) return Object.assign(store, {
          dispatch: dispatch
        });
        return assign_1(store, 'dispatch', dispatch);
      };
    };
  }

  function composeWithEnhancer(config) {
    return function () {
      return compose(compose.apply(null, arguments), enhancer(config));
    };
  }

  exports.__esModule = true;

  exports.composeWithDevTools = function () {
    if (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
      if (arguments.length === 0) return enhancer();
      if (typeof arguments[0] === 'object') return composeWithEnhancer(arguments[0]);
      return composeWithEnhancer().apply(null, arguments);
    }

    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === 'object') return compose;
    return compose.apply(null, arguments);
  };

  exports.devToolsEnhancer = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? enhancer : function () {
    return function (noop) {
      return noop;
    };
  };
});
unwrapExports(logOnly);
var logOnly_1 = logOnly.composeWithDevTools;
var logOnly_2 = logOnly.devToolsEnhancer;
var logOnlyInProduction = createCommonjsModule(function (module, exports) {
  var compose = redux.compose;
  exports.__esModule = true;
  exports.composeWithDevTools = process.env.NODE_ENV === 'production' ? logOnly.composeWithDevTools : typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === 'object') return compose;
    return compose.apply(null, arguments);
  };
  exports.devToolsEnhancer = process.env.NODE_ENV === 'production' ? logOnly.devToolsEnhancer : typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop) {
      return noop;
    };
  };
});
unwrapExports(logOnlyInProduction);
var logOnlyInProduction_1 = logOnlyInProduction.composeWithDevTools;
var logOnlyInProduction_2 = logOnlyInProduction.devToolsEnhancer;
var lodash_isequal = createCommonjsModule(function (module, exports) {
  /**
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright JS Foundation and other contributors <https://js.foundation/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;
  /** Used to stand-in for `undefined` hash values. */

  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used to compose bitmasks for value comparisons. */

  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
  /** Used as references for various `Number` constants. */

  var MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */

  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  /* Node.js helper references. */


  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */

  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];

      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }

    return result;
  }
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */


  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }

    return array;
  }
  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */


  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }

    return false;
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */


  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function cacheHas(cache, key) {
    return cache.has(key);
  }
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */


  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */


  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }
  /** Used for built-in method references. */


  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to detect overreaching core-js shims. */

  var coreJsData = root['__core-js_shared__'];
  /** Used to resolve the decompiled source of functions. */

  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */


  var nativeObjectToString = objectProto.toString;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = Symbol ? Symbol.toStringTag : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols = Object.getOwnPropertySymbols,
      nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeKeys = overArg(Object.keys, Object);
  /* Built-in method references that are verified to be native. */

  var DataView = getNative(root, 'DataView'),
      Map = getNative(root, 'Map'),
      Promise = getNative(root, 'Promise'),
      Set = getNative(root, 'Set'),
      WeakMap = getNative(root, 'WeakMap'),
      nativeCreate = getNative(Object, 'create');
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */


  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */


  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    --this.size;
    return true;
  }
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */

  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();

    while (++index < length) {
      this.add(values[index]);
    }
  }
  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */


  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);

    return this;
  }
  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */


  function setCacheHas(value) {
    return this.__data__.has(value);
  } // Add methods to `SetCache`.


  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);
    this.size = data.size;
    return result;
  }
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function stackGet(key) {
    return this.__data__.get(key);
  }
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function stackHas(key) {
    return this.__data__.has(key);
  }
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */


  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }
  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */


  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }
  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */


  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }
  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */


  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }

    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }

    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }
  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }

      objIsArr = true;
      objIsObj = false;
    }

    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }

    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }

    if (!isSameTag) {
      return false;
    }

    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */


  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */


  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */


  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    } // Assume cyclic values are equal.


    var stacked = stack.get(array);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array); // Ignore non-index properties.

    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }

      if (compared !== undefined) {
        if (compared) {
          continue;
        }

        result = false;
        break;
      } // Recursively compare arrays (susceptible to call stack limits).


      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }

    stack['delete'](array);
    stack['delete'](other);
    return result;
  }
  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }

        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }

        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        } // Assume cyclic values are equal.


        var stacked = stack.get(object);

        if (stacked) {
          return stacked == other;
        }

        bitmask |= COMPARE_UNORDERED_FLAG; // Recursively compare objects (susceptible to call stack limits).

        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }

    }

    return false;
  }
  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }

    var index = objLength;

    while (index--) {
      var key = objProps[index];

      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    } // Assume cyclic values are equal.


    var stacked = stack.get(object);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;

    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      } // Recursively compare objects (susceptible to call stack limits).


      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }

      skipCtor || (skipCtor = key == 'constructor');
    }

    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }

    stack['delete'](object);
    stack['delete'](other);
    return result;
  }
  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */


  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }
  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */


  var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
      return [];
    }

    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;

          case mapCtorString:
            return mapTag;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag;

          case weakMapCtorString:
            return weakMapTag;
        }
      }

      return result;
    };
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */


  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */


  function objectToString(value) {
    return nativeObjectToString.call(value);
  }
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */


  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */


  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */

  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */


  var isBuffer = nativeIsBuffer || stubFalse;
  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are compared by strict equality, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */

  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */


  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    } // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.


    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */


  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */

  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */


  function stubArray() {
    return [];
  }
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */


  function stubFalse() {
    return false;
  }

  module.exports = isEqual;
});
var browserCrypto = createCommonjsModule(function (module) {
  if (commonjsGlobal.crypto && commonjsGlobal.crypto.getRandomValues) {
    module.exports.randomBytes = function (length) {
      var bytes = new Uint8Array(length);
      commonjsGlobal.crypto.getRandomValues(bytes);
      return bytes;
    };
  } else {
    module.exports.randomBytes = function (length) {
      var bytes = new Array(length);

      for (var i = 0; i < length; i++) {
        bytes[i] = Math.floor(Math.random() * 256);
      }

      return bytes;
    };
  }
});
var browserCrypto_1 = browserCrypto.randomBytes;
/* global crypto:true */
// This string has length 32, a power of 2, so the modulus doesn't introduce a
// bias.

var _randomStringChars = 'abcdefghijklmnopqrstuvwxyz012345';
var random = {
  string: function string(length) {
    var max = _randomStringChars.length;
    var bytes = browserCrypto.randomBytes(length);
    var ret = [];

    for (var i = 0; i < length; i++) {
      ret.push(_randomStringChars.substr(bytes[i] % max, 1));
    }

    return ret.join('');
  },
  number: function number(max) {
    return Math.floor(Math.random() * max);
  },
  numberString: function numberString(max) {
    var t = ('' + (max - 1)).length;
    var p = new Array(t + 1).join('0');
    return (p + this.number(max)).slice(-t);
  }
};
var event = createCommonjsModule(function (module) {
  var onUnload = {},
      afterUnload = false // detect google chrome packaged apps because they don't allow the 'unload' event
  ,
      isChromePackagedApp = commonjsGlobal.chrome && commonjsGlobal.chrome.app && commonjsGlobal.chrome.app.runtime;
  module.exports = {
    attachEvent: function attachEvent(event, listener) {
      if (typeof commonjsGlobal.addEventListener !== 'undefined') {
        commonjsGlobal.addEventListener(event, listener, false);
      } else if (commonjsGlobal.document && commonjsGlobal.attachEvent) {
        // IE quirks.
        // According to: http://stevesouders.com/misc/test-postmessage.php
        // the message gets delivered only to 'document', not 'window'.
        commonjsGlobal.document.attachEvent('on' + event, listener); // I get 'window' for ie8.

        commonjsGlobal.attachEvent('on' + event, listener);
      }
    },
    detachEvent: function detachEvent(event, listener) {
      if (typeof commonjsGlobal.addEventListener !== 'undefined') {
        commonjsGlobal.removeEventListener(event, listener, false);
      } else if (commonjsGlobal.document && commonjsGlobal.detachEvent) {
        commonjsGlobal.document.detachEvent('on' + event, listener);
        commonjsGlobal.detachEvent('on' + event, listener);
      }
    },
    unloadAdd: function unloadAdd(listener) {
      if (isChromePackagedApp) {
        return null;
      }

      var ref = random.string(8);
      onUnload[ref] = listener;

      if (afterUnload) {
        setTimeout(this.triggerUnloadCallbacks, 0);
      }

      return ref;
    },
    unloadDel: function unloadDel(ref) {
      if (ref in onUnload) {
        delete onUnload[ref];
      }
    },
    triggerUnloadCallbacks: function triggerUnloadCallbacks() {
      for (var ref in onUnload) {
        onUnload[ref]();
        delete onUnload[ref];
      }
    }
  };

  var unloadTriggered = function unloadTriggered() {
    if (afterUnload) {
      return;
    }

    afterUnload = true;
    module.exports.triggerUnloadCallbacks();
  }; // 'unload' alone is not reliable in opera within an iframe, but we
  // can't use `beforeunload` as IE fires it on javascript: links.


  if (!isChromePackagedApp) {
    module.exports.attachEvent('unload', unloadTriggered);
  }
});
var event_1 = event.attachEvent;
var event_2 = event.detachEvent;
var event_3 = event.unloadAdd;
var event_4 = event.unloadDel;
var event_5 = event.triggerUnloadCallbacks;
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */

var requiresPort = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;
  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
      return port !== 80;

    case 'https':
    case 'wss':
      return port !== 443;

    case 'ftp':
      return port !== 21;

    case 'gopher':
      return port !== 70;

    case 'file':
      return false;
  }

  return port !== 0;
};

var has = Object.prototype.hasOwnProperty,
    undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */

function decode$1(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */


function encode$2(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */


function querystring(query) {
  var parser = /([^=?#&]+)=?([^&]*)/g,
      result = {},
      part;

  while (part = parser.exec(query)) {
    var key = decode$1(part[1]),
        value = decode$1(part[2]); //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //

    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */


function querystringify(obj, prefix) {
  prefix = prefix || '';
  var pairs = [],
      value,
      key; //
  // Optionally prefix with a '?' if needed
  //

  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key]; //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //

      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      key = encode$2(key);
      value = encode$2(value); //
      // If we failed to encode the strings, we should bail out as we don't
      // want to add invalid strings to the query.
      //

      if (key === null || value === null) continue;
      pairs.push(key + '=' + value);
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
} //
// Expose the module.
//


var stringify = querystringify;
var parse$1 = querystring;
var querystringify_1 = {
  stringify: stringify,
  parse: parse$1
};
var controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/,
    CRHTLF = /[\n\r\t]/g,
    slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//,
    port = /:\d+$/,
    protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i,
    windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */

function trimLeft(str) {
  return (str ? str : '').toString().replace(controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */


var rules = [['#', 'hash'], // Extract from the back.
['?', 'query'], // Extract from the back.
function sanitize(address, url) {
  // Sanitize what is left of the address
  return isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
}, ['/', 'pathname'], // Extract from the back.
['@', 'auth', 1], // Extract from the front.
[NaN, 'host', undefined, 1, 1], // Set left over value.
[/:(\d*)$/, 'port', undefined, 1], // RegExp the back.
[NaN, 'hostname', undefined, 1, 1] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */

var ignore = {
  hash: 1,
  query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */

function lolcation(loc) {
  var globalVar;
  if (typeof window !== 'undefined') globalVar = window;else if (typeof commonjsGlobal !== 'undefined') globalVar = commonjsGlobal;else if (typeof self !== 'undefined') globalVar = self;else globalVar = {};
  var location = globalVar.location || {};
  loc = loc || location;
  var finaldestination = {},
      type = typeof loc,
      key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});

    for (key in ignore) {
      delete finaldestination[key];
    }
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */


function isSpecial(scheme) {
  return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */


function extractProtocol(address, location) {
  address = trimLeft(address);
  address = address.replace(CRHTLF, '');
  location = location || {};
  var match = protocolre.exec(address);
  var protocol = match[1] ? match[1].toLowerCase() : '';
  var forwardSlashes = !!match[2];
  var otherSlashes = !!match[3];
  var slashesCount = 0;
  var rest;

  if (forwardSlashes) {
    if (otherSlashes) {
      rest = match[2] + match[3] + match[4];
      slashesCount = match[2].length + match[3].length;
    } else {
      rest = match[2] + match[4];
      slashesCount = match[2].length;
    }
  } else {
    if (otherSlashes) {
      rest = match[3] + match[4];
      slashesCount = match[3].length;
    } else {
      rest = match[4];
    }
  }

  if (protocol === 'file:') {
    if (slashesCount >= 2) {
      rest = rest.slice(2);
    }
  } else if (isSpecial(protocol)) {
    rest = match[4];
  } else if (protocol) {
    if (forwardSlashes) {
      rest = rest.slice(2);
    }
  } else if (slashesCount >= 2 && isSpecial(location.protocol)) {
    rest = match[4];
  }

  return {
    protocol: protocol,
    slashes: forwardSlashes || isSpecial(protocol),
    slashesCount: slashesCount,
    rest: rest
  };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */


function resolve(relative, base) {
  if (relative === '') return base;
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')),
      i = path.length,
      last = path[i - 1],
      unshift = false,
      up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');
  return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */


function Url(address, location, parser) {
  address = trimLeft(address);
  address = address.replace(CRHTLF, '');

  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative,
      extracted,
      parse,
      instruction,
      index,
      key,
      instructions = rules.slice(),
      type = typeof location,
      url = this,
      i = 0; //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //

  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = querystringify_1.parse;
  location = lolcation(location); //
  // Extract protocol information before running the instructions.
  //

  extracted = extractProtocol(address || '', location);
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest; //
  // When the authority component is absent the URL starts with a path
  // component.
  //

  if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !isSpecial(url.protocol))) {
    instructions[3] = [/(.*)/, 'pathname'];
  }

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address, url);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);

      if (~index) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if (index = parse.exec(address)) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : ''); //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //

    if (instruction[4]) url[key] = url[key].toLowerCase();
  } //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //


  if (parser) url.query = parser(url.query); //
  // If the URL is relative, resolve the pathname against the base URL.
  //

  if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) {
    url.pathname = resolve(url.pathname, location.pathname);
  } //
  // Default to a / for pathname if none exists. This normalizes the URL
  // to always have a /
  //


  if (url.pathname.charAt(0) !== '/' && isSpecial(url.protocol)) {
    url.pathname = '/' + url.pathname;
  } //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //


  if (!requiresPort(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  } //
  // Parse down the `auth` for the username and password.
  //


  url.username = url.password = '';

  if (url.auth) {
    index = url.auth.indexOf(':');

    if (~index) {
      url.username = url.auth.slice(0, index);
      url.username = encodeURIComponent(decodeURIComponent(url.username));
      url.password = url.auth.slice(index + 1);
      url.password = encodeURIComponent(decodeURIComponent(url.password));
    } else {
      url.username = encodeURIComponent(decodeURIComponent(url.auth));
    }

    url.auth = url.password ? url.username + ':' + url.password : url.username;
  }

  url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null'; //
  // The href is just the compiled result.
  //

  url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */


function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || querystringify_1.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!requiresPort(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname + ':' + value;
      }

      break;

    case 'hostname':
      url[part] = value;
      if (url.port) value += ':' + url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (port.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }

      break;

    case 'username':
    case 'password':
      url[part] = encodeURIComponent(value);
      break;

    case 'auth':
      var index = value.indexOf(':');

      if (~index) {
        url.username = value.slice(0, index);
        url.username = encodeURIComponent(decodeURIComponent(url.username));
        url.password = value.slice(index + 1);
        url.password = encodeURIComponent(decodeURIComponent(url.password));
      } else {
        url.username = encodeURIComponent(decodeURIComponent(value));
      }

  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];
    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.auth = url.password ? url.username + ':' + url.password : url.username;
  url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
  url.href = url.toString();
  return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */


function toString$1(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = querystringify_1.stringify;
  var query,
      url = this,
      host = url.host,
      protocol = url.protocol;
  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
  var result = protocol + (url.protocol && url.slashes || isSpecial(url.protocol) ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':' + url.password;
    result += '@';
  } else if (url.password) {
    result += ':' + url.password;
    result += '@';
  } else if (url.protocol !== 'file:' && isSpecial(url.protocol) && !host && url.pathname !== '/') {
    //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
  } //
  // Trailing colon is removed from `url.host` when it is parsed. If it still
  // ends with a colon, then add back the trailing colon that was removed. This
  // prevents an invalid URL from being transformed into a valid one.
  //


  if (host[host.length - 1] === ':' || port.test(url.hostname) && !url.port) {
    host += ':';
  }

  result += host + url.pathname;
  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
  if (url.hash) result += url.hash;
  return result;
}

Url.prototype = {
  set: set,
  toString: toString$1
}; //
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//

Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = querystringify_1;
var urlParse = Url;
/**
 * Helpers.
 */

var s = 1000;
var m$1 = s * 60;
var h$1 = m$1 * 60;
var d$1 = h$1 * 24;
var w$1 = d$1 * 7;
var y$1 = d$1 * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function ms(val, options) {
  options = options || {};
  var type = typeof val;

  if (type === 'string' && val.length > 0) {
    return parse$2(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }

  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */


function parse$2(str) {
  str = String(str);

  if (str.length > 100) {
    return;
  }

  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);

  if (!match) {
    return;
  }

  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();

  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y$1;

    case 'weeks':
    case 'week':
    case 'w':
      return n * w$1;

    case 'days':
    case 'day':
    case 'd':
      return n * d$1;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h$1;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m$1;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;

    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;

    default:
      return undefined;
  }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtShort(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d$1) {
    return Math.round(ms / d$1) + 'd';
  }

  if (msAbs >= h$1) {
    return Math.round(ms / h$1) + 'h';
  }

  if (msAbs >= m$1) {
    return Math.round(ms / m$1) + 'm';
  }

  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }

  return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */


function fmtLong(ms) {
  var msAbs = Math.abs(ms);

  if (msAbs >= d$1) {
    return plural(ms, msAbs, d$1, 'day');
  }

  if (msAbs >= h$1) {
    return plural(ms, msAbs, h$1, 'hour');
  }

  if (msAbs >= m$1) {
    return plural(ms, msAbs, m$1, 'minute');
  }

  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }

  return ms + ' ms';
}
/**
 * Pluralization helper.
 */


function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */


function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = ms;
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // Disabled?
      if (!debug.enabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @api public
  */


  function disable() {
    createDebug.enable('');
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

var common = setup;
var browser$1 = createCommonjsModule(function (module, exports) {
  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }
  /* eslint-env browser */

  /**
   * This is the web browser implementation of `debug()`.
   */


  exports.log = log;
  exports.formatArgs = formatArgs;
  exports.save = save;
  exports.load = load;
  exports.useColors = useColors;
  exports.storage = localstorage();
  /**
   * Colors.
   */

  exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
  /**
   * Currently only WebKit-based Web Inspectors, Firefox >= v31,
   * and the Firebug extension (any Firefox version) are known
   * to support "%c" CSS customizations.
   *
   * TODO: add a `localStorage` variable to explicitly enable/disable colors
   */
  // eslint-disable-next-line complexity

  function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
      return true;
    } // Internet Explorer and Edge do not support colors.


    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
      return false;
    } // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  /**
   * Colorize log arguments if enabled.
   *
   * @api public
   */


  function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

    if (!this.useColors) {
      return;
    }

    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into

    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function (match) {
      if (match === '%%') {
        return;
      }

      index++;

      if (match === '%c') {
        // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
      }
    });
    args.splice(lastC, 0, c);
  }
  /**
   * Invokes `console.log()` when available.
   * No-op when `console.log` is not a "function".
   *
   * @api public
   */


  function log() {
    var _console; // This hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'


    return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
  }
  /**
   * Save `namespaces`.
   *
   * @param {String} namespaces
   * @api private
   */


  function save(namespaces) {
    try {
      if (namespaces) {
        exports.storage.setItem('debug', namespaces);
      } else {
        exports.storage.removeItem('debug');
      }
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    }
  }
  /**
   * Load `namespaces`.
   *
   * @return {String} returns the previously persisted debug modes
   * @api private
   */


  function load() {
    var r;

    try {
      r = exports.storage.getItem('debug');
    } catch (error) {} // Swallow
    // XXX (@Qix-) should we be logging these?
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


    if (!r && typeof process !== 'undefined' && 'env' in process) {
      r = process.env.DEBUG;
    }

    return r;
  }
  /**
   * Localstorage attempts to return the localstorage.
   *
   * This is necessary because safari throws
   * when a user disables cookies/localstorage
   * and you attempt to access it.
   *
   * @return {LocalStorage}
   * @api private
   */


  function localstorage() {
    try {
      // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
      // The Browser also has localStorage in the global context.
      return localStorage;
    } catch (error) {// Swallow
      // XXX (@Qix-) should we be logging these?
    }
  }

  module.exports = common(exports);
  var formatters = module.exports.formatters;
  /**
   * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
   */

  formatters.j = function (v) {
    try {
      return JSON.stringify(v);
    } catch (error) {
      return '[UnexpectedJSONParseError]: ' + error.message;
    }
  };
});
var browser_1 = browser$1.log;
var browser_2 = browser$1.formatArgs;
var browser_3 = browser$1.save;
var browser_4 = browser$1.load;
var browser_5 = browser$1.useColors;
var browser_6 = browser$1.storage;
var browser_7 = browser$1.colors;

var debug = function debug() {};

if (process.env.NODE_ENV !== 'production') {
  debug = browser$1('sockjs-client:utils:url');
}

var url = {
  getOrigin: function getOrigin(url) {
    if (!url) {
      return null;
    }

    var p = new urlParse(url);

    if (p.protocol === 'file:') {
      return null;
    }

    var port = p.port;

    if (!port) {
      port = p.protocol === 'https:' ? '443' : '80';
    }

    return p.protocol + '//' + p.hostname + ':' + port;
  },
  isOriginEqual: function isOriginEqual(a, b) {
    var res = this.getOrigin(a) === this.getOrigin(b);
    debug('same', a, b, res);
    return res;
  },
  isSchemeEqual: function isSchemeEqual(a, b) {
    return a.split(':')[0] === b.split(':')[0];
  },
  addPath: function addPath(url, path) {
    var qs = url.split('?');
    return qs[0] + path + (qs[1] ? '?' + qs[1] : '');
  },
  addQuery: function addQuery(url, q) {
    return url + (url.indexOf('?') === -1 ? '?' + q : '&' + q);
  }
};
var inherits_browser = createCommonjsModule(function (module) {
  if (typeof Object.create === 'function') {
    // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
      if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
          constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
      }
    };
  } else {
    // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
      if (superCtor) {
        ctor.super_ = superCtor;

        var TempCtor = function TempCtor() {};

        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
      }
    };
  }
});
/* Simplified implementation of DOM2 EventTarget.
 *   http://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget
 */

function EventTarget() {
  this._listeners = {};
}

EventTarget.prototype.addEventListener = function (eventType, listener) {
  if (!(eventType in this._listeners)) {
    this._listeners[eventType] = [];
  }

  var arr = this._listeners[eventType]; // #4

  if (arr.indexOf(listener) === -1) {
    // Make a copy so as not to interfere with a current dispatchEvent.
    arr = arr.concat([listener]);
  }

  this._listeners[eventType] = arr;
};

EventTarget.prototype.removeEventListener = function (eventType, listener) {
  var arr = this._listeners[eventType];

  if (!arr) {
    return;
  }

  var idx = arr.indexOf(listener);

  if (idx !== -1) {
    if (arr.length > 1) {
      // Make a copy so as not to interfere with a current dispatchEvent.
      this._listeners[eventType] = arr.slice(0, idx).concat(arr.slice(idx + 1));
    } else {
      delete this._listeners[eventType];
    }

    return;
  }
};

EventTarget.prototype.dispatchEvent = function () {
  var event = arguments[0];
  var t = event.type; // equivalent of Array.prototype.slice.call(arguments, 0);

  var args = arguments.length === 1 ? [event] : Array.apply(null, arguments); // TODO: This doesn't match the real behavior; per spec, onfoo get
  // their place in line from the /first/ time they're set from
  // non-null. Although WebKit bumps it to the end every time it's
  // set.

  if (this['on' + t]) {
    this['on' + t].apply(this, args);
  }

  if (t in this._listeners) {
    // Grab a reference to the listeners list. removeEventListener may alter the list.
    var listeners = this._listeners[t];

    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(this, args);
    }
  }
};

var eventtarget = EventTarget;

function EventEmitter() {
  eventtarget.call(this);
}

inherits_browser(EventEmitter, eventtarget);

EventEmitter.prototype.removeAllListeners = function (type) {
  if (type) {
    delete this._listeners[type];
  } else {
    this._listeners = {};
  }
};

EventEmitter.prototype.once = function (type, listener) {
  var self = this,
      fired = false;

  function g() {
    self.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  this.on(type, g);
};

EventEmitter.prototype.emit = function () {
  var type = arguments[0];
  var listeners = this._listeners[type];

  if (!listeners) {
    return;
  } // equivalent of Array.prototype.slice.call(arguments, 1);


  var l = arguments.length;
  var args = new Array(l - 1);

  for (var ai = 1; ai < l; ai++) {
    args[ai - 1] = arguments[ai];
  }

  for (var i = 0; i < listeners.length; i++) {
    listeners[i].apply(this, args);
  }
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener = eventtarget.prototype.addEventListener;
EventEmitter.prototype.removeListener = eventtarget.prototype.removeEventListener;
var EventEmitter_1 = EventEmitter;
var emitter = {
  EventEmitter: EventEmitter_1
};
var websocket = createCommonjsModule(function (module) {
  var Driver = commonjsGlobal.WebSocket || commonjsGlobal.MozWebSocket;

  if (Driver) {
    module.exports = function WebSocketBrowserDriver(url) {
      return new Driver(url);
    };
  } else {
    module.exports = undefined;
  }
});
var EventEmitter$1 = emitter.EventEmitter;

var debug$1 = function debug$1() {};

if (process.env.NODE_ENV !== 'production') {
  debug$1 = browser$1('sockjs-client:websocket');
}

function WebSocketTransport(transUrl, ignore, options) {
  if (!WebSocketTransport.enabled()) {
    throw new Error('Transport created when disabled');
  }

  EventEmitter$1.call(this);
  debug$1('constructor', transUrl);
  var self = this;
  var url$1 = url.addPath(transUrl, '/websocket');

  if (url$1.slice(0, 5) === 'https') {
    url$1 = 'wss' + url$1.slice(5);
  } else {
    url$1 = 'ws' + url$1.slice(4);
  }

  this.url = url$1;
  this.ws = new websocket(this.url, [], options);

  this.ws.onmessage = function (e) {
    debug$1('message event', e.data);
    self.emit('message', e.data);
  }; // Firefox has an interesting bug. If a websocket connection is
  // created after onunload, it stays alive even when user
  // navigates away from the page. In such situation let's lie -
  // let's not open the ws connection at all. See:
  // https://github.com/sockjs/sockjs-client/issues/28
  // https://bugzilla.mozilla.org/show_bug.cgi?id=696085


  this.unloadRef = event.unloadAdd(function () {
    debug$1('unload');
    self.ws.close();
  });

  this.ws.onclose = function (e) {
    debug$1('close event', e.code, e.reason);
    self.emit('close', e.code, e.reason);

    self._cleanup();
  };

  this.ws.onerror = function (e) {
    debug$1('error event', e);
    self.emit('close', 1006, 'WebSocket connection broken');

    self._cleanup();
  };
}

inherits_browser(WebSocketTransport, EventEmitter$1);

WebSocketTransport.prototype.send = function (data) {
  var msg = '[' + data + ']';
  debug$1('send', msg);
  this.ws.send(msg);
};

WebSocketTransport.prototype.close = function () {
  debug$1('close');
  var ws = this.ws;

  this._cleanup();

  if (ws) {
    ws.close();
  }
};

WebSocketTransport.prototype._cleanup = function () {
  debug$1('_cleanup');
  var ws = this.ws;

  if (ws) {
    ws.onmessage = ws.onclose = ws.onerror = null;
  }

  event.unloadDel(this.unloadRef);
  this.unloadRef = this.ws = null;
  this.removeAllListeners();
};

WebSocketTransport.enabled = function () {
  debug$1('enabled');
  return !!websocket;
};

WebSocketTransport.transportName = 'websocket'; // In theory, ws should require 1 round trip. But in chrome, this is
// not very stable over SSL. Most likely a ws connection requires a
// separate SSL connection, in which case 2 round trips are an
// absolute minumum.

WebSocketTransport.roundTrips = 2;
var websocket$1 = WebSocketTransport;
var EventEmitter$2 = emitter.EventEmitter;

var debug$2 = function debug$2() {};

if (process.env.NODE_ENV !== 'production') {
  debug$2 = browser$1('sockjs-client:buffered-sender');
}

function BufferedSender(url, sender) {
  debug$2(url);
  EventEmitter$2.call(this);
  this.sendBuffer = [];
  this.sender = sender;
  this.url = url;
}

inherits_browser(BufferedSender, EventEmitter$2);

BufferedSender.prototype.send = function (message) {
  debug$2('send', message);
  this.sendBuffer.push(message);

  if (!this.sendStop) {
    this.sendSchedule();
  }
}; // For polling transports in a situation when in the message callback,
// new message is being send. If the sending connection was started
// before receiving one, it is possible to saturate the network and
// timeout due to the lack of receiving socket. To avoid that we delay
// sending messages by some small time, in order to let receiving
// connection be started beforehand. This is only a halfmeasure and
// does not fix the big problem, but it does make the tests go more
// stable on slow networks.


BufferedSender.prototype.sendScheduleWait = function () {
  debug$2('sendScheduleWait');
  var self = this;
  var tref;

  this.sendStop = function () {
    debug$2('sendStop');
    self.sendStop = null;
    clearTimeout(tref);
  };

  tref = setTimeout(function () {
    debug$2('timeout');
    self.sendStop = null;
    self.sendSchedule();
  }, 25);
};

BufferedSender.prototype.sendSchedule = function () {
  debug$2('sendSchedule', this.sendBuffer.length);
  var self = this;

  if (this.sendBuffer.length > 0) {
    var payload = '[' + this.sendBuffer.join(',') + ']';
    this.sendStop = this.sender(this.url, payload, function (err) {
      self.sendStop = null;

      if (err) {
        debug$2('error', err);
        self.emit('close', err.code || 1006, 'Sending error: ' + err);
        self.close();
      } else {
        self.sendScheduleWait();
      }
    });
    this.sendBuffer = [];
  }
};

BufferedSender.prototype._cleanup = function () {
  debug$2('_cleanup');
  this.removeAllListeners();
};

BufferedSender.prototype.close = function () {
  debug$2('close');

  this._cleanup();

  if (this.sendStop) {
    this.sendStop();
    this.sendStop = null;
  }
};

var bufferedSender = BufferedSender;
var EventEmitter$3 = emitter.EventEmitter;

var debug$3 = function debug$3() {};

if (process.env.NODE_ENV !== 'production') {
  debug$3 = browser$1('sockjs-client:polling');
}

function Polling(Receiver, receiveUrl, AjaxObject) {
  debug$3(receiveUrl);
  EventEmitter$3.call(this);
  this.Receiver = Receiver;
  this.receiveUrl = receiveUrl;
  this.AjaxObject = AjaxObject;

  this._scheduleReceiver();
}

inherits_browser(Polling, EventEmitter$3);

Polling.prototype._scheduleReceiver = function () {
  debug$3('_scheduleReceiver');
  var self = this;
  var poll = this.poll = new this.Receiver(this.receiveUrl, this.AjaxObject);
  poll.on('message', function (msg) {
    debug$3('message', msg);
    self.emit('message', msg);
  });
  poll.once('close', function (code, reason) {
    debug$3('close', code, reason, self.pollIsClosing);
    self.poll = poll = null;

    if (!self.pollIsClosing) {
      if (reason === 'network') {
        self._scheduleReceiver();
      } else {
        self.emit('close', code || 1006, reason);
        self.removeAllListeners();
      }
    }
  });
};

Polling.prototype.abort = function () {
  debug$3('abort');
  this.removeAllListeners();
  this.pollIsClosing = true;

  if (this.poll) {
    this.poll.abort();
  }
};

var polling = Polling;

var debug$4 = function debug$4() {};

if (process.env.NODE_ENV !== 'production') {
  debug$4 = browser$1('sockjs-client:sender-receiver');
}

function SenderReceiver(transUrl, urlSuffix, senderFunc, Receiver, AjaxObject) {
  var pollUrl = url.addPath(transUrl, urlSuffix);
  debug$4(pollUrl);
  var self = this;
  bufferedSender.call(this, transUrl, senderFunc);
  this.poll = new polling(Receiver, pollUrl, AjaxObject);
  this.poll.on('message', function (msg) {
    debug$4('poll message', msg);
    self.emit('message', msg);
  });
  this.poll.once('close', function (code, reason) {
    debug$4('poll close', code, reason);
    self.poll = null;
    self.emit('close', code, reason);
    self.close();
  });
}

inherits_browser(SenderReceiver, bufferedSender);

SenderReceiver.prototype.close = function () {
  bufferedSender.prototype.close.call(this);
  debug$4('close');
  this.removeAllListeners();

  if (this.poll) {
    this.poll.abort();
    this.poll = null;
  }
};

var senderReceiver = SenderReceiver;

var debug$5 = function debug$5() {};

if (process.env.NODE_ENV !== 'production') {
  debug$5 = browser$1('sockjs-client:ajax-based');
}

function createAjaxSender(AjaxObject) {
  return function (url$1, payload, callback) {
    debug$5('create ajax sender', url$1, payload);
    var opt = {};

    if (typeof payload === 'string') {
      opt.headers = {
        'Content-type': 'text/plain'
      };
    }

    var ajaxUrl = url.addPath(url$1, '/xhr_send');
    var xo = new AjaxObject('POST', ajaxUrl, payload, opt);
    xo.once('finish', function (status) {
      debug$5('finish', status);
      xo = null;

      if (status !== 200 && status !== 204) {
        return callback(new Error('http status ' + status));
      }

      callback();
    });
    return function () {
      debug$5('abort');
      xo.close();
      xo = null;
      var err = new Error('Aborted');
      err.code = 1000;
      callback(err);
    };
  };
}

function AjaxBasedTransport(transUrl, urlSuffix, Receiver, AjaxObject) {
  senderReceiver.call(this, transUrl, urlSuffix, createAjaxSender(AjaxObject), Receiver, AjaxObject);
}

inherits_browser(AjaxBasedTransport, senderReceiver);
var ajaxBased = AjaxBasedTransport;
var EventEmitter$4 = emitter.EventEmitter;

var debug$6 = function debug$6() {};

if (process.env.NODE_ENV !== 'production') {
  debug$6 = browser$1('sockjs-client:receiver:xhr');
}

function XhrReceiver(url, AjaxObject) {
  debug$6(url);
  EventEmitter$4.call(this);
  var self = this;
  this.bufferPosition = 0;
  this.xo = new AjaxObject('POST', url, null);
  this.xo.on('chunk', this._chunkHandler.bind(this));
  this.xo.once('finish', function (status, text) {
    debug$6('finish', status, text);

    self._chunkHandler(status, text);

    self.xo = null;
    var reason = status === 200 ? 'network' : 'permanent';
    debug$6('close', reason);
    self.emit('close', null, reason);

    self._cleanup();
  });
}

inherits_browser(XhrReceiver, EventEmitter$4);

XhrReceiver.prototype._chunkHandler = function (status, text) {
  debug$6('_chunkHandler', status);

  if (status !== 200 || !text) {
    return;
  }

  for (var idx = -1;; this.bufferPosition += idx + 1) {
    var buf = text.slice(this.bufferPosition);
    idx = buf.indexOf('\n');

    if (idx === -1) {
      break;
    }

    var msg = buf.slice(0, idx);

    if (msg) {
      debug$6('message', msg);
      this.emit('message', msg);
    }
  }
};

XhrReceiver.prototype._cleanup = function () {
  debug$6('_cleanup');
  this.removeAllListeners();
};

XhrReceiver.prototype.abort = function () {
  debug$6('abort');

  if (this.xo) {
    this.xo.close();
    debug$6('close');
    this.emit('close', null, 'user');
    this.xo = null;
  }

  this._cleanup();
};

var xhr$1 = XhrReceiver;
var EventEmitter$5 = emitter.EventEmitter,
    XHR = commonjsGlobal.XMLHttpRequest;

var debug$7 = function debug$7() {};

if (process.env.NODE_ENV !== 'production') {
  debug$7 = browser$1('sockjs-client:browser:xhr');
}

function AbstractXHRObject(method, url, payload, opts) {
  debug$7(method, url);
  var self = this;
  EventEmitter$5.call(this);
  setTimeout(function () {
    self._start(method, url, payload, opts);
  }, 0);
}

inherits_browser(AbstractXHRObject, EventEmitter$5);

AbstractXHRObject.prototype._start = function (method, url$1, payload, opts) {
  var self = this;

  try {
    this.xhr = new XHR();
  } catch (x) {// intentionally empty
  }

  if (!this.xhr) {
    debug$7('no xhr');
    this.emit('finish', 0, 'no xhr support');

    this._cleanup();

    return;
  } // several browsers cache POSTs


  url$1 = url.addQuery(url$1, 't=' + +new Date()); // Explorer tends to keep connection open, even after the
  // tab gets closed: http://bugs.jquery.com/ticket/5280

  this.unloadRef = event.unloadAdd(function () {
    debug$7('unload cleanup');

    self._cleanup(true);
  });

  try {
    this.xhr.open(method, url$1, true);

    if (this.timeout && 'timeout' in this.xhr) {
      this.xhr.timeout = this.timeout;

      this.xhr.ontimeout = function () {
        debug$7('xhr timeout');
        self.emit('finish', 0, '');

        self._cleanup(false);
      };
    }
  } catch (e) {
    debug$7('exception', e); // IE raises an exception on wrong port.

    this.emit('finish', 0, '');

    this._cleanup(false);

    return;
  }

  if ((!opts || !opts.noCredentials) && AbstractXHRObject.supportsCORS) {
    debug$7('withCredentials'); // Mozilla docs says https://developer.mozilla.org/en/XMLHttpRequest :
    // "This never affects same-site requests."

    this.xhr.withCredentials = true;
  }

  if (opts && opts.headers) {
    for (var key in opts.headers) {
      this.xhr.setRequestHeader(key, opts.headers[key]);
    }
  }

  this.xhr.onreadystatechange = function () {
    if (self.xhr) {
      var x = self.xhr;
      var text, status;
      debug$7('readyState', x.readyState);

      switch (x.readyState) {
        case 3:
          // IE doesn't like peeking into responseText or status
          // on Microsoft.XMLHTTP and readystate=3
          try {
            status = x.status;
            text = x.responseText;
          } catch (e) {// intentionally empty
          }

          debug$7('status', status); // IE returns 1223 for 204: http://bugs.jquery.com/ticket/1450

          if (status === 1223) {
            status = 204;
          } // IE does return readystate == 3 for 404 answers.


          if (status === 200 && text && text.length > 0) {
            debug$7('chunk');
            self.emit('chunk', status, text);
          }

          break;

        case 4:
          status = x.status;
          debug$7('status', status); // IE returns 1223 for 204: http://bugs.jquery.com/ticket/1450

          if (status === 1223) {
            status = 204;
          } // IE returns this for a bad port
          // http://msdn.microsoft.com/en-us/library/windows/desktop/aa383770(v=vs.85).aspx


          if (status === 12005 || status === 12029) {
            status = 0;
          }

          debug$7('finish', status, x.responseText);
          self.emit('finish', status, x.responseText);

          self._cleanup(false);

          break;
      }
    }
  };

  try {
    self.xhr.send(payload);
  } catch (e) {
    self.emit('finish', 0, '');

    self._cleanup(false);
  }
};

AbstractXHRObject.prototype._cleanup = function (abort) {
  debug$7('cleanup');

  if (!this.xhr) {
    return;
  }

  this.removeAllListeners();
  event.unloadDel(this.unloadRef); // IE needs this field to be a function

  this.xhr.onreadystatechange = function () {};

  if (this.xhr.ontimeout) {
    this.xhr.ontimeout = null;
  }

  if (abort) {
    try {
      this.xhr.abort();
    } catch (x) {// intentionally empty
    }
  }

  this.unloadRef = this.xhr = null;
};

AbstractXHRObject.prototype.close = function () {
  debug$7('close');

  this._cleanup(true);
};

AbstractXHRObject.enabled = !!XHR; // override XMLHttpRequest for IE6/7
// obfuscate to avoid firewalls

var axo = ['Active'].concat('Object').join('X');

if (!AbstractXHRObject.enabled && axo in commonjsGlobal) {
  debug$7('overriding xmlhttprequest');

  XHR = function XHR() {
    try {
      return new commonjsGlobal[axo]('Microsoft.XMLHTTP');
    } catch (e) {
      return null;
    }
  };

  AbstractXHRObject.enabled = !!new XHR();
}

var cors = false;

try {
  cors = 'withCredentials' in new XHR();
} catch (ignored) {// intentionally empty
}

AbstractXHRObject.supportsCORS = cors;
var abstractXhr = AbstractXHRObject;

function XHRCorsObject(method, url, payload, opts) {
  abstractXhr.call(this, method, url, payload, opts);
}

inherits_browser(XHRCorsObject, abstractXhr);
XHRCorsObject.enabled = abstractXhr.enabled && abstractXhr.supportsCORS;
var xhrCors = XHRCorsObject;

function XHRLocalObject(method, url, payload
/*, opts */
) {
  abstractXhr.call(this, method, url, payload, {
    noCredentials: true
  });
}

inherits_browser(XHRLocalObject, abstractXhr);
XHRLocalObject.enabled = abstractXhr.enabled;
var xhrLocal = XHRLocalObject;
var browser$2 = {
  isOpera: function isOpera() {
    return commonjsGlobal.navigator && /opera/i.test(commonjsGlobal.navigator.userAgent);
  },
  isKonqueror: function isKonqueror() {
    return commonjsGlobal.navigator && /konqueror/i.test(commonjsGlobal.navigator.userAgent);
  } // #187 wrap document.domain in try/catch because of WP8 from file:///
  ,
  hasDomain: function hasDomain() {
    // non-browser client always has a domain
    if (!commonjsGlobal.document) {
      return true;
    }

    try {
      return !!commonjsGlobal.document.domain;
    } catch (e) {
      return false;
    }
  }
};

function XhrStreamingTransport(transUrl) {
  if (!xhrLocal.enabled && !xhrCors.enabled) {
    throw new Error('Transport created when disabled');
  }

  ajaxBased.call(this, transUrl, '/xhr_streaming', xhr$1, xhrCors);
}

inherits_browser(XhrStreamingTransport, ajaxBased);

XhrStreamingTransport.enabled = function (info) {
  if (info.nullOrigin) {
    return false;
  } // Opera doesn't support xhr-streaming #60
  // But it might be able to #92


  if (browser$2.isOpera()) {
    return false;
  }

  return xhrCors.enabled;
};

XhrStreamingTransport.transportName = 'xhr-streaming';
XhrStreamingTransport.roundTrips = 2; // preflight, ajax
// Safari gets confused when a streaming ajax request is started
// before onload. This causes the load indicator to spin indefinetely.
// Only require body when used in a browser

XhrStreamingTransport.needBody = !!commonjsGlobal.document;
var xhrStreaming = XhrStreamingTransport;
var EventEmitter$6 = emitter.EventEmitter;

var debug$8 = function debug$8() {};

if (process.env.NODE_ENV !== 'production') {
  debug$8 = browser$1('sockjs-client:sender:xdr');
} // References:
//   http://ajaxian.com/archives/100-line-ajax-wrapper
//   http://msdn.microsoft.com/en-us/library/cc288060(v=VS.85).aspx


function XDRObject(method, url, payload) {
  debug$8(method, url);
  var self = this;
  EventEmitter$6.call(this);
  setTimeout(function () {
    self._start(method, url, payload);
  }, 0);
}

inherits_browser(XDRObject, EventEmitter$6);

XDRObject.prototype._start = function (method, url$1, payload) {
  debug$8('_start');
  var self = this;
  var xdr = new commonjsGlobal.XDomainRequest(); // IE caches even POSTs

  url$1 = url.addQuery(url$1, 't=' + +new Date());

  xdr.onerror = function () {
    debug$8('onerror');

    self._error();
  };

  xdr.ontimeout = function () {
    debug$8('ontimeout');

    self._error();
  };

  xdr.onprogress = function () {
    debug$8('progress', xdr.responseText);
    self.emit('chunk', 200, xdr.responseText);
  };

  xdr.onload = function () {
    debug$8('load');
    self.emit('finish', 200, xdr.responseText);

    self._cleanup(false);
  };

  this.xdr = xdr;
  this.unloadRef = event.unloadAdd(function () {
    self._cleanup(true);
  });

  try {
    // Fails with AccessDenied if port number is bogus
    this.xdr.open(method, url$1);

    if (this.timeout) {
      this.xdr.timeout = this.timeout;
    }

    this.xdr.send(payload);
  } catch (x) {
    this._error();
  }
};

XDRObject.prototype._error = function () {
  this.emit('finish', 0, '');

  this._cleanup(false);
};

XDRObject.prototype._cleanup = function (abort) {
  debug$8('cleanup', abort);

  if (!this.xdr) {
    return;
  }

  this.removeAllListeners();
  event.unloadDel(this.unloadRef);
  this.xdr.ontimeout = this.xdr.onerror = this.xdr.onprogress = this.xdr.onload = null;

  if (abort) {
    try {
      this.xdr.abort();
    } catch (x) {// intentionally empty
    }
  }

  this.unloadRef = this.xdr = null;
};

XDRObject.prototype.close = function () {
  debug$8('close');

  this._cleanup(true);
}; // IE 8/9 if the request target uses the same scheme - #79


XDRObject.enabled = !!(commonjsGlobal.XDomainRequest && browser$2.hasDomain());
var xdr = XDRObject; // According to:
//   http://stackoverflow.com/questions/1641507/detect-browser-support-for-cross-domain-xmlhttprequests
//   http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/

function XdrStreamingTransport(transUrl) {
  if (!xdr.enabled) {
    throw new Error('Transport created when disabled');
  }

  ajaxBased.call(this, transUrl, '/xhr_streaming', xhr$1, xdr);
}

inherits_browser(XdrStreamingTransport, ajaxBased);

XdrStreamingTransport.enabled = function (info) {
  if (info.cookie_needed || info.nullOrigin) {
    return false;
  }

  return xdr.enabled && info.sameScheme;
};

XdrStreamingTransport.transportName = 'xdr-streaming';
XdrStreamingTransport.roundTrips = 2; // preflight, ajax

var xdrStreaming = XdrStreamingTransport;
var eventsource = commonjsGlobal.EventSource;
var EventEmitter$7 = emitter.EventEmitter;

var debug$9 = function debug$9() {};

if (process.env.NODE_ENV !== 'production') {
  debug$9 = browser$1('sockjs-client:receiver:eventsource');
}

function EventSourceReceiver(url) {
  debug$9(url);
  EventEmitter$7.call(this);
  var self = this;
  var es = this.es = new eventsource(url);

  es.onmessage = function (e) {
    debug$9('message', e.data);
    self.emit('message', decodeURI(e.data));
  };

  es.onerror = function (e) {
    debug$9('error', es.readyState, e); // ES on reconnection has readyState = 0 or 1.
    // on network error it's CLOSED = 2

    var reason = es.readyState !== 2 ? 'network' : 'permanent';

    self._cleanup();

    self._close(reason);
  };
}

inherits_browser(EventSourceReceiver, EventEmitter$7);

EventSourceReceiver.prototype.abort = function () {
  debug$9('abort');

  this._cleanup();

  this._close('user');
};

EventSourceReceiver.prototype._cleanup = function () {
  debug$9('cleanup');
  var es = this.es;

  if (es) {
    es.onmessage = es.onerror = null;
    es.close();
    this.es = null;
  }
};

EventSourceReceiver.prototype._close = function (reason) {
  debug$9('close', reason);
  var self = this; // Safari and chrome < 15 crash if we close window before
  // waiting for ES cleanup. See:
  // https://code.google.com/p/chromium/issues/detail?id=89155

  setTimeout(function () {
    self.emit('close', null, reason);
    self.removeAllListeners();
  }, 200);
};

var eventsource$1 = EventSourceReceiver;

function EventSourceTransport(transUrl) {
  if (!EventSourceTransport.enabled()) {
    throw new Error('Transport created when disabled');
  }

  ajaxBased.call(this, transUrl, '/eventsource', eventsource$1, xhrCors);
}

inherits_browser(EventSourceTransport, ajaxBased);

EventSourceTransport.enabled = function () {
  return !!eventsource;
};

EventSourceTransport.transportName = 'eventsource';
EventSourceTransport.roundTrips = 2;
var eventsource$2 = EventSourceTransport;
var json3 = createCommonjsModule(function (module, exports) {
  (function () {
    // Detect the `define` function exposed by asynchronous module loaders. The
    // strict `define` check is necessary for compatibility with `r.js`.
    var isLoader = typeof undefined === "function" && undefined.amd; // A set of types used to distinguish objects from primitives.

    var objectTypes = {
      "function": true,
      "object": true
    }; // Detect the `exports` object exposed by CommonJS implementations.

    var freeExports = exports && !exports.nodeType && exports; // Use the `global` object exposed by Node (including Browserify via
    // `insert-module-globals`), Narwhal, and Ringo as the default context,
    // and the `window` object in browsers. Rhino exports a `global` function
    // instead.

    var root = objectTypes[typeof window] && window || this,
        freeGlobal = freeExports && objectTypes['object'] && module && !module.nodeType && typeof commonjsGlobal == "object" && commonjsGlobal;

    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
      root = freeGlobal;
    } // Public: Initializes JSON 3 using the given `context` object, attaching the
    // `stringify` and `parse` functions to the specified `exports` object.


    function runInContext(context, exports) {
      context || (context = root.Object());
      exports || (exports = root.Object()); // Native constructor aliases.

      var Number = context.Number || root.Number,
          String = context.String || root.String,
          Object = context.Object || root.Object,
          Date = context.Date || root.Date,
          SyntaxError = context.SyntaxError || root.SyntaxError,
          TypeError = context.TypeError || root.TypeError,
          Math = context.Math || root.Math,
          nativeJSON = context.JSON || root.JSON; // Delegate to the native `stringify` and `parse` implementations.

      if (typeof nativeJSON == "object" && nativeJSON) {
        exports.stringify = nativeJSON.stringify;
        exports.parse = nativeJSON.parse;
      } // Convenience aliases.


      var objectProto = Object.prototype,
          getClass = objectProto.toString,
          isProperty = objectProto.hasOwnProperty,
          undefined$1; // Internal: Contains `try...catch` logic used by other functions.
      // This prevents other functions from being deoptimized.

      function attempt(func, errorFunc) {
        try {
          func();
        } catch (exception) {
          if (errorFunc) {
            errorFunc();
          }
        }
      } // Test the `Date#getUTC*` methods. Based on work by @Yaffle.


      var isExtended = new Date(-3509827334573292);
      attempt(function () {
        // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
        // results for certain dates in Opera >= 10.53.
        isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 && isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
      }); // Internal: Determines whether the native `JSON.stringify` and `parse`
      // implementations are spec-compliant. Based on work by Ken Snyder.

      function has(name) {
        if (has[name] != null) {
          // Return cached feature test result.
          return has[name];
        }

        var isSupported;

        if (name == "bug-string-char-index") {
          // IE <= 7 doesn't support accessing string characters using square
          // bracket notation. IE 8 only supports this for primitives.
          isSupported = "a"[0] != "a";
        } else if (name == "json") {
          // Indicates whether both `JSON.stringify` and `JSON.parse` are
          // supported.
          isSupported = has("json-stringify") && has("date-serialization") && has("json-parse");
        } else if (name == "date-serialization") {
          // Indicates whether `Date`s can be serialized accurately by `JSON.stringify`.
          isSupported = has("json-stringify") && isExtended;

          if (isSupported) {
            var stringify = exports.stringify;
            attempt(function () {
              isSupported = // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
              // serialize extended years.
              stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' && // The milliseconds are optional in ES 5, but required in 5.1.
              stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' && // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
              // four-digit years instead of six-digit years. Credits: @Yaffle.
              stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' && // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
              // values less than 1000. Credits: @Yaffle.
              stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
            });
          }
        } else {
          var value,
              serialized = "{\"a\":[1,true,false,null,\"\\u0000\\b\\n\\f\\r\\t\"]}"; // Test `JSON.stringify`.

          if (name == "json-stringify") {
            var stringify = exports.stringify,
                stringifySupported = typeof stringify == "function";

            if (stringifySupported) {
              // A test function object with a custom `toJSON` method.
              (value = function value() {
                return 1;
              }).toJSON = value;
              attempt(function () {
                stringifySupported = // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" && // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" && stringify(new String()) == '""' && // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undefined$1 && // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undefined$1) === undefined$1 && // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undefined$1 && // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" && stringify([value]) == "[1]" && // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undefined$1]) == "[null]" && // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" && // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undefined$1, getClass, null]) == "[null,null,null]" && // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({
                  "a": [value, true, false, null, "\x00\b\n\f\r\t"]
                }) == serialized && // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" && stringify([1, 2], null, 1) == "[\n 1,\n 2\n]";
              }, function () {
                stringifySupported = false;
              });
            }

            isSupported = stringifySupported;
          } // Test `JSON.parse`.


          if (name == "json-parse") {
            var parse = exports.parse,
                parseSupported;

            if (typeof parse == "function") {
              attempt(function () {
                // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
                // Conforming implementations should also coerce the initial argument to
                // a string prior to parsing.
                if (parse("0") === 0 && !parse(false)) {
                  // Simple parsing test.
                  value = parse(serialized);
                  parseSupported = value["a"].length == 5 && value["a"][0] === 1;

                  if (parseSupported) {
                    attempt(function () {
                      // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                      parseSupported = !parse('"\t"');
                    });

                    if (parseSupported) {
                      attempt(function () {
                        // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                        // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                        // certain octal literals.
                        parseSupported = parse("01") !== 1;
                      });
                    }

                    if (parseSupported) {
                      attempt(function () {
                        // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                        // points. These environments, along with FF 3.1b1 and 2,
                        // also allow trailing commas in JSON objects and arrays.
                        parseSupported = parse("1.") !== 1;
                      });
                    }
                  }
                }
              }, function () {
                parseSupported = false;
              });
            }

            isSupported = parseSupported;
          }
        }

        return has[name] = !!isSupported;
      }

      has["bug-string-char-index"] = has["date-serialization"] = has["json"] = has["json-stringify"] = has["json-parse"] = null;

      if (!has("json")) {
        // Common `[[Class]]` name aliases.
        var functionClass = "[object Function]",
            dateClass = "[object Date]",
            numberClass = "[object Number]",
            stringClass = "[object String]",
            arrayClass = "[object Array]",
            booleanClass = "[object Boolean]"; // Detect incomplete support for accessing string characters by index.

        var charIndexBuggy = has("bug-string-char-index"); // Internal: Normalizes the `for...in` iteration algorithm across
        // environments. Each enumerated key is yielded to a `callback` function.

        var _forOwn = function forOwn(object, callback) {
          var size = 0,
              Properties,
              dontEnums,
              property; // Tests for bugs in the current environment's `for...in` algorithm. The
          // `valueOf` property inherits the non-enumerable flag from
          // `Object.prototype` in older versions of IE, Netscape, and Mozilla.

          (Properties = function Properties() {
            this.valueOf = 0;
          }).prototype.valueOf = 0; // Iterate over a new instance of the `Properties` class.

          dontEnums = new Properties();

          for (property in dontEnums) {
            // Ignore all properties inherited from `Object.prototype`.
            if (isProperty.call(dontEnums, property)) {
              size++;
            }
          }

          Properties = dontEnums = null; // Normalize the iteration algorithm.

          if (!size) {
            // A list of non-enumerable properties inherited from `Object.prototype`.
            dontEnums = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"]; // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
            // properties.

            _forOwn = function forOwn(object, callback) {
              var isFunction = getClass.call(object) == functionClass,
                  property,
                  length;
              var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;

              for (property in object) {
                // Gecko <= 1.0 enumerates the `prototype` property of functions under
                // certain conditions; IE does not.
                if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                  callback(property);
                }
              } // Manually invoke the callback for each non-enumerable property.


              for (length = dontEnums.length; property = dontEnums[--length];) {
                if (hasProperty.call(object, property)) {
                  callback(property);
                }
              }
            };
          } else {
            // No bugs detected; use the standard `for...in` algorithm.
            _forOwn = function forOwn(object, callback) {
              var isFunction = getClass.call(object) == functionClass,
                  property,
                  isConstructor;

              for (property in object) {
                if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                  callback(property);
                }
              } // Manually invoke the callback for the `constructor` property due to
              // cross-environment inconsistencies.


              if (isConstructor || isProperty.call(object, property = "constructor")) {
                callback(property);
              }
            };
          }

          return _forOwn(object, callback);
        }; // Public: Serializes a JavaScript `value` as a JSON string. The optional
        // `filter` argument may specify either a function that alters how object and
        // array members are serialized, or an array of strings and numbers that
        // indicates which properties should be serialized. The optional `width`
        // argument may be either a string or number that specifies the indentation
        // level of the output.


        if (!has("json-stringify") && !has("date-serialization")) {
          // Internal: A map of control characters and their escaped equivalents.
          var Escapes = {
            92: "\\\\",
            34: '\\"',
            8: "\\b",
            12: "\\f",
            10: "\\n",
            13: "\\r",
            9: "\\t"
          }; // Internal: Converts `value` into a zero-padded string such that its
          // length is at least equal to `width`. The `width` must be <= 6.

          var leadingZeroes = "000000";

          var toPaddedString = function toPaddedString(width, value) {
            // The `|| 0` expression is necessary to work around a bug in
            // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
            return (leadingZeroes + (value || 0)).slice(-width);
          }; // Internal: Serializes a date object.


          var _serializeDate = function serializeDate(value) {
            var getData, year, month, date, time, hours, minutes, seconds, milliseconds; // Define additional utility methods if the `Date` methods are buggy.

            if (!isExtended) {
              var floor = Math.floor; // A mapping between the months of the year and the number of days between
              // January 1st and the first of the respective month.

              var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334]; // Internal: Calculates the number of days between the Unix epoch and the
              // first day of the given month.

              var getDay = function getDay(year, month) {
                return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
              };

              getData = function getData(value) {
                // Manually compute the year, month, date, hours, minutes,
                // seconds, and milliseconds if the `getUTC*` methods are
                // buggy. Adapted from @Yaffle's `date-shim` project.
                date = floor(value / 864e5);

                for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++) {
                  ;
                }

                for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++) {
                  ;
                }

                date = 1 + date - getDay(year, month); // The `time` value specifies the time within the day (see ES
                // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
                // to compute `A modulo B`, as the `%` operator does not
                // correspond to the `modulo` operation for negative numbers.

                time = (value % 864e5 + 864e5) % 864e5; // The hours, minutes, seconds, and milliseconds are obtained by
                // decomposing the time within the day. See section 15.9.1.10.

                hours = floor(time / 36e5) % 24;
                minutes = floor(time / 6e4) % 60;
                seconds = floor(time / 1e3) % 60;
                milliseconds = time % 1e3;
              };
            } else {
              getData = function getData(value) {
                year = value.getUTCFullYear();
                month = value.getUTCMonth();
                date = value.getUTCDate();
                hours = value.getUTCHours();
                minutes = value.getUTCMinutes();
                seconds = value.getUTCSeconds();
                milliseconds = value.getUTCMilliseconds();
              };
            }

            _serializeDate = function serializeDate(value) {
              if (value > -1 / 0 && value < 1 / 0) {
                // Dates are serialized according to the `Date#toJSON` method
                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
                // for the ISO 8601 date time string format.
                getData(value); // Serialize extended years correctly.

                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) + "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) + // Months, dates, hours, minutes, and seconds should have two
                // digits; milliseconds should have three.
                "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) + // Milliseconds are optional in ES 5.0, but required in 5.1.
                "." + toPaddedString(3, milliseconds) + "Z";
                year = month = date = hours = minutes = seconds = milliseconds = null;
              } else {
                value = null;
              }

              return value;
            };

            return _serializeDate(value);
          }; // For environments with `JSON.stringify` but buggy date serialization,
          // we override the native `Date#toJSON` implementation with a
          // spec-compliant one.


          if (has("json-stringify") && !has("date-serialization")) {
            // Internal: the `Date#toJSON` implementation used to override the native one.
            var dateToJSON = function dateToJSON(key) {
              return _serializeDate(this);
            }; // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.


            var nativeStringify = exports.stringify;

            exports.stringify = function (source, filter, width) {
              var nativeToJSON = Date.prototype.toJSON;
              Date.prototype.toJSON = dateToJSON;
              var result = nativeStringify(source, filter, width);
              Date.prototype.toJSON = nativeToJSON;
              return result;
            };
          } else {
            // Internal: Double-quotes a string `value`, replacing all ASCII control
            // characters (characters with code unit values between 0 and 31) with
            // their escaped equivalents. This is an implementation of the
            // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
            var unicodePrefix = "\\u00";

            var escapeChar = function escapeChar(character) {
              var charCode = character.charCodeAt(0),
                  escaped = Escapes[charCode];

              if (escaped) {
                return escaped;
              }

              return unicodePrefix + toPaddedString(2, charCode.toString(16));
            };

            var reEscape = /[\x00-\x1f\x22\x5c]/g;

            var quote = function quote(value) {
              reEscape.lastIndex = 0;
              return '"' + (reEscape.test(value) ? value.replace(reEscape, escapeChar) : value) + '"';
            }; // Internal: Recursively serializes an object. Implements the
            // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.


            var serialize = function serialize(property, object, callback, properties, whitespace, indentation, stack) {
              var value, type, className, results, element, index, length, prefix, result;
              attempt(function () {
                // Necessary for host object support.
                value = object[property];
              });

              if (typeof value == "object" && value) {
                if (value.getUTCFullYear && getClass.call(value) == dateClass && value.toJSON === Date.prototype.toJSON) {
                  value = _serializeDate(value);
                } else if (typeof value.toJSON == "function") {
                  value = value.toJSON(property);
                }
              }

              if (callback) {
                // If a replacement function was provided, call it to obtain the value
                // for serialization.
                value = callback.call(object, property, value);
              } // Exit early if value is `undefined` or `null`.


              if (value == undefined$1) {
                return value === undefined$1 ? value : "null";
              }

              type = typeof value; // Only call `getClass` if the value is an object.

              if (type == "object") {
                className = getClass.call(value);
              }

              switch (className || type) {
                case "boolean":
                case booleanClass:
                  // Booleans are represented literally.
                  return "" + value;

                case "number":
                case numberClass:
                  // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
                  // `"null"`.
                  return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";

                case "string":
                case stringClass:
                  // Strings are double-quoted and escaped.
                  return quote("" + value);
              } // Recursively serialize objects and arrays.


              if (typeof value == "object") {
                // Check for cyclic structures. This is a linear search; performance
                // is inversely proportional to the number of unique nested objects.
                for (length = stack.length; length--;) {
                  if (stack[length] === value) {
                    // Cyclic structures cannot be serialized by `JSON.stringify`.
                    throw TypeError();
                  }
                } // Add the object to the stack of traversed objects.


                stack.push(value);
                results = []; // Save the current indentation level and indent one additional level.

                prefix = indentation;
                indentation += whitespace;

                if (className == arrayClass) {
                  // Recursively serialize array elements.
                  for (index = 0, length = value.length; index < length; index++) {
                    element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                    results.push(element === undefined$1 ? "null" : element);
                  }

                  result = results.length ? whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : "[" + results.join(",") + "]" : "[]";
                } else {
                  // Recursively serialize object members. Members are selected from
                  // either a user-specified list of property names, or the object
                  // itself.
                  _forOwn(properties || value, function (property) {
                    var element = serialize(property, value, callback, properties, whitespace, indentation, stack);

                    if (element !== undefined$1) {
                      // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                      // is not the empty string, let `member` {quote(property) + ":"}
                      // be the concatenation of `member` and the `space` character."
                      // The "`space` character" refers to the literal space
                      // character, not the `space` {width} argument provided to
                      // `JSON.stringify`.
                      results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                    }
                  });

                  result = results.length ? whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : "{" + results.join(",") + "}" : "{}";
                } // Remove the object from the traversed object stack.


                stack.pop();
                return result;
              }
            }; // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.


            exports.stringify = function (source, filter, width) {
              var whitespace, callback, properties, className;

              if (objectTypes[typeof filter] && filter) {
                className = getClass.call(filter);

                if (className == functionClass) {
                  callback = filter;
                } else if (className == arrayClass) {
                  // Convert the property names array into a makeshift set.
                  properties = {};

                  for (var index = 0, length = filter.length, value; index < length;) {
                    value = filter[index++];
                    className = getClass.call(value);

                    if (className == "[object String]" || className == "[object Number]") {
                      properties[value] = 1;
                    }
                  }
                }
              }

              if (width) {
                className = getClass.call(width);

                if (className == numberClass) {
                  // Convert the `width` to an integer and create a string containing
                  // `width` number of space characters.
                  if ((width -= width % 1) > 0) {
                    if (width > 10) {
                      width = 10;
                    }

                    for (whitespace = ""; whitespace.length < width;) {
                      whitespace += " ";
                    }
                  }
                } else if (className == stringClass) {
                  whitespace = width.length <= 10 ? width : width.slice(0, 10);
                }
              } // Opera <= 7.54u2 discards the values associated with empty string keys
              // (`""`) only if they are used directly within an object member list
              // (e.g., `!("" in { "": 1})`).


              return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
            };
          }
        } // Public: Parses a JSON source string.


        if (!has("json-parse")) {
          var fromCharCode = String.fromCharCode; // Internal: A map of escaped control characters and their unescaped
          // equivalents.

          var Unescapes = {
            92: "\\",
            34: '"',
            47: "/",
            98: "\b",
            116: "\t",
            110: "\n",
            102: "\f",
            114: "\r"
          }; // Internal: Stores the parser state.

          var Index, Source; // Internal: Resets the parser state and throws a `SyntaxError`.

          var abort = function abort() {
            Index = Source = null;
            throw SyntaxError();
          }; // Internal: Returns the next token, or `"$"` if the parser has reached
          // the end of the source string. A token may be a string, number, `null`
          // literal, or Boolean literal.


          var lex = function lex() {
            var source = Source,
                length = source.length,
                value,
                begin,
                position,
                isSigned,
                charCode;

            while (Index < length) {
              charCode = source.charCodeAt(Index);

              switch (charCode) {
                case 9:
                case 10:
                case 13:
                case 32:
                  // Skip whitespace tokens, including tabs, carriage returns, line
                  // feeds, and space characters.
                  Index++;
                  break;

                case 123:
                case 125:
                case 91:
                case 93:
                case 58:
                case 44:
                  // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                  // the current position.
                  value = charIndexBuggy ? source.charAt(Index) : source[Index];
                  Index++;
                  return value;

                case 34:
                  // `"` delimits a JSON string; advance to the next character and
                  // begin parsing the string. String tokens are prefixed with the
                  // sentinel `@` character to distinguish them from punctuators and
                  // end-of-string tokens.
                  for (value = "@", Index++; Index < length;) {
                    charCode = source.charCodeAt(Index);

                    if (charCode < 32) {
                      // Unescaped ASCII control characters (those with a code unit
                      // less than the space character) are not permitted.
                      abort();
                    } else if (charCode == 92) {
                      // A reverse solidus (`\`) marks the beginning of an escaped
                      // control character (including `"`, `\`, and `/`) or Unicode
                      // escape sequence.
                      charCode = source.charCodeAt(++Index);

                      switch (charCode) {
                        case 92:
                        case 34:
                        case 47:
                        case 98:
                        case 116:
                        case 110:
                        case 102:
                        case 114:
                          // Revive escaped control characters.
                          value += Unescapes[charCode];
                          Index++;
                          break;

                        case 117:
                          // `\u` marks the beginning of a Unicode escape sequence.
                          // Advance to the first character and validate the
                          // four-digit code point.
                          begin = ++Index;

                          for (position = Index + 4; Index < position; Index++) {
                            charCode = source.charCodeAt(Index); // A valid sequence comprises four hexdigits (case-
                            // insensitive) that form a single hexadecimal value.

                            if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                              // Invalid Unicode escape sequence.
                              abort();
                            }
                          } // Revive the escaped character.


                          value += fromCharCode("0x" + source.slice(begin, Index));
                          break;

                        default:
                          // Invalid escape sequence.
                          abort();
                      }
                    } else {
                      if (charCode == 34) {
                        // An unescaped double-quote character marks the end of the
                        // string.
                        break;
                      }

                      charCode = source.charCodeAt(Index);
                      begin = Index; // Optimize for the common case where a string is valid.

                      while (charCode >= 32 && charCode != 92 && charCode != 34) {
                        charCode = source.charCodeAt(++Index);
                      } // Append the string as-is.


                      value += source.slice(begin, Index);
                    }
                  }

                  if (source.charCodeAt(Index) == 34) {
                    // Advance to the next character and return the revived string.
                    Index++;
                    return value;
                  } // Unterminated string.


                  abort();

                default:
                  // Parse numbers and literals.
                  begin = Index; // Advance past the negative sign, if one is specified.

                  if (charCode == 45) {
                    isSigned = true;
                    charCode = source.charCodeAt(++Index);
                  } // Parse an integer or floating-point value.


                  if (charCode >= 48 && charCode <= 57) {
                    // Leading zeroes are interpreted as octal literals.
                    if (charCode == 48 && (charCode = source.charCodeAt(Index + 1), charCode >= 48 && charCode <= 57)) {
                      // Illegal octal literal.
                      abort();
                    }

                    isSigned = false; // Parse the integer component.

                    for (; Index < length && (charCode = source.charCodeAt(Index), charCode >= 48 && charCode <= 57); Index++) {
                      ;
                    } // Floats cannot contain a leading decimal point; however, this
                    // case is already accounted for by the parser.


                    if (source.charCodeAt(Index) == 46) {
                      position = ++Index; // Parse the decimal component.

                      for (; position < length; position++) {
                        charCode = source.charCodeAt(position);

                        if (charCode < 48 || charCode > 57) {
                          break;
                        }
                      }

                      if (position == Index) {
                        // Illegal trailing decimal.
                        abort();
                      }

                      Index = position;
                    } // Parse exponents. The `e` denoting the exponent is
                    // case-insensitive.


                    charCode = source.charCodeAt(Index);

                    if (charCode == 101 || charCode == 69) {
                      charCode = source.charCodeAt(++Index); // Skip past the sign following the exponent, if one is
                      // specified.

                      if (charCode == 43 || charCode == 45) {
                        Index++;
                      } // Parse the exponential component.


                      for (position = Index; position < length; position++) {
                        charCode = source.charCodeAt(position);

                        if (charCode < 48 || charCode > 57) {
                          break;
                        }
                      }

                      if (position == Index) {
                        // Illegal empty exponent.
                        abort();
                      }

                      Index = position;
                    } // Coerce the parsed value to a JavaScript number.


                    return +source.slice(begin, Index);
                  } // A negative sign may only precede numbers.


                  if (isSigned) {
                    abort();
                  } // `true`, `false`, and `null` literals.


                  var temp = source.slice(Index, Index + 4);

                  if (temp == "true") {
                    Index += 4;
                    return true;
                  } else if (temp == "fals" && source.charCodeAt(Index + 4) == 101) {
                    Index += 5;
                    return false;
                  } else if (temp == "null") {
                    Index += 4;
                    return null;
                  } // Unrecognized token.


                  abort();
              }
            } // Return the sentinel `$` character if the parser has reached the end
            // of the source string.


            return "$";
          }; // Internal: Parses a JSON `value` token.


          var get = function get(value) {
            var results, hasMembers;

            if (value == "$") {
              // Unexpected end of input.
              abort();
            }

            if (typeof value == "string") {
              if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
                // Remove the sentinel `@` character.
                return value.slice(1);
              } // Parse object and array literals.


              if (value == "[") {
                // Parses a JSON array, returning a new JavaScript array.
                results = [];

                for (;;) {
                  value = lex(); // A closing square bracket marks the end of the array literal.

                  if (value == "]") {
                    break;
                  } // If the array literal contains elements, the current token
                  // should be a comma separating the previous element from the
                  // next.


                  if (hasMembers) {
                    if (value == ",") {
                      value = lex();

                      if (value == "]") {
                        // Unexpected trailing `,` in array literal.
                        abort();
                      }
                    } else {
                      // A `,` must separate each array element.
                      abort();
                    }
                  } else {
                    hasMembers = true;
                  } // Elisions and leading commas are not permitted.


                  if (value == ",") {
                    abort();
                  }

                  results.push(get(value));
                }

                return results;
              } else if (value == "{") {
                // Parses a JSON object, returning a new JavaScript object.
                results = {};

                for (;;) {
                  value = lex(); // A closing curly brace marks the end of the object literal.

                  if (value == "}") {
                    break;
                  } // If the object literal contains members, the current token
                  // should be a comma separator.


                  if (hasMembers) {
                    if (value == ",") {
                      value = lex();

                      if (value == "}") {
                        // Unexpected trailing `,` in object literal.
                        abort();
                      }
                    } else {
                      // A `,` must separate each object member.
                      abort();
                    }
                  } else {
                    hasMembers = true;
                  } // Leading commas are not permitted, object property names must be
                  // double-quoted strings, and a `:` must separate each property
                  // name and value.


                  if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                    abort();
                  }

                  results[value.slice(1)] = get(lex());
                }

                return results;
              } // Unexpected token encountered.


              abort();
            }

            return value;
          }; // Internal: Updates a traversed object member.


          var update = function update(source, property, callback) {
            var element = walk(source, property, callback);

            if (element === undefined$1) {
              delete source[property];
            } else {
              source[property] = element;
            }
          }; // Internal: Recursively traverses a parsed JSON object, invoking the
          // `callback` function for each value. This is an implementation of the
          // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.


          var walk = function walk(source, property, callback) {
            var value = source[property],
                length;

            if (typeof value == "object" && value) {
              // `forOwn` can't be used to traverse an array in Opera <= 8.54
              // because its `Object#hasOwnProperty` implementation returns `false`
              // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
              if (getClass.call(value) == arrayClass) {
                for (length = value.length; length--;) {
                  update(getClass, _forOwn, value, length, callback);
                }
              } else {
                _forOwn(value, function (property) {
                  update(value, property, callback);
                });
              }
            }

            return callback.call(source, property, value);
          }; // Public: `JSON.parse`. See ES 5.1 section 15.12.2.


          exports.parse = function (source, callback) {
            var result, value;
            Index = 0;
            Source = "" + source;
            result = get(lex()); // If a JSON string contains multiple tokens, it is invalid.

            if (lex() != "$") {
              abort();
            } // Reset the parser state.


            Index = Source = null;
            return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
          };
        }
      }

      exports.runInContext = runInContext;
      return exports;
    }

    if (freeExports && !isLoader) {
      // Export for CommonJS environments.
      runInContext(root, freeExports);
    } else {
      // Export for web browsers and JavaScript engines.
      var nativeJSON = root.JSON,
          previousJSON = root.JSON3,
          isRestored = false;
      var JSON3 = runInContext(root, root.JSON3 = {
        // Public: Restores the original value of the global `JSON` object and
        // returns a reference to the `JSON3` object.
        "noConflict": function noConflict() {
          if (!isRestored) {
            isRestored = true;
            root.JSON = nativeJSON;
            root.JSON3 = previousJSON;
            nativeJSON = previousJSON = null;
          }

          return JSON3;
        }
      });
      root.JSON = {
        "parse": JSON3.parse,
        "stringify": JSON3.stringify
      };
    }
  }).call(commonjsGlobal);
});
var version = '1.4.0';
var iframe = createCommonjsModule(function (module) {
  var debug = function debug() {};

  if (process.env.NODE_ENV !== 'production') {
    debug = browser$1('sockjs-client:utils:iframe');
  }

  module.exports = {
    WPrefix: '_jp',
    currentWindowId: null,
    polluteGlobalNamespace: function polluteGlobalNamespace() {
      if (!(module.exports.WPrefix in commonjsGlobal)) {
        commonjsGlobal[module.exports.WPrefix] = {};
      }
    },
    postMessage: function postMessage(type, data) {
      if (commonjsGlobal.parent !== commonjsGlobal) {
        commonjsGlobal.parent.postMessage(json3.stringify({
          windowId: module.exports.currentWindowId,
          type: type,
          data: data || ''
        }), '*');
      } else {
        debug('Cannot postMessage, no parent window.', type, data);
      }
    },
    createIframe: function createIframe(iframeUrl, errorCallback) {
      var iframe = commonjsGlobal.document.createElement('iframe');
      var tref, unloadRef;

      var unattach = function unattach() {
        debug('unattach');
        clearTimeout(tref); // Explorer had problems with that.

        try {
          iframe.onload = null;
        } catch (x) {// intentionally empty
        }

        iframe.onerror = null;
      };

      var cleanup = function cleanup() {
        debug('cleanup');

        if (iframe) {
          unattach(); // This timeout makes chrome fire onbeforeunload event
          // within iframe. Without the timeout it goes straight to
          // onunload.

          setTimeout(function () {
            if (iframe) {
              iframe.parentNode.removeChild(iframe);
            }

            iframe = null;
          }, 0);
          event.unloadDel(unloadRef);
        }
      };

      var onerror = function onerror(err) {
        debug('onerror', err);

        if (iframe) {
          cleanup();
          errorCallback(err);
        }
      };

      var post = function post(msg, origin) {
        debug('post', msg, origin);
        setTimeout(function () {
          try {
            // When the iframe is not loaded, IE raises an exception
            // on 'contentWindow'.
            if (iframe && iframe.contentWindow) {
              iframe.contentWindow.postMessage(msg, origin);
            }
          } catch (x) {// intentionally empty
          }
        }, 0);
      };

      iframe.src = iframeUrl;
      iframe.style.display = 'none';
      iframe.style.position = 'absolute';

      iframe.onerror = function () {
        onerror('onerror');
      };

      iframe.onload = function () {
        debug('onload'); // `onload` is triggered before scripts on the iframe are
        // executed. Give it few seconds to actually load stuff.

        clearTimeout(tref);
        tref = setTimeout(function () {
          onerror('onload timeout');
        }, 2000);
      };

      commonjsGlobal.document.body.appendChild(iframe);
      tref = setTimeout(function () {
        onerror('timeout');
      }, 15000);
      unloadRef = event.unloadAdd(cleanup);
      return {
        post: post,
        cleanup: cleanup,
        loaded: unattach
      };
    }
    /* eslint no-undef: "off", new-cap: "off" */
    ,
    createHtmlfile: function createHtmlfile(iframeUrl, errorCallback) {
      var axo = ['Active'].concat('Object').join('X');
      var doc = new commonjsGlobal[axo]('htmlfile');
      var tref, unloadRef;
      var iframe;

      var unattach = function unattach() {
        clearTimeout(tref);
        iframe.onerror = null;
      };

      var cleanup = function cleanup() {
        if (doc) {
          unattach();
          event.unloadDel(unloadRef);
          iframe.parentNode.removeChild(iframe);
          iframe = doc = null;
          CollectGarbage();
        }
      };

      var onerror = function onerror(r) {
        debug('onerror', r);

        if (doc) {
          cleanup();
          errorCallback(r);
        }
      };

      var post = function post(msg, origin) {
        try {
          // When the iframe is not loaded, IE raises an exception
          // on 'contentWindow'.
          setTimeout(function () {
            if (iframe && iframe.contentWindow) {
              iframe.contentWindow.postMessage(msg, origin);
            }
          }, 0);
        } catch (x) {// intentionally empty
        }
      };

      doc.open();
      doc.write('<html><s' + 'cript>' + 'document.domain="' + commonjsGlobal.document.domain + '";' + '</s' + 'cript></html>');
      doc.close();
      doc.parentWindow[module.exports.WPrefix] = commonjsGlobal[module.exports.WPrefix];
      var c = doc.createElement('div');
      doc.body.appendChild(c);
      iframe = doc.createElement('iframe');
      c.appendChild(iframe);
      iframe.src = iframeUrl;

      iframe.onerror = function () {
        onerror('onerror');
      };

      tref = setTimeout(function () {
        onerror('timeout');
      }, 15000);
      unloadRef = event.unloadAdd(cleanup);
      return {
        post: post,
        cleanup: cleanup,
        loaded: unattach
      };
    }
  };
  module.exports.iframeEnabled = false;

  if (commonjsGlobal.document) {
    // postMessage misbehaves in konqueror 4.6.5 - the messages are delivered with
    // huge delay, or not at all.
    module.exports.iframeEnabled = (typeof commonjsGlobal.postMessage === 'function' || typeof commonjsGlobal.postMessage === 'object') && !browser$2.isKonqueror();
  }
});
var iframe_1 = iframe.WPrefix;
var iframe_2 = iframe.currentWindowId;
var iframe_3 = iframe.polluteGlobalNamespace;
var iframe_4 = iframe.postMessage;
var iframe_5 = iframe.createIframe;
var iframe_6 = iframe.createHtmlfile;
var iframe_7 = iframe.iframeEnabled; // Few cool transports do work only for same-origin. In order to make
// them work cross-domain we shall use iframe, served from the
// remote domain. New browsers have capabilities to communicate with
// cross domain iframe using postMessage(). In IE it was implemented
// from IE 8+, but of course, IE got some details wrong:
//    http://msdn.microsoft.com/en-us/library/cc197015(v=VS.85).aspx
//    http://stevesouders.com/misc/test-postmessage.php

var EventEmitter$8 = emitter.EventEmitter;

var debug$a = function debug$a() {};

if (process.env.NODE_ENV !== 'production') {
  debug$a = browser$1('sockjs-client:transport:iframe');
}

function IframeTransport(transport, transUrl, baseUrl) {
  if (!IframeTransport.enabled()) {
    throw new Error('Transport created when disabled');
  }

  EventEmitter$8.call(this);
  var self = this;
  this.origin = url.getOrigin(baseUrl);
  this.baseUrl = baseUrl;
  this.transUrl = transUrl;
  this.transport = transport;
  this.windowId = random.string(8);
  var iframeUrl = url.addPath(baseUrl, '/iframe.html') + '#' + this.windowId;
  debug$a(transport, transUrl, iframeUrl);
  this.iframeObj = iframe.createIframe(iframeUrl, function (r) {
    debug$a('err callback');
    self.emit('close', 1006, 'Unable to load an iframe (' + r + ')');
    self.close();
  });
  this.onmessageCallback = this._message.bind(this);
  event.attachEvent('message', this.onmessageCallback);
}

inherits_browser(IframeTransport, EventEmitter$8);

IframeTransport.prototype.close = function () {
  debug$a('close');
  this.removeAllListeners();

  if (this.iframeObj) {
    event.detachEvent('message', this.onmessageCallback);

    try {
      // When the iframe is not loaded, IE raises an exception
      // on 'contentWindow'.
      this.postMessage('c');
    } catch (x) {// intentionally empty
    }

    this.iframeObj.cleanup();
    this.iframeObj = null;
    this.onmessageCallback = this.iframeObj = null;
  }
};

IframeTransport.prototype._message = function (e) {
  debug$a('message', e.data);

  if (!url.isOriginEqual(e.origin, this.origin)) {
    debug$a('not same origin', e.origin, this.origin);
    return;
  }

  var iframeMessage;

  try {
    iframeMessage = json3.parse(e.data);
  } catch (ignored) {
    debug$a('bad json', e.data);
    return;
  }

  if (iframeMessage.windowId !== this.windowId) {
    debug$a('mismatched window id', iframeMessage.windowId, this.windowId);
    return;
  }

  switch (iframeMessage.type) {
    case 's':
      this.iframeObj.loaded(); // window global dependency

      this.postMessage('s', json3.stringify([version, this.transport, this.transUrl, this.baseUrl]));
      break;

    case 't':
      this.emit('message', iframeMessage.data);
      break;

    case 'c':
      var cdata;

      try {
        cdata = json3.parse(iframeMessage.data);
      } catch (ignored) {
        debug$a('bad json', iframeMessage.data);
        return;
      }

      this.emit('close', cdata[0], cdata[1]);
      this.close();
      break;
  }
};

IframeTransport.prototype.postMessage = function (type, data) {
  debug$a('postMessage', type, data);
  this.iframeObj.post(json3.stringify({
    windowId: this.windowId,
    type: type,
    data: data || ''
  }), this.origin);
};

IframeTransport.prototype.send = function (message) {
  debug$a('send', message);
  this.postMessage('m', message);
};

IframeTransport.enabled = function () {
  return iframe.iframeEnabled;
};

IframeTransport.transportName = 'iframe';
IframeTransport.roundTrips = 2;
var iframe$1 = IframeTransport;
var object = {
  isObject: function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  },
  extend: function extend(obj) {
    if (!this.isObject(obj)) {
      return obj;
    }

    var source, prop;

    for (var i = 1, length = arguments.length; i < length; i++) {
      source = arguments[i];

      for (prop in source) {
        if (Object.prototype.hasOwnProperty.call(source, prop)) {
          obj[prop] = source[prop];
        }
      }
    }

    return obj;
  }
};

var iframeWrap = function iframeWrap(transport) {
  function IframeWrapTransport(transUrl, baseUrl) {
    iframe$1.call(this, transport.transportName, transUrl, baseUrl);
  }

  inherits_browser(IframeWrapTransport, iframe$1);

  IframeWrapTransport.enabled = function (url, info) {
    if (!commonjsGlobal.document) {
      return false;
    }

    var iframeInfo = object.extend({}, info);
    iframeInfo.sameOrigin = true;
    return transport.enabled(iframeInfo) && iframe$1.enabled();
  };

  IframeWrapTransport.transportName = 'iframe-' + transport.transportName;
  IframeWrapTransport.needBody = true;
  IframeWrapTransport.roundTrips = iframe$1.roundTrips + transport.roundTrips - 1; // html, javascript (2) + transport - no CORS (1)

  IframeWrapTransport.facadeTransport = transport;
  return IframeWrapTransport;
};

var EventEmitter$9 = emitter.EventEmitter;

var debug$b = function debug$b() {};

if (process.env.NODE_ENV !== 'production') {
  debug$b = browser$1('sockjs-client:receiver:htmlfile');
}

function HtmlfileReceiver(url$1) {
  debug$b(url$1);
  EventEmitter$9.call(this);
  var self = this;
  iframe.polluteGlobalNamespace();
  this.id = 'a' + random.string(6);
  url$1 = url.addQuery(url$1, 'c=' + decodeURIComponent(iframe.WPrefix + '.' + this.id));
  debug$b('using htmlfile', HtmlfileReceiver.htmlfileEnabled);
  var constructFunc = HtmlfileReceiver.htmlfileEnabled ? iframe.createHtmlfile : iframe.createIframe;
  commonjsGlobal[iframe.WPrefix][this.id] = {
    start: function start() {
      debug$b('start');
      self.iframeObj.loaded();
    },
    message: function message(data) {
      debug$b('message', data);
      self.emit('message', data);
    },
    stop: function stop() {
      debug$b('stop');

      self._cleanup();

      self._close('network');
    }
  };
  this.iframeObj = constructFunc(url$1, function () {
    debug$b('callback');

    self._cleanup();

    self._close('permanent');
  });
}

inherits_browser(HtmlfileReceiver, EventEmitter$9);

HtmlfileReceiver.prototype.abort = function () {
  debug$b('abort');

  this._cleanup();

  this._close('user');
};

HtmlfileReceiver.prototype._cleanup = function () {
  debug$b('_cleanup');

  if (this.iframeObj) {
    this.iframeObj.cleanup();
    this.iframeObj = null;
  }

  delete commonjsGlobal[iframe.WPrefix][this.id];
};

HtmlfileReceiver.prototype._close = function (reason) {
  debug$b('_close', reason);
  this.emit('close', null, reason);
  this.removeAllListeners();
};

HtmlfileReceiver.htmlfileEnabled = false; // obfuscate to avoid firewalls

var axo$1 = ['Active'].concat('Object').join('X');

if (axo$1 in commonjsGlobal) {
  try {
    HtmlfileReceiver.htmlfileEnabled = !!new commonjsGlobal[axo$1]('htmlfile');
  } catch (x) {// intentionally empty
  }
}

HtmlfileReceiver.enabled = HtmlfileReceiver.htmlfileEnabled || iframe.iframeEnabled;
var htmlfile = HtmlfileReceiver;

function HtmlFileTransport(transUrl) {
  if (!htmlfile.enabled) {
    throw new Error('Transport created when disabled');
  }

  ajaxBased.call(this, transUrl, '/htmlfile', htmlfile, xhrLocal);
}

inherits_browser(HtmlFileTransport, ajaxBased);

HtmlFileTransport.enabled = function (info) {
  return htmlfile.enabled && info.sameOrigin;
};

HtmlFileTransport.transportName = 'htmlfile';
HtmlFileTransport.roundTrips = 2;
var htmlfile$1 = HtmlFileTransport;

function XhrPollingTransport(transUrl) {
  if (!xhrLocal.enabled && !xhrCors.enabled) {
    throw new Error('Transport created when disabled');
  }

  ajaxBased.call(this, transUrl, '/xhr', xhr$1, xhrCors);
}

inherits_browser(XhrPollingTransport, ajaxBased);

XhrPollingTransport.enabled = function (info) {
  if (info.nullOrigin) {
    return false;
  }

  if (xhrLocal.enabled && info.sameOrigin) {
    return true;
  }

  return xhrCors.enabled;
};

XhrPollingTransport.transportName = 'xhr-polling';
XhrPollingTransport.roundTrips = 2; // preflight, ajax

var xhrPolling = XhrPollingTransport;

function XdrPollingTransport(transUrl) {
  if (!xdr.enabled) {
    throw new Error('Transport created when disabled');
  }

  ajaxBased.call(this, transUrl, '/xhr', xhr$1, xdr);
}

inherits_browser(XdrPollingTransport, ajaxBased);
XdrPollingTransport.enabled = xdrStreaming.enabled;
XdrPollingTransport.transportName = 'xdr-polling';
XdrPollingTransport.roundTrips = 2; // preflight, ajax

var xdrPolling = XdrPollingTransport;
var EventEmitter$a = emitter.EventEmitter;

var debug$c = function debug$c() {};

if (process.env.NODE_ENV !== 'production') {
  debug$c = browser$1('sockjs-client:receiver:jsonp');
}

function JsonpReceiver(url$1) {
  debug$c(url$1);
  var self = this;
  EventEmitter$a.call(this);
  iframe.polluteGlobalNamespace();
  this.id = 'a' + random.string(6);
  var urlWithId = url.addQuery(url$1, 'c=' + encodeURIComponent(iframe.WPrefix + '.' + this.id));
  commonjsGlobal[iframe.WPrefix][this.id] = this._callback.bind(this);

  this._createScript(urlWithId); // Fallback mostly for Konqueror - stupid timer, 35 seconds shall be plenty.


  this.timeoutId = setTimeout(function () {
    debug$c('timeout');

    self._abort(new Error('JSONP script loaded abnormally (timeout)'));
  }, JsonpReceiver.timeout);
}

inherits_browser(JsonpReceiver, EventEmitter$a);

JsonpReceiver.prototype.abort = function () {
  debug$c('abort');

  if (commonjsGlobal[iframe.WPrefix][this.id]) {
    var err = new Error('JSONP user aborted read');
    err.code = 1000;

    this._abort(err);
  }
};

JsonpReceiver.timeout = 35000;
JsonpReceiver.scriptErrorTimeout = 1000;

JsonpReceiver.prototype._callback = function (data) {
  debug$c('_callback', data);

  this._cleanup();

  if (this.aborting) {
    return;
  }

  if (data) {
    debug$c('message', data);
    this.emit('message', data);
  }

  this.emit('close', null, 'network');
  this.removeAllListeners();
};

JsonpReceiver.prototype._abort = function (err) {
  debug$c('_abort', err);

  this._cleanup();

  this.aborting = true;
  this.emit('close', err.code, err.message);
  this.removeAllListeners();
};

JsonpReceiver.prototype._cleanup = function () {
  debug$c('_cleanup');
  clearTimeout(this.timeoutId);

  if (this.script2) {
    this.script2.parentNode.removeChild(this.script2);
    this.script2 = null;
  }

  if (this.script) {
    var script = this.script; // Unfortunately, you can't really abort script loading of
    // the script.

    script.parentNode.removeChild(script);
    script.onreadystatechange = script.onerror = script.onload = script.onclick = null;
    this.script = null;
  }

  delete commonjsGlobal[iframe.WPrefix][this.id];
};

JsonpReceiver.prototype._scriptError = function () {
  debug$c('_scriptError');
  var self = this;

  if (this.errorTimer) {
    return;
  }

  this.errorTimer = setTimeout(function () {
    if (!self.loadedOkay) {
      self._abort(new Error('JSONP script loaded abnormally (onerror)'));
    }
  }, JsonpReceiver.scriptErrorTimeout);
};

JsonpReceiver.prototype._createScript = function (url) {
  debug$c('_createScript', url);
  var self = this;
  var script = this.script = commonjsGlobal.document.createElement('script');
  var script2; // Opera synchronous load trick.

  script.id = 'a' + random.string(8);
  script.src = url;
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.onerror = this._scriptError.bind(this);

  script.onload = function () {
    debug$c('onload');

    self._abort(new Error('JSONP script loaded abnormally (onload)'));
  }; // IE9 fires 'error' event after onreadystatechange or before, in random order.
  // Use loadedOkay to determine if actually errored


  script.onreadystatechange = function () {
    debug$c('onreadystatechange', script.readyState);

    if (/loaded|closed/.test(script.readyState)) {
      if (script && script.htmlFor && script.onclick) {
        self.loadedOkay = true;

        try {
          // In IE, actually execute the script.
          script.onclick();
        } catch (x) {// intentionally empty
        }
      }

      if (script) {
        self._abort(new Error('JSONP script loaded abnormally (onreadystatechange)'));
      }
    }
  }; // IE: event/htmlFor/onclick trick.
  // One can't rely on proper order for onreadystatechange. In order to
  // make sure, set a 'htmlFor' and 'event' properties, so that
  // script code will be installed as 'onclick' handler for the
  // script object. Later, onreadystatechange, manually execute this
  // code. FF and Chrome doesn't work with 'event' and 'htmlFor'
  // set. For reference see:
  //   http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
  // Also, read on that about script ordering:
  //   http://wiki.whatwg.org/wiki/Dynamic_Script_Execution_Order


  if (typeof script.async === 'undefined' && commonjsGlobal.document.attachEvent) {
    // According to mozilla docs, in recent browsers script.async defaults
    // to 'true', so we may use it to detect a good browser:
    // https://developer.mozilla.org/en/HTML/Element/script
    if (!browser$2.isOpera()) {
      // Naively assume we're in IE
      try {
        script.htmlFor = script.id;
        script.event = 'onclick';
      } catch (x) {// intentionally empty
      }

      script.async = true;
    } else {
      // Opera, second sync script hack
      script2 = this.script2 = commonjsGlobal.document.createElement('script');
      script2.text = "try{var a = document.getElementById('" + script.id + "'); if(a)a.onerror();}catch(x){};";
      script.async = script2.async = false;
    }
  }

  if (typeof script.async !== 'undefined') {
    script.async = true;
  }

  var head = commonjsGlobal.document.getElementsByTagName('head')[0];
  head.insertBefore(script, head.firstChild);

  if (script2) {
    head.insertBefore(script2, head.firstChild);
  }
};

var jsonp = JsonpReceiver;

var debug$d = function debug$d() {};

if (process.env.NODE_ENV !== 'production') {
  debug$d = browser$1('sockjs-client:sender:jsonp');
}

var form, area;

function createIframe(id) {
  debug$d('createIframe', id);

  try {
    // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
    return commonjsGlobal.document.createElement('<iframe name="' + id + '">');
  } catch (x) {
    var iframe = commonjsGlobal.document.createElement('iframe');
    iframe.name = id;
    return iframe;
  }
}

function createForm() {
  debug$d('createForm');
  form = commonjsGlobal.document.createElement('form');
  form.style.display = 'none';
  form.style.position = 'absolute';
  form.method = 'POST';
  form.enctype = 'application/x-www-form-urlencoded';
  form.acceptCharset = 'UTF-8';
  area = commonjsGlobal.document.createElement('textarea');
  area.name = 'd';
  form.appendChild(area);
  commonjsGlobal.document.body.appendChild(form);
}

var jsonp$1 = function jsonp$1(url$1, payload, callback) {
  debug$d(url$1, payload);

  if (!form) {
    createForm();
  }

  var id = 'a' + random.string(8);
  form.target = id;
  form.action = url.addQuery(url.addPath(url$1, '/jsonp_send'), 'i=' + id);
  var iframe = createIframe(id);
  iframe.id = id;
  iframe.style.display = 'none';
  form.appendChild(iframe);

  try {
    area.value = payload;
  } catch (e) {// seriously broken browsers get here
  }

  form.submit();

  var completed = function completed(err) {
    debug$d('completed', id, err);

    if (!iframe.onerror) {
      return;
    }

    iframe.onreadystatechange = iframe.onerror = iframe.onload = null; // Opera mini doesn't like if we GC iframe
    // immediately, thus this timeout.

    setTimeout(function () {
      debug$d('cleaning up', id);
      iframe.parentNode.removeChild(iframe);
      iframe = null;
    }, 500);
    area.value = ''; // It is not possible to detect if the iframe succeeded or
    // failed to submit our form.

    callback(err);
  };

  iframe.onerror = function () {
    debug$d('onerror', id);
    completed();
  };

  iframe.onload = function () {
    debug$d('onload', id);
    completed();
  };

  iframe.onreadystatechange = function (e) {
    debug$d('onreadystatechange', id, iframe.readyState, e);

    if (iframe.readyState === 'complete') {
      completed();
    }
  };

  return function () {
    debug$d('aborted', id);
    completed(new Error('Aborted'));
  };
}; // The simplest and most robust transport, using the well-know cross
// domain hack - JSONP. This transport is quite inefficient - one
// message could use up to one http request. But at least it works almost
// everywhere.
// Known limitations:
//   o you will get a spinning cursor
//   o for Konqueror a dumb timer is needed to detect errors


function JsonPTransport(transUrl) {
  if (!JsonPTransport.enabled()) {
    throw new Error('Transport created when disabled');
  }

  senderReceiver.call(this, transUrl, '/jsonp', jsonp$1, jsonp);
}

inherits_browser(JsonPTransport, senderReceiver);

JsonPTransport.enabled = function () {
  return !!commonjsGlobal.document;
};

JsonPTransport.transportName = 'jsonp-polling';
JsonPTransport.roundTrips = 1;
JsonPTransport.needBody = true;
var jsonpPolling = JsonPTransport;
var transportList = [// streaming transports
websocket$1, xhrStreaming, xdrStreaming, eventsource$2, iframeWrap(eventsource$2) // polling transports
, htmlfile$1, iframeWrap(htmlfile$1), xhrPolling, xdrPolling, iframeWrap(xhrPolling), jsonpPolling];
/* eslint-disable */
// pulled specific shims from https://github.com/es-shims/es5-shim

var ArrayPrototype = Array.prototype;
var ObjectPrototype = Object.prototype;
var FunctionPrototype = Function.prototype;
var StringPrototype = String.prototype;
var array_slice = ArrayPrototype.slice;
var _toString = ObjectPrototype.toString;

var isFunction$1 = function isFunction$1(val) {
  return ObjectPrototype.toString.call(val) === '[object Function]';
};

var isArray$1 = function isArray(obj) {
  return _toString.call(obj) === '[object Array]';
};

var isString$1 = function isString(obj) {
  return _toString.call(obj) === '[object String]';
};

var supportsDescriptors = Object.defineProperty && function () {
  try {
    Object.defineProperty({}, 'x', {});
    return true;
  } catch (e) {
    /* this is ES3 */
    return false;
  }
}(); // Define configurable, writable and non-enumerable props
// if they don't exist.


var defineProperty$1;

if (supportsDescriptors) {
  defineProperty$1 = function defineProperty$1(object, name, method, forceAssign) {
    if (!forceAssign && name in object) {
      return;
    }

    Object.defineProperty(object, name, {
      configurable: true,
      enumerable: false,
      writable: true,
      value: method
    });
  };
} else {
  defineProperty$1 = function defineProperty$1(object, name, method, forceAssign) {
    if (!forceAssign && name in object) {
      return;
    }

    object[name] = method;
  };
}

var defineProperties = function defineProperties(object, map, forceAssign) {
  for (var name in map) {
    if (ObjectPrototype.hasOwnProperty.call(map, name)) {
      defineProperty$1(object, name, map[name], forceAssign);
    }
  }
};

var toObject = function toObject(o) {
  if (o == null) {
    // this matches both null and undefined
    throw new TypeError("can't convert " + o + ' to object');
  }

  return Object(o);
}; //
// Util
// ======
//
// ES5 9.4
// http://es5.github.com/#x9.4
// http://jsperf.com/to-integer


function toInteger(num) {
  var n = +num;

  if (n !== n) {
    // isNaN
    n = 0;
  } else if (n !== 0 && n !== 1 / 0 && n !== -(1 / 0)) {
    n = (n > 0 || -1) * Math.floor(Math.abs(n));
  }

  return n;
}

function ToUint32(x) {
  return x >>> 0;
} //
// Function
// ========
//
// ES-5 15.3.4.5
// http://es5.github.com/#x15.3.4.5


function Empty() {}

defineProperties(FunctionPrototype, {
  bind: function bind(that) {
    // .length is 1
    // 1. Let Target be the this value.
    var target = this; // 2. If IsCallable(Target) is false, throw a TypeError exception.

    if (!isFunction$1(target)) {
      throw new TypeError('Function.prototype.bind called on incompatible ' + target);
    } // 3. Let A be a new (possibly empty) internal list of all of the
    //   argument values provided after thisArg (arg1, arg2 etc), in order.
    // XXX slicedArgs will stand in for "A" if used


    var args = array_slice.call(arguments, 1); // for normal call
    // 4. Let F be a new native ECMAScript object.
    // 11. Set the [[Prototype]] internal property of F to the standard
    //   built-in Function prototype object as specified in 15.3.3.1.
    // 12. Set the [[Call]] internal property of F as described in
    //   15.3.4.5.1.
    // 13. Set the [[Construct]] internal property of F as described in
    //   15.3.4.5.2.
    // 14. Set the [[HasInstance]] internal property of F as described in
    //   15.3.4.5.3.

    var binder = function binder() {
      if (this instanceof bound) {
        // 15.3.4.5.2 [[Construct]]
        // When the [[Construct]] internal method of a function object,
        // F that was created using the bind function is called with a
        // list of arguments ExtraArgs, the following steps are taken:
        // 1. Let target be the value of F's [[TargetFunction]]
        //   internal property.
        // 2. If target has no [[Construct]] internal method, a
        //   TypeError exception is thrown.
        // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
        //   property.
        // 4. Let args be a new list containing the same values as the
        //   list boundArgs in the same order followed by the same
        //   values as the list ExtraArgs in the same order.
        // 5. Return the result of calling the [[Construct]] internal
        //   method of target providing args as the arguments.
        var result = target.apply(this, args.concat(array_slice.call(arguments)));

        if (Object(result) === result) {
          return result;
        }

        return this;
      } else {
        // 15.3.4.5.1 [[Call]]
        // When the [[Call]] internal method of a function object, F,
        // which was created using the bind function is called with a
        // this value and a list of arguments ExtraArgs, the following
        // steps are taken:
        // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
        //   property.
        // 2. Let boundThis be the value of F's [[BoundThis]] internal
        //   property.
        // 3. Let target be the value of F's [[TargetFunction]] internal
        //   property.
        // 4. Let args be a new list containing the same values as the
        //   list boundArgs in the same order followed by the same
        //   values as the list ExtraArgs in the same order.
        // 5. Return the result of calling the [[Call]] internal method
        //   of target providing boundThis as the this value and
        //   providing args as the arguments.
        // equiv: target.call(this, ...boundArgs, ...args)
        return target.apply(that, args.concat(array_slice.call(arguments)));
      }
    }; // 15. If the [[Class]] internal property of Target is "Function", then
    //     a. Let L be the length property of Target minus the length of A.
    //     b. Set the length own property of F to either 0 or L, whichever is
    //       larger.
    // 16. Else set the length own property of F to 0.


    var boundLength = Math.max(0, target.length - args.length); // 17. Set the attributes of the length own property of F to the values
    //   specified in 15.3.5.1.

    var boundArgs = [];

    for (var i = 0; i < boundLength; i++) {
      boundArgs.push('$' + i);
    } // XXX Build a dynamic function with desired amount of arguments is the only
    // way to set the length property of a function.
    // In environments where Content Security Policies enabled (Chrome extensions,
    // for ex.) all use of eval or Function costructor throws an exception.
    // However in all of these environments Function.prototype.bind exists
    // and so this code will never be executed.


    var bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);

    if (target.prototype) {
      Empty.prototype = target.prototype;
      bound.prototype = new Empty(); // Clean up dangling references.

      Empty.prototype = null;
    } // TODO
    // 18. Set the [[Extensible]] internal property of F to true.
    // TODO
    // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
    // 20. Call the [[DefineOwnProperty]] internal method of F with
    //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
    //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
    //   false.
    // 21. Call the [[DefineOwnProperty]] internal method of F with
    //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
    //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
    //   and false.
    // TODO
    // NOTE Function objects created using Function.prototype.bind do not
    // have a prototype property or the [[Code]], [[FormalParameters]], and
    // [[Scope]] internal properties.
    // XXX can't delete prototype in pure-js.
    // 22. Return F.


    return bound;
  }
}); //
// Array
// =====
//
// ES5 15.4.3.2
// http://es5.github.com/#x15.4.3.2
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray

defineProperties(Array, {
  isArray: isArray$1
});
var boxedString = Object('a');
var splitString = boxedString[0] !== 'a' || !(0 in boxedString);

var properlyBoxesContext = function properlyBoxed(method) {
  // Check node 0.6.21 bug where third parameter is not boxed
  var properlyBoxesNonStrict = true;
  var properlyBoxesStrict = true;

  if (method) {
    method.call('foo', function (_, __, context) {
      if (typeof context !== 'object') {
        properlyBoxesNonStrict = false;
      }
    });
    method.call([1], function () {
      properlyBoxesStrict = typeof this === 'string';
    }, 'x');
  }

  return !!method && properlyBoxesNonStrict && properlyBoxesStrict;
};

defineProperties(ArrayPrototype, {
  forEach: function forEach(fun
  /*, thisp*/
  ) {
    var object = toObject(this),
        self = splitString && isString$1(this) ? this.split('') : object,
        thisp = arguments[1],
        i = -1,
        length = self.length >>> 0; // If no callback function or if callback is not a callable function

    if (!isFunction$1(fun)) {
      throw new TypeError(); // TODO message
    }

    while (++i < length) {
      if (i in self) {
        // Invoke the callback function with call, passing arguments:
        // context, property value, property key, thisArg object
        // context
        fun.call(thisp, self[i], i, object);
      }
    }
  }
}, !properlyBoxesContext(ArrayPrototype.forEach)); // ES5 15.4.4.14
// http://es5.github.com/#x15.4.4.14
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf

var hasFirefox2IndexOfBug = Array.prototype.indexOf && [0, 1].indexOf(1, 2) !== -1;
defineProperties(ArrayPrototype, {
  indexOf: function indexOf(sought
  /*, fromIndex */
  ) {
    var self = splitString && isString$1(this) ? this.split('') : toObject(this),
        length = self.length >>> 0;

    if (!length) {
      return -1;
    }

    var i = 0;

    if (arguments.length > 1) {
      i = toInteger(arguments[1]);
    } // handle negative indices


    i = i >= 0 ? i : Math.max(0, length + i);

    for (; i < length; i++) {
      if (i in self && self[i] === sought) {
        return i;
      }
    }

    return -1;
  }
}, hasFirefox2IndexOfBug); //
// String
// ======
//
// ES5 15.5.4.14
// http://es5.github.com/#x15.5.4.14
// [bugfix, IE lt 9, firefox 4, Konqueror, Opera, obscure browsers]
// Many browsers do not split properly with regular expressions or they
// do not perform the split correctly under obscure conditions.
// See http://blog.stevenlevithan.com/archives/cross-browser-split
// I've tested in many browsers and this seems to cover the deviant ones:
//    'ab'.split(/(?:ab)*/) should be ["", ""], not [""]
//    '.'.split(/(.?)(.?)/) should be ["", ".", "", ""], not ["", ""]
//    'tesst'.split(/(s)*/) should be ["t", undefined, "e", "s", "t"], not
//       [undefined, "t", undefined, "e", ...]
//    ''.split(/.?/) should be [], not [""]
//    '.'.split(/()()/) should be ["."], not ["", "", "."]

var string_split = StringPrototype.split;

if ('ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 || 'tesst'.split(/(s)*/)[1] === 't' || 'test'.split(/(?:)/, -1).length !== 4 || ''.split(/.?/).length || '.'.split(/()()/).length > 1) {
  (function () {
    var compliantExecNpcg = /()??/.exec('')[1] === void 0; // NPCG: nonparticipating capturing group

    StringPrototype.split = function (separator, limit) {
      var string = this;

      if (separator === void 0 && limit === 0) {
        return [];
      } // If `separator` is not a regex, use native split


      if (_toString.call(separator) !== '[object RegExp]') {
        return string_split.call(this, separator, limit);
      }

      var output = [],
          flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.extended ? 'x' : '') + ( // Proposed for ES6
      separator.sticky ? 'y' : ''),
          // Firefox 3+
      lastLastIndex = 0,
          // Make `global` and avoid `lastIndex` issues by working with a copy
      separator2,
          match,
          lastIndex,
          lastLength;
      separator = new RegExp(separator.source, flags + 'g');
      string += ''; // Type-convert

      if (!compliantExecNpcg) {
        // Doesn't need flags gy, but they don't hurt
        separator2 = new RegExp('^' + separator.source + '$(?!\\s)', flags);
      }
      /* Values for `limit`, per the spec:
       * If undefined: 4294967295 // Math.pow(2, 32) - 1
       * If 0, Infinity, or NaN: 0
       * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
       * If negative number: 4294967296 - Math.floor(Math.abs(limit))
       * If other: Type-convert, then use the above rules
       */


      limit = limit === void 0 ? -1 >>> 0 : // Math.pow(2, 32) - 1
      ToUint32(limit);

      while (match = separator.exec(string)) {
        // `separator.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0].length;

        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index)); // Fix browsers whose `exec` methods don't consistently return `undefined` for
          // nonparticipating capturing groups

          if (!compliantExecNpcg && match.length > 1) {
            match[0].replace(separator2, function () {
              for (var i = 1; i < arguments.length - 2; i++) {
                if (arguments[i] === void 0) {
                  match[i] = void 0;
                }
              }
            });
          }

          if (match.length > 1 && match.index < string.length) {
            ArrayPrototype.push.apply(output, match.slice(1));
          }

          lastLength = match[0].length;
          lastLastIndex = lastIndex;

          if (output.length >= limit) {
            break;
          }
        }

        if (separator.lastIndex === match.index) {
          separator.lastIndex++; // Avoid an infinite loop
        }
      }

      if (lastLastIndex === string.length) {
        if (lastLength || !separator.test('')) {
          output.push('');
        }
      } else {
        output.push(string.slice(lastLastIndex));
      }

      return output.length > limit ? output.slice(0, limit) : output;
    };
  })(); // [bugfix, chrome]
  // If separator is undefined, then the result array contains just one String,
  // which is the this value (converted to a String). If limit is not undefined,
  // then the output array is truncated so that it contains no more than limit
  // elements.
  // "0".split(undefined, 0) -> []

} else if ('0'.split(void 0, 0).length) {
  StringPrototype.split = function split(separator, limit) {
    if (separator === void 0 && limit === 0) {
      return [];
    }

    return string_split.call(this, separator, limit);
  };
} // ECMA-262, 3rd B.2.3
// Not an ECMAScript standard, although ECMAScript 3rd Edition has a
// non-normative section suggesting uniform semantics and it should be
// normalized across all browsers
// [bugfix, IE lt 9] IE < 9 substr() with negative value not working in IE


var string_substr = StringPrototype.substr;
var hasNegativeSubstrBug = ''.substr && '0b'.substr(-1) !== 'b';
defineProperties(StringPrototype, {
  substr: function substr(start, length) {
    return string_substr.call(this, start < 0 ? (start = this.length + start) < 0 ? 0 : start : start, length);
  }
}, hasNegativeSubstrBug); // Some extra characters that Chrome gets wrong, and substitutes with
// something else on the wire.
// eslint-disable-next-line no-control-regex

var extraEscapable = /[\x00-\x1f\ud800-\udfff\ufffe\uffff\u0300-\u0333\u033d-\u0346\u034a-\u034c\u0350-\u0352\u0357-\u0358\u035c-\u0362\u0374\u037e\u0387\u0591-\u05af\u05c4\u0610-\u0617\u0653-\u0654\u0657-\u065b\u065d-\u065e\u06df-\u06e2\u06eb-\u06ec\u0730\u0732-\u0733\u0735-\u0736\u073a\u073d\u073f-\u0741\u0743\u0745\u0747\u07eb-\u07f1\u0951\u0958-\u095f\u09dc-\u09dd\u09df\u0a33\u0a36\u0a59-\u0a5b\u0a5e\u0b5c-\u0b5d\u0e38-\u0e39\u0f43\u0f4d\u0f52\u0f57\u0f5c\u0f69\u0f72-\u0f76\u0f78\u0f80-\u0f83\u0f93\u0f9d\u0fa2\u0fa7\u0fac\u0fb9\u1939-\u193a\u1a17\u1b6b\u1cda-\u1cdb\u1dc0-\u1dcf\u1dfc\u1dfe\u1f71\u1f73\u1f75\u1f77\u1f79\u1f7b\u1f7d\u1fbb\u1fbe\u1fc9\u1fcb\u1fd3\u1fdb\u1fe3\u1feb\u1fee-\u1fef\u1ff9\u1ffb\u1ffd\u2000-\u2001\u20d0-\u20d1\u20d4-\u20d7\u20e7-\u20e9\u2126\u212a-\u212b\u2329-\u232a\u2adc\u302b-\u302c\uaab2-\uaab3\uf900-\ufa0d\ufa10\ufa12\ufa15-\ufa1e\ufa20\ufa22\ufa25-\ufa26\ufa2a-\ufa2d\ufa30-\ufa6d\ufa70-\ufad9\ufb1d\ufb1f\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufb4e\ufff0-\uffff]/g,
    extraLookup; // This may be quite slow, so let's delay until user actually uses bad
// characters.

var unrollLookup = function unrollLookup(escapable) {
  var i;
  var unrolled = {};
  var c = [];

  for (i = 0; i < 65536; i++) {
    c.push(String.fromCharCode(i));
  }

  escapable.lastIndex = 0;
  c.join('').replace(escapable, function (a) {
    unrolled[a] = "\\u" + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
    return '';
  });
  escapable.lastIndex = 0;
  return unrolled;
}; // Quote string, also taking care of unicode characters that browsers
// often break. Especially, take care of unicode surrogates:
// http://en.wikipedia.org/wiki/Mapping_of_Unicode_characters#Surrogates


var _escape = {
  quote: function quote(string) {
    var quoted = json3.stringify(string); // In most cases this should be very fast and good enough.

    extraEscapable.lastIndex = 0;

    if (!extraEscapable.test(quoted)) {
      return quoted;
    }

    if (!extraLookup) {
      extraLookup = unrollLookup(extraEscapable);
    }

    return quoted.replace(extraEscapable, function (a) {
      return extraLookup[a];
    });
  }
};

var debug$e = function debug$e() {};

if (process.env.NODE_ENV !== 'production') {
  debug$e = browser$1('sockjs-client:utils:transport');
}

var transport = function transport(availableTransports) {
  return {
    filterToEnabled: function filterToEnabled(transportsWhitelist, info) {
      var transports = {
        main: [],
        facade: []
      };

      if (!transportsWhitelist) {
        transportsWhitelist = [];
      } else if (typeof transportsWhitelist === 'string') {
        transportsWhitelist = [transportsWhitelist];
      }

      availableTransports.forEach(function (trans) {
        if (!trans) {
          return;
        }

        if (trans.transportName === 'websocket' && info.websocket === false) {
          debug$e('disabled from server', 'websocket');
          return;
        }

        if (transportsWhitelist.length && transportsWhitelist.indexOf(trans.transportName) === -1) {
          debug$e('not in whitelist', trans.transportName);
          return;
        }

        if (trans.enabled(info)) {
          debug$e('enabled', trans.transportName);
          transports.main.push(trans);

          if (trans.facadeTransport) {
            transports.facade.push(trans.facadeTransport);
          }
        } else {
          debug$e('disabled', trans.transportName);
        }
      });
      return transports;
    }
  };
};

var logObject = {};
['log', 'debug', 'warn'].forEach(function (level) {
  var levelExists;

  try {
    levelExists = commonjsGlobal.console && commonjsGlobal.console[level] && commonjsGlobal.console[level].apply;
  } catch (e) {// do nothing
  }

  logObject[level] = levelExists ? function () {
    return commonjsGlobal.console[level].apply(commonjsGlobal.console, arguments);
  } : level === 'log' ? function () {} : logObject.log;
});
var log$1 = logObject;

function Event$1(eventType) {
  this.type = eventType;
}

Event$1.prototype.initEvent = function (eventType, canBubble, cancelable) {
  this.type = eventType;
  this.bubbles = canBubble;
  this.cancelable = cancelable;
  this.timeStamp = +new Date();
  return this;
};

Event$1.prototype.stopPropagation = function () {};

Event$1.prototype.preventDefault = function () {};

Event$1.CAPTURING_PHASE = 1;
Event$1.AT_TARGET = 2;
Event$1.BUBBLING_PHASE = 3;
var event$1 = Event$1;
var location_1 = commonjsGlobal.location || {
  origin: 'http://localhost:80',
  protocol: 'http:',
  host: 'localhost',
  port: 80,
  href: 'http://localhost/',
  hash: ''
};

function CloseEvent() {
  event$1.call(this);
  this.initEvent('close', false, false);
  this.wasClean = false;
  this.code = 0;
  this.reason = '';
}

inherits_browser(CloseEvent, event$1);
var close = CloseEvent;

function TransportMessageEvent(data) {
  event$1.call(this);
  this.initEvent('message', false, false);
  this.data = data;
}

inherits_browser(TransportMessageEvent, event$1);
var transMessage = TransportMessageEvent;
var EventEmitter$b = emitter.EventEmitter;

function
  /* method, url, payload, opts */
XHRFake() {
  var self = this;
  EventEmitter$b.call(this);
  this.to = setTimeout(function () {
    self.emit('finish', 200, '{}');
  }, XHRFake.timeout);
}

inherits_browser(XHRFake, EventEmitter$b);

XHRFake.prototype.close = function () {
  clearTimeout(this.to);
};

XHRFake.timeout = 2000;
var xhrFake = XHRFake;
var EventEmitter$c = emitter.EventEmitter;

var debug$f = function debug$f() {};

if (process.env.NODE_ENV !== 'production') {
  debug$f = browser$1('sockjs-client:info-ajax');
}

function InfoAjax(url, AjaxObject) {
  EventEmitter$c.call(this);
  var self = this;
  var t0 = +new Date();
  this.xo = new AjaxObject('GET', url);
  this.xo.once('finish', function (status, text) {
    var info, rtt;

    if (status === 200) {
      rtt = +new Date() - t0;

      if (text) {
        try {
          info = json3.parse(text);
        } catch (e) {
          debug$f('bad json', text);
        }
      }

      if (!object.isObject(info)) {
        info = {};
      }
    }

    self.emit('finish', info, rtt);
    self.removeAllListeners();
  });
}

inherits_browser(InfoAjax, EventEmitter$c);

InfoAjax.prototype.close = function () {
  this.removeAllListeners();
  this.xo.close();
};

var infoAjax = InfoAjax;
var EventEmitter$d = emitter.EventEmitter;

function InfoReceiverIframe(transUrl) {
  var self = this;
  EventEmitter$d.call(this);
  this.ir = new infoAjax(transUrl, xhrLocal);
  this.ir.once('finish', function (info, rtt) {
    self.ir = null;
    self.emit('message', json3.stringify([info, rtt]));
  });
}

inherits_browser(InfoReceiverIframe, EventEmitter$d);
InfoReceiverIframe.transportName = 'iframe-info-receiver';

InfoReceiverIframe.prototype.close = function () {
  if (this.ir) {
    this.ir.close();
    this.ir = null;
  }

  this.removeAllListeners();
};

var infoIframeReceiver = InfoReceiverIframe;
var EventEmitter$e = emitter.EventEmitter;

var debug$g = function debug$g() {};

if (process.env.NODE_ENV !== 'production') {
  debug$g = browser$1('sockjs-client:info-iframe');
}

function InfoIframe(baseUrl, url) {
  var self = this;
  EventEmitter$e.call(this);

  var go = function go() {
    var ifr = self.ifr = new iframe$1(infoIframeReceiver.transportName, url, baseUrl);
    ifr.once('message', function (msg) {
      if (msg) {
        var d;

        try {
          d = json3.parse(msg);
        } catch (e) {
          debug$g('bad json', msg);
          self.emit('finish');
          self.close();
          return;
        }

        var info = d[0],
            rtt = d[1];
        self.emit('finish', info, rtt);
      }

      self.close();
    });
    ifr.once('close', function () {
      self.emit('finish');
      self.close();
    });
  }; // TODO this seems the same as the 'needBody' from transports


  if (!commonjsGlobal.document.body) {
    event.attachEvent('load', go);
  } else {
    go();
  }
}

inherits_browser(InfoIframe, EventEmitter$e);

InfoIframe.enabled = function () {
  return iframe$1.enabled();
};

InfoIframe.prototype.close = function () {
  if (this.ifr) {
    this.ifr.close();
  }

  this.removeAllListeners();
  this.ifr = null;
};

var infoIframe = InfoIframe;
var EventEmitter$f = emitter.EventEmitter;

var debug$h = function debug$h() {};

if (process.env.NODE_ENV !== 'production') {
  debug$h = browser$1('sockjs-client:info-receiver');
}

function InfoReceiver(baseUrl, urlInfo) {
  debug$h(baseUrl);
  var self = this;
  EventEmitter$f.call(this);
  setTimeout(function () {
    self.doXhr(baseUrl, urlInfo);
  }, 0);
}

inherits_browser(InfoReceiver, EventEmitter$f); // TODO this is currently ignoring the list of available transports and the whitelist

InfoReceiver._getReceiver = function (baseUrl, url, urlInfo) {
  // determine method of CORS support (if needed)
  if (urlInfo.sameOrigin) {
    return new infoAjax(url, xhrLocal);
  }

  if (xhrCors.enabled) {
    return new infoAjax(url, xhrCors);
  }

  if (xdr.enabled && urlInfo.sameScheme) {
    return new infoAjax(url, xdr);
  }

  if (infoIframe.enabled()) {
    return new infoIframe(baseUrl, url);
  }

  return new infoAjax(url, xhrFake);
};

InfoReceiver.prototype.doXhr = function (baseUrl, urlInfo) {
  var self = this,
      url$1 = url.addPath(baseUrl, '/info');
  debug$h('doXhr', url$1);
  this.xo = InfoReceiver._getReceiver(baseUrl, url$1, urlInfo);
  this.timeoutRef = setTimeout(function () {
    debug$h('timeout');

    self._cleanup(false);

    self.emit('finish');
  }, InfoReceiver.timeout);
  this.xo.once('finish', function (info, rtt) {
    debug$h('finish', info, rtt);

    self._cleanup(true);

    self.emit('finish', info, rtt);
  });
};

InfoReceiver.prototype._cleanup = function (wasClean) {
  debug$h('_cleanup');
  clearTimeout(this.timeoutRef);
  this.timeoutRef = null;

  if (!wasClean && this.xo) {
    this.xo.close();
  }

  this.xo = null;
};

InfoReceiver.prototype.close = function () {
  debug$h('close');
  this.removeAllListeners();

  this._cleanup(false);
};

InfoReceiver.timeout = 8000;
var infoReceiver = InfoReceiver;

function FacadeJS(transport) {
  this._transport = transport;
  transport.on('message', this._transportMessage.bind(this));
  transport.on('close', this._transportClose.bind(this));
}

FacadeJS.prototype._transportClose = function (code, reason) {
  iframe.postMessage('c', json3.stringify([code, reason]));
};

FacadeJS.prototype._transportMessage = function (frame) {
  iframe.postMessage('t', frame);
};

FacadeJS.prototype._send = function (data) {
  this._transport.send(data);
};

FacadeJS.prototype._close = function () {
  this._transport.close();

  this._transport.removeAllListeners();
};

var facade = FacadeJS;

var debug$i = function debug$i() {};

if (process.env.NODE_ENV !== 'production') {
  debug$i = browser$1('sockjs-client:iframe-bootstrap');
}

var iframeBootstrap = function iframeBootstrap(SockJS, availableTransports) {
  var transportMap = {};
  availableTransports.forEach(function (at) {
    if (at.facadeTransport) {
      transportMap[at.facadeTransport.transportName] = at.facadeTransport;
    }
  }); // hard-coded for the info iframe
  // TODO see if we can make this more dynamic

  transportMap[infoIframeReceiver.transportName] = infoIframeReceiver;
  var parentOrigin;
  /* eslint-disable camelcase */

  SockJS.bootstrap_iframe = function () {
    /* eslint-enable camelcase */
    var facade$1;
    iframe.currentWindowId = location_1.hash.slice(1);

    var onMessage = function onMessage(e) {
      if (e.source !== parent) {
        return;
      }

      if (typeof parentOrigin === 'undefined') {
        parentOrigin = e.origin;
      }

      if (e.origin !== parentOrigin) {
        return;
      }

      var iframeMessage;

      try {
        iframeMessage = json3.parse(e.data);
      } catch (ignored) {
        debug$i('bad json', e.data);
        return;
      }

      if (iframeMessage.windowId !== iframe.currentWindowId) {
        return;
      }

      switch (iframeMessage.type) {
        case 's':
          var p;

          try {
            p = json3.parse(iframeMessage.data);
          } catch (ignored) {
            debug$i('bad json', iframeMessage.data);
            break;
          }

          var version = p[0];
          var transport = p[1];
          var transUrl = p[2];
          var baseUrl = p[3];
          debug$i(version, transport, transUrl, baseUrl); // change this to semver logic

          if (version !== SockJS.version) {
            throw new Error('Incompatible SockJS! Main site uses:' + ' "' + version + '", the iframe:' + ' "' + SockJS.version + '".');
          }

          if (!url.isOriginEqual(transUrl, location_1.href) || !url.isOriginEqual(baseUrl, location_1.href)) {
            throw new Error('Can\'t connect to different domain from within an ' + 'iframe. (' + location_1.href + ', ' + transUrl + ', ' + baseUrl + ')');
          }

          facade$1 = new facade(new transportMap[transport](transUrl, baseUrl));
          break;

        case 'm':
          facade$1._send(iframeMessage.data);

          break;

        case 'c':
          if (facade$1) {
            facade$1._close();
          }

          facade$1 = null;
          break;
      }
    };

    event.attachEvent('message', onMessage); // Start

    iframe.postMessage('s');
  };
};

var debug$j = function debug$j() {};

if (process.env.NODE_ENV !== 'production') {
  debug$j = browser$1('sockjs-client:main');
}

var transports; // follow constructor steps defined at http://dev.w3.org/html5/websockets/#the-websocket-interface

function SockJS(url$1, protocols, options) {
  if (!(this instanceof SockJS)) {
    return new SockJS(url$1, protocols, options);
  }

  if (arguments.length < 1) {
    throw new TypeError("Failed to construct 'SockJS: 1 argument required, but only 0 present");
  }

  eventtarget.call(this);
  this.readyState = SockJS.CONNECTING;
  this.extensions = '';
  this.protocol = ''; // non-standard extension

  options = options || {};

  if (options.protocols_whitelist) {
    log$1.warn("'protocols_whitelist' is DEPRECATED. Use 'transports' instead.");
  }

  this._transportsWhitelist = options.transports;
  this._transportOptions = options.transportOptions || {};
  this._timeout = options.timeout || 0;
  var sessionId = options.sessionId || 8;

  if (typeof sessionId === 'function') {
    this._generateSessionId = sessionId;
  } else if (typeof sessionId === 'number') {
    this._generateSessionId = function () {
      return random.string(sessionId);
    };
  } else {
    throw new TypeError('If sessionId is used in the options, it needs to be a number or a function.');
  }

  this._server = options.server || random.numberString(1000); // Step 1 of WS spec - parse and validate the url. Issue #8

  var parsedUrl = new urlParse(url$1);

  if (!parsedUrl.host || !parsedUrl.protocol) {
    throw new SyntaxError("The URL '" + url$1 + "' is invalid");
  } else if (parsedUrl.hash) {
    throw new SyntaxError('The URL must not contain a fragment');
  } else if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
    throw new SyntaxError("The URL's scheme must be either 'http:' or 'https:'. '" + parsedUrl.protocol + "' is not allowed.");
  }

  var secure = parsedUrl.protocol === 'https:'; // Step 2 - don't allow secure origin with an insecure protocol

  if (location_1.protocol === 'https:' && !secure) {
    throw new Error('SecurityError: An insecure SockJS connection may not be initiated from a page loaded over HTTPS');
  } // Step 3 - check port access - no need here
  // Step 4 - parse protocols argument


  if (!protocols) {
    protocols = [];
  } else if (!Array.isArray(protocols)) {
    protocols = [protocols];
  } // Step 5 - check protocols argument


  var sortedProtocols = protocols.sort();
  sortedProtocols.forEach(function (proto, i) {
    if (!proto) {
      throw new SyntaxError("The protocols entry '" + proto + "' is invalid.");
    }

    if (i < sortedProtocols.length - 1 && proto === sortedProtocols[i + 1]) {
      throw new SyntaxError("The protocols entry '" + proto + "' is duplicated.");
    }
  }); // Step 6 - convert origin

  var o = url.getOrigin(location_1.href);
  this._origin = o ? o.toLowerCase() : null; // remove the trailing slash

  parsedUrl.set('pathname', parsedUrl.pathname.replace(/\/+$/, '')); // store the sanitized url

  this.url = parsedUrl.href;
  debug$j('using url', this.url); // Step 7 - start connection in background
  // obtain server info
  // http://sockjs.github.io/sockjs-protocol/sockjs-protocol-0.3.3.html#section-26

  this._urlInfo = {
    nullOrigin: !browser$2.hasDomain(),
    sameOrigin: url.isOriginEqual(this.url, location_1.href),
    sameScheme: url.isSchemeEqual(this.url, location_1.href)
  };
  this._ir = new infoReceiver(this.url, this._urlInfo);

  this._ir.once('finish', this._receiveInfo.bind(this));
}

inherits_browser(SockJS, eventtarget);

function userSetCode(code) {
  return code === 1000 || code >= 3000 && code <= 4999;
}

SockJS.prototype.close = function (code, reason) {
  // Step 1
  if (code && !userSetCode(code)) {
    throw new Error('InvalidAccessError: Invalid code');
  } // Step 2.4 states the max is 123 bytes, but we are just checking length


  if (reason && reason.length > 123) {
    throw new SyntaxError('reason argument has an invalid length');
  } // Step 3.1


  if (this.readyState === SockJS.CLOSING || this.readyState === SockJS.CLOSED) {
    return;
  } // TODO look at docs to determine how to set this


  var wasClean = true;

  this._close(code || 1000, reason || 'Normal closure', wasClean);
};

SockJS.prototype.send = function (data) {
  // #13 - convert anything non-string to string
  // TODO this currently turns objects into [object Object]
  if (typeof data !== 'string') {
    data = '' + data;
  }

  if (this.readyState === SockJS.CONNECTING) {
    throw new Error('InvalidStateError: The connection has not been established yet');
  }

  if (this.readyState !== SockJS.OPEN) {
    return;
  }

  this._transport.send(_escape.quote(data));
};

SockJS.version = version;
SockJS.CONNECTING = 0;
SockJS.OPEN = 1;
SockJS.CLOSING = 2;
SockJS.CLOSED = 3;

SockJS.prototype._receiveInfo = function (info, rtt) {
  debug$j('_receiveInfo', rtt);
  this._ir = null;

  if (!info) {
    this._close(1002, 'Cannot connect to server');

    return;
  } // establish a round-trip timeout (RTO) based on the
  // round-trip time (RTT)


  this._rto = this.countRTO(rtt); // allow server to override url used for the actual transport

  this._transUrl = info.base_url ? info.base_url : this.url;
  info = object.extend(info, this._urlInfo);
  debug$j('info', info); // determine list of desired and supported transports

  var enabledTransports = transports.filterToEnabled(this._transportsWhitelist, info);
  this._transports = enabledTransports.main;
  debug$j(this._transports.length + ' enabled transports');

  this._connect();
};

SockJS.prototype._connect = function () {
  for (var Transport = this._transports.shift(); Transport; Transport = this._transports.shift()) {
    debug$j('attempt', Transport.transportName);

    if (Transport.needBody) {
      if (!commonjsGlobal.document.body || typeof commonjsGlobal.document.readyState !== 'undefined' && commonjsGlobal.document.readyState !== 'complete' && commonjsGlobal.document.readyState !== 'interactive') {
        debug$j('waiting for body');

        this._transports.unshift(Transport);

        event.attachEvent('load', this._connect.bind(this));
        return;
      }
    } // calculate timeout based on RTO and round trips. Default to 5s


    var timeoutMs = Math.max(this._timeout, this._rto * Transport.roundTrips || 5000);
    this._transportTimeoutId = setTimeout(this._transportTimeout.bind(this), timeoutMs);
    debug$j('using timeout', timeoutMs);
    var transportUrl = url.addPath(this._transUrl, '/' + this._server + '/' + this._generateSessionId());
    var options = this._transportOptions[Transport.transportName];
    debug$j('transport url', transportUrl);
    var transportObj = new Transport(transportUrl, this._transUrl, options);
    transportObj.on('message', this._transportMessage.bind(this));
    transportObj.once('close', this._transportClose.bind(this));
    transportObj.transportName = Transport.transportName;
    this._transport = transportObj;
    return;
  }

  this._close(2000, 'All transports failed', false);
};

SockJS.prototype._transportTimeout = function () {
  debug$j('_transportTimeout');

  if (this.readyState === SockJS.CONNECTING) {
    if (this._transport) {
      this._transport.close();
    }

    this._transportClose(2007, 'Transport timed out');
  }
};

SockJS.prototype._transportMessage = function (msg) {
  debug$j('_transportMessage', msg);
  var self = this,
      type = msg.slice(0, 1),
      content = msg.slice(1),
      payload; // first check for messages that don't need a payload

  switch (type) {
    case 'o':
      this._open();

      return;

    case 'h':
      this.dispatchEvent(new event$1('heartbeat'));
      debug$j('heartbeat', this.transport);
      return;
  }

  if (content) {
    try {
      payload = json3.parse(content);
    } catch (e) {
      debug$j('bad json', content);
    }
  }

  if (typeof payload === 'undefined') {
    debug$j('empty payload', content);
    return;
  }

  switch (type) {
    case 'a':
      if (Array.isArray(payload)) {
        payload.forEach(function (p) {
          debug$j('message', self.transport, p);
          self.dispatchEvent(new transMessage(p));
        });
      }

      break;

    case 'm':
      debug$j('message', this.transport, payload);
      this.dispatchEvent(new transMessage(payload));
      break;

    case 'c':
      if (Array.isArray(payload) && payload.length === 2) {
        this._close(payload[0], payload[1], true);
      }

      break;
  }
};

SockJS.prototype._transportClose = function (code, reason) {
  debug$j('_transportClose', this.transport, code, reason);

  if (this._transport) {
    this._transport.removeAllListeners();

    this._transport = null;
    this.transport = null;
  }

  if (!userSetCode(code) && code !== 2000 && this.readyState === SockJS.CONNECTING) {
    this._connect();

    return;
  }

  this._close(code, reason);
};

SockJS.prototype._open = function () {
  debug$j('_open', this._transport && this._transport.transportName, this.readyState);

  if (this.readyState === SockJS.CONNECTING) {
    if (this._transportTimeoutId) {
      clearTimeout(this._transportTimeoutId);
      this._transportTimeoutId = null;
    }

    this.readyState = SockJS.OPEN;
    this.transport = this._transport.transportName;
    this.dispatchEvent(new event$1('open'));
    debug$j('connected', this.transport);
  } else {
    // The server might have been restarted, and lost track of our
    // connection.
    this._close(1006, 'Server lost session');
  }
};

SockJS.prototype._close = function (code, reason, wasClean) {
  debug$j('_close', this.transport, code, reason, wasClean, this.readyState);
  var forceFail = false;

  if (this._ir) {
    forceFail = true;

    this._ir.close();

    this._ir = null;
  }

  if (this._transport) {
    this._transport.close();

    this._transport = null;
    this.transport = null;
  }

  if (this.readyState === SockJS.CLOSED) {
    throw new Error('InvalidStateError: SockJS has already been closed');
  }

  this.readyState = SockJS.CLOSING;
  setTimeout(function () {
    this.readyState = SockJS.CLOSED;

    if (forceFail) {
      this.dispatchEvent(new event$1('error'));
    }

    var e = new close('close');
    e.wasClean = wasClean || false;
    e.code = code || 1000;
    e.reason = reason;
    this.dispatchEvent(e);
    this.onmessage = this.onclose = this.onerror = null;
    debug$j('disconnected');
  }.bind(this), 0);
}; // See: http://www.erg.abdn.ac.uk/~gerrit/dccp/notes/ccid2/rto_estimator/
// and RFC 2988.


SockJS.prototype.countRTO = function (rtt) {
  // In a local environment, when using IE8/9 and the `jsonp-polling`
  // transport the time needed to establish a connection (the time that pass
  // from the opening of the transport to the call of `_dispatchOpen`) is
  // around 200msec (the lower bound used in the article above) and this
  // causes spurious timeouts. For this reason we calculate a value slightly
  // larger than that used in the article.
  if (rtt > 100) {
    return 4 * rtt; // rto > 400msec
  }

  return 300 + rtt; // 300msec < rto <= 400msec
};

var main$1 = function main$1(availableTransports) {
  transports = transport(availableTransports);
  iframeBootstrap(SockJS, availableTransports);
  return SockJS;
};

var entry = main$1(transportList); // TODO can't get rid of this until all servers do

if ('_sockjs_onload' in commonjsGlobal) {
  setTimeout(commonjsGlobal._sockjs_onload, 1);
}
/**
 * Some byte values, used as per STOMP specifications.
 *
 * Part of `@stomp/stompjs`.
 *
 * @internal
 */


var BYTE = {
  // LINEFEED byte (octet 10)
  LF: '\x0A',
  // NULL byte (octet 0)
  NULL: '\x00'
};
/**
 * Frame class represents a STOMP frame.
 *
 * @internal
 */

var FrameImpl =
/** @class */
function () {
  /**
   * Frame constructor. `command`, `headers` and `body` are available as properties.
   *
   * @internal
   */
  function FrameImpl(params) {
    var command = params.command,
        headers = params.headers,
        body = params.body,
        binaryBody = params.binaryBody,
        escapeHeaderValues = params.escapeHeaderValues,
        skipContentLengthHeader = params.skipContentLengthHeader;
    this.command = command;
    this.headers = Object.assign({}, headers || {});

    if (binaryBody) {
      this._binaryBody = binaryBody;
      this.isBinaryBody = true;
    } else {
      this._body = body || '';
      this.isBinaryBody = false;
    }

    this.escapeHeaderValues = escapeHeaderValues || false;
    this.skipContentLengthHeader = skipContentLengthHeader || false;
  }

  Object.defineProperty(FrameImpl.prototype, "body", {
    /**
     * body of the frame
     */
    get: function get() {
      if (!this._body && this.isBinaryBody) {
        this._body = new TextDecoder().decode(this._binaryBody);
      }

      return this._body;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FrameImpl.prototype, "binaryBody", {
    /**
     * body as Uint8Array
     */
    get: function get() {
      if (!this._binaryBody && !this.isBinaryBody) {
        this._binaryBody = new TextEncoder().encode(this._body);
      }

      return this._binaryBody;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * deserialize a STOMP Frame from raw data.
   *
   * @internal
   */

  FrameImpl.fromRawFrame = function (rawFrame, escapeHeaderValues) {
    var headers = {};

    var trim = function trim(str) {
      return str.replace(/^\s+|\s+$/g, '');
    }; // In case of repeated headers, as per standards, first value need to be used


    for (var _i = 0, _a = rawFrame.headers.reverse(); _i < _a.length; _i++) {
      var header = _a[_i];
      var idx = header.indexOf(':');
      var key = trim(header[0]);
      var value = trim(header[1]);

      if (escapeHeaderValues && rawFrame.command !== 'CONNECT' && rawFrame.command !== 'CONNECTED') {
        value = FrameImpl.hdrValueUnEscape(value);
      }

      headers[key] = value;
    }

    return new FrameImpl({
      command: rawFrame.command,
      headers: headers,
      binaryBody: rawFrame.binaryBody,
      escapeHeaderValues: escapeHeaderValues
    });
  };
  /**
   * @internal
   */


  FrameImpl.prototype.toString = function () {
    return this.serializeCmdAndHeaders();
  };
  /**
   * serialize this Frame in a format suitable to be passed to WebSocket.
   * If the body is string the output will be string.
   * If the body is binary (i.e. of type Unit8Array) it will be serialized to ArrayBuffer.
   *
   * @internal
   */


  FrameImpl.prototype.serialize = function () {
    var cmdAndHeaders = this.serializeCmdAndHeaders();

    if (this.isBinaryBody) {
      return FrameImpl.toUnit8Array(cmdAndHeaders, this._binaryBody).buffer;
    } else {
      return cmdAndHeaders + this._body + BYTE.NULL;
    }
  };

  FrameImpl.prototype.serializeCmdAndHeaders = function () {
    var lines = [this.command];

    if (this.skipContentLengthHeader) {
      delete this.headers['content-length'];
    }

    for (var _i = 0, _a = Object.keys(this.headers || {}); _i < _a.length; _i++) {
      var name_1 = _a[_i];
      var value = this.headers[name_1];

      if (this.escapeHeaderValues && this.command !== 'CONNECT' && this.command !== 'CONNECTED') {
        lines.push(name_1 + ":" + FrameImpl.hdrValueEscape("" + value));
      } else {
        lines.push(name_1 + ":" + value);
      }
    }

    if (this.isBinaryBody || !this.isBodyEmpty() && !this.skipContentLengthHeader) {
      lines.push("content-length:" + this.bodyLength());
    }

    return lines.join(BYTE.LF) + BYTE.LF + BYTE.LF;
  };

  FrameImpl.prototype.isBodyEmpty = function () {
    return this.bodyLength() === 0;
  };

  FrameImpl.prototype.bodyLength = function () {
    var binaryBody = this.binaryBody;
    return binaryBody ? binaryBody.length : 0;
  };
  /**
   * Compute the size of a UTF-8 string by counting its number of bytes
   * (and not the number of characters composing the string)
   */


  FrameImpl.sizeOfUTF8 = function (s) {
    return s ? new TextEncoder().encode(s).length : 0;
  };

  FrameImpl.toUnit8Array = function (cmdAndHeaders, binaryBody) {
    var uint8CmdAndHeaders = new TextEncoder().encode(cmdAndHeaders);
    var nullTerminator = new Uint8Array([0]);
    var uint8Frame = new Uint8Array(uint8CmdAndHeaders.length + binaryBody.length + nullTerminator.length);
    uint8Frame.set(uint8CmdAndHeaders);
    uint8Frame.set(binaryBody, uint8CmdAndHeaders.length);
    uint8Frame.set(nullTerminator, uint8CmdAndHeaders.length + binaryBody.length);
    return uint8Frame;
  };
  /**
   * Serialize a STOMP frame as per STOMP standards, suitable to be sent to the STOMP broker.
   *
   * @internal
   */


  FrameImpl.marshall = function (params) {
    var frame = new FrameImpl(params);
    return frame.serialize();
  };
  /**
   *  Escape header values
   */


  FrameImpl.hdrValueEscape = function (str) {
    return str.replace(/\\/g, '\\\\').replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/:/g, '\\c');
  };
  /**
   * UnEscape header values
   */


  FrameImpl.hdrValueUnEscape = function (str) {
    return str.replace(/\\r/g, '\r').replace(/\\n/g, '\n').replace(/\\c/g, ':').replace(/\\\\/g, '\\');
  };

  return FrameImpl;
}();
/**
 * @internal
 */


var NULL = 0;
/**
 * @internal
 */

var LF = 10;
/**
 * @internal
 */

var CR = 13;
/**
 * @internal
 */

var COLON = 58;
/**
 * This is an evented, rec descent parser.
 * A stream of Octets can be passed and whenever it recognizes
 * a complete Frame or an incoming ping it will invoke the registered callbacks.
 *
 * All incoming Octets are fed into _onByte function.
 * Depending on current state the _onByte function keeps changing.
 * Depending on the state it keeps accumulating into _token and _results.
 * State is indicated by current value of _onByte, all states are named as _collect.
 *
 * STOMP standards https://stomp.github.io/stomp-specification-1.2.html
 * imply that all lengths are considered in bytes (instead of string lengths).
 * So, before actual parsing, if the incoming data is String it is converted to Octets.
 * This allows faithful implementation of the protocol and allows NULL Octets to be present in the body.
 *
 * There is no peek function on the incoming data.
 * When a state change occurs based on an Octet without consuming the Octet,
 * the Octet, after state change, is fed again (_reinjectByte).
 * This became possible as the state change can be determined by inspecting just one Octet.
 *
 * There are two modes to collect the body, if content-length header is there then it by counting Octets
 * otherwise it is determined by NULL terminator.
 *
 * Following the standards, the command and headers are converted to Strings
 * and the body is returned as Octets.
 * Headers are returned as an array and not as Hash - to allow multiple occurrence of an header.
 *
 * This parser does not use Regular Expressions as that can only operate on Strings.
 *
 * It handles if multiple STOMP frames are given as one chunk, a frame is split into multiple chunks, or
 * any combination there of. The parser remembers its state (any partial frame) and continues when a new chunk
 * is pushed.
 *
 * Typically the higher level function will convert headers to Hash, handle unescaping of header values
 * (which is protocol version specific), and convert body to text.
 *
 * Check the parser.spec.js to understand cases that this parser is supposed to handle.
 *
 * Part of `@stomp/stompjs`.
 *
 * @internal
 */

var Parser =
/** @class */
function () {
  function Parser(onFrame, onIncomingPing) {
    this.onFrame = onFrame;
    this.onIncomingPing = onIncomingPing;
    this._encoder = new TextEncoder();
    this._decoder = new TextDecoder();
    this._token = [];

    this._initState();
  }

  Parser.prototype.parseChunk = function (segment, appendMissingNULLonIncoming) {
    if (appendMissingNULLonIncoming === void 0) {
      appendMissingNULLonIncoming = false;
    }

    var chunk;

    if (segment instanceof ArrayBuffer) {
      chunk = new Uint8Array(segment);
    } else {
      chunk = this._encoder.encode(segment);
    } // See https://github.com/stomp-js/stompjs/issues/89
    // Remove when underlying issue is fixed.
    //
    // Send a NULL byte, if the last byte of a Text frame was not NULL.F


    if (appendMissingNULLonIncoming && chunk[chunk.length - 1] !== 0) {
      var chunkWithNull = new Uint8Array(chunk.length + 1);
      chunkWithNull.set(chunk, 0);
      chunkWithNull[chunk.length] = 0;
      chunk = chunkWithNull;
    } // tslint:disable-next-line:prefer-for-of


    for (var i = 0; i < chunk.length; i++) {
      var byte = chunk[i];

      this._onByte(byte);
    }
  }; // The following implements a simple Rec Descent Parser.
  // The grammar is simple and just one byte tells what should be the next state


  Parser.prototype._collectFrame = function (byte) {
    if (byte === NULL) {
      // Ignore
      return;
    }

    if (byte === CR) {
      // Ignore CR
      return;
    }

    if (byte === LF) {
      // Incoming Ping
      this.onIncomingPing();
      return;
    }

    this._onByte = this._collectCommand;

    this._reinjectByte(byte);
  };

  Parser.prototype._collectCommand = function (byte) {
    if (byte === CR) {
      // Ignore CR
      return;
    }

    if (byte === LF) {
      this._results.command = this._consumeTokenAsUTF8();
      this._onByte = this._collectHeaders;
      return;
    }

    this._consumeByte(byte);
  };

  Parser.prototype._collectHeaders = function (byte) {
    if (byte === CR) {
      // Ignore CR
      return;
    }

    if (byte === LF) {
      this._setupCollectBody();

      return;
    }

    this._onByte = this._collectHeaderKey;

    this._reinjectByte(byte);
  };

  Parser.prototype._reinjectByte = function (byte) {
    this._onByte(byte);
  };

  Parser.prototype._collectHeaderKey = function (byte) {
    if (byte === COLON) {
      this._headerKey = this._consumeTokenAsUTF8();
      this._onByte = this._collectHeaderValue;
      return;
    }

    this._consumeByte(byte);
  };

  Parser.prototype._collectHeaderValue = function (byte) {
    if (byte === CR) {
      // Ignore CR
      return;
    }

    if (byte === LF) {
      this._results.headers.push([this._headerKey, this._consumeTokenAsUTF8()]);

      this._headerKey = undefined;
      this._onByte = this._collectHeaders;
      return;
    }

    this._consumeByte(byte);
  };

  Parser.prototype._setupCollectBody = function () {
    var contentLengthHeader = this._results.headers.filter(function (header) {
      return header[0] === 'content-length';
    })[0];

    if (contentLengthHeader) {
      this._bodyBytesRemaining = parseInt(contentLengthHeader[1], 10);
      this._onByte = this._collectBodyFixedSize;
    } else {
      this._onByte = this._collectBodyNullTerminated;
    }
  };

  Parser.prototype._collectBodyNullTerminated = function (byte) {
    if (byte === NULL) {
      this._retrievedBody();

      return;
    }

    this._consumeByte(byte);
  };

  Parser.prototype._collectBodyFixedSize = function (byte) {
    // It is post decrement, so that we discard the trailing NULL octet
    if (this._bodyBytesRemaining-- === 0) {
      this._retrievedBody();

      return;
    }

    this._consumeByte(byte);
  };

  Parser.prototype._retrievedBody = function () {
    this._results.binaryBody = this._consumeTokenAsRaw();
    this.onFrame(this._results);

    this._initState();
  }; // Rec Descent Parser helpers


  Parser.prototype._consumeByte = function (byte) {
    this._token.push(byte);
  };

  Parser.prototype._consumeTokenAsUTF8 = function () {
    return this._decoder.decode(this._consumeTokenAsRaw());
  };

  Parser.prototype._consumeTokenAsRaw = function () {
    var rawResult = new Uint8Array(this._token);
    this._token = [];
    return rawResult;
  };

  Parser.prototype._initState = function () {
    this._results = {
      command: undefined,
      headers: [],
      binaryBody: undefined
    };
    this._token = [];
    this._headerKey = undefined;
    this._onByte = this._collectFrame;
  };

  return Parser;
}();
/**
 * Supported STOMP versions
 *
 * Part of `@stomp/stompjs`.
 */


var Versions =
/** @class */
function () {
  /**
   * Takes an array of string of versions, typical elements '1.0', '1.1', or '1.2'
   *
   * You will an instance if this class if you want to override supported versions to be declared during
   * STOMP handshake.
   */
  function Versions(versions) {
    this.versions = versions;
  }
  /**
   * Used as part of CONNECT STOMP Frame
   */


  Versions.prototype.supportedVersions = function () {
    return this.versions.join(',');
  };
  /**
   * Used while creating a WebSocket
   */


  Versions.prototype.protocolVersions = function () {
    return this.versions.map(function (x) {
      return "v" + x.replace('.', '') + ".stomp";
    });
  };
  /**
   * Indicates protocol version 1.0
   */


  Versions.V1_0 = '1.0';
  /**
   * Indicates protocol version 1.1
   */

  Versions.V1_1 = '1.1';
  /**
   * Indicates protocol version 1.2
   */

  Versions.V1_2 = '1.2';
  /**
   * @internal
   */

  Versions.default = new Versions([Versions.V1_0, Versions.V1_1, Versions.V1_2]);
  return Versions;
}();
/**
 * Possible states for the WebSocket, copied here to avoid dependency on WebSocket class
 *
 * Part of `@stomp/rx-stomp`
 *
 * @internal
 */


var WebSocketState;

(function (WebSocketState) {
  WebSocketState[WebSocketState["CONNECTING"] = 0] = "CONNECTING";
  WebSocketState[WebSocketState["OPEN"] = 1] = "OPEN";
  WebSocketState[WebSocketState["CLOSING"] = 2] = "CLOSING";
  WebSocketState[WebSocketState["CLOSED"] = 3] = "CLOSED";
})(WebSocketState || (WebSocketState = {}));
/**
 * The STOMP protocol handler
 *
 * Part of `@stomp/stompjs`.
 *
 * @internal
 */


var StompHandler =
/** @class */
function () {
  function StompHandler(_client, _webSocket, config) {
    var _this = this;

    if (config === void 0) {
      config = {};
    }

    this._client = _client;
    this._webSocket = _webSocket;
    this._serverFrameHandlers = {
      // [CONNECTED Frame](http://stomp.github.com/stomp-specification-1.2.html#CONNECTED_Frame)
      CONNECTED: function CONNECTED(frame) {
        _this.debug("connected to server " + frame.headers.server);

        _this._connected = true;
        _this._connectedVersion = frame.headers.version; // STOMP version 1.2 needs header values to be escaped

        if (_this._connectedVersion === Versions.V1_2) {
          _this._escapeHeaderValues = true;
        }

        _this._setupHeartbeat(frame.headers);

        _this.onConnect(frame);
      },
      // [MESSAGE Frame](http://stomp.github.com/stomp-specification-1.2.html#MESSAGE)
      MESSAGE: function MESSAGE(frame) {
        // the callback is registered when the client calls
        // `subscribe()`.
        // If there is no registered subscription for the received message,
        // the default `onUnhandledMessage` callback is used that the client can set.
        // This is useful for subscriptions that are automatically created
        // on the browser side (e.g. [RabbitMQ's temporary
        // queues](http://www.rabbitmq.com/stomp.html)).
        var subscription = frame.headers.subscription;
        var onReceive = _this._subscriptions[subscription] || _this.onUnhandledMessage; // bless the frame to be a Message

        var message = frame;
        var client = _this;
        var messageId = _this._connectedVersion === Versions.V1_2 ? message.headers.ack : message.headers['message-id']; // add `ack()` and `nack()` methods directly to the returned frame
        // so that a simple call to `message.ack()` can acknowledge the message.

        message.ack = function (headers) {
          if (headers === void 0) {
            headers = {};
          }

          return client.ack(messageId, subscription, headers);
        };

        message.nack = function (headers) {
          if (headers === void 0) {
            headers = {};
          }

          return client.nack(messageId, subscription, headers);
        };

        onReceive(message);
      },
      // [RECEIPT Frame](http://stomp.github.com/stomp-specification-1.2.html#RECEIPT)
      RECEIPT: function RECEIPT(frame) {
        var callback = _this._receiptWatchers[frame.headers['receipt-id']];

        if (callback) {
          callback(frame); // Server will acknowledge only once, remove the callback

          delete _this._receiptWatchers[frame.headers['receipt-id']];
        } else {
          _this.onUnhandledReceipt(frame);
        }
      },
      // [ERROR Frame](http://stomp.github.com/stomp-specification-1.2.html#ERROR)
      ERROR: function ERROR(frame) {
        _this.onStompError(frame);
      }
    }; // used to index subscribers

    this._counter = 0; // subscription callbacks indexed by subscriber's ID

    this._subscriptions = {}; // receipt-watchers indexed by receipts-ids

    this._receiptWatchers = {};
    this._partialData = '';
    this._escapeHeaderValues = false;
    this._lastServerActivityTS = Date.now();
    this.configure(config);
  }

  Object.defineProperty(StompHandler.prototype, "connectedVersion", {
    get: function get() {
      return this._connectedVersion;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StompHandler.prototype, "connected", {
    get: function get() {
      return this._connected;
    },
    enumerable: true,
    configurable: true
  });

  StompHandler.prototype.configure = function (conf) {
    // bulk assign all properties to this
    Object.assign(this, conf);
  };

  StompHandler.prototype.start = function () {
    var _this = this;

    var parser = new Parser( // On Frame
    function (rawFrame) {
      var frame = FrameImpl.fromRawFrame(rawFrame, _this._escapeHeaderValues); // if this.logRawCommunication is set, the rawChunk is logged at this._webSocket.onmessage

      if (!_this.logRawCommunication) {
        _this.debug("<<< " + frame);
      }

      var serverFrameHandler = _this._serverFrameHandlers[frame.command] || _this.onUnhandledFrame;
      serverFrameHandler(frame);
    }, // On Incoming Ping
    function () {
      _this.debug('<<< PONG');
    });

    this._webSocket.onmessage = function (evt) {
      _this.debug('Received data');

      _this._lastServerActivityTS = Date.now();

      if (_this.logRawCommunication) {
        var rawChunkAsString = evt.data instanceof ArrayBuffer ? new TextDecoder().decode(evt.data) : evt.data;

        _this.debug("<<< " + rawChunkAsString);
      }

      parser.parseChunk(evt.data, _this.appendMissingNULLonIncoming);
    };

    this._webSocket.onclose = function (closeEvent) {
      _this.debug("Connection closed to " + _this._webSocket.url);

      _this.onWebSocketClose(closeEvent);

      _this._cleanUp();
    };

    this._webSocket.onerror = function (errorEvent) {
      _this.onWebSocketError(errorEvent);
    };

    this._webSocket.onopen = function () {
      // Clone before updating
      var connectHeaders = Object.assign({}, _this.connectHeaders);

      _this.debug('Web Socket Opened...');

      connectHeaders['accept-version'] = _this.stompVersions.supportedVersions();
      connectHeaders['heart-beat'] = [_this.heartbeatOutgoing, _this.heartbeatIncoming].join(',');

      _this._transmit({
        command: 'CONNECT',
        headers: connectHeaders
      });
    };
  };

  StompHandler.prototype._setupHeartbeat = function (headers) {
    var _this = this;

    if (headers.version !== Versions.V1_1 && headers.version !== Versions.V1_2) {
      return;
    } // heart-beat header received from the server looks like:
    //
    //     heart-beat: sx, sy


    var _a = headers['heart-beat'].split(',').map(function (v) {
      return parseInt(v, 10);
    }),
        serverOutgoing = _a[0],
        serverIncoming = _a[1];

    if (this.heartbeatOutgoing !== 0 && serverIncoming !== 0) {
      var ttl = Math.max(this.heartbeatOutgoing, serverIncoming);
      this.debug("send PING every " + ttl + "ms");
      this._pinger = setInterval(function () {
        if (_this._webSocket.readyState === WebSocketState.OPEN) {
          _this._webSocket.send(BYTE.LF);

          _this.debug('>>> PING');
        }
      }, ttl);
    }

    if (this.heartbeatIncoming !== 0 && serverOutgoing !== 0) {
      var ttl_1 = Math.max(this.heartbeatIncoming, serverOutgoing);
      this.debug("check PONG every " + ttl_1 + "ms");
      this._ponger = setInterval(function () {
        var delta = Date.now() - _this._lastServerActivityTS; // We wait twice the TTL to be flexible on window's setInterval calls


        if (delta > ttl_1 * 2) {
          _this.debug("did not receive server activity for the last " + delta + "ms");

          _this._webSocket.close();
        }
      }, ttl_1);
    }
  };

  StompHandler.prototype._transmit = function (params) {
    var command = params.command,
        headers = params.headers,
        body = params.body,
        binaryBody = params.binaryBody,
        skipContentLengthHeader = params.skipContentLengthHeader;
    var frame = new FrameImpl({
      command: command,
      headers: headers,
      body: body,
      binaryBody: binaryBody,
      escapeHeaderValues: this._escapeHeaderValues,
      skipContentLengthHeader: skipContentLengthHeader
    });
    var rawChunk = frame.serialize();

    if (this.logRawCommunication) {
      this.debug(">>> " + rawChunk);
    } else {
      this.debug(">>> " + frame);
    }

    if (this.forceBinaryWSFrames && typeof rawChunk === 'string') {
      rawChunk = new TextEncoder().encode(rawChunk);
    }

    if (typeof rawChunk !== 'string' || !this.splitLargeFrames) {
      this._webSocket.send(rawChunk);
    } else {
      var out = rawChunk;

      while (out.length > 0) {
        var chunk = out.substring(0, this.maxWebSocketChunkSize);
        out = out.substring(this.maxWebSocketChunkSize);

        this._webSocket.send(chunk);

        this.debug("chunk sent = " + chunk.length + ", remaining = " + out.length);
      }
    }
  };

  StompHandler.prototype.dispose = function () {
    var _this = this;

    if (this.connected) {
      try {
        // clone before updating
        var disconnectHeaders = Object.assign({}, this.disconnectHeaders);

        if (!disconnectHeaders.receipt) {
          disconnectHeaders.receipt = "close-" + this._counter++;
        }

        this.watchForReceipt(disconnectHeaders.receipt, function (frame) {
          _this._webSocket.close();

          _this._cleanUp();

          _this.onDisconnect(frame);
        });

        this._transmit({
          command: 'DISCONNECT',
          headers: disconnectHeaders
        });
      } catch (error) {
        this.debug("Ignoring error during disconnect " + error);
      }
    } else {
      if (this._webSocket.readyState === WebSocketState.CONNECTING || this._webSocket.readyState === WebSocketState.OPEN) {
        this._webSocket.close();
      }
    }
  };

  StompHandler.prototype._cleanUp = function () {
    this._connected = false;

    if (this._pinger) {
      clearInterval(this._pinger);
    }

    if (this._ponger) {
      clearInterval(this._ponger);
    }
  };

  StompHandler.prototype.publish = function (params) {
    var destination = params.destination,
        headers = params.headers,
        body = params.body,
        binaryBody = params.binaryBody,
        skipContentLengthHeader = params.skipContentLengthHeader;
    var hdrs = Object.assign({
      destination: destination
    }, headers);

    this._transmit({
      command: 'SEND',
      headers: hdrs,
      body: body,
      binaryBody: binaryBody,
      skipContentLengthHeader: skipContentLengthHeader
    });
  };

  StompHandler.prototype.watchForReceipt = function (receiptId, callback) {
    this._receiptWatchers[receiptId] = callback;
  };

  StompHandler.prototype.subscribe = function (destination, callback, headers) {
    if (headers === void 0) {
      headers = {};
    }

    headers = Object.assign({}, headers);

    if (!headers.id) {
      headers.id = "sub-" + this._counter++;
    }

    headers.destination = destination;
    this._subscriptions[headers.id] = callback;

    this._transmit({
      command: 'SUBSCRIBE',
      headers: headers
    });

    var client = this;
    return {
      id: headers.id,
      unsubscribe: function unsubscribe(hdrs) {
        return client.unsubscribe(headers.id, hdrs);
      }
    };
  };

  StompHandler.prototype.unsubscribe = function (id, headers) {
    if (headers === void 0) {
      headers = {};
    }

    headers = Object.assign({}, headers);
    delete this._subscriptions[id];
    headers.id = id;

    this._transmit({
      command: 'UNSUBSCRIBE',
      headers: headers
    });
  };

  StompHandler.prototype.begin = function (transactionId) {
    var txId = transactionId || "tx-" + this._counter++;

    this._transmit({
      command: 'BEGIN',
      headers: {
        transaction: txId
      }
    });

    var client = this;
    return {
      id: txId,
      commit: function commit() {
        client.commit(txId);
      },
      abort: function abort() {
        client.abort(txId);
      }
    };
  };

  StompHandler.prototype.commit = function (transactionId) {
    this._transmit({
      command: 'COMMIT',
      headers: {
        transaction: transactionId
      }
    });
  };

  StompHandler.prototype.abort = function (transactionId) {
    this._transmit({
      command: 'ABORT',
      headers: {
        transaction: transactionId
      }
    });
  };

  StompHandler.prototype.ack = function (messageId, subscriptionId, headers) {
    if (headers === void 0) {
      headers = {};
    }

    headers = Object.assign({}, headers);

    if (this._connectedVersion === Versions.V1_2) {
      headers.id = messageId;
    } else {
      headers['message-id'] = messageId;
    }

    headers.subscription = subscriptionId;

    this._transmit({
      command: 'ACK',
      headers: headers
    });
  };

  StompHandler.prototype.nack = function (messageId, subscriptionId, headers) {
    if (headers === void 0) {
      headers = {};
    }

    headers = Object.assign({}, headers);

    if (this._connectedVersion === Versions.V1_2) {
      headers.id = messageId;
    } else {
      headers['message-id'] = messageId;
    }

    headers.subscription = subscriptionId;
    return this._transmit({
      command: 'NACK',
      headers: headers
    });
  };

  return StompHandler;
}();

var __awaiter = null && null.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = null && null.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/**
 * STOMP Client Class.
 *
 * Part of `@stomp/stompjs`.
 */


var Client =
/** @class */
function () {
  /**
   * Create an instance.
   */
  function Client(conf) {
    if (conf === void 0) {
      conf = {};
    }
    /**
     * STOMP versions to attempt during STOMP handshake. By default versions `1.0`, `1.1`, and `1.2` are attempted.
     *
     * Example:
     * ```javascript
     *        // Try only versions 1.0 and 1.1
     *        client.stompVersions = new Versions(['1.0', '1.1'])
     * ```
     */


    this.stompVersions = Versions.default;
    /**
     *  automatically reconnect with delay in milliseconds, set to 0 to disable.
     */

    this.reconnectDelay = 5000;
    /**
     * Incoming heartbeat interval in milliseconds. Set to 0 to disable.
     */

    this.heartbeatIncoming = 10000;
    /**
     * Outgoing heartbeat interval in milliseconds. Set to 0 to disable.
     */

    this.heartbeatOutgoing = 10000;
    /**
     * This switches on a non standard behavior while sending WebSocket packets.
     * It splits larger (text) packets into chunks of [maxWebSocketChunkSize]{@link Client#maxWebSocketChunkSize}.
     * Only Java Spring brokers seems to use this mode.
     *
     * WebSockets, by itself, split large (text) packets,
     * so it is not needed with a truly compliant STOMP/WebSocket broker.
     * Actually setting it for such broker will cause large messages to fail.
     *
     * `false` by default.
     *
     * Binary frames are never split.
     */

    this.splitLargeFrames = false;
    /**
     * See [splitLargeFrames]{@link Client#splitLargeFrames}.
     * This has no effect if [splitLargeFrames]{@link Client#splitLargeFrames} is `false`.
     */

    this.maxWebSocketChunkSize = 8 * 1024;
    /**
     * Usually the
     * [type of WebSocket frame]{@link https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send#Parameters}
     * is automatically decided by type of the payload.
     * Default is `false`, which should work with all compliant brokers.
     *
     * Set this flag to force binary frames.
     */

    this.forceBinaryWSFrames = false;
    /**
     * A bug in ReactNative chops a string on occurrence of a NULL.
     * See issue [https://github.com/stomp-js/stompjs/issues/89]{@link https://github.com/stomp-js/stompjs/issues/89}.
     * This makes incoming WebSocket messages invalid STOMP packets.
     * Setting this flag attempts to reverse the damage by appending a NULL.
     * If the broker splits a large message into multiple WebSocket messages,
     * this flag will cause data loss and abnormal termination of connection.
     *
     * This is not an ideal solution, but a stop gap until the underlying issue is fixed at ReactNative library.
     */

    this.appendMissingNULLonIncoming = false;
    this._active = false; // Dummy callbacks

    var noOp = function noOp() {};

    this.debug = noOp;
    this.beforeConnect = noOp;
    this.onConnect = noOp;
    this.onDisconnect = noOp;
    this.onUnhandledMessage = noOp;
    this.onUnhandledReceipt = noOp;
    this.onUnhandledFrame = noOp;
    this.onStompError = noOp;
    this.onWebSocketClose = noOp;
    this.onWebSocketError = noOp;
    this.logRawCommunication = false; // These parameters would typically get proper values before connect is called

    this.connectHeaders = {};
    this._disconnectHeaders = {}; // Apply configuration

    this.configure(conf);
  }

  Object.defineProperty(Client.prototype, "webSocket", {
    /**
     * Underlying WebSocket instance, READONLY.
     */
    get: function get() {
      return this._webSocket;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Client.prototype, "disconnectHeaders", {
    /**
     * Disconnection headers.
     */
    get: function get() {
      return this._disconnectHeaders;
    },
    set: function set(value) {
      this._disconnectHeaders = value;

      if (this._stompHandler) {
        this._stompHandler.disconnectHeaders = this._disconnectHeaders;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Client.prototype, "connected", {
    /**
     * `true` if there is a active connection with STOMP Broker
     */
    get: function get() {
      return !!this._stompHandler && this._stompHandler.connected;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Client.prototype, "connectedVersion", {
    /**
     * version of STOMP protocol negotiated with the server, READONLY
     */
    get: function get() {
      return this._stompHandler ? this._stompHandler.connectedVersion : undefined;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Client.prototype, "active", {
    /**
     * if the client is active (connected or going to reconnect)
     */
    get: function get() {
      return this._active;
    },
    enumerable: true,
    configurable: true
  });
  /**
   * Update configuration.
   */

  Client.prototype.configure = function (conf) {
    // bulk assign all properties to this
    Object.assign(this, conf);
  };
  /**
   * Initiate the connection with the broker.
   * If the connection breaks, as per [Client#reconnectDelay]{@link Client#reconnectDelay},
   * it will keep trying to reconnect.
   *
   * Call [Client#deactivate]{@link Client#deactivate} to disconnect and stop reconnection attempts.
   */


  Client.prototype.activate = function () {
    this._active = true;

    this._connect();
  };

  Client.prototype._connect = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.connected) {
              this.debug('STOMP: already connected, nothing to do');
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , this.beforeConnect()];

          case 1:
            _a.sent();

            if (!this._active) {
              this.debug('Client has been marked inactive, will not attempt to connect');
              return [2
              /*return*/
              ];
            }

            this.debug('Opening Web Socket...'); // Get the actual WebSocket (or a similar object)

            this._webSocket = this._createWebSocket();
            this._stompHandler = new StompHandler(this, this._webSocket, {
              debug: this.debug,
              stompVersions: this.stompVersions,
              connectHeaders: this.connectHeaders,
              disconnectHeaders: this._disconnectHeaders,
              heartbeatIncoming: this.heartbeatIncoming,
              heartbeatOutgoing: this.heartbeatOutgoing,
              splitLargeFrames: this.splitLargeFrames,
              maxWebSocketChunkSize: this.maxWebSocketChunkSize,
              forceBinaryWSFrames: this.forceBinaryWSFrames,
              logRawCommunication: this.logRawCommunication,
              appendMissingNULLonIncoming: this.appendMissingNULLonIncoming,
              onConnect: function onConnect(frame) {
                if (!_this._active) {
                  _this.debug('STOMP got connected while deactivate was issued, will disconnect now');

                  _this._disposeStompHandler();

                  return;
                }

                _this.onConnect(frame);
              },
              onDisconnect: function onDisconnect(frame) {
                _this.onDisconnect(frame);
              },
              onStompError: function onStompError(frame) {
                _this.onStompError(frame);
              },
              onWebSocketClose: function onWebSocketClose(evt) {
                _this.onWebSocketClose(evt); // The callback is called before attempting to reconnect, this would allow the client
                // to be `deactivated` in the callback.


                if (_this._active) {
                  _this._schedule_reconnect();
                }
              },
              onWebSocketError: function onWebSocketError(evt) {
                _this.onWebSocketError(evt);
              },
              onUnhandledMessage: function onUnhandledMessage(message) {
                _this.onUnhandledMessage(message);
              },
              onUnhandledReceipt: function onUnhandledReceipt(frame) {
                _this.onUnhandledReceipt(frame);
              },
              onUnhandledFrame: function onUnhandledFrame(frame) {
                _this.onUnhandledFrame(frame);
              }
            });

            this._stompHandler.start();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Client.prototype._createWebSocket = function () {
    var webSocket;

    if (this.webSocketFactory) {
      webSocket = this.webSocketFactory();
    } else {
      webSocket = new WebSocket(this.brokerURL, this.stompVersions.protocolVersions());
    }

    webSocket.binaryType = 'arraybuffer';
    return webSocket;
  };

  Client.prototype._schedule_reconnect = function () {
    var _this = this;

    if (this.reconnectDelay > 0) {
      this.debug("STOMP: scheduling reconnection in " + this.reconnectDelay + "ms");
      this._reconnector = setTimeout(function () {
        _this._connect();
      }, this.reconnectDelay);
    }
  };
  /**
   * Disconnect if connected and stop auto reconnect loop.
   * Appropriate callbacks will be invoked if underlying STOMP connection was connected.
   *
   * To reactivate you can call [Client#activate]{@link Client#activate}.
   */


  Client.prototype.deactivate = function () {
    // indicate that auto reconnect loop should terminate
    this._active = false; // Clear if a reconnection was scheduled

    if (this._reconnector) {
      clearTimeout(this._reconnector);
    }

    this._disposeStompHandler();
  };
  /**
   * Force disconnect if there is an active connection by directly closing the underlying WebSocket.
   * This is different than a normal disconnect where a DISCONNECT sequence is carried out with the broker.
   * After forcing disconnect, automatic reconnect will be attempted.
   * To stop further reconnects call [Client#deactivate]{@link Client#deactivate} as well.
   */


  Client.prototype.forceDisconnect = function () {
    if (this._webSocket) {
      if (this._webSocket.readyState === WebSocketState.CONNECTING || this._webSocket.readyState === WebSocketState.OPEN) {
        this._webSocket.close();
      }
    }
  };

  Client.prototype._disposeStompHandler = function () {
    // Dispose STOMP Handler
    if (this._stompHandler) {
      this._stompHandler.dispose();

      this._stompHandler = null;
    }
  };
  /**
   * Send a message to a named destination. Refer to your STOMP broker documentation for types
   * and naming of destinations.
   *
   * STOMP protocol specifies and suggests some headers and also allows broker specific headers.
   *
   * `body` must be String.
   * You will need to covert the payload to string in case it is not string (e.g. JSON).
   *
   * To send a binary message body use binaryBody parameter. It should be a
   * [Uint8Array](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array).
   * Sometimes brokers may not support binary frames out of the box.
   * Please check your broker documentation.
   *
   * `content-length` header is automatically added to the STOMP Frame sent to the broker.
   * Set `skipContentLengthHeader` to indicate that `content-length` header should not be added.
   * For binary messages `content-length` header is always added.
   *
   * Caution: The broker will, most likely, report an error and disconnect if message body has NULL octet(s)
   * and `content-length` header is missing.
   *
   * ```javascript
   *        client.publish({destination: "/queue/test", headers: {priority: 9}, body: "Hello, STOMP"});
   *
   *        // Only destination is mandatory parameter
   *        client.publish({destination: "/queue/test", body: "Hello, STOMP"});
   *
   *        // Skip content-length header in the frame to the broker
   *        client.publish({"/queue/test", body: "Hello, STOMP", skipContentLengthHeader: true});
   *
   *        var binaryData = generateBinaryData(); // This need to be of type Uint8Array
   *        // setting content-type header is not mandatory, however a good practice
   *        client.publish({destination: '/topic/special', binaryBody: binaryData,
   *                         headers: {'content-type': 'application/octet-stream'}});
   * ```
   */


  Client.prototype.publish = function (params) {
    this._stompHandler.publish(params);
  };
  /**
   * STOMP brokers may carry out operation asynchronously and allow requesting for acknowledgement.
   * To request an acknowledgement, a `receipt` header needs to be sent with the actual request.
   * The value (say receipt-id) for this header needs to be unique for each use. Typically a sequence, a UUID, a
   * random number or a combination may be used.
   *
   * A complaint broker will send a RECEIPT frame when an operation has actually been completed.
   * The operation needs to be matched based in the value of the receipt-id.
   *
   * This method allow watching for a receipt and invoke the callback
   * when corresponding receipt has been received.
   *
   * The actual {@link FrameImpl} will be passed as parameter to the callback.
   *
   * Example:
   * ```javascript
   *        // Subscribing with acknowledgement
   *        let receiptId = randomText();
   *
   *        client.watchForReceipt(receiptId, function() {
   *          // Will be called after server acknowledges
   *        });
   *
   *        client.subscribe(TEST.destination, onMessage, {receipt: receiptId});
   *
   *
   *        // Publishing with acknowledgement
   *        receiptId = randomText();
   *
   *        client.watchForReceipt(receiptId, function() {
   *          // Will be called after server acknowledges
   *        });
   *        client.publish({destination: TEST.destination, headers: {receipt: receiptId}, body: msg});
   * ```
   */


  Client.prototype.watchForReceipt = function (receiptId, callback) {
    this._stompHandler.watchForReceipt(receiptId, callback);
  };
  /**
   * Subscribe to a STOMP Broker location. The callback will be invoked for each received message with
   * the {@link IMessage} as argument.
   *
   * Note: The library will generate an unique ID if there is none provided in the headers.
   *       To use your own ID, pass it using the headers argument.
   *
   * ```javascript
   *        callback = function(message) {
   *        // called when the client receives a STOMP message from the server
   *          if (message.body) {
   *            alert("got message with body " + message.body)
   *          } else {
   *            alert("got empty message");
   *          }
   *        });
   *
   *        var subscription = client.subscribe("/queue/test", callback);
   *
   *        // Explicit subscription id
   *        var mySubId = 'my-subscription-id-001';
   *        var subscription = client.subscribe(destination, callback, { id: mySubId });
   * ```
   */


  Client.prototype.subscribe = function (destination, callback, headers) {
    if (headers === void 0) {
      headers = {};
    }

    return this._stompHandler.subscribe(destination, callback, headers);
  };
  /**
   * It is preferable to unsubscribe from a subscription by calling
   * `unsubscribe()` directly on {@link StompSubscription} returned by `client.subscribe()`:
   *
   * ```javascript
   *        var subscription = client.subscribe(destination, onmessage);
   *        // ...
   *        subscription.unsubscribe();
   * ```
   *
   * See: http://stomp.github.com/stomp-specification-1.2.html#UNSUBSCRIBE UNSUBSCRIBE Frame
   */


  Client.prototype.unsubscribe = function (id, headers) {
    if (headers === void 0) {
      headers = {};
    }

    this._stompHandler.unsubscribe(id, headers);
  };
  /**
   * Start a transaction, the returned {@link ITransaction} has methods - [commit]{@link ITransaction#commit}
   * and [abort]{@link ITransaction#abort}.
   *
   * `transactionId` is optional, if not passed the library will generate it internally.
   */


  Client.prototype.begin = function (transactionId) {
    return this._stompHandler.begin(transactionId);
  };
  /**
   * Commit a transaction.
   *
   * It is preferable to commit a transaction by calling [commit]{@link ITransaction#commit} directly on
   * {@link ITransaction} returned by [client.begin]{@link Client#begin}.
   *
   * ```javascript
   *        var tx = client.begin(txId);
   *        //...
   *        tx.commit();
   * ```
   */


  Client.prototype.commit = function (transactionId) {
    this._stompHandler.commit(transactionId);
  };
  /**
   * Abort a transaction.
   * It is preferable to abort a transaction by calling [abort]{@link ITransaction#abort} directly on
   * {@link ITransaction} returned by [client.begin]{@link Client#begin}.
   *
   * ```javascript
   *        var tx = client.begin(txId);
   *        //...
   *        tx.abort();
   * ```
   */


  Client.prototype.abort = function (transactionId) {
    this._stompHandler.abort(transactionId);
  };
  /**
   * ACK a message. It is preferable to acknowledge a message by calling [ack]{@link IMessage#ack} directly
   * on the {@link IMessage} handled by a subscription callback:
   *
   * ```javascript
   *        var callback = function (message) {
   *          // process the message
   *          // acknowledge it
   *          message.ack();
   *        };
   *        client.subscribe(destination, callback, {'ack': 'client'});
   * ```
   */


  Client.prototype.ack = function (messageId, subscriptionId, headers) {
    if (headers === void 0) {
      headers = {};
    }

    this._stompHandler.ack(messageId, subscriptionId, headers);
  };
  /**
   * NACK a message. It is preferable to acknowledge a message by calling [nack]{@link IMessage#nack} directly
   * on the {@link IMessage} handled by a subscription callback:
   *
   * ```javascript
   *        var callback = function (message) {
   *          // process the message
   *          // an error occurs, nack it
   *          message.nack();
   *        };
   *        client.subscribe(destination, callback, {'ack': 'client'});
   * ```
   */


  Client.prototype.nack = function (messageId, subscriptionId, headers) {
    if (headers === void 0) {
      headers = {};
    }

    this._stompHandler.nack(messageId, subscriptionId, headers);
  };

  return Client;
}();

var StompClient = /*#__PURE__*/function (_React$Component) {
  function StompClient(props) {
    var _this;

    _classCallCheck(this, StompClient);

    _this = _callSuper(this, StompClient, [props]);

    _this.subscribe = function () {
      _this.props.topics.forEach(function (topic) {
        _this.state.client.subscribe(topic, function (msg) {
          _this.props.onMessage(_this.parseMessage(msg.body), msg.headers.destination);
        });
      });
    };

    _this.debug = function (str) {
      if (_this.props.debug) {
        console.log(str);
      }
    };

    _this.disconnect = function () {
      _this.setState({
        connected: false
      });

      _this.state.client.deactivate();

      _this.props.onDisconnect();
    };

    _this.connect = function () {
      var that = _this;

      var client = _this.setUpClient();

      client.onConnect = function () {
        that.props.onConnect();
        that.subscribe();
      };

      client.onStompError = function (frame) {
        that.debug('Broker reported error: ' + frame.headers['message']);
        that.debug('Additional details: ' + frame.body);

        _this.disconnect();
      };

      client.activate();
    };

    _this.setUpClient = function () {
      var client = new Client({
        webSocketFactory: function webSocketFactory() {
          return new entry(_this.props.url);
        },
        debug: _this.debug,
        reconnectDelay: _this.props.reconnectDelay,
        heartbeatIncoming: _this.props.heartbeatIncoming,
        heartbeatOutgoing: _this.props.heartbeatIncoming
      });

      _this.setState({
        client: client
      });

      return client;
    };

    _this.parseMessage = function (msg) {
      try {
        return JSON.parse(msg);
      } catch (e) {
        return msg;
      }
    };

    _this.state = {
      client: null
    };
    return _this;
  }

  _inherits(StompClient, _React$Component);

  return _createClass(StompClient, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.connect();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disconnect();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(React.Component);

StompClient.defaultProps = {
  onConnect: function onConnect() {},
  onDisconnect: function onDisconnect() {},
  onMessage: function onMessage() {},
  debug: false,
  reconnectDelay: 3000,
  heartbeatIncoming: 10000,
  heartbeatOutgoing: 10000
};
StompClient.propTypes = {
  url: PropTypes__default.string.isRequired,
  topics: PropTypes__default.array.isRequired,
  onConnect: PropTypes__default.func,
  onDisconnect: PropTypes__default.func,

  /** Should be able to handle the incoming message and destination (topic) - onMessage = (message, topic) => {}**/
  onMessage: PropTypes__default.func,
  debug: PropTypes__default.bool,
  reconnectDelay: PropTypes__default.number,
  heartbeatIncoming: PropTypes__default.number,
  heartbeatOutgoing: PropTypes__default.number
};
/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var lodash_isnil = isNil;
var has$1 = Object.prototype.hasOwnProperty;

var hexTable = function () {
  var array = [];

  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }

  return array;
}();

var compactQueue = function compactQueue(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];

    if (Array.isArray(obj)) {
      var compacted = [];

      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }

      item.obj[item.prop] = compacted;
    }
  }
};

var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};

  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }

  return obj;
};

var merge$1 = function merge(target, source, options) {
  if (!source) {
    return target;
  }

  if (typeof source !== 'object') {
    if (Array.isArray(target)) {
      target.push(source);
    } else if (typeof target === 'object') {
      if (options && (options.plainObjects || options.allowPrototypes) || !has$1.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }

    return target;
  }

  if (typeof target !== 'object') {
    return [target].concat(source);
  }

  var mergeTarget = target;

  if (Array.isArray(target) && !Array.isArray(source)) {
    mergeTarget = arrayToObject(target, options);
  }

  if (Array.isArray(target) && Array.isArray(source)) {
    source.forEach(function (item, i) {
      if (has$1.call(target, i)) {
        if (target[i] && typeof target[i] === 'object') {
          target[i] = merge(target[i], item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }

  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];

    if (has$1.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }

    return acc;
  }, mergeTarget);
};

var assign$1 = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};

var decode$2 = function decode$2(str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, ' ');

  if (charset === 'iso-8859-1') {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  } // utf-8


  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};

var encode$3 = function encode(str, defaultEncoder, charset) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }

  var string = typeof str === 'string' ? str : String(str);

  if (charset === 'iso-8859-1') {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
  }

  var out = '';

  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);

    if (c === 0x2D // -
    || c === 0x2E // .
    || c === 0x5F // _
    || c === 0x7E // ~
    || c >= 0x30 && c <= 0x39 // 0-9
    || c >= 0x41 && c <= 0x5A // a-z
    || c >= 0x61 && c <= 0x7A // A-Z
    ) {
      out += string.charAt(i);
      continue;
    }

    if (c < 0x80) {
      out = out + hexTable[c];
      continue;
    }

    if (c < 0x800) {
      out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    if (c < 0xD800 || c >= 0xE000) {
      out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
      continue;
    }

    i += 1;
    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
  }

  return out;
};

var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];

  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);

    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];

      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }

  compactQueue(queue);
  return value;
};

var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer$1 = function isBuffer(obj) {
  if (obj === null || typeof obj === 'undefined') {
    return false;
  }

  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
  return [].concat(a, b);
};

var utils$1 = {
  arrayToObject: arrayToObject,
  assign: assign$1,
  combine: combine,
  compact: compact,
  decode: decode$2,
  encode: encode$3,
  isBuffer: isBuffer$1,
  isRegExp: isRegExp,
  merge: merge$1
};
var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var formats = {
  'default': 'RFC3986',
  formatters: {
    RFC1738: function RFC1738(value) {
      return replace.call(value, percentTwenties, '+');
    },
    RFC3986: function RFC3986(value) {
      return value;
    }
  },
  RFC1738: 'RFC1738',
  RFC3986: 'RFC3986'
};
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    // eslint-disable-line func-name-matching
    return prefix + '[]';
  },
  indices: function indices(prefix, key) {
    // eslint-disable-line func-name-matching
    return prefix + '[' + key + ']';
  },
  repeat: function repeat(prefix) {
    // eslint-disable-line func-name-matching
    return prefix;
  }
};
var isArray$2 = Array.isArray;
var push = Array.prototype.push;

var pushToArray = function pushToArray(arr, valueOrArray) {
  push.apply(arr, isArray$2(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;
var defaults$1 = {
  addQueryPrefix: false,
  allowDots: false,
  charset: 'utf-8',
  charsetSentinel: false,
  delimiter: '&',
  encode: true,
  encoder: utils$1.encode,
  encodeValuesOnly: false,
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    // eslint-disable-line func-name-matching
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};

var stringify$1 = function stringify( // eslint-disable-line func-name-matching
object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset) {
  var obj = object;

  if (typeof filter === 'function') {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate(obj);
  }

  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults$1.encoder, charset) : prefix;
    }

    obj = '';
  }

  if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils$1.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$1.encoder, charset);
      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$1.encoder, charset))];
    }

    return [formatter(prefix) + '=' + formatter(String(obj))];
  }

  var values = [];

  if (typeof obj === 'undefined') {
    return values;
  }

  var objKeys;

  if (Array.isArray(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (skipNulls && obj[key] === null) {
      continue;
    }

    if (Array.isArray(obj)) {
      pushToArray(values, stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
    } else {
      pushToArray(values, stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
    }
  }

  return values;
};

var stringify_1 = function stringify_1(object, opts) {
  var obj = object;
  var options = opts ? utils$1.assign({}, opts) : {};

  if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
    throw new TypeError('Encoder has to be a function.');
  }

  var delimiter = typeof options.delimiter === 'undefined' ? defaults$1.delimiter : options.delimiter;
  var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults$1.strictNullHandling;
  var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults$1.skipNulls;
  var encode = typeof options.encode === 'boolean' ? options.encode : defaults$1.encode;
  var encoder = typeof options.encoder === 'function' ? options.encoder : defaults$1.encoder;
  var sort = typeof options.sort === 'function' ? options.sort : null;
  var allowDots = typeof options.allowDots === 'undefined' ? defaults$1.allowDots : !!options.allowDots;
  var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults$1.serializeDate;
  var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults$1.encodeValuesOnly;
  var charset = options.charset || defaults$1.charset;

  if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
    throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  if (typeof options.format === 'undefined') {
    options.format = formats['default'];
  } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
    throw new TypeError('Unknown format option provided.');
  }

  var formatter = formats.formatters[options.format];
  var objKeys;
  var filter;

  if (typeof options.filter === 'function') {
    filter = options.filter;
    obj = filter('', obj);
  } else if (Array.isArray(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }

  var keys = [];

  if (typeof obj !== 'object' || obj === null) {
    return '';
  }

  var arrayFormat;

  if (options.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = options.arrayFormat;
  } else if ('indices' in options) {
    arrayFormat = options.indices ? 'indices' : 'repeat';
  } else {
    arrayFormat = 'indices';
  }

  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

  if (!objKeys) {
    objKeys = Object.keys(obj);
  }

  if (sort) {
    objKeys.sort(sort);
  }

  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];

    if (skipNulls && obj[key] === null) {
      continue;
    }

    pushToArray(keys, stringify$1(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode ? encoder : null, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset));
  }

  var joined = keys.join(delimiter);
  var prefix = options.addQueryPrefix === true ? '?' : '';

  if (options.charsetSentinel) {
    if (charset === 'iso-8859-1') {
      // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
      prefix += 'utf8=%26%2310003%3B&';
    } else {
      // encodeURIComponent('✓')
      prefix += 'utf8=%E2%9C%93&';
    }
  }

  return joined.length > 0 ? prefix + joined : '';
};

var has$2 = Object.prototype.hasOwnProperty;
var defaults$2 = {
  allowDots: false,
  allowPrototypes: false,
  arrayLimit: 20,
  charset: 'utf-8',
  charsetSentinel: false,
  decoder: utils$1.decode,
  delimiter: '&',
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1000,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};

var interpretNumericEntities = function interpretNumericEntities(str) {
  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
}; // This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.


var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1; // Keep track of where the utf8 sentinel was found

  var i;
  var charset = options.charset;

  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf('utf8=') === 0) {
        if (parts[i] === charsetSentinel) {
          charset = 'utf-8';
        } else if (parts[i] === isoSentinel) {
          charset = 'iso-8859-1';
        }

        skipIndex = i;
        i = parts.length; // The eslint settings do not allow break;
      }
    }
  }

  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }

    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;

    if (pos === -1) {
      key = options.decoder(part, defaults$2.decoder, charset);
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults$2.decoder, charset);
      val = options.decoder(part.slice(pos + 1), defaults$2.decoder, charset);
    }

    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
      val = interpretNumericEntities(val);
    }

    if (has$2.call(obj, key)) {
      obj[key] = utils$1.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }

  return obj;
};

var parseObject = function parseObject(chain, val, options) {
  var leaf = val;

  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];

    if (root === '[]' && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var index = parseInt(cleanRoot, 10);

      if (!options.parseArrays && cleanRoot === '') {
        obj = {
          0: leaf
        };
      } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else {
        obj[cleanRoot] = leaf;
      }
    }

    leaf = obj;
  }

  return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
  if (!givenKey) {
    return;
  } // Transform dot notation to bracket notation


  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g; // Get the parent

  var segment = brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

  var keys = [];

  if (parent) {
    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
    if (!options.plainObjects && has$2.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(parent);
  } // Loop through children appending to the array until we hit depth


  var i = 0;

  while ((segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;

    if (!options.plainObjects && has$2.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }

    keys.push(segment[1]);
  } // If there's a remainder, just add whatever is left


  if (segment) {
    keys.push('[' + key.slice(segment.index) + ']');
  }

  return parseObject(keys, val, options);
};

var parse$3 = function parse$3(str, opts) {
  var options = opts ? utils$1.assign({}, opts) : {};

  if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }

  options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
  options.delimiter = typeof options.delimiter === 'string' || utils$1.isRegExp(options.delimiter) ? options.delimiter : defaults$2.delimiter;
  options.depth = typeof options.depth === 'number' ? options.depth : defaults$2.depth;
  options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults$2.arrayLimit;
  options.parseArrays = options.parseArrays !== false;
  options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults$2.decoder;
  options.allowDots = typeof options.allowDots === 'undefined' ? defaults$2.allowDots : !!options.allowDots;
  options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults$2.plainObjects;
  options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults$2.allowPrototypes;
  options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults$2.parameterLimit;
  options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults$2.strictNullHandling;

  if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
    throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
  }

  if (typeof options.charset === 'undefined') {
    options.charset = defaults$2.charset;
  }

  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }

  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options);
    obj = utils$1.merge(obj, newObj, options);
  }

  return utils$1.compact(obj);
};

var lib = {
  formats: formats,
  parse: parse$3,
  stringify: stringify_1
};
var INITIAL_STEP = 1;
var CONFIRM_STEP = 2;
var NO_VALID_BID_INCREMENT = 'NO_VALID_BID_INCREMENT';
var INVALID_BID_AMOUNT = 'INVALID_BID_AMOUNT';
var AMOUNT_LOWER_MAX_BID = 'AMOUNT_LOWER_MAX_BID';
var AMOUNT_LOWER_HIGH_BID = 'AMOUNT_LOWER_HIGH_BID';
var AMOUNT_LOWER_START_PRICE = 'AMOUNT_LOWER_START_PRICE';
var BID_RETRACTION_IN_PROGRESS = 'BID_RETRACTION_IN_PROGRESS';
var BIDDER_NOT_APPROVED = 'BIDDER_NOT_APPROVED';
var INIT_TIMER = 'INIT_TIMER';
var START_TIMER = 'START_TIMER';
var STOP_TIMER = 'STOP_TIMER';
var UPDATE_TIMER = 'UPDATE_TIMER';
var TICK = 'TICK';
var UPDATE_CURRENT_BID = 'UPDATE_CURRENT_BID';
var IS_LOADING_ITEM = 'IS_LOADING_ITEM';
var LOADING_ERROR = 'LOADING_ERROR';
var END_TIME = 'END_TIME';
var IS_ITEM_SOLD_OR_PASSED = 'IS_ITEM_SOLD_OR_PASSED';
var SET_INCREMENT_ERROR = 'SET_INCREMENT_ERROR';
var SET_AMOUNT_LOWER_ERROR = 'SET_AMOUNT_LOWER_ERROR';
var UPDATE_PAYMENT = 'UPDATE_PAYMENT';
var SET_BID_RETRACTION_ERROR = 'SET_BID_RETRACTION_ERROR';
var CANCEL_INCREMENT_CHOICE = 'CANCEL_INCREMENT_CHOICE';
var EXTENDED_BIDDING = 'EXTENDED_BIDDING';
var EXTENDED_TIME_TRIGGER_SECONDS = 'EXTENDED_TIME_TRIGGER_SECONDS';
var UPDATE_BIDDER_ITEM_STATUS = 'UPDATE_BIDDER_ITEM_STATUS';
var CHANGE_STEP = 'CHANGE_STEP';
var OUTBID_ON_CONFIRM = 'OUTBID_ON_CONFIRM';
var UPDATE_MAX_INPUT = 'UPDATE_MAX_INPUT';
var CLEAR_ERROR = 'CLEAR_ERROR';
var SKIP_CONFIRM = 'SKIP_CONFIRM';

var setCurrentBid = function setCurrentBid(action) {
  return _objectSpread2({
    type: UPDATE_CURRENT_BID
  }, action);
};

var setPayment = function setPayment(action) {
  return _objectSpread2({
    type: UPDATE_PAYMENT
  }, action);
};

var setBidderItemStatus = function setBidderItemStatus(bidderItemStatus) {
  return {
    type: UPDATE_BIDDER_ITEM_STATUS,
    bidderItemStatus: bidderItemStatus
  };
};

var setMaxBidInput = function setMaxBidInput(input) {
  return {
    type: UPDATE_MAX_INPUT,
    input: input
  };
};

var loadingItem = function loadingItem(isLoading) {
  return {
    type: IS_LOADING_ITEM,
    isLoading: isLoading
  };
};

var itemNotFound = function itemNotFound() {
  var hasItemFailed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var isLoadingItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: LOADING_ERROR,
    hasItemFailed: hasItemFailed,
    isLoadingItem: isLoadingItem
  };
};

var finishItem = function finishItem() {
  var isfinished = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return {
    type: IS_ITEM_SOLD_OR_PASSED,
    isItemSoldOrPassed: isfinished
  };
};

var setEndTime = function setEndTime(endTime) {
  return {
    type: END_TIME,
    endTime: endTime
  };
};

var applyChangesAfterGet = function applyChangesAfterGet(props, payload) {
  var stopTimer = props.stopTimer,
      startTimer = props.startTimer;

  if (payload.secondsRemaining <= 0) {
    stopTimer();
  } else {
    startTimer();
  }

  return Promise.resolve();
};

var applyChangesAfterPost = function applyChangesAfterPost(_ref, dispatch) {
  var actions = _ref.actions,
      step = _ref.step,
      skipConfirm = _ref.skipConfirm;

  if (step === INITIAL_STEP && !skipConfirm) {
    actions.changeStep(CONFIRM_STEP);
  } else {
    dispatch(setMaxBidInput(''));
    actions.changeStep(INITIAL_STEP);
  }
};

var applyChanges = function applyChanges(_ref2, payload, dispatch) {
  var actions = _ref2.actions;
  actions.initTimer(payload.secondsRemaining);
  dispatch(setEndTime(payload.endTime));
  dispatch(setCurrentBid({
    highBidderUsername: payload.highBidderUsername,
    highBidderReferenceId: payload.highBidderReferenceId,
    nextBidAmount: payload.nextBidAmount,
    bidAmount: payload.bidAmount,
    currencyCode: payload.currencyCode,
    currencySymbol: payload.currencySymbol,
    reserveMet: payload.reserveMet,
    quantity: payload.quantity,
    quantityType: payload.quantityType,
    startPrice: payload.startPrice,
    lastFourCc: payload.lastFourCc,
    sellerSettings: payload.sellerSettings
  }));
  actions.setExtendedBidding(payload.extendedBidding);
  actions.setExtendedTimeTriggerSeconds(payload.extendedTimeTriggerSeconds);

  if (payload.bidderReferenceDetail) {
    dispatch(setBidderItemStatus(payload.bidderReferenceDetail.bidderItemStatus));
  }

  return Promise.resolve(payload);
};

var getCurrentBid = function getCurrentBid(props) {
  return function (dispatch, getState, api) {
    var itemId = props.itemId,
        sellerId = props.sellerId,
        currentBidResponse = props.currentBidResponse,
        clientProxy = props.clientProxy,
        demoMode = props.demoMode,
        bidderId = props.bidderId;
    dispatch(loadingItem(true));
    var request;

    if (demoMode) {
      request = new Promise(function (resolve) {
        return resolve(currentBidResponse);
      });
    } else {
      var pathParams = {};

      if (!lodash_isnil(bidderId) && bidderId !== '') {
        pathParams.bidderReferenceId = bidderId;
      }

      var url = "".concat(clientProxy, "/timedBiddingAdapter/v1/bids/item/").concat(itemId, "/").concat(sellerId).concat(!pathParams ? '' : "?".concat(lib.stringify(pathParams)));
      request = api.doRequest('GET', url);
    }

    return request.then(function (response) {
      return response.data;
    }).then(function (payload) {
      return applyChanges(props, payload, dispatch);
    }).then(function (payload) {
      return applyChangesAfterGet(props, payload);
    })["catch"](function () {
      dispatch(itemNotFound());
    })["finally"](function () {
      dispatch(loadingItem(false));
    });
  };
};

var postBid = function postBid(props, amount) {
  return function (dispatch, getState, api) {
    var actions = props.actions,
        sessionId = props.sessionId,
        itemId = props.itemId,
        sellerId = props.sellerId,
        bidderId = props.bidderId,
        demoMode = props.demoMode,
        currentBidResponse = props.currentBidResponse,
        step = props.step,
        clientProxy = props.clientProxy,
        skipConfirm = props.skipConfirm;
    dispatch(loadingItem(true));
    var request;
    var response;
    var errorResponse = {
      status: 0
    };
    var auctionGuardStatus;
    var paymentValidationStatus;
    var skipConfirmStepCookie = sessionStorage.getItem('skipConfirmStep' + itemId);
    actions.skipConfirm(skipConfirmStepCookie === null ? false : true);
    var validateOnly = step === INITIAL_STEP && !skipConfirm;
    var payload = {
      itemReferenceId: itemId,
      sellerReferenceId: sellerId,
      bidderReferenceId: bidderId,
      amount: amount
    };

    if (demoMode) {
      request = new Promise(function (resolve, reject) {
        return currentBidResponse.error ? reject(currentBidResponse.error) : resolve(currentBidResponse);
      });
    } else {
      var params = {
        bidderId: bidderId,
        sessionId: sessionId
      };
      var url = "".concat(clientProxy, "/timedBiddingAdapter/v1/bids").concat(validateOnly ? '?validateOnly=true' : '');
      request = api.doRequest('POST', url, params, JSON.stringify(payload));
    }

    return request.then(function (responseData) {
      response = responseData.data;
      auctionGuardStatus = response.auctionGuardStatus;
      return response;
    }).then(function (response) {
      applyChanges(props, response, dispatch);
    }).then(function () {
      return applyChangesAfterPost(props, dispatch);
    })["catch"](function (error) {
      errorResponse = error && error.response;
      auctionGuardStatus = errorResponse && errorResponse.data && errorResponse.data.additionalProperties && errorResponse.data.additionalProperties.AuctionGuardStatus;
      paymentValidationStatus = errorResponse && errorResponse.data && errorResponse.data.additionalProperties && errorResponse.data.additionalProperties.PaymentValidationStatus;

      if (errorResponse && errorResponse.status === 401) {
        props.openBuyerLoginModal();
        return;
      }

      var errorResponseCode = errorResponse && errorResponse.data && errorResponse.data.code;

      switch (errorResponseCode) {
        case BIDDER_NOT_APPROVED:
          // we do nothing, we are going to trigger an action on finally
          break;

        case BID_RETRACTION_IN_PROGRESS:
          actions.setBidRetractionError(error.response.data.status, error.response.data.code, error.response.data.error);
          break;

        case NO_VALID_BID_INCREMENT:
          actions.setIncrementError(error.response.data.status, error.response.data.code, error.response.data.error, error.response.data.additionalProperties.BID_RANGE_LOW, error.response.data.additionalProperties.BID_RANGE_HIGH);
          break;

        case AMOUNT_LOWER_MAX_BID:
        case AMOUNT_LOWER_HIGH_BID:
        case AMOUNT_LOWER_START_PRICE:
        case INVALID_BID_AMOUNT:
          actions.setAmountLowerError(error.response.data.status, error.response.data.code, error.response.data.error, error.response.data.additionalProperties.AMOUNT);
          break;
      }

      props.notifyBidAttempt({
        errorResponseCode: errorResponseCode,
        bidderReferenceId: bidderId,
        lotId: itemId
      });
    })["finally"](function () {
      if (!validateOnly && response) {
        props.notifyBidAttempt(_objectSpread2(_objectSpread2({}, response), {}, {
          bidderReferenceId: bidderId,
          lotId: response.itemReferenceId
        }));
      } else {
        if (errorResponse.status !== 401 && errorResponse.status !== 0 && !lodash_isnil(auctionGuardStatus)) {
          props.triggerBidderRegistration();
        }
      }

      dispatch(loadingItem(false));

      if (paymentValidationStatus) {
        props.openChangeCreditCardModal(paymentValidationStatus);
      }

      if (auctionGuardStatus) {
        props.emitAuctionGuardStatus(auctionGuardStatus);
      }
    });
  };
};

var postBidIncrement = function postBidIncrement(props, amount) {
  return function (dispatch, getState, api) {
    var actions = props.actions,
        sessionId = props.sessionId,
        itemId = props.itemId,
        sellerId = props.sellerId,
        bidderId = props.bidderId,
        demoMode = props.demoMode,
        currentBidResponse = props.currentBidResponse,
        clientProxy = props.clientProxy;
    dispatch(loadingItem(true));
    var request;
    var response;
    var errorResponse = {
      status: 0
    };
    var skipConfirmStepCookie = sessionStorage.getItem('skipConfirmStep' + itemId);
    actions.skipConfirm(skipConfirmStepCookie === null ? false : true);
    var payload = {
      itemReferenceId: itemId,
      sellerReferenceId: sellerId,
      bidderReferenceId: bidderId,
      amount: amount
    };

    if (demoMode) {
      request = new Promise(function (resolve, reject) {
        return currentBidResponse.error ? reject(currentBidResponse.error) : resolve(currentBidResponse);
      });
    } else {
      var params = {
        bidderId: bidderId,
        sessionId: sessionId
      };
      var url = "".concat(clientProxy, "/timedBiddingAdapter/v1/bids?validateOnly=true");
      request = api.doRequest('POST', url, params, JSON.stringify(payload));
    }

    return request.then(function (responseData) {
      response = responseData.data;
      return response;
    }).then(function (response) {
      applyChanges(props, response, dispatch);
    }).then(function (response) {
      actions.setPayment({
        lastFourCc: response.lastFourCc
      });
    }).then(function () {
      return applyChangesAfterPost(props, dispatch);
    })["catch"](function (error) {
      errorResponse = error && error.response;
      var errorResponseCode = errorResponse && errorResponse.data && errorResponse.data.code;

      if (errorResponseCode === NO_VALID_BID_INCREMENT) {
        actions.setIncrementError(error.response.data.status, error.response.data.code, error.response.data.error, error.response.data.additionalProperties.BID_RANGE_LOW, error.response.data.additionalProperties.BID_RANGE_HIGH);
      }

      props.notifyBidAttempt({
        errorResponseCode: errorResponseCode,
        bidderReferenceId: bidderId,
        lotId: itemId
      });
    })["finally"](function () {
      actions.setCurrentBid({
        nextBidAmount: amount
      });
      dispatch(loadingItem(false));
    });
  };
};

var currentBid = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setCurrentBid: setCurrentBid,
  setPayment: setPayment,
  setBidderItemStatus: setBidderItemStatus,
  setMaxBidInput: setMaxBidInput,
  loadingItem: loadingItem,
  itemNotFound: itemNotFound,
  finishItem: finishItem,
  setEndTime: setEndTime,
  getCurrentBid: getCurrentBid,
  postBid: postBid,
  postBidIncrement: postBidIncrement
});

var initTimer = function initTimer(seconds) {
  return {
    type: INIT_TIMER,
    seconds: seconds,
    status: 'INIT'
  };
};

var start = function start() {
  return {
    type: START_TIMER,
    status: 'START'
  };
};

var stop = function stop() {
  return {
    type: STOP_TIMER,
    seconds: 0,
    status: 'STOP'
  };
};

var tick = function tick() {
  return {
    type: TICK
  };
};

var update = function update(seconds) {
  return {
    type: UPDATE_TIMER,
    seconds: seconds
  };
};

var setExtendedBidding = function setExtendedBidding(extendedBidding) {
  return {
    type: EXTENDED_BIDDING,
    extendedBidding: extendedBidding
  };
};

var setExtendedTimeTriggerSeconds = function setExtendedTimeTriggerSeconds(extendedTimeTriggerSeconds) {
  return {
    type: EXTENDED_TIME_TRIGGER_SECONDS,
    extendedTimeTriggerSeconds: extendedTimeTriggerSeconds
  };
};

var timer = /*#__PURE__*/Object.freeze({
  __proto__: null,
  initTimer: initTimer,
  start: start,
  stop: stop,
  tick: tick,
  update: update,
  setExtendedBidding: setExtendedBidding,
  setExtendedTimeTriggerSeconds: setExtendedTimeTriggerSeconds
});

var changeStep = function changeStep(step) {
  return {
    type: CHANGE_STEP,
    step: step
  };
};

var outbidOnConfirm = function outbidOnConfirm() {
  return {
    type: OUTBID_ON_CONFIRM,
    step: INITIAL_STEP
  };
};

var skipConfirm = function skipConfirm(_skipConfirm) {
  return {
    type: SKIP_CONFIRM,
    skipConfirm: _skipConfirm
  };
};

var widget = /*#__PURE__*/Object.freeze({
  __proto__: null,
  changeStep: changeStep,
  outbidOnConfirm: outbidOnConfirm,
  skipConfirm: skipConfirm
});
var TOPIC_BIDS_ITEM = '/topic/bids.item';
var TOPIC_APP_TIME = '/topic/app.time';

function getListOfTopics(itemId, sellerId) {
  return ["".concat(TOPIC_BIDS_ITEM, ".").concat(itemId, ".").concat(sellerId), TOPIC_APP_TIME];
}

var OUTBID = 'OUTBID';
var NO_BID = 'NO_BID';

var SocketHandler = /*#__PURE__*/function (_Component) {
  function SocketHandler(props) {
    var _this;

    _classCallCheck(this, SocketHandler);

    _this = _callSuper(this, SocketHandler, [props]);

    _this.onMessageReceived = function (message, topic) {
      if (message && topic) {
        if (topic.includes(TOPIC_BIDS_ITEM)) {
          _this.props.actions.setCurrentBid({
            highBidderUsername: message.highBidderUsername,
            highBidderReferenceId: message.highBidderReferenceId,
            nextBidAmount: message.nextBidAmount,
            bidAmount: message.bidAmount,
            currencyCode: message.currencyCode,
            reserveMet: message.reserveMet,
            quantity: message.quantity
          });

          _this.props.actions.setEndTime(message.endTime);

          if (message.secondsRemaining > 0) {
            _this.props.actions.syncTimeWithServer(message.secondsRemaining);
          }

          _this.props.actions.setExtendedBidding(message.extendedBidding);

          _this.props.actions.setExtendedTimeTriggerSeconds(message.extendedTimeTriggerSeconds);

          if (_this.props.bidderItemStatus !== NO_BID && _this.props.bidderId && _this.props.bidderId !== message.highBidderReferenceId) {
            _this.props.actions.setBidderItemStatus(OUTBID);

            if (_this.props.step === CONFIRM_STEP) {
              _this.props.actions.outbidOnConfirm();
            }
          }
        } else if (topic.includes(TOPIC_APP_TIME)) {
          var itemEndTime = new Date(_this.props.itemEndTime);
          var currentServerTime = new Date(message);
          var secondsRemaining = Math.floor((itemEndTime.getTime() - currentServerTime.getTime()) / 1000);

          _this.props.actions.syncTimeWithServer(secondsRemaining);
        }
      }
    };

    return _this;
  }

  _inherits(SocketHandler, _Component);

  return _createClass(SocketHandler, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          demoMode = _this$props.demoMode,
          itemId = _this$props.itemId,
          isItemSoldOrPassed = _this$props.isItemSoldOrPassed,
          sellerId = _this$props.sellerId,
          apiGatewayURL = _this$props.apiGatewayURL;
      if (demoMode || isItemSoldOrPassed) return null;
      return /*#__PURE__*/React.createElement(StompClient, {
        url: "".concat(apiGatewayURL, "/timedbidding/websocket"),
        topics: getListOfTopics(itemId, sellerId),
        onMessage: this.onMessageReceived,
        debug: false
      });
    }
  }]);
}(Component);

SocketHandler.propTypes = {
  itemId: PropTypes__default.string.isRequired,
  sellerId: PropTypes__default.string.isRequired,
  apiGatewayURL: PropTypes__default.string.isRequired,
  actions: PropTypes__default.object,
  demoMode: PropTypes__default.bool,
  itemEndTime: PropTypes__default.string,
  isItemSoldOrPassed: PropTypes__default.bool,
  bidderId: PropTypes__default.string,
  bidderItemStatus: PropTypes__default.string,
  step: PropTypes__default.number
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isLoadingItem: state.currentBid.isLoading,
    itemEndTime: state.currentBid.endTime,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    bidderItemStatus: state.currentBid.bidderItemStatus,
    step: state.widget.step
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(_objectSpread2(_objectSpread2({}, currentBid), {}, {
      syncTimeWithServer: update,
      setExtendedBidding: setExtendedBidding,
      setExtendedTimeTriggerSeconds: setExtendedTimeTriggerSeconds,
      setEndTime: setEndTime,
      outbidOnConfirm: outbidOnConfirm
    }), dispatch)
  };
};

var SocketHandlerWithStore = connect(mapStateToProps, mapDispatchToProps)(SocketHandler);

function millisToDays(secondsToBid, extendedBidding, removeRemainingLabel) {
  var days = Math.floor(secondsToBid / (3600 * 24));
  var hours = Math.floor(secondsToBid % (3600 * 24) / 3600);
  var minutes = Math.floor(secondsToBid % 3600 / 60);
  var seconds = Math.floor(secondsToBid % 3600 % 60);
  var daysToDisplay = displayDays(days) ? days + (days === 1 ? ' day' : ' days') : '';
  var hoursToDisplay = displayHours(hours) ? (displayDivider(days) ? ': ' : '') + hours.toLocaleString() + (hours === 1 ? 'hr' : 'hrs') : '';
  var minutesToDisplay = displayMinutes(days, minutes) ? (displayDivider(hours) ? ': ' : '') + minutes + (minutes === 1 ? 'min ' : 'mins ') : '';
  var secondsToDisplay = displaySeconds(days, hours) ? seconds + (seconds === 1 ? 'sec ' : 'secs ') : '';
  var remainingLabel = removeRemainingLabel ? '' : days > 0 ? ', remaining!' : ', left to bid!';
  var biddingExtended = extendedBidding ? ' Bidding Extended' : '';
  return daysToDisplay + hoursToDisplay + minutesToDisplay + secondsToDisplay + remainingLabel + biddingExtended;
}

var displayDivider = function displayDivider(time) {
  return time > 0;
};

var displayDays = function displayDays(days) {
  return days > 0;
};

var displayHours = function displayHours(hours) {
  return hours > 0;
};

var displaySeconds = function displaySeconds(days, hours) {
  return days === 0 && hours === 0;
};

var displayMinutes = function displayMinutes(days, minutes) {
  return days === 0 && minutes > 0;
};

function getTimesTheMoneyTotal(quantity, bidAmount) {
  return quantity * bidAmount;
}

var isLoggedInBidder = function isLoggedInBidder(highBidderReferenceId, bidderId) {
  return highBidderReferenceId === bidderId;
};

var options = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
};
var useStyles = makeStyles(function (theme) {
  return {
    cardActionText: {
      color: grey[50],
      padding: '0 1rem',
      fontWeight: '600',
      fontSize: '1rem'
    },
    cancelButtonText: {
      color: grey[600]
    }
  };
});

function BidButtonText(props) {
  var classes = useStyles();

  var getBidAmount = function getBidAmount(maxBidInput) {
    return isNaN(maxBidInput) ? '' : Number.parseFloat(maxBidInput).toLocaleString(undefined, options);
  };

  var getNextBid = function getNextBid(startPrice, nextBidAmount) {
    if (startPrice !== null) {
      if (startPrice > nextBidAmount) {
        return startPrice.toLocaleString(undefined, options);
      } else {
        return nextBidAmount.toLocaleString(undefined, options);
      }
    } else if (nextBidAmount !== null) {
      return nextBidAmount.toLocaleString(undefined, options);
    } else {
      return 'Place Bid';
    }
  };

  var getText = function getText() {
    if (props.isLoadingItem) {
      return 'Loading...';
    } else if (props.hasItemFailed) {
      return null;
    } else {
      if (props.step === INITIAL_STEP) {
        if (props.isItemSoldOrPassed) {
          if (props.bidAmount === null || props.reserveMet != undefined && !props.reserveMet) {
            return 'Passed';
          } else {
            return 'Sold';
          }
        } else {
          if (props.lowBidIncrement != null && props.highBidIncrement != null) {
            return 'Cancel';
          } else {
            if ((props.bidAmount === null || props.bidAmount === 0) && props.maxBidInput === '' && props.startPrice === null) {
              return 'Place Bid';
            } else {
              if (props.maxBidInput !== '') {
                return "Bid ".concat(props.currencySymbol).concat(getBidAmount(props.maxBidInput));
              } else {
                if (props.nextBidAmount != null) {
                  return "Bid ".concat(props.currencySymbol).concat(getNextBid(props.startPrice, props.nextBidAmount));
                } else {
                  return null;
                }
              }
            }
          }
        }
      } else {
        return 'Confirm';
      }
    }
  };

  return /*#__PURE__*/React.createElement(Typography, {
    className: classes.cardActionText,
    noWrap: true
  }, getText());
}

BidButtonText.propTypes = {
  step: PropTypes__default.number,
  maxBidInput: PropTypes__default.string,
  isItemSoldOrPassed: PropTypes__default.bool,
  nextBidAmount: PropTypes__default.number,
  bidAmount: PropTypes__default.number,
  reserveMet: PropTypes__default.bool,
  currencySymbol: PropTypes__default.string,
  lowBidIncrement: PropTypes__default.number,
  highBidIncrement: PropTypes__default.number,
  isLoadingItem: PropTypes__default.bool,
  hasItemFailed: PropTypes__default.bool,
  startPrice: PropTypes__default.number
};

var mapStateToProps$1 = function mapStateToProps(state) {
  return {
    bidAmount: state.currentBid.bidAmount,
    nextBidAmount: state.currentBid.nextBidAmount,
    reserveMet: state.currentBid.reserveMet,
    maxBidInput: state.currentBid.input,
    isLoadingItem: state.currentBid.isLoading,
    startPrice: state.currentBid.startPrice,
    lowBidIncrement: state.currentBid.lowBidIncrement,
    highBidIncrement: state.currentBid.highBidIncrement
  };
};

var BidButtonTextWithStore = connect(mapStateToProps$1)(BidButtonText);
var useStyles$1 = makeStyles(function (theme) {
  return {
    confirmButtonStyle: {
      flex: '0 1 auto',
      width: 'auto'
    },
    cancelButtonFormat: {
      borderRadius: 5,
      backgroundColor: grey[50],
      '&:hover': {
        backgroundColor: grey[300]
      }
    },
    cancelBidButtonText: {
      padding: '0 1rem',
      color: grey[900],
      fontSize: '1rem'
    },
    bidButton: {
      height: '2.65rem'
    }
  };
});
BidButton.propTypes = {
  step: PropTypes__default.number,
  isItemSoldOrPassed: PropTypes__default.bool,
  isLoadingItem: PropTypes__default.bool,
  nextBidAmount: PropTypes__default.number,
  maxBidInput: PropTypes__default.string,
  bidAmount: PropTypes__default.number,
  reserveMet: PropTypes__default.bool,
  currencySymbol: PropTypes__default.string,
  lowBidIncrement: PropTypes__default.number,
  highBidIncrement: PropTypes__default.number,
  handleBidButton: PropTypes__default.func,
  hasItemFailed: PropTypes__default.bool,
  errorCode: PropTypes__default.string,
  startPrice: PropTypes__default.number
};

function BidButton(props) {
  var classes = useStyles$1();

  var isButtonDisabled = function isButtonDisabled() {
    var isNotANumber = isNaN(props.maxBidInput);
    return props.nextBidAmount === 0 && props.maxBidInput === '' && props.startPrice === null || props.bidAmount === null && props.maxBidInput === '' && props.startPrice === null && props.step === INITIAL_STEP || props.nextBidAmount === null && props.bidAmount == undefined && props.maxBidInput === '' || props.isItemSoldOrPassed || props.hasItemFailed || props.isLoadingItem || isNotANumber;
  };

  var isIncrementChoice = function isIncrementChoice() {
    return props.lowBidIncrement !== null && props.highBidIncrement !== null && props.step === INITIAL_STEP;
  };

  if (isIncrementChoice()) {
    return /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      variant: "contained",
      id: "cancelIncrement",
      fullWidth: true,
      className: classes.cancelButtonFormat,
      onClick: props.handleCancelBidButtonClick,
      style: {
        boxShadow: 'none'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.cancelBidButtonText
    }, "Cancel"));
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      id: "placeBidButton",
      color: "secondary",
      variant: "contained",
      fullWidth: true,
      onClick: props.handleBidButton,
      className: props.step === INITIAL_STEP ? classes.bidButton : classes.confirmButtonStyle,
      disabled: isButtonDisabled(),
      style: {
        boxShadow: 'none'
      }
    }, /*#__PURE__*/React.createElement(BidButtonTextWithStore, {
      step: props.step,
      isItemSoldOrPassed: props.isItemSoldOrPassed,
      nextBidAmount: props.nextBidAmount,
      bidAmount: props.bidAmount,
      reserveMet: props.reserveMet,
      currencySymbol: props.currencySymbol,
      lowBidIncrement: props.lowBidIncrement,
      highBidIncrement: props.highBidIncrement,
      hasItemFailed: props.hasItemFailed,
      startPrice: props.startPrice
    }));
  }
}

var mapStateToProps$2 = function mapStateToProps(state) {
  return {
    isLoadingItem: state.currentBid.isLoading,
    maxBidInput: state.currentBid.input,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    bidAmount: state.currentBid.bidAmount,
    nextBidAmount: state.currentBid.nextBidAmount,
    reserveMet: state.currentBid.reserveMet,
    hasItemFailed: state.currentBid.hasItemFailed,
    lowBidIncrement: state.error.lowBidIncrement,
    highBidIncrement: state.error.highBidIncrement,
    startPrice: state.error.startPrice,
    step: state.widget.step,
    errorCode: state.error.errorCode
  };
};

var BidButtonWithStore = connect(mapStateToProps$2)(BidButton);
var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var useStyles$2 = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    },
    avatar: {
      backgroundColor: grey[200],
      color: grey[400],
      margin: 0,
      width: '30px',
      height: '30px'
    },
    fontContent: {
      fontWeight: 600,
      fontSize: '1rem'
    },
    remainingWrapper: {
      fontSize: '1rem'
    },
    fontNormal: {
      color: theme.palette.primary.main
    },
    fontEnding: {
      color: theme.palette.error[700]
    }
  };
});
CardHeaderText.propTypes = {
  bidAmount: PropTypes__default.number,
  reserveMet: PropTypes__default.bool,
  seconds: PropTypes__default.number,
  status: PropTypes__default.string,
  stopTimer: PropTypes__default.func,
  isLoadingItem: PropTypes__default.bool,
  isItemSoldOrPassed: PropTypes__default.bool,
  hasItemFailed: PropTypes__default.bool,
  extendedBidding: PropTypes__default.bool,
  extendedTimeTriggerSeconds: PropTypes__default.number
};

function CardHeaderText(props) {
  var classes = useStyles$2();
  var elementId = 'timeRemaining';
  var remainingText = millisToDays(props.seconds, props.extendedBidding).split(',');
  var inExtendTriggerTime = props.extendedTimeTriggerSeconds && props.seconds <= props.extendedTimeTriggerSeconds;

  if (props.seconds <= 0 && (props.status === 'START' || props.status === 'INIT')) {
    props.stopTimer();
  }

  if (props.isLoadingItem) {
    return /*#__PURE__*/React.createElement("div", {
      id: elementId,
      className: classes.root
    }, /*#__PURE__*/React.createElement(Typography, {
      id: "loadingTime",
      className: classnames(classes.fontContent, classes.fontNormal)
    }, /*#__PURE__*/React.createElement("span", null, "Loading...")));
  } else if (props.hasItemFailed) {
    return /*#__PURE__*/React.createElement("div", {
      id: elementId,
      className: classes.root
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.fontContent, classes.fontEnding)
    }, "Item Not Available")));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      id: elementId,
      className: classes.root
    }, !props.isItemSoldOrPassed ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Avatar, {
      "aria-label": "Recipe",
      className: classnames(classes.avatar, inExtendTriggerTime ? classes.fontEnding : undefined)
    }, /*#__PURE__*/React.createElement(Schedule, null)), /*#__PURE__*/React.createElement(Typography, {
      className: classnames(classes.remainingWrapper, inExtendTriggerTime && classes.fontEnding)
    }, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.fontContent, inExtendTriggerTime ? classes.fontEnding : classes.fontNormal)
    }, remainingText[0]), " ", remainingText[1])) : props.bidAmount !== null && (props.reserveMet || props.reserveMet === null) ? /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.fontContent, classes.fontNormal)
    }, "Sold!")) : /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("span", {
      className: classnames(classes.fontContent, classes.fontEnding)
    }, "Passed!")));
  }
}

var mapStateToProps$3 = function mapStateToProps(state, ownProps) {
  return {
    seconds: ownProps.seconds || state.timer.seconds,
    status: state.timer.status,
    isLoadingItem: state.currentBid.isLoading,
    bidAmount: state.currentBid.bidAmount,
    reserveMet: state.currentBid.reserveMet,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    hasItemFailed: state.currentBid.hasItemFailed,
    extendedBidding: state.timer.extendedBidding,
    extendedTimeTriggerSeconds: state.timer.extendedTimeTriggerSeconds
  };
};

var CardHeaderTextWithStore = connect(mapStateToProps$3)(CardHeaderText);
var useStyles$3 = makeStyles(function (theme) {
  return {
    errorText: {
      color: theme.palette.error[800],
      fontWeight: 600,
      fontSize: '1rem'
    },
    alignCenter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    errorIcon: {
      background: 0,
      color: theme.palette.error[800],
      marginLeft: '5px',
      marginRight: '5px',
      display: 'flex',
      justifyContent: 'center'
    }
  };
});
BidInfoText.propTypes = {
  step: PropTypes__default.number,
  isItemSoldOrPassed: PropTypes__default.bool,
  bidAmount: PropTypes__default.number,
  reserveMet: PropTypes__default.bool
};

function BidInfoText(props) {
  var classes = useStyles$3();
  var elementId = 'currentBidText';

  if (props.step === INITIAL_STEP) {
    if (props.bidAmount === null && props.reserveMet === null && !props.isItemSoldOrPassed) {
      return /*#__PURE__*/React.createElement(Typography, {
        id: elementId,
        className: classes.errorText
      }, "No Bids Placed");
    } else {
      if (props.reserveMet !== null && !props.reserveMet) {
        return /*#__PURE__*/React.createElement(Typography, {
          id: elementId,
          className: classnames(classes.errorText, classes.alignCenter)
        }, /*#__PURE__*/React.createElement(Icon, {
          className: classes.errorIcon
        }, /*#__PURE__*/React.createElement(NotInterestedIcon, null)), "Reserve Not Met");
      }
    }
  }

  return null;
}

var mapStateToProps$4 = function mapStateToProps(state) {
  return {
    bidAmount: state.currentBid.bidAmount,
    reserveMet: state.currentBid.reserveMet,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    step: state.widget.step
  };
};

var BidInfoTextWithStore = connect(mapStateToProps$4)(BidInfoText);
var ALL_ONE_MONEY = 'ALL_ONE_MONEY';
HighBidText.propTypes = {
  step: PropTypes__default.number,
  isItemSoldOrPassed: PropTypes__default.bool,
  bidAmount: PropTypes__default.number,
  nextBidAmount: PropTypes__default.number,
  quantity: PropTypes__default.number,
  quantityType: PropTypes__default.string,
  highBidderUsername: PropTypes__default.string,
  highBidderReferenceId: PropTypes__default.string,
  reserveMet: PropTypes__default.bool,
  currencySymbol: PropTypes__default.string,
  lowBidIncrement: PropTypes__default.number,
  highBidIncrement: PropTypes__default.number,
  bidderId: PropTypes__default.string,
  maxBidInput: PropTypes__default.string
};

function HighBidText(props) {
  var classes = useStyles$4();
  var elementId = 'highBidText';
  var isLoggedIn = isLoggedInBidder(props.highBidderReferenceId, props.bidderId);
  var highBidAmount = props.bidAmount ? props.currencySymbol + props.bidAmount.toLocaleString(undefined, options) : undefined;
  var highBidAmountTimes = props.currencySymbol + getTimesTheMoneyTotal(props.quantity, props.bidAmount).toLocaleString(undefined, options);

  var getConfirmBidText = function getConfirmBidText(elementId, classes, maxBidInput, nextBidAmount, bidAmount, highBidAmount, currencySymbol, quantity, quantityType) {
    var currentHighBid = bidAmount !== null && highBidAmount !== null ? highBidAmount : currencySymbol + 0.00;
    var bidAmountToDisplay = getMaxBidAttempt(maxBidInput, nextBidAmount).toLocaleString(undefined, options);
    return /*#__PURE__*/React.createElement(Typography, {
      id: elementId,
      component: 'div',
      className: classes.confirmCurrentHighBid
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.textFormat
    }, "Current High Bid: ", currentHighBid), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
      className: classes.youEnteredTextFormat
    }, "You entered: ", currencySymbol, bidAmountToDisplay, /*#__PURE__*/React.createElement("br", null), getQuantityText(quantity, quantityType, bidAmountToDisplay, currencySymbol)));
  };

  var getQuantityText = function getQuantityText(quantity, quantityType, nextBidAmount, currencySymbol) {
    var quantityText = null;

    if (quantity > 1) {
      if (quantityType === ALL_ONE_MONEY) {
        quantityText = /*#__PURE__*/React.createElement("span", {
          className: classes.quantityTextFormat
        }, "(Quantity: ".concat(quantity, ")"));
      } else {
        quantityText = /*#__PURE__*/React.createElement("span", null, " ", "(".concat(currencySymbol + nextBidAmount, " x ").concat(quantity, " = \n                ").concat(currencySymbol + getTimesTheMoneyTotal(quantity, nextBidAmount).toLocaleString(undefined, options), ")"));
      }
    }

    return quantityText;
  };

  var getMaxBidAttempt = function getMaxBidAttempt(maxBidInput, nextBidAmount) {
    if (maxBidInput !== '') {
      return maxBidInput;
    } else if (nextBidAmount !== undefined) {
      return nextBidAmount;
    }
  };

  var getQuantityOpening = function getQuantityOpening(quantity, quantityType, startPrice, currencySymbol) {
    if (startPrice === null) {
      if (quantity > 1) {
        if (quantityType === ALL_ONE_MONEY) {
          return /*#__PURE__*/React.createElement(Typography, {
            className: classes.textFontSize
          }, "Quantity: ".concat(quantity));
        } else {
          return /*#__PURE__*/React.createElement(Typography, {
            className: classes.textFontSize,
            component: 'div'
          }, "".concat(currencySymbol, "0.00 x ").concat(quantity, " = ").concat(currencySymbol, "0.00"));
        }
      } else {
        return null;
      }
    } else {
      if (quantityType === ALL_ONE_MONEY) {
        return /*#__PURE__*/React.createElement(Typography, {
          className: classes.textFontSize
        }, "Quantity: ".concat(quantity));
      } else {
        return null;
      }
    }
  };

  if (props.step === INITIAL_STEP) {
    if (props.isItemSoldOrPassed) {
      if (props.bidAmount === null || props.reserveMet !== null && !props.reserveMet) {
        return /*#__PURE__*/React.createElement(Typography, {
          id: elementId,
          className: classnames(classes.textFormat, classes.textFontSize)
        }, "This Item Was Not Sold");
      } else {
        if (props.quantity > 1) {
          if (props.quantityType === ALL_ONE_MONEY) {
            return /*#__PURE__*/React.createElement(Typography, {
              id: elementId,
              className: classnames(classes.textFormat, classes.textFontSize, isLoggedIn && classes.toYouFormat)
            }, "For ".concat(highBidAmount, " to ").concat(isLoggedIn ? 'YOU' : props.highBidderUsername));
          } else {
            return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
              id: elementId,
              className: classnames(classes.textFormat, classes.textFontSize, isLoggedIn && classes.toYouFormat)
            }, "For ".concat(highBidAmountTimes, " (").concat(highBidAmount, " x ").concat(props.quantity, ") to ").concat(isLoggedIn ? 'YOU' : props.highBidderUsername)));
          }
        } else {
          return /*#__PURE__*/React.createElement(Typography, {
            id: elementId,
            className: classnames(classes.textFormat, classes.textFontSize, isLoggedIn && classes.toYouFormat)
          }, "For ".concat(highBidAmount, " to ").concat(isLoggedIn ? 'YOU' : props.highBidderUsername));
        }
      }
    } else {
      if (props.bidAmount === null) {
        if (props.reserveMet !== null) {
          return /*#__PURE__*/React.createElement(Typography, {
            id: elementId,
            className: classes.noBidsPlacedTextFormat,
            component: 'div'
          }, "No Bids Placed", /*#__PURE__*/React.createElement("span", null, getQuantityOpening(props.quantity, props.quantityType, props.startPrice, props.currencySymbol)));
        } else {
          return getQuantityOpening(props.quantity, props.quantityType, props.startPrice, props.currencySymbol);
        }
      } else {
        if (props.quantity > 1) {
          if (props.quantityType === ALL_ONE_MONEY) {
            return /*#__PURE__*/React.createElement(Typography, {
              id: elementId,
              className: classnames(classes.textFormat, classes.textFontSize, isLoggedIn && classes.toYouFormat)
            }, "Total Bid: ".concat(highBidAmount), " ", /*#__PURE__*/React.createElement("span", {
              className: classes.quantityTextFormat
            }, "(Quantity: ".concat(props.quantity, ")")));
          } else {
            return /*#__PURE__*/React.createElement(Typography, {
              id: elementId
            }, /*#__PURE__*/React.createElement("span", {
              className: classnames(classes.textFormat, classes.textFontSize, isLoggedIn && classes.toYouFormat)
            }, "Total Bid: ".concat(highBidAmountTimes, " ")), /*#__PURE__*/React.createElement("span", {
              className: classes.quantityTextFormat
            }, " ", "(".concat(highBidAmount, " x ").concat(props.quantity, ")")));
          }
        } else {
          return /*#__PURE__*/React.createElement(Typography, {
            id: elementId,
            className: classnames(classes.textFormat, classes.textFontSize, isLoggedIn && classes.toYouFormat)
          }, "High Bid: ", highBidAmountTimes);
        }
      }
    }
  } else {
    return getConfirmBidText(elementId, classes, props.maxBidInput, props.nextBidAmount, props.bidAmount, highBidAmount, props.currencySymbol, props.quantity, props.quantityType);
  }
}

var mapStateToProps$5 = function mapStateToProps(state) {
  return {
    highBidderUsername: state.currentBid.highBidderUsername,
    bidAmount: state.currentBid.bidAmount,
    nextBidAmount: state.currentBid.nextBidAmount,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    quantity: state.currentBid.quantity,
    quantityType: state.currentBid.quantityType,
    reserveMet: state.currentBid.reserveMet,
    maxBidInput: state.currentBid.input,
    startPrice: state.currentBid.startPrice,
    highBidderReferenceId: state.currentBid.highBidderReferenceId,
    step: state.widget.step,
    lowBidIncrement: state.error.lowBidIncrement,
    highBidIncrement: state.error.highBidIncrement
  };
};

var HighBidTextWithStore = connect(mapStateToProps$5)(HighBidText);
var useStyles$4 = makeStyles(function () {
  return {
    textFormat: {
      fontWeight: 600
    },
    toYouFormat: {
      fontSize: '1rem',
      color: '#23B376'
    },
    confirmCurrentHighBid: {
      fontSize: '1rem',
      margin: '0 0 1rem'
    },
    youEnteredTextFormat: {
      color: grey[600]
    },
    textFontSize: {
      fontSize: '1rem'
    },
    quantityTextFormat: {
      fontWeight: 300
    }
  };
});
var useStyles$5 = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      background: grey[200],
      alignItems: 'center',
      justifyContent: 'center'
    },
    alignCenter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    textFormat: {
      color: grey[600],
      fontSize: '1rem',
      fontWeight: 300
    },
    toYouFormat: {
      color: '#23B376',
      fontSize: '1rem'
    }
  };
});
BidderDetailText.propTypes = {
  step: PropTypes__default.number,
  bidAmount: PropTypes__default.number,
  currentMaxBidAmount: PropTypes__default.number,
  bidderId: PropTypes__default.string,
  highBidderReferenceId: PropTypes__default.string,
  isItemSoldOrPassed: PropTypes__default.bool,
  highBidderUsername: PropTypes__default.string
};

function BidderDetailText(props) {
  var classes = useStyles$5();
  var elementId = 'bidDetailText';
  var isLoggedIn = isLoggedInBidder(props.highBidderReferenceId, props.bidderId);

  var getText = function getText() {
    if (isLoggedIn) {
      return 'You';
    } else {
      return props.highBidderUsername;
    }
  };

  var getClasses = function getClasses() {
    if (isLoggedIn) {
      return classnames(classes.textFormat, classes.toYouFormat);
    } else {
      return classes.textFormat;
    }
  };

  if (props.step === INITIAL_STEP) {
    if (!props.isItemSoldOrPassed) {
      if (props.bidAmount != null) {
        return /*#__PURE__*/React.createElement(Typography, {
          id: elementId,
          className: getClasses()
        }, "By ".concat(getText()));
      } else {
        return null;
      }
    } else {
      return null;
    }
  } else {
    return null;
  }
}

var mapStateToProps$6 = function mapStateToProps(state) {
  return {
    bidAmount: state.currentBid.bidAmount,
    step: state.widget.step,
    currentMaxBidAmount: state.error.currentMaxBidAmount,
    highBidderReferenceId: state.currentBid.highBidderReferenceId,
    highBidderUsername: state.currentBid.highBidderUsername
  };
};

var BidderDetailTextWithStore = connect(mapStateToProps$6)(BidderDetailText);
var utils$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.noop = noop;
  exports.returnTrue = returnTrue;
  exports.charIsNumber = charIsNumber;
  exports.escapeRegExp = escapeRegExp;
  exports.getThousandsGroupRegex = getThousandsGroupRegex;
  exports.applyThousandSeparator = applyThousandSeparator;
  exports.splitDecimal = splitDecimal;
  exports.fixLeadingZero = fixLeadingZero;
  exports.limitToScale = limitToScale;
  exports.roundToPrecision = roundToPrecision;
  exports.omit = omit;
  exports.setCaretPosition = setCaretPosition;
  exports.findChangedIndex = findChangedIndex;
  exports.clamp = clamp;
  exports.getCurrentCaretPosition = getCurrentCaretPosition; // basic noop function

  function noop() {}

  function returnTrue() {
    return true;
  }

  function charIsNumber(char) {
    return !!(char || '').match(/\d/);
  }

  function escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
  }

  function getThousandsGroupRegex(thousandsGroupStyle) {
    switch (thousandsGroupStyle) {
      case 'lakh':
        return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;

      case 'wan':
        return /(\d)(?=(\d{4})+(?!\d))/g;

      case 'thousand':
      default:
        return /(\d)(?=(\d{3})+(?!\d))/g;
    }
  }

  function applyThousandSeparator(str, thousandSeparator, thousandsGroupStyle) {
    var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
    var index = str.search(/[1-9]/);
    return str.substring(0, index) + str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator);
  } //spilt a float number into different parts beforeDecimal, afterDecimal, and negation


  function splitDecimal(numStr) {
    var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var hasNagation = numStr[0] === '-';
    var addNegation = hasNagation && allowNegative;
    numStr = numStr.replace('-', '');
    var parts = numStr.split('.');
    var beforeDecimal = parts[0];
    var afterDecimal = parts[1] || '';
    return {
      beforeDecimal: beforeDecimal,
      afterDecimal: afterDecimal,
      hasNagation: hasNagation,
      addNegation: addNegation
    };
  }

  function fixLeadingZero(numStr) {
    if (!numStr) return numStr;
    var isNegative = numStr[0] === '-';
    if (isNegative) numStr = numStr.substring(1, numStr.length);
    var parts = numStr.split('.');
    var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
    var afterDecimal = parts[1] || '';
    return "".concat(isNegative ? '-' : '').concat(beforeDecimal).concat(afterDecimal ? ".".concat(afterDecimal) : '');
  }
  /**
   * limit decimal numbers to given scale
   * Not used .fixedTo because that will break with big numbers
   */


  function limitToScale(numStr, scale, fixedDecimalScale) {
    var str = '';
    var filler = fixedDecimalScale ? '0' : '';

    for (var i = 0; i <= scale - 1; i++) {
      str += numStr[i] || filler;
    }

    return str;
  }
  /**
   * This method is required to round prop value to given scale.
   * Not used .round or .fixedTo because that will break with big numbers
   */


  function roundToPrecision(numStr, scale, fixedDecimalScale) {
    //if number is empty don't do anything return empty string
    if (['', '-'].indexOf(numStr) !== -1) return numStr;
    var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;

    var _splitDecimal = splitDecimal(numStr),
        beforeDecimal = _splitDecimal.beforeDecimal,
        afterDecimal = _splitDecimal.afterDecimal,
        hasNagation = _splitDecimal.hasNagation;

    var roundedDecimalParts = parseFloat("0.".concat(afterDecimal || '0')).toFixed(scale).split('.');
    var intPart = beforeDecimal.split('').reverse().reduce(function (roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
      }

      return current + roundedStr;
    }, roundedDecimalParts[0]);
    var decimalPart = limitToScale(roundedDecimalParts[1] || '', Math.min(scale, afterDecimal.length), fixedDecimalScale);
    var negation = hasNagation ? '-' : '';
    var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
    return "".concat(negation).concat(intPart).concat(decimalSeparator).concat(decimalPart);
  }

  function omit(obj, keyMaps) {
    var filteredObj = {};
    Object.keys(obj).forEach(function (key) {
      if (!keyMaps[key]) filteredObj[key] = obj[key];
    });
    return filteredObj;
  }
  /** set the caret positon in an input field **/


  function setCaretPosition(el, caretPos) {
    el.value = el.value; // ^ this is used to not only get "focus", but
    // to make sure we don't have it everything -selected-
    // (it causes an issue in chrome, and having it doesn't hurt any other browser)

    if (el !== null) {
      if (el.createTextRange) {
        var range = el.createTextRange();
        range.move('character', caretPos);
        range.select();
        return true;
      } // (el.selectionStart === 0 added for Firefox bug)


      if (el.selectionStart || el.selectionStart === 0) {
        el.focus();
        el.setSelectionRange(caretPos, caretPos);
        return true;
      } // fail city, fortunately this never happens (as far as I've tested) :)


      el.focus();
      return false;
    }
  }
  /**
    Given previous value and newValue it returns the index
    start - end to which values have changed.
    This function makes assumption about only consecutive
    characters are changed which is correct assumption for caret input.
  */


  function findChangedIndex(prevValue, newValue) {
    var i = 0,
        j = 0;
    var prevLength = prevValue.length;
    var newLength = newValue.length;

    while (prevValue[i] === newValue[i] && i < prevLength) {
      i++;
    } //check what has been changed from last


    while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i) {
      j++;
    }

    return {
      start: i,
      end: prevLength - j
    };
  }
  /*
    Returns a number whose value is limited to the given range
  */


  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  function getCurrentCaretPosition(el) {
    /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
    return Math.max(el.selectionStart, el.selectionEnd);
  }
});
unwrapExports(utils$2);
var utils_1 = utils$2.noop;
var utils_2 = utils$2.returnTrue;
var utils_3 = utils$2.charIsNumber;
var utils_4 = utils$2.escapeRegExp;
var utils_5 = utils$2.getThousandsGroupRegex;
var utils_6 = utils$2.applyThousandSeparator;
var utils_7 = utils$2.splitDecimal;
var utils_8 = utils$2.fixLeadingZero;
var utils_9 = utils$2.limitToScale;
var utils_10 = utils$2.roundToPrecision;
var utils_11 = utils$2.omit;
var utils_12 = utils$2.setCaretPosition;
var utils_13 = utils$2.findChangedIndex;
var utils_14 = utils$2.clamp;
var utils_15 = utils$2.getCurrentCaretPosition;
var number_format = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;

  var _propTypes = _interopRequireDefault(PropTypes__default);

  var _react = _interopRequireDefault(React);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  var propTypes = {
    thousandSeparator: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.oneOf([true])]),
    decimalSeparator: _propTypes.default.string,
    thousandsGroupStyle: _propTypes.default.oneOf(['thousand', 'lakh', 'wan']),
    decimalScale: _propTypes.default.number,
    fixedDecimalScale: _propTypes.default.bool,
    displayType: _propTypes.default.oneOf(['input', 'text']),
    prefix: _propTypes.default.string,
    suffix: _propTypes.default.string,
    format: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    removeFormatting: _propTypes.default.func,
    mask: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    isNumericString: _propTypes.default.bool,
    customInput: _propTypes.default.elementType,
    allowNegative: _propTypes.default.bool,
    allowEmptyFormatting: _propTypes.default.bool,
    onValueChange: _propTypes.default.func,
    onKeyDown: _propTypes.default.func,
    onMouseUp: _propTypes.default.func,
    onChange: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    type: _propTypes.default.oneOf(['text', 'tel', 'password']),
    isAllowed: _propTypes.default.func,
    renderText: _propTypes.default.func,
    getInputRef: _propTypes.default.func
  };
  var defaultProps = {
    displayType: 'input',
    decimalSeparator: '.',
    thousandsGroupStyle: 'thousand',
    fixedDecimalScale: false,
    prefix: '',
    suffix: '',
    allowNegative: true,
    allowEmptyFormatting: false,
    isNumericString: false,
    type: 'text',
    onValueChange: utils$2.noop,
    onChange: utils$2.noop,
    onKeyDown: utils$2.noop,
    onMouseUp: utils$2.noop,
    onFocus: utils$2.noop,
    onBlur: utils$2.noop,
    isAllowed: utils$2.returnTrue,
    getInputRef: utils$2.noop
  };

  var NumberFormat = /*#__PURE__*/function (_React$Component) {
    _inherits(NumberFormat, _React$Component);

    function NumberFormat(props) {
      var _this;

      _classCallCheck(this, NumberFormat);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberFormat).call(this, props));
      var defaultValue = props.defaultValue; //validate props

      _this.validateProps();

      var formattedValue = _this.formatValueProp(defaultValue);

      _this.state = {
        value: formattedValue,
        numAsString: _this.removeFormatting(formattedValue)
      };
      _this.selectionBeforeInput = {
        selectionStart: 0,
        selectionEnd: 0
      };
      _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(NumberFormat, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        this.updateValueIfRequired(prevProps);
      }
    }, {
      key: "updateValueIfRequired",
      value: function updateValueIfRequired(prevProps) {
        var props = this.props,
            state = this.state,
            focusedElm = this.focusedElm;
        var stateValue = state.value,
            _state$numAsString = state.numAsString,
            lastNumStr = _state$numAsString === void 0 ? '' : _state$numAsString;

        if (prevProps !== props) {
          //validate props
          this.validateProps();
          var lastValueWithNewFormat = this.formatNumString(lastNumStr);
          var formattedValue = props.value === undefined ? lastValueWithNewFormat : this.formatValueProp();
          var numAsString = this.removeFormatting(formattedValue);
          var floatValue = parseFloat(numAsString);
          var lastFloatValue = parseFloat(lastNumStr);

          if ( //while typing set state only when float value changes
          (!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || //can also set state when float value is same and the format props changes
          lastValueWithNewFormat !== stateValue || //set state always when not in focus and formatted value is changed
          focusedElm === null && formattedValue !== stateValue) {
            this.updateValue({
              formattedValue: formattedValue,
              numAsString: numAsString,
              input: focusedElm
            });
          }
        }
      }
      /** Misc methods **/

    }, {
      key: "getFloatString",
      value: function getFloatString() {
        var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var decimalScale = this.props.decimalScale;

        var _this$getSeparators = this.getSeparators(),
            decimalSeparator = _this$getSeparators.decimalSeparator;

        var numRegex = this.getNumberRegex(true); //remove negation for regex check

        var hasNegation = num[0] === '-';
        if (hasNegation) num = num.replace('-', ''); //if decimal scale is zero remove decimal and number after decimalSeparator

        if (decimalSeparator && decimalScale === 0) {
          num = num.split(decimalSeparator)[0];
        }

        num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.'); //remove extra decimals

        var firstDecimalIndex = num.indexOf('.');

        if (firstDecimalIndex !== -1) {
          num = "".concat(num.substring(0, firstDecimalIndex), ".").concat(num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, utils$2.escapeRegExp)(decimalSeparator), 'g'), ''));
        } //add negation back


        if (hasNegation) num = '-' + num;
        return num;
      } //returned regex assumes decimalSeparator is as per prop

    }, {
      key: "getNumberRegex",
      value: function getNumberRegex(g, ignoreDecimalSeparator) {
        var _this$props = this.props,
            format = _this$props.format,
            decimalScale = _this$props.decimalScale;

        var _this$getSeparators2 = this.getSeparators(),
            decimalSeparator = _this$getSeparators2.decimalSeparator;

        return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, utils$2.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
      }
    }, {
      key: "getSeparators",
      value: function getSeparators() {
        var decimalSeparator = this.props.decimalSeparator;
        var thousandSeparator = this.props.thousandSeparator;

        if (thousandSeparator === true) {
          thousandSeparator = ',';
        }

        return {
          decimalSeparator: decimalSeparator,
          thousandSeparator: thousandSeparator
        };
      }
    }, {
      key: "getMaskAtIndex",
      value: function getMaskAtIndex(index) {
        var _this$props$mask = this.props.mask,
            mask = _this$props$mask === void 0 ? ' ' : _this$props$mask;

        if (typeof mask === 'string') {
          return mask;
        }

        return mask[index] || ' ';
      }
    }, {
      key: "getValueObject",
      value: function getValueObject(formattedValue, numAsString) {
        var floatValue = parseFloat(numAsString);
        return {
          formattedValue: formattedValue,
          value: numAsString,
          floatValue: isNaN(floatValue) ? undefined : floatValue
        };
      }
    }, {
      key: "validateProps",
      value: function validateProps() {
        var mask = this.props.mask; //validate decimalSeparator and thousandSeparator

        var _this$getSeparators3 = this.getSeparators(),
            decimalSeparator = _this$getSeparators3.decimalSeparator,
            thousandSeparator = _this$getSeparators3.thousandSeparator;

        if (decimalSeparator === thousandSeparator) {
          throw new Error("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: ".concat(thousandSeparator, " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: ").concat(decimalSeparator, " (default value for decimalSeparator is .)\n       "));
        } //validate mask


        if (mask) {
          var maskAsStr = mask === 'string' ? mask : mask.toString();

          if (maskAsStr.match(/\d/g)) {
            throw new Error("\n          Mask ".concat(mask, " should not contain numeric character;\n        "));
          }
        }
      }
      /** Misc methods end **/

      /** caret specific methods **/

    }, {
      key: "setPatchedCaretPosition",
      value: function setPatchedCaretPosition(el, caretPos, currentValue) {
        /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */
        (0, utils$2.setCaretPosition)(el, caretPos);
        setTimeout(function () {
          if (el.value === currentValue) (0, utils$2.setCaretPosition)(el, caretPos);
        }, 0);
      }
      /* This keeps the caret within typing area so people can't type in between prefix or suffix */

    }, {
      key: "correctCaretPosition",
      value: function correctCaretPosition(value, caretPos, direction) {
        var _this$props2 = this.props,
            prefix = _this$props2.prefix,
            suffix = _this$props2.suffix,
            format = _this$props2.format; //if value is empty return 0

        if (value === '') return 0; //caret position should be between 0 and value length

        caretPos = (0, utils$2.clamp)(caretPos, 0, value.length); //in case of format as number limit between prefix and suffix

        if (!format) {
          var hasNegation = value[0] === '-';
          return (0, utils$2.clamp)(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
        } //in case if custom format method don't do anything


        if (typeof format === 'function') return caretPos;
        /* in case format is string find the closest # position from the caret position */
        //in case the caretPos have input value on it don't do anything

        if (format[caretPos] === '#' && (0, utils$2.charIsNumber)(value[caretPos])) return caretPos; //if caretPos is just after input value don't do anything

        if (format[caretPos - 1] === '#' && (0, utils$2.charIsNumber)(value[caretPos - 1])) return caretPos; //find the nearest caret position

        var firstHashPosition = format.indexOf('#');
        var lastHashPosition = format.lastIndexOf('#'); //limit the cursor between the first # position and the last # position

        caretPos = (0, utils$2.clamp)(caretPos, firstHashPosition, lastHashPosition + 1);
        var nextPos = format.substring(caretPos, format.length).indexOf('#');
        var caretLeftBound = caretPos;
        var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos); //get the position where the last number is present

        while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, utils$2.charIsNumber)(value[caretLeftBound]))) {
          caretLeftBound -= 1;
        }

        var goToLeft = !(0, utils$2.charIsNumber)(value[caretRightBound]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;

        if (goToLeft) {
          //check if number should be taken after the bound or after it
          //if number preceding a valid number keep it after
          return (0, utils$2.charIsNumber)(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
        }

        return caretRightBound;
      }
    }, {
      key: "getCaretPosition",
      value: function getCaretPosition(inputValue, formattedValue, caretPos) {
        var format = this.props.format;
        var stateValue = this.state.value;
        var numRegex = this.getNumberRegex(true);
        var inputNumber = (inputValue.match(numRegex) || []).join('');
        var formattedNumber = (formattedValue.match(numRegex) || []).join('');
        var j, i;
        j = 0;

        for (i = 0; i < caretPos; i++) {
          var currentInputChar = inputValue[i] || '';
          var currentFormatChar = formattedValue[j] || ''; //no need to increase new cursor position if formatted value does not have those characters
          //case inputValue = 1a23 and formattedValue =  123

          if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue; //When we are striping out leading zeros maintain the new cursor position
          //Case inputValue = 00023 and formattedValue = 23;

          if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue; //we are not using currentFormatChar because j can change here

          while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
            j++;
          }

          j++;
        }

        if (typeof format === 'string' && !stateValue) {
          //set it to the maximum value so it goes after the last number
          j = formattedValue.length;
        } //correct caret position if its outside of editable area


        j = this.correctCaretPosition(formattedValue, j);
        return j;
      }
      /** caret specific methods ends **/

      /** methods to remove formattting **/

    }, {
      key: "removePrefixAndSuffix",
      value: function removePrefixAndSuffix(val) {
        var _this$props3 = this.props,
            format = _this$props3.format,
            prefix = _this$props3.prefix,
            suffix = _this$props3.suffix; //remove prefix and suffix

        if (!format && val) {
          var isNegative = val[0] === '-'; //remove negation sign

          if (isNegative) val = val.substring(1, val.length); //remove prefix

          val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val; //remove suffix

          var suffixLastIndex = val.lastIndexOf(suffix);
          val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val; //add negation sign back

          if (isNegative) val = '-' + val;
        }

        return val;
      }
    }, {
      key: "removePatternFormatting",
      value: function removePatternFormatting(val) {
        var format = this.props.format;
        var formatArray = format.split('#').filter(function (str) {
          return str !== '';
        });
        var start = 0;
        var numStr = '';

        for (var i = 0, ln = formatArray.length; i <= ln; i++) {
          var part = formatArray[i] || ''; //if i is the last fragment take the index of end of the value
          //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##

          var index = i === ln ? val.length : val.indexOf(part, start);
          /* in any case if we don't find the pattern part in the value assume the val as numeric string
          This will be also in case if user has started typing, in any other case it will not be -1
          unless wrong prop value is provided */

          if (index === -1) {
            numStr = val;
            break;
          } else {
            numStr += val.substring(start, index);
            start = index + part.length;
          }
        }

        return (numStr.match(/\d/g) || []).join('');
      }
    }, {
      key: "removeFormatting",
      value: function removeFormatting(val) {
        var _this$props4 = this.props,
            format = _this$props4.format,
            removeFormatting = _this$props4.removeFormatting;
        if (!val) return val;

        if (!format) {
          val = this.removePrefixAndSuffix(val);
          val = this.getFloatString(val);
        } else if (typeof format === 'string') {
          val = this.removePatternFormatting(val);
        } else if (typeof removeFormatting === 'function') {
          //condition need to be handled if format method is provide,
          val = removeFormatting(val);
        } else {
          val = (val.match(/\d/g) || []).join('');
        }

        return val;
      }
      /** methods to remove formattting end **/

      /*** format specific methods start ***/

      /**
       * Format when # based string is provided
       * @param  {string} numStr Numeric String
       * @return {string}        formatted Value
       */

    }, {
      key: "formatWithPattern",
      value: function formatWithPattern(numStr) {
        var format = this.props.format;
        var hashCount = 0;
        var formattedNumberAry = format.split('');

        for (var i = 0, ln = format.length; i < ln; i++) {
          if (format[i] === '#') {
            formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
            hashCount += 1;
          }
        }

        return formattedNumberAry.join('');
      }
      /**
       * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
       * @return {string} formatted Value
       */

    }, {
      key: "formatAsNumber",
      value: function formatAsNumber(numStr) {
        var _this$props5 = this.props,
            decimalScale = _this$props5.decimalScale,
            fixedDecimalScale = _this$props5.fixedDecimalScale,
            prefix = _this$props5.prefix,
            suffix = _this$props5.suffix,
            allowNegative = _this$props5.allowNegative,
            thousandsGroupStyle = _this$props5.thousandsGroupStyle;

        var _this$getSeparators4 = this.getSeparators(),
            thousandSeparator = _this$getSeparators4.thousandSeparator,
            decimalSeparator = _this$getSeparators4.decimalSeparator;

        var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;

        var _splitDecimal = (0, utils$2.splitDecimal)(numStr, allowNegative),
            beforeDecimal = _splitDecimal.beforeDecimal,
            afterDecimal = _splitDecimal.afterDecimal,
            addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const
        //apply decimal precision if its defined


        if (decimalScale !== undefined) afterDecimal = (0, utils$2.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);

        if (thousandSeparator) {
          beforeDecimal = (0, utils$2.applyThousandSeparator)(beforeDecimal, thousandSeparator, thousandsGroupStyle);
        } //add prefix and suffix


        if (prefix) beforeDecimal = prefix + beforeDecimal;
        if (suffix) afterDecimal = afterDecimal + suffix; //restore negation sign

        if (addNegation) beforeDecimal = '-' + beforeDecimal;
        numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
        return numStr;
      }
    }, {
      key: "formatNumString",
      value: function formatNumString() {
        var numStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var _this$props6 = this.props,
            format = _this$props6.format,
            allowEmptyFormatting = _this$props6.allowEmptyFormatting;
        var formattedValue = numStr;

        if (numStr === '' && !allowEmptyFormatting) {
          formattedValue = '';
        } else if (numStr === '-' && !format) {
          formattedValue = '-';
        } else if (typeof format === 'string') {
          formattedValue = this.formatWithPattern(formattedValue);
        } else if (typeof format === 'function') {
          formattedValue = format(formattedValue);
        } else {
          formattedValue = this.formatAsNumber(formattedValue);
        }

        return formattedValue;
      }
    }, {
      key: "formatValueProp",
      value: function formatValueProp(defaultValue) {
        var _this$props7 = this.props,
            format = _this$props7.format,
            decimalScale = _this$props7.decimalScale,
            fixedDecimalScale = _this$props7.fixedDecimalScale,
            allowEmptyFormatting = _this$props7.allowEmptyFormatting;
        var _this$props8 = this.props,
            _this$props8$value = _this$props8.value,
            value = _this$props8$value === void 0 ? defaultValue : _this$props8$value,
            isNumericString = _this$props8.isNumericString;
        var isNonNumericFalsy = !value && value !== 0;

        if (isNonNumericFalsy && allowEmptyFormatting) {
          value = '';
        } // if value is not defined return empty string


        if (isNonNumericFalsy && !allowEmptyFormatting) return '';

        if (typeof value === 'number') {
          value = value.toString();
          isNumericString = true;
        } //change infinity value to empty string


        if (value === 'Infinity' && isNumericString) {
          value = '';
        } //round the number based on decimalScale
        //format only if non formatted value is provided


        if (isNumericString && !format && typeof decimalScale === 'number') {
          value = (0, utils$2.roundToPrecision)(value, decimalScale, fixedDecimalScale);
        }

        var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
        return formattedValue;
      }
    }, {
      key: "formatNegation",
      value: function formatNegation() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var allowNegative = this.props.allowNegative;
        var negationRegex = new RegExp('(-)');
        var doubleNegationRegex = new RegExp('(-)(.)*(-)'); // Check number has '-' value

        var hasNegation = negationRegex.test(value); // Check number has 2 or more '-' values

        var removeNegation = doubleNegationRegex.test(value); //remove negation

        value = value.replace(/-/g, '');

        if (hasNegation && !removeNegation && allowNegative) {
          value = '-' + value;
        }

        return value;
      }
    }, {
      key: "formatInput",
      value: function formatInput() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var format = this.props.format; //format negation only if we are formatting as number

        if (!format) {
          value = this.removePrefixAndSuffix(value);
          value = this.formatNegation(value);
        } //remove formatting from number


        value = this.removeFormatting(value);
        return this.formatNumString(value);
      }
      /*** format specific methods end ***/

    }, {
      key: "isCharacterAFormat",
      value: function isCharacterAFormat(caretPos, value) {
        var _this$props9 = this.props,
            format = _this$props9.format,
            prefix = _this$props9.prefix,
            suffix = _this$props9.suffix,
            decimalScale = _this$props9.decimalScale,
            fixedDecimalScale = _this$props9.fixedDecimalScale;

        var _this$getSeparators5 = this.getSeparators(),
            decimalSeparator = _this$getSeparators5.decimalSeparator; //check within format pattern


        if (typeof format === 'string' && format[caretPos] !== '#') return true; //check in number format

        if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
          return true;
        }

        return false;
      }
    }, {
      key: "checkIfFormatGotDeleted",
      value: function checkIfFormatGotDeleted(start, end, value) {
        for (var i = start; i < end; i++) {
          if (this.isCharacterAFormat(i, value)) return true;
        }

        return false;
      }
      /**
       * This will check if any formatting got removed by the delete or backspace and reset the value
       * It will also work as fallback if android chome keyDown handler does not work
       **/

    }, {
      key: "correctInputValue",
      value: function correctInputValue(caretPos, lastValue, value) {
        var _this$props10 = this.props,
            format = _this$props10.format,
            allowNegative = _this$props10.allowNegative,
            prefix = _this$props10.prefix,
            suffix = _this$props10.suffix;

        var _this$getSeparators6 = this.getSeparators(),
            decimalSeparator = _this$getSeparators6.decimalSeparator;

        var lastNumStr = this.state.numAsString || '';
        var _this$selectionBefore = this.selectionBeforeInput,
            selectionStart = _this$selectionBefore.selectionStart,
            selectionEnd = _this$selectionBefore.selectionEnd;

        var _findChangedIndex = (0, utils$2.findChangedIndex)(lastValue, value),
            start = _findChangedIndex.start,
            end = _findChangedIndex.end;
        /** Check if only . is added in the numeric format and replace it with decimal separator */


        if (!format && decimalSeparator !== '.' && start === end && value[selectionStart] === '.') {
          return value.substr(0, selectionStart) + decimalSeparator + value.substr(selectionStart + 1, value.length);
        }
        /* don't do anyhting if something got added,
         or if value is empty string (when whole input is cleared)
         or whole input is replace with a number
        */


        var leftBound = !!format ? 0 : prefix.length;
        var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

        if (value.length > lastValue.length || !value.length || start === end || selectionStart === 0 && selectionEnd === lastValue.length || selectionStart === leftBound && selectionEnd === rightBound) {
          return value;
        } //if format got deleted reset the value to last value


        if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
          value = lastValue;
        } //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
        //clear all numbers in such case while keeping the - sign


        if (!format) {
          var numericString = this.removeFormatting(value);

          var _splitDecimal2 = (0, utils$2.splitDecimal)(numericString, allowNegative),
              beforeDecimal = _splitDecimal2.beforeDecimal,
              afterDecimal = _splitDecimal2.afterDecimal,
              addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const
          //clear only if something got deleted


          var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;

          if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
            return addNegation ? '-' : '';
          }
        }

        return value;
      }
      /** Update value and caret position */

    }, {
      key: "updateValue",
      value: function updateValue(params) {
        var _this2 = this;

        var onUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : utils$2.noop;
        var formattedValue = params.formattedValue,
            input = params.input;
        var numAsString = params.numAsString,
            caretPos = params.caretPos;
        var onValueChange = this.props.onValueChange;
        var lastValue = this.state.value; //set caret position, and value imperatively when element is provided

        if (input) {
          //calculate caret position if not defined
          if (!caretPos) {
            var inputValue = params.inputValue || input.value;
            var currentCaretPosition = (0, utils$2.getCurrentCaretPosition)(input); //get the caret position

            caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
          } //set the value imperatively, this is required for IE fix


          input.value = formattedValue; //set caret position

          this.setPatchedCaretPosition(input, caretPos, formattedValue);
        } //calculate numeric string if not passed


        if (numAsString === undefined) {
          numAsString = this.removeFormatting(formattedValue);
        } //update state if value is changed


        if (formattedValue !== lastValue) {
          this.setState({
            value: formattedValue,
            numAsString: numAsString
          }, function () {
            onValueChange(_this2.getValueObject(formattedValue, numAsString));
            onUpdate();
          });
        } else {
          onUpdate();
        }
      }
    }, {
      key: "onChange",
      value: function onChange(e) {
        e.persist();
        var el = e.target;
        var inputValue = el.value;
        var state = this.state,
            props = this.props;
        var isAllowed = props.isAllowed;
        var lastValue = state.value || '';
        var currentCaretPosition = (0, utils$2.getCurrentCaretPosition)(el);
        inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
        var formattedValue = this.formatInput(inputValue) || '';
        var numAsString = this.removeFormatting(formattedValue);
        var valueObj = this.getValueObject(formattedValue, numAsString);

        if (!isAllowed(valueObj)) {
          formattedValue = lastValue;
        }

        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          inputValue: inputValue,
          input: el
        }, function () {
          props.onChange(e);
        });
      }
    }, {
      key: "onBlur",
      value: function onBlur(e) {
        var props = this.props,
            state = this.state;
        var format = props.format,
            onBlur = props.onBlur;
        var numAsString = state.numAsString;
        var lastValue = state.value;
        this.focusedElm = null;

        if (!format) {
          numAsString = (0, utils$2.fixLeadingZero)(numAsString);
          var formattedValue = this.formatNumString(numAsString); //change the state

          if (formattedValue !== lastValue) {
            // the event needs to be persisted because its properties can be accessed in an asynchronous way
            e.persist();
            this.updateValue({
              formattedValue: formattedValue,
              numAsString: numAsString
            }, function () {
              onBlur(e);
            });
            return;
          }
        }

        onBlur(e);
      }
    }, {
      key: "onKeyDown",
      value: function onKeyDown(e) {
        var el = e.target;
        var key = e.key;
        var selectionStart = el.selectionStart,
            selectionEnd = el.selectionEnd,
            _el$value = el.value,
            value = _el$value === void 0 ? '' : _el$value;
        var expectedCaretPosition;
        var _this$props11 = this.props,
            decimalScale = _this$props11.decimalScale,
            fixedDecimalScale = _this$props11.fixedDecimalScale,
            prefix = _this$props11.prefix,
            suffix = _this$props11.suffix,
            format = _this$props11.format,
            onKeyDown = _this$props11.onKeyDown,
            onValueChange = _this$props11.onValueChange;
        var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
        var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
        var negativeRegex = new RegExp('-');
        var isPatternFormat = typeof format === 'string';
        this.selectionBeforeInput = {
          selectionStart: selectionStart,
          selectionEnd: selectionEnd //Handle backspace and delete against non numerical/decimal characters or arrow keys

        };

        if (key === 'ArrowLeft' || key === 'Backspace') {
          expectedCaretPosition = selectionStart - 1;
        } else if (key === 'ArrowRight') {
          expectedCaretPosition = selectionStart + 1;
        } else if (key === 'Delete') {
          expectedCaretPosition = selectionStart;
        } //if expectedCaretPosition is not set it means we don't want to Handle keyDown
        //also if multiple characters are selected don't handle


        if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
          onKeyDown(e);
          return;
        }

        var newCaretPosition = expectedCaretPosition;
        var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
        var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

        if (key === 'ArrowLeft' || key === 'ArrowRight') {
          var direction = key === 'ArrowLeft' ? 'left' : 'right';
          newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
        } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
          while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
            newCaretPosition++;
          }
        } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
          /* NOTE: This is special case when backspace is pressed on a
          negative value while the cursor position is after prefix. We can't handle it on onChange because
          we will not have any information of keyPress
          */
          if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
            var newValue = value.substring(1); //persist event before performing async task

            e.persist();
            this.updateValue({
              formattedValue: newValue,
              caretPos: newCaretPosition,
              input: el
            });
          } else if (!negativeRegex.test(value[expectedCaretPosition])) {
            while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
              newCaretPosition--;
            }

            newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
          }
        }

        if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
          e.preventDefault();
          this.setPatchedCaretPosition(el, newCaretPosition, value);
        }
        /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
                Remove this when you find different solution */


        if (e.isUnitTestRun) {
          this.setPatchedCaretPosition(el, newCaretPosition, value);
        }

        this.props.onKeyDown(e);
      }
      /** required to handle the caret position when click anywhere within the input **/

    }, {
      key: "onMouseUp",
      value: function onMouseUp(e) {
        var el = e.target;
        /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
        */

        var selectionStart = el.selectionStart,
            selectionEnd = el.selectionEnd,
            _el$value2 = el.value,
            value = _el$value2 === void 0 ? '' : _el$value2;

        if (selectionStart === selectionEnd) {
          var caretPosition = this.correctCaretPosition(value, selectionStart);

          if (caretPosition !== selectionStart) {
            this.setPatchedCaretPosition(el, caretPosition, value);
          }
        }

        this.props.onMouseUp(e);
      }
    }, {
      key: "onFocus",
      value: function onFocus(e) {
        var _this3 = this; // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
        // (onFocus event target selectionStart is always 0 before setTimeout)


        e.persist();
        this.focusedElm = e.target;
        setTimeout(function () {
          var el = e.target;
          var selectionStart = el.selectionStart,
              selectionEnd = el.selectionEnd,
              _el$value3 = el.value,
              value = _el$value3 === void 0 ? '' : _el$value3;

          var caretPosition = _this3.correctCaretPosition(value, selectionStart); //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)


          if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
            _this3.setPatchedCaretPosition(el, caretPosition, value);
          }

          _this3.props.onFocus(e);
        }, 0);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props12 = this.props,
            type = _this$props12.type,
            displayType = _this$props12.displayType,
            customInput = _this$props12.customInput,
            renderText = _this$props12.renderText,
            getInputRef = _this$props12.getInputRef;
        var value = this.state.value;
        var otherProps = (0, utils$2.omit)(this.props, propTypes);

        var inputProps = _extends({}, otherProps, {
          type: type,
          value: value,
          onChange: this.onChange,
          onKeyDown: this.onKeyDown,
          onMouseUp: this.onMouseUp,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        });

        if (displayType === 'text') {
          return renderText ? renderText(value) || null : _react.default.createElement("span", _extends({}, otherProps, {
            ref: getInputRef
          }), value);
        } else if (customInput) {
          var CustomInput = customInput;
          return _react.default.createElement(CustomInput, inputProps);
        }

        return _react.default.createElement("input", _extends({}, inputProps, {
          ref: getInputRef
        }));
      }
    }]);

    return NumberFormat;
  }(_react.default.Component);

  NumberFormat.propTypes = propTypes;
  NumberFormat.defaultProps = defaultProps;
  var _default = NumberFormat;
  exports.default = _default;
  module.exports = exports.default;
});
var NumberFormat = unwrapExports(number_format);
var _excluded$1 = ["inputRef"];
MaxBidDiv.propTypes = {
  step: number,
  isItemSoldOrPassed: bool,
  currencyCode: string,
  maxBidInput: string,
  handleInputChange: func,
  lowBidIncrement: number,
  highBidIncrement: number,
  lastFourCc: string,
  handleEnterPress: func
};
NumberFormatCustom.propTypes = {
  inputRef: any
};

function NumberFormatCustom(props) {
  // eslint-disable-next-line no-unused-vars
  var inputRef = props.inputRef,
      rest = _objectWithoutProperties(props, _excluded$1);

  return /*#__PURE__*/React.createElement(NumberFormat, _extends({}, rest, {
    displayType: 'input',
    allowNegative: false
  }));
}

function MaxBidDiv(props) {
  var classes = useStyles$6();
  var elementId = 'maxBidInput';

  var getCcText = function getCcText(lastFourCc) {
    if (lastFourCc === null) {
      return /*#__PURE__*/React.createElement(Typography, {
        className: classes.paymentType
      }, "Contact Seller to Arrange Payment");
    } else {
      return /*#__PURE__*/React.createElement(Typography, {
        className: classes.paymentType
      }, "Payment: ", /*#__PURE__*/React.createElement("span", {
        className: classes.cardText
      }, "Ending with ", lastFourCc));
    }
  };

  if (props.step === INITIAL_STEP) {
    if (!props.isItemSoldOrPassed && props.lowBidIncrement == null && props.highBidIncrement == null) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.inputBackground
      }, /*#__PURE__*/React.createElement(Input$1, {
        id: elementId,
        placeholder: "Enter Max Bid",
        inputProps: {
          min: 0,
          maxLength: '16'
        },
        classes: {
          input: classes.inputContent
        },
        disableUnderline: true,
        value: props.maxBidInput,
        onChange: props.handleInputChange,
        onKeyDown: props.handleEnterPress,
        disabled: props.isItemSoldOrPassed,
        inputComponent: NumberFormatCustom,
        fullWidth: true,
        autoComplete: 'off'
      }));
    } else {
      return null;
    }
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.paymentContainer
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "div",
      id: elementId,
      className: classes.paymentType
    }, getCcText(props.lastFourCc)), props.lastFourCc !== null && /*#__PURE__*/React.createElement(Avatar, {
      "data-testid": 'changeCcButton',
      id: 'changeCcButton',
      className: classes.changeCardLink,
      onClick: props.handleChangeCc
    }, /*#__PURE__*/React.createElement(Create, null)));
  }
}

var useStyles$6 = makeStyles(function (theme) {
  return {
    inputBackground: {
      padding: '0.2rem',
      borderColor: grey[200],
      backgroundColor: '#FFFFFF',
      borderStyle: 'solid',
      width: '90%',
      borderRadius: 8
    },
    inputContent: {
      padding: '0.5rem',
      textAlign: 'center',
      lineHeight: '1.5',
      width: '100% !important'
    },
    paymentContainer: {
      display: 'flex',
      flexDirection: 'row',
      background: grey[200],
      alignItems: 'center',
      justifyContent: 'center'
    },
    paymentType: {
      fontSize: '0.875rem'
    },
    cardText: {
      color: theme.textColor[700],
      fontSize: '0.875rem',
      fontWeight: 600
    },
    changeCardLink: {
      color: lightBlue[600],
      backgroundColor: grey[200],
      alignItems: 'center',
      '&:hover': {
        color: lightBlue[400],
        cursor: 'pointer'
      }
    }
  };
});

var mapStateToProps$7 = function mapStateToProps(state) {
  return {
    maxBidInput: state.currentBid.input,
    lowBidIncrement: state.error.lowBidIncrement,
    highBidIncrement: state.error.highBidIncrement,
    currencyCode: state.currentBid.currencyCode,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    step: state.widget.step,
    lastFourCc: state.currentBid.lastFourCc
  };
};

var MaxBidDivWithStore = connect(mapStateToProps$7)(MaxBidDiv);
var useStyles$7 = makeStyles(function (theme) {
  return {
    errorText: {
      fontSize: '0.85rem',
      color: theme.palette.error[800]
    }
  };
});

function ErrorHelperText(props) {
  var classes = useStyles$7();

  var getErrorText = function getErrorText(currencySymbol, currentMaxBidAmount, errorCode) {
    var text;

    switch (errorCode) {
      case AMOUNT_LOWER_MAX_BID:
        text = "You've already placed a bid of ".concat(currencySymbol).concat(currentMaxBidAmount.toLocaleString(undefined, options), " on this lot");
        break;

      case AMOUNT_LOWER_HIGH_BID:
        text = 'Your bid is too low. Please bid higher.';
        break;

      case INVALID_BID_AMOUNT:
        text = "Your bid must be greater than ".concat(currencySymbol, "0.00");
        break;

      case AMOUNT_LOWER_START_PRICE:
        text = "The minimum bid on this lot is ".concat(currencySymbol).concat(currentMaxBidAmount.toLocaleString(undefined, options), ".");
        break;

      case BID_RETRACTION_IN_PROGRESS:
        text = 'Bid not accepted.  Please try again.';
        break;

      default:
        text = null;
    }

    return text;
  };

  if (props.step === INITIAL_STEP) {
    return /*#__PURE__*/React.createElement(Typography, {
      "data-testid": 'biddingErrorMessage',
      id: 'biddingErrorMessage',
      className: classes.errorText
    }, getErrorText(props.currencySymbol, props.currentMaxBidAmount, props.errorCode));
  } else {
    return null;
  }
}

ErrorHelperText.propTypes = {
  errorCode: PropTypes__default.string,
  currentMaxBidAmount: PropTypes__default.number,
  currencySymbol: PropTypes__default.string
};

var mapStateToProps$8 = function mapStateToProps(state) {
  return {
    currentMaxBidAmount: state.error.currentMaxBidAmount,
    errorCode: state.error.errorCode
  };
};

var ErrorHelperTextWithStore = connect(mapStateToProps$8)(ErrorHelperText);
var useStyles$8 = makeStyles(function (theme) {
  return {
    soldPendingConfirmation: {
      fontWeight: 600
    }
  };
});
SoldPendingConfirmationText.propTypes = {
  step: PropTypes__default.number,
  isItemSoldOrPassed: PropTypes__default.bool,
  allowSoldPendingConfirmation: PropTypes__default.bool
};

function SoldPendingConfirmationText(props) {
  var classes = useStyles$8();
  var elementId = 'soldPendingConfirmationText';
  return props.step === INITIAL_STEP && props.isItemSoldOrPassed && props.allowSoldPendingConfirmation && /*#__PURE__*/React.createElement(Typography, {
    id: elementId,
    className: classes.soldPendingConfirmation
  }, "Pending Confirmation");
}

var useStyles$9 = makeStyles(function (theme) {
  return {
    buttonTextStyle: {
      display: 'flex',
      alignItems: 'center',
      color: grey[50]
    }
  };
});
IncrementButton.propTypes = {
  id: PropTypes__default.string,
  incrementAmount: PropTypes__default.number,
  incrementArrowType: PropTypes__default.object,
  currencySymbol: PropTypes__default.string,
  color: PropTypes__default.string,
  variant: PropTypes__default.string,
  handleBidIncrementClick: PropTypes__default.func
};

function IncrementButton(props) {
  var classes = useStyles$9();
  return /*#__PURE__*/React.createElement(Button, {
    size: "small",
    color: props.color,
    variant: props.variant,
    id: props.id,
    onClick: props.handleBidIncrementClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.buttonTextStyle
  }, props.incrementArrowType, /*#__PURE__*/React.createElement(Typography, null, props.currencySymbol, props.incrementAmount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }))));
}

IncrementChoice.propTypes = {
  step: PropTypes__default.number,
  lowBidIncrement: PropTypes__default.number,
  highBidIncrement: PropTypes__default.number,
  handleHighBidIncrementClick: PropTypes__default.func,
  handleLowBidIncrementClick: PropTypes__default.func,
  itemId: PropTypes__default.string,
  handleCancelBidButtonClick: PropTypes__default.func,
  currencySymbol: PropTypes__default.string,
  isItemSoldOrPassed: PropTypes__default.bool
};

function IncrementChoice(props) {
  var classes = useStyles$a();
  return props.lowBidIncrement !== null && props.highBidIncrement !== null && props.step === INITIAL_STEP && !props.isItemSoldOrPassed && /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    direction: "column",
    className: classes.incrementChoice,
    wrap: "nowrap",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true
  }, /*#__PURE__*/React.createElement(IncrementButton, {
    color: "primary",
    variant: "contained",
    id: "incrementUp-".concat(props.itemId),
    incrementArrowType: /*#__PURE__*/React.createElement(ArrowUpward, null),
    incrementAmount: props.highBidIncrement,
    currencySymbol: props.currencySymbol,
    handleBidIncrementClick: props.handleHighBidIncrementClick
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.incrementChoiceText
  }, "OR")), /*#__PURE__*/React.createElement(Grid$1, {
    item: true
  }, /*#__PURE__*/React.createElement(IncrementButton, {
    color: "secondary",
    variant: "contained",
    id: "incrementDown-".concat(props.itemId),
    incrementArrowType: /*#__PURE__*/React.createElement(ArrowDownward, null),
    incrementAmount: props.lowBidIncrement,
    currencySymbol: props.currencySymbol,
    handleBidIncrementClick: props.handleLowBidIncrementClick
  })));
}

var useStyles$a = makeStyles(function (theme) {
  return {
    incrementChoice: {
      marginBottom: '0.5rem'
    },
    incrementChoiceText: {
      color: grey[600],
      justifyContent: 'center',
      padding: '7px 5px 7px'
    }
  };
});

var mapStateToProps$9 = function mapStateToProps(state) {
  return {
    secondsRemaining: state.currentBid.secondsRemaining,
    bidAmount: state.currentBid.bidAmount,
    reserveMet: state.currentBid.reserveMet,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    lowBidIncrement: state.error.lowBidIncrement,
    highBidIncrement: state.error.highBidIncrement,
    step: state.widget.step
  };
};

var IncrementChoiceWithStore = connect(mapStateToProps$9)(IncrementChoice);
var useStyles$b = makeStyles(function (theme) {
  return {
    openingBidText: {
      color: '#23B376',
      fontWeight: 500,
      fontSize: '1rem'
    }
  };
});
StartPriceText.propTypes = {
  step: PropTypes__default.number,
  isItemSoldOrPassed: PropTypes__default.bool,
  startPrice: PropTypes__default.number,
  bidAmount: PropTypes__default.number,
  quantityType: PropTypes__default.string,
  quantity: PropTypes__default.number,
  currencySymbol: PropTypes__default.string,
  itemHasFailed: PropTypes__default.bool,
  isLoadingItem: PropTypes__default.bool
};

function StartPriceText(props) {
  var classes = useStyles$b();
  var elementId = 'startPriceText';

  if (props.step === INITIAL_STEP && props.bidAmount < props.startPrice && !props.isItemSoldOrPassed && !props.itemHasFailed && !props.isLoadingItem) {
    if (props.quantity === 1 || props.quantityType === ALL_ONE_MONEY) {
      return /*#__PURE__*/React.createElement(Typography, {
        id: elementId,
        className: classes.openingBidText
      }, "Opening Bid : ".concat(props.currencySymbol).concat(props.startPrice.toLocaleString(undefined, options)));
    } else {
      return /*#__PURE__*/React.createElement(Typography, {
        id: elementId
      }, /*#__PURE__*/React.createElement("span", {
        className: classes.openingBidText
      }, "Opening Bid : ".concat(props.currencySymbol).concat(props.startPrice.toLocaleString(undefined, options))), " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        className: classes.openingBidText
      }, "Total Bid :"), /*#__PURE__*/React.createElement("span", null, " ".concat(props.currencySymbol).concat(getTimesTheMoneyTotal(props.quantity, props.startPrice).toLocaleString(undefined, options), "\n                        (").concat(props.currencySymbol).concat(props.startPrice.toLocaleString(undefined, options), " x ").concat(props.quantity, ")")));
    }
  } else {
    return null;
  }
}

var mapStateToProps$a = function mapStateToProps(state) {
  return {
    bidAmount: state.currentBid.bidAmount,
    startPrice: state.currentBid.startPrice,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    quantity: state.currentBid.quantity,
    quantityType: state.currentBid.quantityType,
    reserveMet: state.currentBid.reserveMet,
    highBidderReferenceId: state.currentBid.highBidderReferenceId,
    hasItemFailed: state.currentBid.hasItemFailed,
    isLoadingItem: state.currentBid.isLoading,
    step: state.widget.step
  };
};

var StartPriceTextWithStore = connect(mapStateToProps$a)(StartPriceText);
var useStyles$c = makeStyles(function (theme) {
  return {
    cancelButtonFormat: {
      flex: '0 1 auto',
      borderRadius: 5,
      backgroundColor: '#FFFFFF',
      '&:hover': {
        backgroundColor: grey[300]
      }
    },
    cancelBidButtonText: {
      color: grey[900],
      fontSize: '1rem'
    }
  };
});
CancelBidButton.propTypes = {
  handleCancelBidButtonClick: PropTypes__default.func,
  step: PropTypes__default.number,
  isItemSoldOrPassed: PropTypes__default.bool,
  hasItemFailed: PropTypes__default.bool,
  isLoadingItem: PropTypes__default.bool
};

function CancelBidButton(props) {
  var classes = useStyles$c();
  var cancelBidButtonId = 'cancelBidButton';
  var cancelBidButtonTextId = 'cancelBidButtonText';

  if (props.step === CONFIRM_STEP && !props.isItemSoldOrPassed && !props.hasItemFailed && !props.isLoadingItem) {
    return /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      variant: "contained",
      id: cancelBidButtonId,
      className: classes.cancelButtonFormat,
      onClick: props.handleCancelBidButtonClick,
      size: "medium",
      style: {
        boxShadow: 'none'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      id: cancelBidButtonTextId,
      className: classes.cancelBidButtonText
    }, "Cancel"));
  } else {
    return null;
  }
}

var mapStateToProps$b = function mapStateToProps(state, ownProps) {
  return {
    step: ownProps.step || state.widget.step,
    isLoadingItem: state.currentBid.isLoading,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    hasItemFailed: state.currentBid.hasItemFailed
  };
};

var CancelBidButtonWithStore = connect(mapStateToProps$b)(CancelBidButton);
var useStyles$d = makeStyles(function (theme) {
  return {
    fontContent: {
      color: red[800],
      fontSize: '0.875rem'
    }
  };
});
OutbidText.propTypes = {
  step: PropTypes__default.number,
  bidderItemStatus: PropTypes__default.string
};

function OutbidText(props) {
  var classes = useStyles$d();
  return props.step === INITIAL_STEP && props.bidderItemStatus === OUTBID ? /*#__PURE__*/React.createElement(Typography$1, {
    id: 'outbidText',
    className: classes.fontContent
  }, 'You\'ve been outbid') : null;
}

var mapStateToProps$c = function mapStateToProps(state) {
  return {
    step: state.widget.step,
    bidderItemStatus: state.currentBid.bidderItemStatus
  };
};

var OutbidTextWithStore = connect(mapStateToProps$c)(OutbidText);
var useStyles$e = makeStyles(function (theme) {
  return {
    checkBox: {
      marginLeft: '.5rem',
      backgroundColor: theme.palette.primary
    },
    textFormat: {
      fontSize: '0.875rem',
      opacity: '0.7'
    }
  };
});
ConfirmSkipCheck.propTypes = {
  step: PropTypes__default.number,
  skipConfirm: PropTypes__default.bool
};

function ConfirmSkipCheck(props) {
  var classes = useStyles$e();

  if (props.step === CONFIRM_STEP) {
    return /*#__PURE__*/React.createElement(FormControlLabel$1, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        className: classes.checkBox,
        checked: props.skipConfirm,
        onChange: props.handleSkipConfirmCheck,
        color: 'primary',
        id: 'confirm-skip-checkbox'
      }),
      label: /*#__PURE__*/React.createElement(Typography$1, {
        className: classes.textFormat
      }, "Skip future confirmation"),
      id: 'confirm-skip'
    });
  } else {
    return null;
  }
}

var mapStateToProps$d = function mapStateToProps(state, ownProps) {
  return {
    step: state.widget.step,
    skipConfirm: state.widget.skipConfirm
  };
};

var ConfirmSkipCheckWithStore = connect(mapStateToProps$d)(ConfirmSkipCheck);

var setIncrementError = function setIncrementError(status, errorCode, message, lowBidIncrement, highBidIncrement) {
  return {
    type: SET_INCREMENT_ERROR,
    status: status,
    errorCode: errorCode,
    message: message,
    lowBidIncrement: lowBidIncrement,
    highBidIncrement: highBidIncrement
  };
};

var setAmountLowerError = function setAmountLowerError(status, errorCode, message, amount) {
  return {
    type: SET_AMOUNT_LOWER_ERROR,
    status: status,
    errorCode: errorCode,
    message: message,
    amount: amount
  };
};

var setBidRetractionError = function setBidRetractionError(status, errorCode, message) {
  return {
    type: SET_BID_RETRACTION_ERROR,
    status: status,
    errorCode: errorCode,
    message: message
  };
};

var cancelIncrementChoice = function cancelIncrementChoice() {
  return {
    type: CANCEL_INCREMENT_CHOICE,
    lowBidIncrement: null,
    highBidIncrement: null
  };
};

var clearError = function clearError() {
  return {
    type: CLEAR_ERROR,
    errorCode: undefined
  };
};

var error = /*#__PURE__*/Object.freeze({
  __proto__: null,
  setIncrementError: setIncrementError,
  setAmountLowerError: setAmountLowerError,
  setBidRetractionError: setBidRetractionError,
  cancelIncrementChoice: cancelIncrementChoice,
  clearError: clearError
});
var EVENT_LOGIN_SHOW_LOGIN_DIALOG = '@http-event/EVENT_LOGIN_SHOW_LOGIN_DIALOG';
var EVENT_LOGIN_UPDATE_DISPLAY_NAME = '@http-event/EVENT_LOGIN_UPDATE_DISPLAY_NAME';
var EVENT_LOGGED_IN = '@http-event/EVENT_LOGGED_IN';
var eventLogin = {
  EVENT_LOGIN_SHOW_LOGIN_DIALOG: EVENT_LOGIN_SHOW_LOGIN_DIALOG,
  EVENT_LOGIN_UPDATE_DISPLAY_NAME: EVENT_LOGIN_UPDATE_DISPLAY_NAME,
  EVENT_LOGGED_IN: EVENT_LOGGED_IN
};

var styles$1 = function styles(theme) {
  return {
    root: {
      width: '100%',
      borderRadius: 0
    },
    cardHeader: {
      backgroundColor: grey$1[200],
      padding: '0.2rem',
      '& > *': {
        marginRight: 0
      }
    },
    cardAction: {
      width: '92.5%',
      justifyContent: 'center'
    },
    cardContent: {
      textAlign: 'center',
      padding: '0 !important'
    },
    contentWrapper: {
      padding: '1rem'
    },
    progressContent: {
      height: '100px',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex'
    },
    itemFailed: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      textAlign: 'center',
      fontSize: '3rem'
    },
    lowerContent: {
      padding: '0.5rem 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: grey$1[200]
    }
  };
};

var intervalLength = 1000;

var TimedBidding = /*#__PURE__*/function (_React$Component) {
  function TimedBidding(props) {
    var _this;

    _classCallCheck(this, TimedBidding);

    _this = _callSuper(this, TimedBidding, [props]);
    _this.debounceGetCurrentBid = lodash_debounce(_this.props.actions.getCurrentBid, 100);
    _this.debouncePostBid = lodash_debounce(_this.props.actions.postBid);
    _this.debounceMaxBidInput = lodash_debounce(_this.props.actions.setMaxBidInput, 100);

    _this.openBuyerLoginModal = function () {
      EventService.dispatchEvent(EVENT_LOGIN_SHOW_LOGIN_DIALOG);
    };

    _this.triggerBidderRegistration = function () {
      _this.props.eventService && _this.props.eventService.dispatchEventWithPayload('bidderRegistrationAction', {
        lotId: _this.props.itemId
      });
    };

    _this.openChangeCreditCardModal = function (paymentValidationStatus) {
      var eventPayload = {
        lotId: _this.props.itemId
      }; //find out if it is an event or an actual paymentValidationStatus

      if (lodash_isnil(paymentValidationStatus.target)) {
        eventPayload.paymentValidationStatus = paymentValidationStatus;
      }

      _this.props.eventService && _this.props.eventService.dispatchEventWithPayload('showChangeCC', eventPayload);
    };

    _this.notifyBidAttempt = function (params) {
      _this.props.eventService && _this.props.eventService.dispatchEventWithPayload('bidAttempt', params);
    };

    _this.emitAuctionGuardStatus = function (auctionGuardStatus) {
      _this.props.eventService && _this.props.eventService.dispatchEvent(auctionGuardStatus);
    };

    _this.emitItemFinished = function (_ref) {
      var itemId = _ref.itemId;
      _this.props.eventService && _this.props.eventService.dispatchEventWithPayload('itemFinished', {
        itemId: itemId
      });
    };

    _this.handleSkipConfirmCheck = function (e) {
      _this.props.actions.skipConfirm(e.target.checked);
    };

    _this.handleBidButton = function () {
      if (_this.props.skipConfirm === true) {
        window.sessionStorage.setItem('skipConfirmStep' + _this.props.itemId, true);
      }

      _this.props.actions.clearError(_this.props.errorCode);

      _this.debouncePostBid(_objectSpread2(_objectSpread2({}, _this.props), {}, {
        triggerBidderRegistration: _this.triggerBidderRegistration,
        openBuyerLoginModal: _this.openBuyerLoginModal,
        notifyBidAttempt: _this.notifyBidAttempt,
        emitAuctionGuardStatus: _this.emitAuctionGuardStatus,
        openChangeCreditCardModal: _this.openChangeCreditCardModal
      }), _this.props.maxBidInput === '' ? _this.props.nextBidAmount : _this.props.maxBidInput);
    };

    _this.handleInputChange = function (e) {
      _this.debounceMaxBidInput(e.target.value);
    };

    _this.handleHighBidIncrementClick = function () {
      _this.props.actions.setMaxBidInput('');

      if (_this.props.skipConfirm === false) {
        _this.props.actions.changeStep(CONFIRM_STEP);
      }

      if (_this.props.skipConfirm) {
        _this.debouncePostBid(_objectSpread2(_objectSpread2({}, _this.props), {}, {
          openAddCreditCardModal: _this.openAddCreditCardModal,
          triggerBidderRegistration: _this.triggerBidderRegistration,
          openBuyerLoginModal: _this.openBuyerLoginModal,
          notifyBidAttempt: _this.notifyBidAttempt,
          emitAuctionGuardStatus: _this.emitAuctionGuardStatus,
          openChangeCreditCardModal: _this.openChangeCreditCardModal
        }), _this.props.highBidIncrement);
      } else {
        _this.props.actions.postBidIncrement(_objectSpread2(_objectSpread2({}, _this.props), {}, {
          triggerBidderRegistration: _this.triggerBidderRegistration,
          openBuyerLoginModal: _this.openBuyerLoginModal,
          notifyBidAttempt: _this.notifyBidAttempt
        }), _this.props.highBidIncrement);
      }

      _this.props.actions.cancelIncrementChoice();

      _this.props.actions.clearError(_this.props.errorCode);
    };

    _this.handleLowBidIncrementClick = function () {
      _this.props.actions.setMaxBidInput('');

      _this.props.actions.setCurrentBid({
        nextBidAmount: _this.lowBidIncrement
      });

      if (_this.props.skipConfirm === false) {
        _this.props.actions.changeStep(CONFIRM_STEP);
      }

      if (_this.props.skipConfirm) {
        _this.debouncePostBid(_objectSpread2(_objectSpread2({}, _this.props), {}, {
          openAddCreditCardModal: _this.openAddCreditCardModal,
          triggerBidderRegistration: _this.triggerBidderRegistration,
          openBuyerLoginModal: _this.openBuyerLoginModal,
          notifyBidAttempt: _this.notifyBidAttempt,
          emitAuctionGuardStatus: _this.emitAuctionGuardStatus,
          openChangeCreditCardModal: _this.openChangeCreditCardModal
        }), _this.props.lowBidIncrement);
      } else {
        _this.props.actions.postBidIncrement(_objectSpread2(_objectSpread2({}, _this.props), {}, {
          triggerBidderRegistration: _this.triggerBidderRegistration,
          openBuyerLoginModal: _this.openBuyerLoginModal,
          notifyBidAttempt: _this.notifyBidAttempt
        }), _this.props.lowBidIncrement);
      }

      _this.props.actions.cancelIncrementChoice();

      _this.props.actions.clearError(_this.props.errorCode);
    };

    _this.handleCancelIncrementSelectClick = function () {
      _this.props.actions.cancelIncrementChoice();

      _this.props.actions.setMaxBidInput('');
    };

    _this.handleCancelBidButtonClick = function () {
      _this.props.actions.cancelIncrementChoice();

      _this.props.actions.setMaxBidInput('');

      _this.props.actions.changeStep(INITIAL_STEP);

      _this.debounceGetCurrentBid(_objectSpread2(_objectSpread2({}, _this.props), {}, {
        startTimer: _this.startTimer,
        stopTimer: _this.stopTimer
      }));
    };

    _this.cancelTimer = function () {
      clearInterval(_this.interval);
    };

    _this.handleEnterPress = function (e) {
      if (e.key === 'Enter' && e.currentTarget === e.target) {
        _this.handleBidButton();

        e.preventDefault();
      }
    };

    _this.tick = function () {
      if (_this.props.timerStatus === 'STOP') {
        _this.cancelTimer();
      } else {
        _this.props.actions.tick();
      }
    };

    _this.startTimer = function () {
      _this.props.actions.start();

      clearInterval(_this.interval);
      _this.interval = setInterval(_this.tick, intervalLength);
    };

    _this.stopTimer = function () {
      _this.props.actions.stop();

      _this.props.actions.finishItem();

      _this.props.actions.changeStep(INITIAL_STEP);

      _this.cancelTimer();

      _this.emitItemFinished({
        itemId: _this.props.itemId
      });
    };

    _this.changeCc = function (lastFour) {
      _this.props.actions.setPayment({
        lastFourCc: lastFour
      });
    };

    _this.getCurrencySymbol = function (currencySymbol, currencyCode) {
      if (currencySymbol === '$') {
        return currencyCode + ' ';
      } else {
        return currencySymbol;
      }
    };

    window["changeCc".concat(props.itemId)] = _this.changeCc.bind(_this);
    _this.openChangeCreditCardModal = _this.openChangeCreditCardModal.bind(_this);
    _this.notifyBidAttempt = _this.notifyBidAttempt.bind(_this);
    _this.triggerBidderRegistration = _this.triggerBidderRegistration.bind(_this);
    _this.emitAuctionGuardStatus = _this.emitAuctionGuardStatus.bind(_this);
    return _this;
  }

  _inherits(TimedBidding, _React$Component);

  return _createClass(TimedBidding, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.actions.getCurrentBid(_objectSpread2(_objectSpread2({}, this.props), {}, {
        startTimer: this.startTimer,
        stopTimer: this.stopTimer
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.demoMode) {
        if (!lodash_isequal(this.props.currentBidResponse.data, prevProps.currentBidResponse.data)) {
          this.debounceGetCurrentBid(_objectSpread2(_objectSpread2({}, this.props), {}, {
            startTimer: this.startTimer,
            stopTimer: this.stopTimer
          }));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          isLoadingItem = _this$props.isLoadingItem,
          isItemSoldOrPassed = _this$props.isItemSoldOrPassed,
          itemId = _this$props.itemId,
          sellerId = _this$props.sellerId,
          demoMode = _this$props.demoMode,
          apiGatewayURL = _this$props.apiGatewayURL,
          hasItemFailed = _this$props.hasItemFailed,
          bidderId = _this$props.bidderId;
      var currencySymbol = this.getCurrencySymbol(this.props.currencySymbol, this.props.currencyCode);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SocketHandlerWithStore, {
        demoMode: demoMode,
        itemId: itemId,
        sellerId: sellerId,
        apiGatewayURL: apiGatewayURL,
        bidderId: bidderId
      }), /*#__PURE__*/React.createElement(Card, {
        className: classes.root
      }, /*#__PURE__*/React.createElement(CardHeader, {
        className: classes.cardHeader,
        title: /*#__PURE__*/React.createElement(CardHeaderTextWithStore, {
          stopTimer: this.stopTimer
        })
      }), isLoadingItem ? /*#__PURE__*/React.createElement("div", {
        className: classes.progressContent
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        size: 50
      })) : hasItemFailed ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classes.itemFailed
      }, /*#__PURE__*/React.createElement(Warning$1, {
        className: classes.itemFailed,
        viewBox: '0 0 23 20',
        color: 'error'
      })), /*#__PURE__*/React.createElement("div", {
        className: classes.itemFailed
      }, /*#__PURE__*/React.createElement(Typography, null, "Please contact system administrator"))) : /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.contentWrapper
      }, /*#__PURE__*/React.createElement(SoldPendingConfirmationText, {
        step: this.props.step,
        isItemSoldOrPassed: isItemSoldOrPassed,
        allowSoldPendingConfirmation: this.props.sellerSettings && this.props.sellerSettings.allowSoldPendingConfirmation
      }), /*#__PURE__*/React.createElement(BidInfoTextWithStore, {
        bidderId: this.props.bidderId
      }), /*#__PURE__*/React.createElement(HighBidTextWithStore, {
        currencySymbol: currencySymbol,
        bidderId: this.props.bidderId
      }), /*#__PURE__*/React.createElement(BidderDetailTextWithStore, {
        bidderId: this.props.bidderId,
        isItemSoldOrPassed: isItemSoldOrPassed
      }), /*#__PURE__*/React.createElement(OutbidTextWithStore, null), /*#__PURE__*/React.createElement(StartPriceTextWithStore, {
        currencySymbol: currencySymbol
      })), !isItemSoldOrPassed && /*#__PURE__*/React.createElement("div", {
        className: classes.lowerContent
      }, /*#__PURE__*/React.createElement(IncrementChoiceWithStore, {
        handleHighBidIncrementClick: this.handleHighBidIncrementClick,
        handleLowBidIncrementClick: this.handleLowBidIncrementClick,
        currencySymbol: this.props.currencySymbol,
        handleCancelBidButtonClick: this.handleCancelBidButtonClick,
        itemId: this.props.itemId
      }), /*#__PURE__*/React.createElement(MaxBidDivWithStore, {
        handleInputChange: this.handleInputChange,
        handleEnterPress: this.handleEnterPress,
        currencySymbol: currencySymbol,
        handleChangeCc: this.openChangeCreditCardModal
      }), /*#__PURE__*/React.createElement(ErrorHelperTextWithStore, {
        currencySymbol: this.props.currencySymbol,
        step: this.props.step
      }), /*#__PURE__*/React.createElement(CardActions, {
        className: classes.cardAction
      }, /*#__PURE__*/React.createElement(CancelBidButtonWithStore, {
        handleCancelBidButtonClick: this.handleCancelBidButtonClick
      }), /*#__PURE__*/React.createElement(BidButtonWithStore, {
        currencySymbol: this.props.currencySymbol,
        handleBidButton: this.handleBidButton,
        handleCancelBidButtonClick: this.handleCancelBidButtonClick
      })), /*#__PURE__*/React.createElement(ConfirmSkipCheckWithStore, {
        handleSkipConfirmCheck: this.handleSkipConfirmCheck
      })))));
    }
  }]);
}(React.Component);

TimedBidding.propTypes = {
  classes: object$1.isRequired,
  step: number,
  itemId: string.isRequired,
  sellerId: string.isRequired,
  apiGatewayURL: string.isRequired,
  demoMode: bool,
  currentBidResponse: object$1,
  isItemSoldOrPassed: bool,
  bidAmount: number,
  nextBidAmount: number,
  maxBidAttemptAmount: number,
  startPrice: number,
  currencyCode: string,
  currencySymbol: string,
  reserveMet: bool,
  sellerSettings: object$1,
  lowBidIncrement: number,
  highBidIncrement: number,
  actions: object$1,
  timerStatus: string,
  eventService: shape({
    dispatchEvent: func,
    dispatchEventWithPayload: func
  }),
  isLoadingItem: bool,
  hasItemFailed: bool,
  errorCode: string,
  bidderId: string,
  sessionId: string,
  lastFourCc: string,
  maxBidInput: string,
  skipConfirm: bool
};
TimedBidding.defaultProps = {
  demoMode: false,
  sellerSettings: {
    allowSoldPendingConfirmation: false
  }
};

var mapStateToProps$e = function mapStateToProps(state) {
  return {
    timerStatus: state.timer.status,
    isLoadingItem: state.currentBid.isLoading,
    hasItemFailed: state.currentBid.hasItemFailed,
    isItemSoldOrPassed: state.currentBid.isItemSoldOrPassed,
    currencyCode: state.currentBid.currencyCode,
    bidAmount: state.currentBid.bidAmount,
    nextBidAmount: state.currentBid.nextBidAmount,
    startPrice: state.currentBid.startPrice,
    reserveMet: state.currentBid.reserveMet,
    maxBidInput: state.currentBid.input,
    sellerSettings: state.currentBid.sellerSettings,
    errorCode: state.error.errorCode,
    errorStatus: state.error.status,
    lowBidIncrement: state.error.lowBidIncrement,
    highBidIncrement: state.error.highBidIncrement,
    currencySymbol: state.currentBid.currencySymbol,
    step: state.widget.step,
    skipConfirm: state.widget.skipConfirm
  };
};

var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, timer), currentBid), error), widget), dispatch)
  };
};

var TimedBiddingWithStore = connect(mapStateToProps$e, mapDispatchToProps$1)(withStyles(styles$1)(TimedBidding));
var initialState = {
  seconds: 0,
  extendedBidding: false,
  extendedTimeTriggerSeconds: null
};

function timer$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case INIT_TIMER:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        seconds: action.seconds,
        status: action.status
      });

    case START_TIMER:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        seconds: state.seconds,
        status: action.status
      });

    case TICK:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        seconds: state.seconds >= 0 && state.seconds - 1
      });

    case STOP_TIMER:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.status
      });

    case UPDATE_TIMER:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        seconds: action.seconds
      });

    case EXTENDED_BIDDING:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        extendedBidding: action.extendedBidding
      });

    case EXTENDED_TIME_TRIGGER_SECONDS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        extendedTimeTriggerSeconds: action.extendedTimeTriggerSeconds
      });

    default:
      return state;
  }
}

var initialState$1 = {
  highBidderUsername: '',
  highBidderReferenceId: '',
  bidAmount: 0,
  nextBidAmount: 0,
  startPrice: 0,
  reserveMet: true,
  quantityType: undefined,
  lastFourCc: '',
  bidderItemStatus: NO_BID,
  input: '',
  loading: false,
  error: false,
  isItemSoldOrPassed: false,
  endTime: null,
  sellerSettings: {
    allowSoldPendingConfirmation: false
  }
};

function currentBid$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case UPDATE_CURRENT_BID:
      return _objectSpread2(_objectSpread2({}, state), action);

    case UPDATE_PAYMENT:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        lastFourCc: action.lastFourCc
      });

    case UPDATE_BIDDER_ITEM_STATUS:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        bidderItemStatus: action.bidderItemStatus
      });

    case UPDATE_MAX_INPUT:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        input: action.input
      });

    case IS_LOADING_ITEM:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: action.isLoading
      });

    case IS_ITEM_SOLD_OR_PASSED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isItemSoldOrPassed: action.isItemSoldOrPassed
      });

    case LOADING_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isLoading: false,
        hasItemFailed: true
      });

    case END_TIME:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        endTime: action.endTime
      });

    default:
      return state;
  }
}

var initialState$2 = {
  status: '',
  errorCode: '',
  message: '',
  lowBidIncrement: null,
  highBidIncrement: null,
  currentMaxBidAmount: null
};

function setError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$2;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_INCREMENT_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.status,
        errorCode: action.errorCode,
        message: action.message,
        lowBidIncrement: Number(action.lowBidIncrement),
        highBidIncrement: Number(action.highBidIncrement)
      });

    case SET_AMOUNT_LOWER_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.status,
        errorCode: action.errorCode,
        message: action.message,
        currentMaxBidAmount: Number(action.amount)
      });

    case SET_BID_RETRACTION_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        status: action.status,
        errorCode: action.errorCode,
        message: action.message
      });

    case CANCEL_INCREMENT_CHOICE:
      return {
        lowBidIncrement: action.lowBidIncrement,
        highBidIncrement: action.highBidIncrement
      };

    case CLEAR_ERROR:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        errorCode: action.errorCode
      });

    default:
      return state;
  }
}

var initialState$3 = {
  step: INITIAL_STEP,
  skipConfirm: false,
  showDialog: false
};

function changeStep$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$3;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case CHANGE_STEP:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        step: action.step
      });

    case SKIP_CONFIRM:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        skipConfirm: action.skipConfirm
      });

    case OUTBID_ON_CONFIRM:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        step: action.step
      });

    default:
      return state;
  }
}

var rootReducer = combineReducers({
  timer: timer$1,
  currentBid: currentBid$1,
  error: setError,
  widget: changeStep$1
});
var TIMEOUT = 30000;

var doRequest = function doRequest(method, url, params) {
  var payload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var buildHeaders = function buildHeaders(params) {
    var headersToReturn = {};

    if (params && params.bidderId) {
      headersToReturn['user-id'] = params.bidderId;
    }

    if (params && params.sessionId) {
      headersToReturn['guid'] = params.sessionId;
    }

    return headersToReturn;
  };

  var headers = _objectSpread2({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }, buildHeaders(params));

  var request = {
    method: method,
    url: url,
    timeout: TIMEOUT,
    headers: headers,
    withCredentials: true,
    data: payload
  };
  return axios$1(request);
};

var api = /*#__PURE__*/Object.freeze({
  __proto__: null,
  doRequest: doRequest
});

var Root = /*#__PURE__*/function (_Component) {
  function Root(props) {
    var _this;

    _classCallCheck(this, Root);

    _this = _callSuper(this, Root, [props]);
    var preloadedState = {
      widget: {
        step: INITIAL_STEP
      }
    };
    _this.store = createStore(rootReducer, preloadedState, compose(applyMiddleware(thunk.withExtraArgument(api)), logOnlyInProduction_2({
      actionsBlacklist: [TICK, UPDATE_TIMER]
    })));
    return _this;
  }

  _inherits(Root, _Component);

  return _createClass(Root, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Provider, {
        store: this.store
      }, /*#__PURE__*/React.createElement(ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/React.createElement(TimedBiddingWithStore, this.props)));
    }
  }]);
}(Component);

var _excluded$2 = ["inputStyles", "buttonStyles", "clickHandler"];
var useStyles$f = makeStyles(function (theme) {
  return {
    input: _defineProperty(_defineProperty({
      width: '100%',
      padding: '3px 0 3px 10px'
    }, theme.breakpoints.only('xs'), {
      padding: '7px 0 7px 10px'
    }), '& > input', {
      width: '100% !important'
    })
  };
});
SearchField.propTypes = {
  placeholder: PropTypes__default.string,
  onChange: PropTypes__default.func,
  clickHandler: PropTypes__default.func,
  onKeyDown: PropTypes__default.func,
  classes: PropTypes__default.object,
  value: PropTypes__default.string,
  inputStyles: PropTypes__default.object,
  buttonStyles: PropTypes__default.object
};

function SearchField(props) {
  var classes = useStyles$f();

  var inputStyles = props.inputStyles,
      buttonStyles = props.buttonStyles,
      clickHandler = props.clickHandler,
      rest = _objectWithoutProperties(props, _excluded$2);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input$2, _extends({}, rest, {
    style: _objectSpread2({}, inputStyles),
    placeholder: props.placeholder,
    onChange: props.onChange,
    onKeyDown: props.onKeyDown,
    className: classes.input,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React.createElement(IconButton, {
      style: _objectSpread2({}, buttonStyles),
      onClick: clickHandler,
      id: 'search-button'
    }, /*#__PURE__*/React.createElement(SearchIcon, null)))
  })));
}

var TIMEOUT$1 = 30000;

var legacyAPIPost = function legacyAPIPost(url, payload) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = {
    'Accept': 'application/x-www-form-urlencoded',
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  return axios$1({
    method: 'post',
    url: url,
    data: lib.stringify(payload),
    timeout: options.timeout || TIMEOUT$1,
    headers: headers,
    withCredentials: true
  })["catch"](function (err) {
    return console.error(err);
  });
};

var NO_ATTEMPTS = 0;
var SUBSEQUENT_ATTEMPTS = 2;
var MAX_ATTEMPT_REACHED = 3;

var styles$2 = function styles(theme) {
  return {
    defaultMargin: {
      marginTop: '20px'
    },
    privateContent: _defineProperty({
      border: '1px solid',
      borderColor: grey[300],
      height: '250px',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center'
    }, theme.breakpoints.up('sm'), {
      height: '300px'
    }),
    auctionHouseLabel: {
      textAlign: 'center',
      fontWeight: '600'
    },
    auctionInfoLabel: {
      textAlign: 'center'
    },
    errorText: {
      color: red[900]
    },
    submitButton: _defineProperty({
      backgroundColor: grey[900],
      borderRadius: '8px',
      color: grey[50],
      padding: '10px 0',
      width: '70%',
      '&:hover': {
        backgroundColor: grey[700]
      }
    }, theme.breakpoints.up('sm'), {
      padding: '10px 20px',
      width: 'auto'
    }),
    submitButtonText: {
      color: grey[300]
    }
  };
};

var PrivateAuction = /*#__PURE__*/function (_React$Component) {
  function PrivateAuction(props) {
    var _this;

    _classCallCheck(this, PrivateAuction);

    _this = _callSuper(this, PrivateAuction, [props]);

    _this.fetchAuctionData = function (auctionId, action) {
      var password = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      _this.setState({
        isFetchingData: true
      });

      legacyAPIPost('/asp/ajax/PrivateAuctionService.asp', {
        auctionId: auctionId,
        action: action,
        password: password
      }).then(function (response) {
        if (response && response.data) {
          var data = response.data;

          if (action === 'info') {
            _this.setState({
              auctionHouse: data.auctionHouseName,
              auctionTitle: data.auctionTitle,
              isFetchingData: false
            });
          } else {
            if (data.success) {
              window.location = _this.props.url;
            } else {
              _this.setState({
                step: _this.getStep(data.attempts),
                isFetchingData: false
              });
            }
          }
        }
      })["catch"](function (error) {
        console.error(error);

        _this.setState({
          isFetchingData: false
        });
      });
    };

    _this.handlePasswordInput = function (event) {
      _this.setState({
        passwordInput: event.target.value
      });
    };

    _this.handleKeyInput = function (event) {
      if (event.key === 'Enter') {
        _this.onSubmitClick();
      }
    };

    _this.onSubmitClick = function () {
      _this.fetchAuctionData(_this.props.auctionId, 'enter', _this.state.passwordInput);
    };

    _this.state = {
      step: _this.getStep(props.attempt),
      auctionHouse: props.auctionHouse,
      auctionTitle: props.auctionTitle,
      isFetchingData: false
    };
    return _this;
  }

  _inherits(PrivateAuction, _React$Component);

  return _createClass(PrivateAuction, [{
    key: "getStep",
    value: function getStep(attempt) {
      if (attempt === 0) {
        return NO_ATTEMPTS;
      } else if (attempt > 0 && attempt < 3) {
        return SUBSEQUENT_ATTEMPTS;
      } else {
        return MAX_ATTEMPT_REACHED;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.auctionId != 0) {
        this.fetchAuctionData(this.props.auctionId, 'info');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      var _this$state = this.state,
          auctionHouse = _this$state.auctionHouse,
          auctionTitle = _this$state.auctionTitle;
      var auctionHouseText = /*#__PURE__*/React.createElement(Typography, {
        variant: "h3",
        className: classnames(classes.auctionHouseLabel, classes.defaultMargin)
      }, auctionHouse);
      var auctionInfoText = /*#__PURE__*/React.createElement(Typography, {
        variant: "h4",
        className: classnames(classes.auctionInfoLabel, classes.defaultMargin)
      }, auctionTitle);
      var enterPassLabel = this.state.step === NO_ATTEMPTS || this.state.step === SUBSEQUENT_ATTEMPTS ? /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        className: classes.auctionInfoLabel
      }, "Enter the event password sent by the seller") : /*#__PURE__*/React.createElement(Typography, {
        variant: "h5",
        className: classnames(classes.errorText, classes.defaultMargin)
      }, 'You\'ve exceeded the maximum number of attempts to enter this auction.');
      var passwordField = this.state.step === NO_ATTEMPTS ? /*#__PURE__*/React.createElement(TextField, {
        autoFocus: true,
        id: "passwordInput",
        label: "Password",
        type: "password",
        variant: "outlined",
        className: classes.defaultMargin,
        onChange: this.handlePasswordInput,
        onKeyDown: this.handleKeyInput
      }) : this.state.step === SUBSEQUENT_ATTEMPTS && /*#__PURE__*/React.createElement(TextField, {
        error: true,
        autoFocus: true,
        id: "passwordInput",
        label: "Password",
        type: "password",
        variant: "outlined",
        className: classes.defaultMargin,
        onChange: this.handlePasswordInput,
        onKeyDown: this.handleKeyInput,
        helperText: "Incorrect event password"
      });
      var submitButtonText = /*#__PURE__*/React.createElement(Typography, {
        variant: "h6",
        className: classes.submitButtonText
      }, 'Enter');
      var submitButton = (this.state.step === NO_ATTEMPTS || this.state.step === SUBSEQUENT_ATTEMPTS) && /*#__PURE__*/React.createElement(Button, {
        id: "submitButton",
        className: classnames(classes.submitButton, classes.defaultMargin),
        variant: "contained",
        size: "small",
        loading: this.state.isFetchingData,
        onClick: this.onSubmitClick
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "button",
        className: classes.submitButtonText
      }, submitButtonText));
      return /*#__PURE__*/React.createElement(React.Fragment, null, auctionHouseText, auctionInfoText, /*#__PURE__*/React.createElement("div", {
        className: classes.privateContent
      }, enterPassLabel, passwordField, submitButton));
    }
  }]);
}(React.Component);

PrivateAuction.propTypes = {
  classes: PropTypes__default.object.isRequired,
  auctionId: PropTypes__default.number.isRequired,
  auctionHouse: PropTypes__default.string,
  auctionTitle: PropTypes__default.string,
  attempt: PropTypes__default.number.isRequired,
  url: PropTypes__default.string.isRequired
};
PrivateAuction.defaultProps = {
  attempt: NO_ATTEMPTS
};
var privateAuction = withStyles(styles$2)(PrivateAuction);

var styles$3 = function styles(theme) {
  return {
    root: {
      display: 'flex'
    },
    card: {
      width: 300,
      height: 250
    },
    cardMedia: {
      height: 130,
      maxWidth: 300,
      width: 'auto',
      margin: '0 auto'
    },
    cardContentTop: {
      width: 300,
      height: 70,
      padding: theme.spacing(1)
    },
    cardContentBottom: {
      padding: theme.spacing(1)
    }
  };
};

var StreamCard = /*#__PURE__*/function (_React$Component) {
  function StreamCard() {
    var _this;

    _classCallCheck(this, StreamCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_this = _callSuper(this, StreamCard, [].concat(args)), _this.navigateToStream = function () {
      window.open(_this.props.subscriberUrl, '_blank');
    }, _assertThisInitialized(_this)));
  }

  _inherits(StreamCard, _React$Component);

  return _createClass(StreamCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          imageUrl = _this$props.imageUrl,
          name = _this$props.name,
          description = _this$props.description;
      return /*#__PURE__*/React.createElement(Card, {
        className: classes.card
      }, /*#__PURE__*/React.createElement(CardActionArea, {
        onClick: this.navigateToStream
      }, /*#__PURE__*/React.createElement(CardMedia, {
        image: imageUrl,
        alt: name,
        component: "img",
        className: classes.cardMedia
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContentTop
      }, /*#__PURE__*/React.createElement(Typography, {
        noWrap: true,
        gutterBottom: true,
        variant: "subtitle1"
      }, name), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        component: 'p'
      }, description)), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContentBottom
      }, /*#__PURE__*/React.createElement(Typography, {
        size: "small",
        color: "secondary"
      }, this.props.subscriberCount > 0 ? 'Viewers bidding now' : ''))));
    }
  }]);
}(React.Component);

StreamCard.propTypes = {
  classes: object$1.isRequired,
  name: string.isRequired,
  description: string.isRequired,
  subscriberCount: number.isRequired,
  startTime: string.isRequired,
  subscriberUrl: string.isRequired,
  imageUrl: string
};
var StreamCard$1 = withStyles(styles$3)(StreamCard);

var StreamCardList = /*#__PURE__*/function (_React$Component) {
  function StreamCardList() {
    var _this;

    _classCallCheck(this, StreamCardList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_this = _callSuper(this, StreamCardList, [].concat(args)), _this.renderCardList = function () {
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, _this.props.streams.map(function (stream) {
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          key: stream.name
        }, /*#__PURE__*/React.createElement(StreamCard$1, stream));
      }));
    }, _assertThisInitialized(_this)));
  }

  _inherits(StreamCardList, _React$Component);

  return _createClass(StreamCardList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.streams.length > 0 ? this.renderCardList() : /*#__PURE__*/React.createElement(Typography, {
        variant: "h6",
        color: "primary"
      }, 'No active live streams'));
    }
  }]);
}(React.Component);

StreamCardList.propTypes = {
  streams: array.isRequired
};

var StreamCardMarketingContentPage = /*#__PURE__*/function (_React$Component) {
  function StreamCardMarketingContentPage(props) {
    var _this;

    _classCallCheck(this, StreamCardMarketingContentPage);

    _this = _callSuper(this, StreamCardMarketingContentPage, [props]);
    _this.fetchStreams = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.state.loadingStreams) {
                _this.setState({
                  loadingStreams: true
                });
              }

              _context.prev = 1;
              _context.next = 4;
              return fetchCurrentStreams(_this.props.clientProxyUrl);

            case 4:
              response = _context.sent;

              if (_this.state.streams !== response.data) {
                _this.setState({
                  streams: response.data,
                  loadingStreams: false
                });
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    _this.state = {
      streams: [],
      loadingStreams: true
    };
    return _this;
  }

  _inherits(StreamCardMarketingContentPage, _React$Component);

  return _createClass(StreamCardMarketingContentPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.fetchStreams()["finally"](function () {
        if (_this2.state.loadingStreams) {
          _this2.setState({
            loadingStreams: false
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Box, {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }, this.state.loadingStreams ? /*#__PURE__*/React.createElement(CircularProgress, {
        size: 100
      }) : /*#__PURE__*/React.createElement(StreamCardList, {
        streams: this.state.streams
      }));
    }
  }]);
}(React.Component);

StreamCardMarketingContentPage.propTypes = {
  clientProxyUrl: string.isRequired
};

function TermsAndConditions(props) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState({
    unifiedUserAgreementAccepted: false,
    privacyPolicyAccepted: false
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      policies = _useState6[0],
      setPolicies = _useState6[1];

  var handleSubmit = function handleSubmit(event) {
    if (event) {
      setLoading(true);
      event.preventDefault();
      return axiosInstance.post(props.termsAndConditionsSubmitUrl, {
        acceptUnifiedUserAgreement: policies.unifiedUserAgreementAccepted,
        acceptPrivacyPolicy: policies.privacyPolicyAccepted
      }, {
        headers: {
          'guid': props.guid,
          'user-id': props.userId
        }
      }).then(function (response) {
        return props.onSuccess(response);
      })["catch"](function () {
        setLoading(false);
        setErrorMessage(props.errorMessage);
      })["finally"](function () {
        return setLoading(false);
      });
    }
  };

  var handleChecked = function handleChecked(name) {
    return function (event) {
      event.persist();
      setPolicies(_objectSpread2(_objectSpread2({}, policies), {}, _defineProperty({}, name, event.target.checked)));
    };
  };

  return /*#__PURE__*/React.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(FormHelperText, {
    error: errorMessage
  }, errorMessage), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: "true"
  }, "Updated Terms"), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: "true"
  }, "Please read and accept the updated policies to continue the login process."), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox$1, {
      id: "uu-agreement",
      required: true,
      disabled: loading,
      value: "acceptUnifiedUserAgreement",
      color: "primary",
      inputProps: {
        'aria-label': 'Accept Unified User Agreement'
      },
      checked: policies.unifiedUserAgreementAccepted,
      onChange: handleChecked('unifiedUserAgreementAccepted')
    }),
    label: /*#__PURE__*/React.createElement(Typography, null, "I have read and agree to the ", /*#__PURE__*/React.createElement(Link, {
      href: props.unifiedUserAgreementUrl,
      target: "_blank"
    }, "Proxibid Unified User Agreement."))
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox$1, {
      id: "privacy-policy",
      required: true,
      disabled: loading,
      value: "acceptPrivacyPolicy",
      color: "primary",
      inputProps: {
        'aria-label': 'Accept Privacy Policy'
      },
      checked: policies.privacyPolicyAccepted,
      onChange: handleChecked('privacyPolicyAccepted')
    }),
    label: /*#__PURE__*/React.createElement(Typography, null, "I have read and agree to the ", /*#__PURE__*/React.createElement(Link, {
      href: props.privacyPolicyUrl,
      target: "_blank"
    }, "Proxibid Privacy Policy."))
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: !policies.unifiedUserAgreementAccepted || !policies.privacyPolicyAccepted,
    loading: loading,
    id: "accept-terms"
  }, /*#__PURE__*/React.createElement(Typography, null, "Accept")))));
}

TermsAndConditions.propTypes = {
  termsAndConditionsSubmitUrl: PropTypes__default.string.isRequired,
  errorMessage: PropTypes__default.string,
  onSuccess: PropTypes__default.func.isRequired,
  unifiedUserAgreementUrl: PropTypes__default.string.isRequired,
  privacyPolicyUrl: PropTypes__default.string.isRequired,
  guid: PropTypes__default.string,
  userId: PropTypes__default.string
};
var fingerprint2 = createCommonjsModule(function (module) {
  /*
  * Fingerprintjs2 2.1.0 - Modern & flexible browser fingerprint library v2
  * https://github.com/Valve/fingerprintjs2
  * Copyright (c) 2015 Valentin Vasilyev (valentin.vasilyev@outlook.com)
  * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
  *
  * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
  * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
  * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
  * ARE DISCLAIMED. IN NO EVENT SHALL VALENTIN VASILYEV BE LIABLE FOR ANY
  * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
  * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
  * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
  * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
  * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
  * THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */

  /* global define */
  (function (name, context, definition) {
    if (typeof window !== 'undefined' && typeof undefined === 'function' && undefined.amd) {
      undefined(definition);
    } else if (module.exports) {
      module.exports = definition();
    } else if (context.exports) {
      context.exports = definition();
    } else {
      context[name] = definition();
    }
  })('Fingerprint2', commonjsGlobal, function () {
    /// MurmurHash3 related functions
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // added together as a 64bit int (as an array of two 32bit ints).
    //
    var x64Add = function x64Add(m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] + n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] + n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] + n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] + n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }; //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // multiplied together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Multiply = function x64Multiply(m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
      var o = [0, 0, 0, 0];
      o[3] += m[3] * n[3];
      o[2] += o[3] >>> 16;
      o[3] &= 0xffff;
      o[2] += m[2] * n[3];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[2] += m[3] * n[2];
      o[1] += o[2] >>> 16;
      o[2] &= 0xffff;
      o[1] += m[1] * n[3];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[2] * n[2];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[1] += m[3] * n[1];
      o[0] += o[1] >>> 16;
      o[1] &= 0xffff;
      o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
      o[0] &= 0xffff;
      return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
    }; //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) rotated left by that number of positions.
    //


    var x64Rotl = function x64Rotl(m, n) {
      n %= 64;

      if (n === 32) {
        return [m[1], m[0]];
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n | m[0] >>> 32 - n];
      } else {
        n -= 32;
        return [m[1] << n | m[0] >>> 32 - n, m[0] << n | m[1] >>> 32 - n];
      }
    }; //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) shifted left by that number of positions.
    //


    var x64LeftShift = function x64LeftShift(m, n) {
      n %= 64;

      if (n === 0) {
        return m;
      } else if (n < 32) {
        return [m[0] << n | m[1] >>> 32 - n, m[1] << n];
      } else {
        return [m[1] << n - 32, 0];
      }
    }; //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // xored together as a 64bit int (as an array of two 32bit ints).
    //


    var x64Xor = function x64Xor(m, n) {
      return [m[0] ^ n[0], m[1] ^ n[1]];
    }; //
    // Given a block, returns murmurHash3's final x64 mix of that block.
    // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
    // only place where we need to right shift 64bit ints.)
    //


    var x64Fmix = function x64Fmix(h) {
      h = x64Xor(h, [0, h[0] >>> 1]);
      h = x64Multiply(h, [0xff51afd7, 0xed558ccd]);
      h = x64Xor(h, [0, h[0] >>> 1]);
      h = x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
      h = x64Xor(h, [0, h[0] >>> 1]);
      return h;
    }; //
    // Given a string and an optional seed as an int, returns a 128 bit
    // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
    //


    var x64hash128 = function x64hash128(key, seed) {
      key = key || '';
      seed = seed || 0;
      var remainder = key.length % 16;
      var bytes = key.length - remainder;
      var h1 = [0, seed];
      var h2 = [0, seed];
      var k1 = [0, 0];
      var k2 = [0, 0];
      var c1 = [0x87c37b91, 0x114253d5];
      var c2 = [0x4cf5ad43, 0x2745937f];

      for (var i = 0; i < bytes; i = i + 16) {
        k1 = [key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24, key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24];
        k2 = [key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24, key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24];
        k1 = x64Multiply(k1, c1);
        k1 = x64Rotl(k1, 31);
        k1 = x64Multiply(k1, c2);
        h1 = x64Xor(h1, k1);
        h1 = x64Rotl(h1, 27);
        h1 = x64Add(h1, h2);
        h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
        k2 = x64Multiply(k2, c2);
        k2 = x64Rotl(k2, 33);
        k2 = x64Multiply(k2, c1);
        h2 = x64Xor(h2, k2);
        h2 = x64Rotl(h2, 31);
        h2 = x64Add(h2, h1);
        h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
      }

      k1 = [0, 0];
      k2 = [0, 0];

      switch (remainder) {
        case 15:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
        // fallthrough

        case 14:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
        // fallthrough

        case 13:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
        // fallthrough

        case 12:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
        // fallthrough

        case 11:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
        // fallthrough

        case 10:
          k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
        // fallthrough

        case 9:
          k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
          k2 = x64Multiply(k2, c2);
          k2 = x64Rotl(k2, 33);
          k2 = x64Multiply(k2, c1);
          h2 = x64Xor(h2, k2);
        // fallthrough

        case 8:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
        // fallthrough

        case 7:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
        // fallthrough

        case 6:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
        // fallthrough

        case 5:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
        // fallthrough

        case 4:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
        // fallthrough

        case 3:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
        // fallthrough

        case 2:
          k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
        // fallthrough

        case 1:
          k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
          k1 = x64Multiply(k1, c1);
          k1 = x64Rotl(k1, 31);
          k1 = x64Multiply(k1, c2);
          h1 = x64Xor(h1, k1);
        // fallthrough
      }

      h1 = x64Xor(h1, [0, key.length]);
      h2 = x64Xor(h2, [0, key.length]);
      h1 = x64Add(h1, h2);
      h2 = x64Add(h2, h1);
      h1 = x64Fmix(h1);
      h2 = x64Fmix(h2);
      h1 = x64Add(h1, h2);
      h2 = x64Add(h2, h1);
      return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8);
    };

    var defaultOptions = {
      preprocessor: null,
      audio: {
        timeout: 1000,
        // On iOS 11, audio context can only be used in response to user interaction.
        // We require users to explicitly enable audio fingerprinting on iOS 11.
        // See https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
        excludeIOS11: true
      },
      fonts: {
        swfContainerId: 'fingerprintjs2',
        swfPath: 'flash/compiled/FontList.swf',
        userDefinedFonts: [],
        extendedJsFonts: false
      },
      screen: {
        // To ensure consistent fingerprints when users rotate their mobile devices
        detectScreenOrientation: true
      },
      plugins: {
        sortPluginsFor: [/palemoon/i],
        excludeIE: false
      },
      extraComponents: [],
      excludes: {
        // Unreliable on Windows, see https://github.com/Valve/fingerprintjs2/issues/375
        'enumerateDevices': true,
        // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
        'pixelRatio': true,
        // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
        'doNotTrack': true,
        // uses js fonts already
        'fontsFlash': true
      },
      NOT_AVAILABLE: 'not available',
      ERROR: 'error',
      EXCLUDED: 'excluded'
    };

    var each = function each(obj, iterator) {
      if (Array.prototype.forEach && obj.forEach === Array.prototype.forEach) {
        obj.forEach(iterator);
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          iterator(obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            iterator(obj[key], key, obj);
          }
        }
      }
    };

    var map = function map(obj, iterator) {
      var results = []; // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.

      if (obj == null) {
        return results;
      }

      if (Array.prototype.map && obj.map === Array.prototype.map) {
        return obj.map(iterator);
      }

      each(obj, function (value, index, list) {
        results.push(iterator(value, index, list));
      });
      return results;
    };

    var extendSoft = function extendSoft(target, source) {
      if (source == null) {
        return target;
      }

      var value;
      var key;

      for (key in source) {
        value = source[key];

        if (value != null && !Object.prototype.hasOwnProperty.call(target, key)) {
          target[key] = value;
        }
      }

      return target;
    }; // https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices


    var enumerateDevicesKey = function enumerateDevicesKey(done, options) {
      if (!isEnumerateDevicesSupported()) {
        return done(options.NOT_AVAILABLE);
      }

      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        done(devices.map(function (device) {
          return 'id=' + device.deviceId + ';gid=' + device.groupId + ';' + device.kind + ';' + device.label;
        }));
      }).catch(function (error) {
        done(error);
      });
    };

    var isEnumerateDevicesSupported = function isEnumerateDevicesSupported() {
      return navigator.mediaDevices && navigator.mediaDevices.enumerateDevices;
    }; // Inspired by and based on https://github.com/cozylife/audio-fingerprint


    var audioKey = function audioKey(done, options) {
      var audioOptions = options.audio;

      if (audioOptions.excludeIOS11 && navigator.userAgent.match(/OS 11.+Version\/11.+Safari/)) {
        // See comment for excludeUserAgent and https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
        return done(options.EXCLUDED);
      }

      var AudioContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;

      if (AudioContext == null) {
        return done(options.NOT_AVAILABLE);
      }

      var context = new AudioContext(1, 44100, 44100);
      var oscillator = context.createOscillator();
      oscillator.type = 'triangle';
      oscillator.frequency.setValueAtTime(10000, context.currentTime);
      var compressor = context.createDynamicsCompressor();
      each([['threshold', -50], ['knee', 40], ['ratio', 12], ['reduction', -20], ['attack', 0], ['release', 0.25]], function (item) {
        if (compressor[item[0]] !== undefined && typeof compressor[item[0]].setValueAtTime === 'function') {
          compressor[item[0]].setValueAtTime(item[1], context.currentTime);
        }
      });
      oscillator.connect(compressor);
      compressor.connect(context.destination);
      oscillator.start(0);
      context.startRendering();
      var audioTimeoutId = setTimeout(function () {
        console.warn('Audio fingerprint timed out. Please report bug at https://github.com/Valve/fingerprintjs2 with your user agent: "' + navigator.userAgent + '".');

        context.oncomplete = function () {};

        context = null;
        return done('audioTimeout');
      }, audioOptions.timeout);

      context.oncomplete = function (event) {
        var fingerprint;

        try {
          clearTimeout(audioTimeoutId);
          fingerprint = event.renderedBuffer.getChannelData(0).slice(4500, 5000).reduce(function (acc, val) {
            return acc + Math.abs(val);
          }, 0).toString();
          oscillator.disconnect();
          compressor.disconnect();
        } catch (error) {
          done(error);
          return;
        }

        done(fingerprint);
      };
    };

    var UserAgent = function UserAgent(done) {
      done(navigator.userAgent);
    };

    var webdriver = function webdriver(done, options) {
      done(navigator.webdriver == null ? options.NOT_AVAILABLE : navigator.webdriver);
    };

    var languageKey = function languageKey(done, options) {
      done(navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || options.NOT_AVAILABLE);
    };

    var colorDepthKey = function colorDepthKey(done, options) {
      done(window.screen.colorDepth || options.NOT_AVAILABLE);
    };

    var deviceMemoryKey = function deviceMemoryKey(done, options) {
      done(navigator.deviceMemory || options.NOT_AVAILABLE);
    };

    var pixelRatioKey = function pixelRatioKey(done, options) {
      done(window.devicePixelRatio || options.NOT_AVAILABLE);
    };

    var screenResolutionKey = function screenResolutionKey(done, options) {
      done(getScreenResolution(options));
    };

    var getScreenResolution = function getScreenResolution(options) {
      var resolution = [window.screen.width, window.screen.height];

      if (options.screen.detectScreenOrientation) {
        resolution.sort().reverse();
      }

      return resolution;
    };

    var availableScreenResolutionKey = function availableScreenResolutionKey(done, options) {
      done(getAvailableScreenResolution(options));
    };

    var getAvailableScreenResolution = function getAvailableScreenResolution(options) {
      if (window.screen.availWidth && window.screen.availHeight) {
        var available = [window.screen.availHeight, window.screen.availWidth];

        if (options.screen.detectScreenOrientation) {
          available.sort().reverse();
        }

        return available;
      } // headless browsers


      return options.NOT_AVAILABLE;
    };

    var timezoneOffset = function timezoneOffset(done) {
      done(new Date().getTimezoneOffset());
    };

    var timezone = function timezone(done, options) {
      if (window.Intl && window.Intl.DateTimeFormat) {
        done(new window.Intl.DateTimeFormat().resolvedOptions().timeZone);
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var sessionStorageKey = function sessionStorageKey(done, options) {
      done(hasSessionStorage(options));
    };

    var localStorageKey = function localStorageKey(done, options) {
      done(hasLocalStorage(options));
    };

    var indexedDbKey = function indexedDbKey(done, options) {
      done(hasIndexedDB(options));
    };

    var addBehaviorKey = function addBehaviorKey(done) {
      // body might not be defined at this point or removed programmatically
      done(!!(document.body && document.body.addBehavior));
    };

    var openDatabaseKey = function openDatabaseKey(done) {
      done(!!window.openDatabase);
    };

    var cpuClassKey = function cpuClassKey(done, options) {
      done(getNavigatorCpuClass(options));
    };

    var platformKey = function platformKey(done, options) {
      done(getNavigatorPlatform(options));
    };

    var doNotTrackKey = function doNotTrackKey(done, options) {
      done(getDoNotTrack(options));
    };

    var canvasKey = function canvasKey(done, options) {
      if (isCanvasSupported()) {
        done(getCanvasFp(options));
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var webglKey = function webglKey(done, options) {
      if (isWebGlSupported()) {
        done(getWebglFp());
        return;
      }

      done(options.NOT_AVAILABLE);
    };

    var webglVendorAndRendererKey = function webglVendorAndRendererKey(done) {
      if (isWebGlSupported()) {
        done(getWebglVendorAndRenderer());
        return;
      }

      done();
    };

    var adBlockKey = function adBlockKey(done) {
      done(getAdBlock());
    };

    var hasLiedLanguagesKey = function hasLiedLanguagesKey(done) {
      done(getHasLiedLanguages());
    };

    var hasLiedResolutionKey = function hasLiedResolutionKey(done) {
      done(getHasLiedResolution());
    };

    var hasLiedOsKey = function hasLiedOsKey(done) {
      done(getHasLiedOs());
    };

    var hasLiedBrowserKey = function hasLiedBrowserKey(done) {
      done(getHasLiedBrowser());
    }; // flash fonts (will increase fingerprinting time 20X to ~ 130-150ms)


    var flashFontsKey = function flashFontsKey(done, options) {
      // we do flash if swfobject is loaded
      if (!hasSwfObjectLoaded()) {
        return done('swf object not loaded');
      }

      if (!hasMinFlashInstalled()) {
        return done('flash not installed');
      }

      if (!options.fonts.swfPath) {
        return done('missing options.fonts.swfPath');
      }

      loadSwfAndDetectFonts(function (fonts) {
        done(fonts);
      }, options);
    }; // kudos to http://www.lalit.org/lab/javascript-css-font-detect/


    var jsFontsKey = function jsFontsKey(done, options) {
      // a font will be compared against all the three default fonts.
      // and if it doesn't match all 3 then that font is not available.
      var baseFonts = ['monospace', 'sans-serif', 'serif'];
      var fontList = ['Andale Mono', 'Arial', 'Arial Black', 'Arial Hebrew', 'Arial MT', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS', 'Bitstream Vera Sans Mono', 'Book Antiqua', 'Bookman Old Style', 'Calibri', 'Cambria', 'Cambria Math', 'Century', 'Century Gothic', 'Century Schoolbook', 'Comic Sans', 'Comic Sans MS', 'Consolas', 'Courier', 'Courier New', 'Geneva', 'Georgia', 'Helvetica', 'Helvetica Neue', 'Impact', 'Lucida Bright', 'Lucida Calligraphy', 'Lucida Console', 'Lucida Fax', 'LUCIDA GRANDE', 'Lucida Handwriting', 'Lucida Sans', 'Lucida Sans Typewriter', 'Lucida Sans Unicode', 'Microsoft Sans Serif', 'Monaco', 'Monotype Corsiva', 'MS Gothic', 'MS Outlook', 'MS PGothic', 'MS Reference Sans Serif', 'MS Sans Serif', 'MS Serif', 'MYRIAD', 'MYRIAD PRO', 'Palatino', 'Palatino Linotype', 'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Light', 'Segoe UI Semibold', 'Segoe UI Symbol', 'Tahoma', 'Times', 'Times New Roman', 'Times New Roman PS', 'Trebuchet MS', 'Verdana', 'Wingdings', 'Wingdings 2', 'Wingdings 3'];

      if (options.fonts.extendedJsFonts) {
        var extendedFontList = ['Abadi MT Condensed Light', 'Academy Engraved LET', 'ADOBE CASLON PRO', 'Adobe Garamond', 'ADOBE GARAMOND PRO', 'Agency FB', 'Aharoni', 'Albertus Extra Bold', 'Albertus Medium', 'Algerian', 'Amazone BT', 'American Typewriter', 'American Typewriter Condensed', 'AmerType Md BT', 'Andalus', 'Angsana New', 'AngsanaUPC', 'Antique Olive', 'Aparajita', 'Apple Chancery', 'Apple Color Emoji', 'Apple SD Gothic Neo', 'Arabic Typesetting', 'ARCHER', 'ARNO PRO', 'Arrus BT', 'Aurora Cn BT', 'AvantGarde Bk BT', 'AvantGarde Md BT', 'AVENIR', 'Ayuthaya', 'Bandy', 'Bangla Sangam MN', 'Bank Gothic', 'BankGothic Md BT', 'Baskerville', 'Baskerville Old Face', 'Batang', 'BatangChe', 'Bauer Bodoni', 'Bauhaus 93', 'Bazooka', 'Bell MT', 'Bembo', 'Benguiat Bk BT', 'Berlin Sans FB', 'Berlin Sans FB Demi', 'Bernard MT Condensed', 'BernhardFashion BT', 'BernhardMod BT', 'Big Caslon', 'BinnerD', 'Blackadder ITC', 'BlairMdITC TT', 'Bodoni 72', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bodoni MT', 'Bodoni MT Black', 'Bodoni MT Condensed', 'Bodoni MT Poster Compressed', 'Bookshelf Symbol 7', 'Boulder', 'Bradley Hand', 'Bradley Hand ITC', 'Bremen Bd BT', 'Britannic Bold', 'Broadway', 'Browallia New', 'BrowalliaUPC', 'Brush Script MT', 'Californian FB', 'Calisto MT', 'Calligrapher', 'Candara', 'CaslonOpnface BT', 'Castellar', 'Centaur', 'Cezanne', 'CG Omega', 'CG Times', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charlesworth', 'Charter Bd BT', 'Charter BT', 'Chaucer', 'ChelthmITC Bk BT', 'Chiller', 'Clarendon', 'Clarendon Condensed', 'CloisterBlack BT', 'Cochin', 'Colonna MT', 'Constantia', 'Cooper Black', 'Copperplate', 'Copperplate Gothic', 'Copperplate Gothic Bold', 'Copperplate Gothic Light', 'CopperplGoth Bd BT', 'Corbel', 'Cordia New', 'CordiaUPC', 'Cornerstone', 'Coronet', 'Cuckoo', 'Curlz MT', 'DaunPenh', 'Dauphin', 'David', 'DB LCD Temp', 'DELICIOUS', 'Denmark', 'DFKai-SB', 'Didot', 'DilleniaUPC', 'DIN', 'DokChampa', 'Dotum', 'DotumChe', 'Ebrima', 'Edwardian Script ITC', 'Elephant', 'English 111 Vivace BT', 'Engravers MT', 'EngraversGothic BT', 'Eras Bold ITC', 'Eras Demi ITC', 'Eras Light ITC', 'Eras Medium ITC', 'EucrosiaUPC', 'Euphemia', 'Euphemia UCAS', 'EUROSTILE', 'Exotc350 Bd BT', 'FangSong', 'Felix Titling', 'Fixedsys', 'FONTIN', 'Footlight MT Light', 'Forte', 'FrankRuehl', 'Fransiscan', 'Freefrm721 Blk BT', 'FreesiaUPC', 'Freestyle Script', 'French Script MT', 'FrnkGothITC Bk BT', 'Fruitger', 'FRUTIGER', 'Futura', 'Futura Bk BT', 'Futura Lt BT', 'Futura Md BT', 'Futura ZBlk BT', 'FuturaBlack BT', 'Gabriola', 'Galliard BT', 'Gautami', 'Geeza Pro', 'Geometr231 BT', 'Geometr231 Hv BT', 'Geometr231 Lt BT', 'GeoSlab 703 Lt BT', 'GeoSlab 703 XBd BT', 'Gigi', 'Gill Sans', 'Gill Sans MT', 'Gill Sans MT Condensed', 'Gill Sans MT Ext Condensed Bold', 'Gill Sans Ultra Bold', 'Gill Sans Ultra Bold Condensed', 'Gisha', 'Gloucester MT Extra Condensed', 'GOTHAM', 'GOTHAM BOLD', 'Goudy Old Style', 'Goudy Stout', 'GoudyHandtooled BT', 'GoudyOLSt BT', 'Gujarati Sangam MN', 'Gulim', 'GulimChe', 'Gungsuh', 'GungsuhChe', 'Gurmukhi MN', 'Haettenschweiler', 'Harlow Solid Italic', 'Harrington', 'Heather', 'Heiti SC', 'Heiti TC', 'HELV', 'Herald', 'High Tower Text', 'Hiragino Kaku Gothic ProN', 'Hiragino Mincho ProN', 'Hoefler Text', 'Humanst 521 Cn BT', 'Humanst521 BT', 'Humanst521 Lt BT', 'Imprint MT Shadow', 'Incised901 Bd BT', 'Incised901 BT', 'Incised901 Lt BT', 'INCONSOLATA', 'Informal Roman', 'Informal011 BT', 'INTERSTATE', 'IrisUPC', 'Iskoola Pota', 'JasmineUPC', 'Jazz LET', 'Jenson', 'Jester', 'Jokerman', 'Juice ITC', 'Kabel Bk BT', 'Kabel Ult BT', 'Kailasa', 'KaiTi', 'Kalinga', 'Kannada Sangam MN', 'Kartika', 'Kaufmann Bd BT', 'Kaufmann BT', 'Khmer UI', 'KodchiangUPC', 'Kokila', 'Korinna BT', 'Kristen ITC', 'Krungthep', 'Kunstler Script', 'Lao UI', 'Latha', 'Leelawadee', 'Letter Gothic', 'Levenim MT', 'LilyUPC', 'Lithograph', 'Lithograph Light', 'Long Island', 'Lydian BT', 'Magneto', 'Maiandra GD', 'Malayalam Sangam MN', 'Malgun Gothic', 'Mangal', 'Marigold', 'Marion', 'Marker Felt', 'Market', 'Marlett', 'Matisse ITC', 'Matura MT Script Capitals', 'Meiryo', 'Meiryo UI', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Tai Le', 'Microsoft Uighur', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU', 'MingLiU_HKSCS', 'MingLiU_HKSCS-ExtB', 'MingLiU-ExtB', 'Minion', 'Minion Pro', 'Miriam', 'Miriam Fixed', 'Mistral', 'Modern', 'Modern No. 20', 'Mona Lisa Solid ITC TT', 'Mongolian Baiti', 'MONO', 'MoolBoran', 'Mrs Eaves', 'MS LineDraw', 'MS Mincho', 'MS PMincho', 'MS Reference Specialty', 'MS UI Gothic', 'MT Extra', 'MUSEO', 'MV Boli', 'Nadeem', 'Narkisim', 'NEVIS', 'News Gothic', 'News GothicMT', 'NewsGoth BT', 'Niagara Engraved', 'Niagara Solid', 'Noteworthy', 'NSimSun', 'Nyala', 'OCR A Extended', 'Old Century', 'Old English Text MT', 'Onyx', 'Onyx BT', 'OPTIMA', 'Oriya Sangam MN', 'OSAKA', 'OzHandicraft BT', 'Palace Script MT', 'Papyrus', 'Parchment', 'Party LET', 'Pegasus', 'Perpetua', 'Perpetua Titling MT', 'PetitaBold', 'Pickwick', 'Plantagenet Cherokee', 'Playbill', 'PMingLiU', 'PMingLiU-ExtB', 'Poor Richard', 'Poster', 'PosterBodoni BT', 'PRINCETOWN LET', 'Pristina', 'PTBarnum BT', 'Pythagoras', 'Raavi', 'Rage Italic', 'Ravie', 'Ribbon131 Bd BT', 'Rockwell', 'Rockwell Condensed', 'Rockwell Extra Bold', 'Rod', 'Roman', 'Sakkal Majalla', 'Santa Fe LET', 'Savoye LET', 'Sceptre', 'Script', 'Script MT Bold', 'SCRIPTINA', 'Serifa', 'Serifa BT', 'Serifa Th BT', 'ShelleyVolante BT', 'Sherwood', 'Shonar Bangla', 'Showcard Gothic', 'Shruti', 'Signboard', 'SILKSCREEN', 'SimHei', 'Simplified Arabic', 'Simplified Arabic Fixed', 'SimSun', 'SimSun-ExtB', 'Sinhala Sangam MN', 'Sketch Rockwell', 'Skia', 'Small Fonts', 'Snap ITC', 'Snell Roundhand', 'Socket', 'Souvenir Lt BT', 'Staccato222 BT', 'Steamer', 'Stencil', 'Storybook', 'Styllo', 'Subway', 'Swis721 BlkEx BT', 'Swiss911 XCm BT', 'Sylfaen', 'Synchro LET', 'System', 'Tamil Sangam MN', 'Technical', 'Teletype', 'Telugu Sangam MN', 'Tempus Sans ITC', 'Terminal', 'Thonburi', 'Traditional Arabic', 'Trajan', 'TRAJAN PRO', 'Tristan', 'Tubular', 'Tunga', 'Tw Cen MT', 'Tw Cen MT Condensed', 'Tw Cen MT Condensed Extra Bold', 'TypoUpright BT', 'Unicorn', 'Univers', 'Univers CE 55 Medium', 'Univers Condensed', 'Utsaah', 'Vagabond', 'Vani', 'Vijaya', 'Viner Hand ITC', 'VisualUI', 'Vivaldi', 'Vladimir Script', 'Vrinda', 'Westminster', 'WHITNEY', 'Wide Latin', 'ZapfEllipt BT', 'ZapfHumnst BT', 'ZapfHumnst Dm BT', 'Zapfino', 'Zurich BlkEx BT', 'Zurich Ex BT', 'ZWAdobeF'];
        fontList = fontList.concat(extendedFontList);
      }

      fontList = fontList.concat(options.fonts.userDefinedFonts); // remove duplicate fonts

      fontList = fontList.filter(function (font, position) {
        return fontList.indexOf(font) === position;
      }); // we use m or w because these two characters take up the maximum width.
      // And we use a LLi so that the same matching fonts can get separated

      var testString = 'mmmmmmmmmmlli'; // we test using 72px font size, we may use any size. I guess larger the better.

      var testSize = '72px';
      var h = document.getElementsByTagName('body')[0]; // div to load spans for the base fonts

      var baseFontsDiv = document.createElement('div'); // div to load spans for the fonts to detect

      var fontsDiv = document.createElement('div');
      var defaultWidth = {};
      var defaultHeight = {}; // creates a span where the fonts will be loaded

      var createSpan = function createSpan() {
        var s = document.createElement('span');
        /*
         * We need this css as in some weird browser this
         * span elements shows up for a microSec which creates a
         * bad user experience
         */

        s.style.position = 'absolute';
        s.style.left = '-9999px';
        s.style.fontSize = testSize; // css font reset to reset external styles

        s.style.fontStyle = 'normal';
        s.style.fontWeight = 'normal';
        s.style.letterSpacing = 'normal';
        s.style.lineBreak = 'auto';
        s.style.lineHeight = 'normal';
        s.style.textTransform = 'none';
        s.style.textAlign = 'left';
        s.style.textDecoration = 'none';
        s.style.textShadow = 'none';
        s.style.whiteSpace = 'normal';
        s.style.wordBreak = 'normal';
        s.style.wordSpacing = 'normal';
        s.innerHTML = testString;
        return s;
      }; // creates a span and load the font to detect and a base font for fallback


      var createSpanWithFonts = function createSpanWithFonts(fontToDetect, baseFont) {
        var s = createSpan();
        s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
        return s;
      }; // creates spans for the base fonts and adds them to baseFontsDiv


      var initializeBaseFontsSpans = function initializeBaseFontsSpans() {
        var spans = [];

        for (var index = 0, length = baseFonts.length; index < length; index++) {
          var s = createSpan();
          s.style.fontFamily = baseFonts[index];
          baseFontsDiv.appendChild(s);
          spans.push(s);
        }

        return spans;
      }; // creates spans for the fonts to detect and adds them to fontsDiv


      var initializeFontsSpans = function initializeFontsSpans() {
        var spans = {};

        for (var i = 0, l = fontList.length; i < l; i++) {
          var fontSpans = [];

          for (var j = 0, numDefaultFonts = baseFonts.length; j < numDefaultFonts; j++) {
            var s = createSpanWithFonts(fontList[i], baseFonts[j]);
            fontsDiv.appendChild(s);
            fontSpans.push(s);
          }

          spans[fontList[i]] = fontSpans; // Stores {fontName : [spans for that font]}
        }

        return spans;
      }; // checks if a font is available


      var isFontAvailable = function isFontAvailable(fontSpans) {
        var detected = false;

        for (var i = 0; i < baseFonts.length; i++) {
          detected = fontSpans[i].offsetWidth !== defaultWidth[baseFonts[i]] || fontSpans[i].offsetHeight !== defaultHeight[baseFonts[i]];

          if (detected) {
            return detected;
          }
        }

        return detected;
      }; // create spans for base fonts


      var baseFontsSpans = initializeBaseFontsSpans(); // add the spans to the DOM

      h.appendChild(baseFontsDiv); // get the default width for the three base fonts

      for (var index = 0, length = baseFonts.length; index < length; index++) {
        defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font

        defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
      } // create spans for fonts to detect


      var fontsSpans = initializeFontsSpans(); // add all the spans to the DOM

      h.appendChild(fontsDiv); // check available fonts

      var available = [];

      for (var i = 0, l = fontList.length; i < l; i++) {
        if (isFontAvailable(fontsSpans[fontList[i]])) {
          available.push(fontList[i]);
        }
      } // remove spans from DOM


      h.removeChild(fontsDiv);
      h.removeChild(baseFontsDiv);
      done(available);
    };

    var pluginsComponent = function pluginsComponent(done, options) {
      if (isIE()) {
        if (!options.plugins.excludeIE) {
          done(getIEPlugins(options));
        } else {
          done(options.EXCLUDED);
        }
      } else {
        done(getRegularPlugins(options));
      }
    };

    var getRegularPlugins = function getRegularPlugins(options) {
      if (navigator.plugins == null) {
        return options.NOT_AVAILABLE;
      }

      var plugins = []; // plugins isn't defined in Node envs.

      for (var i = 0, l = navigator.plugins.length; i < l; i++) {
        if (navigator.plugins[i]) {
          plugins.push(navigator.plugins[i]);
        }
      } // sorting plugins only for those user agents, that we know randomize the plugins
      // every time we try to enumerate them


      if (pluginsShouldBeSorted(options)) {
        plugins = plugins.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }

          if (a.name < b.name) {
            return -1;
          }

          return 0;
        });
      }

      return map(plugins, function (p) {
        var mimeTypes = map(p, function (mt) {
          return [mt.type, mt.suffixes];
        });
        return [p.name, p.description, mimeTypes];
      });
    };

    var getIEPlugins = function getIEPlugins(options) {
      var result = [];

      if (Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject') || 'ActiveXObject' in window) {
        var names = ['AcroPDF.PDF', // Adobe PDF reader 7+
        'Adodb.Stream', 'AgControl.AgControl', // Silverlight
        'DevalVRXCtrl.DevalVRXCtrl.1', 'MacromediaFlashPaper.MacromediaFlashPaper', 'Msxml2.DOMDocument', 'Msxml2.XMLHTTP', 'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
        'QuickTime.QuickTime', // QuickTime
        'QuickTimeCheckObject.QuickTimeCheck.1', 'RealPlayer', 'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)', 'RealVideo.RealVideo(tm) ActiveX Control (32-bit)', 'Scripting.Dictionary', 'SWCtl.SWCtl', // ShockWave player
        'Shell.UIHelper', 'ShockwaveFlash.ShockwaveFlash', // flash plugin
        'Skype.Detection', 'TDCCtl.TDCCtl', 'WMPlayer.OCX', // Windows media player
        'rmocx.RealPlayer G2 Control', 'rmocx.RealPlayer G2 Control.1']; // starting to detect plugins in IE

        result = map(names, function (name) {
          try {
            // eslint-disable-next-line no-new
            new window.ActiveXObject(name);
            return name;
          } catch (e) {
            return options.ERROR;
          }
        });
      } else {
        result.push(options.NOT_AVAILABLE);
      }

      if (navigator.plugins) {
        result = result.concat(getRegularPlugins(options));
      }

      return result;
    };

    var pluginsShouldBeSorted = function pluginsShouldBeSorted(options) {
      var should = false;

      for (var i = 0, l = options.plugins.sortPluginsFor.length; i < l; i++) {
        var re = options.plugins.sortPluginsFor[i];

        if (navigator.userAgent.match(re)) {
          should = true;
          break;
        }
      }

      return should;
    };

    var touchSupportKey = function touchSupportKey(done) {
      done(getTouchSupport());
    };

    var hardwareConcurrencyKey = function hardwareConcurrencyKey(done, options) {
      done(getHardwareConcurrency(options));
    };

    var hasSessionStorage = function hasSessionStorage(options) {
      try {
        return !!window.sessionStorage;
      } catch (e) {
        return options.ERROR; // SecurityError when referencing it means it exists
      }
    }; // https://bugzilla.mozilla.org/show_bug.cgi?id=781447


    var hasLocalStorage = function hasLocalStorage(options) {
      try {
        return !!window.localStorage;
      } catch (e) {
        return options.ERROR; // SecurityError when referencing it means it exists
      }
    };

    var hasIndexedDB = function hasIndexedDB(options) {
      try {
        return !!window.indexedDB;
      } catch (e) {
        return options.ERROR; // SecurityError when referencing it means it exists
      }
    };

    var getHardwareConcurrency = function getHardwareConcurrency(options) {
      if (navigator.hardwareConcurrency) {
        return navigator.hardwareConcurrency;
      }

      return options.NOT_AVAILABLE;
    };

    var getNavigatorCpuClass = function getNavigatorCpuClass(options) {
      return navigator.cpuClass || options.NOT_AVAILABLE;
    };

    var getNavigatorPlatform = function getNavigatorPlatform(options) {
      if (navigator.platform) {
        return navigator.platform;
      } else {
        return options.NOT_AVAILABLE;
      }
    };

    var getDoNotTrack = function getDoNotTrack(options) {
      if (navigator.doNotTrack) {
        return navigator.doNotTrack;
      } else if (navigator.msDoNotTrack) {
        return navigator.msDoNotTrack;
      } else if (window.doNotTrack) {
        return window.doNotTrack;
      } else {
        return options.NOT_AVAILABLE;
      }
    }; // This is a crude and primitive touch screen detection.
    // It's not possible to currently reliably detect the  availability of a touch screen
    // with a JS, without actually subscribing to a touch event.
    // http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
    // https://github.com/Modernizr/Modernizr/issues/548
    // method returns an array of 3 values:
    // maxTouchPoints, the success or failure of creating a TouchEvent,
    // and the availability of the 'ontouchstart' property


    var getTouchSupport = function getTouchSupport() {
      var maxTouchPoints = 0;
      var touchEvent;

      if (typeof navigator.maxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.maxTouchPoints;
      } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.msMaxTouchPoints;
      }

      try {
        document.createEvent('TouchEvent');
        touchEvent = true;
      } catch (_) {
        touchEvent = false;
      }

      var touchStart = ('ontouchstart' in window);
      return [maxTouchPoints, touchEvent, touchStart];
    }; // https://www.browserleaks.com/canvas#how-does-it-work


    var getCanvasFp = function getCanvasFp(options) {
      var result = []; // Very simple now, need to make it more complex (geo shapes etc)

      var canvas = document.createElement('canvas');
      canvas.width = 2000;
      canvas.height = 200;
      canvas.style.display = 'inline';
      var ctx = canvas.getContext('2d'); // detect browser support of canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js

      ctx.rect(0, 0, 10, 10);
      ctx.rect(2, 2, 6, 6);
      result.push('canvas winding:' + (ctx.isPointInPath(5, 5, 'evenodd') === false ? 'yes' : 'no'));
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#f60';
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = '#069'; // https://github.com/Valve/fingerprintjs2/issues/66

      if (options.dontUseFakeFontInCanvas) {
        ctx.font = '11pt Arial';
      } else {
        ctx.font = '11pt no-real-font-123';
      }

      ctx.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 2, 15);
      ctx.fillStyle = 'rgba(102, 204, 0, 0.2)';
      ctx.font = '18pt Arial';
      ctx.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 4, 45); // canvas blending
      // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
      // http://jsfiddle.net/NDYV8/16/

      ctx.globalCompositeOperation = 'multiply';
      ctx.fillStyle = 'rgb(255,0,255)';
      ctx.beginPath();
      ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(0,255,255)';
      ctx.beginPath();
      ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(255,255,0)';
      ctx.beginPath();
      ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgb(255,0,255)'; // canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // http://jsfiddle.net/NDYV8/19/

      ctx.arc(75, 75, 75, 0, Math.PI * 2, true);
      ctx.arc(75, 75, 25, 0, Math.PI * 2, true);
      ctx.fill('evenodd');

      if (canvas.toDataURL) {
        result.push('canvas fp:' + canvas.toDataURL());
      }

      return result;
    };

    var getWebglFp = function getWebglFp() {
      var gl;

      var fa2s = function fa2s(fa) {
        gl.clearColor(0.0, 0.0, 0.0, 1.0);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        return '[' + fa[0] + ', ' + fa[1] + ']';
      };

      var maxAnisotropy = function maxAnisotropy(gl) {
        var ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic');

        if (ext) {
          var anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);

          if (anisotropy === 0) {
            anisotropy = 2;
          }

          return anisotropy;
        } else {
          return null;
        }
      };

      gl = getWebglCanvas();

      if (!gl) {
        return null;
      } // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
      // First it draws a gradient object with shaders and convers the image to the Base64 string.
      // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
      // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.


      var result = [];
      var vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}';
      var fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}';
      var vertexPosBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer);
      var vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0]);
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
      vertexPosBuffer.itemSize = 3;
      vertexPosBuffer.numItems = 3;
      var program = gl.createProgram();
      var vshader = gl.createShader(gl.VERTEX_SHADER);
      gl.shaderSource(vshader, vShaderTemplate);
      gl.compileShader(vshader);
      var fshader = gl.createShader(gl.FRAGMENT_SHADER);
      gl.shaderSource(fshader, fShaderTemplate);
      gl.compileShader(fshader);
      gl.attachShader(program, vshader);
      gl.attachShader(program, fshader);
      gl.linkProgram(program);
      gl.useProgram(program);
      program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex');
      program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset');
      gl.enableVertexAttribArray(program.vertexPosArray);
      gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0);
      gl.uniform2f(program.offsetUniform, 1, 1);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems);

      try {
        result.push(gl.canvas.toDataURL());
      } catch (e) {
        /* .toDataURL may be absent or broken (blocked by extension) */
      }

      result.push('extensions:' + (gl.getSupportedExtensions() || []).join(';'));
      result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)));
      result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)));
      result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS));
      result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'));
      result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS));
      result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS));
      result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS));
      result.push('webgl max anisotropy:' + maxAnisotropy(gl));
      result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS));
      result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE));
      result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS));
      result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE));
      result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS));
      result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE));
      result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS));
      result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS));
      result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS));
      result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS));
      result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)));
      result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS));
      result.push('webgl renderer:' + gl.getParameter(gl.RENDERER));
      result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION));
      result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS));
      result.push('webgl vendor:' + gl.getParameter(gl.VENDOR));
      result.push('webgl version:' + gl.getParameter(gl.VERSION));

      try {
        // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
        var extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info');

        if (extensionDebugRendererInfo) {
          result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL));
          result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL));
        }
      } catch (e) {
        /* squelch */
      }

      if (!gl.getShaderPrecisionFormat) {
        return result;
      }

      each(['FLOAT', 'INT'], function (numType) {
        each(['VERTEX', 'FRAGMENT'], function (shader) {
          each(['HIGH', 'MEDIUM', 'LOW'], function (numSize) {
            each(['precision', 'rangeMin', 'rangeMax'], function (key) {
              var format = gl.getShaderPrecisionFormat(gl[shader + '_SHADER'], gl[numSize + '_' + numType])[key];

              if (key !== 'precision') {
                key = 'precision ' + key;
              }

              var line = ['webgl ', shader.toLowerCase(), ' shader ', numSize.toLowerCase(), ' ', numType.toLowerCase(), ' ', key, ':', format].join('');
              result.push(line);
            });
          });
        });
      });
      return result;
    };

    var getWebglVendorAndRenderer = function getWebglVendorAndRenderer() {
      /* This a subset of the WebGL fingerprint with a lot of entropy, while being reasonably browser-independent */
      try {
        var glContext = getWebglCanvas();
        var extensionDebugRendererInfo = glContext.getExtension('WEBGL_debug_renderer_info');
        return glContext.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL) + '~' + glContext.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL);
      } catch (e) {
        return null;
      }
    };

    var getAdBlock = function getAdBlock() {
      var ads = document.createElement('div');
      ads.innerHTML = '&nbsp;';
      ads.className = 'adsbox';
      var result = false;

      try {
        // body may not exist, that's why we need try/catch
        document.body.appendChild(ads);
        result = document.getElementsByClassName('adsbox')[0].offsetHeight === 0;
        document.body.removeChild(ads);
      } catch (e) {
        result = false;
      }

      return result;
    };

    var getHasLiedLanguages = function getHasLiedLanguages() {
      // We check if navigator.language is equal to the first language of navigator.languages
      // navigator.languages is undefined on IE11 (and potentially older IEs)
      if (typeof navigator.languages !== 'undefined') {
        try {
          var firstLanguages = navigator.languages[0].substr(0, 2);

          if (firstLanguages !== navigator.language.substr(0, 2)) {
            return true;
          }
        } catch (err) {
          return true;
        }
      }

      return false;
    };

    var getHasLiedResolution = function getHasLiedResolution() {
      return window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight;
    };

    var getHasLiedOs = function getHasLiedOs() {
      var userAgent = navigator.userAgent.toLowerCase();
      var oscpu = navigator.oscpu;
      var platform = navigator.platform.toLowerCase();
      var os; // We extract the OS from the user agent (respect the order of the if else if statement)

      if (userAgent.indexOf('windows phone') >= 0) {
        os = 'Windows Phone';
      } else if (userAgent.indexOf('win') >= 0) {
        os = 'Windows';
      } else if (userAgent.indexOf('android') >= 0) {
        os = 'Android';
      } else if (userAgent.indexOf('linux') >= 0 || userAgent.indexOf('cros') >= 0) {
        os = 'Linux';
      } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0) {
        os = 'iOS';
      } else if (userAgent.indexOf('mac') >= 0) {
        os = 'Mac';
      } else {
        os = 'Other';
      } // We detect if the person uses a mobile device


      var mobileDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

      if (mobileDevice && os !== 'Windows Phone' && os !== 'Android' && os !== 'iOS' && os !== 'Other') {
        return true;
      } // We compare oscpu with the OS extracted from the UA


      if (typeof oscpu !== 'undefined') {
        oscpu = oscpu.toLowerCase();

        if (oscpu.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
          return true;
        } else if (oscpu.indexOf('linux') >= 0 && os !== 'Linux' && os !== 'Android') {
          return true;
        } else if (oscpu.indexOf('mac') >= 0 && os !== 'Mac' && os !== 'iOS') {
          return true;
        } else if ((oscpu.indexOf('win') === -1 && oscpu.indexOf('linux') === -1 && oscpu.indexOf('mac') === -1) !== (os === 'Other')) {
          return true;
        }
      } // We compare platform with the OS extracted from the UA


      if (platform.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
        return true;
      } else if ((platform.indexOf('linux') >= 0 || platform.indexOf('android') >= 0 || platform.indexOf('pike') >= 0) && os !== 'Linux' && os !== 'Android') {
        return true;
      } else if ((platform.indexOf('mac') >= 0 || platform.indexOf('ipad') >= 0 || platform.indexOf('ipod') >= 0 || platform.indexOf('iphone') >= 0) && os !== 'Mac' && os !== 'iOS') {
        return true;
      } else {
        var platformIsOther = platform.indexOf('win') < 0 && platform.indexOf('linux') < 0 && platform.indexOf('mac') < 0 && platform.indexOf('iphone') < 0 && platform.indexOf('ipad') < 0;

        if (platformIsOther !== (os === 'Other')) {
          return true;
        }
      }

      return typeof navigator.plugins === 'undefined' && os !== 'Windows' && os !== 'Windows Phone';
    };

    var getHasLiedBrowser = function getHasLiedBrowser() {
      var userAgent = navigator.userAgent.toLowerCase();
      var productSub = navigator.productSub; // we extract the browser from the user agent (respect the order of the tests)

      var browser;

      if (userAgent.indexOf('firefox') >= 0) {
        browser = 'Firefox';
      } else if (userAgent.indexOf('opera') >= 0 || userAgent.indexOf('opr') >= 0) {
        browser = 'Opera';
      } else if (userAgent.indexOf('chrome') >= 0) {
        browser = 'Chrome';
      } else if (userAgent.indexOf('safari') >= 0) {
        browser = 'Safari';
      } else if (userAgent.indexOf('trident') >= 0) {
        browser = 'Internet Explorer';
      } else {
        browser = 'Other';
      }

      if ((browser === 'Chrome' || browser === 'Safari' || browser === 'Opera') && productSub !== '20030107') {
        return true;
      } // eslint-disable-next-line no-eval


      var tempRes = eval.toString().length;

      if (tempRes === 37 && browser !== 'Safari' && browser !== 'Firefox' && browser !== 'Other') {
        return true;
      } else if (tempRes === 39 && browser !== 'Internet Explorer' && browser !== 'Other') {
        return true;
      } else if (tempRes === 33 && browser !== 'Chrome' && browser !== 'Opera' && browser !== 'Other') {
        return true;
      } // We create an error to see how it is handled


      var errFirefox;

      try {
        // eslint-disable-next-line no-throw-literal
        throw 'a';
      } catch (err) {
        try {
          err.toSource();
          errFirefox = true;
        } catch (errOfErr) {
          errFirefox = false;
        }
      }

      return errFirefox && browser !== 'Firefox' && browser !== 'Other';
    };

    var isCanvasSupported = function isCanvasSupported() {
      var elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    };

    var isWebGlSupported = function isWebGlSupported() {
      // code taken from Modernizr
      if (!isCanvasSupported()) {
        return false;
      }

      var glContext = getWebglCanvas();
      return !!window.WebGLRenderingContext && !!glContext;
    };

    var isIE = function isIE() {
      if (navigator.appName === 'Microsoft Internet Explorer') {
        return true;
      } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) {
        // IE 11
        return true;
      }

      return false;
    };

    var hasSwfObjectLoaded = function hasSwfObjectLoaded() {
      return typeof window.swfobject !== 'undefined';
    };

    var hasMinFlashInstalled = function hasMinFlashInstalled() {
      return window.swfobject.hasFlashPlayerVersion('9.0.0');
    };

    var addFlashDivNode = function addFlashDivNode(options) {
      var node = document.createElement('div');
      node.setAttribute('id', options.fonts.swfContainerId);
      document.body.appendChild(node);
    };

    var loadSwfAndDetectFonts = function loadSwfAndDetectFonts(done, options) {
      var hiddenCallback = '___fp_swf_loaded';

      window[hiddenCallback] = function (fonts) {
        done(fonts);
      };

      var id = options.fonts.swfContainerId;
      addFlashDivNode();
      var flashvars = {
        onReady: hiddenCallback
      };
      var flashparams = {
        allowScriptAccess: 'always',
        menu: 'false'
      };
      window.swfobject.embedSWF(options.fonts.swfPath, id, '1', '1', '9.0.0', false, flashvars, flashparams, {});
    };

    var getWebglCanvas = function getWebglCanvas() {
      var canvas = document.createElement('canvas');
      var gl = null;

      try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
      } catch (e) {
        /* squelch */
      }

      if (!gl) {
        gl = null;
      }

      return gl;
    };

    var components = [{
      key: 'userAgent',
      getData: UserAgent
    }, {
      key: 'webdriver',
      getData: webdriver
    }, {
      key: 'language',
      getData: languageKey
    }, {
      key: 'colorDepth',
      getData: colorDepthKey
    }, {
      key: 'deviceMemory',
      getData: deviceMemoryKey
    }, {
      key: 'pixelRatio',
      getData: pixelRatioKey
    }, {
      key: 'hardwareConcurrency',
      getData: hardwareConcurrencyKey
    }, {
      key: 'screenResolution',
      getData: screenResolutionKey
    }, {
      key: 'availableScreenResolution',
      getData: availableScreenResolutionKey
    }, {
      key: 'timezoneOffset',
      getData: timezoneOffset
    }, {
      key: 'timezone',
      getData: timezone
    }, {
      key: 'sessionStorage',
      getData: sessionStorageKey
    }, {
      key: 'localStorage',
      getData: localStorageKey
    }, {
      key: 'indexedDb',
      getData: indexedDbKey
    }, {
      key: 'addBehavior',
      getData: addBehaviorKey
    }, {
      key: 'openDatabase',
      getData: openDatabaseKey
    }, {
      key: 'cpuClass',
      getData: cpuClassKey
    }, {
      key: 'platform',
      getData: platformKey
    }, {
      key: 'doNotTrack',
      getData: doNotTrackKey
    }, {
      key: 'plugins',
      getData: pluginsComponent
    }, {
      key: 'canvas',
      getData: canvasKey
    }, {
      key: 'webgl',
      getData: webglKey
    }, {
      key: 'webglVendorAndRenderer',
      getData: webglVendorAndRendererKey
    }, {
      key: 'adBlock',
      getData: adBlockKey
    }, {
      key: 'hasLiedLanguages',
      getData: hasLiedLanguagesKey
    }, {
      key: 'hasLiedResolution',
      getData: hasLiedResolutionKey
    }, {
      key: 'hasLiedOs',
      getData: hasLiedOsKey
    }, {
      key: 'hasLiedBrowser',
      getData: hasLiedBrowserKey
    }, {
      key: 'touchSupport',
      getData: touchSupportKey
    }, {
      key: 'fonts',
      getData: jsFontsKey,
      pauseBefore: true
    }, {
      key: 'fontsFlash',
      getData: flashFontsKey,
      pauseBefore: true
    }, {
      key: 'audio',
      getData: audioKey
    }, {
      key: 'enumerateDevices',
      getData: enumerateDevicesKey
    }];

    var Fingerprint2 = function Fingerprint2(options) {
      throw new Error("'new Fingerprint()' is deprecated, see https://github.com/Valve/fingerprintjs2#upgrade-guide-from-182-to-200");
    };

    Fingerprint2.get = function (options, callback) {
      if (!callback) {
        callback = options;
        options = {};
      } else if (!options) {
        options = {};
      }

      extendSoft(options, defaultOptions);
      options.components = options.extraComponents.concat(components);
      var keys = {
        data: [],
        addPreprocessedComponent: function addPreprocessedComponent(key, value) {
          if (typeof options.preprocessor === 'function') {
            value = options.preprocessor(key, value);
          }

          keys.data.push({
            key: key,
            value: value
          });
        }
      };
      var i = -1;

      var chainComponents = function chainComponents(alreadyWaited) {
        i += 1;

        if (i >= options.components.length) {
          // on finish
          callback(keys.data);
          return;
        }

        var component = options.components[i];

        if (options.excludes[component.key]) {
          chainComponents(false); // skip

          return;
        }

        if (!alreadyWaited && component.pauseBefore) {
          i -= 1;
          setTimeout(function () {
            chainComponents(true);
          }, 1);
          return;
        }

        try {
          component.getData(function (value) {
            keys.addPreprocessedComponent(component.key, value);
            chainComponents(false);
          }, options);
        } catch (error) {
          // main body error
          keys.addPreprocessedComponent(component.key, String(error));
          chainComponents(false);
        }
      };

      chainComponents(false);
    };

    Fingerprint2.getPromise = function (options) {
      return new Promise(function (resolve, reject) {
        Fingerprint2.get(options, resolve);
      });
    };

    Fingerprint2.getV18 = function (options, callback) {
      if (callback == null) {
        callback = options;
        options = {};
      }

      return Fingerprint2.get(options, function (components) {
        var newComponents = [];

        for (var i = 0; i < components.length; i++) {
          var component = components[i];

          if (component.value === (options.NOT_AVAILABLE || 'not available')) {
            newComponents.push({
              key: component.key,
              value: 'unknown'
            });
          } else if (component.key === 'plugins') {
            newComponents.push({
              key: 'plugins',
              value: map(component.value, function (p) {
                var mimeTypes = map(p[2], function (mt) {
                  if (mt.join) {
                    return mt.join('~');
                  }

                  return mt;
                }).join(',');
                return [p[0], p[1], mimeTypes].join('::');
              })
            });
          } else if (['canvas', 'webgl'].indexOf(component.key) !== -1) {
            newComponents.push({
              key: component.key,
              value: component.value.join('~')
            });
          } else if (['sessionStorage', 'localStorage', 'indexedDb', 'addBehavior', 'openDatabase'].indexOf(component.key) !== -1) {
            if (component.value) {
              newComponents.push({
                key: component.key,
                value: 1
              });
            } else {
              // skip
              continue;
            }
          } else {
            if (component.value) {
              newComponents.push(component.value.join ? {
                key: component.key,
                value: component.value.join(';')
              } : component);
            } else {
              newComponents.push({
                key: component.key,
                value: component.value
              });
            }
          }
        }

        var murmur = x64hash128(map(newComponents, function (component) {
          return component.value;
        }).join('~~~'), 31);
        callback(murmur, newComponents);
      });
    };

    Fingerprint2.x64hash128 = x64hash128;
    Fingerprint2.VERSION = '2.1.0';
    return Fingerprint2;
  });
});
var _excluded$3 = ["isMobile", "buttonName"];
SignInButton.propTypes = {
  isMobile: bool.isRequired,
  onClick: func,
  buttonName: string.isRequired,
  id: string.isRequired,
  loading: bool,
  disabled: bool,
  variant: string,
  type: string
};

function SignInButton(_ref) {
  var isMobile = _ref.isMobile,
      buttonName = _ref.buttonName,
      theRest = _objectWithoutProperties(_ref, _excluded$3);

  var classes = useStyles$g();
  return /*#__PURE__*/React.createElement(Button, _extends({}, theRest, {
    className: isMobile ? classes.signInButtonMobile : '',
    color: "primary",
    "aria-label": buttonName
  }), /*#__PURE__*/React.createElement(Typography$1, {
    id: theRest.id,
    className: classnames(classes.linkSignIn),
    noWrap: true
  }, buttonName));
}

var useStyles$g = makeStyles$1(function (theme) {
  return {
    linkSignIn: _defineProperty(_defineProperty(_defineProperty({}, theme.breakpoints.only('sm'), {
      fontSize: theme.typography.fontSize
    }), "opacity", 1), theme.breakpoints.up('sm'), {
      color: theme.header.upperSection.textColor,
      fontWeight: 'bold'
    }),
    signInButtonMobile: {
      backgroundColor: theme.header.upperSection.textColor,
      width: '100%',
      opacity: 0.8,
      '&:hover': {
        backgroundColor: theme.header.upperSection.textColor,
        opacity: 1
      }
    }
  };
});
Message.propTypes = {
  children: node.isRequired,
  variant: oneOf(['error', 'info', 'success', 'warning']).isRequired,
  action: string,
  onActionClick: func,
  id: string,
  dataDescription: string
};

function Message(props) {
  var classes = useStyles$h();
  var children = props.children,
      variant = props.variant,
      action = props.action,
      onActionClick = props.onActionClick;
  var VariantIcon = variantIcon[variant]; // action button will switch container types to handle a nice responsive layout.

  return /*#__PURE__*/React.createElement(Box$1, {
    "data-description": props.dataDescription,
    p: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    className: classnames(classes.messageContainer, classes[variant])
  }, /*#__PURE__*/React.createElement(VariantIcon, {
    className: classnames(classes.icon, classes.iconVariant)
  }), /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    direction: "row",
    alignItems: "center",
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    container: true,
    xs: true,
    direction: "row",
    alignItems: "center",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Box$1, {
    flexGrow: 1,
    flexBasis: 20
  }, /*#__PURE__*/React.createElement(Typography$1, {
    component: 'div',
    id: props.id,
    variant: "body2",
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, children)), action && /*#__PURE__*/React.createElement(Hidden, {
    xsDown: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    ml: 1
  }, getActionButton()))), action && /*#__PURE__*/React.createElement(Hidden, {
    smUp: true
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, getActionButton(true)))));

  function getActionButton() {
    var fullWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      className: classes.actionButton,
      onClick: onActionClick,
      fullWidth: fullWidth
    }, action);
  }
}

var variantIcon = {
  success: CheckCircle,
  warning: Warning$2,
  error: Error$1,
  info: Info
};
var useStyles$h = makeStyles(function (theme) {
  return {
    messageContainer: {
      color: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius
    },
    success: {
      backgroundColor: theme.success.color
    },
    error: {
      backgroundColor: theme.palette.error.dark
    },
    info: {
      backgroundColor: theme.info.color
    },
    warning: {
      backgroundColor: theme.warning.color
    },
    icon: {
      marginRight: theme.spacing()
    },
    iconVariant: {
      opacity: 0.9
    },
    actionButton: {
      color: theme.palette.common.white,
      borderColor: 'rgba(255,255,255, .23)',
      whiteSpace: 'nowrap'
    }
  };
});

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var ReCAPTCHA = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized$1(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized$1(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized$1(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized$1(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose$2(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return React.createElement("div", _extends$2({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(React.Component);

ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: PropTypes__default.string.isRequired,
  onChange: PropTypes__default.func,
  grecaptcha: PropTypes__default.object,
  theme: PropTypes__default.oneOf(["dark", "light"]),
  type: PropTypes__default.oneOf(["image", "audio"]),
  tabindex: PropTypes__default.number,
  onExpired: PropTypes__default.func,
  onErrored: PropTypes__default.func,
  size: PropTypes__default.oneOf(["compact", "normal", "invisible"]),
  stoken: PropTypes__default.string,
  hl: PropTypes__default.string,
  badge: PropTypes__default.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;

function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader = /*#__PURE__*/function (_Component) {
      _inheritsLoose$1(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this; // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry


        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = _objectWithoutPropertiesLoose$3(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return createElement(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = forwardRef(function (props, ref) {
      return createElement(AsyncScriptLoader, _extends$3({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: PropTypes__default.func
    };
    return hoistNonReactStatics_cjs(ForwardedComponent, WrappedComponent);
  };
}

var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

var RecaptchaWrapper = makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA);
Login.propTypes = {
  loginUrl: PropTypes__default.string.isRequired,
  errorMessage: PropTypes__default.string,
  infoMessage: PropTypes__default.string,
  onSuccess: PropTypes__default.func.isRequired,
  buttonText: PropTypes__default.string,
  forgotPasswordUrl: PropTypes__default.string,
  contactSupportUrl: PropTypes__default.string,
  captchaEnabled: PropTypes__default.bool,
  captchaApiKey: PropTypes__default.string
};

function Login(props) {
  var recaptchaRef = React.createRef();
  var MAX_FAILURE_COUNT = 5;
  var usernameEl = useRef(null);
  var passwordEl = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      fingerprint = _useState4[0],
      setFingerprint = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      failureCount = _useState8[0],
      setFailureCount = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      submitEvent = _useState10[0],
      setSubmitEvent = _useState10[1];

  var onCaptchaChange = function onCaptchaChange(value) {
    loginUser(submitEvent, value);
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();

    if (props.captchaEnabled) {
      setSubmitEvent(event);
      recaptchaRef.current.execute();
    } else {
      loginUser(event, '');
    }
  };

  function loginUser(event, token) {
    var ref = '';

    if (props.captchaEnabled) {
      ref = recaptchaRef.current;
    }

    if (event) {
      setLoading(true);
      deleteCookiesStartingWith('ASPSESSIONID');
      return axiosInstance.post(props.loginUrl, {
        email: usernameEl.current.value,
        password: passwordEl.current.value,
        secondaryAuthentication: token
      }, {
        headers: {
          'device-id': fingerprint
        }
      }).then(function (response) {
        console.log('Processing Kameleoon Login successful conversion for GoalId: 346751');

        try {
          window.kameleoonQueue.push(['Goals.processConversion', 346751]);
        } catch (error) {
          console.error('Kameleoon conversion tracking failed:', error);
        }

        EventService.dispatchEvent(EVENT_LOGGED_IN, response.data);
        return props.onSuccess(response);
      })["catch"](function () {
        if (props.captchaEnabled) {
          ref.reset();
        }

        var currentFailureCount = failureCount + 1;

        if (currentFailureCount === MAX_FAILURE_COUNT - 1) {
          var fullError = /*#__PURE__*/React.createElement("span", null, props.errorMessage, " Account may be locked on the next failed attempt.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
            style: {
              color: 'white',
              textDecoration: 'underline'
            },
            href: props.forgotPasswordUrl || '/asp/ResetPassword.asp'
          }, "Reset your password."));
          setErrorMessage(fullError);
        } else if (currentFailureCount >= MAX_FAILURE_COUNT) {
          var _fullError = /*#__PURE__*/React.createElement("span", null, "Username or password cannot be validated.", /*#__PURE__*/React.createElement(Link, {
            style: {
              color: 'white',
              textDecoration: 'underline'
            },
            href: props.forgotPasswordUrl || '/asp/ResetPassword.asp'
          }, " Reset your password."));

          setErrorMessage(_fullError);
        } else {
          var _fullError2 = /*#__PURE__*/React.createElement("span", null, props.errorMessage, /*#__PURE__*/React.createElement("br", null), "Forgot Password? ", /*#__PURE__*/React.createElement(Link, {
            style: {
              color: 'white',
              textDecoration: 'underline'
            },
            href: props.forgotPasswordUrl || '/asp/ResetPassword.asp'
          }, "Reset your password."));

          setErrorMessage(_fullError2);
        }

        setFailureCount(currentFailureCount);
      })["finally"](function () {
        return setLoading(false);
      });
    }
  }

  fingerprint2.get({
    excludes: {
      webgl: true
    }
  }, function (components) {
    var values = components.map(function (component) {
      return component.value;
    }).join('');
    setFingerprint(fingerprint2.x64hash128(values, 31));
  });
  var submitButtonText = props.buttonText && props.buttonText.trim() ? props.buttonText.trim() : 'Sign In';
  var theme = useTheme();
  return /*#__PURE__*/React.createElement("form", {
    className: 'loginForm',
    noValidate: true,
    onSubmit: handleSubmit
  }, props.infoMessage && /*#__PURE__*/React.createElement(Message, {
    variant: 'info'
  }, props.infoMessage), errorMessage && /*#__PURE__*/React.createElement(Message, {
    variant: 'error',
    id: 'loginError'
  }, errorMessage), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(TextField, {
    InputLabelProps: {
      shrink: true
    },
    variant: "outlined",
    margin: "normal",
    required: true,
    id: "username",
    label: "Username or Email",
    name: "username",
    autoComplete: "username",
    autoFocus: true,
    inputRef: usernameEl,
    onChange: function onChange() {
      return setFailureCount(0);
    },
    color: theme.login.colorPalette
  }), /*#__PURE__*/React.createElement(TextField, {
    InputLabelProps: {
      shrink: true
    },
    variant: "outlined",
    margin: "normal",
    required: true,
    name: "password",
    label: "Password",
    type: "password",
    id: "password",
    autoComplete: "current-password",
    inputRef: passwordEl,
    color: theme.login.colorPalette
  }), /*#__PURE__*/React.createElement(SignInButton, {
    type: 'submit',
    loading: loading,
    variant: 'contained',
    isMobile: false,
    buttonName: submitButtonText,
    id: 'sign-in-submit'
  }), props.captchaEnabled && /*#__PURE__*/React.createElement(RecaptchaWrapper, {
    ref: recaptchaRef,
    size: "invisible",
    sitekey: props.captchaApiKey,
    onChange: onCaptchaChange
  }))));
}

LoginForm.propTypes = {
  forgotPasswordUrl: string,
  signUpUrl: string,
  sellerLoginUrl: string,
  captchaApiKey: string,
  captchaEnabled: bool
};

function LoginForm(props) {
  var classes = useStyles$i();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.section1
  }, /*#__PURE__*/React.createElement(Login, props), /*#__PURE__*/React.createElement("a", {
    href: props.forgotPasswordUrl || '/asp/passwordreminder.asp?u=b'
  }, /*#__PURE__*/React.createElement(Typography, null, 'Forgot Password?'))), /*#__PURE__*/React.createElement(Divider, {
    variant: "middle"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.section2
  }, /*#__PURE__*/React.createElement(Typography, null, 'Don\'t have an account? ', /*#__PURE__*/React.createElement("a", {
    href: props.signUpUrl || '/asp/createbidder.asp'
  }, 'Sign up!')), /*#__PURE__*/React.createElement("a", {
    href: props.sellerLoginUrl || '/asp/LoginAuctioneer.asp'
  }, /*#__PURE__*/React.createElement(Typography, null, 'Seller Login'))));
}

var useStyles$i = makeStyles(function (theme) {
  return {
    section1: {
      margin: theme.spacing(1)
    },
    section2: {
      margin: theme.spacing(2),
      textAlign: 'center'
    }
  };
});
LoginFlow.propTypes = {
  loginUrl: string.isRequired,
  onSuccess: func.isRequired,
  unifiedUserAgreementUrl: string.isRequired,
  privacyPolicyUrl: string.isRequired,
  termsAndConditionsSubmitUrl: string.isRequired,
  infoMessage: string,
  forgotPasswordUrl: string,
  signUpUrl: string,
  sellerLoginUrl: string,
  captchaApiKey: string.isRequired,
  captchaEnabled: bool.isRequired
};

function LoginFlow(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      requiresAgreement = _useState2[0],
      setRequiresAgreement = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      guid = _useState4[0],
      setGuid = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      userId = _useState6[0],
      setUserId = _useState6[1];

  var loginSuccess = function loginSuccess(response) {
    if (response.data['requiresTermsAndConditionsAcceptance']) {
      setRequiresAgreement(true);
      deleteCookie('guid');
      deleteCookie('userid');
      setGuid(response.data['buyerGuid']);
      setUserId(response.data['bidderUserId']);
    } else {
      props.onSuccess(response);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, requiresAgreement ? /*#__PURE__*/React.createElement(TermsAndConditions, {
    errorMessage: "Error accepting terms and conditions.",
    termsAndConditionsSubmitUrl: props.termsAndConditionsSubmitUrl,
    onSuccess: props.onSuccess,
    unifiedUserAgreementUrl: props.unifiedUserAgreementUrl,
    privacyPolicyUrl: props.privacyPolicyUrl,
    guid: guid,
    userId: userId
  }) : /*#__PURE__*/React.createElement(LoginForm, {
    loginUrl: props.loginUrl,
    errorMessage: "Invalid username/email or password.",
    onSuccess: loginSuccess,
    infoMessage: props.infoMessage,
    forgotPasswordUrl: props.forgotPasswordUrl,
    signUpUrl: props.signUpUrl,
    sellerLoginUrl: props.sellerLoginUrl,
    captchaApiKey: props.captchaApiKey,
    captchaEnabled: props.captchaEnabled
  }));
}

LoginFlowDialog.propTypes = {
  showDialog: bool.isRequired,
  onClose: func.isRequired,
  dialogTitle: string.isRequired,
  captchaEnabled: bool.isRequired,
  captchaApiKey: string.isRequired
};

function LoginFlowDialog(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hit401 = _useState2[0],
      didHit401 = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      eventShowDialog = _useState4[0],
      setEventShowDialog = _useState4[1];

  useEffect(function () {
    EventService.addEventListener(EVENT_HTTP_401, event401Handler);
    EventService.addEventListener(EVENT_LOGIN_SHOW_LOGIN_DIALOG, handleEventShowDialog);
    return function () {
      EventService.removeEventListener(EVENT_HTTP_401, event401Handler);
      EventService.removeEventListener(EVENT_LOGIN_SHOW_LOGIN_DIALOG, handleEventShowDialog);
    };
  }, []);

  var handleClose = function handleClose() {
    if (hit401) {
      location.reload();
    }

    setEventShowDialog(false);
    props.onClose();
  };

  var event401Handler = function event401Handler() {
    didHit401(true);
  };

  var handleEventShowDialog = function handleEventShowDialog() {
    return setEventShowDialog(true);
  };

  var theme = useTheme();
  var fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  var closeButton = {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1)
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "sm",
    open: props.showDialog || hit401 || eventShowDialog,
    onClose: handleClose,
    fullScreen: fullScreen
  }, /*#__PURE__*/React.createElement(DialogTitle$1, null, props.dialogTitle, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    style: closeButton,
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CloseIcon$1, null))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Box, {
    pb: 4
  }, /*#__PURE__*/React.createElement(LoginFlow, props))));
}

var moment = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    var hookCallback;

    function hooks() {
      return hookCallback.apply(null, arguments);
    } // This is done to register the method called with moment()
    // without creating circular dependencies.


    function setHookCallback(callback) {
      hookCallback = callback;
    }

    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
      // IE8 will treat undefined and null as object if it wasn't for
      // input != null
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;

        for (k in obj) {
          if (obj.hasOwnProperty(k)) {
            return false;
          }
        }

        return true;
      }
    }

    function isUndefined(input) {
      return input === void 0;
    }

    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
      var res = [],
          i;

      for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
      }

      return res;
    }

    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }

      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }

      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }

      return a;
    }

    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
      // We need to deep clone this object.
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }

    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }

      return m._pf;
    }

    var some;

    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }

        return false;
      };
    }

    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
          return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }

      return m._isValid;
    }

    function createInvalid(flags) {
      var m = createUTC(NaN);

      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }

      return m;
    } // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.


    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
      var i, prop, val;

      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }

      if (!isUndefined(from._i)) {
        to._i = from._i;
      }

      if (!isUndefined(from._f)) {
        to._f = from._f;
      }

      if (!isUndefined(from._l)) {
        to._l = from._l;
      }

      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }

      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }

      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }

      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }

      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }

      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }

      if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
          prop = momentProperties[i];
          val = from[prop];

          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }

      return to;
    }

    var updateInProgress = false; // Moment prototype object

    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);

      if (!this.isValid()) {
        this._d = new Date(NaN);
      } // Prevent infinite loop in case updateOffset creates new moment
      // objects.


      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }

    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function absFloor(number) {
      if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }

    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
          value = 0;

      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }

      return value;
    } // compare two arrays, return the number of differences


    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
          lengthDiff = Math.abs(array1.length - array2.length),
          diffs = 0,
          i;

      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }

      return diffs + lengthDiff;
    }

    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }

    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }

        if (firstTime) {
          var args = [];
          var arg;

          for (var i = 0; i < arguments.length; i++) {
            arg = '';

            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';

              for (var key in arguments[0]) {
                arg += key + ': ' + arguments[0][key] + ', ';
              }

              arg = arg.slice(0, -2); // Remove trailing comma and space
            } else {
              arg = arguments[i];
            }

            args.push(arg);
          }

          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }

        return fn.apply(this, arguments);
      }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }

      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
      return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
      var prop, i;

      for (i in config) {
        prop = config[i];

        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this['_' + i] = prop;
        }
      }

      this._config = config; // Lenient ordinal parsing accepts just a number in addition to
      // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
      // TODO: Remove "ordinalParse" fallback in next major release.

      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
          prop;

      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }

      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          // make sure changes to properties don't modify parent config
          res[prop] = extend({}, res[prop]);
        }
      }

      return res;
    }

    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }

    var keys;

    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
            res = [];

        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }

        return res;
      };
    }

    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };

    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
      var format = this._longDateFormat[key],
          formatUpper = this._longDateFormat[key.toUpperCase()];

      if (format || !formatUpper) {
        return format;
      }

      this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
      });
      return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
      return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
          normalizedProp,
          prop;

      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);

          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }

      return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
      var units = [];

      for (var u in unitsObj) {
        units.push({
          unit: u,
          priority: priorities[u]
        });
      }

      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }

    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
          zerosToFill = targetLength - absNumber.length,
          sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
    var formatFunctions = {};
    var formatTokenFunctions = {}; // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }

    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;

      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }

      if (token) {
        formatTokenFunctions[token] = func;
      }

      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }

      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }

    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }

      return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
          i,
          length;

      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }

      return function (mom) {
        var output = '',
            i;

        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }

        return output;
      };
    } // format date using native date object


    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }

      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
      var i = 5;

      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }

      localFormattingTokens.lastIndex = 0;

      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }

      return format;
    }

    var match1 = /\d/; //       0 - 9

    var match2 = /\d\d/; //      00 - 99

    var match3 = /\d{3}/; //     000 - 999

    var match4 = /\d{4}/; //    0000 - 9999

    var match6 = /[+-]?\d{6}/; // -999999 - 999999

    var match1to2 = /\d\d?/; //       0 - 99

    var match3to4 = /\d\d\d\d?/; //     999 - 9999

    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999

    var match1to3 = /\d{1,3}/; //       0 - 999

    var match1to4 = /\d{1,4}/; //       0 - 9999

    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

    var matchUnsigned = /\d+/; //       0 - inf

    var matchSigned = /[+-]?\d+/; //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z

    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months

    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }

    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }

      return regexes[token](config._strict, config._locale);
    } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }

    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
      var i,
          func = callback;

      if (typeof token === 'string') {
        token = [token];
      }

      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }

      for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
      }
    }

    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }

    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8; // FORMATTING

    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? '' + y : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

    addUnitAlias('year', 'y'); // PRIORITIES

    addUnitPriority('year', 1); // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    }); // HELPERS

    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    } // HOOKS


    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    }; // MOMENTS


    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
      return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }

    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    } // MOMENTS


    function stringGet(units) {
      units = normalizeUnits(units);

      if (isFunction(this[units])) {
        return this[units]();
      }

      return this;
    }

    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);

        for (var i = 0; i < prioritized.length; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);

        if (isFunction(this[units])) {
          return this[units](value);
        }
      }

      return this;
    }

    function mod(n, x) {
      return (n % x + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        // I know
        var i;

        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }

        return -1;
      };
    }

    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }

      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    } // FORMATTING


    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    }); // ALIASES

    addUnitAlias('month', 'M'); // PRIORITY

    addUnitPriority('month', 8); // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    }); // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');

    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }

      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');

    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }

      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
      var i,
          ii,
          mom,
          llc = monthName.toLocaleLowerCase();

      if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];

        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;

      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }

      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      } // TODO: add sorting
      // Sorting makes sure if one month (or abbr) is a prefix of another
      // see sorting in computeMonthsParse


      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);

        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }

        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        } // test the regex


        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    } // MOMENTS


    function setMonth(mom, value) {
      var dayOfMonth;

      if (!mom.isValid()) {
        // No op
        return mom;
      }

      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

          if (!isNumber(value)) {
            return mom;
          }
        }
      }

      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

      return mom;
    }

    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }

    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;

    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }

        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }

        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }

    var defaultMonthsRegex = matchWord;

    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }

        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }

        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }

    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var shortPieces = [],
          longPieces = [],
          mixedPieces = [],
          i,
          mom;

      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      } // Sorting makes sure if one month (or abbr) is a prefix of another it
      // will match the longer piece.


      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);

      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }

      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate(y, m, d, h, M, s, ms) {
      // can't just apply() to create a date:
      // https://stackoverflow.com/q/181348
      var date; // the date constructor remaps years 0-99 to 1900-1999

      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);

        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }

      return date;
    }

    function createUTCDate(y) {
      var date; // the Date.UTC function remaps years 0-99 to 1900-1999

      if (y < 100 && y >= 0) {
        var args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));

        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }

      return date;
    } // start-of-first-week - start-of-year


    function firstWeekOffset(year, dow, doy) {
      var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
      fwd = 7 + dow - doy,
          // first-week day local weekday -- which local weekday is fwd
      fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
          weekOffset = firstWeekOffset(year, dow, doy),
          dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
          resYear,
          resDayOfYear;

      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }

      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }

    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
          week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
          resWeek,
          resYear;

      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }

      return {
        week: resWeek,
        year: resYear
      };
    }

    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
          weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    } // FORMATTING


    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W'); // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5); // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    }); // HELPERS
    // LOCALES

    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6 // The week that contains Jan 6th is the first week of the year.

    };

    function localeFirstDayOfWeek() {
      return this._week.dow;
    }

    function localeFirstDayOfYear() {
      return this._week.doy;
    } // MOMENTS


    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    } // FORMATTING


    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E'); // PRIORITY

    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11); // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    }); // HELPERS

    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }

      if (!isNaN(input)) {
        return parseInt(input, 10);
      }

      input = locale.weekdaysParse(input);

      if (typeof input === 'number') {
        return input;
      }

      return null;
    }

    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }

      return isNaN(input) ? null : input;
    } // LOCALES


    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');

    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');

    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');

    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
          ii,
          mom,
          llc = weekdayName.toLocaleLowerCase();

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;

      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);

        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }

        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        } // test the regex


        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    } // MOMENTS


    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }

    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      } // behaves the same as moment#day except
      // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
      // as a setter, sunday should belong to the previous week.


      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }

    var defaultWeekdaysRegex = matchWord;

    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }

        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }

    var defaultWeekdaysShortRegex = matchWord;

    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }

        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }

    var defaultWeekdaysMinRegex = matchWord;

    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }

        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }

    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var minPieces = [],
          shortPieces = [],
          longPieces = [],
          mixedPieces = [],
          i,
          mom,
          minp,
          shortp,
          longp;

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
      // will match the longer piece.


      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);

      for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    } // FORMATTING


    function hFormat() {
      return this.hours() % 12 || 12;
    }

    function kFormat() {
      return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }

    meridiem('a', true);
    meridiem('A', false); // ALIASES

    addUnitAlias('hour', 'h'); // PRIORITY

    addUnitPriority('hour', 13); // PARSING

    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4;
      var pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4;
      var pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    }); // LOCALES

    function localeIsPM(input) {
      // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
      // Using charAt should be more compatible.
      return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;

    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    } // MOMENTS
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.


    var getSetHour = makeGetSet('Hours', true);
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    }; // internal storage for locale config files

    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    } // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


    function chooseLocale(names) {
      var i = 0,
          j,
          next,
          locale,
          split;

      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;

        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));

          if (locale) {
            return locale;
          }

          if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
            //the next array item is better than a shallower substring of this one
            break;
          }

          j--;
        }

        i++;
      }

      return globalLocale;
    }

    function loadLocale(name) {
      var oldLocale = null; // TODO: Find a better way to register and load all the locales in Node

      if (!locales[name] && 'object' !== 'undefined' && module && module.exports) {
        try {
          oldLocale = globalLocale._abbr;
          var aliasedRequire = commonjsRequire;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {}
      }

      return locales[name];
    } // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.


    function getSetGlobalLocale(key, values) {
      var data;

      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }

        if (data) {
          // moment.duration._locale = moment._locale = data;
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }

      return globalLocale._abbr;
    }

    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
            parentConfig = baseConfig;
        config.abbr = name;

        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);

            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }

              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }

        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        } // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.


        getSetGlobalLocale(name);
        return locales[name];
      } else {
        // useful for testing
        delete locales[name];
        return null;
      }
    }

    function updateLocale(name, config) {
      if (config != null) {
        var locale,
            tmpLocale,
            parentConfig = baseConfig; // MERGE

        tmpLocale = loadLocale(name);

        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }

        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale; // backwards compat for now: also set the locale

        getSetGlobalLocale(name);
      } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }

      return locales[name];
    } // returns locale data


    function getLocale(key) {
      var locale;

      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }

      if (!key) {
        return globalLocale;
      }

      if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);

        if (locale) {
          return locale;
        }

        key = [key];
      }

      return chooseLocale(key);
    }

    function listLocales() {
      return keys(locales);
    }

    function checkOverflow(m) {
      var overflow;
      var a = m._a;

      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }

        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }

        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
      }

      return m;
    } // Pick the first defined of two or three arguments.


    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }

      if (b != null) {
        return b;
      }

      return c;
    }

    function currentDateArray(config) {
      // hooks is actually the exported moment object
      var nowValue = new Date(hooks.now());

      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }

      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    } // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]


    function configFromArray(config) {
      var i,
          date,
          input = [],
          currentDate,
          expectedWeekday,
          yearToUse;

      if (config._d) {
        return;
      }

      currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      } //if the day of the year is set, figure out what it is


      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      } // Default to current date.
      // * if no year, month, day of month are given, default to today
      // * if day of month is given, default month and year
      // * if month is given, default only year
      // * if year is given, don't default anything


      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      } // Zero out whatever was not defaulted, including time


      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      } // Check for 24:00:00.000


      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }

      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
      // with parseZone.

      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }

      if (config._nextDay) {
        config._a[HOUR] = 24;
      } // check for mismatching day of week


      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }

    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
      w = config._w;

      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).

        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);

        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        var curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
          // weekday -- low day numbers are considered next week
          weekday = w.d;

          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          // local weekday -- counting starts from beginning of week
          weekday = w.e + dow;

          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          // default to beginning of week
          weekday = dow;
        }
      }

      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    } // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
    var isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/]]; // iso time formats and regexes

    var isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]];
    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i; // date from iso format

    function configFromISO(config) {
      var i,
          l,
          string = config._i,
          match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
          allowTime,
          dateFormat,
          timeFormat,
          tzFormat;

      if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }

        if (dateFormat == null) {
          config._isValid = false;
          return;
        }

        if (match[3]) {
          for (i = 0, l = isoTimes.length; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              // match[2] should be 'T' or space
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }

          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }

        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }

        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }

        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    } // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3


    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }

      return result;
    }

    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);

      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }

      return year;
    }

    function preprocessRFC2822(s) {
      // Remove comments and folding whitespace and replace multiple-spaces with a single space
      return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }

      return true;
    }

    var obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
      } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100,
            h = (hm - m) / 100;
        return h * 60 + m;
      }
    } // date and time from ref 2822 format


    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i));

      if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);

        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    } // date from iso format or fallback


    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);

      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }

      configFromISO(config);

      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }

      configFromRFC2822(config);

      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      } // Final attempt, use Input Fallback


      hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }); // constant that refers to the ISO standard

    hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


    hooks.RFC_2822 = function () {}; // date from string and format string


    function configFromStringAndFormat(config) {
      // TODO: Move this to another part of the creation flow to prevent circular deps
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }

      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }

      config._a = [];
      getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

      var string = '' + config._i,
          i,
          parsedInput,
          tokens,
          token,
          skipped,
          stringLength = string.length,
          totalParsedInputLength = 0;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

      for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0]; // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));

        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));

          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }

          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        } // don't parse if it's not a known token


        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }

          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      } // add remaining unparsed input length to the string


      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      } // clear _12h flag if hour is <= 12


      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }

      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
      configFromArray(config);
      checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;

      if (meridiem == null) {
        // nothing to do
        return hour;
      }

      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);

        if (isPm && hour < 12) {
          hour += 12;
        }

        if (!isPm && hour === 12) {
          hour = 0;
        }

        return hour;
      } else {
        // this is not supposed to happen
        return hour;
      }
    } // date from string and array of format strings


    function configFromStringAndArray(config) {
      var tempConfig, bestMoment, scoreToBeat, i, currentScore;

      if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }

      for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);

        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }

        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
          continue;
        } // if there is any input that was not parsed add a penalty for that format


        currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }

      extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
      if (config._d) {
        return;
      }

      var i = normalizeObjectUnits(config._i);
      config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }

    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));

      if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
      }

      return res;
    }

    function prepareConfig(config) {
      var input = config._i,
          format = config._f;
      config._locale = config._locale || getLocale(config._l);

      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }

      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }

      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }

      if (!isValid(config)) {
        config._d = null;
      }

      return config;
    }

    function configFromInput(config) {
      var input = config._i;

      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};

      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }

      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      } // object construction must be done this way.
      // https://github.com/moment/moment/issues/1423


      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);

      if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
      } else {
        return createInvalid();
      }
    });
    var prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);

      if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
      } else {
        return createInvalid();
      }
    }); // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.

    function pickBy(fn, moments) {
      var res, i;

      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }

      if (!moments.length) {
        return createLocal();
      }

      res = moments[0];

      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }

      return res;
    } // TODO: Use [].sort instead?


    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }

    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }

    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
      for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }

      var unitHasDecimal = false;

      for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false; // only allow non-integers for smallest unit
          }

          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }

      return true;
    }

    function isValid$1() {
      return this._isValid;
    }

    function createInvalid$1() {
      return createDuration(NaN);
    }

    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
          years = normalizedInput.year || 0,
          quarters = normalizedInput.quarter || 0,
          months = normalizedInput.month || 0,
          weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
          days = normalizedInput.day || 0,
          hours = normalizedInput.hour || 0,
          minutes = normalizedInput.minute || 0,
          seconds = normalizedInput.second || 0,
          milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

      this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
      minutes * 6e4 + // 1000 * 60
      hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
      // Because of dateAddRemove treats 24 hours as different from a
      // day when working around DST, we need to store them separately

      this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
      // which months you are are talking about, so we have to store
      // it separately.

      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();

      this._bubble();
    }

    function isDuration(obj) {
      return obj instanceof Duration;
    }

    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    } // FORMATTING


    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';

        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }

        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }

    offset('Z', ':');
    offset('ZZ', ''); // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    }); // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']

    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher);

      if (matches === null) {
        return null;
      }

      var chunk = matches[matches.length - 1] || [];
      var parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      var minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    } // Return a moment from input, that is local/utc/zone equivalent to model.


    function cloneWithOffset(input, model) {
      var res, diff;

      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

        res._d.setTime(res._d.valueOf() + diff);

        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }

    function getDateOffset(m) {
      // On Firefox.24 Date#getTimezoneOffset returns a floating point.
      // https://github.com/moment/moment/pull/1871
      return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    } // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.


    hooks.updateOffset = function () {}; // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.


    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
          localAdjust;

      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);

          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }

        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }

        this._offset = input;
        this._isUTC = true;

        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }

        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }

        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }

    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }

        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }

    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }

      return this;
    }

    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);

        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }

      return this;
    }

    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }

      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }

      var c = {};
      copyConfig(c, this);
      c = prepareConfig(c);

      if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }

      return this._isDSTShifted;
    }

    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    } // ASP.NET json date format regex


    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/; // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day

    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
      var duration = input,
          // matching against regexp is expensive, do it on demand
      match = null,
          sign,
          ret,
          diffRes;

      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input)) {
        duration = {};

        if (key) {
          duration[key] = input;
        } else {
          duration.milliseconds = input;
        }
      } else if (!!(match = aspNetRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

        };
      } else if (!!(match = isoRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        // checks for null or undefined
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }

      ret = new Duration(duration);

      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }

      return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
      // We'd normally use ~~inp for this, but unfortunately it also
      // converts floats to ints.
      // inp may be undefined, so careful calling replace on it.
      var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

      return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }

      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }

    function momentsDifference(base, other) {
      var res;

      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }

      other = cloneWithOffset(other, base);

      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }

      return res;
    } // TODO: remove 'name' arg after deprecation is removed


    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp; //invert the arguments, but complain about it

        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
          days = absRound(duration._days),
          months = absRound(duration._months);

      if (!mom.isValid()) {
        // No op
        return;
      }

      updateOffset = updateOffset == null ? true : updateOffset;

      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }

      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }

      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }

      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }

    var add = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
      // We want to compare the start of today, vs this.
      // Getting start-of-today depends on whether we're local/utc/offset or not.
      var now = time || createLocal(),
          sod = cloneWithOffset(now, this).startOf('day'),
          format = hooks.calendarFormat(this, sod) || 'sameElse';
      var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
      return new Moment(this);
    }

    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }

    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }

    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
          localTo = isMoment(to) ? to : createLocal(to);

      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }

      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
          inputMs;

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }

    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
      var that, zoneDelta, output;

      if (!this.isValid()) {
        return NaN;
      }

      that = cloneWithOffset(input, this);

      if (!that.isValid()) {
        return NaN;
      }

      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);

      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;

        case 'month':
          output = monthDiff(this, that);
          break;

        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;

        case 'second':
          output = (this - that) / 1e3;
          break;
        // 1000

        case 'minute':
          output = (this - that) / 6e4;
          break;
        // 1000 * 60

        case 'hour':
          output = (this - that) / 36e5;
          break;
        // 1000 * 60 * 60

        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        // 1000 * 60 * 60 * 24, negate dst

        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        // 1000 * 60 * 60 * 24 * 7, negate dst

        default:
          output = this - that;
      }

      return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
      // difference in months
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
          // b is in (anchor - 1 month, anchor + 1 month)
      anchor = a.clone().add(wholeMonthDiff, 'months'),
          anchor2,
          adjust;

      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

        adjust = (b - anchor) / (anchor2 - anchor);
      } //check for negative zero, return zero if negative zero


      return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }

      var utc = keepOffset !== true;
      var m = utc ? this.clone().utc() : this;

      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }

      if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }

      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */


    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }

      var func = 'moment';
      var zone = '';

      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }

      var prefix = '[' + func + '("]';
      var year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      var datetime = '-MM-DD[T]HH:mm:ss.SSS';
      var suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }

      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    } // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.


    function locale(key) {
      var newLocaleData;

      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);

        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }

        return this;
      }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });

    function localeData() {
      return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }

    function utcStartOfDate(y, m, d) {
      // Date.UTC remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }

    function startOf(units) {
      var time;
      units = normalizeUnits(units);

      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }

      var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;

        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;

        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;

        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;

        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;

        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;

        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;

        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }

      this._d.setTime(time);

      hooks.updateOffset(this, true);
      return this;
    }

    function endOf(units) {
      var time;
      units = normalizeUnits(units);

      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }

      var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;

        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;

        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;

        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;

        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;

        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;

        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;

        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }

      this._d.setTime(time);

      hooks.updateOffset(this, true);
      return this;
    }

    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
      return new Date(this.valueOf());
    }

    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }

    function toJSON() {
      // new Date(NaN).toJSON() === null
      return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
      return isValid(this);
    }

    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
      return getParsingFlags(this).overflow;
    }

    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    } // FORMATTING


    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1); // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    }); // MOMENTS

    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;

      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;

      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);

        if (week > weeksTarget) {
          week = weeksTarget;
        }

        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
          date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    } // FORMATTING


    addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

    addUnitAlias('quarter', 'Q'); // PRIORITY

    addUnitPriority('quarter', 7); // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    }); // MOMENTS

    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    } // FORMATTING


    addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

    addUnitAlias('date', 'D'); // PRIORITY

    addUnitPriority('date', 9); // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      // TODO: Remove "ordinalParse" fallback in next major release.
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    }); // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

    addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

    addUnitPriority('dayOfYear', 4); // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    }); // HELPERS
    // MOMENTS

    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    } // FORMATTING


    addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

    addUnitAlias('minute', 'm'); // PRIORITY

    addUnitPriority('minute', 14); // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE); // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

    addUnitAlias('second', 's'); // PRIORITY

    addUnitPriority('second', 15); // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND); // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    }); // ALIASES

    addUnitAlias('millisecond', 'ms'); // PRIORITY

    addUnitPriority('millisecond', 16); // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token;

    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    } // MOMENTS


    var getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
      return createLocal(input * 1000);
    }

    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
      return string;
    }

    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
      var locale = getLocale();
      var utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';

      if (index != null) {
        return get$1(format, index, field, 'month');
      }

      var i;
      var out = [];

      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }

      return out;
    } // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)


    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || '';
      }

      var locale = getLocale(),
          shift = localeSorted ? locale._week.dow : 0;

      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }

      var i;
      var out = [];

      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }

      return out;
    }

    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
            output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    }); // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;

    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }

    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    } // supports only 2.0-style add(1, 's') or add(duration)


    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    } // supports only 2.0-style subtract(1, 's') or subtract(duration)


    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }

    function bubble() {
      var milliseconds = this._milliseconds;
      var days = this._days;
      var months = this._months;
      var data = this._data;
      var seconds, minutes, hours, years, monthsFromDays; // if we have a mix of positive and negative values, bubble down first
      // check: https://github.com/moment/moment/issues/2166

      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      } // The following code bubbles up values, see the tests for
      // examples of what that means.


      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24); // convert days to months

      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }

    function daysToMonths(days) {
      // 400 years have 146097 days (taking into account leap year rules)
      // 400 years have 12 months === 4800
      return days * 4800 / 146097;
    }

    function monthsToDays(months) {
      // the reverse of daysToMonths
      return months * 146097 / 4800;
    }

    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }

      var days;
      var months;
      var milliseconds = this._milliseconds;
      units = normalizeUnits(units);

      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);

        switch (units) {
          case 'month':
            return months;

          case 'quarter':
            return months / 3;

          case 'year':
            return months / 12;
        }
      } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));

        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;

          case 'day':
            return days + milliseconds / 864e5;

          case 'hour':
            return days * 24 + milliseconds / 36e5;

          case 'minute':
            return days * 1440 + milliseconds / 6e4;

          case 'second':
            return days * 86400 + milliseconds / 1000;
          // Math.floor prevents floating point math errors here

          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;

          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    } // TODO: Use this.as('ms')?


    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }

      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds = makeAs('s');
    var asMinutes = makeAs('m');
    var asHours = makeAs('h');
    var asDays = makeAs('d');
    var asWeeks = makeAs('w');
    var asMonths = makeAs('M');
    var asQuarters = makeAs('Q');
    var asYears = makeAs('y');

    function clone$1() {
      return createDuration(this);
    }

    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds = makeGetter('seconds');
    var minutes = makeGetter('minutes');
    var hours = makeGetter('hours');
    var days = makeGetter('days');
    var months = makeGetter('months');
    var years = makeGetter('years');

    function weeks() {
      return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month
      M: 11 // months to year

    }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
      var duration = createDuration(posNegDuration).abs();
      var seconds = round(duration.as('s'));
      var minutes = round(duration.as('m'));
      var hours = round(duration.as('h'));
      var days = round(duration.as('d'));
      var months = round(duration.as('M'));
      var years = round(duration.as('y'));
      var a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days] || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    } // This function allows you to set the rounding function for relative time strings


    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }

      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }

      return false;
    } // This function allows you to set a threshold for relative time strings


    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }

      if (limit === undefined) {
        return thresholds[threshold];
      }

      thresholds[threshold] = limit;

      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }

      return true;
    }

    function humanize(withSuffix) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var locale = this.localeData();
      var output = relativeTime$1(this, !withSuffix, locale);

      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }

      return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
      // for ISO strings we do not use the normal bubbling rules:
      //  * milliseconds bubble up until they become hours
      //  * days do not bubble at all
      //  * months bubble up until they become years
      // This is because there is no context-free conversion between hours and days
      // (think of clock changes)
      // and also not between days and months (28-31 days per month)
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var seconds = abs$1(this._milliseconds) / 1000;
      var days = abs$1(this._days);
      var months = abs$1(this._months);
      var minutes, hours, years; // 3600 seconds -> 60 minutes -> 1 hour

      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60; // 12 months -> 1 year

      years = absFloor(months / 12);
      months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

      var Y = years;
      var M = months;
      var D = days;
      var h = hours;
      var m = minutes;
      var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      var total = this.asSeconds();

      if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
      }

      var totalSign = total < 0 ? '-' : '';
      var ymSign = sign(this._months) !== sign(total) ? '-' : '';
      var daysSign = sign(this._days) !== sign(total) ? '-' : '';
      var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (Y ? ymSign + Y + 'Y' : '') + (M ? ymSign + M + 'M' : '') + (D ? daysSign + D + 'D' : '') + (h || m || s ? 'T' : '') + (h ? hmsSign + h + 'H' : '') + (m ? hmsSign + m + 'M' : '') + (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang; // Side effect imports
    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf'); // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    }); // Side effect imports

    hooks.version = '2.24.0';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      // <input type="datetime-local" step="0.001" />
      DATE: 'YYYY-MM-DD',
      // <input type="date" />
      TIME: 'HH:mm',
      // <input type="time" />
      TIME_SECONDS: 'HH:mm:ss',
      // <input type="time" step="1" />
      TIME_MS: 'HH:mm:ss.SSS',
      // <input type="time" step="0.001" />
      WEEK: 'GGGG-[W]WW',
      // <input type="week" />
      MONTH: 'YYYY-MM' // <input type="month" />

    };
    return hooks;
  });
});

var AuctionTimer = /*#__PURE__*/function (_Component) {
  function AuctionTimer(props) {
    var _this;

    _classCallCheck(this, AuctionTimer);

    _this = _callSuper(this, AuctionTimer, [props]);

    _this.calculateCountdown = function (endDate) {
      var eventTime = moment(endDate).local();
      var currentTime = moment();
      var diff = eventTime - currentTime;
      var duration = moment.duration(diff, 'milliseconds');
      var secondsUntilEndDate = duration / 1000;
      if (duration.asMilliseconds() <= 0) return false;
      return {
        secondsLeft: secondsUntilEndDate
      };
    };

    _this.state = {
      secondsLeft: -1
    };
    return _this;
  }

  _inherits(AuctionTimer, _Component);

  return _createClass(AuctionTimer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.tick = setInterval(function () {
        var timeLeft = _this2.calculateCountdown(_this2.props.date);

        timeLeft ? _this2.setState(timeLeft) : _this2.stop();
      }, 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.tick);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "AuctionTimer"
      }, /*#__PURE__*/React.createElement("div", null, millisToDays(this.state.secondsLeft, false, true)));
    }
  }]);
}(Component);

AuctionTimer.propTypes = {
  date: string.isRequired
};
var navLinks = [{
  id: "today-link",
  to: "/todays-auctions",
  text: "Today's Events",
  name: "Today's Events Link"
}, {
  id: "live-link",
  to: "/live-auctions",
  text: "Live Auctions",
  name: "Live Auctions Link"
}, {
  id: "timed-link",
  to: "/timed-events",
  text: "Timed Auctions",
  name: "Timed Auctions Link"
}, {
  id: "all-auctions-link",
  to: "/all-auctions",
  text: "All Events",
  name: "All Events Link"
}, {
  id: "companies-link",
  to: "/asp/auction-companies.asp",
  text: "Auction Houses",
  name: "Companies Link"
}, {
  id: "world-map-link",
  to: "/auctions-near-me-map",
  text: "Auctions Near Me",
  name: "Auction Location Link"
}, {
  id: "date-link",
  to: "#",
  text: "Date",
  name: "Date Link"
}, {
  id: "featured-lots-link",
  to: "/asp/featured-lots.asp",
  text: "Featured Items",
  name: "Featured Items Link"
}];
var useStyles$j = makeStyles(function (theme) {
  return {
    textFormatDropdown: {
      fontSize: theme.header.fontSize,
      color: theme.header.lowerSection.textColor + ' !important',
      padding: '0.25rem 2rem'
    },
    drawer: {
      width: '90%',
      backgroundColor: theme.palette.primary.main,
      flexShrink: 0
    },
    popper: {
      'z-index': '100'
    },
    linkWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    container: {
      alignSelf: 'flex-start',
      width: '15rem'
    },
    label: {
      marginLeft: 50,
      paddingBottom: '1.45rem',
      fontWeight: 600,
      fontSize: theme.header.fontSize,
      color: theme.header.lowerSection.categoryTextColor
    },
    link: {
      paddingLeft: '5rem',
      display: 'flex',
      alignItems: 'flex-start',
      padding: '0.45rem 2rem',
      fontSize: theme.header.fontSize,
      color: theme.header.lowerSection.categoryTextColor,
      cursor: 'pointer'
    },
    closeLink: {
      padding: '2rem 1.45rem 2.45rem',
      color: theme.header.lowerSection.categoryTextColor,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    dateTextField: {
      display: 'none'
    }
  };
});
BrowseByLinks.propTypes = {
  anchorEl: PropTypes__default.object,
  handleClose: PropTypes__default.func
};

function BrowseByLinks(props) {
  var classes = useStyles$j();
  var theme = useTheme();
  var anchorEl = props.anchorEl,
      handleClose = props.handleClose,
      isDrawerOpen = props.isDrawerOpen,
      isMobile = props.isMobile,
      handleDrawerToggleBrowseBy = props.handleDrawerToggleBrowseBy;

  var _useState = useState(new Date()),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDate = _useState2[0],
      handleDateChange = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpenCalendar = _useState4[0],
      handleOpenCalendar = _useState4[1];

  var linkWithForwardRef = function linkWithForwardRef(element) {
    var LinkRef = React.forwardRef(function LinkRefRender(props, ref) {
      return element.id === 'date-link' ? /*#__PURE__*/React.createElement(Link$1, {
        underline: "none",
        "data-testid": element.id,
        ref: ref,
        onClick: function onClick() {
          return handleOpenCalendar(true);
        },
        className: classnames(props.className, 'header-calendar')
      }, props.children) : /*#__PURE__*/React.createElement(Link$1, _extends({
        underline: "none",
        "aria-label": element.name,
        ref: ref,
        href: element.to
      }, props));
    });
    LinkRef.propTypes = {
      className: PropTypes__default.string,
      children: PropTypes__default.array
    };
    return LinkRef;
  };

  function searchByDate(date) {
    var searchDate = new Date(date);
    var buildURL = "/todays-auctions?cat=0&asvt=all&dt=".concat(('0' + (searchDate.getMonth() + 1)).slice(-2), "/").concat(('0' + searchDate.getDate()).slice(-2), "/").concat(searchDate.getFullYear());
    window.location = window.location.origin + buildURL;
  }

  var calendarCustomization = _objectSpread2(_objectSpread2({}, theme), {}, {
    overrides: {
      MuiPickersBasePicker: {
        pickerView: {
          minHeight: 270
        }
      },
      MuiPickersCalendar: {
        transitionContainer: {
          minHeight: 181
        }
      }
    }
  });

  function renderCalendar() {
    // Commenting out as it causes weird problems, haven't been able to figure out why
    // if (!isMobile && isOpenCalendar) {
    //     handleClose();
    // }
    var dialogProps = {
      id: 'datePickerDialog'
    };
    return /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
      utils: DateFnsUtils
    }, /*#__PURE__*/React.createElement(ThemeProvider$1, {
      theme: calendarCustomization
    }, /*#__PURE__*/React.createElement(DatePicker, {
      id: 'date-picker',
      autoOk: true,
      okLabel: '',
      cancelLabel: '',
      className: classes.dateTextField,
      value: selectedDate,
      onAccept: function onAccept(date) {
        return searchByDate(date);
      },
      onChange: handleDateChange,
      open: isOpenCalendar,
      variant: "dialog",
      DialogProps: dialogProps,
      onClose: function onClose() {
        return handleOpenCalendar(false);
      },
      animateYearScrolling: true
    })));
  }

  var menuOpen = Boolean(anchorEl);
  var menuId = menuOpen ? 'browseby-menu' : undefined;
  var dropdownComponent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popper, {
    id: menuId,
    className: classes.popper,
    open: menuOpen,
    anchorEl: anchorEl
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 8
  }, /*#__PURE__*/React.createElement(Box, {
    py: 1
  }, navLinks.map(function (element, index) {
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      key: index,
      onClick: handleClose,
      id: element.id,
      "data-testid": element.id,
      className: classnames(classes.textFormatDropdown, element["class"]),
      component: linkWithForwardRef(element)
    }, element.text);
  })))), renderCalendar());
  var drawerComponent = /*#__PURE__*/React.createElement(Drawer$1, {
    variant: "temporary",
    anchor: "left",
    open: isDrawerOpen,
    classes: {
      paper: classes.drawer
    }
  }, /*#__PURE__*/React.createElement(KeyboardArrowLeft, {
    id: "close-browse-by",
    "data-test": "close-browse-by",
    "aria-label": "Close Browse By",
    fontSize: theme.header.icon.fontSize,
    className: classes.closeLink,
    onClick: function onClick() {
      return handleDrawerToggleBrowseBy();
    }
  }), /*#__PURE__*/React.createElement(Typography$1, {
    className: classes.label,
    id: 'browseByLabel',
    "aria-label": 'Browse By Label'
  }, "Browse By"), /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    direction: "column",
    spacing: 1,
    className: classes.drawer
  }, navLinks.map(function (element, index) {
    return /*#__PURE__*/React.createElement(Grid$2, {
      key: index,
      item: true,
      className: classnames(classes.linkWrapper, element["class"]),
      component: linkWithForwardRef(element)
    }, /*#__PURE__*/React.createElement(Typography$1, {
      className: classes.link,
      id: element.id
    }, element.text));
  }), renderCalendar()));
  return isMobile ? drawerComponent : dropdownComponent;
}

var categories = [{
  id: "collectibles-link",
  name: "Art, Antiques & Collectibles",
  to: "/for-sale/art-antiques-collectibles"
}, {
  id: "charity-link",
  name: "Benefit & Charity",
  to: "/for-sale/benefit-charity"
}, {
  id: "cars-vehicles-link",
  name: "Cars & Vehicles",
  to: "/for-sale/cars-vehicles"
}, {
  id: "coins-link",
  name: "Coins & Currency",
  to: "/for-sale/coins-currency"
}, {
  id: "collector-cars-link",
  name: "Collector Cars",
  to: "/for-sale/collector-cars"
}, {
  id: "commercial-trucks-link",
  name: "Commercial Trucks",
  to: "/for-sale/commercial-trucks"
}, {
  id: "electronics-link",
  name: "Computers & Electronics",
  to: "/for-sale/computers-electronics"
}, {
  id: "estate-link",
  name: "Estate & Personal Property",
  to: "/for-sale/estate-personal-property"
}, {
  id: "farm-equipment-link",
  name: "Farm Equipment & Machinery",
  to: "/for-sale/farm-equipment-machinery"
}, {
  id: "guns-link",
  name: "Guns & Military Artifacts",
  to: "/for-sale/guns-military-artifacts"
}, {
  id: "construction-link",
  name: "Heavy Construction Equipment",
  to: "/for-sale/heavy-construction-equipment"
}, {
  id: "horse-link",
  name: "Horse & Livestock",
  to: "/for-sale/horse-livestock"
}, {
  id: "industrial-machinery-link",
  name: "Industrial Machinery & Equipment",
  to: "/for-sale/industrial-machinery-equipment"
}, {
  id: "jewelry-link",
  name: "Jewelry, Gemstones & Watches",
  to: "/for-sale/jewelry-gemstones-watches"
}, {
  id: "real-estate-link",
  name: "Real Estate",
  to: "/for-sale/real-estate"
}];
var useStyles$k = makeStyles(function (theme) {
  return {
    textFormatDropdown: {
      fontSize: theme.header.fontSize,
      color: theme.header.lowerSection.textColor + ' !important',
      padding: '0.25rem 2rem'
    },
    viewAllContainer: {
      borderTop: '1px solid',
      width: '100%',
      padding: '0.85rem 2rem 0'
    },
    drawer: {
      width: '90%',
      backgroundColor: theme.palette.primary.main,
      flexShrink: 0
    },
    popper: {
      'z-index': '100'
    },
    linkWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    container: {
      alignSelf: 'flex-start',
      width: '15rem'
    },
    label: {
      marginLeft: 50,
      paddingBottom: '1.45rem',
      fontWeight: 600,
      fontSize: theme.header.fontSize,
      color: theme.header.lowerSection.categoryTextColor
    },
    link: {
      paddingLeft: '5rem',
      display: 'flex',
      alignItems: 'flex-start',
      padding: '0.45rem 2rem',
      fontSize: theme.header.fontSize,
      color: theme.header.lowerSection.categoryTextColor,
      cursor: 'pointer'
    },
    closeLink: {
      padding: '2rem 1.45rem 2.45rem',
      color: theme.header.lowerSection.categoryTextColor,
      '&:hover': {
        cursor: 'pointer'
      }
    }
  };
});
CategoryLinks.propTypes = {
  anchorEl: PropTypes__default.object,
  handleClose: PropTypes__default.func
};

function CategoryLinks(props) {
  var classes = useStyles$k();
  var theme = useTheme();
  var anchorEl = props.anchorEl,
      handleClose = props.handleClose,
      isDrawerOpen = props.isDrawerOpen,
      isMobile = props.isMobile,
      handleDrawerToggleCategories = props.handleDrawerToggleCategories;

  var linkWithForwardRef = function linkWithForwardRef(element) {
    return React.forwardRef(function LinkRefRender(props, ref) {
      return /*#__PURE__*/React.createElement(Link$1, _extends({
        underline: "none",
        "aria-label": element.name,
        ref: ref,
        href: element.to
      }, props));
    });
  };

  var menuOpen = Boolean(anchorEl);
  var menuId = menuOpen ? 'category-menu' : undefined;
  var dropdownComponent = /*#__PURE__*/React.createElement(Popper, {
    id: menuId,
    className: classes.popper,
    open: menuOpen,
    anchorEl: anchorEl
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 8
  }, /*#__PURE__*/React.createElement(Box, {
    py: 1
  }, categories.map(function (element, index) {
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      key: index,
      onClick: handleClose,
      "data-testid": element.id,
      id: element.id,
      className: classnames(classes.categoryLink, classes.textFormatDropdown),
      component: linkWithForwardRef(element)
    }, element.name);
  }), /*#__PURE__*/React.createElement(MenuItem$1, {
    onClick: handleClose,
    className: classes.viewAllContainer,
    component: linkWithForwardRef({
      name: 'View All Categories',
      to: '/all-categories'
    })
  }, /*#__PURE__*/React.createElement(Typography$1, {
    id: "view-all-categories",
    className: classes.textFormat
  }, "View All Categories")))));
  var drawerComponent = /*#__PURE__*/React.createElement(Drawer$1, {
    variant: "temporary",
    anchor: "left",
    open: isDrawerOpen,
    classes: {
      paper: classes.drawer
    }
  }, /*#__PURE__*/React.createElement(KeyboardArrowLeft, {
    id: "close-categories",
    "data-test": "close-categories",
    "aria-label": "Close Categories",
    fontSize: theme.header.icon.fontSize,
    className: classes.closeLink,
    onClick: function onClick() {
      return handleDrawerToggleCategories();
    }
  }), /*#__PURE__*/React.createElement(Typography$1, {
    className: classes.label,
    id: 'categoryLabel',
    "aria-label": 'Category Label'
  }, "Categories"), /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    direction: "column",
    spacing: 1,
    className: classes.drawer
  }, categories.map(function (element, index) {
    return /*#__PURE__*/React.createElement(Grid$2, {
      key: index,
      item: true,
      className: classes.linkWrapper,
      component: linkWithForwardRef(element)
    }, /*#__PURE__*/React.createElement(Typography$1, {
      className: classes.link,
      id: element.id
    }, element.name));
  }), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    component: linkWithForwardRef({
      to: '/all-categories',
      name: 'View All Categories'
    })
  }, /*#__PURE__*/React.createElement(Typography$1, {
    id: "view-all-categories",
    className: classes.link
  }, "View All Categories"))));
  return isMobile ? drawerComponent : dropdownComponent;
}

var useStyles$l = makeStyles(function (theme) {
  return {
    root: _defineProperty(_defineProperty({
      flexGrow: 1,
      flexDirection: 'column',
      height: '100%'
    }, theme.breakpoints.up('sm'), {
      flexDirection: 'row',
      marginLeft: 0,
      justifyContent: 'space-around'
    }), theme.breakpoints.up('md'), {
      justifyContent: 'start'
    }),
    textStyle: _defineProperty(_defineProperty({
      padding: '0.2rem 2rem',
      color: theme.header.lowerSection.categoryTextColor,
      cursor: 'pointer',
      alignSelf: 'center',
      fontSize: theme.header.fontSize,
      '&:hover': {
        color: theme.header.lowerSection.activeLinkHighlight
      }
    }, theme.breakpoints.up('sm'), {
      color: theme.header.lowerSection.textColor,
      padding: '.6rem 1rem .6rem 0'
    }), theme.breakpoints.up('md'), {
      padding: '.6rem 2.75rem .6rem 0'
    }),
    textStyleHome: _defineProperty({}, theme.breakpoints.up('sm'), {
      padding: '.6rem 0'
    }),
    textStyleCat: _defineProperty(_defineProperty({}, theme.breakpoints.up('sm'), {
      paddingLeft: '1rem'
    }), theme.breakpoints.up('md'), {
      paddingLeft: '2.75rem'
    }),
    linkWrapper: {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    categoryDrawer: {
      width: '90%',
      backgroundColor: theme.palette.primary.main,
      flexShrink: 0
    },
    activeTextStyle: _defineProperty({
      lineHeight: 1,
      fontWeight: 'bold',
      marginLeft: -5
    }, theme.breakpoints.up('sm'), {
      marginLeft: 0
    }),
    activeEffect: _defineProperty({
      background: 'rgba(255, 255, 255, 0.095389)',
      borderLeft: "5px solid ".concat(theme.header.upperSection.buttonColor)
    }, theme.breakpoints.up('sm'), {
      borderBottom: "5px solid ".concat(theme.header.upperSection.buttonColor),
      borderLeft: 'none',
      borderTop: '5px solid transparent'
    }),
    textStyleMobile: _defineProperty({
      padding: '12px 0'
    }, theme.breakpoints.up('sm'), {
      padding: 0
    })
  };
});

function NavLinks(props) {
  var classes = useStyles$l();
  var theme = useTheme();
  var isMobile = useMediaQuery$1(theme.breakpoints.only('xs'));

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openCategories = _React$useState2[0],
      setOpenCategories = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openBrowseBy = _React$useState4[0],
      setOpenBrowseBy = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      anchorCategories = _React$useState6[0],
      setAnchorCategories = _React$useState6[1];

  var _React$useState7 = React.useState(null),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      anchorBrowseBy = _React$useState8[0],
      setAnchorBrowseBy = _React$useState8[1];

  function handleDrawerToggleCategories() {
    setOpenCategories(!openCategories);
  }

  function handleDrawerToggleBrowseBy() {
    setOpenBrowseBy(!openBrowseBy);
  }

  function handleDropdownCategories(event) {
    setAnchorCategories(anchorCategories ? null : event.currentTarget);
  }

  function handleDropdownBrowseBy(event) {
    setAnchorBrowseBy(anchorBrowseBy ? null : event.currentTarget);
  }

  function handleBrowseByClose(event) {
    event && event.stopPropagation();
    setAnchorBrowseBy(null);
  }

  function handleCategoriesClose(event) {
    event.stopPropagation();
    setAnchorCategories(null);
  }

  function isHomeLinkActive() {
    return props.active === '/';
  }

  function arrowDisplay(anchor) {
    var isAnyMenuOpen = openCategories || openBrowseBy;

    if (isMobile) {
      return isAnyMenuOpen || !!anchor ? /*#__PURE__*/React.createElement(KeyboardArrowLeft, null) : /*#__PURE__*/React.createElement(KeyboardArrowRight, null);
    } else {
      return isAnyMenuOpen || !!anchor ? /*#__PURE__*/React.createElement(KeyboardArrowUp, null) : /*#__PURE__*/React.createElement(KeyboardArrowDown, null);
    }
  }

  var linkWithForwardRef = function linkWithForwardRef(element) {
    return React.forwardRef(function LinkRef(props, ref) {
      return /*#__PURE__*/React.createElement(Link$1, _extends({
        underline: "none",
        "aria-label": element.name,
        ref: ref,
        href: element.to
      }, props));
    });
  };

  return /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    className: classes.root,
    direction: "row",
    wrap: "nowrap"
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    id: 'main-home-link',
    className: classnames(classes.linkWrapper, classes.textStyleMobile, isHomeLinkActive() && classes.activeEffect),
    "data-testid": 'home-item',
    component: linkWithForwardRef({
      to: '/',
      name: 'Home'
    })
  }, /*#__PURE__*/React.createElement(Typography$1, {
    className: classnames(classes.textStyle, classes.textStyleHome, isHomeLinkActive() && classes.activeTextStyle),
    id: 'home-link'
  }, 'Home')), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    className: classnames(classes.linkWrapper, classes.textStyleMobile)
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleCategoriesClose,
    touchEvent: false
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Typography$1, {
    underline: "none",
    "data-testid": "category-dropdown",
    id: "category-dropdown",
    "aria-label": "Toggle Categories",
    className: classnames(classes.linkWrapper, classes.textStyle, classes.textStyleCat),
    onClick: function onClick(event) {
      return isMobile ? handleDrawerToggleCategories() : handleDropdownCategories(event);
    }
  }, "Categories ", arrowDisplay(anchorCategories)), /*#__PURE__*/React.createElement(CategoryLinks, {
    anchorEl: anchorCategories,
    handleClose: handleCategoriesClose,
    isDrawerOpen: openCategories,
    isMobile: isMobile,
    handleDrawerToggleCategories: handleDrawerToggleCategories
  })))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    className: classnames(classes.linkWrapper, classes.textStyleMobile)
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleBrowseByClose,
    touchEvent: false
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Typography$1, {
    underline: "none",
    "data-testid": "browse-by-dropdown",
    id: "browse-by-dropdown",
    "aria-label": "Toggle Browse By",
    className: classnames(classes.linkWrapper, classes.textStyle),
    noWrap: true,
    onClick: function onClick(event) {
      return isMobile ? handleDrawerToggleBrowseBy() : handleDropdownBrowseBy(event);
    }
  }, "Browse By ", arrowDisplay(anchorBrowseBy)), /*#__PURE__*/React.createElement(BrowseByLinks, {
    anchorEl: anchorBrowseBy,
    handleClose: handleBrowseByClose,
    isDrawerOpen: openBrowseBy,
    isMobile: isMobile,
    handleDrawerToggleBrowseBy: handleDrawerToggleBrowseBy
  })))));
}

NavLinks.propTypes = {
  active: PropTypes__default.string
};
var topLinks = [{
  id: "help-link",
  name: "Help",
  to: "https://proxibid.zendesk.com",
  target: "_blank",
  type: "link"
}, {
  id: "ze-chat-launcher",
  name: "Chat",
  type: "ze-chat-launcher"
}, {
  id: "marketplace-trust-link",
  name: "Marketplace Trust",
  to: "https://discover.proxibid.com/trust/",
  type: "link"
}, {
  id: "buying-link",
  name: "Buying",
  to: "https://discover.proxibid.com/buying/",
  type: "link"
}, {
  id: "selling-link",
  name: "Selling",
  to: "https://discover.proxibid.com/selling/",
  type: "link"
}, {
  id: "sign-in-link",
  name: "SIGN IN",
  type: "primary-button"
}, {
  id: "register-button",
  name: "SIGN UP",
  to: "/asp/createbidder.asp",
  type: "button"
}];
var myAccountLinksMobile = [{
  id: "my-proxibid-link",
  name: "My Proxibid",
  to: "/asp/Bidder/BidderHome.asp",
  type: "link"
}, {
  id: "watching-link",
  name: "Watching",
  to: "/asp/Bidder/PrebidManage.asp?opt=1",
  type: "link"
}, {
  id: "prebid-link",
  name: "Buying",
  to: "/asp/Bidder/PrebidManage.asp",
  type: "link"
}, {
  id: "purchased-link",
  name: "Purchased",
  to: "/asp/Bidder/PrebidManage.asp?opt=2",
  type: "link"
}, {
  id: "invoice-link",
  name: "Invoices",
  to: "/asp/Bidder/InvoiceManage.asp",
  type: "link"
}, {
  id: "logout-link",
  type: "link",
  name: "Sign Out"
}];
var myAccountLinks = [{
  id: "my-proxibid-link",
  name: "My Proxibid",
  to: "/asp/Bidder/BidderHome.asp"
}, {
  id: "logout-link",
  name: "Sign Out"
}];

var LogoutEvent = /*#__PURE__*/_createClass(function LogoutEvent() {
  _classCallCheck(this, LogoutEvent);
});

LogoutEvent.LOGOUT = '@logout/LOGOUT';
LogoutEvent.LOGOUT_SUCCESS = '@logout/LOGOUT_SUCCESS';

var ProxiponentsConfig = /*#__PURE__*/_createClass(function ProxiponentsConfig() {
  _classCallCheck(this, ProxiponentsConfig);

  this.clientProxyUrl = '';
});

ProxiponentsConfig.instance = new ProxiponentsConfig();

var LogoutService = /*#__PURE__*/function () {
  function LogoutService() {
    _classCallCheck(this, LogoutService);

    this.useRelativeUrls = true;
    this.proxiponentsConfig = ProxiponentsConfig.instance;
  }

  return _createClass(LogoutService, [{
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this = this;

      EventService.addEventListener(LogoutEvent.LOGOUT, function () {
        return _this.logout();
      });
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;

        var buyerGuid, logoutUrl, logoutResponse, additionalLogoutUrls, additionalLogoutPromises;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                buyerGuid = getCookieValue('guid');

                if (!buyerGuid) {
                  _context.next = 18;
                  break;
                }

                _context.prev = 2;
                logoutUrl = this.proxiponentsConfig.clientProxyUrl + '/logout/v1';
                _context.next = 6;
                return axiosInstance.post(logoutUrl, {
                  buyerGuid: buyerGuid
                });

              case 6:
                logoutResponse = _context.sent;
                additionalLogoutUrls = logoutResponse.data.additionalLogoutUrls;
                additionalLogoutPromises = additionalLogoutUrls.map(function (url) {
                  var urlToGet = url;

                  if (_this2.useRelativeUrls) {
                    var parsedUrl = new URL(url);
                    urlToGet = url.substring(parsedUrl.origin.length);
                  }

                  axiosInstance.get(urlToGet);
                });
                _context.next = 11;
                return Promise.all(additionalLogoutPromises);

              case 11:
                _context.next = 13;
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve('pause for redirects');
                  }, 1000);
                });

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);
                console.warn('Failed to complete all logout requests.', _context.t0);

              case 18:
                deleteCookiesStartingWith('ASPSESSIONID');
                EventService.dispatchEvent(LogoutEvent.LOGOUT_SUCCESS);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 15]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }]);
}();

LogoutService.instance = new LogoutService();
SignInRegister.propTypes = {
  clientProxy: string.isRequired,
  dialogTitle: string.isRequired,
  captchaEnabled: bool.isRequired,
  captchaApiKey: string.isRequired,
  handleDrawerToggle: func
};

function SignInRegister(props) {
  var classes = useStyles$m();
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.only('xs'));
  var logoutService = LogoutService.instance;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loggedIn = _useState4[0],
      setLoggedIn = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      anchorEl = _useState6[0],
      setAnchorEl = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showDialog = _useState8[0],
      setShowDialog = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      name = _useState10[0],
      setName = _useState10[1];

  function eventUpdateBidderDisplayName(_x) {
    return _eventUpdateBidderDisplayName.apply(this, arguments);
  }

  function _eventUpdateBidderDisplayName() {
    _eventUpdateBidderDisplayName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var encodedName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              encodedName = event.detail;

              if (!(encodedName && encodedName !== '')) {
                _context.next = 6;
                break;
              }

              setName(encodedName.replace(/\+/g, ' '));
              setLoggedIn(true);
              _context.next = 9;
              break;

            case 6:
              _context.next = 8;
              return handleLogout();

            case 8:
              setName('');

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _eventUpdateBidderDisplayName.apply(this, arguments);
  }

  function event401Handler() {
    deleteAllCookies();
    setLoggedIn(false);
    setName('');
    setShowDialog(true);
  }

  useEffect(function () {
    var guid = getCookieValue('guid');
    var encodedName = getCookieValue('BidderDisplayName');

    if (guid && guid !== '' && encodedName && encodedName !== '') {
      setName(encodedName.replace(/\+/g, ' '));
      setLoggedIn(true);
    }
  }, []);
  useEffect(function () {
    EventService.addEventListener(EVENT_LOGIN_UPDATE_DISPLAY_NAME, eventUpdateBidderDisplayName);
    EventService.addEventListener(EVENT_HTTP_401, event401Handler);
    return function () {
      EventService.removeEventListener(EVENT_LOGIN_UPDATE_DISPLAY_NAME, eventUpdateBidderDisplayName);
      EventService.removeEventListener(EVENT_HTTP_401, event401Handler);
    };
  }, [loggedIn]);

  function handleLoginSuccess() {
    return _handleLoginSuccess.apply(this, arguments);
  }

  function _handleLoginSuccess() {
    _handleLoginSuccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return axiosInstance.get('/asp/service/loginBidderByGuid.asp');

            case 3:
              _context2.next = 8;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);

            case 8:
              location.reload();

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    }));
    return _handleLoginSuccess.apply(this, arguments);
  }

  function handleLogout() {
    return _handleLogout.apply(this, arguments);
  }

  function _handleLogout() {
    _handleLogout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return logoutService.logout();

            case 2:
              setLoggedIn(false);
              handleDropDownClose();

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _handleLogout.apply(this, arguments);
  }

  function handleLogoutWithReload() {
    return _handleLogoutWithReload.apply(this, arguments);
  }

  function _handleLogoutWithReload() {
    _handleLogoutWithReload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var returnURL;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return handleLogout();

            case 2:
              if (getCookieValue('a2o_auth')) {
                returnURL = window.location.origin;
                window.location.href = '/account/signout?returnUrl=' + returnURL;
              } else {
                location.reload();
              }

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _handleLogoutWithReload.apply(this, arguments);
  }

  function handleDropDownClick(event) {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  }

  function handleDropDownClose() {
    setAnchorEl(null);
  }

  function handleDrawerToggle() {
    setOpen(!open);
  }

  var accountLink = function accountLink(element) {
    return /*#__PURE__*/React.createElement(Link, {
      id: element.id,
      underline: "none",
      "aria-label": element.name,
      href: element.to,
      onClick: element.name === 'Sign Out' ? function () {
        return handleLogoutWithReload();
      } : undefined
    }, /*#__PURE__*/React.createElement(Typography, {
      className: element.name === 'Sign Out' ? classnames(classes.accountLink) : classes.accountLink,
      id: element.id
    }, element.name));
  };

  var accountMenuItem = function accountMenuItem(element) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: element.id,
      component: element.to !== undefined ? linkWithForwardRef(element) : undefined,
      onClick: element.name === 'Sign Out' ? function () {
        return handleLogoutWithReload();
      } : undefined
    }, element.name);
  };

  var linkWithForwardRef = function linkWithForwardRef(element) {
    return React.forwardRef(function ForwardRefLink(props, ref) {
      return /*#__PURE__*/React.createElement(Link, _extends({
        underline: "none",
        "aria-label": element.name,
        ref: ref,
        href: window.location.pathname !== element.to ? element.to : undefined
      }, props));
    });
  };

  var renderLink = function renderLink(element) {
    return /*#__PURE__*/React.createElement(Link, {
      underline: "none",
      "aria-label": element.name,
      href: element.to,
      target: 'target' in element ? element.target : '_self'
    }, /*#__PURE__*/React.createElement(Typography, {
      id: element.id,
      className: classnames(classes.link, element.name === 'SIGN IN' ? classes.linkSignIn : ''),
      noWrap: true
    }, element.name));
  }; //Create a button to launch the Zendesk chat widget from the mobile menu.


  var renderZeChatLauncher = function renderZeChatLauncher(element) {
    return /*#__PURE__*/React.createElement(Link, {
      underline: "none",
      "aria-label": element.name,
      component: "button",
      id: element.id,
      onClick: function onClick() {
        //Close mobile menu drawer so that it doesn't steal focus from the widget
        // (see Material UI modal "disableEnforceFocus" property https://mui.com/material-ui/api/modal/#props)
        props.handleDrawerToggle(); //Open chat widget

        if (typeof window['zE'] === 'function') {
          window['zE']('webWidget', 'show');
          window['zE']('webWidget', 'open');
        }
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classnames(classes.link),
      noWrap: true
    }, element.name));
  };

  function handleSignInClick() {
    setShowDialog(!showDialog);
  }

  function renderSignInRegister(element) {
    if (element.type === 'primary-button') {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SignInButton, {
        isMobile: isMobile,
        showMarketplaceLinks: true,
        onClick: handleSignInClick,
        buttonName: element.name,
        id: element.id
      }), /*#__PURE__*/React.createElement(LoginFlowDialog, {
        showDialog: showDialog,
        dialogTitle: props.dialogTitle,
        captchaEnabled: props.captchaEnabled,
        captchaApiKey: props.captchaApiKey,
        loginUrl: "".concat(props.clientProxy, "/login/v1"),
        onSuccess: handleLoginSuccess,
        onClose: function onClose() {
          return setShowDialog(false);
        },
        unifiedUserAgreementUrl: '/docs/ProxibidUUA.pdf',
        privacyPolicyUrl: '/docs/ProxibidPrivacyPolicy.pdf',
        termsAndConditionsSubmitUrl: "".concat(props.clientProxy, "/terms-and-conditions/v1")
      }));
    } else {
      return /*#__PURE__*/React.createElement(Button, {
        className: classes.button,
        variant: "contained",
        id: element.id,
        "aria-label": element.name,
        href: element.to
      }, /*#__PURE__*/React.createElement(Typography, {
        className: classnames(classes.buttonText, element.name === 'SIGN UP' ? classes.linkRegister : ''),
        noWrap: true
      }, element.name));
    }
  }

  function renderLoggedIn() {
    var NON_BREAKING_SPACE = "\xA0";
    var menuOpen = Boolean(anchorEl);
    var menuId = menuOpen ? 'loggedin-myproxibid-menu' : undefined;
    return /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: handleDropDownClose,
      touchEvent: false
    }, /*#__PURE__*/React.createElement("div", {
      className: isMobile ? classes.signedInMobile : classes.signedIn
    }, /*#__PURE__*/React.createElement(Avatar, {
      className: classes.avatar,
      onClick: isMobile ? function () {
        return handleDrawerToggle();
      } : function (event) {
        return handleDropDownClick(event);
      }
    }, /*#__PURE__*/React.createElement(Person, null)), /*#__PURE__*/React.createElement(Button, {
      id: 'signed-in-button',
      onClick: isMobile ? function () {
        return handleDrawerToggle();
      } : function (event) {
        return handleDropDownClick(event);
      },
      className: classnames(classes.buttonText, classes.username, classes.dropDownButton)
    }, name.replace(/\s/, NON_BREAKING_SPACE)), isMobile ? /*#__PURE__*/React.createElement(ChevronRight, {
      className: classes.dropDownArrow,
      onClick: handleDrawerToggle
    }) : /*#__PURE__*/React.createElement(ExpandMore, {
      className: classes.dropDownArrow,
      onClick: handleDropDownClick,
      id: 'signed-in-dropdown'
    }), isMobile && /*#__PURE__*/React.createElement(SwipeableDrawer, {
      variant: "persistent",
      anchor: 'left',
      open: open,
      classes: {
        paper: classes.myAccountDrawer
      },
      onClose: function onClose() {},
      onOpen: function onOpen() {}
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "column",
      spacing: 1,
      className: classes.myAccountDrawer
    }, /*#__PURE__*/React.createElement(Grid$1, {
      container: true,
      direction: "column",
      spacing: 1,
      className: classes.myAccountDrawer
    }, isMobile && /*#__PURE__*/React.createElement(ArrowBack, {
      id: "close-account-drawer",
      "aria-label": "Close My Account",
      className: classnames(classes.accountLink, classes.arrowBack),
      onClick: handleDrawerToggle
    }), /*#__PURE__*/React.createElement(Typography, {
      className: classnames(classes.textStyleBold, classes.myAccountText)
    }, "My Account"), /*#__PURE__*/React.createElement(Typography, {
      className: classnames(classes.linkWrapper, classes.textStyle, classes.fullWidth)
    }, myAccountLinksMobile.map(function (element, index) {
      return /*#__PURE__*/React.createElement(Grid$1, {
        key: index,
        item: true,
        className: classes.linkWrapper
      }, accountLink(element));
    }))))), /*#__PURE__*/React.createElement(Popper, {
      id: menuId,
      open: menuOpen,
      anchorEl: anchorEl
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 8
    }, /*#__PURE__*/React.createElement(Box, {
      py: 1
    }, myAccountLinks.map(function (element) {
      return accountMenuItem(element);
    }))))));
  }

  function render(element) {
    if (element.type.includes('button')) {
      //Render the "Sign in" and "Sign up" buttons if not already logged in
      if (!loggedIn) return renderSignInRegister(element);
    } else if (element.type === 'ze-chat-launcher') {
      return renderZeChatLauncher(element);
    } else {
      return renderLink(element);
    }
  }

  return /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    className: classes.root,
    justify: "flex-end",
    wrap: "nowrap"
  }, topLinks.map(function (element, index) {
    return /*#__PURE__*/React.createElement(Grid$1, {
      key: index,
      item: true,
      className: classnames(classes.textFormat, element.type.includes('button') ? classes.textFormatSignInRegister : '', element.id === 'marketplace-trust-link' ? classes.hide740Down : '', element.id === 'ze-chat-launcher' ? classes.hide600Up : '')
    }, render(element));
  }), loggedIn && renderLoggedIn());
}

var useStyles$m = makeStyles(function (theme) {
  return {
    root: _defineProperty({
      alignItems: 'left',
      flexDirection: 'row',
      flexWrap: 'wrap',
      overflow: 'hidden'
    }, theme.breakpoints.up('sm'), {
      alignItems: 'center',
      flexWrap: 'nowrap'
    }),
    textFormat: _defineProperty(_defineProperty({
      fontSize: '1rem',
      flex: '0 0 100%',
      padding: '0 2rem 1.5rem 2rem'
    }, theme.breakpoints.up('sm'), {
      padding: '0 0.8rem',
      flex: '0 1 auto'
    }), theme.breakpoints.up('md'), {
      padding: '0 1.5rem'
    }),
    textFormatSignInRegister: _defineProperty({
      flex: '0 0 50%',
      marginTop: 20,
      padding: '0 1.5rem 1rem'
    }, theme.breakpoints.up('sm'), {
      marginTop: 0,
      padding: '0 0 0 1rem',
      flex: '0 0 auto'
    }),
    link: _defineProperty({
      color: theme.header.upperSection.textColor,
      cursor: 'pointer',
      fontSize: '0.875rem',
      opacity: 0.8,
      '&:hover': {
        color: theme.header.lowerSection.activeLinkHighlight,
        opacity: 1
      }
    }, theme.breakpoints.only('sm'), {
      fontSize: theme.header.fontSizeSmall
    }),
    linkSignIn: _defineProperty(_defineProperty({
      color: theme.header.upperSection.buttonColor,
      backgroundColor: theme.header.upperSection.textColor,
      opacity: 1
    }, theme.breakpoints.up('sm'), {
      marginLeft: 10,
      color: theme.header.upperSection.textColor,
      backgroundColor: theme.palette.primary.main,
      fontWeight: 'bold'
    }), theme.breakpoints.up('md'), {
      marginLeft: 30
    }),
    linkRegister: {
      marginRight: 0
    },
    button: {
      backgroundColor: theme.header.upperSection.buttonColor,
      width: '100%',
      '&:hover': {
        backgroundColor: theme.header.upperSection.buttonHover
      }
    },
    buttonText: _defineProperty({
      color: theme.header.upperSection.textColor,
      fontSize: theme.header.fontSize
    }, theme.breakpoints.only('sm'), {
      fontSize: theme.header.fontSizeSmall
    }),
    signedIn: {
      display: 'flex',
      alignItems: 'center'
    },
    avatar: {
      marginRight: '.5rem',
      backgroundColor: theme.header.lowerSection.activeLinkBackground,
      cursor: 'pointer'
    },
    username: {
      textTransform: 'none'
    },
    dropDownButton: _defineProperty(_defineProperty({}, theme.breakpoints.down(770), {
      display: 'none'
    }), theme.breakpoints.down('xs'), {
      display: 'flex'
    }),
    dropDownArrow: _defineProperty(_defineProperty({
      cursor: 'pointer',
      color: theme.header.upperSection.textColor
    }, theme.breakpoints.down(770), {
      display: 'none'
    }), theme.breakpoints.down('xs'), {
      display: 'flex'
    }),
    myAccountDrawer: _defineProperty(_defineProperty({
      backgroundColor: theme.palette.primary.main,
      fontSize: theme.header.fontSize,
      color: theme.textColor,
      flexShrink: 0
    }, theme.breakpoints.up('sm'), {
      marginTop: '9rem',
      height: '30rem'
    }), "width", '90%'),
    accountLink: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: '0.45rem 2rem',
      fontSize: theme.header.fontSize,
      color: theme.header.lowerSection.categoryTextColor,
      cursor: 'pointer',
      marginLeft: '2rem'
    },
    linkWrapper: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column'
    },
    textStyleBold: _defineProperty(_defineProperty({
      alignItems: 'flex-start',
      fontWeight: '700',
      color: theme.header.lowerSection.categoryTextColor
    }, theme.breakpoints.up('sm'), {
      padding: '1rem',
      color: theme.header.lowerSection.textColor
    }), theme.breakpoints.only('sm'), {
      fontSize: theme.header.fontSizeSmall
    }),
    myAccountText: {
      padding: '1rem 2rem 1rem 2rem'
    },
    textStyle: _defineProperty(_defineProperty({
      padding: '0.2rem 0',
      color: theme.header.lowerSection.categoryTextColor,
      alignSelf: 'center',
      fontSize: theme.header.fontSize,
      '&:hover': {
        color: grey[400],
        cursor: 'pointer'
      }
    }, theme.breakpoints.up('sm'), {
      padding: '1rem',
      color: theme.header.lowerSection.textColor
    }), theme.breakpoints.only('sm'), {
      fontSize: theme.header.fontSizeSmall
    }),
    fullWidth: {
      width: '100%'
    },
    arrowBack: {
      fontSize: '2rem',
      padding: '2rem 0rem 1rem 0rem'
    },
    signedInMobile: {
      marginRight: '9rem',
      marginBottom: '2rem',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    hide740Down: _defineProperty({}, theme.breakpoints.down(740), {
      display: 'none'
    }),
    hide600Up: _defineProperty({}, theme.breakpoints.up(600), {
      display: 'none'
    })
  };
});

function ProxibidLogoWhite(props) {
  var whiteFill = '{fill:#fff}';
  var width = 143;
  var height = 28;

  if (isWidthDown('md', props.width)) {
    width = 124;
    height = 25;
  }

  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.72 90"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1", whiteFill)), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,31.91q0-6.63,3.61-10.24t10.44-3.61H31.1q6.63,0,10.44,3.41t3.81,9.83v26a15.25,15.25,0,0,1-4,10.69,13,13,0,0,1-9.94,4.36H9V90H0Zm14.05,31.4H31.2a4.84,4.84,0,0,0,3.67-1.55,5.5,5.5,0,0,0,1.45-3.87V32.21q0-5.12-4.71-5.12H15.45Q9,27.09,9,32.61V57.09a7,7,0,0,0,1.4,4.41A4.37,4.37,0,0,0,14.05,63.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.09,32.41c0-4.82,1-8.36,3-10.74a9.4,9.4,0,0,1,4.22-2.86,18.42,18.42,0,0,1,6.12-.75h5.11v9.13H72.14q-5,0-5,5.42V72.34h-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.28,58.9V30.8a11.84,11.84,0,0,1,3.86-9.33Q92,18.06,98.73,18.06h16.55q6.52,0,10.49,3.46a11.71,11.71,0,0,1,4,9.28V59a12.46,12.46,0,0,1-4.11,9.53,14.64,14.64,0,0,1-10.34,3.81H98.73a14.83,14.83,0,0,1-10.39-3.71A12.56,12.56,0,0,1,84.28,58.9Zm15.45,4.41h14.55q6.42,0,6.42-6.82V33.61q0-6.52-6.42-6.52H99.73q-6.42,0-6.42,6.52V56.09c0,2.47.5,4.3,1.5,5.46S97.46,63.31,99.73,63.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155,44.38,136.65,18.06H148l12.34,18.19,12.54-18.19h11.22L165.82,44.38l19.47,28-11.11,0-14-20.19L146.56,72.32l-11.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.35,0a6.14,6.14,0,0,1,4.57,1.91,6.13,6.13,0,0,1,.05,8.73,5.86,5.86,0,0,1-4.42,1.9,6.12,6.12,0,0,1-4.31-1.8,5.87,5.87,0,0,1-1.91-4.42A6.26,6.26,0,0,1,192,1.76,5.74,5.74,0,0,1,196.35,0Zm-4.21,18.06h8.93V72.34h-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.91,18.06q7,0,10.84,3.51t3.81,10.24V58.09a14.06,14.06,0,0,1-3.91,10.24,12.83,12.83,0,0,1-9.53,4H227.36a12.32,12.32,0,0,1-9.48-4.41,15.63,15.63,0,0,1-4-10.84V0h9V18.06Zm-15,45.25h15.76a4.52,4.52,0,0,0,3.46-1.6,5.91,5.91,0,0,0,1.45-4.12V33.21q0-6.12-5.92-6.12H228.76q-5.82,0-5.82,5.92V56.79a7,7,0,0,0,1.56,4.67A5.38,5.38,0,0,0,228.86,63.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.52,0a6.13,6.13,0,0,1,4.56,1.91,6.11,6.11,0,0,1,.05,8.73,5.83,5.83,0,0,1-4.41,1.9,6.12,6.12,0,0,1-4.32-1.8,5.86,5.86,0,0,1-1.9-4.42,6.29,6.29,0,0,1,1.7-4.56A5.78,5.78,0,0,1,275.52,0ZM271.3,18.06h8.93V72.34H271.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.72,57.09a15.66,15.66,0,0,1-4,10.84,12.32,12.32,0,0,1-9.48,4.41H306.52a12.83,12.83,0,0,1-5.07-1.2,19.35,19.35,0,0,1-5.56-3.92c-1.88-1.8-2.81-4.84-2.81-9.13V31.81q0-6.52,3.76-10.14t10.88-3.61h21V0h9Zm-30.8,6.22h15.85A5.48,5.48,0,0,0,327,61.46a6.78,6.78,0,0,0,1.65-4.67V33q0-5.92-5.81-5.92H308q-5.92,0-5.92,6.12V57.59a6.12,6.12,0,0,0,1.4,4A4.29,4.29,0,0,0,306.92,63.31Z"
  }));
}

ProxibidLogoWhite.propTypes = {
  width: PropTypes__default.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired
};
var ProxibidLogoWhite$1 = withWidth()(ProxibidLogoWhite);

function ExternalLogo(props) {
  var width = 300;
  var height = 50;

  if (isWidthDown('sm', props.width)) {
    width = 195;
    height = 50;
  }

  return /*#__PURE__*/React.createElement("img", {
    width: width,
    height: height,
    src: props.source,
    alt: 'ExternalLogo'
  });
}

ExternalLogo.propTypes = {
  width: PropTypes__default.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired,
  source: PropTypes__default.string.isRequired
};
var ExternalLogo$1 = withWidth()(ExternalLogo);
var useStyles$n = makeStyles(function (theme) {
  return {
    iconFormat: {
      color: theme.header.upperSection.iconColor,
      cursor: 'pointer',
      padding: 15
    },
    drawerContainer: {
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      height: '100%',
      position: 'absolute'
    },
    drawerItem: {
      justifyContent: 'space-between',
      width: '100%'
    },
    drawerPaper: {
      backgroundColor: theme.palette.primary.main,
      width: '90%'
    },
    drawerLogoFormat: {
      padding: '1rem 2rem'
    }
  };
});

function Drawer(props) {
  var classes = useStyles$n();
  var logo = props.logo;
  return /*#__PURE__*/React.createElement(SwipeableDrawer, {
    variant: 'temporary',
    anchor: 'left',
    open: props.open,
    onClose: props.handleDrawerToggle,
    onOpen: props.handleDrawerToggle,
    classes: {
      paper: classes.drawerPaper
    },
    ModalProps: {
      keepMounted: true
    }
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    className: classes.drawerContainer,
    direction: "column",
    alignItems: "flex-start",
    justify: "space-between",
    wrap: "nowrap"
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    className: classes.drawerItem
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    className: classes.drawerLogoFormat
  }, logo), /*#__PURE__*/React.createElement(Grid$1, {
    item: true
  }, /*#__PURE__*/React.createElement(Close, {
    id: 'close-drawer',
    fontSize: 'large',
    className: classes.iconFormat,
    onClick: props.handleDrawerToggle
  })), /*#__PURE__*/React.createElement(NavLinks, {
    active: props.active || window.location.pathname
  })), /*#__PURE__*/React.createElement(Grid$1, {
    item: true
  }, /*#__PURE__*/React.createElement(SignInRegister, {
    dialogTitle: 'Buyer Sign In',
    clientProxy: props.clientProxy,
    handleDrawerToggle: props.handleDrawerToggle,
    captchaEnabled: props.captchaEnabled,
    captchaApiKey: props.captchaApiKey
  }))));
}

Drawer.propTypes = {
  active: string,
  open: bool.isRequired,
  clientProxy: string.isRequired,
  handleDrawerToggle: func.isRequired,
  logo: element.isRequired,
  captchaEnabled: bool.isRequired,
  captchaApiKey: string.isRequired
};

function Cache() {
  var _cache = Object.create(null);

  var _hitCount = 0;
  var _missCount = 0;
  var _size = 0;
  var _debug = false;

  this.put = function (key, value, time, timeoutCallback) {
    if (_debug) {
      console.log('caching: %s = %j (@%s)', key, value, time);
    }

    if (typeof time !== 'undefined' && (typeof time !== 'number' || isNaN(time) || time <= 0)) {
      throw new Error('Cache timeout must be a positive number');
    } else if (typeof timeoutCallback !== 'undefined' && typeof timeoutCallback !== 'function') {
      throw new Error('Cache timeout callback must be a function');
    }

    var oldRecord = _cache[key];

    if (oldRecord) {
      clearTimeout(oldRecord.timeout);
    } else {
      _size++;
    }

    var record = {
      value: value,
      expire: time + Date.now()
    };

    if (!isNaN(record.expire)) {
      record.timeout = setTimeout(function () {
        _del(key);

        if (timeoutCallback) {
          timeoutCallback(key, value);
        }
      }.bind(this), time);
    }

    _cache[key] = record;
    return value;
  };

  this.del = function (key) {
    var canDelete = true;
    var oldRecord = _cache[key];

    if (oldRecord) {
      clearTimeout(oldRecord.timeout);

      if (!isNaN(oldRecord.expire) && oldRecord.expire < Date.now()) {
        canDelete = false;
      }
    } else {
      canDelete = false;
    }

    if (canDelete) {
      _del(key);
    }

    return canDelete;
  };

  function _del(key) {
    _size--;
    delete _cache[key];
  }

  this.clear = function () {
    for (var key in _cache) {
      clearTimeout(_cache[key].timeout);
    }

    _size = 0;
    _cache = Object.create(null);

    if (_debug) {
      _hitCount = 0;
      _missCount = 0;
    }
  };

  this.get = function (key) {
    var data = _cache[key];

    if (typeof data != "undefined") {
      if (isNaN(data.expire) || data.expire >= Date.now()) {
        if (_debug) _hitCount++;
        return data.value;
      } else {
        // free some space
        if (_debug) _missCount++;
        _size--;
        delete _cache[key];
      }
    } else if (_debug) {
      _missCount++;
    }

    return null;
  };

  this.size = function () {
    return _size;
  };

  this.memsize = function () {
    var size = 0,
        key;

    for (key in _cache) {
      size++;
    }

    return size;
  };

  this.debug = function (bool) {
    _debug = bool;
  };

  this.hits = function () {
    return _hitCount;
  };

  this.misses = function () {
    return _missCount;
  };

  this.keys = function () {
    return Object.keys(_cache);
  };

  this.exportJson = function () {
    var plainJsCache = {}; // Discard the `timeout` property.
    // Note: JSON doesn't support `NaN`, so convert it to `'NaN'`.

    for (var key in _cache) {
      var record = _cache[key];
      plainJsCache[key] = {
        value: record.value,
        expire: record.expire || 'NaN'
      };
    }

    return JSON.stringify(plainJsCache);
  };

  this.importJson = function (jsonToImport, options) {
    var cacheToImport = JSON.parse(jsonToImport);
    var currTime = Date.now();
    var skipDuplicates = options && options.skipDuplicates;

    for (var key in cacheToImport) {
      if (cacheToImport.hasOwnProperty(key)) {
        if (skipDuplicates) {
          var existingRecord = _cache[key];

          if (existingRecord) {
            if (_debug) {
              console.log('Skipping duplicate imported key \'%s\'', key);
            }

            continue;
          }
        }

        var record = cacheToImport[key]; // record.expire could be `'NaN'` if no expiry was set.
        // Try to subtract from it; a string minus a number is `NaN`, which is perfectly fine here.

        var remainingTime = record.expire - currTime;

        if (remainingTime <= 0) {
          // Delete any record that might exist with the same key, since this key is expired.
          this.del(key);
          continue;
        } // Remaining time must now be either positive or `NaN`,
        // but `put` will throw an error if we try to give it `NaN`.


        remainingTime = remainingTime > 0 ? remainingTime : undefined;
        this.put(key, record.value, remainingTime);
      }
    }

    return this.size();
  };
}

var memoryCache = new Cache();
var Cache_1 = Cache;
memoryCache.Cache = Cache_1;
var MAX_AGE = 5000;
var TIMEOUT$2 = 30000;

var clientProxyAPI = function clientProxyAPI(apiClientProxyURL, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var url = "".concat(apiClientProxyURL).concat(!params ? '' : "?".concat(lib.stringify(params)));
  var request = memoryCache.get(url);

  if (!request) {
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'data': {}
    };
    request = axios$1.get(url, {
      timeout: options.timeout || TIMEOUT$2,
      headers: headers,
      data: {}
    });
    memoryCache.put(url, request, MAX_AGE);
  }

  return request;
};

var useStyles$o = makeStyles$1(function (theme) {
  return {
    searchBox: {
      display: 'flex',
      color: theme.textColor[900]
    },
    termMenuItemText: {
      fontWeight: '600'
    },
    suggestionMenuItemText: {
      marginLeft: 10
    },
    results: {
      zIndex: 1500
    }
  };
});

function HomeSearch(props) {
  var cookieSearch = getCookieValue('search');
  var cookieSort = cookieSearch ? cookieSearch.split('&')[0] : undefined;
  var cookieView = cookieSearch ? cookieSearch.split('&')[1] : undefined;
  var cookieLength = cookieSearch ? cookieSearch.split('&')[2] : undefined;
  var initialValue = lib.parse(window.location.search.replace('?', '')).searchTerm || '';
  var sort = lib.parse(window.location.hash.replace('#', '')).sort || cookieSort || 'relevance';
  var view = lib.parse(window.location.hash.replace('#', '')).view || cookieView || 'gallery';
  var length = lib.parse(window.location.hash.replace('#', '')).length || cookieLength || '25';
  var defaultCategory = 'all categories';
  var classes = useStyles$o();
  var theme = useTheme$1();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = React.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      inputValue = _React$useState4[0],
      setInputValue = _React$useState4[1];

  var _React$useState5 = React.useState([]),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      suggestions = _React$useState6[0],
      setSuggestions = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      isOpen = _React$useState8[0],
      setOpen = _React$useState8[1];

  var customStyles = {
    searchInput: {
      fontSize: theme.searchField.fontSize,
      color: theme.searchField.textColor,
      backgroundColor: grey[300],
      borderRadius: 4,
      justifyContent: 'space-between'
    },
    searchButton: {
      fontSize: theme.searchField.icon.fontSize,
      color: theme.searchField.icon.color
    }
  };

  var callAutoSuggestionAPI = function callAutoSuggestionAPI(value) {
    setInputValue(value);
  };

  var debounceAutoSuggestionAPI = React.useCallback(lodash_debounce(callAutoSuggestionAPI, 50), []);
  React.useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(inputValue.length >= 3)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 3;
                return clientProxyAPI(props.autoSuggestionAPIUrl, {
                  term: inputValue
                });

              case 3:
                result = _context.sent;
                setSuggestions(result.data);
                setOpen(true);
                _context.next = 9;
                break;

              case 8:
                setOpen(false);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData().then(function (r) {
      return r;
    });
  }, [inputValue]);

  var handleChange = function handleChange(event) {
    setAnchorEl(event.currentTarget.parentNode);
    debounceAutoSuggestionAPI(event.target.value);
  };

  var handleClose = function handleClose(event) {
    if (anchorEl && anchorEl.current && anchorEl.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  var search = function search(term, category) {
    if (!term.trim()) {
      return;
    }

    var searchTerm = term.replace(/&/g, '%26').replace(/ /g, '+').replace(/,/g, '%2C');
    var searchQuery = "".concat(props.searchPageUrl) + "?searchTerm=".concat(searchTerm) + "&category=".concat(encodeURIComponent(defaultCategory)) + "&timestamp=".concat(Date.now()) + "#searchid=0&type=lot&search=".concat(searchTerm, "&sort=").concat(sort, "&view=").concat(view, "&length=").concat(length);

    if (category && category.toLowerCase() !== defaultCategory) {
      var refinedCategory = category.replace(/&/g, '%26').replace(/ /g, '+').replace(/,/g, '%2C');
      searchQuery = searchQuery + "&refine=Category|".concat(refinedCategory);
    }

    searchQuery = searchQuery + '&start=1';
    window.location = searchQuery;
  };

  var handleSearchKeyDown = function handleSearchKeyDown(event) {
    if (event.key === 'Enter') {
      search(inputValue);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.searchBox
  }, /*#__PURE__*/React.createElement(SearchField, {
    id: "search-marketplace",
    inputStyles: customStyles.searchInput,
    buttonStyles: customStyles.searchButton,
    placeholder: "Search Marketplace",
    autoComplete: 'off',
    type: "text",
    variant: "filled",
    disableUnderline: true,
    onChange: handleChange,
    clickHandler: function clickHandler() {
      return search(inputValue);
    },
    defaultValue: initialValue,
    onKeyDown: handleSearchKeyDown
  }), /*#__PURE__*/React.createElement(Popper, {
    open: isOpen,
    anchorEl: anchorEl,
    id: "search-suggestion-menu",
    className: classes.results,
    modifiers: {
      flip: {
        enabled: false
      },
      preventOverflow: {
        enabled: true,
        boundariesElement: 'undefined'
      }
    }
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement(Paper, {
    square: true,
    style: {
      marginTop: 5,
      width: anchorEl ? anchorEl.clientWidth : undefined
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "".concat(inputValue, "-term"),
    onClick: function onClick() {
      return search(inputValue);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.termMenuItemText
  }, " ", inputValue, " ")), suggestions.map(function (suggestion, key) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: "".concat(key, "-key"),
      onClick: function onClick() {
        return search(inputValue, suggestion.categoryPath);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.suggestionMenuItemText
    }, " ", suggestion.label, " "));
  })))));
}

HomeSearch.propTypes = {
  searchPageUrl: string.isRequired,
  autoSuggestionAPIUrl: string.isRequired
};

function verificationCodeNeverSent(emailVerificationCode) {
  return emailVerificationCode === '0000000000000000';
}

function expiredVerificationCode(emailVerificationCode) {
  var emailVerificationCodeAsMoment = moment(emailVerificationCode, 'YYYYMMDDHHmm');
  return moment().isAfter(emailVerificationCodeAsMoment);
}

var EVENT_IDENTITY_SHOW_PHONE_NUMBER_UNVERIFIED = '@identity-event/EVENT_IDENTITY_SHOW_PHONE_NUMBER_UNVERIFIED';
var EVENT_IDENTITY_SHOW_EMAIL_UNVERIFIED = '@identity-event/EVENT_IDENTITY_SHOW_EMAIL_UNVERIFIED';
var EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_NOT_SENT = '@identity-event/EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_NOT_SENT';
var EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_EXPIRED = '@identity-event/EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_EXPIRED';
var EVENT_IDENTITY_PROFILE_COMPLETE = '@identity-event/EVENT_IDENTITY_PROFILE_COMPLETE';
var EVENT_IDENTITY_SHOW_USER_WAS_ROUTED = '@identity-event/EVENT_IDENTITY_SHOW_USER_WAS_ROUTED';
var EVENT_IDENTITY_UPDATE_SUCCESS = '@identity-event/EVENT_IDENTITY_UPDATE_SUCCESS';
var EVENT_IDENTITY_UPDATE_FAILED = '@identity-event/EVENT_IDENTITY_UPDATE_FAILED';
var EVENT_IDENTITY_SHOW_BIDDER_STATUS = '@identity-event/EVENT_IDENTITY_SHOW_BIDDER_STATUS';
var EventIdentity = {
  EVENT_IDENTITY_SHOW_EMAIL_UNVERIFIED: EVENT_IDENTITY_SHOW_EMAIL_UNVERIFIED,
  EVENT_IDENTITY_PROFILE_COMPLETE: EVENT_IDENTITY_PROFILE_COMPLETE,
  EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_NOT_SENT: EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_NOT_SENT,
  EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_EXPIRED: EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_EXPIRED,
  EVENT_IDENTITY_SHOW_PHONE_NUMBER_UNVERIFIED: EVENT_IDENTITY_SHOW_PHONE_NUMBER_UNVERIFIED,
  EVENT_IDENTITY_SHOW_USER_WAS_ROUTED: EVENT_IDENTITY_SHOW_USER_WAS_ROUTED,
  EVENT_IDENTITY_UPDATE_SUCCESS: EVENT_IDENTITY_UPDATE_SUCCESS,
  EVENT_IDENTITY_UPDATE_FAILED: EVENT_IDENTITY_UPDATE_FAILED,
  EVENT_IDENTITY_SHOW_BIDDER_STATUS: EVENT_IDENTITY_SHOW_BIDDER_STATUS
};
EmailUnverified.propTypes = {
  emailAddress: string.isRequired,
  sendEmail: func.isRequired
};

function EmailUnverified(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasSentEmail = _useState2[0],
      setHasSentEmail = _useState2[1];

  var reSendEmailVerificationEmail = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return props.sendEmail();

            case 2:
              setHasSentEmail(true);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function reSendEmailVerificationEmail() {
      return _ref.apply(this, arguments);
    };
  }();

  if (hasSentEmail) {
    return /*#__PURE__*/React.createElement(Message, {
      dataDescription: 'email-unverified-sent',
      variant: 'warning'
    }, "Email sent. Your account is not yet activated. Please check your email (", props.emailAddress, ") and click the link within to activate your account.");
  }

  return /*#__PURE__*/React.createElement(Message, {
    dataDescription: 'email-unverified',
    variant: 'warning',
    action: 'Re-Send Email',
    onActionClick: reSendEmailVerificationEmail
  }, "Your account is not yet activated. Please check your email (", props.emailAddress, ") and click the link within to activate your account.");
}

ProfileIncomplete.propTypes = {
  profileUpdateLocation: string.isRequired
};

function ProfileIncomplete(props) {
  return /*#__PURE__*/React.createElement(Message, {
    variant: 'warning'
  }, "Your profile is not complete. Please ", /*#__PURE__*/React.createElement(Link$1, {
    href: props.profileUpdateLocation
  }, "update your profile"), " to begin bidding.");
}

EmailVerificationCodeExpired.propTypes = {
  emailAddress: string.isRequired,
  sendEmail: func.isRequired
};

function EmailVerificationCodeExpired(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasSentEmail = _useState2[0],
      setHasSentEmail = _useState2[1];

  var reSendEmailVerificationEmail = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return props.sendEmail();

            case 2:
              setHasSentEmail(true);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function reSendEmailVerificationEmail() {
      return _ref.apply(this, arguments);
    };
  }();

  if (hasSentEmail) {
    return /*#__PURE__*/React.createElement(Message, {
      dataDescription: 'email-verification-code-expired-sent',
      variant: 'error'
    }, "Email sent. Your account is not yet activated. Please check your email (", props.emailAddress, ") and click the link within to activate your account.");
  }

  return /*#__PURE__*/React.createElement(Message, {
    dataDescription: 'email-verification-code-expired',
    variant: 'error',
    action: 'Re-Send Email',
    onActionClick: reSendEmailVerificationEmail
  }, "Your account is not yet activated. It has been past 7 days since you updated your email address without successful verification.");
}

EmailVerificationNotSent.propTypes = {
  emailAddress: string.isRequired,
  sendEmail: func.isRequired
};

function EmailVerificationNotSent(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasSentEmail = _useState2[0],
      setHasSentEmail = _useState2[1];

  var reSendEmailVerificationEmail = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return props.sendEmail();

            case 2:
              setHasSentEmail(true);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function reSendEmailVerificationEmail() {
      return _ref.apply(this, arguments);
    };
  }();

  if (hasSentEmail) {
    return /*#__PURE__*/React.createElement(Message, {
      dataDescription: 'email-verification-not-sent-sent',
      variant: 'error'
    }, "Email sent. Your account is not yet activated. Please check your email (", props.emailAddress, ") and click the link within to activate your account.");
  }

  return /*#__PURE__*/React.createElement(Message, {
    dataDescription: 'email-verification-not-sent',
    variant: 'error',
    action: 'Re-Send Email',
    onActionClick: reSendEmailVerificationEmail
  }, "Your account is not yet activated. The original email validation may have failed.");
}

PhoneNumberUnverified.propTypes = {
  verifyPhoneNumber: func.isRequired
};

function PhoneNumberUnverified(props) {
  return /*#__PURE__*/React.createElement(Message, {
    dataDescription: 'phone-number-unverified',
    variant: 'info',
    action: 'Verify Phone Number',
    onActionClick: props.verifyPhoneNumber
  }, "Help us protect your account. For a higher level of security, please verify your mobile phone number.");
}

UserRouted.propTypes = {
  userRoutedFromUrl: string.isRequired,
  onActionClick: func.isRequired
};

function UserRouted(props) {
  return /*#__PURE__*/React.createElement(Message, {
    dataDescription: 'user-routed',
    variant: 'info',
    action: 'OK',
    onActionClick: props.onActionClick
  }, "You have been redirected to this tab from ", /*#__PURE__*/React.createElement(Link, {
    style: {
      color: 'white',
      textDecoration: 'underline'
    },
    href: props.userRoutedFromUrl
  }, props.userRoutedFromUrl), ".");
}

BidderStatus.propTypes = {
  bidderStatus: string.isRequired,
  contactSupportUrl: string.isRequired
};

function convertStatusCode(statusCode, supportUrl) {
  if (statusCode === 'BLACK_FLAG') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "Your account has been black flagged. Please ", /*#__PURE__*/React.createElement(Link, {
      style: {
        color: 'white',
        textDecoration: 'underline'
      },
      href: supportUrl,
      target: "_blank"
    }, "contact Proxibid"), ".");
  }
}

function BidderStatus(props) {
  return /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, convertStatusCode(props.bidderStatus, props.contactSupportUrl));
}

function _objectWithoutPropertiesLoose$4(r, e) {
  if (null == r) return {};
  var t = {};

  for (var n in r) {
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n)) continue;
      t[n] = r[n];
    }
  }

  return t;
}

function _objectWithoutProperties$1(e, t) {
  if (null == e) return {};

  var o,
      r,
      i = _objectWithoutPropertiesLoose$4(e, t);

  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);

    for (r = 0; r < s.length; r++) {
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
  }

  return i;
}

function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  }, _extends$4.apply(null, arguments);
}

function r$1(e) {
  var t,
      f,
      n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) {
    e[t] && (f = r$1(e[t])) && (n && (n += " "), n += f);
  } else for (t in e) {
    e[t] && (n && (n += " "), n += t);
  }
  return n;
}

function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) {
    (e = arguments[f++]) && (t = r$1(e)) && (n && (n += " "), n += t);
  }

  return n;
}

function createSvgIcon(path, displayName) {
  var Component = React.memo(React.forwardRef(function (props, ref) {
    return React.createElement(SvgIcon, _extends$4({
      ref: ref
    }, props), path);
  }));

  if (process.env.NODE_ENV !== 'production') {
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = SvgIcon.muiName;
  return Component;
}
/**
 * @ignore - internal component.
 */


var SuccessOutlinedIcon = createSvgIcon(React.createElement("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');
/**
 * @ignore - internal component.
 */

var ReportProblemOutlinedIcon = createSvgIcon(React.createElement("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');
/**
 * @ignore - internal component.
 */

var ErrorOutlineIcon = createSvgIcon(React.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');
/**
 * @ignore - internal component.
 */

var InfoOutlinedIcon = createSvgIcon(React.createElement("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');
/**
 * @ignore - internal component.
 */

var CloseIcon = createSvgIcon(React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var styles$4 = function styles(theme) {
  var getColor = theme.palette.type === 'light' ? darken : lighten;
  var getBackgroundColor = theme.palette.type === 'light' ? lighten : darken;
  return {
    /* Styles applied to the root element. */
    root: _extends$4({}, theme.typography.body2, {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: 'transparent',
      display: 'flex',
      padding: '6px 16px'
    }),

    /* Styles applied to the root element if `variant="standard"` and `color="success"`. */
    standardSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
      '& $icon': {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="info"`. */
    standardInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
      '& $icon': {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */
    standardWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
      '& $icon': {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="error"`. */
    standardError: {
      color: getColor(theme.palette.error.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
      '& $icon': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */
    outlinedSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      border: "1px solid ".concat(theme.palette.success.main),
      '& $icon': {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */
    outlinedInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      border: "1px solid ".concat(theme.palette.info.main),
      '& $icon': {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
    outlinedWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      border: "1px solid ".concat(theme.palette.warning.main),
      '& $icon': {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */
    outlinedError: {
      color: getColor(theme.palette.error.main, 0.6),
      border: "1px solid ".concat(theme.palette.error.main),
      '& $icon': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="filled"` and `color="success"`. */
    filledSuccess: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.success.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="info"`. */
    filledInfo: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.info.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */
    filledWarning: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.warning.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="error"`. */
    filledError: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.error.main
    },

    /* Styles applied to the icon wrapper element. */
    icon: {
      marginRight: 12,
      padding: '7px 0',
      display: 'flex',
      fontSize: 22,
      opacity: 0.9
    },

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};

var defaultIconMapping = {
  success: React.createElement(SuccessOutlinedIcon, {
    fontSize: "inherit"
  }),
  warning: React.createElement(ReportProblemOutlinedIcon, {
    fontSize: "inherit"
  }),
  error: React.createElement(ErrorOutlineIcon, {
    fontSize: "inherit"
  }),
  info: React.createElement(InfoOutlinedIcon, {
    fontSize: "inherit"
  })
};

var _ref = React.createElement(CloseIcon, {
  fontSize: "small"
});

var Alert = React.forwardRef(function Alert(props, ref) {
  var action = props.action,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
      color = props.color,
      icon = props.icon,
      _props$iconMapping = props.iconMapping,
      iconMapping = _props$iconMapping === void 0 ? defaultIconMapping : _props$iconMapping,
      onClose = props.onClose,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      _props$severity = props.severity,
      severity = _props$severity === void 0 ? 'success' : _props$severity,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties$1(props, ["action", "children", "classes", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"]);

  return React.createElement(Paper, _extends$4({
    role: role,
    square: true,
    elevation: 0,
    className: clsx(classes.root, classes["".concat(variant).concat(capitalize(color || severity))], className),
    ref: ref
  }, other), icon !== false ? React.createElement("div", {
    className: classes.icon
  }, icon || iconMapping[severity] || defaultIconMapping[severity]) : null, React.createElement("div", {
    className: classes.message
  }, children), action != null ? React.createElement("div", {
    className: classes.action
  }, action) : null, action == null && onClose ? React.createElement("div", {
    className: classes.action
  }, React.createElement(IconButton, {
    size: "small",
    "aria-label": closeText,
    title: closeText,
    color: "inherit",
    onClick: onClose
  }, _ref)) : null);
});
process.env.NODE_ENV !== "production" ? Alert.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: PropTypes__default.node,

  /**
   * The content of the component.
   */
  children: PropTypes__default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes__default.object,

  /**
   * @ignore
   */
  className: PropTypes__default.string,

  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes__default.string,

  /**
   * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
   */
  color: PropTypes__default.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   */
  icon: PropTypes__default.node,

  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: PropTypes__default.shape({
    error: PropTypes__default.node,
    info: PropTypes__default.node,
    success: PropTypes__default.node,
    warning: PropTypes__default.node
  }),

  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes__default.func,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes__default.string,

  /**
   * The severity of the alert. This defines the color and icon used.
   */
  severity: PropTypes__default.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * The variant to use.
   */
  variant: PropTypes__default.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var Alert$1 = withStyles(styles$4, {
  name: 'MuiAlert'
})(Alert);

function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);

  for (var e = 0, n = Array(a); e < a; e++) {
    n[e] = r[e];
  }

  return n;
}

function _arrayWithoutHoles$1(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$1(r);
}

function _iterableToArray$1(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$1(r) {
  return _arrayWithoutHoles$1(r) || _iterableToArray$1(r) || _unsupportedIterableToArray$1(r) || _nonIterableSpread$1();
}

function _arrayWithHoles$1(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit$1(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$1(r, e) {
  return _arrayWithHoles$1(r) || _iterableToArrayLimit$1(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest$1();
}

function usePagination() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _props$boundaryCount = props.boundaryCount,
      boundaryCountProp = _props$boundaryCount === void 0 ? 1 : _props$boundaryCount,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'usePagination' : _props$componentName,
      _props$count = props.count,
      count = _props$count === void 0 ? 1 : _props$count,
      _props$defaultPage = props.defaultPage,
      defaultPage = _props$defaultPage === void 0 ? 1 : _props$defaultPage,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$hideNextButton = props.hideNextButton,
      hideNextButton = _props$hideNextButton === void 0 ? false : _props$hideNextButton,
      _props$hidePrevButton = props.hidePrevButton,
      hidePrevButton = _props$hidePrevButton === void 0 ? false : _props$hidePrevButton,
      handleChange = props.onChange,
      pageProp = props.page,
      _props$showFirstButto = props.showFirstButton,
      showFirstButton = _props$showFirstButto === void 0 ? false : _props$showFirstButto,
      _props$showLastButton = props.showLastButton,
      showLastButton = _props$showLastButton === void 0 ? false : _props$showLastButton,
      _props$siblingCount = props.siblingCount,
      siblingCount = _props$siblingCount === void 0 ? 1 : _props$siblingCount,
      other = _objectWithoutProperties$1(props, ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"]); // TODO: Update all formulae to remove this adjustment


  var boundaryCount = boundaryCountProp - 1;

  var _useControlled = useControlled({
    controlled: pageProp,
    default: defaultPage,
    name: componentName
  }),
      _useControlled2 = _slicedToArray$1(_useControlled, 2),
      page = _useControlled2[0],
      setPageState = _useControlled2[1];

  var handleClick = function handleClick(event, value) {
    if (!pageProp) {
      setPageState(value);
    }

    if (handleChange) {
      handleChange(event, value);
    }
  }; // https://dev.to/namirsab/comment/2050


  var range = function range(start, end) {
    var length = end - start + 1;
    return Array.from({
      length: length
    }, function (_, i) {
      return start + i;
    });
  };

  var startPages = range(1, Math.min(boundaryCount + 1, count));
  var endPages = range(Math.max(count - boundaryCount, boundaryCount + 2), count);
  var siblingsStart = Math.max(Math.min( // Natural start
  page - siblingCount, // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 2), // Greater than startPages
  boundaryCount + 3);
  var siblingsEnd = Math.min(Math.max( // Natural end
  page + siblingCount, // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 3), // Less than endPages
  endPages[0] - 2); // Basic list of items to render
  // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']

  var itemList = [].concat(_toConsumableArray$1(showFirstButton ? ['first'] : []), _toConsumableArray$1(hidePrevButton ? [] : ['previous']), _toConsumableArray$1(startPages), _toConsumableArray$1(siblingsStart > boundaryCount + 3 ? ['start-ellipsis'] : 2 + boundaryCount < count - boundaryCount - 1 ? [2 + boundaryCount] : []), _toConsumableArray$1(range(siblingsStart, siblingsEnd)), _toConsumableArray$1(siblingsEnd < count - boundaryCount - 2 ? ['end-ellipsis'] : count - boundaryCount - 1 > boundaryCount + 1 ? [count - boundaryCount - 1] : []), _toConsumableArray$1(endPages), _toConsumableArray$1(hideNextButton ? [] : ['next']), _toConsumableArray$1(showLastButton ? ['last'] : [])); // Map the button type to its page number

  var buttonPage = function buttonPage(type) {
    switch (type) {
      case 'first':
        return 1;

      case 'previous':
        return page - 1;

      case 'next':
        return page + 1;

      case 'last':
        return count;

      default:
        return null;
    }
  }; // Convert the basic item list to PaginationItem props objects


  var items = itemList.map(function (item) {
    return typeof item === 'number' ? {
      onClick: function onClick(event) {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled: disabled,
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: function onClick(event) {
        handleClick(event, buttonPage(item));
      },
      type: item,
      page: buttonPage(item),
      selected: false,
      disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
    };
  });
  return _extends$4({
    items: items
  }, other);
}
/**
 * @ignore - internal component.
 */


var FirstPageIcon = createSvgIcon(React.createElement("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');
/**
 * @ignore - internal component.
 */

var LastPageIcon = createSvgIcon(React.createElement("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');
/**
 * @ignore - internal component.
 */

var NavigateBeforeIcon = createSvgIcon(React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');
/**
 * @ignore - internal component.
 */

var NavigateNextIcon = createSvgIcon(React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

var styles$5 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$4({}, theme.typography.body2, {
      borderRadius: 32 / 2,
      textAlign: 'center',
      boxSizing: 'border-box',
      minWidth: 32,
      height: 32,
      padding: '0 6px',
      margin: '0 3px',
      color: theme.palette.text.primary
    }),

    /* Styles applied to the root element if `type="page"`. */
    page: {
      transition: theme.transitions.create(['color', 'background-color'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$focusVisible': {
        backgroundColor: theme.palette.action.focus
      },
      '&$selected': {
        backgroundColor: theme.palette.action.selected,
        '&:hover, &$focusVisible': {
          backgroundColor: fade(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          opacity: 1,
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.selected
        }
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Styles applied applied to the root element if `size="small"`. */
    sizeSmall: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: '0 1px',
      padding: '0 4px',
      '& $icon': {
        fontSize: theme.typography.pxToRem(18)
      }
    },

    /* Styles applied applied to the root element if `size="large"`. */
    sizeLarge: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: '0 10px',
      fontSize: theme.typography.pxToRem(15),
      '& $icon': {
        fontSize: theme.typography.pxToRem(22)
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      '&$selected': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover, &$focusVisible': {
          backgroundColor: theme.palette.primary.dark,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.primary.main
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      '&$selected': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
        '&:hover, &$focusVisible': {
          backgroundColor: theme.palette.secondary.dark,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.secondary.main
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `outlined="true"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$selected': {
        '&$disabled': {
          border: "1px solid ".concat(theme.palette.action.disabledBackground)
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      '&$selected': {
        color: theme.palette.primary.main,
        border: "1px solid ".concat(fade(theme.palette.primary.main, 0.5)),
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.activatedOpaciy),
        '&:hover, &$focusVisible': {
          backgroundColor: fade(theme.palette.primary.main, theme.palette.action.activatedOpaciy + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      '&$selected': {
        color: theme.palette.secondary.main,
        border: "1px solid ".concat(fade(theme.palette.secondary.main, 0.5)),
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.activatedOpaciy),
        '&:hover, &$focusVisible': {
          backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.activatedOpaciy + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `rounded="true"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `type="start-ellipsis"` or `type="end-ellipsis"`. */
    ellipsis: {
      height: 'auto',
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element if keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the icon element. */
    icon: {
      fontSize: theme.typography.pxToRem(20),
      margin: '0 -8px'
    }
  };
};

var PaginationItem = React.forwardRef(function PaginationItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color,
      component = props.component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      page = props.page,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'round' : _props$shape,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'page' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties$1(props, ["classes", "className", "color", "component", "disabled", "page", "selected", "shape", "size", "type", "variant"]);

  return type === 'start-ellipsis' || type === 'end-ellipsis' ? React.createElement("div", {
    ref: ref,
    className: clsx(classes.root, classes.ellipsis, disabled && classes.disabled, size !== 'medium' && classes["size".concat(capitalize(size))])
  }, "\u2026") : React.createElement(ButtonBase, _extends$4({
    ref: ref,
    component: component,
    disabled: disabled,
    focusVisibleClassName: classes.focusVisible,
    className: clsx(classes.root, classes.page, classes[variant], classes[shape], className, color !== 'standard' && classes["".concat(variant).concat(capitalize(color))], disabled && classes.disabled, selected && classes.selected, size !== 'medium' && classes["size".concat(capitalize(size))])
  }, other), type === 'page' && page, type === 'previous' && React.createElement(NavigateBeforeIcon, {
    className: classes.icon
  }), type === 'next' && React.createElement(NavigateNextIcon, {
    className: classes.icon
  }), type === 'first' && React.createElement(FirstPageIcon, {
    className: classes.icon
  }), type === 'last' && React.createElement(LastPageIcon, {
    className: classes.icon
  }));
});
process.env.NODE_ENV !== "production" ? PaginationItem.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes__default.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes__default.string,

  /**
   * The active color.
   */
  color: PropTypes__default.oneOf(['standard', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes__default.elementType,

  /**
   * If `true`, the item will be disabled.
   */
  disabled: PropTypes__default.bool,

  /**
   * The current page number.
   */
  page: PropTypes__default.number,

  /**
   * If `true` the pagination item is selected.
   */
  selected: PropTypes__default.bool,

  /**
   * The shape of the pagination item.
   */
  shape: PropTypes__default.oneOf(['round', 'rounded']),

  /**
   * The size of the pagination item.
   */
  size: PropTypes__default.oneOf(['small', 'medium', 'large']),

  /**
   * The type of pagination item.
   */
  type: PropTypes__default.oneOf(['page', 'first', 'last', 'next', 'previous', 'start-ellipsis', 'end-ellipsis']),

  /**
   * The pagination item variant.
   */
  variant: PropTypes__default.oneOf(['text', 'outlined'])
} : void 0;
var PaginationItem$1 = withStyles(styles$5, {
  name: 'MuiPaginationItem'
})(PaginationItem);
var styles$6 = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ul element. */
  ul: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  }
};

function defaultGetAriaLabel(type, page, selected) {
  if (type === 'page') {
    return "".concat(selected ? '' : 'Go to ', "page ").concat(page);
  }

  return "Go to ".concat(type, " page");
}

var Pagination = React.forwardRef(function Pagination(props, ref) {
  /* eslint-disable no-unused-vars */
  var _props$boundaryCount = props.boundaryCount,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color,
      _props$count = props.count,
      _props$defaultPage = props.defaultPage,
      _props$disabled = props.disabled,
      _props$getItemAriaLab = props.getItemAriaLabel,
      getAriaLabel = _props$getItemAriaLab === void 0 ? defaultGetAriaLabel : _props$getItemAriaLab,
      _props$hideNextButton = props.hideNextButton,
      _props$hidePrevButton = props.hidePrevButton,
      _props$renderItem = props.renderItem,
      renderItem = _props$renderItem === void 0 ? function (item) {
    return React.createElement(PaginationItem$1, item);
  } : _props$renderItem,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'round' : _props$shape,
      _props$showFirstButto = props.showFirstButton,
      _props$showLastButton = props.showLastButton,
      _props$siblingCount = props.siblingCount,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties$1(props, ["boundaryCount", "children", "classes", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"]);
  /* eslint-enable no-unused-vars */


  var _usePagination = usePagination(_extends$4({}, props, {
    componentName: 'Pagination'
  })),
      items = _usePagination.items;

  return React.createElement("nav", _extends$4({
    "aria-label": "pagination navigation",
    className: clsx(classes.root, className),
    ref: ref
  }, other), React.createElement("ul", {
    className: classes.ul
  }, children || items.map(function (item, index) {
    return React.createElement("li", {
      key: index
    }, renderItem(_extends$4({}, item, {
      color: color,
      'aria-label': getAriaLabel(item.type, item.page, item.selected),
      shape: shape,
      size: size,
      variant: variant
    })));
  })));
});
process.env.NODE_ENV !== "production" ? Pagination.propTypes = {
  /**
   * Number of always visible pages at the beginning and end.
   */
  boundaryCount: PropTypes__default.number,

  /**
   * Pagination items.
   */
  children: PropTypes__default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes__default.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes__default.string,

  /**
   * The active color.
   */
  color: PropTypes__default.oneOf(['default', 'primary', 'secondary']),

  /**
   * The total number of pages.
   */
  count: PropTypes__default.number,

  /**
   * The page selected by default when the component is uncontrolled.
   */
  defaultPage: PropTypes__default.number,

  /**
   * If `true`, all the pagination component will be disabled.
   */
  disabled: PropTypes__default.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   *
   * @param {string} [type = page] The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous').
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: PropTypes__default.func,

  /**
   * If `true`, hide the next-page button.
   */
  hideNextButton: PropTypes__default.bool,

  /**
   * If `true`, hide the previous-page button.
   */
  hidePrevButton: PropTypes__default.bool,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: PropTypes__default.func,

  /**
   * The current page.
   */
  page: PropTypes__default.number,

  /**
   * Render the item.
   *
   * @param {object} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   */
  renderItem: PropTypes__default.func,

  /**
   * The shape of the pagination items.
   */
  shape: PropTypes__default.oneOf(['round', 'rounded']),

  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: PropTypes__default.bool,

  /**
   * If `true`, show the last-page button.
   */
  showLastButton: PropTypes__default.bool,

  /**
   * Number of always visible pages before and after the current page.
   */
  siblingCount: PropTypes__default.number,

  /**
   * The size of the pagination component.
   */
  size: PropTypes__default.oneOf(['small', 'medium', 'large']),

  /**
   * The variant to use.
   */
  variant: PropTypes__default.oneOf(['text', 'outlined'])
} : void 0;
var Pagination$1 = withStyles(styles$6, {
  name: 'MuiPagination'
})(Pagination);
var YEAR_IN_DAYS = 365;
CookiesNotAccepted.propTypes = {
  privacyPolicyUrl: string.isRequired
};

function CookiesNotAccepted(props) {
  var _React$useState = React.useState(!getCookieValue('acceptedCookies') || false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  function writeCookie() {
    setCookie('acceptedCookies', true, YEAR_IN_DAYS * 2);
    setOpen(false);
  }

  return /*#__PURE__*/React.createElement(Collapse, {
    "in": open
  }, /*#__PURE__*/React.createElement(Alert$1, {
    "data-description": 'cookieMessage',
    severity: 'info',
    variant: 'standard',
    action: /*#__PURE__*/React.createElement(Button, {
      "data-description": 'cookieAccept',
      color: "inherit",
      size: "small",
      onClick: writeCookie
    }, "OK")
  }, "Our site uses cookies to optimize your experience. By continuing, you're providing your consent.", /*#__PURE__*/React.createElement(Link, {
    href: props.privacyPolicyUrl,
    target: "_blank"
  }, "View privacy policy")));
}

PersistedMessages.propTypes = {
  sendEmail: func.isRequired,
  profileUpdateLocation: string.isRequired,
  verifyPhoneNumber: func,
  contactSupportUrl: string.isRequired,
  privacyPolicyUrl: string.isRequired
};

function PersistedMessages(props) {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      unverifiedEmailAddress = _useState2[0],
      setUnverifiedEmailAddress = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showEmailNotVerifiedMessage = _useState4[0],
      setShowEmailNotVerifiedMessage = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showEmailVerificationCodeNotSentMessage = _useState6[0],
      setShowEmailVerificationCodeNotSentMessage = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showEmailVerificationExpiredMessage = _useState8[0],
      setShowEmailVerificationExpiredMessage = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showProfileIncompleteMessage = _useState10[0],
      setShowProfileIncompleteMessage = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showPhoneNumberNotVerifiedMessage = _useState12[0],
      setShowPhoneNumberNotVerifiedMessage = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showUserRoutedMessage = _useState14[0],
      setShowUserRoutedMessage = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showBidderStatusMessage = _useState16[0],
      setShowBidderStatusMessage = _useState16[1];

  var _useState17 = useState(''),
      _useState18 = _slicedToArray(_useState17, 2),
      bidderStatus = _useState18[0],
      setBidderStatus = _useState18[1];

  var _useState19 = useState(''),
      _useState20 = _slicedToArray(_useState19, 2),
      userRoutedFromUrl = _useState20[0],
      setUserRoutedFromUrl = _useState20[1];

  function handleEmailNotVerifiedEvent(event) {
    if (event && event.detail && event.detail.trim()) {
      setUnverifiedEmailAddress(event.detail);
      setShowEmailNotVerifiedMessage(true);
    } else {
      console.warn('Undefined, null, or empty email address provided.', event);
    }
  }

  function handleEmailVerificationCodeNotSentEvent(event) {
    if (event && event.detail && event.detail.trim()) {
      setUnverifiedEmailAddress(event.detail);
      setShowEmailVerificationCodeNotSentMessage(true);
    } else {
      console.warn('Undefined, null, or empty email address provided.', event);
    }
  }

  function handleEmailVerificationCodeExpiredEvent(event) {
    if (event && event.detail && event.detail.trim()) {
      setUnverifiedEmailAddress(event.detail);
      setShowEmailVerificationExpiredMessage(true);
    } else {
      console.warn('Undefined, null, or empty email address provided.', event);
    }
  }

  function handleProfileCompleteEvent(event) {
    setShowProfileIncompleteMessage(!(event !== null && event !== void 0 && event.detail));
  }

  function handlePhoneNumberNotVerifiedEvent() {
    setShowPhoneNumberNotVerifiedMessage(true);
  }

  function handleUserRoutedEvent(event) {
    if (event && event.detail && event.detail.trim()) {
      setUserRoutedFromUrl(event.detail);
      setShowUserRoutedMessage(true);
    }
  }

  function handleBidderStatusEvent(_x) {
    return _handleBidderStatusEvent.apply(this, arguments);
  }

  function _handleBidderStatusEvent() {
    _handleBidderStatusEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var _event$detail;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (event !== null && event !== void 0 && (_event$detail = event.detail) !== null && _event$detail !== void 0 && _event$detail.trim() && event.detail === 'BLACK_FLAG') {
                setBidderStatus(event.detail);
                setShowBidderStatusMessage(true);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleBidderStatusEvent.apply(this, arguments);
  }

  useEffect(function () {
    EventService.addEventListener(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_UNVERIFIED, handleEmailNotVerifiedEvent);
    EventService.addEventListener(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_NOT_SENT, handleEmailVerificationCodeNotSentEvent);
    EventService.addEventListener(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_EXPIRED, handleEmailVerificationCodeExpiredEvent);
    EventService.addEventListener(EventIdentity.EVENT_IDENTITY_SHOW_PHONE_NUMBER_UNVERIFIED, handlePhoneNumberNotVerifiedEvent);
    EventService.addEventListener(EventIdentity.EVENT_IDENTITY_PROFILE_COMPLETE, handleProfileCompleteEvent);
    EventService.addEventListener(EventIdentity.EVENT_IDENTITY_SHOW_USER_WAS_ROUTED, handleUserRoutedEvent);
    EventService.addEventListener(EventIdentity.EVENT_IDENTITY_SHOW_BIDDER_STATUS, handleBidderStatusEvent);
    return function () {
      EventService.removeEventListener(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_UNVERIFIED, handleEmailNotVerifiedEvent);
      EventService.removeEventListener(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_NOT_SENT, handleEmailVerificationCodeNotSentEvent);
      EventService.removeEventListener(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_EXPIRED, handleEmailVerificationCodeExpiredEvent);
      EventService.removeEventListener(EventIdentity.EVENT_IDENTITY_SHOW_PHONE_NUMBER_UNVERIFIED, handlePhoneNumberNotVerifiedEvent);
      EventService.removeEventListener(EventIdentity.EVENT_IDENTITY_PROFILE_COMPLETE, handleProfileCompleteEvent);
      EventService.removeEventListener(EventIdentity.EVENT_IDENTITY_SHOW_USER_WAS_ROUTED, handleUserRoutedEvent);
      EventService.removeEventListener(EventIdentity.EVENT_IDENTITY_SHOW_BIDDER_STATUS, handleBidderStatusEvent);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box$1, {
    p: .5
  }, /*#__PURE__*/React.createElement(CookiesNotAccepted, {
    privacyPolicyUrl: props.privacyPolicyUrl
  })), showEmailNotVerifiedMessage && /*#__PURE__*/React.createElement(Box$1, {
    p: .5
  }, /*#__PURE__*/React.createElement(EmailUnverified, {
    emailAddress: unverifiedEmailAddress,
    sendEmail: props.sendEmail
  })), !showEmailNotVerifiedMessage && showEmailVerificationExpiredMessage && /*#__PURE__*/React.createElement(Box$1, {
    p: .5
  }, /*#__PURE__*/React.createElement(EmailVerificationCodeExpired, {
    emailAddress: unverifiedEmailAddress,
    sendEmail: props.sendEmail
  })), !showEmailNotVerifiedMessage && showEmailVerificationCodeNotSentMessage && /*#__PURE__*/React.createElement(Box$1, {
    p: .5
  }, /*#__PURE__*/React.createElement(EmailVerificationNotSent, {
    emailAddress: unverifiedEmailAddress,
    sendEmail: props.sendEmail
  })), showProfileIncompleteMessage && /*#__PURE__*/React.createElement(Box$1, {
    p: .5
  }, /*#__PURE__*/React.createElement(ProfileIncomplete, {
    profileUpdateLocation: props.profileUpdateLocation
  })), props.verifyPhoneNumber && showPhoneNumberNotVerifiedMessage && /*#__PURE__*/React.createElement(Box$1, {
    p: .5
  }, /*#__PURE__*/React.createElement(PhoneNumberUnverified, {
    verifyPhoneNumber: props.verifyPhoneNumber
  })), showUserRoutedMessage && /*#__PURE__*/React.createElement(Box$1, {
    p: .5
  }, /*#__PURE__*/React.createElement(UserRouted, {
    userRoutedFromUrl: userRoutedFromUrl,
    onActionClick: function onActionClick() {
      return setShowUserRoutedMessage(false);
    }
  })), showBidderStatusMessage && /*#__PURE__*/React.createElement(Box$1, {
    p: .5
  }, /*#__PURE__*/React.createElement(BidderStatus, {
    bidderStatus: bidderStatus,
    contactSupportUrl: props.contactSupportUrl
  })));
}

PersistedMessagesManager.propTypes = {
  identity: shape({
    emailVerificationCode: string.isRequired,
    email: string.isRequired,
    profileComplete: bool.isRequired
  }).isRequired,
  profileUpdateLocation: string.isRequired,
  contactSupportUrl: string.isRequired,
  privacyPolicyUrl: string.isRequired,
  verifyPhoneNumber: func.isRequired,
  sendEmail: func.isRequired
};

function PersistedMessagesManager(props) {
  useEffect(function () {
    if (props.identity.emailVerificationCode) {
      if (verificationCodeNeverSent(props.identity.emailVerificationCode)) {
        EventService.dispatchEvent(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_NOT_SENT, props.identity.email);
      } else if (expiredVerificationCode(props.identity.emailVerificationCode)) {
        EventService.dispatchEvent(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_VERIFICATION_EXPIRED, props.identity.email);
      } else {
        EventService.dispatchEvent(EventIdentity.EVENT_IDENTITY_SHOW_EMAIL_UNVERIFIED, props.identity.email);
      }
    }

    EventService.dispatchEvent(EventIdentity.EVENT_IDENTITY_PROFILE_COMPLETE, props.identity.profileComplete);
  }, [props.identity]);
  useEffect(function () {
    var urlParams = new URLSearchParams(window.location.search);
    var userRoutedFromUrl = urlParams.get('userRoutedFromUrl');

    if (urlParams && userRoutedFromUrl) {
      EventService.dispatchEvent(EventIdentity.EVENT_IDENTITY_SHOW_USER_WAS_ROUTED, userRoutedFromUrl);
    }
  });
  return /*#__PURE__*/React.createElement(PersistedMessages, {
    sendEmail: props.sendEmail,
    profileUpdateLocation: props.profileUpdateLocation,
    verifyPhoneNumber: props.verifyPhoneNumber,
    contactSupportUrl: props.contactSupportUrl,
    privacyPolicyUrl: props.privacyPolicyUrl
  });
}

function ZendeskChat(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      zeLoaded = _useState2[0],
      setZeLoaded = _useState2[1];

  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.only('xs')); //Initial Zendesk Chat setup

  useEffect(function () {
    //Add <script> tag for Zendesk chat
    var zeScriptTag = document.createElement('script');
    zeScriptTag.src = 'https://static.zdassets.com/ekr/snippet.js?key=567717b4-efa9-4d39-b639-5caacb3e838a';
    zeScriptTag.id = 'ze-snippet';
    document.head.appendChild(zeScriptTag);

    zeScriptTag.onload = function () {
      //Hide chat by default - mobile-first design
      window['zE']('webWidget', 'hide'); //Hide chat on close when on mobile

      window['zE']('webWidget:on', 'close', function () {
        var mediaQuery = theme.breakpoints.only('xs').substring(7); //Cut off '@media ' for parsing

        if (window.matchMedia(mediaQuery).matches) {
          window['zE']('webWidget', 'hide');
        }
      }); //Apply additional config

      setChatConfig();
      setZeLoaded(true);
    }; //Clean up on dismount (may not be needed, but never hurts)


    return function () {
      document.head.removeChild(zeScriptTag);
    };
  }, []); //Hide the Zendesk chat on mobile and show on larger screens

  useEffect(function () {
    if (zeLoaded && typeof window['zE'] === 'function') {
      if (isMobile) {
        window['zE']('webWidget', 'hide');
      } else {
        window['zE']('webWidget', 'show');
      }
    }
  }, [isMobile, zeLoaded]);
  /**
   * Set up basic chat configuration and department logic.
   * With the exception of zIndex, which was set to 1200 to keep the chat
   * behind Material UI modal overlays, this logic is identical to the snippet
   * in Google Tag Manager for widget configuration on discover.proxibid.com as
   * of 7 July 2022.
   */

  function setChatConfig() {
    if (typeof window['zE'] === 'function') {
      window['zESettings'] = {
        webWidget: {
          zIndex: 1200,
          chat: {
            departments: {
              enabled: []
            }
          }
        }
      };
      window['zE']('webWidget:on', 'chat:departmentStatus', function (dept) {
        if (dept.name === 'Proxibid Customer Experience' && dept.status === 'online') {
          //console.log(dept.name + ' is ' + dept.status);      //optional logging
          window['zE']('webWidget', 'updateSettings', {
            webWidget: {
              zIndex: 1200,
              chat: {
                departments: {
                  enabled: [''],
                  select: 'Proxibid Customer Experience'
                },
                suppress: false
              }
            }
          });
        } else if (dept.name === 'Proxibid Customer Experience' && dept.status !== 'online') {
          //console.log(dept.name + ' is ' + dept.status);      //optional logging
          window['zE']('webWidget', 'updateSettings', {
            webWidget: {
              zIndex: 1200,
              chat: {
                suppress: true
              }
            }
          });
        }
      });
    }
  }

  return null;
}

Header.propTypes = {
  active: string,
  clientProxy: string.isRequired,
  searchPageUrl: string.isRequired,
  theme: object$1,
  profileUpdateLocation: string.isRequired,
  verifyPhoneNumber: func.isRequired,
  sendEmail: func.isRequired,
  contactSupportUrl: string.isRequired,
  privacyPolicyUrl: string.isRequired,
  captchaEnabled: bool.isRequired,
  captchaApiKey: string.isRequired
};

function Header(props) {
  var classes = useStyles$p();
  var theme = useTheme();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mobileOpen = _React$useState2[0],
      setMobileOpen = _React$useState2[1];

  var _React$useState3 = React.useState({
    emailVerificationCode: '',
    email: '',
    profileComplete: true
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      identity = _React$useState4[0],
      setIdentity = _React$useState4[1];

  var useOtherLogo = false;

  if (!lodash_isnil(theme.header.logoSource)) {
    useOtherLogo = true;
  }

  var fetchIdentity = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var userId, _response$data, _response$data2, response, _error$response;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              userId = getCookieValue('userid') || 0;

              if (!(userId > 0)) {
                _context.next = 9;
                break;
              }

              _context.next = 5;
              return axiosInstance.get("".concat(props.clientProxy, "/identities/v1/").concat(userId), {
                params: {
                  skip401Event: true
                }
              });

            case 5:
              response = _context.sent;
              EventService.dispatchEvent(EVENT_LOGIN_UPDATE_DISPLAY_NAME, (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.displayName);
              EventService.dispatchEvent(EventIdentity.EVENT_IDENTITY_SHOW_BIDDER_STATUS, (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.bidderRating);
              setIdentity(response.data);

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);

              if ((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
                EventService.dispatchEvent(EVENT_LOGIN_UPDATE_DISPLAY_NAME);
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function fetchIdentity() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    fetchIdentity();
  }, []);

  var handleDrawerToggle = function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  };

  var getExternalLogo = function getExternalLogo() {
    return /*#__PURE__*/React.createElement(ExternalLogo$1, {
      source: theme.header.logoSource,
      "data-testid": "drawer-logo",
      id: "drawer-logo"
    });
  };

  return /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(ZendeskChat, null), /*#__PURE__*/React.createElement(Hidden$1, {
    smUp: true
  }, /*#__PURE__*/React.createElement(Drawer, {
    open: mobileOpen,
    active: props.active,
    clientProxy: props.clientProxy,
    captchaEnabled: props.captchaEnabled,
    captchaApiKey: props.captchaApiKey,
    handleDrawerToggle: handleDrawerToggle,
    logo: useOtherLogo ? getExternalLogo() : /*#__PURE__*/React.createElement(ProxibidLogoWhite$1, {
      "data-testid": "drawer-logo",
      id: "drawer-logo"
    })
  })), /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    className: classes.upperSection,
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Hidden$1, {
    smUp: true
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 1,
    sm: false,
    className: classes.menuIconFormat
  }, /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "open-drawer",
    id: "open-drawer",
    className: classes.iconFormat,
    "aria-label": "open drawer",
    edge: "start",
    onClick: handleDrawerToggle
  }, /*#__PURE__*/React.createElement(Menu, {
    fontSize: theme.header.icon.fontSize
  })))), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 5,
    sm: 3,
    lg: 3,
    className: classes.logo
  }, /*#__PURE__*/React.createElement(Link$1, {
    "data-testid": "proxilogo",
    id: "proxilogo",
    "aria-label": "Proxibid Logo",
    className: classes.homeLink,
    href: window.location.pathname !== '/' ? '/' : undefined
  }, useOtherLogo ? getExternalLogo() : /*#__PURE__*/React.createElement(ProxibidLogoWhite$1, {
    "data-testid": "drawer-logo",
    id: "drawer-logo"
  }))), /*#__PURE__*/React.createElement(Hidden$1, {
    xsDown: true
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    className: classes.textFormat,
    xs: false,
    sm: 9,
    lg: 9
  }, /*#__PURE__*/React.createElement(SignInRegister, {
    dialogTitle: 'Buyer Sign In',
    clientProxy: props.clientProxy,
    captchaEnabled: props.captchaEnabled,
    captchaApiKey: props.captchaApiKey
  })))), /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    className: classes.lowerSection,
    justify: "center"
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    className: classes.lowerSectionInner,
    justify: "center",
    alignItems: "center",
    spacing: 0
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    className: classes.container,
    xs: false,
    sm: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Hidden$1, {
    xsDown: true
  }, /*#__PURE__*/React.createElement(NavLinks, {
    active: props.active || window.location.pathname
  })))), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    className: classes.searchBox,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(HomeSearch, {
    searchPageUrl: props.searchPageUrl,
    autoSuggestionAPIUrl: "".concat(props.clientProxy, "/search/autoSuggestCategory")
  })))), /*#__PURE__*/React.createElement(Grid$1, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PersistedMessagesManager, {
    identity: identity,
    profileUpdateLocation: props.profileUpdateLocation,
    sendEmail: props.sendEmail,
    verifyPhoneNumber: props.verifyPhoneNumber,
    contactSupportUrl: props.contactSupportUrl,
    privacyPolicyUrl: props.privacyPolicyUrl
  }))));
}

var useStyles$p = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1
    },
    upperSection: _defineProperty({
      alignContent: 'center',
      backgroundColor: theme.palette.primary.main,
      color: theme.textColor[50],
      paddingLeft: 10,
      paddingRight: 10,
      height: 55,
      maxHeight: 55
    }, theme.breakpoints.up('sm'), {
      paddingLeft: 18,
      paddingRight: 30
    }),
    lowerSection: _defineProperty({
      alignContent: 'center',
      background: theme.header.lowerSection.background,
      boxShadow: '0 3px 20px 10px rgba(0,0,0,0.10)',
      color: theme.textColor[900],
      display: 'flex',
      height: 50,
      maxHeight: 50
    }, theme.breakpoints.up('sm'), {
      height: 50,
      maxHeight: 50
    }),
    lowerSectionInner: _defineProperty({
      height: '100%',
      margin: 0,
      maxWidth: 1240
    }, theme.breakpoints.up('sm'), {
      width: '90%'
    }),
    signInRegister: {
      paddingRight: 20
    },
    logo: {
      cursor: 'pointer'
    },
    searchBox: _defineProperty({}, theme.breakpoints.up('sm'), {
      maxWidth: '400px'
    }),
    homeLink: {
      display: 'flex'
    },
    textFormat: {
      fontSize: theme.header.fontSize
    },
    iconFormat: {
      color: theme.header.upperSection.iconColor,
      cursor: 'pointer',
      padding: 15
    },
    menuIconFormat: {
      marginRight: 12
    },
    container: {
      height: '100%'
    }
  };
});

var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial$1(value);
};

function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}

function isSpecial$1(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
} // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}

function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}

function getMergeFunction(key, options) {
  if (!options.customMerge) {
    return deepmerge;
  }

  var customMerge = options.customMerge(key);
  return typeof customMerge === 'function' ? customMerge : deepmerge;
}

function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function (symbol) {
    return target.propertyIsEnumerable(symbol);
  }) : [];
}

function getKeys(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}

function propertyIsOnObject(object, property) {
  try {
    return property in object;
  } catch (_) {
    return false;
  }
} // Protects from prototype poisoning and unexpected merging up the prototype chain.


function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  && Object.propertyIsEnumerable.call(target, key)); // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    getKeys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }

  getKeys(source).forEach(function (key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }

    if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    }
  });
  return destination;
}

function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject; // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  // implementations can use it. The caller may not replace it.

  options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}

deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }

  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};

var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
var SHOW_HEADER = '@header-event/SHOW_HEADER';
var HIDE_HEADER = '@header-event/HIDE_HEADER';
var HeaderEvent = {
  SHOW_HEADER: SHOW_HEADER,
  HIDE_HEADER: HIDE_HEADER
};
var generateClassName = createGenerateClassName({
  disableGlobal: true,
  seed: 'header'
});
RootHeader.propTypes = {
  active: PropTypes__default.string,
  clientProxy: PropTypes__default.string.isRequired,
  searchPageUrl: PropTypes__default.string.isRequired,
  theme: PropTypes__default.string,
  profileUpdateLocation: PropTypes__default.string.isRequired,
  contactSupportUrl: PropTypes__default.string.isRequired,
  privacyPolicyUrl: PropTypes__default.string.isRequired,
  verifyPhoneNumber: PropTypes__default.func.isRequired,
  sendEmail: PropTypes__default.func.isRequired,
  captchaEnabled: PropTypes__default.bool.isRequired,
  captchaApiKey: PropTypes__default.string.isRequired
};

function RootHeader(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showHeader = _useState2[0],
      setShowHeader = _useState2[1];

  var themeToUse = !lodash_isnil(props.theme) ? cjs(theme, props.theme) : theme;
  useEffect(function () {
    EventService.addEventListener(HeaderEvent.SHOW_HEADER, showHeaderHandler);
    EventService.addEventListener(HeaderEvent.HIDE_HEADER, hideHeaderHandler);
    return function () {
      EventService.removeEventListener(HeaderEvent.SHOW_HEADER, showHeaderHandler);
      EventService.removeEventListener(HeaderEvent.HIDE_HEADER, hideHeaderHandler);
    };
  });
  return /*#__PURE__*/React.createElement(StylesProvider, {
    generateClassName: generateClassName
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeToUse
  }, showHeader && /*#__PURE__*/React.createElement(Header, {
    active: props.active,
    clientProxy: props.clientProxy,
    searchPageUrl: props.searchPageUrl,
    profileUpdateLocation: props.profileUpdateLocation,
    sendEmail: props.sendEmail,
    verifyPhoneNumber: props.verifyPhoneNumber,
    contactSupportUrl: props.contactSupportUrl,
    privacyPolicyUrl: props.privacyPolicyUrl,
    captchaEnabled: props.captchaEnabled,
    captchaApiKey: props.captchaApiKey
  })));

  function showHeaderHandler() {
    setShowHeader(true);
  }

  function hideHeaderHandler() {
    setShowHeader(false);
  }
}

var PENDING = 'PENDING';
var ONLINE = 'ONLINE';
var LIVE = 'LIVE';
var noImageSvg = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20632%20504%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E.cls-1%7Bfill%3A%23cbcbcb%3B%7D%3C%2Fstyle%3E%20%20%3C%2Fdefs%3E%20%20%3Ctitle%3Eno-imageArtboard%201%3C%2Ftitle%3E%20%20%3Cpath%20class%3D%22cls-1%22%20%20%20%20d%3D%22M622.11%2C162.69%2C478.83%2C125.6l7.2%2C26.92%2C118.26%2C30.62L528.4%2C476.29%2C294%2C415.61l-47.63%2C12.74%2C287.72%2C74.47a12.13%2C12.13%2C0%2C0%2C0%2C14.78-8.7l82-316.65A12.13%2C12.13%2C0%2C0%2C0%2C622.11%2C162.69Z%22%2F%3E%20%20%3Cpath%20class%3D%22cls-1%22%20%20%20%20d%3D%22M505.26%2C340.63a12.13%2C12.13%2C0%2C0%2C0%2C8.59-14.85l-84.48-316a12.12%2C12.12%2C0%2C0%2C0-14.85-8.58L9.79%2C109.41a12.13%2C12.13%2C0%2C0%2C0-8.58%2C14.85l84.48%2C316a12.09%2C12.09%2C0%2C0%2C0%2C11.72%2C9%2C12%2C12%2C0%2C0%2C0%2C3.13-.41ZM409.07%2C27.78l78.21%2C292.54L106%2C422.26%2C27.78%2C129.71Z%22%2F%3E%3C%2Fsvg%3E";
AuctionListItem.propTypes = {
  auction: PropTypes__default.object.isRequired,
  catalogUrl: PropTypes__default.string,
  auctionIdPlaceholder: PropTypes__default.string
};

function AuctionListItem(props) {
  var _this = this;

  var classes = useStyles$q();
  var _props$auction = props.auction,
      id = _props$auction.id,
      title = _props$auction.title,
      description = _props$auction.description,
      logoFileName = _props$auction.logoFileName,
      postalCode = _props$auction.postalCode,
      streetAddress = _props$auction.streetAddress,
      location = _props$auction.location,
      abbreviation = _props$auction.abbreviation,
      auctionDateTime = _props$auction.auctionDateTime,
      auctionStatus = _props$auction.auctionStatus,
      auctionTypeId = _props$auction.auctionTypeId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      imgErrored = _useState2[0],
      setImgErrored = _useState2[1];

  var _useState3 = useState(logoFileName),
      _useState4 = _slicedToArray(_useState3, 2),
      imgSrc = _useState4[0],
      setImgSrc = _useState4[1];

  var getButtonText = function getButtonText(auctionStatus) {
    switch (auctionStatus) {
      case LIVE:
        return 'ENTER LIVE AUCTION';

      case PENDING:
        return 'VIEW CATALOG';

      case ONLINE:
      default:
        return 'BID NOW';
    }
  };

  var onImgError = function onImgError() {
    if (!imgErrored) {
      setImgSrc(noImageSvg);
      setImgErrored(true);
    }
  };

  var handleButtonClick = function handleButtonClick(path) {
    window.location = path;
  };

  return /*#__PURE__*/React.createElement(ListItem, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    className: classes.container
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 5,
    sm: 2,
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.imgButton,
    disableRipple: true,
    onClick: function onClick() {
      return handleButtonClick("".concat(props.catalogUrl).concat(id));
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.img,
    alt: title,
    src: imgSrc,
    onError: function onError() {
      _this.onError = onImgError();
    }
  }))), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 7,
    sm: 3,
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classnames(classes.auctionTitleInfo, classes.columnBox)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    gutterBottom: true,
    noWrap: true
  }, title), /*#__PURE__*/React.createElement(Typography, {
    className: classes.auctionDescription,
    variant: "caption",
    color: "textSecondary"
  }, description))), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 12,
    sm: 5,
    className: classnames(classes.auctionInfo, classes.contentContainer)
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classnames(classes.columnBox, classes.infoBox)
  }, /*#__PURE__*/React.createElement(Link, {
    target: "_blank",
    href: "http://maps.google.com/?daddr=".concat(streetAddress, ", ").concat(location, ", ").concat(abbreviation)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, streetAddress), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    gutterBottom: true
  }, location, ", ", abbreviation, ", ", postalCode))), /*#__PURE__*/React.createElement(Box$1, {
    className: classnames(classes.columnBox, classes.infoBox)
  }, auctionTypeId === 2 ? /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(AvTimerIcon, {
    fontSize: 'small'
  }), "Timed") : /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(GavelIcon, {
    fontSize: 'small'
  }), "Live"), /*#__PURE__*/React.createElement(Typography, {
    variant: 'body2',
    component: 'div',
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: 'flex',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(DateRangeOutlinedIcon, {
    fontSize: 'small',
    color: 'action'
  }), moment(auctionDateTime).format('LL'))), /*#__PURE__*/React.createElement(Typography, {
    variant: 'body2',
    component: 'div',
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: 'flex',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Schedule, {
    fontSize: 'small',
    color: 'action'
  }), moment(auctionDateTime).format('LT'))))), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 12,
    sm: 2,
    className: classnames(classes.buttonContainer, classes.contentContainer)
  }, /*#__PURE__*/React.createElement(Button, {
    id: 'bidButton' + id,
    fullWidth: true,
    variant: 'contained',
    color: 'secondary',
    className: classes.button,
    onClick: function onClick() {
      return handleButtonClick("".concat(props.catalogUrl).concat(id));
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.buttonText
  }, getButtonText(auctionStatus))))));
}

var useStyles$q = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      userSelect: 'none'
    },
    container: {
      display: 'flex',
      border: '1px solid lightgray'
    },
    contentContainer: {
      padding: theme.spacing(2)
    },
    imgButton: {
      background: 'transparent',
      '&:hover': {
        background: 'transparent'
      }
    },
    auctionTitleInfo: {
      justifyContent: 'flex-start'
    },
    button: {
      textAlign: 'center'
    },
    img: {
      width: '90%',
      maxHeight: '90%'
    },
    auctionInfo: _defineProperty({
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: '2px solid lightgray',
      borderBottom: '2px solid lightgray',
      display: 'flex',
      justifyContent: 'space-around',
      maxWidth: '100%'
    }, theme.breakpoints.up('sm'), {
      borderLeft: '2px solid lightgray',
      borderRight: '2px solid lightgray',
      borderTop: 'none',
      borderBottom: 'none'
    }),
    auctionDescription: {
      maxHeight: '205px',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    infoBox: {
      width: '50%'
    },
    columnBox: {
      display: 'flex',
      flexDirection: 'column'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    buttonText: {
      fontSize: '0.875rem',
      color: 'black'
    }
  };
});
var useStyles$r = makeStyles(function (theme) {
  return {
    info: {
      color: theme.info.color
    },
    success: {
      color: theme.success.color
    },
    "default": {
      color: theme["default"].color
    }
  };
});

function BigMessage(props) {
  var children = props.children,
      secondary = props.secondary,
      Icon = props.Icon,
      type = props.type;
  var classes = useStyles$r();
  return /*#__PURE__*/React.createElement(Card$1, {
    align: "center"
  }, /*#__PURE__*/React.createElement(CardContent$1, null, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    justify: "center",
    alignItems: "center",
    mb: 2
  }, /*#__PURE__*/React.createElement(Icon, {
    style: {
      fontSize: 100
    },
    className: classes[type]
  }), /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "h5"
  }, children))), secondary && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider$1, {
    variant: "fullWidth"
  }), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    justify: "center",
    alignItems: "center",
    mt: 2
  }, secondary))));
}

BigMessage.propTypes = {
  children: PropTypes__default.node.isRequired,
  secondary: PropTypes__default.element,
  Icon: PropTypes__default.object,
  type: PropTypes__default.oneOf(['info', 'success', 'default'])
};
var useStyles$s = makeStyles(function (theme) {
  return {
    linkStyle: {
      color: '#008EC3'
    },
    container: {
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1.25rem'
    },
    iconStyle: {
      color: theme.palette.primary.main,
      fontSize: '5rem'
    }
  };
});

function AuctionList(props) {
  var classes = useStyles$s();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      auctions = _useState2[0],
      getAuctionsByState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    var getAuctionsByStateRequest = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var auctions;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                _context.next = 3;
                return clientProxyAPI(props.coreServiceUrl + props.auctionsByStateUrl, {
                  stateCode: props.stateCode,
                  resultSet: props.resultSet,
                  filterLocation: props.filterLocation,
                  coreToken: props.apiToken
                });

              case 3:
                auctions = _context.sent;
                getAuctionsByState(auctions.data);
                setLoading(false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getAuctionsByStateRequest() {
        return _ref.apply(this, arguments);
      };
    }();

    getAuctionsByStateRequest().then(function (r) {
      return r;
    });
  }, [props.stateCode, props.resultSet, props.filterLocation]);

  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "primary",
      variant: "h6"
    }, "Fetching Auction Data..."), /*#__PURE__*/React.createElement(CircularProgress, {
      color: "primary",
      size: 50
    }));
  } else {
    if (auctions.length > 0) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(List, {
        "data-testid": 'auctionList',
        id: 'auctionList',
        component: "ul"
      }, auctions.map(function (auction) {
        return /*#__PURE__*/React.createElement(AuctionListItem, _extends({
          key: auction.id,
          auction: auction
        }, props));
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '14px'
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h6",
        color: "primary"
      }, 'Not what you\'re looking for? Browse ', /*#__PURE__*/React.createElement(Link, {
        id: "todays-auctions-link",
        className: classes.linkStyle,
        href: "/todays-auctions"
      }, 'Today\'s Auctions'), " on Proxibid")));
    } else {
      return /*#__PURE__*/React.createElement(BigMessage, {
        Icon: UhOhIcon,
        type: "info",
        secondary: /*#__PURE__*/React.createElement("div", {
          className: classes.container
        }, /*#__PURE__*/React.createElement(Button, {
          color: "primary",
          href: "/todays-auctions"
        }, 'Browse Today\'s Auctions'))
      }, "Sorry, no auctions were found");
    }
  }
}

AuctionList.propTypes = {
  auctions: PropTypes__default.array.isRequired,
  catalogUrl: PropTypes__default.string,
  auctionIdPlaceholder: PropTypes__default.string,
  auctionsByStateUrl: PropTypes__default.string,
  apiToken: PropTypes__default.string,
  stateCode: PropTypes__default.string,
  resultSet: PropTypes__default.string,
  coreServiceUrl: PropTypes__default.string,
  filterLocation: PropTypes__default.string
};

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var defaultProps = {
  preventDefaultTouchmoveEvent: false,
  delta: 10,
  rotationAngle: 0,
  trackMouse: false,
  trackTouch: true
};
var initialState$4 = {
  xy: [0, 0],
  swiping: false,
  eventData: undefined,
  start: undefined
};
var LEFT = 'Left';
var RIGHT = 'Right';
var UP = 'Up';
var DOWN = 'Down';
var touchStart = 'touchstart';
var touchMove = 'touchmove';
var touchEnd = 'touchend';
var mouseMove = 'mousemove';
var mouseUp = 'mouseup';

function getDirection(absX, absY, deltaX, deltaY) {
  if (absX > absY) {
    if (deltaX > 0) {
      return LEFT;
    }

    return RIGHT;
  } else if (deltaY > 0) {
    return UP;
  }

  return DOWN;
}

function rotateXYByAngle(pos, angle) {
  if (angle === 0) return pos;
  var angleInRadians = Math.PI / 180 * angle;
  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
  return [x, y];
}

function getHandlers(set, handlerProps) {
  var onStart = function onStart(event) {
    // if more than a single touch don't track, for now...
    if (event.touches && event.touches.length > 1) return;
    set(function (state, props) {
      // setup mouse listeners on document to track swipe since swipe can leave container
      if (props.trackMouse) {
        document.addEventListener(mouseMove, onMove);
        document.addEventListener(mouseUp, onUp);
      }

      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
      return _extends$5({}, state, initialState$4, {
        eventData: {
          initial: [].concat(xy),
          first: true
        },
        xy: xy,
        start: event.timeStamp || 0
      });
    });
  };

  var onMove = function onMove(event) {
    set(function (state, props) {
      if (!state.xy[0] || !state.xy[1] || event.touches && event.touches.length > 1) {
        return state;
      }

      var _ref2 = event.touches ? event.touches[0] : event,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
          x = _rotateXYByAngle[0],
          y = _rotateXYByAngle[1];

      var deltaX = state.xy[0] - x;
      var deltaY = state.xy[1] - y;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var time = (event.timeStamp || 0) - state.start;
      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1); // if swipe is under delta and we have not started to track a swipe: skip update

      if (absX < props.delta && absY < props.delta && !state.swiping) return state;
      var dir = getDirection(absX, absY, deltaX, deltaY);

      var eventData = _extends$5({}, state.eventData, {
        event: event,
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        velocity: velocity,
        dir: dir
      });

      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
      // so we can call preventDefault if needed

      var cancelablePageSwipe = false;

      if (props.onSwiping || props.onSwiped || props["onSwiped" + dir]) {
        cancelablePageSwipe = true;
      }

      if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault(); // first is now always false

      return _extends$5({}, state, {
        eventData: _extends$5({}, eventData, {
          first: false
        }),
        swiping: true
      });
    });
  };

  var onEnd = function onEnd(event) {
    set(function (state, props) {
      var eventData;

      if (state.swiping) {
        eventData = _extends$5({}, state.eventData, {
          event: event
        });
        props.onSwiped && props.onSwiped(eventData);
        props["onSwiped" + eventData.dir] && props["onSwiped" + eventData.dir](eventData);
      }

      return _extends$5({}, state, initialState$4, {
        eventData: eventData
      });
    });
  };

  var cleanUpMouse = function cleanUpMouse() {
    // safe to just call removeEventListener
    document.removeEventListener(mouseMove, onMove);
    document.removeEventListener(mouseUp, onUp);
  };

  var onUp = function onUp(e) {
    cleanUpMouse();
    onEnd(e);
  };

  var attachTouch = function attachTouch(el) {
    if (el && el.addEventListener) {
      // attach touch event listeners and handlers
      var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
      tls.forEach(function (_ref3) {
        var e = _ref3[0],
            h = _ref3[1];
        return el.addEventListener(e, h);
      }); // return properly scoped cleanup method for removing listeners

      return function () {
        return tls.forEach(function (_ref4) {
          var e = _ref4[0],
              h = _ref4[1];
          return el.removeEventListener(e, h);
        });
      };
    }
  };

  var onRef = function onRef(el) {
    // "inline" ref functions are called twice on render, once with null then again with DOM element
    // ignore null here
    if (el === null) return;
    set(function (state, props) {
      // if the same DOM el as previous just return state
      if (state.el === el) return state;
      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

      if (state.el && state.el !== el && state.cleanUpTouch) {
        state.cleanUpTouch();
        addState.cleanUpTouch = null;
      } // only attach if we want to track touch


      if (props.trackTouch && el) {
        addState.cleanUpTouch = attachTouch(el);
      } // store event attached DOM el for comparison, clean up, and re-attachment


      return _extends$5({}, state, {
        el: el
      }, addState);
    });
  }; // set ref callback to attach touch event listeners


  var output = {
    ref: onRef // if track mouse attach mouse down listener

  };

  if (handlerProps.trackMouse) {
    output.onMouseDown = onStart;
  }

  return [output, attachTouch];
}

function updateTransientState(state, props, attachTouch) {
  var addState = {}; // clean up touch handlers if no longer tracking touches

  if (!props.trackTouch && state.cleanUpTouch) {
    state.cleanUpTouch();
    addState.cleanUpTouch = null;
  } else if (props.trackTouch && !state.cleanUpTouch) {
    // attach/re-attach touch handlers
    if (state.el) {
      addState.cleanUpTouch = attachTouch(state.el);
    }
  }

  return _extends$5({}, state, addState);
}

function useSwipeable(props) {
  var trackMouse = props.trackMouse;
  var transientState = React.useRef(_extends$5({}, initialState$4, {
    type: 'hook'
  }));
  var transientProps = React.useRef();
  transientProps.current = _extends$5({}, defaultProps, props);

  var _React$useMemo = React.useMemo(function () {
    return getHandlers(function (cb) {
      return transientState.current = cb(transientState.current, transientProps.current);
    }, {
      trackMouse: trackMouse
    });
  }, [trackMouse]),
      handlers = _React$useMemo[0],
      attachTouch = _React$useMemo[1];

  transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
  return handlers;
}

var Swipeable = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose$2(Swipeable, _React$PureComponent);

  function Swipeable(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _this._set = function (cb) {
      _this.transientState = cb(_this.transientState, _this.props);
    };

    _this.transientState = _extends$5({}, initialState$4, {
      type: 'class'
    });
    return _this;
  }

  var _proto = Swipeable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        _this$props$nodeName = _this$props.nodeName,
        nodeName = _this$props$nodeName === void 0 ? 'div' : _this$props$nodeName,
        innerRef = _this$props.innerRef,
        children = _this$props.children,
        trackMouse = _this$props.trackMouse;

    var _getHandlers = getHandlers(this._set, {
      trackMouse: trackMouse
    }),
        handlers = _getHandlers[0],
        attachTouch = _getHandlers[1];

    this.transientState = updateTransientState(this.transientState, this.props, attachTouch);
    var ref = innerRef ? function (el) {
      return innerRef(el), handlers.ref(el);
    } : handlers.ref;
    return React.createElement(nodeName, _extends$5({}, handlers, {
      className: className,
      style: style,
      ref: ref
    }), children);
  };

  return Swipeable;
}(React.PureComponent);

Swipeable.propTypes = {
  onSwiped: PropTypes__default.func,
  onSwiping: PropTypes__default.func,
  onSwipedUp: PropTypes__default.func,
  onSwipedRight: PropTypes__default.func,
  onSwipedDown: PropTypes__default.func,
  onSwipedLeft: PropTypes__default.func,
  delta: PropTypes__default.number,
  preventDefaultTouchmoveEvent: PropTypes__default.bool,
  nodeName: PropTypes__default.string,
  trackMouse: PropTypes__default.bool,
  trackTouch: PropTypes__default.bool,
  innerRef: PropTypes__default.func,
  rotationAngle: PropTypes__default.number
};
Swipeable.defaultProps = defaultProps;
var es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DOWN: DOWN,
  LEFT: LEFT,
  RIGHT: RIGHT,
  Swipeable: Swipeable,
  UP: UP,
  useSwipeable: useSwipeable
});
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */

var FUNC_ERROR_TEXT$1 = 'Expected a function';
/** Used as references for various `Number` constants. */

var NAN$1 = 0 / 0;
/** `Object#toString` result references. */

var symbolTag$1 = '[object Symbol]';
/** Used to match leading and trailing whitespace. */

var reTrim$1 = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary$1 = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal$1 = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt$1 = parseInt;
/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root$2 = freeGlobal$1 || freeSelf$1 || Function('return this')();
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString$1 = objectProto$1.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now$1 = function now$1() {
  return root$2.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */


function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }

  wait = toNumber$1(wait) || 0;

  if (isObject$3(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now$1();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */


function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }

  if (isObject$3(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$3(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol$1(value) {
  return typeof value == 'symbol' || isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */


function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol$1(value)) {
    return NAN$1;
  }

  if (isObject$3(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$3(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}

var lodash_throttle = throttle;
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */

/* eslint-disable require-jsdoc, valid-jsdoc */

var MapShim = function () {
  if (typeof Map !== 'undefined') {
    return Map;
  }
  /**
   * Returns index in provided array that matches the specified key.
   *
   * @param {Array<Array>} arr
   * @param {*} key
   * @returns {number}
   */


  function getIndex(arr, key) {
    var result = -1;
    arr.some(function (entry, index) {
      if (entry[0] === key) {
        result = index;
        return true;
      }

      return false;
    });
    return result;
  }

  return (
    /** @class */
    function () {
      function class_1() {
        this.__entries__ = [];
      }

      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function get() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      /**
       * @param {*} key
       * @returns {*}
       */

      class_1.prototype.get = function (key) {
        var index = getIndex(this.__entries__, key);
        var entry = this.__entries__[index];
        return entry && entry[1];
      };
      /**
       * @param {*} key
       * @param {*} value
       * @returns {void}
       */


      class_1.prototype.set = function (key, value) {
        var index = getIndex(this.__entries__, key);

        if (~index) {
          this.__entries__[index][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */


      class_1.prototype.delete = function (key) {
        var entries = this.__entries__;
        var index = getIndex(entries, key);

        if (~index) {
          entries.splice(index, 1);
        }
      };
      /**
       * @param {*} key
       * @returns {void}
       */


      class_1.prototype.has = function (key) {
        return !!~getIndex(this.__entries__, key);
      };
      /**
       * @returns {void}
       */


      class_1.prototype.clear = function () {
        this.__entries__.splice(0);
      };
      /**
       * @param {Function} callback
       * @param {*} [ctx=null]
       * @returns {void}
       */


      class_1.prototype.forEach = function (callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }

        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };

      return class_1;
    }()
  );
}();
/**
 * Detects whether window and document objects are available in current environment.
 */


var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document; // Returns global object of a current environment.

var global$1 = function () {
  if (typeof global !== 'undefined' && global.Math === Math) {
    return global;
  }

  if (typeof self !== 'undefined' && self.Math === Math) {
    return self;
  }

  if (typeof window !== 'undefined' && window.Math === Math) {
    return window;
  } // eslint-disable-next-line no-new-func


  return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */


var requestAnimationFrame$1 = function () {
  if (typeof requestAnimationFrame === 'function') {
    // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
  }

  return function (callback) {
    return setTimeout(function () {
      return callback(Date.now());
    }, 1000 / 60);
  };
}(); // Defines minimum timeout before adding a trailing call.


var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */

function throttle$1(callback, delay) {
  var leadingCall = false,
      trailingCall = false,
      lastCallTime = 0;
  /**
   * Invokes the original callback function and schedules new invocation if
   * the "proxy" was called during current request.
   *
   * @returns {void}
   */

  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }

    if (trailingCall) {
      proxy();
    }
  }
  /**
   * Callback invoked after the specified delay. It will further postpone
   * invocation of the original function delegating it to the
   * requestAnimationFrame.
   *
   * @returns {void}
   */


  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  /**
   * Schedules invocation of the original function.
   *
   * @returns {void}
   */


  function proxy() {
    var timeStamp = Date.now();

    if (leadingCall) {
      // Reject immediately following calls.
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      } // Schedule new call to be in invoked when the pending one is resolved.
      // This is important for "transitions" which never actually start
      // immediately so there is a chance that we might miss one if change
      // happens amids the pending invocation.


      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }

    lastCallTime = timeStamp;
  }

  return proxy;
} // Minimum delay before invoking the update of observers.


var REFRESH_DELAY = 20; // A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.

var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight']; // Check if MutationObserver is available.

var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */

var ResizeObserverController =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserverController.
   *
   * @private
   */
  function ResizeObserverController() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;
    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */

    this.mutationEventsAdded_ = false;
    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */

    this.mutationsObserver_ = null;
    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */

    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
  }
  /**
   * Adds observer to observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be added.
   * @returns {void}
   */


  ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    } // Add listeners if they haven't been added yet.


    if (!this.connected_) {
      this.connect_();
    }
  };
  /**
   * Removes observer from observers list.
   *
   * @param {ResizeObserverSPI} observer - Observer to be removed.
   * @returns {void}
   */


  ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer); // Remove observer if it's present in registry.

    if (~index) {
      observers.splice(index, 1);
    } // Remove listeners if controller has no connected observers.


    if (!observers.length && this.connected_) {
      this.disconnect_();
    }
  };
  /**
   * Invokes the update of observers. It will continue running updates insofar
   * it detects changes.
   *
   * @returns {void}
   */


  ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_(); // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.

    if (changesDetected) {
      this.refresh();
    }
  };
  /**
   * Updates every observer from observers list and notifies them of queued
   * entries.
   *
   * @private
   * @returns {boolean} Returns "true" if any observer has detected changes in
   *      dimensions of it's elements.
   */


  ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
      return observer.gatherActive(), observer.hasActive();
    }); // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.

    activeObservers.forEach(function (observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  /**
   * Initializes DOM listeners.
   *
   * @private
   * @returns {void}
   */


  ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
      return;
    } // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.


    document.addEventListener('transitionend', this.onTransitionEnd_);
    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener('DOMSubtreeModified', this.refresh);
      this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
  };
  /**
   * Removes DOM listeners.
   *
   * @private
   * @returns {void}
   */


  ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
      return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
      document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  /**
   * "Transitionend" event handler.
   *
   * @private
   * @param {TransitionEvent} event
   * @returns {void}
   */


  ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
    var _b = _a.propertyName,
        propertyName = _b === void 0 ? '' : _b; // Detect whether transition may affect dimensions of an element.

    var isReflowProperty = transitionKeys.some(function (key) {
      return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
      this.refresh();
    }
  };
  /**
   * Returns instance of the ResizeObserverController.
   *
   * @returns {ResizeObserverController}
   */


  ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
  };
  /**
   * Holds reference to the controller's instance.
   *
   * @private {ResizeObserverController}
   */


  ResizeObserverController.instance_ = null;
  return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */


var defineConfigurable = function defineConfigurable(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }

  return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */


var getWindowOf = function getWindowOf(target) {
  // Assume that the element is an instance of Node, which means that it
  // has the "ownerDocument" property from which we can retrieve a
  // corresponding global object.
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView; // Return the local global object if it's not possible extract one from
  // provided element.

  return ownerGlobal || global$1;
}; // Placeholder of an empty content rectangle.


var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */

function toFloat(value) {
  return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */


function getBordersSize(styles) {
  var positions = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }

  return positions.reduce(function (size, position) {
    var value = styles['border-' + position + '-width'];
    return size + toFloat(value);
  }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */


function getPaddings(styles) {
  var positions = ['top', 'right', 'bottom', 'left'];
  var paddings = {};

  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles['padding-' + position];
    paddings[position] = toFloat(value);
  }

  return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */


function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */


function getHTMLElementContentRect(target) {
  // Client width & height properties can't be
  // used exclusively as they provide rounded values.
  var clientWidth = target.clientWidth,
      clientHeight = target.clientHeight; // By this condition we can catch all non-replaced inline, hidden and
  // detached elements. Though elements with width & height properties less
  // than 0.5 will be discarded as well.
  //
  // Without it we would need to implement separate methods for each of
  // those cases and it's not possible to perform a precise and performance
  // effective test for hidden elements. E.g. even jQuery's ':visible' filter
  // gives wrong results for elements with width & height less than 0.5.

  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }

  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom; // Computed styles of width & height are being used because they are the
  // only dimensions available to JS that contain non-rounded values. It could
  // be possible to utilize the getBoundingClientRect if only it's data wasn't
  // affected by CSS transformations let alone paddings, borders and scroll bars.

  var width = toFloat(styles.width),
      height = toFloat(styles.height); // Width & height include paddings and borders when the 'border-box' box
  // model is applied (except for IE).

  if (styles.boxSizing === 'border-box') {
    // Following conditions are required to handle Internet Explorer which
    // doesn't include paddings and borders to computed CSS dimensions.
    //
    // We can say that if CSS dimensions + paddings are equal to the "client"
    // properties then it's either IE, and thus we don't need to subtract
    // anything, or an element merely doesn't have paddings/borders styles.
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, 'left', 'right') + horizPad;
    }

    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
  } // Following steps can't be applied to the document's root element as its
  // client[Width/Height] properties represent viewport area of the window.
  // Besides, it's as well not necessary as the <html> itself neither has
  // rendered scroll bars nor it can be clipped.


  if (!isDocumentElement(target)) {
    // In some browsers (only in Firefox, actually) CSS width & height
    // include scroll bars size which can be removed at this step as scroll
    // bars are the only difference between rounded dimensions + paddings
    // and "client" properties, though that is not always true in Chrome.
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight; // Chrome has a rather weird rounding of "client" properties.
    // E.g. for an element with content width of 314.2px it sometimes gives
    // the client width of 315px and for the width of 314.7px it may give
    // 314px. And it doesn't happen all the time. So just ignore this delta
    // as a non-relevant.

    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }

    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }

  return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */


var isSVGGraphicsElement = function () {
  // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
  // interface.
  if (typeof SVGGraphicsElement !== 'undefined') {
    return function (target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  } // If it's so, then check that element is at least an instance of the
  // SVGElement and that it has the "getBBox" method.
  // eslint-disable-next-line no-extra-parens


  return function (target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
  };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */


function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */


function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }

  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }

  return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */


function createReadOnlyRect(_a) {
  var x = _a.x,
      y = _a.y,
      width = _a.width,
      height = _a.height; // If DOMRectReadOnly is available use it as a prototype for the rectangle.

  var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype); // Rectangle's properties are not writable and non-enumerable.

  defineConfigurable(rect, {
    x: x,
    y: y,
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: height + y,
    left: x
  });
  return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */


function createRectInit(x, y, width, height) {
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */


var ResizeObservation =
/** @class */
function () {
  /**
   * Creates an instance of ResizeObservation.
   *
   * @param {Element} target - Element to be observed.
   */
  function ResizeObservation(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;
    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */

    this.broadcastHeight = 0;
    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */

    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  /**
   * Updates content rectangle and tells whether it's width or height properties
   * have changed since the last broadcast.
   *
   * @returns {boolean}
   */


  ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  /**
   * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
   * from the corresponding properties of the last observed content rectangle.
   *
   * @returns {DOMRectInit} Last observed content rectangle.
   */


  ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };

  return ResizeObservation;
}();

var ResizeObserverEntry =
/** @class */
function () {
  /**
   * Creates an instance of ResizeObserverEntry.
   *
   * @param {Element} target - Element that is being observed.
   * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
   */
  function ResizeObserverEntry(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit); // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.

    defineConfigurable(this, {
      target: target,
      contentRect: contentRect
    });
  }

  return ResizeObserverEntry;
}();

var ResizeObserverSPI =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback function that is invoked
   *      when one of the observed elements changes it's content dimensions.
   * @param {ResizeObserverController} controller - Controller instance which
   *      is responsible for the updates of observer.
   * @param {ResizeObserver} callbackCtx - Reference to the public
   *      ResizeObserver instance which will be passed to callback function.
   */
  function ResizeObserverSPI(callback, controller, callbackCtx) {
    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];
    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */

    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
      throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  /**
   * Starts observing provided element.
   *
   * @param {Element} target - Element to be observed.
   * @returns {void}
   */


  ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    } // Do nothing if current environment doesn't have the Element interface.


    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_; // Do nothing if element is already being observed.

    if (observations.has(target)) {
      return;
    }

    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this); // Force the update of observations.

    this.controller_.refresh();
  };
  /**
   * Stops observing provided element.
   *
   * @param {Element} target - Element to stop observing.
   * @returns {void}
   */


  ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    } // Do nothing if current environment doesn't have the Element interface.


    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
      return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_; // Do nothing if element is not being observed.

    if (!observations.has(target)) {
      return;
    }

    observations.delete(target);

    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  /**
   * Stops observing all elements.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  /**
   * Collects observation instances the associated element of which has changed
   * it's content rectangle.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.gatherActive = function () {
    var _this = this;

    this.clearActive();
    this.observations_.forEach(function (observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  /**
   * Invokes initial callback function with a list of ResizeObserverEntry
   * instances collected from active resize observations.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
      return;
    }

    var ctx = this.callbackCtx_; // Create ResizeObserverEntry instance for every active observation.

    var entries = this.activeObservations_.map(function (observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  /**
   * Clears the collection of active observations.
   *
   * @returns {void}
   */


  ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
  };
  /**
   * Tells whether observer has active observations.
   *
   * @returns {boolean}
   */


  ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
  };

  return ResizeObserverSPI;
}(); // Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.


var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */

var ResizeObserver =
/** @class */
function () {
  /**
   * Creates a new instance of ResizeObserver.
   *
   * @param {ResizeObserverCallback} callback - Callback that is invoked when
   *      dimensions of the observed elements change.
   */
  function ResizeObserver(callback) {
    if (!(this instanceof ResizeObserver)) {
      throw new TypeError('Cannot call a class as a function.');
    }

    if (!arguments.length) {
      throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }

  return ResizeObserver;
}(); // Expose public methods of ResizeObserver.


['observe', 'unobserve', 'disconnect'].forEach(function (method) {
  ResizeObserver.prototype[method] = function () {
    var _a;

    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});

var index = function () {
  // Export existing implementation if available.
  if (typeof global$1.ResizeObserver !== 'undefined') {
    return global$1.ResizeObserver;
  }

  return ResizeObserver;
}();

var imageGallery = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(React);

  var _lodash2 = _interopRequireDefault(lodash_throttle);

  var _lodash4 = _interopRequireDefault(lodash_debounce);

  var _resizeObserverPolyfill2 = _interopRequireDefault(index);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var screenChangeEvents = ['fullscreenchange', 'MSFullscreenChange', 'mozfullscreenchange', 'webkitfullscreenchange'];

  var ImageGallery = function (_React$Component) {
    _inherits(ImageGallery, _React$Component);

    function ImageGallery(props) {
      _classCallCheck(this, ImageGallery);

      var _this = _possibleConstructorReturn(this, (ImageGallery.__proto__ || Object.getPrototypeOf(ImageGallery)).call(this, props));

      _this.slideToIndex = function (index, event) {
        var _this$state = _this.state,
            currentIndex = _this$state.currentIndex,
            isTransitioning = _this$state.isTransitioning;

        if (!isTransitioning) {
          if (event) {
            if (_this._intervalId) {
              // user triggered event while ImageGallery is playing, reset interval
              _this.pause(false);

              _this.play(false);
            }
          }

          var slideCount = _this.props.items.length - 1;
          var nextIndex = index;

          if (index < 0) {
            nextIndex = slideCount;
          } else if (index > slideCount) {
            nextIndex = 0;
          }

          _this.setState({
            previousIndex: currentIndex,
            currentIndex: nextIndex,
            isTransitioning: nextIndex !== currentIndex,
            offsetPercentage: 0,
            style: {
              transition: 'all ' + _this.props.slideDuration + 'ms ease-out'
            }
          }, _this._onSliding);
        }
      };

      _this._onSliding = function () {
        var isTransitioning = _this.state.isTransitioning;
        _this._transitionTimer = window.setTimeout(function () {
          if (isTransitioning) {
            _this.setState({
              isTransitioning: !isTransitioning
            });

            if (_this.props.onSlide) {
              _this.props.onSlide(_this.state.currentIndex);
            }
          }
        }, _this.props.slideDuration + 50);
      };

      _this._handleScreenChange = function () {
        /*
          handles screen change events that the browser triggers e.g. esc key
        */
        var fullScreenElement = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

        if (_this.props.onScreenChange) {
          _this.props.onScreenChange(fullScreenElement);
        }

        _this.setState({
          isFullscreen: !!fullScreenElement
        });
      };

      _this._toggleFullScreen = function () {
        if (_this.state.isFullscreen) {
          _this.exitFullScreen();
        } else {
          _this.fullScreen();
        }
      };

      _this._togglePlay = function () {
        if (_this._intervalId) {
          _this.pause();
        } else {
          _this.play();
        }
      };

      _this._initGalleryResizing = function (element) {
        /*
          When image-gallery-slide-wrapper unmounts and mounts when thumbnail bar position is changed
          ref is called twice, once with null and another with the element.
          Make sure element is available before calling observe.
        */
        if (element) {
          _this._imageGallerySlideWrapper = element;
          _this.resizeObserver = new _resizeObserverPolyfill2.default(_this._createResizeObserver);

          _this.resizeObserver.observe(element);
        }
      };

      _this._createResizeObserver = (0, _lodash4.default)(function (entries) {
        if (!entries) return;
        entries.forEach(function () {
          _this._handleResize();
        });
      }, 300);

      _this._handleResize = function () {
        var currentIndex = _this.state.currentIndex;

        if (_this._imageGallery) {
          _this.setState({
            galleryWidth: _this._imageGallery.offsetWidth
          });
        }

        if (_this._imageGallerySlideWrapper) {
          _this.setState({
            gallerySlideWrapperHeight: _this._imageGallerySlideWrapper.offsetHeight
          });
        }

        if (_this._thumbnailsWrapper) {
          if (_this._isThumbnailVertical()) {
            _this.setState({
              thumbnailsWrapperHeight: _this._thumbnailsWrapper.offsetHeight
            });
          } else {
            _this.setState({
              thumbnailsWrapperWidth: _this._thumbnailsWrapper.offsetWidth
            });
          }
        } // Adjust thumbnail container when thumbnail width or height is adjusted


        _this._setThumbsTranslate(-_this._getThumbsTranslate(currentIndex));
      };

      _this._handleKeyDown = function (event) {
        if (_this.props.disableArrowKeys) {
          return;
        }

        var LEFT_ARROW = 37;
        var RIGHT_ARROW = 39;
        var ESC_KEY = 27;
        var key = parseInt(event.keyCode || event.which || 0);

        switch (key) {
          case LEFT_ARROW:
            if (_this._canSlideLeft() && !_this._intervalId) {
              _this._slideLeft();
            }

            break;

          case RIGHT_ARROW:
            if (_this._canSlideRight() && !_this._intervalId) {
              _this._slideRight();
            }

            break;

          case ESC_KEY:
            if (_this.state.isFullscreen && !_this.props.useBrowserFullscreen) {
              _this.exitFullScreen();
            }

        }
      };

      _this._handleImageError = function (event) {
        if (_this.props.defaultImage && event.target.src.indexOf(_this.props.defaultImage) === -1) {
          event.target.src = _this.props.defaultImage;
        }
      };

      _this._handleOnSwiped = function (_ref) {
        var event = _ref.event,
            dir = _ref.dir,
            velocity = _ref.velocity;
        if (_this.props.disableSwipe) return;
        var _this$state2 = _this.state,
            scrollingUpDown = _this$state2.scrollingUpDown,
            scrollingLeftRight = _this$state2.scrollingLeftRight;
        var isRTL = _this.props.isRTL;
        if (_this.props.stopPropagation) event.stopPropagation();

        if (scrollingUpDown) {
          // user stopped scrollingUpDown
          _this.setState({
            scrollingUpDown: false
          });
        }

        if (scrollingLeftRight) {
          // user stopped scrollingLeftRight
          _this.setState({
            scrollingLeftRight: false
          });
        }

        if (!scrollingUpDown) {
          // don't swipe if user is scrolling
          var side = (dir === es.LEFT ? 1 : -1) * (isRTL ? -1 : 1); // if it is RTL the direction is reversed

          var isFlick = velocity > _this.props.flickThreshold;

          _this._handleOnSwipedTo(side, isFlick);
        }
      };

      _this._handleSwiping = function (_ref2) {
        var event = _ref2.event,
            absX = _ref2.absX,
            dir = _ref2.dir;
        if (_this.props.disableSwipe) return;
        var _this$state3 = _this.state,
            galleryWidth = _this$state3.galleryWidth,
            isTransitioning = _this$state3.isTransitioning,
            scrollingUpDown = _this$state3.scrollingUpDown,
            scrollingLeftRight = _this$state3.scrollingLeftRight;
        var swipingTransitionDuration = _this.props.swipingTransitionDuration;

        _this._setScrollDirection(dir);

        if (_this.props.stopPropagation) event.stopPropagation();
        if ((_this.props.preventDefaultTouchmoveEvent || scrollingLeftRight) && event.cancelable) event.preventDefault();

        if (!isTransitioning && !scrollingUpDown) {
          var side = dir === es.RIGHT ? 1 : -1;
          var offsetPercentage = absX / galleryWidth * 100;

          if (Math.abs(offsetPercentage) >= 100) {
            offsetPercentage = 100;
          }

          var swipingTransition = {
            transition: 'transform ' + swipingTransitionDuration + 'ms ease-out'
          };

          _this.setState({
            offsetPercentage: side * offsetPercentage,
            style: swipingTransition
          });
        } else {
          // don't move the slide
          _this.setState({
            offsetPercentage: 0
          });
        }
      };

      _this._slideLeft = function () {
        _this.props.isRTL ? _this._slideNext() : _this._slidePrevious();
      };

      _this._slideRight = function () {
        _this.props.isRTL ? _this._slidePrevious() : _this._slideNext();
      };

      _this._slidePrevious = function (event) {
        _this.slideToIndex(_this.state.currentIndex - 1, event);
      };

      _this._slideNext = function (event) {
        _this.slideToIndex(_this.state.currentIndex + 1, event);
      };

      _this._renderItem = function (item) {
        var onImageError = _this.props.onImageError || _this._handleImageError;
        return _react2.default.createElement('div', {
          className: 'image-gallery-image'
        }, item.imageSet ? _react2.default.createElement('picture', {
          onLoad: _this.props.onImageLoad,
          onError: onImageError
        }, item.imageSet.map(function (source, index) {
          return _react2.default.createElement('source', {
            key: index,
            media: source.media,
            srcSet: source.srcSet,
            type: source.type
          });
        }), _react2.default.createElement('img', {
          alt: item.originalAlt,
          src: item.original
        })) : _react2.default.createElement('img', {
          src: item.original,
          alt: item.originalAlt,
          srcSet: item.srcSet,
          sizes: item.sizes,
          title: item.originalTitle,
          onLoad: _this.props.onImageLoad,
          onError: onImageError
        }), item.description && _react2.default.createElement('span', {
          className: 'image-gallery-description'
        }, item.description));
      };

      _this._renderThumbInner = function (item) {
        var onThumbnailError = _this.props.onThumbnailError || _this._handleImageError;
        return _react2.default.createElement('div', {
          className: 'image-gallery-thumbnail-inner'
        }, _react2.default.createElement('img', {
          src: item.thumbnail,
          alt: item.thumbnailAlt,
          title: item.thumbnailTitle,
          onError: onThumbnailError
        }), item.thumbnailLabel && _react2.default.createElement('div', {
          className: 'image-gallery-thumbnail-label'
        }, item.thumbnailLabel));
      };

      _this._onThumbnailClick = function (event, index) {
        _this.slideToIndex(index, event);

        if (_this.props.onThumbnailClick) {
          _this.props.onThumbnailClick(event, index);
        }
      };

      _this._onThumbnailMouseOver = function (event, index) {
        if (_this._thumbnailMouseOverTimer) {
          window.clearTimeout(_this._thumbnailMouseOverTimer);
          _this._thumbnailMouseOverTimer = null;
        }

        _this._thumbnailMouseOverTimer = window.setTimeout(function () {
          _this.slideToIndex(index);

          _this.pause();
        }, 300);
      };

      _this._onThumbnailMouseLeave = function () {
        if (_this._thumbnailMouseOverTimer) {
          window.clearTimeout(_this._thumbnailMouseOverTimer);
          _this._thumbnailMouseOverTimer = null;

          if (_this.props.autoPlay) {
            _this.play();
          }
        }
      };

      _this.state = {
        currentIndex: props.startIndex,
        thumbsTranslate: 0,
        offsetPercentage: 0,
        galleryWidth: 0,
        thumbnailsWrapperWidth: 0,
        thumbnailsWrapperHeight: 0,
        isFullscreen: false,
        isPlaying: false
      }; // Used to update the throttle if slideDuration changes

      _this._unthrottledSlideToIndex = _this.slideToIndex;
      _this.slideToIndex = (0, _lodash2.default)(_this._unthrottledSlideToIndex, props.slideDuration, {
        trailing: false
      });

      if (props.lazyLoad) {
        _this._lazyLoaded = [];
      }

      return _this;
    }

    _createClass(ImageGallery, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.autoPlay) {
          this.play();
        }

        window.addEventListener('keydown', this._handleKeyDown);

        this._onScreenChangeEvent();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        var itemsSizeChanged = prevProps.items.length !== this.props.items.length;
        var itemsChanged = JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items);
        var startIndexUpdated = prevProps.startIndex !== this.props.startIndex;

        if (itemsSizeChanged) {
          this._handleResize();
        }

        if (prevState.currentIndex !== this.state.currentIndex) {
          this._slideThumbnailBar(prevState.currentIndex);
        } // if slideDuration changes, update slideToIndex throttle


        if (prevProps.slideDuration !== this.props.slideDuration) {
          this.slideToIndex = (0, _lodash2.default)(this._unthrottledSlideToIndex, this.props.slideDuration, {
            trailing: false
          });
        }

        if (this.props.lazyLoad && (!prevProps.lazyLoad || itemsChanged)) {
          this._lazyLoaded = [];
        }

        if (startIndexUpdated || itemsChanged) {
          this.setState({
            currentIndex: this.props.startIndex
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('keydown', this._handleKeyDown);

        this._offScreenChangeEvent();

        if (this._intervalId) {
          window.clearInterval(this._intervalId);
          this._intervalId = null;
        }

        if (this.resizeObserver && this._imageGallerySlideWrapper) {
          this.resizeObserver.unobserve(this._imageGallerySlideWrapper);
        }

        if (this._transitionTimer) {
          window.clearTimeout(this._transitionTimer);
        }

        if (this._createResizeObserver) {
          this._createResizeObserver();
        }
      }
    }, {
      key: 'play',
      value: function play() {
        var _this2 = this;

        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (!this._intervalId) {
          var _props = this.props,
              slideInterval = _props.slideInterval,
              slideDuration = _props.slideDuration;
          this.setState({
            isPlaying: true
          });
          this._intervalId = window.setInterval(function () {
            if (!_this2.props.infinite && !_this2._canSlideRight()) {
              _this2.pause();
            } else {
              _this2.slideToIndex(_this2.state.currentIndex + 1);
            }
          }, Math.max(slideInterval, slideDuration));

          if (this.props.onPlay && callback) {
            this.props.onPlay(this.state.currentIndex);
          }
        }
      }
    }, {
      key: 'pause',
      value: function pause() {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (this._intervalId) {
          window.clearInterval(this._intervalId);
          this._intervalId = null;
          this.setState({
            isPlaying: false
          });

          if (this.props.onPause && callback) {
            this.props.onPause(this.state.currentIndex);
          }
        }
      }
    }, {
      key: 'setModalFullscreen',
      value: function setModalFullscreen(state) {
        this.setState({
          modalFullscreen: state
        }); // manually call because browser does not support screenchange events

        if (this.props.onScreenChange) {
          this.props.onScreenChange(state);
        }
      }
    }, {
      key: 'fullScreen',
      value: function fullScreen() {
        var gallery = this._imageGallery;

        if (this.props.useBrowserFullscreen) {
          if (gallery.requestFullscreen) {
            gallery.requestFullscreen();
          } else if (gallery.msRequestFullscreen) {
            gallery.msRequestFullscreen();
          } else if (gallery.mozRequestFullScreen) {
            gallery.mozRequestFullScreen();
          } else if (gallery.webkitRequestFullscreen) {
            gallery.webkitRequestFullscreen();
          } else {
            // fallback to fullscreen modal for unsupported browsers
            this.setModalFullscreen(true);
          }
        } else {
          this.setModalFullscreen(true);
        }

        this.setState({
          isFullscreen: true
        });
      }
    }, {
      key: 'exitFullScreen',
      value: function exitFullScreen() {
        if (this.state.isFullscreen) {
          if (this.props.useBrowserFullscreen) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            } else {
              // fallback to fullscreen modal for unsupported browsers
              this.setModalFullscreen(false);
            }
          } else {
            this.setModalFullscreen(false);
          }

          this.setState({
            isFullscreen: false
          });
        }
      }
    }, {
      key: 'getCurrentIndex',
      value: function getCurrentIndex() {
        return this.state.currentIndex;
      }
    }, {
      key: '_onScreenChangeEvent',
      value: function _onScreenChangeEvent() {
        var _this3 = this;

        screenChangeEvents.map(function (eventName) {
          document.addEventListener(eventName, _this3._handleScreenChange);
        });
      }
    }, {
      key: '_offScreenChangeEvent',
      value: function _offScreenChangeEvent() {
        var _this4 = this;

        screenChangeEvents.map(function (eventName) {
          document.removeEventListener(eventName, _this4._handleScreenChange);
        });
      }
    }, {
      key: '_isThumbnailVertical',
      value: function _isThumbnailVertical() {
        var thumbnailPosition = this.props.thumbnailPosition;
        return thumbnailPosition === 'left' || thumbnailPosition === 'right';
      }
    }, {
      key: '_setScrollDirection',
      value: function _setScrollDirection(dir) {
        var _state = this.state,
            scrollingUpDown = _state.scrollingUpDown,
            scrollingLeftRight = _state.scrollingLeftRight;

        if (!scrollingUpDown && !scrollingLeftRight) {
          if (dir === es.LEFT || dir === es.RIGHT) {
            this.setState({
              scrollingLeftRight: true
            });
          } else {
            this.setState({
              scrollingUpDown: true
            });
          }
        }
      }
    }, {
      key: '_handleOnSwipedTo',
      value: function _handleOnSwipedTo(side, isFlick) {
        var _state2 = this.state,
            currentIndex = _state2.currentIndex,
            isTransitioning = _state2.isTransitioning;
        var slideTo = currentIndex;

        if ((this._sufficientSwipeOffset() || isFlick) && !isTransitioning) {
          slideTo += side;
        }

        if (side < 0) {
          if (!this._canSlideLeft()) {
            slideTo = currentIndex;
          }
        } else {
          if (!this._canSlideRight()) {
            slideTo = currentIndex;
          }
        }

        this._unthrottledSlideToIndex(slideTo);
      }
    }, {
      key: '_sufficientSwipeOffset',
      value: function _sufficientSwipeOffset() {
        return Math.abs(this.state.offsetPercentage) > this.props.swipeThreshold;
      }
    }, {
      key: '_canNavigate',
      value: function _canNavigate() {
        return this.props.items.length >= 2;
      }
    }, {
      key: '_canSlideLeft',
      value: function _canSlideLeft() {
        return this.props.infinite || (this.props.isRTL ? this._canSlideNext() : this._canSlidePrevious());
      }
    }, {
      key: '_canSlideRight',
      value: function _canSlideRight() {
        return this.props.infinite || (this.props.isRTL ? this._canSlidePrevious() : this._canSlideNext());
      }
    }, {
      key: '_canSlidePrevious',
      value: function _canSlidePrevious() {
        return this.state.currentIndex > 0;
      }
    }, {
      key: '_canSlideNext',
      value: function _canSlideNext() {
        return this.state.currentIndex < this.props.items.length - 1;
      }
    }, {
      key: '_slideThumbnailBar',
      value: function _slideThumbnailBar(previousIndex) {
        var _state3 = this.state,
            thumbsTranslate = _state3.thumbsTranslate,
            currentIndex = _state3.currentIndex;

        if (this.state.currentIndex === 0) {
          this._setThumbsTranslate(0);
        } else {
          var indexDifference = Math.abs(previousIndex - currentIndex);

          var scroll = this._getThumbsTranslate(indexDifference);

          if (scroll > 0) {
            if (previousIndex < currentIndex) {
              this._setThumbsTranslate(thumbsTranslate - scroll);
            } else if (previousIndex > currentIndex) {
              this._setThumbsTranslate(thumbsTranslate + scroll);
            }
          }
        }
      }
    }, {
      key: '_setThumbsTranslate',
      value: function _setThumbsTranslate(thumbsTranslate) {
        this.setState({
          thumbsTranslate: thumbsTranslate
        });
      }
    }, {
      key: '_getThumbsTranslate',
      value: function _getThumbsTranslate(indexDifference) {
        if (this.props.disableThumbnailScroll) {
          return 0;
        }

        var _state4 = this.state,
            thumbnailsWrapperWidth = _state4.thumbnailsWrapperWidth,
            thumbnailsWrapperHeight = _state4.thumbnailsWrapperHeight;
        var totalScroll = void 0;

        if (this._thumbnails) {
          // total scroll required to see the last thumbnail
          if (this._isThumbnailVertical()) {
            if (this._thumbnails.scrollHeight <= thumbnailsWrapperHeight) {
              return 0;
            }

            totalScroll = this._thumbnails.scrollHeight - thumbnailsWrapperHeight;
          } else {
            if (this._thumbnails.scrollWidth <= thumbnailsWrapperWidth || thumbnailsWrapperWidth <= 0) {
              return 0;
            }

            totalScroll = this._thumbnails.scrollWidth - thumbnailsWrapperWidth;
          }

          var totalThumbnails = this._thumbnails.children.length; // scroll-x required per index change

          var perIndexScroll = totalScroll / (totalThumbnails - 1);
          return indexDifference * perIndexScroll;
        }
      }
    }, {
      key: '_getAlignmentClassName',
      value: function _getAlignmentClassName(index) {
        /*
          Necessary for lazing loading
        */
        var currentIndex = this.state.currentIndex;
        var alignment = '';
        var leftClassName = 'left';
        var centerClassName = 'center';
        var rightClassName = 'right';

        switch (index) {
          case currentIndex - 1:
            alignment = ' ' + leftClassName;
            break;

          case currentIndex:
            alignment = ' ' + centerClassName;
            break;

          case currentIndex + 1:
            alignment = ' ' + rightClassName;
            break;
        }

        if (this.props.items.length >= 3 && this.props.infinite) {
          if (index === 0 && currentIndex === this.props.items.length - 1) {
            // set first slide as right slide if were sliding right from last slide
            alignment = ' ' + rightClassName;
          } else if (index === this.props.items.length - 1 && currentIndex === 0) {
            // set last slide as left slide if were sliding left from first slide
            alignment = ' ' + leftClassName;
          }
        }

        return alignment;
      }
    }, {
      key: '_isGoingFromFirstToLast',
      value: function _isGoingFromFirstToLast() {
        var _state5 = this.state,
            currentIndex = _state5.currentIndex,
            previousIndex = _state5.previousIndex;
        var totalSlides = this.props.items.length - 1;
        return previousIndex === 0 && currentIndex === totalSlides;
      }
    }, {
      key: '_isGoingFromLastToFirst',
      value: function _isGoingFromLastToFirst() {
        var _state6 = this.state,
            currentIndex = _state6.currentIndex,
            previousIndex = _state6.previousIndex;
        var totalSlides = this.props.items.length - 1;
        return previousIndex === totalSlides && currentIndex === 0;
      }
    }, {
      key: '_getTranslateXForTwoSlide',
      value: function _getTranslateXForTwoSlide(index) {
        // For taking care of infinite swipe when there are only two slides
        var _state7 = this.state,
            currentIndex = _state7.currentIndex,
            offsetPercentage = _state7.offsetPercentage,
            previousIndex = _state7.previousIndex;
        var baseTranslateX = -100 * currentIndex;
        var translateX = baseTranslateX + index * 100 + offsetPercentage; // keep track of user swiping direction

        if (offsetPercentage > 0) {
          this.direction = 'left';
        } else if (offsetPercentage < 0) {
          this.direction = 'right';
        } // when swiping make sure the slides are on the correct side


        if (currentIndex === 0 && index === 1 && offsetPercentage > 0) {
          translateX = -100 + offsetPercentage;
        } else if (currentIndex === 1 && index === 0 && offsetPercentage < 0) {
          translateX = 100 + offsetPercentage;
        }

        if (currentIndex !== previousIndex) {
          // when swiped move the slide to the correct side
          if (previousIndex === 0 && index === 0 && offsetPercentage === 0 && this.direction === 'left') {
            translateX = 100;
          } else if (previousIndex === 1 && index === 1 && offsetPercentage === 0 && this.direction === 'right') {
            translateX = -100;
          }
        } else {
          // keep the slide on the correct slide even when not a swipe
          if (currentIndex === 0 && index === 1 && offsetPercentage === 0 && this.direction === 'left') {
            translateX = -100;
          } else if (currentIndex === 1 && index === 0 && offsetPercentage === 0 && this.direction === 'right') {
            translateX = 100;
          }
        }

        return translateX;
      }
    }, {
      key: '_getThumbnailBarHeight',
      value: function _getThumbnailBarHeight() {
        if (this._isThumbnailVertical()) {
          return {
            height: this.state.gallerySlideWrapperHeight
          };
        }

        return {};
      }
    }, {
      key: '_shouldPushSlideOnInfiniteMode',
      value: function _shouldPushSlideOnInfiniteMode(index) {
        /*
          Push(show) slide if slide is the current slide, and the next slide
          OR
          The slide is going more than 1 slide left, or right, but not going from
          first to last and not going from last to first
           There is an edge case where if you go to the first or last slide, when they're
          not left, or right of each other they will try to catch up in the background
          so unless were going from first to last or vice versa we don't want the first
          or last slide to show up during our transition
        */
        return !this._slideIsTransitioning(index) || this._ignoreIsTransitioning() && !this._isFirstOrLastSlide(index);
      }
    }, {
      key: '_slideIsTransitioning',
      value: function _slideIsTransitioning(index) {
        /*
        returns true if the gallery is transitioning and the index is not the
        previous or currentIndex
        */
        var _state8 = this.state,
            isTransitioning = _state8.isTransitioning,
            previousIndex = _state8.previousIndex,
            currentIndex = _state8.currentIndex;
        var indexIsNotPreviousOrNextSlide = !(index === previousIndex || index === currentIndex);
        return isTransitioning && indexIsNotPreviousOrNextSlide;
      }
    }, {
      key: '_isFirstOrLastSlide',
      value: function _isFirstOrLastSlide(index) {
        var totalSlides = this.props.items.length - 1;
        var isLastSlide = index === totalSlides;
        var isFirstSlide = index === 0;
        return isLastSlide || isFirstSlide;
      }
    }, {
      key: '_ignoreIsTransitioning',
      value: function _ignoreIsTransitioning() {
        /*
          Ignore isTransitioning because were not going to sibling slides
          e.g. center to left or center to right
        */
        var _state9 = this.state,
            previousIndex = _state9.previousIndex,
            currentIndex = _state9.currentIndex;
        var totalSlides = this.props.items.length - 1; // we want to show the in between slides transition

        var slidingMoreThanOneSlideLeftOrRight = Math.abs(previousIndex - currentIndex) > 1;
        var notGoingFromFirstToLast = !(previousIndex === 0 && currentIndex === totalSlides);
        var notGoingFromLastToFirst = !(previousIndex === totalSlides && currentIndex === 0);
        return slidingMoreThanOneSlideLeftOrRight && notGoingFromFirstToLast && notGoingFromLastToFirst;
      }
    }, {
      key: '_getSlideStyle',
      value: function _getSlideStyle(index) {
        var _state10 = this.state,
            currentIndex = _state10.currentIndex,
            offsetPercentage = _state10.offsetPercentage;
        var _props2 = this.props,
            infinite = _props2.infinite,
            items = _props2.items,
            useTranslate3D = _props2.useTranslate3D,
            isRTL = _props2.isRTL;
        var baseTranslateX = -100 * currentIndex;
        var totalSlides = items.length - 1; // calculates where the other slides belong based on currentIndex
        // if it is RTL the base line should be reversed

        var translateX = (baseTranslateX + index * 100) * (isRTL ? -1 : 1) + offsetPercentage;

        if (infinite && items.length > 2) {
          if (currentIndex === 0 && index === totalSlides) {
            // make the last slide the slide before the first
            // if it is RTL the base line should be reversed
            translateX = -100 * (isRTL ? -1 : 1) + offsetPercentage;
          } else if (currentIndex === totalSlides && index === 0) {
            // make the first slide the slide after the last
            // if it is RTL the base line should be reversed
            translateX = 100 * (isRTL ? -1 : 1) + offsetPercentage;
          }
        } // Special case when there are only 2 items with infinite on


        if (infinite && items.length === 2) {
          translateX = this._getTranslateXForTwoSlide(index);
        }

        var translate = 'translate(' + translateX + '%, 0)';

        if (useTranslate3D) {
          translate = 'translate3d(' + translateX + '%, 0, 0)';
        }

        return {
          WebkitTransform: translate,
          MozTransform: translate,
          msTransform: translate,
          OTransform: translate,
          transform: translate
        };
      }
    }, {
      key: '_getThumbnailStyle',
      value: function _getThumbnailStyle() {
        var translate = void 0;
        var _props3 = this.props,
            useTranslate3D = _props3.useTranslate3D,
            isRTL = _props3.isRTL;
        var thumbsTranslate = this.state.thumbsTranslate;
        var verticalTranslateValue = isRTL ? thumbsTranslate * -1 : thumbsTranslate;

        if (this._isThumbnailVertical()) {
          translate = 'translate(0, ' + thumbsTranslate + 'px)';

          if (useTranslate3D) {
            translate = 'translate3d(0, ' + thumbsTranslate + 'px, 0)';
          }
        } else {
          translate = 'translate(' + verticalTranslateValue + 'px, 0)';

          if (useTranslate3D) {
            translate = 'translate3d(' + verticalTranslateValue + 'px, 0, 0)';
          }
        }

        return {
          WebkitTransform: translate,
          MozTransform: translate,
          msTransform: translate,
          OTransform: translate,
          transform: translate
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _this5 = this;

        var _state11 = this.state,
            currentIndex = _state11.currentIndex,
            isFullscreen = _state11.isFullscreen,
            modalFullscreen = _state11.modalFullscreen,
            isPlaying = _state11.isPlaying;
        var _props4 = this.props,
            infinite = _props4.infinite,
            slideOnThumbnailOver = _props4.slideOnThumbnailOver,
            isRTL = _props4.isRTL,
            lazyLoad = _props4.lazyLoad;

        var thumbnailStyle = this._getThumbnailStyle();

        var thumbnailPosition = this.props.thumbnailPosition;
        var slideLeft = this._slideLeft;
        var slideRight = this._slideRight;
        var slides = [];
        var thumbnails = [];
        var bullets = [];
        this.props.items.forEach(function (item, index) {
          var alignment = _this5._getAlignmentClassName(index);

          var originalClass = item.originalClass ? ' ' + item.originalClass : '';
          var thumbnailClass = item.thumbnailClass ? ' ' + item.thumbnailClass : '';
          var renderItem = item.renderItem || _this5.props.renderItem || _this5._renderItem;
          var renderThumbInner = item.renderThumbInner || _this5.props.renderThumbInner || _this5._renderThumbInner;
          var showItem = !lazyLoad || alignment || _this5._lazyLoaded[index];

          if (showItem && lazyLoad && !_this5._lazyLoaded[index]) {
            _this5._lazyLoaded[index] = true;
          }

          var slideStyle = _this5._getSlideStyle(index);

          var slide = _react2.default.createElement('div', {
            key: index,
            className: 'image-gallery-slide' + alignment + originalClass,
            style: _extends(slideStyle, _this5.state.style),
            onClick: _this5.props.onClick,
            onTouchMove: _this5.props.onTouchMove,
            onTouchEnd: _this5.props.onTouchEnd,
            onTouchStart: _this5.props.onTouchStart,
            onMouseOver: _this5.props.onMouseOver,
            onMouseLeave: _this5.props.onMouseLeave,
            role: _this5.props.onClick && 'button'
          }, showItem ? renderItem(item) : _react2.default.createElement('div', {
            style: {
              height: '100%'
            }
          }));

          if (infinite) {
            // don't add some slides while transitioning to avoid background transitions
            if (_this5._shouldPushSlideOnInfiniteMode(index)) {
              slides.push(slide);
            }
          } else {
            slides.push(slide);
          }

          if (_this5.props.showThumbnails) {
            thumbnails.push(_react2.default.createElement('a', {
              key: index,
              role: 'button',
              'aria-pressed': currentIndex === index ? 'true' : 'false',
              'aria-label': 'Go to Slide ' + (index + 1),
              className: 'image-gallery-thumbnail' + (currentIndex === index ? ' active' : '') + thumbnailClass,
              onMouseLeave: slideOnThumbnailOver ? _this5._onThumbnailMouseLeave : undefined,
              onMouseOver: function onMouseOver(event) {
                return slideOnThumbnailOver ? _this5._onThumbnailMouseOver(event, index) : undefined;
              },
              onClick: function onClick(event) {
                return _this5._onThumbnailClick(event, index);
              }
            }, renderThumbInner(item)));
          }

          if (_this5.props.showBullets) {
            var bulletOnClick = function bulletOnClick(event) {
              if (item.bulletOnClick) {
                item.bulletOnClick({
                  item: item,
                  itemIndex: index,
                  currentIndex: currentIndex
                });
              }

              return _this5.slideToIndex.call(_this5, index, event);
            };

            bullets.push(_react2.default.createElement('button', {
              key: index,
              type: 'button',
              className: ['image-gallery-bullet', currentIndex === index ? 'active' : '', item.bulletClass || ''].join(' '),
              onClick: bulletOnClick,
              'aria-pressed': currentIndex === index ? 'true' : 'false',
              'aria-label': 'Go to Slide ' + (index + 1)
            }));
          }
        });

        var slideWrapper = _react2.default.createElement('div', {
          ref: this._initGalleryResizing,
          className: 'image-gallery-slide-wrapper ' + thumbnailPosition + ' ' + (isRTL ? 'image-gallery-rtl' : '')
        }, this.props.renderCustomControls && this.props.renderCustomControls(), this.props.showFullscreenButton && this.props.renderFullscreenButton(this._toggleFullScreen, isFullscreen), this.props.showPlayButton && this.props.renderPlayPauseButton(this._togglePlay, isPlaying), this._canNavigate() ? [this.props.showNav && _react2.default.createElement('span', {
          key: 'navigation'
        }, this.props.renderLeftNav(slideLeft, !this._canSlideLeft()), this.props.renderRightNav(slideRight, !this._canSlideRight())), _react2.default.createElement(es.Swipeable, {
          className: 'image-gallery-swipe',
          key: 'swipeable',
          delta: 0,
          onSwiping: this._handleSwiping,
          onSwiped: this._handleOnSwiped
        }, _react2.default.createElement('div', {
          className: 'image-gallery-slides'
        }, slides))] : _react2.default.createElement('div', {
          className: 'image-gallery-slides'
        }, slides), this.props.showBullets && _react2.default.createElement('div', {
          className: 'image-gallery-bullets'
        }, _react2.default.createElement('div', {
          className: 'image-gallery-bullets-container',
          role: 'navigation',
          'aria-label': 'Bullet Navigation'
        }, bullets)), this.props.showIndex && _react2.default.createElement('div', {
          className: 'image-gallery-index'
        }, _react2.default.createElement('span', {
          className: 'image-gallery-index-current'
        }, this.state.currentIndex + 1), _react2.default.createElement('span', {
          className: 'image-gallery-index-separator'
        }, this.props.indexSeparator), _react2.default.createElement('span', {
          className: 'image-gallery-index-total'
        }, this.props.items.length)));

        var classNames = ['image-gallery', this.props.additionalClass, modalFullscreen ? 'fullscreen-modal' : ''].filter(function (name) {
          return typeof name === 'string';
        }).join(' ');
        return _react2.default.createElement('div', {
          ref: function ref(i) {
            return _this5._imageGallery = i;
          },
          className: classNames,
          'aria-live': 'polite'
        }, _react2.default.createElement('div', {
          className: 'image-gallery-content' + (isFullscreen ? ' fullscreen' : '')
        }, (thumbnailPosition === 'bottom' || thumbnailPosition === 'right') && slideWrapper, this.props.showThumbnails && _react2.default.createElement('div', {
          className: 'image-gallery-thumbnails-wrapper ' + thumbnailPosition + ' ' + (!this._isThumbnailVertical() && isRTL ? 'thumbnails-wrapper-rtl' : ''),
          style: this._getThumbnailBarHeight()
        }, _react2.default.createElement('div', {
          className: 'image-gallery-thumbnails',
          ref: function ref(i) {
            return _this5._thumbnailsWrapper = i;
          }
        }, _react2.default.createElement('div', {
          ref: function ref(t) {
            return _this5._thumbnails = t;
          },
          className: 'image-gallery-thumbnails-container',
          style: thumbnailStyle,
          'aria-label': 'Thumbnail Navigation'
        }, thumbnails))), (thumbnailPosition === 'top' || thumbnailPosition === 'left') && slideWrapper));
      }
    }]);

    return ImageGallery;
  }(_react2.default.Component);

  ImageGallery.propTypes = {
    flickThreshold: _propTypes2.default.number,
    items: _propTypes2.default.array.isRequired,
    showNav: _propTypes2.default.bool,
    autoPlay: _propTypes2.default.bool,
    lazyLoad: _propTypes2.default.bool,
    infinite: _propTypes2.default.bool,
    showIndex: _propTypes2.default.bool,
    showBullets: _propTypes2.default.bool,
    showThumbnails: _propTypes2.default.bool,
    showPlayButton: _propTypes2.default.bool,
    showFullscreenButton: _propTypes2.default.bool,
    disableThumbnailScroll: _propTypes2.default.bool,
    disableArrowKeys: _propTypes2.default.bool,
    disableSwipe: _propTypes2.default.bool,
    useBrowserFullscreen: _propTypes2.default.bool,
    preventDefaultTouchmoveEvent: _propTypes2.default.bool,
    defaultImage: _propTypes2.default.string,
    indexSeparator: _propTypes2.default.string,
    thumbnailPosition: _propTypes2.default.string,
    startIndex: _propTypes2.default.number,
    slideDuration: _propTypes2.default.number,
    slideInterval: _propTypes2.default.number,
    slideOnThumbnailOver: _propTypes2.default.bool,
    swipeThreshold: _propTypes2.default.number,
    swipingTransitionDuration: _propTypes2.default.number,
    onSlide: _propTypes2.default.func,
    onScreenChange: _propTypes2.default.func,
    onPause: _propTypes2.default.func,
    onPlay: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    onImageLoad: _propTypes2.default.func,
    onImageError: _propTypes2.default.func,
    onTouchMove: _propTypes2.default.func,
    onTouchEnd: _propTypes2.default.func,
    onTouchStart: _propTypes2.default.func,
    onMouseOver: _propTypes2.default.func,
    onMouseLeave: _propTypes2.default.func,
    onThumbnailError: _propTypes2.default.func,
    onThumbnailClick: _propTypes2.default.func,
    renderCustomControls: _propTypes2.default.func,
    renderLeftNav: _propTypes2.default.func,
    renderRightNav: _propTypes2.default.func,
    renderPlayPauseButton: _propTypes2.default.func,
    renderFullscreenButton: _propTypes2.default.func,
    renderItem: _propTypes2.default.func,
    stopPropagation: _propTypes2.default.bool,
    additionalClass: _propTypes2.default.string,
    useTranslate3D: _propTypes2.default.bool,
    isRTL: _propTypes2.default.bool
  };
  ImageGallery.defaultProps = {
    items: [],
    showNav: true,
    autoPlay: false,
    lazyLoad: false,
    infinite: true,
    showIndex: false,
    showBullets: false,
    showThumbnails: true,
    showPlayButton: true,
    showFullscreenButton: true,
    disableThumbnailScroll: false,
    disableArrowKeys: false,
    disableSwipe: false,
    useTranslate3D: true,
    isRTL: false,
    useBrowserFullscreen: true,
    preventDefaultTouchmoveEvent: false,
    flickThreshold: 0.4,
    stopPropagation: false,
    indexSeparator: ' / ',
    thumbnailPosition: 'bottom',
    startIndex: 0,
    slideDuration: 450,
    swipingTransitionDuration: 0,
    slideInterval: 3000,
    swipeThreshold: 30,
    renderLeftNav: function renderLeftNav(onClick, disabled) {
      return _react2.default.createElement('button', {
        type: 'button',
        className: 'image-gallery-left-nav',
        disabled: disabled,
        onClick: onClick,
        'aria-label': 'Previous Slide'
      });
    },
    renderRightNav: function renderRightNav(onClick, disabled) {
      return _react2.default.createElement('button', {
        type: 'button',
        className: 'image-gallery-right-nav',
        disabled: disabled,
        onClick: onClick,
        'aria-label': 'Next Slide'
      });
    },
    renderPlayPauseButton: function renderPlayPauseButton(onClick, isPlaying) {
      return _react2.default.createElement('button', {
        type: 'button',
        className: 'image-gallery-play-button' + (isPlaying ? ' active' : ''),
        onClick: onClick,
        'aria-label': 'Play or Pause Slideshow'
      });
    },
    renderFullscreenButton: function renderFullscreenButton(onClick, isFullscreen) {
      return _react2.default.createElement('button', {
        type: 'button',
        className: 'image-gallery-fullscreen-button' + (isFullscreen ? ' active' : ''),
        onClick: onClick,
        'aria-label': 'Open Fullscreen'
      });
    }
  };
  exports.default = ImageGallery;
});
var ReactImageGallery = unwrapExports(imageGallery);

var EmbedVideo = function EmbedVideo(props) {
  var src = props.src;
  return /*#__PURE__*/React.createElement("div", {
    className: "image-gallery-div"
  }, /*#__PURE__*/React.createElement("iframe", {
    className: "image-gallery-iframe",
    src: src,
    height: "315",
    width: "560",
    frameBorder: "0",
    allowFullScreen: true
  }));
};

EmbedVideo.propTypes = {
  src: PropTypes__default.string
};
var css$1 = "@charset \"UTF-8\";\n/*!\n  Ionicons, v2.0.0\n  Created by Ben Sperry for the Ionic Framework, http://ionicons.com/\n  https://twitter.com/benjsperry  https://twitter.com/ionicframework\n  MIT License: https://github.com/driftyco/ionicons\n\n  Android-style icons originally built by Google’s\n  Material Design Icons: https://github.com/google/material-design-icons\n  used under CC BY http://creativecommons.org/licenses/by/4.0/\n  Modified icons to fit ionicon’s grid from original.\n*/\n@font-face {\n  font-family: \"Ionicons\";\n  src: url(\"https://cdnjs.cloudflare.com/ajax/libs/ionicons/2.0.1/fonts/ionicons.eot?v=2.0.0\");\n  src: url(\"https://cdnjs.cloudflare.com/ajax/libs/ionicons/2.0.1/fonts/ionicons.eot?v=2.0.0#iefix\") format(\"embedded-opentype\"), url(\"https://cdnjs.cloudflare.com/ajax/libs/ionicons/2.0.1/fonts/ionicons.ttf?v=2.0.0\") format(\"truetype\"), url(\"https://cdnjs.cloudflare.com/ajax/libs/ionicons/2.0.1/fonts/ionicons.woff?v=2.0.0\") format(\"woff\"), url(\"https://cdnjs.cloudflare.com/ajax/libs/ionicons/2.0.1/fonts/ionicons.svg?v=2.0.0#Ionicons\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n.image-gallery-fullscreen-button::before,\n.image-gallery-play-button::before,\n.image-gallery-left-nav::before,\n.image-gallery-right-nav::before {\n  display: inline-block;\n  font-family: \"Ionicons\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  text-rendering: auto;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.image-gallery {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent; }\n  .image-gallery.fullscreen-modal {\n    background: #000;\n    bottom: 0;\n    height: 100%;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    width: 100%;\n    z-index: 5; }\n    .image-gallery.fullscreen-modal .image-gallery-content {\n      top: 50%;\n      transform: translateY(-50%); }\n\n.image-gallery-content {\n  position: relative;\n  line-height: 0;\n  top: 0; }\n  .image-gallery-content.fullscreen {\n    background: #000; }\n    .image-gallery-content.fullscreen .image-gallery-slide {\n      background: #000; }\n\n.image-gallery-slide-wrapper {\n  position: relative; }\n  .image-gallery-slide-wrapper.left, .image-gallery-slide-wrapper.right {\n    display: inline-block;\n    width: calc(100% - 113px); }\n    @media (max-width: 768px) {\n      .image-gallery-slide-wrapper.left, .image-gallery-slide-wrapper.right {\n        width: calc(100% - 84px); } }\n  .image-gallery-slide-wrapper.image-gallery-rtl {\n    direction: rtl; }\n\n.image-gallery-fullscreen-button,\n.image-gallery-play-button,\n.image-gallery-left-nav,\n.image-gallery-right-nav {\n  appearance: none;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: none;\n  position: absolute;\n  z-index: 4; }\n  .image-gallery-fullscreen-button::before,\n  .image-gallery-play-button::before,\n  .image-gallery-left-nav::before,\n  .image-gallery-right-nav::before {\n    color: #fff;\n    line-height: .7;\n    text-shadow: 0 2px 2px #1a1a1a;\n    transition: color .2s ease-out; }\n  .image-gallery-fullscreen-button:hover::before,\n  .image-gallery-play-button:hover::before,\n  .image-gallery-left-nav:hover::before,\n  .image-gallery-right-nav:hover::before {\n    color: #337ab7; }\n    @media (max-width: 768px) {\n      .image-gallery-fullscreen-button:hover::before,\n      .image-gallery-play-button:hover::before,\n      .image-gallery-left-nav:hover::before,\n      .image-gallery-right-nav:hover::before {\n        color: #fff; } }\n\n.image-gallery-fullscreen-button,\n.image-gallery-play-button {\n  bottom: 0; }\n  .image-gallery-fullscreen-button::before,\n  .image-gallery-play-button::before {\n    font-size: 2.7em;\n    padding: 15px 20px;\n    text-shadow: 0 1px 1px #1a1a1a; }\n    @media (max-width: 768px) {\n      .image-gallery-fullscreen-button::before,\n      .image-gallery-play-button::before {\n        font-size: 2.4em; } }\n    @media (max-width: 480px) {\n      .image-gallery-fullscreen-button::before,\n      .image-gallery-play-button::before {\n        font-size: 2em; } }\n  .image-gallery-fullscreen-button:hover::before,\n  .image-gallery-play-button:hover::before {\n    color: #fff;\n    transform: scale(1.1); }\n    @media (max-width: 768px) {\n      .image-gallery-fullscreen-button:hover::before,\n      .image-gallery-play-button:hover::before {\n        transform: none; } }\n\n.image-gallery-fullscreen-button {\n  right: 0; }\n  .image-gallery-fullscreen-button::before {\n    content: \"\"; }\n  .image-gallery-fullscreen-button.active::before {\n    content: \"\"; }\n  .image-gallery-fullscreen-button.active:hover::before {\n    transform: scale(0.9); }\n\n.image-gallery-play-button {\n  left: 0; }\n  .image-gallery-play-button::before {\n    content: \"\"; }\n  .image-gallery-play-button.active::before {\n    content: \"\"; }\n\n.image-gallery-left-nav,\n.image-gallery-right-nav {\n  color: #fff;\n  font-size: 5em;\n  padding: 50px 15px;\n  top: 50%;\n  transform: translateY(-50%); }\n  .image-gallery-left-nav[disabled],\n  .image-gallery-right-nav[disabled] {\n    cursor: disabled;\n    opacity: .6;\n    pointer-events: none; }\n  @media (max-width: 768px) {\n    .image-gallery-left-nav,\n    .image-gallery-right-nav {\n      font-size: 3.4em;\n      padding: 20px 15px; } }\n  @media (max-width: 480px) {\n    .image-gallery-left-nav,\n    .image-gallery-right-nav {\n      font-size: 2.4em;\n      padding: 0 15px; } }\n\n.image-gallery-left-nav {\n  left: 0; }\n  .image-gallery-left-nav::before {\n    content: \"\"; }\n\n.image-gallery-right-nav {\n  right: 0; }\n  .image-gallery-right-nav::before {\n    content: \"\"; }\n\n.image-gallery-slides {\n  line-height: 0;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap; }\n\n.image-gallery-slide {\n  background: #fff;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%; }\n  .image-gallery-slide.center {\n    position: relative; }\n  .image-gallery-slide img {\n    width: 100%; }\n  .image-gallery-slide .image-gallery-description {\n    background: rgba(0, 0, 0, 0.4);\n    bottom: 70px;\n    color: #fff;\n    left: 0;\n    line-height: 1;\n    padding: 10px 20px;\n    position: absolute;\n    white-space: normal; }\n    @media (max-width: 768px) {\n      .image-gallery-slide .image-gallery-description {\n        bottom: 45px;\n        font-size: .8em;\n        padding: 8px 15px; } }\n\n.image-gallery-bullets {\n  bottom: 20px;\n  left: 0;\n  margin: 0 auto;\n  position: absolute;\n  right: 0;\n  width: 80%;\n  z-index: 4; }\n  .image-gallery-bullets .image-gallery-bullets-container {\n    margin: 0;\n    padding: 0;\n    text-align: center; }\n  .image-gallery-bullets .image-gallery-bullet {\n    appearance: none;\n    background-color: transparent;\n    border: 1px solid #fff;\n    border-radius: 50%;\n    box-shadow: 0 1px 0 #1a1a1a;\n    cursor: pointer;\n    display: inline-block;\n    margin: 0 5px;\n    outline: none;\n    padding: 5px; }\n    @media (max-width: 768px) {\n      .image-gallery-bullets .image-gallery-bullet {\n        margin: 0 3px;\n        padding: 3px; } }\n    @media (max-width: 480px) {\n      .image-gallery-bullets .image-gallery-bullet {\n        padding: 2.7px; } }\n    .image-gallery-bullets .image-gallery-bullet.active {\n      background: #fff; }\n\n.image-gallery-thumbnails-wrapper {\n  position: relative; }\n  .image-gallery-thumbnails-wrapper.thumbnails-wrapper-rtl {\n    direction: rtl; }\n  .image-gallery-thumbnails-wrapper.left, .image-gallery-thumbnails-wrapper.right {\n    display: inline-block;\n    vertical-align: top;\n    width: 108px; }\n    @media (max-width: 768px) {\n      .image-gallery-thumbnails-wrapper.left, .image-gallery-thumbnails-wrapper.right {\n        width: 81px; } }\n    .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails, .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails {\n      height: 100%;\n      width: 100%;\n      left: 0;\n      padding: 0;\n      position: absolute;\n      top: 0; }\n      .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails .image-gallery-thumbnail {\n        display: block;\n        margin-right: 0;\n        padding: 0; }\n        .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail {\n          margin-left: 0; }\n  .image-gallery-thumbnails-wrapper.left {\n    margin-right: 5px; }\n    @media (max-width: 768px) {\n      .image-gallery-thumbnails-wrapper.left {\n        margin-right: 3px; } }\n  .image-gallery-thumbnails-wrapper.right {\n    margin-left: 5px; }\n    @media (max-width: 768px) {\n      .image-gallery-thumbnails-wrapper.right {\n        margin-left: 3px; } }\n\n.image-gallery-thumbnails {\n  overflow: hidden;\n  padding: 5px 0; }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnails {\n      padding: 3px 0; } }\n  .image-gallery-thumbnails .image-gallery-thumbnails-container {\n    cursor: pointer;\n    text-align: center;\n    transition: transform .45s ease-out;\n    white-space: nowrap; }\n\n.image-gallery-thumbnail {\n  display: inline-block;\n  border: 4px solid transparent;\n  transition: border .3s ease-out;\n  width: 100px; }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnail {\n      border: 3px solid transparent;\n      width: 75px; } }\n  .image-gallery-thumbnail + .image-gallery-thumbnail {\n    margin-left: 2px; }\n  .image-gallery-thumbnail .image-gallery-thumbnail-inner {\n    position: relative; }\n  .image-gallery-thumbnail img {\n    vertical-align: middle;\n    width: 100%; }\n  .image-gallery-thumbnail.active {\n    border: 4px solid #337ab7; }\n    @media (max-width: 768px) {\n      .image-gallery-thumbnail.active {\n        border: 3px solid #337ab7; } }\n\n.image-gallery-thumbnail-label {\n  box-sizing: border-box;\n  color: white;\n  font-size: 1em;\n  left: 0;\n  line-height: 1em;\n  padding: 5%;\n  position: absolute;\n  top: 50%;\n  text-shadow: 1px 1px 0 black;\n  transform: translateY(-50%);\n  white-space: normal;\n  width: 100%; }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnail-label {\n      font-size: .8em;\n      line-height: .8em; } }\n\n.image-gallery-index {\n  background: rgba(0, 0, 0, 0.4);\n  color: #fff;\n  line-height: 1;\n  padding: 10px 20px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 4; }\n  @media (max-width: 768px) {\n    .image-gallery-index {\n      font-size: .8em;\n      padding: 5px 10px; } }\n";
styleInject(css$1);
var css$2 = ".image-gallery-content:not(.fullscreen) .image-gallery-image {\n  width: 100%;\n  height: 0;\n  padding-top: 75%;\n  position: relative;\n}\n\n.image-gallery-content:not(.fullscreen) .image-gallery-image img,\n.image-gallery-content:not(.fullscreen) .image-gallery-image .image-gallery-iframe {\n  position: absolute;\n  top: 0;\n  object-fit: contain;\n  object-position: center center;\n  width: 100%;\n  height: 100%;\n}\n\n.image-gallery-content.fullscreen .image-gallery-image img {\n  object-fit: contain;\n  width: 100%;\n  height: 100vH;\n}\n\n.image-gallery-content.fullscreen .image-gallery-image .image-gallery-div {\n  padding-bottom: 56.25%;\n  margin-bottom: 0;\n  position: relative;\n  height: 0;\n  overflow: hidden;\n}\n\n.image-gallery-content.fullscreen .image-gallery-image .image-gallery-iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.image-gallery-thumbnail {\n  width: 120px\n}\n\n.image-gallery-thumbnail img {\n  width: 100%;\n  height: 75px;\n  overflow: hidden;\n  object-fit: contain;\n}";
styleInject(css$2);
var badVideoThumbnail = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20441.61%20351.59%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3Anone%3B%7D.cls-2%7Bfill%3A%23cbcbcb%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ctitle%3EArtboard%201%20copy-%3C%2Ftitle%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M324.19%2C21.08h-246A45.7%2C45.7%2C0%2C0%2C0%2C32.59%2C66.76V235.55a45.7%2C45.7%2C0%2C0%2C0%2C45.64%2C45.64H232.14A105.39%2C105.39%2C0%2C0%2C1%2C369.83%2C156.68v-90A45.7%2C45.7%2C0%2C0%2C0%2C324.19%2C21.08ZM246.37%2C160l-80%2C46.21a10.29%2C10.29%2C0%2C0%2C1-15.42-8.9V104.92A10.29%2C10.29%2C0%2C0%2C1%2C166.33%2C96l80%2C46.21a10.28%2C10.28%2C0%2C0%2C1%2C0%2C17.81Z%22%2F%3E%3Cpolygon%20class%3D%22cls-1%22%20points%3D%22171.48%20179.53%20220.66%20151.13%20171.48%20122.74%20171.48%20179.53%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M78.23%2C281.19a45.7%2C45.7%2C0%2C0%2C1-45.64-45.64V66.76A45.7%2C45.7%2C0%2C0%2C1%2C78.23%2C21.08h246a45.7%2C45.7%2C0%2C0%2C1%2C45.64%2C45.64v90a104.8%2C104.8%2C0%2C0%2C1%2C20.56%2C10V66.76A66.27%2C66.27%2C0%2C0%2C0%2C324.19.52h-246A66.27%2C66.27%2C0%2C0%2C0%2C12%2C66.72V235.55a66.27%2C66.27%2C0%2C0%2C0%2C66.2%2C66.2H239.56a104.27%2C104.27%2C0%2C0%2C1-7.42-20.56Z%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M246.37%2C142.23%2C166.33%2C96a10.29%2C10.29%2C0%2C0%2C0-15.42%2C8.9v92.43a10.29%2C10.29%2C0%2C0%2C0%2C15.42%2C8.9l80-46.21a10.28%2C10.28%2C0%2C0%2C0%2C0-17.81Zm-74.89%2C37.3V122.74l49.18%2C28.39Z%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M334.47%2C160.85A95.11%2C95.11%2C0%2C1%2C0%2C429.58%2C256%2C95.22%2C95.22%2C0%2C0%2C0%2C334.47%2C160.85Zm0%2C169.66A74.55%2C74.55%2C0%2C1%2C1%2C409%2C256%2C74.63%2C74.63%2C0%2C0%2C1%2C334.47%2C330.51Z%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M345.24%2C301.35a10.77%2C10.77%2C0%2C1%2C0-10.77%2C10.78A10.77%2C10.77%2C0%2C0%2C0%2C345.24%2C301.35Z%22%2F%3E%3Cpath%20class%3D%22cls-2%22%20d%3D%22M330.82%2C280.36a3.72%2C3.72%2C0%2C0%2C0%2C7.3%2C0l13.44-66.69a3.73%2C3.73%2C0%2C0%2C0-3.65-4.46H321a3.73%2C3.73%2C0%2C0%2C0-3.65%2C4.46Z%22%2F%3E%3C%2Fsvg%3E";

var getGalleryImages = function getGalleryImages(images, defaultImageUrl, videoThumbnailUrl, renderEmbeddedVideo, renderModelCanvas) {
  if (!defaultImageUrl) {
    defaultImageUrl = noImageSvg;
  }

  if (!images || images.length === 0) {
    return [{
      original: defaultImageUrl
    }];
  }

  var passImages = images.map(function (image, index) {
    var galleryImage = {
      original: !image.original ? image.thumbnail : image.original,
      thumbnail: !image.thumbnail ? image.original : image.thumbnail,
      embedUrl: image.embedUrl,
      description: image.description
    };

    if (image.embedUrl && image.embedUrl.trim() !== '') {
      if (image.embedUrl.includes('youtube.com') || image.embedUrl.includes('youtu.be')) {
        var videoId = getYouTubeVideoId(image.embedUrl);

        if (!videoId) {
          galleryImage.embedUrl = null;
          galleryImage.original = badVideoThumbnail;
          galleryImage.thumbnail = badVideoThumbnail;
        } else {
          galleryImage.embedUrl = "//www.youtube.com/embed/".concat(videoId);
          galleryImage.original = "//i.ytimg.com/vi/".concat(videoId, "/maxresdefault.jpg");
          galleryImage.thumbnail = "//i.ytimg.com/vi/".concat(videoId, "/hqdefault.jpg");
        }
      } else {
        galleryImage.embedUrl = image.embedUrl.substring(image.embedUrl.indexOf('/'));
        galleryImage.original = videoThumbnailUrl;
        galleryImage.thumbnail = videoThumbnailUrl;
      }

      if (galleryImage.embedUrl == null) {
        galleryImage.renderItem = null;
      } else {
        galleryImage.renderItem = renderEmbeddedVideo;
      }
    } else {
      if (galleryImage.original && galleryImage.original.includes('.obj')) {
        galleryImage.renderItem = renderModelCanvas;
      }

      if (!galleryImage.original) {
        if (index === 0) {
          galleryImage = {
            original: defaultImageUrl
          };
        } else if (index >= 1) {
          galleryImage = null;
        }
      }
    }

    return galleryImage;
  });
  var video = null;
  var onlyImages = passImages.filter(function (image) {
    if (image.embedUrl) {
      video = image;
    } else {
      return image;
    }
  });
  onlyImages.splice(1, 0, video);
  return onlyImages.filter(function (image) {
    return !!image;
  });
};

var getYouTubeVideoId = function getYouTubeVideoId(url) {
  if (url.includes('youtube.com')) {
    var params = getQueryStringParams(url);
    return params['v'];
  } else if (url.includes('youtu.be')) {
    var _params = url.substring(url.lastIndexOf('/') + 1);

    if (_params === '' || _params === 'www.youtu.be') {
      _params = undefined;
    }

    return _params;
  }
};

var getQueryStringParams = function getQueryStringParams(url) {
  var query = url.slice(url.indexOf('?'));
  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {}) : {};
};

var ImageGallery = function ImageGallery(props) {
  var images = props.images,
      defaultImageUrl = props.defaultImageUrl,
      videoThumbnailUrl = props.videoThumbnailUrl;

  var renderEmbeddedVideo = function renderEmbeddedVideo(item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "image-gallery-image"
    }, /*#__PURE__*/React.createElement(EmbedVideo, {
      src: item.embedUrl
    }));
  };

  var renderModelCanvas = function renderModelCanvas() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("canvas", {
      style: {
        height: '100%',
        width: '100%'
      },
      id: "c"
    }));
  };

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      prunedImages = _useState2[0],
      setPrunedImages = _useState2[1];

  var resolveGoodImage = function resolveGoodImage(image) {
    return new Promise(function (resolve, reject) {
      if (image.embedUrl) {
        resolve(image);
      } else {
        if (image.original.includes('.obj')) {
          resolve(image);
        }
      }

      var img = new Image();
      img.src = image.thumbnail || image.original;

      img.onload = function () {
        return resolve(image);
      };

      img.onerror = function () {
        return reject('bad image');
      };
    });
  };

  useEffect(function () {
    var imagePromises = images.map(function (image) {
      return resolveGoodImage(image)["catch"](function () {});
    });
    Promise.all(imagePromises).then(function (responses) {
      var undefinedCleaned = responses.filter(function (response) {
        return !!response;
      });
      setPrunedImages(undefinedCleaned);
    });
  }, [images]);
  var passImages = getGalleryImages(prunedImages, defaultImageUrl, videoThumbnailUrl, renderEmbeddedVideo, renderModelCanvas);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      visibility: prunedImages === null ? 'hidden' : 'visible'
    }
  }, /*#__PURE__*/React.createElement(ReactImageGallery, {
    showIndex: true,
    items: passImages,
    showPlayButton: false,
    showFullscreenButton: passImages.length > 0,
    showThumbnails: passImages.length > 1,
    defaultImage: defaultImageUrl,
    lazyLoad: true
  }));
};

ImageGallery.propTypes = {
  images: arrayOf(shape({
    original: string,
    thumbnail: string,
    embedUrl: string,
    description: string,
    embedModel: string
  })),
  defaultImageUrl: string.isRequired,
  videoThumbnailUrl: string.isRequired
};
ImageGallery.defaultProps = {
  images: []
};
var defaultVideoThumb = "data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20441.61%20351.59%22%3E%20%20%3Cdefs%3E%20%20%20%20%3Cstyle%3E.cls-1%7Bfill%3A%23cbcbcb%3B%7D%3C%2Fstyle%3E%20%20%3C%2Fdefs%3E%20%20%3Ctitle%3Emissing-videoArtboard%204%3C%2Ftitle%3E%20%20%3Cpath%20class%3D%22cls-1%22%20%20%20%20d%3D%22M364.34%2C0H77.27A77.35%2C77.35%2C0%2C0%2C0%2C0%2C77.27V274.32a77.35%2C77.35%2C0%2C0%2C0%2C77.27%2C77.27H364.34a77.35%2C77.35%2C0%2C0%2C0%2C77.27-77.27v-197A77.35%2C77.35%2C0%2C0%2C0%2C364.34%2C0Zm53.27%2C274.32a53.33%2C53.33%2C0%2C0%2C1-53.27%2C53.27H77.27A53.33%2C53.33%2C0%2C0%2C1%2C24%2C274.32v-197A53.33%2C53.33%2C0%2C0%2C1%2C77.27%2C24H364.34a53.33%2C53.33%2C0%2C0%2C1%2C53.27%2C53.27Z%22%2F%3E%20%20%3Cpath%20class%3D%22cls-1%22%20%20%20%20d%3D%22M273.51%2C165.4%2C180.1%2C111.47a12%2C12%2C0%2C0%2C0-18%2C10.39V229.73a12%2C12%2C0%2C0%2C0%2C18%2C10.39l93.41-53.93a12%2C12%2C0%2C0%2C0%2C0-20.79ZM186.1%2C208.94V142.65l57.41%2C33.14Z%22%2F%3E%3C%2Fsvg%3E";
var socialLinks = [{
  icon: "Facebook",
  url: "https://facebook.com/Proxibid",
  id: "facebook-link"
}, {
  icon: "Twitter",
  url: "https://twitter.com/Proxibid",
  id: "twitter-link"
}, {
  icon: "Youtube",
  url: "https://www.youtube.com/user/Proxibid",
  id: "youtube-link"
}, {
  icon: "Linkedin",
  url: "https://www.linkedin.com/company/proxibid",
  id: "linkedin-link"
}, {
  icon: "Instagram",
  url: "https://www.instagram.com/Proxibid",
  id: "instagram-link"
}];
var aboutUs = [{
  label: "About Us",
  url: "https://discover.proxibid.com/about-us/",
  id: "about-us-link"
}, {
  label: "Leadership",
  url: "https://discover.proxibid.com/leadership/",
  id: "leadership-link"
}, {
  label: "Newsroom",
  url: "https://discover.proxibid.com/news/",
  id: "newsroom-link"
}, {
  label: "Blog",
  url: "https://discover.proxibid.com/blog/",
  id: "blog-link"
}, {
  label: "Careers",
  url: "https://discover.proxibid.com/careers-and-culture/",
  id: "careers-link"
}];
var support = [{
  label: "Contact Us",
  url: "https://discover.proxibid.com/contact-us/",
  id: "contact-us-link"
}, {
  label: "FAQs",
  url: "https://proxibid.zendesk.com",
  target: "_blank",
  id: "faq-link"
}, {
  label: "Privacy Policy",
  url: "/asp/PrivacyPolicy.asp",
  id: "privacy-policy-link"
}, {
  label: "User Agreement",
  url: "/asp/UnifiedUserAgreement.asp",
  id: "user-agreement-link"
}, {
  label: "Accessibility",
  url: "",
  id: "accessibility-link"
}];
var buyingAndSelling = [{
  label: "Buyer Sign Up",
  url: "/asp/createbidder.asp",
  id: "buyer-sign-up-link"
}, {
  label: "Apply To Sell",
  url: "/asp/createSeller.asp",
  id: "apply-to-sell-link"
}, {
  label: "Buying",
  url: "https://discover.proxibid.com/buying/",
  id: "buying-link"
}, {
  label: "Selling",
  url: "https://discover.proxibid.com/selling/",
  id: "selling-link"
}, {
  label: "Marketplace Trust",
  url: "https://discover.proxibid.com",
  id: "marketplace-trust-link"
}];
var footerData = {
  socialLinks: socialLinks,
  aboutUs: aboutUs,
  support: support,
  buyingAndSelling: buyingAndSelling
};
FacebookIcon.propTypes = {
  viewBox: string
};

function FacebookIcon(props) {
  if (props.viewBox == undefined || props.viewBox == null) {
    props = _objectSpread2(_objectSpread2({}, props), {}, {
      viewBox: '0 0 512 512'
    });
  }

  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
  }));
}

TwitterIcon.propTypes = {
  viewBox: string
};

function TwitterIcon(props) {
  if (props.viewBox == undefined || props.viewBox == null) {
    props = _objectSpread2(_objectSpread2({}, props), {}, {
      viewBox: '0 0 512 512'
    });
  }

  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
  }));
}

YoutubeIcon.propTypes = {
  viewBox: string
};

function YoutubeIcon(props) {
  if (props.viewBox == undefined || props.viewBox == null) {
    props = _objectSpread2(_objectSpread2({}, props), {}, {
      viewBox: '0 0 576 512'
    });
  }

  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
  }));
}

LinkedinIcon.propTypes = {
  viewBox: string
};

function LinkedinIcon(props) {
  if (props.viewBox == undefined || props.viewBox == null) {
    props = _objectSpread2(_objectSpread2({}, props), {}, {
      viewBox: '0 0 448 512'
    });
  }

  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
  }));
}

InstagramIcon.propTypes = {
  viewBox: string
};

function InstagramIcon(props) {
  if (props.viewBox == undefined || props.viewBox == null) {
    props = _objectSpread2(_objectSpread2({}, props), {}, {
      viewBox: '0 0 448 512'
    });
  }

  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
  }));
}

var SocialIcon = function SocialIcon(_ref) {
  var site = _ref.site;
  var siteName = site.toLowerCase();
  var components = {
    facebook: FacebookIcon,
    twitter: TwitterIcon,
    youtube: YoutubeIcon,
    linkedin: LinkedinIcon,
    instagram: InstagramIcon
  };
  var Icon = components[siteName];
  return /*#__PURE__*/React.createElement(Icon, null);
};

SocialIcon.propTypes = {
  site: PropTypes__default.string
};
ProxibidLogo.propTypes = {
  viewBox: string
};

function ProxibidLogo(props) {
  if (props.viewBox == undefined || props.viewBox == null) {
    props = _objectSpread2(_objectSpread2({}, props), {}, {
      viewBox: '0 0 407.41 108.14'
    });
  }

  var lightGrey = '{fill:#fafafa}';
  var darkGrey = '{fill:#616161}';
  return /*#__PURE__*/React.createElement(Link$1, {
    href: "/"
  }, /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1", lightGrey), /*#__PURE__*/React.createElement("style", null, ".cls-2", darkGrey)), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M402.48,83.46a4.61,4.61,0,1,0,4.68,4.59A4.63,4.63,0,0,0,402.48,83.46Zm0,8.26a3.67,3.67,0,1,1,3.5-3.64A3.52,3.52,0,0,1,402.48,91.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.52,88.19v-.06a1.18,1.18,0,0,0,1-1.09,1.16,1.16,0,0,0-.48-1,2.46,2.46,0,0,0-1.57-.36,11.87,11.87,0,0,0-1.76.14v4.59h1.07V88.61h.5c.59,0,.87.22.95.7a4,4,0,0,0,.36,1.12h1.13a3.85,3.85,0,0,1-.34-1.12C404.19,88.69,404,88.33,403.52,88.19Zm-1.26-.34h-.51V86.54a2.46,2.46,0,0,1,.59-.06c.67,0,1,.28,1,.7S402.84,87.85,402.26,87.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.36,21.85H356.28q-8.52,0-13,4.32t-4.5,12.12V69.73q0,7.68,3.36,10.92a23.11,23.11,0,0,0,6.66,4.68,15.29,15.29,0,0,0,6.06,1.44h21.24a14.73,14.73,0,0,0,11.34-5.28,18.7,18.7,0,0,0,4.74-13V.25h-10.8Zm0,46.32a8.07,8.07,0,0,1-2,5.58,6.52,6.52,0,0,1-5.1,2.22h-19a5.11,5.11,0,0,1-4.08-2,7.32,7.32,0,0,1-1.68-4.8V40q0-7.32,7.08-7.32H374.4q7,0,7,7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.76.25a6.89,6.89,0,0,0-5.16,2.1,7.51,7.51,0,0,0-2,5.46,7,7,0,0,0,2.28,5.28A7.31,7.31,0,0,0,321,15.25,7,7,0,0,0,326.28,13a7.32,7.32,0,0,0-.06-10.44A7.32,7.32,0,0,0,320.76.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: "315.72",
    y: "21.85",
    width: "10.69",
    height: "64.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285,21.85H259.88V.25h-10.8V68.53a18.66,18.66,0,0,0,4.75,13,14.7,14.7,0,0,0,11.34,5.28h21.24A15.31,15.31,0,0,0,297.8,82a16.81,16.81,0,0,0,4.69-12.24V38.29q0-8-4.57-12.24T285,21.85Zm6.72,47.28a7,7,0,0,1-1.74,4.92A5.41,5.41,0,0,1,285.8,76H267a6.4,6.4,0,0,1-5.21-2.22,8.35,8.35,0,0,1-1.87-5.58V39.73q0-7.08,7-7.08H284.6q7.08,0,7.08,7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.08.25a6.89,6.89,0,0,0-5.16,2.1,7.51,7.51,0,0,0-2,5.46,7,7,0,0,0,2.28,5.28,7.31,7.31,0,0,0,5.16,2.16A7,7,0,0,0,235.6,13a7.32,7.32,0,0,0-.06-10.44A7.32,7.32,0,0,0,230.08.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: "225.04",
    y: "21.85",
    width: "10.68",
    height: "64.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "215.42 21.84 202 21.85 187 43.61 172.25 21.85 158.68 21.85 180.59 53.33 157.24 86.77 170.52 86.75 186.87 62.62 203.56 86.77 216.85 86.79 193.57 53.33 215.42 21.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.66,26q-4.74-4.14-12.54-4.14h-19.8q-8,0-12.66,4.08T98,37.09v33.6a15,15,0,0,0,4.86,11.64,17.7,17.7,0,0,0,12.42,4.44h19.8a17.48,17.48,0,0,0,12.36-4.56,14.9,14.9,0,0,0,4.92-11.4V37.09A14,14,0,0,0,147.66,26ZM141.6,67.81q0,8.16-7.68,8.16h-17.4q-4.08,0-5.88-2.1t-1.8-6.54V40.45q0-7.8,7.68-7.8h17.4q7.68,0,7.68,7.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.73,23.17a14.51,14.51,0,0,0-5.41,3q-3.6,4.2-3.59,12.84V86.77H78.52V39.25q0-6.48,6-6.48H89.8V21.85H83.69A20.79,20.79,0,0,0,76.73,23.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.45,21.85H17.05c-5.45,0-9.6,1.44-12.48,4.32S.25,33.13.25,38.41v69.48h10.8V86.77H37.81a15.52,15.52,0,0,0,11.88-5.22,18.23,18.23,0,0,0,4.8-12.78V37.69c0-5.12-1.53-9-4.56-11.76S42.73,21.85,37.45,21.85Zm6.24,47.64A6.55,6.55,0,0,1,42,74.11,5.77,5.77,0,0,1,37.57,76H17.05a5.21,5.21,0,0,1-4.32-2.16,8.28,8.28,0,0,1-1.68-5.28V39.25q0-6.6,7.68-6.6H38.05c3.75,0,5.64,2,5.64,6.12Z"
  })));
}

var useStyles$t = makeStyles(function (theme) {
  return {
    columnHeading: {
      marginBottom: '15px',
      fontSize: '16px',
      fontWeight: '700',
      color: grey[50],
      minWidth: '150px',
      textAlign: 'center'
    }
  };
});

var FooterBox = function FooterBox(props) {
  var classes = useStyles$t();
  return /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 12,
    sm: 4,
    md: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.columnHeading
  }, props.columnHeading), props.children);
};

FooterBox.propTypes = {
  columnHeading: PropTypes__default.string,
  children: PropTypes__default.node
};
var useStyles$u = makeStyles(function (theme) {
  return {
    label: {
      '& a': {
        color: grey[50],
        fontSize: '13px',
        textAlign: 'center'
      }
    },
    linkText: {
      minWidth: '160px',
      color: grey[400],
      '&:hover': {
        color: grey[50]
      }
    }
  };
});

var FooterLink = function FooterLink(_ref) {
  var url = _ref.url,
      label = _ref.label,
      id = _ref.id,
      onClick = _ref.onClick,
      target = _ref.target;
  var classes = useStyles$u();
  return /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "h6",
    className: classes.label
  }, /*#__PURE__*/React.createElement(Link$1, {
    href: url,
    underline: "none",
    id: id,
    onClick: onClick,
    target: target
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.linkText
  }, label))));
};

FooterLink.propTypes = {
  url: PropTypes__default.string,
  label: PropTypes__default.string,
  id: PropTypes__default.string,
  onClick: PropTypes__default.func,
  target: PropTypes__default.string
};
FooterLink.defaultProps = {
  onClick: function onClick() {}
};

var SocialLink = function SocialLink(props) {
  return /*#__PURE__*/React.createElement(Grid$2, {
    item: true
  }, /*#__PURE__*/React.createElement(Link$1, {
    href: props.url
  }, props.icon));
};

SocialLink.propTypes = {
  url: PropTypes__default.string,
  icon: PropTypes__default.node
};

var AccessibeService = /*#__PURE__*/function () {
  function AccessibeService() {
    _classCallCheck(this, AccessibeService);
  }

  return _createClass(AccessibeService, null, [{
    key: "loadAccessibeOnce",
    value: function loadAccessibeOnce() {
      if (!AccessibeService.accessibeHasBeenLoaded) {
        AccessibeService._loadAccessibeScript();
      }
    }
  }, {
    key: "_loadAccessibeScript",
    value: function _loadAccessibeScript() {
      // copied from accessibe.com, generating custom script for proxibid.com
      // accessibe uses the "current url" you're on to check for configs and license, so no custom per environment setup needs to be done
      var theme = useTheme$1(); // -- copied script below -- //

      (function (document, tag) {
        var script = document.createElement(tag);
        var element = document.getElementsByTagName('body')[0];
        script.src = 'https://acsbap.com/api/app/assets/js/acsb.js';
        script.async = true;
        script.defer = true;
        (typeof element === 'undefined' ? document.getElementsByTagName('html')[0] : element).appendChild(script);

        script.onload = function () {
          // eslint-disable-next-line no-undef
          acsbJS.init({
            statementLink: '',
            feedbackLink: '',
            footerHtml: '',
            hideMobile: false,
            hideTrigger: true,
            language: 'en',
            position: 'right',
            // right position was picked so that a user could see more of left nav content when changing accessibility settings
            leadColor: theme.brandColors.capuaBlue,
            triggerColor: theme.brandColors.capuaBlue,
            triggerRadius: '50%',
            triggerPositionX: 'left',
            triggerPositionY: 'bottom',
            triggerIcon: 'people',
            triggerSize: 'medium',
            triggerOffsetX: 20,
            triggerOffsetY: 20,
            mobile: {
              triggerSize: 'small',
              triggerPositionX: 'left',
              triggerPositionY: 'center',
              triggerOffsetX: 0,
              triggerOffsetY: 0,
              triggerRadius: '0'
            }
          });
        };
      })(document, 'script'); // -- end copied script -- //


      AccessibeService.accessibeHasBeenLoaded = true;
    }
  }]);
}();

AccessibeService.accessibeHasBeenLoaded = false;
var SHOW_FOOTER = '@footer-event/SHOW_FOOTER';
var HIDE_FOOTER = '@footer-event/HIDE_FOOTER';
var FooterEvent = {
  SHOW_FOOTER: SHOW_FOOTER,
  HIDE_FOOTER: HIDE_FOOTER
};
var backgroundColor = grey[900];
var useStyles$v = makeStyles(function () {
  return {
    root: {
      background: backgroundColor,
      color: grey[700],
      marginTop: '14px'
    },
    logo: {
      marginBottom: '15px',
      width: '180px',
      height: '45px'
    },
    sociallinks: {
      '& a': {
        color: grey[700],
        '&:hover': {
          color: grey[50]
        }
      }
    },
    serverIp: {
      color: backgroundColor
    }
  };
});

var Footer = function Footer(props) {
  var classes = useStyles$v();

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showFooter = _useState2[0],
      setShowFooter = _useState2[1];

  AccessibeService.loadAccessibeOnce();
  useEffect(function () {
    EventService.addEventListener(FooterEvent.SHOW_FOOTER, showFooterHandler);
    EventService.addEventListener(FooterEvent.HIDE_FOOTER, hideFooterHandler);
    return function () {
      EventService.removeEventListener(FooterEvent.SHOW_FOOTER, showFooterHandler);
      EventService.removeEventListener(FooterEvent.HIDE_FOOTER, hideFooterHandler);
    };
  }, []);
  return showFooter && /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Container, {
    maxWidth: "xl"
  }, /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 4,
    justify: "center"
  }, /*#__PURE__*/React.createElement(FooterBox, {
    columnHeading: "About"
  }, footerData.aboutUs.map(function (element, index) {
    return /*#__PURE__*/React.createElement(FooterLink, {
      key: index,
      url: element.url,
      label: element.label,
      id: element.id
    });
  })), /*#__PURE__*/React.createElement(FooterBox, {
    columnHeading: "Support"
  }, footerData.support.map(function (element, index) {
    if (element.id === 'accessibility-link') {
      return /*#__PURE__*/React.createElement(Box, {
        "data-acsb": "trigger",
        key: index
      }, /*#__PURE__*/React.createElement(FooterLink, {
        key: index,
        url: element.url,
        label: element.label,
        id: element.id,
        onClick: preventDefaultClickHandler
      }));
    } else {
      return /*#__PURE__*/React.createElement(FooterLink, {
        key: index,
        url: element.url,
        label: element.label,
        id: element.id,
        target: 'target' in element ? element.target : '_self'
      });
    }
  })), /*#__PURE__*/React.createElement(FooterBox, {
    columnHeading: "Buying & Selling"
  }, props.isSellerAuthenticated ? /*#__PURE__*/React.createElement(FooterLink, {
    url: "/asp/auctioneer/ABLogOff.asp",
    label: "Sign Out"
  }) : /*#__PURE__*/React.createElement(FooterLink, {
    url: "/asp/LoginAuctioneer.asp",
    label: "Seller Log In"
  }), footerData.buyingAndSelling.map(function (element, index) {
    return /*#__PURE__*/React.createElement(FooterLink, {
      key: index,
      url: element.url,
      label: element.label,
      id: element.id
    });
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    align: "center"
  }, /*#__PURE__*/React.createElement(ProxibidLogo, {
    className: classes.logo
  }), /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    direction: "row",
    spacing: 2,
    className: classes.sociallinks,
    justify: "center"
  }, footerData.socialLinks.map(function (element, index) {
    return /*#__PURE__*/React.createElement(SocialLink, {
      key: index,
      url: element.url,
      id: element.id,
      icon: /*#__PURE__*/React.createElement(SocialIcon, {
        site: element.icon
      })
    });
  }))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    align: "center"
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "subtitle1"
  }, "Copyright \xA9 Proxibid Inc. ", new Date().getFullYear()), /*#__PURE__*/React.createElement("span", {
    className: classes.serverIp
  }, props.serverIp)))));

  function preventDefaultClickHandler(event) {
    event.preventDefault();
  }

  function showFooterHandler() {
    setShowFooter(true);
  }

  function hideFooterHandler() {
    setShowFooter(false);
  }
};

Footer.propTypes = {
  serverIp: PropTypes__default.string,
  isSellerAuthenticated: PropTypes__default.bool
};

function RequestOneTimePassword(props) {
  var recaptchaRef = React.createRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(props.errorMessage),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(props.infoMessage),
      _useState6 = _slicedToArray(_useState5, 2),
      infoMessage = _useState6[0],
      setInfoMessage = _useState6[1];

  var _useState7 = useState(props.showRequestPasswordForm),
      _useState8 = _slicedToArray(_useState7, 2),
      showRequestPasswordForm = _useState8[0],
      setShowRequestPasswordForm = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      submitEvent = _useState10[0],
      setSubmitEvent = _useState10[1];

  var _useState11 = useState({
    email: ''
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      inputs = _useState12[0],
      setInputs = _useState12[1];

  var onCaptchaChange = function onCaptchaChange(value) {
    submitReset(submitEvent, value);
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();

    if (props.captchaEnabled) {
      setSubmitEvent(event);
      recaptchaRef.current.execute();
    } else {
      submitReset(event, '');
    }
  };

  var submitReset = function submitReset(event, token) {
    var ref = '';

    if (props.captchaEnabled) {
      ref = recaptchaRef.current;
    }

    if (event) {
      setErrorMessage(null);
      setLoading(true);
      event.preventDefault();
      return axiosInstance.post(props.requestResetUrl, {
        email: inputs.email,
        secondaryAuthentication: token
      }, {
        headers: {
          'device-id': props.deviceId
        }
      }).then(function (response) {
        setInfoMessage("If an account exists for ".concat(inputs.email, ", a confirmation email has been sent. It will have a link to reset your password."));
        setShowRequestPasswordForm(false);
      })["catch"](function () {
        if (props.captchaEnabled) {
          ref.reset();
        }

        setErrorMessage('An error occurred attempting to send the e-mail. Please try again later or contact support if this problem continues.');
        setShowRequestPasswordForm(false);
      })["finally"](function () {
        return setLoading(false);
      });
    }
  };

  var handleInputChange = function handleInputChange(event) {
    event.persist();
    setInputs(function (inputs) {
      return _objectSpread2(_objectSpread2({}, inputs), {}, _defineProperty({}, event.target.name, event.target.value));
    });
  };

  return /*#__PURE__*/React.createElement("form", {
    className: 'loginForm',
    noValidate: true,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'h5'
  }, "Request Password Reset E-mail"), errorMessage && /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, errorMessage), infoMessage && /*#__PURE__*/React.createElement(Message, {
    variant: 'info'
  }, infoMessage), showRequestPasswordForm && /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    margin: "normal",
    required: true,
    id: "email",
    label: "E-mail",
    name: "email",
    autoFocus: true,
    onChange: handleInputChange,
    value: inputs.email
  }), /*#__PURE__*/React.createElement(Button, {
    type: 'submit',
    loading: loading,
    color: 'primary',
    disabled: !inputs.email,
    variant: 'contained',
    id: 'request-one-time-password-submit'
  }, "Request Password Reset E-mail"), props.captchaEnabled && /*#__PURE__*/React.createElement(RecaptchaWrapper, {
    ref: recaptchaRef,
    size: "invisible",
    sitekey: props.captchaApiKey,
    onChange: onCaptchaChange
  }))));
}

RequestOneTimePassword.propTypes = {
  requestResetUrl: string.isRequired,
  deviceId: string,
  captchaEnabled: bool,
  captchaApiKey: string,
  infoMessage: string,
  errorMessage: string,
  showRequestPasswordForm: bool
};
var parse_1$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = parse; // Parses the `text`.
  //
  // Returns `{ value, caret }` where `caret` is
  // the caret position inside `value`
  // corresponding to the `caret_position` inside `text`.
  //
  // The `text` is parsed by feeding each character sequentially to
  // `parse_character(character, value)` function
  // and appending the result (if it's not `undefined`) to `value`.
  //
  // Example:
  //
  // `text` is `8 (800) 555-35-35`,
  // `caret_position` is `4` (before the first `0`).
  // `parse_character` is `(character, value) =>
  //   if (character >= '0' && character <= '9') { return character }`.
  //
  // then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
  //

  function parse(text, caret_position, parse_character) {
    var value = '';
    var focused_input_character_index = 0;
    var index = 0;

    while (index < text.length) {
      var character = parse_character(text[index], value);

      if (character !== undefined) {
        value += character;

        if (caret_position !== undefined) {
          if (caret_position === index) {
            focused_input_character_index = value.length - 1;
          } else if (caret_position > index) {
            focused_input_character_index = value.length;
          }
        }
      }

      index++;
    } // If caret position wasn't specified


    if (caret_position === undefined) {
      // Then set caret position to "after the last input character"
      focused_input_character_index = value.length;
    }

    var result = {
      value: value,
      caret: focused_input_character_index
    };
    return result;
  }
});
unwrapExports(parse_1$1);
var edit_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = edit; // Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
  //
  // Example:
  //
  // value - '88005553535'
  // caret - 2 // starting from 0; is positioned before the first zero
  // operation - 'Backspace'
  //
  // Returns
  // {
  // 	value: '8005553535'
  // 	caret: 1
  // }
  //
  // Currently supports just 'Delete' and 'Backspace' operations
  //

  function edit(value, caret, operation) {
    switch (operation) {
      case 'Backspace':
        // If there exists the previous character,
        // then erase it and reposition the caret.
        if (caret > 0) {
          // Remove the previous character
          value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was

          caret--;
        }

        break;

      case 'Delete':
        // Remove current digit (if any)
        value = value.slice(0, caret) + value.slice(caret + 1);
        break;
    }

    return {
      value: value,
      caret: caret
    };
  }
});
unwrapExports(edit_1);
var helpers = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.count_occurences = count_occurences; // Counts all occurences of a symbol in a string

  function count_occurences(symbol, string) {
    var count = 0; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // so skipping such miscellaneous "exotic" characters
    // won't matter here for just counting placeholder character occurrences.

    for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var character = _ref;

      if (character === symbol) {
        count++;
      }
    }

    return count;
  }
});
unwrapExports(helpers);
var helpers_1 = helpers.count_occurences;
var close_braces_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = close_braces;

  function close_braces(retained_template, template) {
    var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
    var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
    var cut_before = retained_template.length;
    var opening_braces = (0, helpers.count_occurences)('(', retained_template);
    var closing_braces = (0, helpers.count_occurences)(')', retained_template);
    var dangling_braces = opening_braces - closing_braces;

    while (dangling_braces > 0 && cut_before < template.length) {
      retained_template += template[cut_before].replace(placeholder, empty_placeholder);

      if (template[cut_before] === ')') {
        dangling_braces--;
      }

      cut_before++;
    }

    return retained_template;
  }
});
unwrapExports(close_braces_1);
var template_formatter = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.default = function (template) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
    var should_close_braces = arguments[2];

    if (!template) {
      return function (value) {
        return {
          text: value
        };
      };
    }

    var characters_in_template = (0, helpers.count_occurences)(placeholder, template);
    return function (value) {
      if (!value) {
        return {
          text: '',
          template: template
        };
      }

      var value_character_index = 0;
      var filled_in_template = ''; // Using `.split('')` here instead of normal `for ... of`
      // because the importing application doesn't neccessarily include an ES6 polyfill.
      // The `.split('')` approach discards "exotic" UTF-8 characters
      // (the ones consisting of four bytes)
      // but template placeholder characters don't fall into that range
      // and appending UTF-8 characters to a string in parts still works.

      for (var _iterator = template.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var character = _ref;

        if (character !== placeholder) {
          filled_in_template += character;
          continue;
        }

        filled_in_template += value[value_character_index];
        value_character_index++; // If the last available value character has been filled in,
        // then return the filled in template
        // (either trim the right part or retain it,
        //  if no more character placeholders in there)

        if (value_character_index === value.length) {
          // If there are more character placeholders
          // in the right part of the template
          // then simply trim it.
          if (value.length < characters_in_template) {
            break;
          }
        }
      }

      if (should_close_braces) {
        filled_in_template = (0, _closeBraces2.default)(filled_in_template, template);
      }

      return {
        text: filled_in_template,
        template: template
      };
    };
  };

  var _closeBraces2 = _interopRequireDefault(close_braces_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
});
unwrapExports(template_formatter);
var format_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = format;

  var _templateFormatter2 = _interopRequireDefault(template_formatter);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  } // Formats `value` value preserving `caret` at the same character.
  //
  // `{ value, caret }` attribute is the result of `parse()` function call.
  //
  // Returns `{ text, caret }` where the new `caret` is the caret position
  // inside `text` text corresponding to the original `caret` position inside `value`.
  //
  // `formatter(value)` is a function returning `{ text, template }`.
  //
  // `text` is the `value` value formatted using `template`.
  // It may either cut off the non-filled right part of the `template`
  // or it may fill the non-filled character placeholders
  // in the right part of the `template` with `spacer`
  // which is a space (' ') character by default.
  //
  // `template` is the template used to format the `value`.
  // It can be either a full-length template or a partial template.
  //
  // `formatter` can also be a string — a `template`
  // where character placeholders are denoted by 'x'es.
  // In this case `formatter` function is automatically created.
  //
  // Example:
  //
  // `value` is '880',
  // `caret` is `2` (before the first `0`)
  //
  // `formatter` is `'880' =>
  //   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
  //
  // The result is `{ text: '8 (80 )', caret: 4 }`.
  //


  function format(value, caret, formatter) {
    if (typeof formatter === 'string') {
      formatter = (0, _templateFormatter2.default)(formatter);
    }

    var _ref = formatter(value) || {},
        text = _ref.text,
        template = _ref.template;

    if (text === undefined) {
      text = value;
    }

    if (template) {
      if (caret === undefined) {
        caret = text.length;
      } else {
        var index = 0;
        var found = false;
        var possibly_last_input_character_index = -1;

        while (index < text.length && index < template.length) {
          // Character placeholder found
          if (text[index] !== template[index]) {
            if (caret === 0) {
              found = true;
              caret = index;
              break;
            }

            possibly_last_input_character_index = index;
            caret--;
          }

          index++;
        } // If the caret was positioned after last input character,
        // then the text caret index is just after the last input character.


        if (!found) {
          caret = possibly_last_input_character_index + 1;
        }
      }
    }

    return {
      text: text,
      caret: caret
    };
  }
});
unwrapExports(format_1);
var dom = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getSelection = getSelection;
  exports.getOperation = getOperation;
  exports.getCaretPosition = getCaretPosition;
  exports.setCaretPosition = setCaretPosition; // Gets <input/> selection bounds

  function getSelection(element) {
    // If no selection, return nothing
    if (element.selectionStart === element.selectionEnd) {
      return;
    }

    return {
      start: element.selectionStart,
      end: element.selectionEnd
    };
  } // Key codes


  var Keys = exports.Keys = {
    Backspace: 8,
    Delete: 46 // Finds out the operation to be intercepted and performed
    // based on the key down event `keyCode`.

  };

  function getOperation(event) {
    switch (event.keyCode) {
      case Keys.Backspace:
        return 'Backspace';

      case Keys.Delete:
        return 'Delete';
    }
  } // Gets <input/> caret position


  function getCaretPosition(element) {
    return element.selectionStart;
  } // Sets <input/> caret position


  function setCaretPosition(element, caret_position) {
    // Sanity check
    if (caret_position === undefined) {
      return;
    } // Set caret position.
    // There has been an issue with caret positioning on Android devices.
    // https://github.com/catamphetamine/input-format/issues/2
    // I was revisiting this issue and looked for similar issues in other libraries.
    // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
    // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
    // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
    // https://github.com/text-mask/text-mask/issues/300
    // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
    // https://github.com/text-mask/text-mask/pull/400/files
    // I've implemented the same workaround here.


    if (isAndroid()) {
      setTimeout(function () {
        return element.setSelectionRange(caret_position, caret_position);
      }, 0);
    } else {
      element.setSelectionRange(caret_position, caret_position);
    }
  }

  function isAndroid() {
    // `navigator` is not defined when running mocha tests.
    if (typeof navigator !== 'undefined') {
      return ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
    }
  }

  var ANDROID_USER_AGENT_REG_EXP = /Android/i;
});
unwrapExports(dom);
var dom_1 = dom.getSelection;
var dom_2 = dom.getOperation;
var dom_3 = dom.getCaretPosition;
var dom_4 = dom.setCaretPosition;
var dom_5 = dom.Keys;
var input_control = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.onCut = onCut;
  exports.onPaste = onPaste;
  exports.onChange = onChange;
  exports.onKeyDown = onKeyDown;

  var _edit2 = _interopRequireDefault(edit_1);

  var _parse4 = _interopRequireDefault(parse_1$1);

  var _format3 = _interopRequireDefault(format_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function onCut(event, input, _parse, _format, on_change) {
    // The actual cut hasn't happened just yet hence the timeout.
    setTimeout(function () {
      return format_input_text(input, _parse, _format, undefined, on_change);
    }, 0);
  }

  function onPaste(event, input, _parse, _format, on_change) {
    var selection = (0, dom.getSelection)(input); // If selection is made,
    // just erase the selected text
    // prior to pasting

    if (selection) {
      erase_selection(input, selection);
    }

    format_input_text(input, _parse, _format, undefined, on_change);
  }

  function onChange(event, input, _parse, _format, on_change) {
    format_input_text(input, _parse, _format, undefined, on_change);
  } // Intercepts "Delete" and "Backspace" keys.
  // (hitting "Delete" or "Backspace" at any caret
  //  position should always result in rasing a digit)


  function onKeyDown(event, input, _parse, _format, on_change) {
    var operation = (0, dom.getOperation)(event);

    switch (operation) {
      case 'Delete':
      case 'Backspace':
        // Intercept this operation and perform it manually.
        event.preventDefault();
        var selection = (0, dom.getSelection)(input); // If selection is made,
        // just erase the selected text,
        // and don't apply any more operations to it.

        if (selection) {
          erase_selection(input, selection);
          return format_input_text(input, _parse, _format, undefined, on_change);
        } // Else, perform the (character erasing) operation manually


        return format_input_text(input, _parse, _format, operation, on_change);
      // Will be handled when `onChange` fires.
    }
  }
  /**
   * Erases the selected text inside an `<input/>`.
   * @param  {DOMElement} input
   * @param  {Selection} selection
   */


  function erase_selection(input, selection) {
    var text = input.value;
    text = text.slice(0, selection.start) + text.slice(selection.end);
    input.value = text;
    (0, dom.setCaretPosition)(input, selection.start);
  }
  /**
   * Parses and re-formats `<input/>` textual value.
   * E.g. when a user enters something into the `<input/>`
   * that raw input must first be parsed and the re-formatted properly.
   * Is called either after some user input (e.g. entered a character, pasted something)
   * or after the user performed an `operation` (e.g. "Backspace", "Delete").
   * @param  {DOMElement} input
   * @param  {Function} parse
   * @param  {Function} format
   * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
   * @param  {Function} onChange
   */


  function format_input_text(input, _parse, _format, operation, on_change) {
    // Parse `<input/>` textual value.
    // Get `value` and `caret` position.
    var _parse2 = (0, _parse4.default)(input.value, (0, dom.getCaretPosition)(input), _parse),
        value = _parse2.value,
        caret = _parse2.caret; // If a user performed an operation (e.g. "Backspace", "Delete")
    // then apply that operation and get new `value` and `caret` position.


    if (operation) {
      var operation_applied = (0, _edit2.default)(value, caret, operation);
      value = operation_applied.value;
      caret = operation_applied.caret;
    } // Format the `value`.
    // (and reposition the caret accordingly)


    var formatted = (0, _format3.default)(value, caret, _format);
    var text = formatted.text;
    caret = formatted.caret; // Set `<input/>` textual value manually
    // to prevent React from resetting the caret position
    // later inside subsequent `render()`.
    // Doesn't work for custom `inputComponent`s for some reason.

    input.value = text; // Position the caret properly.

    (0, dom.setCaretPosition)(input, caret); // `<input/>` textual value may have changed,
    // so the parsed `value` may have changed too.
    // The `value` didn't neccessarily change
    // but it might have.

    on_change(value);
  }
});
unwrapExports(input_control);
var input_control_1 = input_control.onCut;
var input_control_2 = input_control.onPaste;
var input_control_3 = input_control.onChange;
var input_control_4 = input_control.onKeyDown;
var Input_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(React);

  var _propTypes2 = _interopRequireDefault(PropTypes__default);

  var _parse3 = _interopRequireDefault(parse_1$1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  } // This is just `./ReactInput.js` rewritten in Hooks.
  // Usage:
  //
  // <ReactInput
  // 	value={this.state.phone}
  // 	onChange={phone => this.setState({ phone })}
  // 	parse={character => character}
  // 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
  //


  function Input(_ref, ref) {
    var value = _ref.value,
        parse = _ref.parse,
        format = _ref.format,
        InputComponent = _ref.inputComponent,
        onChange = _ref.onChange,
        onCut = _ref.onCut,
        onPaste = _ref.onPaste,
        onKeyDown = _ref.onKeyDown,
        rest = _objectWithoutProperties(_ref, ['value', 'parse', 'format', 'inputComponent', 'onChange', 'onCut', 'onPaste', 'onKeyDown']);

    var ownRef = (0, React.useRef)();
    ref = ref || ownRef;

    var _onChange = (0, React.useCallback)(function (event) {
      return (0, input_control.onChange)(event, ref.current, parse, format, onChange);
    }, [ref, parse, format, onChange]);

    var _onPaste = (0, React.useCallback)(function (event) {
      if (onPaste) {
        onPaste(event);
      }

      return (0, input_control.onPaste)(event, ref.current, parse, format, onChange);
    }, [ref, parse, format, onChange, onPaste]);

    var _onCut = (0, React.useCallback)(function (event) {
      if (onCut) {
        onCut(event);
      }

      return (0, input_control.onCut)(event, ref.current, parse, format, onChange);
    }, [ref, parse, format, onChange, onCut]);

    var _onKeyDown = (0, React.useCallback)(function (event) {
      if (onKeyDown) {
        onKeyDown(event);
      }

      return (0, input_control.onKeyDown)(event, ref.current, parse, format, onChange);
    }, [ref, parse, format, onChange, onKeyDown]);

    return _react2.default.createElement(InputComponent, _extends({}, rest, {
      ref: ref,
      value: format(isEmptyValue(value) ? '' : value).text,
      onKeyDown: _onKeyDown,
      onChange: _onChange,
      onPaste: _onPaste,
      onCut: _onCut
    }));
  }

  Input = _react2.default.forwardRef(Input);
  Input.propTypes = {
    // Parses a single characher of `<input/>` text.
    parse: _propTypes2.default.func.isRequired,
    // Formats `value` into `<input/>` text.
    format: _propTypes2.default.func.isRequired,
    // Renders `<input/>` by default.
    inputComponent: _propTypes2.default.elementType.isRequired,
    // `<input/>` `type` attribute.
    type: _propTypes2.default.string.isRequired,
    // Is parsed from <input/> text.
    value: _propTypes2.default.string,
    // This handler is called each time `<input/>` text is changed.
    onChange: _propTypes2.default.func.isRequired,
    // Passthrough
    onKeyDown: _propTypes2.default.func,
    onCut: _propTypes2.default.func,
    onPaste: _propTypes2.default.func
  };
  Input.defaultProps = {
    // Renders `<input/>` by default.
    inputComponent: 'input',
    // `<input/>` `type` attribute.
    type: 'text'
  };
  exports.default = Input;

  function isEmptyValue(value) {
    return value === undefined || value === null;
  }
});
var Input = unwrapExports(Input_1);

function getInputValuePrefix(country, international, metadata) {
  return country && international ? "+".concat(getCountryCallingCode(country, metadata)) : '';
}

function removeInputValuePrefix(value, prefix) {
  if (prefix) {
    value = value.slice(prefix.length);

    if (value[0] === ' ') {
      value = value.slice(1);
    }
  }

  return value;
}

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$5(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * This input uses `input-format` library
 * for "smart" caret positioning.
 */


function createInput(defaultMetadata) {
  function InputSmart(_ref, ref) {
    var country = _ref.country,
        international = _ref.international,
        metadata = _ref.metadata,
        rest = _objectWithoutProperties$2(_ref, ["country", "international", "metadata"]);

    var format = useCallback(function (value) {
      // "As you type" formatter.
      var formatter = new AsYouType(country, metadata);
      var prefix = getInputValuePrefix(country, international, metadata); // Format the number.

      var text = formatter.input(prefix + value);
      var template = formatter.getTemplate();

      if (prefix) {
        text = removeInputValuePrefix(text, prefix); // `AsYouType.getTemplate()` can be `undefined`.

        if (template) {
          template = removeInputValuePrefix(template, prefix);
        }
      }

      return {
        text: text,
        template: template
      };
    }, [country, metadata]);
    return React.createElement(Input, _extends$6({}, rest, {
      ref: ref,
      parse: parsePhoneNumberCharacter,
      format: format
    }));
  }

  InputSmart = React.forwardRef(InputSmart);
  InputSmart.propTypes = {
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: PropTypes__default.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes__default.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes__default.object.isRequired
  };
  InputSmart.defaultProps = {
    metadata: defaultMetadata
  };
  return InputSmart;
}

var InputSmart = createInput();

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$6(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createInput$1(defaultMetadata) {
  /**
   * `InputBasic`'s caret is not as "smart" as the default `inputComponent`'s
   * but still works good enough. When erasing or inserting digits in the middle
   * of a phone number the caret usually jumps to the end: this is the expected
   * behaviour and it's the workaround for the [Samsung Galaxy smart caret positioning bug](https://github.com/catamphetamine/react-phone-number-input/issues/75).
   */
  function InputBasic(_ref, ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        country = _ref.country,
        international = _ref.international,
        metadata = _ref.metadata,
        Input = _ref.inputComponent,
        rest = _objectWithoutProperties$3(_ref, ["value", "onChange", "country", "international", "metadata", "inputComponent"]);

    var prefix = getInputValuePrefix(country, international, metadata);

    var _onChange = useCallback(function (event) {
      var newValue = parseIncompletePhoneNumber(event.target.value); // By default, if a value is something like `"(123)"`
      // then Backspace would only erase the rightmost brace
      // becoming something like `"(123"`
      // which would give the same `"123"` value
      // which would then be formatted back to `"(123)"`
      // and so a user wouldn't be able to erase the phone number.
      // Working around this issue with this simple hack.

      if (newValue === value) {
        var newValueFormatted = format(prefix, newValue, country, metadata);

        if (newValueFormatted.indexOf(event.target.value) === 0) {
          // Trim the last digit (or plus sign).
          newValue = newValue.slice(0, -1);
        }
      }

      onChange(newValue);
    }, [prefix, value, onChange, country, metadata]);

    return React.createElement(Input, _extends$7({}, rest, {
      ref: ref,
      value: format(prefix, value, country, metadata),
      onChange: _onChange
    }));
  }

  InputBasic = React.forwardRef(InputBasic);
  InputBasic.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: PropTypes__default.string.isRequired,

    /**
     * Updates the `value`.
     */
    onChange: PropTypes__default.func.isRequired,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * Perhaps the `country` property should have been called `defaultCountry`
     * because if `value` is an international number then `country` is ignored.
     */
    country: PropTypes__default.string,

    /**
     * If `country` property is passed along with `international={true}` property
     * then the phone number will be input in "international" format for that `country`
     * (without "country calling code").
     * For example, if `country="US"` property is passed to "without country select" input
     * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
     * But if both `country="US"` and `international={true}` properties are passed then
     * the phone number will be input in the "international" format for `US` (`213 373 4253`)
     * (without "country calling code" `+1`).
     */
    international: PropTypes__default.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes__default.object.isRequired,

    /**
     * The `<input/>` component.
     */
    inputComponent: PropTypes__default.elementType.isRequired
  };
  InputBasic.defaultProps = {
    metadata: defaultMetadata,
    inputComponent: 'input'
  };
  return InputBasic;
}

var InputBasic = createInput$1();

function format(prefix, value, country, metadata) {
  return removeInputValuePrefix(formatIncompletePhoneNumber(prefix + value, country, metadata), prefix);
}

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$7(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size in IE 11.
// https://github.com/catamphetamine/react-phone-number-input/issues/111


function FlagComponent(_ref) {
  var country = _ref.country,
      countryName = _ref.countryName,
      flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      rest = _objectWithoutProperties$4(_ref, ["country", "countryName", "flags", "flagUrl"]);

  if (flags && flags[country]) {
    return flags[country]({
      title: countryName
    });
  }

  return React.createElement("img", _extends$8({}, rest, {
    alt: countryName,
    src: flagUrl.replace('{XX}', country).replace('{xx}', country.toLowerCase())
  }));
}

FlagComponent.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: PropTypes__default.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: PropTypes__default.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` github pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: PropTypes__default.objectOf(PropTypes__default.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` github pages website.
  flagUrl: PropTypes__default.string.isRequired
};

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

function _objectWithoutProperties$5(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$8(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$8(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function InternationalIcon(_ref) {
  var aspectRatio = _ref.aspectRatio,
      rest = _objectWithoutProperties$5(_ref, ["aspectRatio"]);

  if (aspectRatio === 1) {
    return React.createElement(InternationalIcon1x1, rest);
  } else {
    return React.createElement(InternationalIcon3x2, rest);
  }
}

InternationalIcon.propTypes = {
  title: PropTypes__default.string.isRequired,
  aspectRatio: PropTypes__default.number
}; // 3x2.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon3x2(_ref2) {
  var title = _ref2.title,
      rest = _objectWithoutProperties$5(_ref2, ["title"]);

  return React.createElement("svg", _extends$9({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), React.createElement("title", null, title), React.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, React.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), React.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), React.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), React.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), React.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), React.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), React.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}

InternationalIcon3x2.propTypes = {
  title: PropTypes__default.string.isRequired
}; // 1x1.
// Using `<title/>` in `<svg/>`s:
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title

function InternationalIcon1x1(_ref3) {
  var title = _ref3.title,
      rest = _objectWithoutProperties$5(_ref3, ["title"]);

  return React.createElement("svg", _extends$9({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), React.createElement("title", null, title), React.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, React.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), React.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), React.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), React.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), React.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), React.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), React.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}

InternationalIcon1x1.propTypes = {
  title: PropTypes__default.string.isRequired
};
/**
 * Sorts country `<select/>` options.
 * Can move some country `<select/>` options
 * to the top of the list, for example.
 * @param  {object[]} countryOptions — Country `<select/>` options.
 * @param  {string[]} [countryOptionsOrder] — Country `<select/>` options order. Example: `["US", "CA", "AU", "|", "..."]`.
 * @return {object[]}
 */

function sortCountryOptions(options, order) {
  if (!order) {
    return options;
  }

  var optionsOnTop = [];
  var optionsOnBottom = [];
  var appendTo = optionsOnTop;

  var _loop = function _loop() {
    if (_isArray) {
      if (_i >= _iterator.length) return "break";
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) return "break";
      _ref = _i.value;
    }

    var element = _ref;

    if (element === '|') {
      appendTo.push({
        divider: true
      });
    } else if (element === '...' || element === '…') {
      appendTo = optionsOnBottom;
    } else {
      // Find the position of the option.
      var index = options.indexOf(options.filter(function (option) {
        return option.value === element;
      })[0]); // Get the option.

      var option = options[index]; // Remove the option from its default position.

      options.splice(index, 1); // Add the option on top.

      appendTo.push(option);
    }
  };

  for (var _iterator = order, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    var _ret = _loop();

    if (_ret === "break") break;
  }

  return optionsOnTop.concat(options).concat(optionsOnBottom);
}

function getSupportedCountryOptions(countryOptions, metadata) {
  if (countryOptions) {
    countryOptions = countryOptions.filter(function (option) {
      switch (option) {
        case '|':
        case '...':
        case '…':
          return true;

        default:
          return isCountrySupportedWithError(option, metadata);
      }
    });

    if (countryOptions.length > 0) {
      return countryOptions;
    }
  }
}

function isCountrySupportedWithError(country, metadata) {
  if (isSupportedCountry(country, metadata)) {
    return true;
  } else {
    console.error("Country not found: ".concat(country));
    return false;
  }
}

function getSupportedCountries(countries, metadata) {
  if (countries) {
    countries = countries.filter(function (country) {
      return isCountrySupportedWithError(country, metadata);
    });

    if (countries.length === 0) {
      countries = undefined;
    }
  }

  return countries;
}

function createCountryIconComponent(_ref) {
  var flags = _ref.flags,
      flagUrl = _ref.flagUrl,
      FlagComponent = _ref.flagComponent,
      InternationalIcon$1 = _ref.internationalIcon;

  function CountryIcon(_ref2) {
    var country = _ref2.country,
        label = _ref2.label,
        aspectRatio = _ref2.aspectRatio; // `aspectRatio` is currently a hack for the default "International" icon
    // to render it as a square when Unicode flag icons are used.
    // So `aspectRatio` property is only used with the default "International" icon.

    var _aspectRatio = InternationalIcon$1 === InternationalIcon ? aspectRatio : undefined;

    return React.createElement("div", {
      className: classnames('PhoneInputCountryIcon', {
        'PhoneInputCountryIcon--square': _aspectRatio === 1,
        'PhoneInputCountryIcon--border': country
      })
    }, country ? React.createElement(FlagComponent, {
      country: country,
      countryName: label,
      flags: flags,
      flagUrl: flagUrl,
      className: "PhoneInputCountryIconImg"
    }) : React.createElement(InternationalIcon$1, {
      title: label,
      aspectRatio: _aspectRatio,
      className: "PhoneInputCountryIconImg"
    }));
  }

  CountryIcon.propTypes = {
    country: PropTypes__default.string,
    label: PropTypes__default.string.isRequired,
    aspectRatio: PropTypes__default.number
  };
  return CountryIcon;
}

createCountryIconComponent({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: 'https://catamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
  flagComponent: FlagComponent,
  internationalIcon: InternationalIcon
});
var metadata = PropTypes__default.shape({
  country_calling_codes: PropTypes__default.object.isRequired,
  countries: PropTypes__default.object.isRequired
});
var labels = PropTypes__default.objectOf(PropTypes__default.string);
/**
 * Decides which country should be pre-selected
 * when the phone number input component is first mounted.
 * @param  {object?} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {string?} country - Pre-defined country (two-letter code).
 * @param  {string[]?} countries - A list of countries available.
 * @param  {boolean} includeInternationalOption - Whether "International" country option is available.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string?}
 */

function getPreSelectedCountry(phoneNumber, country, countries, includeInternationalOption, metadata) {
  // If can get country from E.164 phone number
  // then it overrides the `country` passed (or not passed).
  if (phoneNumber && phoneNumber.country) {
    // `country` will be left `undefined` in case of non-detection.
    country = phoneNumber.country;
  } // Only pre-select a country if it's in the available `countries` list.


  if (countries && countries.indexOf(country) < 0) {
    country = undefined;
  } // If there will be no "International" option
  // then some `country` must be selected.
  // It will still be the wrong country though.
  // But still country `<select/>` can't be left in a broken state.


  if (!country && !includeInternationalOption && countries && countries.length > 0) {
    country = countries[0];
  }

  return country;
}
/**
 * Generates a sorted list of country `<select/>` options.
 * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
 * @param  {object} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
 * @param  {boolean} includeInternationalOption - Whether should include "International" option at the top of the list.
 * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
 */


function getCountrySelectOptions(countries, country_names, includeInternationalOption) {
  // Generates a `<Select/>` option for each country.
  var country_select_options = countries.map(function (country) {
    return {
      value: country,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: country_names[country] || country
    };
  }); // Sort the list of countries alphabetically.

  country_select_options.sort(function (a, b) {
    return compare_strings(a.label, b.label);
  }); // Add the "International" option to the country list (if suitable)

  if (includeInternationalOption) {
    country_select_options.unshift({
      label: country_names.ZZ
    });
  }

  return country_select_options;
}
/**
 * Parses a E.164 phone number to an instance of `PhoneNumber` class.
 * @param {string?} value = E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @example
 * parsePhoneNumber('+78005553535')
 */


function parsePhoneNumber(value, metadata) {
  return parsePhoneNumberFromString(value || '', metadata);
}
/**
 * Generates national number digits for a parsed phone.
 * May prepend national prefix.
 * The phone number must be a complete and valid phone number.
 * @param  {object} phoneNumber - An instance of `PhoneNumber` class.
 * @param  {object} metadata - `libphonenumber-js` metadata
 * @return {string}
 * @example
 * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
 * // returns '88005553535'
 */


function generateNationalNumberDigits(phoneNumber) {
  return phoneNumber.formatNational().replace(/\D/g, '');
}
/**
 * Migrates parsed `<input/>` `value` for the newly selected `country`.
 * @param {string?} value - The `value` parsed from phone number `<input/>` (it's the `parsed_input` state property, not the `value` property).
 * @param {string?} previousCountry - Previously selected country.
 * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @param {boolean} preferNationalFormat - whether should attempt to convert from international to national number for the new country.
 * @return {string?}
 */


function migrateParsedInputForNewCountry(value, previous_country, new_country, metadata, preferNationalFormat) {
  // If `parsed_input` is empty
  // then no need to migrate anything.
  if (!value) {
    return value;
  } // If switching to some country.
  // (from "International" or another country)
  // If switching from "International" then `value` starts with a `+`.
  // Otherwise it may or may not start with a `+`.


  if (new_country) {
    // If the phone number was entered in international format
    // then migrate it to the newly selected country.
    // The phone number may be incomplete.
    // The phone number entered not necessarily starts with
    // the previously selected country phone prefix.
    if (value[0] === '+') {
      // If the international phone number is for the new country
      // then convert it to local if required.
      if (preferNationalFormat) {
        // // If a phone number is being input in international form
        // // and the country can already be derived from it,
        // // and if it is the new country, then format as a national number.
        // const derived_country = get_country_from_possibly_incomplete_international_phone_number(value, metadata)
        // if (derived_country === new_country)
        // {
        // 	return strip_country_calling_code(value, derived_country, metadata)
        // }
        // Actually, the two countries don't necessarily need to match:
        // the condition could be looser here, because several countries
        // might share the same international phone number format
        // (for example, "NANPA" countries like US, Canada, etc).
        // The looser condition would be just "same nternational phone number format"
        // which would mean "same country calling code" in the context of `libphonenumber-js`.
        if (value.indexOf('+' + getCountryCallingCode(new_country, metadata)) === 0) {
          return strip_country_calling_code(value, new_country, metadata);
        } // Simply discard the previously entered international phone number,
        // because otherwise any "smart" transformation like getting the
        // "national (significant) number" part and then prepending the
        // newly selected country's "country calling code" to it
        // would just be confusing for a user without being actually useful.


        return ''; // // Simply strip the leading `+` character
        // // therefore simply converting all digits into a "local" phone number.
        // // https://github.com/catamphetamine/react-phone-number-input/issues/287
        // return value.slice(1)
      } // If the international phone number already contains
      // any country calling code then trim the country calling code part.
      // (that could also be the newly selected country phone code prefix as well)
      // `value` doesn't neccessarily belong to `previous_country`.
      // (e.g. if a user enters an international number
      //  not belonging to any of the reduced `countries` list).


      value = strip_country_calling_code(value, previous_country, metadata); // Prepend country calling code prefix
      // for the newly selected country.

      return e164(value, new_country, metadata) || "+".concat(getCountryCallingCode(new_country, metadata));
    }
  } // If switching to "International" from a country.
  else {
    // If the phone number was entered in national format.
    if (value[0] !== '+') {
      // Format the national phone number as an international one.
      // The phone number entered not necessarily even starts with
      // the previously selected country phone prefix.
      // Even if the phone number belongs to whole another country
      // it will still be parsed into some national phone number.
      return e164(value, previous_country, metadata) || '';
    }
  }

  return value;
}
/**
 * Converts phone number digits to a (possibly incomplete) E.164 phone number.
 * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string?} country
 * @param  {[object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function e164(number, country, metadata) {
  if (!number) {
    return;
  } // If the phone number is being input in international format.


  if (number[0] === '+') {
    // If it's just the `+` sign then return nothing.
    if (number === '+') {
      return;
    } // If there are any digits then the `value` is returned as is.


    return number;
  } // For non-international phone numbers
  // an accompanying country code is required.


  if (!country) {
    return;
  }

  var partial_national_significant_number = getNationalSignificantNumberDigits(number, country, metadata);

  if (partial_national_significant_number) {
    return "+".concat(getCountryCallingCode(country, metadata)).concat(partial_national_significant_number);
  }
}
/**
 * Trims phone number digits if they exceed the maximum possible length
 * for a national (significant) number for the country.
 * @param  {string} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
 * @param  {string} country
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string} Can be empty.
 */


function trimNumber(number, country, metadata) {
  var nationalSignificantNumberPart = getNationalSignificantNumberDigits(number, country, metadata);

  if (nationalSignificantNumberPart) {
    var overflowDigitsCount = nationalSignificantNumberPart.length - getMaxNumberLength(country, metadata);

    if (overflowDigitsCount > 0) {
      return number.slice(0, number.length - overflowDigitsCount);
    }
  }

  return number;
}

function getMaxNumberLength(country, metadata) {
  // Get "possible lengths" for a phone number of the country.
  metadata = new Metadata(metadata);
  metadata.country(country); // Return the last "possible length".

  return metadata.possibleLengths()[metadata.possibleLengths().length - 1];
} // If the phone number being input is an international one
// then tries to derive the country from the phone number.
// (regardless of whether there's any country currently selected)

/**
 * @param {string} parsedInput - A possibly incomplete E.164 phone number.
 * @param {string?} country - Currently selected country.
 * @param {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param {boolean} includeInternationalOption - Whether "International" country option is available.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function getCountryForPartialE164Number(partialE164Number, country, countries, includeInternationalOption, metadata) {
  if (partialE164Number === '+') {
    // Don't change the currently selected country yet.
    return country;
  }

  var derived_country = get_country_from_possibly_incomplete_international_phone_number(partialE164Number, metadata); // If a phone number is being input in international form
  // and the country can already be derived from it,
  // then select that country.

  if (derived_country && (!countries || countries.indexOf(derived_country) >= 0)) {
    return derived_country;
  } // If "International" country option has not been disabled
  // and the international phone number entered doesn't correspond
  // to the currently selected country then reset the currently selected country.
  else if (country && includeInternationalOption && !could_number_belong_to_country(partialE164Number, country, metadata)) {
    return undefined;
  } // Don't change the currently selected country.


  return country;
}
/**
 * Parses `<input/>` value. Derives `country` from `input`. Derives an E.164 `value`.
 * @param  {string?} input — Parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} prevInput — Previous parsed `<input/>` value. Examples: `""`, `"+"`, `"+123"`, `"123"`.
 * @param  {string?} country - Currently selected country.
 * @param  {string[]?} countries - A list of available countries. If not passed then "all countries" are assumed.
 * @param  {boolean} includeInternationalOption - Whether "International" country option is available.
 * @param  {boolean} limitMaxLength — Whether to enable limiting phone number max length.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {object} An object of shape `{ input, country, value }`.
 */


function parseInput(input, prevInput, country, defaultCountry, countries, includeInternationalOption, limitMaxLength, metadata) {
  // Trim the input to not exceed the maximum possible number length.
  if (input && country && limitMaxLength) {
    input = trimNumber(input, country, metadata);
  } // If this `onChange()` event was triggered
  // as a result of selecting "International" country
  // then force-prepend a `+` sign if the phone number
  // `<input/>` value isn't in international format.


  if (input && !country && input[0] !== '+') {
    input = '+' + input;
  } // If the previously entered phone number
  // has been entered in international format
  // and the user decides to erase it,
  // then also reset the `country`
  // because it was most likely automatically selected
  // while the user was typing in the phone number
  // in international format.
  // This fixes the issue when a user is presented
  // with a phone number input with no country selected
  // and then types in their local phone number
  // then discovers that the input's messed up
  // (a `+` has been prepended at the start of their input
  //  and a random country has been selected),
  // decides to undo it all by erasing everything
  // and then types in their local phone number again
  // resulting in a seemingly correct phone number
  // but in reality that phone number has incorrect country.
  // https://github.com/catamphetamine/react-phone-number-input/issues/273


  if (!input && prevInput && prevInput[0] === '+') {
    country = defaultCountry;
  } // Also resets such "randomly" selected country
  // as soon as the user erases the number
  // digit-by-digit up to the leading `+` sign.


  if (input === '+' && prevInput && prevInput[0] === '+' && prevInput.length > '+'.length) {
    country = undefined;
  } // Generate the new `value` property.


  var value;

  if (input) {
    if (input[0] === '+') {
      if (input !== '+') {
        value = input;
      }
    } else {
      value = e164(input, country, metadata);
    }
  } // Derive the country from the phone number.
  // (regardless of whether there's any country currently selected)


  if (value) {
    country = getCountryForPartialE164Number(value, country, countries, includeInternationalOption, metadata);
  }

  return {
    input: input,
    country: country,
    value: value
  };
}
/**
 * Determines the country for a given (possibly incomplete) E.164 phone number.
 * @param  {string} number - A possibly incomplete E.164 phone number.
 * @param  {object} metadata - `libphonenumber-js` metadata.
 * @return {string?}
 */


function get_country_from_possibly_incomplete_international_phone_number(number, metadata) {
  var formatter = new AsYouType(null, metadata);
  formatter.input(number); // `001` is a special "non-geograpical entity" code
  // in Google's `libphonenumber` library.

  if (formatter.country === '001') {
    return;
  }

  return formatter.country;
}
/**
 * Compares two strings.
 * A helper for `Array.sort()`.
 */


function compare_strings(a, b) {
  // Use `String.localeCompare` if it's available.
  // https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
  // Which means everyone except IE <= 10 and Safari <= 10.
  // `localeCompare()` is available in latest Node.js versions.

  /* istanbul ignore else */
  if (String.prototype.localeCompare) {
    return a.localeCompare(b);
  }
  /* istanbul ignore next */


  return a < b ? -1 : a > b ? 1 : 0;
}
/**
 * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
 * @param {string} number - (possibly incomplete) E.164 phone number.
 * @param {string?} country - A possible country for this phone number.
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string}
 */


function strip_country_calling_code(number, country, metadata) {
  // Just an optimization, so that it
  // doesn't have to iterate through all country calling codes.
  if (country) {
    var country_calling_prefix = '+' + getCountryCallingCode(country, metadata); // If `country` fits the actual `number`.

    if (number.length < country_calling_prefix.length) {
      if (country_calling_prefix.indexOf(number) === 0) {
        return '';
      }
    } else {
      if (number.indexOf(country_calling_prefix) === 0) {
        return number.slice(country_calling_prefix.length);
      }
    }
  } // If `country` doesn't fit the actual `number`.
  // Try all available country calling codes.


  for (var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++) {
    var country_calling_code = _Object$keys[_i];

    if (number.indexOf(country_calling_code) === '+'.length) {
      return number.slice('+'.length + country_calling_code.length);
    }
  }

  return '';
}
/**
 * Parses a partially entered national phone number digits
 * (or a partially entered E.164 international phone number)
 * and returns the national significant number part.
 * National significant number returned doesn't come with a national prefix.
 * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
 * @param {string?} country
 * @param {object} metadata - `libphonenumber-js` metadata.
 * @return {string} [result]
 */


function getNationalSignificantNumberDigits(number, country, metadata) {
  // Create "as you type" formatter.
  var formatter = new AsYouType(country, metadata); // Input partial national phone number.

  formatter.input(number); // Return the parsed partial national phone number.

  var phoneNumber = formatter.getNumber();
  return phoneNumber && phoneNumber.nationalNumber;
}
/**
 * Checks if a partially entered E.164 phone number could belong to a country.
 * @param  {string} number
 * @param  {string} country
 * @return {boolean}
 */


function could_number_belong_to_country(number, country, metadata) {
  var country_calling_code = getCountryCallingCode(country, metadata);
  var i = 0;

  while (i + 1 < number.length && i < country_calling_code.length) {
    if (number[i + 1] !== country_calling_code[i]) {
      return false;
    }

    i++;
  }

  return true;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

function _objectWithoutProperties$6(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$9(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$9(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$2(self);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var PhoneNumberInput_ = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$1(PhoneNumberInput_, _React$PureComponent);

  function PhoneNumberInput_(props) {
    var _this;

    _classCallCheck$1(this, PhoneNumberInput_);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(PhoneNumberInput_).call(this, props));

    _defineProperty$2(_assertThisInitialized$2(_this), "inputRef", React.createRef());

    _defineProperty$2(_assertThisInitialized$2(_this), "isCountrySupportedWithError", function (country) {
      var metadata = _this.props.metadata;
      return isCountrySupportedWithError(country, metadata);
    });

    _defineProperty$2(_assertThisInitialized$2(_this), "onCountryChange", function (newCountry) {
      var _this$props = _this.props,
          metadata = _this$props.metadata,
          onChange = _this$props.onChange;
      var _this$state = _this.state,
          prevParsedInput = _this$state.parsedInput,
          prevCountry = _this$state.country; // After the new `country` has been selected,
      // if the phone number `<input/>` holds any digits
      // then migrate those digits for the new `country`.

      var newParsedInput = migrateParsedInputForNewCountry(prevParsedInput, prevCountry, newCountry, metadata, // Convert the phone number to "national" format
      // when the user changes the selected country by hand.
      true);
      var newValue = e164(newParsedInput, newCountry, metadata); // Focus phone number `<input/>` upon country selection.

      _this.getInputRef().current.focus(); // If the user has already manually selected a country
      // then don't override that already selected country
      // if the `defaultCountry` property changes.
      // That's what `hasUserSelectedACountry` flag is for.


      _this.setState({
        country: newCountry,
        hasUserSelectedACountry: true,
        parsedInput: newParsedInput,
        value: newValue
      }, function () {
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        onChange(newValue);
      });
    });

    _defineProperty$2(_assertThisInitialized$2(_this), "onChange", function (_input) {
      var _this$props2 = _this.props,
          defaultCountry = _this$props2.defaultCountry,
          onChange = _this$props2.onChange,
          addInternationalOption = _this$props2.addInternationalOption,
          limitMaxLength = _this$props2.limitMaxLength,
          metadata = _this$props2.metadata;

      var _parseInput = parseInput(_input, _this.state.parsedInput, _this.state.country, defaultCountry, _this.state.countries, addInternationalOption, limitMaxLength, metadata),
          input = _parseInput.input,
          country = _parseInput.country,
          value = _parseInput.value;

      _this.setState({
        parsedInput: input,
        value: value,
        country: country
      }, // Update the new `value` property.
      // Doing it after the `state` has been updated
      // because `onChange()` will trigger `getDerivedStateFromProps()`
      // with the new `value` which will be compared to `state.value` there.
      function () {
        return onChange(value);
      });
    });

    _defineProperty$2(_assertThisInitialized$2(_this), "_onFocus", function () {
      return _this.setState({
        isFocused: true
      });
    });

    _defineProperty$2(_assertThisInitialized$2(_this), "_onBlur", function () {
      return _this.setState({
        isFocused: false
      });
    });

    _defineProperty$2(_assertThisInitialized$2(_this), "onFocus", function (event) {
      _this._onFocus();

      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    });

    _defineProperty$2(_assertThisInitialized$2(_this), "onBlur", function (event) {
      var onBlur = _this.props.onBlur;

      _this._onBlur();

      if (onBlur) {
        onBlur(event);
      }
    });

    _defineProperty$2(_assertThisInitialized$2(_this), "onCountryFocus", function (event) {
      _this._onFocus(); // this.setState({ countrySelectFocused: true })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onFocus = countrySelectProps.onFocus;

        if (onFocus) {
          onFocus(event);
        }
      }
    });

    _defineProperty$2(_assertThisInitialized$2(_this), "onCountryBlur", function (event) {
      _this._onBlur(); // this.setState({ countrySelectFocused: false })


      var countrySelectProps = _this.props.countrySelectProps;

      if (countrySelectProps) {
        var onBlur = countrySelectProps.onBlur;

        if (onBlur) {
          onBlur(event);
        }
      }
    });

    var _this$props3 = _this.props,
        _value = _this$props3.value,
        labels = _this$props3.labels,
        _addInternationalOption = _this$props3.addInternationalOption,
        _metadata = _this$props3.metadata,
        countryOptionsOrder = _this$props3.countryOptionsOrder;
    var _this$props4 = _this.props,
        _defaultCountry = _this$props4.defaultCountry,
        countries = _this$props4.countries; // Validate `defaultCountry`.

    if (_defaultCountry) {
      if (!_this.isCountrySupportedWithError(_defaultCountry)) {
        _defaultCountry = undefined;
      }
    } // Validate `countries`.


    countries = getSupportedCountries(countries, _metadata);
    var phoneNumber = parsePhoneNumber(_value, _metadata);
    _this.CountryIcon = createCountryIconComponent(_this.props);
    _this.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: _this.props,
      // The country selected.
      country: getPreSelectedCountry(phoneNumber, _defaultCountry, countries || getCountries(_metadata), _addInternationalOption),
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: countries,
      // `parsedInput` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value`is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `parsedInput` is `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `parsedInput` is `+78005553535`.
      parsedInput: generateParsedInput(_value, phoneNumber, _this.props),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `parsedInput` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `parsedInput` and `country` should be updated.
      value: _value
    };
    return _this;
  }

  _createClass$1(PhoneNumberInput_, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onCountryChange = this.props.onCountryChange;
      var defaultCountry = this.props.defaultCountry;
      var selectedCountry = this.state.country;

      if (onCountryChange) {
        if (defaultCountry) {
          if (!this.isCountrySupportedWithError(defaultCountry)) {
            defaultCountry = undefined;
          }
        }

        if (selectedCountry !== defaultCountry) {
          onCountryChange(selectedCountry);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onCountryChange = this.props.onCountryChange;
      var country = this.state.country; // Call `onCountryChange` when user selects another country.

      if (onCountryChange && country !== prevState.country) {
        onCountryChange(country);
      }
    } // A shorthand for not passing `metadata` as a second argument.

  }, {
    key: "getInputRef",
    value: function getInputRef() {
      var inputRef = this.props.inputRef;
      return inputRef || this.inputRef;
    } // `state` holds previous props as `props`, and also:
    // * `country` — The currently selected country, e.g. `"RU"`.
    // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
    // * `parsedInput` — The parsed `<input/>` value, e.g. `8005553535`.
    // (and a couple of other less significant properties)

  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          name = _this$props5.name,
          disabled = _this$props5.disabled,
          autoComplete = _this$props5.autoComplete,
          style = _this$props5.style,
          className = _this$props5.className,
          inputRef = _this$props5.inputRef,
          inputComponent = _this$props5.inputComponent,
          numberInputProps = _this$props5.numberInputProps,
          smartCaret = _this$props5.smartCaret,
          CountrySelectComponent = _this$props5.countrySelectComponent,
          countrySelectProps = _this$props5.countrySelectProps,
          defaultCountry = _this$props5.defaultCountry,
          countries = _this$props5.countries,
          countryOptionsOrder = _this$props5.countryOptionsOrder,
          labels = _this$props5.labels,
          flags = _this$props5.flags,
          flagComponent = _this$props5.flagComponent,
          flagUrl = _this$props5.flagUrl,
          addInternationalOption = _this$props5.addInternationalOption,
          internationalIcon = _this$props5.internationalIcon,
          displayInitialValueAsLocalNumber = _this$props5.displayInitialValueAsLocalNumber,
          onCountryChange = _this$props5.onCountryChange,
          limitMaxLength = _this$props5.limitMaxLength,
          reset = _this$props5.reset,
          metadata = _this$props5.metadata,
          rest = _objectWithoutProperties$6(_this$props5, ["name", "disabled", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "onCountryChange", "limitMaxLength", "reset", "metadata"]);

      var _this$state2 = this.state,
          country = _this$state2.country,
          parsedInput = _this$state2.parsedInput,
          isFocused = _this$state2.isFocused;
      var InputComponent = smartCaret ? InputSmart : InputBasic;
      var countrySelectOptions = useMemoCountrySelectOptions(function () {
        return sortCountryOptions(getCountrySelectOptions(countries || getCountries(metadata), labels, addInternationalOption), getSupportedCountryOptions(countryOptionsOrder, metadata));
      }, [countries, countryOptionsOrder, addInternationalOption, labels, metadata]);
      return React.createElement("div", {
        style: style,
        className: classnames(className, 'PhoneInput', {
          'PhoneInput--focus': isFocused
        })
      }, React.createElement(CountrySelectComponent, _extends$a({
        name: name ? "".concat(name, "Country") : undefined,
        "aria-label": labels.country
      }, countrySelectProps, {
        value: country,
        options: countrySelectOptions,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: disabled || countrySelectProps && countrySelectProps.disabled,
        iconComponent: this.CountryIcon
      })), React.createElement(InputComponent, _extends$a({
        ref: this.getInputRef(),
        type: "tel",
        autoComplete: autoComplete
      }, numberInputProps, rest, {
        name: name,
        metadata: metadata,
        country: country,
        value: parsedInput || '',
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: disabled,
        inputComponent: inputComponent,
        className: classnames('PhoneInputInput', numberInputProps && numberInputProps.className, rest.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var country = state.country,
          hasUserSelectedACountry = state.hasUserSelectedACountry,
          value = state.value,
          _state$props = state.props,
          prevDefaultCountry = _state$props.defaultCountry,
          prevValue = _state$props.value,
          prevReset = _state$props.reset;
      var metadata = props.metadata,
          countries = props.countries,
          newDefaultCountry = props.defaultCountry,
          newValue = props.value,
          newReset = props.reset;
      var newState = {
        // Emulate `prevProps` via `state.props`.
        props: props,
        // If the user has already manually selected a country
        // then don't override that already selected country
        // if the `defaultCountry` property changes.
        // That's what `hasUserSelectedACountry` flag is for.
        hasUserSelectedACountry: hasUserSelectedACountry
      }; // Some users requested a way to reset the component
      // (both number `<input/>` and country `<select/>`).
      // Whenever `reset` property changes both number `<input/>`
      // and country `<select/>` are reset.
      // It's not implemented as some instance `.reset()` method
      // because `ref` is forwarded to `<input/>`.
      // It's also not replaced with just resetting `country` on
      // external `value` reset, because a user could select a country
      // and then not input any `value`, and so the selected country
      // would be "stuck", if not using this `reset` property.
      // https://github.com/catamphetamine/react-phone-number-input/issues/300

      if (newReset !== prevReset) {
        return _objectSpread({}, newState, {
          parsedInput: undefined,
          value: undefined,
          country: newDefaultCountry,
          hasUserSelectedACountry: undefined
        });
      } // If the default country changed.
      // (e.g. in case of ajax GeoIP detection after page loaded)
      // then select it but only if the user hasn't already manually
      // selected a country and no phone number has been entered so far.
      // Because if the user has already started inputting a phone number
      // then he's okay with no country being selected at all ("International")
      // and doesn't want to be disturbed, doesn't want his input to be screwed, etc.


      if (newDefaultCountry !== prevDefaultCountry && !hasUserSelectedACountry && !value && !newValue) {
        return _objectSpread({}, newState, {
          country: isCountrySupportedWithError(newDefaultCountry, metadata) ? newDefaultCountry : prevDefaultCountry // `value` is `undefined`.
          // `parsedInput` is `undefined` because `value` is `undefined`.

        });
      } // If a new `value` is set externally.
      // (e.g. as a result of an ajax API request
      //  to get user's phone after page loaded)
      // The first part — `newValue !== prevValue` —
      // is basically `props.value !== prevProps.value`
      // so it means "if value property was changed externally".
      // The second part — `newValue !== value` —
      // is for ignoring the `getDerivedStateFromProps()` call
      // which happens in `this.onChange()` right after `this.setState()`.
      // If this `getDerivedStateFromProps()` call isn't ignored
      // then the country flag would reset on each input.
      else if (newValue !== prevValue && newValue !== value) {
        var phoneNumber = parsePhoneNumber(newValue, metadata);
        var parsedCountry;

        if (phoneNumber) {
          var _countries = getSupportedCountries(props.countries, metadata);

          if (!_countries || _countries.indexOf(phoneNumber.country) >= 0) {
            parsedCountry = phoneNumber.country;
          }
        }

        if (!newValue) {
          newState.hasUserSelectedACountry = undefined;
        }

        return _objectSpread({}, newState, {
          parsedInput: generateParsedInput(newValue, phoneNumber, props),
          value: newValue,
          country: newValue ? parsedCountry : newDefaultCountry
        });
      } // `defaultCountry` didn't change.
      // `value` didn't change.
      // `parsedInput` didn't change, because `value` didn't change.
      //
      // So no need to update state here really.
      // Could as well return `null` explicitly
      // to indicate that the `state` hasn't changed.
      // But just in case, returns `newState`.
      // (who knows if someone adds something
      // changing `newState` above in some future)


      return newState;
    }
  }]);

  return PhoneNumberInput_;
}(React.PureComponent); // This wrapper is only to `.forwardRef()` to the `<input/>`.


var PhoneNumberInput = React.forwardRef(function (props, ref) {
  return React.createElement(PhoneNumberInput_, _extends$a({}, props, {
    inputRef: ref
  }));
});
PhoneNumberInput.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   */
  value: PropTypes__default.string,

  /**
   * Updates the `value` as the user inputs the phone number.
   */
  onChange: PropTypes__default.func.isRequired,

  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: PropTypes__default.func,

  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: PropTypes__default.func,

  /**
   * `onKeyDown` handler (e.g. to handle Enter key press).
   * @ignore
   */
  onKeyDown: PropTypes__default.func,

  /**
   * Set to `true` to disable both the phone number `<input/>`
   * and the country `<select/>`.
   */
  disabled: PropTypes__default.bool,

  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: PropTypes__default.string.isRequired,

  /**
   * Set to `true` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if this flag is set to `true`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, this flag is set to `false`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `false` by default)
  displayInitialValueAsLocalNumber: PropTypes__default.bool.isRequired,

  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: PropTypes__default.string,

  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: PropTypes__default.arrayOf(PropTypes__default.string),

  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: labels.isRequired,

  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` github pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: PropTypes__default.string.isRequired,

  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: PropTypes__default.objectOf(PropTypes__default.elementType),

  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: PropTypes__default.elementType.isRequired,

  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: PropTypes__default.bool.isRequired,

  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: PropTypes__default.elementType.isRequired,

  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"|"` — inserts a separator.
   * * `"..."` — means "the rest of the countries" (can be omitted, in which case it will automatically be added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: PropTypes__default.arrayOf(PropTypes__default.string),

  /**
   * `<Phone/>` component CSS style object.
   */
  style: PropTypes__default.object,

  /**
   * `<Phone/>` component CSS class.
   */
  className: PropTypes__default.string,

  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: PropTypes__default.elementType.isRequired,

  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: PropTypes__default.object,

  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: PropTypes__default.elementType.isRequired,

  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: PropTypes__default.object,

  /**
   * By default, the caret position is being "intelligently" managed
   * while a user inputs a phone number.
   * This "smart" caret behavior can be turned off
   * by passing `smartCaret={false}` property.
   * This is just an "escape hatch" for any possible caret position issues.
   */
  // Is `true` by default.
  smartCaret: PropTypes__default.bool.isRequired,

  /**
   * If set to `true` the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: PropTypes__default.bool.isRequired,

  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: metadata.isRequired,

  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: PropTypes__default.func
};
PhoneNumberInput.defaultProps = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: 'tel',

  /**
   * Flag icon component.
   */
  flagComponent: FlagComponent,

  /**
   * By default, uses icons from `country-flag-icons` github pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: 'https://catamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',

  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: InternationalIcon,

  /**
   * Phone number `<input/>` component.
   */
  inputComponent: 'input',

  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: PropTypes__default.any,

  /**
   * Don't convert the initially passed phone number `value`
   * to a national phone number for its country.
   * The reason is that the newer generation grows up when
   * there are no stationary phones and therefore everyone inputs
   * phone numbers with a `+` in their smartphones
   * so phone numbers written in international form
   * are gradually being considered more natural than local ones.
   */
  displayInitialValueAsLocalNumber: false,

  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: true,

  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: true,

  /**
   * If set to `true` the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: false
};

function generateParsedInput(value, phoneNumber, _ref) {
  var displayInitialValueAsLocalNumber = _ref.displayInitialValueAsLocalNumber; // If the `value` (E.164 phone number)
  // belongs to the currently selected country
  // and `displayInitialValueAsLocalNumber` property is `true`
  // then convert `value` (E.164 phone number)
  // to a local phone number digits.
  // E.g. '+78005553535' -> '88005553535'.

  if (displayInitialValueAsLocalNumber && phoneNumber && phoneNumber.country) {
    return generateNationalNumberDigits(phoneNumber);
  }

  return value;
}

var countrySelectOptionsMemo;
var countrySelectOptionsMemoDependencies;

function useMemoCountrySelectOptions(generator, dependencies) {
  if (!countrySelectOptionsMemoDependencies || !areEqualArrays(dependencies, countrySelectOptionsMemoDependencies)) {
    countrySelectOptionsMemo = generator();
    countrySelectOptionsMemoDependencies = dependencies;
  }

  return countrySelectOptionsMemo;
}

function areEqualArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  var i = 0;

  while (i < a.length) {
    if (a[i] !== b[i]) {
      return false;
    }

    i++;
  }

  return true;
}

function isPossiblePhoneNumber(value, metadata) {
  if (!value) {
    return false;
  }

  var phoneNumber = parsePhoneNumberFromString(value, metadata);

  if (!phoneNumber) {
    return false;
  }

  return phoneNumber.isPossible();
}

var ext = "ext.";
var country = "Phone number country";
var phone = "Phone";
var AB = "Abkhazia";
var AC = "Ascension Island";
var AD = "Andorra";
var AE = "United Arab Emirates";
var AF = "Afghanistan";
var AG = "Antigua and Barbuda";
var AI = "Anguilla";
var AL = "Albania";
var AM = "Armenia";
var AO = "Angola";
var AQ = "Antarctica";
var AR = "Argentina";
var AS = "American Samoa";
var AT = "Austria";
var AU = "Australia";
var AW = "Aruba";
var AX = "Åland Islands";
var AZ = "Azerbaijan";
var BA = "Bosnia and Herzegovina";
var BB = "Barbados";
var BD = "Bangladesh";
var BE = "Belgium";
var BF = "Burkina Faso";
var BG = "Bulgaria";
var BH = "Bahrain";
var BI = "Burundi";
var BJ = "Benin";
var BL = "Saint Barthélemy";
var BM = "Bermuda";
var BN = "Brunei Darussalam";
var BO = "Bolivia";
var BQ = "Bonaire, Sint Eustatius and Saba";
var BR = "Brazil";
var BS = "Bahamas";
var BT = "Bhutan";
var BV = "Bouvet Island";
var BW = "Botswana";
var BY = "Belarus";
var BZ = "Belize";
var CA = "Canada";
var CC = "Cocos (Keeling) Islands";
var CD = "Congo, Democratic Republic of the";
var CF = "Central African Republic";
var CG = "Congo";
var CH = "Switzerland";
var CI = "Cote d'Ivoire";
var CK = "Cook Islands";
var CL = "Chile";
var CM = "Cameroon";
var CN = "China";
var CO = "Colombia";
var CR$1 = "Costa Rica";
var CU = "Cuba";
var CV = "Cape Verde";
var CW = "Curaçao";
var CX = "Christmas Island";
var CY = "Cyprus";
var CZ = "Czech Republic";
var DE = "Germany";
var DJ = "Djibouti";
var DK = "Denmark";
var DM = "Dominica";
var DO = "Dominican Republic";
var DZ = "Algeria";
var EC = "Ecuador";
var EE = "Estonia";
var EG = "Egypt";
var EH = "Western Sahara";
var ER = "Eritrea";
var ES = "Spain";
var ET = "Ethiopia";
var FI = "Finland";
var FJ = "Fiji";
var FK = "Falkland Islands";
var FM = "Federated States of Micronesia";
var FO = "Faroe Islands";
var FR = "France";
var GA = "Gabon";
var GB = "United Kingdom";
var GD = "Grenada";
var GE = "Georgia";
var GF = "French Guiana";
var GG = "Guernsey";
var GH = "Ghana";
var GI = "Gibraltar";
var GL = "Greenland";
var GM = "Gambia";
var GN = "Guinea";
var GP = "Guadeloupe";
var GQ = "Equatorial Guinea";
var GR = "Greece";
var GS = "South Georgia and the South Sandwich Islands";
var GT = "Guatemala";
var GU = "Guam";
var GW = "Guinea-Bissau";
var GY = "Guyana";
var HK = "Hong Kong";
var HM = "Heard Island and McDonald Islands";
var HN = "Honduras";
var HR = "Croatia";
var HT = "Haiti";
var HU = "Hungary";
var ID = "Indonesia";
var IE = "Ireland";
var IL = "Israel";
var IM = "Isle of Man";
var IN = "India";
var IO = "British Indian Ocean Territory";
var IQ = "Iraq";
var IR = "Iran";
var IS = "Iceland";
var IT = "Italy";
var JE = "Jersey";
var JM = "Jamaica";
var JO = "Jordan";
var JP = "Japan";
var KE = "Kenya";
var KG = "Kyrgyzstan";
var KH = "Cambodia";
var KI = "Kiribati";
var KM = "Comoros";
var KN = "Saint Kitts and Nevis";
var KP = "North Korea";
var KR = "South Korea";
var KW = "Kuwait";
var KY = "Cayman Islands";
var KZ = "Kazakhstan";
var LA = "Laos";
var LB = "Lebanon";
var LC = "Saint Lucia";
var LI = "Liechtenstein";
var LK = "Sri Lanka";
var LR = "Liberia";
var LS = "Lesotho";
var LT = "Lithuania";
var LU = "Luxembourg";
var LV = "Latvia";
var LY = "Libya";
var MA = "Morocco";
var MC = "Monaco";
var MD = "Moldova";
var ME = "Montenegro";
var MF = "Saint Martin (French Part)";
var MG = "Madagascar";
var MH = "Marshall Islands";
var MK = "North Macedonia";
var ML = "Mali";
var MM = "Burma";
var MN = "Mongolia";
var MO = "Macao";
var MP = "Northern Mariana Islands";
var MQ = "Martinique";
var MR = "Mauritania";
var MS = "Montserrat";
var MT = "Malta";
var MU = "Mauritius";
var MV = "Maldives";
var MW = "Malawi";
var MX = "Mexico";
var MY = "Malaysia";
var MZ = "Mozambique";
var NA = "Namibia";
var NC = "New Caledonia";
var NE = "Niger";
var NF = "Norfolk Island";
var NG = "Nigeria";
var NI = "Nicaragua";
var NL = "Netherlands";
var NO = "Norway";
var NP = "Nepal";
var NR = "Nauru";
var NU = "Niue";
var NZ = "New Zealand";
var OM = "Oman";
var OS = "South Ossetia";
var PA = "Panama";
var PE = "Peru";
var PF = "French Polynesia";
var PG = "Papua New Guinea";
var PH = "Philippines";
var PK = "Pakistan";
var PL = "Poland";
var PM = "Saint Pierre and Miquelon";
var PN = "Pitcairn";
var PR = "Puerto Rico";
var PS = "Palestine";
var PT = "Portugal";
var PW = "Palau";
var PY = "Paraguay";
var QA = "Qatar";
var RE = "Reunion";
var RO = "Romania";
var RS = "Serbia";
var RU = "Russia";
var RW = "Rwanda";
var SA = "Saudi Arabia";
var SB = "Solomon Islands";
var SC = "Seychelles";
var SD = "Sudan";
var SE = "Sweden";
var SG = "Singapore";
var SH = "Saint Helena";
var SI = "Slovenia";
var SJ = "Svalbard and Jan Mayen";
var SK = "Slovakia";
var SL = "Sierra Leone";
var SM = "San Marino";
var SN = "Senegal";
var SO = "Somalia";
var SR = "Suriname";
var SS = "South Sudan";
var ST = "Sao Tome and Principe";
var SV = "El Salvador";
var SX = "Sint Maarten";
var SY = "Syria";
var SZ = "Swaziland";
var TA = "Tristan da Cunha";
var TC = "Turks and Caicos Islands";
var TD = "Chad";
var TF = "French Southern Territories";
var TG = "Togo";
var TH = "Thailand";
var TJ = "Tajikistan";
var TK = "Tokelau";
var TL = "Timor-Leste";
var TM = "Turkmenistan";
var TN = "Tunisia";
var TO = "Tonga";
var TR = "Turkey";
var TT = "Trinidad and Tobago";
var TV = "Tuvalu";
var TW = "Taiwan";
var TZ = "Tanzania";
var UA = "Ukraine";
var UG = "Uganda";
var UM = "United States Minor Outlying Islands";
var US = "United States";
var UY = "Uruguay";
var UZ = "Uzbekistan";
var VA = "Holy See (Vatican City State)";
var VC = "Saint Vincent and the Grenadines";
var VE = "Venezuela";
var VG = "Virgin Islands, British";
var VI = "Virgin Islands, U.S.";
var VN = "Vietnam";
var VU = "Vanuatu";
var WF = "Wallis and Futuna";
var WS = "Samoa";
var XK = "Kosovo";
var YE = "Yemen";
var YT = "Mayotte";
var ZA = "South Africa";
var ZM = "Zambia";
var ZW = "Zimbabwe";
var ZZ = "International";
var labels$1 = {
  ext: ext,
  country: country,
  phone: phone,
  AB: AB,
  AC: AC,
  AD: AD,
  AE: AE,
  AF: AF,
  AG: AG,
  AI: AI,
  AL: AL,
  AM: AM,
  AO: AO,
  AQ: AQ,
  AR: AR,
  AS: AS,
  AT: AT,
  AU: AU,
  AW: AW,
  AX: AX,
  AZ: AZ,
  BA: BA,
  BB: BB,
  BD: BD,
  BE: BE,
  BF: BF,
  BG: BG,
  BH: BH,
  BI: BI,
  BJ: BJ,
  BL: BL,
  BM: BM,
  BN: BN,
  BO: BO,
  BQ: BQ,
  BR: BR,
  BS: BS,
  BT: BT,
  BV: BV,
  BW: BW,
  BY: BY,
  BZ: BZ,
  CA: CA,
  CC: CC,
  CD: CD,
  CF: CF,
  CG: CG,
  CH: CH,
  CI: CI,
  CK: CK,
  CL: CL,
  CM: CM,
  CN: CN,
  CO: CO,
  CR: CR$1,
  CU: CU,
  CV: CV,
  CW: CW,
  CX: CX,
  CY: CY,
  CZ: CZ,
  DE: DE,
  DJ: DJ,
  DK: DK,
  DM: DM,
  DO: DO,
  DZ: DZ,
  EC: EC,
  EE: EE,
  EG: EG,
  EH: EH,
  ER: ER,
  ES: ES,
  ET: ET,
  FI: FI,
  FJ: FJ,
  FK: FK,
  FM: FM,
  FO: FO,
  FR: FR,
  GA: GA,
  GB: GB,
  GD: GD,
  GE: GE,
  GF: GF,
  GG: GG,
  GH: GH,
  GI: GI,
  GL: GL,
  GM: GM,
  GN: GN,
  GP: GP,
  GQ: GQ,
  GR: GR,
  GS: GS,
  GT: GT,
  GU: GU,
  GW: GW,
  GY: GY,
  HK: HK,
  HM: HM,
  HN: HN,
  HR: HR,
  HT: HT,
  HU: HU,
  ID: ID,
  IE: IE,
  IL: IL,
  IM: IM,
  IN: IN,
  IO: IO,
  IQ: IQ,
  IR: IR,
  IS: IS,
  IT: IT,
  JE: JE,
  JM: JM,
  JO: JO,
  JP: JP,
  KE: KE,
  KG: KG,
  KH: KH,
  KI: KI,
  KM: KM,
  KN: KN,
  KP: KP,
  KR: KR,
  KW: KW,
  KY: KY,
  KZ: KZ,
  LA: LA,
  LB: LB,
  LC: LC,
  LI: LI,
  LK: LK,
  LR: LR,
  LS: LS,
  LT: LT,
  LU: LU,
  LV: LV,
  LY: LY,
  MA: MA,
  MC: MC,
  MD: MD,
  ME: ME,
  MF: MF,
  MG: MG,
  MH: MH,
  MK: MK,
  ML: ML,
  MM: MM,
  MN: MN,
  MO: MO,
  MP: MP,
  MQ: MQ,
  MR: MR,
  MS: MS,
  MT: MT,
  MU: MU,
  MV: MV,
  MW: MW,
  MX: MX,
  MY: MY,
  MZ: MZ,
  NA: NA,
  NC: NC,
  NE: NE,
  NF: NF,
  NG: NG,
  NI: NI,
  NL: NL,
  NO: NO,
  NP: NP,
  NR: NR,
  NU: NU,
  NZ: NZ,
  OM: OM,
  OS: OS,
  PA: PA,
  PE: PE,
  PF: PF,
  PG: PG,
  PH: PH,
  PK: PK,
  PL: PL,
  PM: PM,
  PN: PN,
  PR: PR,
  PS: PS,
  PT: PT,
  PW: PW,
  PY: PY,
  QA: QA,
  RE: RE,
  RO: RO,
  RS: RS,
  RU: RU,
  RW: RW,
  SA: SA,
  SB: SB,
  SC: SC,
  SD: SD,
  SE: SE,
  SG: SG,
  SH: SH,
  SI: SI,
  SJ: SJ,
  SK: SK,
  SL: SL,
  SM: SM,
  SN: SN,
  SO: SO,
  SR: SR,
  SS: SS,
  ST: ST,
  SV: SV,
  SX: SX,
  SY: SY,
  SZ: SZ,
  TA: TA,
  TC: TC,
  TD: TD,
  TF: TF,
  TG: TG,
  TH: TH,
  TJ: TJ,
  TK: TK,
  TL: TL,
  TM: TM,
  TN: TN,
  TO: TO,
  TR: TR,
  TT: TT,
  TV: TV,
  TW: TW,
  TZ: TZ,
  UA: UA,
  UG: UG,
  UM: UM,
  US: US,
  UY: UY,
  UZ: UZ,
  VA: VA,
  VC: VC,
  VE: VE,
  VG: VG,
  VI: VI,
  VN: VN,
  VU: VU,
  WF: WF,
  WS: WS,
  XK: XK,
  YE: YE,
  YT: YT,
  ZA: ZA,
  ZM: ZM,
  ZW: ZW,
  ZZ: ZZ
};
/**
 * Creates Unicode flag from a two-letter ISO country code.
 * https://stackoverflow.com/questions/24050671/how-to-put-japan-flag-character-in-a-string
 * @param  {string} country — A two-letter ISO country code (case-insensitive).
 * @return {string}
 */

function getCountryFlag(country) {
  return getRegionalIndicatorSymbol(country[0]) + getRegionalIndicatorSymbol(country[1]);
}
/**
 * Converts a letter to a Regional Indicator Symbol.
 * @param  {string} letter
 * @return {string}
 */


function getRegionalIndicatorSymbol(letter) {
  return String.fromCodePoint(0x1F1E6 - 65 + letter.toUpperCase().charCodeAt(0));
}

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

function _objectWithoutProperties$7(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$a(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$a(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function CountrySelect(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      rest = _objectWithoutProperties$7(_ref, ["value", "onChange", "options"]);

  var onChange_ = useCallback(function (event) {
    var value = event.target.value;
    onChange(value === 'ZZ' ? undefined : value);
  }, [onChange]);
  var selectedOption = useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]); // "ZZ" means "International".
  // (HTML requires each `<option/>` have some string `value`).

  return React.createElement("select", _extends$b({}, rest, {
    value: value || 'ZZ',
    onChange: onChange_
  }), options.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label,
        divider = _ref2.divider;
    return React.createElement("option", {
      key: divider ? '|' : value || 'ZZ',
      value: divider ? '|' : value || 'ZZ',
      disabled: divider ? true : false,
      style: divider ? DIVIDER_STYLE : undefined
    }, label);
  }));
}

CountrySelect.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: PropTypes__default.string,

  /**
   * Updates the `value`.
   */
  onChange: PropTypes__default.func.isRequired,
  // `<select/>` options.
  options: PropTypes__default.arrayOf(PropTypes__default.shape({
    value: PropTypes__default.string,
    label: PropTypes__default.string,
    divider: PropTypes__default.bool
  })).isRequired
};
var DIVIDER_STYLE = {
  fontSize: '1px',
  backgroundColor: 'currentColor',
  color: 'inherit'
};

function CountrySelectWithIcon(_ref3) {
  var value = _ref3.value,
      options = _ref3.options,
      className = _ref3.className,
      Icon = _ref3.iconComponent,
      getIconAspectRatio = _ref3.getIconAspectRatio,
      Arrow = _ref3.arrowComponent,
      unicodeFlags = _ref3.unicodeFlags,
      rest = _objectWithoutProperties$7(_ref3, ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"]);

  var selectedOption = useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]);
  return React.createElement("div", {
    className: "PhoneInputCountry"
  }, React.createElement(CountrySelect, _extends$b({}, rest, {
    value: value,
    options: options,
    className: classnames('PhoneInputCountrySelect', className)
  })), unicodeFlags && value && React.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, getCountryFlag(value)), !(unicodeFlags && value) && React.createElement(Icon, {
    country: value,
    label: selectedOption && selectedOption.label,
    aspectRatio: unicodeFlags ? 1 : undefined
  }), React.createElement(Arrow, null));
}

CountrySelectWithIcon.propTypes = {
  // Country flag component.
  iconComponent: PropTypes__default.elementType,
  // Select arrow component.
  arrowComponent: PropTypes__default.elementType.isRequired,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: PropTypes__default.bool
};
CountrySelectWithIcon.defaultProps = {
  // Is "International" icon square?
  arrowComponent: function arrowComponent() {
    return React.createElement("div", {
      className: "PhoneInputCountrySelectArrow"
    });
  }
};

function getSelectedOption(options, value) {
  for (var _iterator = options, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref4 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref4 = _i.value;
    }

    var option = _ref4;

    if (!option.divider && option.value === value) {
      return option;
    }
  }
}

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

function createPhoneInput(defaultMetadata) {
  var PhoneInputDefault = React.forwardRef(function (props, ref) {
    return React.createElement(PhoneNumberInput, _extends$c({
      ref: ref
    }, props));
  });
  PhoneInputDefault.propTypes = {
    metadata: metadata.isRequired,
    labels: labels.isRequired,
    countrySelectComponent: PropTypes__default.elementType.isRequired
  };
  PhoneInputDefault.defaultProps = {
    metadata: defaultMetadata,
    labels: labels$1,
    countrySelectComponent: CountrySelectWithIcon
  };
  return PhoneInputDefault;
}

createPhoneInput();

function call(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata$1);
  return func.apply(this, args);
}

createPhoneInput(metadata$1);

function parsePhoneNumber$1() {
  return call(parsePhoneNumberFromString, arguments);
}

function isPossiblePhoneNumber$1() {
  return call(isPossiblePhoneNumber, arguments);
}

var PASSWORD_LENGTH_MINIMUM = 8;
var PASSWORD_LENGTH_MAXIMUM = 50;
var EMAIL_REGEX = /^([\w+-]+\.)*[\w+-]+@([\w+-]+\.)*[\w+-]+\.[a-zA-Z]{2,4}$/;

var scrubPhoneNumber = function scrubPhoneNumber(phoneNumber) {
  if (!phoneNumber || phoneNumber.trim() === '' || phoneNumber === '(   )    -    ') {
    return null;
  }

  return phoneNumber.trim();
};

var validUsernameLength = function validUsernameLength(username) {
  return username.length >= 5 && username.length <= 64;
};

var validUsernameCharacters = function validUsernameCharacters(username) {
  var regex = /([A-Za-z0-9.\-_]+)?/g;
  var matchedValue = regex.exec(username);
  return !!(matchedValue && matchedValue[0] === matchedValue['input']);
};

var validPasswordLength = function validPasswordLength(password) {
  return password.length >= PASSWORD_LENGTH_MINIMUM && password.length <= PASSWORD_LENGTH_MAXIMUM;
};

var validPasswordNumberOrSpecialCharacter = function validPasswordNumberOrSpecialCharacter(password) {
  return hasOneNumber(password) || hasOneSpecial(password);
};

var validPasswordLetter = function validPasswordLetter(password) {
  return hasOneLetter(password);
};

var validPasswordCharacters = function validPasswordCharacters(password) {
  return !hasInvalidCharacters(password);
};

var validateNotEmpty = function validateNotEmpty(fieldName, errorMessage) {
  if (!fieldName || fieldName.trim() === '') {
    return errorMessage;
  }
};

var validatePhoneNumber = function validatePhoneNumber(fieldName) {
  var _parsePhoneNumber;

  var countryCode = 'US';

  if (!fieldName || fieldName.trim() === '+') {
    return 'Phone Number is required';
  } else if (!fieldName || fieldName.trim() === '' || fieldName.replace(/\D/g, '').length < 6) {
    return 'Phone Number not long enough';
  } // Parse the phone number with the provided `countryCode`. 
  // If the `countryCode` is not provided or is set to "US", the library will automatically
  // fetch the country code based on the phone number's format and country of origin.


  var parsedPhoneNumber = (_parsePhoneNumber = parsePhoneNumber$1(fieldName, countryCode)) === null || _parsePhoneNumber === void 0 ? void 0 : _parsePhoneNumber.number; // Check if the parsed phone number is possible

  if (!isPossiblePhoneNumber$1(parsedPhoneNumber)) {
    return 'Invalid phone number';
  }
};

var validateDateOfBirth = function validateDateOfBirth(dateOfBirth) {
  if (!dateOfBirth) {
    return 'Date of Birth is required';
  } else if (!moment(dateOfBirth).isValid()) {
    return 'Invalid date';
  } else if (moment.duration(moment().diff(dateOfBirth)).asYears() < 18) {
    return 'You must be 18 years or older to participate in auctions on Proxibid';
  }
};

var hasOneLetter = function hasOneLetter(password) {
  return /[a-zA-Z]/.test(password);
};

var hasInvalidCharacters = function hasInvalidCharacters(password) {
  return /[^0-9a-zA-Z!@#$%*()_-]/.test(password);
};

var hasOneNumber = function hasOneNumber(password) {
  return /[0-9]/.test(password);
};

var hasOneSpecial = function hasOneSpecial(password) {
  return /[!@#$%*()-]/.test(password);
};

NewPassword.propTypes = {
  newPassword: string.isRequired,
  handlePasswordChange: func.isRequired,
  handlePasswordValidation: func
};

function NewPassword(props) {
  var _useState = useState('password'),
      _useState2 = _slicedToArray(_useState, 2),
      textFieldType = _useState2[0],
      setTextFieldType = _useState2[1];

  var _useState3 = useState({
    invalidCharacters: false,
    noNumberOrSpecialChar: false,
    noLetter: false,
    invalidLength: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      invalidPassword = _useState4[0],
      setInvalidPassword = _useState4[1];

  var toggleVisibility = function toggleVisibility() {
    if (textFieldType === 'text') {
      setTextFieldType('password');
    } else {
      setTextFieldType('text');
    }
  };

  var handleAndValidate = function handleAndValidate(event) {
    validate(event.target.value);
  };

  var validate = function validate(newPassword) {
    var invalidLength = !validPasswordLength(newPassword);
    var noNumberOrSpecialChar = !validPasswordNumberOrSpecialCharacter(newPassword);
    var noLetter = !validPasswordLetter(newPassword);
    var invalidCharacters = !validPasswordCharacters(newPassword);
    setInvalidPassword({
      invalidLength: invalidLength,
      noNumberOrSpecialChar: noNumberOrSpecialChar,
      noLetter: noLetter,
      invalidCharacters: invalidCharacters
    });
  };

  var isInvalid = Object.values(invalidPassword).indexOf(true) > -1;

  if (props.handlePasswordValidation) {
    props.handlePasswordValidation(!isInvalid);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    id: 'chrome-workaround-to-password-autofill',
    type: 'text',
    tabIndex: -1,
    style: {
      height: 0,
      width: 0,
      position: 'absolute',
      top: -10000
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    error: isInvalid,
    variant: "outlined",
    margin: "normal",
    required: true,
    id: "newPassword",
    name: "newPassword",
    label: "New Password",
    onChange: function onChange(e) {
      props.handlePasswordChange(e), handleAndValidate(e);
    },
    value: props.newPassword || '',
    InputProps: {
      autoComplete: 'new-password',
      type: textFieldType,
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
        position: 'end'
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: toggleVisibility
      }, textFieldType === 'text' ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
    },
    inputProps: {
      maxLength: 50
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    style: {
      display: isInvalid ? 'block' : 'none',
      padding: '0.5rem'
    }
  }, /*#__PURE__*/React.createElement(Typography, null, "Password Requirements:"), /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: invalidPassword.invalidLength ? 'bold' : 'normal'
    }
  }, "- Must have at least ", PASSWORD_LENGTH_MINIMUM, " characters"), /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: invalidPassword.noLetter ? 'bold' : 'normal'
    }
  }, "- Must contain at least one letter"), /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: invalidPassword.noNumberOrSpecialChar ? 'bold' : 'normal'
    }
  }, "- Must contain at least one number or special character"), /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: invalidPassword.invalidCharacters ? 'bold' : 'normal'
    }
  }, "- Valid characters  a-z A-Z 0-9 ! @ # $ % * ( ) _ -")));
}

function CreateNewPassword(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState({
    newPassword: ''
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      inputs = _useState6[0],
      setInputs = _useState6[1];

  useEffect(function () {
    window.addEventListener('beforeunload', unloadListener);
    return function () {
      window.removeEventListener('beforeunload', unloadListener);
    };
  });

  var unloadListener = function unloadListener(event) {
    if (!inputs.newPassword) {
      event.preventDefault();
      event.returnValue = '';
    }
  };

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      passwordValid = _useState8[0],
      setPasswordValid = _useState8[1];

  var handleSubmit = function handleSubmit(event) {
    if (event) {
      setLoading(true);
      setErrorMessage(null);
      event.preventDefault();
      return axiosInstance.post(props.resetPasswordUrl, {
        params: props.params,
        newPassword: inputs.newPassword
      }, {
        headers: {
          'device-id': props.deviceId
        }
      }).then(function (response) {
        return props.onSuccess(response);
      })["catch"](handleApiError)["finally"](function () {
        return setLoading(false);
      });
    }
  };

  var handleApiError = function handleApiError(error) {
    var message = error.response.data;

    if (message.status == '400' && message.additionalProperties.newPassword.length > 0) {
      setErrorMessage('Password must be 8-50 characters with at least one letter and at least one number or special character.');
    } else {
      setErrorMessage('A problem occurred while resetting your password. Please try again.');
    }
  };

  var handleInputChange = function handleInputChange(event) {
    event.persist();
    setInputs(function (inputs) {
      return _objectSpread2(_objectSpread2({}, inputs), {}, _defineProperty({}, event.target.name, event.target.value));
    });
  };

  var handlePasswordValidation = function handlePasswordValidation(valid) {
    return setPasswordValid(valid);
  };

  return /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      maxWidth: 500,
      minHeight: 300,
      paddingTop: 20
    }
  }, /*#__PURE__*/React.createElement("form", {
    className: 'loginForm',
    noValidate: true,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'h5',
    gutterBottom: true
  }, "Create a New Password"), errorMessage && /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, errorMessage), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(NewPassword, {
    newPassword: inputs.newPassword,
    handlePasswordChange: handleInputChange,
    handlePasswordValidation: handlePasswordValidation
  }), /*#__PURE__*/React.createElement(Button, {
    type: 'submit',
    loading: loading,
    color: 'primary',
    disabled: !inputs.newPassword || !passwordValid,
    variant: 'contained',
    id: 'reset-password-submit'
  }, "Reset Password")))));
}

CreateNewPassword.propTypes = {
  resetPasswordUrl: string.isRequired,
  onSuccess: func.isRequired,
  params: string.isRequired,
  deviceId: string
};

function ResetPassword(props) {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      fingerprint = _useState2[0],
      setFingerprint = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      infoMessage = _useState6[0],
      setInfoMessage = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      showRequestOneTimePassword = _useState10[0],
      setShowRequestOneTimePassword = _useState10[1];

  var _useState11 = useState(true),
      _useState12 = _slicedToArray(_useState11, 1),
      showRequestPasswordForm = _useState12[0];

  fingerprint2.get({
    excludes: {
      webgl: true
    }
  }, function (components) {
    var values = components.map(function (component) {
      return component.value;
    }).join('');
    setFingerprint(fingerprint2.x64hash128(values, 31));
  });

  var validateToken = function validateToken() {
    if (!props.params) {
      // in the case there is no token it is a new
      // request cycle and we can stop here
      setShowRequestOneTimePassword(true);
      setLoading(false);
      return;
    } // if params exists check token status


    axiosInstance.post(props.validateTokenUrl, {
      token: props.params
    }, {
      headers: {
        'device-id': fingerprint
      }
    }) // non-error response indicates a valid token
    .then(function (response) {
      setShowRequestOneTimePassword(false);
    }) // If invalid token it will catch as an error
    ["catch"](function (error) {
      //alerts are used so there are not multiple info messages stacked.
      if (error.response.status === 400 && error.response.data.additionalProperties.token) {
        setInfoMessage("".concat(error.response.data.additionalProperties.token));
      } else {
        setErrorMessage('An error occurred. Please try again later or contact support if this problem continues.');
      }
    })["finally"](function () {
      return setLoading(false);
    });
    return;
  };

  useEffect(function () {
    validateToken();
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: 'h4',
    gutterBottom: true
  }, "Reset Password"), loading && /*#__PURE__*/React.createElement(LinearProgress, null), !showRequestOneTimePassword && !loading && /*#__PURE__*/React.createElement(CreateNewPassword, {
    resetPasswordUrl: props.resetPasswordUrl,
    onSuccess: props.onSuccess,
    params: props.params,
    deviceId: fingerprint
  }), showRequestOneTimePassword && !loading && /*#__PURE__*/React.createElement(RequestOneTimePassword, {
    requestResetUrl: props.requestResetUrl,
    deviceId: fingerprint,
    captchaEnabled: props.captchaEnabled,
    captchaApiKey: props.captchaApiKey,
    infoMessage: infoMessage,
    errorMessage: errorMessage,
    showRequestPasswordForm: showRequestPasswordForm
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, null, "If you are having trouble resetting your password, please ", /*#__PURE__*/React.createElement(Link, {
    href: "/asp/ContactUs.asp",
    target: "_blank"
  }, "contact Proxibid"), "."));
}

ResetPassword.propTypes = {
  requestResetUrl: string.isRequired,
  resetPasswordUrl: string.isRequired,
  validateTokenUrl: string.isRequired,
  captchaEnabled: bool,
  captchaApiKey: string,
  onSuccess: func.isRequired,
  params: string
};

function SuccessMessage(props) {
  var children = props.children,
      secondary = props.secondary;
  return /*#__PURE__*/React.createElement(BigMessage, {
    secondary: secondary,
    Icon: CheckCircleIcon,
    type: 'success'
  }, children);
}

SuccessMessage.propTypes = {
  children: PropTypes__default.node.isRequired,
  secondary: PropTypes__default.element
};

function NewUsernameInput(_ref) {
  var required = _ref.required,
      handleInputChange = _ref.handleInputChange,
      value = _ref.value,
      usernameCheckUrl = _ref.usernameCheckUrl,
      handleUsernameValidation = _ref.handleUsernameValidation,
      checkUsernameToggle = _ref.checkUsernameToggle;

  var _useState = useState({
    invalidLength: false,
    invalidCharacters: false,
    usernameTaken: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      invalidUsername = _useState2[0],
      setInvalidUsername = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      usernameTaken = _useState4[0],
      setUsernameTaken = _useState4[1];

  useEffect(function () {
    if (value.length > 0) {
      validate(value);
    }
  }, []);

  var handleAndValidate = function handleAndValidate(event) {
    setUsernameTaken(null);
    validate(event.target.value);
  };

  var checkUsername = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(newUsername) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleUsernameValidation(false);
              _context.prev = 1;
              _context.next = 4;
              return axiosInstance.post(usernameCheckUrl, {
                username: newUsername
              });

            case 4:
              return _context.abrupt("return", _context.sent.data);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function checkUsername(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var validate = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(newValue) {
      var invalidLength, invalidCharacters, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              invalidLength = !validUsernameLength(newValue);
              invalidCharacters = !validUsernameCharacters(newValue);
              setInvalidUsername({
                invalidLength: invalidLength,
                invalidCharacters: invalidCharacters
              });

              if (!checkUsernameToggle) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return checkUsername(newValue);

            case 6:
              response = _context2.sent;

              if (response) {
                setUsernameTaken(!response.unique);
              } else {
                setUsernameTaken(null);
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function validate(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var isInvalid = Object.values(invalidUsername).indexOf(true) > -1 || usernameTaken;
  handleUsernameValidation(!isInvalid);
  var helperField;

  if (usernameTaken === null && checkUsernameToggle) {
    helperField = /*#__PURE__*/React.createElement(Typography$1, null, "Checking username... ", /*#__PURE__*/React.createElement(CircularProgress, {
      size: '1.5rem'
    }));
  } else {
    helperField = /*#__PURE__*/React.createElement(Paper$1, {
      style: {
        display: isInvalid ? 'block' : 'none',
        padding: '0.5rem'
      }
    }, /*#__PURE__*/React.createElement(Typography$1, null, "Username Requirements:"), /*#__PURE__*/React.createElement(Typography$1, {
      style: {
        fontWeight: usernameTaken && checkUsernameToggle ? 'bold' : 'normal'
      }
    }, "- Must be unique"), /*#__PURE__*/React.createElement(Typography$1, {
      style: {
        fontWeight: invalidUsername.invalidLength ? 'bold' : 'normal'
      }
    }, "- Must have at least 5 characters"), /*#__PURE__*/React.createElement(Typography$1, {
      style: {
        fontWeight: invalidUsername.invalidCharacters ? 'bold' : 'normal'
      }
    }, "- May use alphanumeric characters, period, hyphen, underscore"));
  }

  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(TextField, {
    error: isInvalid,
    variant: "outlined",
    margin: "normal",
    required: required,
    name: "newUsername",
    label: "New Username",
    id: "new-username",
    autoComplete: "username",
    onBlur: handleAndValidate,
    inputProps: {
      maxLength: 64
    },
    onChange: handleInputChange,
    value: value
  }), helperField);
}

NewUsernameInput.propTypes = {
  required: bool,
  handleInputChange: func.isRequired,
  value: string.isRequired,
  handleUsernameValidation: func.isRequired,
  usernameCheckUrl: string.isRequired,
  checkUsernameToggle: bool
};
NewUsernameInput.defaultProps = {
  required: false,
  checkUsernameToggle: false
};

function BasicInfo(props) {
  var _useState = useState({
    email: '',
    newUsername: '',
    newPassword: '',
    policies: {
      'unifiedUserAgreementAccepted': false,
      'privacyPolicyAccepted': false,
      'notificationDesired': false
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      inputs = _useState2[0],
      setInputs = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      errorMessage = _useState6[0],
      setErrorMessage = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      emailTaken = _useState8[0],
      setEmailTaken = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      badEmail = _useState10[0],
      setBadEmail = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      hasBlurredEmail = _useState12[0],
      setHasBlurredEmail = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      usernameValid = _useState14[0],
      setUsernameValid = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      passwordValid = _useState16[0],
      setPasswordValid = _useState16[1];

  var recaptchaRef = React.createRef();

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      submitEvent = _useState18[0],
      setSubmitEvent = _useState18[1];

  var onCaptchaChange = function onCaptchaChange(value) {
    registerUser(submitEvent, value);
  };

  function registerUser(event, token) {
    var ref = '';

    if (props.captchaEnabled) {
      ref = recaptchaRef.current;
    }

    if (event) {
      setLoading(true);
      setEmailTaken(false);
      return axiosInstance.post(props.basicInfoSubmitUrl, {
        acceptUnifiedUserAgreement: inputs.policies.unifiedUserAgreementAccepted,
        acceptPrivacyPolicy: inputs.policies.privacyPolicyAccepted,
        username: inputs.newUsername,
        password: inputs.newPassword,
        email: inputs.email,
        receiveNotifications: inputs.policies.notificationDesired,
        secondaryAuthentication: token
      }).then(function (response) {
        var _response$data;

        EventService.dispatchEvent(EVENT_LOGIN_UPDATE_DISPLAY_NAME, response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.username);
        props.onSuccess(response);
      })["catch"](function (error) {
        var _error$response$data;

        if (props.captchaEnabled) {
          ref.reset();
        }

        var message = (_error$response$data = error.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message;
        var knownError = message && message.length > 0;
        var messageData = error.response.data;
        var fullError = /*#__PURE__*/React.createElement("span", null, "The email address you entered is already in use.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
          style: {
            color: 'white',
            textDecoration: 'underline'
          },
          href: '/asp/LoginBidder.asp'
        }, "Log in to your account."));

        if (knownError) {
          switch (message) {
            case 'USERNAME_EXISTS':
              setErrorMessage('This username already exists');
              break;

            case 'EMAIL_EXISTS':
              setErrorMessage(fullError);
              setEmailTaken(true);
              break;

            case 'TERMS_AND_CONDITIONS_REQUIRED':
              setErrorMessage('Acceptance of Terms and Conditions is required');
              break;

            case 'CURRENT_PASSWORD_INVALID':
              setErrorMessage('This is not a valid password');
              break;

            default:
              setErrorMessage('An error has occurred');
              break;
          }
        } else if (messageData.status == '400' && messageData.additionalProperties.password.length > 0) {
          setErrorMessage('This is not a valid password');
        } else {
          setErrorMessage('An error has occurred');
        }
      })["finally"](function () {
        return setLoading(false);
      });
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    if (props.captchaEnabled) {
      setSubmitEvent(event);
      recaptchaRef.current.execute();
    } else {
      registerUser(event, '');
    }
  }

  function handleInputChange(event) {
    event.persist();
    setInputs(function (inputs) {
      return _objectSpread2(_objectSpread2({}, inputs), {}, _defineProperty({}, event.target.name, event.target.value));
    });
  }

  function handleEmailInputChange(event) {
    event.persist();
    var validEmail = EMAIL_REGEX.test(event.target.value);
    setBadEmail(!validEmail);
    setEmailTaken(false);
    setErrorMessage(null);
    setInputs(function (inputs) {
      return _objectSpread2(_objectSpread2({}, inputs), {}, _defineProperty({}, event.target.name, event.target.value));
    });
  }

  var handleChecked = function handleChecked(name) {
    return function (event) {
      event.persist();
      setInputs(_objectSpread2(_objectSpread2({}, inputs), {}, {
        policies: _objectSpread2(_objectSpread2({}, inputs.policies), {}, _defineProperty({}, name, event.target.checked))
      }));
    };
  };

  var populateUsername = function populateUsername() {
    setHasBlurredEmail(true);
    var atIndex = inputs.email.indexOf('@');
    var guessedUsername = atIndex > 0 ? inputs.email.slice(0, atIndex) : inputs.email;

    if (inputs.newUsername.length === 0) {
      setInputs(_objectSpread2(_objectSpread2({}, inputs), {}, {
        newUsername: guessedUsername
      }));
    }
  };

  var populateHelperText = function populateHelperText() {
    return hasBlurredEmail && badEmail && 'Email address is not a valid format';
  };

  var handleUsernameValidation = function handleUsernameValidation(valid) {
    return setUsernameValid(valid);
  };

  var handlePasswordValidation = function handlePasswordValidation(valid) {
    return setPasswordValid(valid);
  };

  return /*#__PURE__*/React.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit
  }, errorMessage && /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, errorMessage), /*#__PURE__*/React.createElement("fieldset", {
    disabled: loading,
    style: {
      border: 'none'
    }
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    margin: "normal",
    required: true,
    id: "email",
    label: "Email",
    name: "email",
    autoComplete: "email",
    autoFocus: true,
    onChange: handleEmailInputChange,
    value: inputs.email,
    onBlur: populateUsername,
    error: hasBlurredEmail && (emailTaken || badEmail),
    helperText: populateHelperText()
  }), /*#__PURE__*/React.createElement(NewUsernameInput, {
    required: true,
    value: inputs.newUsername,
    handleInputChange: handleInputChange,
    usernameCheckUrl: props.usernameCheckUrl,
    checkUsernameToggle: props.checkUsernameToggle,
    handleUsernameValidation: handleUsernameValidation
  }), /*#__PURE__*/React.createElement(NewPassword, {
    newPassword: inputs.newPassword,
    handlePasswordChange: handleInputChange,
    handlePasswordValidation: handlePasswordValidation
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      required: true,
      id: 'accept-uua',
      value: "acceptUnifiedUserAgreement",
      color: "primary",
      inputProps: {
        'aria-label': 'Accept Unified User Agreement'
      },
      checked: inputs.policies.unifiedUserAgreementAccepted,
      disabled: loading,
      onChange: handleChecked('unifiedUserAgreementAccepted')
    }),
    label: /*#__PURE__*/React.createElement(Typography, null, "I have read and agree to the ", /*#__PURE__*/React.createElement(Link, {
      href: props.unifiedUserAgreementUrl,
      target: "_blank"
    }, "Proxibid Unified User Agreement."))
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      required: true,
      id: 'accept-privacy-policy',
      value: "acceptPrivacyPolicy",
      color: "primary",
      inputProps: {
        'aria-label': 'Accept Privacy Policy'
      },
      checked: inputs.policies.privacyPolicyAccepted,
      disabled: loading,
      onChange: handleChecked('privacyPolicyAccepted')
    }),
    label: /*#__PURE__*/React.createElement(Typography, null, "I have read and agree to the ", /*#__PURE__*/React.createElement(Link, {
      href: props.privacyPolicyUrl,
      target: "_blank"
    }, "Proxibid Privacy Policy."))
  }), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: '0.5rem',
      marginBottom: '0.5rem'
    }
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      id: 'receive-notifications',
      value: "notificationDesired",
      color: "primary",
      inputProps: {
        'aria-label': 'Accept Newsletter and Sale Alert Notifications'
      },
      checked: inputs.policies.notificationDesired,
      disabled: loading,
      onChange: handleChecked('notificationDesired')
    }),
    label: /*#__PURE__*/React.createElement(Typography, null, "Yes, I want to receive ", 'Proxibid\'s', " weekly newsletter and sale alerts based on my recent purchases. ", /*#__PURE__*/React.createElement("em", null, "(optional)"))
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      marginTop: '1rem'
    },
    id: 'createFullAccount',
    color: 'primary',
    variant: 'contained',
    type: 'submit',
    loading: loading,
    disabled: !usernameValid || !passwordValid || hasBlurredEmail && badEmail || !inputs.policies.privacyPolicyAccepted || !inputs.policies.unifiedUserAgreementAccepted
  }, "Create Account"), props.captchaEnabled && /*#__PURE__*/React.createElement(RecaptchaWrapper, {
    ref: recaptchaRef,
    size: "invisible",
    sitekey: props.captchaApiKey,
    onChange: onCaptchaChange
  }))));
}

BasicInfo.propTypes = {
  basicInfoSubmitUrl: string.isRequired,
  usernameCheckUrl: string.isRequired,
  onSuccess: func.isRequired,
  unifiedUserAgreementUrl: string.isRequired,
  privacyPolicyUrl: string.isRequired,
  captchaEnabled: bool,
  checkUsernameToggle: bool,
  captchaApiKey: string
};
BasicInfo.defaultProps = {
  captchaEnabled: false,
  checkUsernameToggle: false,
  captchaApiKey: ''
};
var lodash_isempty = createCommonjsModule(function (module, exports) {
  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      setTag = '[object Set]',
      weakMapTag = '[object WeakMap]';
  var dataViewTag = '[object DataView]';
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */

  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */

  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */


  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;

    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }

    return result;
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /** Used for built-in method references. */


  var funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to detect overreaching core-js shims. */

  var coreJsData = root['__core-js_shared__'];
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /** Used to resolve the decompiled source of functions. */


  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var objectToString = objectProto.toString;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /** Built-in value references. */

  var Buffer = moduleExports ? root.Buffer : undefined,
      propertyIsEnumerable = objectProto.propertyIsEnumerable;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeKeys = overArg(Object.keys, Object);
  /* Built-in method references that are verified to be native. */

  var DataView = getNative(root, 'DataView'),
      Map = getNative(root, 'Map'),
      Promise = getNative(root, 'Promise'),
      Set = getNative(root, 'Set'),
      WeakMap = getNative(root, 'WeakMap');
  /** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */

  var nonEnumShadows = !propertyIsEnumerable.call({
    'valueOf': 1
  }, 'valueOf');
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);
  /**
   * The base implementation of `getTag`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  function baseGetTag(value) {
    return objectToString.call(value);
  }
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */


  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */


  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11,
  // for data views in Edge < 14, and promises in Node.js.

  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = objectToString.call(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : undefined;

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;

          case mapCtorString:
            return mapTag;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag;

          case weakMapCtorString:
            return weakMapTag;
        }
      }

      return result;
    };
  }
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */


  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
  }
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */


  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */


  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */


  var isBuffer = nativeIsBuffer || stubFalse;
  /**
   * Checks if `value` is an empty object, collection, map, or set.
   *
   * Objects are considered empty if they have no own enumerable string keyed
   * properties.
   *
   * Array-like values such as `arguments` objects, arrays, buffers, strings, or
   * jQuery-like collections are considered empty if they have a `length` of `0`.
   * Similarly, maps and sets are considered empty if they have a `size` of `0`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty(null);
   * // => true
   *
   * _.isEmpty(true);
   * // => true
   *
   * _.isEmpty(1);
   * // => true
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({ 'a': 1 });
   * // => false
   */

  function isEmpty(value) {
    if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
      return !value.length;
    }

    var tag = getTag(value);

    if (tag == mapTag || tag == setTag) {
      return !value.size;
    }

    if (nonEnumShadows || isPrototype(value)) {
      return !nativeKeys(value).length;
    }

    for (var key in value) {
      if (hasOwnProperty.call(value, key)) {
        return false;
      }
    }

    return true;
  }
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */


  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }
  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */


  function stubFalse() {
    return false;
  }

  module.exports = isEmpty;
});
var postcodeRegexes = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.POSTCODE_REGEXES = {
    UK: /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i,
    JE: /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
    GG: /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
    IM: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
    US: /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/,
    CA: /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/i,
    IE: /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/,
    DE: /^\d{5}$/,
    JP: /^\d{3}-\d{4}$/,
    FR: /^\d{2}[ ]?\d{3}$/,
    AU: /^\d{4}$/,
    IT: /^\d{5}$/,
    CH: /^\d{4}$/,
    AT: /^(?!0)\d{4}$/,
    ES: /^\d{5}$/,
    NL: /^\d{4}[ ]?[A-Z]{2}$/,
    BE: /^\d{4}$/,
    DK: /^\d{4}$/,
    SE: /^\d{3}[ ]?\d{2}$/,
    NO: /^\d{4}$/,
    BR: /^\d{5}[\-]?\d{3}$/,
    PT: /^\d{4}([\-]\d{3})?$/,
    FI: /^\d{5}$/,
    AX: /^22\d{3}$/,
    KR: /^\d{3}[\-]\d{3}$/,
    CN: /^\d{6}$/,
    TW: /^\d{3}(\d{2})?$/,
    SG: /^\d{6}$/,
    DZ: /^\d{5}$/,
    AD: /^AD\d{3}$/,
    AR: /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/,
    AM: /^(37)?\d{4}$/,
    AZ: /^\d{4}$/,
    BH: /^((1[0-2]|[2-9])\d{2})?$/,
    BD: /^\d{4}$/,
    BB: /^(BB\d{5})?$/,
    BY: /^\d{6}$/,
    BM: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/,
    BA: /^\d{5}$/,
    IO: /^BBND 1ZZ$/,
    BN: /^[A-Z]{2}[ ]?\d{4}$/,
    BG: /^\d{4}$/,
    KH: /^\d{5}$/,
    CV: /^\d{4}$/,
    CL: /^\d{7}$/,
    CR: /^\d{4,5}|\d{3}-\d{4}$/,
    HR: /^\d{5}$/,
    CY: /^\d{4}$/,
    CZ: /^\d{3}[ ]?\d{2}$/,
    DO: /^\d{5}$/,
    EC: /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
    EG: /^\d{5}$/,
    EE: /^\d{5}$/,
    FO: /^\d{3}$/,
    GE: /^\d{4}$/,
    GR: /^\d{3}[ ]?\d{2}$/,
    GL: /^39\d{2}$/,
    GT: /^\d{5}$/,
    HT: /^\d{4}$/,
    HN: /^(?:\d{5})?$/,
    HU: /^\d{4}$/,
    IS: /^\d{3}$/,
    IN: /^\d{6}$/,
    ID: /^\d{5}$/,
    IL: /^\d{5}$/,
    JO: /^\d{5}$/,
    KZ: /^\d{6}$/,
    KE: /^\d{5}$/,
    KW: /^\d{5}$/,
    LA: /^\d{5}$/,
    LV: /^\d{4}$/,
    LB: /^(\d{4}([ ]?\d{4})?)?$/,
    LI: /^(948[5-9])|(949[0-7])$/,
    LT: /^\d{5}$/,
    LU: /^\d{4}$/,
    MK: /^\d{4}$/,
    MY: /^\d{5}$/,
    MV: /^\d{5}$/,
    MT: /^[A-Z]{3}[ ]?\d{2,4}$/,
    MU: /^(\d{3}[A-Z]{2}\d{3})?$/,
    MX: /^\d{5}$/,
    MD: /^\d{4}$/,
    MC: /^980\d{2}$/,
    MA: /^\d{5}$/,
    NP: /^\d{5}$/,
    NZ: /^\d{4}$/,
    NI: /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/,
    NG: /^(\d{6})?$/,
    OM: /^(PC )?\d{3}$/,
    PK: /^\d{5}$/,
    PY: /^\d{4}$/,
    PH: /^\d{4}$/,
    PL: /^\d{2}-\d{3}$/,
    PR: /^00[679]\d{2}([ \-]\d{4})?$/,
    RO: /^\d{6}$/,
    RU: /^\d{6}$/,
    SM: /^4789\d$/,
    SA: /^\d{5}$/,
    SN: /^\d{5}$/,
    SK: /^\d{3}[ ]?\d{2}$/,
    SI: /^\d{4}$/,
    ZA: /^\d{4}$/,
    LK: /^\d{5}$/,
    TJ: /^\d{6}$/,
    TH: /^\d{5}$/,
    TN: /^\d{4}$/,
    TR: /^\d{5}$/,
    TM: /^\d{6}$/,
    UA: /^\d{5}$/,
    UY: /^\d{5}$/,
    UZ: /^\d{6}$/,
    VA: /^00120$/,
    VE: /^\d{4}$/,
    ZM: /^\d{5}$/,
    AS: /^96799$/,
    CC: /^6799$/,
    CK: /^\d{4}$/,
    RS: /^\d{6}$/,
    ME: /^8\d{4}$/,
    CS: /^\d{5}$/,
    YU: /^\d{5}$/,
    CX: /^6798$/,
    ET: /^\d{4}$/,
    FK: /^FIQQ 1ZZ$/,
    NF: /^2899$/,
    FM: /^(9694[1-4])([ \-]\d{4})?$/,
    GF: /^9[78]3\d{2}$/,
    GN: /^\d{3}$/,
    GP: /^9[78][01]\d{2}$/,
    GS: /^SIQQ 1ZZ$/,
    GU: /^969[123]\d([ \-]\d{4})?$/,
    GW: /^\d{4}$/,
    HM: /^\d{4}$/,
    IQ: /^\d{5}$/,
    KG: /^\d{6}$/,
    LR: /^\d{4}$/,
    LS: /^\d{3}$/,
    MG: /^\d{3}$/,
    MH: /^969[67]\d([ \-]\d{4})?$/,
    MN: /^\d{6}$/,
    MP: /^9695[012]([ \-]\d{4})?$/,
    MQ: /^9[78]2\d{2}$/,
    NC: /^988\d{2}$/,
    NE: /^\d{4}$/,
    VI: /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/,
    PF: /^987\d{2}$/,
    PG: /^\d{3}$/,
    PM: /^9[78]5\d{2}$/,
    PN: /^PCRN 1ZZ$/,
    PW: /^96940$/,
    RE: /^9[78]4\d{2}$/,
    SH: /^(ASCN|STHL) 1ZZ$/,
    SJ: /^\d{4}$/,
    SO: /^\d{5}$/,
    SZ: /^[HLMS]\d{3}$/,
    TC: /^TKCA 1ZZ$/,
    WF: /^986\d{2}$/,
    XK: /^\d{5}$/,
    YT: /^976\d{2}$/,
    INTL: /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/i
  };
});
unwrapExports(postcodeRegexes);
var postcodeRegexes_1 = postcodeRegexes.POSTCODE_REGEXES;
var main$2 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  exports.postcodeValidator = function (postcode, country) {
    var countryUppercase = country.toUpperCase();

    if (!postcodeRegexes.POSTCODE_REGEXES.hasOwnProperty(countryUppercase)) {
      // throw Error if country code is unrecognised
      throw new Error("Invalid country code: ".concat(country));
    }

    return postcodeRegexes.POSTCODE_REGEXES[countryUppercase].test(postcode);
  };
});
unwrapExports(main$2);
var main_1$1 = main$2.postcodeValidator;

function validateAddress(addressInfo) {
  var errors = {};

  if (!(addressInfo !== null && addressInfo !== void 0 && addressInfo.addressLine1) || (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.addressLine1.trim()) === '') {
    errors.addressLine1 = 'Address Line 1 is required';
  }

  if (!(addressInfo !== null && addressInfo !== void 0 && addressInfo.addressLevel1Id) || (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.addressLevel1Id.trim()) === '') {
    errors.addressLevel1Id = 'State / Territory is required';
  }

  if (!(addressInfo !== null && addressInfo !== void 0 && addressInfo.addressLevel2) || (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.addressLevel2.trim()) === '') {
    errors.addressLevel2 = 'City is required';
  }

  if (!(addressInfo !== null && addressInfo !== void 0 && addressInfo.postalCode) || (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.postalCode.trim()) === '') {
    errors.postalCode = 'Zip Code / Postal Code is required';
  } else {
    if ((addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.countryId) === '1' && !main_1$1(addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.postalCode, 'US')) {
      errors.postalCode = 'Postal Code is invalid';
    }
  }

  if (!(addressInfo !== null && addressInfo !== void 0 && addressInfo.countryId)) {
    errors.countryId = 'Country is required';
  }

  return errors;
}

Address.propTypes = {
  initialAddress: shape({
    addressLine1: string,
    addressLine2: string,
    addressLevel1Id: string,
    addressLevel2: string,
    countryId: string,
    postalCode: string
  }),
  currentAddress: shape({
    addressLine1: string,
    addressLine2: string,
    addressLevel1Id: string,
    addressLevel2: string,
    countryId: string,
    postalCode: string
  }),
  attemptedSubmission: bool.isRequired,
  addressChanged: func.isRequired,
  countryRegionData: arrayOf(shape({
    id: number,
    name: string,
    countryCode: string,
    states: arrayOf(shape({
      id: number,
      name: string,
      abbreviation: string
    }))
  })).isRequired,
  idprefix: string,
  onError: func
};

function Address(props) {
  var _props$currentAddress3, _props$currentAddress4, _props$currentAddress5, _props$currentAddress6, _props$currentAddress7, _props$currentAddress8, _props$currentAddress9, _props$currentAddress10;

  var countryLabel = useRef(null);

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      countryLabelWidth = _React$useState2[0],
      setCountryLabelWidth = _React$useState2[1];

  var regionLabel = useRef(null);

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      regionLabelWidth = _React$useState4[0],
      setRegionLabelWidth = _React$useState4[1];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      regions = _useState2[0],
      setRegions = _useState2[1];

  useEffect(function () {
    setCountryLabelWidth(countryLabel.current.offsetWidth);
    setRegionLabelWidth(regionLabel.current.offsetWidth);
  }, []);
  useEffect(function () {
    var _props$currentAddress;

    if (!((_props$currentAddress = props.currentAddress) !== null && _props$currentAddress !== void 0 && _props$currentAddress.countryId)) {
      props.addressChanged('countryId', '1');
      populateRegions('1');
    }
  }, [props.currentAddress]);
  var isFirstRun = useRef(true);
  useEffect(function () {
    if (props.initialAddress && !lodash_isequal(props.initialAddress, props.currentAddress)) {
      isFirstRun.current = true;
      props.addressChanged('addressLine1', props.initialAddress.addressLine1);
      props.addressChanged('addressLine2', props.initialAddress.addressLine2);
      props.addressChanged('addressLevel1Id', props.initialAddress.addressLevel1Id);
      props.addressChanged('addressLevel2', props.initialAddress.addressLevel2);
      props.addressChanged('postalCode', props.initialAddress.postalCode);
      props.addressChanged('countryId', props.initialAddress.countryId);
    }
  }, [props.initialAddress]);
  useEffect(function () {
    var _props$currentAddress2;

    if (isFirstRun.current) {
      isFirstRun.current = false;
    } else {
      props.addressChanged('addressLevel1Id', '');
      props.addressChanged('postalCode', '');
    }

    populateRegions((_props$currentAddress2 = props.currentAddress) === null || _props$currentAddress2 === void 0 ? void 0 : _props$currentAddress2.countryId);
  }, [(_props$currentAddress3 = props.currentAddress) === null || _props$currentAddress3 === void 0 ? void 0 : _props$currentAddress3.countryId]);

  function populateRegions(countryId) {
    var country = props.countryRegionData.find(function (country) {
      return country.id + '' === countryId;
    });
    setRegions((country === null || country === void 0 ? void 0 : country.states) || []);
  }

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      addressErrors = _useState4[0],
      setAddressErrors = _useState4[1];

  useEffect(function () {
    setAddressErrors(validateAddress(props.currentAddress));
  }, [props.currentAddress]);
  useEffect(function () {
    if (props.onError) {
      props.onError(!lodash_isempty(addressErrors));
    }
  }, [addressErrors]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!addressErrors.addressLine1,
    helperText: props.attemptedSubmission && addressErrors.addressLine1,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: props.idprefix ? props.idprefix + '-address1Ship' : 'address1Ship',
    inputProps: {
      maxLength: 50
    },
    label: "Address Line 1",
    name: "address-line-1",
    autoComplete: "address-line1",
    fullWidth: true,
    value: ((_props$currentAddress4 = props.currentAddress) === null || _props$currentAddress4 === void 0 ? void 0 : _props$currentAddress4.addressLine1) || '',
    onChange: function onChange(event) {
      return props.addressChanged('addressLine1', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!addressErrors.addressLine2,
    helperText: props.attemptedSubmission && addressErrors.addressLine2,
    variant: "outlined",
    margin: "dense",
    id: props.idprefix ? props.idprefix + '-address2Ship' : 'address2Ship',
    inputProps: {
      maxLength: 50
    },
    label: "Address Line 2",
    name: "address-line-2",
    autoComplete: "address-line2",
    fullWidth: true,
    value: ((_props$currentAddress5 = props.currentAddress) === null || _props$currentAddress5 === void 0 ? void 0 : _props$currentAddress5.addressLine2) || '',
    onChange: function onChange(event) {
      return props.addressChanged('addressLine2', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!addressErrors.addressLevel2,
    helperText: props.attemptedSubmission && addressErrors.addressLevel2,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: props.idprefix ? props.idprefix + '-city' : 'city',
    inputProps: {
      maxLength: 50
    },
    label: "City",
    name: "city",
    autoComplete: "address-level2",
    fullWidth: true,
    value: ((_props$currentAddress6 = props.currentAddress) === null || _props$currentAddress6 === void 0 ? void 0 : _props$currentAddress6.addressLevel2) || '',
    onChange: function onChange(event) {
      return props.addressChanged('addressLevel2', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    error: props.attemptedSubmission && !!addressErrors.addressLevel1Id
  }, /*#__PURE__*/React.createElement(InputLabel$1, {
    htmlFor: props.idprefix ? props.idprefix + '-region' : 'region',
    ref: regionLabel
  }, "State / Territory"), /*#__PURE__*/React.createElement(Select$3, {
    value: ((_props$currentAddress7 = props.currentAddress) === null || _props$currentAddress7 === void 0 ? void 0 : _props$currentAddress7.addressLevel1Id) || '',
    onChange: function onChange(event) {
      return props.addressChanged('addressLevel1Id', event.target.value);
    },
    id: props.idprefix ? props.idprefix + '-region' : 'region',
    autoComplete: "address-level1",
    "native": true,
    disabled: !((_props$currentAddress8 = props.currentAddress) !== null && _props$currentAddress8 !== void 0 && _props$currentAddress8.countryId),
    labelWidth: regionLabelWidth
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), regions.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option['abbreviation'],
      value: option['id']
    }, option['name']);
  })), props.attemptedSubmission && !!addressErrors.addressLevel1Id && /*#__PURE__*/React.createElement(FormHelperText, null, addressErrors.addressLevel1Id))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!addressErrors.postalCode,
    helperText: props.attemptedSubmission && addressErrors.postalCode,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: props.idprefix ? props.idprefix + '-postalCode' : 'postalCode',
    inputProps: {
      maxLength: 50
    },
    label: "Zip Code / Postal Code",
    name: "postalCode",
    autoComplete: "postal-code",
    fullWidth: true,
    value: ((_props$currentAddress9 = props.currentAddress) === null || _props$currentAddress9 === void 0 ? void 0 : _props$currentAddress9.postalCode) || '',
    onChange: function onChange(event) {
      return props.addressChanged('postalCode', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    error: props.attemptedSubmission && !!addressErrors.countryId
  }, /*#__PURE__*/React.createElement(InputLabel$1, {
    htmlFor: props.idprefix ? props.idprefix + '-country' : 'country',
    ref: countryLabel
  }, 'Country'), /*#__PURE__*/React.createElement(Select$3, {
    value: ((_props$currentAddress10 = props.currentAddress) === null || _props$currentAddress10 === void 0 ? void 0 : _props$currentAddress10.countryId) || '1',
    onChange: function onChange(event) {
      return props.addressChanged('countryId', event.target.value);
    },
    labelWidth: countryLabelWidth,
    id: props.idprefix ? props.idprefix + '-country' : 'country',
    autoComplete: "cc-name",
    "native": true
  }, props.countryRegionData.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option['id'],
      value: option['id']
    }, option['name']);
  })), props.attemptedSubmission && !!addressErrors.countryId && /*#__PURE__*/React.createElement(FormHelperText, null, addressErrors.countryId)))));
}

var lodash_pickby = createCommonjsModule(function (module, exports) {
  /**
   * lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright jQuery Foundation and other contributors <https://jquery.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;
  /** Used as the `TypeError` message for "Functions" methods. */

  var FUNC_ERROR_TEXT = 'Expected a function';
  /** Used to stand-in for `undefined` hash values. */

  var HASH_UNDEFINED = '__lodash_hash_undefined__';
  /** Used to compose bitmasks for comparison styles. */

  var UNORDERED_COMPARE_FLAG = 1,
      PARTIAL_COMPARE_FLAG = 2;
  /** Used as references for various `Number` constants. */

  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991;
  /** `Object#toString` result references. */

  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      weakMapTag = '[object WeakMap]';
  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
  /** Used to match property names within property paths. */

  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */

  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  /** Used to match backslashes in property paths. */

  var reEscapeChar = /\\(\\)?/g;
  /** Used to detect host constructors (Safari). */

  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  /** Used to detect unsigned integer values. */

  var reIsUint = /^(?:0|[1-9]\d*)$/;
  /** Used to identify `toStringTag` values of typed arrays. */

  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  /** Detect free variable `global` from Node.js. */

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  /** Detect free variable `self`. */

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
  /** Used as a reference to the global object. */

  var root = freeGlobal || freeSelf || Function('return this')();
  /** Detect free variable `exports`. */

  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      return freeProcess && freeProcess.binding('util');
    } catch (e) {}
  }();
  /* Node.js helper references. */


  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */

  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }

    return array;
  }
  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */


  function arraySome(array, predicate) {
    var index = -1,
        length = array ? array.length : 0;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }

    return false;
  }
  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */


  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }
  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */


  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }

    return result;
  }
  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */


  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }
  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */


  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }
  /**
   * Checks if `value` is a host object in IE < 9.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
   */


  function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;

    if (value != null && typeof value.toString != 'function') {
      try {
        result = !!(value + '');
      } catch (e) {}
    }

    return result;
  }
  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */


  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */


  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }
  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */


  function setToArray(set) {
    var index = -1,
        result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }
  /** Used for built-in method references. */


  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  /** Used to detect overreaching core-js shims. */

  var coreJsData = root['__core-js_shared__'];
  /** Used to detect methods masquerading as native. */

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();
  /** Used to resolve the decompiled source of functions. */


  var funcToString = funcProto.toString;
  /** Used to check objects for own properties. */

  var hasOwnProperty = objectProto.hasOwnProperty;
  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */

  var objectToString = objectProto.toString;
  /** Used to detect if a method is native. */

  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  /** Built-in value references. */

  var Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeGetSymbols = Object.getOwnPropertySymbols,
      nativeKeys = overArg(Object.keys, Object);
  /* Built-in method references that are verified to be native. */

  var DataView = getNative(root, 'DataView'),
      Map = getNative(root, 'Map'),
      Promise = getNative(root, 'Promise'),
      Set = getNative(root, 'Set'),
      WeakMap = getNative(root, 'WeakMap'),
      nativeCreate = getNative(Object, 'create');
  /** Used to detect maps, sets, and weakmaps. */

  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);
  /** Used to convert symbols to primitives and strings. */

  var symbolProto = Symbol ? Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;
  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Hash(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */


  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }
  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }
  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }
  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }
  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */


  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  } // Add methods to `Hash`.


  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function ListCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */


  function listCacheClear() {
    this.__data__ = [];
  }
  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }

    return true;
  }
  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }
  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */


  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }

    return this;
  } // Add methods to `ListCache`.


  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function MapCache(entries) {
    var index = -1,
        length = entries ? entries.length : 0;
    this.clear();

    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */


  function mapCacheClear() {
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }
  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
  }
  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */


  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  } // Add methods to `MapCache`.


  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */

  function SetCache(values) {
    var index = -1,
        length = values ? values.length : 0;
    this.__data__ = new MapCache();

    while (++index < length) {
      this.add(values[index]);
    }
  }
  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */


  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);

    return this;
  }
  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */


  function setCacheHas(value) {
    return this.__data__.has(value);
  } // Add methods to `SetCache`.


  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;
  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */

  function Stack(entries) {
    this.__data__ = new ListCache(entries);
  }
  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */


  function stackClear() {
    this.__data__ = new ListCache();
  }
  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */


  function stackDelete(key) {
    return this.__data__['delete'](key);
  }
  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */


  function stackGet(key) {
    return this.__data__.get(key);
  }
  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */


  function stackHas(key) {
    return this.__data__.has(key);
  }
  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */


  function stackSet(key, value) {
    var cache = this.__data__;

    if (cache instanceof ListCache) {
      var pairs = cache.__data__;

      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        return this;
      }

      cache = this.__data__ = new MapCache(pairs);
    }

    cache.set(key, value);
    return this;
  } // Add methods to `Stack`.


  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */

  function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length,
        skipIndexes = !!length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */


  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }
  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */


  function baseGet(object, path) {
    path = isKey(path, object) ? [path] : castPath(path);
    var index = 0,
        length = path.length;

    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }

    return index && index == length ? object : undefined;
  }
  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  /**
   * The base implementation of `getTag`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */


  function baseGetTag(value) {
    return objectToString.call(value);
  }
  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */


  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }
  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {boolean} [bitmask] The bitmask of comparison flags.
   *  The bitmask may be composed of the following flags:
   *     1 - Unordered comparison
   *     2 - Partial comparison
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */


  function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) {
      return true;
    }

    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }

    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
  }
  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = arrayTag,
        othTag = arrayTag;

    if (!objIsArr) {
      objTag = getTag(object);
      objTag = objTag == argsTag ? objectTag : objTag;
    }

    if (!othIsArr) {
      othTag = getTag(other);
      othTag = othTag == argsTag ? objectTag : othTag;
    }

    var objIsObj = objTag == objectTag && !isHostObject(object),
        othIsObj = othTag == objectTag && !isHostObject(other),
        isSameTag = objTag == othTag;

    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }

    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
      }
    }

    if (!isSameTag) {
      return false;
    }

    stack || (stack = new Stack());
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
  }
  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */


  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
        length = index,
        noCustomizer = !customizer;

    if (object == null) {
      return !length;
    }

    object = Object(object);

    while (index--) {
      var data = matchData[index];

      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }

    while (++index < length) {
      data = matchData[index];
      var key = data[0],
          objValue = object[key],
          srcValue = data[1];

      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();

        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }

        if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
          return false;
        }
      }
    }

    return true;
  }
  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */


  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */


  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
  }
  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */


  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }

    if (value == null) {
      return identity;
    }

    if (typeof value == 'object') {
      return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }

    return property(value);
  }
  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }

    var result = [];

    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function baseKeysIn(object) {
    if (!isObject(object)) {
      return nativeKeysIn(object);
    }

    var isProto = isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */


  function baseMatches(source) {
    var matchData = getMatchData(source);

    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }

    return function (object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }
  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */


  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }

    return function (object) {
      var objValue = get(object, path);
      return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
  }
  /**
   * The base implementation of  `_.pickBy` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The source object.
   * @param {string[]} props The property identifiers to pick from.
   * @param {Function} predicate The function invoked per property.
   * @returns {Object} Returns the new object.
   */


  function basePickBy(object, props, predicate) {
    var index = -1,
        length = props.length,
        result = {};

    while (++index < length) {
      var key = props[index],
          value = object[key];

      if (predicate(value, key)) {
        result[key] = value;
      }
    }

    return result;
  }
  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */


  function basePropertyDeep(path) {
    return function (object) {
      return baseGet(object, path);
    };
  }
  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */


  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }

    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }
  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array} Returns the cast property path array.
   */


  function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
  }
  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */


  function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    } // Assume cyclic values are equal.


    var stacked = stack.get(array);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var index = -1,
        result = true,
        seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array); // Ignore non-index properties.

    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }

      if (compared !== undefined) {
        if (compared) {
          continue;
        }

        result = false;
        break;
      } // Recursively compare arrays (susceptible to call stack limits).


      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            return seen.add(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
        result = false;
        break;
      }
    }

    stack['delete'](array);
    stack['delete'](other);
    return result;
  }
  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }

        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }

        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        } // Assume cyclic values are equal.


        var stacked = stack.get(object);

        if (stacked) {
          return stacked == other;
        }

        bitmask |= UNORDERED_COMPARE_FLAG; // Recursively compare objects (susceptible to call stack limits).

        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }

    }

    return false;
  }
  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Function} customizer The function to customize comparisons.
   * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
   *  for more details.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */


  function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
        objProps = keys(object),
        objLength = objProps.length,
        othProps = keys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }

    var index = objLength;

    while (index--) {
      var key = objProps[index];

      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    } // Assume cyclic values are equal.


    var stacked = stack.get(object);

    if (stacked && stack.get(other)) {
      return stacked == other;
    }

    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;

    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      } // Recursively compare objects (susceptible to call stack limits).


      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
        result = false;
        break;
      }

      skipCtor || (skipCtor = key == 'constructor');
    }

    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }

    stack['delete'](object);
    stack['delete'](other);
    return result;
  }
  /**
   * Creates an array of own and inherited enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */


  function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
  }
  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */


  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }
  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */


  function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
      var key = result[length],
          value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }

    return result;
  }
  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */


  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }
  /**
   * Creates an array of the own enumerable symbol properties of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */


  var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
  /**
   * Creates an array of the own and inherited enumerable symbol properties
   * of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */

  var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
    var result = [];

    while (object) {
      arrayPush(result, getSymbols(object));
      object = getPrototype(object);
    }

    return result;
  };
  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */

  var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11,
  // for data views in Edge < 14, and promises in Node.js.

  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = objectToString.call(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : undefined;

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;

          case mapCtorString:
            return mapTag;

          case promiseCtorString:
            return promiseTag;

          case setCtorString:
            return setTag;

          case weakMapCtorString:
            return weakMapTag;
        }
      }

      return result;
    };
  }
  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */


  function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [path] : castPath(path);
    var result,
        index = -1,
        length = path.length;

    while (++index < length) {
      var key = toKey(path[index]);

      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }

      object = object[key];
    }

    if (result) {
      return result;
    }

    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
  }
  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */


  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }
  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */


  function isKey(value, object) {
    if (isArray(value)) {
      return false;
    }

    var type = typeof value;

    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
      return true;
    }

    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }
  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */


  function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }
  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */


  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */


  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
  }
  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */


  function isStrictComparable(value) {
    return value === value && !isObject(value);
  }
  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */


  function matchesStrictComparable(key, srcValue) {
    return function (object) {
      if (object == null) {
        return false;
      }

      return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
  }
  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */


  function nativeKeysIn(object) {
    var result = [];

    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }

    return result;
  }
  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */


  var stringToPath = memoize(function (string) {
    string = toString(string);
    var result = [];

    if (reLeadingDot.test(string)) {
      result.push('');
    }

    string.replace(rePropName, function (match, number, quote, string) {
      result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
  });
  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */

  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }

    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }
  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to process.
   * @returns {string} Returns the source code.
   */


  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + '';
      } catch (e) {}
    }

    return '';
  }
  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */


  function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }

    var memoized = function memoized() {
      var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = memoized.cache;

      if (cache.has(key)) {
        return cache.get(key);
      }

      var result = func.apply(this, args);
      memoized.cache = cache.set(key, result);
      return result;
    };

    memoized.cache = new (memoize.Cache || MapCache)();
    return memoized;
  } // Assign cache to `_.memoize`.


  memoize.Cache = MapCache;
  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */

  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */


  function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
  }
  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */


  var isArray = Array.isArray;
  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */


  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */


  function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
  }
  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */


  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */


  function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
  }
  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */


  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }
  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */


  function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
  }
  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */


  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */

  function toString(value) {
    return value == null ? '' : baseToString(value);
  }
  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */


  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }
  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */


  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }
  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */


  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */


  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }
  /**
   * Creates an object composed of the `object` properties `predicate` returns
   * truthy for. The predicate is invoked with two arguments: (value, key).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The source object.
   * @param {Function} [predicate=_.identity] The function invoked per property.
   * @returns {Object} Returns the new object.
   * @example
   *
   * var object = { 'a': 1, 'b': '2', 'c': 3 };
   *
   * _.pickBy(object, _.isNumber);
   * // => { 'a': 1, 'c': 3 }
   */


  function pickBy(object, predicate) {
    return object == null ? {} : basePickBy(object, getAllKeysIn(object), baseIteratee(predicate));
  }
  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */


  function identity(value) {
    return value;
  }
  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */


  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }
  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */


  function stubArray() {
    return [];
  }

  module.exports = pickBy;
});

function validateProfile(profile) {
  var profileErrors = {};
  profileErrors.firstName = validateNotEmpty(profile.firstName, 'First Name is required');
  profileErrors.lastName = validateNotEmpty(profile.lastName, 'Last Name is required');
  profileErrors.phoneNumber = validatePhoneNumber(profile.phoneNumber);
  profileErrors.phoneType = validateNotEmpty(profile.phoneType, 'Phone Type is required');
  profileErrors.dateOfBirth = validateDateOfBirth(profile.dateOfBirth);
  profileErrors.securityQuestion = validateNotEmpty(profile.securityQuestion, 'Security Question is required');
  profileErrors.securityAnswer = validateNotEmpty(profile.securityAnswer, 'Security Answer is required');
  return _objectSpread2(_objectSpread2({}, lodash_pickby(profileErrors)), validateAddress(profile));
}

var reactTextMask = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t(React);
  }(commonjsGlobal, function (e) {
    return function (e) {
      function t(n) {
        if (r[n]) return r[n].exports;
        var o = r[n] = {
          exports: {},
          id: n,
          loaded: !1
        };
        return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
      }

      var r = {};
      return t.m = e, t.c = r, t.p = "", t(0);
    }([function (e, t, r) {
      function n(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e, t) {
        var r = {};

        for (var n in e) {
          t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
        }

        return r;
      }

      function i(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function a(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.conformToMask = void 0;

      var s = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      },
          l = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }

        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
          f = r(3);

      Object.defineProperty(t, "conformToMask", {
        enumerable: !0,
        get: function get() {
          return n(f).default;
        }
      });

      var c = r(11),
          p = n(c),
          d = r(9),
          h = n(d),
          v = r(5),
          y = n(v),
          m = r(2),
          b = function (e) {
        function t() {
          var e;
          i(this, t);

          for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
            n[o] = arguments[o];
          }

          var u = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(n)));
          return u.setRef = u.setRef.bind(u), u.onBlur = u.onBlur.bind(u), u.onChange = u.onChange.bind(u), u;
        }

        return u(t, e), l(t, [{
          key: "setRef",
          value: function value(e) {
            this.inputElement = e;
          }
        }, {
          key: "initTextMask",
          value: function value() {
            var e = this.props,
                t = this.props.value;
            this.textMaskInputElement = (0, y.default)(s({
              inputElement: this.inputElement
            }, e)), this.textMaskInputElement.update(t);
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            this.initTextMask();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            var t = this.props,
                r = t.value,
                n = t.pipe,
                o = t.mask,
                i = t.guide,
                a = t.placeholderChar,
                u = t.showMask,
                s = {
              guide: i,
              placeholderChar: a,
              showMask: u
            },
                l = "function" == typeof n && "function" == typeof e.pipe ? n.toString() !== e.pipe.toString() : (0, m.isNil)(n) && !(0, m.isNil)(e.pipe) || !(0, m.isNil)(n) && (0, m.isNil)(e.pipe),
                f = o.toString() !== e.mask.toString(),
                c = Object.keys(s).some(function (t) {
              return s[t] !== e[t];
            }) || f || l,
                p = r !== this.inputElement.value;
            (p || c) && this.initTextMask();
          }
        }, {
          key: "render",
          value: function e() {
            var t = this.props,
                e = t.render,
                r = o(t, ["render"]);
            return delete r.mask, delete r.guide, delete r.pipe, delete r.placeholderChar, delete r.keepCharPositions, delete r.value, delete r.onBlur, delete r.onChange, delete r.showMask, e(this.setRef, s({
              onBlur: this.onBlur,
              onChange: this.onChange,
              defaultValue: this.props.value
            }, r));
          }
        }, {
          key: "onChange",
          value: function value(e) {
            this.textMaskInputElement.update(), "function" == typeof this.props.onChange && this.props.onChange(e);
          }
        }, {
          key: "onBlur",
          value: function value(e) {
            "function" == typeof this.props.onBlur && this.props.onBlur(e);
          }
        }]), t;
      }(p.default.PureComponent);

      t.default = b, b.propTypes = {
        mask: h.default.oneOfType([h.default.array, h.default.func, h.default.bool, h.default.shape({
          mask: h.default.oneOfType([h.default.array, h.default.func]),
          pipe: h.default.func
        })]).isRequired,
        guide: h.default.bool,
        value: h.default.oneOfType([h.default.string, h.default.number]),
        pipe: h.default.func,
        placeholderChar: h.default.string,
        keepCharPositions: h.default.bool,
        showMask: h.default.bool
      }, b.defaultProps = {
        render: function render(e, t) {
          return p.default.createElement("input", s({
            ref: e
          }, t));
        }
      };
    }, function (e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.placeholderChar = "_", t.strFunction = "function";
    }, function (e, t, r) {
      function n() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : f,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.placeholderChar;
        if (!o(e)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
        if (e.indexOf(t) !== -1) throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n" + ("The placeholder character that was received is: " + JSON.stringify(t) + "\n\n") + ("The mask that was received is: " + JSON.stringify(e)));
        return e.map(function (e) {
          return e instanceof RegExp ? t : e;
        }).join("");
      }

      function o(e) {
        return Array.isArray && Array.isArray(e) || e instanceof Array;
      }

      function i(e) {
        return "string" == typeof e || e instanceof String;
      }

      function a(e) {
        return "number" == typeof e && void 0 === e.length && !isNaN(e);
      }

      function u(e) {
        return "undefined" == typeof e || null === e;
      }

      function s(e) {
        for (var t = [], r = void 0; r = e.indexOf(c), r !== -1;) {
          t.push(r), e.splice(r, 1);
        }

        return {
          maskWithoutCaretTraps: e,
          indexes: t
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.convertMaskToPlaceholder = n, t.isArray = o, t.isString = i, t.isNumber = a, t.isNil = u, t.processCaretTraps = s;
      var l = r(1),
          f = [],
          c = "[]";
    }, function (e, t, r) {
      function n() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s,
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

        if (!(0, i.isArray)(t)) {
          if (("undefined" == typeof t ? "undefined" : o(t)) !== a.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
          t = t(e, r), t = (0, i.processCaretTraps)(t).maskWithoutCaretTraps;
        }

        var n = r.guide,
            l = void 0 === n || n,
            f = r.previousConformedValue,
            c = void 0 === f ? s : f,
            p = r.placeholderChar,
            d = void 0 === p ? a.placeholderChar : p,
            h = r.placeholder,
            v = void 0 === h ? (0, i.convertMaskToPlaceholder)(t, d) : h,
            y = r.currentCaretPosition,
            m = r.keepCharPositions,
            b = l === !1 && void 0 !== c,
            g = e.length,
            k = c.length,
            C = v.length,
            O = t.length,
            T = g - k,
            P = T > 0,
            x = y + (P ? -T : 0),
            w = x + Math.abs(T);

        if (m === !0 && !P) {
          for (var S = s, _ = x; _ < w; _++) {
            v[_] === d && (S += d);
          }

          e = e.slice(0, x) + S + e.slice(x, g);
        }

        for (var M = e.split(s).map(function (e, t) {
          return {
            char: e,
            isNew: t >= x && t < w
          };
        }), j = g - 1; j >= 0; j--) {
          var E = M[j].char;

          if (E !== d) {
            var R = j >= x && k === O;
            E === v[R ? j - T : j] && M.splice(j, 1);
          }
        }

        var V = s,
            N = !1;

        e: for (var A = 0; A < C; A++) {
          var B = v[A];

          if (B === d) {
            if (M.length > 0) for (; M.length > 0;) {
              var I = M.shift(),
                  F = I.char,
                  q = I.isNew;

              if (F === d && b !== !0) {
                V += d;
                continue e;
              }

              if (t[A].test(F)) {
                if (m === !0 && q !== !1 && c !== s && l !== !1 && P) {
                  for (var D = M.length, L = null, W = 0; W < D; W++) {
                    var J = M[W];
                    if (J.char !== d && J.isNew === !1) break;

                    if (J.char === d) {
                      L = W;
                      break;
                    }
                  }

                  null !== L ? (V += F, M.splice(L, 1)) : A--;
                } else V += F;

                continue e;
              }

              N = !0;
            }
            b === !1 && (V += v.substr(A, C));
            break;
          }

          V += B;
        }

        if (b && P === !1) {
          for (var U = null, H = 0; H < V.length; H++) {
            v[H] === d && (U = H);
          }

          V = null !== U ? V.substr(0, U + 1) : s;
        }

        return {
          conformedValue: V,
          meta: {
            someCharsRejected: N
          }
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };
      t.default = n;
      var i = r(2),
          a = r(1),
          u = [],
          s = "";
    }, function (e, t) {
      function r(e) {
        var t = e.previousConformedValue,
            r = void 0 === t ? o : t,
            i = e.previousPlaceholder,
            a = void 0 === i ? o : i,
            u = e.currentCaretPosition,
            s = void 0 === u ? 0 : u,
            l = e.conformedValue,
            f = e.rawValue,
            c = e.placeholderChar,
            p = e.placeholder,
            d = e.indexesOfPipedChars,
            h = void 0 === d ? n : d,
            v = e.caretTrapIndexes,
            y = void 0 === v ? n : v;
        if (0 === s || !f.length) return 0;
        var m = f.length,
            b = r.length,
            g = p.length,
            k = l.length,
            C = m - b,
            O = C > 0,
            T = 0 === b,
            P = C > 1 && !O && !T;
        if (P) return s;

        var x = O && (r === l || l === p),
            w = 0,
            S = void 0,
            _ = void 0;

        if (x) w = s - C;else {
          var M = l.toLowerCase(),
              j = f.toLowerCase(),
              E = j.substr(0, s).split(o),
              R = E.filter(function (e) {
            return M.indexOf(e) !== -1;
          });
          _ = R[R.length - 1];
          var V = a.substr(0, R.length).split(o).filter(function (e) {
            return e !== c;
          }).length,
              N = p.substr(0, R.length).split(o).filter(function (e) {
            return e !== c;
          }).length,
              A = N !== V,
              B = void 0 !== a[R.length - 1] && void 0 !== p[R.length - 2] && a[R.length - 1] !== c && a[R.length - 1] !== p[R.length - 1] && a[R.length - 1] === p[R.length - 2];
          !O && (A || B) && V > 0 && p.indexOf(_) > -1 && void 0 !== f[s] && (S = !0, _ = f[s]);

          for (var I = h.map(function (e) {
            return M[e];
          }), F = I.filter(function (e) {
            return e === _;
          }).length, q = R.filter(function (e) {
            return e === _;
          }).length, D = p.substr(0, p.indexOf(c)).split(o).filter(function (e, t) {
            return e === _ && f[t] !== e;
          }).length, L = D + q + F + (S ? 1 : 0), W = 0, J = 0; J < k; J++) {
            var U = M[J];
            if (w = J + 1, U === _ && W++, W >= L) break;
          }
        }

        if (O) {
          for (var H = w, Y = w; Y <= g; Y++) {
            if (p[Y] === c && (H = Y), p[Y] === c || y.indexOf(Y) !== -1 || Y === g) return H;
          }
        } else if (S) {
          for (var z = w - 1; z >= 0; z--) {
            if (l[z] === _ || y.indexOf(z) !== -1 || 0 === z) return z;
          }
        } else for (var G = w; G >= 0; G--) {
          if (p[G - 1] === c || y.indexOf(G) !== -1 || 0 === G) return G;
        }
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = r;
      var n = [],
          o = "";
    }, function (e, t, r) {
      function n(e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }

      function o(e) {
        var t = {
          previousConformedValue: void 0,
          previousPlaceholder: void 0
        };
        return {
          state: t,
          update: function update(r) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e,
                o = n.inputElement,
                l = n.mask,
                c = n.guide,
                y = n.pipe,
                b = n.placeholderChar,
                g = void 0 === b ? h.placeholderChar : b,
                k = n.keepCharPositions,
                C = void 0 !== k && k,
                O = n.showMask,
                T = void 0 !== O && O;

            if ("undefined" == typeof r && (r = o.value), r !== t.previousConformedValue) {
              ("undefined" == typeof l ? "undefined" : s(l)) === m && void 0 !== l.pipe && void 0 !== l.mask && (y = l.pipe, l = l.mask);
              var P = void 0,
                  x = void 0;

              if (l instanceof Array && (P = (0, d.convertMaskToPlaceholder)(l, g)), l !== !1) {
                var w = a(r),
                    S = o.selectionEnd,
                    _ = t.previousConformedValue,
                    M = t.previousPlaceholder,
                    j = void 0;

                if (("undefined" == typeof l ? "undefined" : s(l)) === h.strFunction) {
                  if (x = l(w, {
                    currentCaretPosition: S,
                    previousConformedValue: _,
                    placeholderChar: g
                  }), x === !1) return;
                  var E = (0, d.processCaretTraps)(x),
                      R = E.maskWithoutCaretTraps,
                      V = E.indexes;
                  x = R, j = V, P = (0, d.convertMaskToPlaceholder)(x, g);
                } else x = l;

                var N = {
                  previousConformedValue: _,
                  guide: c,
                  placeholderChar: g,
                  pipe: y,
                  placeholder: P,
                  currentCaretPosition: S,
                  keepCharPositions: C
                },
                    A = (0, p.default)(w, x, N),
                    B = A.conformedValue,
                    I = ("undefined" == typeof y ? "undefined" : s(y)) === h.strFunction,
                    F = {};
                I && (F = y(B, u({
                  rawValue: w
                }, N)), F === !1 ? F = {
                  value: _,
                  rejected: !0
                } : (0, d.isString)(F) && (F = {
                  value: F
                }));
                var q = I ? F.value : B,
                    D = (0, f.default)({
                  previousConformedValue: _,
                  previousPlaceholder: M,
                  conformedValue: q,
                  placeholder: P,
                  rawValue: w,
                  currentCaretPosition: S,
                  placeholderChar: g,
                  indexesOfPipedChars: F.indexesOfPipedChars,
                  caretTrapIndexes: j
                }),
                    L = q === P && 0 === D,
                    W = T ? P : v,
                    J = L ? W : q;
                t.previousConformedValue = J, t.previousPlaceholder = P, o.value !== J && (o.value = J, i(o, D));
              }
            }
          }
        };
      }

      function i(e, t) {
        document.activeElement === e && (b ? g(function () {
          return e.setSelectionRange(t, t, y);
        }, 0) : e.setSelectionRange(t, t, y));
      }

      function a(e) {
        if ((0, d.isString)(e)) return e;
        if ((0, d.isNumber)(e)) return String(e);
        if (void 0 === e || null === e) return v;
        throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n " + JSON.stringify(e));
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }

        return e;
      },
          s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };

      t.default = o;
      var l = r(4),
          f = n(l),
          c = r(3),
          p = n(c),
          d = r(2),
          h = r(1),
          v = "",
          y = "none",
          m = "object",
          b = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent),
          g = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : setTimeout;
    }, function (e, t) {
      function r(e) {
        return function () {
          return e;
        };
      }

      var n = function n() {};

      n.thatReturns = r, n.thatReturnsFalse = r(!1), n.thatReturnsTrue = r(!0), n.thatReturnsNull = r(null), n.thatReturnsThis = function () {
        return this;
      }, n.thatReturnsArgument = function (e) {
        return e;
      }, e.exports = n;
    }, function (e, t, r) {
      function n(e, t, r, n, i, a, u, s) {
        if (!e) {
          var l;
          if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var f = [r, n, i, a, u, s],
                c = 0;
            l = new Error(t.replace(/%s/g, function () {
              return f[c++];
            })), l.name = "Invariant Violation";
          }
          throw l.framesToPop = 1, l;
        }
      }

      e.exports = n;
    }, function (e, t, r) {
      var n = r(6),
          o = r(7),
          i = r(10);

      e.exports = function () {
        function e(e, t, r, n, a, u) {
          u !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        }

        function t() {
          return e;
        }

        e.isRequired = e;
        var r = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t
        };
        return r.checkPropTypes = n, r.PropTypes = r, r;
      };
    }, function (e, t, r) {
      e.exports = r(8)();
    }, function (e, t) {
      var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      e.exports = r;
    }, function (t, r) {
      t.exports = e;
    }]);
  });
});
var MaskedInput = unwrapExports(reactTextMask);
var reactTextMask_1 = reactTextMask.reactTextMask;
var _excluded$4 = ["inputRef"];
UsaPhoneNumberMask.propTypes = {
  inputRef: func.isRequired
};

function UsaPhoneNumberMask(props) {
  var inputRef = props.inputRef,
      other = _objectWithoutProperties(props, _excluded$4);

  return /*#__PURE__*/React.createElement(MaskedInput, _extends({}, other, {
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    placeholderChar: "\u2000",
    placeholder: '(555) 123-4567',
    guide: false,
    showMask: true
  }));
}

UsaPhoneNumberMask.propTypes = {
  inputRef: func.isRequired
};
DateOfBirth.propTypes = {
  date: string,
  dateOfBirthErrors: shape({
    form: string,
    year: string,
    month: string,
    day: string
  }),
  onChange: func.isRequired,
  disabled: bool,
  onError: func,
  required: bool,
  helperText: string
};

function DateOfBirth(props) {
  var _props$dateOfBirthErr, _props$dateOfBirthErr2, _props$dateOfBirthErr3, _props$dateOfBirthErr4;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      year = _useState2[0],
      setYear = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      month = _useState4[0],
      setMonth = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      day = _useState6[0],
      setDay = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      dateOfBirthErrors = _useState8[0],
      setDateOfBirthErrors = _useState8[1];

  useEffect(function () {
    props.onError && props.onError(dateOfBirthErrors);
  }, [dateOfBirthErrors]);
  useEffect(function () {
    if (!props.date) {
      return;
    }

    var isoDate = parseISO(props.date);

    if (isValid(isoDate)) {
      setYear(padIfPresent(getYear(isoDate).toString()));
      setMonth(padIfPresent((getMonth(isoDate) + 1).toString()));
      setDay(padIfPresent(getDate(isoDate).toString()));
    } else {
      console.debug('date attribute was provided but was invalid', props.date);
    }
  }, [props.date]);
  useEffect(function () {
    var formattedDate = "".concat(year, "-").concat(month, "-").concat(day);
    var date = parseISO(formattedDate);
    var errorMsg = undefined;
    var noErrors = !Object.keys(dateOfBirthErrors).some(function (key) {
      return dateOfBirthErrors[key];
    });

    if (noErrors && isValid(date) && !isFuture(date)) {
      props.onChange(formattedDate);
    } else if (year.length === 4 && month.length === 2 && day.length === 2) {
      props.onChange('');
      errorMsg = 'The date of birth entered is not valid';
    } else {
      props.onChange('');
    }

    setDateOfBirthErrors(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        form: errorMsg
      });
    });
  }, [year, month, day]);
  useEffect(function () {
    var errorMsg = undefined;
    var yearInt = parseInt(year);

    if (year.length === 4 && (yearInt < 1900 || yearInt > new Date().getFullYear())) {
      errorMsg = 'Invalid year';
    }

    setDateOfBirthErrors(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        year: errorMsg
      });
    });
  }, [year]);
  useEffect(function () {
    var errorMsg = undefined;
    var monthInt = parseInt(month);

    if (month.length === 2 && (monthInt > 12 || monthInt < 1)) {
      errorMsg = 'Invalid month';
    }

    setDateOfBirthErrors(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        month: errorMsg
      });
    });
  }, [dateOfBirthErrors.year, month]);
  useEffect(function () {
    var errorMsg = undefined;
    var dayInt = isNaN(parseInt(day)) ? 0 : parseInt(day);
    var restOfDateValid = !dateOfBirthErrors.year && !dateOfBirthErrors.month;
    var greaterThanMonthAllows = restOfDateValid ? dayInt > getDaysInMonth(parseISO("".concat(year, "-").concat(month))) : false;

    if (day.length === 2 && (greaterThanMonthAllows || dayInt < 1 || dayInt > 31)) {
      errorMsg = 'Invalid day';
    }

    setDateOfBirthErrors(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        day: errorMsg
      });
    });
  }, [dateOfBirthErrors.year, dateOfBirthErrors.month, year, month, day]);

  var onlyUpdateWithNumber = function onlyUpdateWithNumber(event) {
    var stringValue = event.target.value;
    return stringValue.split('').map(function (character) {
      var intValue = parseInt(character);
      var isNumber = !isNaN(intValue);
      return isNumber ? character : '';
    }).join('');
  };

  var padIfPresent = function padIfPresent(value) {
    return value.length > 0 ? value.padStart(2, '0') : value;
  };

  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    id: 'date-of-birth-label'
  }, "Date of Birth"), !!((_props$dateOfBirthErr = props.dateOfBirthErrors) !== null && _props$dateOfBirthErr !== void 0 && _props$dateOfBirthErr.form) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, props.dateOfBirthErrors.form), !!dateOfBirthErrors.form && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, dateOfBirthErrors.form), /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 1,
    role: 'group',
    "aria-labelledby": 'date-of-birth-label'
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: !!((_props$dateOfBirthErr2 = props.dateOfBirthErrors) !== null && _props$dateOfBirthErr2 !== void 0 && _props$dateOfBirthErr2.form) || !!dateOfBirthErrors.year,
    helperText: dateOfBirthErrors.year,
    disabled: props.disabled,
    required: props.required,
    variant: "outlined",
    margin: "dense",
    inputProps: {
      maxLength: 4
    },
    label: "Year",
    id: "year",
    name: "year",
    autoComplete: "bday-year",
    fullWidth: true,
    value: year,
    onChange: function onChange(event) {
      return setYear(onlyUpdateWithNumber(event));
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 6,
    sm: 3
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: !!((_props$dateOfBirthErr3 = props.dateOfBirthErrors) !== null && _props$dateOfBirthErr3 !== void 0 && _props$dateOfBirthErr3.form) || !!dateOfBirthErrors.month,
    helperText: dateOfBirthErrors.month,
    disabled: props.disabled,
    required: props.required,
    variant: "outlined",
    margin: "dense",
    inputProps: {
      maxLength: 2
    },
    label: "Month",
    id: "month",
    name: "month",
    autoComplete: "bday-month",
    fullWidth: true,
    value: month,
    onBlur: function onBlur() {
      setMonth(function (state) {
        return padIfPresent(state);
      });
    },
    onChange: function onChange(event) {
      return setMonth(onlyUpdateWithNumber(event));
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 6,
    sm: 3
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: !!((_props$dateOfBirthErr4 = props.dateOfBirthErrors) !== null && _props$dateOfBirthErr4 !== void 0 && _props$dateOfBirthErr4.form) || !!dateOfBirthErrors.day,
    helperText: dateOfBirthErrors.day,
    disabled: props.disabled,
    required: props.required,
    variant: "outlined",
    margin: "dense",
    inputProps: {
      maxLength: 2
    },
    label: "Day",
    id: "day",
    name: "day",
    autoComplete: "bday-day",
    fullWidth: true,
    value: day,
    onBlur: function onBlur() {
      setDay(function (state) {
        return padIfPresent(state);
      });
    },
    onChange: function onChange(event) {
      return setDay(onlyUpdateWithNumber(event));
    }
  }))), !!props.helperText && /*#__PURE__*/React.createElement(FormHelperText, null, props.helperText));
}

var dist = createCommonjsModule(function (module) {
  module.exports = function (n) {
    var e = {};

    function t(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) {
        t.d(r, o, function (e) {
          return n[e];
        }.bind(null, o));
      }
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "", t(t.s = 182);
  }([function (n, e, t) {
    n.exports = t(174)();
  }, function (n, e) {
    n.exports = React;
  }, function (n, e) {
    var t = Array.isArray;
    n.exports = t;
  }, function (n, e, t) {
    var r = t(40),
        o = "object" == typeof self && self && self.Object === Object && self,
        a = r || o || Function("return this")();
    n.exports = a;
  }, function (n, e, t) {
    var r = t(78),
        o = t(25),
        a = t(27),
        i = t(28);

    n.exports = function (n, e, t) {
      return n = i(n), t = null == t ? 0 : r(a(t), 0, n.length), e = o(e), n.slice(t, t + e.length) == e;
    };
  }, function (n, e, t) {
    var r = t(171)(t(23));
    n.exports = r;
  }, function (n, e, t) {
    var r = t(14),
        o = t(76),
        a = t(77),
        i = "[object Null]",
        u = "[object Undefined]",
        c = r ? r.toStringTag : void 0;

    n.exports = function (n) {
      return null == n ? void 0 === n ? u : i : c && c in Object(n) ? o(n) : a(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return null != n && "object" == typeof n;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return null != n && ("object" == e || "function" == e);
    };
  }, function (n, e, t) {
    var r = t(92),
        o = t(95);

    n.exports = function (n, e) {
      var t = o(n, e);
      return r(t) ? t : void 0;
    };
  }, function (n, e, t) {
    var r = t(111),
        o = t(150),
        a = t(157),
        i = t(2),
        u = t(158);

    n.exports = function (n) {
      return "function" == typeof n ? n : null == n ? a : "object" == typeof n ? i(n) ? o(n[0], n[1]) : r(n) : u(n);
    };
  }, function (n, e, t) {
    var r = t(44),
        o = t(34);

    n.exports = function (n) {
      return null != n && o(n.length) && !r(n);
    };
  }, function (n, e, t) {
    var r = t(133),
        o = t(140),
        a = t(11);

    n.exports = function (n) {
      return a(n) ? r(n) : o(n);
    };
  }, function (n, e, t) {
    var r = t(26),
        o = t(10),
        a = t(168),
        i = t(2);

    n.exports = function (n, e) {
      return (i(n) ? r : a)(n, o(e, 3));
    };
  }, function (n, e, t) {
    var r = t(3).Symbol;
    n.exports = r;
  }, function (n, e, t) {
    var r = t(6),
        o = t(7),
        a = "[object Symbol]";

    n.exports = function (n) {
      return "symbol" == typeof n || o(n) && r(n) == a;
    };
  }, function (n, e, t) {
    var r = t(9)(Object, "create");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(100),
        o = t(101),
        a = t(102),
        i = t(103),
        u = t(104);

    function c(n) {
      var e = -1,
          t = null == n ? 0 : n.length;

      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(31);

    n.exports = function (n, e) {
      for (var t = n.length; t--;) {
        if (r(n[t][0], e)) return t;
      }

      return -1;
    };
  }, function (n, e, t) {
    var r = t(106);

    n.exports = function (n, e) {
      var t = n.__data__;
      return r(e) ? t["string" == typeof e ? "string" : "hash"] : t.map;
    };
  }, function (n, e, t) {
    var r = t(15),
        o = 1 / 0;

    n.exports = function (n) {
      if ("string" == typeof n || r(n)) return n;
      var e = n + "";
      return "0" == e && 1 / n == -o ? "-0" : e;
    };
  }, function (n, e, t) {
    var r = t(164),
        o = t(167)(r);
    n.exports = o;
  }, function (n, e, t) {
    var r = t(30),
        o = "Expected a function";

    function a(n, e) {
      if ("function" != typeof n || null != e && "function" != typeof e) throw new TypeError(o);

      var t = function t() {
        var r = arguments,
            o = e ? e.apply(this, r) : r[0],
            a = t.cache;
        if (a.has(o)) return a.get(o);
        var i = n.apply(this, r);
        return t.cache = a.set(o, i) || a, i;
      };

      return t.cache = new (a.Cache || r)(), t;
    }

    a.Cache = r, n.exports = a;
  }, function (n, e, t) {
    var r = t(43),
        o = t(10),
        a = t(27),
        i = Math.max;

    n.exports = function (n, e, t) {
      var u = null == n ? 0 : n.length;
      if (!u) return -1;
      var c = null == t ? 0 : a(t);
      return c < 0 && (c = i(u + c, 0)), r(n, o(e, 3), c);
    };
  }, function (n, e, t) {
    var r = t(50),
        o = t(163),
        a = t(10),
        i = t(2);

    n.exports = function (n, e) {
      return (i(n) ? r : o)(n, a(e, 3));
    };
  }, function (n, e, t) {
    var r = t(14),
        o = t(26),
        a = t(2),
        i = t(15),
        u = 1 / 0,
        c = r ? r.prototype : void 0,
        s = c ? c.toString : void 0;

    n.exports = function n(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return o(e, n) + "";
      if (i(e)) return s ? s.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -u ? "-0" : t;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = Array(r); ++t < r;) {
        o[t] = e(n[t], t, n);
      }

      return o;
    };
  }, function (n, e, t) {
    var r = t(79);

    n.exports = function (n) {
      var e = r(n),
          t = e % 1;
      return e == e ? t ? e - t : e : 0;
    };
  }, function (n, e, t) {
    var r = t(25);

    n.exports = function (n) {
      return null == n ? "" : r(n);
    };
  }, function (n, e, t) {
    var r = t(43),
        o = t(82),
        a = t(83);

    n.exports = function (n, e, t) {
      return e == e ? a(n, e, t) : r(n, o, t);
    };
  }, function (n, e, t) {
    var r = t(89),
        o = t(105),
        a = t(107),
        i = t(108),
        u = t(109);

    function c(n) {
      var e = -1,
          t = null == n ? 0 : n.length;

      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e) {
    n.exports = function (n, e) {
      return n === e || n != n && e != e;
    };
  }, function (n, e, t) {
    var r = t(9)(t(3), "Map");
    n.exports = r;
  }, function (n, e) {
    var t = 9007199254740991,
        r = /^(?:0|[1-9]\d*)$/;

    n.exports = function (n, e) {
      var o = typeof n;
      return !!(e = null == e ? t : e) && ("number" == o || "symbol" != o && r.test(n)) && n > -1 && n % 1 == 0 && n < e;
    };
  }, function (n, e) {
    var t = 9007199254740991;

    n.exports = function (n) {
      return "number" == typeof n && n > -1 && n % 1 == 0 && n <= t;
    };
  }, function (n, e, t) {
    var r = t(2),
        o = t(15),
        a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        i = /^\w*$/;

    n.exports = function (n, e) {
      if (r(n)) return !1;
      var t = typeof n;
      return !("number" != t && "symbol" != t && "boolean" != t && null != n && !o(n)) || i.test(n) || !a.test(n) || null != e && n in Object(e);
    };
  }, function (n, e, t) {
    var r = t(6),
        o = t(2),
        a = t(7),
        i = "[object String]";

    n.exports = function (n) {
      return "string" == typeof n || !o(n) && a(n) && r(n) == i;
    };
  }, function (n, e, t) {
    var r = t(169),
        o = t(21),
        a = t(10),
        i = t(170),
        u = t(2);

    n.exports = function (n, e, t) {
      var c = u(n) ? r : i,
          s = arguments.length < 3;
      return c(n, a(e, 4), t, s, o);
    };
  }, function (n, e, t) {
    var r = t(49),
        o = t(10),
        a = t(172),
        i = t(2),
        u = t(173);

    n.exports = function (n, e, t) {
      var c = i(n) ? r : a;
      return t && u(n, e, t) && (e = void 0), c(n, o(e, 3));
    };
  }, function (n, e) {
    var t;

    function r(n, e) {
      var t = Object.keys(n);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function o(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }

    function a(n, e) {
      return function (n) {
        if (Array.isArray(n)) return n;
      }(n) || function (n, e) {
        if (!(Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n))) return;
        var t = [],
            r = !0,
            o = !1,
            a = void 0;

        try {
          for (var i, u = n[Symbol.iterator](); !(r = (i = u.next()).done) && (t.push(i.value), !e || t.length !== e); r = !0) {
            ;
          }
        } catch (n) {
          o = !0, a = n;
        } finally {
          try {
            r || null == u.return || u.return();
          } finally {
            if (o) throw a;
          }
        }

        return t;
      }(n, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var i = {};

    function u(n, e, t) {
      e in i || (i[e] = []);
      var r = t || 0;
      i[e][r] = n;
    }

    var c,
        s = (t = []).concat.apply(t, function (n) {
      if (Array.isArray(n)) {
        for (var e = 0, t = new Array(n.length); e < n.length; e++) {
          t[e] = n[e];
        }

        return t;
      }
    }(c = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["American Samoa", ["oceania"], "as", "1684"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "+.. (..) ........"], ["Armenia", ["asia", "ex-ussr"], "am", "374"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "+.. ... ... ..."], ["Austria", ["europe", "european-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994"], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "+... (..) ... .. .."], ["Belgium", ["europe", "european-union"], "be", "32", "+.. ... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "+.. (..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "european-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "+. (...) ...-....", 1, ["204", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "+.. ..-........."], ["Colombia", ["america", "south-america"], "co", "57"], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Cook Islands", ["oceania"], "ck", "682"], ["Costa Rica", ["america", "central-america"], "cr", "506", "+... ....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225"], ["Croatia", ["europe", "european-union"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "european-union"], "cy", "357", "+... .. ......"], ["Czech Republic", ["europe", "european-union"], "cz", "420"], ["Denmark", ["europe", "european-union"], "dk", "45", "+.. .. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "+... ....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "european-union", "ex-ussr"], "ee", "372", "+... .... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "european-union"], "fi", "358", "+... .. ... .. .."], ["France", ["europe", "european-union"], "fr", "33", "+.. . .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "european-union"], "de", "49", "+.. .... ........"], ["Ghana", ["africa"], "gh", "233"], ["Gibraltar", ["europe"], "gi", "350"], ["Greece", ["europe", "european-union"], "gr", "30"], ["Greenland", ["america"], "gl", "299"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "+... ....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "+... ....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", "+... .... ...."], ["Hungary", ["europe", "european-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "+... ... ...."], ["India", ["asia"], "in", "91", "+.. .....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98"], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "european-union"], "ie", "353", "+... .. ......."], ["Israel", ["middle-east"], "il", "972", "+... ... ... ...."], ["Italy", ["europe", "european-union"], "it", "39", "+.. ... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", "+.. .. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "+. ... ...-..-..", 1, ["313", "327", "7172", "312", "73622", "321", "324", "336", "318", "315", "325", "311", "326", "310"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996"], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "european-union", "ex-ussr"], "lv", "371"], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "european-union", "ex-ussr"], "lt", "370"], ["Luxembourg", ["europe", "european-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "+.. ..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "european-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52"], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "+... (..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe"], "me", "382"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "european-union"], "nl", "31", "+.. .. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "+.. ...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["North Korea", ["asia"], "kp", "850"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Norway", ["europe"], "no", "47", "+.. ... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "+.. ...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", "+.. .... ......."], ["Poland", ["europe", "european-union"], "pl", "48", "+.. ...-...-..."], ["Portugal", ["europe", "european-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "european-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr"], "ru", "7", "+. (...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "+.. ....-...."], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Slovakia", ["europe", "european-union"], "sk", "421"], ["Slovenia", ["europe", "european-union"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "+.. ... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "european-union"], "es", "34", "+.. ... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "european-union"], "se", "46", "+.. (..) ...-..-.."], ["Switzerland", ["europe"], "ch", "41", "+.. .. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tokelau", ["oceania"], "tk", "690"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "+.. ... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["Tuvalu", ["asia"], "tv", "688"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "+... (..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "european-union"], "gb", "44", "+.. .... ......"], ["United States", ["america", "north-america"], "us", "1", "+. (...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998"], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", "+.. .. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Wallis and Futuna", ["oceania"], "wf", "681"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]].map(function (n) {
      var e = a(n, 7),
          t = e[0],
          i = e[1],
          c = e[2],
          s = e[3],
          p = e[4],
          f = e[5],
          l = e[6],
          g = {
        name: t,
        regions: i,
        iso2: c,
        dialCode: s,
        priority: f,
        format: p || void 0,
        hasAreaCodes: l
      },
          d = [];
      return g.hasAreaCodes && l.forEach(function (n) {
        var e = function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = null != arguments[e] ? arguments[e] : {};
            e % 2 ? r(t, !0).forEach(function (e) {
              o(n, e, t[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : r(t).forEach(function (e) {
              Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
            });
          }

          return n;
        }({}, g, {
          regions: i,
          dialCode: "".concat(s).concat(n),
          isAreaCode: !0
        });

        d.push(e), u(c, e.dialCode);
      }), u(g.iso2, g.dialCode, g.hasAreaCodes), d.length > 0 ? [g].concat(d) : [g];
    })) || function (n) {
      if (Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n)) return Array.from(n);
    }(c) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }());
    n.exports = {
      allCountries: s,
      allCountryCodes: i
    };
  }, function (n, e, t) {
    (function (e) {
      var t = "object" == typeof e && e && e.Object === Object && e;
      n.exports = t;
    }).call(this, t(75));
  }, function (n, e, t) {
    var r = t(8),
        o = t(15),
        a = NaN,
        i = /^\s+|\s+$/g,
        u = /^[-+]0x[0-9a-f]+$/i,
        c = /^0b[01]+$/i,
        s = /^0o[0-7]+$/i,
        p = parseInt;

    n.exports = function (n) {
      if ("number" == typeof n) return n;
      if (o(n)) return a;

      if (r(n)) {
        var e = "function" == typeof n.valueOf ? n.valueOf() : n;
        n = r(e) ? e + "" : e;
      }

      if ("string" != typeof n) return 0 === n ? n : +n;
      n = n.replace(i, "");
      var t = c.test(n);
      return t || s.test(n) ? p(n.slice(2), t ? 2 : 8) : u.test(n) ? a : +n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      var r = -1,
          o = n.length;
      e < 0 && (e = -e > o ? 0 : o + e), (t = t > o ? o : t) < 0 && (t += o), o = e > t ? 0 : t - e >>> 0, e >>>= 0;

      for (var a = Array(o); ++r < o;) {
        a[r] = n[r + e];
      }

      return a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      for (var o = n.length, a = t + (r ? 1 : -1); r ? a-- : ++a < o;) {
        if (e(n[a], a, n)) return a;
      }

      return -1;
    };
  }, function (n, e, t) {
    var r = t(6),
        o = t(8),
        a = "[object AsyncFunction]",
        i = "[object Function]",
        u = "[object GeneratorFunction]",
        c = "[object Proxy]";

    n.exports = function (n) {
      if (!o(n)) return !1;
      var e = r(n);
      return e == i || e == u || e == a || e == c;
    };
  }, function (n, e) {
    var t = Function.prototype.toString;

    n.exports = function (n) {
      if (null != n) {
        try {
          return t.call(n);
        } catch (n) {}

        try {
          return n + "";
        } catch (n) {}
      }

      return "";
    };
  }, function (n, e, t) {
    var r = t(17),
        o = t(113),
        a = t(114),
        i = t(115),
        u = t(116),
        c = t(117);

    function s(n) {
      var e = this.__data__ = new r(n);
      this.size = e.size;
    }

    s.prototype.clear = o, s.prototype.delete = a, s.prototype.get = i, s.prototype.has = u, s.prototype.set = c, n.exports = s;
  }, function (n, e, t) {
    var r = t(118),
        o = t(7);

    n.exports = function n(e, t, a, i, u) {
      return e === t || (null == e || null == t || !o(e) && !o(t) ? e != e && t != t : r(e, t, a, i, n, u));
    };
  }, function (n, e, t) {
    var r = t(119),
        o = t(49),
        a = t(122),
        i = 1,
        u = 2;

    n.exports = function (n, e, t, c, s, p) {
      var f = t & i,
          l = n.length,
          g = e.length;
      if (l != g && !(f && g > l)) return !1;
      var d = p.get(n);
      if (d && p.get(e)) return d == e;
      var b = -1,
          x = !0,
          A = t & u ? new r() : void 0;

      for (p.set(n, e), p.set(e, n); ++b < l;) {
        var v = n[b],
            h = e[b];
        if (c) var m = f ? c(h, v, b, e, n, p) : c(v, h, b, n, e, p);

        if (void 0 !== m) {
          if (m) continue;
          x = !1;
          break;
        }

        if (A) {
          if (!o(e, function (n, e) {
            if (!a(A, e) && (v === n || s(v, n, t, c, p))) return A.push(e);
          })) {
            x = !1;
            break;
          }
        } else if (v !== h && !s(v, h, t, c, p)) {
          x = !1;
          break;
        }
      }

      return p.delete(n), p.delete(e), x;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length; ++t < r;) {
        if (e(n[t], t, n)) return !0;
      }

      return !1;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = 0, a = []; ++t < r;) {
        var i = n[t];
        e(i, t, n) && (a[o++] = i);
      }

      return a;
    };
  }, function (n, e, t) {
    var r = t(135),
        o = t(7),
        a = Object.prototype,
        i = a.hasOwnProperty,
        u = a.propertyIsEnumerable,
        c = r(function () {
      return arguments;
    }()) ? r : function (n) {
      return o(n) && i.call(n, "callee") && !u.call(n, "callee");
    };
    n.exports = c;
  }, function (n, e, t) {
    (function (n) {
      var r = t(3),
          o = t(136),
          a = e && !e.nodeType && e,
          i = a && "object" == typeof n && n && !n.nodeType && n,
          u = i && i.exports === a ? r.Buffer : void 0,
          c = (u ? u.isBuffer : void 0) || o;
      n.exports = c;
    }).call(this, t(53)(n));
  }, function (n, e) {
    n.exports = function (n) {
      return n.webpackPolyfill || (n.deprecate = function () {}, n.paths = [], n.children || (n.children = []), Object.defineProperty(n, "loaded", {
        enumerable: !0,
        get: function get() {
          return n.l;
        }
      }), Object.defineProperty(n, "id", {
        enumerable: !0,
        get: function get() {
          return n.i;
        }
      }), n.webpackPolyfill = 1), n;
    };
  }, function (n, e, t) {
    var r = t(137),
        o = t(138),
        a = t(139),
        i = a && a.isTypedArray,
        u = i ? o(i) : r;
    n.exports = u;
  }, function (n, e, t) {
    var r = t(8);

    n.exports = function (n) {
      return n == n && !r(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return null != t && t[n] === e && (void 0 !== e || n in Object(t));
      };
    };
  }, function (n, e, t) {
    var r = t(58),
        o = t(20);

    n.exports = function (n, e) {
      for (var t = 0, a = (e = r(e, n)).length; null != n && t < a;) {
        n = n[o(e[t++])];
      }

      return t && t == a ? n : void 0;
    };
  }, function (n, e, t) {
    var r = t(2),
        o = t(35),
        a = t(152),
        i = t(28);

    n.exports = function (n, e) {
      return r(n) ? n : o(n, e) ? [n] : a(i(n));
    };
  }, function (n, e) {
    n.exports = "data:image/png;base64,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";
  }, function (n, e, t) {
    var r = t(25),
        o = t(80),
        a = t(81),
        i = t(84),
        u = t(85),
        c = t(28),
        s = /^\s+|\s+$/g;

    n.exports = function (n, e, t) {
      if ((n = c(n)) && (t || void 0 === e)) return n.replace(s, "");
      if (!n || !(e = r(e))) return n;
      var p = u(n),
          f = u(e),
          l = i(p, f),
          g = a(p, f) + 1;
      return o(p, l, g).join("");
    };
  }, function (n, e, t) {
    var r = t(8),
        o = t(110),
        a = t(41),
        i = "Expected a function",
        u = Math.max,
        c = Math.min;

    n.exports = function (n, e, t) {
      var s,
          p,
          f,
          l,
          g,
          d,
          b = 0,
          x = !1,
          A = !1,
          v = !0;
      if ("function" != typeof n) throw new TypeError(i);

      function h(e) {
        var t = s,
            r = p;
        return s = p = void 0, b = e, l = n.apply(r, t);
      }

      function m(n) {
        var t = n - d;
        return void 0 === d || t >= e || t < 0 || A && n - b >= f;
      }

      function y() {
        var n = o();
        if (m(n)) return C(n);
        g = setTimeout(y, function (n) {
          var t = e - (n - d);
          return A ? c(t, f - (n - b)) : t;
        }(n));
      }

      function C(n) {
        return g = void 0, v && s ? h(n) : (s = p = void 0, l);
      }

      function k() {
        var n = o(),
            t = m(n);

        if (s = arguments, p = this, d = n, t) {
          if (void 0 === g) return function (n) {
            return b = n, g = setTimeout(y, e), x ? h(n) : l;
          }(d);
          if (A) return clearTimeout(g), g = setTimeout(y, e), h(d);
        }

        return void 0 === g && (g = setTimeout(y, e)), l;
      }

      return e = a(e) || 0, r(t) && (x = !!t.leading, f = (A = "maxWait" in t) ? u(a(t.maxWait) || 0, e) : f, v = "trailing" in t ? !!t.trailing : v), k.cancel = function () {
        void 0 !== g && clearTimeout(g), b = 0, s = d = p = g = void 0;
      }, k.flush = function () {
        return void 0 === g ? l : C(o());
      }, k;
    };
  }, function (n, e, t) {
    var r = t(42);

    n.exports = function (n) {
      var e = null == n ? 0 : n.length;
      return e ? r(n, 1, e) : [];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n && n.length ? n[0] : void 0;
    };
  }, function (n, e, t) {
    var r = t(29),
        o = t(11),
        a = t(36),
        i = t(27),
        u = t(161),
        c = Math.max;

    n.exports = function (n, e, t, s) {
      n = o(n) ? n : u(n), t = t && !s ? i(t) : 0;
      var p = n.length;
      return t < 0 && (t = c(p + t, 0)), a(n) ? t <= p && n.indexOf(e, t) > -1 : !!p && r(n, e, t) > -1;
    };
  }, function (n, e) {
    n.exports = clsx;
  }, function (n, e) {
    n.exports = TextField;
  }, function (n, e) {
    n.exports = InputAdornment$1;
  }, function (n, e) {
    n.exports = MuiButton;
  }, function (n, e) {
    n.exports = Menu$1;
  }, function (n, e) {
    n.exports = Divider;
  }, function (n, e) {
    n.exports = NativeSelect;
  }, function (n, e) {
    n.exports = withStyles$1;
  }, function (n, e) {
    n.exports = MenuItem;
  }, function (n, e) {
    n.exports = RootRef;
  }, function (n, e) {
    var t;

    t = function () {
      return this;
    }();

    try {
      t = t || new Function("return this")();
    } catch (n) {
      "object" == typeof window && (t = window);
    }

    n.exports = t;
  }, function (n, e, t) {
    var r = t(14),
        o = Object.prototype,
        a = o.hasOwnProperty,
        i = o.toString,
        u = r ? r.toStringTag : void 0;

    n.exports = function (n) {
      var e = a.call(n, u),
          t = n[u];

      try {
        n[u] = void 0;
        var r = !0;
      } catch (n) {}

      var o = i.call(n);
      return r && (e ? n[u] = t : delete n[u]), o;
    };
  }, function (n, e) {
    var t = Object.prototype.toString;

    n.exports = function (n) {
      return t.call(n);
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      return n == n && (void 0 !== t && (n = n <= t ? n : t), void 0 !== e && (n = n >= e ? n : e)), n;
    };
  }, function (n, e, t) {
    var r = t(41),
        o = 1 / 0,
        a = 17976931348623157e292;

    n.exports = function (n) {
      return n ? (n = r(n)) === o || n === -o ? (n < 0 ? -1 : 1) * a : n == n ? n : 0 : 0 === n ? n : 0;
    };
  }, function (n, e, t) {
    var r = t(42);

    n.exports = function (n, e, t) {
      var o = n.length;
      return t = void 0 === t ? o : t, !e && t >= o ? n : r(n, e, t);
    };
  }, function (n, e, t) {
    var r = t(29);

    n.exports = function (n, e) {
      for (var t = n.length; t-- && r(e, n[t], 0) > -1;) {
        ;
      }

      return t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n != n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      for (var r = t - 1, o = n.length; ++r < o;) {
        if (n[r] === e) return r;
      }

      return -1;
    };
  }, function (n, e, t) {
    var r = t(29);

    n.exports = function (n, e) {
      for (var t = -1, o = n.length; ++t < o && r(e, n[t], 0) > -1;) {
        ;
      }

      return t;
    };
  }, function (n, e, t) {
    var r = t(86),
        o = t(87),
        a = t(88);

    n.exports = function (n) {
      return o(n) ? a(n) : r(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n.split("");
    };
  }, function (n, e) {
    var t = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

    n.exports = function (n) {
      return t.test(n);
    };
  }, function (n, e) {
    var t = "[\\ud800-\\udfff]",
        r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        o = "\\ud83c[\\udffb-\\udfff]",
        a = "[^\\ud800-\\udfff]",
        i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        u = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        c = "(?:" + r + "|" + o + ")" + "?",
        s = "[\\ufe0e\\ufe0f]?" + c + ("(?:\\u200d(?:" + [a, i, u].join("|") + ")[\\ufe0e\\ufe0f]?" + c + ")*"),
        p = "(?:" + [a + r + "?", r, i, u, t].join("|") + ")",
        f = RegExp(o + "(?=" + o + ")|" + p + s, "g");

    n.exports = function (n) {
      return n.match(f) || [];
    };
  }, function (n, e, t) {
    var r = t(90),
        o = t(17),
        a = t(32);

    n.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || o)(),
        string: new r()
      };
    };
  }, function (n, e, t) {
    var r = t(91),
        o = t(96),
        a = t(97),
        i = t(98),
        u = t(99);

    function c(n) {
      var e = -1,
          t = null == n ? 0 : n.length;

      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }

    c.prototype.clear = r, c.prototype.delete = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(16);

    n.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(44),
        o = t(93),
        a = t(8),
        i = t(45),
        u = /^\[object .+?Constructor\]$/,
        c = Function.prototype,
        s = Object.prototype,
        p = c.toString,
        f = s.hasOwnProperty,
        l = RegExp("^" + p.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    n.exports = function (n) {
      return !(!a(n) || o(n)) && (r(n) ? l : u).test(i(n));
    };
  }, function (n, e, t) {
    var r,
        o = t(94),
        a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

    n.exports = function (n) {
      return !!a && a in n;
    };
  }, function (n, e, t) {
    var r = t(3)["__core-js_shared__"];
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return null == n ? void 0 : n[e];
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.has(n) && delete this.__data__[n];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e, t) {
    var r = t(16),
        o = "__lodash_hash_undefined__",
        a = Object.prototype.hasOwnProperty;

    n.exports = function (n) {
      var e = this.__data__;

      if (r) {
        var t = e[n];
        return t === o ? void 0 : t;
      }

      return a.call(e, n) ? e[n] : void 0;
    };
  }, function (n, e, t) {
    var r = t(16),
        o = Object.prototype.hasOwnProperty;

    n.exports = function (n) {
      var e = this.__data__;
      return r ? void 0 !== e[n] : o.call(e, n);
    };
  }, function (n, e, t) {
    var r = t(16),
        o = "__lodash_hash_undefined__";

    n.exports = function (n, e) {
      var t = this.__data__;
      return this.size += this.has(n) ? 0 : 1, t[n] = r && void 0 === e ? o : e, this;
    };
  }, function (n, e) {
    n.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(18),
        o = Array.prototype.splice;

    n.exports = function (n) {
      var e = this.__data__,
          t = r(e, n);
      return !(t < 0) && (t == e.length - 1 ? e.pop() : o.call(e, t, 1), --this.size, !0);
    };
  }, function (n, e, t) {
    var r = t(18);

    n.exports = function (n) {
      var e = this.__data__,
          t = r(e, n);
      return t < 0 ? void 0 : e[t][1];
    };
  }, function (n, e, t) {
    var r = t(18);

    n.exports = function (n) {
      return r(this.__data__, n) > -1;
    };
  }, function (n, e, t) {
    var r = t(18);

    n.exports = function (n, e) {
      var t = this.__data__,
          o = r(t, n);
      return o < 0 ? (++this.size, t.push([n, e])) : t[o][1] = e, this;
    };
  }, function (n, e, t) {
    var r = t(19);

    n.exports = function (n) {
      var e = r(this, n).delete(n);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== n : null === n;
    };
  }, function (n, e, t) {
    var r = t(19);

    n.exports = function (n) {
      return r(this, n).get(n);
    };
  }, function (n, e, t) {
    var r = t(19);

    n.exports = function (n) {
      return r(this, n).has(n);
    };
  }, function (n, e, t) {
    var r = t(19);

    n.exports = function (n, e) {
      var t = r(this, n),
          o = t.size;
      return t.set(n, e), this.size += t.size == o ? 0 : 1, this;
    };
  }, function (n, e, t) {
    var r = t(3);

    n.exports = function () {
      return r.Date.now();
    };
  }, function (n, e, t) {
    var r = t(112),
        o = t(149),
        a = t(56);

    n.exports = function (n) {
      var e = o(n);
      return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (t) {
        return t === n || r(t, n, e);
      };
    };
  }, function (n, e, t) {
    var r = t(46),
        o = t(47),
        a = 1,
        i = 2;

    n.exports = function (n, e, t, u) {
      var c = t.length,
          s = c,
          p = !u;
      if (null == n) return !s;

      for (n = Object(n); c--;) {
        var f = t[c];
        if (p && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
      }

      for (; ++c < s;) {
        var l = (f = t[c])[0],
            g = n[l],
            d = f[1];

        if (p && f[2]) {
          if (void 0 === g && !(l in n)) return !1;
        } else {
          var b = new r();
          if (u) var x = u(g, d, l, n, e, b);
          if (!(void 0 === x ? o(d, g, a | i, u, b) : x)) return !1;
        }
      }

      return !0;
    };
  }, function (n, e, t) {
    var r = t(17);

    n.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.__data__,
          t = e.delete(n);
      return this.size = e.size, t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.get(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e, t) {
    var r = t(17),
        o = t(32),
        a = t(30),
        i = 200;

    n.exports = function (n, e) {
      var t = this.__data__;

      if (t instanceof r) {
        var u = t.__data__;
        if (!o || u.length < i - 1) return u.push([n, e]), this.size = ++t.size, this;
        t = this.__data__ = new a(u);
      }

      return t.set(n, e), this.size = t.size, this;
    };
  }, function (n, e, t) {
    var r = t(46),
        o = t(48),
        a = t(123),
        i = t(127),
        u = t(144),
        c = t(2),
        s = t(52),
        p = t(54),
        f = 1,
        l = "[object Arguments]",
        g = "[object Array]",
        d = "[object Object]",
        b = Object.prototype.hasOwnProperty;

    n.exports = function (n, e, t, x, A, v) {
      var h = c(n),
          m = c(e),
          y = h ? g : u(n),
          C = m ? g : u(e),
          k = (y = y == l ? d : y) == d,
          w = (C = C == l ? d : C) == d,
          B = y == C;

      if (B && s(n)) {
        if (!s(e)) return !1;
        h = !0, k = !1;
      }

      if (B && !k) return v || (v = new r()), h || p(n) ? o(n, e, t, x, A, v) : a(n, e, y, t, x, A, v);

      if (!(t & f)) {
        var j = k && b.call(n, "__wrapped__"),
            P = w && b.call(e, "__wrapped__");

        if (j || P) {
          var O = j ? n.value() : n,
              E = P ? e.value() : e;
          return v || (v = new r()), A(O, E, t, x, v);
        }
      }

      return !!B && (v || (v = new r()), i(n, e, t, x, A, v));
    };
  }, function (n, e, t) {
    var r = t(30),
        o = t(120),
        a = t(121);

    function i(n) {
      var e = -1,
          t = null == n ? 0 : n.length;

      for (this.__data__ = new r(); ++e < t;) {
        this.add(n[e]);
      }
    }

    i.prototype.add = i.prototype.push = o, i.prototype.has = a, n.exports = i;
  }, function (n, e) {
    var t = "__lodash_hash_undefined__";

    n.exports = function (n) {
      return this.__data__.set(n, t), this;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return n.has(e);
    };
  }, function (n, e, t) {
    var r = t(14),
        o = t(124),
        a = t(31),
        i = t(48),
        u = t(125),
        c = t(126),
        s = 1,
        p = 2,
        f = "[object Boolean]",
        l = "[object Date]",
        g = "[object Error]",
        d = "[object Map]",
        b = "[object Number]",
        x = "[object RegExp]",
        A = "[object Set]",
        v = "[object String]",
        h = "[object Symbol]",
        m = "[object ArrayBuffer]",
        y = "[object DataView]",
        C = r ? r.prototype : void 0,
        k = C ? C.valueOf : void 0;

    n.exports = function (n, e, t, r, C, w, B) {
      switch (t) {
        case y:
          if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset) return !1;
          n = n.buffer, e = e.buffer;

        case m:
          return !(n.byteLength != e.byteLength || !w(new o(n), new o(e)));

        case f:
        case l:
        case b:
          return a(+n, +e);

        case g:
          return n.name == e.name && n.message == e.message;

        case x:
        case v:
          return n == e + "";

        case d:
          var j = u;

        case A:
          var P = r & s;
          if (j || (j = c), n.size != e.size && !P) return !1;
          var O = B.get(n);
          if (O) return O == e;
          r |= p, B.set(n, e);
          var E = i(j(n), j(e), r, C, w, B);
          return B.delete(n), E;

        case h:
          if (k) return k.call(n) == k.call(e);
      }

      return !1;
    };
  }, function (n, e, t) {
    var r = t(3).Uint8Array;
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
          t = Array(n.size);
      return n.forEach(function (n, r) {
        t[++e] = [r, n];
      }), t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
          t = Array(n.size);
      return n.forEach(function (n) {
        t[++e] = n;
      }), t;
    };
  }, function (n, e, t) {
    var r = t(128),
        o = 1,
        a = Object.prototype.hasOwnProperty;

    n.exports = function (n, e, t, i, u, c) {
      var s = t & o,
          p = r(n),
          f = p.length;
      if (f != r(e).length && !s) return !1;

      for (var l = f; l--;) {
        var g = p[l];
        if (!(s ? g in e : a.call(e, g))) return !1;
      }

      var d = c.get(n);
      if (d && c.get(e)) return d == e;
      var b = !0;
      c.set(n, e), c.set(e, n);

      for (var x = s; ++l < f;) {
        var A = n[g = p[l]],
            v = e[g];
        if (i) var h = s ? i(v, A, g, e, n, c) : i(A, v, g, n, e, c);

        if (!(void 0 === h ? A === v || u(A, v, t, i, c) : h)) {
          b = !1;
          break;
        }

        x || (x = "constructor" == g);
      }

      if (b && !x) {
        var m = n.constructor,
            y = e.constructor;
        m != y && "constructor" in n && "constructor" in e && !("function" == typeof m && m instanceof m && "function" == typeof y && y instanceof y) && (b = !1);
      }

      return c.delete(n), c.delete(e), b;
    };
  }, function (n, e, t) {
    var r = t(129),
        o = t(131),
        a = t(12);

    n.exports = function (n) {
      return r(n, a, o);
    };
  }, function (n, e, t) {
    var r = t(130),
        o = t(2);

    n.exports = function (n, e, t) {
      var a = e(n);
      return o(n) ? a : r(a, t(n));
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = e.length, o = n.length; ++t < r;) {
        n[o + t] = e[t];
      }

      return n;
    };
  }, function (n, e, t) {
    var r = t(50),
        o = t(132),
        a = Object.prototype.propertyIsEnumerable,
        i = Object.getOwnPropertySymbols,
        u = i ? function (n) {
      return null == n ? [] : (n = Object(n), r(i(n), function (e) {
        return a.call(n, e);
      }));
    } : o;
    n.exports = u;
  }, function (n, e) {
    n.exports = function () {
      return [];
    };
  }, function (n, e, t) {
    var r = t(134),
        o = t(51),
        a = t(2),
        i = t(52),
        u = t(33),
        c = t(54),
        s = Object.prototype.hasOwnProperty;

    n.exports = function (n, e) {
      var t = a(n),
          p = !t && o(n),
          f = !t && !p && i(n),
          l = !t && !p && !f && c(n),
          g = t || p || f || l,
          d = g ? r(n.length, String) : [],
          b = d.length;

      for (var x in n) {
        !e && !s.call(n, x) || g && ("length" == x || f && ("offset" == x || "parent" == x) || l && ("buffer" == x || "byteLength" == x || "byteOffset" == x) || u(x, b)) || d.push(x);
      }

      return d;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = Array(n); ++t < n;) {
        r[t] = e(t);
      }

      return r;
    };
  }, function (n, e, t) {
    var r = t(6),
        o = t(7),
        a = "[object Arguments]";

    n.exports = function (n) {
      return o(n) && r(n) == a;
    };
  }, function (n, e) {
    n.exports = function () {
      return !1;
    };
  }, function (n, e, t) {
    var r = t(6),
        o = t(34),
        a = t(7),
        i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, n.exports = function (n) {
      return a(n) && o(n.length) && !!i[r(n)];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return n(e);
      };
    };
  }, function (n, e, t) {
    (function (n) {
      var r = t(40),
          o = e && !e.nodeType && e,
          a = o && "object" == typeof n && n && !n.nodeType && n,
          i = a && a.exports === o && r.process,
          u = function () {
        try {
          var n = a && a.require && a.require("util").types;

          return n || i && i.binding && i.binding("util");
        } catch (n) {}
      }();

      n.exports = u;
    }).call(this, t(53)(n));
  }, function (n, e, t) {
    var r = t(141),
        o = t(142),
        a = Object.prototype.hasOwnProperty;

    n.exports = function (n) {
      if (!r(n)) return o(n);
      var e = [];

      for (var t in Object(n)) {
        a.call(n, t) && "constructor" != t && e.push(t);
      }

      return e;
    };
  }, function (n, e) {
    var t = Object.prototype;

    n.exports = function (n) {
      var e = n && n.constructor;
      return n === ("function" == typeof e && e.prototype || t);
    };
  }, function (n, e, t) {
    var r = t(143)(Object.keys, Object);
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return n(e(t));
      };
    };
  }, function (n, e, t) {
    var r = t(145),
        o = t(32),
        a = t(146),
        i = t(147),
        u = t(148),
        c = t(6),
        s = t(45),
        p = s(r),
        f = s(o),
        l = s(a),
        g = s(i),
        d = s(u),
        b = c;
    (r && "[object DataView]" != b(new r(new ArrayBuffer(1))) || o && "[object Map]" != b(new o()) || a && "[object Promise]" != b(a.resolve()) || i && "[object Set]" != b(new i()) || u && "[object WeakMap]" != b(new u())) && (b = function b(n) {
      var e = c(n),
          t = "[object Object]" == e ? n.constructor : void 0,
          r = t ? s(t) : "";
      if (r) switch (r) {
        case p:
          return "[object DataView]";

        case f:
          return "[object Map]";

        case l:
          return "[object Promise]";

        case g:
          return "[object Set]";

        case d:
          return "[object WeakMap]";
      }
      return e;
    }), n.exports = b;
  }, function (n, e, t) {
    var r = t(9)(t(3), "DataView");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Promise");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Set");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "WeakMap");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(55),
        o = t(12);

    n.exports = function (n) {
      for (var e = o(n), t = e.length; t--;) {
        var a = e[t],
            i = n[a];
        e[t] = [a, i, r(i)];
      }

      return e;
    };
  }, function (n, e, t) {
    var r = t(47),
        o = t(151),
        a = t(154),
        i = t(35),
        u = t(55),
        c = t(56),
        s = t(20),
        p = 1,
        f = 2;

    n.exports = function (n, e) {
      return i(n) && u(e) ? c(s(n), e) : function (t) {
        var i = o(t, n);
        return void 0 === i && i === e ? a(t, n) : r(e, i, p | f);
      };
    };
  }, function (n, e, t) {
    var r = t(57);

    n.exports = function (n, e, t) {
      var o = null == n ? void 0 : r(n, e);
      return void 0 === o ? t : o;
    };
  }, function (n, e, t) {
    var r = t(153),
        o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        a = /\\(\\)?/g,
        i = r(function (n) {
      var e = [];
      return 46 === n.charCodeAt(0) && e.push(""), n.replace(o, function (n, t, r, o) {
        e.push(r ? o.replace(a, "$1") : t || n);
      }), e;
    });
    n.exports = i;
  }, function (n, e, t) {
    var r = t(22),
        o = 500;

    n.exports = function (n) {
      var e = r(n, function (n) {
        return t.size === o && t.clear(), n;
      }),
          t = e.cache;
      return e;
    };
  }, function (n, e, t) {
    var r = t(155),
        o = t(156);

    n.exports = function (n, e) {
      return null != n && o(n, e, r);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return null != n && e in Object(n);
    };
  }, function (n, e, t) {
    var r = t(58),
        o = t(51),
        a = t(2),
        i = t(33),
        u = t(34),
        c = t(20);

    n.exports = function (n, e, t) {
      for (var s = -1, p = (e = r(e, n)).length, f = !1; ++s < p;) {
        var l = c(e[s]);
        if (!(f = null != n && t(n, l))) break;
        n = n[l];
      }

      return f || ++s != p ? f : !!(p = null == n ? 0 : n.length) && u(p) && i(l, p) && (a(n) || o(n));
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n;
    };
  }, function (n, e, t) {
    var r = t(159),
        o = t(160),
        a = t(35),
        i = t(20);

    n.exports = function (n) {
      return a(n) ? r(i(n)) : o(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return null == e ? void 0 : e[n];
      };
    };
  }, function (n, e, t) {
    var r = t(57);

    n.exports = function (n) {
      return function (e) {
        return r(e, n);
      };
    };
  }, function (n, e, t) {
    var r = t(162),
        o = t(12);

    n.exports = function (n) {
      return null == n ? [] : r(n, o(n));
    };
  }, function (n, e, t) {
    var r = t(26);

    n.exports = function (n, e) {
      return r(e, function (e) {
        return n[e];
      });
    };
  }, function (n, e, t) {
    var r = t(21);

    n.exports = function (n, e) {
      var t = [];
      return r(n, function (n, r, o) {
        e(n, r, o) && t.push(n);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(165),
        o = t(12);

    n.exports = function (n, e) {
      return n && r(n, e, o);
    };
  }, function (n, e, t) {
    var r = t(166)();
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      return function (e, t, r) {
        for (var o = -1, a = Object(e), i = r(e), u = i.length; u--;) {
          var c = i[n ? u : ++o];
          if (!1 === t(a[c], c, a)) break;
        }

        return e;
      };
    };
  }, function (n, e, t) {
    var r = t(11);

    n.exports = function (n, e) {
      return function (t, o) {
        if (null == t) return t;
        if (!r(t)) return n(t, o);

        for (var a = t.length, i = e ? a : -1, u = Object(t); (e ? i-- : ++i < a) && !1 !== o(u[i], i, u);) {
          ;
        }

        return t;
      };
    };
  }, function (n, e, t) {
    var r = t(21),
        o = t(11);

    n.exports = function (n, e) {
      var t = -1,
          a = o(n) ? Array(n.length) : [];
      return r(n, function (n, r, o) {
        a[++t] = e(n, r, o);
      }), a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      var o = -1,
          a = null == n ? 0 : n.length;

      for (r && a && (t = n[++o]); ++o < a;) {
        t = e(t, n[o], o, n);
      }

      return t;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r, o) {
      return o(n, function (n, o, a) {
        t = r ? (r = !1, n) : e(t, n, o, a);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(10),
        o = t(11),
        a = t(12);

    n.exports = function (n) {
      return function (e, t, i) {
        var u = Object(e);

        if (!o(e)) {
          var c = r(t, 3);
          e = a(e), t = function t(n) {
            return c(u[n], n, u);
          };
        }

        var s = n(e, t, i);
        return s > -1 ? u[c ? e[s] : s] : void 0;
      };
    };
  }, function (n, e, t) {
    var r = t(21);

    n.exports = function (n, e) {
      var t;
      return r(n, function (n, r, o) {
        return !(t = e(n, r, o));
      }), !!t;
    };
  }, function (n, e, t) {
    var r = t(31),
        o = t(11),
        a = t(33),
        i = t(8);

    n.exports = function (n, e, t) {
      if (!i(t)) return !1;
      var u = typeof e;
      return !!("number" == u ? o(t) && a(e, t.length) : "string" == u && e in t) && r(t[e], n);
    };
  }, function (n, e, t) {
    var r = t(175);

    function o() {}

    function a() {}

    a.resetWarningCache = o, n.exports = function () {
      function n(n, e, t, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function e() {
        return n;
      }

      n.isRequired = n;
      var t = {
        array: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: e,
        element: n,
        elementType: n,
        instanceOf: e,
        node: n,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return t.PropTypes = t, t;
    };
  }, function (n, e, t) {
    n.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (n, e, t) {
    var r = t(177);
    "string" == typeof r && (r = [[n.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    t(180)(r, o);
    r.locals && (n.exports = r.locals);
  }, function (n, e, t) {
    e = n.exports = t(178)(!1);
    var r = t(179)(t(59));
    e.push([n.i, ".flag {\n  width: 16px;\n  height: 11px;\n  background-image: url(" + r + ") !important;\n}\n.flag.margin {\n  margin-right: 8px;\n}\n.flag.ad {\n  background-position: -16px 0;\n}\n.flag.ae {\n  background-position: -32px 0;\n}\n.flag.af {\n  background-position: -48px 0;\n}\n.flag.ag {\n  background-position: -64px 0;\n}\n.flag.ai {\n  background-position: -80px 0;\n}\n.flag.al {\n  background-position: -96px 0;\n}\n.flag.am {\n  background-position: -112px 0;\n}\n.flag.ao {\n  background-position: -128px 0;\n}\n.flag.ar {\n  background-position: -144px 0;\n}\n.flag.as {\n  background-position: -160px 0;\n}\n.flag.at {\n  background-position: -176px 0;\n}\n.flag.au {\n  background-position: -192px 0;\n}\n.flag.aw {\n  background-position: -208px 0;\n}\n.flag.az {\n  background-position: -224px 0;\n}\n.flag.ba {\n  background-position: -240px 0;\n}\n.flag.bb {\n  background-position: 0 -11px;\n}\n.flag.bd {\n  background-position: -16px -11px;\n}\n.flag.be {\n  background-position: -32px -11px;\n}\n.flag.bf {\n  background-position: -48px -11px;\n}\n.flag.bg {\n  background-position: -64px -11px;\n}\n.flag.bh {\n  background-position: -80px -11px;\n}\n.flag.bi {\n  background-position: -96px -11px;\n}\n.flag.bj {\n  background-position: -112px -11px;\n}\n.flag.bm {\n  background-position: -128px -11px;\n}\n.flag.bn {\n  background-position: -144px -11px;\n}\n.flag.bo {\n  background-position: -160px -11px;\n}\n.flag.br {\n  background-position: -176px -11px;\n}\n.flag.bs {\n  background-position: -192px -11px;\n}\n.flag.bt {\n  background-position: -208px -11px;\n}\n.flag.bw {\n  background-position: -224px -11px;\n}\n.flag.by {\n  background-position: -240px -11px;\n}\n.flag.bz {\n  background-position: 0 -22px;\n}\n.flag.ca {\n  background-position: -16px -22px;\n}\n.flag.cd {\n  background-position: -32px -22px;\n}\n.flag.cf {\n  background-position: -48px -22px;\n}\n.flag.cg {\n  background-position: -64px -22px;\n}\n.flag.ch {\n  background-position: -80px -22px;\n}\n.flag.ci {\n  background-position: -96px -22px;\n}\n.flag.ck {\n  background-position: -112px -22px;\n}\n.flag.cl {\n  background-position: -128px -22px;\n}\n.flag.cm {\n  background-position: -144px -22px;\n}\n.flag.cn {\n  background-position: -160px -22px;\n}\n.flag.co {\n  background-position: -176px -22px;\n}\n.flag.cr {\n  background-position: -192px -22px;\n}\n.flag.cu {\n  background-position: -208px -22px;\n}\n.flag.cv {\n  background-position: -224px -22px;\n}\n.flag.cw {\n  background-position: -240px -22px;\n}\n.flag.cy {\n  background-position: 0 -33px;\n}\n.flag.cz {\n  background-position: -16px -33px;\n}\n.flag.de {\n  background-position: -32px -33px;\n}\n.flag.dj {\n  background-position: -48px -33px;\n}\n.flag.dk {\n  background-position: -64px -33px;\n}\n.flag.dm {\n  background-position: -80px -33px;\n}\n.flag.do {\n  background-position: -96px -33px;\n}\n.flag.dz {\n  background-position: -112px -33px;\n}\n.flag.ec {\n  background-position: -128px -33px;\n}\n.flag.ee {\n  background-position: -144px -33px;\n}\n.flag.eg {\n  background-position: -160px -33px;\n}\n.flag.er {\n  background-position: -176px -33px;\n}\n.flag.es {\n  background-position: -192px -33px;\n}\n.flag.et {\n  background-position: -208px -33px;\n}\n.flag.fi {\n  background-position: -224px -33px;\n}\n.flag.fj {\n  background-position: -240px -33px;\n}\n.flag.fk {\n  background-position: 0 -44px;\n}\n.flag.fm {\n  background-position: -16px -44px;\n}\n.flag.fo {\n  background-position: -32px -44px;\n}\n.flag.fr,\n.flag.bl,\n.flag.mf {\n  background-position: -48px -44px;\n}\n.flag.ga {\n  background-position: -64px -44px;\n}\n.flag.gb {\n  background-position: -80px -44px;\n}\n.flag.gd {\n  background-position: -96px -44px;\n}\n.flag.ge {\n  background-position: -112px -44px;\n}\n.flag.gf {\n  background-position: -128px -44px;\n}\n.flag.gh {\n  background-position: -144px -44px;\n}\n.flag.gi {\n  background-position: -160px -44px;\n}\n.flag.gl {\n  background-position: -176px -44px;\n}\n.flag.gm {\n  background-position: -192px -44px;\n}\n.flag.gn {\n  background-position: -208px -44px;\n}\n.flag.gp {\n  background-position: -224px -44px;\n}\n.flag.gq {\n  background-position: -240px -44px;\n}\n.flag.gr {\n  background-position: 0 -55px;\n}\n.flag.gt {\n  background-position: -16px -55px;\n}\n.flag.gu {\n  background-position: -32px -55px;\n}\n.flag.gw {\n  background-position: -48px -55px;\n}\n.flag.gy {\n  background-position: -64px -55px;\n}\n.flag.hk {\n  background-position: -80px -55px;\n}\n.flag.hn {\n  background-position: -96px -55px;\n}\n.flag.hr {\n  background-position: -112px -55px;\n}\n.flag.ht {\n  background-position: -128px -55px;\n}\n.flag.hu {\n  background-position: -144px -55px;\n}\n.flag.id {\n  background-position: -160px -55px;\n}\n.flag.ie {\n  background-position: -176px -55px;\n}\n.flag.il {\n  background-position: -192px -55px;\n}\n.flag.in {\n  background-position: -208px -55px;\n}\n.flag.io {\n  background-position: -224px -55px;\n}\n.flag.iq {\n  background-position: -240px -55px;\n}\n.flag.ir {\n  background-position: 0 -66px;\n}\n.flag.is {\n  background-position: -16px -66px;\n}\n.flag.it {\n  background-position: -32px -66px;\n}\n.flag.jm {\n  background-position: -48px -66px;\n}\n.flag.jo {\n  background-position: -64px -66px;\n}\n.flag.jp {\n  background-position: -80px -66px;\n}\n.flag.ke {\n  background-position: -96px -66px;\n}\n.flag.kg {\n  background-position: -112px -66px;\n}\n.flag.kh {\n  background-position: -128px -66px;\n}\n.flag.ki {\n  background-position: -144px -66px;\n}\n.flag.km {\n  background-position: -160px -66px;\n}\n.flag.kn {\n  background-position: -176px -66px;\n}\n.flag.kp {\n  background-position: -192px -66px;\n}\n.flag.kr {\n  background-position: -208px -66px;\n}\n.flag.kw {\n  background-position: -224px -66px;\n}\n.flag.ky {\n  background-position: -240px -66px;\n}\n.flag.kz {\n  background-position: 0 -77px;\n}\n.flag.la {\n  background-position: -16px -77px;\n}\n.flag.lb {\n  background-position: -32px -77px;\n}\n.flag.lc {\n  background-position: -48px -77px;\n}\n.flag.li {\n  background-position: -64px -77px;\n}\n.flag.lk {\n  background-position: -80px -77px;\n}\n.flag.lr {\n  background-position: -96px -77px;\n}\n.flag.ls {\n  background-position: -112px -77px;\n}\n.flag.lt {\n  background-position: -128px -77px;\n}\n.flag.lu {\n  background-position: -144px -77px;\n}\n.flag.lv {\n  background-position: -160px -77px;\n}\n.flag.ly {\n  background-position: -176px -77px;\n}\n.flag.ma {\n  background-position: -192px -77px;\n}\n.flag.mc {\n  background-position: -208px -77px;\n}\n.flag.md {\n  background-position: -224px -77px;\n}\n.flag.me {\n  background-position: -112px -154px;\n  height: 12px;\n}\n.flag.mg {\n  background-position: 0 -88px;\n}\n.flag.mh {\n  background-position: -16px -88px;\n}\n.flag.mk {\n  background-position: -32px -88px;\n}\n.flag.ml {\n  background-position: -48px -88px;\n}\n.flag.mm {\n  background-position: -64px -88px;\n}\n.flag.mn {\n  background-position: -80px -88px;\n}\n.flag.mo {\n  background-position: -96px -88px;\n}\n.flag.mp {\n  background-position: -112px -88px;\n}\n.flag.mq {\n  background-position: -128px -88px;\n}\n.flag.mr {\n  background-position: -144px -88px;\n}\n.flag.ms {\n  background-position: -160px -88px;\n}\n.flag.mt {\n  background-position: -176px -88px;\n}\n.flag.mu {\n  background-position: -192px -88px;\n}\n.flag.mv {\n  background-position: -208px -88px;\n}\n.flag.mw {\n  background-position: -224px -88px;\n}\n.flag.mx {\n  background-position: -240px -88px;\n}\n.flag.my {\n  background-position: 0 -99px;\n}\n.flag.mz {\n  background-position: -16px -99px;\n}\n.flag.na {\n  background-position: -32px -99px;\n}\n.flag.nc {\n  background-position: -48px -99px;\n}\n.flag.ne {\n  background-position: -64px -99px;\n}\n.flag.nf {\n  background-position: -80px -99px;\n}\n.flag.ng {\n  background-position: -96px -99px;\n}\n.flag.ni {\n  background-position: -112px -99px;\n}\n.flag.nl,\n.flag.bq {\n  background-position: -128px -99px;\n}\n.flag.no {\n  background-position: -144px -99px;\n}\n.flag.np {\n  background-position: -160px -99px;\n}\n.flag.nr {\n  background-position: -176px -99px;\n}\n.flag.nu {\n  background-position: -192px -99px;\n}\n.flag.nz {\n  background-position: -208px -99px;\n}\n.flag.om {\n  background-position: -224px -99px;\n}\n.flag.pa {\n  background-position: -240px -99px;\n}\n.flag.pe {\n  background-position: 0 -110px;\n}\n.flag.pf {\n  background-position: -16px -110px;\n}\n.flag.pg {\n  background-position: -32px -110px;\n}\n.flag.ph {\n  background-position: -48px -110px;\n}\n.flag.pk {\n  background-position: -64px -110px;\n}\n.flag.pl {\n  background-position: -80px -110px;\n}\n.flag.pm {\n  background-position: -96px -110px;\n}\n.flag.pr {\n  background-position: -112px -110px;\n}\n.flag.ps {\n  background-position: -128px -110px;\n}\n.flag.pt {\n  background-position: -144px -110px;\n}\n.flag.pw {\n  background-position: -160px -110px;\n}\n.flag.py {\n  background-position: -176px -110px;\n}\n.flag.qa {\n  background-position: -192px -110px;\n}\n.flag.re {\n  background-position: -208px -110px;\n}\n.flag.ro {\n  background-position: -224px -110px;\n}\n.flag.rs {\n  background-position: -240px -110px;\n}\n.flag.ru {\n  background-position: 0 -121px;\n}\n.flag.rw {\n  background-position: -16px -121px;\n}\n.flag.sa {\n  background-position: -32px -121px;\n}\n.flag.sb {\n  background-position: -48px -121px;\n}\n.flag.sc {\n  background-position: -64px -121px;\n}\n.flag.sd {\n  background-position: -80px -121px;\n}\n.flag.se {\n  background-position: -96px -121px;\n}\n.flag.sg {\n  background-position: -112px -121px;\n}\n.flag.sh {\n  background-position: -128px -121px;\n}\n.flag.si {\n  background-position: -144px -121px;\n}\n.flag.sk {\n  background-position: -160px -121px;\n}\n.flag.sl {\n  background-position: -176px -121px;\n}\n.flag.sm {\n  background-position: -192px -121px;\n}\n.flag.sn {\n  background-position: -208px -121px;\n}\n.flag.so {\n  background-position: -224px -121px;\n}\n.flag.sr {\n  background-position: -240px -121px;\n}\n.flag.ss {\n  background-position: 0 -132px;\n}\n.flag.st {\n  background-position: -16px -132px;\n}\n.flag.sv {\n  background-position: -32px -132px;\n}\n.flag.sx {\n  background-position: -48px -132px;\n}\n.flag.sy {\n  background-position: -64px -132px;\n}\n.flag.sz {\n  background-position: -80px -132px;\n}\n.flag.tc {\n  background-position: -96px -132px;\n}\n.flag.td {\n  background-position: -112px -132px;\n}\n.flag.tg {\n  background-position: -128px -132px;\n}\n.flag.th {\n  background-position: -144px -132px;\n}\n.flag.tj {\n  background-position: -160px -132px;\n}\n.flag.tk {\n  background-position: -176px -132px;\n}\n.flag.tl {\n  background-position: -192px -132px;\n}\n.flag.tm {\n  background-position: -208px -132px;\n}\n.flag.tn {\n  background-position: -224px -132px;\n}\n.flag.to {\n  background-position: -240px -132px;\n}\n.flag.tr {\n  background-position: 0 -143px;\n}\n.flag.tt {\n  background-position: -16px -143px;\n}\n.flag.tv {\n  background-position: -32px -143px;\n}\n.flag.tw {\n  background-position: -48px -143px;\n}\n.flag.tz {\n  background-position: -64px -143px;\n}\n.flag.ua {\n  background-position: -80px -143px;\n}\n.flag.ug {\n  background-position: -96px -143px;\n}\n.flag.us {\n  background-position: -112px -143px;\n}\n.flag.uy {\n  background-position: -128px -143px;\n}\n.flag.uz {\n  background-position: -144px -143px;\n}\n.flag.va {\n  background-position: -160px -143px;\n}\n.flag.vc {\n  background-position: -176px -143px;\n}\n.flag.ve {\n  background-position: -192px -143px;\n}\n.flag.vg {\n  background-position: -208px -143px;\n}\n.flag.vi {\n  background-position: -224px -143px;\n}\n.flag.vn {\n  background-position: -240px -143px;\n}\n.flag.vu {\n  background-position: 0 -154px;\n}\n.flag.wf {\n  background-position: -16px -154px;\n}\n.flag.ws {\n  background-position: -32px -154px;\n}\n.flag.ye {\n  background-position: -48px -154px;\n}\n.flag.za {\n  background-position: -64px -154px;\n}\n.flag.zm {\n  background-position: -80px -154px;\n}\n.flag.zw {\n  background-position: -96px -154px;\n}\n", ""]);
  }, function (n, e, t) {
    n.exports = function (n) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var t = function (n, e) {
            var t = n[1] || "",
                r = n[3];
            if (!r) return t;

            if (e && "function" == typeof btoa) {
              var o = (i = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(c, " */")),
                  a = r.sources.map(function (n) {
                return "/*# sourceURL=".concat(r.sourceRoot).concat(n, " */");
              });
              return [t].concat(a).concat([o]).join("\n");
            }

            var i, u, c;
            return [t].join("\n");
          }(e, n);

          return e[2] ? "@media ".concat(e[2], "{").concat(t, "}") : t;
        }).join("");
      }, e.i = function (n, t) {
        "string" == typeof n && (n = [[null, n, ""]]);

        for (var r = {}, o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (r[a] = !0);
        }

        for (var i = 0; i < n.length; i++) {
          var u = n[i];
          null != u[0] && r[u[0]] || (t && !u[2] ? u[2] = t : t && (u[2] = "(".concat(u[2], ") and (").concat(t, ")")), e.push(u));
        }
      }, e;
    };
  }, function (n, e, t) {
    n.exports = function (n, e) {
      return "string" != typeof (n = n.__esModule ? n.default : n) ? n : (/^['"].*['"]$/.test(n) && (n = n.slice(1, -1)), /["'() \t\n]/.test(n) || e ? '"'.concat(n.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : n);
    };
  }, function (n, e, t) {
    var r,
        o,
        a = {},
        i = (r = function r() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === o && (o = r.apply(this, arguments)), o;
    }),
        u = function u(n, e) {
      return e ? e.querySelector(n) : document.querySelector(n);
    },
        c = function (n) {
      var e = {};
      return function (n, t) {
        if ("function" == typeof n) return n();

        if (void 0 === e[n]) {
          var r = u.call(this, n, t);
          if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (n) {
            r = null;
          }
          e[n] = r;
        }

        return e[n];
      };
    }(),
        s = null,
        p = 0,
        f = [],
        l = t(181);

    function g(n, e) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t],
            o = a[r.id];

        if (o) {
          o.refs++;

          for (var i = 0; i < o.parts.length; i++) {
            o.parts[i](r.parts[i]);
          }

          for (; i < r.parts.length; i++) {
            o.parts.push(h(r.parts[i], e));
          }
        } else {
          var u = [];

          for (i = 0; i < r.parts.length; i++) {
            u.push(h(r.parts[i], e));
          }

          a[r.id] = {
            id: r.id,
            refs: 1,
            parts: u
          };
        }
      }
    }

    function d(n, e) {
      for (var t = [], r = {}, o = 0; o < n.length; o++) {
        var a = n[o],
            i = e.base ? a[0] + e.base : a[0],
            u = {
          css: a[1],
          media: a[2],
          sourceMap: a[3]
        };
        r[i] ? r[i].parts.push(u) : t.push(r[i] = {
          id: i,
          parts: [u]
        });
      }

      return t;
    }

    function b(n, e) {
      var t = c(n.insertInto);
      if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = f[f.length - 1];
      if ("top" === n.insertAt) r ? r.nextSibling ? t.insertBefore(e, r.nextSibling) : t.appendChild(e) : t.insertBefore(e, t.firstChild), f.push(e);else if ("bottom" === n.insertAt) t.appendChild(e);else {
        if ("object" != typeof n.insertAt || !n.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = c(n.insertAt.before, t);
        t.insertBefore(e, o);
      }
    }

    function x(n) {
      if (null === n.parentNode) return !1;
      n.parentNode.removeChild(n);
      var e = f.indexOf(n);
      e >= 0 && f.splice(e, 1);
    }

    function A(n) {
      var e = document.createElement("style");

      if (void 0 === n.attrs.type && (n.attrs.type = "text/css"), void 0 === n.attrs.nonce) {
        var r = function () {
          return t.nc;
        }();

        r && (n.attrs.nonce = r);
      }

      return v(e, n.attrs), b(n, e), e;
    }

    function v(n, e) {
      Object.keys(e).forEach(function (t) {
        n.setAttribute(t, e[t]);
      });
    }

    function h(n, e) {
      var t, r, o, a;

      if (e.transform && n.css) {
        if (!(a = "function" == typeof e.transform ? e.transform(n.css) : e.transform.default(n.css))) return function () {};
        n.css = a;
      }

      if (e.singleton) {
        var i = p++;
        t = s || (s = A(e)), r = C.bind(null, t, i, !1), o = C.bind(null, t, i, !0);
      } else n.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (n) {
        var e = document.createElement("link");
        return void 0 === n.attrs.type && (n.attrs.type = "text/css"), n.attrs.rel = "stylesheet", v(e, n.attrs), b(n, e), e;
      }(e), r = w.bind(null, t, e), o = function o() {
        x(t), t.href && URL.revokeObjectURL(t.href);
      }) : (t = A(e), r = k.bind(null, t), o = function o() {
        x(t);
      });

      return r(n), function (e) {
        if (e) {
          if (e.css === n.css && e.media === n.media && e.sourceMap === n.sourceMap) return;
          r(n = e);
        } else o();
      };
    }

    n.exports = function (n, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var t = d(n, e);
      return g(t, e), function (n) {
        for (var r = [], o = 0; o < t.length; o++) {
          var i = t[o];
          (u = a[i.id]).refs--, r.push(u);
        }

        n && g(d(n, e), e);

        for (o = 0; o < r.length; o++) {
          var u;

          if (0 === (u = r[o]).refs) {
            for (var c = 0; c < u.parts.length; c++) {
              u.parts[c]();
            }

            delete a[u.id];
          }
        }
      };
    };

    var m,
        y = (m = [], function (n, e) {
      return m[n] = e, m.filter(Boolean).join("\n");
    });

    function C(n, e, t, r) {
      var o = t ? "" : r.css;
      if (n.styleSheet) n.styleSheet.cssText = y(e, o);else {
        var a = document.createTextNode(o),
            i = n.childNodes;
        i[e] && n.removeChild(i[e]), i.length ? n.insertBefore(a, i[e]) : n.appendChild(a);
      }
    }

    function k(n, e) {
      var t = e.css,
          r = e.media;
      if (r && n.setAttribute("media", r), n.styleSheet) n.styleSheet.cssText = t;else {
        for (; n.firstChild;) {
          n.removeChild(n.firstChild);
        }

        n.appendChild(document.createTextNode(t));
      }
    }

    function w(n, e, t) {
      var r = t.css,
          o = t.sourceMap,
          a = void 0 === e.convertToAbsoluteUrls && o;
      (e.convertToAbsoluteUrls || a) && (r = l(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([r], {
        type: "text/css"
      }),
          u = n.href;
      n.href = URL.createObjectURL(i), u && URL.revokeObjectURL(u);
    }
  }, function (n, e) {
    n.exports = function (n) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!n || "string" != typeof n) return n;
      var t = e.protocol + "//" + e.host,
          r = t + e.pathname.replace(/\/[^\/]*$/, "/");
      return n.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (n, e) {
        var o,
            a = e.trim().replace(/^"(.*)"$/, function (n, e) {
          return e;
        }).replace(/^'(.*)'$/, function (n, e) {
          return e;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? n : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? t + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (n, e, t) {
    t.r(e);

    var r = t(36),
        o = t.n(r),
        a = t(4),
        i = t.n(a),
        u = t(60),
        c = t.n(u),
        s = t(22),
        p = t.n(s),
        f = t(61),
        l = t.n(f),
        g = t(62),
        d = t.n(g),
        b = t(63),
        x = t.n(b),
        A = t(23),
        v = t.n(A),
        h = t(64),
        m = t.n(h),
        y = t(24),
        C = t.n(y),
        k = t(13),
        w = t.n(k),
        B = t(37),
        j = t.n(B),
        P = t(5),
        O = t.n(P),
        E = t(38),
        I = t.n(E),
        D = t(1),
        Q = t.n(D),
        S = t(0),
        T = t.n(S),
        M = t(65),
        R = t.n(M),
        F = t(66),
        U = t.n(F),
        L = t(67),
        N = t.n(L),
        z = t(68),
        K = t.n(z),
        G = t(69),
        H = t.n(G),
        q = t(70),
        Y = t.n(q),
        V = t(71),
        J = t.n(V),
        X = t(72),
        Z = t.n(X),
        W = t(39),
        _ = t.n(W),
        $ = t(73),
        nn = t.n($),
        en = t(74),
        tn = t.n(en);

    function rn(n) {
      return (rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }

    function on() {
      return (on = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }
        }

        return n;
      }).apply(this, arguments);
    }

    function an(n, e) {
      if (null == n) return {};

      var t,
          r,
          o = function (n, e) {
        if (null == n) return {};
        var t,
            r,
            o = {},
            a = Object.keys(n);

        for (r = 0; r < a.length; r++) {
          t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
        }

        return o;
      }(n, e);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);

        for (r = 0; r < a.length; r++) {
          t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
        }
      }

      return o;
    }

    function un(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }

    function cn(n, e) {
      return !e || "object" !== rn(e) && "function" != typeof e ? function (n) {
        if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return n;
      }(n) : e;
    }

    function sn(n) {
      return (sn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }

    function pn(n, e) {
      return (pn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }

    var fn = function (n) {
      function e() {
        return function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), cn(this, sn(e).apply(this, arguments));
      }

      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && pn(n, e);
      }(e, n), t = e, (r = [{
        key: "render",
        value: function value() {
          var n = this.props,
              e = n.name,
              t = n.iso2,
              r = n.dialCode,
              o = n.localization,
              a = n.itemRef,
              i = n.native,
              u = an(n, ["name", "iso2", "dialCode", "localization", "itemRef", "native"]);
          return i ? Q.a.createElement("option", on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t,
            value: t
          }, u), o || e, " ", "+".concat(r)) : Q.a.createElement(tn.a, {
            rootRef: function rootRef(n) {
              return a(n);
            }
          }, Q.a.createElement(nn.a, on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t
          }, u), Q.a.createElement("div", {
            className: "flag ".concat(t, " margin")
          }), Q.a.createElement("span", {
            className: "country-name"
          }, o || e), Q.a.createElement("span", {
            className: "dial-code"
          }, "+".concat(r))));
        }
      }]) && un(t.prototype, r), e;
    }(Q.a.PureComponent);

    fn.propTypes = {
      name: T.a.string.isRequired,
      iso2: T.a.string.isRequired,
      dialCode: T.a.string.isRequired,
      itemRef: T.a.func.isRequired,
      localization: T.a.string,
      native: T.a.bool
    }, fn.defaultProps = {
      localization: null,
      native: !1
    };
    var ln = fn;
    t(176), t(59);

    function gn(n) {
      return (gn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }

    function dn() {
      return (dn = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];

          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }
        }

        return n;
      }).apply(this, arguments);
    }

    function bn(n, e) {
      var t = Object.keys(n);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }

      return t;
    }

    function xn(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {};
        e % 2 ? bn(t, !0).forEach(function (e) {
          Cn(n, e, t[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : bn(t).forEach(function (e) {
          Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
        });
      }

      return n;
    }

    function An(n, e) {
      if (null == n) return {};

      var t,
          r,
          o = function (n, e) {
        if (null == n) return {};
        var t,
            r,
            o = {},
            a = Object.keys(n);

        for (r = 0; r < a.length; r++) {
          t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
        }

        return o;
      }(n, e);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);

        for (r = 0; r < a.length; r++) {
          t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
        }
      }

      return o;
    }

    function vn(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }

    function hn(n) {
      return (hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }

    function mn(n) {
      if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }

    function yn(n, e) {
      return (yn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }

    function Cn(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }

    var kn = function (n) {
      function e(n) {
        var t;
        !function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), t = function (n, e) {
          return !e || "object" !== gn(e) && "function" != typeof e ? mn(n) : e;
        }(this, hn(e).call(this, n)), Cn(mn(t), "flags", {}), Cn(mn(t), "guessSelectedCountry", p()(function (n, e, r) {
          var o = O()(e, {
            iso2: r
          }) || {};
          if ("" === c()(n)) return o;
          var a = j()(e, function (e, t) {
            if (i()(n, t.dialCode)) {
              if (t.dialCode.length > e.dialCode.length) return t;
              if (t.dialCode.length === e.dialCode.length && t.priority < e.priority) return t;
            }

            return e;
          }, {
            dialCode: "",
            priority: 10001
          }, mn(t));
          return a.name ? a : o;
        })), Cn(mn(t), "getProbableCandidate", p()(function (n) {
          if (!n || 0 === n.length) return null;
          var e = t.state.onlyCountries;
          return C()(e, function (e) {
            return i()(e.name.toLowerCase(), n.toLowerCase());
          }, mn(t))[0];
        })), Cn(mn(t), "getOnlyCountries", function (n, e) {
          return 0 === n.length ? e : e.filter(function (e) {
            return n.some(function (n) {
              return n === e.iso2;
            });
          });
        }), Cn(mn(t), "excludeCountries", function (n, e) {
          return 0 === e.length ? n : C()(n, function (n) {
            return !m()(e, n.iso2);
          });
        }), Cn(mn(t), "filterRegions", function (n, e) {
          if ("string" == typeof n) {
            var t = n;
            return e.filter(function (n) {
              return n.regions.some(function (n) {
                return n === t;
              });
            });
          }

          return e.filter(function (e) {
            return n.map(function (n) {
              return e.regions.some(function (e) {
                return e === n;
              });
            }).some(function (n) {
              return n;
            });
          });
        }), Cn(mn(t), "deleteAreaCodes", function (n) {
          return n.filter(function (n) {
            return !0 !== n.isAreaCode;
          });
        }), Cn(mn(t), "updateDefaultCountry", function (n) {
          var e = t.state.onlyCountries,
              r = t.props.disableCountryCode,
              o = O()(e, {
            iso2: n
          });
          t.setState({
            defaultCountry: n,
            selectedCountry: o,
            formattedNumber: r ? "" : "+".concat(o.dialCode)
          });
        }), Cn(mn(t), "scrollTo", function (n) {
          if (n) {
            var e = t.dropdownContainerRef;
            e && document.body && (e.scrollTop = n.offsetTop);
          }
        }), Cn(mn(t), "formatNumber", function (n, e) {
          var r,
              o = t.props,
              a = o.disableCountryCode,
              i = o.enableLongNumbers,
              u = o.autoFormat;
          if (a && e ? ((r = e.split(" ")).shift(), r = r.join(" ")) : r = e, !n || 0 === n.length) return a ? "" : "+";
          if (n && n.length < 2 || !r || !u) return a ? n : "+".concat(n);
          var c,
              s = j()(r, function (n, e) {
            return 0 === n.remainingText.length ? n : "." !== e ? {
              formattedText: n.formattedText + e,
              remainingText: n.remainingText
            } : {
              formattedText: n.formattedText + x()(n.remainingText),
              remainingText: d()(n.remainingText)
            };
          }, {
            formattedText: "",
            remainingText: n.split("")
          });
          return (c = i ? s.formattedText + s.remainingText.join("") : s.formattedText).includes("(") && !c.includes(")") && (c += ")"), c;
        }), Cn(mn(t), "cursorToEnd", function () {
          var n = t.props.isModernBrowser,
              e = t.inputRef;

          if (e.focus(), n) {
            var r = e.value.length;
            e.setSelectionRange(r, r);
          }
        }), Cn(mn(t), "getElement", function (n) {
          return t.flags["flag_no_".concat(n)];
        }), Cn(mn(t), "getCountryData", function () {
          var n = t.state.selectedCountry;
          return n ? {
            name: n.name || "",
            dialCode: n.dialCode || "",
            countryCode: n.iso2 || ""
          } : {};
        }), Cn(mn(t), "handleInput", function (n) {
          var e = t.state,
              r = e.selectedCountry,
              o = e.freezeSelection,
              a = t.state,
              i = a.selectedCountry,
              u = a.formattedNumber,
              c = a.onlyCountries,
              s = a.defaultCountry,
              p = t.props,
              f = p.disableCountryCode,
              l = p.countryCodeEditable,
              g = p.isModernBrowser,
              d = p.onChange,
              b = f ? "" : "+";

          if (!l) {
            var x = "+".concat(r.dialCode);
            if (n.target.value.length < x.length) return;
          }

          if (!(n.target.value.replace(/\D/g, "").length > 15) && n.target.value !== u) {
            if (n.preventDefault ? n.preventDefault() : n.returnValue = !1, n.target.value.length > 0) {
              var A = n.target.value.replace(/\D/g, "");
              (!o || i.dialCode.length > A.length) && (r = t.guessSelectedCountry(A.substring(0, 6), c, s), o = !1), b = t.formatNumber(A, r.format);
            }

            var v = n.target.selectionStart,
                h = b.length - u.length;
            t.setState({
              formattedNumber: b,
              freezeSelection: o,
              selectedCountry: r.dialCode ? r : i
            }, function () {
              g && (h > 0 && (v -= h), ")" === b.charAt(b.length - 1) ? t.inputRef.setSelectionRange(b.length - 1, b.length - 1) : v > 0 && u.length >= b.length && t.inputRef.setSelectionRange(v, v));
              d && d(b, t.getCountryData());
            });
          }
        }), Cn(mn(t), "handleRefInput", function (n) {
          var e,
              r = t.props,
              o = r.inputRef,
              a = r.InputProps;
          t.inputRef = n, o ? e = o : a && a.ref && (e = a.ref), e && ("function" == typeof e ? e(n) : e.current = n);
        }), Cn(mn(t), "handleInputClick", function (n) {
          var e = t.props.onClick;
          e && e(n, t.getCountryData());
        }), Cn(mn(t), "handleFlagItemClick", function (n) {
          var e = t.state,
              r = e.formattedNumber,
              a = e.selectedCountry,
              i = e.onlyCountries,
              u = t.props.onChange,
              c = a,
              s = o()(n) ? O()(i, function (e) {
            return e.iso2 === n;
          }) : O()(i, n),
              p = r.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""),
              f = p.length > 1 ? p.replace(c.dialCode, s.dialCode) : s.dialCode,
              l = t.formatNumber(f.replace(/\D/g, ""), s.format);
          t.setState({
            anchorEl: null,
            selectedCountry: s,
            freezeSelection: !0,
            formattedNumber: l
          }, function () {
            t.cursorToEnd(), u && u(l, t.getCountryData());
          });
        }), Cn(mn(t), "handleInputFocus", function (n) {
          var e = t.state.selectedCountry,
              r = t.props,
              o = r.disableCountryCode,
              a = r.onFocus;
          t.inputRef && "+" === t.inputRef.value && e && !o && t.setState({
            formattedNumber: "+".concat(e.dialCode)
          }, function () {
            return setTimeout(t.cursorToEnd, 10);
          }), t.setState({
            placeholder: ""
          }), a && a(n, t.getCountryData()), setTimeout(t.cursorToEnd, 10);
        }), Cn(mn(t), "handleInputBlur", function (n) {
          var e = t.props,
              r = e.placeholder,
              o = e.onBlur;
          n.target.value || t.setState({
            placeholder: r
          }), o && o(n, t.getCountryData());
        }), Cn(mn(t), "getHighlightCountryIndex", function (n) {
          var e = t.state,
              r = e.highlightCountryIndex,
              o = e.onlyCountries,
              a = e.preferredCountries,
              i = r + n;
          return i < 0 || i >= o.length + a.length ? i - n : i;
        }), Cn(mn(t), "searchCountry", function () {
          var n = t.state,
              e = n.queryString,
              r = n.onlyCountries,
              o = n.preferredCountries,
              a = t.getProbableCandidate(e) || r[0],
              i = v()(r, a) + o.length;
          t.scrollTo(t.getElement(i), !0), t.setState({
            queryString: "",
            highlightCountryIndex: i
          });
        }), Cn(mn(t), "handleKeydown", function (n) {
          var e = t.state,
              r = e.anchorEl,
              o = e.highlightCountryIndex,
              a = e.preferredCountries,
              i = e.onlyCountries,
              u = e.queryString,
              c = e.debouncedQueryStingSearcher,
              s = t.props,
              p = s.keys,
              f = s.disabled;

          if (r && !f) {
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;

            var l = function l(n) {
              t.setState({
                highlightCountryIndex: t.getHighlightCountryIndex(n)
              }, function () {
                t.scrollTo(t.getElement(o + a.length), !0);
              });
            };

            switch (n.which) {
              case p.DOWN:
                l(1);
                break;

              case p.UP:
                l(-1);
                break;

              case p.ENTER:
                t.handleFlagItemClick(i[o], n);
                break;

              case p.ESC:
                t.setState({
                  anchorEl: null
                }, t.cursorToEnd);
                break;

              default:
                (n.which >= p.A && n.which <= p.Z || n.which === p.SPACE) && t.setState({
                  queryString: u + String.fromCharCode(n.which)
                }, c);
            }
          }
        }), Cn(mn(t), "handleInputKeyDown", function (n) {
          var e = t.props,
              r = e.keys,
              o = e.onEnterKeyPress,
              a = e.onKeyDown;
          n.which === r.ENTER && o && o(n), a && a(n);
        }), Cn(mn(t), "checkIfValid", function () {
          var n = t.state.formattedNumber;
          return (0, t.props.isValid)(n.replace(/\D/g, ""));
        }), Cn(mn(t), "updateFormattedNumber", function (n) {
          var e,
              r = t.state,
              o = r.onlyCountries,
              a = r.defaultCountry,
              u = t.props.disableCountryCode,
              c = n,
              s = n;
          if (c.startsWith("+")) c = c.replace(/\D/g, ""), e = t.guessSelectedCountry(c.substring(0, 6), o, a), s = t.formatNumber(c, e.format);else {
            var p = (e = O()(o, {
              iso2: a
            })) && !i()(c.replace(/\D/g, ""), e.dialCode) ? e.dialCode : "";
            s = t.formatNumber((u ? "" : p) + c.replace(/\D/g, ""), e ? e.format : void 0);
          }
          t.setState({
            selectedCountry: e,
            formattedNumber: s
          });
        }), Cn(mn(t), "getDropdownProps", function () {
          var n = t.state,
              e = n.selectedCountry,
              r = n.anchorEl,
              o = n.preferredCountries,
              a = n.onlyCountries,
              i = t.props,
              u = i.classes,
              c = i.dropdownClass,
              s = i.localization,
              p = i.disableDropdown,
              f = i.native,
              l = "flag ".concat(e.iso2),
              g = function g(n) {
            return Boolean(e && e.dialCode === n.dialCode);
          };

          return p ? {} : {
            startAdornment: Q.a.createElement(N.a, {
              className: u.positionStart,
              position: "start"
            }, f ? Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(J.a, {
              id: "country-menu",
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              },
              className: u.native,
              classes: {
                root: R()(u.nativeRoot, "native", l),
                select: u.nativeSelect
              },
              onChange: function onChange(n) {
                return t.handleFlagItemClick(n.target.value);
              },
              disableUnderline: !0
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                native: !0
              });
            }), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                native: !0
              });
            }))) : Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(K.a, {
              className: u.flagButton,
              "aria-owns": r ? "country-menu" : null,
              "aria-label": "Select country",
              onClick: function onClick(n) {
                return t.setState({
                  anchorEl: n.currentTarget
                });
              },
              "aria-haspopup": !0
            }, Q.a.createElement("div", {
              className: l
            })), Q.a.createElement(H.a, {
              className: c,
              id: "country-menu",
              anchorEl: r,
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              }
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }), !!o.length && Q.a.createElement(Y.a, null), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }))))
          };
        });
        var r = _.a.allCountries;
        n.disableAreaCodes && (r = t.deleteAreaCodes(r)), n.regions && (r = t.filterRegions(n.regions, r));
        var a,
            u = t.excludeCountries(t.getOnlyCountries(n.onlyCountries, r), n.excludeCountries),
            s = C()(r, function (e) {
          return I()(n.preferredCountries, function (n) {
            return n === e.iso2;
          });
        }),
            f = n.value || "";
        a = f.length > 1 ? t.guessSelectedCountry(f.replace(/\D/g, "").substring(0, 6), u, n.defaultCountry) || 0 : n.defaultCountry && O()(u, {
          iso2: n.defaultCountry
        }) || 0;
        var g = v()(t.allCountries, a),
            b = f.length < 2 && a && !i()(f.replace(/\D/g, ""), a.dialCode) ? a.dialCode : "",
            A = "" === f && 0 === a ? "" : t.formatNumber((n.disableCountryCode ? "" : b) + f.replace(/\D/g, ""), a.name ? a.format : void 0);
        return t.state = {
          formattedNumber: A,
          placeholder: n.placeholder,
          onlyCountries: u,
          preferredCountries: s,
          defaultCountry: n.defaultCountry,
          selectedCountry: a,
          highlightCountryIndex: g,
          queryString: "",
          freezeSelection: !1,
          debouncedQueryStingSearcher: l()(t.searchCountry, 100),
          anchorEl: null
        }, t;
      }

      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && yn(n, e);
      }(e, n), t = e, (r = [{
        key: "componentDidMount",
        value: function value() {
          document.addEventListener && document.addEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(n) {
          var e = n.value,
              t = this.state,
              r = t.defaultCountry,
              o = t.formattedNumber,
              a = this.props,
              i = a.defaultCountry,
              u = a.value;
          i && i !== r && this.updateDefaultCountry(i), "string" == typeof u && u !== e && u !== o && this.updateFormattedNumber(u);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          document.removeEventListener && document.removeEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "render",
        value: function value() {
          var n = this.state,
              e = n.formattedNumber,
              t = n.placeholder,
              r = this.props,
              o = (r.native, r.defaultCountry, r.excludeCountries, r.onlyCountries, r.preferredCountries, r.dropdownClass, r.autoFormat, r.disableAreaCodes, r.isValid, r.disableCountryCode, r.disableDropdown, r.enableLongNumbers, r.countryCodeEditable, r.onEnterKeyPress, r.isModernBrowser, r.classes, r.keys, r.localization, r.placeholder, r.regions, r.onChange, r.value, r.inputClass),
              a = r.error,
              i = r.InputProps,
              u = An(r, ["native", "defaultCountry", "excludeCountries", "onlyCountries", "preferredCountries", "dropdownClass", "autoFormat", "disableAreaCodes", "isValid", "disableCountryCode", "disableDropdown", "enableLongNumbers", "countryCodeEditable", "onEnterKeyPress", "isModernBrowser", "classes", "keys", "localization", "placeholder", "regions", "onChange", "value", "inputClass", "error", "InputProps"]),
              c = this.getDropdownProps();
          return Q.a.createElement(U.a, dn({
            placeholder: t,
            value: e,
            className: o,
            inputRef: this.handleRefInput,
            error: a || !this.checkIfValid(),
            onChange: this.handleInput,
            onClick: this.handleInputClick,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleInputKeyDown,
            type: "tel",
            InputProps: xn({}, c, {}, i)
          }, u));
        }
      }]) && vn(t.prototype, r), e;
    }(Q.a.Component);

    kn.propTypes = {
      classes: T.a.object,
      excludeCountries: T.a.arrayOf(T.a.string),
      onlyCountries: T.a.arrayOf(T.a.string),
      preferredCountries: T.a.arrayOf(T.a.string),
      defaultCountry: T.a.string,
      value: T.a.string,
      placeholder: T.a.string,
      disabled: T.a.bool,
      error: T.a.bool,
      variant: T.a.string,
      native: T.a.bool,
      inputClass: T.a.string,
      dropdownClass: T.a.string,
      InputProps: T.a.object,
      inputProps: T.a.object,
      inputRef: T.a.func,
      autoFormat: T.a.bool,
      disableAreaCodes: T.a.bool,
      disableCountryCode: T.a.bool,
      disableDropdown: T.a.bool,
      enableLongNumbers: T.a.bool,
      countryCodeEditable: T.a.bool,
      regions: T.a.oneOfType([T.a.string, T.a.arrayOf(T.a.string)]),
      localization: T.a.object,
      onChange: T.a.func,
      onFocus: T.a.func,
      onBlur: T.a.func,
      onClick: T.a.func,
      onKeyDown: T.a.func,
      isValid: T.a.func,
      isModernBrowser: T.a.func,
      onEnterKeyPress: T.a.func,
      keys: T.a.object
    }, kn.defaultProps = {
      excludeCountries: [],
      onlyCountries: [],
      preferredCountries: [],
      defaultCountry: "",
      placeholder: "+1 (702) 123-4567",
      disabled: !1,
      error: !1,
      variant: "standard",
      native: !1,
      inputClass: "",
      dropdownClass: "",
      autoFormat: !0,
      disableAreaCodes: !1,
      isValid: function isValid(n) {
        return I()(_.a.allCountries, function (e) {
          return i()(n, e.dialCode) || i()(e.dialCode, n);
        });
      },
      disableCountryCode: !1,
      disableDropdown: !1,
      enableLongNumbers: !1,
      countryCodeEditable: !0,
      regions: "",
      localization: {},
      onEnterKeyPress: function onEnterKeyPress() {},
      onChange: function onChange() {},
      isModernBrowser: function isModernBrowser() {
        return !!document.createElement && Boolean(document.createElement("input").setSelectionRange);
      },
      keys: {
        UP: 38,
        DOWN: 40,
        RIGHT: 39,
        LEFT: 37,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32
      }
    }, kn.displayName = "MuiPhoneNumber";
    var wn = Z()(function () {
      return {
        flagButton: {
          minWidth: 30,
          padding: 0,
          height: 30
        },
        native: {
          width: 30,
          height: 30,
          padding: 8
        },
        nativeRoot: {
          padding: 0,
          "& + svg": {
            display: "none"
          }
        },
        nativeSelect: {
          padding: 0,
          lineHeight: 0,
          height: 11
        },
        positionStart: {
          position: "relative"
        }
      };
    })(kn);
    e.default = wn;
  }]);
});
var MuiPhoneNumber = unwrapExports(dist);
AddContactInfo.propTypes = {
  firstName: string.isRequired,
  lastName: string.isRequired,
  phoneNumber: string.isRequired,
  phoneType: string.isRequired,
  dateOfBirth: string.isRequired,
  countryId: string.isRequired,
  languageId: number,
  securityQuestion: string.isRequired,
  securityAnswer: string.isRequired,
  profileInfoErrors: object$1.isRequired,
  securityQuestions: arrayOf(shape({
    id: number,
    text: string
  })).isRequired,
  attemptedSubmission: bool.isRequired,
  contactChanged: func
};

function AddContactInfo(props) {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      phoneNumber = _useState2[0],
      setPhoneNumber = _useState2[1];

  var inputLabel = useRef(null);
  var securityQuestionLabel = useRef(null);

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      labelWidth = _useState4[0],
      setLabelWidth = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      securityQuestionLabelWidth = _useState6[0],
      setSecurityQuestionLabelWidth = _useState6[1];

  var _useState7 = useState('password'),
      _useState8 = _slicedToArray(_useState7, 2),
      textFieldType = _useState8[0],
      setTextFieldType = _useState8[1];

  React.useEffect(function () {
    setLabelWidth(inputLabel.current.offsetWidth);
    setSecurityQuestionLabelWidth(securityQuestionLabel.current.offsetWidth);
  }, []);

  var toggleVisibility = function toggleVisibility() {
    if (textFieldType === 'text') {
      setTextFieldType('password');
    } else {
      setTextFieldType('text');
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!props.profileInfoErrors.firstName,
    helperText: props.attemptedSubmission && props.profileInfoErrors.firstName,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "first-name",
    inputProps: {
      maxLength: 30
    },
    label: "First Name",
    name: "firstName",
    autoComplete: "given-name",
    autoFocus: true,
    fullWidth: true,
    value: props.firstName,
    onChange: function onChange(event) {
      return props.contactChanged('firstName', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!props.profileInfoErrors.lastName,
    helperText: props.attemptedSubmission && props.profileInfoErrors.lastName,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "last-name",
    inputProps: {
      maxLength: 30
    },
    label: "Last Name",
    name: "lastName",
    autoComplete: "family-name",
    fullWidth: true,
    value: props.lastName,
    onChange: function onChange(event) {
      return props.contactChanged('lastName', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DateOfBirth, {
    helperText: 'Please provide your date of birth to be approved to bid. ' + 'This information will be used to protect you and to verify your identity. ' + 'You must be at least 18 years old to participate in auctions on Proxibid.',
    dateOfBirthErrors: props.attemptedSubmission && props.profileInfoErrors.dateOfBirth ? {
      form: props.profileInfoErrors.dateOfBirth
    } : null,
    date: props.dateOfBirth,
    required: true,
    onChange: function onChange(value) {
      return props.contactChanged('dateOfBirth', value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(MuiPhoneNumber, {
    error: props.attemptedSubmission && !!props.profileInfoErrors.phoneNumber,
    helperText: props.attemptedSubmission && props.profileInfoErrors.phoneNumber,
    required: true,
    className: 'muiPhoneClass',
    fullWidth: true,
    disableAreaCodes: true,
    defaultCountry: 'us',
    onlyCountries: ['ad', 'ae', 'af', 'ag', 'al', 'am', 'ao', 'ar', 'at', 'au', 'az', 'ba', 'bb', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bm', 'bn', 'bo', 'br', 'bs', 'bt', 'bw', 'by', 'bz', 'ca', 'cd', 'cf', 'cg', 'ch', 'ci', 'cl', 'cm', 'cn', 'co', 'cr', 'cu', 'cv', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'do', 'dz', 'ec', 'ee', 'eg', 'eh', 'er', 'es', 'et', 'fi', 'fj', 'fm', 'fr', 'ga', 'gb', 'gd', 'ge', 'gh', 'gm', 'gn', 'gq', 'gr', 'gt', 'gw', 'gy', 'hn', 'hr', 'ht', 'hu', 'id', 'ie', 'il', 'in', 'iq', 'is', 'it', 'jm', 'jo', 'jp', 'ke', 'kg', 'kh', 'ki', 'km', 'kn', 'kp', 'kr', 'kw', 'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'mg', 'mh', 'mk', 'ml', 'mm', 'mn', 'mr', 'mt', 'mu', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'ne', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nz', 'om', 'other', 'pa', 'pe', 'pg', 'ph', 'pk', 'pl', 'pt', 'pw', 'py', 'qa', 'ro', 'rs/me', 'ru', 'rw', 'sa', 'sb', 'sc', 'sd', 'se', 'sg', 'si', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'st', 'sv', 'sz', 'td', 'tg', 'th', 'tj', 'tl', 'tm', 'tn', 'to', 'tr', 'tt', 'tv', 'tw', 'tz', 'ua', 'ug', 'us', 'uy', 'uz', 'va', 'vc', 've', 'vn', 'vu', 'ws', 'ye', 'za', 'zm', 'zw'],
    preferredCountries: ['us'],
    inputProps: {
      autoComplete: 'disabled'
    },
    countryCodeEditable: false,
    variant: 'outlined',
    label: 'Phone Number',
    name: "phoneNumber",
    id: "phone-number",
    value: props.phoneNumber,
    onChange: function onChange(value) {
      return props.contactChanged('phoneNumber', value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    error: props.attemptedSubmission && !!props.profileInfoErrors.phoneType
  }, /*#__PURE__*/React.createElement(InputLabel$1, {
    id: "phone-type-label",
    htmlFor: 'phone-type',
    ref: inputLabel
  }, "Phone Type"), /*#__PURE__*/React.createElement(Select$3, {
    labelid: "phone-type-label",
    id: "phone-type",
    required: true,
    value: props.phoneType,
    labelWidth: labelWidth,
    onChange: function onChange(event) {
      return props.contactChanged('phoneType', event.target.value);
    },
    fullWidth: true,
    "native": true
  }, /*#__PURE__*/React.createElement("option", {
    value: 'Mobile'
  }, "Mobile"), /*#__PURE__*/React.createElement("option", {
    value: 'Home'
  }, "Home"), /*#__PURE__*/React.createElement("option", {
    value: 'Work'
  }, "Work")), props.attemptedSubmission && !!props.profileInfoErrors.phoneType && /*#__PURE__*/React.createElement(FormHelperText, null, props.profileInfoErrors.phoneType))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    error: props.attemptedSubmission && !!props.profileInfoErrors.securityQuestion
  }, /*#__PURE__*/React.createElement(InputLabel$1, {
    id: "security-question-label",
    htmlFor: 'security-question',
    ref: securityQuestionLabel
  }, "Security Question"), /*#__PURE__*/React.createElement(Select$3, {
    labelid: "security-question-label",
    id: "security-question",
    required: true,
    value: props.securityQuestion,
    labelWidth: securityQuestionLabelWidth,
    onChange: function onChange(event) {
      return props.contactChanged('securityQuestion', event.target.value);
    },
    style: {
      width: '100%'
    },
    "native": true
  }, /*#__PURE__*/React.createElement("option", {
    value: '',
    disabled: true
  }), props.securityQuestions.map(function (question) {
    return /*#__PURE__*/React.createElement("option", {
      key: question.id,
      value: question.id
    }, question.text);
  })), props.attemptedSubmission && !!props.profileInfoErrors.securityQuestion && /*#__PURE__*/React.createElement(FormHelperText, null, props.profileInfoErrors.securityQuestion))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!props.profileInfoErrors.securityAnswer,
    helperText: props.attemptedSubmission && props.profileInfoErrors.securityAnswer,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "security-answer",
    inputProps: {
      maxLength: 50
    },
    label: "Security Answer",
    name: "securityAnswer",
    autoComplete: "off",
    InputProps: {
      autoComplete: 'new-password',
      type: textFieldType,
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
        position: 'end'
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: toggleVisibility
      }, textFieldType === 'text' ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
    },
    fullWidth: true,
    value: props.securityAnswer,
    onChange: function onChange(event) {
      return props.contactChanged('securityAnswer', event.target.value);
    }
  }))));
}

ProfileInfo.propTypes = {
  email: string.isRequired,
  submitUrl: string.isRequired,
  securityQuestions: arrayOf(shape({
    id: number,
    text: string
  })).isRequired,
  onSuccess: func,
  countryRegionData: arrayOf(shape({
    id: number,
    name: string,
    countryCode: string,
    states: arrayOf(shape({
      id: number,
      name: string,
      abbreviation: string
    }))
  }))
};

function ProfileInfo(props) {
  var _props$countryRegionD;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      attemptedSubmission = _useState4[0],
      setAttemptedSubmission = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      errorMessage = _useState6[0],
      setErrorMessage = _useState6[1];

  var _useState7 = useState({
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    addressLevel1Id: '',
    addressLevel2: '',
    countryId: ((_props$countryRegionD = props.countryRegionData) === null || _props$countryRegionD === void 0 ? void 0 : _props$countryRegionD.length) > 0 ? '1' : '0',
    postalCode: '',
    dateOfBirth: '',
    phoneNumber: '',
    phoneType: 'Mobile',
    securityQuestion: '',
    securityAnswer: ''
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      profileInfo = _useState8[0],
      setProfileInfo = _useState8[1];

  var _useState9 = useState({}),
      _useState10 = _slicedToArray(_useState9, 2),
      profileInfoErrors = _useState10[0],
      setProfileInfoErrors = _useState10[1];

  useEffect(function () {
    var _props$countryRegionD2;

    if (((_props$countryRegionD2 = props.countryRegionData) === null || _props$countryRegionD2 === void 0 ? void 0 : _props$countryRegionD2.length) > 0) {
      setProfileInfo(_objectSpread2(_objectSpread2({}, profileInfo), {}, {
        countryId: '1'
      }));
    }
  }, [props.countryRegionData]);
  useEffect(function () {
    var validatedProfile = validateProfile(profileInfo);
    setProfileInfoErrors(validatedProfile);

    if (lodash_isempty(validatedProfile)) {
      if (errorMessage) {
        setErrorMessage('');
      }
    } else {
      setErrorMessage('This form contains errors.');
    }
  }, [profileInfo]);

  function handleChange(attributeName, value) {
    setProfileInfo(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, attributeName, value));
    });
  }

  function handleSubmit() {
    return _handleSubmit.apply(this, arguments);
  }

  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var currentIdentity, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setAttemptedSubmission(true);

              if (!lodash_isempty(profileInfoErrors)) {
                _context.next = 19;
                break;
              }

              setErrorMessage('');
              setLoading(true);
              _context.prev = 4;
              _context.next = 7;
              return axiosInstance.get(props.submitUrl, {
                params: {
                  skip401Event: true
                }
              });

            case 7:
              currentIdentity = _context.sent;
              _context.next = 10;
              return axiosInstance.put(props.submitUrl, {
                'address': {
                  'addressTypeId': 2,
                  'city': profileInfo.addressLevel2,
                  'countryId': profileInfo.countryId,
                  'line1': profileInfo.addressLine1,
                  'line2': profileInfo.addressLine2,
                  'stateId': profileInfo.addressLevel1Id,
                  'zipCode': profileInfo.postalCode
                },
                'billingAddress': {
                  'addressTypeId': 1,
                  'city': profileInfo.addressLevel2,
                  'countryId': profileInfo.countryId,
                  'line1': profileInfo.addressLine1,
                  'line2': profileInfo.addressLine2,
                  'stateId': profileInfo.addressLevel1Id,
                  'zipCode': profileInfo.postalCode
                },
                'dateOfBirth': moment(profileInfo.dateOfBirth).format('YYYY-MM-DD'),
                'firstName': profileInfo.firstName,
                'homePhone': profileInfo.phoneType === 'Home' ? profileInfo.phoneNumber : null,
                'lastName': profileInfo.lastName,
                'mobilePhone': profileInfo.phoneType === 'Mobile' ? profileInfo.phoneNumber : null,
                'securityAnswer': profileInfo.securityAnswer,
                'securityQuestionId': profileInfo.securityQuestion,
                'workPhone': profileInfo.phoneType === 'Work' ? profileInfo.phoneNumber : null,
                'email': currentIdentity.data.email,
                'outBidEmailAlert': currentIdentity.data.outBidEmailAlert,
                'outBidSmsAlert': currentIdentity.data.outBidSmsAlert,
                'watchedItemAlert': currentIdentity.data.watchedItemAlert,
                'likeItemAlert': currentIdentity.data.likeItemAlert,
                'eventAlert': currentIdentity.data.eventAlert,
                'remindByEmail': currentIdentity.data.remindByEmail,
                'remindBySms': currentIdentity.data.remindBySms,
                'remindLeadMinutes': currentIdentity.data.remindLeadMinutes,
                'carrierType': currentIdentity.data.carrierType
              });

            case 10:
              response = _context.sent;
              EventService.dispatchEvent(EVENT_LOGIN_UPDATE_DISPLAY_NAME, "".concat(profileInfo.firstName, " ").concat(profileInfo.lastName));
              props.onSuccess(response);
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](4);
              setErrorMessage('Form submission failed.\nYour information has not been saved. Please try again.');

            case 18:
              setLoading(false);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 15]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }

  return /*#__PURE__*/React.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("fieldset", {
    disabled: loading,
    style: {
      border: 'none'
    }
  }, attemptedSubmission && errorMessage && /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, errorMessage), /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(AddContactInfo, {
    firstName: profileInfo.firstName,
    lastName: profileInfo.lastName,
    phoneNumber: profileInfo.phoneNumber,
    phoneType: profileInfo.phoneType,
    dateOfBirth: profileInfo.dateOfBirth,
    countryId: profileInfo.countryId,
    securityQuestion: profileInfo.securityQuestion,
    securityAnswer: profileInfo.securityAnswer,
    contactChanged: handleChange,
    attemptedSubmission: attemptedSubmission,
    profileInfoErrors: profileInfoErrors,
    securityQuestions: props.securityQuestions
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Address, {
    initialAddress: _objectSpread2({}, profileInfo),
    currentAddress: _objectSpread2({}, profileInfo),
    addressChanged: handleChange,
    attemptedSubmission: attemptedSubmission,
    countryRegionData: props.countryRegionData
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    style: {
      marginTop: '1rem',
      width: '100%'
    },
    id: 'update-shipping-info',
    color: 'primary',
    variant: 'contained',
    loading: loading,
    disabled: attemptedSubmission && !lodash_isempty(profileInfoErrors),
    onClick: handleSubmit
  }, "Update Shipping Info")))));
}

function validateContactInfo(profile) {
  var profileErrors = {};
  profileErrors.firstName = validateNotEmpty(profile.firstName, 'First Name is required');
  profileErrors.lastName = validateNotEmpty(profile.lastName, 'Last Name is required');
  profileErrors.emailAddress = validateNotEmpty(profile.emailAddress, 'Email Address is required');
  var hasOnePhone = scrubPhoneNumber(profile.workPhone) || scrubPhoneNumber(profile.homePhone) || scrubPhoneNumber(profile.mobilePhone);

  if (!hasOnePhone) {
    profileErrors.homePhone = 'At least one phone type is required';
    profileErrors.workPhone = 'At least one phone type is required';
    profileErrors.mobilePhone = 'At least one phone type is required';
  }

  profileErrors.dateOfBirth = validateDateOfBirth(profile.dateOfBirth);
  return _objectSpread2({}, lodash_pickby(profileErrors));
}

EditContactInfo.propTypes = {
  initialIdentity: shape({
    firstName: string,
    lastName: string,
    emailAddress: string.isRequired,
    workPhone: string,
    mobilePhone: string,
    homePhone: string,
    faxNumber: string,
    carrierType: string,
    dateOfBirth: string,
    country: string
  }).isRequired,
  currentIdentity: shape({
    firstName: string,
    lastName: string,
    emailAddress: string.isRequired,
    workPhone: string,
    mobilePhone: string,
    homePhone: string,
    faxNumber: string,
    carrierType: string,
    dateOfBirth: string,
    country: string
  }).isRequired,
  mobileCarriers: arrayOf(shape({
    id: string,
    text: string
  })).isRequired,
  attemptedSubmission: bool.isRequired,
  contactChanged: func.isRequired,
  onError: func
};

function EditContactInfo(props) {
  var mobileCarrierLabel = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      mobileCarrierLabelWidth = _useState2[0],
      setMobileCarrierLabelWidth = _useState2[1];

  React.useEffect(function () {
    setMobileCarrierLabelWidth(mobileCarrierLabel.current.offsetWidth);
  }, []);

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      contactInfoErrors = _useState4[0],
      setContactInfoErrors = _useState4[1];

  React.useEffect(function () {
    setContactInfoErrors(validateContactInfo(props.currentIdentity));
  }, [props.currentIdentity]);
  React.useEffect(function () {
    if (props.onError) {
      props.onError(!lodash_isempty(contactInfoErrors));
    }
  }, [contactInfoErrors]);

  function getPhoneNumberInputComponent() {
    if (!props.currentIdentity.country || props.currentIdentity.country === 'USA') {
      return {
        inputComponent: UsaPhoneNumberMask
      };
    } else {
      return {};
    }
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    disabled: !!props.initialIdentity.firstName,
    error: props.attemptedSubmission && !!contactInfoErrors.firstName,
    helperText: props.attemptedSubmission && contactInfoErrors.firstName,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "first-name",
    inputProps: {
      maxLength: 30
    },
    label: "First Name",
    name: "firstName",
    autoComplete: "given-name",
    autoFocus: true,
    fullWidth: true,
    value: props.currentIdentity.firstName || '',
    onChange: function onChange(event) {
      return props.contactChanged('firstName', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    disabled: !!props.initialIdentity.lastName,
    error: props.attemptedSubmission && !!contactInfoErrors.lastName,
    helperText: props.attemptedSubmission && contactInfoErrors.lastName,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "last-name",
    inputProps: {
      maxLength: 30
    },
    label: "Last Name",
    name: "lastName",
    autoComplete: "family-name",
    fullWidth: true,
    value: props.currentIdentity.lastName || '',
    onChange: function onChange(event) {
      return props.contactChanged('lastName', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!contactInfoErrors.emailAddress,
    helperText: props.attemptedSubmission && contactInfoErrors.emailAddress,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "email-address",
    label: "Email",
    name: "emailAddress",
    autoComplete: "email",
    fullWidth: true,
    value: props.currentIdentity.emailAddress,
    onChange: function onChange(event) {
      return props.contactChanged('emailAddress', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DateOfBirth, {
    onChange: function onChange(value) {
      return props.contactChanged('dateOfBirth', value);
    },
    helperText: 'Please provide your date of birth to be approved to bid. ' + 'This information will be used to protect you and to verify your identity. ' + 'You must be at least 18 years old to participate in auctions on Proxibid.',
    dateOfBirthErrors: props.attemptedSubmission && contactInfoErrors.dateOfBirth ? {
      form: contactInfoErrors.dateOfBirth
    } : null,
    disabled: !!props.initialIdentity.dateOfBirth,
    required: true,
    date: props.currentIdentity.dateOfBirth
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!contactInfoErrors.homePhone,
    helperText: props.attemptedSubmission && contactInfoErrors.homePhone,
    variant: "outlined",
    margin: "dense",
    id: "home-phone",
    label: "Home Phone",
    name: "homePhone",
    autoComplete: "homephone",
    fullWidth: true,
    value: props.currentIdentity.homePhone || '',
    onChange: function onChange(event) {
      return props.contactChanged('homePhone', event.target.value);
    },
    InputProps: getPhoneNumberInputComponent(),
    inputProps: {
      maxLength: 20
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!contactInfoErrors.workPhone,
    helperText: props.attemptedSubmission && contactInfoErrors.workPhone,
    variant: "outlined",
    margin: "dense",
    id: "work-phone",
    label: "Work Phone",
    name: "workPhone",
    autoComplete: "workphone",
    fullWidth: true,
    value: props.currentIdentity.workPhone || '',
    onChange: function onChange(event) {
      return props.contactChanged('workPhone', event.target.value);
    },
    InputProps: getPhoneNumberInputComponent(),
    inputProps: {
      maxLength: 20
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!contactInfoErrors.mobilePhone,
    helperText: props.attemptedSubmission && contactInfoErrors.mobilePhone,
    variant: "outlined",
    margin: "dense",
    id: "mobile-phone",
    label: "Mobile Phone",
    name: "mobilePhone",
    autoComplete: "mobilephone",
    fullWidth: true,
    value: props.currentIdentity.mobilePhone || '',
    onChange: function onChange(event) {
      return props.contactChanged('mobilePhone', event.target.value);
    },
    InputProps: getPhoneNumberInputComponent(),
    inputProps: {
      maxLength: 20
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    error: props.attemptedSubmission && !!contactInfoErrors.mobileCarrier
  }, /*#__PURE__*/React.createElement(InputLabel$1, {
    id: "mobile-carrier-label",
    ref: mobileCarrierLabel,
    htmlFor: 'mobile-carrier'
  }, "Mobile Carrier"), /*#__PURE__*/React.createElement(Select$3, {
    labelid: "mobile-carrier-label",
    id: "mobile-carrier",
    value: props.currentIdentity.carrierType || 'NOT_SELECTED',
    labelWidth: mobileCarrierLabelWidth,
    onChange: function onChange(event) {
      return props.contactChanged('carrierType', event.target.value);
    },
    style: {
      width: '100%'
    },
    "native": true
  }, /*#__PURE__*/React.createElement("option", {
    value: 'NOT_SELECTED'
  }, "None"), props.mobileCarriers.map(function (carrier) {
    return /*#__PURE__*/React.createElement("option", {
      key: carrier.id,
      value: carrier.id,
      dangerouslySetInnerHTML: {
        __html: carrier.name
      }
    });
  })), props.attemptedSubmission && !!contactInfoErrors.mobileCarrier && /*#__PURE__*/React.createElement(FormHelperText, null, contactInfoErrors.mobileCarrier))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!contactInfoErrors.faxNumber,
    helperText: props.attemptedSubmission && contactInfoErrors.faxNumber,
    variant: "outlined",
    margin: "dense",
    id: "fax",
    label: "Fax",
    name: "fax",
    autoComplete: "fax",
    fullWidth: true,
    value: props.currentIdentity.faxNumber || '',
    onChange: function onChange(event) {
      return props.contactChanged('faxNumber', event.target.value);
    },
    InputProps: getPhoneNumberInputComponent(),
    inputProps: {
      maxLength: 20
    }
  }))));
}

SecuritySection.propTypes = {
  currentIdentity: shape({
    securityQuestion: string,
    securityAnswer: string
  }).isRequired,
  securityErrors: object$1.isRequired,
  securityInfoChanged: func.isRequired,
  securityQuestions: arrayOf(shape({
    id: number,
    text: string
  })).isRequired,
  attemptedSubmission: bool
};

function SecuritySection(props) {
  var _props$currentIdentit;

  var securityQuestionLabel = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      securityQuestionLabelWidth = _useState2[0],
      setSecurityQuestionLabelWidth = _useState2[1];

  var _useState3 = useState('password'),
      _useState4 = _slicedToArray(_useState3, 2),
      textFieldType = _useState4[0],
      setTextFieldType = _useState4[1];

  React.useEffect(function () {
    setSecurityQuestionLabelWidth(securityQuestionLabel.current.offsetWidth);
  }, []);

  var toggleVisibility = function toggleVisibility() {
    if (textFieldType === 'text') {
      setTextFieldType('password');
    } else {
      setTextFieldType('text');
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense",
    error: props.attemptedSubmission && !!props.securityErrors.securityQuestion
  }, /*#__PURE__*/React.createElement(InputLabel$1, {
    id: "security-question-label",
    ref: securityQuestionLabel,
    htmlFor: 'security-question'
  }, "Security Question"), /*#__PURE__*/React.createElement(Select$3, {
    labelid: "security-question-label",
    id: "security-question",
    required: true,
    value: (_props$currentIdentit = props.currentIdentity.securityQuestion) !== null && _props$currentIdentit !== void 0 ? _props$currentIdentit : '',
    labelWidth: securityQuestionLabelWidth,
    onChange: function onChange(event) {
      return props.securityInfoChanged('securityQuestion', event.target.value);
    },
    style: {
      width: '100%'
    },
    "native": true
  }, /*#__PURE__*/React.createElement("option", {
    value: '',
    disabled: true
  }), props.securityQuestions.map(function (question) {
    return /*#__PURE__*/React.createElement("option", {
      key: question.text,
      value: question.text
    }, question.text);
  })), props.attemptedSubmission && !!props.securityErrors.securityQuestion && /*#__PURE__*/React.createElement(FormHelperText$1, null, props.securityErrors.securityQuestion))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!props.securityErrors.securityAnswer,
    helperText: props.attemptedSubmission && props.securityErrors.securityAnswer,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "security-answer",
    inputProps: {
      maxLength: 50
    },
    label: "Security Answer",
    name: "securityAnswer",
    autoComplete: "off",
    fullWidth: true,
    InputProps: {
      autoComplete: 'new-password',
      type: textFieldType,
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
        position: 'end'
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: toggleVisibility
      }, textFieldType === 'text' ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
    },
    value: props.currentIdentity.securityAnswer,
    onChange: function onChange(event) {
      return props.securityInfoChanged('securityAnswer', event.target.value);
    }
  })));
}

var createAutoCorrectedDatePipe = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t();
  }(commonjsGlobal, function () {
    return function (e) {
      function t(n) {
        if (r[n]) return r[n].exports;
        var o = r[n] = {
          exports: {},
          id: n,
          loaded: !1
        };
        return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
      }

      var r = {};
      return t.m = e, t.c = r, t.p = "", t(0);
    }([function (e, t, r) {
      e.exports = r(1);
    }, function (e, t) {
      function r() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "mm dd yyyy",
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = t.minYear,
            i = void 0 === r ? 1 : r,
            d = t.maxYear,
            u = void 0 === d ? 9999 : d,
            s = e.split(/[^dmyHMS]+/).sort(function (e, t) {
          return o.indexOf(e) - o.indexOf(t);
        });
        return function (t) {
          var r = [],
              o = {
            dd: 31,
            mm: 12,
            yy: 99,
            yyyy: u,
            HH: 23,
            MM: 59,
            SS: 59
          },
              d = {
            dd: 1,
            mm: 1,
            yy: 0,
            yyyy: i,
            HH: 0,
            MM: 0,
            SS: 0
          },
              a = t.split("");
          s.forEach(function (t) {
            var n = e.indexOf(t),
                i = parseInt(o[t].toString().substr(0, 1), 10);
            parseInt(a[n], 10) > i && (a[n + 1] = a[n], a[n] = 0, r.push(n));
          });
          var y = 0,
              f = s.some(function (r) {
            var s = e.indexOf(r),
                a = r.length,
                f = t.substr(s, a).replace(/\D/g, ""),
                p = parseInt(f, 10);
            "mm" === r && (y = p || 0);
            var c = "dd" === r ? n[y] : o[r];

            if ("yyyy" === r && (1 !== i || 9999 !== u)) {
              var l = parseInt(o[r].toString().substring(0, f.length), 10),
                  m = parseInt(d[r].toString().substring(0, f.length), 10);
              return p < m || p > l;
            }

            return p > c || f.length === a && p < d[r];
          });
          return !f && {
            value: a.join(""),
            indexesOfPipedChars: r
          };
        };
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.default = r;
      var n = [31, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
          o = ["yyyy", "yy", "mm", "dd", "HH", "MM", "SS"];
    }]);
  });
});
var createAutoCorrectedDatePipe$1 = unwrapExports(createAutoCorrectedDatePipe);
var createAutoCorrectedDatePipe_1 = createAutoCorrectedDatePipe.createAutoCorrectedDatePipe;
var _excluded$5 = ["inputRef"];
CreditCardExpirationDateMask.propTypes = {
  inputRef: func.isRequired
};

function CreditCardExpirationDateMask(props) {
  var inputRef = props.inputRef,
      other = _objectWithoutProperties(props, _excluded$5);

  var autoCorrectedDatePipe = createAutoCorrectedDatePipe$1('mm-yyyy', {
    minYear: new Date().getFullYear(),
    maxYear: new Date().getFullYear() + 100
  });
  return /*#__PURE__*/React.createElement(MaskedInput, _extends({
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    placeholderChar: "\u2000",
    pipe: autoCorrectedDatePipe,
    placeholder: 'MM/YYYY',
    keepCharPositions: true
  }, other));
}

CreditCardExpirationDateMask.propTypes = {
  inputRef: func.isRequired
};
/*
 * Luhn algorithm implementation in JavaScript
 * Copyright (c) 2009 Nicholas C. Zakas
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

function luhn10(identifier) {
  var sum = 0;
  var alt = false;
  var i = identifier.length - 1;
  var num;

  while (i >= 0) {
    num = parseInt(identifier.charAt(i), 10);

    if (alt) {
      num *= 2;

      if (num > 9) {
        num = num % 10 + 1; // eslint-disable-line no-extra-parens
      }
    }

    alt = !alt;
    sum += num;
    i--;
  }

  return sum % 10 === 0;
}

var luhn10_1 = luhn10;
var cardTypes = {
  visa: {
    niceType: 'Visa',
    type: 'visa',
    patterns: [4],
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
    code: {
      name: 'CVV',
      size: 3
    }
  },
  mastercard: {
    niceType: 'Mastercard',
    type: 'mastercard',
    patterns: [[51, 55], [2221, 2229], [223, 229], [23, 26], [270, 271], 2720],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVC',
      size: 3
    }
  },
  'american-express': {
    niceType: 'American Express',
    type: 'american-express',
    patterns: [34, 37],
    gaps: [4, 10],
    lengths: [15],
    code: {
      name: 'CID',
      size: 4
    }
  },
  'diners-club': {
    niceType: 'Diners Club',
    type: 'diners-club',
    patterns: [[300, 305], 36, 38, 39],
    gaps: [4, 10],
    lengths: [14, 16, 19],
    code: {
      name: 'CVV',
      size: 3
    }
  },
  discover: {
    niceType: 'Discover',
    type: 'discover',
    patterns: [6011, [644, 649], 65],
    gaps: [4, 8, 12],
    lengths: [16, 19],
    code: {
      name: 'CID',
      size: 3
    }
  },
  jcb: {
    niceType: 'JCB',
    type: 'jcb',
    patterns: [2131, 1800, [3528, 3589]],
    gaps: [4, 8, 12],
    lengths: [16, 17, 18, 19],
    code: {
      name: 'CVV',
      size: 3
    }
  },
  unionpay: {
    niceType: 'UnionPay',
    type: 'unionpay',
    patterns: [620, [624, 626], [62100, 62182], [62184, 62187], [62185, 62197], [62200, 62205], [622010, 622999], 622018, [622019, 622999], [62207, 62209], [622126, 622925], [623, 626], 6270, 6272, 6276, [627700, 627779], [627781, 627799], [6282, 6289], 6291, 6292, 810, [8110, 8131], [8132, 8151], [8152, 8163], [8164, 8171]],
    gaps: [4, 8, 12],
    lengths: [14, 15, 16, 17, 18, 19],
    code: {
      name: 'CVN',
      size: 3
    }
  },
  maestro: {
    niceType: 'Maestro',
    type: 'maestro',
    patterns: [493698, [500000, 506698], [506779, 508999], [56, 59], 63, 67, 6],
    gaps: [4, 8, 12],
    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
    code: {
      name: 'CVC',
      size: 3
    }
  },
  elo: {
    niceType: 'Elo',
    type: 'elo',
    patterns: [401178, 401179, 438935, 457631, 457632, 431274, 451416, 457393, 504175, [506699, 506778], [509000, 509999], 627780, 636297, 636368, [650031, 650033], [650035, 650051], [650405, 650439], [650485, 650538], [650541, 650598], [650700, 650718], [650720, 650727], [650901, 650978], [651652, 651679], [655000, 655019], [655021, 655058]],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVE',
      size: 3
    }
  },
  mir: {
    niceType: 'Mir',
    type: 'mir',
    patterns: [[2200, 2204]],
    gaps: [4, 8, 12],
    lengths: [16, 17, 18, 19],
    code: {
      name: 'CVP2',
      size: 3
    }
  },
  hiper: {
    niceType: 'Hiper',
    type: 'hiper',
    patterns: [637095, 637568, 637599, 637609, 637612],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVC',
      size: 3
    }
  },
  hipercard: {
    niceType: 'Hipercard',
    type: 'hipercard',
    patterns: [606282],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
      name: 'CVC',
      size: 3
    }
  }
};
var cardTypes_1 = cardTypes;

function clone(originalObject) {
  var dupe;

  if (!originalObject) {
    return null;
  }

  dupe = JSON.parse(JSON.stringify(originalObject));
  return dupe;
}

var clone_1 = clone;

function hasEnoughResultsToDetermineBestMatch(results) {
  var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
    return result.matchStrength;
  }).length; // if all possible results have a maxStrength property
  // that means the card number is sufficiently long
  // enough to determine conclusively what the type is

  return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
}

function findBestMatch(results) {
  if (!hasEnoughResultsToDetermineBestMatch(results)) {
    return;
  }

  return results.reduce(function (bestMatch, result) {
    // eslint-disable-line consistent-return
    if (!bestMatch) {
      return result;
    } // if the current best match pattern is less specific
    // than this result, set the result as the new best match


    if (bestMatch.matchStrength < result.matchStrength) {
      return result;
    }

    return bestMatch;
  });
}

var findBestMatch_1 = findBestMatch;

function isValidInputType(cardNumber) {
  return typeof cardNumber === 'string' || cardNumber instanceof String;
}

var isValidInputType_1 = isValidInputType; // Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42

function matchesRange(cardNumber, min, max) {
  var maxLengthToCheck = String(min).length;
  var substr = cardNumber.substr(0, maxLengthToCheck);
  var integerRepresentationOfCardNumber = parseInt(substr, 10);
  min = parseInt(String(min).substr(0, substr.length), 10);
  max = parseInt(String(max).substr(0, substr.length), 10);
  return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}

function matchesPattern(cardNumber, pattern) {
  pattern = String(pattern);
  return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}

function matches(cardNumber, pattern) {
  if (Array.isArray(pattern)) {
    return matchesRange(cardNumber, pattern[0], pattern[1]);
  }

  return matchesPattern(cardNumber, pattern);
}

var matches_1 = matches;

function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
  var i, pattern, patternLength, clonedCardConfiguration;

  for (i = 0; i < cardConfiguration.patterns.length; i++) {
    pattern = cardConfiguration.patterns[i];

    if (!matches_1(cardNumber, pattern)) {
      continue;
    }

    clonedCardConfiguration = clone_1(cardConfiguration);

    if (Array.isArray(pattern)) {
      patternLength = String(pattern[0]).length;
    } else {
      patternLength = String(pattern).length;
    }

    if (cardNumber.length >= patternLength) {
      clonedCardConfiguration.matchStrength = patternLength;
    }

    results.push(clonedCardConfiguration);
    break;
  }
}

var addMatchingCardsToResults_1 = addMatchingCardsToResults;
var testOrder;
var customCards = {};
var cardNames = {
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  AMERICAN_EXPRESS: 'american-express',
  DINERS_CLUB: 'diners-club',
  DISCOVER: 'discover',
  JCB: 'jcb',
  UNIONPAY: 'unionpay',
  MAESTRO: 'maestro',
  ELO: 'elo',
  MIR: 'mir',
  HIPER: 'hiper',
  HIPERCARD: 'hipercard'
};
var ORIGINAL_TEST_ORDER = [cardNames.VISA, cardNames.MASTERCARD, cardNames.AMERICAN_EXPRESS, cardNames.DINERS_CLUB, cardNames.DISCOVER, cardNames.JCB, cardNames.UNIONPAY, cardNames.MAESTRO, cardNames.ELO, cardNames.MIR, cardNames.HIPER, cardNames.HIPERCARD];
testOrder = clone_1(ORIGINAL_TEST_ORDER);

function findType(type) {
  return customCards[type] || cardTypes_1[type];
}

function getAllCardTypes() {
  return testOrder.map(function (type) {
    return clone_1(findType(type));
  });
}

function getCardPosition(name, ignoreErrorForNotExisting) {
  var position = testOrder.indexOf(name);

  if (!ignoreErrorForNotExisting && position === -1) {
    throw new Error('"' + name + '" is not a supported card type.');
  }

  return position;
}

function creditCardType(cardNumber) {
  var bestMatch;
  var results = [];

  if (!isValidInputType_1(cardNumber)) {
    return [];
  }

  if (cardNumber.length === 0) {
    return getAllCardTypes();
  }

  testOrder.forEach(function (type) {
    var cardConfiguration = findType(type);
    addMatchingCardsToResults_1(cardNumber, cardConfiguration, results);
  });
  bestMatch = findBestMatch_1(results);

  if (bestMatch) {
    return [bestMatch];
  }

  return results;
}

creditCardType.getTypeInfo = function (type) {
  return clone_1(findType(type));
};

creditCardType.removeCard = function (name) {
  var position = getCardPosition(name);
  testOrder.splice(position, 1);
};

creditCardType.addCard = function (config) {
  var existingCardPosition = getCardPosition(config.type, true);
  customCards[config.type] = config;

  if (existingCardPosition === -1) {
    testOrder.push(config.type);
  }
};

creditCardType.updateCard = function (cardType, updates) {
  var clonedCard;
  var originalObject = customCards[cardType] || cardTypes_1[cardType];

  if (!originalObject) {
    throw new Error('"' + cardType + '" is not a recognized type. Use `addCard` instead.');
  }

  if (updates.type && originalObject.type !== updates.type) {
    throw new Error('Cannot overwrite type parameter.');
  }

  clonedCard = clone_1(originalObject);
  Object.keys(clonedCard).forEach(function (key) {
    if (updates[key]) {
      clonedCard[key] = updates[key];
    }
  });
  customCards[clonedCard.type] = clonedCard;
};

creditCardType.changeOrder = function (name, position) {
  var currentPosition = getCardPosition(name);
  testOrder.splice(currentPosition, 1);
  testOrder.splice(position, 0, name);
};

creditCardType.resetModifications = function () {
  testOrder = clone_1(ORIGINAL_TEST_ORDER);
  customCards = {};
};

creditCardType.types = cardNames;
var creditCardType_1 = creditCardType;

function verification(card, isPotentiallyValid, isValid) {
  return {
    card: card,
    isPotentiallyValid: isPotentiallyValid,
    isValid: isValid
  };
}

function cardNumber(value, options) {
  var potentialTypes, cardType, isPotentiallyValid, isValid, i, maxLength;
  options = options || {};

  if (typeof value === 'number') {
    value = String(value);
  }

  if (typeof value !== 'string') {
    return verification(null, false, false);
  }

  value = value.replace(/\-|\s/g, '');

  if (!/^\d*$/.test(value)) {
    return verification(null, false, false);
  }

  potentialTypes = creditCardType_1(value);

  if (potentialTypes.length === 0) {
    return verification(null, false, false);
  } else if (potentialTypes.length !== 1) {
    return verification(null, true, false);
  }

  cardType = potentialTypes[0];

  if (options.maxLength && value.length > options.maxLength) {
    return verification(cardType, false, false);
  }

  if (cardType.type === creditCardType_1.types.UNIONPAY && options.luhnValidateUnionPay !== true) {
    isValid = true;
  } else {
    isValid = luhn10_1(value);
  }

  maxLength = Math.max.apply(null, cardType.lengths);

  if (options.maxLength) {
    maxLength = Math.min(options.maxLength, maxLength);
  }

  for (i = 0; i < cardType.lengths.length; i++) {
    if (cardType.lengths[i] === value.length) {
      isPotentiallyValid = value.length < maxLength || isValid;
      return verification(cardType, isPotentiallyValid, isValid);
    }
  }

  return verification(cardType, value.length < maxLength, false);
}

var cardNumber_1 = cardNumber;
var DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;

function verification$1(isValid, isPotentiallyValid, isCurrentYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isCurrentYear: isCurrentYear || false
  };
}

function expirationYear(value, maxElapsedYear) {
  var currentFirstTwo, currentYear, firstTwo, len, twoDigitYear, valid, isCurrentYear;
  maxElapsedYear = maxElapsedYear || DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE;

  if (typeof value !== 'string') {
    return verification$1(false, false);
  }

  if (value.replace(/\s/g, '') === '') {
    return verification$1(false, true);
  }

  if (!/^\d*$/.test(value)) {
    return verification$1(false, false);
  }

  len = value.length;

  if (len < 2) {
    return verification$1(false, true);
  }

  currentYear = new Date().getFullYear();

  if (len === 3) {
    // 20x === 20x
    firstTwo = value.slice(0, 2);
    currentFirstTwo = String(currentYear).slice(0, 2);
    return verification$1(false, firstTwo === currentFirstTwo);
  }

  if (len > 4) {
    return verification$1(false, false);
  }

  value = parseInt(value, 10);
  twoDigitYear = Number(String(currentYear).substr(2, 2));

  if (len === 2) {
    isCurrentYear = twoDigitYear === value;
    valid = value >= twoDigitYear && value <= twoDigitYear + maxElapsedYear;
  } else if (len === 4) {
    isCurrentYear = currentYear === value;
    valid = value >= currentYear && value <= currentYear + maxElapsedYear;
  }

  return verification$1(valid, valid, isCurrentYear);
}

var expirationYear_1 = expirationYear; // Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.

var isArray$3 = Array.isArray || function (arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};

function getNumberOfMonthDigitsInDateString(dateString) {
  var firstCharacter = Number(dateString[0]);
  var assumedYear;
  /*
    if the first character in the string starts with `0`,
    we know that the month will be 2 digits.
     '0122' => {month: '01', year: '22'}
  */

  if (firstCharacter === 0) {
    return 2;
  }
  /*
    if the first character in the string starts with
    number greater than 1, it must be a 1 digit month
     '322' => {month: '3', year: '22'}
  */


  if (firstCharacter > 1) {
    return 1;
  }
  /*
    if the first 2 characters make up a number between
    13-19, we know that the month portion must be 1
     '139' => {month: '1', year: '39'}
  */


  if (firstCharacter === 1 && Number(dateString[1]) > 2) {
    return 1;
  }
  /*
    if the first 2 characters make up a number between
    10-12, we check if the year portion would be considered
    valid if we assumed that the month was 1. If it is
    not potentially valid, we assume the month must have
    2 digits.
     '109' => {month: '10', year: '9'}
    '120' => {month: '1', year: '20'} // when checked in the year 2019
    '120' => {month: '12', year: '0'} // when checked in the year 2021
  */


  if (firstCharacter === 1) {
    assumedYear = dateString.substr(1);
    return expirationYear_1(assumedYear).isPotentiallyValid ? 1 : 2;
  }
  /*
    If the length of the value is exactly 5 characters,
    we assume a full year was passed in, meaning the remaining
    single leading digit must be the month value.
     '12202' => {month: '1', year: '2202'}
  */


  if (dateString.length === 5) {
    return 1;
  }
  /*
    If the length of the value is more than five characters,
    we assume a full year was passed in addition to the month
    and therefore the month portion must be 2 digits.
     '112020' => {month: '11', year: '2020'}
  */


  if (dateString.length > 5) {
    return 2;
  }
  /*
    By default, the month value is the first value
  */


  return 1;
}

function parseDate(date) {
  var month, numberOfDigitsInMonth;

  if (/^\d{4}-\d{1,2}$/.test(date)) {
    date = date.split('-').reverse();
  } else if (/\//.test(date)) {
    date = date.split(/\s*\/\s*/g);
  } else if (/\s/.test(date)) {
    date = date.split(/ +/g);
  }

  if (isArray$3(date)) {
    return {
      month: date[0] || '',
      year: date.slice(1).join()
    };
  }

  numberOfDigitsInMonth = getNumberOfMonthDigitsInDateString(date);
  month = date.substr(0, numberOfDigitsInMonth);
  return {
    month: month,
    year: date.substr(month.length)
  };
}

var parseDate_1 = parseDate;

function verification$2(isValid, isPotentiallyValid, isValidForThisYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isValidForThisYear: isValidForThisYear || false
  };
}

function expirationMonth(value) {
  var month, result;
  var currentMonth = new Date().getMonth() + 1;

  if (typeof value !== 'string') {
    return verification$2(false, false);
  }

  if (value.replace(/\s/g, '') === '' || value === '0') {
    return verification$2(false, true);
  }

  if (!/^\d*$/.test(value)) {
    return verification$2(false, false);
  }

  month = parseInt(value, 10);

  if (isNaN(value)) {
    return verification$2(false, false);
  }

  result = month > 0 && month < 13;
  return verification$2(result, result, result && month >= currentMonth);
}

var expirationMonth_1 = expirationMonth;

function verification$3(isValid, isPotentiallyValid, month, year) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    month: month,
    year: year
  };
}

function expirationDate(value, maxElapsedYear) {
  var date, monthValid, yearValid, isValidForThisYear;

  if (typeof value === 'string') {
    value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, '$1/$2');
    date = parseDate_1(value);
  } else if (value !== null && typeof value === 'object') {
    date = {
      month: String(value.month),
      year: String(value.year)
    };
  } else {
    return verification$3(false, false, null, null);
  }

  monthValid = expirationMonth_1(date.month);
  yearValid = expirationYear_1(date.year, maxElapsedYear);

  if (monthValid.isValid) {
    if (yearValid.isCurrentYear) {
      isValidForThisYear = monthValid.isValidForThisYear;
      return verification$3(isValidForThisYear, isValidForThisYear, date.month, date.year);
    }

    if (yearValid.isValid) {
      return verification$3(true, true, date.month, date.year);
    }
  }

  if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) {
    return verification$3(false, true, null, null);
  }

  return verification$3(false, false, null, null);
}

var expirationDate_1 = expirationDate;
var DEFAULT_LENGTH = 3;

function includes(array, thing) {
  var i = 0;

  for (; i < array.length; i++) {
    if (thing === array[i]) {
      return true;
    }
  }

  return false;
}

function max(array) {
  var maximum = DEFAULT_LENGTH;
  var i = 0;

  for (; i < array.length; i++) {
    maximum = array[i] > maximum ? array[i] : maximum;
  }

  return maximum;
}

function verification$4(isValid, isPotentiallyValid) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid
  };
}

function cvv(value, maxLength) {
  maxLength = maxLength || DEFAULT_LENGTH;
  maxLength = maxLength instanceof Array ? maxLength : [maxLength];

  if (typeof value !== 'string') {
    return verification$4(false, false);
  }

  if (!/^\d*$/.test(value)) {
    return verification$4(false, false);
  }

  if (includes(maxLength, value.length)) {
    return verification$4(true, true);
  }

  if (value.length < Math.min.apply(null, maxLength)) {
    return verification$4(false, true);
  }

  if (value.length > max(maxLength)) {
    return verification$4(false, false);
  }

  return verification$4(true, true);
}

var cvv_1 = cvv;
var DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;

function verification$5(isValid, isPotentiallyValid) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid
  };
}

function postalCode(value, options) {
  var minLength;
  options = options || {};
  minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;

  if (typeof value !== 'string') {
    return verification$5(false, false);
  } else if (value.length < minLength) {
    return verification$5(false, true);
  }

  return verification$5(true, true);
}

var postalCode_1 = postalCode;
var cardValidator = {
  number: cardNumber_1,
  expirationDate: expirationDate_1,
  expirationMonth: expirationMonth_1,
  expirationYear: expirationYear_1,
  cvv: cvv_1,
  postalCode: postalCode_1,
  creditCardType: creditCardType_1
};

function validateCreditCard(creditCardInfo) {
  var _numberValidation$car, _numberValidation$car2;

  var numberValidation = cardValidator.number(creditCardInfo.cardNumber);
  var creditCardErrors = {};

  if (!creditCardInfo.nameOnCard || creditCardInfo.nameOnCard.trim() === '') {
    creditCardErrors.nameOnCard = 'Name on Card is required';
  }

  if (!creditCardInfo.cardNumber || "".concat(creditCardInfo.cardNumber).trim() === '') {
    creditCardErrors.cardNumber = 'Card Number is required';
  } else if (!numberValidation.isValid) {
    creditCardErrors.cardNumber = 'Card Number is invalid';
  }

  if (!creditCardInfo.securityCode || "".concat(creditCardInfo.securityCode).trim() === '') {
    creditCardErrors.securityCode = 'Security Code is required';
  } else if (!numberValidation.card) {
    creditCardErrors.securityCode = 'Security Code must be a 3 or 4 digit number';
  } else if (creditCardInfo.securityCode.toString().length !== (numberValidation === null || numberValidation === void 0 ? void 0 : (_numberValidation$car = numberValidation.card) === null || _numberValidation$car === void 0 ? void 0 : (_numberValidation$car2 = _numberValidation$car.code) === null || _numberValidation$car2 === void 0 ? void 0 : _numberValidation$car2.size)) {
    var _numberValidation$car3, _numberValidation$car4;

    creditCardErrors.securityCode = 'Security Code must be a ' + (numberValidation === null || numberValidation === void 0 ? void 0 : (_numberValidation$car3 = numberValidation.card) === null || _numberValidation$car3 === void 0 ? void 0 : (_numberValidation$car4 = _numberValidation$car3.code) === null || _numberValidation$car4 === void 0 ? void 0 : _numberValidation$car4.size) + ' digit number';
  }

  if (!creditCardInfo.expirationDate) {
    creditCardErrors.expirationDate = 'Expiration Date is required';
  } else {
    var expirationDate = moment(creditCardInfo.expirationDate, 'MM-YYYY');

    if (!expirationDate.isValid()) {
      creditCardErrors.expirationDate = 'Invalid date';
    } else if (moment().isAfter(expirationDate, 'month')) {
      creditCardErrors.expirationDate = 'Expiration Date must be in the future';
    }
  }

  return _objectSpread2(_objectSpread2({}, creditCardErrors), validateAddress(creditCardInfo));
}

SkipWarning.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  onCancel: func.isRequired
};

function SkipWarning(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onCancel = _ref.onCancel;
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/React.createElement(DialogTitle$1, {
    id: "alert-dialog-title"
  }, 'Skip Credit Card'), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(DialogContentText$1, {
    id: "alert-dialog-description"
  }, "Are you sure you want to skip this step? You will not be able to participate in most auctions without a valid credit card.")), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onCancel,
    color: "primary"
  }, "Yes"), /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "primary",
    autoFocus: true
  }, "No")));
}

AddCreditCardResponseMessage.propTypes = {
  error: string,
  code: string,
  disableForm: func.isRequired
};

function AddCreditCardResponseMessage(props) {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      responseMessage = _useState2[0],
      setResponseMessage = _useState2[1];

  useEffect(function () {
    switch (props.code) {
      case 'FORM_ERROR':
        setResponseMessage('This form contains errors.');
        break;

      case 'MAX_ATTEMPTS':
        setResponseMessage('You have exceeded the maximum number of attempts to add a credit card. Please contact us for further assistance.');
        props.disableForm();
        break;

      default:
        setResponseMessage(props.error || 'Unable to add card.');
        break;
    }
  }, []);
  return /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, responseMessage);
}

function convertCountryIdToCountryCode3(countryId, countryRegionData) {
  if (countryId && countryRegionData) {
    var country = countryRegionData.find(function (country) {
      return country.id + '' === countryId;
    });

    if (!(country !== null && country !== void 0 && country.countryCode3)) {
      return '';
    }

    return country.countryCode3;
  }

  return '';
}

function convertStateIdToAbbreviation(stateId, countryId, countryRegionData) {
  if (countryId && countryRegionData) {
    var country = countryRegionData.find(function (country) {
      return country.id + '' === countryId;
    });

    if (country && country.states) {
      var state = country.states.find(function (state) {
        return state.id + '' === stateId;
      });

      if (state) {
        return state.abbreviation;
      }
    }
  }

  return '';
}

var visa = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22750%22%20height%3D%22471%22%20viewBox%3D%220%200%20750%20471%22%3E%3Cg%20fill-rule%3D%22nonzero%22%20fill%3D%22none%22%3E%3Crect%20fill%3D%22%230E4595%22%20width%3D%22750%22%20height%3D%22471%22%20rx%3D%2240%22%2F%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M278.197%20334.228l33.361-195.763h53.36l-33.385%20195.763zM524.308%20142.688c-10.572-3.966-27.137-8.222-47.823-8.222-52.725%200-89.865%2026.55-90.18%2064.603-.298%2028.13%2026.513%2043.822%2046.753%2053.186%2020.77%209.594%2027.752%2015.714%2027.654%2024.283-.132%2013.121-16.587%2019.116-31.923%2019.116-21.357%200-32.703-2.966-50.226-10.276l-6.876-3.111-7.49%2043.824c12.464%205.464%2035.51%2010.198%2059.438%2010.443%2056.09%200%2092.501-26.246%2092.916-66.882.2-22.268-14.016-39.216-44.8-53.188-18.65-9.055-30.072-15.099-29.951-24.268%200-8.137%209.667-16.839%2030.556-16.839%2017.45-.27%2030.089%203.535%2039.937%207.5l4.781%202.26%207.234-42.43M661.615%20138.465h-41.231c-12.774%200-22.332%203.487-27.942%2016.234l-79.245%20179.404h56.032s9.161-24.123%2011.233-29.418c6.124%200%2060.554.084%2068.337.084%201.596%206.853%206.491%2029.334%206.491%2029.334h49.513l-43.188-195.638zm-65.418%20126.407c4.413-11.279%2021.26-54.723%2021.26-54.723-.316.522%204.38-11.334%207.075-18.684l3.606%2016.879s10.217%2046.728%2012.352%2056.528h-44.293z%22%2F%3E%3Cpath%20d%3D%22M45.879%20138.465l-.682%204.074c21.091%205.106%2039.93%2012.494%2056.422%2021.686l47.346%20169.691%2056.455-.066%2084.004-195.385h-56.522l-52.24%20133.496-5.566-27.129a88.005%2088.005%200%200%200-.823-2.49l-18.166-87.35c-3.23-12.396-12.598-16.095-24.187-16.527H45.879z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
var mastercard = "data:image/svg+xml,%3Csvg%20width%3D%22750%22%20height%3D%22471%22%20viewBox%3D%220%200%20750%20471%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill-rule%3D%22nonzero%22%20fill%3D%22none%22%3E%3Crect%20fill%3D%22%23000%22%20width%3D%22750%22%20height%3D%22471%22%20rx%3D%2240%22%2F%3E%3Cpath%20d%3D%22M221.13%20421.67v-24.85c0-9.53-5.8-15.74-15.32-15.74-5%200-10.35%201.66-14.08%207-2.9-4.56-7-7-13.25-7a14.07%2014.07%200%200%200-12%205.8v-5h-7.87v39.76h7.87v-22.75c0-7%204.14-10.35%209.94-10.35s9.11%203.73%209.11%2010.35v22.78h7.87v-22.78c0-7%204.14-10.35%209.94-10.35s9.11%203.73%209.11%2010.35v22.78h8.68zm129.22-39.35h-14.5v-12H328v12h-8.28v7H328V408c0%209.11%203.31%2014.5%2013.25%2014.5a23.17%2023.17%200%200%200%2010.75-2.9l-2.49-7a13.63%2013.63%200%200%201-7.46%202.07c-4.14%200-6.21-2.49-6.21-6.63V389h14.5v-6.63l.01-.05zm73.72-1.24a12.39%2012.39%200%200%200-10.77%205.8v-5h-7.87v39.76h7.87v-22.33c0-6.63%203.31-10.77%208.7-10.77a24.24%2024.24%200%200%201%205.38.83l2.49-7.46a28%2028%200%200%200-5.8-.83zm-111.41%204.14c-4.14-2.9-9.94-4.14-16.15-4.14-9.94%200-16.15%204.56-16.15%2012.43%200%206.63%204.56%2010.35%2013.25%2011.6l4.14.41c4.56.83%207.46%202.49%207.46%204.56%200%202.9-3.31%205-9.53%205a21.84%2021.84%200%200%201-13.25-4.14l-4.14%206.21c5.8%204.14%2012.84%205%2017%205%2011.6%200%2017.81-5.38%2017.81-12.84%200-7-5-10.35-13.67-11.6l-4.14-.41c-3.73-.41-7-1.66-7-4.14%200-2.9%203.31-5%207.87-5%205%200%209.94%202.07%2012.43%203.31l4.07-6.25zm120.11%2016.57c0%2012%207.87%2020.71%2020.71%2020.71%205.8%200%209.94-1.24%2014.08-4.56l-4.14-6.21a16.74%2016.74%200%200%201-10.35%203.73c-7%200-12.43-5.38-12.43-13.25S446%20389%20453.07%20389a16.74%2016.74%200%200%201%2010.35%203.73l4.14-6.21c-4.14-3.31-8.28-4.56-14.08-4.56-12.43-.83-20.71%207.87-20.71%2019.88v-.05zm-55.5-20.71c-11.6%200-19.47%208.28-19.47%2020.71%200%2012.43%208.28%2020.71%2020.29%2020.71a25.33%2025.33%200%200%200%2016.15-5.38l-4.14-5.8a19.79%2019.79%200%200%201-11.6%204.14c-5.38%200-11.18-3.31-12-10.35h29.41v-3.31c0-12.43-7.46-20.71-18.64-20.71v-.01zm-.41%207.46c5.8%200%209.94%203.73%2010.35%209.94h-21.53c1.24-5.8%205-9.94%2011.18-9.94zm-107.27%2013.25v-19.88h-7.87v5c-2.9-3.73-7-5.8-12.84-5.8-11.18%200-19.47%208.7-19.47%2020.71%200%2012.01%208.28%2020.71%2019.47%2020.71%205.8%200%209.94-2.07%2012.84-5.8v5h7.87v-19.94zm-31.89%200c0-7.46%204.56-13.25%2012.43-13.25%207.46%200%2012%205.8%2012%2013.25%200%207.87-5%2013.25-12%2013.25-7.87.41-12.43-5.8-12.43-13.25zm306.08-20.71a12.39%2012.39%200%200%200-10.77%205.8v-5h-7.87v39.76H533v-22.33c0-6.63%203.31-10.77%208.7-10.77a24.24%2024.24%200%200%201%205.38.83l2.49-7.46a28%2028%200%200%200-5.8-.83h.01zm-30.65%2020.71v-19.88h-7.87v5c-2.9-3.73-7-5.8-12.84-5.8-11.18%200-19.47%208.7-19.47%2020.71%200%2012.01%208.28%2020.71%2019.47%2020.71%205.8%200%209.94-2.07%2012.84-5.8v5h7.87v-19.94zm-31.89%200c0-7.46%204.56-13.25%2012.43-13.25%207.46%200%2012%205.8%2012%2013.25%200%207.87-5%2013.25-12%2013.25-7.87.41-12.43-5.8-12.43-13.25zm111.83%200v-35.62h-7.87v20.71c-2.9-3.73-7-5.8-12.84-5.8-11.18%200-19.47%208.7-19.47%2020.71%200%2012.01%208.28%2020.71%2019.47%2020.71%205.8%200%209.94-2.07%2012.84-5.8v5h7.87v-19.91zm-31.89%200c0-7.46%204.56-13.25%2012.43-13.25%207.46%200%2012%205.8%2012%2013.25%200%207.87-5%2013.25-12%2013.25-7.88.42-12.44-5.79-12.44-13.25h.01z%22%20fill%3D%22%23FFF%22%2F%3E%3Cpath%20fill%3D%22%23FF5F00%22%20d%3D%22M303.55%2080.39h143.72v234.42H303.55z%22%2F%3E%3Cpath%20d%3D%22M318.05%20197.6a149.5%20149.5%200%200%201%2056.74-117.21c-61.128-48.061-148.928-41.075-201.687%2016.048-52.758%2057.123-52.758%20145.2%200%20202.324%2052.759%2057.123%20140.559%2064.11%20201.687%2016.048a149.5%20149.5%200%200%201-56.74-117.21z%22%20fill%3D%22%23EB001B%22%2F%3E%3Cpath%20d%3D%22M616.26%20197.6c.041%2057.047-32.503%20109.106-83.804%20134.056-51.302%2024.95-112.347%2018.408-157.196-16.846a149.43%20149.43%200%200%200%200-234.42c44.85-35.254%20105.894-41.797%20157.196-16.846%2051.3%2024.95%2083.845%2077.01%2083.804%20134.056z%22%20fill%3D%22%23F79E1B%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
var discover = "data:image/svg+xml,%3Csvg%20width%3D%22750%22%20height%3D%22471%22%20viewBox%3D%220%200%20750%20471%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill-rule%3D%22nonzero%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M52.877%200C23.68%200%200%2023.155%200%2051.71v367.58C0%20447.85%2023.672%20471%2052.877%20471h644.246C726.32%20471%20750%20447.845%20750%20419.29V51.71C750%2023.15%20726.328%200%20697.123%200H52.877z%22%20fill%3D%22%234D4D4D%22%2F%3E%3Cpath%20d%3D%22M314.57%20152.198c8.496%200%2015.623%201.733%2024.295%205.912v22.087c-8.215-7.633-15.341-10.828-24.765-10.828-18.523%200-33.09%2014.576-33.09%2033.055%200%2019.488%2014.116%2033.196%2034.008%2033.196%208.955%200%2015.95-3.029%2023.847-10.54v22.098c-8.981%204.02-16.26%205.607-24.765%205.607-30.075%200-53.444-21.935-53.444-50.224%200-27.984%2023.991-50.363%2053.914-50.363zm-93.379.609c11.102%200%2021.26%203.612%2029.754%2010.673l-10.335%2012.86c-5.145-5.48-10.01-7.792-15.927-7.792-8.513%200-14.713%204.606-14.713%2010.667%200%205.198%203.48%207.95%2015.332%2012.118%2022.467%207.808%2029.124%2014.732%2029.124%2030.021%200%2018.633-14.399%2031.602-34.923%2031.602-15.029%200-25.955-5.626-35.055-18.32l12.758-11.68c4.549%208.36%2012.136%2012.837%2021.557%2012.837%208.811%200%2015.334-5.779%2015.334-13.576%200-4.042-1.976-7.507-5.921-9.958-1.987-1.16-5.921-2.89-13.653-5.481-18.55-6.347-24.914-13.132-24.914-26.391%200-15.75%2013.667-27.58%2031.582-27.58zm225.695%201.678h21.575l27.004%2064.645%2027.35-64.645h21.412l-43.744%2098.713h-10.628l-42.969-98.713zm-382.065.148h28.991c32.03%200%2054.359%2019.786%2054.359%2048.19%200%2014.163-6.831%2027.856-18.382%2036.944-9.72%207.67-20.795%2011.11-36.13%2011.11H64.822v-96.244zm92.437%200h19.751v96.245h-19.75v-96.245zm395.899%200h56.011v16.308h-36.275v21.362h34.938v16.3h-34.938v25.98h36.275v16.295h-56.011v-96.245zm69.094%200h29.283c22.78%200%2035.833%2010.397%2035.833%2028.416%200%2014.735-8.187%2024.406-23.064%2027.284l31.873%2040.545h-24.288l-27.336-38.664h-2.575v38.664h-19.726v-96.245zm19.726%2015.159v29.148h5.771c12.612%200%2019.297-5.206%2019.297-14.88%200-9.367-6.686-14.268-18.985-14.268h-6.083zm-557.42%201.149v63.642h5.3c12.763%200%2020.823-2.324%2027.028-7.648%206.83-5.782%2010.94-15.015%2010.94-24.25%200-9.222-4.11-18.18-10.94-23.961-6.523-5.61-14.265-7.783-27.028-7.783h-5.3z%22%20fill%3D%22%23FFF%22%2F%3E%3Cpath%20d%3D%22M399.164%20151.56c29.75%200%2053.867%2022.167%2053.867%2049.552v.031c0%2027.385-24.117%2049.584-53.867%2049.584-29.75%200-53.867-22.199-53.867-49.584v-.03c0-27.386%2024.117-49.554%2053.867-49.554zm350.819%20119.534c-25.048%2017.233-212.574%20140.397-537.264%20199.891h484.387c29.197%200%2052.877-23.154%2052.877-51.71V271.094z%22%20fill%3D%22%23F47216%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
var amex = "data:image/svg+xml,%3Csvg%20width%3D%22750%22%20height%3D%22471%22%20viewBox%3D%220%200%20750%20471%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill-rule%3D%22nonzero%22%20fill%3D%22none%22%3E%3Crect%20fill%3D%22%232557D6%22%20width%3D%22750%22%20height%3D%22471%22%20rx%3D%2240%22%2F%3E%3Cpath%20d%3D%22M.003%20221.185h36.024l8.123-19.51h18.185l8.101%2019.51h70.88V206.27l6.327%2014.98h36.796l6.327-15.202v15.138h176.151l-.082-32.026h3.408c2.386.083%203.083.302%203.083%204.226v27.8h91.106v-7.455c7.349%203.92%2018.779%207.455%2033.819%207.455h38.328l8.203-19.51h18.185l8.021%2019.51h73.86v-18.532l11.186%2018.532h59.187V98.678h-58.576v14.468l-8.202-14.468h-60.105v14.468l-7.532-14.468h-81.188c-13.59%200-25.536%201.889-35.186%207.153v-7.153h-56.026v7.153c-6.14-5.426-14.508-7.153-23.812-7.153H179.908l-13.734%2031.641-14.104-31.641H87.6v14.468l-7.083-14.468H25.534L0%20156.924v64.261h.003zm227.397-17.67h-21.615l-.08-68.794-30.573%2068.793H156.62l-30.652-68.854v68.854H83.084l-8.101-19.592h-43.9L22.9%20203.514H0l37.756-87.837h31.326l35.859%2083.164v-83.164h34.412l27.593%2059.587%2025.347-59.587h35.104v87.837h.003zM67.777%20165.692l-14.43-35.017-14.35%2035.017h28.78zm245.642%2037.821h-70.433v-87.837h70.433v18.291h-49.348v15.833h48.165v18.005H264.07v17.542h49.348v18.166zm99.256-64.18c0%2014.004-9.386%2021.24-14.856%2023.412%204.613%201.748%208.553%204.838%2010.43%207.397%202.976%204.369%203.49%208.271%203.49%2016.116v17.255h-21.266l-.08-11.077c0-5.285.508-12.886-3.328-17.112-3.081-3.09-7.777-3.76-15.368-3.76h-22.633v31.95H327.98v-87.838h48.495c10.775%200%2018.714.283%2025.53%204.207%206.67%203.924%2010.67%209.652%2010.67%2019.45zm-26.652%2013.042c-2.898%201.752-6.324%201.81-10.43%201.81H349.98v-19.51h25.962c3.674%200%207.508.164%209.998%201.584%202.735%201.28%204.427%204.003%204.427%207.765%200%203.84-1.61%206.929-4.344%208.351zm60.466%2051.138h-21.513v-87.837h21.513v87.837zm249.74%200H666.35l-39.964-65.927v65.927h-42.94l-8.204-19.592h-43.799l-7.96%2019.592H498.81c-10.248%200-23.224-2.257-30.572-9.715-7.41-7.458-11.265-17.56-11.265-33.533%200-13.027%202.304-24.936%2011.366-34.347%206.816-7.01%2017.49-10.242%2032.02-10.242h20.412v18.821h-19.984c-7.694%200-12.039%201.14-16.224%205.203-3.594%203.699-6.06%2010.69-6.06%2019.897%200%209.41%201.878%2016.196%205.797%2020.628%203.245%203.476%209.144%204.53%2014.694%204.53h9.469l29.716-69.076h31.592l35.696%2083.081V115.68h32.103l37.062%2061.174V115.68h21.596v87.834zM568.07%20165.693l-14.591-35.017-14.51%2035.017h29.1zM749.956%20343.767c-5.121%207.458-15.101%2011.239-28.611%2011.239h-40.718v-18.84h40.553c4.022%200%206.837-.527%208.532-2.175a7.71%207.71%200%200%200%202.493-5.73c0-2.56-1.024-4.592-2.575-5.81-1.53-1.341-3.757-1.95-7.429-1.95-19.797-.67-44.495.609-44.495-27.194%200-12.743%208.125-26.157%2030.25-26.157h41.998l.002-17.48h-39.022c-11.776%200-20.33%202.808-26.388%207.174v-7.175H626.83c-9.23%200-20.063%202.279-25.187%207.175v-7.175H498.578v7.175c-8.203-5.892-22.043-7.175-28.431-7.175h-67.983v7.175c-6.49-6.258-20.92-7.175-29.716-7.175h-76.085l-17.41%2018.763-16.307-18.763H148.99v122.592h111.516l17.94-19.06%2016.9%2019.06%2068.739.061v-28.838h6.757c9.12.14%2019.878-.226%2029.368-4.31v33.085h56.697v-31.952h2.735c3.49%200%203.834.143%203.834%203.616v28.333H635.71c10.935%200%2022.365-2.787%2028.695-7.845v7.845h54.632c11.369%200%2022.471-1.587%2030.918-5.651v-22.838zm-341.503-47.154c0%2024.406-18.286%2029.445-36.716%2029.445H345.43v29.469h-40.98l-25.962-29.085-26.981%2029.085H167.99v-87.859h84.8l25.941%2028.799%2026.819-28.799h67.371c16.732%200%2035.532%204.613%2035.532%2028.945zm-167.625%2040.434h-51.839v-17.481h46.289V301.64h-46.289v-15.973h52.86l23.062%2025.604-24.083%2025.776zm83.526%2010.06l-32.37-35.788%2032.37-34.651v70.439zm47.873-39.066H344.98v-22.374h27.492c7.612%200%2012.896%203.09%2012.896%2010.773%200%207.598-5.04%2011.601-13.14%2011.601zm142.744-40.373h70.369v18.17h-49.372v15.973h48.167v17.925h-48.167v17.481l49.372.08v18.23h-70.37v-87.859zm-27.054%2047.03c4.693%201.724%208.53%204.816%2010.329%207.375%202.977%204.29%203.408%208.293%203.493%2016.037v17.417H480.57v-10.992c0-5.286.511-13.112-3.408-17.198-3.08-3.147-7.777-3.9-15.468-3.9h-22.533v32.09h-21.186v-87.859h48.678c10.674%200%2018.448.47%2025.369%204.146%206.654%204.004%2010.839%209.488%2010.839%2019.51-.003%2014.024-9.395%2021.18-14.945%2023.373zM476%20303.59c-2.82%201.667-6.308%201.81-10.41%201.81h-25.614v-19.733h25.962c3.754%200%207.51.08%2010.062%201.587%202.732%201.423%204.366%204.144%204.366%207.903%200%203.76-1.634%206.788-4.366%208.433zm190.336%205.597c4.106%204.23%206.306%209.572%206.306%2018.614%200%2018.9-11.858%2027.723-33.122%2027.723h-41.065v-18.84h40.9c4%200%206.836-.527%208.613-2.175%201.45-1.359%202.49-3.333%202.49-5.73%200-2.56-1.125-4.592-2.573-5.81-1.612-1.34-3.836-1.95-7.508-1.95-19.717-.67-44.41.61-44.41-27.193%200-12.744%208.04-26.158%2030.144-26.158h42.269v18.7h-38.677c-3.834%200-6.327.143-8.447%201.587-2.31%201.422-3.166%203.534-3.166%206.32%200%203.315%201.96%205.57%204.613%206.545%202.224.77%204.613.996%208.205.996l11.35.305c11.446.278%2019.303%202.249%2024.078%207.066zM750%20285.667h-38.427c-3.836%200-6.385.143-8.532%201.587-2.224%201.423-3.081%203.534-3.081%206.322%200%203.314%201.878%205.569%204.61%206.544%202.225.77%204.614.996%208.126.996l11.427.304c11.531.284%2019.228%202.258%2023.921%207.072.855.67%201.368%201.422%201.956%202.175v-25z%22%20fill%3D%22%23FFF%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E";
var generic = "data:image/svg+xml,%3Csvg%20width%3D%22750%22%20height%3D%22471%22%20viewBox%3D%220%200%20750%20471%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20fill-rule%3D%22nonzero%22%20fill%3D%22none%22%3E%3Crect%20fill%3D%22%23000C9D%22%20width%3D%22750%22%20height%3D%22471%22%20rx%3D%2240%22%2F%3E%3Crect%20fill%3D%22%239D9400%22%20x%3D%2248.71%22%20y%3D%22153.576%22%20width%3D%22110.324%22%20height%3D%2299.679%22%20rx%3D%2220.323%22%2F%3E%3Cg%20fill%3D%22%23FFF%22%3E%3Cpath%20d%3D%22M78.102%20310.37v-3.795h-5.117v-11.27h-4.198l-.402%2011.27H56.942l10.58-25.07-3.967-1.725-11.673%2027.14v3.45h16.445v9.66h4.658v-9.66h5.117zM97.688%20279.78c-4.025%200-7.878%201.38-11.213%204.6l2.588%202.933c2.645-2.473%205.002-3.68%208.395-3.68%204.197%200%207.532%202.357%207.532%206.727%200%204.773-3.737%206.958-7.532%206.958H95.1l-.575%203.795h3.335c4.658%200%208.223%201.84%208.223%207.532%200%204.945-3.278%208.108-8.855%208.108-3.22%200-6.555-1.323-8.798-3.968l-3.22%202.645c2.99%203.68%207.705%205.233%2012.133%205.233%208.165%200%2013.742-5.175%2013.742-12.018%200-6.152-4.37-9.372-9.027-9.717%204.197-.805%207.762-4.428%207.762-9.2%200-5.405-4.715-9.948-12.132-9.948zM132.165%20279.78c-5.347%200-8.912%201.898-12.075%205.693l3.335%202.53c2.53-2.933%204.658-4.198%208.568-4.198%204.427%200%207.072%202.76%207.072%207.188%200%206.497-3.22%2010.81-18.17%2025.127v3.91h23.518l.575-4.082h-18.63c13.052-11.903%2017.71-17.825%2017.71-25.07%200-6.325-4.428-11.098-11.903-11.098zM180.903%20316.12h-8.28v-35.65h-4.198l-11.73%207.245%202.07%203.393%209.085-5.463v30.475h-9.775v3.91h22.828v-3.91zM250.49%20310.37v-3.795h-5.117v-11.27h-4.198l-.402%2011.27H229.33l10.58-25.07-3.967-1.725-11.673%2027.14v3.45h16.445v9.66h4.658v-9.66h5.117zM270.075%20279.78c-4.025%200-7.877%201.38-11.212%204.6l2.587%202.933c2.645-2.473%205.003-3.68%208.395-3.68%204.198%200%207.533%202.357%207.533%206.727%200%204.773-3.738%206.958-7.533%206.958h-2.357l-.575%203.795h3.335c4.657%200%208.222%201.84%208.222%207.532%200%204.945-3.277%208.108-8.855%208.108-3.22%200-6.555-1.323-8.797-3.968l-3.22%202.645c2.99%203.68%207.705%205.233%2012.132%205.233%208.165%200%2013.743-5.175%2013.743-12.018%200-6.152-4.37-9.372-9.028-9.717%204.198-.805%207.763-4.428%207.763-9.2%200-5.405-4.715-9.948-12.133-9.948zM304.553%20279.78c-5.348%200-8.913%201.898-12.075%205.693l3.335%202.53c2.53-2.933%204.657-4.198%208.567-4.198%204.428%200%207.073%202.76%207.073%207.188%200%206.497-3.22%2010.81-18.17%2025.127v3.91H316.8l.575-4.082h-18.63c13.053-11.903%2017.71-17.825%2017.71-25.07%200-6.325-4.427-11.098-11.902-11.098zM353.29%20316.12h-8.28v-35.65h-4.197l-11.73%207.245%202.07%203.393%209.085-5.463v30.475h-9.775v3.91h22.827v-3.91zM422.878%20310.37v-3.795h-5.118v-11.27h-4.197l-.403%2011.27h-11.442l10.58-25.07-3.968-1.725-11.672%2027.14v3.45h16.445v9.66h4.657v-9.66h5.118zM442.463%20279.78c-4.025%200-7.878%201.38-11.213%204.6l2.588%202.933c2.645-2.473%205.002-3.68%208.395-3.68%204.197%200%207.532%202.357%207.532%206.727%200%204.773-3.737%206.958-7.532%206.958h-2.358l-.575%203.795h3.335c4.658%200%208.223%201.84%208.223%207.532%200%204.945-3.278%208.108-8.855%208.108-3.22%200-6.555-1.323-8.798-3.968l-3.22%202.645c2.99%203.68%207.705%205.233%2012.133%205.233%208.165%200%2013.742-5.175%2013.742-12.018%200-6.152-4.37-9.372-9.027-9.717%204.197-.805%207.762-4.428%207.762-9.2%200-5.405-4.715-9.948-12.132-9.948zM476.94%20279.78c-5.347%200-8.912%201.898-12.075%205.693l3.335%202.53c2.53-2.933%204.658-4.198%208.568-4.198%204.427%200%207.072%202.76%207.072%207.188%200%206.497-3.22%2010.81-18.17%2025.127v3.91h23.518l.575-4.082h-18.63c13.052-11.903%2017.71-17.825%2017.71-25.07%200-6.325-4.428-11.098-11.903-11.098zM525.678%20316.12h-8.28v-35.65H513.2l-11.73%207.245%202.07%203.393%209.085-5.463v30.475h-9.775v3.91h22.828v-3.91zM595.266%20310.37v-3.795h-5.118v-11.27h-4.197l-.403%2011.27h-11.442l10.58-25.07-3.968-1.725-11.672%2027.14v3.45h16.445v9.66h4.657v-9.66h5.118zM614.85%20279.78c-4.024%200-7.877%201.38-11.212%204.6l2.588%202.933c2.645-2.473%205.002-3.68%208.395-3.68%204.197%200%207.532%202.357%207.532%206.727%200%204.773-3.737%206.958-7.532%206.958h-2.358l-.575%203.795h3.335c4.658%200%208.223%201.84%208.223%207.532%200%204.945-3.278%208.108-8.855%208.108-3.22%200-6.555-1.323-8.798-3.968l-3.22%202.645c2.99%203.68%207.705%205.233%2012.133%205.233%208.165%200%2013.742-5.175%2013.742-12.018%200-6.152-4.37-9.372-9.027-9.717%204.197-.805%207.762-4.428%207.762-9.2%200-5.405-4.715-9.948-12.132-9.948zM649.328%20279.78c-5.347%200-8.912%201.898-12.075%205.693l3.335%202.53c2.53-2.933%204.658-4.198%208.568-4.198%204.427%200%207.072%202.76%207.072%207.188%200%206.497-3.22%2010.81-18.17%2025.127v3.91h23.518l.575-4.082h-18.63c13.052-11.903%2017.71-17.825%2017.71-25.07%200-6.325-4.428-11.098-11.903-11.098zM698.066%20316.12h-8.28v-35.65h-4.198l-11.73%207.245%202.07%203.393%209.085-5.463v30.475h-9.775v3.91h22.828v-3.91z%22%2F%3E%3C%2Fg%3E%3Cg%20fill%3D%22%23FFF%22%20fill-opacity%3D%22.784%22%3E%3Cpath%20d%3D%22M55.607%20415.42h6.445v-22.245l-7.012%201.406v-3.594l6.973-1.406h3.945v25.84h6.446v3.32H55.607zM81.075%20415.42h6.446v-22.245l-7.012%201.406v-3.594l6.973-1.406h3.945v25.84h6.445v3.32H81.075zM121.993%20415.42h13.77v3.321h-18.516v-3.32a762.619%20762.619%200%200%201%206.114-6.23c2.59-2.618%204.218-4.304%204.882-5.06%201.263-1.418%202.142-2.616%202.637-3.593.508-.99.762-1.96.762-2.91%200-1.55-.547-2.813-1.64-3.79-1.082-.976-2.494-1.464-4.24-1.464-1.236%200-2.545.215-3.925.645-1.367.43-2.832%201.08-4.394%201.953v-3.985c1.588-.638%203.073-1.12%204.453-1.445%201.38-.326%202.643-.488%203.789-.488%203.02%200%205.43.755%207.226%202.265%201.797%201.51%202.696%203.529%202.696%206.055a8.707%208.707%200%200%201-.684%203.418c-.443%201.068-1.256%202.33-2.441%203.789-.326.378-1.361%201.471-3.106%203.281a2473.283%202473.283%200%200%201-7.383%207.559zM156.017%20403.019c1.888.403%203.36%201.243%204.414%202.52%201.068%201.275%201.601%202.85%201.601%204.726%200%202.877-.99%205.104-2.968%206.68-1.98%201.575-4.792%202.363-8.438%202.363-1.224%200-2.487-.124-3.789-.372a26.623%2026.623%200%200%201-4.004-1.074v-3.808a13.669%2013.669%200%200%200%203.594%201.445%2016.77%2016.77%200%200%200%204.082.488c2.474%200%204.355-.488%205.645-1.465%201.302-.976%201.953-2.395%201.953-4.257%200-1.72-.606-3.06-1.817-4.024-1.198-.976-2.87-1.465-5.02-1.465h-3.398v-3.242h3.555c1.94%200%203.424-.384%204.453-1.152%201.029-.781%201.543-1.901%201.543-3.36%200-1.497-.534-2.643-1.601-3.437-1.055-.807-2.572-1.211-4.551-1.211-1.081%200-2.24.117-3.477.352-1.237.234-2.597.599-4.082%201.093v-3.515a38.347%2038.347%200%200%201%204.2-.938%2023.777%2023.777%200%200%201%203.71-.312c2.995%200%205.365.683%207.11%202.05%201.744%201.355%202.617%203.19%202.617%205.508%200%201.615-.462%202.982-1.387%204.102-.924%201.107-2.24%201.875-3.945%202.305zM182.306%20389.581h15.488v3.32H185.92v7.149a10.371%2010.371%200%200%201%201.719-.43%209.59%209.59%200%200%201%201.719-.156c3.255%200%205.833.892%207.734%202.676%201.901%201.783%202.852%204.199%202.852%207.246%200%203.138-.977%205.58-2.93%207.324-1.953%201.732-4.707%202.598-8.262%202.598-1.224%200-2.474-.105-3.75-.313a29.94%2029.94%200%200%201-3.926-.937v-3.965a15.373%2015.373%200%200%200%203.633%201.426c1.25.312%202.572.468%203.965.468%202.253%200%204.037-.592%205.352-1.777%201.315-1.185%201.972-2.793%201.972-4.824%200-2.032-.657-3.64-1.972-4.825-1.315-1.184-3.1-1.777-5.352-1.777-1.055%200-2.11.117-3.164.352a16.66%2016.66%200%200%200-3.203%201.093v-14.648zM216.173%20404.894c-1.875%200-3.353.5-4.434%201.503-1.067%201.003-1.601%202.383-1.601%204.141s.534%203.138%201.601%204.14c1.081%201.003%202.56%201.505%204.434%201.505%201.875%200%203.353-.502%204.434-1.504%201.08-1.016%201.62-2.396%201.62-4.14%200-1.759-.54-3.139-1.62-4.142-1.068-1.002-2.546-1.503-4.434-1.503zm-3.945-1.68c-1.693-.417-3.015-1.205-3.965-2.363-.938-1.16-1.406-2.572-1.406-4.239%200-2.33.827-4.173%202.48-5.527%201.667-1.354%203.945-2.031%206.836-2.031%202.904%200%205.182.677%206.836%202.03%201.654%201.355%202.48%203.198%202.48%205.528%200%201.667-.475%203.08-1.425%204.239-.938%201.158-2.246%201.946-3.926%202.363%201.901.443%203.379%201.308%204.434%202.597%201.067%201.29%201.601%202.865%201.601%204.727%200%202.826-.866%204.994-2.598%206.504-1.718%201.51-4.186%202.266-7.402%202.266s-5.69-.756-7.422-2.266c-1.719-1.51-2.578-3.678-2.578-6.504%200-1.862.534-3.437%201.602-4.727%201.067-1.289%202.552-2.154%204.453-2.597zm-1.446-6.23c0%201.51.47%202.688%201.407%203.535.95.846%202.278%201.27%203.984%201.27%201.693%200%203.014-.424%203.965-1.27.963-.847%201.445-2.025%201.445-3.536%200-1.51-.482-2.688-1.445-3.535-.95-.846-2.272-1.27-3.965-1.27-1.706%200-3.034.424-3.984%201.27-.938.847-1.407%202.025-1.407%203.535z%22%2F%3E%3C%2Fg%3E%3Cg%20fill%3D%22%23FFF%22%20fill-opacity%3D%22.784%22%3E%3Cpath%20d%3D%22M308.836%20414.453h6.445v-22.246l-7.011%201.406v-3.593l6.972-1.407h3.946v25.84h6.445v3.32h-16.797zM345.574%20402.05c1.888.404%203.36%201.244%204.415%202.52%201.067%201.276%201.601%202.852%201.601%204.727%200%202.877-.99%205.104-2.969%206.68-1.979%201.575-4.791%202.363-8.437%202.363-1.224%200-2.487-.124-3.79-.371a26.623%2026.623%200%200%201-4.003-1.074v-3.81a13.669%2013.669%200%200%200%203.594%201.446%2016.77%2016.77%200%200%200%204.082.489c2.474%200%204.355-.489%205.644-1.465%201.302-.977%201.953-2.396%201.953-4.258%200-1.719-.605-3.06-1.816-4.024-1.198-.976-2.871-1.464-5.02-1.464h-3.398v-3.243h3.555c1.94%200%203.424-.384%204.453-1.152%201.028-.781%201.543-1.901%201.543-3.36%200-1.497-.534-2.643-1.602-3.437-1.055-.807-2.571-1.21-4.55-1.21-1.081%200-2.24.116-3.477.35-1.237.235-2.598.6-4.082%201.095v-3.516a38.348%2038.348%200%200%201%204.199-.938%2023.777%2023.777%200%200%201%203.71-.312c2.996%200%205.366.684%207.11%202.05%201.745%201.355%202.617%203.19%202.617%205.509%200%201.614-.462%202.981-1.386%204.101-.925%201.107-2.24%201.875-3.946%202.305zM362.489%20414.453h13.77v3.32h-18.517v-3.32a762.755%20762.755%200%200%201%206.114-6.23c2.59-2.618%204.218-4.304%204.883-5.059%201.263-1.42%202.141-2.617%202.636-3.594.508-.99.762-1.96.762-2.91%200-1.55-.547-2.812-1.64-3.789-1.081-.976-2.494-1.465-4.239-1.465-1.237%200-2.546.215-3.926.645-1.367.43-2.832%201.08-4.394%201.953v-3.984c1.588-.638%203.073-1.12%204.453-1.446%201.38-.325%202.643-.488%203.789-.488%203.02%200%205.43.755%207.226%202.266%201.797%201.51%202.696%203.528%202.696%206.054a8.707%208.707%200%200%201-.684%203.418c-.442%201.068-1.256%202.33-2.441%203.79-.326.377-1.36%201.47-3.106%203.28a2474.291%202474.291%200%200%201-7.382%207.56zM385.242%20414.453h6.446v-22.246l-7.012%201.406v-3.593l6.973-1.407h3.945v25.84h6.445v3.32h-16.797zM434.715%20402.05c1.888.404%203.36%201.244%204.414%202.52%201.068%201.276%201.602%202.852%201.602%204.727%200%202.877-.99%205.104-2.969%206.68-1.98%201.575-4.792%202.363-8.438%202.363-1.223%200-2.487-.124-3.789-.371a26.623%2026.623%200%200%201-4.004-1.074v-3.81a13.669%2013.669%200%200%200%203.594%201.446%2016.77%2016.77%200%200%200%204.082.489c2.474%200%204.356-.489%205.645-1.465%201.302-.977%201.953-2.396%201.953-4.258%200-1.719-.606-3.06-1.816-4.024-1.198-.976-2.872-1.464-5.02-1.464h-3.398v-3.243h3.554c1.94%200%203.425-.384%204.453-1.152%201.029-.781%201.543-1.901%201.543-3.36%200-1.497-.534-2.643-1.601-3.437-1.055-.807-2.572-1.21-4.551-1.21-1.08%200-2.24.116-3.477.35-1.237.235-2.597.6-4.082%201.095v-3.516a38.347%2038.347%200%200%201%204.2-.938%2023.777%2023.777%200%200%201%203.71-.312c2.995%200%205.365.684%207.11%202.05%201.745%201.355%202.617%203.19%202.617%205.509%200%201.614-.462%202.981-1.387%204.101-.924%201.107-2.24%201.875-3.945%202.305zM459.07%20392.05l-9.96%2015.567h9.96v-15.566zm-1.035-3.437h4.961v19.004h4.16v3.281h-4.16v6.875h-3.925v-6.875h-13.165v-3.808l12.13-18.477zM473.739%20388.613h15.488v3.32h-11.875v7.149a10.37%2010.37%200%200%201%201.719-.43%209.59%209.59%200%200%201%201.718-.156c3.256%200%205.834.892%207.735%202.676%201.9%201.784%202.851%204.2%202.851%207.246%200%203.138-.976%205.58-2.93%207.324-1.953%201.732-4.706%202.598-8.261%202.598-1.224%200-2.474-.104-3.75-.313a29.94%2029.94%200%200%201-3.926-.937v-3.965a15.373%2015.373%200%200%200%203.633%201.426c1.25.312%202.571.469%203.965.469%202.252%200%204.036-.593%205.351-1.778%201.315-1.185%201.973-2.793%201.973-4.824%200-2.031-.658-3.64-1.973-4.824-1.315-1.185-3.099-1.778-5.351-1.778-1.055%200-2.11.118-3.164.352a16.66%2016.66%200%200%200-3.203%201.094v-14.649zM499.207%20388.613h15.489v3.32H502.82v7.149a10.37%2010.37%200%200%201%201.718-.43%209.59%209.59%200%200%201%201.72-.156c3.254%200%205.832.892%207.733%202.676%201.901%201.784%202.852%204.2%202.852%207.246%200%203.138-.977%205.58-2.93%207.324-1.953%201.732-4.707%202.598-8.261%202.598-1.224%200-2.474-.104-3.75-.313a29.94%2029.94%200%200%201-3.926-.937v-3.965a15.373%2015.373%200%200%200%203.633%201.426c1.25.312%202.571.469%203.964.469%202.253%200%204.037-.593%205.352-1.778%201.315-1.185%201.973-2.793%201.973-4.824%200-2.031-.658-3.64-1.973-4.824-1.315-1.185-3.099-1.778-5.352-1.778-1.054%200-2.109.118-3.164.352a16.66%2016.66%200%200%200-3.203%201.094v-14.649z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

var FormError = /*#__PURE__*/function () {
  function FormError(message, fieldErrors) {
    _classCallCheck(this, FormError);

    this.message = message;
    this.fieldErrors = fieldErrors;
  }

  return _createClass(FormError, [{
    key: "getMessage",
    value: function getMessage() {
      return this.message;
    }
  }, {
    key: "getFieldErrors",
    value: function getFieldErrors() {
      return this.fieldErrors;
    }
  }]);
}();

var cards = [{
  cardTypeId: 0,
  cardType: 'Generic',
  icon: {
    src: generic,
    alt: 'Generic logo'
  }
}, {
  cardTypeId: 1,
  cardType: 'Visa',
  icon: {
    src: visa,
    alt: 'Visa logo'
  }
}, {
  cardTypeId: 2,
  cardType: 'Mastercard',
  icon: {
    src: mastercard,
    alt: 'Mastercard logo'
  }
}, {
  cardTypeId: 3,
  cardType: 'Discover',
  icon: {
    src: discover,
    alt: 'Discover logo'
  }
}, {
  cardTypeId: 4,
  cardType: 'American Express',
  icon: {
    src: amex,
    alt: 'American Express logo'
  }
}];

var CreditCardService = /*#__PURE__*/function () {
  function CreditCardService() {
    _classCallCheck(this, CreditCardService);
  }

  return _createClass(CreditCardService, null, [{
    key: "getCreditCards",
    value: function () {
      var _getCreditCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(creditCardUrl) {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axiosInstance.get("".concat(creditCardUrl));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getCreditCards(_x) {
        return _getCreditCards.apply(this, arguments);
      }

      return getCreditCards;
    }()
  }, {
    key: "addCreditCard",
    value: function () {
      var _addCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(session, creditCardInfo, countryRegionData) {
        var formData, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = CreditCardService.toFormData(session, creditCardInfo, countryRegionData);
                _context2.next = 3;
                return axios$1.post(session.formActionUrl, formData, {
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                });

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function addCreditCard(_x2, _x3, _x4) {
        return _addCreditCard.apply(this, arguments);
      }

      return addCreditCard;
    }()
  }, {
    key: "updateCreditCard",
    value: function () {
      var _updateCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(creditCard, creditCardUrl) {
        var response, _error$response$data, _error$response$data2, _error$response$data3, message, _error$response$data4;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                response = {};
                _context3.prev = 1;
                _context3.next = 4;
                return axiosInstance.put("".concat(creditCardUrl, "/").concat(creditCard.id), creditCard);

              case 4:
                response = _context3.sent;
                _context3.next = 21;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);

                if (!_context3.t0.response) {
                  _context3.next = 20;
                  break;
                }

                if (!(((_error$response$data = _context3.t0.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.status) === 400)) {
                  _context3.next = 18;
                  break;
                }

                message = (_error$response$data2 = _context3.t0.response.data) === null || _error$response$data2 === void 0 ? void 0 : _error$response$data2.error;

                if ((_error$response$data3 = _context3.t0.response.data) !== null && _error$response$data3 !== void 0 && _error$response$data3.additionalProperties) {
                  message = 'Please update your credit card information.';
                }

                if (!message) {
                  _context3.next = 17;
                  break;
                }

                throw new FormError(message, (_error$response$data4 = _context3.t0.response.data) === null || _error$response$data4 === void 0 ? void 0 : _error$response$data4.additionalProperties);

              case 17:
                console.debug(_context3.t0.response);

              case 18:
                _context3.next = 21;
                break;

              case 20:
                console.debug('Error', _context3.t0);

              case 21:
                return _context3.abrupt("return", response.data);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 7]]);
      }));

      function updateCreditCard(_x5, _x6) {
        return _updateCreditCard.apply(this, arguments);
      }

      return updateCreditCard;
    }()
  }, {
    key: "deleteCreditCard",
    value: function () {
      var _deleteCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(creditCardId, creditCardUrl) {
        var response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                response = '';
                _context4.prev = 1;
                _context4.next = 4;
                return axiosInstance["delete"](creditCardUrl + '/' + creditCardId);

              case 4:
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](1);
                response = _context4.t0.response;

              case 9:
                return _context4.abrupt("return", response);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 6]]);
      }));

      function deleteCreditCard(_x7, _x8) {
        return _deleteCreditCard.apply(this, arguments);
      }

      return deleteCreditCard;
    }()
  }, {
    key: "toFormData",
    value: function toFormData(session, creditCardInfo, countryRegionData) {
      var stateAbbreviation = convertStateIdToAbbreviation(creditCardInfo.addressLevel1Id, creditCardInfo.countryId, countryRegionData);
      var ftniStateAbbreviation = stateAbbreviation.length <= 4 ? stateAbbreviation : '';
      return "CardType=".concat(creditCardInfo.creditCardType, "&") + "CardNumber=".concat(creditCardInfo.cardNumber, "&") + "CVV=".concat(creditCardInfo.securityCode, "&") + "NameOnCard=".concat(creditCardInfo.nameOnCard, "&") + "ExpirationMonth=".concat(creditCardInfo.expirationDate.split('/')[0], "&") + "ExpirationYear=".concat(creditCardInfo.expirationDate.split('/')[1], "&") + "Address1=".concat(creditCardInfo.addressLine1, "&") + "Address2=".concat(creditCardInfo.addressLine2, "&") + "City=".concat(creditCardInfo.addressLevel2, "&") + "State=".concat(ftniStateAbbreviation, "&") + "Country=".concat(convertCountryIdToCountryCode3(creditCardInfo.countryId, countryRegionData), "&") + "Zip=".concat(creditCardInfo.postalCode, "&") + "CallBack=".concat(session.callbackUrl, "&") + "OrderNumber=".concat(this.getOrderNumber(session, creditCardInfo, stateAbbreviation), "&") + "ProcessingInstruction=".concat(session.processingInstruction, "&") + "Amount=".concat(session.saveAmount, "&") + "Save=".concat(session.save);
    }
  }, {
    key: "getOrderNumber",
    value: function getOrderNumber(session, creditCardInfo, stateAbbreviation) {
      return JSON.stringify({
        type: creditCardInfo.creditCardType,
        expiration: creditCardInfo.expirationDate,
        nickname: creditCardInfo.cardNickname,
        state: stateAbbreviation,
        ipAddress: session.ipAddress,
        guid: getCookieValue('guid')
      });
    }
  }, {
    key: "findCardByCardType",
    value: function findCardByCardType(creditCardType) {
      return cards.find(function (card) {
        return card.cardType === creditCardType;
      });
    }
  }, {
    key: "findCardByCardTypeId",
    value: function findCardByCardTypeId(cardTypeId) {
      return cards.find(function (card) {
        return card.cardTypeId === cardTypeId;
      });
    }
  }]);
}();

function CreditCardLabel() {
  return /*#__PURE__*/React.createElement(Box$1, {
    p: 1
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: 'h6'
  }, "Credit Card"));
}

function BillingAddressLabel() {
  return /*#__PURE__*/React.createElement(Box$1, {
    p: 1
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: 'h6'
  }, "Billing Address"));
}

AddCreditCard.propTypes = {
  sessionUrl: string.isRequired,
  onSuccess: func.isRequired,
  countryRegionData: arrayOf(shape({
    id: number,
    name: string,
    countryCode: string,
    states: arrayOf(shape({
      id: number,
      name: string,
      abbreviation: string
    }))
  })).isRequired,
  initialNameOnCard: string,
  initialAddress: shape({
    addressLine1: string,
    addressLine2: string,
    addressLevel1Id: string,
    addressLevel2: string,
    countryId: string,
    postalCode: string
  }),
  confirm: bool,
  onCancel: func,
  onSkip: func
};

function AddCreditCard(props) {
  var _props$initialAddress, _props$initialAddress2, _props$initialAddress3, _props$initialAddress4, _props$initialAddress5, _props$initialAddress6, _creditCardInfo$icon, _creditCardInfo$icon2;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      attemptedSubmission = _useState4[0],
      setAttemptedSubmission = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showSkipWarning = _useState6[0],
      setSkipWarning = _useState6[1];

  var _useState7 = useState({
    nameOnCard: props.initialNameOnCard,
    cardNumber: '',
    creditCardType: '',
    securityCode: '',
    expirationDate: '',
    cardNickname: '',
    icon: '',
    addressLine1: ((_props$initialAddress = props.initialAddress) === null || _props$initialAddress === void 0 ? void 0 : _props$initialAddress.addressLine1) || '',
    addressLine2: ((_props$initialAddress2 = props.initialAddress) === null || _props$initialAddress2 === void 0 ? void 0 : _props$initialAddress2.addressLine2) || '',
    addressLevel1Id: ((_props$initialAddress3 = props.initialAddress) === null || _props$initialAddress3 === void 0 ? void 0 : _props$initialAddress3.addressLevel1Id) || '',
    addressLevel2: ((_props$initialAddress4 = props.initialAddress) === null || _props$initialAddress4 === void 0 ? void 0 : _props$initialAddress4.addressLevel2) || '',
    countryId: ((_props$initialAddress5 = props.initialAddress) === null || _props$initialAddress5 === void 0 ? void 0 : _props$initialAddress5.countryId) || '1',
    postalCode: ((_props$initialAddress6 = props.initialAddress) === null || _props$initialAddress6 === void 0 ? void 0 : _props$initialAddress6.postalCode) || ''
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      creditCardInfo = _useState8[0],
      setCreditCardInfo = _useState8[1];

  var _useState9 = useState({}),
      _useState10 = _slicedToArray(_useState9, 2),
      creditCardInfoErrors = _useState10[0],
      setCreditCardInfoErrors = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      disableForm = _useState12[0],
      setDisableForm = _useState12[1];

  var _useState13 = useState(undefined),
      _useState14 = _slicedToArray(_useState13, 2),
      responseData = _useState14[0],
      setResponseData = _useState14[1];

  var classes = useStyles$w();

  var onlyNumbers = function onlyNumbers(e) {
    return e.target.value = e.target.value.replace(/[^0-9]/g, '');
  };

  useEffect(function () {
    var _props$initialAddress7, _props$countryRegionD;

    if (!((_props$initialAddress7 = props.initialAddress) !== null && _props$initialAddress7 !== void 0 && _props$initialAddress7.countryId) && ((_props$countryRegionD = props.countryRegionData) === null || _props$countryRegionD === void 0 ? void 0 : _props$countryRegionD.length) > 0) {
      var _props$initialAddress8;

      setCreditCardInfo(_objectSpread2(_objectSpread2({}, creditCardInfo), {}, {
        countryId: ((_props$initialAddress8 = props.initialAddress) === null || _props$initialAddress8 === void 0 ? void 0 : _props$initialAddress8.countryId) || '1'
      }));
    }
  }, [props.countryRegionData]);
  useEffect(function () {
    var validatedCreditCard = validateCreditCard(creditCardInfo);
    setCreditCardInfoErrors(validatedCreditCard);

    if (!lodash_isempty(validatedCreditCard)) {
      setResponseData({
        code: 'FORM_ERROR'
      });
    }
  }, [creditCardInfo]);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var session, sessionData, data, _e$response$data, errorCode;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setAttemptedSubmission(true);

              if (!lodash_isempty(creditCardInfoErrors)) {
                _context.next = 27;
                break;
              }

              setResponseData({
                code: ''
              });
              setLoading(true);
              _context.prev = 4;
              _context.next = 7;
              return axiosInstance.get(props.sessionUrl);

            case 7:
              session = _context.sent;
              sessionData = session.data;
              _context.prev = 9;
              _context.next = 12;
              return CreditCardService.addCreditCard(sessionData, creditCardInfo, props.countryRegionData);

            case 12:
              data = _context.sent;

              if (!props.confirm && !data.code) {
                props.onSuccess();
              }

              setResponseData(data);
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](9);
              setResponseData({
                code: 'ERROR'
              });

            case 20:
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](4);
              errorCode = (_e$response$data = _context.t1.response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.code;

              if (errorCode === 'max_attempts') {
                setResponseData({
                  code: 'MAX_ATTEMPTS'
                });
              } else {
                setResponseData({
                  code: 'ERROR'
                });
              }

            case 26:
              setLoading(false);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 22], [9, 17]]);
    }));

    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    setCreditCardInfo(_objectSpread2(_objectSpread2({}, creditCardInfo), {}, {
      securityCode: ''
    }));
  }, [creditCardInfo.creditCardType]);
  useEffect(function () {
    var _validation$card;

    var validation = cardValidator.number(creditCardInfo.cardNumber);
    var card = CreditCardService.findCardByCardType((_validation$card = validation.card) === null || _validation$card === void 0 ? void 0 : _validation$card.niceType);

    if (card) {
      setCreditCardInfo(_objectSpread2(_objectSpread2({}, creditCardInfo), {}, {
        creditCardType: card.cardTypeId,
        icon: card.icon
      }));
    } else {
      setCreditCardInfo(_objectSpread2(_objectSpread2({}, creditCardInfo), {}, {
        creditCardType: '',
        icon: ''
      }));
    }
  }, [creditCardInfo.cardNumber]);

  var handleChange = function handleChange(attributeName, value) {
    setCreditCardInfo(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, attributeName, value));
    });
  };

  var skipButton = function skipButton() {
    function handleSkip() {
      setSkipWarning(false);
      props.onSkip();
    }

    return /*#__PURE__*/React.createElement(Grid$2, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(SkipWarning, {
      onCancel: handleSkip,
      onClose: function onClose() {
        return setSkipWarning(false);
      },
      open: showSkipWarning
    }), /*#__PURE__*/React.createElement(Button, {
      style: {
        width: '100%'
      },
      id: 'skip-add-credit-card',
      disabled: loading,
      onClick: function onClick() {
        return setSkipWarning(true);
      }
    }, "Skip For Now"));
  };

  var cancelButton = function cancelButton() {
    return /*#__PURE__*/React.createElement(Button, {
      id: 'cancel-add-credit-card',
      disabled: loading,
      onClick: props.onCancel,
      fullWidth: true
    }, "Cancel");
  };

  var getSecurityCodeMessage = function getSecurityCodeMessage() {
    var message;

    if (creditCardInfo.creditCardType === '') {
      message = '';
    } else if (creditCardInfo.creditCardType !== 4) {
      message = 'Last three digits on signature strip';
    } else {
      message = 'Four digits on front of card';
    }

    return message;
  };

  return /*#__PURE__*/React.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("fieldset", {
    disabled: loading || disableForm,
    style: {
      border: 'none'
    }
  }, attemptedSubmission && (responseData.code || responseData.error) && /*#__PURE__*/React.createElement(AddCreditCardResponseMessage, {
    disableForm: function disableForm() {
      setDisableForm(true);
    },
    code: responseData.code,
    error: responseData.error
  }), /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider$1, {
    variant: "fullWidth",
    component: CreditCardLabel
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.nameOnCard,
    helperText: attemptedSubmission && creditCardInfoErrors.nameOnCard,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "ccNameOnCard",
    label: "Name on Card",
    name: "ccname",
    autoComplete: "cc-name",
    autoFocus: true,
    fullWidth: true,
    value: creditCardInfo.nameOnCard,
    disabled: !!props.initialNameOnCard,
    onChange: function onChange(event) {
      return handleChange('nameOnCard', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.cardNumber,
    helperText: attemptedSubmission && creditCardInfoErrors.cardNumber,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "ccNum",
    label: "Card Number",
    name: "cardnumber",
    autoComplete: "cc-number",
    fullWidth: true,
    value: creditCardInfo.cardNumber,
    onChange: function onChange(event) {
      return handleChange('cardNumber', event.target.value);
    },
    inputProps: {
      maxLength: 16
    },
    InputProps: {
      endAdornment: creditCardInfo.icon && /*#__PURE__*/React.createElement(CardMedia, {
        "aria-label": 'creditCardLogo',
        className: classes.ccLogo,
        component: 'img',
        image: (_creditCardInfo$icon = creditCardInfo.icon) === null || _creditCardInfo$icon === void 0 ? void 0 : _creditCardInfo$icon.src,
        title: (_creditCardInfo$icon2 = creditCardInfo.icon) === null || _creditCardInfo$icon2 === void 0 ? void 0 : _creditCardInfo$icon2.alt
      })
    },
    onInput: onlyNumbers
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.expirationDate,
    helperText: attemptedSubmission && creditCardInfoErrors.expirationDate,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "expirationDate",
    label: "Expiration Date",
    name: "cc-exp",
    autoComplete: "cc-exp",
    fullWidth: true,
    value: creditCardInfo.expirationDate,
    placeholder: 'MM/YYYY',
    onChange: function onChange(event) {
      return handleChange('expirationDate', event.target.value);
    },
    InputProps: {
      inputComponent: CreditCardExpirationDateMask,
      placeholder: 'MM/YYYY'
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.securityCode,
    helperText: attemptedSubmission && creditCardInfoErrors.securityCode ? creditCardInfoErrors.securityCode : getSecurityCodeMessage(),
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "ccSecurityCode",
    label: "Security Code",
    name: "cvc",
    autoComplete: "cc-csc",
    fullWidth: true,
    value: creditCardInfo.securityCode,
    onChange: function onChange(event) {
      return handleChange('securityCode', event.target.value);
    },
    inputProps: {
      maxLength: creditCardInfo.creditCardType !== 4 ? 3 : 4
    },
    onInput: onlyNumbers
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.cardNickname,
    helperText: 'Ex. "Business Visa" or "Citibank Platinum"',
    variant: "outlined",
    margin: "dense",
    id: "cardNickname",
    label: "Card Nickname",
    name: "cardNickname",
    fullWidth: true,
    value: creditCardInfo.cardNickname,
    inputProps: {
      maxLength: 25
    },
    onChange: function onChange(event) {
      return handleChange('cardNickname', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider$1, {
    variant: "fullWidth",
    component: BillingAddressLabel
  }), /*#__PURE__*/React.createElement(Address, {
    initialAddress: _objectSpread2({}, creditCardInfo),
    currentAddress: _objectSpread2({}, creditCardInfo),
    addressChanged: handleChange,
    attemptedSubmission: attemptedSubmission,
    countryRegionData: props.countryRegionData
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    style: {
      marginTop: '1rem',
      width: '100%'
    },
    id: 'add-credit-card',
    color: 'primary',
    variant: 'contained',
    loading: loading,
    disabled: attemptedSubmission && !lodash_isempty(creditCardInfoErrors) || disableForm,
    onClick: handleSubmit
  }, "Add Credit Card")), props.onCancel && !disableForm && cancelButton(), props.onSkip && !disableForm && skipButton())));
}

var useStyles$w = makeStyles(function () {
  return {
    ccLogo: {
      maxHeight: '2rem',
      width: 'auto',
      maxWidth: '100%',
      margin: '0 auto'
    }
  };
});

function EmptyStateMessage(props) {
  var children = props.children,
      secondary = props.secondary;
  return /*#__PURE__*/React.createElement(BigMessage, {
    secondary: secondary,
    Icon: ErrorIcon,
    type: "default"
  }, children);
}

EmptyStateMessage.propTypes = {
  children: PropTypes__default.node.isRequired,
  secondary: PropTypes__default.element
};
Logout.propTypes = {
  buttonText: PropTypes__default.string,
  onSuccess: PropTypes__default.func.isRequired
};

function Logout(props) {
  var logoutService = LogoutService.instance;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loggingOut = _useState2[0],
      setLoggingOut = _useState2[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!event) {
                _context.next = 6;
                break;
              }

              setLoggingOut(true);
              event.preventDefault();
              _context.next = 5;
              return logoutService.logout();

            case 5:
              setLoggingOut(false);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClick,
    loading: loggingOut,
    color: "primary"
  }, /*#__PURE__*/React.createElement(Typography, null, props.buttonText && props.buttonText.trim() ? props.buttonText.trim() : 'Sign Out')));
}

HeroCard.propTypes = {
  title: string.isRequired,
  url: string.isRequired,
  imageUrl: string.isRequired
};

function HeroCard(props) {
  var title = props.title,
      url = props.url,
      imageUrl = props.imageUrl;
  return /*#__PURE__*/React.createElement(Card$1, {
    style: {
      height: 220,
      margin: 0
    }
  }, /*#__PURE__*/React.createElement(CardActionArea, {
    style: {
      height: '100%'
    },
    href: url
  }, /*#__PURE__*/React.createElement(CardMedia, {
    image: imageUrl,
    style: {
      height: 140
    }
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2"
  }, title))));
}

HeroGrid.propTypes = {
  title: string,
  children: node.isRequired // intended children are <HeroCard>s

};

function HeroGrid(props) {
  var children = props.children,
      title = props.title;
  var classes = useStyles$x();
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("h2", {
    className: classes.sectionHeader
  }, title), "             ", /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, children.map(function (child, index) {
    return /*#__PURE__*/React.createElement(Grid$1, {
      item: true,
      key: index,
      xs: 6,
      sm: 4,
      md: 3,
      lg: 2
    }, child);
  })));
}

var useStyles$x = makeStyles$1(function (theme) {
  return {
    sectionHeader: _objectSpread2({}, theme.typographyClasses.sectionHeader)
  };
});
var clones = createCommonjsModule(function (module, exports) {
  function getOriginalCounterPart(index, _a, childrenArr) {
    var slidesToShow = _a.slidesToShow,
        currentSlide = _a.currentSlide;
    return childrenArr.length > 2 * slidesToShow ? index + 2 * slidesToShow : currentSlide >= childrenArr.length ? childrenArr.length + index : index;
  }

  function getOriginalIndexLookupTableByClones(slidesToShow, childrenArr) {
    if (childrenArr.length > 2 * slidesToShow) {
      for (var table = {}, firstBeginningOfClones = childrenArr.length - 2 * slidesToShow, firstEndOfClones = childrenArr.length - firstBeginningOfClones, firstCount = firstBeginningOfClones, i = 0; i < firstEndOfClones; i++) {
        table[i] = firstCount, firstCount++;
      }

      var secondBeginningOfClones = childrenArr.length + firstEndOfClones,
          secondEndOfClones = secondBeginningOfClones + childrenArr.slice(0, 2 * slidesToShow).length,
          secondCount = 0;

      for (i = secondBeginningOfClones; i <= secondEndOfClones; i++) {
        table[i] = secondCount, secondCount++;
      }

      var originalEnd = secondBeginningOfClones,
          originalCounter = 0;

      for (i = firstEndOfClones; i < originalEnd; i++) {
        table[i] = originalCounter, originalCounter++;
      }

      return table;
    }

    table = {};
    var totalSlides = 3 * childrenArr.length,
        count = 0;

    for (i = 0; i < totalSlides; i++) {
      table[i] = count, ++count === childrenArr.length && (count = 0);
    }

    return table;
  }

  function getClones(slidesToShow, childrenArr) {
    return childrenArr.length < slidesToShow ? childrenArr : childrenArr.length > 2 * slidesToShow ? childrenArr.slice(childrenArr.length - 2 * slidesToShow, childrenArr.length).concat(childrenArr, childrenArr.slice(0, 2 * slidesToShow)) : childrenArr.concat(childrenArr, childrenArr);
  }

  function getInitialSlideInInfiniteMode(slidesToShow, childrenArr) {
    return childrenArr.length > 2 * slidesToShow ? 2 * slidesToShow : childrenArr.length;
  }

  function checkClonesPosition(_a, childrenArr, props) {
    var isReachingTheEnd,
        currentSlide = _a.currentSlide,
        slidesToShow = _a.slidesToShow,
        itemWidth = _a.itemWidth,
        totalItems = _a.totalItems,
        nextSlide = 0,
        nextPosition = 0,
        isReachingTheStart = 0 === currentSlide,
        originalFirstSlide = childrenArr.length - (childrenArr.length - 2 * slidesToShow);
    return childrenArr.length < slidesToShow ? (nextPosition = nextSlide = 0, isReachingTheStart = isReachingTheEnd = !1) : childrenArr.length > 2 * slidesToShow ? ((isReachingTheEnd = currentSlide >= originalFirstSlide + childrenArr.length) && (nextPosition = -itemWidth * (nextSlide = currentSlide - childrenArr.length)), isReachingTheStart && (nextPosition = -itemWidth * (nextSlide = originalFirstSlide + (childrenArr.length - 2 * slidesToShow)))) : ((isReachingTheEnd = currentSlide >= 2 * childrenArr.length) && (nextPosition = -itemWidth * (nextSlide = currentSlide - childrenArr.length)), isReachingTheStart && (nextPosition = props.showDots ? -itemWidth * (nextSlide = childrenArr.length) : -itemWidth * (nextSlide = totalItems - 2 * slidesToShow))), {
      isReachingTheEnd: isReachingTheEnd,
      isReachingTheStart: isReachingTheStart,
      nextSlide: nextSlide,
      nextPosition: nextPosition
    };
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.getOriginalCounterPart = getOriginalCounterPart, exports.getOriginalIndexLookupTableByClones = getOriginalIndexLookupTableByClones, exports.getClones = getClones, exports.getInitialSlideInInfiniteMode = getInitialSlideInInfiniteMode, exports.checkClonesPosition = checkClonesPosition;
});
unwrapExports(clones);
var clones_1 = clones.getOriginalCounterPart;
var clones_2 = clones.getOriginalIndexLookupTableByClones;
var clones_3 = clones.getClones;
var clones_4 = clones.getInitialSlideInInfiniteMode;
var clones_5 = clones.checkClonesPosition;
var elementWidth = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var hasWarnAboutTypo = !1;

  function getPartialVisibilityGutter(responsive, partialVisible, serverSideDeviceType, clientSideDeviceType) {
    var gutter = 0,
        deviceType = clientSideDeviceType || serverSideDeviceType;
    return partialVisible && deviceType && (!hasWarnAboutTypo && "production" !== process.env.NODE_ENV && responsive[deviceType].paritialVisibilityGutter && (hasWarnAboutTypo = !0, console.warn("You appear to be using paritialVisibilityGutter instead of partialVisibilityGutter which will be moved to partialVisibilityGutter in the future completely")), gutter = responsive[deviceType].partialVisibilityGutter || responsive[deviceType].paritialVisibilityGutter), gutter;
  }

  function getWidthFromDeviceType(deviceType, responsive) {
    var itemWidth;
    responsive[deviceType] && (itemWidth = (100 / responsive[deviceType].items).toFixed(1));
    return itemWidth;
  }

  function getItemClientSideWidth(props, slidesToShow, containerWidth) {
    return Math.round(containerWidth / (slidesToShow + (props.centerMode ? 1 : 0)));
  }

  exports.getPartialVisibilityGutter = getPartialVisibilityGutter, exports.getWidthFromDeviceType = getWidthFromDeviceType, exports.getItemClientSideWidth = getItemClientSideWidth;
});
unwrapExports(elementWidth);
var elementWidth_1 = elementWidth.getPartialVisibilityGutter;
var elementWidth_2 = elementWidth.getWidthFromDeviceType;
var elementWidth_3 = elementWidth.getItemClientSideWidth;
var common$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  function getInitialState(state, props) {
    var flexBisis,
        domLoaded = state.domLoaded,
        slidesToShow = state.slidesToShow,
        containerWidth = state.containerWidth,
        itemWidth = state.itemWidth,
        deviceType = props.deviceType,
        responsive = props.responsive,
        ssr = props.ssr,
        partialVisbile = props.partialVisbile,
        partialVisible = props.partialVisible,
        domFullyLoaded = Boolean(domLoaded && slidesToShow && containerWidth && itemWidth);
    ssr && deviceType && !domFullyLoaded && (flexBisis = elementWidth.getWidthFromDeviceType(deviceType, responsive));
    var shouldRenderOnSSR = Boolean(ssr && deviceType && !domFullyLoaded && flexBisis);
    return {
      shouldRenderOnSSR: shouldRenderOnSSR,
      flexBisis: flexBisis,
      domFullyLoaded: domFullyLoaded,
      partialVisibilityGutter: elementWidth.getPartialVisibilityGutter(responsive, partialVisbile || partialVisible, deviceType, state.deviceType),
      shouldRenderAtAll: shouldRenderOnSSR || domFullyLoaded
    };
  }

  function getIfSlideIsVisbile(index, state) {
    var currentSlide = state.currentSlide,
        slidesToShow = state.slidesToShow;
    return currentSlide <= index && index < currentSlide + slidesToShow;
  }

  function getTransformForCenterMode(state, props, transformPlaceHolder) {
    var transform = transformPlaceHolder || state.transform;
    return !props.infinite && 0 === state.currentSlide || props.infinite && state.totalItems < state.slidesToShow ? transform : transform + state.itemWidth / 2;
  }

  function isInLeftEnd(_a) {
    return !(0 < _a.currentSlide);
  }

  function isInRightEnd(_a) {
    var currentSlide = _a.currentSlide,
        totalItems = _a.totalItems;
    return !(currentSlide + _a.slidesToShow < totalItems);
  }

  function getTransformForPartialVsibile(state, partialVisibilityGutter, props, transformPlaceHolder) {
    void 0 === partialVisibilityGutter && (partialVisibilityGutter = 0);
    var currentSlide = state.currentSlide,
        slidesToShow = state.slidesToShow,
        isRightEndReach = isInRightEnd(state),
        shouldRemoveRightGutter = !props.infinite && isRightEndReach,
        transform = (transformPlaceHolder || state.transform) + currentSlide * partialVisibilityGutter;
    return shouldRemoveRightGutter ? transform + (state.containerWidth - (state.itemWidth - partialVisibilityGutter) * slidesToShow) : transform;
  }

  function getTransform(state, props, transformPlaceHolder) {
    var partialVisbile = props.partialVisbile,
        partialVisible = props.partialVisible,
        responsive = props.responsive,
        deviceType = props.deviceType,
        centerMode = props.centerMode,
        transform = transformPlaceHolder || state.transform,
        partialVisibilityGutter = elementWidth.getPartialVisibilityGutter(responsive, partialVisbile || partialVisible, deviceType, state.deviceType);
    return partialVisible || partialVisbile ? getTransformForPartialVsibile(state, partialVisibilityGutter, props, transformPlaceHolder) : centerMode ? getTransformForCenterMode(state, props, transformPlaceHolder) : transform;
  }

  function notEnoughChildren(state, props, items) {
    var childrenArr = React.Children.toArray(props.children),
        slidesToShow = state.slidesToShow;
    return items ? childrenArr.length < items : childrenArr.length < slidesToShow;
  }

  function getSlidesToSlide(state, props) {
    var domLoaded = state.domLoaded,
        slidesToShow = state.slidesToShow,
        containerWidth = state.containerWidth,
        itemWidth = state.itemWidth,
        deviceType = props.deviceType,
        responsive = props.responsive,
        slidesToScroll = props.slidesToSlide || 1,
        domFullyLoaded = Boolean(domLoaded && slidesToShow && containerWidth && itemWidth);
    return props.ssr && props.deviceType && !domFullyLoaded && Object.keys(responsive).forEach(function (device) {
      var slidesToSlide = responsive[device].slidesToSlide;
      deviceType === device && slidesToSlide && (slidesToScroll = slidesToSlide);
    }), domFullyLoaded && Object.keys(responsive).forEach(function (item) {
      var _a = responsive[item],
          breakpoint = _a.breakpoint,
          slidesToSlide = _a.slidesToSlide,
          max = breakpoint.max,
          min = breakpoint.min;
      slidesToSlide && window.innerWidth >= min && window.innerWidth <= max && (slidesToScroll = slidesToSlide);
    }), slidesToScroll;
  }

  exports.getInitialState = getInitialState, exports.getIfSlideIsVisbile = getIfSlideIsVisbile, exports.getTransformForCenterMode = getTransformForCenterMode, exports.isInLeftEnd = isInLeftEnd, exports.isInRightEnd = isInRightEnd, exports.getTransformForPartialVsibile = getTransformForPartialVsibile, exports.getTransform = getTransform, exports.notEnoughChildren = notEnoughChildren, exports.getSlidesToSlide = getSlidesToSlide;
});
unwrapExports(common$1);
var common_1 = common$1.getInitialState;
var common_2 = common$1.getIfSlideIsVisbile;
var common_3 = common$1.getTransformForCenterMode;
var common_4 = common$1.isInLeftEnd;
var common_5 = common$1.isInRightEnd;
var common_6 = common$1.getTransformForPartialVsibile;
var common_7 = common$1.getTransform;
var common_8 = common$1.notEnoughChildren;
var common_9 = common$1.getSlidesToSlide;
var throttle_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var throttle = function throttle(func, limit, setIsInThrottle) {
    var inThrottle;
    return function () {
      var args = arguments;
      inThrottle || (func.apply(this, args), inThrottle = !0, "function" == typeof setIsInThrottle && setIsInThrottle(!0), setTimeout(function () {
        inThrottle = !1, "function" == typeof setIsInThrottle && setIsInThrottle(!1);
      }, limit));
    };
  };

  exports.default = throttle;
});
unwrapExports(throttle_1);
var throwError_1 = createCommonjsModule(function (module, exports) {
  function throwError(state, props) {
    var partialVisbile = props.partialVisbile,
        partialVisible = props.partialVisible,
        centerMode = props.centerMode,
        ssr = props.ssr,
        responsive = props.responsive;
    if ((partialVisbile || partialVisible) && centerMode) throw new Error("center mode can not be used at the same time with partialVisible");
    if (!responsive) throw ssr ? new Error("ssr mode need to be used in conjunction with responsive prop") : new Error("Responsive prop is needed for deciding the amount of items to show on the screen");
    if (responsive && "object" != typeof responsive) throw new Error("responsive prop must be an object");
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = throwError;
});
unwrapExports(throwError_1);
var next = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  function populateNextSlides(state, props, slidesHavePassed) {
    void 0 === slidesHavePassed && (slidesHavePassed = 0);
    var nextSlides,
        nextPosition,
        slidesToShow = state.slidesToShow,
        currentSlide = state.currentSlide,
        itemWidth = state.itemWidth,
        totalItems = state.totalItems,
        slidesToSlide = common$1.getSlidesToSlide(state, props),
        nextMaximumSlides = currentSlide + 1 + slidesHavePassed + slidesToShow + (0 < slidesHavePassed ? 0 : slidesToSlide);
    return nextPosition = nextMaximumSlides <= totalItems ? -itemWidth * (nextSlides = currentSlide + slidesHavePassed + (0 < slidesHavePassed ? 0 : slidesToSlide)) : totalItems < nextMaximumSlides && currentSlide !== totalItems - slidesToShow ? -itemWidth * (nextSlides = totalItems - slidesToShow) : nextSlides = void 0, {
      nextSlides: nextSlides,
      nextPosition: nextPosition
    };
  }

  exports.populateNextSlides = populateNextSlides;
});
unwrapExports(next);
var next_1 = next.populateNextSlides;
var previous = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var common_2 = common$1;

  function populatePreviousSlides(state, props, slidesHavePassed) {
    void 0 === slidesHavePassed && (slidesHavePassed = 0);
    var nextSlides,
        nextPosition,
        currentSlide = state.currentSlide,
        itemWidth = state.itemWidth,
        slidesToShow = state.slidesToShow,
        children = props.children,
        showDots = props.showDots,
        infinite = props.infinite,
        slidesToSlide = common$1.getSlidesToSlide(state, props),
        nextMaximumSlides = currentSlide - slidesHavePassed - (0 < slidesHavePassed ? 0 : slidesToSlide),
        additionalSlides = (React.Children.toArray(children).length - slidesToShow) % slidesToSlide;
    return nextPosition = 0 <= nextMaximumSlides ? (nextSlides = nextMaximumSlides, showDots && !infinite && 0 < additionalSlides && common_2.isInRightEnd(state) && (nextSlides = currentSlide - additionalSlides), -itemWidth * nextSlides) : nextSlides = nextMaximumSlides < 0 && 0 !== currentSlide ? 0 : void 0, {
      nextSlides: nextSlides,
      nextPosition: nextPosition
    };
  }

  exports.populatePreviousSlides = populatePreviousSlides;
});
unwrapExports(previous);
var previous_1 = previous.populatePreviousSlides;
var mouseOrTouchMove = createCommonjsModule(function (module, exports) {
  function populateSlidesOnMouseTouchMove(state, props, initialX, lastX, clientX, transformPlaceHolder) {
    var direction,
        nextPosition,
        itemWidth = state.itemWidth,
        slidesToShow = state.slidesToShow,
        totalItems = state.totalItems,
        currentSlide = state.currentSlide,
        infinite = props.infinite,
        canContinue = !1,
        slidesHavePassedRight = Math.round((initialX - lastX) / itemWidth),
        slidesHavePassedLeft = Math.round((lastX - initialX) / itemWidth),
        isMovingLeft = initialX < clientX;

    if (clientX < initialX && !!(slidesHavePassedRight <= slidesToShow)) {
      direction = "right";
      var translateXLimit = Math.abs(-itemWidth * (totalItems - slidesToShow)),
          nextTranslate = transformPlaceHolder - (lastX - clientX),
          isLastSlide = currentSlide === totalItems - slidesToShow;
      (Math.abs(nextTranslate) <= translateXLimit || isLastSlide && infinite) && (nextPosition = nextTranslate, canContinue = !0);
    }

    isMovingLeft && slidesHavePassedLeft <= slidesToShow && (direction = "left", ((nextTranslate = transformPlaceHolder + (clientX - lastX)) <= 0 || 0 === currentSlide && infinite) && (canContinue = !0, nextPosition = nextTranslate));
    return {
      direction: direction,
      nextPosition: nextPosition,
      canContinue: canContinue
    };
  }

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.populateSlidesOnMouseTouchMove = populateSlidesOnMouseTouchMove;
});
unwrapExports(mouseOrTouchMove);
var mouseOrTouchMove_1 = mouseOrTouchMove.populateSlidesOnMouseTouchMove;
var utils$3 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  exports.getOriginalCounterPart = clones.getOriginalCounterPart, exports.getClones = clones.getClones, exports.checkClonesPosition = clones.checkClonesPosition, exports.getInitialSlideInInfiniteMode = clones.getInitialSlideInInfiniteMode;
  exports.getWidthFromDeviceType = elementWidth.getWidthFromDeviceType, exports.getPartialVisibilityGutter = elementWidth.getPartialVisibilityGutter, exports.getItemClientSideWidth = elementWidth.getItemClientSideWidth;
  exports.getInitialState = common$1.getInitialState, exports.getIfSlideIsVisbile = common$1.getIfSlideIsVisbile, exports.getTransformForCenterMode = common$1.getTransformForCenterMode, exports.getTransformForPartialVsibile = common$1.getTransformForPartialVsibile, exports.isInLeftEnd = common$1.isInLeftEnd, exports.isInRightEnd = common$1.isInRightEnd, exports.notEnoughChildren = common$1.notEnoughChildren, exports.getSlidesToSlide = common$1.getSlidesToSlide;
  exports.throttle = throttle_1.default;
  exports.throwError = throwError_1.default;
  exports.populateNextSlides = next.populateNextSlides;
  exports.populatePreviousSlides = previous.populatePreviousSlides;
  exports.populateSlidesOnMouseTouchMove = mouseOrTouchMove.populateSlidesOnMouseTouchMove;
});
unwrapExports(utils$3);
var utils_1$1 = utils$3.getOriginalCounterPart;
var utils_2$1 = utils$3.getClones;
var utils_3$1 = utils$3.checkClonesPosition;
var utils_4$1 = utils$3.getInitialSlideInInfiniteMode;
var utils_5$1 = utils$3.getWidthFromDeviceType;
var utils_6$1 = utils$3.getPartialVisibilityGutter;
var utils_7$1 = utils$3.getItemClientSideWidth;
var utils_8$1 = utils$3.getInitialState;
var utils_9$1 = utils$3.getIfSlideIsVisbile;
var utils_10$1 = utils$3.getTransformForCenterMode;
var utils_11$1 = utils$3.getTransformForPartialVsibile;
var utils_12$1 = utils$3.isInLeftEnd;
var utils_13$1 = utils$3.isInRightEnd;
var utils_14$1 = utils$3.notEnoughChildren;
var utils_15$1 = utils$3.getSlidesToSlide;
var utils_16 = utils$3.throttle;
var utils_17 = utils$3.throwError;
var utils_18 = utils$3.populateNextSlides;
var utils_19 = utils$3.populatePreviousSlides;
var utils_20 = utils$3.populateSlidesOnMouseTouchMove;
var types = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics = function extendStatics(d, b) {
      return (_extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          b.hasOwnProperty(p) && (d[p] = b[p]);
        }
      })(d, b);
    };

    return function (d, b) {
      function __() {
        this.constructor = d;
      }

      _extendStatics(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();

  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  function isMouseMoveEvent(e) {
    return "clientY" in e;
  }

  exports.isMouseMoveEvent = isMouseMoveEvent;

  var Carousel = function (_super) {
    function Carousel() {
      return null !== _super && _super.apply(this, arguments) || this;
    }

    return __extends(Carousel, _super), Carousel;
  }(React.Component);

  exports.default = Carousel;
});
unwrapExports(types);
var types_1 = types.isMouseMoveEvent;
var dots = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  function getLookupTableForNextSlides(numberOfDotsToShow, state, props, childrenArr) {
    var table = {},
        slidesToSlide = common$1.getSlidesToSlide(state, props);
    return Array(numberOfDotsToShow).fill(0).forEach(function (_, i) {
      var nextSlide = clones.getOriginalCounterPart(i, state, childrenArr);
      if (0 === i) table[0] = nextSlide;else {
        var now = table[i - 1] + slidesToSlide;
        table[i] = now;
      }
    }), table;
  }

  exports.getLookupTableForNextSlides = getLookupTableForNextSlides;
});
unwrapExports(dots);
var dots_1 = dots.getLookupTableForNextSlides;
var Dots_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var Dots = function Dots(_a) {
    var props = _a.props,
        state = _a.state,
        goToSlide = _a.goToSlide,
        getState = _a.getState,
        showDots = props.showDots,
        customDot = props.customDot,
        dotListClass = props.dotListClass,
        infinite = props.infinite,
        children = props.children;
    if (!showDots || common$1.notEnoughChildren(state, props)) return null;
    var numberOfDotsToShow,
        currentSlide = state.currentSlide,
        slidesToShow = state.slidesToShow,
        slidesToSlide = common$1.getSlidesToSlide(state, props),
        childrenArr = React.Children.toArray(children);
    numberOfDotsToShow = infinite ? Math.ceil(childrenArr.length / slidesToSlide) : Math.ceil((childrenArr.length - slidesToShow) / slidesToSlide) + 1;
    var nextSlidesTable = dots.getLookupTableForNextSlides(numberOfDotsToShow, state, props, childrenArr),
        lookupTable = clones.getOriginalIndexLookupTableByClones(slidesToShow, childrenArr),
        currentSlides = lookupTable[currentSlide];
    return React.createElement("ul", {
      className: "react-multi-carousel-dot-list " + dotListClass
    }, Array(numberOfDotsToShow).fill(0).map(function (_, index) {
      var isActive, nextSlide;

      if (infinite) {
        nextSlide = nextSlidesTable[index];
        var cloneIndex = lookupTable[nextSlide];
        isActive = currentSlides === cloneIndex || cloneIndex <= currentSlides && currentSlides < cloneIndex + slidesToSlide;
      } else {
        var maximumNextSlide = childrenArr.length - slidesToShow,
            possibileNextSlides = index * slidesToSlide;
        isActive = (nextSlide = maximumNextSlide < possibileNextSlides ? maximumNextSlide : possibileNextSlides) === currentSlide || nextSlide < currentSlide && currentSlide < nextSlide + slidesToSlide && currentSlide < childrenArr.length - slidesToShow;
      }

      return customDot ? React.cloneElement(customDot, {
        index: index,
        active: isActive,
        key: index,
        onClick: function onClick() {
          return goToSlide(nextSlide);
        },
        carouselState: getState()
      }) : React.createElement("li", {
        "data-index": index,
        key: index,
        className: "react-multi-carousel-dot " + (isActive ? "react-multi-carousel-dot--active" : "")
      }, React.createElement("button", {
        onClick: function onClick() {
          return goToSlide(nextSlide);
        }
      }));
    }));
  };

  exports.default = Dots;
});
unwrapExports(Dots_1);
var Arrows = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var LeftArrow = function LeftArrow(_a) {
    var customLeftArrow = _a.customLeftArrow,
        getState = _a.getState,
        previous = _a.previous;
    return customLeftArrow ? React.cloneElement(customLeftArrow, {
      onClick: function onClick() {
        return previous();
      },
      carouselState: getState()
    }) : React.createElement("button", {
      "aria-label": "Go to previous slide",
      className: "react-multiple-carousel__arrow react-multiple-carousel__arrow--left",
      onClick: function onClick() {
        return previous();
      }
    });
  };

  exports.LeftArrow = LeftArrow;

  var RightArrow = function RightArrow(_a) {
    var customRightArrow = _a.customRightArrow,
        next = _a.next,
        getState = _a.getState;
    return customRightArrow ? React.cloneElement(customRightArrow, {
      onClick: function onClick() {
        return next();
      },
      carouselState: getState()
    }) : React.createElement("button", {
      "aria-label": "Go to next slide",
      className: "react-multiple-carousel__arrow react-multiple-carousel__arrow--right",
      onClick: function onClick() {
        return next();
      }
    });
  };

  exports.RightArrow = RightArrow;
});
unwrapExports(Arrows);
var Arrows_1 = Arrows.LeftArrow;
var Arrows_2 = Arrows.RightArrow;
var CarouselItems_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var CarouselItems = function CarouselItems(_a) {
    var props = _a.props,
        state = _a.state,
        goToSlide = _a.goToSlide,
        clones = _a.clones,
        itemWidth = state.itemWidth,
        children = props.children,
        infinite = props.infinite,
        itemClass = props.itemClass,
        partialVisbile = props.partialVisbile,
        partialVisible = props.partialVisible,
        _b = utils$3.getInitialState(state, props),
        flexBisis = _b.flexBisis,
        shouldRenderOnSSR = _b.shouldRenderOnSSR,
        domFullyLoaded = _b.domFullyLoaded,
        partialVisibilityGutter = _b.partialVisibilityGutter;

    return _b.shouldRenderAtAll ? (partialVisbile && console.warn('WARNING: Please correct props name: "partialVisible" as old typo will be removed in future versions!'), React.createElement(React.Fragment, null, (infinite ? clones : React.Children.toArray(children)).map(function (child, index) {
      return React.createElement("li", {
        key: index,
        "data-index": index,
        onClick: function onClick() {
          props.focusOnSelect && goToSlide(index);
        },
        "aria-hidden": utils$3.getIfSlideIsVisbile(index, state) ? "false" : "true",
        style: {
          flex: shouldRenderOnSSR ? "1 0 " + flexBisis + "%" : "auto",
          position: "relative",
          width: domFullyLoaded ? ((partialVisbile || partialVisible) && partialVisibilityGutter ? itemWidth - partialVisibilityGutter : itemWidth) + "px" : "auto"
        },
        className: "react-multi-carousel-item " + (utils$3.getIfSlideIsVisbile(index, state) ? "react-multi-carousel-item--active" : "") + " " + itemClass
      }, child);
    }))) : null;
  };

  exports.default = CarouselItems;
});
unwrapExports(CarouselItems_1);
var Carousel_1 = createCommonjsModule(function (module, exports) {
  var __extends = commonjsGlobal && commonjsGlobal.__extends || function () {
    var _extendStatics2 = function extendStatics(d, b) {
      return (_extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) {
          b.hasOwnProperty(p) && (d[p] = b[p]);
        }
      })(d, b);
    };

    return function (d, b) {
      function __() {
        this.constructor = d;
      }

      _extendStatics2(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }(),
      __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
    return (__assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        for (var p in s = arguments[i]) {
          Object.prototype.hasOwnProperty.call(s, p) && (t[p] = s[p]);
        }
      }

      return t;
    }).apply(this, arguments);
  };

  Object.defineProperty(exports, "__esModule", {
    value: !0
  });

  var defaultTransitionDuration = 400,
      defaultTransition = "transform 400ms ease-in-out",
      Carousel = function (_super) {
    function Carousel(props) {
      var _this = _super.call(this, props) || this;

      return _this.containerRef = React.createRef(), _this.listRef = React.createRef(), _this.state = {
        itemWidth: 0,
        slidesToShow: 0,
        currentSlide: 0,
        totalItems: React.Children.count(props.children),
        deviceType: "",
        domLoaded: !1,
        transform: 0,
        containerWidth: 0
      }, _this.onResize = _this.onResize.bind(_this), _this.handleDown = _this.handleDown.bind(_this), _this.handleMove = _this.handleMove.bind(_this), _this.handleOut = _this.handleOut.bind(_this), _this.onKeyUp = _this.onKeyUp.bind(_this), _this.handleEnter = _this.handleEnter.bind(_this), _this.setIsInThrottle = _this.setIsInThrottle.bind(_this), _this.next = utils$3.throttle(_this.next.bind(_this), props.transitionDuration || defaultTransitionDuration, _this.setIsInThrottle), _this.previous = utils$3.throttle(_this.previous.bind(_this), props.transitionDuration || defaultTransitionDuration, _this.setIsInThrottle), _this.goToSlide = utils$3.throttle(_this.goToSlide.bind(_this), props.transitionDuration || defaultTransitionDuration, _this.setIsInThrottle), _this.onMove = !1, _this.initialX = 0, _this.lastX = 0, _this.isAnimationAllowed = !1, _this.direction = "", _this.initialY = 0, _this.isInThrottle = !1, _this.transformPlaceHolder = 0, _this;
    }

    return __extends(Carousel, _super), Carousel.prototype.resetTotalItems = function () {
      var _this = this,
          totalItems = React.Children.count(this.props.children),
          currentSlide = utils$3.notEnoughChildren(this.state, this.props) ? 0 : Math.max(0, Math.min(this.state.currentSlide, totalItems));

      this.setState({
        totalItems: totalItems,
        currentSlide: currentSlide
      }, function () {
        _this.setContainerAndItemWidth(_this.state.slidesToShow, !0);
      });
    }, Carousel.prototype.setIsInThrottle = function (isInThrottle) {
      void 0 === isInThrottle && (isInThrottle = !1), this.isInThrottle = isInThrottle;
    }, Carousel.prototype.setTransformDirectly = function (position, withAnimation) {
      var additionalTransfrom = this.props.additionalTransfrom,
          currentTransform = common$1.getTransform(this.state, this.props, position);
      this.transformPlaceHolder = position, this.listRef && this.listRef.current && (this.setAnimationDirectly(withAnimation), this.listRef.current.style.transform = "translate3d(" + (currentTransform + additionalTransfrom) + "px,0,0)");
    }, Carousel.prototype.setAnimationDirectly = function (animationAllowed) {
      this.listRef && this.listRef.current && (this.listRef.current.style.transition = animationAllowed ? this.props.customTransition || defaultTransition : "none");
    }, Carousel.prototype.componentDidMount = function () {
      this.setState({
        domLoaded: !0
      }), this.setItemsToShow(), window.addEventListener("resize", this.onResize), this.onResize(!0), this.props.keyBoardControl && window.addEventListener("keyup", this.onKeyUp), this.props.autoPlay && this.props.autoPlaySpeed && (this.autoPlay = setInterval(this.next, this.props.autoPlaySpeed));
    }, Carousel.prototype.setClones = function (slidesToShow, itemWidth, forResizing, resetCurrentSlide) {
      var _this = this;

      void 0 === resetCurrentSlide && (resetCurrentSlide = !1), this.isAnimationAllowed = !1;
      var childrenArr = React.Children.toArray(this.props.children),
          initialSlide = utils$3.getInitialSlideInInfiniteMode(slidesToShow || this.state.slidesToShow, childrenArr),
          clones = utils$3.getClones(this.state.slidesToShow, childrenArr),
          currentSlide = childrenArr.length < this.state.slidesToShow ? 0 : this.state.currentSlide;
      this.setState({
        totalItems: clones.length,
        currentSlide: forResizing && !resetCurrentSlide ? currentSlide : initialSlide
      }, function () {
        _this.correctItemsPosition(itemWidth || _this.state.itemWidth);
      });
    }, Carousel.prototype.setItemsToShow = function (shouldCorrectItemPosition, resetCurrentSlide) {
      var _this = this,
          responsive = this.props.responsive;

      Object.keys(responsive).forEach(function (item) {
        var _a = responsive[item],
            breakpoint = _a.breakpoint,
            items = _a.items,
            max = breakpoint.max,
            min = breakpoint.min;
        window.innerWidth >= min && window.innerWidth <= max && (_this.setState({
          slidesToShow: items,
          deviceType: item
        }), _this.setContainerAndItemWidth(items, shouldCorrectItemPosition, resetCurrentSlide));
      });
    }, Carousel.prototype.setContainerAndItemWidth = function (slidesToShow, shouldCorrectItemPosition, resetCurrentSlide) {
      var _this = this;

      if (this.containerRef && this.containerRef.current) {
        var containerWidth = this.containerRef.current.offsetWidth,
            itemWidth_1 = utils$3.getItemClientSideWidth(this.props, slidesToShow, containerWidth);
        this.setState({
          containerWidth: containerWidth,
          itemWidth: itemWidth_1
        }, function () {
          _this.props.infinite && _this.setClones(slidesToShow, itemWidth_1, shouldCorrectItemPosition, resetCurrentSlide);
        }), shouldCorrectItemPosition && this.correctItemsPosition(itemWidth_1);
      }
    }, Carousel.prototype.correctItemsPosition = function (itemWidth, isAnimationAllowed, setToDomDirectly) {
      isAnimationAllowed && (this.isAnimationAllowed = !0), !isAnimationAllowed && this.isAnimationAllowed && (this.isAnimationAllowed = !1);
      var nextTransform = this.state.totalItems < this.state.slidesToShow ? 0 : -itemWidth * this.state.currentSlide;
      setToDomDirectly && this.setTransformDirectly(nextTransform, !0), this.setState({
        transform: nextTransform
      });
    }, Carousel.prototype.onResize = function (value) {
      var shouldCorrectItemPosition;
      shouldCorrectItemPosition = !!this.props.infinite && ("boolean" != typeof value || !value), this.setItemsToShow(shouldCorrectItemPosition, !0);
    }, Carousel.prototype.componentDidUpdate = function (_a, _b) {
      var _this = this,
          keyBoardControl = _a.keyBoardControl,
          autoPlay = _a.autoPlay,
          children = _a.children,
          containerWidth = _b.containerWidth,
          domLoaded = _b.domLoaded,
          currentSlide = _b.currentSlide;

      this.containerRef && this.containerRef.current && this.containerRef.current.offsetWidth !== containerWidth && setTimeout(function () {
        _this.setItemsToShow(!0);
      }, this.props.transitionDuration || defaultTransitionDuration), keyBoardControl && !this.props.keyBoardControl && window.removeEventListener("keyup", this.onKeyUp), !keyBoardControl && this.props.keyBoardControl && window.addEventListener("keyup", this.onKeyUp), autoPlay && !this.props.autoPlay && this.autoPlay && (clearInterval(this.autoPlay), this.autoPlay = void 0), autoPlay || !this.props.autoPlay || this.autoPlay || (this.autoPlay = setInterval(this.next, this.props.autoPlaySpeed)), children.length !== this.props.children.length ? setTimeout(function () {
        _this.props.infinite ? _this.setClones(_this.state.slidesToShow, _this.state.itemWidth, !0, !0) : _this.resetTotalItems();
      }, this.props.transitionDuration || defaultTransitionDuration) : this.props.infinite && this.state.currentSlide !== currentSlide && this.correctClonesPosition({
        domLoaded: domLoaded
      }), this.transformPlaceHolder !== this.state.transform && (this.transformPlaceHolder = this.state.transform);
    }, Carousel.prototype.correctClonesPosition = function (_a) {
      var _this = this,
          domLoaded = _a.domLoaded,
          childrenArr = React.Children.toArray(this.props.children),
          _b = utils$3.checkClonesPosition(this.state, childrenArr, this.props),
          isReachingTheEnd = _b.isReachingTheEnd,
          isReachingTheStart = _b.isReachingTheStart,
          nextSlide = _b.nextSlide,
          nextPosition = _b.nextPosition;

      this.state.domLoaded && domLoaded && (isReachingTheEnd || isReachingTheStart) && (this.isAnimationAllowed = !1, setTimeout(function () {
        _this.setState({
          transform: nextPosition,
          currentSlide: nextSlide
        });
      }, this.props.transitionDuration || defaultTransitionDuration));
    }, Carousel.prototype.next = function (slidesHavePassed) {
      var _this = this;

      void 0 === slidesHavePassed && (slidesHavePassed = 0);
      var _a = this.props,
          afterChange = _a.afterChange,
          beforeChange = _a.beforeChange;

      if (!utils$3.notEnoughChildren(this.state, this.props)) {
        var _b = utils$3.populateNextSlides(this.state, this.props, slidesHavePassed),
            nextSlides = _b.nextSlides,
            nextPosition = _b.nextPosition,
            previousSlide = this.state.currentSlide;

        void 0 !== nextSlides && void 0 !== nextPosition && ("function" == typeof beforeChange && beforeChange(nextSlides, this.getState()), this.isAnimationAllowed = !0, this.setState({
          transform: nextPosition,
          currentSlide: nextSlides
        }, function () {
          "function" == typeof afterChange && setTimeout(function () {
            afterChange(previousSlide, _this.getState());
          }, _this.props.transitionDuration || defaultTransitionDuration);
        }));
      }
    }, Carousel.prototype.previous = function (slidesHavePassed) {
      var _this = this;

      void 0 === slidesHavePassed && (slidesHavePassed = 0);
      var _a = this.props,
          afterChange = _a.afterChange,
          beforeChange = _a.beforeChange;

      if (!utils$3.notEnoughChildren(this.state, this.props)) {
        var _b = utils$3.populatePreviousSlides(this.state, this.props, slidesHavePassed),
            nextSlides = _b.nextSlides,
            nextPosition = _b.nextPosition;

        if (void 0 !== nextSlides && void 0 !== nextPosition) {
          var previousSlide = this.state.currentSlide;
          "function" == typeof beforeChange && beforeChange(nextSlides, this.getState()), this.isAnimationAllowed = !0, this.setState({
            transform: nextPosition,
            currentSlide: nextSlides
          }, function () {
            "function" == typeof afterChange && setTimeout(function () {
              afterChange(previousSlide, _this.getState());
            }, _this.props.transitionDuration || defaultTransitionDuration);
          });
        }
      }
    }, Carousel.prototype.componentWillUnmount = function () {
      window.removeEventListener("resize", this.onResize), this.props.keyBoardControl && window.removeEventListener("keyup", this.onKeyUp), this.props.autoPlay && this.autoPlay && (clearInterval(this.autoPlay), this.autoPlay = void 0);
    }, Carousel.prototype.resetMoveStatus = function () {
      this.onMove = !1, this.initialX = 0, this.lastX = 0, this.direction = "", this.initialY = 0;
    }, Carousel.prototype.handleDown = function (e) {
      if (!(!types.isMouseMoveEvent(e) && !this.props.swipeable || types.isMouseMoveEvent(e) && !this.props.draggable || this.isInThrottle)) {
        var _a = types.isMouseMoveEvent(e) ? e : e.touches[0],
            clientX = _a.clientX,
            clientY = _a.clientY;

        this.onMove = !0, this.initialX = clientX, this.initialY = clientY, this.lastX = clientX, this.isAnimationAllowed = !1;
      }
    }, Carousel.prototype.handleMove = function (e) {
      if (!(!types.isMouseMoveEvent(e) && !this.props.swipeable || types.isMouseMoveEvent(e) && !this.props.draggable || utils$3.notEnoughChildren(this.state, this.props))) {
        var _a = types.isMouseMoveEvent(e) ? e : e.touches[0],
            clientX = _a.clientX,
            clientY = _a.clientY,
            diffX = this.initialX - clientX,
            diffY = this.initialY - clientY;

        if (!types.isMouseMoveEvent(e) && this.autoPlay && this.props.autoPlay && (clearInterval(this.autoPlay), this.autoPlay = void 0), this.onMove) {
          if (!(Math.abs(diffX) > Math.abs(diffY))) return;

          var _b = utils$3.populateSlidesOnMouseTouchMove(this.state, this.props, this.initialX, this.lastX, clientX, this.transformPlaceHolder),
              direction = _b.direction,
              nextPosition = _b.nextPosition,
              canContinue = _b.canContinue;

          direction && (this.direction = direction, canContinue && void 0 !== nextPosition && this.setTransformDirectly(nextPosition)), this.lastX = clientX;
        }
      }
    }, Carousel.prototype.handleOut = function (e) {
      this.props.autoPlay && !this.autoPlay && (this.autoPlay = setInterval(this.next, this.props.autoPlaySpeed));
      var shouldDisableOnMobile = "touchend" === e.type && !this.props.swipeable,
          shouldDisableOnDesktop = ("mouseleave" === e.type || "mouseup" === e.type) && !this.props.draggable;

      if (!shouldDisableOnMobile && !shouldDisableOnDesktop && this.onMove) {
        if (this.setAnimationDirectly(!0), "right" === this.direction) if (this.initialX - this.lastX >= this.props.minimumTouchDrag) {
          var slidesHavePassed = Math.round((this.initialX - this.lastX) / this.state.itemWidth);
          this.next(slidesHavePassed);
        } else this.correctItemsPosition(this.state.itemWidth, !0, !0);
        if ("left" === this.direction) if (this.lastX - this.initialX > this.props.minimumTouchDrag) {
          slidesHavePassed = Math.round((this.lastX - this.initialX) / this.state.itemWidth);
          this.previous(slidesHavePassed);
        } else this.correctItemsPosition(this.state.itemWidth, !0, !0);
        this.resetMoveStatus();
      }
    }, Carousel.prototype.onKeyUp = function (e) {
      switch (e.keyCode) {
        case 37:
          return this.previous();

        case 39:
          return this.next();
      }
    }, Carousel.prototype.handleEnter = function () {
      this.autoPlay && this.props.autoPlay && (clearInterval(this.autoPlay), this.autoPlay = void 0);
    }, Carousel.prototype.goToSlide = function (slide, skipCallbacks) {
      var _this = this;

      if (!this.isInThrottle) {
        var itemWidth = this.state.itemWidth,
            _a = this.props,
            afterChange = _a.afterChange,
            beforeChange = _a.beforeChange,
            previousSlide = this.state.currentSlide;
        "function" != typeof beforeChange || skipCallbacks && ("object" != typeof skipCallbacks || skipCallbacks.skipBeforeChange) || beforeChange(slide, this.getState()), this.isAnimationAllowed = !0, this.setState({
          currentSlide: slide,
          transform: -itemWidth * slide
        }, function () {
          _this.props.infinite && _this.correctClonesPosition({
            domLoaded: !0
          }), "function" != typeof afterChange || skipCallbacks && ("object" != typeof skipCallbacks || skipCallbacks.skipAfterChange) || setTimeout(function () {
            afterChange(previousSlide, _this.getState());
          }, _this.props.transitionDuration || defaultTransitionDuration);
        });
      }
    }, Carousel.prototype.getState = function () {
      return __assign({}, this.state, {
        onMove: this.onMove,
        direction: this.direction
      });
    }, Carousel.prototype.renderLeftArrow = function () {
      var _this = this,
          customLeftArrow = this.props.customLeftArrow;

      return React.createElement(Arrows.LeftArrow, {
        customLeftArrow: customLeftArrow,
        getState: function getState() {
          return _this.getState();
        },
        previous: this.previous
      });
    }, Carousel.prototype.renderRightArrow = function () {
      var _this = this,
          customRightArrow = this.props.customRightArrow;

      return React.createElement(Arrows.RightArrow, {
        customRightArrow: customRightArrow,
        getState: function getState() {
          return _this.getState();
        },
        next: this.next
      });
    }, Carousel.prototype.renderButtonGroups = function () {
      var _this = this,
          customButtonGroup = this.props.customButtonGroup;

      return customButtonGroup ? React.cloneElement(customButtonGroup, {
        previous: function previous() {
          return _this.previous();
        },
        next: function next() {
          return _this.next();
        },
        goToSlide: function goToSlide(slideIndex, skipCallbacks) {
          return _this.goToSlide(slideIndex, skipCallbacks);
        },
        carouselState: this.getState()
      }) : null;
    }, Carousel.prototype.renderDotsList = function () {
      var _this = this;

      return React.createElement(Dots_1.default, {
        state: this.state,
        props: this.props,
        goToSlide: this.goToSlide,
        getState: function getState() {
          return _this.getState();
        }
      });
    }, Carousel.prototype.renderCarouselItems = function () {
      var clones = [];

      if (this.props.infinite) {
        var childrenArr = React.Children.toArray(this.props.children);
        clones = utils$3.getClones(this.state.slidesToShow, childrenArr);
      }

      return React.createElement(CarouselItems_1.default, {
        clones: clones,
        goToSlide: this.goToSlide,
        state: this.state,
        props: this.props
      });
    }, Carousel.prototype.render = function () {
      var _a = this.props,
          deviceType = _a.deviceType,
          arrows = _a.arrows,
          removeArrowOnDeviceType = _a.removeArrowOnDeviceType,
          infinite = _a.infinite,
          containerClass = _a.containerClass,
          sliderClass = _a.sliderClass,
          customTransition = _a.customTransition,
          additionalTransfrom = _a.additionalTransfrom,
          renderDotsOutside = _a.renderDotsOutside,
          renderButtonGroupOutside = _a.renderButtonGroupOutside,
          className = _a.className;
      "production" !== process.env.NODE_ENV && utils$3.throwError(this.state, this.props);

      var _b = utils$3.getInitialState(this.state, this.props),
          shouldRenderOnSSR = _b.shouldRenderOnSSR,
          shouldRenderAtAll = _b.shouldRenderAtAll,
          isLeftEndReach = utils$3.isInLeftEnd(this.state),
          isRightEndReach = utils$3.isInRightEnd(this.state),
          shouldShowArrows = arrows && !(removeArrowOnDeviceType && (deviceType && -1 < removeArrowOnDeviceType.indexOf(deviceType) || this.state.deviceType && -1 < removeArrowOnDeviceType.indexOf(this.state.deviceType))) && !utils$3.notEnoughChildren(this.state, this.props) && shouldRenderAtAll,
          disableLeftArrow = !infinite && isLeftEndReach,
          disableRightArrow = !infinite && isRightEndReach,
          currentTransform = common$1.getTransform(this.state, this.props);

      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: "react-multi-carousel-list " + containerClass + " " + className,
        ref: this.containerRef
      }, React.createElement("ul", {
        ref: this.listRef,
        className: "react-multi-carousel-track " + sliderClass,
        style: {
          transition: this.isAnimationAllowed ? customTransition || defaultTransition : "none",
          overflow: shouldRenderOnSSR ? "hidden" : "unset",
          transform: "translate3d(" + (currentTransform + additionalTransfrom) + "px,0,0)"
        },
        onMouseMove: this.handleMove,
        onMouseDown: this.handleDown,
        onMouseUp: this.handleOut,
        onMouseEnter: this.handleEnter,
        onMouseLeave: this.handleOut,
        onTouchStart: this.handleDown,
        onTouchMove: this.handleMove,
        onTouchEnd: this.handleOut
      }, this.renderCarouselItems()), shouldShowArrows && !disableLeftArrow && this.renderLeftArrow(), shouldShowArrows && !disableRightArrow && this.renderRightArrow(), shouldRenderAtAll && !renderButtonGroupOutside && this.renderButtonGroups(), shouldRenderAtAll && !renderDotsOutside && this.renderDotsList()), shouldRenderAtAll && renderDotsOutside && this.renderDotsList(), shouldRenderAtAll && renderButtonGroupOutside && this.renderButtonGroups());
    }, Carousel.defaultProps = {
      slidesToSlide: 1,
      infinite: !1,
      draggable: !0,
      swipeable: !0,
      arrows: !0,
      containerClass: "",
      sliderClass: "",
      itemClass: "",
      keyBoardControl: !0,
      autoPlaySpeed: 3e3,
      showDots: !1,
      renderDotsOutside: !1,
      renderButtonGroupOutside: !1,
      minimumTouchDrag: 80,
      className: "",
      dotListClass: "",
      focusOnSelect: !1,
      centerMode: !1,
      additionalTransfrom: 0
    }, Carousel;
  }(React.Component);

  exports.default = Carousel;
});
var Carousel = unwrapExports(Carousel_1);
var css$3 = "@font-face{font-family:\"revicons\";fallback:fallback;src:url(\"data:font/woff;base64,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\") format('woff'),url(\"data:font/ttf;base64,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\") format('ttf'),url(\"data:application/vnd.ms-fontobject;base64,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\") format('ttf')}.react-multi-carousel-list{display:flex;align-items:center;overflow:hidden;position:relative}.react-multi-carousel-track{list-style:none;padding:0;margin:0;display:flex;flex-direction:row;position:relative;transform-style:preserve-3d;backface-visibility:hidden;will-change:transform,transition}.react-multiple-carousel__arrow{position:absolute;outline:0;transition:all .5s;border-radius:35px;z-index:1000;border:0;background:rgba(0,0,0,0.5);min-width:43px;min-height:43px;opacity:1;cursor:pointer}.react-multiple-carousel__arrow:hover{background:rgba(0,0,0,0.8)}.react-multiple-carousel__arrow::before{font-size:20px;color:#fff;display:block;font-family:revicons;text-align:center;z-index:2;position:relative}.react-multiple-carousel__arrow--left{left:calc(4% + 1px)}.react-multiple-carousel__arrow--left::before{content:\"\\e824\"}.react-multiple-carousel__arrow--right{right:calc(4% + 1px)}.react-multiple-carousel__arrow--right::before{content:\"\\e825\"}.react-multi-carousel-dot-list{position:absolute;bottom:0;display:flex;left:0;right:0;justify-content:center;margin:auto;padding:0;margin:0;list-style:none;text-align:center}.react-multi-carousel-dot button{display:inline-block;width:12px;height:12px;border-radius:50%;opacity:1;padding:5px 5px 5px 5px;box-shadow:none;transition:background .5s;border-width:2px;border-style:solid;border-color:grey;padding:0;margin:0;margin-right:6px;outline:0;cursor:pointer}.react-multi-carousel-dot button:hover{background:#080808}.react-multi-carousel-dot--active button{background:#080808}.react-multi-carousel-item{transform-style:preserve-3d;backface-visibility:hidden}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.react-multi-carousel-item{flex-shrink:0 !important}.react-multi-carousel-track{overflow:visible !important}}";
styleInject(css$3); // import {useTheme} from '@material-ui/styles';

HeroCarousel.propTypes = {
  title: string,
  children: node.isRequired // intended children are <HeroCard>s, or boxes surrounding Hero Cards

};
var carouselResponsiveConfig = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 900
    },
    items: 5,
    slidesToSlide: 4
  },
  tablet: {
    breakpoint: {
      max: 900,
      min: 564
    },
    items: 4,
    slidesToSlide: 3
  },
  mobile: {
    breakpoint: {
      max: 564,
      min: 0
    },
    items: 2,
    slidesToSlide: 2
  }
};

function HeroCarousel(props) {
  var title = props.title,
      children = props.children;
  var classes = useStyles$y(); // const theme = useTheme();

  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("h2", {
    className: classes.sectionHeader
  }, title), "             ", /*#__PURE__*/React.createElement(Carousel, {
    responsive: carouselResponsiveConfig
  }, children.map(function (child, index) {
    return /*#__PURE__*/React.createElement(Box, {
      m: 1,
      key: index
    }, child);
  })));
}

var useStyles$y = makeStyles$1(function (theme) {
  return {
    sectionHeader: _objectSpread2({}, theme.typographyClasses.sectionHeader)
  };
});

var Textarea = /*#__PURE__*/function (_React$Component) {
  function Textarea() {
    var _this;

    _classCallCheck(this, Textarea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_this = _callSuper(this, Textarea, [].concat(args)), _this.shouldShrinkLabel = function () {
      return {
        shrink: true
      };
    }, _assertThisInitialized(_this)));
  }

  _inherits(Textarea, _React$Component);

  return _createClass(Textarea, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TextField$1$1, _extends({
        multiline: true,
        InputLabelProps: this.shouldShrinkLabel()
      }, this.props));
    }
  }]);
}(React.Component);

var REGISTRATION_NEEDED = {
  value: '-1',
  variant: 'info',
  message: 'Registration is required to bid in this auction.'
};
var REGISTRATION_PENDING = {
  value: '0',
  variant: 'warning',
  message: 'Your request to participate in this event is currently under review. Please contact customer service for assistance.'
};
var REGISTRATION_ACCEPTED = {
  value: '1',
  variant: 'success',
  message: 'Congratulations! You are now approved to bid in this auction!'
};
var REGISTRATION_DECLINED = {
  value: '2',
  variant: 'error',
  message: 'Your request to participate in this event has been declined. Please contact customer service for assistance.'
};
var REGISTRATION_REVIEWED = {
  value: '4',
  variant: 'warning',
  message: 'Your request to participate in this event is currently under review. Please contact customer service for assistance.'
};
var DEFAULT_ERROR = {
  variant: 'error',
  message: 'An error occured while processing your request to bid. Please contact customer service for assistance.'
};

var getMgStatus = function getMgStatus(status) {
  switch (status) {
    case REGISTRATION_ACCEPTED.value:
      return REGISTRATION_ACCEPTED;

    case REGISTRATION_PENDING.value:
      return REGISTRATION_PENDING;

    case REGISTRATION_REVIEWED.value:
      return REGISTRATION_REVIEWED;

    case REGISTRATION_NEEDED.value:
      return REGISTRATION_NEEDED;

    case REGISTRATION_DECLINED.value:
      return REGISTRATION_DECLINED;

    default:
      return DEFAULT_ERROR;
  }
};

var registerBidder = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(clientProxyUrl, bidderId, auctionId) {
    var requestUrl;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            requestUrl = "".concat(clientProxyUrl, "/bidders/v1/").concat(bidderId, "/registration/auction/").concat(auctionId);
            _context.next = 3;
            return axiosInstance.post(requestUrl).then(function (response) {
              return response;
            })["catch"](function (error) {
              var errorResponse = error.response.data;
              EventService.dispatchEvent(errorResponse.responseCode ? errorResponse.responseCode : errorResponse.messages[0] && errorResponse.messages[0].code);
              return 'ERROR';
            });

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function registerBidder(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var getBidderRegistration = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(clientProxyUrl, bidderId, auctionId) {
    var requestUrl;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            requestUrl = "".concat(clientProxyUrl, "/bidders/v1/").concat(bidderId, "/registration/auction/").concat(auctionId);
            _context2.next = 3;
            return axiosInstance.get(requestUrl).then(function (response) {
              return response;
            })["catch"](function (error) {
              var errorResponse = error.response.data;
              EventService.dispatchEvent(errorResponse.responseCode ? errorResponse.responseCode : errorResponse.messages[0] && errorResponse.messages[0].code);
              return 'ERROR';
            });

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getBidderRegistration(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var getBidderCcInfo = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(clientProxyUrl, bidderId, auctionId, coreToken) {
    var requestUrl;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            requestUrl = "".concat(clientProxyUrl, "/bidders/v1/creditCardInfo/auction?").concat(lib.stringify({
              bidderId: bidderId,
              auctionId: auctionId,
              coreToken: coreToken
            }));
            _context3.next = 3;
            return axiosInstance.get(requestUrl).then(function (response) {
              return response;
            })["catch"](function (error) {
              console.error(error);
              return null;
            });

          case 3:
            return _context3.abrupt("return", _context3.sent);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getBidderCcInfo(_x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

var handleAgStatusResponse = function handleAgStatusResponse(auctionGuardStatus) {
  var returnValue;

  switch (auctionGuardStatus) {
    // Approved Cases
    case 'APPROVED_WHITELIST_AUCTION_COMPANY':
    case 'APPROVED_WHITELIST_PROXIBID':
    case 'APPROVED':
      returnValue = REGISTRATION_ACCEPTED.value;
      break;
    // Declined Cases

    case 'DECLINED_BLACKLIST':
    case 'DECLINED_BLACK_FLAG':
    case 'BANNED_COUNTRY':
    case 'DECLINED':
    case 'PENDING_IP_NOT_TRUSTED':
    case 'PENDING_BAD_SCORE':
    case 'PENDING_FAILED_SSN_VERIY':
    case 'PENDING_FRAUD':
    case 'PENDING_CREDIT_CARD_CHECK_FAILED':
      returnValue = REGISTRATION_DECLINED.value;
      break;
    // Pending cases should fire an event to consumer

    case 'PENDING_FINANCIAL_QUESTIONNAIRE':
    case 'PENDING_BIDDER_COULD_NOT_GET_CC':
    case 'PENDING_EMAIL_VERIFICATION':
    case 'PENDING_NEED_SCORE':
    case 'PENDING_WAITING_FOR_SCORE':
    case 'PENDING_NO_CC_ON_FILE':
    case 'PENDING_NEED_SSN':
    case 'PENDING_NEED_CURP':
    case 'PENDING_IP_NOT_IN_AUCTION_COUNTRY':
    case 'PENDING_BILLING_ADDRESS_NOT_IN_AUCTION_COUNTRY':
    case 'PENDING_CALL_AUCTION_COMPANY_WHITE_LIST':
    case 'PENDING_NEED_MANUAL_APPROVAL':
    case 'PENDING_CALL_PROXIBID':
    case 'PENDING_CREDIT_CARD_VENDOR_DOWN':
    case 'PENDING_NEED_TELESIGN_VERIFICATION':
    case 'PENDING_NEED_DEPOSIT':
    case 'PENDING_AUTO_DEPOSIT':
      returnValue = REGISTRATION_PENDING.value;
      break;
    // Error Cases

    case 'PROCESSING':
    case 'ERROR_GENERAL_EXCEPTION':
    default:
      returnValue = DEFAULT_ERROR.value;
  }

  EventService.dispatchEvent(auctionGuardStatus);
  return returnValue;
};

function MarketguardMessage(props) {
  var registrationStatus = props.registrationStatus,
      clientProxyUrl = props.clientProxyUrl,
      bidderId = props.bidderId,
      auctionId = props.auctionId;

  var _useState = useState(registrationStatus ? registrationStatus : null),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    setStatus(props.registrationStatus);
  }, [props.registrationStatus]);
  useEffect(function () {
    getMgMessage(status);
  }, [status]);

  var getMessageAction = function getMessageAction(status) {
    if (loading) {
      return /*#__PURE__*/React.createElement(CircularProgress, {
        color: "white",
        size: 10
      });
    } else {
      return status === REGISTRATION_NEEDED.value ? 'Click here to Register' : '';
    }
  };

  var getStatus = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var bidderStatusResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return getBidderRegistration(clientProxyUrl, bidderId, auctionId);

            case 3:
              bidderStatusResponse = _context.sent;
              setLoading(false);
              handleStatusResponse(bidderStatusResponse.data && bidderStatusResponse.data.bidderRegistrationStatus);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getStatus() {
      return _ref.apply(this, arguments);
    };
  }();

  var getMgMessage = function getMgMessage(status) {
    status == undefined && setStatus(getStatus());
    var mgStatus = getMgStatus(status);
    return /*#__PURE__*/React.createElement(Message, {
      id: 'marketguard-message',
      variant: loading ? 'info' : mgStatus.variant,
      action: getMessageAction(status),
      onActionClick: function onActionClick() {
        return !loading && handleRegisterClick();
      }
    }, loading ? 'Fetching Data...' : mgStatus.message);
  };

  var handleRegisterClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var bidderStatusResponse;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return registerBidder(clientProxyUrl, bidderId, auctionId);

            case 3:
              bidderStatusResponse = _context2.sent;
              setLoading(false);
              bidderStatusResponse.data ? handleStatusResponse(bidderStatusResponse.data.bidderRegistrationStatus, bidderStatusResponse.data.auctionGuardStatus) : handleStatusResponse(bidderStatusResponse);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRegisterClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleStatusResponse = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(brStatus, agStatus) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = brStatus;
              _context3.next = _context3.t0 === 'REGISTRATION_ACCEPTED' ? 3 : _context3.t0 === 'PROCESSING_PENDING_REVIEWED' ? 5 : _context3.t0 === 'REGISTRATION_DECLINED' ? 7 : _context3.t0 === 'REGISTRATION_NEEDED' ? 9 : _context3.t0 === 'NEW_REGISTRATION' ? 11 : _context3.t0 === 'ERROR' ? 13 : 13;
              break;

            case 3:
              setStatus(REGISTRATION_ACCEPTED.value);
              return _context3.abrupt("break", 14);

            case 5:
              setStatus(REGISTRATION_PENDING.value);
              return _context3.abrupt("break", 14);

            case 7:
              setStatus(REGISTRATION_DECLINED.value);
              return _context3.abrupt("break", 14);

            case 9:
              setStatus(REGISTRATION_NEEDED.value);
              return _context3.abrupt("break", 14);

            case 11:
              setStatus(handleAgStatusResponse(agStatus));
              return _context3.abrupt("break", 14);

            case 13:
              setStatus('ERROR');

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleStatusResponse(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return getMgMessage(status);
}

MarketguardMessage.propTypes = {
  registrationStatus: PropTypes__default.string,
  clientProxyUrl: PropTypes__default.string,
  bidderId: PropTypes__default.string,
  auctionId: PropTypes__default.string
};
var useStyles$z = makeStyles$2(function (theme) {
  return {
    button: {
      margin: theme.spacing(1),
      borderColor: 'rgba(255,255,255, .23)',
      color: theme.palette.common.white
    },
    gridRoot: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    depositMessage: {
      fontSize: theme.fontSize
    }
  };
});

function DepositRequiredMessage(props) {
  var options = props.options,
      clientProxyUrl = props.clientProxyUrl,
      bidderId = props.bidderId,
      auctionId = props.auctionId,
      coreToken = props.coreToken,
      variant = props.variant;
  var classes = useStyles$z();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState({
    id: null,
    token: null,
    lastFour: null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      ccInfo = _useState4[0],
      setCcInfo = _useState4[1];

  var _useState5 = useState(REGISTRATION_NEEDED.value),
      _useState6 = _slicedToArray(_useState5, 2),
      mgStatus = _useState6[0],
      setMgStatus = _useState6[1];

  useEffect(function () {
    (function () {
      var _fetchBidderCcInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ccResponse;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getBidderCcInfo(clientProxyUrl, bidderId, auctionId, coreToken);

              case 2:
                ccResponse = _context.sent;

                if (ccResponse != undefined) {
                  setCcInfo(ccResponse.data);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function fetchBidderCcInfo() {
        return _fetchBidderCcInfo.apply(this, arguments);
      }

      return fetchBidderCcInfo;
    })()();
  }, []);

  var handleDepositSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var depositMode,
          bidderStatusResponse,
          _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              depositMode = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 0;

              if (!(depositMode === 0)) {
                _context2.next = 9;
                break;
              }

              setLoading(true);
              _context2.next = 5;
              return registerBidder(clientProxyUrl, bidderId, auctionId);

            case 5:
              bidderStatusResponse = _context2.sent;
              handleStatusResponse(bidderStatusResponse.data.auctionGuardStatus, bidderStatusResponse.data.bidderRegistrationStatus);
              _context2.next = 10;
              break;

            case 9:
              if (depositMode === 1) {
                EventService.dispatchEvent('SUBMIT_DEPOSIT_CHANGE_CC');
              }

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDepositSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleStatusResponse = function handleStatusResponse(agStatus, brStatus) {
    if (brStatus === REGISTRATION_DECLINED) {
      setMgStatus(REGISTRATION_DECLINED.value);
      return getMgBanner(mgStatus);
    }

    if (agStatus === 'PENDING_NEED_DEPOSIT' || agStatus === 'PENDING_AUTO_DEPOSIT') {
      if (brStatus === 'NEW_REGISTRATION') {
        handleDepositRequired();
      } else {
        EventService.dispatchEvent('sendRegistrationEmail', {
          registrationStatus: REGISTRATION_PENDING.value
        });
        EventService.dispatchEvent(agStatus);
      }
    } else {
      EventService.dispatchEvent(agStatus);
    }
  };

  var handleDepositRequired = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              EventService.dispatchEvent('SUBMIT_DEPOSIT', {
                bid: bidderId,
                ccId: ccInfo.id,
                token: ccInfo.token,
                aid: auctionId,
                amount: options.amount
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDepositRequired() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getMgBanner = function getMgBanner(status) {
    return /*#__PURE__*/React.createElement(MarketguardMessage, {
      registrationStatus: status,
      clientProxyUrl: clientProxyUrl,
      bidderId: bidderId,
      auctionId: auctionId
    });
  };

  var getDepositBanner = function getDepositBanner() {
    if (variant === 'small') {
      return /*#__PURE__*/React.createElement(Message, {
        variant: "info"
      }, /*#__PURE__*/React.createElement(Grid$1, {
        container: true,
        className: classes.gridRoot
      }, /*#__PURE__*/React.createElement(Typography, {
        className: classes.depositMessage
      }, loading ? 'Please wait while we process your information...' : "A deposit of ".concat(options.currency).concat(options.amount, " is required to bid. Please select a card to continue.")), !loading && /*#__PURE__*/React.createElement(Box, null, ccInfo.lastFour && /*#__PURE__*/React.createElement(Button, {
        id: "submit-deposit-button-banner",
        className: classes.button,
        variant: "outlined",
        onClick: function onClick() {
          return handleDepositSubmit();
        }
      }, "USE CARD ENDING IN ".concat(ccInfo.lastFour)), /*#__PURE__*/React.createElement(Button, {
        id: "select-card-deposit-button-banner",
        className: classes.button,
        variant: "outlined",
        onClick: function onClick() {
          return !loading && handleDepositSubmit(1);
        }
      }, loading ? /*#__PURE__*/React.createElement(CircularProgress, {
        size: 10,
        color: "white"
      }) : 'Select Payment'))));
    } else if (props.variant === 'large') {
      return /*#__PURE__*/React.createElement(BigMessage, {
        Icon: loading ? CircularProgress : ReportProblemOutlinedIcon$1,
        type: "info",
        secondary: !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, null, ccInfo.lastFour && /*#__PURE__*/React.createElement(Button, {
          id: "submit-deposit-button-modal",
          className: classes.button,
          variant: "contained",
          color: "primary",
          onClick: function onClick() {
            return handleDepositSubmit();
          }
        }, "USE CARD ENDING IN ".concat(ccInfo.lastFour)), /*#__PURE__*/React.createElement(Button, {
          id: "select-card-deposit-button-modal",
          className: classes.button,
          variant: "contained",
          color: "primary",
          onClick: function onClick() {
            return !loading && handleDepositSubmit(1);
          }
        }, loading ? /*#__PURE__*/React.createElement(CircularProgress, {
          size: 10,
          color: "white"
        }) : 'Select Payment')))
      }, loading ? 'Please wait while we process your information...' : "A deposit of ".concat(options.currency).concat(options.amount, " is required to bid. Please select a card to continue."));
    }
  };

  return mgStatus === REGISTRATION_NEEDED.value ? getDepositBanner() : getMgBanner(mgStatus);
}

DepositRequiredMessage.propTypes = {
  clientProxyUrl: PropTypes__default.string,
  bidderId: PropTypes__default.string,
  auctionId: PropTypes__default.string,
  coreToken: PropTypes__default.string,
  variant: PropTypes__default.oneOf(['small', 'large']).isRequired,
  options: PropTypes__default.object
};
var _excluded$6 = ["children", "onClose", "open", "anchorOrigin", "autoHideDuration"];
SnackbarMessage.propTypes = {
  open: bool.isRequired,
  autoHideDuration: number,
  anchorOrigin: shape({
    vertical: string.isRequired,
    horizontal: string.isRequired
  }),
  onClose: func.isRequired,
  children: node.isRequired,
  variant: oneOf(['error', 'info', 'success', 'warning']).isRequired,
  action: string,
  onActionClick: func,
  id: string,
  dataDescription: string
};

function SnackbarMessage(props) {
  var children = props.children,
      onClose = props.onClose,
      open = props.open,
      anchorOrigin = props.anchorOrigin,
      autoHideDuration = props.autoHideDuration,
      rest = _objectWithoutProperties(props, _excluded$6);

  return /*#__PURE__*/React.createElement(Snackbar, {
    anchorOrigin: anchorOrigin,
    autoHideDuration: autoHideDuration,
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Message, rest, children));
}

var useStyles$A = makeStyles$3(function (theme) {
  return {
    formHelperText: {
      marginTop: 0,
      marginBottom: theme.spacing(1)
    },
    "switch": {
      paddingBottom: 0,
      marginLeft: 0
    }
  };
});
SwitchHelper.propTypes = {
  size: string.isRequired,
  id: string.isRequired,
  value: string.isRequired,
  name: string.isRequired,
  color: string.isRequired,
  inputProps: object$1.isRequired,
  checked: bool.isRequired,
  onChange: func.isRequired,
  helperText: string.isRequired,
  disabled: bool
};

function SwitchHelper(props) {
  var classes = useStyles$A(theme);
  var switchRef = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      switchWidth = _useState2[0],
      setSwitchWidth = _useState2[1];

  React.useEffect(function () {
    //TODO: The `parentElement` accounts for a bug in material-ui. That may need to be removed in a future release, if fixed.
    setSwitchWidth(switchRef.current.parentElement.offsetWidth);
  }, [switchRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    className: classes["switch"],
    control: /*#__PURE__*/React.createElement(Switch, {
      size: props.size,
      id: props.id,
      value: props.value,
      color: props.color,
      inputProps: props.inputProps,
      checked: props.checked,
      onChange: props.onChange,
      disabled: props.disabled,
      ref: switchRef
    }),
    label: /*#__PURE__*/React.createElement(Typography, null, props.name)
  }), /*#__PURE__*/React.createElement(FormHelperText, {
    className: classes.formHelperText,
    style: {
      paddingLeft: switchWidth
    },
    component: 'div'
  }, props.helperText));
}

CommunicationInfo.propTypes = {
  initialCommunication: shape({
    outBidEmailAlert: bool.isRequired,
    outBidSmsAlert: bool.isRequired,
    watchedItemAlert: bool.isRequired,
    likeItemAlert: bool.isRequired,
    eventAlert: bool.isRequired,
    country: string,
    language: string.isRequired
  }).isRequired,
  currentCommunication: shape({
    outBidEmailAlert: bool.isRequired,
    outBidSmsAlert: bool.isRequired,
    watchedItemAlert: bool.isRequired,
    likeItemAlert: bool.isRequired,
    eventAlert: bool.isRequired,
    country: string,
    language: string.isRequired
  }).isRequired,
  hasMobilePhoneAndCarrier: bool.isRequired,
  communicationChanged: func.isRequired,
  countries: arrayOf(shape({
    id: number,
    text: string
  })).isRequired,
  languages: arrayOf(shape({
    id: number,
    text: string
  })).isRequired
};

function CommunicationInfo(props) {
  var countryLabel = useRef(null);
  var languageLabel = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      countryLabelWidth = _useState2[0],
      setCountryLabelWidth = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      languageLabelWidth = _useState4[0],
      setLanguageLabelWidth = _useState4[1];

  React.useEffect(function () {
    setCountryLabelWidth(countryLabel.current.offsetWidth);
    setLanguageLabelWidth(languageLabel.current.offsetWidth);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "country-label",
    ref: countryLabel,
    htmlFor: 'country'
  }, "Country"), /*#__PURE__*/React.createElement(Select$2, {
    labelid: "country-label",
    id: "country",
    required: true,
    value: props.currentCommunication.country || '',
    labelWidth: countryLabelWidth,
    onChange: function onChange(event) {
      return props.communicationChanged('country', event.target.value);
    },
    style: {
      width: '100%'
    },
    "native": true
  }, /*#__PURE__*/React.createElement("option", {
    value: '',
    disabled: true
  }), props.countries.map(function (country) {
    return /*#__PURE__*/React.createElement("option", {
      key: country.countryCode3,
      value: country.countryCode3
    }, country.name);
  })))), /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "language-label",
    ref: languageLabel,
    htmlFor: 'language'
  }, "Language"), /*#__PURE__*/React.createElement(Select$2, {
    labelid: "language-label",
    id: "language",
    required: true,
    value: props.currentCommunication.language,
    labelWidth: languageLabelWidth,
    onChange: function onChange(event) {
      return props.communicationChanged('language', event.target.value);
    },
    style: {
      width: '100%'
    },
    "native": true
  }, /*#__PURE__*/React.createElement("option", {
    value: '',
    disabled: true
  }), props.languages.map(function (language) {
    return /*#__PURE__*/React.createElement("option", {
      key: language.languageCode,
      value: language.languageCode
    }, language.language);
  })))), /*#__PURE__*/React.createElement("fieldset", {
    style: {
      border: 'none'
    }
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(SwitchHelper, {
    size: 'medium',
    id: 'outbid-email-alert',
    value: 'outBidEmailAlert',
    color: 'primary',
    name: 'Outbid Email Alert',
    inputProps: {
      'aria-label': 'Outbid Email Alert'
    },
    checked: !!props.currentCommunication.outBidEmailAlert,
    onChange: function onChange(event) {
      return props.communicationChanged('outBidEmailAlert', event.target.checked);
    },
    helperText: 'Be notified by email when you have been outbid.'
  }), /*#__PURE__*/React.createElement(SwitchHelper, {
    size: 'medium',
    id: 'outbid-sms-alert',
    value: 'outBidSmsAlert',
    color: 'primary',
    name: 'Outbid SMS Alert',
    disabled: !props.hasMobilePhoneAndCarrier,
    inputProps: {
      'aria-label': 'Outbid Sms Alert'
    },
    checked: !!props.currentCommunication.outBidSmsAlert,
    onChange: function onChange(event) {
      return props.communicationChanged('outBidSmsAlert', event.target.checked);
    },
    helperText: 'Be notified by SMS when you have been outbid. Carrier rates may apply. ' + 'You must provide your mobile number and mobile carrier in your contact information on file.'
  }), /*#__PURE__*/React.createElement(SwitchHelper, {
    size: 'medium',
    id: 'watched-item-alert',
    value: 'outBidSmsAlert',
    color: 'primary',
    name: 'Watched Item Alert',
    inputProps: {
      'aria-label': 'Watched Item Alert'
    },
    checked: !!props.currentCommunication.watchedItemAlert,
    onChange: function onChange(event) {
      return props.communicationChanged('watchedItemAlert', event.target.checked);
    },
    helperText: 'Be notified by email when items you have chosen to watch are coming up for sale. Also visible in MyProxibid.'
  }), /*#__PURE__*/React.createElement(SwitchHelper, {
    size: 'medium',
    id: 'like-item-alert',
    value: 'likeItemAlert',
    color: 'primary',
    name: 'Like Item Alert',
    inputProps: {
      'aria-label': 'Like Item Alert'
    },
    checked: !!props.currentCommunication.likeItemAlert,
    onChange: function onChange(event) {
      return props.communicationChanged('likeItemAlert', event.target.checked);
    },
    helperText: 'Be notified by email of items similar to those you bid on but didn\'t win.'
  }), /*#__PURE__*/React.createElement(SwitchHelper, {
    size: 'medium',
    id: 'event-alert',
    value: 'eventAlert',
    color: 'primary',
    name: 'Event Start/End Alert',
    inputProps: {
      'aria-label': 'Event Start/End Alert'
    },
    checked: !!props.currentCommunication.eventAlert,
    onChange: function onChange(event) {
      return props.communicationChanged('eventAlert', event.target.checked);
    },
    helperText: 'Be notified by email of auctions you are approved to participate in. ' + 'Messages are sent before the live auction starts and before the first lot in the timed auction closes.'
  })))));
}

EventReminderOptions.propTypes = {
  intialOptions: shape({
    remindByEmail: bool.isRequired,
    remindBySms: bool.isRequired,
    remindLeadMinutes: number.isRequired
  }).isRequired,
  currentOptions: shape({
    remindByEmail: bool.isRequired,
    remindBySms: bool.isRequired,
    remindLeadMinutes: number.isRequired
  }).isRequired,
  hasMobilePhoneAndCarrier: bool.isRequired,
  optionsChanged: func.isRequired
};

function EventReminderOptions(props) {
  var timeframeLabel = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      timeframeLabelWidth = _useState2[0],
      setTimeframeWidth = _useState2[1];

  React.useEffect(function () {
    setTimeframeWidth(timeframeLabel.current.offsetWidth);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("fieldset", {
    style: {
      border: 'none'
    }
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, 'When viewing an event, you may choose to be reminded about it. ' + 'Select your reminder preferences below.'), /*#__PURE__*/React.createElement(SwitchHelper, {
    size: 'medium',
    id: 'remind-by-email',
    value: 'remindByEmail',
    color: 'primary',
    name: 'Remind By Email',
    inputProps: {
      'aria-label': 'Remind By Email'
    },
    checked: !!props.currentOptions.remindByEmail,
    onChange: function onChange(event) {
      return props.optionsChanged('remindByEmail', event.target.checked);
    },
    helperText: 'Carrier rates may apply. You must provide your' + 'mobile number and mobile carrier in your contact information on file.'
  }), /*#__PURE__*/React.createElement(SwitchHelper, {
    size: 'medium',
    id: 'remind-by-sms',
    value: 'remindBySms',
    color: 'primary',
    name: 'Remind By SMS',
    disabled: !props.hasMobilePhoneAndCarrier,
    inputProps: {
      'aria-label': 'Remind By Sms'
    },
    checked: !!props.currentOptions.remindBySms,
    onChange: function onChange(event) {
      return props.optionsChanged('remindBySms', event.target.checked);
    },
    helperText: 'Be notified by SMS when you have been outbid. Carrier rates may apply. ' + 'You must provide your mobile number and mobile carrier in your contact information on file.'
  }), /*#__PURE__*/React.createElement(Grid$1, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$1, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    margin: "dense"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "timeframe-label",
    ref: timeframeLabel
  }, "Timeframe"), /*#__PURE__*/React.createElement(Select$2, {
    labelid: "timeframe-label",
    id: "timeframe",
    required: true,
    value: props.currentOptions.remindLeadMinutes || '',
    labelWidth: timeframeLabelWidth,
    onChange: function onChange(event) {
      return props.optionsChanged('remindLeadMinutes', event.target.value);
    },
    style: {
      width: '100%'
    },
    "native": true
  }, /*#__PURE__*/React.createElement("option", {
    value: 30
  }, "30 minutes"), /*#__PURE__*/React.createElement("option", {
    value: 60
  }, "60 minutes"), /*#__PURE__*/React.createElement("option", {
    value: 120
  }, "120 minutes"), /*#__PURE__*/React.createElement("option", {
    value: 1440
  }, "1 day"))))), /*#__PURE__*/React.createElement(FormHelperText, null, 'Select how far in advance you want to be notified before a' + ' live auction starts or before the first lot in a timed auction closes.'))));
}

SimpleDialog.propTypes = {
  onClose: PropTypes__default.func.isRequired,
  open: PropTypes__default.bool.isRequired,
  title: PropTypes__default.string,
  children: PropTypes__default.node.isRequired,
  secondary: PropTypes__default.element
};

function SimpleDialog(props) {
  var classes = useStyles$B();
  return /*#__PURE__*/React.createElement(Dialog$1$1, {
    fullWidth: true,
    maxWidth: "sm",
    onClose: props.onClose,
    open: props.open,
    scroll: "paper"
  }, /*#__PURE__*/React.createElement(DialogTitle$1$1, {
    id: "dialog-title"
  }, props.title, /*#__PURE__*/React.createElement(CloseIcon$1, {
    className: classes.closeIconStyle,
    onClick: props.onClose
  })), /*#__PURE__*/React.createElement(DialogContent$1$1, null, /*#__PURE__*/React.createElement(Box, {
    m: 1,
    className: classes.container
  }, props.children), props.secondary && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    variant: "fullWidth"
  }), /*#__PURE__*/React.createElement(Box, {
    m: 1,
    className: classes.container
  }, props.secondary))));
}

var useStyles$B = makeStyles$2(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    closeIconStyle: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      '&:hover': {
        cursor: 'pointer'
      }
    }
  };
});
DialogManager.propTypes = {
  event: string.isRequired,
  onClose: func.isRequired,
  title: string.isRequired,
  message: node.isRequired
};

function DialogManager(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      eventDetail = _useState4[0],
      setEventDetail = _useState4[1];

  function onOpenEvent(event) {
    setOpen(true);
    setEventDetail(event.detail);
  }

  function onClose() {
    setOpen(false);
    props.onClose(eventDetail);
  }

  useEffect(function () {
    EventService.addEventListener(props.event, onOpenEvent);
    return function cleanup() {
      EventService.removeEventListener(props.event, onOpenEvent);
    };
  });
  return /*#__PURE__*/React.createElement(SimpleDialog, {
    onClose: onClose,
    open: open,
    title: props.title
  }, /*#__PURE__*/React.createElement(Typography, {
    component: 'div'
  }, props.message));
}

BusinessInfo.propTypes = {
  initialIdentity: shape({
    companyName: string.isRequired,
    stateTaxExemptId: string.isRequired,
    dealerNumber: string.isRequired,
    dealerNumberDescription: string.isRequired
  }).isRequired,
  currentIdentity: shape({
    companyName: string.isRequired,
    stateTaxExemptId: string.isRequired,
    dealerNumber: string.isRequired,
    dealerNumberDescription: string.isRequired
  }).isRequired,
  onChange: func.isRequired,
  errors: object$1,
  attemptedSubmission: bool
};
BusinessInfo.defaultProps = {
  errors: {},
  attemptedSubmission: false
};

function BusinessInfo(props) {
  return /*#__PURE__*/React.createElement(Grid$2, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!props.errors.companyName,
    helperText: props.attemptedSubmission && props.errors.companyName,
    variant: "outlined",
    margin: "dense",
    id: "company-name",
    inputProps: {
      maxLength: 50
    },
    label: "Company Name",
    name: "companyName",
    autoComplete: "off",
    fullWidth: true,
    value: props.currentIdentity.companyName,
    onChange: function onChange(event) {
      return props.onChange('companyName', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!props.errors.stateTaxExemptId,
    helperText: props.attemptedSubmission && props.errors.stateTaxExemptId,
    variant: "outlined",
    margin: "dense",
    id: "state-tax-exempt-id",
    inputProps: {
      maxLength: 15
    },
    label: "State Tax Exempt ID",
    name: "stateTaxExemptId",
    autoComplete: "off",
    fullWidth: true,
    value: props.currentIdentity.stateTaxExemptId,
    onChange: function onChange(event) {
      return props.onChange('stateTaxExemptId', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!props.errors.dealerNumber,
    helperText: props.attemptedSubmission && props.errors.dealerNumber,
    variant: "outlined",
    margin: "dense",
    id: "dealer-number",
    inputProps: {
      maxLength: 50
    },
    label: "Dealer Number",
    name: "dealerNumber",
    autoComplete: "off",
    fullWidth: true,
    value: props.currentIdentity.dealerNumber,
    onChange: function onChange(event) {
      return props.onChange('dealerNumber', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: props.attemptedSubmission && !!props.errors.dealerNumberDescription,
    helperText: props.attemptedSubmission && props.errors.dealerNumberDescription,
    variant: "outlined",
    margin: "dense",
    id: "dealer-number-description",
    inputProps: {
      maxLength: 50
    },
    label: "Dealer Number Description",
    name: "dealerNumberDescription",
    autoComplete: "off",
    fullWidth: true,
    value: props.currentIdentity.dealerNumberDescription,
    onChange: function onChange(event) {
      return props.onChange('dealerNumberDescription', event.target.value);
    }
  })));
}

var expired_storage = createCommonjsModule(function (module, exports) {
  (function (root) {
    /**
     * ExpiredStorage
     * A class to manage local storage with expiration time (like cookies).
     *
     * @param storage: Optional storage base class to use (must implement the 'localStorage' API). If not defined, 'localStorage' will be used as a default.
     **/
    function ExpiredStorage(storage) {
      // set default storage to localStorage
      storage = storage || (typeof localStorage !== "undefined" ? localStorage : null); // sanity check1: make sure we have a valid storage class to use.

      if (!storage) {
        throw new Error("ExpiredStorage: No storage base class provided and 'localStorage' is undefined! Please provide a valid base storage class.");
      } // sanity check2: make sure the storage class provide the required API.


      if (!(storage.setItem && storage.getItem && storage.removeItem && storage.clear)) {
        throw new Error("ExpiredStorage: Storage class  don't support one or more of the required API functions: getItem, setItem, removeItem or clear.");
      } // set storage class


      this._storage = storage;
    }
    /**
     * Define expired storage prototype.
     */


    ExpiredStorage.prototype = {
      // base storage class to use, must implement the localStorage API.
      _storage: null,
      // prefix to use when storing items timestamp
      _expiration_key_prefix: "__expired_storage_ts__",

      /**
       * Get current timestamp in seconds.
       **/
      getTimestamp: function getTimestamp() {
        return Math.floor(new Date().getTime() / 1000);
      },

      /**
       * Set item.
       * @param key: Item key to set (string).
       * @param value: Value to store (string).
       * @param expiration: Expiration time, in seconds. If not provided, will not set expiration time.
       * @param return: Storage.setItem() return code.
       **/
      setItem: function setItem(key, value, expiration) {
        // set item
        var ret = this._storage.setItem(key, value); // set expiration timestamp (only if defined)


        if (expiration) {
          this.updateExpiration(key, expiration);
        } // return set value return value


        return ret;
      },

      /**
       * Get item.
       * @param key: Item key to get (string).
       * @return: Stored value, or undefined if not set / expired.
       */
      getItem: function getItem(key) {
        // if expired remove item and return null
        if (this.isExpired(key)) {
          this.removeItem(key);
          return null;
        } // try to fetch and return item value


        return this._storage.getItem(key);
      },

      /**
      * Get item + metadata such as time left and if expired.
      * Even if item expired, will not remove it.
      * @param key: Item key to get (string).
      * @return: Dictionary with: {value, timeLeft, isExpired}
      */
      peek: function peek(key) {
        // get value and time left
        var ret = {
          value: this._storage.getItem(key),
          timeLeft: this.getTimeLeft(key)
        }; // set if expired

        ret.isExpired = ret.timeLeft !== null && ret.timeLeft <= 0; // return data

        return ret;
      },

      /**
       * Get item time left to live.
       * @param key: Item key to get (string).
       * @return: Time left to expire (in seconds), or null if don't have expiration date.
       */
      getTimeLeft: function getTimeLeft(key) {
        // try to fetch expiration time for key
        var expireTime = parseInt(this._storage.getItem(this._expiration_key_prefix + key)); // if got expiration time return how much left to live

        if (expireTime && !isNaN(expireTime)) {
          return expireTime - this.getTimestamp();
        } // if don't have expiration time return null


        return null;
      },

      /**
       * Return if an item is expired (don't remove it, even if expired).
       * @param key: Item key to check (string).
       * @return: True if expired, False otherwise.
       */
      isExpired: function isExpired(key) {
        // get time left for item
        var timeLeft = this.getTimeLeft(key); // return if expired

        return timeLeft !== null && timeLeft <= 0;
      },

      /**
       * Update expiration time for an item (note: doesn't validate that the item is set).
       * @param key: Item key to update expiration for (string).
       * @param expiration: New expiration time in seconds to set.
       * @return: Storage.setItem() return code for setting new expiration.
       **/
      updateExpiration: function updateExpiration(key, expiration) {
        return this._storage.setItem(this._expiration_key_prefix + key, this.getTimestamp() + expiration);
      },

      /**
       * Remove an item.
       * @param key: Item key to remove (string).
       * @return: Storage.removeItem() return code.
       */
      removeItem: function removeItem(key) {
        // remove the item itself and its expiration time
        var ret = this._storage.removeItem(key);

        this._storage.removeItem(this._expiration_key_prefix + key); // return optional return code


        return ret;
      },

      /**
       * Set a json serializable value. This basically calls JSON.stringify on 'val' before setting it.
       * @param key: Item key to set (string).
       * @param value: Value to store (object, will be stringified).
       * @param expiration: Expiration time, in seconds. If not provided, will not set expiration time.
       * @param return: Storage.setItem() return code.
       **/
      setJson: function setJson(key, val, expiration) {
        // special case - make sure not undefined, because it would just write "undefined" and crash on reading.
        if (val === undefined) {
          throw new Error("Cannot set undefined value as JSON!");
        } // set stringified value


        return this.setItem(key, JSON.stringify(val), expiration);
      },

      /**
       * Get a json serializable value. This basically calls JSON.parse on the returned value.
       * @param key: Item key to get (string).
       * @return: Stored value, or undefined if not set / expired.
       **/
      getJson: function getJson(key) {
        // get value
        var val = this.getItem(key); // if null, return null

        if (val === null) {
          return null;
        } // parse and return value


        return JSON.parse(val);
      },

      /**
       * Get all keys in storage, not including internal keys used to store expiration.
       * @param: includeExpired: if true, will also include expired keys.
       * @return: Array with keys.
       */
      keys: function keys(includeExpired) {
        // create list to return
        var ret = []; // iterate over storage keys to find all non-expiration keys

        var that = this;

        this._iterKeys(function (storageKey) {
          // if its not a timestamp key, skip it
          if (storageKey.indexOf(that._expiration_key_prefix) !== 0) {
            // add to return list, but only if including expired keys or if not expired yet
            if (includeExpired || !that.isExpired(storageKey)) {
              ret.push(storageKey);
            }
          }
        }); // return keys


        return ret;
      },

      /**
       * Iterate all keys in storage class.
       * @param callback: Function to call for every key, with a single param: key.
       */
      _iterKeys: function _iterKeys(callback) {
        // first check if storage define a 'keys()' function. if it does, use it
        if (typeof this._storage.keys === "function") {
          var keys = this._storage.keys();

          for (var i = 0; i < keys.length; ++i) {
            callback(keys[i]);
          }
        } // if not supported try to use object.keys
        else if (typeof Object === "function" && Object.keys) {
          var keys = Object.keys(this._storage);

          for (var i = 0; i < keys.length; ++i) {
            callback(keys[i]);
          }
        } // if not supported try to use iteration via length
        else if (this._storage.length !== undefined && typeof this._storage.key === "function") {
          // first build keys array, so this function will be delete-safe (eg if callback remove keys it won't cause problems due to index change)
          var keys = [];

          for (var i = 0, len = this._storage.length; i < len; ++i) {
            keys.push(this._storage.key(i));
          } // now actually iterate keys


          for (var i = 0; i < keys.length; ++i) {
            callback(keys[i]);
          }
        } // if both methods above didn't work, iterate on all keys in storage class hoping for the best..
        else {
          for (var storageKey in this._storage) {
            callback(storageKey);
          }
        }
      },

      /**
       * Clear the entire storage and all keys in it.
       */
      clear: function clear() {
        this._storage.clear();
      },

      /**
       * Clear expired keys.
       * If you never call this function, expired keys will remain until you try to get them / reset a new value.
       *
       * @param return: List of removed keys due to expiration.
       */
      clearExpired: function clearExpired() {
        // return list
        var ret = []; // get current timestamp

        var timestamp = this.getTimestamp(); // iterate over storage keys to find all counters

        var that = this;

        this._iterKeys(function (storageKey) {
          // if its not a timestamp key, skip it
          if (storageKey.indexOf(that._expiration_key_prefix) === 0) {
            // get item key
            var itemKey = storageKey.substr(that._expiration_key_prefix.length); // if expired remove it + the item

            if (that.isExpired(itemKey)) {
              that.removeItem(itemKey);
              ret.push(itemKey);
            }
          }
        }); // return list with removed keys


        return ret;
      }
    }; // add some api params

    ExpiredStorage.version = "1.0.2";
    ExpiredStorage.author = "Ronen Ness";
    ExpiredStorage.gitUrl = "https://github.com/RonenNess/ExpiredStorage"; // AMD support.

    if (module.exports) {
      module.exports = ExpiredStorage;
    } // support in CommonJS without 'module' object
    else if (exports) {
      exports = ExpiredStorage;
    } // add to root (only if not previously defined)
    else if (root && !root.ExpiredStorage) {
      root.ExpiredStorage = ExpiredStorage;
    } // also return the API object


    return ExpiredStorage;
  })(commonjsGlobal);
});

function getFingerprint() {
  return _getFingerprint.apply(this, arguments);
}

function _getFingerprint() {
  _getFingerprint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve) {
              setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var components;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return fingerprint2.getPromise();

                      case 2:
                        components = _context.sent;
                        resolve(fingerprint2.x64hash128(components.map(function (component) {
                          return component.value;
                        }).join(''), 31));

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), 50);
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getFingerprint.apply(this, arguments);
}

function isFeatureActiveForUser(_x, _x2) {
  return _isFeatureActiveForUser.apply(this, arguments);
}

function _isFeatureActiveForUser() {
  _isFeatureActiveForUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(featureId, providedUserId) {
    var _expiredStorage$getIt;

    var userId, expiredStorage, cookie, featureEnabled, response, oneDayInSeconds;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = providedUserId || getCookieValue('userid');

            if (_context3.t0) {
              _context3.next = 5;
              break;
            }

            _context3.next = 4;
            return getFingerprint();

          case 4:
            _context3.t0 = _context3.sent;

          case 5:
            userId = _context3.t0;
            expiredStorage = new expired_storage();
            cookie = (_expiredStorage$getIt = expiredStorage.getItem("feature.".concat(featureId, ".").concat(userId))) === null || _expiredStorage$getIt === void 0 ? void 0 : _expiredStorage$getIt.toString();

            if (!cookie) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", cookie === 'true');

          case 10:
            featureEnabled = false;
            _context3.prev = 11;
            _context3.next = 14;
            return axiosInstance.get("/proxy/feature-toggle/v1/features/".concat(featureId, "/users/").concat(userId, "/enabled"));

          case 14:
            response = _context3.sent;
            featureEnabled = response.data === true;
            oneDayInSeconds = 86400;
            expiredStorage.setJson("feature.".concat(featureId, ".").concat(userId), featureEnabled, oneDayInSeconds);
            _context3.next = 23;
            break;

          case 20:
            _context3.prev = 20;
            _context3.t1 = _context3["catch"](11);
            console.debug(_context3.t1);

          case 23:
            return _context3.abrupt("return", featureEnabled);

          case 24:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[11, 20]]);
  }));
  return _isFeatureActiveForUser.apply(this, arguments);
}

LotsCard.propTypes = {
  lotId: number.isRequired,
  lotTitle: string.isRequired,
  lotImage: string,
  primaryCategoryName: string.isRequired,
  auctionHouseId: number.isRequired,
  auctionId: number.isRequired,
  awsImageURL: string.isRequired
};

function LotsCard(props) {
  var getLotImageURL = function getLotImageURL() {
    if (props.lotImage) {
      return "".concat(props.awsImageURL, "AuctionImages/").concat(props.auctionHouseId, "/").concat(props.auctionId, "/CatalogDetail/").concat(props.lotImage);
    } else {
      return '/AuctionImages/noimage.jpg';
    }
  };

  var getCatalogPageURL = function getCatalogPageURL() {
    return "/".concat(formatToDashes(props.primaryCategoryName), "/").concat(formatToDashes(props.lotTitle), "/lotInformation/").concat(props.lotId);
  };

  var formatToDashes = function formatToDashes(name) {
    return name.replace(/\W+/g, '-').replace(/-$/g, '');
  };

  return /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Card$1, {
    style: {
      height: 240,
      margin: 0
    }
  }, /*#__PURE__*/React.createElement(CardActionArea$1, {
    style: {
      height: '100%'
    },
    href: getCatalogPageURL()
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(CardMedia$1, null, /*#__PURE__*/React.createElement("img", {
    src: getLotImageURL(),
    alt: props.lotTitle,
    onError: function onError(e) {
      e.target.onerror = null;
      e.target.src = '/AuctionImages/noimage.jpg';
    },
    style: {
      height: 160
    }
  }))), /*#__PURE__*/React.createElement(CardContent$1, null, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2"
  }, props.lotTitle)))));
}

var useStyles$C = makeStyles$2({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '28px'
  }
});
LotCardList.propTypes = {
  streams: array.isRequired,
  primaryCategoryName: string.isRequired,
  awsImageURL: string,
  totalLots: number,
  totalPage: number,
  currentPage: number,
  showPaginationOrNot: bool
};

function LotCardList(props) {
  var classes = useStyles$C();

  var _useState = useState(window.matchMedia('(min-width: 29.5em)').matches),
      _useState2 = _slicedToArray(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  var lotCount = Number(props.totalLots);
  var totalPage = Number(props.totalPage);
  var showPaginationOrNot = props.showPaginationOrNot;
  var currentPage = Number(props.currentPage);
  var heroGridTitle = lotCount + (lotCount === 1 ? ' Result' : ' Results');

  var handlePageChange = function handlePageChange(event, value) {
    currentPage = value;
  };

  useEffect(function () {
    window.matchMedia('(min-width: 29.5em)').addEventListener('change', function (e) {
      return setMatches(e.matches);
    });
  }, []);
  return /*#__PURE__*/React.createElement(Box$1, {
    mb: 4
  }, /*#__PURE__*/React.createElement(HeroGrid, {
    title: heroGridTitle
  }, props.streams.map(function (stream) {
    return /*#__PURE__*/React.createElement(LotsCard, {
      key: stream.lotId,
      awsImageURL: props.awsImageURL,
      lotId: stream.lotId,
      lotTitle: stream.lotTitle,
      lotImage: stream.lotImage,
      auctionHouseId: stream.auctionHouseId,
      auctionId: stream.auctionId,
      primaryCategoryName: props.primaryCategoryName
    });
  })), showPaginationOrNot && /*#__PURE__*/React.createElement(Pagination$1, {
    count: totalPage,
    page: currentPage,
    variant: "outlined",
    shape: "rounded",
    color: "primary",
    className: classes.root,
    siblingCount: matches ? 2 : 0,
    onChange: handlePageChange,
    renderItem: function renderItem(item) {
      if (item.type === 'next') {
        return /*#__PURE__*/React.createElement(PaginationItem$1, _extends({
          href: "".concat(window.location.pathname, "?pageNumber=").concat(item.page)
        }, item, {
          rel: "next"
        }));
      } else if (item.type === 'previous') {
        return /*#__PURE__*/React.createElement(PaginationItem$1, _extends({
          href: "".concat(window.location.pathname, "?pageNumber=").concat(item.page)
        }, item, {
          rel: "prev"
        }));
      } else {
        return /*#__PURE__*/React.createElement(PaginationItem$1, _extends({
          href: "".concat(window.location.pathname, "?pageNumber=").concat(item.page)
        }, item));
      }
    }
  }));
}

CategoryCard.propTypes = {
  id: number.isRequired,
  name: string.isRequired,
  categoryImage: {
    auctionHouseId: number,
    auctionId: number,
    lotImage: string
  },
  awsImageURL: string,
  primaryCategoryName: string
};

function CategoryCard(props) {
  var getCategoryImageURL = function getCategoryImageURL() {
    if (props.categoryImage) {
      return "".concat(props.awsImageURL, "AuctionImages/").concat(props.categoryImage.auctionHouseId, "/").concat(props.categoryImage.auctionId, "/CatalogDetail/").concat(props.categoryImage.lotImage);
    } else {
      return '/images/proxibid-paddle.jpg';
    }
  };

  var getCatalogPageURL = function getCatalogPageURL() {
    var categoryURL;

    if (props.primaryCategoryName && props.name !== props.primaryCategoryName) {
      categoryURL = "/".concat(formatToDashes(props.primaryCategoryName), "/").concat(formatToDashes(props.name), "/for-sale/").concat(props.id);
    } else {
      categoryURL = "/".concat(formatToDashes(props.name), "/for-sale/").concat(props.id);
    }

    return categoryURL;
  };

  var formatToDashes = function formatToDashes(categoryTitle) {
    return categoryTitle.replace(/\W+/g, '-').replace(/-$/g, '');
  };

  return /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Card$1, {
    style: {
      height: 220,
      margin: 0
    }
  }, /*#__PURE__*/React.createElement(CardActionArea$1, {
    style: {
      height: '100%'
    },
    href: getCatalogPageURL()
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(CardMedia$1, null, /*#__PURE__*/React.createElement("img", {
    src: getCategoryImageURL(),
    alt: props.name,
    onError: function onError(e) {
      e.target.onerror = null;
      e.target.src = '/AuctionImages/noimage.jpg';
    },
    style: {
      height: 140
    }
  }))), /*#__PURE__*/React.createElement(CardContent$1, null, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2"
  }, props.name)))));
}

CategoryCarousel.propTypes = {
  categories: array.isRequired,
  awsImageURL: string,
  primaryCategoryName: string
};

function CategoryCarousel(props) {
  var renderCategoryCarousel = function renderCategoryCarousel() {
    return props.categories.length ? /*#__PURE__*/React.createElement(Box$1, {
      mb: 4
    }, /*#__PURE__*/React.createElement(HeroCarousel, {
      title: 'Shop By Category'
    }, props.categories.map(function (category) {
      return /*#__PURE__*/React.createElement(CategoryCard, {
        key: category.id,
        awsImageURL: props.awsImageURL,
        id: category.id,
        name: category.name,
        categoryImage: category.categoryImage,
        primaryCategoryName: props.primaryCategoryName
      });
    }))) : /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "primary"
    }, 'No Categories Available!');
  };

  return props.categories ? renderCategoryCarousel() : /*#__PURE__*/React.createElement(Typography, {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 280,
      margin: 0
    },
    variant: "h6",
    color: "primary"
  }, 'Loading Categories...');
}

CreditCardListItem.propTypes = {
  creditCard: shape({
    id: number,
    lastFour: string
  }).isRequired,
  order: number
};

function CreditCardListItem(props) {
  var classes = useStyles$D(theme);
  var icon = CreditCardService.findCardByCardTypeId(0).icon;
  return /*#__PURE__*/React.createElement(Grid$2, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 1,
    xs: 2
  }, /*#__PURE__*/React.createElement(CardMedia, {
    className: classes.ccLogo,
    component: 'img',
    image: icon.src,
    title: icon.alt
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    container: true,
    sm: 11,
    xs: 10,
    className: classes.ccDetails
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 5,
    md: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography$1, null, 'Card on File')), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 4,
    md: 3,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography$1, null, "Ending with ", /*#__PURE__*/React.createElement("strong", null, props.creditCard.lastFour))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 3,
    md: 3,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography$1, null, "Expires ", '**/**'))));
}

var useStyles$D = makeStyles$1(function (theme) {
  return {
    ccDetails: {
      paddingLeft: theme.spacing(1)
    },
    ccLogo: {
      maxHeight: '2rem',
      width: 'auto',
      maxWidth: '100%',
      margin: '0 auto'
    }
  };
});
SelectCreditCardList.propTypes = {
  handleCardSelect: func.isRequired,
  creditCards: arrayOf(shape({
    ccName: string,
    ccid: number
  })).isRequired,
  children: object$1
};

function SelectCreditCardList(props) {
  var theme = useTheme$1();
  var classes = useStyles$E(theme);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedCreditCard = _React$useState4[0],
      setSelectedCreditCard = _React$useState4[1];

  useEffect(function () {
    if (props.creditCards && props.creditCards[selectedCreditCard]) {
      props.handleCardSelect(props.creditCards[selectedCreditCard].ccid);
    }
  }, [selectedCreditCard, props.creditCards]);

  var handleCreditCardChange = function handleCreditCardChange(event) {
    setSelectedCreditCard(event.target.value);
  };

  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      if (props.children) {
        setExpanded(isExpanded ? panel : false);
      }
    };
  };

  return /*#__PURE__*/React.createElement("div", null, props.creditCards && props.creditCards.map(function (creditCard, index) {
    return /*#__PURE__*/React.createElement(ExpansionPanel, {
      key: index,
      expanded: expanded === "panel".concat(index),
      onChange: handleChange("panel".concat(index)),
      TransitionProps: {
        unmountOnExit: true
      },
      "data-description": "".concat(creditCard.ccName)
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Radio, {
      checked: selectedCreditCard === index,
      onChange: handleCreditCardChange,
      value: index,
      size: "small",
      name: "credit-cards",
      inputProps: {
        'aria-label': 'credit-card-' + index
      },
      className: classes.radio
    }), /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
      expandIcon: props.children && /*#__PURE__*/React.createElement(ExpandMore, null),
      "aria-controls": "cc".concat(index, "-content"),
      id: "cc".concat(index, "-header"),
      className: classes.summary
    }, /*#__PURE__*/React.createElement(CreditCardListItem, {
      creditCard: creditCard,
      order: index + 1
    }))));
  }));
}

var useStyles$E = makeStyles$2(function (theme) {
  return {
    summary: {
      maxWidth: '100%',
      paddingLeft: '30px'
    },
    radio: {
      top: '50%',
      position: 'absolute',
      transform: 'translateY(-50%)',
      zIndex: 1
    }
  };
});
var AppendHead = createCommonjsModule(function (module) {
  module.exports = function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
  }([function (e, t, r) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n,
        o = function o(e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var r = [],
            n = !0,
            o = !1,
            u = void 0;

        try {
          for (var i, c = e[Symbol.iterator](); !(n = (i = c.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          o = !0, u = e;
        } finally {
          try {
            !n && c.return && c.return();
          } finally {
            if (o) throw u;
          }
        }

        return r;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
        u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        i = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        c = r(1),
        a = (n = c) && n.__esModule ? n : {
      default: n
    };

    Object.entries || (Object.entries = function (e) {
      for (var t = Object.keys(e), r = t.length, n = new Array(r); r--;) {
        n[r] = [t[r], e[t[r]]];
      }

      return n;
    });

    var l = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return r.queue = [], r.loadingRessources = [], r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), i(t, [{
        key: "componentDidMount",
        value: function value() {
          this.carryChildren();
        }
      }, {
        key: "carryChildren",
        value: function value() {
          var e = this,
              t = this.props.children,
              r = a.default.Children.map(t, function (e) {
            return {
              type: e.type,
              order: isNaN(+e.props.order) ? -1 : +e.props.order,
              attributes: u({}, e.props)
            };
          }).sort(function (e, t) {
            return e.order - t.order > 0 ? 1 : e.order - t.order < 0 ? -1 : 0;
          });
          this.props.debug && console.log("[react-append-head] Workload: ", r), r.forEach(function (t) {
            e.props.debug && console.log("[react-append-head] Processing: ", t);
            var r = document.querySelector(t.type + "[name='" + t.attributes.name + "']");
            if (r) r.hasAttribute("loading") ? e.loadingRessources.push(r) : e.props.debug && console.log("[react-append-head] Ressource was already loaded. Skipping.");else {
              var n = document.createElement(t.type);
              Object.entries(t.attributes).forEach(function (e) {
                var t = o(e, 2),
                    r = t[0],
                    u = t[1];
                "onLoad" == r ? n.addEventListener("load", u) : "children" == r ? n.innerHTML = u + ';document.currentScript.dispatchEvent(new Event("load"));' : n.setAttribute(r, u);
              }), n.setAttribute("loading", !0), t.order >= 0 ? (e.queue.push(n), e.props.debug && console.log("[react-append-head] Ressource added to queue: ", n)) : (n.addEventListener("load", function () {
                n.removeAttribute("loading"), e.props.debug && console.log("[react-append-head] Ressource loaded: ", n);
              }), document.head.insertAdjacentElement("beforeend", n), e.props.debug && console.log("[react-append-head] Ressource injected: ", n));
            }
          }), this.processQueue();
        }
      }, {
        key: "processQueue",
        value: function value() {
          var e = this;

          if (this.queue.length) {
            this.props.debug && console.log("[react-append-head] The queue has " + this.queue.length + " queued elements.");
            var t = this.queue.filter(function (t) {
              return t.getAttribute("order") == e.queue[0].getAttribute("order");
            });
            this.props.debug && console.log("[react-append-head] Processing " + t.length + " elements: ", t);
            var r = [];
            t.forEach(function (t) {
              var n = new Promise(function (r) {
                t.addEventListener("load", function () {
                  t.removeAttribute("loading"), e.props.debug && console.log("[react-append-head] Ressource loaded: ", t), r();
                });
              });
              r.push(n), e.props.debug && console.log("[react-append-head] Ressource injected: ", e.queue[0]), document.head.insertAdjacentElement("beforeend", t);
            }), Promise.all(r).then(function () {
              e.queue.splice(0, t.length), e.processQueue();
            });
          } else this.endCheck();
        }
      }, {
        key: "endCheck",
        value: function value() {
          var e = this;
          if (this.loadingRessources.length) var t = setInterval(function () {
            e.loadingRessources = e.loadingRessources.filter(function (e) {
              return e.hasAttribute("loading");
            }), e.loadingRessources.length || (clearInterval(t), e.props.onLoad && e.props.onLoad());
          }, 100);else this.props.onLoad && this.props.onLoad();
        }
      }, {
        key: "render",
        value: function value() {
          return null;
        }
      }]), t;
    }(a.default.Component);

    t.default = l;
  }, function (e, t, r) {
    e.exports = r(2);
  }, function (e, t, r) {
    /** @license React v16.14.0
    * react.production.min.js
    *
    * Copyright (c) Facebook, Inc. and its affiliates.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */
    var n = r(3),
        o = "function" == typeof Symbol && Symbol.for,
        u = o ? Symbol.for("react.element") : 60103,
        i = o ? Symbol.for("react.portal") : 60106,
        c = o ? Symbol.for("react.fragment") : 60107,
        a = o ? Symbol.for("react.strict_mode") : 60108,
        l = o ? Symbol.for("react.profiler") : 60114,
        s = o ? Symbol.for("react.provider") : 60109,
        f = o ? Symbol.for("react.context") : 60110,
        p = o ? Symbol.for("react.forward_ref") : 60112,
        d = o ? Symbol.for("react.suspense") : 60113,
        y = o ? Symbol.for("react.memo") : 60115,
        h = o ? Symbol.for("react.lazy") : 60116,
        b = "function" == typeof Symbol && Symbol.iterator;

    function v(e) {
      for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 1; r < arguments.length; r++) {
        t += "&args[]=" + encodeURIComponent(arguments[r]);
      }

      return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }

    var g = {
      isMounted: function isMounted() {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate() {},
      enqueueReplaceState: function enqueueReplaceState() {},
      enqueueSetState: function enqueueSetState() {}
    },
        m = {};

    function j(e, t, r) {
      this.props = e, this.context = t, this.refs = m, this.updater = r || g;
    }

    function O() {}

    function _(e, t, r) {
      this.props = e, this.context = t, this.refs = m, this.updater = r || g;
    }

    j.prototype.isReactComponent = {}, j.prototype.setState = function (e, t) {
      if ("object" != typeof e && "function" != typeof e && null != e) throw Error(v(85));
      this.updater.enqueueSetState(this, e, t, "setState");
    }, j.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    }, O.prototype = j.prototype;
    var w = _.prototype = new O();
    w.constructor = _, n(w, j.prototype), w.isPureReactComponent = !0;
    var S = {
      current: null
    },
        k = Object.prototype.hasOwnProperty,
        E = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };

    function P(e, t, r) {
      var n,
          o = {},
          i = null,
          c = null;
      if (null != t) for (n in void 0 !== t.ref && (c = t.ref), void 0 !== t.key && (i = "" + t.key), t) {
        k.call(t, n) && !E.hasOwnProperty(n) && (o[n] = t[n]);
      }
      var a = arguments.length - 2;
      if (1 === a) o.children = r;else if (1 < a) {
        for (var l = Array(a), s = 0; s < a; s++) {
          l[s] = arguments[s + 2];
        }

        o.children = l;
      }
      if (e && e.defaultProps) for (n in a = e.defaultProps) {
        void 0 === o[n] && (o[n] = a[n]);
      }
      return {
        $$typeof: u,
        type: e,
        key: i,
        ref: c,
        props: o,
        _owner: S.current
      };
    }

    function R(e) {
      return "object" == typeof e && null !== e && e.$$typeof === u;
    }

    var C = /\/+/g,
        x = [];

    function $(e, t, r, n) {
      if (x.length) {
        var o = x.pop();
        return o.result = e, o.keyPrefix = t, o.func = r, o.context = n, o.count = 0, o;
      }

      return {
        result: e,
        keyPrefix: t,
        func: r,
        context: n,
        count: 0
      };
    }

    function A(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > x.length && x.push(e);
    }

    function q(e, t, r) {
      return null == e ? 0 : function e(t, r, n, o) {
        var c = typeof t;
        "undefined" !== c && "boolean" !== c || (t = null);
        var a = !1;
        if (null === t) a = !0;else switch (c) {
          case "string":
          case "number":
            a = !0;
            break;

          case "object":
            switch (t.$$typeof) {
              case u:
              case i:
                a = !0;
            }

        }
        if (a) return n(o, t, "" === r ? "." + L(t, 0) : r), 1;
        if (a = 0, r = "" === r ? "." : r + ":", Array.isArray(t)) for (var l = 0; l < t.length; l++) {
          var s = r + L(c = t[l], l);
          a += e(c, s, n, o);
        } else if (null === t || "object" != typeof t ? s = null : s = "function" == typeof (s = b && t[b] || t["@@iterator"]) ? s : null, "function" == typeof s) for (t = s.call(t), l = 0; !(c = t.next()).done;) {
          a += e(c = c.value, s = r + L(c, l++), n, o);
        } else if ("object" === c) throw n = "" + t, Error(v(31, "[object Object]" === n ? "object with keys {" + Object.keys(t).join(", ") + "}" : n, ""));
        return a;
      }(e, "", t, r);
    }

    function L(e, t) {
      return "object" == typeof e && null !== e && null != e.key ? function (e) {
        var t = {
          "=": "=0",
          ":": "=2"
        };
        return "$" + ("" + e).replace(/[=:]/g, function (e) {
          return t[e];
        });
      }(e.key) : t.toString(36);
    }

    function M(e, t) {
      e.func.call(e.context, t, e.count++);
    }

    function I(e, t, r) {
      var n = e.result,
          o = e.keyPrefix;
      e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? T(e, n, r, function (e) {
        return e;
      }) : null != e && (R(e) && (e = function (e, t) {
        return {
          $$typeof: u,
          type: e.type,
          key: t,
          ref: e.ref,
          props: e.props,
          _owner: e._owner
        };
      }(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(C, "$&/") + "/") + r)), n.push(e));
    }

    function T(e, t, r, n, o) {
      var u = "";
      null != r && (u = ("" + r).replace(C, "$&/") + "/"), q(e, I, t = $(t, u, n, o)), A(t);
    }

    var N = {
      current: null
    };

    function U() {
      var e = N.current;
      if (null === e) throw Error(v(321));
      return e;
    }

    var D = {
      ReactCurrentDispatcher: N,
      ReactCurrentBatchConfig: {
        suspense: null
      },
      ReactCurrentOwner: S,
      IsSomeRendererActing: {
        current: !1
      },
      assign: n
    };
    t.Children = {
      map: function map(e, t, r) {
        if (null == e) return e;
        var n = [];
        return T(e, n, null, t, r), n;
      },
      forEach: function forEach(e, t, r) {
        if (null == e) return e;
        q(e, M, t = $(null, null, t, r)), A(t);
      },
      count: function count(e) {
        return q(e, function () {
          return null;
        }, null);
      },
      toArray: function toArray(e) {
        var t = [];
        return T(e, t, null, function (e) {
          return e;
        }), t;
      },
      only: function only(e) {
        if (!R(e)) throw Error(v(143));
        return e;
      }
    }, t.Component = j, t.Fragment = c, t.Profiler = l, t.PureComponent = _, t.StrictMode = a, t.Suspense = d, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = D, t.cloneElement = function (e, t, r) {
      if (null == e) throw Error(v(267, e));
      var o = n({}, e.props),
          i = e.key,
          c = e.ref,
          a = e._owner;

      if (null != t) {
        if (void 0 !== t.ref && (c = t.ref, a = S.current), void 0 !== t.key && (i = "" + t.key), e.type && e.type.defaultProps) var l = e.type.defaultProps;

        for (s in t) {
          k.call(t, s) && !E.hasOwnProperty(s) && (o[s] = void 0 === t[s] && void 0 !== l ? l[s] : t[s]);
        }
      }

      var s = arguments.length - 2;
      if (1 === s) o.children = r;else if (1 < s) {
        l = Array(s);

        for (var f = 0; f < s; f++) {
          l[f] = arguments[f + 2];
        }

        o.children = l;
      }
      return {
        $$typeof: u,
        type: e.type,
        key: i,
        ref: c,
        props: o,
        _owner: a
      };
    }, t.createContext = function (e, t) {
      return void 0 === t && (t = null), (e = {
        $$typeof: f,
        _calculateChangedBits: t,
        _currentValue: e,
        _currentValue2: e,
        _threadCount: 0,
        Provider: null,
        Consumer: null
      }).Provider = {
        $$typeof: s,
        _context: e
      }, e.Consumer = e;
    }, t.createElement = P, t.createFactory = function (e) {
      var t = P.bind(null, e);
      return t.type = e, t;
    }, t.createRef = function () {
      return {
        current: null
      };
    }, t.forwardRef = function (e) {
      return {
        $$typeof: p,
        render: e
      };
    }, t.isValidElement = R, t.lazy = function (e) {
      return {
        $$typeof: h,
        _ctor: e,
        _status: -1,
        _result: null
      };
    }, t.memo = function (e, t) {
      return {
        $$typeof: y,
        type: e,
        compare: void 0 === t ? null : t
      };
    }, t.useCallback = function (e, t) {
      return U().useCallback(e, t);
    }, t.useContext = function (e, t) {
      return U().useContext(e, t);
    }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
      return U().useEffect(e, t);
    }, t.useImperativeHandle = function (e, t, r) {
      return U().useImperativeHandle(e, t, r);
    }, t.useLayoutEffect = function (e, t) {
      return U().useLayoutEffect(e, t);
    }, t.useMemo = function (e, t) {
      return U().useMemo(e, t);
    }, t.useReducer = function (e, t, r) {
      return U().useReducer(e, t, r);
    }, t.useRef = function (e) {
      return U().useRef(e);
    }, t.useState = function (e) {
      return U().useState(e);
    }, t.version = "16.14.0";
  }, function (e, t, r) {
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    var n = Object.getOwnPropertySymbols,
        o = Object.prototype.hasOwnProperty,
        u = Object.prototype.propertyIsEnumerable;

    function i(e) {
      if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }

    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, r = 0; r < 10; r++) {
          t["_" + String.fromCharCode(r)] = r;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var n = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          n[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var r, c, a = i(e), l = 1; l < arguments.length; l++) {
        for (var s in r = Object(arguments[l])) {
          o.call(r, s) && (a[s] = r[s]);
        }

        if (n) {
          c = n(r);

          for (var f = 0; f < c.length; f++) {
            u.call(r, c[f]) && (a[c[f]] = r[c[f]]);
          }
        }
      }

      return a;
    };
  }]);
});
var AppendHead$1 = unwrapExports(AppendHead);
PayrixCardForm.propTypes = {
  payrixApiUrl: string.isRequired,
  payrixApiKey: string.isRequired
};

function PayrixCardForm(props) {
  var classes = useStyles$F(theme);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppendHead$1, null, /*#__PURE__*/React.createElement("script", {
    name: "jquery",
    order: "0",
    src: "https://code.jquery.com/jquery-2.2.4.min.js",
    type: "text/javascript",
    id: "payFieldsScript1"
  }), /*#__PURE__*/React.createElement("script", {
    name: "payFields",
    order: "1",
    src: props.payrixApiUrl + '/payFieldsScript',
    type: "text/javascript",
    id: "payFieldsScript2"
  }), /*#__PURE__*/React.createElement("script", {
    name: "payFieldsSetup",
    id: "payFieldsScript3",
    order: "2"
  }, "\n                PayFields.fields = [\n                    {type: \"number\", element: \"#number\"},\n                    {type: \"cvv\", element: \"#cvv\"},\n                    {type: \"expiration\", element: \"#expiration\"}\n                ];\n\n                PayFields.customizations = {\n                    style: {\n                      \".input\": {\n                        \"letter-spacing\": \"0.5px\",\n                        \"font-weight\": \"normal\",\n                        \"font-size\": \"16px\",\n                        \"line-height\": \"22px\",\n                        \"border\": \"1px solid #e3e3e3\",\n                        \"padding\": \"6px 12px\",\n                        \"color\": \"#211614\",\n                        \"border-radius\": \"0\",\n                        \"width\": \"100%\",\n                        \"max-width\": \"100%\",\n                        \"display\": \"block\",\n                        \"height\": \"44px\",\n                        \"box-sizing\": \"border-box\",\n                      },\n                      \".card-icon\": {\n                          \"top\": \"7px\",\n                      },\n                      \".form-error\": {\n                          \"font-size\": \"0px\",\n                      },\n                    },\n                    optionalFields: [\"#email\", \"#phone\"],\n                    placeholders: {\n                        \"#name\": \"\",\n                        \"#payment_number\": \"\",\n                        \"#payment_cvv\": \"\",\n                        \"#expiration\": \"\"\n                    }\n                  }\n                PayFields.config.apiKey = \"".concat(props.payrixApiKey, "\";\n                PayFields.config.mode = \"token\";\n                PayFields.fields.push({type: \"name\", element: \"#name\"});\n                PayFields.button = {element: \"#submit\", value: \"Save and Continue\"};\n                PayFields.onSuccess = function(response) {\n                    if(response && response.data && response.data[0] && response.data[0].customer) {\n                        window.payrixFailure = false;\n                        window.payrixToken = response.data[0].token;\n                        window.payrixName = {first: response.data[0].customer.first, last: response.data[0].customer.last}\n                    } else {\n                        window.payrixFailure = true;\n                    }\n                }\n                PayFields.onFailure = function(response) {\n                    window.payrixFailure = true;\n                }\n                PayFields.onValidationFailure = function(response) {\n                    window.payrixFailure = true;\n                }\n                \n                PayFields.appendIframe();\n            "))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, "Name on card *"), /*#__PURE__*/React.createElement("div", {
    className: classes.payrixFormWrapper,
    id: "name"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.cardInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, /*#__PURE__*/React.createElement(Typography, null, "Card Number *"), /*#__PURE__*/React.createElement("div", {
    className: classes.payrixFormWrapper,
    id: "number"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.expCvv
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.expiration
  }, /*#__PURE__*/React.createElement(Typography, null, "Expiration *"), /*#__PURE__*/React.createElement("div", {
    className: classes.payrixFormWrapper,
    id: "expiration"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.cvv
  }, /*#__PURE__*/React.createElement(Typography, null, "CVV *"), /*#__PURE__*/React.createElement("div", {
    className: classes.payrixFormWrapper,
    id: "cvv"
  })))))));
}

var useStyles$F = makeStyles$1(function (theme) {
  return {
    payrixFormWrapper: {
      height: '64px'
    },
    cardInfo: {
      display: 'flex',
      justifyContent: 'space-between',
      '@media (max-width: 768px)': {
        flexWrap: 'wrap'
      }
    },
    number: {
      width: '50%',
      '@media (max-width: 768px)': {
        width: '100%'
      }
    },
    expCvv: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '49%',
      '@media (max-width: 768px)': {
        width: '100%'
      }
    },
    expiration: {
      width: '49%'
    },
    cvv: {
      width: '49%'
    }
  };
});
AddCreditCard$1.propTypes = {
  countryRegionData: arrayOf(shape({
    id: number,
    name: string,
    countryCode: string,
    states: arrayOf(shape({
      id: number,
      name: string,
      abbreviation: string
    }))
  })),
  payrixApiUrl: string.isRequired,
  payrixApiKey: string.isRequired,
  handleSubmit: func.isRequired,
  handleChange: func.isRequired,
  disableSubmit: bool.isRequired,
  creditCardInfo: shape({
    addressLine1: string,
    addressLine2: string,
    addressLevel1Id: string,
    addressLevel2: string,
    countryId: string,
    postalCode: string
  })
};

function AddCreditCard$1(props) {
  var styles = useStyles$G();

  function BillingAddressLabel() {
    return /*#__PURE__*/React.createElement(Box$1, {
      pt: 1,
      pr: 1,
      pb: 1
    }, /*#__PURE__*/React.createElement(Typography$1, {
      variant: 'h6'
    }, "Billing Address"));
  }

  function CreditCardLabel() {
    return /*#__PURE__*/React.createElement(Box$1, {
      pt: 1,
      pr: 1,
      pb: 1
    }, /*#__PURE__*/React.createElement(Typography$1, {
      variant: 'h6'
    }, "Credit Card"));
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Divider$1, {
    variant: "fullWidth",
    component: CreditCardLabel
  }), /*#__PURE__*/React.createElement(PayrixCardForm, {
    payrixApiUrl: props.payrixApiUrl,
    payrixApiKey: props.payrixApiKey
  }), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider$1, {
    variant: "fullWidth",
    component: BillingAddressLabel
  }), /*#__PURE__*/React.createElement("div", {
    className: 'billingAddress'
  }, /*#__PURE__*/React.createElement(Address, {
    initialAddress: props.creditCardInfo,
    currentAddress: props.creditCardInfo,
    addressChanged: props.handleChange,
    countryRegionData: props.countryRegionData,
    attemptedSubmission: false
  }))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      pointerEvents: props.disableSubmit ? 'none' : ''
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.submitButton,
    id: 'submit',
    disabled: props.disableSubmit,
    onClick: props.handleSubmit
  }, "Save and Continue"))));
}

var useStyles$G = makeStyles(function (theme) {
  return {
    submitButton: {
      width: '100%',
      borderRadius: '4px',
      marginTop: '1rem',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: '500',
      fontSize: '0.875rem',
      letterSpacing: '0.02857em',
      '&:disabled': {
        backgroundColor: '#eaeaea !important',
        color: '#bababa !important'
      }
    }
  };
});
AddCreditCardCheckoutFlow.propTypes = {
  countryRegionData: arrayOf(shape({
    id: number,
    name: string,
    countryCode: string,
    states: arrayOf(shape({
      id: number,
      name: string,
      abbreviation: string
    }))
  })),
  payrixApiUrl: string.isRequired,
  payrixApiKey: string.isRequired,
  addCreditCardUrl: string.isRequired,
  handleCardAddSuccess: func.isRequired,
  noCards: bool.isRequired,
  setErrorMessage: func.isRequired
};

function AddCreditCardCheckoutFlow(props) {
  var _props$countryRegionD;

  var initialAddress = {
    addressLine1: '',
    addressLine2: '',
    addressLevel1Id: '',
    addressLevel2: '',
    countryId: ((_props$countryRegionD = props.countryRegionData) === null || _props$countryRegionD === void 0 ? void 0 : _props$countryRegionD.length) > 0 ? '1' : '0',
    postalCode: ''
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(initialAddress),
      _useState4 = _slicedToArray(_useState3, 2),
      creditCardInfo = _useState4[0],
      setCreditCardInfo = _useState4[1];

  var creditCardInfoRef = useRef(creditCardInfo);

  var _useState5 = useState(true),
      _useState6 = _slicedToArray(_useState5, 2),
      disableSubmit = _useState6[0],
      setDisableSubmit = _useState6[1];

  var ERROR_MESSAGE = 'We are experiencing technical difficulties, please try again later.';
  useEffect(function () {
    window.addEventListener('message', handleIframeTask);
  }, []);
  useEffect(function () {
    var _props$countryRegionD2;

    if (((_props$countryRegionD2 = props.countryRegionData) === null || _props$countryRegionD2 === void 0 ? void 0 : _props$countryRegionD2.length) > 0) {
      setCreditCardInfo(_objectSpread2(_objectSpread2({}, creditCardInfo), {}, {
        countryId: '1'
      }));
    }
  }, [props.countryRegionData]);
  useEffect(function () {
    creditCardInfoRef.current = creditCardInfo;
    var errors = validateAddress(creditCardInfo);
    setDisableSubmit(!isEmpty(errors));
  }, [creditCardInfo]);

  var handleChange = function handleChange(attributeName, value) {
    setCreditCardInfo(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, attributeName, value));
    });
  };

  var handleSubmit = function handleSubmit() {
    setDisableSubmit(true);
  };

  var handleShow = function handleShow() {
    if (visible) {
      iFrameTeardown();
      setCreditCardInfo(initialAddress);
    } else {
      setDisableSubmit(true);
    }

    setVisible(!visible);
  };

  var handleIframeTask = function handleIframeTask(e) {
    var _e$data;

    var data = '';

    if (e.origin === props.payrixApiUrl && e.data) {
      data = JSON.parse(e.data);
    }

    if (data && data.success && ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.type) !== 'handleWebViewSize') {
      var last4 = data.res.data[0].payment.number;
      var token = data.res.data[0].token;
      axiosInstance.post(props.addCreditCardUrl + '/auth', {
        paymentToken: token,
        address: creditCardInfoRef.current
      }, {
        headers: {
          'user-id': getCookieValue('user-id'),
          'guid': getCookieValue('guid')
        }
      }).then(function (response) {
        if (response.data.success) {
          delay(2000).then(function () {
            setCreditCardInfo(creditCardInfo);
          });
          delay(2500).then(function () {
            setDisableSubmit(true);
            setVisible(false);
            iFrameTeardown();
          });
          axiosInstance.put(props.addCreditCardUrl, {
            lastFour: last4,
            paymentToken: token,
            address: creditCardInfoRef.current
          }, {
            headers: {
              'user-id': getCookieValue('user-id'),
              'guid': getCookieValue('guid')
            }
          }).then(function () {
            props.handleCardAddSuccess(token);
            props.setErrorMessage('');
          })["catch"](function () {
            props.setErrorMessage(ERROR_MESSAGE);
          });
        } else {
          props.setErrorMessage(response.data.errorMessage);
        }
      })["catch"](function () {
        props.setErrorMessage(ERROR_MESSAGE);
      });
    }

    if (data && (data.error || data.sender === 'error')) {
      delay(2500).then(function () {
        setDisableSubmit(false);
      });
    }
  };

  function iFrameTeardown() {
    var elementsToRemove = [document.getElementById('payFields-iframe'), document.getElementById('payFields-iframe-name'), document.getElementById('payFields-iframe-number'), document.getElementById('payFields-iframe-expiration'), document.getElementById('payFields-iframe-cvv'), document.getElementById('payFieldsScript1'), document.getElementById('payFieldsScript2'), document.getElementById('payFieldsScript3')];

    for (var _i = 0, _elementsToRemove = elementsToRemove; _i < _elementsToRemove.length; _i++) {
      var element = _elementsToRemove[_i];

      try {
        element.parentNode.removeChild(element); // eslint-disable-next-line no-empty
      } catch (error) {// if it's already removed, then I don't care!
      }
    }
  }

  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  function delay(time) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, time);
    });
  }

  return /*#__PURE__*/React.createElement("div", null, !props.noCards && /*#__PURE__*/React.createElement(Button, {
    id: 'add-cc',
    onClick: handleShow,
    color: 'primary'
  }, "Use a different card"), (visible || props.noCards) && /*#__PURE__*/React.createElement(AddCreditCard$1, {
    countryRegionData: props.countryRegionData,
    payrixApiUrl: props.payrixApiUrl,
    payrixApiKey: props.payrixApiKey,
    disableSubmit: disableSubmit,
    handleSubmit: handleSubmit,
    handleChange: handleChange,
    creditCardInfo: creditCardInfo
  }));
}

CreditCardListItem$1.propTypes = {
  creditCard: shape({
    id: number,
    ccTypeId: oneOfType([number, string]),
    ccName: string,
    lastFour: string,
    expirationDate: string,
    addressLine1: string,
    addressLine2: string,
    addressLevel1: string,
    addressLevel2: string,
    postalCode: string,
    country: string,
    ccStatusType: string
  }).isRequired
};

function CreditCardListItem$1(props) {
  var classes = useStyles$H(theme);
  var icon = CreditCardService.findCardByCardTypeId(props.creditCard.ccTypeId).icon;
  var ccName = /*#__PURE__*/React.createElement(Typography$1, {
    color: 'textSecondary'
  }, /*#__PURE__*/React.createElement("em", null, "No Name"));

  if (props.creditCard.ccName) {
    ccName = /*#__PURE__*/React.createElement(Typography$1, {
      noWrap: true
    }, /*#__PURE__*/React.createElement("strong", null, props.creditCard.ccName));
  }

  var todaysDate = new Date();
  todaysDate.setHours(0, 0, 0, 0);
  var expirationDate = endOfMonth(parseISO(props.creditCard.expirationDate));
  return /*#__PURE__*/React.createElement(Grid$2, {
    container: true
  }, props.creditCard.ccStatusType === 'PENDING' && /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Alert$1, {
    className: classes.statusAlert,
    severity: 'warning'
  }, "Your card is pending.")), props.creditCard.ccStatusType === 'DECLINED' && /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Alert$1, {
    className: classes.statusAlert,
    severity: 'error'
  }, "Your card is declined.")), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 1,
    xs: 2
  }, /*#__PURE__*/React.createElement(CardMedia, {
    className: classes.ccLogo,
    component: 'img',
    image: icon.src,
    title: icon.alt
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    container: true,
    sm: 11,
    xs: 10,
    className: classes.ccDetails
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 5,
    md: 6,
    xs: 12
  }, ccName), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 4,
    md: 3,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography$1, null, "Ending with ", /*#__PURE__*/React.createElement("strong", null, props.creditCard.lastFour))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 3,
    md: 3,
    xs: 12
  }, parseISO(todaysDate.toISOString()) <= expirationDate ? /*#__PURE__*/React.createElement(Typography$1, null, "Expires ", format$1(expirationDate, 'MM/yy')) : /*#__PURE__*/React.createElement(Typography$1, {
    color: 'error'
  }, "Expired ", format$1(expirationDate, 'MM/yy')))));
}

var useStyles$H = makeStyles$1(function (theme) {
  return {
    ccDetails: {
      paddingLeft: theme.spacing(1)
    },
    statusAlert: {
      marginBottom: theme.spacing(1),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0)
    },
    ccLogo: {
      maxHeight: '2rem',
      width: 'auto',
      maxWidth: '100%',
      margin: '0 auto'
    }
  };
});
CreditCardList.propTypes = {
  creditCards: arrayOf(shape({
    ccName: string
  })).isRequired,
  children: object$1
};

function CreditCardList(props) {
  var theme = useTheme$1();
  var classes = useStyles$I(theme);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var handleChange = function handleChange(panel) {
    return function (event, isExpanded) {
      if (props.children) {
        setExpanded(isExpanded ? panel : false);
      }
    };
  };

  return /*#__PURE__*/React.createElement("div", null, props.creditCards && props.creditCards.map(function (creditCard, index) {
    return /*#__PURE__*/React.createElement(ExpansionPanel, {
      key: index,
      expanded: expanded === "panel".concat(index),
      onChange: handleChange("panel".concat(index)),
      TransitionProps: {
        unmountOnExit: true
      },
      "data-description": "".concat(creditCard.ccName)
    }, /*#__PURE__*/React.createElement(ExpansionPanelSummary, {
      expandIcon: props.children && /*#__PURE__*/React.createElement(ExpandMore, null),
      "aria-controls": "cc".concat(index, "-content"),
      id: "cc".concat(index, "-header"),
      classes: {
        content: classes.summary
      }
    }, /*#__PURE__*/React.createElement(CreditCardListItem$1, {
      creditCard: creditCard
    })), props.children && /*#__PURE__*/React.createElement(ExpansionPanelDetails, null, cloneElement(props.children, {
      creditCard: creditCard
    })));
  }));
}

var useStyles$I = makeStyles$2(function (theme) {
  return {
    summary: {
      maxWidth: '100%'
    }
  };
});

function validateCreditCard$1(creditCardInfo) {
  var creditCardErrors = {};

  if (!creditCardInfo.expirationDate) {
    creditCardErrors.expirationDate = 'Expiration Date is required';
  } else {
    var expirationDate = moment(creditCardInfo.expirationDate, 'MM-YYYY');

    if (!expirationDate.isValid()) {
      creditCardErrors.expirationDate = 'Invalid date';
    } else if (moment().isAfter(expirationDate, 'month')) {
      creditCardErrors.expirationDate = 'Expiration Date must be in the future';
    }
  }

  return _objectSpread2(_objectSpread2({}, creditCardErrors), validateAddress(creditCardInfo));
}

var USED_CREDIT_CARD_DELETE_ATTEMPTED = '@identity-event/USED_CREDIT_CARD_DELETE_ATTEMPTED';
var CreditCardEvents = {
  USED_CREDIT_CARD_DELETE_ATTEMPTED: USED_CREDIT_CARD_DELETE_ATTEMPTED
};

function CreditCardLabel$1() {
  return /*#__PURE__*/React.createElement(Box$1, {
    p: 1
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: 'h6'
  }, "Credit Card"));
}

function BillingAddressLabel$1() {
  return /*#__PURE__*/React.createElement(Box$1, {
    p: 1
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: 'h6'
  }, "Billing Address"));
}

EditCreditCard.propTypes = {
  creditCardUrl: string.isRequired,
  onChange: func.isRequired,
  countryRegionData: arrayOf(shape({
    id: number,
    name: string,
    countryCode: string,
    states: arrayOf(shape({
      id: number,
      name: string,
      abbreviation: string
    }))
  })).isRequired,
  creditCard: shape({
    id: number,
    ccTypeId: oneOfType([number, string]),
    nameAsOnCard: string,
    ccName: string,
    lastFour: string,
    expirationDate: string,
    addressLine1: string,
    addressLine2: string,
    addressLevel1Id: string,
    addressLevel2: string,
    countryId: string,
    postalCode: string
  }).isRequired,
  onCancel: func
};

function EditCreditCard(props) {
  var _props$creditCard, _props$creditCard2, _props$creditCard3, _props$creditCard4, _props$creditCard5, _props$creditCard6, _props$creditCard7, _props$creditCard8, _props$creditCard9, _props$creditCard10, _props$creditCard11, _props$creditCard12, _props$creditCard13;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      attemptedSubmission = _useState4[0],
      setAttemptedSubmission = _useState4[1];

  var _useState5 = useState({
    id: ((_props$creditCard = props.creditCard) === null || _props$creditCard === void 0 ? void 0 : _props$creditCard.id) || undefined,
    nameOnCard: ((_props$creditCard2 = props.creditCard) === null || _props$creditCard2 === void 0 ? void 0 : _props$creditCard2.nameAsOnCard) || '',
    cardNumber: (_props$creditCard3 = props.creditCard) !== null && _props$creditCard3 !== void 0 && _props$creditCard3.lastFour ? '*'.repeat(12) + ((_props$creditCard4 = props.creditCard) === null || _props$creditCard4 === void 0 ? void 0 : _props$creditCard4.lastFour) : '',
    creditCardType: ((_props$creditCard5 = props.creditCard) === null || _props$creditCard5 === void 0 ? void 0 : _props$creditCard5.ccTypeId) || '',
    expirationDate: format$1(parseISO((_props$creditCard6 = props.creditCard) === null || _props$creditCard6 === void 0 ? void 0 : _props$creditCard6.expirationDate), 'MM/yyyy') || '',
    cardNickname: ((_props$creditCard7 = props.creditCard) === null || _props$creditCard7 === void 0 ? void 0 : _props$creditCard7.ccName) || '',
    addressLine1: ((_props$creditCard8 = props.creditCard) === null || _props$creditCard8 === void 0 ? void 0 : _props$creditCard8.addressLine1) || '',
    addressLine2: ((_props$creditCard9 = props.creditCard) === null || _props$creditCard9 === void 0 ? void 0 : _props$creditCard9.addressLine2) || '',
    addressLevel1Id: ((_props$creditCard10 = props.creditCard) === null || _props$creditCard10 === void 0 ? void 0 : _props$creditCard10.addressLevel1Id) || '',
    addressLevel2: ((_props$creditCard11 = props.creditCard) === null || _props$creditCard11 === void 0 ? void 0 : _props$creditCard11.addressLevel2) || '',
    countryId: ((_props$creditCard12 = props.creditCard) === null || _props$creditCard12 === void 0 ? void 0 : _props$creditCard12.countryId) || '1',
    postalCode: ((_props$creditCard13 = props.creditCard) === null || _props$creditCard13 === void 0 ? void 0 : _props$creditCard13.postalCode) || ''
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      creditCardInfo = _useState6[0],
      setCreditCardInfo = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      creditCardInfoErrors = _useState8[0],
      setCreditCardInfoErrors = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      noData = _useState10[0],
      setNoData = _useState10[1];

  var onlyNumbers = function onlyNumbers(e) {
    return e.target.value = e.target.value.replace(/[^0-9]/g, '');
  };

  useEffect(function () {
    var validatedCreditCard = validateCreditCard$1(creditCardInfo);
    setCreditCardInfoErrors(validatedCreditCard);
  }, [creditCardInfo]);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var creditCardRequest, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setAttemptedSubmission(true);

              if (!lodash_isempty(creditCardInfoErrors)) {
                _context.next = 15;
                break;
              }

              setLoading(true);
              creditCardRequest = {
                id: creditCardInfo.id,
                ccName: creditCardInfo.cardNickname,
                expirationDate: format$1(startOfMonth(parse$4(creditCardInfo.expirationDate, 'MM/yyyy', Date.now())), 'yyyy-MM-dd'),
                nameAsOnCard: creditCardInfo.nameOnCard,
                address1: creditCardInfo.addressLine1,
                address2: creditCardInfo.addressLine2,
                city: creditCardInfo.addressLevel2,
                stateId: creditCardInfo.addressLevel1Id,
                postalCode: creditCardInfo.postalCode,
                countryId: creditCardInfo.countryId
              };
              _context.prev = 4;
              _context.next = 7;
              return CreditCardService.updateCreditCard(creditCardRequest, props.creditCardUrl);

            case 7:
              data = _context.sent;

              if (data) {
                setCreditCardInfoErrors(function (state) {
                  delete state.form;
                  return state;
                });
                props.onChange();
              } else {
                setNoData(true);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              setCreditCardInfoErrors(function (state) {
                return _objectSpread2(_objectSpread2({}, state), {}, {
                  form: _context.t0.message
                });
              });

            case 14:
              setLoading(false);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 11]]);
    }));

    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleChange = function handleChange(attributeName, value) {
    setCreditCardInfoErrors(function (state) {
      delete state.form;
      return state;
    });
    setCreditCardInfo(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, attributeName, value));
    });
  };

  var cancelButton = function cancelButton() {
    function handleCancel() {
      props.onCancel();
    }

    return /*#__PURE__*/React.createElement(Grid$2, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      style: {
        width: '100%'
      },
      id: 'cancel-add-credit-card',
      disabled: loading,
      onClick: handleCancel
    }, "Cancel"));
  };

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showDialog = _useState12[0],
      setShowDialog = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      deleteError = _useState14[0],
      setDeleteError = _useState14[1];

  var handleDelete = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return CreditCardService.deleteCreditCard(props.creditCard.id, props.creditCardUrl);

            case 3:
              response = _context2.sent;

              if (response) {
                _context2.next = 8;
                break;
              }

              props.onChange();
              _context2.next = 16;
              break;

            case 8:
              _context2.t0 = response.data.code;
              _context2.next = _context2.t0 === 'credit_card_used' ? 11 : _context2.t0 === 'unable_to_delete' ? 14 : 14;
              break;

            case 11:
              EventService.dispatchEvent(CreditCardEvents.USED_CREDIT_CARD_DELETE_ATTEMPTED, props.creditCard);
              setDeleteError('Your credit card is currently being used in an auction.');
              return _context2.abrupt("break", 16);

            case 14:
              setDeleteError('Card could not be deleted.');
              return _context2.abrupt("break", 16);

            case 16:
              setShowDialog(false);
              setLoading(false);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDelete() {
      return _ref2.apply(this, arguments);
    };
  }();

  function handleDialogClose() {
    setShowDialog(false);
  }

  return /*#__PURE__*/React.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Notification, {
    messageOpen: showDialog,
    headerText: 'Deleting card ending in ' + props.creditCard.lastFour,
    bodyText: 'Are you sure?'
  }, loading && /*#__PURE__*/React.createElement(CircularProgress$1, null), /*#__PURE__*/React.createElement(Button, {
    onClick: handleDialogClose,
    variant: "contained",
    disabled: loading
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleDelete,
    variant: "contained",
    color: "primary",
    disabled: loading
  }, "Okay")), noData && /*#__PURE__*/React.createElement(Message, {
    variant: 'warning'
  }, 'Unable to connect to server. Please try again.'), deleteError && /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, deleteError), attemptedSubmission && creditCardInfoErrors.form && /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, creditCardInfoErrors.form), /*#__PURE__*/React.createElement("fieldset", {
    disabled: loading,
    style: {
      border: 'none'
    }
  }, /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 11
  }, /*#__PURE__*/React.createElement(Divider$1, {
    variant: "fullWidth",
    component: CreditCardLabel$1
  })), /*#__PURE__*/React.createElement(Grid$2, {
    container: true,
    alignItems: "flex-start",
    justify: "flex-end",
    direction: "row",
    item: true,
    xs: 1
  }, /*#__PURE__*/React.createElement(IconButton$1, {
    "data-description": 'delete-card',
    disabled: loading,
    "aria-label": "delete",
    color: "primary",
    onClick: function onClick() {
      return setShowDialog(true);
    }
  }, /*#__PURE__*/React.createElement(Delete, null))), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.nameOnCard,
    helperText: attemptedSubmission && creditCardInfoErrors.nameOnCard,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "ccNameOnCard",
    label: "Name on Card",
    name: "ccname",
    autoComplete: "cc-name",
    autoFocus: true,
    fullWidth: true,
    disabled: true,
    value: creditCardInfo.nameOnCard,
    onChange: function onChange(event) {
      return handleChange('nameOnCard', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.cardNumber,
    helperText: attemptedSubmission && creditCardInfoErrors.cardNumber,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "ccNum",
    label: "Card Number",
    name: "cardnumber",
    autoComplete: "cc-number",
    fullWidth: true,
    disabled: true,
    value: creditCardInfo.cardNumber,
    onChange: function onChange(event) {
      return handleChange('cardNumber', event.target.value);
    },
    inputProps: {
      maxLength: 16
    },
    onInput: onlyNumbers
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    sm: 6,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.expirationDate,
    helperText: attemptedSubmission && creditCardInfoErrors.expirationDate,
    variant: "outlined",
    margin: "dense",
    required: true,
    id: "expirationDate",
    label: "Expiration Date",
    name: "cc-exp",
    autoComplete: "cc-exp",
    fullWidth: true,
    value: creditCardInfo.expirationDate,
    placeholder: 'MM/YYYY',
    onChange: function onChange(event) {
      return handleChange('expirationDate', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField$1, {
    error: attemptedSubmission && !!creditCardInfoErrors.cardNickname,
    helperText: 'Ex. "Business Visa" or "Citibank Platinum"',
    variant: "outlined",
    margin: "dense",
    id: "cardNickname",
    label: "Card Nickname",
    name: "cardNickname",
    fullWidth: true,
    value: creditCardInfo.cardNickname,
    inputProps: {
      maxLength: 25
    },
    onChange: function onChange(event) {
      return handleChange('cardNickname', event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider$1, {
    variant: "fullWidth",
    component: BillingAddressLabel$1
  }), /*#__PURE__*/React.createElement(Address, {
    initialAddress: props.creditCard,
    currentAddress: creditCardInfo,
    addressChanged: handleChange,
    attemptedSubmission: attemptedSubmission,
    countryRegionData: props.countryRegionData
  })), /*#__PURE__*/React.createElement(Grid$2, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    style: {
      marginTop: '1rem',
      width: '100%'
    },
    id: 'update-credit-card',
    color: 'primary',
    variant: 'contained',
    loading: loading,
    disabled: attemptedSubmission && !lodash_isempty(creditCardInfoErrors),
    onClick: handleSubmit
  }, "Update Credit Card")), props.onCancel && cancelButton())), attemptedSubmission && creditCardInfoErrors.form && /*#__PURE__*/React.createElement(Message, {
    variant: 'error'
  }, creditCardInfoErrors.form));
}

var _excluded$7 = ["id"];

function updateRegistration(_x, _x2) {
  return _updateRegistration.apply(this, arguments);
}

function _updateRegistration() {
  _updateRegistration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(registration, registrationUrl) {
    var id, registrationRequest, response, _e$response, _e$response$data;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = registration.id, registrationRequest = _objectWithoutProperties(registration, _excluded$7);
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance.put("".concat(registrationUrl, "/").concat(id), registrationRequest);

          case 4:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            throw new Error(((_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.description) || 'Unable to update registration.');

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _updateRegistration.apply(this, arguments);
}

function getRegistrations(_x3) {
  return _getRegistrations.apply(this, arguments);
}

function _getRegistrations() {
  _getRegistrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(registrationUrl) {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axiosInstance.get("".concat(registrationUrl));

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getRegistrations.apply(this, arguments);
}

var registrationService = /*#__PURE__*/Object.freeze({
  __proto__: null,
  updateRegistration: updateRegistration,
  getRegistrations: getRegistrations
});
RegisteredCreditCard.propTypes = {
  registration: shape({
    id: string,
    auctionTitle: string.isRequired,
    ccId: number,
    auctionCreditCardOptions: arrayOf(shape({
      id: number,
      name: string
    })),
    auctionDate: string
  }),
  creditCards: arrayOf(shape({
    id: number,
    ccTypeId: number,
    expirationDate: string,
    ccName: string,
    lastFour: string,
    ccStatusType: string
  })),
  registrationUrl: string.isRequired,
  onChange: func.isRequired
};

function RegisteredCreditCard(props) {
  var _props$registration$c;

  var classes = useStyles$J();
  var creditCardSelectLabel = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      creditCardSelectLabelWidth = _useState2[0],
      setCreditCardSelectLabelWidth = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      updating = _useState4[0],
      setUpdating = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showUpdateSuccess = _useState6[0],
      setShowUpdateSuccess = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      updateFailure = _useState8[0],
      setUpdateFailure = _useState8[1];

  var timeoutRef = useRef(null);
  React.useEffect(function () {
    setCreditCardSelectLabelWidth(creditCardSelectLabel.current.offsetWidth);
    return function () {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  var _useState9 = useState((_props$registration$c = props.registration.ccId) !== null && _props$registration$c !== void 0 ? _props$registration$c : 0),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedCC = _useState10[0],
      setSelectedCc = _useState10[1];

  function handleChange(_x) {
    return _handleChange.apply(this, arguments);
  }

  function _handleChange() {
    _handleChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var registrationRequest;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setShowUpdateSuccess(false);
              setUpdateFailure('');
              setUpdating(true);
              setSelectedCc(event.target.value);
              registrationRequest = {
                id: props.registration.id,
                ccId: event.target.value
              };
              _context.prev = 5;
              _context.next = 8;
              return updateRegistration(registrationRequest, props.registrationUrl);

            case 8:
              setShowUpdateSuccess(true);
              clearTimeout(timeoutRef.current);
              timeoutRef.current = setTimeout(function () {
                return setShowUpdateSuccess(false);
              }, 3000);
              props.onChange();
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](5);
              setUpdateFailure(_context.t0.message);

            case 17:
              setUpdating(false);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 14]]);
    }));
    return _handleChange.apply(this, arguments);
  }

  function isCardExpired(creditCard) {
    var expirationDate = endOfMonth(parse$4(creditCard.expirationDate, 'yyyy-MM-dd', Date.now()));
    var auctionDate = parse$4(props.registration.auctionDate, 'yyyy-MM-dd', Date.now());
    return isBefore(expirationDate, auctionDate);
  }

  function createCreditCardOptions(creditCard) {
    var expired = isCardExpired(creditCard);
    var approved = creditCard.ccStatusType === 'APPROVED';
    var displayName = creditCard.ccName || "Ending with ".concat(creditCard.lastFour);
    var disabled = false;

    if (!approved) {
      displayName = 'NOT APPROVED - ' + displayName;
      disabled = true;
    } else if (expired) {
      displayName = 'EXPIRED - ' + displayName;
      disabled = true;
    }

    return /*#__PURE__*/React.createElement("option", {
      value: creditCard.id,
      key: creditCard.id,
      disabled: disabled
    }, displayName);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
    component: 'div'
  }, /*#__PURE__*/React.createElement(Box$1, {
    id: "registration-".concat(props.registration.id),
    fontWeight: 500
  }, props.registration.auctionTitle)), /*#__PURE__*/React.createElement(Box$1, {
    ml: 3,
    alignItems: 'center',
    display: 'flex',
    "aria-labelledby": "registration-".concat(props.registration.id)
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    margin: "dense"
  }, /*#__PURE__*/React.createElement(InputLabel$1, {
    id: "selected-cc-".concat(props.registration.id, "-label"),
    htmlFor: "selected-cc-".concat(props.registration.id),
    ref: creditCardSelectLabel
  }, "Selected Credit Card"), /*#__PURE__*/React.createElement(Select$3, {
    className: classes.creditCardSelect,
    labelId: "selected-cc-".concat(props.registration.id, "-label"),
    labelWidth: creditCardSelectLabelWidth,
    id: "selected-cc-".concat(props.registration.id),
    required: true,
    value: selectedCC,
    onChange: handleChange,
    "native": true
  }, /*#__PURE__*/React.createElement("option", {
    value: 0,
    disabled: true
  }, "None"), props.creditCards.filter(function (creditCard) {
    return props.registration.auctionCreditCardOptions.some(function (option) {
      return option.id === creditCard.ccTypeId;
    });
  }).map(createCreditCardOptions)))), /*#__PURE__*/React.createElement(Box$1, {
    pl: 1
  }, updating && /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 24,
    className: classes.loadingIcon
  }), !updateFailure && /*#__PURE__*/React.createElement(Zoom, {
    "in": showUpdateSuccess,
    timeout: 200
  }, /*#__PURE__*/React.createElement(CheckCircleIcon, {
    "aria-label": 'success',
    className: classes.successIcon
  })), !showUpdateSuccess && /*#__PURE__*/React.createElement(Zoom, {
    "in": updateFailure !== '',
    timeout: 200
  }, /*#__PURE__*/React.createElement(Tooltip, {
    arrow: true,
    title: updateFailure
  }, /*#__PURE__*/React.createElement(ErrorIcon, {
    "aria-label": 'error',
    className: classes.failureIcon
  }))))));
}

var useStyles$J = makeStyles$2(function (theme) {
  return {
    loadingIcon: {
      verticalAlign: 'middle'
    },
    successIcon: {
      color: theme.palette.success.main,
      verticalAlign: 'middle'
    },
    failureIcon: {
      color: theme.palette.error.main,
      verticalAlign: 'middle'
    },
    creditCardSelect: {
      width: '25rem',
      maxWidth: '80vw'
    }
  };
});
var _excluded$8 = ["registrations"];
ManageRegisteredCards.propTypes = {
  registrations: array
};

function ManageRegisteredCards(props) {
  var registrations = props.registrations,
      rest = _objectWithoutProperties(props, _excluded$8);

  return /*#__PURE__*/React.createElement(React.Fragment, null, registrations && registrations.map(function (registration) {
    return /*#__PURE__*/React.createElement(RegisteredCreditCard, _extends({
      key: registration.id,
      registration: registration
    }, rest), registration.auctionTitle);
  }));
}

export { AddContactInfo, AddCreditCard, AddCreditCardCheckoutFlow, Address, AuctionList, AuctionTimer, axiosInstance as AxiosProxy, BasicInfo, BusinessInfo, Button, CategoryCard, CategoryCarousel, CommunicationInfo, cookie as CookieService, CreateNewPassword, CreditCardEvents, CreditCardList, CreditCardService, defaultVideoThumb as DefaultVideoThumbnail, DepositRequiredMessage, DialogManager, EditContactInfo, EditCreditCard, EmptyStateMessage, eventHttp as EventHttp, EventIdentity, eventLogin as EventLogin, EventReminderOptions, EventService, Footer, FooterEvent, RootHeader as Header, HeaderEvent, HeroCard, HeroCarousel, HeroGrid, ImageGallery, LiveStreamTest, Login, LoginFlow, LoginFlowDialog, Logout, LogoutEvent, LogoutService, LotCardList, LotsCard, ManageRegisteredCards, MarketguardMessage, Message, noImageSvg as NoImage, PersistedMessages, PersistedMessagesManager, privateAuction as PrivateAuction, ProfileInfo, ProxiponentsConfig, Publisher, registrationService as RegistrationService, RequestOneTimePassword, ResetPassword, SearchField, SecuritySection, Select$1 as Select, SelectCreditCardList, SignInRegister, SimpleDialog, SnackbarMessage, StreamCardMarketingContentPage, Subscriber, SuccessMessage, TermsAndConditions, Textarea as TextArea, Root as TimedBidding, ZendeskChat, isFeatureActiveForUser, theme };